(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global = globalThis;
    
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire36e0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire36e0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hU107", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAuthApi = void 0;

var $3TYuV = parcelRequire("3TYuV");
class $d088715dc09d97c3$var$BaseAuthApi {
    /**
     * Creates a user action challenge
     */ static async createUserActionChallenge(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/action/init', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Sign a user action challenge
     */ static async signUserActionChallenge(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/action', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Initiates user login, by creating a challenge that will need to be signed by the user Credentials.
     */ static async createUserLoginChallenge(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/login/init', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes user login by sending the signed login challenge.
     */ static async createUserLogin(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/login', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes user logout by sending the user auth token.
     */ static async userLogout(options) {
        if (!options.authToken) throw new Error('authToken is required');
        const response = await (0, $3TYuV.simpleFetch)('/auth/logout', {
            method: 'PUT',
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Initiates Registration by creating a challenge that will need to be signed by a new set of Credentials.
     */ static async createUserRegistrationChallenge(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/registration/init', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes Registration by sending the signed registration challenge, containing the new Credential identity created.
     */ static async createUserRegistration(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/registration', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes Recovery by sending the signed recovery challenge, containing the new Credential identity created.
     */ async createUserRecovery(request, options) {
        const response = await (0, $3TYuV.simpleFetch)('/auth/recover/user', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
}
module.exports.BaseAuthApi = $d088715dc09d97c3$var$BaseAuthApi;

});
parcelRegister("3TYuV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleFetch = module.exports.dfnsAuth = module.exports.catchPolicyPending = module.exports.errorHandler = module.exports.formDataSerializer = module.exports.jsonSerializer = module.exports.fullUrl = void 0;

var $4wBHT = parcelRequire("4wBHT");

var $21L47 = parcelRequire("21L47");

var $d7UCD = parcelRequire("d7UCD");

var $kn0BT = parcelRequire("kn0BT");
const $2d756fc087f8d155$var$DEFAULT_DFNS_BASE_URL = 'https://api.dfns.io';

var $6qYGc = parcelRequire("6qYGc");
const $2d756fc087f8d155$var$fullUrl = (fetch)=>{
    return async (resource, options)=>{
        const baseUrl = options.apiOptions.baseUrl || $2d756fc087f8d155$var$DEFAULT_DFNS_BASE_URL;
        resource = new URL(resource, baseUrl);
        return fetch(resource, options);
    };
};
module.exports.fullUrl = $2d756fc087f8d155$var$fullUrl;
const $2d756fc087f8d155$var$jsonSerializer = (fetch)=>{
    return async (resource, options)=>{
        if (options.body && !(options.body instanceof FormData)) {
            options.body = JSON.stringify(options.body);
            options.headers = {
                'content-type': 'application/json',
                ...options.headers ?? {}
            };
        }
        return fetch(resource, options);
    };
};
module.exports.jsonSerializer = $2d756fc087f8d155$var$jsonSerializer;
const $2d756fc087f8d155$var$formDataSerializer = (fetch)=>{
    return async (resource, options)=>{
        if (!options.file) return fetch(resource, options);
        const { bytes: bytes, name: name } = options.file;
        const fileChecksum = await (0, $kn0BT.sha256)(bytes);
        const body = {
            ...options.body ?? {},
            fileChecksum: fileChecksum
        };
        const form = new FormData();
        form.append('data', JSON.stringify(body));
        form.append('file', new Blob([
            bytes
        ]), name);
        return fetch(resource, {
            ...options,
            body: form
        });
    };
};
module.exports.formDataSerializer = $2d756fc087f8d155$var$formDataSerializer;
const $2d756fc087f8d155$var$errorHandler = (fetch)=>{
    return async (resource, options)=>{
        const response = await fetch(resource, options);
        if (response.ok) return response;
        else {
            const body = await response.json();
            const message = body?.error?.message ?? body?.message;
            throw new $21L47.DfnsError(response.status, message, {
                url: response.url,
                headers: response.headers,
                body: body
            });
        }
    };
};
module.exports.errorHandler = $2d756fc087f8d155$var$errorHandler;
// raise a 202 response by policy execution as error
const $2d756fc087f8d155$var$catchPolicyPending = (fetch)=>{
    return async (resource, options)=>{
        const response = await fetch(resource, options);
        if (response.status === $21L47.PolicyPendingError.HTTP_ACCEPTED) throw new $21L47.PolicyPendingError(await response.json());
        else return response;
    };
};
module.exports.catchPolicyPending = $2d756fc087f8d155$var$catchPolicyPending;
const $2d756fc087f8d155$var$dfnsAuth = (fetch)=>{
    return async (resource, options)=>{
        const { orgId: orgId, authToken: authToken } = options.apiOptions;
        if (authToken && orgId) (0, $d7UCD.assertAuthTokenIsSameOrg)({
            orgId: orgId,
            authToken: authToken
        });
        const authorization = authToken ? {
            authorization: `Bearer ${authToken}`
        } : {};
        options.headers = {
            'x-dfns-sdk-version': $6qYGc.version,
            ...authorization,
            ...options.headers ?? {}
        };
        return fetch(resource, options);
    };
};
module.exports.dfnsAuth = $2d756fc087f8d155$var$dfnsAuth;
module.exports.simpleFetch = (0, module.exports.fullUrl)((0, module.exports.jsonSerializer)((0, module.exports.dfnsAuth)((0, module.exports.catchPolicyPending)((0, module.exports.errorHandler)($4wBHT.fetch)))));

});
parcelRegister("4wBHT", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("21L47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PolicyPendingError = module.exports.DfnsError = void 0;
class $17a02efe1fb9d9c3$var$DfnsError extends Error {
    constructor(httpStatus, message, context){
        super(message);
        this.httpStatus = httpStatus;
        this.context = context;
        this.name = 'DfnsError';
    }
    toString() {
        return JSON.stringify({
            httpStatus: this.httpStatus,
            message: this.message,
            ...this.context && this.context
        }, null, 2);
    }
}
module.exports.DfnsError = $17a02efe1fb9d9c3$var$DfnsError;
class $17a02efe1fb9d9c3$var$PolicyPendingError extends $17a02efe1fb9d9c3$var$DfnsError {
    constructor(context){
        super($17a02efe1fb9d9c3$var$PolicyPendingError.HTTP_ACCEPTED, 'Operation triggered a policy pending approval', context);
    }
}
module.exports.PolicyPendingError = $17a02efe1fb9d9c3$var$PolicyPendingError;
$17a02efe1fb9d9c3$var$PolicyPendingError.HTTP_ACCEPTED = 202;

});

parcelRegister("d7UCD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertAuthTokenIsSameOrg = module.exports.JWT_CUSTOM_DATA_CLAIM = void 0;

var $hWIAg = parcelRequire("hWIAg");
module.exports.JWT_CUSTOM_DATA_CLAIM = 'https://custom/app_metadata';
const $98e7d9cc64aade16$var$assertAuthTokenIsSameOrg = ({ authToken: authToken, orgId: orgId })=>{
    const tokenBody = authToken.split('.')?.[1] || '';
    let decoded;
    try {
        decoded = JSON.parse((0, $hWIAg.fromBase64)(tokenBody).toString('utf-8'));
    } catch (error) {
        throw new Error('Provided auth token could not be properly parsed');
    }
    const tokenOrgId = decoded?.[module.exports.JWT_CUSTOM_DATA_CLAIM]?.['orgId'];
    if (tokenOrgId !== orgId) throw new Error(`Provided auth token is not scoped to org ID ${orgId}`);
};
module.exports.assertAuthTokenIsSameOrg = $98e7d9cc64aade16$var$assertAuthTokenIsSameOrg;

});
parcelRegister("hWIAg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64Url = module.exports.toBase64Url = module.exports.fromBase64 = module.exports.toBase64 = void 0;

var $hAePC = parcelRequire("hAePC");
const $d10a6fe04745c02e$var$pad = (topad)=>{
    const padLength = 4 - topad.length % 4;
    if (padLength < 4) topad += '='.repeat(padLength);
    return topad;
};
const $d10a6fe04745c02e$var$toBase64 = (buffer)=>{
    if (typeof buffer === 'string') buffer = $hAePC.Buffer.from(buffer);
    return buffer.toString('base64');
};
module.exports.toBase64 = $d10a6fe04745c02e$var$toBase64;
const $d10a6fe04745c02e$var$fromBase64 = (encoded)=>{
    return $hAePC.Buffer.from($d10a6fe04745c02e$var$pad(encoded), 'base64');
};
module.exports.fromBase64 = $d10a6fe04745c02e$var$fromBase64;
const $d10a6fe04745c02e$var$toBase64Url = (buffer)=>{
    return (0, module.exports.toBase64)(buffer).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
module.exports.toBase64Url = $d10a6fe04745c02e$var$toBase64Url;
const $d10a6fe04745c02e$var$fromBase64Url = (encoded)=>{
    encoded = $d10a6fe04745c02e$var$pad(encoded).replace(/\-/g, '+').replace(/_/g, '/');
    return $hAePC.Buffer.from(encoded, 'base64');
};
module.exports.fromBase64Url = $d10a6fe04745c02e$var$fromBase64Url;

});
parcelRegister("hAePC", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $ccd14daeaaa4d35b$export$a143d493d941bafc, (v) => $ccd14daeaaa4d35b$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $ccd14daeaaa4d35b$export$f99ded8fe4b79145, (v) => $ccd14daeaaa4d35b$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ccd14daeaaa4d35b$export$a143d493d941bafc;
var $ccd14daeaaa4d35b$export$e4cf37d7f6fb9e0a;
var $ccd14daeaaa4d35b$export$f99ded8fe4b79145;
var $ccd14daeaaa4d35b$export$599f31c3813fae4d;
'use strict';

var $iMAiF = parcelRequire("iMAiF");

var $fmKz7 = parcelRequire("fmKz7");
const $ccd14daeaaa4d35b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ccd14daeaaa4d35b$export$a143d493d941bafc = $ccd14daeaaa4d35b$var$Buffer;
$ccd14daeaaa4d35b$export$e4cf37d7f6fb9e0a = $ccd14daeaaa4d35b$var$SlowBuffer;
$ccd14daeaaa4d35b$export$f99ded8fe4b79145 = 50;
const $ccd14daeaaa4d35b$var$K_MAX_LENGTH = 0x7fffffff;
$ccd14daeaaa4d35b$export$599f31c3813fae4d = $ccd14daeaaa4d35b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ccd14daeaaa4d35b$var$Buffer.TYPED_ARRAY_SUPPORT = $ccd14daeaaa4d35b$var$typedArraySupport();
if (!$ccd14daeaaa4d35b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ccd14daeaaa4d35b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ccd14daeaaa4d35b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ccd14daeaaa4d35b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ccd14daeaaa4d35b$var$createBuffer(length) {
    if (length > $ccd14daeaaa4d35b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ccd14daeaaa4d35b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ccd14daeaaa4d35b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ccd14daeaaa4d35b$var$allocUnsafe(arg);
    }
    return $ccd14daeaaa4d35b$var$from(arg, encodingOrOffset, length);
}
$ccd14daeaaa4d35b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ccd14daeaaa4d35b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ccd14daeaaa4d35b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ccd14daeaaa4d35b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ccd14daeaaa4d35b$var$isInstance(value, ArrayBuffer) || value && $ccd14daeaaa4d35b$var$isInstance(value.buffer, ArrayBuffer)) return $ccd14daeaaa4d35b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ccd14daeaaa4d35b$var$isInstance(value, SharedArrayBuffer) || value && $ccd14daeaaa4d35b$var$isInstance(value.buffer, SharedArrayBuffer))) return $ccd14daeaaa4d35b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ccd14daeaaa4d35b$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $ccd14daeaaa4d35b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ccd14daeaaa4d35b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ccd14daeaaa4d35b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ccd14daeaaa4d35b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ccd14daeaaa4d35b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ccd14daeaaa4d35b$var$Buffer, Uint8Array);
function $ccd14daeaaa4d35b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ccd14daeaaa4d35b$var$alloc(size, fill, encoding) {
    $ccd14daeaaa4d35b$var$assertSize(size);
    if (size <= 0) return $ccd14daeaaa4d35b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ccd14daeaaa4d35b$var$createBuffer(size).fill(fill, encoding) : $ccd14daeaaa4d35b$var$createBuffer(size).fill(fill);
    return $ccd14daeaaa4d35b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ccd14daeaaa4d35b$var$Buffer.alloc = function(size, fill, encoding) {
    return $ccd14daeaaa4d35b$var$alloc(size, fill, encoding);
};
function $ccd14daeaaa4d35b$var$allocUnsafe(size) {
    $ccd14daeaaa4d35b$var$assertSize(size);
    return $ccd14daeaaa4d35b$var$createBuffer(size < 0 ? 0 : $ccd14daeaaa4d35b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ccd14daeaaa4d35b$var$Buffer.allocUnsafe = function(size) {
    return $ccd14daeaaa4d35b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ccd14daeaaa4d35b$var$Buffer.allocUnsafeSlow = function(size) {
    return $ccd14daeaaa4d35b$var$allocUnsafe(size);
};
function $ccd14daeaaa4d35b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ccd14daeaaa4d35b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $ccd14daeaaa4d35b$var$byteLength(string, encoding) | 0;
    let buf = $ccd14daeaaa4d35b$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ccd14daeaaa4d35b$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $ccd14daeaaa4d35b$var$checked(array.length) | 0;
    const buf = $ccd14daeaaa4d35b$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ccd14daeaaa4d35b$var$fromArrayView(arrayView) {
    if ($ccd14daeaaa4d35b$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $ccd14daeaaa4d35b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ccd14daeaaa4d35b$var$fromArrayLike(arrayView);
}
function $ccd14daeaaa4d35b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ccd14daeaaa4d35b$var$Buffer.prototype);
    return buf;
}
function $ccd14daeaaa4d35b$var$fromObject(obj) {
    if ($ccd14daeaaa4d35b$var$Buffer.isBuffer(obj)) {
        const len = $ccd14daeaaa4d35b$var$checked(obj.length) | 0;
        const buf = $ccd14daeaaa4d35b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ccd14daeaaa4d35b$var$numberIsNaN(obj.length)) return $ccd14daeaaa4d35b$var$createBuffer(0);
        return $ccd14daeaaa4d35b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ccd14daeaaa4d35b$var$fromArrayLike(obj.data);
}
function $ccd14daeaaa4d35b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ccd14daeaaa4d35b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ccd14daeaaa4d35b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ccd14daeaaa4d35b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ccd14daeaaa4d35b$var$Buffer.alloc(+length);
}
$ccd14daeaaa4d35b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ccd14daeaaa4d35b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ccd14daeaaa4d35b$var$Buffer.compare = function compare(a, b) {
    if ($ccd14daeaaa4d35b$var$isInstance(a, Uint8Array)) a = $ccd14daeaaa4d35b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ccd14daeaaa4d35b$var$isInstance(b, Uint8Array)) b = $ccd14daeaaa4d35b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(a) || !$ccd14daeaaa4d35b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ccd14daeaaa4d35b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ccd14daeaaa4d35b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ccd14daeaaa4d35b$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $ccd14daeaaa4d35b$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($ccd14daeaaa4d35b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(buf)) buf = $ccd14daeaaa4d35b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ccd14daeaaa4d35b$var$byteLength(string, encoding) {
    if ($ccd14daeaaa4d35b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ccd14daeaaa4d35b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ccd14daeaaa4d35b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ccd14daeaaa4d35b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ccd14daeaaa4d35b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ccd14daeaaa4d35b$var$Buffer.byteLength = $ccd14daeaaa4d35b$var$byteLength;
function $ccd14daeaaa4d35b$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ccd14daeaaa4d35b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ccd14daeaaa4d35b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ccd14daeaaa4d35b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ccd14daeaaa4d35b$var$latin1Slice(this, start, end);
        case 'base64':
            return $ccd14daeaaa4d35b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ccd14daeaaa4d35b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ccd14daeaaa4d35b$var$Buffer.prototype._isBuffer = true;
function $ccd14daeaaa4d35b$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ccd14daeaaa4d35b$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$ccd14daeaaa4d35b$var$swap(this, i, i + 1);
    return this;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $ccd14daeaaa4d35b$var$swap(this, i, i + 3);
        $ccd14daeaaa4d35b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $ccd14daeaaa4d35b$var$swap(this, i, i + 7);
        $ccd14daeaaa4d35b$var$swap(this, i + 1, i + 6);
        $ccd14daeaaa4d35b$var$swap(this, i + 2, i + 5);
        $ccd14daeaaa4d35b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ccd14daeaaa4d35b$var$utf8Slice(this, 0, length);
    return $ccd14daeaaa4d35b$var$slowToString.apply(this, arguments);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.toLocaleString = $ccd14daeaaa4d35b$var$Buffer.prototype.toString;
$ccd14daeaaa4d35b$var$Buffer.prototype.equals = function equals(b) {
    if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ccd14daeaaa4d35b$var$Buffer.compare(this, b) === 0;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $ccd14daeaaa4d35b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ccd14daeaaa4d35b$var$customInspectSymbol) $ccd14daeaaa4d35b$var$Buffer.prototype[$ccd14daeaaa4d35b$var$customInspectSymbol] = $ccd14daeaaa4d35b$var$Buffer.prototype.inspect;
$ccd14daeaaa4d35b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ccd14daeaaa4d35b$var$isInstance(target, Uint8Array)) target = $ccd14daeaaa4d35b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ccd14daeaaa4d35b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ccd14daeaaa4d35b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ccd14daeaaa4d35b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ccd14daeaaa4d35b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ccd14daeaaa4d35b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ccd14daeaaa4d35b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ccd14daeaaa4d35b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ccd14daeaaa4d35b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ccd14daeaaa4d35b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ccd14daeaaa4d35b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ccd14daeaaa4d35b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ccd14daeaaa4d35b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ccd14daeaaa4d35b$var$utf8Write(buf, string, offset, length) {
    return $ccd14daeaaa4d35b$var$blitBuffer($ccd14daeaaa4d35b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ccd14daeaaa4d35b$var$asciiWrite(buf, string, offset, length) {
    return $ccd14daeaaa4d35b$var$blitBuffer($ccd14daeaaa4d35b$var$asciiToBytes(string), buf, offset, length);
}
function $ccd14daeaaa4d35b$var$base64Write(buf, string, offset, length) {
    return $ccd14daeaaa4d35b$var$blitBuffer($ccd14daeaaa4d35b$var$base64ToBytes(string), buf, offset, length);
}
function $ccd14daeaaa4d35b$var$ucs2Write(buf, string, offset, length) {
    return $ccd14daeaaa4d35b$var$blitBuffer($ccd14daeaaa4d35b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ccd14daeaaa4d35b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ccd14daeaaa4d35b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ccd14daeaaa4d35b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ccd14daeaaa4d35b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ccd14daeaaa4d35b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ccd14daeaaa4d35b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ccd14daeaaa4d35b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ccd14daeaaa4d35b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $iMAiF.fromByteArray(buf);
    else return $iMAiF.fromByteArray(buf.slice(start, end));
}
function $ccd14daeaaa4d35b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ccd14daeaaa4d35b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $ccd14daeaaa4d35b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ccd14daeaaa4d35b$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $ccd14daeaaa4d35b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ccd14daeaaa4d35b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ccd14daeaaa4d35b$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ccd14daeaaa4d35b$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ccd14daeaaa4d35b$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $ccd14daeaaa4d35b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ccd14daeaaa4d35b$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ccd14daeaaa4d35b$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ccd14daeaaa4d35b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ccd14daeaaa4d35b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ccd14daeaaa4d35b$var$Buffer.prototype.readUintLE = $ccd14daeaaa4d35b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readUintBE = $ccd14daeaaa4d35b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readUint8 = $ccd14daeaaa4d35b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readUint16LE = $ccd14daeaaa4d35b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readUint16BE = $ccd14daeaaa4d35b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readUint32LE = $ccd14daeaaa4d35b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readUint32BE = $ccd14daeaaa4d35b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readBigUInt64LE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ccd14daeaaa4d35b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ccd14daeaaa4d35b$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ccd14daeaaa4d35b$var$Buffer.prototype.readBigUInt64BE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ccd14daeaaa4d35b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ccd14daeaaa4d35b$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ccd14daeaaa4d35b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readBigInt64LE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ccd14daeaaa4d35b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ccd14daeaaa4d35b$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$ccd14daeaaa4d35b$var$Buffer.prototype.readBigInt64BE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ccd14daeaaa4d35b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ccd14daeaaa4d35b$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$ccd14daeaaa4d35b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 4, this.length);
    return $fmKz7.read(this, offset, true, 23, 4);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 4, this.length);
    return $fmKz7.read(this, offset, false, 23, 4);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 8, this.length);
    return $fmKz7.read(this, offset, true, 52, 8);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkOffset(offset, 8, this.length);
    return $fmKz7.read(this, offset, false, 52, 8);
};
function $ccd14daeaaa4d35b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUintLE = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ccd14daeaaa4d35b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUintBE = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ccd14daeaaa4d35b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUint8 = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUint16LE = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUint16BE = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUint32LE = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeUint32BE = $ccd14daeaaa4d35b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ccd14daeaaa4d35b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ccd14daeaaa4d35b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ccd14daeaaa4d35b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ccd14daeaaa4d35b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ccd14daeaaa4d35b$var$Buffer.prototype.writeBigUInt64LE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $ccd14daeaaa4d35b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ccd14daeaaa4d35b$var$Buffer.prototype.writeBigUInt64BE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $ccd14daeaaa4d35b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ccd14daeaaa4d35b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ccd14daeaaa4d35b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ccd14daeaaa4d35b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeBigInt64LE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $ccd14daeaaa4d35b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$ccd14daeaaa4d35b$var$Buffer.prototype.writeBigInt64BE = $ccd14daeaaa4d35b$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $ccd14daeaaa4d35b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $ccd14daeaaa4d35b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ccd14daeaaa4d35b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $fmKz7.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ccd14daeaaa4d35b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ccd14daeaaa4d35b$var$writeFloat(this, value, offset, true, noAssert);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ccd14daeaaa4d35b$var$writeFloat(this, value, offset, false, noAssert);
};
function $ccd14daeaaa4d35b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ccd14daeaaa4d35b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $fmKz7.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ccd14daeaaa4d35b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ccd14daeaaa4d35b$var$writeDouble(this, value, offset, true, noAssert);
};
$ccd14daeaaa4d35b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ccd14daeaaa4d35b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ccd14daeaaa4d35b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ccd14daeaaa4d35b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ccd14daeaaa4d35b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ccd14daeaaa4d35b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $ccd14daeaaa4d35b$var$Buffer.isBuffer(val) ? val : $ccd14daeaaa4d35b$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $ccd14daeaaa4d35b$var$errors = {};
function $ccd14daeaaa4d35b$var$E(sym, getMessage, Base) {
    $ccd14daeaaa4d35b$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$ccd14daeaaa4d35b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$ccd14daeaaa4d35b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$ccd14daeaaa4d35b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $ccd14daeaaa4d35b$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $ccd14daeaaa4d35b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $ccd14daeaaa4d35b$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $ccd14daeaaa4d35b$var$checkBounds(buf, offset, byteLength) {
    $ccd14daeaaa4d35b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ccd14daeaaa4d35b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ccd14daeaaa4d35b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $ccd14daeaaa4d35b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $ccd14daeaaa4d35b$var$checkBounds(buf, offset, byteLength);
}
function $ccd14daeaaa4d35b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $ccd14daeaaa4d35b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $ccd14daeaaa4d35b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ccd14daeaaa4d35b$var$validateNumber(value, type);
        throw new $ccd14daeaaa4d35b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $ccd14daeaaa4d35b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ccd14daeaaa4d35b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $ccd14daeaaa4d35b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ccd14daeaaa4d35b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ccd14daeaaa4d35b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ccd14daeaaa4d35b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ccd14daeaaa4d35b$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ccd14daeaaa4d35b$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ccd14daeaaa4d35b$var$base64ToBytes(str) {
    return $iMAiF.toByteArray($ccd14daeaaa4d35b$var$base64clean(str));
}
function $ccd14daeaaa4d35b$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ccd14daeaaa4d35b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ccd14daeaaa4d35b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $ccd14daeaaa4d35b$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ccd14daeaaa4d35b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $ccd14daeaaa4d35b$var$BufferBigIntNotDefined : fn;
}
function $ccd14daeaaa4d35b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("iMAiF", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $03875e6bfb5cdd71$export$d622b2ad8d90c771, (v) => $03875e6bfb5cdd71$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $03875e6bfb5cdd71$export$6100ba28696e12de, (v) => $03875e6bfb5cdd71$export$6100ba28696e12de = v);
var $03875e6bfb5cdd71$export$a48f0734ac7c2329;
var $03875e6bfb5cdd71$export$d622b2ad8d90c771;
var $03875e6bfb5cdd71$export$6100ba28696e12de;
'use strict';
$03875e6bfb5cdd71$export$a48f0734ac7c2329 = $03875e6bfb5cdd71$var$byteLength;
$03875e6bfb5cdd71$export$d622b2ad8d90c771 = $03875e6bfb5cdd71$var$toByteArray;
$03875e6bfb5cdd71$export$6100ba28696e12de = $03875e6bfb5cdd71$var$fromByteArray;
var $03875e6bfb5cdd71$var$lookup = [];
var $03875e6bfb5cdd71$var$revLookup = [];
var $03875e6bfb5cdd71$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $03875e6bfb5cdd71$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $03875e6bfb5cdd71$var$i = 0, $03875e6bfb5cdd71$var$len = $03875e6bfb5cdd71$var$code.length; $03875e6bfb5cdd71$var$i < $03875e6bfb5cdd71$var$len; ++$03875e6bfb5cdd71$var$i){
    $03875e6bfb5cdd71$var$lookup[$03875e6bfb5cdd71$var$i] = $03875e6bfb5cdd71$var$code[$03875e6bfb5cdd71$var$i];
    $03875e6bfb5cdd71$var$revLookup[$03875e6bfb5cdd71$var$code.charCodeAt($03875e6bfb5cdd71$var$i)] = $03875e6bfb5cdd71$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$03875e6bfb5cdd71$var$revLookup['-'.charCodeAt(0)] = 62;
$03875e6bfb5cdd71$var$revLookup['_'.charCodeAt(0)] = 63;
function $03875e6bfb5cdd71$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $03875e6bfb5cdd71$var$byteLength(b64) {
    var lens = $03875e6bfb5cdd71$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $03875e6bfb5cdd71$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $03875e6bfb5cdd71$var$toByteArray(b64) {
    var tmp;
    var lens = $03875e6bfb5cdd71$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $03875e6bfb5cdd71$var$Arr($03875e6bfb5cdd71$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i)] << 18 | $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i)] << 2 | $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i)] << 10 | $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $03875e6bfb5cdd71$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $03875e6bfb5cdd71$var$tripletToBase64(num) {
    return $03875e6bfb5cdd71$var$lookup[num >> 18 & 0x3F] + $03875e6bfb5cdd71$var$lookup[num >> 12 & 0x3F] + $03875e6bfb5cdd71$var$lookup[num >> 6 & 0x3F] + $03875e6bfb5cdd71$var$lookup[num & 0x3F];
}
function $03875e6bfb5cdd71$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($03875e6bfb5cdd71$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $03875e6bfb5cdd71$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($03875e6bfb5cdd71$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($03875e6bfb5cdd71$var$lookup[tmp >> 2] + $03875e6bfb5cdd71$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($03875e6bfb5cdd71$var$lookup[tmp >> 10] + $03875e6bfb5cdd71$var$lookup[tmp >> 4 & 0x3F] + $03875e6bfb5cdd71$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("fmKz7", function(module, exports) {

$parcel$export(module.exports, "read", () => $b2fd0801e062d79c$export$aafa59e2e03f2942, (v) => $b2fd0801e062d79c$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $b2fd0801e062d79c$export$68d8715fc104d294, (v) => $b2fd0801e062d79c$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $b2fd0801e062d79c$export$aafa59e2e03f2942;
var $b2fd0801e062d79c$export$68d8715fc104d294;
$b2fd0801e062d79c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$b2fd0801e062d79c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("kn0BT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = void 0;

var $3VCKu = parcelRequire("3VCKu");
const $ed466dc86dd109f1$var$sha256 = async (bytes)=>{
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return (0, $3VCKu.toHex)(digest);
};
module.exports.sha256 = $ed466dc86dd109f1$var$sha256;

});
parcelRegister("3VCKu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toHex = module.exports.splitString = void 0;
const $2dc4c0ac21fc23f8$var$splitString = (text, maxLineLength = 64)=>{
    const regex = new RegExp(`(.{1,${maxLineLength}})`, 'g');
    const matches = text.matchAll(regex);
    const lines = [];
    for (const match of matches)lines.push(match[1]);
    return lines;
};
module.exports.splitString = $2dc4c0ac21fc23f8$var$splitString;
const $2dc4c0ac21fc23f8$var$toHex = (buffer)=>{
    const view = new Uint8Array(buffer);
    let hexString = "";
    for (const byte of view){
        const hexByte = byte.toString(16);
        hexString += hexByte.padStart(2, "0");
    }
    return hexString.toLowerCase();
};
module.exports.toHex = $2dc4c0ac21fc23f8$var$toHex;

});


parcelRegister("6qYGc", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@dfns/sdk\",\"version\":\"0.8.21\",\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/dfns/dfns-sdk-ts.git\",\"directory\":\"packages/sdk\"},\"dependencies\":{\"buffer\":\"^6.0.3\",\"cross-fetch\":\"^3.1.6\"},\"main\":\"./index.js\",\"type\":\"commonjs\"}");

});



parcelRegister("6M1yn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DfnsApiClient = void 0;

var $hmNiQ = parcelRequire("hmNiQ");

var $aIEww = parcelRequire("aIEww");

var $jFryV = parcelRequire("jFryV");

var $dVmLf = parcelRequire("dVmLf");

var $eFwEd = parcelRequire("eFwEd");

var $1mQ28 = parcelRequire("1mQ28");

var $lRWRX = parcelRequire("lRWRX");

var $b0sby = parcelRequire("b0sby");

var $lf1zV = parcelRequire("lf1zV");

var $g82VE = parcelRequire("g82VE");

var $lfAEc = parcelRequire("lfAEc");

var $lQ6X1 = parcelRequire("lQ6X1");

var $k2fao = parcelRequire("k2fao");

var $i2KgQ = parcelRequire("i2KgQ");

var $kbCVX = parcelRequire("kbCVX");
class $4ee86e3dd7f635ac$var$DfnsApiClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    get agreements() {
        return new $hmNiQ.AgreementsClient(this.apiOptions);
    }
    get allocations() {
        return new $aIEww.AllocationsClient(this.apiOptions);
    }
    get auth() {
        return new $jFryV.AuthClient(this.apiOptions);
    }
    get exchanges() {
        return new $dVmLf.ExchangesClient(this.apiOptions);
    }
    get feeSponsors() {
        return new $eFwEd.FeeSponsorsClient(this.apiOptions);
    }
    get keys() {
        return new $1mQ28.KeysClient(this.apiOptions);
    }
    get networks() {
        return new $lRWRX.NetworksClient(this.apiOptions);
    }
    get payouts() {
        return new $b0sby.PayoutsClient(this.apiOptions);
    }
    get permissions() {
        return new $lf1zV.PermissionsClient(this.apiOptions);
    }
    get policies() {
        return new $g82VE.PoliciesClient(this.apiOptions);
    }
    get signers() {
        return new $lfAEc.SignersClient(this.apiOptions);
    }
    get staking() {
        return new $lQ6X1.StakingClient(this.apiOptions);
    }
    get swaps() {
        return new $k2fao.SwapsClient(this.apiOptions);
    }
    get wallets() {
        return new $i2KgQ.WalletsClient(this.apiOptions);
    }
    get webhooks() {
        return new $kbCVX.WebhooksClient(this.apiOptions);
    }
}
module.exports.DfnsApiClient = $4ee86e3dd7f635ac$var$DfnsApiClient;

});
parcelRegister("hmNiQ", function(module, exports) {
"use strict";
var $ca4abc481d6abe9d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ca4abc481d6abe9d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ca4abc481d6abe9d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ca4abc481d6abe9d$var$__exportStar((parcelRequire("8cePC")), module.exports);

$ca4abc481d6abe9d$var$__exportStar((parcelRequire("dFgj3")), module.exports);

$ca4abc481d6abe9d$var$__exportStar((parcelRequire("7Ciuy")), module.exports);

});
parcelRegister("8cePC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dFgj3", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgreementsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $9f2bc0c76a2c08ca$var$AgreementsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async getLatestUnacceptedAgreement(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/agreements/latest-unaccepted', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recordAgreementAcceptance(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/agreements/:agreementId/accept', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.AgreementsClient = $9f2bc0c76a2c08ca$var$AgreementsClient;

});
parcelRegister("4Ztiw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.userActionFetch = void 0;

var $4wBHT = parcelRequire("4wBHT");

var $3TYuV = parcelRequire("3TYuV");

var $hU107 = parcelRequire("hU107");

var $21L47 = parcelRequire("21L47");
const $3a2395d60857714f$var$userAction = (fetch)=>{
    return async (resource, options)=>{
        if (options.method !== 'GET') {
            const apiOptions = {
                ...options.apiOptions,
                baseUrl: options.apiOptions.baseAuthUrl || options.apiOptions.baseUrl
            };
            if (!apiOptions.signer) throw new $21L47.DfnsError(-1, 'A "signer" needs to be passed to Dfns client.', {
                detail: `Most non-readonly endpoints require "User Action Signing" flow.` + ` During that flow, the credential "signer" that you passed will handle signing` + ` the user action challenge, using your credential.`
            });
            const body = (options.body instanceof FormData ? options.body.get('data') : options.body) ?? '';
            if (typeof body !== 'string') throw new $21L47.DfnsError(-1, 'unexpected fetch body for user action signing', {
                details: {
                    type: typeof body
                }
            });
            const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
                userActionPayload: body,
                userActionHttpMethod: options.method,
                userActionHttpPath: resource.pathname,
                userActionServerKind: apiOptions?.userActionServerKind || 'Api'
            }, apiOptions);
            const assertion = await apiOptions.signer.sign(challenge);
            const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge({
                challengeIdentifier: challenge.challengeIdentifier,
                firstFactor: assertion
            }, apiOptions);
            options.headers = {
                'x-dfns-useraction': userAction,
                ...options.headers ?? {}
            };
        }
        return fetch(resource, options);
    };
};
module.exports.userActionFetch = (0, $3TYuV.fullUrl)((0, $3TYuV.formDataSerializer)((0, $3TYuV.jsonSerializer)((0, $3TYuV.dfnsAuth)($3a2395d60857714f$var$userAction((0, $3TYuV.catchPolicyPending)((0, $3TYuV.errorHandler)($4wBHT.fetch)))))));

});

parcelRegister("c8Pib", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildPathAndQuery = void 0;
const $8d6e04f7f27012ec$var$buildPathAndQuery = (pattern, params)=>{
    let path = pattern;
    const paramsToReplace = (path.match(new RegExp(`:[a-zA-Z]+`, 'g')) || []).map((v)=>v.replace(/^:/, ''));
    for (const key of paramsToReplace)path = path.replace(new RegExp(`:${key}`, 'g'), encodeURIComponent(params.path[key]));
    const query = Object.entries(params.query).flatMap(([key, value])=>{
        if (Array.isArray(value)) return value.map((item)=>`${key}=${encodeURIComponent(item)}`);
        else if (!value) return [];
        else return [
            `${key}=${encodeURIComponent(value.toString())}`
        ];
    }).join('&');
    return query === '' ? path : `${path}?${query}`;
};
module.exports.buildPathAndQuery = $8d6e04f7f27012ec$var$buildPathAndQuery;

});


parcelRegister("7Ciuy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedAgreementsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $58ba6d1aa6426e5e$var$DelegatedAgreementsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async getLatestUnacceptedAgreement(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/agreements/latest-unaccepted', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recordAgreementAcceptanceInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/agreements/:agreementId/accept', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async recordAgreementAcceptanceComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/agreements/:agreementId/accept', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedAgreementsClient = $58ba6d1aa6426e5e$var$DelegatedAgreementsClient;

});


parcelRegister("aIEww", function(module, exports) {
"use strict";
var $7cdd728f512caa00$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7cdd728f512caa00$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7cdd728f512caa00$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7cdd728f512caa00$var$__exportStar((parcelRequire("jx9ol")), module.exports);

$7cdd728f512caa00$var$__exportStar((parcelRequire("9cL9o")), module.exports);

$7cdd728f512caa00$var$__exportStar((parcelRequire("8TSaa")), module.exports);

});
parcelRegister("jx9ol", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9cL9o", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AllocationsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $6b39cf2a1360b0a4$var$AllocationsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createAllocation(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAllocationAction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAllocation(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocationActions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocations(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.AllocationsClient = $6b39cf2a1360b0a4$var$AllocationsClient;

});

parcelRegister("8TSaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedAllocationsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $67ad796a1c70e501$var$DelegatedAllocationsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createAllocationInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createAllocationComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAllocationActionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createAllocationActionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAllocation(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocationActions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocations(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedAllocationsClient = $67ad796a1c70e501$var$DelegatedAllocationsClient;

});


parcelRegister("jFryV", function(module, exports) {
"use strict";
var $e51739f2f0c5a2ca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e51739f2f0c5a2ca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e51739f2f0c5a2ca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e51739f2f0c5a2ca$var$__exportStar((parcelRequire("eSuj6")), module.exports);

$e51739f2f0c5a2ca$var$__exportStar((parcelRequire("3rQIe")), module.exports);

$e51739f2f0c5a2ca$var$__exportStar((parcelRequire("3CXDw")), module.exports);

});
parcelRegister("eSuj6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3rQIe", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $282cc84f7a1cbda0$var$AuthClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateCredential(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activatePersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archivePersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredential(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createCredential instead */ async createUserCredential(request) {
        return this.createCredential(request);
    }
    async createCredentialChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createCredentialChallenge instead */ async createUserCredentialChallenge(request) {
        return this.createCredentialChallenge(request);
    }
    async createCredentialChallengeWithCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialWithCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code/verify', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createDelegatedRecoveryChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/delegated', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createDelegatedRecoveryChallenge instead */ async createDelegatedUserRecovery(request) {
        return this.createDelegatedRecoveryChallenge(request);
    }
    async createDelegatedRegistrationChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/delegated', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createDelegatedRegistrationChallenge instead */ async createDelegatedUserRegistration(request) {
        return this.createDelegatedRegistrationChallenge(request);
    }
    async createLoginChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRecoveryChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRegistrationChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSocialRegistrationChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUserActionChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createUserActionChallenge instead */ async createUserActionSignatureChallenge(request) {
        return this.createUserActionChallenge(request);
    }
    async createUserActionSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateCredential(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivatePersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegatedLogin(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/delegated', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use delegatedLogin instead */ async createDelegatedUserLogin(request) {
        return this.delegatedLogin(request);
    }
    async getApplication(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/apps/:appId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAuditLog(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action/logs/:id', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApplications() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/apps', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAuditLogs(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action/logs', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCredentials() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use listCredentials instead */ async listUserCredentials() {
        return this.listCredentials();
    }
    async listPersonalAccessTokens() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listServiceAccounts() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listUsers(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async login(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async logout(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/logout', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request?.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recover(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use recover instead */ async createUserRecovery(request) {
        return this.recover(request);
    }
    async register(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use register instead */ async createUserRegistration(request) {
        return this.register(request);
    }
    async registerEndUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/enduser', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async resendRegistrationCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendLoginCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendRecoveryCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async socialLogin(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLogin(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/sso', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLoginInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/sso/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.AuthClient = $282cc84f7a1cbda0$var$AuthClient;

});

parcelRegister("3CXDw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedAuthClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $2a432e491ed807e5$var$DelegatedAuthClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateCredentialInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateCredentialComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activatePersonalAccessTokenInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activatePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateServiceAccountInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateServiceAccountComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateUserInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateUserComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archivePersonalAccessTokenInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archivePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveServiceAccountInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archiveServiceAccountComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveUserInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archiveUserComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCredentialComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createCredentialChallenge instead */ async createUserCredentialChallenge(request) {
        return this.createCredentialChallenge(request);
    }
    async createCredentialChallengeWithCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialCodeInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCredentialCodeComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialWithCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/code/verify', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createDelegatedRecoveryChallengeInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/delegated', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createDelegatedRecoveryChallengeComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/delegated', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createDelegatedRegistrationChallengeInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/delegated', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createDelegatedRegistrationChallengeComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/delegated', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createLoginChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPersonalAccessTokenInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRecoveryChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRegistrationChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createServiceAccountInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createServiceAccountComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSocialRegistrationChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUserInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createUserComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUserActionChallenge(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createUserActionChallenge instead */ async createUserActionSignatureChallenge(request) {
        return this.createUserActionChallenge(request);
    }
    async createUserActionSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateCredentialInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateCredentialComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivatePersonalAccessTokenInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivatePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateServiceAccountInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateServiceAccountComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateUserInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateUserComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegatedLoginInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/delegated', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async delegatedLoginComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/delegated', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getApplication(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/apps/:appId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAuditLog(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action/logs/:id', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPersonalAccessToken(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getServiceAccount(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApplications() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/apps', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAuditLogs(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/action/logs', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCredentials() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/credentials', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use listCredentials instead */ async listUserCredentials() {
        return this.listCredentials();
    }
    async listPersonalAccessTokens() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listServiceAccounts() {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listUsers(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async login(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async logout(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/logout', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request?.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recover(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use recover instead */ async createUserRecovery(request) {
        return this.recover(request);
    }
    async register(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use register instead */ async createUserRegistration(request) {
        return this.register(request);
    }
    async registerEndUser(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/enduser', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async resendRegistrationCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/registration/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendLoginCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendRecoveryCode(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/recover/user/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async socialLogin(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLogin(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/sso', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLoginInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/login/sso/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePersonalAccessTokenInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updatePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateServiceAccountInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateServiceAccountComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateUserInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateUserComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedAuthClient = $2a432e491ed807e5$var$DelegatedAuthClient;

});


parcelRegister("dVmLf", function(module, exports) {
"use strict";
var $a232411e2a4ea648$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a232411e2a4ea648$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a232411e2a4ea648$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a232411e2a4ea648$var$__exportStar((parcelRequire("gky1S")), module.exports);

$a232411e2a4ea648$var$__exportStar((parcelRequire("50yBW")), module.exports);

$a232411e2a4ea648$var$__exportStar((parcelRequire("lcyOY")), module.exports);

});
parcelRegister("gky1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("50yBW", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExchangesClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $3a57ccd478a75872$var$ExchangesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createDeposit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/deposits', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createExchange(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWithdrawal(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/withdrawals', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteExchange(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getExchange(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccountAssets(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccounts(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssetWithdrawalNetworks(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets/:asset/withdrawal-networks', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listExchanges(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.ExchangesClient = $3a57ccd478a75872$var$ExchangesClient;

});

parcelRegister("lcyOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedExchangesClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $f6f5bab51cc3315c$var$DelegatedExchangesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createDepositInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/deposits', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createDepositComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/deposits', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createExchangeInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createExchangeComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWithdrawalInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/withdrawals', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createWithdrawalComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/withdrawals', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteExchangeInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteExchangeComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getExchange(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccountAssets(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccounts(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssetWithdrawalNetworks(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets/:asset/withdrawal-networks', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listExchanges(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedExchangesClient = $f6f5bab51cc3315c$var$DelegatedExchangesClient;

});


parcelRegister("eFwEd", function(module, exports) {
"use strict";
var $aade3824ac2eba0d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aade3824ac2eba0d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aade3824ac2eba0d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aade3824ac2eba0d$var$__exportStar((parcelRequire("peQD6")), module.exports);

$aade3824ac2eba0d$var$__exportStar((parcelRequire("lGd6f")), module.exports);

$aade3824ac2eba0d$var$__exportStar((parcelRequire("aN90u")), module.exports);

});
parcelRegister("peQD6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lGd6f", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeeSponsorsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $fc87ae8cf24ea72b$var$FeeSponsorsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateFeeSponsor(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createFeeSponsor(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateFeeSponsor(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteFeeSponsor(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFeeSponsor(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listFeeSponsors(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSponsoredFees(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/fees', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.FeeSponsorsClient = $fc87ae8cf24ea72b$var$FeeSponsorsClient;

});

parcelRegister("aN90u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedFeeSponsorsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $7db57791af3552ac$var$DelegatedFeeSponsorsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateFeeSponsorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createFeeSponsorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateFeeSponsorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteFeeSponsorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFeeSponsor(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listFeeSponsors(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSponsoredFees(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/fees', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedFeeSponsorsClient = $7db57791af3552ac$var$DelegatedFeeSponsorsClient;

});


parcelRegister("1mQ28", function(module, exports) {
"use strict";
var $0ff0354c4d542971$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0ff0354c4d542971$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0ff0354c4d542971$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0ff0354c4d542971$var$__exportStar((parcelRequire("347Q0")), module.exports);

$0ff0354c4d542971$var$__exportStar((parcelRequire("9uu5B")), module.exports);

$0ff0354c4d542971$var$__exportStar((parcelRequire("jsffk")), module.exports);

});
parcelRegister("347Q0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9uu5B", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeysClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $6e8e41855f6969f8$var$KeysClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/delegate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deriveKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/derive', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/export', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/import', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeys(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.KeysClient = $6e8e41855f6969f8$var$KeysClient;

});

parcelRegister("jsffk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedKeysClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $e29c756a820e0f61$var$DelegatedKeysClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/delegate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async delegateKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/delegate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deriveKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/derive', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deriveKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/derive', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/export', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async exportKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/export', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignatureInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async generateSignatureComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getKey(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/import', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async importKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/import', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeys(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateKeyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateKeyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedKeysClient = $e29c756a820e0f61$var$DelegatedKeysClient;

});


parcelRegister("lRWRX", function(module, exports) {
"use strict";
var $febc366f83eb588f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $febc366f83eb588f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $febc366f83eb588f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$febc366f83eb588f$var$__exportStar((parcelRequire("2LS8r")), module.exports);

$febc366f83eb588f$var$__exportStar((parcelRequire("hlIO7")), module.exports);

$febc366f83eb588f$var$__exportStar((parcelRequire("cPVeC")), module.exports);

});
parcelRegister("2LS8r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hlIO7", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworksClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $ca1727a9e3fc7755$var$NetworksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async callFunction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/call-function', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCantonValidator(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteCantonValidator(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getCantonValidator(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFees(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/fees', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCantonValidators(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateCantonValidator(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.NetworksClient = $ca1727a9e3fc7755$var$NetworksClient;

});

parcelRegister("cPVeC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedNetworksClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $9586a51d2ca2e5cc$var$DelegatedNetworksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async callFunction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/call-function', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCantonValidatorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCantonValidatorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteCantonValidatorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteCantonValidatorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getCantonValidator(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFees(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/fees', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCantonValidators(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateCantonValidatorInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateCantonValidatorComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedNetworksClient = $9586a51d2ca2e5cc$var$DelegatedNetworksClient;

});


parcelRegister("b0sby", function(module, exports) {
"use strict";
var $80358ecff4018c18$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $80358ecff4018c18$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $80358ecff4018c18$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$80358ecff4018c18$var$__exportStar((parcelRequire("1jia4")), module.exports);

$80358ecff4018c18$var$__exportStar((parcelRequire("h5c01")), module.exports);

$80358ecff4018c18$var$__exportStar((parcelRequire("89ZOG")), module.exports);

});
parcelRegister("1jia4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("h5c01", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PayoutsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $c6fc3619538297cb$var$PayoutsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createPayout(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutAction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/:payoutId/action', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutQuote(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/quote', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPayout(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/:payoutId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPayouts(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.PayoutsClient = $c6fc3619538297cb$var$PayoutsClient;

});

parcelRegister("89ZOG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedPayoutsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $5f0f1d6eb8b1c811$var$DelegatedPayoutsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createPayoutInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPayoutComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutActionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/:payoutId/action', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPayoutActionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/:payoutId/action', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutQuote(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/quote', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPayout(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts/:payoutId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPayouts(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedPayoutsClient = $5f0f1d6eb8b1c811$var$DelegatedPayoutsClient;

});


parcelRegister("lf1zV", function(module, exports) {
"use strict";
var $f76c391dae267883$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f76c391dae267883$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f76c391dae267883$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f76c391dae267883$var$__exportStar((parcelRequire("9ieSB")), module.exports);

$f76c391dae267883$var$__exportStar((parcelRequire("kXgp7")), module.exports);

$f76c391dae267883$var$__exportStar((parcelRequire("arYJV")), module.exports);

});
parcelRegister("9ieSB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kXgp7", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermissionsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $f4160ad698c33147$var$PermissionsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePermission(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAssignment(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPermission(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteAssignment(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments/:assignmentId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
    }
    async getPermission(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssignments(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPermissions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePermission(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.PermissionsClient = $f4160ad698c33147$var$PermissionsClient;

});

parcelRegister("arYJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedPermissionsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $79bb8aa21fe0b409$var$DelegatedPermissionsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePermissionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archivePermissionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAssignmentInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createAssignmentComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPermissionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPermissionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteAssignmentInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments/:assignmentId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteAssignmentComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments/:assignmentId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
    }
    async getPermission(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssignments(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPermissions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePermissionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updatePermissionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedPermissionsClient = $79bb8aa21fe0b409$var$DelegatedPermissionsClient;

});


parcelRegister("g82VE", function(module, exports) {
"use strict";
var $bbdfaa48277c60fe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bbdfaa48277c60fe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bbdfaa48277c60fe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bbdfaa48277c60fe$var$__exportStar((parcelRequire("7dfZ1")), module.exports);

$bbdfaa48277c60fe$var$__exportStar((parcelRequire("conKv")), module.exports);

$bbdfaa48277c60fe$var$__exportStar((parcelRequire("7a43f")), module.exports);

});
parcelRegister("7dfZ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("conKv", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PoliciesClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $905a25fd947da5d2$var$PoliciesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePolicy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createApprovalDecision(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPolicy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getApproval(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals/:approvalId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPolicy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApprovals(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPolicies(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePolicy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.PoliciesClient = $905a25fd947da5d2$var$PoliciesClient;

});

parcelRegister("7a43f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedPoliciesClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $536c9c16036291d7$var$DelegatedPoliciesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePolicyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archivePolicyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createApprovalDecisionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createApprovalDecisionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPolicyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPolicyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getApproval(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals/:approvalId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPolicy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApprovals(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policy-approvals', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPolicies(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePolicyInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updatePolicyComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedPoliciesClient = $536c9c16036291d7$var$DelegatedPoliciesClient;

});


parcelRegister("lfAEc", function(module, exports) {
"use strict";
var $f7876d15afb96b43$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f7876d15afb96b43$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f7876d15afb96b43$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f7876d15afb96b43$var$__exportStar((parcelRequire("3RaZE")), module.exports);

$f7876d15afb96b43$var$__exportStar((parcelRequire("jxIk1")), module.exports);

$f7876d15afb96b43$var$__exportStar((parcelRequire("90Y3M")), module.exports);

});
parcelRegister("3RaZE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jxIk1", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignersClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $e3a37acc2ffdfef8$var$SignersClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createCloneInput(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/clone/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createGenesisInput(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/genesis/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createOnchainSignInput(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createProofOfControlInput(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeyStores() {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSigners() {
        const path = (0, $c8Pib.buildPathAndQuery)('/signers', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitCloneOutput(request, file) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/clone/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitGenesisOutput(request, file) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/genesis/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitOnchainSignOutput(request, file) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitProofOfControlOutput(request, file) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.SignersClient = $e3a37acc2ffdfef8$var$SignersClient;

});

parcelRegister("90Y3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedSignersClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $6902b3d21f3cf352$var$DelegatedSignersClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createCloneInputInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/clone/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCloneInputComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/clone/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createGenesisInputInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/genesis/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createGenesisInputComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/genesis/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createOnchainSignInputInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createOnchainSignInputComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createProofOfControlInputInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createProofOfControlInputComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeyStores() {
        const path = (0, $c8Pib.buildPathAndQuery)('/key-stores', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSigners() {
        const path = (0, $c8Pib.buildPathAndQuery)('/signers', {
            path: {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedSignersClient = $6902b3d21f3cf352$var$DelegatedSignersClient;

});


parcelRegister("lQ6X1", function(module, exports) {
"use strict";
var $fe63d8a43b6bc101$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe63d8a43b6bc101$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fe63d8a43b6bc101$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fe63d8a43b6bc101$var$__exportStar((parcelRequire("j1w2Z")), module.exports);

$fe63d8a43b6bc101$var$__exportStar((parcelRequire("4kqKK")), module.exports);

$fe63d8a43b6bc101$var$__exportStar((parcelRequire("CCyJa")), module.exports);

});
parcelRegister("j1w2Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4kqKK", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakingClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $326dc84484acf11b$var$StakingClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createStake(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createStakeAction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakeRewards(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/rewards', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakes(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakeActions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakes(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.StakingClient = $326dc84484acf11b$var$StakingClient;

});

parcelRegister("CCyJa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedStakingClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $074175c33fa464b9$var$DelegatedStakingClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createStakeInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createStakeComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createStakeActionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createStakeActionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakeRewards(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/rewards', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakes(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakeActions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakes(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedStakingClient = $074175c33fa464b9$var$DelegatedStakingClient;

});


parcelRegister("k2fao", function(module, exports) {
"use strict";
var $e95fc2533627396d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e95fc2533627396d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e95fc2533627396d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e95fc2533627396d$var$__exportStar((parcelRequire("jPT3G")), module.exports);

$e95fc2533627396d$var$__exportStar((parcelRequire("5trrS")), module.exports);

$e95fc2533627396d$var$__exportStar((parcelRequire("aJ4Vm")), module.exports);

});
parcelRegister("jPT3G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5trrS", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SwapsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $3fc4f3ea730357dc$var$SwapsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createSwap(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSwapQuote(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps/quotes', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwap(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps/:swapId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwapQuote(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps/quotes/:quoteId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSwaps(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.SwapsClient = $3fc4f3ea730357dc$var$SwapsClient;

});

parcelRegister("aJ4Vm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedSwapsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $7cf1ed2d6ff397a6$var$DelegatedSwapsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createSwapInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createSwapComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSwapQuote(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps/quotes', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwap(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps/:swapId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwapQuote(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps/quotes/:quoteId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSwaps(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedSwapsClient = $7cf1ed2d6ff397a6$var$DelegatedSwapsClient;

});


parcelRegister("i2KgQ", function(module, exports) {
"use strict";
var $d22c4e4686e11b76$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d22c4e4686e11b76$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d22c4e4686e11b76$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d22c4e4686e11b76$var$__exportStar((parcelRequire("8IfiC")), module.exports);

$d22c4e4686e11b76$var$__exportStar((parcelRequire("fxaCK")), module.exports);

$d22c4e4686e11b76$var$__exportStar((parcelRequire("1RoZM")), module.exports);

});
parcelRegister("8IfiC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fxaCK", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletsClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $b4f22dcbb9549465$var$WalletsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async abortTransaction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/abort', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async abortTransfer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/abort', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async acceptOffer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/accept', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async broadcastTransaction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransaction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/cancel', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransfer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/cancel', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cantonLedgerApiProxy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/canton/ledger-api', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/delegate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/export', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getOffer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransaction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransfer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletAssets(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletHistory(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/history', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletNfts(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/nfts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/import', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOffers(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOrgWalletHistory(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/all/history', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransactions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransfers(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWallets(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async rejectOffer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/reject', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransaction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransfer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async tagWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async transferAsset(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async untagWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.WalletsClient = $b4f22dcbb9549465$var$WalletsClient;

});

parcelRegister("1RoZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedWalletsClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $15ae213f8fc4ae54$var$DelegatedWalletsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async abortTransactionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/abort', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async abortTransactionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/abort', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async abortTransferInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/abort', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async abortTransferComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/abort', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async acceptOfferInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/accept', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async acceptOfferComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/accept', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async broadcastTransactionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async broadcastTransactionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransactionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/cancel', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async cancelTransactionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/cancel', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransferInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/cancel', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async cancelTransferComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/cancel', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cantonLedgerApiProxy(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/canton/ledger-api', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/delegate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async delegateWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/delegate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/export', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async exportWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/export', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignatureInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async generateSignatureComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getOffer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransaction(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransfer(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWallet(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletAssets(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletHistory(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/history', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletNfts(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/nfts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/import', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async importWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/import', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOffers(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOrgWalletHistory(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/all/history', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransactions(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransfers(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWallets(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async rejectOfferInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/reject', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async rejectOfferComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/reject', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransactionInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async speedUpTransactionComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransferInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async speedUpTransferComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async tagWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async tagWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async transferAssetInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async transferAssetComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async untagWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async untagWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWalletInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateWalletComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedWalletsClient = $15ae213f8fc4ae54$var$DelegatedWalletsClient;

});


parcelRegister("kbCVX", function(module, exports) {
"use strict";
var $eb23092e808e02dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eb23092e808e02dd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $eb23092e808e02dd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$eb23092e808e02dd$var$__exportStar((parcelRequire("lovl6")), module.exports);

$eb23092e808e02dd$var$__exportStar((parcelRequire("idFhk")), module.exports);

$eb23092e808e02dd$var$__exportStar((parcelRequire("iwLfS")), module.exports);

});
parcelRegister("lovl6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("idFhk", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebhooksClient = void 0;

var $3TYuV = parcelRequire("3TYuV");

var $4Ztiw = parcelRequire("4Ztiw");

var $c8Pib = parcelRequire("c8Pib");
class $d43975ec03dfea2d$var$WebhooksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createWebhook(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteWebhook(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhook(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhookEvent(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/events/:webhookEventId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhookEvents(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/events', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhooks(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async pingWebhook(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/ping', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWebhook(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $4Ztiw.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.WebhooksClient = $d43975ec03dfea2d$var$WebhooksClient;

});

parcelRegister("iwLfS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedWebhooksClient = void 0;

var $hU107 = parcelRequire("hU107");

var $3TYuV = parcelRequire("3TYuV");

var $c8Pib = parcelRequire("c8Pib");
class $d7cfdf0ad43526bb$var$DelegatedWebhooksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createWebhookInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createWebhookComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteWebhookInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteWebhookComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhook(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhookEvent(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/events/:webhookEventId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhookEvents(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/events', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhooks(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async pingWebhookInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/ping', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async pingWebhookComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId/ping', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWebhookInit(request) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $hU107.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateWebhookComplete(request, signedChallenge) {
        const path = (0, $c8Pib.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $hU107.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $3TYuV.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedWebhooksClient = $d7cfdf0ad43526bb$var$DelegatedWebhooksClient;

});



parcelRegister("9bDGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DfnsAuthenticator = void 0;

var $hU107 = parcelRequire("hU107");
class $6b03ed0004699b25$var$DfnsAuthenticator {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async login(request) {
        const challenge = await $hU107.BaseAuthApi.createUserLoginChallenge(request, this.apiOptions);
        const assertion = await this.apiOptions.signer.sign(challenge);
        return $hU107.BaseAuthApi.createUserLogin({
            challengeIdentifier: challenge.challengeIdentifier,
            firstFactor: assertion
        }, this.apiOptions);
    }
    async register(request) {
        if (!this.apiOptions.signer.create) throw new Error(`Provided signer does not implement 'create'`);
        const challenge = await $hU107.BaseAuthApi.createUserRegistrationChallenge(request, this.apiOptions);
        const attestation = await this.apiOptions.signer.create(challenge);
        return $hU107.BaseAuthApi.createUserRegistration({
            firstFactorCredential: attestation
        }, {
            ...this.apiOptions,
            authToken: challenge.temporaryAuthenticationToken
        });
    }
}
module.exports.DfnsAuthenticator = $6b03ed0004699b25$var$DfnsAuthenticator;

});

parcelRegister("lKg8n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DfnsDelegatedApiClient = void 0;

var $hmNiQ = parcelRequire("hmNiQ");

var $aIEww = parcelRequire("aIEww");

var $jFryV = parcelRequire("jFryV");

var $dVmLf = parcelRequire("dVmLf");

var $eFwEd = parcelRequire("eFwEd");

var $1mQ28 = parcelRequire("1mQ28");

var $lRWRX = parcelRequire("lRWRX");

var $b0sby = parcelRequire("b0sby");

var $lf1zV = parcelRequire("lf1zV");

var $g82VE = parcelRequire("g82VE");

var $lfAEc = parcelRequire("lfAEc");

var $lQ6X1 = parcelRequire("lQ6X1");

var $k2fao = parcelRequire("k2fao");

var $i2KgQ = parcelRequire("i2KgQ");

var $kbCVX = parcelRequire("kbCVX");
class $fd4a68c15323405b$var$DfnsDelegatedApiClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    get agreements() {
        return new $hmNiQ.DelegatedAgreementsClient(this.apiOptions);
    }
    get allocations() {
        return new $aIEww.DelegatedAllocationsClient(this.apiOptions);
    }
    get auth() {
        return new $jFryV.DelegatedAuthClient(this.apiOptions);
    }
    get exchanges() {
        return new $dVmLf.DelegatedExchangesClient(this.apiOptions);
    }
    get feeSponsors() {
        return new $eFwEd.DelegatedFeeSponsorsClient(this.apiOptions);
    }
    get keys() {
        return new $1mQ28.DelegatedKeysClient(this.apiOptions);
    }
    get networks() {
        return new $lRWRX.DelegatedNetworksClient(this.apiOptions);
    }
    get payouts() {
        return new $b0sby.DelegatedPayoutsClient(this.apiOptions);
    }
    get permissions() {
        return new $lf1zV.DelegatedPermissionsClient(this.apiOptions);
    }
    get policies() {
        return new $g82VE.DelegatedPoliciesClient(this.apiOptions);
    }
    get staking() {
        return new $lQ6X1.DelegatedStakingClient(this.apiOptions);
    }
    get swaps() {
        return new $k2fao.DelegatedSwapsClient(this.apiOptions);
    }
    get signers() {
        return new $lfAEc.DelegatedSignersClient(this.apiOptions);
    }
    get wallets() {
        return new $i2KgQ.DelegatedWalletsClient(this.apiOptions);
    }
    get webhooks() {
        return new $kbCVX.DelegatedWebhooksClient(this.apiOptions);
    }
}
module.exports.DfnsDelegatedApiClient = $fd4a68c15323405b$var$DfnsDelegatedApiClient;

});

parcelRegister("6sZi9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8wOwi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("tBfT8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minimizeBigInt = void 0;
const $058f9baae6ad73f3$var$minimizeBigInt = (value)=>{
    const minValue = [
        0,
        ...value
    ];
    for(let i = 0; i < minValue.length; ++i){
        if (minValue[i] === 0) continue;
        if (minValue[i] > 0x7f) return new Uint8Array(minValue.slice(i - 1));
        return new Uint8Array(minValue.slice(i));
    }
    return new Uint8Array([
        0
    ]);
};
module.exports.minimizeBigInt = $058f9baae6ad73f3$var$minimizeBigInt;

});

parcelRegister("lDIUv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rawSignatureToAns1 = module.exports.exportPublicKeyInPemFormatBrowser = void 0;

var $hAePC = parcelRequire("hAePC");

var $hWIAg = parcelRequire("hWIAg");

var $3VCKu = parcelRequire("3VCKu");

var $tBfT8 = parcelRequire("tBfT8");
// Using crypto.subtle in order to run this in the browser
// Adding `Browser` in the function name to distinguish with native node crypto module usage
const $fc1013bed6ab0b0b$var$exportPublicKeyInPemFormatBrowser = async (key)=>{
    const exported = await crypto.subtle.exportKey('spki', key.publicKey);
    const b64Exported = (0, $hWIAg.toBase64)($hAePC.Buffer.from(exported));
    const pem = `-----BEGIN PUBLIC KEY-----\n${(0, $3VCKu.splitString)(b64Exported).join("\n")}\n-----END PUBLIC KEY-----`;
    return pem;
};
module.exports.exportPublicKeyInPemFormatBrowser = $fc1013bed6ab0b0b$var$exportPublicKeyInPemFormatBrowser;
const $fc1013bed6ab0b0b$var$rawSignatureToAns1 = (rawSignature)=>{
    const r = rawSignature.slice(0, 32);
    const s = rawSignature.slice(32);
    const minR = (0, $tBfT8.minimizeBigInt)(r);
    const minS = (0, $tBfT8.minimizeBigInt)(s);
    return new Uint8Array([
        0x30,
        minR.length + minS.length + 4,
        0x02,
        minR.length,
        ...minR,
        0x02,
        minS.length,
        ...minS
    ]);
};
module.exports.rawSignatureToAns1 = $fc1013bed6ab0b0b$var$rawSignatureToAns1;

});

parcelRegister("kFTZb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $f0d310983a00c4e1$var$R = typeof Reflect === 'object' ? Reflect : null;
var $f0d310983a00c4e1$var$ReflectApply = $f0d310983a00c4e1$var$R && typeof $f0d310983a00c4e1$var$R.apply === 'function' ? $f0d310983a00c4e1$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $f0d310983a00c4e1$var$ReflectOwnKeys;
if ($f0d310983a00c4e1$var$R && typeof $f0d310983a00c4e1$var$R.ownKeys === 'function') $f0d310983a00c4e1$var$ReflectOwnKeys = $f0d310983a00c4e1$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $f0d310983a00c4e1$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $f0d310983a00c4e1$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $f0d310983a00c4e1$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $f0d310983a00c4e1$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $f0d310983a00c4e1$var$EventEmitter() {
    $f0d310983a00c4e1$var$EventEmitter.init.call(this);
}
module.exports = $f0d310983a00c4e1$var$EventEmitter;
module.exports.once = $f0d310983a00c4e1$var$once;
// Backwards-compat with node 0.10.x
$f0d310983a00c4e1$var$EventEmitter.EventEmitter = $f0d310983a00c4e1$var$EventEmitter;
$f0d310983a00c4e1$var$EventEmitter.prototype._events = undefined;
$f0d310983a00c4e1$var$EventEmitter.prototype._eventsCount = 0;
$f0d310983a00c4e1$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $f0d310983a00c4e1$var$defaultMaxListeners = 10;
function $f0d310983a00c4e1$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($f0d310983a00c4e1$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $f0d310983a00c4e1$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $f0d310983a00c4e1$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $f0d310983a00c4e1$var$defaultMaxListeners = arg;
    }
});
$f0d310983a00c4e1$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$f0d310983a00c4e1$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $f0d310983a00c4e1$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $f0d310983a00c4e1$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $f0d310983a00c4e1$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$f0d310983a00c4e1$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $f0d310983a00c4e1$var$_getMaxListeners(this);
};
$f0d310983a00c4e1$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $f0d310983a00c4e1$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $f0d310983a00c4e1$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$f0d310983a00c4e1$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $f0d310983a00c4e1$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $f0d310983a00c4e1$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $f0d310983a00c4e1$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $f0d310983a00c4e1$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$f0d310983a00c4e1$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $f0d310983a00c4e1$var$_addListener(this, type, listener, false);
};
$f0d310983a00c4e1$var$EventEmitter.prototype.on = $f0d310983a00c4e1$var$EventEmitter.prototype.addListener;
$f0d310983a00c4e1$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $f0d310983a00c4e1$var$_addListener(this, type, listener, true);
};
function $f0d310983a00c4e1$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $f0d310983a00c4e1$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $f0d310983a00c4e1$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$f0d310983a00c4e1$var$EventEmitter.prototype.once = function once(type, listener) {
    $f0d310983a00c4e1$var$checkListener(listener);
    this.on(type, $f0d310983a00c4e1$var$_onceWrap(this, type, listener));
    return this;
};
$f0d310983a00c4e1$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $f0d310983a00c4e1$var$checkListener(listener);
    this.prependListener(type, $f0d310983a00c4e1$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$f0d310983a00c4e1$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $f0d310983a00c4e1$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $f0d310983a00c4e1$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$f0d310983a00c4e1$var$EventEmitter.prototype.off = $f0d310983a00c4e1$var$EventEmitter.prototype.removeListener;
$f0d310983a00c4e1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $f0d310983a00c4e1$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $f0d310983a00c4e1$var$unwrapListeners(evlistener) : $f0d310983a00c4e1$var$arrayClone(evlistener, evlistener.length);
}
$f0d310983a00c4e1$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $f0d310983a00c4e1$var$_listeners(this, type, true);
};
$f0d310983a00c4e1$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $f0d310983a00c4e1$var$_listeners(this, type, false);
};
$f0d310983a00c4e1$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $f0d310983a00c4e1$var$listenerCount.call(emitter, type);
};
$f0d310983a00c4e1$var$EventEmitter.prototype.listenerCount = $f0d310983a00c4e1$var$listenerCount;
function $f0d310983a00c4e1$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$f0d310983a00c4e1$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $f0d310983a00c4e1$var$ReflectOwnKeys(this._events) : [];
};
function $f0d310983a00c4e1$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $f0d310983a00c4e1$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $f0d310983a00c4e1$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $f0d310983a00c4e1$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $f0d310983a00c4e1$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $f0d310983a00c4e1$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $f0d310983a00c4e1$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $f0d310983a00c4e1$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $f0d310983a00c4e1$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("bBj7l", function(module, exports) {

$parcel$export(module.exports, "a7", () => $8721fac3cbf33e27$export$a93c5207d687da10);
$parcel$export(module.exports, "ae", () => $8721fac3cbf33e27$export$f787f51d84a910ad);
$parcel$export(module.exports, "a0", () => $8721fac3cbf33e27$export$34aec0b863436764);
$parcel$export(module.exports, "E", () => $8721fac3cbf33e27$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "D", () => $8721fac3cbf33e27$export$96f57966bedc81b4);
$parcel$export(module.exports, "Q", () => $8721fac3cbf33e27$export$3722cfe417b6ed86);
$parcel$export(module.exports, "ar", () => $8721fac3cbf33e27$export$d24c54395ce0c509);
$parcel$export(module.exports, "aq", () => $8721fac3cbf33e27$export$8a5498727ef6be21);
$parcel$export(module.exports, "r", () => $8721fac3cbf33e27$export$43caf9889c228507);
$parcel$export(module.exports, "ap", () => $8721fac3cbf33e27$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "as", () => $8721fac3cbf33e27$export$6554612db691658e);
$parcel$export(module.exports, "a6", () => $8721fac3cbf33e27$export$2e2af4578d910ddf);
$parcel$export(module.exports, "a4", () => $8721fac3cbf33e27$export$efca4cbe5dd06740);
$parcel$export(module.exports, "h", () => $8721fac3cbf33e27$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "ao", () => $8721fac3cbf33e27$export$7a38258bbe170828);
$parcel$export(module.exports, "af", () => $8721fac3cbf33e27$export$c9170ad7d4cd7e57);
$parcel$export(module.exports, "ah", () => $8721fac3cbf33e27$export$995eb9fca571757);
$parcel$export(module.exports, "a5", () => $8721fac3cbf33e27$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "a3", () => $8721fac3cbf33e27$export$6559d589eb85fbb6);
$parcel$export(module.exports, "n", () => $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "L", () => $8721fac3cbf33e27$export$61196ced6d74a310);
$parcel$export(module.exports, "Z", () => $8721fac3cbf33e27$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "s", () => $8721fac3cbf33e27$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "a1", () => $8721fac3cbf33e27$export$3c2fa207a37baaea);
$parcel$export(module.exports, "c", () => $8721fac3cbf33e27$export$db3b6bfb95261072);
$parcel$export(module.exports, "l", () => $8721fac3cbf33e27$export$882b5998b3b9117c);
$parcel$export(module.exports, "m", () => $8721fac3cbf33e27$export$953cecd6e717a553);
$parcel$export(module.exports, "a", () => $8721fac3cbf33e27$export$407448d2b89b1813);
$parcel$export(module.exports, "j", () => $8721fac3cbf33e27$export$35e795649ee09318);
$parcel$export(module.exports, "b", () => $8721fac3cbf33e27$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "d", () => $8721fac3cbf33e27$export$4368d992c4eafac0);
$parcel$export(module.exports, "B", () => $8721fac3cbf33e27$export$ef35774e6d314e91);
$parcel$export(module.exports, "t", () => $8721fac3cbf33e27$export$625550452a3fa3ec);
$parcel$export(module.exports, "G", () => $8721fac3cbf33e27$export$2329c99376c9d0a4);
$parcel$export(module.exports, "e", () => $8721fac3cbf33e27$export$f1e1789686576879);
$parcel$export(module.exports, "p", () => $8721fac3cbf33e27$export$ffb5f4729a158638);
$parcel$export(module.exports, "J", () => $8721fac3cbf33e27$export$b4171a6734a65d42);
$parcel$export(module.exports, "k", () => $8721fac3cbf33e27$export$342063e11d6c3cad);
$parcel$export(module.exports, "v", () => $8721fac3cbf33e27$export$90a7f3efeed30595);
$parcel$export(module.exports, "T", () => $8721fac3cbf33e27$export$971d5caa766a69d7);
$parcel$export(module.exports, "o", () => $8721fac3cbf33e27$export$ae1af26003f05816);
$parcel$export(module.exports, "H", () => $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "a2", () => $8721fac3cbf33e27$export$ce26c07117d59d6a);
$parcel$export(module.exports, "az", () => $8721fac3cbf33e27$export$3d12bd131bb975d1);
$parcel$export(module.exports, "ax", () => $8721fac3cbf33e27$export$9fa96a7d116ea3ce);
$parcel$export(module.exports, "ay", () => $8721fac3cbf33e27$export$28f7fcd39efa255);
$parcel$export(module.exports, "al", () => $8721fac3cbf33e27$export$ab83b03e4111b1d0);
$parcel$export(module.exports, "ai", () => $8721fac3cbf33e27$export$f38c853ae54ed474);
$parcel$export(module.exports, "g", () => $8721fac3cbf33e27$export$39b482c5e57630a8);
$parcel$export(module.exports, "U", () => $8721fac3cbf33e27$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "ad", () => $8721fac3cbf33e27$export$4c3d22f3d993c33f);
$parcel$export(module.exports, "y", () => $8721fac3cbf33e27$export$4a5767248b18ef41);
$parcel$export(module.exports, "z", () => $8721fac3cbf33e27$export$df995fae86a55f06);
$parcel$export(module.exports, "x", () => $8721fac3cbf33e27$export$d141bba7fdc215a3);
$parcel$export(module.exports, "A", () => $8721fac3cbf33e27$export$ebd11618f299a286);
$parcel$export(module.exports, "V", () => $8721fac3cbf33e27$export$e7c866399fa523f5);
$parcel$export(module.exports, "ak", () => $8721fac3cbf33e27$export$21579262ef46735b);
$parcel$export(module.exports, "a9", () => $8721fac3cbf33e27$export$a9c996f45e5784d0);
$parcel$export(module.exports, "_", () => $8721fac3cbf33e27$export$71511d61b312f219);
$parcel$export(module.exports, "$", () => $8721fac3cbf33e27$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "q", () => $8721fac3cbf33e27$export$9e5f44173e64f162);
$parcel$export(module.exports, "a8", () => $8721fac3cbf33e27$export$c3950d9923825c02);
$parcel$export(module.exports, "aA", () => $8721fac3cbf33e27$export$91c6e00c14e7e6fd);
$parcel$export(module.exports, "u", () => $8721fac3cbf33e27$export$3b14a55fb2447963);
$parcel$export(module.exports, "ac", () => $8721fac3cbf33e27$export$2219238a014317b0);
$parcel$export(module.exports, "F", () => $8721fac3cbf33e27$export$d66501df72047452);
$parcel$export(module.exports, "I", () => $8721fac3cbf33e27$export$9bb611d729802a56);
$parcel$export(module.exports, "K", () => $8721fac3cbf33e27$export$3466f893ebf79586);
$parcel$export(module.exports, "i", () => $8721fac3cbf33e27$export$23f2a1d2818174ef);
$parcel$export(module.exports, "S", () => $8721fac3cbf33e27$export$25ce5a424b770e84);
$parcel$export(module.exports, "N", () => $8721fac3cbf33e27$export$a07804094c3ecf2d);
$parcel$export(module.exports, "w", () => $8721fac3cbf33e27$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "at", () => $8721fac3cbf33e27$export$493d36ec626b6698);
$parcel$export(module.exports, "av", () => $8721fac3cbf33e27$export$d66dc83d8cfc8dd);
$parcel$export(module.exports, "O", () => $8721fac3cbf33e27$export$c4ce752e73470fba);
$parcel$export(module.exports, "am", () => $8721fac3cbf33e27$export$1a82df3d29112e01);
$parcel$export(module.exports, "aw", () => $8721fac3cbf33e27$export$92108d983e8ee699);
$parcel$export(module.exports, "au", () => $8721fac3cbf33e27$export$1fbe638ecf81657e);
$parcel$export(module.exports, "aj", () => $8721fac3cbf33e27$export$3b513254972cfc9c);
$parcel$export(module.exports, "P", () => $8721fac3cbf33e27$export$56c0d5a1e737357d);
$parcel$export(module.exports, "M", () => $8721fac3cbf33e27$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "ag", () => $8721fac3cbf33e27$export$ee7c8ad385a60b7b);
$parcel$export(module.exports, "f", () => $8721fac3cbf33e27$export$2d1720544b23b823);
$parcel$export(module.exports, "C", () => $8721fac3cbf33e27$export$e7094788287c5e9b);
$parcel$export(module.exports, "an", () => $8721fac3cbf33e27$export$306ddfe3a8403e2);
$parcel$export(module.exports, "aa", () => $8721fac3cbf33e27$export$7910e0436ed8d1de);
$parcel$export(module.exports, "X", () => $8721fac3cbf33e27$export$78acf4525d8a74c4);
$parcel$export(module.exports, "ab", () => $8721fac3cbf33e27$export$555508cbc6add439);
$parcel$export(module.exports, "Y", () => $8721fac3cbf33e27$export$8743009a87fcb00f);
$parcel$export(module.exports, "R", () => $8721fac3cbf33e27$export$db202ddc8be9136);
$parcel$export(module.exports, "W", () => $8721fac3cbf33e27$export$71cec2538cb2c617);
$parcel$export(module.exports, "aB", () => $8721fac3cbf33e27$export$9d398bebfec1c039);

var $a6zBK = parcelRequire("a6zBK");
var $fcGyk = parcelRequire("fcGyk");
var $44850 = parcelRequire("44850");
var $9vj9x = parcelRequire("9vj9x");
var $lqWQ2 = parcelRequire("lqWQ2");
var $3U9xZ = parcelRequire("3U9xZ");
var $62g8m = parcelRequire("62g8m");
var $aXPYD = parcelRequire("aXPYD");
var $3nJ2a = parcelRequire("3nJ2a");
var $fPFN5 = parcelRequire("fPFN5");
var $62AF9 = parcelRequire("62AF9");
var $kgoiB = parcelRequire("kgoiB");
var $gybEh = parcelRequire("gybEh");

var $9TSAA = parcelRequire("9TSAA");
var $9vj9x = parcelRequire("9vj9x");
var $jfdoI = parcelRequire("jfdoI");
var $fIHKl = parcelRequire("fIHKl");
var $b2hmj = parcelRequire("b2hmj");
var $3nJ2a = parcelRequire("3nJ2a");
var $fPFN5 = parcelRequire("fPFN5");
var $gltW7 = parcelRequire("gltW7");
var $kgoiB = parcelRequire("kgoiB");
var $gybEh = parcelRequire("gybEh");
var $FNLtf = parcelRequire("FNLtf");

var $dzDkt = parcelRequire("dzDkt");

var $fQSUm = parcelRequire("fQSUm");

var $8FKcp = parcelRequire("8FKcp");

var $a6eMa = parcelRequire("a6eMa");
parcelRequire("8YciW");
var $6hARo = parcelRequire("6hARo");
var $dkXem = parcelRequire("dkXem");
var $bKBH7 = parcelRequire("bKBH7");

var $dHSHZ = parcelRequire("dHSHZ");

var $6bixs = parcelRequire("6bixs");
var $lOW8k = parcelRequire("lOW8k");

var $j9N2Z = parcelRequire("j9N2Z");

var $1VClN = parcelRequire("1VClN");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8721fac3cbf33e27$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
var $8721fac3cbf33e27$var$defaultBnIcon = `<svg width="756" height="756" viewBox="0 0 756 756" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_210_16)">
<rect x="22" y="22" width="712.081" height="712.081" rx="100" fill="white"/>
<rect x="21.5" y="21.5" width="713.081" height="713.081" rx="100.5" stroke="#CCCCCC" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M388.846 243.497C391.572 244.066 394.144 245.216 396.391 246.871C398.905 248.87 400.831 251.522 401.963 254.539C409.105 272.488 416.247 290.426 423.39 308.352C431.294 328.289 439.237 348.23 447.22 368.174C451.381 378.631 455.52 389.098 459.744 399.533C460.643 401.668 461.107 403.962 461.107 406.28C461.107 408.598 460.643 410.893 459.744 413.027L423.444 503.98C421.04 510 416.686 513.743 410.284 514.719C402.319 515.923 395.194 511.974 392.316 504.956C385.505 488.132 378.844 471.255 372.129 454.387L337.984 368.586C327.874 343.124 317.749 317.67 307.611 292.222C304.248 283.772 300.993 275.279 297.479 266.894C296.512 264.614 296.054 262.148 296.139 259.671C296.223 257.193 296.848 254.764 297.969 252.557C299.09 250.349 300.68 248.417 302.625 246.896C304.571 245.376 306.825 244.304 309.228 243.757C309.518 243.692 309.799 243.584 310.079 243.497H388.846Z" fill="url(#paint0_linear_210_16)"/>
<path d="M247.379 243.497C248.273 243.747 249.168 243.963 250.041 244.267C252.313 244.981 254.399 246.198 256.143 247.829C257.887 249.46 259.245 251.464 260.118 253.693C267.915 273.131 275.675 292.584 283.399 312.051C291.217 331.677 299.035 351.307 306.852 370.94C310.675 380.565 314.516 390.187 318.374 399.804C319.238 401.864 319.683 404.077 319.683 406.312C319.683 408.548 319.238 410.761 318.374 412.821C314.063 423.625 309.752 434.425 305.44 445.221C297.536 464.985 289.632 484.748 281.728 504.512C280.487 507.589 278.366 510.226 275.633 512.087C272.901 513.949 269.68 514.952 266.38 514.968C262.884 515.03 259.455 514.004 256.561 512.029C253.667 510.055 251.45 507.228 250.213 503.937C242.906 485.312 235.447 466.742 228.053 448.15C218.144 422.977 208.185 397.823 198.176 372.686C187.987 347.102 177.802 321.513 167.62 295.921C163.761 286.235 159.935 276.527 156.023 266.851C154.313 262.819 154.23 258.277 155.791 254.185C157.353 250.093 160.435 246.773 164.386 244.929C165.82 244.346 167.293 243.867 168.795 243.497H247.379Z" fill="url(#paint1_linear_210_16)"/>
<path d="M599.828 408.922C597.67 416.244 594.438 423.154 591.69 430.215C583.736 450.304 575.738 470.382 567.695 490.449C565.852 495.049 563.976 499.637 562.188 504.258C560.928 507.415 558.759 510.12 555.952 512.021C553.15 513.923 549.845 514.934 546.463 514.923C543.081 514.913 539.784 513.881 536.992 511.963C534.2 510.043 532.042 507.325 530.803 504.16L495.904 416.494L465.724 340.77C455.873 316.046 446.029 291.325 436.192 266.608C435.257 264.348 434.826 261.909 434.929 259.463C435.032 257.017 435.667 254.623 436.79 252.451C437.912 250.279 439.494 248.381 441.424 246.892C443.355 245.402 445.587 244.356 447.962 243.829C448.286 243.753 448.598 243.645 448.921 243.547H527.689C527.934 243.623 528.173 243.72 528.422 243.775C531.184 244.355 533.756 245.627 535.9 247.474C538.043 249.321 539.692 251.682 540.689 254.34C545.272 265.91 549.863 277.448 554.461 288.953C566.497 319.166 578.522 349.379 590.536 379.592C593.695 387.553 597.208 395.374 599.795 403.553L599.828 408.922Z" fill="url(#paint2_linear_210_16)"/>
</g>
<defs>
<filter id="filter0_d_210_16" x="0.348907" y="0.348907" width="755.384" height="755.383" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="10.3255"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
<feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow_210_16"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_210_16" result="shape"/>
</filter>
<linearGradient id="paint0_linear_210_16" x1="283.92" y1="265.538" x2="474.49" y2="454.896" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF00A8"/>
<stop offset="1" stop-color="#6200C6"/>
</linearGradient>
<linearGradient id="paint1_linear_210_16" x1="142.528" y1="265.473" x2="333.054" y2="454.788" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF00A8"/>
<stop offset="1" stop-color="#6200C6"/>
</linearGradient>
<linearGradient id="paint2_linear_210_16" x1="422.73" y1="265.469" x2="613.268" y2="454.794" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF00A8"/>
<stop offset="1" stop-color="#6200C6"/>
</linearGradient>
</defs>
</svg>
`;
var $8721fac3cbf33e27$export$a93c5207d687da10 = `
<svg width="170" height="17" viewBox="0 0 170 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_208_15)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M122.262 1.76074C121.506 1.76074 120.886 2.37313 120.886 3.15393C120.886 3.91942 121.506 4.53181 122.262 4.53181C123.019 4.53181 123.639 3.91942 123.639 3.15393C123.639 2.37313 123.019 1.76074 122.262 1.76074ZM123.472 5.23601H121.068V13.4879H123.472V5.23601ZM107.034 2.06696H109.378V5.23607H111.178V7.44068H109.378V10.3495C109.378 10.7782 109.711 11.115 110.119 11.115H111.162V13.4574H110.119C108.425 13.4574 107.034 12.0642 107.034 10.3342V7.42536H105.945V5.22076H107.034V2.06696ZM116.909 5.05236C115.82 5.05236 114.958 5.51164 114.626 6.23121V2.06696H112.221V13.4727H114.626V8.84917C114.626 7.88466 115.246 7.21103 116.123 7.21103C117.015 7.21103 117.514 7.79281 117.514 8.77262V13.488H119.919V8.46642C119.919 6.32307 118.83 5.05236 116.909 5.05236ZM126.905 5.22072V6.35364C127.268 5.52691 128.145 5.05232 129.249 5.03701C129.415 5.03701 129.627 5.05232 129.884 5.08293V7.3794C129.642 7.33346 129.37 7.30285 129.083 7.30285C127.707 7.30285 126.905 8.08364 126.905 9.44619V13.4727H124.501V5.22072H126.905ZM136.644 6.30776C136.402 5.58819 135.449 5.08299 134.224 5.08299C133.075 5.08299 132.107 5.49634 131.336 6.32307C130.58 7.13448 130.187 8.16023 130.187 9.3544C130.187 10.5486 130.58 11.559 131.336 12.401C132.107 13.2124 133.075 13.6258 134.224 13.6258C135.449 13.6258 136.402 13.1206 136.644 12.401V13.488H139.048V2.06696H136.644V6.30776ZM136.16 10.8241C135.752 11.2222 135.253 11.4059 134.663 11.4059C134.088 11.4059 133.589 11.2069 133.196 10.8241C132.788 10.4108 132.591 9.92085 132.591 9.3544C132.591 8.78793 132.788 8.29803 133.196 7.89997C133.604 7.4866 134.088 7.28758 134.663 7.28758C135.268 7.28758 135.767 7.4866 136.16 7.89997C136.583 8.29803 136.795 8.78793 136.795 9.3544C136.795 9.92085 136.583 10.4108 136.16 10.8241ZM145.99 5.26662L148.168 9.18591L149.634 5.23601H151.994L148.636 13.9625L145.99 9.21654L143.343 13.9625L140.001 5.23601H142.361L143.812 9.18591L145.99 5.26662ZM155.956 5.03701C154.716 5.03701 153.672 5.43505 152.855 6.23115C152.054 7.01195 151.646 8.05301 151.646 9.33903V9.41558C151.646 10.7016 152.054 11.7427 152.855 12.5235C153.687 13.2889 154.746 13.687 156.077 13.687C157.317 13.687 158.33 13.442 159.101 12.9368V10.8088C158.345 11.3446 157.377 11.6049 156.213 11.6049C154.942 11.6049 154.111 10.9772 154.065 9.99736H160.039C160.069 9.7524 160.084 9.47683 160.084 9.20125C160.084 8.0224 159.691 7.04258 158.935 6.24648C158.179 5.43505 157.165 5.03701 155.956 5.03701ZM154.065 8.42046C154.08 8.0377 154.277 7.71619 154.64 7.45593C155.018 7.19566 155.441 7.05789 155.956 7.05789C156.908 7.05789 157.649 7.68558 157.649 8.42046H154.065ZM165.816 5.08297C166.965 5.08297 167.933 5.49634 168.689 6.32307C169.46 7.14979 169.853 8.14493 169.853 9.33907C169.853 10.5332 169.46 11.5437 168.689 12.3857C167.933 13.1971 166.965 13.6105 165.816 13.6105C164.591 13.6105 163.638 13.1053 163.396 12.3857V13.4727H160.991V2.06696H163.396V6.30776C163.638 5.58819 164.591 5.08297 165.816 5.08297ZM165.377 11.4059C165.952 11.4059 166.436 11.2222 166.844 10.8241C167.252 10.4108 167.449 9.92085 167.449 9.3544C167.449 8.78793 167.252 8.29801 166.844 7.89997C166.451 7.4866 165.952 7.28758 165.377 7.28758C164.787 7.28758 164.288 7.4866 163.865 7.89997C163.456 8.29801 163.245 8.78793 163.245 9.3544C163.245 9.92085 163.456 10.4108 163.865 10.8241C164.273 11.2069 164.772 11.4059 165.377 11.4059Z" fill="currentColor"/>
<path d="M89.8362 0.333008C89.988 0.364561 90.1313 0.428355 90.2565 0.520089C90.3966 0.630998 90.5038 0.778018 90.5669 0.945385C90.9647 1.94075 91.3625 2.9355 91.7603 3.92966C92.2006 5.03532 92.6431 6.14117 93.0877 7.24722C93.3194 7.82711 93.55 8.4076 93.7853 8.9863C93.8354 9.10466 93.8612 9.23191 93.8612 9.36046C93.8612 9.48901 93.8354 9.61626 93.7853 9.73462L91.7633 14.7786C91.6295 15.1125 91.3869 15.32 91.0303 15.3741C90.5867 15.4409 90.1898 15.222 90.0296 14.8327C89.6501 13.8997 89.2791 12.9637 88.9051 12.0283L87.0032 7.27007C86.4401 5.85803 85.8762 4.4464 85.3114 3.03517C85.1241 2.56656 84.9428 2.09555 84.7471 1.63055C84.6932 1.50411 84.6677 1.36735 84.6724 1.22995C84.6772 1.09255 84.712 0.957863 84.7744 0.835438C84.8368 0.713012 84.9254 0.605838 85.0337 0.52151C85.1421 0.437179 85.2677 0.377755 85.4015 0.347445C85.4177 0.343836 85.4333 0.33782 85.4489 0.333008H89.8362Z" fill="url(#paint0_linear_208_15)"/>
<path d="M81.9564 0.333008C82.0062 0.346844 82.0561 0.358875 82.1047 0.375718C82.2313 0.415281 82.3474 0.482777 82.4446 0.57324C82.5417 0.663706 82.6174 0.774838 82.666 0.898465C83.1003 1.97644 83.5325 3.05522 83.9628 4.13481C84.3982 5.2232 84.8337 6.31181 85.2691 7.4006C85.482 7.93438 85.696 8.46795 85.9109 9.00134C85.959 9.11556 85.9838 9.23828 85.9838 9.36226C85.9838 9.48624 85.959 9.60897 85.9109 9.7232C85.6707 10.3223 85.4306 10.9213 85.1905 11.52C84.7502 12.616 84.31 13.7121 83.8697 14.8081C83.8006 14.9787 83.6824 15.125 83.5302 15.2282C83.378 15.3315 83.1986 15.3871 83.0148 15.388C82.8201 15.3914 82.6291 15.3345 82.4679 15.225C82.3067 15.1155 82.1832 14.9587 82.1143 14.7762C81.7073 13.7433 81.2918 12.7135 80.88 11.6824C80.3281 10.2864 79.7734 8.89144 79.2158 7.49746C78.6483 6.0786 78.081 4.65954 77.5139 3.2403C77.2989 2.70311 77.0858 2.16473 76.8679 1.62814C76.7727 1.40457 76.768 1.15263 76.855 0.925706C76.942 0.698779 77.1137 0.514681 77.3337 0.412412C77.4136 0.380081 77.4956 0.353544 77.5793 0.333008H81.9564Z" fill="url(#paint1_linear_208_15)"/>
<path d="M101.588 9.50617C101.468 9.91224 101.288 10.2954 101.135 10.687C100.692 11.8011 100.246 12.9146 99.7983 14.0274C99.6956 14.2825 99.5912 14.5369 99.4916 14.7932C99.4214 14.9683 99.3003 15.1183 99.1442 15.2237C98.9881 15.3292 98.804 15.3853 98.6156 15.3847C98.4273 15.3841 98.2436 15.3269 98.0881 15.2205C97.9326 15.1141 97.8124 14.9633 97.7434 14.7878L95.7994 9.92605L94.1185 5.72664C93.5698 4.35552 93.0215 2.98458 92.4735 1.61385C92.4214 1.48852 92.3974 1.35326 92.4032 1.21761C92.4089 1.08196 92.4443 0.949232 92.5068 0.828775C92.5693 0.708318 92.6574 0.603069 92.765 0.520448C92.8725 0.437828 92.9968 0.37985 93.1291 0.350601C93.1471 0.346391 93.1645 0.340375 93.1825 0.334961H97.5699C97.5836 0.339172 97.5969 0.344586 97.6108 0.347594C97.7646 0.379769 97.9079 0.450334 98.0273 0.552752C98.1467 0.655171 98.2385 0.78613 98.2938 0.933503C98.5493 1.57515 98.805 2.215 99.0612 2.85305C99.7316 4.52856 100.401 6.20407 101.071 7.87958C101.246 8.32113 101.442 8.75485 101.586 9.20842L101.588 9.50617Z" fill="url(#paint2_linear_208_15)"/>
</g>
<path d="M0.788497 15.9577V6.16183H2.73655V7.35849H2.82468C2.91126 7.16678 3.03649 6.97197 3.20037 6.77407C3.36735 6.57308 3.5838 6.40611 3.84972 6.27315C4.11874 6.13709 4.45269 6.06906 4.85158 6.06906C5.37106 6.06906 5.85034 6.20512 6.28942 6.47723C6.72851 6.74624 7.07947 7.15286 7.3423 7.69708C7.60513 8.2382 7.73655 8.91693 7.73655 9.73326C7.73655 10.5279 7.60823 11.1989 7.35158 11.7462C7.09802 12.2905 6.7517 12.7033 6.31262 12.9846C5.87662 13.2629 5.38806 13.4021 4.84694 13.4021C4.46351 13.4021 4.13729 13.3387 3.86827 13.2119C3.60235 13.0851 3.38435 12.9259 3.21429 12.7342C3.04422 12.5394 2.91435 12.343 2.82468 12.1451H2.76438V15.9577H0.788497ZM2.72263 9.72398C2.72263 10.1476 2.78139 10.5171 2.89889 10.8325C3.01639 11.1479 3.18646 11.3937 3.40909 11.57C3.63173 11.7432 3.90229 11.8297 4.22078 11.8297C4.54236 11.8297 4.81447 11.7416 5.03711 11.5654C5.25974 11.386 5.42826 11.1386 5.54267 10.8232C5.66017 10.5047 5.71892 10.1383 5.71892 9.72398C5.71892 9.31273 5.66172 8.95094 5.54731 8.63864C5.4329 8.32633 5.26438 8.08205 5.04174 7.9058C4.81911 7.72955 4.54545 7.64142 4.22078 7.64142C3.8992 7.64142 3.62709 7.72645 3.40445 7.89652C3.18491 8.06659 3.01639 8.30778 2.89889 8.62008C2.78139 8.93239 2.72263 9.30036 2.72263 9.72398ZM11.8809 13.4253C11.1604 13.4253 10.5374 13.2722 10.0117 12.9661C9.48912 12.6569 9.08559 12.2271 8.80111 11.6767C8.51664 11.1232 8.3744 10.4816 8.3744 9.75181C8.3744 9.01588 8.51664 8.37271 8.80111 7.82231C9.08559 7.26882 9.48912 6.83901 10.0117 6.53289C10.5374 6.22367 11.1604 6.06906 11.8809 6.06906C12.6014 6.06906 13.2229 6.22367 13.7455 6.53289C14.2711 6.83901 14.6762 7.26882 14.9607 7.82231C15.2451 8.37271 15.3874 9.01588 15.3874 9.75181C15.3874 10.4816 15.2451 11.1232 14.9607 11.6767C14.6762 12.2271 14.2711 12.6569 13.7455 12.9661C13.2229 13.2722 12.6014 13.4253 11.8809 13.4253ZM11.8902 11.8947C12.2179 11.8947 12.4916 11.8019 12.7111 11.6164C12.9307 11.4278 13.0961 11.1711 13.2074 10.8464C13.3218 10.5218 13.379 10.1522 13.379 9.7379C13.379 9.32355 13.3218 8.95404 13.2074 8.62936C13.0961 8.30469 12.9307 8.04804 12.7111 7.85942C12.4916 7.6708 12.2179 7.57649 11.8902 7.57649C11.5593 7.57649 11.281 7.6708 11.0553 7.85942C10.8327 8.04804 10.6641 8.30469 10.5497 8.62936C10.4384 8.95404 10.3827 9.32355 10.3827 9.7379C10.3827 10.1522 10.4384 10.5218 10.5497 10.8464C10.6641 11.1711 10.8327 11.4278 11.0553 11.6164C11.281 11.8019 11.5593 11.8947 11.8902 11.8947ZM17.5071 13.2861L15.5684 6.16183H17.5674L18.6713 10.9485H18.7363L19.8865 6.16183H21.8485L23.0173 10.9206H23.0776L24.163 6.16183H26.1574L24.2233 13.2861H22.1314L20.907 8.80561H20.8188L19.5943 13.2861H17.5071ZM29.8878 13.4253C29.155 13.4253 28.5242 13.2769 27.9954 12.98C27.4697 12.6801 27.0647 12.2564 26.7802 11.7091C26.4957 11.1587 26.3535 10.5078 26.3535 9.75645C26.3535 9.02361 26.4957 8.38044 26.7802 7.82695C27.0647 7.27346 27.4651 6.8421 27.9815 6.53289C28.501 6.22367 29.1101 6.06906 29.8089 6.06906C30.279 6.06906 30.7165 6.14482 31.1216 6.29634C31.5297 6.44476 31.8853 6.66894 32.1884 6.96888C32.4945 7.26882 32.7326 7.64606 32.9026 8.1006C33.0727 8.55206 33.1577 9.08081 33.1577 9.68687V10.2295H27.142V9.00506H31.2978C31.2978 8.72058 31.236 8.46857 31.1123 8.24903C30.9886 8.02948 30.817 7.85787 30.5974 7.73418C30.381 7.60741 30.129 7.54402 29.8414 7.54402C29.5415 7.54402 29.2756 7.61359 29.0436 7.75274C28.8148 7.88879 28.6355 8.07277 28.5056 8.30469C28.3757 8.5335 28.3093 8.78861 28.3062 9.06999V10.2342C28.3062 10.5867 28.3711 10.8913 28.501 11.1479C28.6339 11.4046 28.821 11.6025 29.0622 11.7416C29.3034 11.8808 29.5894 11.9503 29.9203 11.9503C30.1398 11.9503 30.3408 11.9194 30.5232 11.8576C30.7057 11.7957 30.8618 11.703 30.9917 11.5793C31.1216 11.4556 31.2205 11.3041 31.2885 11.1247L33.116 11.2453C33.0232 11.6844 32.8331 12.0678 32.5455 12.3956C32.261 12.7203 31.8931 12.9738 31.4416 13.1563C30.9932 13.3356 30.4753 13.4253 29.8878 13.4253ZM34.0553 13.2861V6.16183H35.9709V7.40487H36.0451C36.175 6.96269 36.393 6.62874 36.6991 6.40302C37.0052 6.1742 37.3577 6.05979 37.7566 6.05979C37.8556 6.05979 37.9623 6.06597 38.0767 6.07834C38.1911 6.09071 38.2916 6.10772 38.3782 6.12936V7.88261C38.2854 7.85478 38.1571 7.83004 37.9932 7.8084C37.8293 7.78675 37.6793 7.77593 37.5433 7.77593C37.2526 7.77593 36.9929 7.83932 36.7641 7.9661C36.5383 8.08978 36.359 8.26294 36.226 8.48558C36.0961 8.70821 36.0312 8.96486 36.0312 9.25552V13.2861H34.0553ZM41.923 13.4253C41.1902 13.4253 40.5594 13.2769 40.0306 12.98C39.5049 12.6801 39.0999 12.2564 38.8154 11.7091C38.5309 11.1587 38.3887 10.5078 38.3887 9.75645C38.3887 9.02361 38.5309 8.38044 38.8154 7.82695C39.0999 7.27346 39.5003 6.8421 40.0167 6.53289C40.5362 6.22367 41.1453 6.06906 41.8442 6.06906C42.3142 6.06906 42.7517 6.14482 43.1568 6.29634C43.5649 6.44476 43.9205 6.66894 44.2236 6.96888C44.5297 7.26882 44.7678 7.64606 44.9378 8.1006C45.1079 8.55206 45.1929 9.08081 45.1929 9.68687V10.2295H39.1772V9.00506H43.333C43.333 8.72058 43.2712 8.46857 43.1475 8.24903C43.0238 8.02948 42.8522 7.85787 42.6327 7.73418C42.4162 7.60741 42.1642 7.54402 41.8766 7.54402C41.5767 7.54402 41.3108 7.61359 41.0788 7.75274C40.85 7.88879 40.6707 8.07277 40.5408 8.30469C40.4109 8.5335 40.3445 8.78861 40.3414 9.06999V10.2342C40.3414 10.5867 40.4063 10.8913 40.5362 11.1479C40.6691 11.4046 40.8562 11.6025 41.0974 11.7416C41.3386 11.8808 41.6246 11.9503 41.9555 11.9503C42.175 11.9503 42.376 11.9194 42.5584 11.8576C42.7409 11.7957 42.897 11.703 43.0269 11.5793C43.1568 11.4556 43.2557 11.3041 43.3237 11.1247L45.1512 11.2453C45.0584 11.6844 44.8683 12.0678 44.5807 12.3956C44.2962 12.7203 43.9283 12.9738 43.4768 13.1563C43.0284 13.3356 42.5105 13.4253 41.923 13.4253ZM48.7158 13.4021C48.1746 13.4021 47.6845 13.2629 47.2455 12.9846C46.8095 12.7033 46.4631 12.2905 46.2065 11.7462C45.9529 11.1989 45.8262 10.5279 45.8262 9.73326C45.8262 8.91693 45.9576 8.2382 46.2204 7.69708C46.4832 7.15286 46.8327 6.74624 47.2686 6.47723C47.7077 6.20512 48.1886 6.06906 48.7111 6.06906C49.11 6.06906 49.4424 6.13709 49.7083 6.27315C49.9774 6.40611 50.1938 6.57308 50.3577 6.77407C50.5247 6.97197 50.6515 7.16678 50.738 7.35849H50.7983V3.78706H52.7696V13.2861H50.8215V12.1451H50.738C50.6453 12.343 50.5139 12.5394 50.3438 12.7342C50.1768 12.9259 49.9588 13.0851 49.6898 13.2119C49.4239 13.3387 49.0992 13.4021 48.7158 13.4021ZM49.3419 11.8297C49.6604 11.8297 49.9294 11.7432 50.149 11.57C50.3716 11.3937 50.5417 11.1479 50.6592 10.8325C50.7798 10.5171 50.8401 10.1476 50.8401 9.72398C50.8401 9.30036 50.7813 8.93239 50.6638 8.62008C50.5463 8.30778 50.3763 8.06659 50.1536 7.89652C49.931 7.72645 49.6604 7.64142 49.3419 7.64142C49.0173 7.64142 48.7436 7.72955 48.521 7.9058C48.2983 8.08205 48.1298 8.32633 48.0154 8.63864C47.901 8.95094 47.8438 9.31273 47.8438 9.72398C47.8438 10.1383 47.901 10.5047 48.0154 10.8232C48.1329 11.1386 48.3014 11.386 48.521 11.5654C48.7436 11.7416 49.0173 11.8297 49.3419 11.8297ZM56.6705 13.2861V3.78706H58.6464V7.35849H58.7067C58.7933 7.16678 58.9185 6.97197 59.0824 6.77407C59.2493 6.57308 59.4658 6.40611 59.7317 6.27315C60.0007 6.13709 60.3347 6.06906 60.7336 6.06906C61.2531 6.06906 61.7323 6.20512 62.1714 6.47723C62.6105 6.74624 62.9615 7.15286 63.2243 7.69708C63.4871 8.2382 63.6185 8.91693 63.6185 9.73326C63.6185 10.5279 63.4902 11.1989 63.2336 11.7462C62.98 12.2905 62.6337 12.7033 62.1946 12.9846C61.7586 13.2629 61.2701 13.4021 60.7289 13.4021C60.3455 13.4021 60.0193 13.3387 59.7503 13.2119C59.4844 13.0851 59.2664 12.9259 59.0963 12.7342C58.9262 12.5394 58.7963 12.343 58.7067 12.1451H58.6185V13.2861H56.6705ZM58.6046 9.72398C58.6046 10.1476 58.6634 10.5171 58.7809 10.8325C58.8984 11.1479 59.0685 11.3937 59.2911 11.57C59.5137 11.7432 59.7843 11.8297 60.1028 11.8297C60.4244 11.8297 60.6965 11.7416 60.9191 11.5654C61.1417 11.386 61.3103 11.1386 61.4247 10.8232C61.5422 10.5047 61.6009 10.1383 61.6009 9.72398C61.6009 9.31273 61.5437 8.95094 61.4293 8.63864C61.3149 8.32633 61.1464 8.08205 60.9237 7.9058C60.7011 7.72955 60.4275 7.64142 60.1028 7.64142C59.7812 7.64142 59.5091 7.72645 59.2865 7.89652C59.0669 8.06659 58.8984 8.30778 58.7809 8.62008C58.6634 8.93239 58.6046 9.30036 58.6046 9.72398ZM65.5354 15.9577C65.2849 15.9577 65.0499 15.9376 64.8304 15.8975C64.6139 15.8603 64.4346 15.8124 64.2923 15.7537L64.7376 14.2787C64.9695 14.3498 65.1782 14.3885 65.3638 14.3947C65.5524 14.4009 65.7147 14.3576 65.8508 14.2648C65.9899 14.172 66.1028 14.0143 66.1894 13.7917L66.3053 13.4902L63.7497 6.16183H65.8276L67.3025 11.3937H67.3768L68.8656 6.16183H70.9575L68.1884 14.0561C68.0555 14.4395 67.8746 14.7735 67.6458 15.0579C67.4201 15.3455 67.134 15.5666 66.7877 15.7212C66.4414 15.8789 66.0239 15.9577 65.5354 15.9577Z" fill="currentColor"/>
<defs>
<linearGradient id="paint0_linear_208_15" x1="83.9919" y1="1.55536" x2="94.5605" y2="12.1028" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF00A8"/>
<stop offset="1" stop-color="#6200C6"/>
</linearGradient>
<linearGradient id="paint1_linear_208_15" x1="76.1162" y1="1.55175" x2="86.6824" y2="12.0968" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF00A8"/>
<stop offset="1" stop-color="#6200C6"/>
</linearGradient>
<linearGradient id="paint2_linear_208_15" x1="91.7237" y1="1.55069" x2="102.291" y2="12.0963" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF00A8"/>
<stop offset="1" stop-color="#6200C6"/>
</linearGradient>
<clipPath id="clip0_208_15">
<rect width="93.2653" height="15.102" fill="white" transform="translate(76.7344 0.286133)"/>
</clipPath>
</defs>
</svg>
`;
var $8721fac3cbf33e27$var$ethereumIcon = `
  <svg height="100%" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.99902 0.12619V5.20805L9.58065 7.12736L4.99902 0.12619Z" fill="white" fill-opacity="0.602"/>
    <path d="M4.99923 0.12619L0.416992 7.12736L4.99923 5.20805V0.12619Z" fill="white"/>
    <path d="M4.99902 10.4207V13.8737L9.58371 7.92728L4.99902 10.4207Z" fill="white" fill-opacity="0.602"/>
    <path d="M4.99923 13.8737V10.4201L0.416992 7.92728L4.99923 13.8737Z" fill="white"/>
    <path d="M4.99902 9.62134L9.58065 7.12739L4.99902 5.20923V9.62134Z" fill="white" fill-opacity="0.2"/>
    <path d="M0.416992 7.12739L4.99923 9.62134V5.20923L0.416992 7.12739Z" fill="white" fill-opacity="0.602"/>
  </svg>
`;
var $8721fac3cbf33e27$var$polygonIcon = `
  <svg width="100%" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5091 4.05856C10.2585 3.91901 9.9362 3.91901 9.64974 4.05856L7.64453 5.20986L6.28385 5.94251L4.31445 7.09382C4.0638 7.23337 3.74154 7.23337 3.45508 7.09382L1.91536 6.18673C1.66471 6.04718 1.48568 5.76807 1.48568 5.45408V3.70968C1.48568 3.43057 1.62891 3.15147 1.91536 2.97703L3.45508 2.10483C3.70573 1.96527 4.02799 1.96527 4.31445 2.10483L5.85417 3.01192C6.10482 3.15147 6.28385 3.43057 6.28385 3.74457V4.89587L7.64453 4.12833V2.94214C7.64453 2.66304 7.5013 2.38393 7.21484 2.20949L4.35026 0.569752C4.09961 0.4302 3.77734 0.4302 3.49089 0.569752L0.554687 2.24438C0.268229 2.38393 0.125 2.66304 0.125 2.94214V6.22162C0.125 6.50072 0.268229 6.77983 0.554687 6.95427L3.45508 8.59401C3.70573 8.73356 4.02799 8.73356 4.31445 8.59401L6.28385 7.47759L7.64453 6.71005L9.61393 5.59363C9.86458 5.45408 10.1868 5.45408 10.4733 5.59363L12.013 6.46583C12.2637 6.60539 12.4427 6.88449 12.4427 7.19848V8.94289C12.4427 9.22199 12.2995 9.50109 12.013 9.67553L10.5091 10.5477C10.2585 10.6873 9.9362 10.6873 9.64974 10.5477L8.11002 9.67553C7.85937 9.53598 7.68034 9.25688 7.68034 8.94289V7.82647L6.31966 8.59401V9.74531C6.31966 10.0244 6.46289 10.3035 6.74935 10.478L9.64974 12.1177C9.90039 12.2572 10.2227 12.2572 10.5091 12.1177L13.4095 10.478C13.6602 10.3384 13.8392 10.0593 13.8392 9.74531V6.43095C13.8392 6.15184 13.696 5.87274 13.4095 5.6983L10.5091 4.05856Z" fill="white"/>
  </svg>
`;
var $8721fac3cbf33e27$var$binanceIcon = `
  <svg width="100%" height="100%" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32975 5.90275L7 3.2325L9.67163 5.90413L11.2254 4.35038L7 0.125L2.776 4.349L4.32975 5.90275ZM0.125 7L1.67875 5.44625L3.2325 7L1.67875 8.55375L0.125 7ZM4.32975 8.09725L7 10.7675L9.67163 8.09587L11.2254 9.64894L7 13.875L2.776 9.651L2.77394 9.64894L4.32975 8.09725ZM10.7675 7L12.3212 5.44625L13.875 7L12.3212 8.55375L10.7675 7ZM8.57575 6.99863H8.57713V7L7 8.57713L5.42494 7.00275L5.42219 7L5.42494 6.99794L5.70062 6.72156L5.83469 6.5875L7 5.42288L8.57644 6.99931L8.57575 6.99863Z" fill="white"/>
  </svg>
`;
var $8721fac3cbf33e27$var$fantomIcon = `
  <svg height="100%" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.26613 0.133876C5.46683 0.0457135 5.68592 0 5.90775 0C6.12958 0 6.34867 0.0457135 6.54938 0.133876L10.2679 1.9598C10.3617 1.99893 10.4437 2.05898 10.5068 2.13465C10.5699 2.21033 10.6121 2.29932 10.6298 2.3938H10.6335V11.5637C10.6245 11.6667 10.5857 11.7654 10.5213 11.8495C10.457 11.9336 10.3694 11.9998 10.2679 12.0411L6.54938 13.8656C6.34867 13.9538 6.12958 13.9995 5.90775 13.9995C5.68592 13.9995 5.46683 13.9538 5.26613 13.8656L1.54762 12.0397C1.44724 11.9979 1.36095 11.9313 1.29799 11.8472C1.23504 11.7631 1.19779 11.6646 1.19025 11.5623C1.19025 11.5465 1.19025 11.5332 1.19025 11.522V2.39205C1.20579 2.29767 1.24673 2.20852 1.30923 2.13292C1.37173 2.05733 1.45375 1.99776 1.54762 1.9598L5.26613 0.133876ZM10.0478 7.50898L6.54938 9.22396C6.34872 9.31229 6.12961 9.35809 5.90775 9.35809C5.68589 9.35809 5.46678 9.31229 5.26613 9.22396L1.77525 7.51283V11.5455L5.26613 13.2493C5.43937 13.3471 5.62982 13.4154 5.82863 13.4512L5.9085 13.4558C6.12668 13.4357 6.3373 13.3704 6.525 13.2647L10.05 11.5301V7.50898H10.0478ZM0.585375 11.3642C0.568078 11.6186 0.612957 11.8734 0.716625 12.1093C0.805331 12.2602 0.936232 12.3857 1.09538 12.4726L1.10662 12.4796C1.1505 12.5069 1.1985 12.5356 1.25663 12.5692L1.32563 12.6081L1.53675 12.7267L1.23375 13.1922L0.9975 13.0592L0.95775 13.0365C0.889125 12.9973 0.8325 12.9637 0.779625 12.9315C0.214875 12.5769 0.004125 12.1912 0 11.3887V11.3642H0.585H0.585375ZM5.61412 5.05096C5.58845 5.05933 5.5634 5.06926 5.53912 5.08071L1.82137 6.90524L1.81013 6.91119H1.80675L1.81275 6.91469L1.82137 6.91889L5.53988 8.74341C5.56405 8.75505 5.58912 8.76499 5.61487 8.77316L5.61412 5.05096ZM6.201 5.05096V8.77456C6.22675 8.76639 6.25182 8.75645 6.276 8.74481L9.9945 6.92029L10.0057 6.91434H10.0091L10.0031 6.91154L9.9945 6.90699L6.276 5.08246C6.25182 5.07083 6.22675 5.06088 6.201 5.05271V5.05096ZM10.0478 3.04479L6.71025 4.68137L10.0478 6.31795V3.04304V3.04479ZM1.77525 3.04864V6.3141L5.103 4.68137L1.77525 3.04864ZM6.27525 0.61617C6.15894 0.569406 6.03364 0.545286 5.907 0.545286C5.78036 0.545286 5.65506 0.569406 5.53875 0.61617L1.821 2.4393L1.80975 2.4449L1.80638 2.44665L1.81238 2.4498L1.821 2.45365L5.5395 4.27817C5.65571 4.32526 5.78106 4.34956 5.90775 4.34956C6.03444 4.34956 6.15979 4.32526 6.276 4.27817L9.9945 2.45365L10.0057 2.4498L10.0091 2.44805L10.0031 2.4449L9.9945 2.4407L6.27525 0.61617ZM10.5968 0.816717L10.833 0.949365L10.875 0.970015C10.9432 1.00921 10.9999 1.04316 11.0528 1.07501C11.6179 1.42851 11.8282 1.81455 11.8328 2.61709V2.64159H11.2459C11.2632 2.38703 11.2183 2.13212 11.1146 1.8961C11.0258 1.74528 10.8948 1.61983 10.7355 1.53316L10.7242 1.52616C10.6807 1.49851 10.6327 1.47016 10.5743 1.43656L10.5056 1.39981L10.2945 1.28151L10.5975 0.816017L10.5968 0.816717Z" fill="white"/>
  </svg>
`;
var $8721fac3cbf33e27$var$optimismIcon = `
  <svg width="100%" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33611 9.25254C2.38341 9.25254 1.60287 9.02834 0.99442 8.58002C0.393974 8.1237 0.09375 7.47526 0.09375 6.63462C0.09375 6.45849 0.113782 6.2423 0.153782 5.9861C0.257909 5.40972 0.406006 4.71718 0.598133 3.9086C1.14252 1.707 2.54757 0.606201 4.81323 0.606201C5.42967 0.606201 5.98206 0.710266 6.47044 0.918394C6.95882 1.11852 7.34308 1.42278 7.62327 1.8311C7.90346 2.23135 8.04362 2.71174 8.04362 3.27212C8.04362 3.44025 8.02359 3.65241 7.98352 3.9086C7.86346 4.62111 7.71933 5.31366 7.55121 5.9861C7.27101 7.08294 6.78666 7.90354 6.09815 8.44793C5.40964 8.98431 4.489 9.25254 3.33611 9.25254ZM3.50424 7.52326C3.95262 7.52326 4.33284 7.39116 4.6451 7.12697C4.96535 6.86278 5.19351 6.45849 5.32958 5.9141C5.51371 5.16153 5.65387 4.50502 5.74993 3.94463C5.78193 3.7765 5.79793 3.60441 5.79793 3.42822C5.79793 2.6997 5.41764 2.33542 4.65713 2.33542C4.20875 2.33542 3.82449 2.46751 3.50424 2.7317C3.19205 2.99596 2.96786 3.40025 2.83179 3.94463C2.68766 4.48102 2.54354 5.13753 2.39947 5.9141C2.36741 6.07417 2.35141 6.2423 2.35141 6.41842C2.35141 7.155 2.73573 7.52326 3.50424 7.52326Z" fill="white"/>
    <path d="M8.59569 9.13247C8.50762 9.13247 8.43953 9.10443 8.39153 9.04837C8.35146 8.98431 8.33949 8.9123 8.35549 8.83224L10.0127 1.02648C10.0287 0.938417 10.0727 0.866353 10.1448 0.810289C10.2169 0.754289 10.2929 0.726257 10.373 0.726257H13.5673C14.456 0.726257 15.1685 0.910385 15.7049 1.27864C16.2493 1.64696 16.5215 2.17931 16.5215 2.87582C16.5215 3.07595 16.4975 3.28415 16.4495 3.50027C16.2493 4.42098 15.845 5.10149 15.2366 5.54181C14.6361 5.98213 13.8115 6.20229 12.7627 6.20229H11.1415L10.5892 8.83224C10.5731 8.92031 10.5291 8.99231 10.4571 9.04837C10.385 9.10443 10.3089 9.13247 10.2289 9.13247H8.59569ZM12.8468 4.54507C13.183 4.54507 13.4752 4.45298 13.7234 4.26885C13.9796 4.08472 14.1478 3.82053 14.2278 3.47627C14.2518 3.34015 14.2639 3.22008 14.2639 3.11602C14.2639 2.88383 14.1958 2.7077 14.0597 2.58763C13.9236 2.45951 13.6914 2.3955 13.3632 2.3955H11.9221L11.4658 4.54507H12.8468Z" fill="white"/>
  </svg>
`;
var $8721fac3cbf33e27$var$avalancheIcon = `
  <svg width="100%" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.8682 0.489349H0.110352V18.4468H19.8682V0.489349Z" fill="white"/>
  </svg>
`;
var $8721fac3cbf33e27$var$celoIcon = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Symbol" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 384 383" style="enable-background:new 0 0 384 383;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#FCFF52;}
</style>
<path class="st0" d="M383.5,0H0.5v383h383V249.3h-63.6C298,298.1,248.7,332,192.3,332c-77.8,0-140.8-63.6-140.8-140.8
	C51.4,114,114.5,51,192.3,51c57.5,0,106.8,35,128.7,84.9h62.5V0z"/>
</svg>
`;
var $8721fac3cbf33e27$var$gnosisIcon = `
  <svg width="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z" fill="#04795B"/>
    <path d="M11.6529 17.4492C12.2831 17.4492 12.8648 17.2392 13.3334 16.8758L9.4877 13.0316C9.12413 13.4919 8.9141 14.0734 8.9141 14.7114C8.906 16.2216 10.134 17.4492 11.6529 17.4492Z" fill="#EFEFEF"/>
    <path d="M23.0931 14.7033C23.0931 14.0734 22.8831 13.4919 22.5195 13.0234L18.6738 16.8677C19.1343 17.2311 19.716 17.4411 20.3543 17.4411C21.8651 17.4492 23.0931 16.2216 23.0931 14.7033Z" fill="#EFEFEF"/>
    <path d="M25.0322 10.528L23.3275 12.2321C23.8931 12.9105 24.2324 13.7666 24.2324 14.7195C24.2324 16.8597 22.4954 18.5961 20.3544 18.5961C19.4092 18.5961 18.5447 18.2569 17.866 17.6915L15.9998 19.5571L14.1335 17.6915C13.4549 18.2569 12.5985 18.5961 11.6451 18.5961C9.50416 18.5961 7.7672 16.8597 7.7672 14.7195C7.7672 13.7746 8.10651 12.9105 8.67206 12.2321L7.79947 11.3599L6.96736 10.528C5.99787 12.1271 5.44043 13.9927 5.44043 15.9956C5.44043 21.8265 10.1667 26.543 15.9917 26.543C21.8167 26.543 26.543 21.8185 26.543 15.9956C26.5591 13.9846 26.0017 12.119 25.0322 10.528Z" fill="#EFEFEF"/>
    <path d="M23.6338 8.71084C21.7191 6.6999 19.0045 5.44 15.9991 5.44C12.9937 5.44 10.2872 6.6999 8.36435 8.71084C8.10584 8.98545 7.85539 9.27617 7.62109 9.575L15.991 17.9419L24.361 9.56695C24.1509 9.27617 23.9005 8.97734 23.6338 8.71084ZM15.9991 6.81297C18.4713 6.81297 20.7658 7.76593 22.4866 9.50231L15.9991 15.9874L9.5116 9.50231C11.2405 7.76593 13.5269 6.81297 15.9991 6.81297Z" fill="#EFEFEF"/>
  </svg>
`;
var $8721fac3cbf33e27$var$harmonyOneIcon = `
  <svg width="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5484 1.04102e-06C11.6346 -0.000708404 10.7578 0.361217 10.1105 1.00633C9.46322 1.65145 9.09835 2.52703 9.096 3.44089V7.256C8.74045 7.28 8.37689 7.29511 8 7.29511C7.62311 7.29511 7.26133 7.31022 6.904 7.33156V3.44089C6.88946 2.53496 6.51938 1.67105 5.87358 1.03553C5.22779 0.400017 4.35805 0.0438409 3.452 0.0438409C2.54595 0.0438409 1.67621 0.400017 1.03042 1.03553C0.384623 1.67105 0.0145378 2.53496 0 3.44089V12.5591C0.0145378 13.465 0.384623 14.329 1.03042 14.9645C1.67621 15.6 2.54595 15.9562 3.452 15.9562C4.35805 15.9562 5.22779 15.6 5.87358 14.9645C6.51938 14.329 6.88946 13.465 6.904 12.5591V8.744C7.25956 8.72 7.62311 8.70489 8 8.70489C8.37689 8.70489 8.73867 8.68978 9.096 8.66845V12.5591C9.11054 13.465 9.48062 14.329 10.1264 14.9645C10.7722 15.6 11.6419 15.9562 12.548 15.9562C13.4541 15.9562 14.3238 15.6 14.9696 14.9645C15.6154 14.329 15.9855 13.465 16 12.5591V3.44089C15.9976 2.52719 15.6329 1.65173 14.9858 1.00665C14.3387 0.361557 13.4622 -0.000472854 12.5484 1.04102e-06ZM3.45156 1.40978C3.99089 1.40954 4.50828 1.62326 4.89023 2.00404C5.27218 2.38482 5.48748 2.90156 5.48889 3.44089V7.48089C4.47892 7.62724 3.49264 7.90609 2.55556 8.31023C2.14954 8.48842 1.76733 8.71655 1.41778 8.98934V3.44089C1.41919 2.90218 1.634 2.38597 2.01518 2.00529C2.39636 1.62462 2.91284 1.41048 3.45156 1.40978ZM5.48889 12.5591C5.48889 13.0994 5.27424 13.6177 4.89217 13.9997C4.51009 14.3818 3.99189 14.5964 3.45156 14.5964C2.91122 14.5964 2.39302 14.3818 2.01094 13.9997C1.62887 13.6177 1.41422 13.0994 1.41422 12.5591V11.6444C1.41422 10.8364 2.05422 10.0711 3.12711 9.59467C3.88309 9.26852 4.6763 9.03656 5.48889 8.904V12.5591ZM12.5484 14.5902C12.0091 14.5905 11.4917 14.3767 11.1098 13.996C10.7278 13.6152 10.5125 13.0984 10.5111 12.5591V8.51911C11.5211 8.37276 12.5074 8.09392 13.4444 7.68978C13.8505 7.51159 14.2327 7.28345 14.5822 7.01067V12.5591C14.5808 13.0978 14.366 13.614 13.9848 13.9947C13.6036 14.3754 13.0872 14.5895 12.5484 14.5902ZM12.8729 6.4C12.1169 6.72615 11.3237 6.95811 10.5111 7.09067V3.44089C10.5111 2.90056 10.7258 2.38235 11.1078 2.00028C11.4899 1.6182 12.0081 1.40356 12.5484 1.40356C13.0888 1.40356 13.607 1.6182 13.9891 2.00028C14.3711 2.38235 14.5858 2.90056 14.5858 3.44089V4.35556C14.5858 5.16 13.9458 5.92534 12.8729 6.4Z" fill="url(#paint0_linear_10254_2422)"/>
    <defs>
      <linearGradient id="paint0_linear_10254_2422" x1="1.01333" y1="14.7674" x2="14.8954" y2="0.847434" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00AEE9"/>
        <stop offset="1" stop-color="#69FABD"/>
      </linearGradient>
    </defs>
  </svg>
`;
var $8721fac3cbf33e27$var$arbitrumIcon = `
  <svg height="100%" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.7827 11.3172L15.5966 8.23933L20.4858 15.8545L20.4881 17.3159L20.4722 7.25942C20.4606 7.0136 20.3301 6.7887 20.1218 6.6561L11.3194 1.5928C11.1135 1.49162 10.8523 1.49269 10.6468 1.59594C10.6191 1.60989 10.593 1.62499 10.568 1.64147L10.5374 1.66079L1.99318 6.6121L1.95999 6.62712C1.91737 6.64674 1.8743 6.67165 1.83382 6.70063C1.67186 6.81683 1.56424 6.98861 1.52944 7.18131C1.52423 7.21052 1.52039 7.24026 1.51855 7.27023L1.53197 15.4653L6.08607 8.40666C6.65942 7.47067 7.90869 7.1692 9.06835 7.1856L10.4295 7.22155L2.40986 20.0827L3.3552 20.627L11.4709 7.23458L15.0581 7.22155L6.96327 20.9519L10.3366 22.8921L10.7396 23.1239C10.9101 23.1932 11.111 23.1967 11.283 23.1347L20.2091 17.9618L18.5026 18.9507L13.7827 11.3172ZM14.4747 21.2849L11.0677 15.9375L13.1474 12.4083L17.622 19.461L14.4747 21.2849Z" fill="#2D374B"/>
    <path d="M11.0684 15.9375L14.4754 21.2849L17.6228 19.4609L13.1482 12.4083L11.0684 15.9375Z" fill="#28A0F0"/>
    <path d="M20.4887 17.3159L20.4864 15.8545L15.5972 8.23932L13.7832 11.3172L18.5031 18.9507L20.2097 17.9618C20.3771 17.8259 20.4783 17.6264 20.489 17.4111L20.4887 17.3159Z" fill="#28A0F0"/>
    <path d="M7.71943e-05 18.694L2.41 20.0826L10.4296 7.22152L9.0685 7.18557C7.90883 7.16916 6.65964 7.47063 6.08621 8.40662L1.53211 15.4652L0 17.8193V18.694H7.71943e-05Z" fill="white"/>
    <path d="M15.0582 7.22156L11.4712 7.23459L3.35547 20.627L6.19211 22.2603L6.96354 20.9519L15.0582 7.22156Z" fill="white"/>
    <path d="M21.9999 7.20306C21.97 6.45287 21.5638 5.76608 20.9275 5.36626L12.0097 0.237888C11.3803 -0.079066 10.594 -0.0794494 9.96363 0.237658C9.88913 0.275218 1.2912 5.26171 1.2912 5.26171C1.17223 5.31874 1.05764 5.38673 0.949789 5.46384C0.381801 5.87094 0.0355663 6.50346 0 7.19846V17.8194L1.53211 15.4653L1.5187 7.27029C1.52054 7.24032 1.52429 7.21088 1.52958 7.18175C1.56415 6.9889 1.67185 6.81689 1.83397 6.70069C1.87444 6.67171 10.6192 1.60995 10.647 1.596C10.8526 1.49275 11.1137 1.49168 11.3195 1.59286L20.122 6.65616C20.3302 6.78876 20.4608 7.01366 20.4723 7.25948V17.4111C20.4617 17.6265 20.3766 17.8259 20.2092 17.9619L18.5026 18.9508L17.6221 19.461L14.4748 21.285L11.283 23.1347C11.1111 23.1968 10.9101 23.1933 10.7397 23.124L6.96334 20.952L6.19191 22.2603L9.58559 24.2142C9.6978 24.278 9.79784 24.3345 9.87985 24.3807C10.0069 24.452 10.0935 24.4996 10.1241 24.5144C10.3653 24.6315 10.7123 24.6997 11.025 24.6997C11.3118 24.6997 11.5913 24.647 11.8559 24.5434L21.1266 19.1745C21.6587 18.7623 21.9717 18.1406 21.9999 17.467V7.20306Z" fill="#96BEDC"/>
  </svg>
`;
var $8721fac3cbf33e27$var$baseIcon = `
<svg height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1607_202)">
<mask id="mask0_1607_202" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<path d="M32 0H0V32H32V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_1607_202)">
<path d="M16 32C19.1645 32 22.258 31.0616 24.8892 29.3036C27.5204 27.5454 29.571 25.0466 30.782 22.123C31.993 19.1993 32.31 15.9823 31.6926 12.8786C31.0752 9.77486 29.5514 6.92394 27.3138 4.6863C25.076 2.44866 22.2252 0.924806 19.1214 0.307442C16.0177 -0.30992 12.8007 0.0069325 9.87706 1.21793C6.95344 2.42894 4.45458 4.4797 2.69648 7.11088C0.938384 9.74206 0 12.8355 0 16C0 20.2434 1.68571 24.3132 4.6863 27.3138C7.68688 30.3142 11.7565 32 16 32Z" fill="#0052FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9624 27.2676C22.1852 27.2676 27.23 22.223 27.23 16C27.23 9.7771 22.1852 4.73242 15.9624 4.73242C10.0588 4.73242 5.21566 9.2726 4.7341 15.0518H21.4546V16.928H4.73242C5.20432 22.7168 10.0519 27.2676 15.9624 27.2676Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_1607_202">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`;
var $8721fac3cbf33e27$var$hourglass = `
<svg width="100%" height="100%" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0L0.0100002 6L4 10L0.0100002 14.01L0 20H12V14L8 10L12 6.01V0H0ZM10 14.5V18H2V14.5L6 10.5L10 14.5Z" fill="#929BED"/>
</svg>
`;
var $8721fac3cbf33e27$export$f787f51d84a910ad = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.07 12.85C11.84 11.46 13.32 10.64 14.18 9.41C15.09 8.12 14.58 5.71 12 5.71C10.31 5.71 9.48 6.99 9.13 8.05L6.54 6.96C7.25 4.83 9.18 3 11.99 3C14.34 3 15.95 4.07 16.77 5.41C17.47 6.56 17.88 8.71 16.8 10.31C15.6 12.08 14.45 12.62 13.83 13.76C13.58 14.22 13.48 14.52 13.48 16H10.59C10.58 15.22 10.46 13.95 11.07 12.85ZM14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20C10 18.9 10.9 18 12 18C13.1 18 14 18.9 14 20Z" fill="currentColor"/>
  </svg>
`;
var $8721fac3cbf33e27$var$checkmark = `
<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.48076 8.10881L1.33076 4.95881L0.280762 6.00881L4.48076 10.2088L13.4808 1.20881L12.4308 0.158813L4.48076 8.10881Z" fill="#A4F4C6"/>
</svg>
`;
var $8721fac3cbf33e27$var$errorIcon = `<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.666992 13.0002H15.3337L8.00033 0.333496L0.666992 13.0002ZM8.66699 11.0002H7.33366V9.66683H8.66699V11.0002ZM8.66699 8.3335H7.33366V5.66683H8.66699V8.3335Z" fill="#FFB3B3"/>
</svg>
`;
var $8721fac3cbf33e27$var$infoIcon = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="currentColor"/>
  </svg>
`;
var $8721fac3cbf33e27$var$successIcon = `
  <svg width="100%" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.74999 12.15L3.59999 9L2.54999 10.05L6.74999 14.25L15.75 5.25L14.7 4.2L6.74999 12.15Z" fill="currentColor"/>
  </svg>
`;
var $8721fac3cbf33e27$var$pendingIcon = `
  <svg width="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z" fill="currenColor"/>
  </svg>
`;
var $8721fac3cbf33e27$var$degenIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477 477">
  <defs>
    <style>.cls-1{fill:#a36dfe;}.cls-2{fill:#4b2895;}</style>
  </defs>
  <circle class="cls-1" cx="238.5" cy="238.5" r="238.5"/>
  <g>
    <path class="cls-2" d="M237.85,113.99c29.25,1.32,54.97,2.45,80.69,3.69,3.95,.19,7.92,.72,11.82,1.43,9.23,1.69,15.34,8.72,14.78,18.2-1.33,22.33-3.22,44.63-4.79,66.95-.81,11.47-1.49,22.96-2.12,34.44-.29,5.24-2.03,8.14-7.74,10.18-37.84,13.52-76.98,15.46-116.47,13.42-23.24-1.2-45.99-5.86-68.06-13.68-4.71-1.67-6.72-3.91-7.03-8.72-1.31-20.46-2.83-40.9-4.25-61.35-.94-13.55-2.1-27.1-2.7-40.66-.49-11.15,6.17-18.37,17.2-19.01,30.7-1.78,61.4-3.39,88.69-4.88Z"/><path class="cls-2" d="M238.34,363.01c-31.19-1.24-61.52-5.51-90.12-18.31-20.8-9.31-38.13-23.01-48.65-43.63-3.63-7.1-5.68-15.3-6.91-23.24-1.17-7.59,1.95-14.47,8.76-18.93,6.74-4.42,13.4-3.5,20.12,.38,14.24,8.24,14.6,8.18,14.39,24.44-.09,7.1,3.71,11.23,8.41,15.24,12.51,10.67,26.94,17.78,42.7,21.94,38.88,10.26,77.66,10.06,115.42-4.42,11.31-4.33,21.33-12.17,31.67-18.82,5.27-3.39,7.7-8.7,6.88-15.19-1.34-10.7,2.19-17.99,12.86-22.48,7.8-3.29,14.95-6.25,22.38-.72,7.42,5.53,9.4,13.33,7.88,22.37-4.05,24.14-19.06,40.5-38.25,53.68-18.5,12.7-39.59,19.06-61.42,22.61-15.24,2.48-30.72,3.44-46.1,5.09Z"/>
  </g>
</svg>
`;
var $8721fac3cbf33e27$var$snaxIcon = `<svg width="178" height="177" viewBox="0 0 178 177" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="89.0198" cy="88.4095" r="88.305" fill="#06061B"/>
<path d="M68.0815 75.158C67.5149 74.5153 66.8174 74.1932 65.9874 74.1932H49.0126C48.8618 74.1932 48.7384 74.1459 48.6455 74.0512C48.5511 73.9581 48.5039 73.8528 48.5039 73.7398V62.3958C48.5039 62.2828 48.5511 62.179 48.6455 62.0844C48.7384 61.9897 48.8618 61.9424 49.0126 61.9424H66.9499C71.4761 61.9424 75.381 63.7773 78.6629 67.4442L83.0201 72.7185L74.5327 82.9848L68.0815 75.158ZM99.4299 67.3877C102.712 63.7575 106.635 61.9424 111.199 61.9424H129.08C129.231 61.9424 129.344 61.9805 129.42 62.0553C129.495 62.1317 129.533 62.2446 129.533 62.3958V73.7398C129.533 73.8528 129.495 73.9581 129.42 74.0512C129.344 74.1459 129.231 74.1932 129.08 74.1932H112.105C111.275 74.1932 110.578 74.5153 110.011 75.158L97.5064 90.2452L110.068 105.445C110.634 106.051 111.312 106.354 112.105 106.354H129.08C129.231 106.354 129.344 106.401 129.42 106.496C129.495 106.59 129.533 106.714 129.533 106.864V118.208C129.533 118.321 129.495 118.426 129.42 118.519C129.344 118.614 129.231 118.661 129.08 118.661H111.199C106.635 118.661 102.73 116.828 99.4863 113.159L89.0754 100.568L78.6629 113.159C75.381 116.828 71.4578 118.661 66.8936 118.661H49.0126C48.8618 118.661 48.7476 118.614 48.673 118.519C48.5968 118.424 48.5603 118.302 48.5603 118.15V106.806C48.5603 106.693 48.5968 106.589 48.673 106.494C48.7476 106.399 48.8618 106.352 49.0126 106.352H65.9874C66.7793 106.352 67.4768 106.032 68.0815 105.387L80.3595 90.5276L99.4299 67.3877Z" fill="#00D1FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.62306 101.122C1.02459 96.9706 0.714844 92.7262 0.714844 88.4095C0.714844 85.5803 0.84789 82.7823 1.10807 80.0212L11.5198 67.3877C14.8017 63.7575 18.7248 61.9424 23.2891 61.9424H41.1701C41.3209 61.9424 41.4336 61.9805 41.5097 62.0553C41.5844 62.1317 41.6224 62.2446 41.6224 62.3958V73.7398C41.6224 73.8528 41.5844 73.9581 41.5097 74.0512C41.4336 74.1459 41.3209 74.1932 41.1701 74.1932H24.1953C23.3653 74.1932 22.6678 74.5153 22.1012 75.158L9.59627 90.2452L22.1576 105.445C22.7241 106.051 23.4018 106.354 24.1953 106.354H41.1701C41.3209 106.354 41.4336 106.401 41.5097 106.496C41.5844 106.59 41.6224 106.714 41.6224 106.864V118.208C41.6224 118.321 41.5844 118.426 41.5097 118.519C41.4336 118.614 41.3209 118.661 41.1701 118.661H23.2891C18.7248 118.661 14.82 116.828 11.5761 113.159L1.62306 101.122Z" fill="#00D1FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M176.393 101.284C177.007 97.0816 177.325 92.7827 177.325 88.4095C177.325 85.5791 177.192 82.7799 176.931 80.0176L168.27 90.5276L155.992 105.387C155.387 106.032 154.689 106.352 153.898 106.352H136.923C136.772 106.352 136.658 106.399 136.583 106.494C136.507 106.589 136.47 106.693 136.47 106.806V118.15C136.47 118.302 136.507 118.424 136.583 118.519C136.658 118.614 136.772 118.661 136.923 118.661H154.804C159.368 118.661 163.291 116.828 166.573 113.159L176.393 101.284ZM153.898 74.1932C154.728 74.1932 155.425 74.5153 155.992 75.158L162.443 82.9848L170.93 72.7185L166.573 67.4442C163.291 63.7773 159.386 61.9424 154.86 61.9424H136.923C136.772 61.9424 136.649 61.9897 136.556 62.0844C136.461 62.179 136.414 62.2828 136.414 62.3958V73.7398C136.414 73.8528 136.461 73.9581 136.556 74.0512C136.649 74.1459 136.772 74.1932 136.923 74.1932H153.898Z" fill="#00D1FF"/>
</svg>`;
function $8721fac3cbf33e27$var$getDevice() {
    if (typeof window !== 'undefined') {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($dzDkt))).getParser(window.navigator.userAgent);
        const os = parsed.getOS();
        const browser = parsed.getBrowser();
        const { type: type } = parsed.getPlatform();
        return {
            type: type,
            os: os,
            browser: browser
        };
    } else return {
        type: null,
        os: null,
        browser: null
    };
}
const $8721fac3cbf33e27$var$notNullish = (value)=>value != null;
function $8721fac3cbf33e27$export$34aec0b863436764(str) {
    return str.includes('<svg');
}
function $8721fac3cbf33e27$export$a9c23c6ac3fc3eca(add) {
    return `${add.slice(0, 6)}\u{2026}${add.slice(-4)}`;
}
function $8721fac3cbf33e27$export$96f57966bedc81b4(domain) {
    return domain.length > 11 ? `${domain.slice(0, 4)}\u{2026}${domain.slice(-6)}` : domain;
}
async function $8721fac3cbf33e27$export$3722cfe417b6ed86(text) {
    try {
        const copy = await navigator.clipboard.writeText(text);
        return copy;
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
}
const $8721fac3cbf33e27$export$d24c54395ce0c509 = (val)=>typeof val === 'number' ? `0x${val.toString(16)}` : val;
function $8721fac3cbf33e27$var$chainIdToHex(chains) {
    return chains.map((_a)=>{
        var { id: id } = _a, rest = $8721fac3cbf33e27$var$__rest(_a, [
            "id"
        ]);
        const hexId = $8721fac3cbf33e27$export$d24c54395ce0c509(id);
        return Object.assign({
            id: hexId
        }, rest);
    });
}
function $8721fac3cbf33e27$export$8a5498727ef6be21(gwei) {
    return `0x${(gwei * 1e9).toString(16)}`;
}
const $8721fac3cbf33e27$export$43caf9889c228507 = {
    '0x1': 'Ethereum',
    '0xaa36a7': 'Sepolia',
    '0x38': 'Binance',
    '0x89': 'Polygon',
    '0xfa': 'Fantom',
    '0xa': 'OP Mainnet',
    '0x45': 'OP Kovan',
    '0xa86a': 'Avalanche',
    '0xa4ec': 'Celo',
    '0x2105': 'Base',
    '0x14a33': 'Base Goerli',
    '0x64': 'Gnosis',
    '0x63564C40': 'Harmony One',
    '0xa4b1': 'Arbitrum One',
    '0xa4ba': 'Arbitrum Nova',
    '0x27bc86aa': 'Degen',
    '0x890': 'SNAX'
};
function $8721fac3cbf33e27$var$validEnsChain(chainId) {
    // return L2s as Eth for ens resolution
    switch(chainId){
        case '0x1':
        case '0x89':
        case '0xa':
        case '0xa4b1':
        case '0x144':
            return '0x1';
        case '0x5':
            return chainId;
        case '0xaa36a7':
            return chainId;
        default:
            return null;
    }
}


const $8721fac3cbf33e27$var$chainIdToViemENSImport = async (chainId)=>{
    switch(chainId){
        case '0x89':
        case '0xa':
        case '0xa4b1':
        case '0x144':
        case '0x1':
            {
                const { mainnet: mainnet } = await (parcelRequire("gU9dM"));
                return mainnet;
            }
        case '0xaa36a7':
            {
                const { sepolia: sepolia } = await (parcelRequire("gU9dM"));
                return sepolia;
            }
        default:
            return null;
    }
};
const $8721fac3cbf33e27$export$2f6ca3d3b1f80bf5 = {
    main: '0x1',
    sepolia: '0xaa36a7',
    xdai: '0x64',
    'bsc-main': '0x38',
    'matic-main': '0x89',
    'fantom-main': '0xfa',
    'matic-mumbai': '0x80001',
    degen: '0x27bc86aa',
    SNAX: '0x890'
};
const $8721fac3cbf33e27$export$6554612db691658e = {
    '0x1': {
        icon: $8721fac3cbf33e27$var$ethereumIcon,
        color: '#627EEA'
    },
    '0xaa36a7': {
        icon: $8721fac3cbf33e27$var$ethereumIcon,
        color: '#627EEA'
    },
    '0x38': {
        icon: $8721fac3cbf33e27$var$binanceIcon,
        color: '#F3BA2F'
    },
    '0x89': {
        icon: $8721fac3cbf33e27$var$polygonIcon,
        color: '#8247E5'
    },
    '0xfa': {
        icon: $8721fac3cbf33e27$var$fantomIcon,
        color: '#1969FF'
    },
    '0xa': {
        icon: $8721fac3cbf33e27$var$optimismIcon,
        color: '#FF0420'
    },
    '0x45': {
        icon: $8721fac3cbf33e27$var$optimismIcon,
        color: '#FF0420'
    },
    '0xa86a': {
        icon: $8721fac3cbf33e27$var$avalancheIcon,
        color: '#E84142'
    },
    '0xa4ec': {
        icon: $8721fac3cbf33e27$var$celoIcon,
        color: '#FBCC5C'
    },
    '0x64': {
        icon: $8721fac3cbf33e27$var$gnosisIcon,
        color: '#04795B'
    },
    '0x63564C40': {
        icon: $8721fac3cbf33e27$var$harmonyOneIcon,
        color: '#ffffff'
    },
    '0xa4b1': {
        icon: $8721fac3cbf33e27$var$arbitrumIcon,
        color: '#33394B'
    },
    '0xa4ba': {
        icon: $8721fac3cbf33e27$var$arbitrumIcon,
        color: '#33394B'
    },
    '0x2105': {
        icon: $8721fac3cbf33e27$var$baseIcon,
        color: '#0259F9'
    },
    '0x14a33': {
        icon: $8721fac3cbf33e27$var$baseIcon,
        color: '#0259F9'
    },
    '0x80001': {
        icon: $8721fac3cbf33e27$var$polygonIcon,
        color: '#8247E5'
    },
    '0x27bc86aa': {
        icon: $8721fac3cbf33e27$var$degenIcon,
        color: '#a36dfe'
    },
    '0x890': {
        icon: $8721fac3cbf33e27$var$snaxIcon,
        color: '#00D1FF'
    }
};
const $8721fac3cbf33e27$export$2e2af4578d910ddf = {
    icon: $8721fac3cbf33e27$export$f787f51d84a910ad,
    color: '#33394B'
};
function $8721fac3cbf33e27$export$efca4cbe5dd06740(chainId) {
    return chainId ? $8721fac3cbf33e27$export$6554612db691658e[chainId.toLowerCase()] : undefined;
}
function $8721fac3cbf33e27$export$dda1d9f60106f0e9(walletConnectedChain, chains) {
    return !!chains.find(({ id: id, namespace: namespace })=>id === walletConnectedChain.id && namespace === walletConnectedChain.namespace);
}
const $8721fac3cbf33e27$export$7a38258bbe170828 = {
    pending: {
        backgroundColor: 'var(--onboard-primary-700, var(--primary-700))',
        borderColor: '#6370E5',
        eventIcon: $8721fac3cbf33e27$var$hourglass
    },
    success: {
        backgroundColor: '#052E17',
        borderColor: 'var(--onboard-success-300, var(--success-300))',
        eventIcon: $8721fac3cbf33e27$var$checkmark
    },
    error: {
        backgroundColor: '#FDB1B11A',
        borderColor: 'var(--onboard-danger-300, var(--danger-300))',
        eventIcon: $8721fac3cbf33e27$var$errorIcon
    },
    hint: {
        backgroundColor: 'var(--onboard-gray-500, var(--gray-500))',
        borderColor: 'var(--onboard-gray-500, var(--gray-500))',
        iconColor: 'var(--onboard-gray-100, var(--gray-100))',
        eventIcon: $8721fac3cbf33e27$var$infoIcon
    }
};
const $8721fac3cbf33e27$var$wait$1 = (time)=>new Promise((resolve)=>setTimeout(resolve, time));
function $8721fac3cbf33e27$var$getLocalStore(key) {
    try {
        const result = localStorage.getItem(key);
        return result;
    } catch (error) {
        return null;
    }
}
function $8721fac3cbf33e27$var$setLocalStore(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        return;
    }
}
function $8721fac3cbf33e27$var$delLocalStore(key) {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        return;
    }
}
let $8721fac3cbf33e27$export$c9170ad7d4cd7e57 = {
    svelteInstance: null,
    device: $8721fac3cbf33e27$var$getDevice(),
    initialWalletInit: [],
    gas: undefined,
    containerElements: {
        accountCenter: undefined,
        connectModal: undefined
    },
    unstoppableResolution: undefined,
    wagmi: undefined
};
function $8721fac3cbf33e27$var$updateConfiguration(update) {
    $8721fac3cbf33e27$export$c9170ad7d4cd7e57 = Object.assign(Object.assign({}, $8721fac3cbf33e27$export$c9170ad7d4cd7e57), update);
}
const $8721fac3cbf33e27$var$APP_INITIAL_STATE = {
    wallets: [],
    walletModules: [],
    chains: [],
    accountCenter: {
        enabled: true,
        position: 'bottomRight',
        expanded: false,
        minimal: true
    },
    notify: {
        enabled: true,
        position: 'topRight',
        replacement: {
            gasPriceProbability: {
                speedup: 80,
                cancel: 95
            }
        }
    },
    notifications: [],
    locale: '',
    connect: {
        showSidebar: true,
        disableClose: false
    },
    appMetadata: null,
    wagmiConfig: null
};
const $8721fac3cbf33e27$var$STORAGE_KEYS = {
    TERMS_AGREEMENT: 'onboard.js:agreement',
    LAST_CONNECTED_WALLET: 'onboard.js:last_connected_wallet'
};
const $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH = 768;
const $8721fac3cbf33e27$export$995eb9fca571757 = 'https://rpc.blocknative.com/boost';
const $8721fac3cbf33e27$export$a8550f7dbe79f93a = 'https://docs.blocknative.com/blocknative-mev-protection/transaction-boost';
const $8721fac3cbf33e27$var$ADD_CHAINS = 'add_chains';
const $8721fac3cbf33e27$var$UPDATE_CHAINS = 'update_chains';
const $8721fac3cbf33e27$var$RESET_STORE = 'reset_store';
const $8721fac3cbf33e27$var$ADD_WALLET = 'add_wallet';
const $8721fac3cbf33e27$var$UPDATE_WALLET = 'update_wallet';
const $8721fac3cbf33e27$var$REMOVE_WALLET = 'remove_wallet';
const $8721fac3cbf33e27$var$UPDATE_ACCOUNT = 'update_account';
const $8721fac3cbf33e27$var$UPDATE_ACCOUNT_CENTER = 'update_account_center';
const $8721fac3cbf33e27$var$UPDATE_CONNECT_MODAL = 'update_connect_modal';
const $8721fac3cbf33e27$var$SET_WALLET_MODULES = 'set_wallet_modules';
const $8721fac3cbf33e27$var$SET_LOCALE = 'set_locale';
const $8721fac3cbf33e27$var$UPDATE_NOTIFY = 'update_notify';
const $8721fac3cbf33e27$var$ADD_NOTIFICATION = 'add_notification';
const $8721fac3cbf33e27$var$REMOVE_NOTIFICATION = 'remove_notification';
const $8721fac3cbf33e27$var$UPDATE_ALL_WALLETS = 'update_balance';
const $8721fac3cbf33e27$var$UPDATE_APP_METADATA = 'update_app_metadata';
const $8721fac3cbf33e27$var$UPDATE_WAGMI_CONFIG = 'update_wagmi_config';
function $8721fac3cbf33e27$var$reducer(state, action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case $8721fac3cbf33e27$var$ADD_CHAINS:
            return Object.assign(Object.assign({}, state), {
                chains: [
                    ...state.chains,
                    ...payload
                ]
            });
        case $8721fac3cbf33e27$var$UPDATE_CHAINS:
            {
                const updatedChain = payload;
                const chains = state.chains;
                const index = chains.findIndex((chain)=>chain.id === updatedChain.id);
                chains[index] = updatedChain;
                return Object.assign(Object.assign({}, state), {
                    chains: chains
                });
            }
        case $8721fac3cbf33e27$var$ADD_WALLET:
            {
                const wallet = payload;
                const existingWallet = state.wallets.find(({ label: label })=>label === wallet.label);
                return Object.assign(Object.assign({}, state), {
                    wallets: [
                        // add to front of wallets as it is now the primary wallet
                        existingWallet || payload,
                        // filter out wallet if it already existed
                        ...state.wallets.filter(({ label: label })=>label !== wallet.label)
                    ]
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_WALLET:
            {
                const update = payload;
                const { id: id } = update, walletUpdate = $8721fac3cbf33e27$var$__rest(update, [
                    "id"
                ]);
                const updatedWallets = state.wallets.map((wallet)=>wallet.label === id ? Object.assign(Object.assign({}, wallet), walletUpdate) : wallet);
                return Object.assign(Object.assign({}, state), {
                    wallets: updatedWallets
                });
            }
        case $8721fac3cbf33e27$var$REMOVE_WALLET:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state), {
                    wallets: state.wallets.filter(({ label: label })=>label !== update.id)
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_ACCOUNT:
            {
                const update = payload;
                const { id: id, address: address } = update, accountUpdate = $8721fac3cbf33e27$var$__rest(update, [
                    "id",
                    "address"
                ]);
                const updatedWallets = state.wallets.map((wallet)=>{
                    if (wallet.label === id) wallet.accounts = wallet.accounts.map((account)=>{
                        if (account.address === address) return Object.assign(Object.assign({}, account), accountUpdate);
                        return account;
                    });
                    return wallet;
                });
                return Object.assign(Object.assign({}, state), {
                    wallets: updatedWallets
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_ALL_WALLETS:
            {
                const updatedWallets = payload;
                return Object.assign(Object.assign({}, state), {
                    wallets: updatedWallets
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_CONNECT_MODAL:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state), {
                    connect: Object.assign(Object.assign({}, state.connect), update)
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_ACCOUNT_CENTER:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state), {
                    accountCenter: Object.assign(Object.assign({}, state.accountCenter), update)
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_NOTIFY:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state), {
                    notify: Object.assign(Object.assign({}, state.notify), update)
                });
            }
        case $8721fac3cbf33e27$var$ADD_NOTIFICATION:
            {
                const update = payload;
                const notificationsUpdate = [
                    ...state.notifications
                ];
                const notificationExistsIndex = notificationsUpdate.findIndex(({ id: id })=>id === update.id);
                if (notificationExistsIndex !== -1) // if notification with same id, replace it with update
                notificationsUpdate[notificationExistsIndex] = update;
                else // otherwise add it to the beginning of array as new notification
                notificationsUpdate.unshift(update);
                return Object.assign(Object.assign({}, state), {
                    notifications: notificationsUpdate
                });
            }
        case $8721fac3cbf33e27$var$REMOVE_NOTIFICATION:
            {
                const id = payload;
                return Object.assign(Object.assign({}, state), {
                    notifications: state.notifications.filter((notification)=>notification.id !== id)
                });
            }
        case $8721fac3cbf33e27$var$SET_WALLET_MODULES:
            return Object.assign(Object.assign({}, state), {
                walletModules: payload
            });
        case $8721fac3cbf33e27$var$SET_LOCALE:
            // Set the locale in the svelte-i18n internal state
            (0, $fQSUm.locale).set(payload);
            return Object.assign(Object.assign({}, state), {
                locale: payload
            });
        case $8721fac3cbf33e27$var$UPDATE_APP_METADATA:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state), {
                    appMetadata: Object.assign(Object.assign(Object.assign({}, state.appMetadata), update), {
                        name: update.name || ''
                    })
                });
            }
        case $8721fac3cbf33e27$var$UPDATE_WAGMI_CONFIG:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state), {
                    wagmiConfig: update
                });
            }
        case $8721fac3cbf33e27$var$RESET_STORE:
            return $8721fac3cbf33e27$var$APP_INITIAL_STATE;
        default:
            throw new Error(`Unknown type: ${type} in appStore reducer`);
    }
}
const $8721fac3cbf33e27$var$_store = new (0, $a6zBK.BehaviorSubject)($8721fac3cbf33e27$var$APP_INITIAL_STATE);
const $8721fac3cbf33e27$var$_stateUpdates = new (0, $62AF9.Subject)();
$8721fac3cbf33e27$var$_stateUpdates.subscribe($8721fac3cbf33e27$var$_store);
function $8721fac3cbf33e27$var$dispatch$1(action) {
    const state = $8721fac3cbf33e27$var$_store.getValue();
    $8721fac3cbf33e27$var$_stateUpdates.next($8721fac3cbf33e27$var$reducer(state, action));
}
function $8721fac3cbf33e27$var$select(stateKey) {
    if (!stateKey) return $8721fac3cbf33e27$var$_stateUpdates.asObservable();
    const validStateKeys = Object.keys($8721fac3cbf33e27$var$_store.getValue());
    if (!validStateKeys.includes(String(stateKey))) throw new Error(`key: ${stateKey} does not exist on this store`);
    return $8721fac3cbf33e27$var$_stateUpdates.asObservable().pipe((0, $9TSAA.distinctUntilKeyChanged)(stateKey), (0, $fIHKl.pluck)(stateKey), (0, $9vj9x.filter)($8721fac3cbf33e27$var$notNullish));
}
function $8721fac3cbf33e27$var$get() {
    return $8721fac3cbf33e27$var$_store.getValue();
}
const $8721fac3cbf33e27$export$6559d589eb85fbb6 = {
    select: $8721fac3cbf33e27$var$select,
    get: $8721fac3cbf33e27$var$get
};
function $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5() {}
const $8721fac3cbf33e27$var$identity = (x)=>x;
function $8721fac3cbf33e27$var$assign(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function $8721fac3cbf33e27$var$is_promise(value) {
    return !!value && (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function';
}
function $8721fac3cbf33e27$var$run(fn) {
    return fn();
}
function $8721fac3cbf33e27$var$blank_object() {
    return Object.create(null);
}
function $8721fac3cbf33e27$export$61196ced6d74a310(fns) {
    fns.forEach($8721fac3cbf33e27$var$run);
}
function $8721fac3cbf33e27$export$dc98b0b04f4c7758(thing) {
    return typeof thing === 'function';
}
function $8721fac3cbf33e27$export$2408f22a0fab9ae5(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === 'object' || typeof a === 'function';
}
let $8721fac3cbf33e27$var$src_url_equal_anchor;
function $8721fac3cbf33e27$export$3c2fa207a37baaea(element_src, url) {
    if (!$8721fac3cbf33e27$var$src_url_equal_anchor) $8721fac3cbf33e27$var$src_url_equal_anchor = document.createElement('a');
    $8721fac3cbf33e27$var$src_url_equal_anchor.href = url;
    return element_src === $8721fac3cbf33e27$var$src_url_equal_anchor.href;
}
function $8721fac3cbf33e27$var$is_empty(obj) {
    return Object.keys(obj).length === 0;
}
function $8721fac3cbf33e27$var$subscribe(store, ...callbacks) {
    if (store == null) return $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5;
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}
function $8721fac3cbf33e27$export$db3b6bfb95261072(component, store, callback) {
    component.$$.on_destroy.push($8721fac3cbf33e27$var$subscribe(store, callback));
}
function $8721fac3cbf33e27$var$create_slot(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = $8721fac3cbf33e27$var$get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function $8721fac3cbf33e27$var$get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn ? $8721fac3cbf33e27$var$assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function $8721fac3cbf33e27$var$get_slot_changes(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) return lets;
        if (typeof lets === 'object') {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for(let i = 0; i < len; i += 1)merged[i] = $$scope.dirty[i] | lets[i];
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function $8721fac3cbf33e27$var$update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = $8721fac3cbf33e27$var$get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function $8721fac3cbf33e27$var$get_all_dirty_from_scope($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for(let i = 0; i < length; i++)dirty[i] = -1;
        return dirty;
    }
    return -1;
}
function $8721fac3cbf33e27$export$882b5998b3b9117c(value) {
    return value == null ? '' : value;
}
function $8721fac3cbf33e27$var$split_css_unit(value) {
    const split = typeof value === 'string' && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [
        parseFloat(split[1]),
        split[2] || 'px'
    ] : [
        value,
        'px'
    ];
}
const $8721fac3cbf33e27$var$is_client = typeof window !== 'undefined';
let $8721fac3cbf33e27$var$now = $8721fac3cbf33e27$var$is_client ? ()=>window.performance.now() : ()=>Date.now();
let $8721fac3cbf33e27$var$raf = $8721fac3cbf33e27$var$is_client ? (cb)=>requestAnimationFrame(cb) : $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5;
const $8721fac3cbf33e27$var$tasks = new Set();
function $8721fac3cbf33e27$var$run_tasks(now) {
    $8721fac3cbf33e27$var$tasks.forEach((task)=>{
        if (!task.c(now)) {
            $8721fac3cbf33e27$var$tasks.delete(task);
            task.f();
        }
    });
    if ($8721fac3cbf33e27$var$tasks.size !== 0) $8721fac3cbf33e27$var$raf($8721fac3cbf33e27$var$run_tasks);
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */ function $8721fac3cbf33e27$var$loop(callback) {
    let task;
    if ($8721fac3cbf33e27$var$tasks.size === 0) $8721fac3cbf33e27$var$raf($8721fac3cbf33e27$var$run_tasks);
    return {
        promise: new Promise((fulfill)=>{
            $8721fac3cbf33e27$var$tasks.add(task = {
                c: callback,
                f: fulfill
            });
        }),
        abort () {
            $8721fac3cbf33e27$var$tasks.delete(task);
        }
    };
}
function $8721fac3cbf33e27$export$953cecd6e717a553(target, node) {
    target.appendChild(node);
}
function $8721fac3cbf33e27$export$407448d2b89b1813(target, style_sheet_id, styles) {
    const append_styles_to = $8721fac3cbf33e27$var$get_root_for_style(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = $8721fac3cbf33e27$export$35e795649ee09318('style');
        style.id = style_sheet_id;
        style.textContent = styles;
        $8721fac3cbf33e27$var$append_stylesheet(append_styles_to, style);
    }
}
function $8721fac3cbf33e27$var$get_root_for_style(node) {
    if (!node) return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) return root;
    return node.ownerDocument;
}
function $8721fac3cbf33e27$var$append_empty_stylesheet(node) {
    const style_element = $8721fac3cbf33e27$export$35e795649ee09318('style');
    $8721fac3cbf33e27$var$append_stylesheet($8721fac3cbf33e27$var$get_root_for_style(node), style_element);
    return style_element.sheet;
}
function $8721fac3cbf33e27$var$append_stylesheet(node, style) {
    $8721fac3cbf33e27$export$953cecd6e717a553(node.head || node, style);
    return style.sheet;
}
function $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $8721fac3cbf33e27$export$4368d992c4eafac0(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $8721fac3cbf33e27$export$ef35774e6d314e91(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $8721fac3cbf33e27$export$35e795649ee09318(name) {
    return document.createElement(name);
}
function $8721fac3cbf33e27$var$svg_element(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}
function $8721fac3cbf33e27$export$625550452a3fa3ec(data) {
    return document.createTextNode(data);
}
function $8721fac3cbf33e27$export$2329c99376c9d0a4() {
    return $8721fac3cbf33e27$export$625550452a3fa3ec(' ');
}
function $8721fac3cbf33e27$export$f1e1789686576879() {
    return $8721fac3cbf33e27$export$625550452a3fa3ec('');
}
function $8721fac3cbf33e27$export$ffb5f4729a158638(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $8721fac3cbf33e27$export$b4171a6734a65d42(fn) {
    return function(event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $8721fac3cbf33e27$export$342063e11d6c3cad(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
function $8721fac3cbf33e27$var$children(element) {
    return Array.from(element.childNodes);
}
function $8721fac3cbf33e27$export$90a7f3efeed30595(text, data) {
    data = '' + data;
    if (text.data === data) return;
    text.data = data;
}
function $8721fac3cbf33e27$export$971d5caa766a69d7(node, key, value, important) {
    if (value == null) node.style.removeProperty(key);
    else node.style.setProperty(key, value, important ? 'important' : '');
}
function $8721fac3cbf33e27$export$ae1af26003f05816(select, value, mounting) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) select.selectedIndex = -1; // no option should be selected
}
function $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(element, name, toggle) {
    element.classList[toggle ? 'add' : 'remove'](name);
}
function $8721fac3cbf33e27$var$custom_event(type, detail, { bubbles: bubbles = false, cancelable: cancelable = false } = {}) {
    const e = document.createEvent('CustomEvent');
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
class $8721fac3cbf33e27$export$ce26c07117d59d6a {
    constructor(is_svg = false){
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg) this.e = $8721fac3cbf33e27$var$svg_element(target.nodeName);
            else this.e = $8721fac3cbf33e27$export$35e795649ee09318(target.nodeType === 11 ? 'TEMPLATE' : target.nodeName);
            this.t = target.tagName !== 'TEMPLATE' ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === 'TEMPLATE' ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$8721fac3cbf33e27$export$8b22cf2602fb60ce(this.t, this.n[i], anchor);
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach($8721fac3cbf33e27$export$4368d992c4eafac0);
    }
}
function $8721fac3cbf33e27$var$construct_svelte_component(component, props) {
    return new component(props);
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const $8721fac3cbf33e27$var$managed_styles = new Map();
let $8721fac3cbf33e27$var$active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function $8721fac3cbf33e27$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i--)hash = (hash << 5) - hash ^ str.charCodeAt(i);
    return hash >>> 0;
}
function $8721fac3cbf33e27$var$create_style_information(doc, node) {
    const info = {
        stylesheet: $8721fac3cbf33e27$var$append_empty_stylesheet(node),
        rules: {}
    };
    $8721fac3cbf33e27$var$managed_styles.set(doc, info);
    return info;
}
function $8721fac3cbf33e27$var$create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = '{\n';
    for(let p = 0; p <= 1; p += step){
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${$8721fac3cbf33e27$var$hash(rule)}_${uid}`;
    const doc = $8721fac3cbf33e27$var$get_root_for_style(node);
    const { stylesheet: stylesheet, rules: rules } = $8721fac3cbf33e27$var$managed_styles.get(doc) || $8721fac3cbf33e27$var$create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || '';
    node.style.animation = `${animation ? `${animation}, ` : ''}${name} ${duration}ms linear ${delay}ms 1 both`;
    $8721fac3cbf33e27$var$active += 1;
    return name;
}
function $8721fac3cbf33e27$var$delete_rule(node, name) {
    const previous = (node.style.animation || '').split(', ');
    const next = previous.filter(name ? (anim)=>anim.indexOf(name) < 0 // remove specific animation
     : (anim)=>anim.indexOf('__svelte') === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(', ');
        $8721fac3cbf33e27$var$active -= deleted;
        if (!$8721fac3cbf33e27$var$active) $8721fac3cbf33e27$var$clear_rules();
    }
}
function $8721fac3cbf33e27$var$clear_rules() {
    $8721fac3cbf33e27$var$raf(()=>{
        if ($8721fac3cbf33e27$var$active) return;
        $8721fac3cbf33e27$var$managed_styles.forEach((info)=>{
            const { ownerNode: ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode) $8721fac3cbf33e27$export$4368d992c4eafac0(ownerNode);
        });
        $8721fac3cbf33e27$var$managed_styles.clear();
    });
}
function $8721fac3cbf33e27$export$3d12bd131bb975d1(node, from, fn, params) {
    if (!from) return $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom) return $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5;
    const { delay: delay = 0, duration: duration = 300, easing: easing = $8721fac3cbf33e27$var$identity, // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = $8721fac3cbf33e27$var$now() + delay, end: // @ts-ignore todo:
    end = start_time + duration, tick: tick = $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5, css: css } = fn(node, {
        from: from,
        to: to
    }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) name = $8721fac3cbf33e27$var$create_rule(node, 0, 1, duration, delay, easing, css);
        if (!delay) started = true;
    }
    function stop() {
        if (css) $8721fac3cbf33e27$var$delete_rule(node, name);
        running = false;
    }
    $8721fac3cbf33e27$var$loop((now)=>{
        if (!started && now >= start_time) started = true;
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) return false;
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function $8721fac3cbf33e27$export$9fa96a7d116ea3ce(node) {
    const style = getComputedStyle(node);
    if (style.position !== 'absolute' && style.position !== 'fixed') {
        const { width: width, height: height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = 'absolute';
        node.style.width = width;
        node.style.height = height;
        $8721fac3cbf33e27$export$28f7fcd39efa255(node, a);
    }
}
function $8721fac3cbf33e27$export$28f7fcd39efa255(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === 'none' ? '' : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}
let $8721fac3cbf33e27$var$current_component;
function $8721fac3cbf33e27$var$set_current_component(component) {
    $8721fac3cbf33e27$var$current_component = component;
}
function $8721fac3cbf33e27$var$get_current_component() {
    if (!$8721fac3cbf33e27$var$current_component) throw new Error('Function called outside component initialization');
    return $8721fac3cbf33e27$var$current_component;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */ function $8721fac3cbf33e27$var$beforeUpdate(fn) {
    $8721fac3cbf33e27$var$get_current_component().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $8721fac3cbf33e27$var$onMount(fn) {
    $8721fac3cbf33e27$var$get_current_component().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $8721fac3cbf33e27$var$afterUpdate(fn) {
    $8721fac3cbf33e27$var$get_current_component().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */ function $8721fac3cbf33e27$export$ab83b03e4111b1d0(fn) {
    $8721fac3cbf33e27$var$get_current_component().$$.on_destroy.push(fn);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function $8721fac3cbf33e27$export$f38c853ae54ed474(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) // @ts-ignore
    callbacks.slice().forEach((fn)=>fn.call(this, event));
}
const $8721fac3cbf33e27$var$dirty_components = [];
const $8721fac3cbf33e27$export$39b482c5e57630a8 = [];
let $8721fac3cbf33e27$var$render_callbacks = [];
const $8721fac3cbf33e27$var$flush_callbacks = [];
const $8721fac3cbf33e27$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $8721fac3cbf33e27$var$update_scheduled = false;
function $8721fac3cbf33e27$var$schedule_update() {
    if (!$8721fac3cbf33e27$var$update_scheduled) {
        $8721fac3cbf33e27$var$update_scheduled = true;
        $8721fac3cbf33e27$var$resolved_promise.then($8721fac3cbf33e27$var$flush);
    }
}
function $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(fn) {
    $8721fac3cbf33e27$var$render_callbacks.push(fn);
}
function $8721fac3cbf33e27$export$4c3d22f3d993c33f(fn) {
    $8721fac3cbf33e27$var$flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $8721fac3cbf33e27$var$seen_callbacks = new Set();
let $8721fac3cbf33e27$var$flushidx = 0; // Do *not* move this inside the flush() function
function $8721fac3cbf33e27$var$flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($8721fac3cbf33e27$var$flushidx !== 0) return;
    const saved_component = $8721fac3cbf33e27$var$current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($8721fac3cbf33e27$var$flushidx < $8721fac3cbf33e27$var$dirty_components.length){
                const component = $8721fac3cbf33e27$var$dirty_components[$8721fac3cbf33e27$var$flushidx];
                $8721fac3cbf33e27$var$flushidx++;
                $8721fac3cbf33e27$var$set_current_component(component);
                $8721fac3cbf33e27$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $8721fac3cbf33e27$var$dirty_components.length = 0;
            $8721fac3cbf33e27$var$flushidx = 0;
            throw e;
        }
        $8721fac3cbf33e27$var$set_current_component(null);
        $8721fac3cbf33e27$var$dirty_components.length = 0;
        $8721fac3cbf33e27$var$flushidx = 0;
        while($8721fac3cbf33e27$export$39b482c5e57630a8.length)$8721fac3cbf33e27$export$39b482c5e57630a8.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $8721fac3cbf33e27$var$render_callbacks.length; i += 1){
            const callback = $8721fac3cbf33e27$var$render_callbacks[i];
            if (!$8721fac3cbf33e27$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $8721fac3cbf33e27$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $8721fac3cbf33e27$var$render_callbacks.length = 0;
    }while ($8721fac3cbf33e27$var$dirty_components.length);
    while($8721fac3cbf33e27$var$flush_callbacks.length)$8721fac3cbf33e27$var$flush_callbacks.pop()();
    $8721fac3cbf33e27$var$update_scheduled = false;
    $8721fac3cbf33e27$var$seen_callbacks.clear();
    $8721fac3cbf33e27$var$set_current_component(saved_component);
}
function $8721fac3cbf33e27$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $8721fac3cbf33e27$export$61196ced6d74a310($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($8721fac3cbf33e27$export$3a6d5c9ae78a2c08);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $8721fac3cbf33e27$var$flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    $8721fac3cbf33e27$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $8721fac3cbf33e27$var$render_callbacks = filtered;
}
let $8721fac3cbf33e27$var$promise;
function $8721fac3cbf33e27$var$wait() {
    if (!$8721fac3cbf33e27$var$promise) {
        $8721fac3cbf33e27$var$promise = Promise.resolve();
        $8721fac3cbf33e27$var$promise.then(()=>{
            $8721fac3cbf33e27$var$promise = null;
        });
    }
    return $8721fac3cbf33e27$var$promise;
}
function $8721fac3cbf33e27$var$dispatch(node, direction, kind) {
    node.dispatchEvent($8721fac3cbf33e27$var$custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
}
const $8721fac3cbf33e27$var$outroing = new Set();
let $8721fac3cbf33e27$var$outros;
function $8721fac3cbf33e27$export$4a5767248b18ef41() {
    $8721fac3cbf33e27$var$outros = {
        r: 0,
        c: [],
        p: $8721fac3cbf33e27$var$outros // parent group
    };
}
function $8721fac3cbf33e27$export$df995fae86a55f06() {
    if (!$8721fac3cbf33e27$var$outros.r) $8721fac3cbf33e27$export$61196ced6d74a310($8721fac3cbf33e27$var$outros.c);
    $8721fac3cbf33e27$var$outros = $8721fac3cbf33e27$var$outros.p;
}
function $8721fac3cbf33e27$export$d141bba7fdc215a3(block, local) {
    if (block && block.i) {
        $8721fac3cbf33e27$var$outroing.delete(block);
        block.i(local);
    }
}
function $8721fac3cbf33e27$export$ebd11618f299a286(block, local, detach, callback) {
    if (block && block.o) {
        if ($8721fac3cbf33e27$var$outroing.has(block)) return;
        $8721fac3cbf33e27$var$outroing.add(block);
        $8721fac3cbf33e27$var$outros.c.push(()=>{
            $8721fac3cbf33e27$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
const $8721fac3cbf33e27$var$null_transition = {
    duration: 0
};
function $8721fac3cbf33e27$export$e7c866399fa523f5(node, fn, params) {
    const options = {
        direction: 'in'
    };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name) $8721fac3cbf33e27$var$delete_rule(node, animation_name);
    }
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $8721fac3cbf33e27$var$identity, tick: tick = $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5, css: css } = config || $8721fac3cbf33e27$var$null_transition;
        if (css) animation_name = $8721fac3cbf33e27$var$create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = $8721fac3cbf33e27$var$now() + delay;
        const end_time = start_time + duration;
        if (task) task.abort();
        running = true;
        $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>$8721fac3cbf33e27$var$dispatch(node, true, 'start'));
        task = $8721fac3cbf33e27$var$loop((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    $8721fac3cbf33e27$var$dispatch(node, true, 'end');
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start () {
            if (started) return;
            started = true;
            $8721fac3cbf33e27$var$delete_rule(node);
            if ($8721fac3cbf33e27$export$dc98b0b04f4c7758(config)) {
                config = config(options);
                $8721fac3cbf33e27$var$wait().then(go);
            } else go();
        },
        invalidate () {
            started = false;
        },
        end () {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function $8721fac3cbf33e27$export$21579262ef46735b(node, fn, params) {
    const options = {
        direction: 'out'
    };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = $8721fac3cbf33e27$var$outros;
    group.r += 1;
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $8721fac3cbf33e27$var$identity, tick: tick = $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5, css: css } = config || $8721fac3cbf33e27$var$null_transition;
        if (css) animation_name = $8721fac3cbf33e27$var$create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = $8721fac3cbf33e27$var$now() + delay;
        const end_time = start_time + duration;
        $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>$8721fac3cbf33e27$var$dispatch(node, false, 'start'));
        $8721fac3cbf33e27$var$loop((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    $8721fac3cbf33e27$var$dispatch(node, false, 'end');
                    if (!--group.r) // this will result in `end()` being called,
                    // so we don't need to clean up here
                    $8721fac3cbf33e27$export$61196ced6d74a310(group.c);
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if ($8721fac3cbf33e27$export$dc98b0b04f4c7758(config)) $8721fac3cbf33e27$var$wait().then(()=>{
        // @ts-ignore
        config = config(options);
        go();
    });
    else go();
    return {
        end (reset) {
            if (reset && config.tick) config.tick(1, 0);
            if (running) {
                if (animation_name) $8721fac3cbf33e27$var$delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function $8721fac3cbf33e27$export$a9c996f45e5784d0(node, fn, params, intro) {
    const options = {
        direction: 'both'
    };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name) $8721fac3cbf33e27$var$delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = program.b - t;
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d: d,
            duration: duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $8721fac3cbf33e27$var$identity, tick: tick = $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5, css: css } = config || $8721fac3cbf33e27$var$null_transition;
        const program = {
            start: $8721fac3cbf33e27$var$now() + delay,
            b: b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = $8721fac3cbf33e27$var$outros;
            $8721fac3cbf33e27$var$outros.r += 1;
        }
        if (running_program || pending_program) pending_program = program;
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = $8721fac3cbf33e27$var$create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b) tick(0, 1);
            running_program = init(program, duration);
            $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>$8721fac3cbf33e27$var$dispatch(node, b, 'start'));
            $8721fac3cbf33e27$var$loop((now)=>{
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    $8721fac3cbf33e27$var$dispatch(node, running_program.b, 'start');
                    if (css) {
                        clear_animation();
                        animation_name = $8721fac3cbf33e27$var$create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        $8721fac3cbf33e27$var$dispatch(node, running_program.b, 'end');
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) // intro — we can tidy up immediately
                            clear_animation();
                            else // outro — needs to be coordinated
                            if (!--running_program.group.r) $8721fac3cbf33e27$export$61196ced6d74a310(running_program.group.c);
                        }
                        running_program = null;
                    } else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run (b) {
            if ($8721fac3cbf33e27$export$dc98b0b04f4c7758(config)) $8721fac3cbf33e27$var$wait().then(()=>{
                // @ts-ignore
                config = config(options);
                go(b);
            });
            else go(b);
        },
        end () {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}
function $8721fac3cbf33e27$export$71511d61b312f219(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token) return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) info.blocks.forEach((block, i)=>{
                if (i !== index && block) {
                    $8721fac3cbf33e27$export$4a5767248b18ef41();
                    $8721fac3cbf33e27$export$ebd11618f299a286(block, 1, 1, ()=>{
                        if (info.blocks[i] === block) info.blocks[i] = null;
                    });
                    $8721fac3cbf33e27$export$df995fae86a55f06();
                }
            });
            else info.block.d(1);
            block.c();
            $8721fac3cbf33e27$export$d141bba7fdc215a3(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks) info.blocks[index] = block;
        if (needs_flush) $8721fac3cbf33e27$var$flush();
    }
    if ($8721fac3cbf33e27$var$is_promise(promise)) {
        const current_component = $8721fac3cbf33e27$var$get_current_component();
        promise.then((value)=>{
            $8721fac3cbf33e27$var$set_current_component(current_component);
            update(info.then, 1, info.value, value);
            $8721fac3cbf33e27$var$set_current_component(null);
        }, (error)=>{
            $8721fac3cbf33e27$var$set_current_component(current_component);
            update(info.catch, 2, info.error, error);
            $8721fac3cbf33e27$var$set_current_component(null);
            if (!info.hasCatch) throw error;
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    } else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved: resolved } = info;
    if (info.current === info.then) child_ctx[info.value] = resolved;
    if (info.current === info.catch) child_ctx[info.error] = resolved;
    info.block.p(child_ctx, dirty);
}
function $8721fac3cbf33e27$export$9e5f44173e64f162(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function $8721fac3cbf33e27$export$c3950d9923825c02(block, lookup) {
    $8721fac3cbf33e27$export$ebd11618f299a286(block, 1, 1, ()=>{
        lookup.delete(block.key);
    });
}
function $8721fac3cbf33e27$export$91c6e00c14e7e6fd(block, lookup) {
    block.f();
    $8721fac3cbf33e27$export$c3950d9923825c02(block, lookup);
}
function $8721fac3cbf33e27$export$3b14a55fb2447963(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while(i--)old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while(i--){
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        } else if (dynamic) // defer updates until all the DOM shuffling is done
        updates.push(()=>block.p(child_ctx, dirty));
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        $8721fac3cbf33e27$export$d141bba7fdc215a3(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while(o && n){
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        } else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        } else if (!lookup.has(new_key) || will_move.has(new_key)) insert(new_block);
        else if (did_move.has(old_key)) o--;
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        } else {
            will_move.add(old_key);
            o--;
        }
    }
    while(o--){
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
    }
    while(n)insert(new_blocks[n - 1]);
    $8721fac3cbf33e27$export$61196ced6d74a310(updates);
    return new_blocks;
}
function $8721fac3cbf33e27$export$2219238a014317b0(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function $8721fac3cbf33e27$export$d66501df72047452(block) {
    block && block.c();
}
function $8721fac3cbf33e27$export$9bb611d729802a56(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>{
        const new_on_destroy = component.$$.on_mount.map($8721fac3cbf33e27$var$run).filter($8721fac3cbf33e27$export$dc98b0b04f4c7758);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $8721fac3cbf33e27$export$61196ced6d74a310(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($8721fac3cbf33e27$export$3a6d5c9ae78a2c08);
}
function $8721fac3cbf33e27$export$3466f893ebf79586(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $8721fac3cbf33e27$var$flush_render_callbacks($$.after_update);
        $8721fac3cbf33e27$export$61196ced6d74a310($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $8721fac3cbf33e27$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $8721fac3cbf33e27$var$dirty_components.push(component);
        $8721fac3cbf33e27$var$schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $8721fac3cbf33e27$export$23f2a1d2818174ef(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $8721fac3cbf33e27$var$current_component;
    $8721fac3cbf33e27$var$set_current_component(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        not_equal: not_equal,
        bound: $8721fac3cbf33e27$var$blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $8721fac3cbf33e27$var$blank_object(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $8721fac3cbf33e27$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $8721fac3cbf33e27$export$61196ced6d74a310($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            const nodes = $8721fac3cbf33e27$var$children(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($8721fac3cbf33e27$export$4368d992c4eafac0);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $8721fac3cbf33e27$export$d141bba7fdc215a3(component.$$.fragment);
        $8721fac3cbf33e27$export$9bb611d729802a56(component, options.target, options.anchor, options.customElement);
        $8721fac3cbf33e27$var$flush();
    }
    $8721fac3cbf33e27$var$set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $8721fac3cbf33e27$export$25ce5a424b770e84 {
    $destroy() {
        $8721fac3cbf33e27$export$3466f893ebf79586(this, 1);
        this.$destroy = $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5;
    }
    $on(type, callback) {
        if (!$8721fac3cbf33e27$export$dc98b0b04f4c7758(callback)) return $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$8721fac3cbf33e27$var$is_empty($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
const $8721fac3cbf33e27$var$reset$ = new (0, $62AF9.Subject)();
const $8721fac3cbf33e27$var$disconnectWallet$ = new (0, $62AF9.Subject)();
const $8721fac3cbf33e27$export$a07804094c3ecf2d = new (0, $a6zBK.BehaviorSubject)({
    inProgress: false,
    actionRequired: ''
});
const $8721fac3cbf33e27$var$switchChainModal$ = new (0, $a6zBK.BehaviorSubject)(null);
const $8721fac3cbf33e27$export$efccba1c4a2ef57b = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('wallets').pipe((0, $3nJ2a.shareReplay)(1));
// reset logic
$8721fac3cbf33e27$var$reset$.pipe((0, $FNLtf.withLatestFrom)($8721fac3cbf33e27$export$efccba1c4a2ef57b), (0, $fIHKl.pluck)('1')).subscribe((wallets)=>{
    // disconnect all wallets
    wallets.forEach(({ label: label })=>{
        $8721fac3cbf33e27$var$disconnectWallet$.next(label);
    });
    $8721fac3cbf33e27$var$resetStore();
});
// keep transactions for all notifications for replacement actions
const $8721fac3cbf33e27$export$493d36ec626b6698 = new (0, $a6zBK.BehaviorSubject)([]);
function $8721fac3cbf33e27$export$d66dc83d8cfc8dd(hash) {
    const currentTransactions = $8721fac3cbf33e27$export$493d36ec626b6698.getValue();
    $8721fac3cbf33e27$export$493d36ec626b6698.next(currentTransactions.filter((tx)=>tx.hash !== hash));
}
(0, $fcGyk.defer)(()=>{
    const subject = new (0, $62AF9.Subject)();
    $8721fac3cbf33e27$var$onMount(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $kgoiB.take)(1));
});
const $8721fac3cbf33e27$var$onDestroy$ = (0, $fcGyk.defer)(()=>{
    const subject = new (0, $62AF9.Subject)();
    $8721fac3cbf33e27$export$ab83b03e4111b1d0(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $kgoiB.take)(1));
});
(0, $fcGyk.defer)(()=>{
    const subject = new (0, $62AF9.Subject)();
    $8721fac3cbf33e27$var$afterUpdate(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $gybEh.takeUntil)($8721fac3cbf33e27$var$onDestroy$));
});
(0, $fcGyk.defer)(()=>{
    const subject = new (0, $62AF9.Subject)();
    $8721fac3cbf33e27$var$beforeUpdate(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $gybEh.takeUntil)($8721fac3cbf33e27$var$onDestroy$));
});
const $8721fac3cbf33e27$var$themes = {
    default: {
        '--w3o-background-color': 'unset',
        '--w3o-foreground-color': 'unset',
        '--w3o-text-color': 'unset',
        '--w3o-border-color': 'unset',
        '--w3o-action-color': 'unset',
        '--w3o-border-radius': 'unset',
        '--w3o-font-family': 'inherit'
    },
    light: {
        '--w3o-background-color': '#ffffff',
        '--w3o-foreground-color': '#EFF1FC',
        '--w3o-text-color': '#1a1d26',
        '--w3o-border-color': '#d0d4f7',
        '--w3o-action-color': '#6370E5',
        '--w3o-border-radius': '16px',
        '--w3o-font-family': 'inherit'
    },
    dark: {
        '--w3o-background-color': '#1A1D26',
        '--w3o-foreground-color': '#242835',
        '--w3o-text-color': '#EFF1FC',
        '--w3o-border-color': '#33394B',
        '--w3o-action-color': '#929bed',
        '--w3o-border-radius': '16px',
        '--w3o-font-family': 'inherit'
    }
};
const $8721fac3cbf33e27$var$returnTheme = (theme)=>{
    if (typeof theme === 'string' && theme === 'system') return $8721fac3cbf33e27$var$watchForSystemThemeChange();
    return $8721fac3cbf33e27$var$returnThemeMap(theme);
};
const $8721fac3cbf33e27$var$returnThemeMap = (theme)=>{
    if (typeof theme === 'string' && theme in $8721fac3cbf33e27$var$themes) return $8721fac3cbf33e27$var$themes[theme];
    if (typeof theme === 'object') return theme;
};
const $8721fac3cbf33e27$var$handleThemeChange = (update)=>{
    Object.keys(update).forEach((targetStyle)=>{
        document.documentElement.style.setProperty(targetStyle, update[targetStyle] || null);
    });
};
const $8721fac3cbf33e27$var$watchForSystemThemeChange = ()=>{
    const systemThemeDark = window.matchMedia('(prefers-color-scheme: dark)');
    systemThemeDark.matches ? $8721fac3cbf33e27$var$handleThemeChange($8721fac3cbf33e27$var$themes['dark']) : $8721fac3cbf33e27$var$handleThemeChange($8721fac3cbf33e27$var$themes['light']);
    (0, $3U9xZ.fromEvent)(systemThemeDark, 'change').pipe((0, $gybEh.takeUntil)($8721fac3cbf33e27$var$reset$)).subscribe((changes)=>{
        const themeChange = changes;
        themeChange.matches ? $8721fac3cbf33e27$var$handleThemeChange($8721fac3cbf33e27$var$themes['dark']) : $8721fac3cbf33e27$var$handleThemeChange($8721fac3cbf33e27$var$themes['light']);
    });
};
const $8721fac3cbf33e27$var$unknownObject = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object().unknown();
const $8721fac3cbf33e27$var$connectedChain = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    namespace: (0, $dkXem.chainNamespaceValidation).required(),
    id: (0, $dkXem.chainIdValidation).required()
});
const $8721fac3cbf33e27$var$ens = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    avatar: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    contentHash: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(), null),
    getText: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().arity(1).required()
}), null);
const $8721fac3cbf33e27$var$uns = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required()
}), null);
const $8721fac3cbf33e27$var$balance = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    eth: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number()
}).unknown(), null);
const $8721fac3cbf33e27$var$secondaryTokens = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    balance: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
}), null);
const $8721fac3cbf33e27$var$account = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    ens: $8721fac3cbf33e27$var$ens,
    uns: $8721fac3cbf33e27$var$uns,
    balance: $8721fac3cbf33e27$var$balance,
    secondaryTokens: $8721fac3cbf33e27$var$secondaryTokens
});
const $8721fac3cbf33e27$var$chains = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, $dkXem.chainValidation)).unique((a, b)=>a.id === b.id).error((e)=>{
    if (e[0].code === 'array.unique') return new Error(`There is a duplicate Chain ID in your Onboard Chains array: ${e}`);
    return new Error(`${e}`);
});
const $8721fac3cbf33e27$var$accounts = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items($8721fac3cbf33e27$var$account);
const $8721fac3cbf33e27$var$wallet = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    provider: $8721fac3cbf33e27$var$unknownObject,
    instance: $8721fac3cbf33e27$var$unknownObject,
    accounts: $8721fac3cbf33e27$var$accounts,
    chains: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items($8721fac3cbf33e27$var$connectedChain),
    wagmiConnector: $8721fac3cbf33e27$var$unknownObject
}).required().error(new Error('wallet must be defined'));
const $8721fac3cbf33e27$var$wallets = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items($8721fac3cbf33e27$var$wallet);
const $8721fac3cbf33e27$var$recommendedWallet = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    url: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().uri().required()
});
const $8721fac3cbf33e27$var$agreement = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    version: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    termsUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().uri(),
    privacyUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().uri()
});
const $8721fac3cbf33e27$var$appMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    gettingStartedGuide: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    appUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    explore: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    recommendedInjectedWallets: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items($8721fac3cbf33e27$var$recommendedWallet),
    agreement: $8721fac3cbf33e27$var$agreement
});
const $8721fac3cbf33e27$var$appMetadataUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    gettingStartedGuide: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    appUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    explore: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    recommendedInjectedWallets: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items($8721fac3cbf33e27$var$recommendedWallet),
    agreement: $8721fac3cbf33e27$var$agreement
});
(0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    getInfo: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().arity(1).required(),
    getInterface: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().arity(1).required()
});
const $8721fac3cbf33e27$var$walletInit = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function()).required();
const $8721fac3cbf33e27$var$locale = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string();
const $8721fac3cbf33e27$var$commonPositions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().valid('topRight', 'bottomRight', 'bottomLeft', 'topLeft');
const $8721fac3cbf33e27$var$gasPriceProbabilities = [
    70,
    80,
    90,
    95,
    99
];
const $8721fac3cbf33e27$var$notify$1 = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    transactionHandler: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().optional(),
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    position: $8721fac3cbf33e27$var$commonPositions,
    replacement: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
        gasPriceProbability: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
            speedup: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number().valid(...$8721fac3cbf33e27$var$gasPriceProbabilities),
            cancel: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number().valid(...$8721fac3cbf33e27$var$gasPriceProbabilities)
        })
    })
});
const $8721fac3cbf33e27$var$notifyOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    desktop: $8721fac3cbf33e27$var$notify$1,
    mobile: $8721fac3cbf33e27$var$notify$1
});
const $8721fac3cbf33e27$var$accountCenterInitOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    position: $8721fac3cbf33e27$var$commonPositions,
    minimal: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    containerElement: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
const $8721fac3cbf33e27$var$accountCenter$1 = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    position: $8721fac3cbf33e27$var$commonPositions,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    minimal: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    containerElement: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
const $8721fac3cbf33e27$var$connectModalOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    showSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    disableClose: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    autoConnectLastWallet: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    autoConnectAllPreviousWallet: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    iDontHaveAWalletLink: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    wheresMyWalletLink: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    removeWhereIsMyWalletWarning: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    removeIDontHaveAWalletInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    disableUDResolution: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean()
});
const $8721fac3cbf33e27$var$containerElements = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    accountCenter: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    connectModal: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
const $8721fac3cbf33e27$var$themeMap = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    '--w3o-background-color': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    '--w3o-font-family': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    '--w3o-foreground-color': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    '--w3o-text-color': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    '--w3o-border-color': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    '--w3o-action-color': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    '--w3o-border-radius': (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
const $8721fac3cbf33e27$var$presetTheme = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().valid('default', 'dark', 'light', 'system');
const $8721fac3cbf33e27$var$theme = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).alternatives().try($8721fac3cbf33e27$var$themeMap, $8721fac3cbf33e27$var$presetTheme);
const $8721fac3cbf33e27$var$initOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    wallets: $8721fac3cbf33e27$var$walletInit,
    chains: $8721fac3cbf33e27$var$chains.required(),
    appMetadata: $8721fac3cbf33e27$var$appMetadata,
    i18n: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object().unknown(),
    apiKey: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    accountCenter: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
        desktop: $8721fac3cbf33e27$var$accountCenterInitOptions,
        mobile: $8721fac3cbf33e27$var$accountCenterInitOptions,
        hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
        transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
    }),
    notify: [
        $8721fac3cbf33e27$var$notifyOptions,
        $8721fac3cbf33e27$var$notify$1
    ],
    gas: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().required(),
        stream: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().required()
    }),
    wagmi: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    connect: $8721fac3cbf33e27$var$connectModalOptions,
    containerElements: $8721fac3cbf33e27$var$containerElements,
    // transactionPreview is deprecated but is still allowed to 
    // avoid breaking dapps a console error is shown although 
    // transactionPreview functionality has been removed
    transactionPreview: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any(),
    theme: $8721fac3cbf33e27$var$theme,
    disableFontDownload: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
    unstoppableResolution: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function()
});
const $8721fac3cbf33e27$var$connectOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    autoSelect: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).alternatives().try((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
        disableModals: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string())
});
const $8721fac3cbf33e27$var$disconnectOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required()
}).required();
const $8721fac3cbf33e27$var$secondaryTokenValidation = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().optional()
});
const $8721fac3cbf33e27$var$setChainOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    chainId: (0, $dkXem.chainIdValidation).required(),
    chainNamespace: (0, $dkXem.chainNamespaceValidation),
    wallet: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    rpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    token: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    protectedRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    secondaryTokens: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().max(5).items($8721fac3cbf33e27$var$secondaryTokenValidation).optional()
});
const $8721fac3cbf33e27$var$customNotificationUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    key: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().allow('pending', 'error', 'success', 'hint'),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
(0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    sendTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    estimateGas: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    gasPrice: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    balance: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).alternatives((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(), (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number()),
    txDetails: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).alternatives((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(), (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number()),
        to: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
        from: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
    }),
    txApproveReminderTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number()
});
const $8721fac3cbf33e27$var$customNotification$1 = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    key: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().allow('pending', 'error', 'success', 'hint'),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
(0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    id: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    key: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().allow('pending', 'error', 'success', 'hint').required(),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number().required(),
    network: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    startTime: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
function $8721fac3cbf33e27$var$validateWallet(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$wallet, data);
}
function $8721fac3cbf33e27$var$validateInitOptions(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$initOptions, data);
}
function $8721fac3cbf33e27$var$validateConnectOptions(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$connectOptions, data);
}
function $8721fac3cbf33e27$var$validateDisconnectOptions(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$disconnectOptions, data);
}
function $8721fac3cbf33e27$var$validateString(str, label) {
    return (0, $dkXem.validate)((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required().label(label || 'value'), str);
}
function $8721fac3cbf33e27$var$validateSetChainOptions(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$setChainOptions, data);
}
function $8721fac3cbf33e27$var$validateAccountCenterUpdate(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$accountCenter$1, data);
}
function $8721fac3cbf33e27$var$validateConnectModalUpdate(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$connectModalOptions, data);
}
function $8721fac3cbf33e27$var$validateWalletInit(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$walletInit, data);
}
function $8721fac3cbf33e27$var$validateLocale(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$locale, data);
}
function $8721fac3cbf33e27$var$validateNotify(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$notify$1, data);
}
function $8721fac3cbf33e27$var$validateNotifyOptions(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$notifyOptions, data);
}
function $8721fac3cbf33e27$var$validateCustomNotificationUpdate(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$customNotificationUpdate, data);
}
function $8721fac3cbf33e27$var$validateCustomNotification(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$customNotification$1, data);
}
function $8721fac3cbf33e27$var$validateUpdateBalances(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$wallets, data);
}
function $8721fac3cbf33e27$var$validateUpdateTheme(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$theme, data);
}
function $8721fac3cbf33e27$var$validateAppMetadataUpdate(data) {
    return (0, $dkXem.validate)($8721fac3cbf33e27$var$appMetadataUpdate, data);
}
function $8721fac3cbf33e27$var$addChains(chains) {
    // chains are validated on init
    const action = {
        type: $8721fac3cbf33e27$var$ADD_CHAINS,
        payload: chains.map((_a)=>{
            var { namespace: namespace = 'evm', id: id, rpcUrl: rpcUrl } = _a, rest = $8721fac3cbf33e27$var$__rest(_a, [
                "namespace",
                "id",
                "rpcUrl"
            ]);
            return Object.assign(Object.assign({}, rest), {
                namespace: namespace,
                id: id.toLowerCase(),
                rpcUrl: rpcUrl ? rpcUrl.trim() : null
            });
        })
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$updateChain(updatedChain) {
    const { label: label, token: token, rpcUrl: rpcUrl, id: chainId, namespace: chainNamespace } = updatedChain;
    const error = $8721fac3cbf33e27$var$validateSetChainOptions({
        label: label,
        token: token,
        rpcUrl: rpcUrl,
        chainId: chainId,
        chainNamespace: chainNamespace
    });
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_CHAINS,
        payload: updatedChain
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$addWallet(wallet) {
    const error = $8721fac3cbf33e27$var$validateWallet(wallet);
    if (error) {
        console.error(error);
        throw error;
    }
    const action = {
        type: $8721fac3cbf33e27$var$ADD_WALLET,
        payload: wallet
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$updateWallet(id, update) {
    const error = $8721fac3cbf33e27$var$validateWallet(update);
    if (error) {
        console.error(error);
        throw error;
    }
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_WALLET,
        payload: Object.assign({
            id: id
        }, update)
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$removeWallet(id) {
    const error = $8721fac3cbf33e27$var$validateString(id, 'wallet id');
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$REMOVE_WALLET,
        payload: {
            id: id
        }
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$export$c4ce752e73470fba(wallet, address) {
    const error = $8721fac3cbf33e27$var$validateWallet(wallet) || address && $8721fac3cbf33e27$var$validateString(address, 'address');
    if (error) throw error;
    // if also setting the primary account
    if (address) {
        const account = wallet.accounts.find((ac)=>ac.address === address);
        if (account) wallet.accounts = [
            account,
            ...wallet.accounts.filter(({ address: address })=>address !== account.address)
        ];
    }
    // Update wagmi config if wagmi is being used
    $8721fac3cbf33e27$var$handleWagmiConnectorUpdate(wallet);
    // add wallet will set it to first wallet since it already exists
    $8721fac3cbf33e27$var$addWallet(wallet);
}
function $8721fac3cbf33e27$var$updateAccount(id, address, update) {
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_ACCOUNT,
        payload: Object.assign({
            id: id,
            address: address
        }, update)
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$export$1a82df3d29112e01(update) {
    const error = $8721fac3cbf33e27$var$validateAccountCenterUpdate(update);
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_ACCOUNT_CENTER,
        payload: update
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$updateConnectModal(update) {
    const error = $8721fac3cbf33e27$var$validateConnectModalUpdate(update);
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_CONNECT_MODAL,
        payload: update
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$updateNotify(update) {
    const error = $8721fac3cbf33e27$var$validateNotify(update);
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_NOTIFY,
        payload: update
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$export$92108d983e8ee699(notification) {
    const customNotificationError = $8721fac3cbf33e27$var$validateCustomNotificationUpdate(notification);
    if (customNotificationError) throw customNotificationError;
    const action = {
        type: $8721fac3cbf33e27$var$ADD_NOTIFICATION,
        payload: notification
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$customNotification(updatedNotification) {
    const customNotificationError = $8721fac3cbf33e27$var$validateCustomNotification(updatedNotification);
    if (customNotificationError) throw customNotificationError;
    const customIdKey = `customNotification-${(0, $8FKcp.nanoid)()}`;
    const notification = Object.assign(Object.assign({}, updatedNotification), {
        id: customIdKey,
        key: customIdKey
    });
    $8721fac3cbf33e27$export$92108d983e8ee699(notification);
    const dismiss = ()=>{
        if (notification.id) $8721fac3cbf33e27$export$1fbe638ecf81657e(notification.id);
    };
    const update = (notificationUpdate)=>{
        const customNotificationError = $8721fac3cbf33e27$var$validateCustomNotification(updatedNotification);
        if (customNotificationError) throw customNotificationError;
        const notificationAfterUpdate = Object.assign(Object.assign({}, notificationUpdate), {
            id: notification.id,
            key: notification.key
        });
        $8721fac3cbf33e27$export$92108d983e8ee699(notificationAfterUpdate);
        return {
            dismiss: dismiss,
            update: update
        };
    };
    $8721fac3cbf33e27$export$92108d983e8ee699(notification);
    return {
        dismiss: dismiss,
        update: update
    };
}
function $8721fac3cbf33e27$export$1fbe638ecf81657e(id) {
    if (typeof id !== 'string') throw new Error('Notification id must be of type string');
    const action = {
        type: $8721fac3cbf33e27$var$REMOVE_NOTIFICATION,
        payload: id
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$resetStore() {
    const action = {
        type: $8721fac3cbf33e27$var$RESET_STORE
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$setWalletModules(wallets) {
    const error = $8721fac3cbf33e27$var$validateWalletInit(wallets);
    if (error) throw error;
    const modules = $8721fac3cbf33e27$var$initializeWalletModules(wallets);
    const dedupedWallets = $8721fac3cbf33e27$var$uniqueWalletsByLabel(modules);
    const action = {
        type: $8721fac3cbf33e27$var$SET_WALLET_MODULES,
        payload: dedupedWallets
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$setLocale(locale) {
    const error = $8721fac3cbf33e27$var$validateLocale(locale);
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$SET_LOCALE,
        payload: locale
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$updateAllWallets(wallets) {
    const error = $8721fac3cbf33e27$var$validateUpdateBalances(wallets);
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_ALL_WALLETS,
        payload: wallets
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
// ==== HELPERS ==== //
function $8721fac3cbf33e27$var$initializeWalletModules(modules) {
    const { device: device } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    if (!device) return [];
    return modules.reduce((acc, walletInit)=>{
        const initialized = walletInit({
            device: device
        });
        if (initialized) // injected wallets is an array of wallets
        acc.push(...Array.isArray(initialized) ? initialized : [
            initialized
        ]);
        return acc;
    }, []);
}
function $8721fac3cbf33e27$var$uniqueWalletsByLabel(walletModuleList) {
    return walletModuleList.filter((wallet, i)=>wallet && walletModuleList.findIndex((innerWallet)=>innerWallet && innerWallet.label === wallet.label) === i);
}
function $8721fac3cbf33e27$var$updateTheme(theme) {
    const error = $8721fac3cbf33e27$var$validateUpdateTheme(theme);
    if (error) throw error;
    const themingObj = $8721fac3cbf33e27$var$returnTheme(theme);
    themingObj && $8721fac3cbf33e27$var$handleThemeChange(themingObj);
}
function $8721fac3cbf33e27$var$updateAppMetadata(update) {
    const error = $8721fac3cbf33e27$var$validateAppMetadataUpdate(update);
    if (error) throw error;
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_APP_METADATA,
        payload: update
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$updateWagmiConfig(update) {
    const action = {
        type: $8721fac3cbf33e27$var$UPDATE_WAGMI_CONFIG,
        payload: update
    };
    $8721fac3cbf33e27$var$dispatch$1(action);
}
function $8721fac3cbf33e27$var$handleWagmiConnectorUpdate(wallet) {
    const { wagmi: wagmi } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    if (!wagmi) return;
    try {
        const { label: label } = wallet;
        const { wagmiConnect: wagmiConnect, getWagmiConnector: getWagmiConnector } = wagmi;
        const wagmiConfig = $8721fac3cbf33e27$export$6559d589eb85fbb6.get().wagmiConfig;
        const wagmiConnector = getWagmiConnector(label);
        wagmiConnect(wagmiConfig, {
            connector: wagmiConnector
        }).then(()=>{
            $8721fac3cbf33e27$var$updateWallet(label, {
                wagmiConnector: wagmiConnector
            });
        });
    } catch (e) {
        console.error(`Error updating Wagmi connector on primary wallet switch ${e}`);
    }
}
async function $8721fac3cbf33e27$export$3b513254972cfc9c(options) {
    if (options) {
        const error = $8721fac3cbf33e27$var$validateConnectOptions(options);
        if (error) throw error;
    }
    const { chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    // Wallets require the chains for initializing providers,
    // so we must ensure at least one is set
    if (!chains.length) throw new Error('At least one chain must be set before attempting to connect a wallet');
    let { autoSelect: autoSelect } = options || {};
    if (!autoSelect) autoSelect = {
        label: '',
        disableModals: false
    };
    // if auto selecting, wait until next event loop
    if (autoSelect && (typeof autoSelect === 'string' || autoSelect.label)) await $8721fac3cbf33e27$var$wait$1(50);
    // first time calling connect, so initialize and set wallet modules
    if (!$8721fac3cbf33e27$export$6559d589eb85fbb6.get().walletModules.length) $8721fac3cbf33e27$var$setWalletModules($8721fac3cbf33e27$export$c9170ad7d4cd7e57.initialWalletInit);
    $8721fac3cbf33e27$export$a07804094c3ecf2d.next({
        autoSelect: typeof autoSelect === 'string' ? {
            label: autoSelect,
            disableModals: false
        } : autoSelect,
        inProgress: true
    });
    const result$ = $8721fac3cbf33e27$export$a07804094c3ecf2d.pipe((0, $9vj9x.filter)(({ inProgress: inProgress, actionRequired: actionRequired })=>inProgress === false && !actionRequired), (0, $FNLtf.withLatestFrom)($8721fac3cbf33e27$export$efccba1c4a2ef57b), (0, $fIHKl.pluck)(1));
    return (0, $lqWQ2.firstValueFrom)(result$);
}
async function $8721fac3cbf33e27$export$56c0d5a1e737357d(options) {
    const error = $8721fac3cbf33e27$var$validateDisconnectOptions(options);
    if (error) throw error;
    const { label: label } = options;
    const { wagmi: wagmi } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    if (wagmi) {
        const wagmiConfig = await wagmi.wagmiDisconnectWallet(label);
        if (wagmiConfig) $8721fac3cbf33e27$var$updateWagmiConfig(wagmiConfig);
    }
    $8721fac3cbf33e27$var$disconnectWallet$.next(label);
    $8721fac3cbf33e27$var$removeWallet(label);
    const lastConnectedWallets = $8721fac3cbf33e27$var$getLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
    if (lastConnectedWallets) try {
        const labels = JSON.parse(lastConnectedWallets);
        if (Array.isArray(labels) && labels.indexOf(label) >= 0) $8721fac3cbf33e27$var$setLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(labels.filter((walletLabel)=>walletLabel !== label)));
        if (typeof labels === 'string' && labels === label) $8721fac3cbf33e27$var$delLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
    } catch (e) {
        console.error(`There was an error disconnecting the last connected wallet from localStorage - Error: ${e}`);
    }
    return $8721fac3cbf33e27$export$6559d589eb85fbb6.get().wallets;
}
async function $8721fac3cbf33e27$var$updateBalances(addresses) {
    const { wallets: wallets, chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    const updatedWallets = await Promise.all(wallets.map(async (wallet)=>{
        const chain = chains.find(({ id: id })=>id === wallet.chains[0].id);
        if (!chain) return;
        const updatedAccounts = await Promise.all(wallet.accounts.map(async (account)=>{
            const secondaryTokens = await $8721fac3cbf33e27$var$updateSecondaryTokens(account.address, chain);
            // if no provided addresses, we want to update all balances
            // otherwise check if address is in addresses array
            if (!addresses || addresses.some((address)=>address.toLowerCase() === account.address.toLowerCase())) {
                const updatedBalance = await $8721fac3cbf33e27$var$getBalance(account.address, chain);
                return Object.assign(Object.assign({}, account), {
                    balance: updatedBalance,
                    secondaryTokens: secondaryTokens
                });
            }
            return Object.assign(Object.assign({}, account), {
                secondaryTokens: secondaryTokens
            });
        }));
        return Object.assign(Object.assign({}, wallet), {
            accounts: updatedAccounts
        });
    }));
    $8721fac3cbf33e27$var$updateAllWallets(updatedWallets);
}

const $8721fac3cbf33e27$var$updateSecondaryTokens = async (accountAddress, chain)=>{
    if (!chain) return [];
    const chainRPC = chain.rpcUrl;
    if (!chain.secondaryTokens || !chain.secondaryTokens.length || !chainRPC) return [];
    const tokenBalances = await Promise.all(chain.secondaryTokens.map(async (token)=>{
        try {
            const { createPublicClient: createPublicClient, http: http } = await (parcelRequire("hn1oL"));
            const viemChain = await (0, $6hARo.chainIdToViemImport)(chain);
            const client = createPublicClient({
                chain: viemChain,
                transport: http(chain.providerConnectionInfo && chain.providerConnectionInfo.url ? chain.providerConnectionInfo.url : chainRPC)
            });
            const viemTokenInterface = {
                abi: [
                    {
                        inputs: [
                            {
                                name: 'owner',
                                type: 'address'
                            }
                        ],
                        name: 'balanceOf',
                        outputs: [
                            {
                                name: '',
                                type: 'uint256'
                            }
                        ],
                        stateMutability: 'view',
                        type: 'function'
                    },
                    {
                        inputs: [],
                        name: 'symbol',
                        outputs: [
                            {
                                name: '',
                                type: 'string'
                            }
                        ],
                        stateMutability: 'view',
                        type: 'function'
                    }
                ],
                address: token.address
            };
            const supplyProm = client.readContract(Object.assign(Object.assign({}, viemTokenInterface), {
                functionName: 'balanceOf',
                args: [
                    accountAddress
                ]
            })) || '';
            const tokenProm = client.readContract(Object.assign(Object.assign({}, viemTokenInterface), {
                functionName: 'symbol',
                args: []
            })) || '';
            const [tokenSupply, tokenName] = await Promise.all([
                supplyProm,
                tokenProm
            ]);
            return {
                name: tokenName,
                balance: (0, $6hARo.weiToEth)(tokenSupply.toString()),
                icon: token.icon
            };
        } catch (error) {
            console.error(`There was an error fetching balance and/or symbol 
          for token contract: ${token.address} - ${error}`);
        }
    }));
    return tokenBalances;
};
const $8721fac3cbf33e27$var$viemProviders = {};

async function $8721fac3cbf33e27$var$getProvider(chain) {
    if (!chain) return null;
    if (!$8721fac3cbf33e27$var$viemProviders[chain.rpcUrl]) {
        const viemChain = await $8721fac3cbf33e27$var$chainIdToViemENSImport(chain.id);
        if (!viemChain) return null;
        const { createPublicClient: createPublicClient, http: http } = await (parcelRequire("hn1oL"));
        const publicProvider = createPublicClient({
            chain: viemChain,
            transport: http()
        });
        $8721fac3cbf33e27$var$viemProviders[chain.rpcUrl] = publicProvider;
    }
    return $8721fac3cbf33e27$var$viemProviders[chain.rpcUrl];
}
function $8721fac3cbf33e27$var$requestAccounts(provider) {
    const args = {
        method: 'eth_requestAccounts'
    };
    return provider.request(args);
}
function $8721fac3cbf33e27$export$3a1a48c8f6ef640e(provider) {
    const args = {
        method: 'eth_selectAccounts'
    };
    return provider.request(args);
}
function $8721fac3cbf33e27$var$getChainId(provider) {
    return provider.request({
        method: 'eth_chainId'
    });
}
function $8721fac3cbf33e27$var$listenAccountsChanged(args) {
    const { provider: provider, disconnected$: disconnected$ } = args;
    const addHandler = (handler)=>{
        provider.on('accountsChanged', handler);
    };
    const removeHandler = (handler)=>{
        provider.removeListener('accountsChanged', handler);
    };
    return (0, $62g8m.fromEventPattern)(addHandler, removeHandler).pipe((0, $gybEh.takeUntil)(disconnected$));
}
function $8721fac3cbf33e27$var$listenChainChanged(args) {
    const { provider: provider, disconnected$: disconnected$ } = args;
    const addHandler = (handler)=>{
        provider.on('chainChanged', handler);
    };
    const removeHandler = (handler)=>{
        provider.removeListener('chainChanged', handler);
    };
    return (0, $62g8m.fromEventPattern)(addHandler, removeHandler).pipe((0, $gybEh.takeUntil)(disconnected$));
}
function $8721fac3cbf33e27$var$trackWallet(provider, label) {
    const disconnected$ = $8721fac3cbf33e27$var$disconnectWallet$.pipe((0, $9vj9x.filter)((wallet)=>wallet === label), (0, $kgoiB.take)(1));
    const accountsChanged$ = $8721fac3cbf33e27$var$listenAccountsChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, $b2hmj.share)());
    // when account changed, set it to first account and subscribe to events
    accountsChanged$.subscribe(async ([address])=>{
        // sync accounts with internal state
        // in the case of an account has been manually disconnected
        try {
            await $8721fac3cbf33e27$var$syncWalletConnectedAccounts(label);
        } catch (error) {
            console.warn('Web3Onboard: Error whilst trying to sync connected accounts:', error);
        }
        // no address, then no account connected, so disconnect wallet
        // this could happen if user locks wallet,
        // or if disconnects app from wallet
        if (!address) {
            $8721fac3cbf33e27$export$56c0d5a1e737357d({
                label: label
            });
            return;
        }
        const { wallets: wallets } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
        const wallet = wallets.find((wallet)=>wallet.label === label);
        const accounts = wallet ? wallet.accounts : [];
        const [[existingAccount], restAccounts] = (0, (/*@__PURE__*/$parcel$interopDefault($dHSHZ)))(accounts, (account)=>account.address === address);
        // update accounts without ens/uns and balance first
        $8721fac3cbf33e27$var$updateWallet(label, {
            accounts: [
                existingAccount || {
                    address: address,
                    ens: null,
                    uns: null,
                    balance: null
                },
                ...restAccounts
            ]
        });
    });
    // also when accounts change, update Balance and ENS/UNS
    accountsChanged$.pipe((0, $gltW7.switchMap)(async ([address])=>{
        if (!address) return;
        const { wallets: wallets, chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
        const primaryWallet = wallets.find((wallet)=>wallet.label === label);
        if (!primaryWallet) return; // Add null check for primaryWallet
        const { chains: walletChains, accounts: accounts } = primaryWallet;
        const [connectedWalletChain] = walletChains;
        const chain = chains.find(({ namespace: namespace, id: id })=>namespace === 'evm' && id === connectedWalletChain.id);
        if (!chain) return;
        const balanceProm = $8721fac3cbf33e27$var$getBalance(address, chain);
        const secondaryTokenBal = $8721fac3cbf33e27$var$updateSecondaryTokens(address, chain);
        const account = accounts.find((account)=>account.address === address);
        const ensChain = chains.find(({ id: id })=>id === $8721fac3cbf33e27$var$validEnsChain(connectedWalletChain.id));
        const ensProm = account && account.ens ? Promise.resolve(account.ens) : ensChain ? $8721fac3cbf33e27$var$getEns(address, ensChain) : Promise.resolve(null);
        const unsProm = account && account.uns ? Promise.resolve(account.uns) : ensChain ? $8721fac3cbf33e27$var$getUns(address, ensChain) : Promise.resolve(null);
        return Promise.all([
            Promise.resolve(address),
            balanceProm,
            ensProm,
            unsProm,
            secondaryTokenBal
        ]);
    })).subscribe((res)=>{
        if (!res) return;
        const [address, balance, ens, uns, secondaryTokens] = res;
        $8721fac3cbf33e27$var$updateAccount(label, address, {
            balance: balance,
            ens: ens,
            uns: uns,
            secondaryTokens: secondaryTokens
        });
    });
    const chainChanged$ = $8721fac3cbf33e27$var$listenChainChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, $b2hmj.share)());
    // Update chain on wallet when chainId changed
    chainChanged$.subscribe(async (chainId)=>{
        const { wallets: wallets } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
        const wallet = wallets.find((wallet)=>wallet.label === label);
        if (!wallet) return; // Add null check for wallet
        const { chains: chains, accounts: accounts } = wallet;
        const [connectedWalletChain] = chains;
        if (!(0, $6bixs.isHex)(chainId)) chainId = (0, $lOW8k.toHex)(chainId);
        if (chainId === connectedWalletChain.id) return;
        const resetAccounts = accounts.map(({ address: address })=>({
                address: address,
                ens: null,
                uns: null,
                balance: null
            }));
        $8721fac3cbf33e27$var$updateWallet(label, {
            chains: [
                {
                    namespace: 'evm',
                    id: chainId
                }
            ],
            accounts: resetAccounts
        });
    });
    // when chain changes get ens/uns and balance for each account for wallet
    chainChanged$.pipe((0, $gltW7.switchMap)(async (chainId)=>{
        const { wallets: wallets, chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
        const primaryWallet = wallets.find((wallet)=>wallet.label === label);
        const accounts = (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.accounts) || [];
        if (!(0, $6bixs.isHex)(chainId)) chainId = (0, $lOW8k.toHex)(chainId);
        const chain = chains.find(({ namespace: namespace, id: id })=>namespace === 'evm' && id === chainId);
        if (!chain) return Promise.resolve(null);
        return Promise.all(accounts.map(async ({ address: address })=>{
            const balanceProm = $8721fac3cbf33e27$var$getBalance(address, chain);
            const secondaryTokenBal = $8721fac3cbf33e27$var$updateSecondaryTokens(address, chain);
            const ensChain = chains.find(({ id: id })=>id === $8721fac3cbf33e27$var$validEnsChain(chainId));
            const ensProm = ensChain ? $8721fac3cbf33e27$var$getEns(address, ensChain) : Promise.resolve(null);
            const unsProm = ensChain ? $8721fac3cbf33e27$var$getUns(address, ensChain) : Promise.resolve(null);
            const [balance, ens, uns, secondaryTokens] = await Promise.all([
                balanceProm,
                ensProm,
                unsProm,
                secondaryTokenBal
            ]);
            return {
                address: address,
                balance: balance,
                ens: ens,
                uns: uns,
                secondaryTokens: secondaryTokens
            };
        }));
    })).subscribe((updatedAccounts)=>{
        updatedAccounts && $8721fac3cbf33e27$var$updateWallet(label, {
            accounts: updatedAccounts
        });
    });
    disconnected$.subscribe(()=>{
        provider.disconnect && provider.disconnect();
    });
}

async function $8721fac3cbf33e27$var$getEns(address, chain) {
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!chain) return null;
    const provider = await $8721fac3cbf33e27$var$getProvider(chain);
    if (!provider) return null;
    try {
        const name = await provider.getEnsName({
            address: address
        });
        let ens = null;
        if (name) {
            const { labelhash: labelhash, normalize: normalize } = await (parcelRequire("7R2Xu")).then(function(n) {
                return n.i;
            });
            const normalizedName = normalize(name);
            const ensResolver = await provider.getEnsResolver({
                name: normalizedName
            });
            const avatar = await provider.getEnsAvatar({
                name: normalizedName
            });
            const contentHash = labelhash(normalizedName);
            const getText = async (key)=>{
                return await provider.getEnsText({
                    name: name,
                    key: key
                });
            };
            ens = {
                name: name,
                avatar: avatar,
                contentHash: contentHash,
                ensResolver: ensResolver,
                getText: getText
            };
        }
        return ens;
    } catch (error) {
        console.error(error);
        return null;
    }
}
async function $8721fac3cbf33e27$var$getUns(address, chain) {
    const { unstoppableResolution: unstoppableResolution } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    // check if address is valid ETH address before attempting to resolve
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!unstoppableResolution || !(0, $6hARo.isAddress)(address) || !chain) return null;
    try {
        return await unstoppableResolution(address);
    } catch (error) {
        console.error(error);
        return null;
    }
}
async function $8721fac3cbf33e27$var$getBalance(address, chain) {
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!chain) return null;
    const { wallets: wallets } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    try {
        const wallet = wallets.find((wallet)=>!!wallet.provider);
        if (!wallet) return null;
        const provider = wallet.provider;
        const balanceHex = await provider.request({
            method: 'eth_getBalance',
            params: [
                address,
                'latest'
            ]
        });
        return balanceHex ? {
            [chain.token || 'eth']: (0, $6hARo.weiHexToEth)(balanceHex)
        } : null;
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $8721fac3cbf33e27$var$switchChain(provider, chainId) {
    return provider.request({
        method: 'wallet_switchEthereumChain',
        params: [
            {
                chainId: chainId
            }
        ]
    });
}
function $8721fac3cbf33e27$var$addNewChain(provider, chain) {
    return provider.request({
        method: 'wallet_addEthereumChain',
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [
                    chain.publicRpcUrl || chain.rpcUrl
                ],
                blockExplorerUrls: chain.blockExplorerUrl ? [
                    chain.blockExplorerUrl
                ] : null
            }
        ]
    });
}
function $8721fac3cbf33e27$export$ee7c8ad385a60b7b(provider, chain, rpcUrl) {
    return provider.request({
        method: 'wallet_addEthereumChain',
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [
                    rpcUrl
                ],
                blockExplorerUrls: chain.blockExplorerUrl ? [
                    chain.blockExplorerUrl
                ] : undefined
            }
        ]
    });
}
async function $8721fac3cbf33e27$var$getPermissions(provider) {
    try {
        const permissions = await provider.request({
            method: 'wallet_getPermissions'
        });
        return Array.isArray(permissions) ? permissions : [];
    } catch (error) {
        return [];
    }
}
async function $8721fac3cbf33e27$var$syncWalletConnectedAccounts(label) {
    const wallet = $8721fac3cbf33e27$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
    if (!wallet) return;
    const permissions = await $8721fac3cbf33e27$var$getPermissions(wallet.provider);
    const accountsPermissions = permissions.find(({ parentCapability: parentCapability })=>parentCapability === 'eth_accounts');
    if (accountsPermissions) {
        const { value: connectedAccounts } = accountsPermissions.caveats.find(({ type: type })=>type === 'restrictReturnedAccounts') || {
            value: null
        };
        if (connectedAccounts) {
            const syncedAccounts = wallet.accounts.filter(({ address: address })=>connectedAccounts.includes(address));
            $8721fac3cbf33e27$var$updateWallet(wallet.label, Object.assign(Object.assign({}, wallet), {
                accounts: syncedAccounts
            }));
        }
    }
}
const $8721fac3cbf33e27$var$addOrSwitchChain = async (provider, chain)=>{
    try {
        const { id: id } = chain;
        await $8721fac3cbf33e27$var$addNewChain(provider, chain);
        await $8721fac3cbf33e27$var$switchChain(provider, id);
        return id;
    } catch (error) {
        return undefined;
    }
};
const $8721fac3cbf33e27$var$wagmiProviderMethods = ()=>({
        addOrSwitchChain: $8721fac3cbf33e27$var$addOrSwitchChain,
        getChainId: $8721fac3cbf33e27$var$getChainId,
        requestAccounts: $8721fac3cbf33e27$var$requestAccounts,
        switchChain: $8721fac3cbf33e27$var$switchChain
    });
async function $8721fac3cbf33e27$export$2d1720544b23b823(options) {
    const error = $8721fac3cbf33e27$var$validateSetChainOptions(options);
    if (error) throw error;
    const { wallets: wallets, chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    const { chainId: chainId, chainNamespace: chainNamespace = 'evm', wallet: walletToSet, rpcUrl: rpcUrl, label: label, token: token } = options;
    const chainIdHex = $8721fac3cbf33e27$export$d24c54395ce0c509(chainId);
    // validate that chainId has been added to chains
    const chain = chains.find(({ namespace: namespace, id: id })=>namespace === chainNamespace && id.toLowerCase() === chainIdHex.toLowerCase());
    if (!chain) throw new Error(`Chain with chainId: ${chainId} and chainNamespace: ${chainNamespace} has not been set and must be added when Onboard is initialized.`);
    const wallet = walletToSet ? wallets.find(({ label: label })=>label === walletToSet) : wallets[0];
    // validate a wallet is connected
    if (!wallet) throw new Error(walletToSet ? `Wallet with label ${walletToSet} is not connected` : 'A wallet must be connected before a chain can be set');
    const [walletConnectedChain] = wallet.chains;
    // check if wallet is already connected to chainId
    if (walletConnectedChain.namespace === chainNamespace && walletConnectedChain.id === chainIdHex) return true;
    try {
        await $8721fac3cbf33e27$var$switchChain(wallet.provider, chainIdHex);
        return true;
    } catch (error) {
        const { code: code } = error;
        const switchChainModalClosed$ = $8721fac3cbf33e27$var$switchChainModal$.pipe((0, $9vj9x.filter)((x)=>x === null), (0, $jfdoI.map)(()=>false));
        if (code === (0, $bKBH7.ProviderRpcErrorCode).CHAIN_NOT_ADDED || code === (0, $bKBH7.ProviderRpcErrorCode).UNRECOGNIZED_CHAIN_ID) {
            // chain has not been added to wallet
            if (rpcUrl || label || token) {
                if (rpcUrl) chain.rpcUrl = rpcUrl;
                if (label) chain.label = label;
                if (token) chain.token = token;
                $8721fac3cbf33e27$var$updateChain(chain);
            }
            // add chain to wallet
            return $8721fac3cbf33e27$var$chainNotInWallet(wallet, chain, switchChainModalClosed$, chainIdHex);
        }
        if (code === (0, $bKBH7.ProviderRpcErrorCode).UNSUPPORTED_METHOD) {
            // method not supported
            $8721fac3cbf33e27$var$switchChainModal$.next({
                chain: chain
            });
            return (0, $lqWQ2.firstValueFrom)(switchChainModalClosed$);
        }
    }
    return false;
}
const $8721fac3cbf33e27$var$chainNotInWallet = async (wallet, chain, switchChainModalClosed$, chainIdHex)=>{
    try {
        await $8721fac3cbf33e27$var$addNewChain(wallet.provider, chain);
        await $8721fac3cbf33e27$var$switchChain(wallet.provider, chainIdHex);
        return true;
    } catch (error) {
        const { code: code } = error;
        if (code === (0, $bKBH7.ProviderRpcErrorCode).ACCOUNT_ACCESS_REJECTED) // add new chain rejected by user
        return false;
        // display notification to user to switch chain
        $8721fac3cbf33e27$var$switchChainModal$.next({
            chain: chain
        });
        return (0, $lqWQ2.firstValueFrom)(switchChainModalClosed$);
    }
};
var $8721fac3cbf33e27$var$connect = {
    selectingWallet: {
        header: "Available Wallets",
        sidebar: {
            heading: "",
            subheading: "Connect your wallet",
            paragraph: "Connecting your wallet is like \u201Clogging in\u201D to Web3. Select your wallet from the options to get started.",
            IDontHaveAWallet: "I don't have a wallet"
        },
        recommendedWalletsPart1: "{app} only supports",
        recommendedWalletsPart2: "on this platform. Please use or install one of the supported wallets to continue",
        installWallet: "You do not have any wallets installed that {app} supports, please use a supported wallet",
        agreement: {
            agree: "I agree to the",
            terms: "Terms & Conditions",
            and: "and",
            privacy: "Privacy Policy"
        },
        whyDontISeeMyWallet: "Why don't I see my wallet?",
        learnMore: "Click here to learn more"
    },
    connectingWallet: {
        header: "{connectionRejected, select, false {Connecting to {wallet}...} other {Connection Rejected}}",
        sidebar: {
            subheading: "Approve Connection",
            paragraph: "Please approve the connection in your wallet and authorize access to continue."
        },
        mainText: "Connecting...",
        paragraph: "Make sure to select all accounts that you want to grant access to.",
        previousConnection: "{wallet} already has a pending connection request, please open the {wallet} app to login and connect.",
        rejectedText: "Connection Rejected!",
        rejectedCTA: "Click here to try again",
        primaryButton: "Back to wallets"
    },
    connectedWallet: {
        header: "Connection Successful",
        sidebar: {
            subheading: "Connection Successful!",
            paragraph: "Your wallet is now connected to {app}"
        },
        mainText: "Connected",
        accountSelected: "Account Selected",
        availableWallet: "available wallet"
    }
};
var $8721fac3cbf33e27$var$modals = {
    actionRequired: {
        heading: "Action required in {wallet}",
        paragraph: "Please switch the active account in your wallet.",
        linkText: "Learn more.",
        buttonText: "Okay"
    },
    switchChain: {
        heading: "Switch Chain",
        paragraph1: "{app} requires that you switch your wallet to the {nextNetworkName} network to continue.",
        paragraph2: "*Some wallets may not support changing networks. If you can not change networks in your wallet you may consider switching to a different wallet."
    },
    confirmDisconnectAll: {
        heading: "Disconnect all Wallets",
        description: "Are you sure that you would like to disconnect all your wallets?",
        confirm: "Confirm",
        cancel: "Cancel"
    },
    confirmTransactionProtection: {
        heading: "Enable Transaction Protection",
        description: "Protect RPC endpoints hide your transaction from front-running and sandwich bots.",
        link: "Learn more",
        enable: "Enable",
        dismiss: "Dismiss"
    }
};
var $8721fac3cbf33e27$var$accountCenter = {
    connectAnotherWallet: "Connect another Wallet",
    disconnectAllWallets: "Disconnect all Wallets",
    currentNetwork: "Current Network",
    enableTransactionProtection: "Enable Transaction Protection",
    appInfo: "App Info",
    learnMore: "Learn More",
    gettingStartedGuide: "Getting Started Guide",
    smartContracts: "Smart Contract(s)",
    explore: "Explore",
    poweredBy: "powered by",
    addAccount: "Add Account",
    setPrimaryAccount: "Set Primary Account",
    disconnectWallet: "Disconnect Wallet",
    copyAddress: "Copy Wallet address"
};
var $8721fac3cbf33e27$var$notify = {
    transaction: {
        txRequest: "Your transaction is waiting for you to confirm",
        nsfFail: "You have insufficient funds for this transaction",
        txUnderpriced: "The gas price for your transaction is too low, try a higher gas price",
        txRepeat: "This could be a repeat transaction",
        txAwaitingApproval: "You have a previous transaction waiting for you to confirm",
        txConfirmReminder: "Please confirm your transaction to continue",
        txSendFail: "You rejected the transaction",
        txSent: "Your transaction has been sent to the network",
        txStallPending: "Your transaction has stalled before it was sent, please try again",
        txStuck: "Your transaction is stuck due to a nonce gap",
        txPool: "Your transaction has started",
        txStallConfirmed: "Your transaction has stalled and hasn't been confirmed",
        txSpeedUp: "Your transaction has been sped up",
        txCancel: "Your transaction is being canceled",
        txFailed: "Your transaction has failed",
        txConfirmed: "Your transaction has succeeded",
        txError: "Oops something went wrong, please try again",
        txReplaceError: "There was an error replacing your transaction, please try again"
    },
    watched: {
        txPool: "Your account is {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txSpeedUp: "Transaction for {formattedValue} {asset} {preposition} {counterpartyShortened} has been sped up",
        txCancel: "Transaction for {formattedValue} {asset} {preposition} {counterpartyShortened} has been canceled",
        txConfirmed: "Your account successfully {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txFailed: "Your account failed to {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txStuck: "Your transaction is stuck due to a nonce gap"
    },
    time: {
        minutes: "min",
        seconds: "sec"
    }
};
var $8721fac3cbf33e27$export$e7094788287c5e9b = {
    connect: $8721fac3cbf33e27$var$connect,
    modals: $8721fac3cbf33e27$var$modals,
    accountCenter: $8721fac3cbf33e27$var$accountCenter,
    notify: $8721fac3cbf33e27$var$notify
};
function $8721fac3cbf33e27$var$initialize(options) {
    if (options) {
        const { en: customizedEn } = options;
        const merged = (0, (/*@__PURE__*/$parcel$interopDefault($j9N2Z)))($8721fac3cbf33e27$export$e7094788287c5e9b, customizedEn || {});
        (0, $fQSUm.addMessages)('en', merged);
        const customLocales = Object.keys(options).filter((key)=>key !== 'en');
        // Sync register all customLocales
        customLocales.forEach((locale)=>{
            const dictionary = options[locale];
            dictionary && (0, $fQSUm.addMessages)(locale, dictionary);
        });
    } else (0, $fQSUm.addMessages)('en', $8721fac3cbf33e27$export$e7094788287c5e9b);
    (0, $fQSUm.init)({
        fallbackLocale: 'en',
        initialLocale: (0, $fQSUm.getLocaleFromNavigator)()
    });
}
var $8721fac3cbf33e27$var$closeIcon = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
  </svg>
`;
/* src/views/shared/CloseButton.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$i(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1ubf722", ".close-button.svelte-1ubf722.svelte-1ubf722{position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;height:2rem;width:2rem;border-radius:2rem;cursor:pointer;color:var(--onboard-close-button-color, inherit)}.close-button.svelte-1ubf722.svelte-1ubf722:hover::before{opacity:0.2}.close-button.svelte-1ubf722:hover .svg-box.svelte-1ubf722{opacity:1}.close-button.svelte-1ubf722.svelte-1ubf722::before{content:'';position:absolute;height:inherit;width:inherit;opacity:0.1;background:currentColor;transition:300ms ease-in-out opacity}.svg-box.svelte-1ubf722.svelte-1ubf722{position:absolute;height:1.5rem;width:1.5rem;opacity:0.6;transition:300ms ease-in-out opacity}");
}
function $8721fac3cbf33e27$var$create_fragment$i(ctx) {
    let div1;
    let div0;
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "svg-box svelte-1ubf722");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "close-button svelte-1ubf722");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            div0.innerHTML = $8721fac3cbf33e27$var$closeIcon;
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
        }
    };
}
class $8721fac3cbf33e27$var$CloseButton extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, null, $8721fac3cbf33e27$var$create_fragment$i, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {}, $8721fac3cbf33e27$var$add_css$i);
    }
}
function $8721fac3cbf33e27$export$306ddfe3a8403e2(t) {
    const f = t - 1.0;
    return f * f * f + 1.0;
}
function $8721fac3cbf33e27$export$7910e0436ed8d1de(t) {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
}
function $8721fac3cbf33e27$export$78acf4525d8a74c4(node, { delay: delay = 0, duration: duration = 400, easing: easing = $8721fac3cbf33e27$var$identity } = {}) {
    const o = +getComputedStyle(node).opacity;
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t)=>`opacity: ${t * o}`
    };
}
function $8721fac3cbf33e27$export$555508cbc6add439(node, { delay: delay = 0, duration: duration = 400, easing: easing = $8721fac3cbf33e27$export$306ddfe3a8403e2, x: x = 0, y: y = 0, opacity: opacity = 0 } = {}) {
    const style = getComputedStyle(node);
    const target_opacity = +style.opacity;
    const transform = style.transform === 'none' ? '' : style.transform;
    const od = target_opacity * (1 - opacity);
    const [xValue, xUnit] = $8721fac3cbf33e27$var$split_css_unit(x);
    const [yValue, yUnit] = $8721fac3cbf33e27$var$split_css_unit(y);
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t, u)=>`
			transform: ${transform} translate(${(1 - t) * xValue}${xUnit}, ${(1 - t) * yValue}${yUnit});
			opacity: ${target_opacity - od * u}`
    };
}
function $8721fac3cbf33e27$var$slide(node, { delay: delay = 0, duration: duration = 400, easing: easing = $8721fac3cbf33e27$export$306ddfe3a8403e2, axis: axis = 'y' } = {}) {
    const style = getComputedStyle(node);
    const opacity = +style.opacity;
    const primary_property = axis === 'y' ? 'height' : 'width';
    const primary_property_value = parseFloat(style[primary_property]);
    const secondary_properties = axis === 'y' ? [
        'top',
        'bottom'
    ] : [
        'left',
        'right'
    ];
    const capitalized_secondary_properties = secondary_properties.map((e)=>`${e[0].toUpperCase()}${e.slice(1)}`);
    const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
    const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
    const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
    const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
    const border_width_start_value = parseFloat(style[`border${capitalized_secondary_properties[0]}Width`]);
    const border_width_end_value = parseFloat(style[`border${capitalized_secondary_properties[1]}Width`]);
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t)=>'overflow: hidden;' + `opacity: ${Math.min(t * 20, 1) * opacity};` + `${primary_property}: ${t * primary_property_value}px;` + `padding-${secondary_properties[0]}: ${t * padding_start_value}px;` + `padding-${secondary_properties[1]}: ${t * padding_end_value}px;` + `margin-${secondary_properties[0]}: ${t * margin_start_value}px;` + `margin-${secondary_properties[1]}: ${t * margin_end_value}px;` + `border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;` + `border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;`
    };
}
/* src/views/shared/Modal.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$h(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-7ee2g7", "section.svelte-7ee2g7{top:0;left:0;pointer-events:none;z-index:var(--onboard-modal-z-index, var(--modal-z-index))}.background.svelte-7ee2g7{background:var(--onboard-modal-backdrop, var(--modal-backdrop));pointer-events:all}.full-screen-background.svelte-7ee2g7{width:100vw;height:100vh;height:100dvh}.max-height.svelte-7ee2g7{max-height:calc(100vh - 2rem)}.modal-position.svelte-7ee2g7{top:var(--onboard-modal-top, var(--modal-top));bottom:var(--onboard-modal-bottom, var(--modal-bottom));left:var(--onboard-modal-left, var(--modal-left));right:var(--onboard-modal-right, var(--modal-right))}.modal-overflow.svelte-7ee2g7{overflow:hidden}.modal-styling.svelte-7ee2g7{--border-radius:var(\n      --onboard-modal-border-radius,\n      var(--w3o-border-radius, 1rem)\n    );border-radius:var(--border-radius) var(--border-radius) 0 0;box-shadow:var(--onboard-modal-box-shadow, var(--box-shadow-0));max-width:100vw}.modal.svelte-7ee2g7{overflow-y:auto;background:var(--onboard-modal-background, white);color:var(--onboard-modal-color, initial)}.width-100.svelte-7ee2g7{width:100%}.modal-container-mobile.svelte-7ee2g7{bottom:0}@media all and (min-width: 768px){.modal-styling.svelte-7ee2g7{border-radius:var(--border-radius)}.modal-container-mobile.svelte-7ee2g7{bottom:unset;margin:1rem}.width-100.svelte-7ee2g7{width:unset}}");
}
function $8721fac3cbf33e27$var$create_fragment$h(ctx) {
    let section;
    let div4;
    let div3;
    let div2;
    let div1;
    let div0;
    let section_transition;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[3].default;
    const default_slot = $8721fac3cbf33e27$var$create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);
    return {
        c () {
            section = $8721fac3cbf33e27$export$35e795649ee09318("section");
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (default_slot) default_slot.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "modal relative svelte-7ee2g7");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "modal-overflow modal-styling relative flex justify-center svelte-7ee2g7");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", `${ctx[1] ? 'max-width: 100%;' : ''}`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "flex relative max-height svelte-7ee2g7");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "width-100", /*connectContainerEl*/ ctx[1]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "modal-container-mobile modal-position flex svelte-7ee2g7");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div3, "absolute", !/*connectContainerEl*/ ctx[1]);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div3, "width-100", /*connectContainerEl*/ ctx[1]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "background flex items-center justify-center relative svelte-7ee2g7");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div4, "full-screen-background", !/*connectContainerEl*/ ctx[1]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(section, "class", "svelte-7ee2g7");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(section, "fixed", !/*connectContainerEl*/ ctx[1]);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, section, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(section, div4);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            if (default_slot) default_slot.m(div0, null);
            current = true;
            if (!mounted) {
                dispose = [
                    $8721fac3cbf33e27$export$ffb5f4729a158638(div2, "click", $8721fac3cbf33e27$export$b4171a6734a65d42(/*click_handler*/ ctx[4])),
                    $8721fac3cbf33e27$export$ffb5f4729a158638(div4, "click", function() {
                        if ($8721fac3cbf33e27$export$dc98b0b04f4c7758(/*close*/ ctx[0])) /*close*/ ctx[0].apply(this, arguments);
                    })
                ];
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 4)) $8721fac3cbf33e27$var$update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[2], !current ? $8721fac3cbf33e27$var$get_all_dirty_from_scope(/*$$scope*/ ctx[2]) : $8721fac3cbf33e27$var$get_slot_changes(default_slot_template, /*$$scope*/ ctx[2], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(default_slot, local);
            $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>{
                if (!current) return;
                if (!section_transition) section_transition = $8721fac3cbf33e27$export$a9c996f45e5784d0(section, $8721fac3cbf33e27$export$78acf4525d8a74c4, {}, true);
                section_transition.run(1);
            });
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(default_slot, local);
            if (!section_transition) section_transition = $8721fac3cbf33e27$export$a9c996f45e5784d0(section, $8721fac3cbf33e27$export$78acf4525d8a74c4, {}, false);
            section_transition.run(0);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(section);
            if (default_slot) default_slot.d(detaching);
            if (detaching && section_transition) section_transition.end();
            mounted = false;
            $8721fac3cbf33e27$export$61196ced6d74a310(dispose);
        }
    };
}
function $8721fac3cbf33e27$var$instance$h($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const connectContainerEl = !!$8721fac3cbf33e27$export$c9170ad7d4cd7e57.containerElements.connectModal;
    const html = document.documentElement;
    $8721fac3cbf33e27$var$onMount(()=>{
        if (!connectContainerEl) {
            html.style.position = 'sticky';
            html.style.overflow = 'hidden';
        }
    });
    $8721fac3cbf33e27$export$ab83b03e4111b1d0(()=>{
        if (!connectContainerEl) {
            html.style.position = '';
            html.style.removeProperty('overflow');
        }
    });
    let { close: close } = $$props;
    function click_handler(event) {
        $8721fac3cbf33e27$export$f38c853ae54ed474.call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ('close' in $$props) $$invalidate(0, close = $$props.close);
        if ('$$scope' in $$props) $$invalidate(2, $$scope = $$props.$$scope);
    };
    return [
        close,
        connectContainerEl,
        $$scope,
        slots,
        click_handler
    ];
}
class $8721fac3cbf33e27$export$8743009a87fcb00f extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$h, $8721fac3cbf33e27$var$create_fragment$h, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            close: 0
        }, $8721fac3cbf33e27$var$add_css$h);
    }
}
/* src/views/connect/Agreement.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$g(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-tz7ru1", ".container.svelte-tz7ru1{padding:var(--onboard-spacing-4, var(--spacing-4));font-size:var(--onboard-font-size-6, var(--font-size-6));line-height:24px}input.svelte-tz7ru1{height:1rem;width:1rem;margin-right:0.5rem}");
}
// (43:0) {#if showTermsOfService}
function $8721fac3cbf33e27$var$create_if_block$a(ctx) {
    let div;
    let label;
    let input;
    let t0;
    let span;
    let t1_value = /*$_*/ ctx[1]('connect.selectingWallet.agreement.agree') + "";
    let t1;
    let t2;
    let t3_value = " ";
    let t3;
    let t4;
    let t5;
    let mounted;
    let dispose;
    let if_block0 = /*termsUrl*/ ctx[3] && $8721fac3cbf33e27$var$create_if_block_2$4(ctx);
    let if_block1 = /*privacyUrl*/ ctx[4] && $8721fac3cbf33e27$var$create_if_block_1$5(ctx);
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            label = $8721fac3cbf33e27$export$35e795649ee09318("label");
            input = $8721fac3cbf33e27$export$35e795649ee09318("input");
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            span = $8721fac3cbf33e27$export$35e795649ee09318("span");
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(t1_value);
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            t3 = $8721fac3cbf33e27$export$625550452a3fa3ec(t3_value);
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block0) if_block0.c();
            t5 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(input, "class", " svelte-tz7ru1");
            $8721fac3cbf33e27$export$342063e11d6c3cad(input, "type", "checkbox");
            $8721fac3cbf33e27$export$342063e11d6c3cad(label, "class", "flex");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "container flex items-center svelte-tz7ru1");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div, label);
            $8721fac3cbf33e27$export$953cecd6e717a553(label, input);
            input.checked = /*agreed*/ ctx[0];
            $8721fac3cbf33e27$export$953cecd6e717a553(label, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(label, span);
            $8721fac3cbf33e27$export$953cecd6e717a553(span, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(span, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(span, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(span, t4);
            if (if_block0) if_block0.m(span, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(span, t5);
            if (if_block1) if_block1.m(span, null);
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(input, "change", /*input_change_handler*/ ctx[6]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*agreed*/ 1) input.checked = /*agreed*/ ctx[0];
            if (dirty & /*$_*/ 2 && t1_value !== (t1_value = /*$_*/ ctx[1]('connect.selectingWallet.agreement.agree') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, t1_value);
            if (/*termsUrl*/ ctx[3]) if_block0.p(ctx, dirty);
            if (/*privacyUrl*/ ctx[4]) if_block1.p(ctx, dirty);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
// (50:8) {#if termsUrl}
function $8721fac3cbf33e27$var$create_if_block_2$4(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[1]('connect.selectingWallet.agreement.terms') + "";
    let t0;
    let t1_value = /*privacyUrl*/ (ctx[4] ? ' ' + /*$_*/ ctx[1]('connect.selectingWallet.agreement.and') + ' ' : '.') + "";
    let t1;
    return {
        c () {
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(t1_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", /*termsUrl*/ ctx[3]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, a, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t0);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 2 && t0_value !== (t0_value = /*$_*/ ctx[1]('connect.selectingWallet.agreement.terms') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$_*/ 2 && t1_value !== (t1_value = /*privacyUrl*/ (ctx[4] ? ' ' + /*$_*/ ctx[1]('connect.selectingWallet.agreement.and') + ' ' : '.') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, t1_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(a);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t1);
        }
    };
}
// (56:8) {#if privacyUrl}
function $8721fac3cbf33e27$var$create_if_block_1$5(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[1]('connect.selectingWallet.agreement.privacy') + "";
    let t0;
    let t1;
    return {
        c () {
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(".");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", /*privacyUrl*/ ctx[4]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, a, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t0);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 2 && t0_value !== (t0_value = /*$_*/ ctx[1]('connect.selectingWallet.agreement.privacy') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(a);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t1);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$g(ctx) {
    let if_block_anchor;
    let if_block = /*showTermsOfService*/ ctx[5] && $8721fac3cbf33e27$var$create_if_block$a(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, [dirty]) {
            if (/*showTermsOfService*/ ctx[5]) if_block.p(ctx, dirty);
        },
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
function $8721fac3cbf33e27$var$instance$g($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(1, $_ = $$value));
    let { agreed: agreed } = $$props;
    const { terms: termsAgreed, privacy: privacyAgreed, version: versionAgreed } = JSON.parse($8721fac3cbf33e27$var$getLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.TERMS_AGREEMENT) || '{}');
    const blankAgreement = {
        termsUrl: '',
        privacyUrl: '',
        version: ''
    };
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(7, $appMetadata$ = value));
    const { termsUrl: termsUrl, privacyUrl: privacyUrl, version: version } = $appMetadata$ && $appMetadata$.agreement || blankAgreement;
    const showTermsOfService = !!(termsUrl && !termsAgreed || privacyUrl && !privacyAgreed || version && version !== versionAgreed);
    agreed = !showTermsOfService;
    function input_change_handler() {
        agreed = this.checked;
        $$invalidate(0, agreed);
    }
    $$self.$$set = ($$props)=>{
        if ('agreed' in $$props) $$invalidate(0, agreed = $$props.agreed);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*agreed*/ 1) {
            if (agreed) $8721fac3cbf33e27$var$setLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.TERMS_AGREEMENT, JSON.stringify({
                version: version,
                terms: !!termsUrl,
                privacy: !!privacyUrl
            }));
            else if (agreed === false) $8721fac3cbf33e27$var$delLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.TERMS_AGREEMENT);
        }
    };
    return [
        agreed,
        $_,
        appMetadata$,
        termsUrl,
        privacyUrl,
        showTermsOfService,
        input_change_handler
    ];
}
class $8721fac3cbf33e27$var$Agreement extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$g, $8721fac3cbf33e27$var$create_fragment$g, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            agreed: 0
        }, $8721fac3cbf33e27$var$add_css$g);
    }
}
/* src/views/shared/PendingStatusIcon.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$f(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-2btye1", ".icon.svelte-2btye1{color:var(--onboard-white, var(--white));border-radius:50px;bottom:-0.25rem;right:-0.25rem}.yellow.svelte-2btye1{background:var(--onboard-warning-500, var(--warning-500))}");
}
function $8721fac3cbf33e27$var$create_fragment$f(ctx) {
    let div;
    let div_class_value;
    let div_style_value;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", div_class_value = "" + ($8721fac3cbf33e27$export$882b5998b3b9117c(`${ctx[2]} icon flex absolute`) + " svelte-2btye1"));
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 6}px;`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "yellow", /*color*/ ctx[1] === 'yellow');
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $8721fac3cbf33e27$var$pendingIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*className*/ 4 && div_class_value !== (div_class_value = "" + ($8721fac3cbf33e27$export$882b5998b3b9117c(`${ctx[2]} icon flex absolute`) + " svelte-2btye1"))) $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", div_class_value);
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 6}px;`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value);
            if (dirty & /*className, color*/ 6) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "yellow", /*color*/ ctx[1] === 'yellow');
        },
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
        }
    };
}
function $8721fac3cbf33e27$var$instance$f($$self, $$props, $$invalidate) {
    let { size: size } = $$props;
    let { color: color = 'yellow' } = $$props;
    let { class: className = 'test' } = $$props;
    $$self.$$set = ($$props)=>{
        if ('size' in $$props) $$invalidate(0, size = $$props.size);
        if ('color' in $$props) $$invalidate(1, color = $$props.color);
        if ('class' in $$props) $$invalidate(2, className = $$props.class);
    };
    return [
        size,
        color,
        className
    ];
}
class $8721fac3cbf33e27$var$PendingStatusIcon extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$f, $8721fac3cbf33e27$var$create_fragment$f, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            size: 0,
            color: 1,
            class: 2
        }, $8721fac3cbf33e27$var$add_css$f);
    }
}
/* src/views/shared/SuccessStatusIcon.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$e(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1bikw7k", ".icon.svelte-1bikw7k{color:var(--onboard-white, var(--white));border-radius:50px}.green.svelte-1bikw7k{background:var(--onboard-success-600, var(--success-600))}.blue.svelte-1bikw7k{background:var(--onboard-primary-1, var(--primary-1))}");
}
function $8721fac3cbf33e27$var$create_fragment$e(ctx) {
    let div;
    let div_style_value;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "icon flex svelte-1bikw7k");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 5}px;`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "green", /*color*/ ctx[1] === 'green');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "blue", /*color*/ ctx[1] === 'blue');
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $8721fac3cbf33e27$var$successIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 5}px;`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value);
            if (dirty & /*color*/ 2) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "green", /*color*/ ctx[1] === 'green');
            if (dirty & /*color*/ 2) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "blue", /*color*/ ctx[1] === 'blue');
        },
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
        }
    };
}
function $8721fac3cbf33e27$var$instance$e($$self, $$props, $$invalidate) {
    let { size: size } = $$props;
    let { color: color = 'green' } = $$props;
    $$self.$$set = ($$props)=>{
        if ('size' in $$props) $$invalidate(0, size = $$props.size);
        if ('color' in $$props) $$invalidate(1, color = $$props.color);
    };
    return [
        size,
        color
    ];
}
class $8721fac3cbf33e27$export$db202ddc8be9136 extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$e, $8721fac3cbf33e27$var$create_fragment$e, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            size: 0,
            color: 1
        }, $8721fac3cbf33e27$var$add_css$e);
    }
}
/* src/views/shared/Spinner.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$d(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1le5672", ".loading-container.svelte-1le5672.svelte-1le5672{font-family:inherit;font-size:inherit;color:inherit}span.svelte-1le5672.svelte-1le5672{font-family:inherit;font-size:0.889em;margin-top:1rem}.loading.svelte-1le5672.svelte-1le5672{display:inline-block}.loading.svelte-1le5672 div.svelte-1le5672{font-size:inherit;display:block;position:absolute;border:3px solid;border-radius:50%;animation:svelte-1le5672-bn-loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;border-color:currentColor transparent transparent transparent}.loading.svelte-1le5672 .loading-first.svelte-1le5672{animation-delay:-0.45s}.loading.svelte-1le5672 .loading-second.svelte-1le5672{animation-delay:-0.3s}.loading.svelte-1le5672 .loading-third.svelte-1le5672{animation-delay:-0.15s}@keyframes svelte-1le5672-bn-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
// (63:2) {#if description}
function $8721fac3cbf33e27$var$create_if_block$9(ctx) {
    let span;
    let t;
    return {
        c () {
            span = $8721fac3cbf33e27$export$35e795649ee09318("span");
            t = $8721fac3cbf33e27$export$625550452a3fa3ec(/*description*/ ctx[0]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(span, "class", "svelte-1le5672");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, span, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(span, t);
        },
        p (ctx, dirty) {
            if (dirty & /*description*/ 1) $8721fac3cbf33e27$export$90a7f3efeed30595(t, /*description*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(span);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$d(ctx) {
    let div4;
    let div3;
    let div0;
    let div0_style_value;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let div2_style_value;
    let div3_style_value;
    let t2;
    let if_block = /*description*/ ctx[0] && $8721fac3cbf33e27$var$create_if_block$9(ctx);
    return {
        c () {
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "loading-first svelte-1le5672");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "style", div0_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "loading-second svelte-1le5672");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "loading-third svelte-1le5672");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "style", div2_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "loading relative svelte-1le5672");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "style", div3_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "loading-container flex flex-column justify-center items-center absolute svelte-1le5672");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div4, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, t2);
            if (if_block) if_block.m(div4, null);
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 2 && div0_style_value !== (div0_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "style", div0_style_value);
            if (dirty & /*size*/ 2 && div1_style_value !== (div1_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*size*/ 2 && div2_style_value !== (div2_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "style", div2_style_value);
            if (dirty & /*size*/ 2 && div3_style_value !== (div3_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (/*description*/ ctx[0]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $8721fac3cbf33e27$var$create_if_block$9(ctx);
                    if_block.c();
                    if_block.m(div4, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div4);
            if (if_block) if_block.d();
        }
    };
}
function $8721fac3cbf33e27$var$instance$d($$self, $$props, $$invalidate) {
    let { description: description = '' } = $$props;
    let { size: size = '2rem' } = $$props;
    $$self.$$set = ($$props)=>{
        if ('description' in $$props) $$invalidate(0, description = $$props.description);
        if ('size' in $$props) $$invalidate(1, size = $$props.size);
    };
    return [
        description,
        size
    ];
}
class $8721fac3cbf33e27$var$Spinner extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$d, $8721fac3cbf33e27$var$create_fragment$d, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            description: 0,
            size: 1
        }, $8721fac3cbf33e27$var$add_css$d);
    }
}
/* src/views/shared/WalletAppBadge.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$c(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-i129jl", ".icon.svelte-i129jl{height:100%}.border-custom.svelte-i129jl{border:1px solid var(--border-color)}.border-yellow.svelte-i129jl{border:1px solid var(--onboard-warning-500, var(--warning-500))}.border-gray.svelte-i129jl{border:1px solid var(--onboard-gray-400, var(--gray-400))}.border-green.svelte-i129jl{border:1px solid var(--onboard-success-500, var(--success-500))}.border-dark-green.svelte-i129jl{border:1px solid var(--onboard-success-700, var(--success-700))}.border-blue.svelte-i129jl{border:1px solid\n      var(\n        --onboard-wallet-app-icon-border-color,\n        var(--onboard-primary-300, var(--primary-300))\n      )}.border-dark-blue.svelte-i129jl{border:1px solid\n      var(\n        --onboard-wallet-app-icon-border-color,\n        var(--onboard-primary-600, var(--primary-600))\n      )}.border-transparent.svelte-i129jl{border:1px solid transparent}.border-black.svelte-i129jl{border:1px solid var(--onboard-gray-600, var(--gray-600))}.background-gray.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-gray,\n      var(--onboard-gray-500, var(--gray-500))\n    )}.background-light-gray.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-light-gray,\n      var(--onboard-gray-100, var(--gray-100))\n    )}.background-light-blue.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-light-blue,\n      var(--onboard-primary-100, var(--primary-100))\n    )}.background-green.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-green,\n      var(--onboard-success-100, var(--success-100))\n    )}.background-white.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-white,\n      var(--onboard-white, var(--white))\n    )}.background-transparent.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-transparent,\n      transparent\n    )}@keyframes svelte-i129jl-pulse{from{opacity:0}to{opacity:1}}.placeholder-icon.svelte-i129jl{width:100%;height:100%;background:var(--onboard-gray-100, var(--gray-100));border-radius:32px;animation:svelte-i129jl-pulse infinite 750ms alternate ease-in-out}.spinner-container.svelte-i129jl{color:var(--onboard-primary-300, var(--primary-300))}img.svelte-i129jl{max-width:100%;height:auto}.pending-status-icon{z-index:1;fill:white;box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1)}.status-icon-container.svelte-i129jl{right:-0.25rem;bottom:-0.25rem;position:absolute}");
}
const $8721fac3cbf33e27$var$get_status_slot_changes = (dirty)=>({});
const $8721fac3cbf33e27$var$get_status_slot_context = (ctx)=>({});
// (178:2) {:else}
function $8721fac3cbf33e27$var$create_else_block$4(ctx) {
    let await_block_anchor;
    let promise;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $8721fac3cbf33e27$var$create_pending_block$1,
        then: $8721fac3cbf33e27$var$create_then_block$1,
        catch: $8721fac3cbf33e27$var$create_catch_block$1,
        value: 13,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $8721fac3cbf33e27$export$71511d61b312f219(promise = /*icon*/ ctx[1], info);
    return {
        c () {
            await_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            info.ctx = ctx;
            if (dirty & /*icon*/ 2 && promise !== (promise = /*icon*/ ctx[1]) && $8721fac3cbf33e27$export$71511d61b312f219(promise, info)) ;
            else $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $8721fac3cbf33e27$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (174:2) {#if loading && windowWidth >= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block$8(ctx) {
    let div;
    let spinner;
    let current;
    spinner = new $8721fac3cbf33e27$var$Spinner({
        props: {
            size: "2rem"
        }
    });
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(spinner.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "spinner-container svelte-i129jl");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(spinner, div, null);
            current = true;
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(spinner.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(spinner.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(spinner);
        }
    };
}
// (1:0) <script lang="ts">import { fade }
function $8721fac3cbf33e27$var$create_catch_block$1(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (181:4) {:then iconLoaded}
function $8721fac3cbf33e27$var$create_then_block$1(ctx) {
    let div;
    let show_if;
    let div_intro;
    let t;
    let if_block1_anchor;
    let current;
    function select_block_type_1(ctx, dirty) {
        if (dirty & /*icon*/ 2) show_if = null;
        if (show_if == null) show_if = !!$8721fac3cbf33e27$export$34aec0b863436764(/*iconLoaded*/ ctx[13]);
        if (show_if) return $8721fac3cbf33e27$var$create_if_block_2$3;
        return $8721fac3cbf33e27$var$create_else_block_1$2;
    }
    let current_block_type = select_block_type_1(ctx, -1);
    let if_block0 = current_block_type(ctx);
    let if_block1 = /*loading*/ ctx[2] && /*windowWidth*/ ctx[9] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && $8721fac3cbf33e27$var$create_if_block_1$4();
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if_block0.c();
            t = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            if_block1_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "icon flex justify-center items-center svelte-i129jl");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            if_block0.m(div, null);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(div, null);
                }
            }
            if (/*loading*/ ctx[2] && /*windowWidth*/ ctx[9] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) {
                if (if_block1) {
                    if (dirty & /*loading, windowWidth*/ 516) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $8721fac3cbf33e27$var$create_if_block_1$4();
                    if_block1.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            if (local) {
                if (!div_intro) $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>{
                    div_intro = $8721fac3cbf33e27$export$e7c866399fa523f5(div, $8721fac3cbf33e27$export$78acf4525d8a74c4, {});
                    div_intro.start();
                });
            }
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            if_block0.d();
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block1_anchor);
        }
    };
}
// (186:8) {:else}
function $8721fac3cbf33e27$var$create_else_block_1$2(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $8721fac3cbf33e27$export$35e795649ee09318("img");
            if (!$8721fac3cbf33e27$export$3c2fa207a37baaea(img.src, img_src_value = /*iconLoaded*/ ctx[13])) $8721fac3cbf33e27$export$342063e11d6c3cad(img, "src", img_src_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(img, "alt", "logo");
            $8721fac3cbf33e27$export$342063e11d6c3cad(img, "class", "svelte-i129jl");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && !$8721fac3cbf33e27$export$3c2fa207a37baaea(img.src, img_src_value = /*iconLoaded*/ ctx[13])) $8721fac3cbf33e27$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(img);
        }
    };
}
// (183:8) {#if isSVG(iconLoaded)}
function $8721fac3cbf33e27$var$create_if_block_2$3(ctx) {
    let html_tag;
    let raw_value = /*iconLoaded*/ ctx[13] + "";
    let html_anchor;
    return {
        c () {
            html_tag = new $8721fac3cbf33e27$export$ce26c07117d59d6a(false);
            html_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && raw_value !== (raw_value = /*iconLoaded*/ ctx[13] + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (191:6) {#if loading && windowWidth <= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block_1$4(ctx) {
    let div;
    let pendingstatusicon;
    let current;
    pendingstatusicon = new $8721fac3cbf33e27$var$PendingStatusIcon({
        props: {
            class: "pending-status-icon",
            size: 20
        }
    });
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(pendingstatusicon.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "status-icon-container svelte-i129jl");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(pendingstatusicon, div, null);
            current = true;
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(pendingstatusicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(pendingstatusicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(pendingstatusicon);
        }
    };
}
// (179:17)        <div class="placeholder-icon" />     {:then iconLoaded}
function $8721fac3cbf33e27$var$create_pending_block$1(ctx) {
    let div;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "placeholder-icon svelte-i129jl");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$c(ctx) {
    let div;
    let current_block_type_index;
    let if_block;
    let t;
    let div_style_value;
    let current;
    let mounted;
    let dispose;
    $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[12]);
    const if_block_creators = [
        $8721fac3cbf33e27$var$create_if_block$8,
        $8721fac3cbf33e27$var$create_else_block$4
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*loading*/ ctx[2] && /*windowWidth*/ ctx[9] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    const status_slot_template = /*#slots*/ ctx[11].status;
    const status_slot = $8721fac3cbf33e27$var$create_slot(status_slot_template, ctx, /*$$scope*/ ctx[10], $8721fac3cbf33e27$var$get_status_slot_context);
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if_block.c();
            t = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (status_slot) status_slot.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "relative svelte-i129jl");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value = `${ctx[6] === 'custom' ? `background-color: ${ctx[7]}` : ''}; padding: ${ctx[3] - 1}px; width: ${ctx[0]}px; height: ${ctx[0]}px; border-radius: ${ctx[8]}px; color: ${ctx[4]};`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-custom", /*border*/ ctx[5] === 'custom');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-yellow", /*border*/ ctx[5] === 'yellow');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-gray", /*border*/ ctx[5] === 'gray');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-green", /*border*/ ctx[5] === 'green');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-dark-green", /*border*/ ctx[5] === 'darkGreen');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-blue", /*border*/ ctx[5] === 'blue');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-dark-blue", /*border*/ ctx[5] === 'darkBlue');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-transparent", /*border*/ ctx[5] === 'transparent');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-black", /*border*/ ctx[5] === 'black');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-gray", /*background*/ ctx[6] === 'gray');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-light-gray", /*background*/ ctx[6] === 'lightGray');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-light-blue", /*background*/ ctx[6] === 'lightBlue');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-green", /*background*/ ctx[6] === 'green');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-white", /*background*/ ctx[6] === 'white');
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-transparent", /*background*/ ctx[6] === 'transparent');
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            if_blocks[current_block_type_index].m(div, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div, t);
            if (status_slot) status_slot.m(div, null);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[12]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                if_block.m(div, t);
            }
            if (status_slot) {
                if (status_slot.p && (!current || dirty & /*$$scope*/ 1024)) $8721fac3cbf33e27$var$update_slot_base(status_slot, status_slot_template, ctx, /*$$scope*/ ctx[10], !current ? $8721fac3cbf33e27$var$get_all_dirty_from_scope(/*$$scope*/ ctx[10]) : $8721fac3cbf33e27$var$get_slot_changes(status_slot_template, /*$$scope*/ ctx[10], dirty, $8721fac3cbf33e27$var$get_status_slot_changes), $8721fac3cbf33e27$var$get_status_slot_context);
            }
            if (!current || dirty & /*background, customBackgroundColor, padding, size, radius, color*/ 473 && div_style_value !== (div_style_value = `${ctx[6] === 'custom' ? `background-color: ${ctx[7]}` : ''}; padding: ${ctx[3] - 1}px; width: ${ctx[0]}px; height: ${ctx[0]}px; border-radius: ${ctx[8]}px; color: ${ctx[4]};`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value);
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-custom", /*border*/ ctx[5] === 'custom');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-yellow", /*border*/ ctx[5] === 'yellow');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-gray", /*border*/ ctx[5] === 'gray');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-green", /*border*/ ctx[5] === 'green');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-dark-green", /*border*/ ctx[5] === 'darkGreen');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-blue", /*border*/ ctx[5] === 'blue');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-dark-blue", /*border*/ ctx[5] === 'darkBlue');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-transparent", /*border*/ ctx[5] === 'transparent');
            if (!current || dirty & /*border*/ 32) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "border-black", /*border*/ ctx[5] === 'black');
            if (!current || dirty & /*background*/ 64) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-gray", /*background*/ ctx[6] === 'gray');
            if (!current || dirty & /*background*/ 64) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-light-gray", /*background*/ ctx[6] === 'lightGray');
            if (!current || dirty & /*background*/ 64) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-light-blue", /*background*/ ctx[6] === 'lightBlue');
            if (!current || dirty & /*background*/ 64) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-green", /*background*/ ctx[6] === 'green');
            if (!current || dirty & /*background*/ 64) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-white", /*background*/ ctx[6] === 'white');
            if (!current || dirty & /*background*/ 64) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "background-transparent", /*background*/ ctx[6] === 'transparent');
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(status_slot, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            $8721fac3cbf33e27$export$ebd11618f299a286(status_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            if_blocks[current_block_type_index].d();
            if (status_slot) status_slot.d(detaching);
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$instance$c($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { size: size } = $$props;
    let { icon: icon } = $$props;
    let { loading: loading = false } = $$props;
    let { padding: padding = size / 6 } = $$props;
    let { color: color = 'black' } = $$props;
    let { border: border = 'transparent' } = $$props;
    let { background: background = 'transparent' } = $$props;
    let { customBackgroundColor: customBackgroundColor = '' } = $$props;
    let { radius: radius = 12 } = $$props;
    let windowWidth;
    function onwindowresize() {
        $$invalidate(9, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ('size' in $$props) $$invalidate(0, size = $$props.size);
        if ('icon' in $$props) $$invalidate(1, icon = $$props.icon);
        if ('loading' in $$props) $$invalidate(2, loading = $$props.loading);
        if ('padding' in $$props) $$invalidate(3, padding = $$props.padding);
        if ('color' in $$props) $$invalidate(4, color = $$props.color);
        if ('border' in $$props) $$invalidate(5, border = $$props.border);
        if ('background' in $$props) $$invalidate(6, background = $$props.background);
        if ('customBackgroundColor' in $$props) $$invalidate(7, customBackgroundColor = $$props.customBackgroundColor);
        if ('radius' in $$props) $$invalidate(8, radius = $$props.radius);
        if ('$$scope' in $$props) $$invalidate(10, $$scope = $$props.$$scope);
    };
    return [
        size,
        icon,
        loading,
        padding,
        color,
        border,
        background,
        customBackgroundColor,
        radius,
        windowWidth,
        $$scope,
        slots,
        onwindowresize
    ];
}
class $8721fac3cbf33e27$export$71cec2538cb2c617 extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$c, $8721fac3cbf33e27$var$create_fragment$c, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            size: 0,
            icon: 1,
            loading: 2,
            padding: 3,
            color: 4,
            border: 5,
            background: 6,
            customBackgroundColor: 7,
            radius: 8
        }, $8721fac3cbf33e27$var$add_css$c);
    }
}
/* src/views/shared/Warning.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$b(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-q2gson", ".container.svelte-q2gson{gap:1rem;padding:0.75rem;color:var(--onboard-warning-700, var(--warning-700));font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px;border:1px solid var(--onboard-warning-400, var(--warning-400));background:var(--onboard-warning-100, var(--warning-100));border-radius:12px}.icon.svelte-q2gson{color:var(--onboard-warning-700, var(--warning-700));width:1rem;height:1rem;flex:0 0 auto}");
}
function $8721fac3cbf33e27$var$create_fragment$b(ctx) {
    let div2;
    let div0;
    let t;
    let div1;
    let div2_intro;
    let current;
    const default_slot_template = /*#slots*/ ctx[1].default;
    const default_slot = $8721fac3cbf33e27$var$create_slot(default_slot_template, ctx, /*$$scope*/ ctx[0], null);
    return {
        c () {
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (default_slot) default_slot.c();
            t = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "icon svelte-q2gson");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "container flex justify-between svelte-q2gson");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div2, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div0);
            if (default_slot) default_slot.m(div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div1);
            div1.innerHTML = $8721fac3cbf33e27$var$infoIcon;
            current = true;
        },
        p (ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 1)) $8721fac3cbf33e27$var$update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[0], !current ? $8721fac3cbf33e27$var$get_all_dirty_from_scope(/*$$scope*/ ctx[0]) : $8721fac3cbf33e27$var$get_slot_changes(default_slot_template, /*$$scope*/ ctx[0], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(default_slot, local);
            if (local) {
                if (!div2_intro) $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>{
                    div2_intro = $8721fac3cbf33e27$export$e7c866399fa523f5(div2, $8721fac3cbf33e27$var$slide, {
                        delay: 50,
                        duration: 500
                    });
                    div2_intro.start();
                });
            }
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div2);
            if (default_slot) default_slot.d(detaching);
        }
    };
}
function $8721fac3cbf33e27$var$instance$b($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    $$self.$$set = ($$props)=>{
        if ('$$scope' in $$props) $$invalidate(0, $$scope = $$props.$$scope);
    };
    return [
        $$scope,
        slots
    ];
}
class $8721fac3cbf33e27$var$Warning extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$b, $8721fac3cbf33e27$var$create_fragment$b, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {}, $8721fac3cbf33e27$var$add_css$b);
    }
}
/* src/views/connect/ConnectedWallet.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$a(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1kfgpsl", ".container.svelte-1kfgpsl{padding:var(--onboard-spacing-4, var(--spacing-4));color:var(\n      --onboard-connect-accent-text-color,\n      var(--onboard-gray-700, var(--gray-700))\n    )}.connecting-container.svelte-1kfgpsl{padding:var(--onboard-spacing-4, var(--spacing-4));border-radius:var(--onboard-border-radius-1, var(--border-radius-1));background:var(--onboard-success-100, var(--success-100));border:1px solid var(--onboard-success-600, var(--success-600));width:100%}.text.svelte-1kfgpsl{right:var(--onboard-spacing-5, var(--spacing-5))}.tick.svelte-1kfgpsl{color:var(--onboard-success-700, var(--success-700))}");
}
function $8721fac3cbf33e27$var$create_fragment$a(ctx) {
    let div7;
    let div6;
    let div4;
    let div2;
    let walletappbadge0;
    let t0;
    let div0;
    let successstatusicon;
    let t1;
    let div1;
    let walletappbadge1;
    let t2;
    let div3;
    let t3_value = /*$_*/ ctx[2]('connect.connectedWallet.mainText', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectedWallet.mainText,
        values: {
            wallet: /*selectedWallet*/ ctx[0].label
        }
    }) + "";
    let t3;
    let t4;
    let div5;
    let current;
    walletappbadge0 = new $8721fac3cbf33e27$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            background: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon ? 'lightBlue' : 'lightGray',
            border: "darkGreen",
            icon: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon || $8721fac3cbf33e27$export$f787f51d84a910ad
        }
    });
    successstatusicon = new $8721fac3cbf33e27$export$db202ddc8be9136({
        props: {
            size: 17
        }
    });
    walletappbadge1 = new $8721fac3cbf33e27$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            border: "darkGreen",
            background: "white",
            icon: /*selectedWallet*/ ctx[0].icon
        }
    });
    return {
        c () {
            div7 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div6 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(walletappbadge0.$$.fragment);
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(successstatusicon.$$.fragment);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(walletappbadge1.$$.fragment);
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t3 = $8721fac3cbf33e27$export$625550452a3fa3ec(t3_value);
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div5 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "relative");
            $8721fac3cbf33e27$export$971d5caa766a69d7(div0, "right", "1rem");
            $8721fac3cbf33e27$export$971d5caa766a69d7(div0, "top", "4px");
            $8721fac3cbf33e27$export$971d5caa766a69d7(div0, "z-index", "1");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "relative");
            $8721fac3cbf33e27$export$971d5caa766a69d7(div1, "right", "1.75rem");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "flex justify-center items-end relative");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "text relative svelte-1kfgpsl");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "flex items-center");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div5, "class", "tick flex items-center svelte-1kfgpsl");
            $8721fac3cbf33e27$export$971d5caa766a69d7(div5, "width", "24px");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div6, "class", "connecting-container flex justify-between items-center svelte-1kfgpsl");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div7, "class", "container svelte-1kfgpsl");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div7, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div7, div6);
            $8721fac3cbf33e27$export$953cecd6e717a553(div6, div4);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div2);
            $8721fac3cbf33e27$export$9bb611d729802a56(walletappbadge0, div2, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div0);
            $8721fac3cbf33e27$export$9bb611d729802a56(successstatusicon, div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div1);
            $8721fac3cbf33e27$export$9bb611d729802a56(walletappbadge1, div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div6, t4);
            $8721fac3cbf33e27$export$953cecd6e717a553(div6, div5);
            div5.innerHTML = $8721fac3cbf33e27$var$successIcon;
            current = true;
        },
        p (ctx, [dirty]) {
            const walletappbadge0_changes = {};
            if (dirty & /*$appMetadata$*/ 2) walletappbadge0_changes.background = /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon ? 'lightBlue' : 'lightGray';
            if (dirty & /*$appMetadata$*/ 2) walletappbadge0_changes.icon = /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon || $8721fac3cbf33e27$export$f787f51d84a910ad;
            walletappbadge0.$set(walletappbadge0_changes);
            const walletappbadge1_changes = {};
            if (dirty & /*selectedWallet*/ 1) walletappbadge1_changes.icon = /*selectedWallet*/ ctx[0].icon;
            walletappbadge1.$set(walletappbadge1_changes);
            if ((!current || dirty & /*$_, selectedWallet*/ 5) && t3_value !== (t3_value = /*$_*/ ctx[2]('connect.connectedWallet.mainText', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectedWallet.mainText,
                values: {
                    wallet: /*selectedWallet*/ ctx[0].label
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t3, t3_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(walletappbadge0.$$.fragment, local);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(successstatusicon.$$.fragment, local);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(walletappbadge1.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(walletappbadge0.$$.fragment, local);
            $8721fac3cbf33e27$export$ebd11618f299a286(successstatusicon.$$.fragment, local);
            $8721fac3cbf33e27$export$ebd11618f299a286(walletappbadge1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div7);
            $8721fac3cbf33e27$export$3466f893ebf79586(walletappbadge0);
            $8721fac3cbf33e27$export$3466f893ebf79586(successstatusicon);
            $8721fac3cbf33e27$export$3466f893ebf79586(walletappbadge1);
        }
    };
}
function $8721fac3cbf33e27$var$instance$a($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(2, $_ = $$value));
    let { selectedWallet: selectedWallet } = $$props;
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(1, $appMetadata$ = value));
    $$self.$$set = ($$props)=>{
        if ('selectedWallet' in $$props) $$invalidate(0, selectedWallet = $$props.selectedWallet);
    };
    return [
        selectedWallet,
        $appMetadata$,
        $_,
        appMetadata$
    ];
}
class $8721fac3cbf33e27$var$ConnectedWallet extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$a, $8721fac3cbf33e27$var$create_fragment$a, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            selectedWallet: 0
        }, $8721fac3cbf33e27$var$add_css$a);
    }
}
/* src/views/connect/ConnectingWallet.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$9(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-j1ywa3", ".container.svelte-j1ywa3{padding:var(--onboard-spacing-4, var(--spacing-4))}.connecting-container.svelte-j1ywa3{width:100%;padding:var(--onboard-spacing-4, var(--spacing-4));transition:background-color 100ms ease-in-out,\n      border-color 100ms ease-in-out;border-radius:24px;background:var(--onboard-primary-100, var(--primary-100));border:1px solid;border-color:var(--onboard-primary-300, var(--primary-300));color:var(--onboard-gray-600, var(--gray-600))}.connecting-container.warning.svelte-j1ywa3{background:var(--onboard-warning-100, var(--warning-100));border-color:var(--onboard-warning-400, var(--warning-400))}.text.svelte-j1ywa3{line-height:16px;margin-bottom:var(--onboard-spacing-5, var(--spacing-5))}.text.text-rejected.svelte-j1ywa3{line-height:24px;margin-bottom:0}.subtext.svelte-j1ywa3{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px}.rejected-cta.svelte-j1ywa3{color:var(--onboard-primary-500, var(--primary-500))}.onboard-button-primary.svelte-j1ywa3{bottom:var(--onboard-spacing-3, var(--spacing-3))}.ml.svelte-j1ywa3{margin-left:var(--onboard-spacing-4, var(--spacing-4))}@media all and (max-width: 520px){.connecting-container.svelte-j1ywa3{border-radius:var(--onboard-border-radius-4, var(--border-radius-4))}.container.svelte-j1ywa3{padding-bottom:0}.wallet-badges.svelte-j1ywa3{display:none}.connecting-wallet-info.svelte-j1ywa3{margin:0}.onboard-button-primary.svelte-j1ywa3{display:none}}");
}
// (141:8) {:else}
function $8721fac3cbf33e27$var$create_else_block$3(ctx) {
    let div;
    let t_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[5] ? 'previousConnection' : 'paragraph'}`, {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.paragraph,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t = $8721fac3cbf33e27$export$625550452a3fa3ec(t_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "subtext svelte-j1ywa3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, previousConnectionRequest, selectedWallet*/ 162 && t_value !== (t_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[5] ? 'previousConnection' : 'paragraph'}`, {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.paragraph,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
        }
    };
}
// (134:8) {#if connectionRejected}
function $8721fac3cbf33e27$var$create_if_block$7(ctx) {
    let div;
    let t_value = /*$_*/ ctx[7]('connect.connectingWallet.rejectedCTA', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.rejectedCTA,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t;
    let mounted;
    let dispose;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t = $8721fac3cbf33e27$export$625550452a3fa3ec(t_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "rejected-cta pointer subtext svelte-j1ywa3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div, t);
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(div, "click", function() {
                    if ($8721fac3cbf33e27$export$dc98b0b04f4c7758(/*connectWallet*/ ctx[0])) /*connectWallet*/ ctx[0].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$_, selectedWallet*/ 130 && t_value !== (t_value = /*$_*/ ctx[7]('connect.connectingWallet.rejectedCTA', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.rejectedCTA,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$9(ctx) {
    let div6;
    let div5;
    let div4;
    let div1;
    let walletappbadge0;
    let t0;
    let div0;
    let walletappbadge1;
    let t1;
    let div3;
    let div2;
    let t2_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[4] ? 'rejectedText' : 'mainText'}`, {
        default: /*connectionRejected*/ ctx[4] ? $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.rejectedText : $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.mainText,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t2;
    let t3;
    let t4;
    let button;
    let t5_value = /*$_*/ ctx[7]('connect.connectingWallet.primaryButton', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.primaryButton
    }) + "";
    let t5;
    let current;
    let mounted;
    let dispose;
    walletappbadge0 = new $8721fac3cbf33e27$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            icon: /*$appMetadata$*/ ctx[6] && /*$appMetadata$*/ ctx[6].icon || $8721fac3cbf33e27$export$f787f51d84a910ad,
            border: /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? 'yellow' : 'blue',
            background: "lightGray"
        }
    });
    walletappbadge1 = new $8721fac3cbf33e27$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            border: /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? 'yellow' : 'blue',
            background: "white",
            icon: /*selectedWallet*/ ctx[1].icon
        }
    });
    function select_block_type(ctx, dirty) {
        if (/*connectionRejected*/ ctx[4]) return $8721fac3cbf33e27$var$create_if_block$7;
        return $8721fac3cbf33e27$var$create_else_block$3;
    }
    let current_block_type = select_block_type(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            div6 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div5 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(walletappbadge0.$$.fragment);
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(walletappbadge1.$$.fragment);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t2 = $8721fac3cbf33e27$export$625550452a3fa3ec(t2_value);
            t3 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if_block.c();
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            button = $8721fac3cbf33e27$export$35e795649ee09318("button");
            t5 = $8721fac3cbf33e27$export$625550452a3fa3ec(t5_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "relative");
            $8721fac3cbf33e27$export$971d5caa766a69d7(div0, "right", "0.5rem");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "flex justify-center relative wallet-badges svelte-j1ywa3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "text svelte-j1ywa3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "text-rejected", /*connectionRejected*/ ctx[4]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "flex flex-column justify-center ml connecting-wallet-info svelte-j1ywa3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "flex");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div5, "class", "connecting-container flex justify-between items-center svelte-j1ywa3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div5, "warning", /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(button, "class", "onboard-button-primary absolute svelte-j1ywa3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div6, "class", "container flex flex-column items-center svelte-j1ywa3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div6, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div6, div5);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div4);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div1);
            $8721fac3cbf33e27$export$9bb611d729802a56(walletappbadge0, div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            $8721fac3cbf33e27$export$9bb611d729802a56(walletappbadge1, div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, t3);
            if_block.m(div3, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div6, t4);
            $8721fac3cbf33e27$export$953cecd6e717a553(div6, button);
            $8721fac3cbf33e27$export$953cecd6e717a553(button, t5);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(button, "click", /*click_handler*/ ctx[9]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            const walletappbadge0_changes = {};
            if (dirty & /*$appMetadata$*/ 64) walletappbadge0_changes.icon = /*$appMetadata$*/ ctx[6] && /*$appMetadata$*/ ctx[6].icon || $8721fac3cbf33e27$export$f787f51d84a910ad;
            if (dirty & /*connectionRejected, previousConnectionRequest*/ 48) walletappbadge0_changes.border = /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? 'yellow' : 'blue';
            walletappbadge0.$set(walletappbadge0_changes);
            const walletappbadge1_changes = {};
            if (dirty & /*connectionRejected, previousConnectionRequest*/ 48) walletappbadge1_changes.border = /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? 'yellow' : 'blue';
            if (dirty & /*selectedWallet*/ 2) walletappbadge1_changes.icon = /*selectedWallet*/ ctx[1].icon;
            walletappbadge1.$set(walletappbadge1_changes);
            if ((!current || dirty & /*$_, connectionRejected, selectedWallet*/ 146) && t2_value !== (t2_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[4] ? 'rejectedText' : 'mainText'}`, {
                default: /*connectionRejected*/ ctx[4] ? $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.rejectedText : $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.mainText,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t2, t2_value);
            if (!current || dirty & /*connectionRejected*/ 16) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "text-rejected", /*connectionRejected*/ ctx[4]);
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(div3, null);
                }
            }
            if (!current || dirty & /*connectionRejected, previousConnectionRequest*/ 48) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div5, "warning", /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5]);
            if ((!current || dirty & /*$_*/ 128) && t5_value !== (t5_value = /*$_*/ ctx[7]('connect.connectingWallet.primaryButton', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.connectingWallet.primaryButton
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t5, t5_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(walletappbadge0.$$.fragment, local);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(walletappbadge1.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(walletappbadge0.$$.fragment, local);
            $8721fac3cbf33e27$export$ebd11618f299a286(walletappbadge1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div6);
            $8721fac3cbf33e27$export$3466f893ebf79586(walletappbadge0);
            $8721fac3cbf33e27$export$3466f893ebf79586(walletappbadge1);
            if_block.d();
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$instance$9($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(7, $_ = $$value));
    let { connectWallet: connectWallet } = $$props;
    let { selectedWallet: selectedWallet } = $$props;
    let { deselectWallet: deselectWallet } = $$props;
    let { setStep: setStep } = $$props;
    let { connectionRejected: connectionRejected } = $$props;
    let { previousConnectionRequest: previousConnectionRequest } = $$props;
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(6, $appMetadata$ = value));
    const click_handler = ()=>{
        deselectWallet(selectedWallet.label);
        setStep('selectingWallet');
    };
    $$self.$$set = ($$props)=>{
        if ('connectWallet' in $$props) $$invalidate(0, connectWallet = $$props.connectWallet);
        if ('selectedWallet' in $$props) $$invalidate(1, selectedWallet = $$props.selectedWallet);
        if ('deselectWallet' in $$props) $$invalidate(2, deselectWallet = $$props.deselectWallet);
        if ('setStep' in $$props) $$invalidate(3, setStep = $$props.setStep);
        if ('connectionRejected' in $$props) $$invalidate(4, connectionRejected = $$props.connectionRejected);
        if ('previousConnectionRequest' in $$props) $$invalidate(5, previousConnectionRequest = $$props.previousConnectionRequest);
    };
    return [
        connectWallet,
        selectedWallet,
        deselectWallet,
        setStep,
        connectionRejected,
        previousConnectionRequest,
        $appMetadata$,
        $_,
        appMetadata$,
        click_handler
    ];
}
class $8721fac3cbf33e27$var$ConnectingWallet extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$9, $8721fac3cbf33e27$var$create_fragment$9, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            connectWallet: 0,
            selectedWallet: 1,
            deselectWallet: 2,
            setStep: 3,
            connectionRejected: 4,
            previousConnectionRequest: 5
        }, $8721fac3cbf33e27$var$add_css$9);
    }
}
/* src/views/connect/InstallWallet.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$8(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1uy2ffh", ".outer-container.svelte-1uy2ffh{padding:var(--onboard-spacing-4, var(--spacing-4))}.link.svelte-1uy2ffh{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px;color:var(--onboard-primary-500, var(--primary-500));text-decoration:none}");
}
function $8721fac3cbf33e27$var$get_each_context$1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[3] = list[i].name;
    child_ctx[4] = list[i].url;
    child_ctx[6] = i;
    return child_ctx;
}
// (44:4) {:else}
function $8721fac3cbf33e27$var$create_else_block$2(ctx) {
    let t_value = /*$_*/ ctx[1]('connect.selectingWallet.installWallet', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.installWallet,
        values: {
            app: /*$appMetadata$*/ ctx[0].name || 'this app'
        }
    }) + "";
    let t;
    return {
        c () {
            t = $8721fac3cbf33e27$export$625550452a3fa3ec(t_value);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, $appMetadata$*/ 3 && t_value !== (t_value = /*$_*/ ctx[1]('connect.selectingWallet.installWallet', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.installWallet,
                values: {
                    app: /*$appMetadata$*/ ctx[0].name || 'this app'
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t);
        }
    };
}
// (25:4) {#if $appMetadata$.recommendedInjectedWallets}
function $8721fac3cbf33e27$var$create_if_block$6(ctx) {
    let t0_value = /*$_*/ ctx[1]('connect.selectingWallet.recommendedWalletsPart1', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart1,
        values: {
            app: /*$appMetadata$*/ ctx[0].name || 'This app'
        }
    }) + "";
    let t0;
    let t1;
    let t2;
    let t3_value = /*$_*/ ctx[1]('connect.selectingWallet.recommendedWalletsPart2', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart2
    }) + "";
    let t3;
    let each_value = /*$appMetadata$*/ ctx[0].recommendedInjectedWallets;
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $8721fac3cbf33e27$var$create_each_block$1($8721fac3cbf33e27$var$get_each_context$1(ctx, each_value, i));
    return {
        c () {
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            t3 = $8721fac3cbf33e27$export$625550452a3fa3ec(t3_value);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t0, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t1, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t2, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t3, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, $appMetadata$*/ 3 && t0_value !== (t0_value = /*$_*/ ctx[1]('connect.selectingWallet.recommendedWalletsPart1', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart1,
                values: {
                    app: /*$appMetadata$*/ ctx[0].name || 'This app'
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$appMetadata$*/ 1) {
                each_value = /*$appMetadata$*/ ctx[0].recommendedInjectedWallets;
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $8721fac3cbf33e27$var$get_each_context$1(ctx, each_value, i);
                    if (each_blocks[i]) each_blocks[i].p(child_ctx, dirty);
                    else {
                        each_blocks[i] = $8721fac3cbf33e27$var$create_each_block$1(child_ctx);
                        each_blocks[i].c();
                        each_blocks[i].m(t2.parentNode, t2);
                    }
                }
                for(; i < each_blocks.length; i += 1)each_blocks[i].d(1);
                each_blocks.length = each_value.length;
            }
            if (dirty & /*$_*/ 2 && t3_value !== (t3_value = /*$_*/ ctx[1]('connect.selectingWallet.recommendedWalletsPart2', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart2
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t3, t3_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t0);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t1);
            $8721fac3cbf33e27$export$ef35774e6d314e91(each_blocks, detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t2);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t3);
        }
    };
}
// (32:6) {#each $appMetadata$.recommendedInjectedWallets as { name, url }
function $8721fac3cbf33e27$var$create_each_block$1(ctx) {
    let a;
    let t0_value = /*name*/ ctx[3] + "";
    let t0;
    let t1_value = /*i*/ (ctx[6] < /*$appMetadata$*/ ctx[0].recommendedInjectedWallets.length - 1 ? ', ' : '') + "";
    let t1;
    let a_href_value;
    return {
        c () {
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(t1_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "class", "link pointer svelte-1uy2ffh");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", a_href_value = /*url*/ ctx[4]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, a, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t1);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 1 && t0_value !== (t0_value = /*name*/ ctx[3] + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$appMetadata$*/ 1 && t1_value !== (t1_value = /*i*/ (ctx[6] < /*$appMetadata$*/ ctx[0].recommendedInjectedWallets.length - 1 ? ', ' : '') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, t1_value);
            if (dirty & /*$appMetadata$*/ 1 && a_href_value !== (a_href_value = /*url*/ ctx[4])) $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", a_href_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(a);
        }
    };
}
// (24:2) <Warning>
function $8721fac3cbf33e27$var$create_default_slot$4(ctx) {
    let if_block_anchor;
    function select_block_type(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[0].recommendedInjectedWallets) return $8721fac3cbf33e27$var$create_if_block$6;
        return $8721fac3cbf33e27$var$create_else_block$2;
    }
    let current_block_type = select_block_type(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$8(ctx) {
    let div;
    let warning;
    let current;
    warning = new $8721fac3cbf33e27$var$Warning({
        props: {
            $$slots: {
                default: [
                    $8721fac3cbf33e27$var$create_default_slot$4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(warning.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "outer-container svelte-1uy2ffh");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            const warning_changes = {};
            if (dirty & /*$$scope, $_, $appMetadata$*/ 131) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(warning);
        }
    };
}
function $8721fac3cbf33e27$var$instance$8($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(1, $_ = $$value));
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(0, $appMetadata$ = value));
    return [
        $appMetadata$,
        $_,
        appMetadata$
    ];
}
class $8721fac3cbf33e27$var$InstallWallet extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$8, $8721fac3cbf33e27$var$create_fragment$8, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {}, $8721fac3cbf33e27$var$add_css$8);
    }
}
/* src/views/connect/WalletButton.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$7(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1ct6vh0", "button.svelte-1ct6vh0:disabled{opacity:0.5}button.wallet-button-styling.svelte-1ct6vh0{position:relative;align-items:flex-start;flex:1;padding:0;background:none;color:var(--onboard-wallet-button-color, inherit)}.wallet-button-container.svelte-1ct6vh0{display:flex}.wallet-button-container-inner.svelte-1ct6vh0{position:relative;display:flex;flex-flow:column;align-items:center;gap:0.5rem;padding:0.75rem;width:5rem}.name.svelte-1ct6vh0{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:1rem;text-overflow:ellipsis;max-width:5rem;max-height:2rem;overflow:hidden}.status-icon.svelte-1ct6vh0{position:absolute;top:3.5rem;left:3.5rem}@media screen and (min-width: 768px){button.wallet-button-styling.svelte-1ct6vh0{transition:background-color 250ms ease-in-out;background:var(--onboard-wallet-button-background, none);border:1px solid transparent;border-color:var(--onboard-wallet-button-border-color, var(--border-color));border-radius:var(--onboard-wallet-button-border-radius, var(--border-radius-1))}button.wallet-button-styling.svelte-1ct6vh0:hover{background:var(--onboard-wallet-button-background-hover, var(--foreground-color));color:var(--onboard-wallet-button-color-hover)}.wallet-button-container-inner.svelte-1ct6vh0{flex:1;flex-flow:row nowrap;gap:1rem;padding:1rem}button.connected.svelte-1ct6vh0{border-color:var(--onboard-success-500, var(--success-500))}.name.svelte-1ct6vh0{font-size:var(--onboard-font-size-5, var(--font-size-5));line-height:1.25rem;text-align:initial;max-width:inherit;max-height:3rem}.status-icon.svelte-1ct6vh0{top:0;bottom:0;left:auto;right:1rem;margin:auto;height:20px}}");
}
// (120:6) {#if connected}
function $8721fac3cbf33e27$var$create_if_block$5(ctx) {
    let div;
    let successstatusicon;
    let current;
    successstatusicon = new $8721fac3cbf33e27$export$db202ddc8be9136({
        props: {
            size: 20
        }
    });
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(successstatusicon.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "status-icon svelte-1ct6vh0");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(successstatusicon, div, null);
            current = true;
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(successstatusicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(successstatusicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(successstatusicon);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$7(ctx) {
    let div2;
    let button;
    let div1;
    let walletappbadge;
    let t0;
    let div0;
    let t1;
    let t2;
    let button_intro;
    let current;
    let mounted;
    let dispose;
    $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[7]);
    walletappbadge = new $8721fac3cbf33e27$export$71cec2538cb2c617({
        props: {
            size: /*windowWidth*/ ctx[6] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH ? 48 : 56,
            icon: /*icon*/ ctx[0],
            loading: /*connecting*/ ctx[4],
            border: /*connected*/ ctx[3] ? 'green' : 'custom',
            background: "transparent"
        }
    });
    let if_block = /*connected*/ ctx[3] && $8721fac3cbf33e27$var$create_if_block$5();
    return {
        c () {
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            button = $8721fac3cbf33e27$export$35e795649ee09318("button");
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(walletappbadge.$$.fragment);
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(/*label*/ ctx[1]);
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "name svelte-1ct6vh0");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "wallet-button-container-inner svelte-1ct6vh0");
            $8721fac3cbf33e27$export$342063e11d6c3cad(button, "class", "wallet-button-styling svelte-1ct6vh0");
            button.disabled = /*disabled*/ ctx[5];
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(button, "connected", /*connected*/ ctx[3]);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "wallet-button-container svelte-1ct6vh0");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div2, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, button);
            $8721fac3cbf33e27$export$953cecd6e717a553(button, div1);
            $8721fac3cbf33e27$export$9bb611d729802a56(walletappbadge, div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t2);
            if (if_block) if_block.m(div1, null);
            current = true;
            if (!mounted) {
                dispose = [
                    $8721fac3cbf33e27$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[7]),
                    $8721fac3cbf33e27$export$ffb5f4729a158638(button, "click", function() {
                        if ($8721fac3cbf33e27$export$dc98b0b04f4c7758(/*onClick*/ ctx[2])) /*onClick*/ ctx[2].apply(this, arguments);
                    })
                ];
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            const walletappbadge_changes = {};
            if (dirty & /*windowWidth*/ 64) walletappbadge_changes.size = /*windowWidth*/ ctx[6] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH ? 48 : 56;
            if (dirty & /*icon*/ 1) walletappbadge_changes.icon = /*icon*/ ctx[0];
            if (dirty & /*connecting*/ 16) walletappbadge_changes.loading = /*connecting*/ ctx[4];
            if (dirty & /*connected*/ 8) walletappbadge_changes.border = /*connected*/ ctx[3] ? 'green' : 'custom';
            walletappbadge.$set(walletappbadge_changes);
            if (!current || dirty & /*label*/ 2) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, /*label*/ ctx[1]);
            if (/*connected*/ ctx[3]) {
                if (if_block) {
                    if (dirty & /*connected*/ 8) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $8721fac3cbf33e27$var$create_if_block$5();
                    if_block.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(div1, null);
                }
            } else if (if_block) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (!current || dirty & /*disabled*/ 32) button.disabled = /*disabled*/ ctx[5];
            if (!current || dirty & /*connected*/ 8) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(button, "connected", /*connected*/ ctx[3]);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(walletappbadge.$$.fragment, local);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            if (local) {
                if (!button_intro) $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(()=>{
                    button_intro = $8721fac3cbf33e27$export$e7c866399fa523f5(button, $8721fac3cbf33e27$export$78acf4525d8a74c4, {});
                    button_intro.start();
                });
            }
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(walletappbadge.$$.fragment, local);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div2);
            $8721fac3cbf33e27$export$3466f893ebf79586(walletappbadge);
            if (if_block) if_block.d();
            mounted = false;
            $8721fac3cbf33e27$export$61196ced6d74a310(dispose);
        }
    };
}
function $8721fac3cbf33e27$var$instance$7($$self, $$props, $$invalidate) {
    let { icon: icon } = $$props;
    let { label: label } = $$props;
    let { onClick: onClick } = $$props;
    let { connected: connected } = $$props;
    let { connecting: connecting } = $$props;
    let { disabled: disabled } = $$props;
    let windowWidth;
    function onwindowresize() {
        $$invalidate(6, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ('icon' in $$props) $$invalidate(0, icon = $$props.icon);
        if ('label' in $$props) $$invalidate(1, label = $$props.label);
        if ('onClick' in $$props) $$invalidate(2, onClick = $$props.onClick);
        if ('connected' in $$props) $$invalidate(3, connected = $$props.connected);
        if ('connecting' in $$props) $$invalidate(4, connecting = $$props.connecting);
        if ('disabled' in $$props) $$invalidate(5, disabled = $$props.disabled);
    };
    return [
        icon,
        label,
        onClick,
        connected,
        connecting,
        disabled,
        windowWidth,
        onwindowresize
    ];
}
class $8721fac3cbf33e27$var$WalletButton extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$7, $8721fac3cbf33e27$var$create_fragment$7, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            icon: 0,
            label: 1,
            onClick: 2,
            connected: 3,
            connecting: 4,
            disabled: 5
        }, $8721fac3cbf33e27$var$add_css$7);
    }
}
/* src/views/connect/SelectingWallet.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$6(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-kpc6js", ".wallets-container.svelte-kpc6js{display:flex;gap:0.5rem;overflow-x:scroll;overflow-y:hidden;padding:0.75rem 0.5rem;border-bottom:1px solid var(--border-color);-ms-overflow-style:none;scrollbar-width:none}.wallets-container.svelte-kpc6js::-webkit-scrollbar{display:none}.warning-container.svelte-kpc6js{margin:1rem 1rem 0}.notice-container.svelte-kpc6js{flex:0 0 100%;margin-top:0.75rem}@media all and (min-width: 768px){.wallets-container.svelte-kpc6js{display:grid;grid-template-columns:repeat(var(--onboard-wallet-columns, 2), 1fr);padding:1rem;border:none}.notice-container.svelte-kpc6js{grid-column:span 2;margin:0}}");
}
function $8721fac3cbf33e27$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[10] = list[i];
    return child_ctx;
}
// (65:2) {#if connectingErrorMessage}
function $8721fac3cbf33e27$var$create_if_block_1$3(ctx) {
    let div;
    let warning;
    let current;
    warning = new $8721fac3cbf33e27$var$Warning({
        props: {
            $$slots: {
                default: [
                    $8721fac3cbf33e27$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(warning.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "warning-container svelte-kpc6js");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const warning_changes = {};
            if (dirty & /*$$scope, connectingErrorMessage*/ 8200) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(warning);
        }
    };
}
// (67:6) <Warning>
function $8721fac3cbf33e27$var$create_default_slot_1(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $8721fac3cbf33e27$export$ce26c07117d59d6a(false);
            html_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(/*connectingErrorMessage*/ ctx[3], target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*connectingErrorMessage*/ 8) html_tag.p(/*connectingErrorMessage*/ ctx[3]);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (72:4) {#each wallets as wallet}
function $8721fac3cbf33e27$var$create_each_block(ctx) {
    let walletbutton;
    let current;
    function func() {
        return /*func*/ ctx[9](/*wallet*/ ctx[10]);
    }
    walletbutton = new $8721fac3cbf33e27$var$WalletButton({
        props: {
            connected: /*checkConnected*/ ctx[7](/*wallet*/ ctx[10].label),
            connecting: /*connectingWalletLabel*/ ctx[2] === /*wallet*/ ctx[10].label,
            label: /*wallet*/ ctx[10].label,
            icon: /*wallet*/ ctx[10].icon,
            onClick: func,
            disabled: /*windowWidth*/ ctx[4] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && /*connectingWalletLabel*/ ctx[2] && /*connectingWalletLabel*/ ctx[2] !== /*wallet*/ ctx[10].label
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(walletbutton.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(walletbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const walletbutton_changes = {};
            if (dirty & /*wallets*/ 1) walletbutton_changes.connected = /*checkConnected*/ ctx[7](/*wallet*/ ctx[10].label);
            if (dirty & /*connectingWalletLabel, wallets*/ 5) walletbutton_changes.connecting = /*connectingWalletLabel*/ ctx[2] === /*wallet*/ ctx[10].label;
            if (dirty & /*wallets*/ 1) walletbutton_changes.label = /*wallet*/ ctx[10].label;
            if (dirty & /*wallets*/ 1) walletbutton_changes.icon = /*wallet*/ ctx[10].icon;
            if (dirty & /*selectWallet, wallets*/ 3) walletbutton_changes.onClick = func;
            if (dirty & /*windowWidth, connectingWalletLabel, wallets*/ 21) walletbutton_changes.disabled = /*windowWidth*/ ctx[4] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && /*connectingWalletLabel*/ ctx[2] && /*connectingWalletLabel*/ ctx[2] !== /*wallet*/ ctx[10].label;
            walletbutton.$set(walletbutton_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(walletbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(walletbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(walletbutton, detaching);
        }
    };
}
// (84:4) {#if !connect.removeWhereIsMyWalletWarning}
function $8721fac3cbf33e27$var$create_if_block$4(ctx) {
    let div;
    let warning;
    let current;
    warning = new $8721fac3cbf33e27$var$Warning({
        props: {
            $$slots: {
                default: [
                    $8721fac3cbf33e27$var$create_default_slot$3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(warning.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "notice-container svelte-kpc6js");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const warning_changes = {};
            if (dirty & /*$$scope, $_*/ 8224) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(warning);
        }
    };
}
// (86:8) <Warning>
function $8721fac3cbf33e27$var$create_default_slot$3(ctx) {
    let div;
    let t0_value = /*$_*/ ctx[5]('connect.selectingWallet.whyDontISeeMyWallet', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.whyDontISeeMyWallet
    }) + "";
    let t0;
    let t1;
    let a;
    let t2_value = /*$_*/ ctx[5]('connect.selectingWallet.learnMore', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.learnMore
    }) + "";
    let t2;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            t2 = $8721fac3cbf33e27$export$625550452a3fa3ec(t2_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "class", "link pointer");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", /*connect*/ ctx[6].wheresMyWalletLink || $8721fac3cbf33e27$var$wheresMyWalletDefault);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div, t0);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t1, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, a, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t2);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 32 && t0_value !== (t0_value = /*$_*/ ctx[5]('connect.selectingWallet.whyDontISeeMyWallet', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.whyDontISeeMyWallet
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$_*/ 32 && t2_value !== (t2_value = /*$_*/ ctx[5]('connect.selectingWallet.learnMore', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.learnMore
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t2, t2_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t1);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(a);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$6(ctx) {
    let div1;
    let t0;
    let div0;
    let t1;
    let current;
    let mounted;
    let dispose;
    $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[8]);
    let if_block0 = /*connectingErrorMessage*/ ctx[3] && $8721fac3cbf33e27$var$create_if_block_1$3(ctx);
    let each_value = /*wallets*/ ctx[0];
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $8721fac3cbf33e27$var$create_each_block($8721fac3cbf33e27$var$get_each_context(ctx, each_value, i));
    const out = (i)=>$8721fac3cbf33e27$export$ebd11618f299a286(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    let if_block1 = !/*connect*/ ctx[6].removeWhereIsMyWalletWarning && $8721fac3cbf33e27$var$create_if_block$4(ctx);
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "wallets-container svelte-kpc6js");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "outer-container");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t1);
            if (if_block1) if_block1.m(div0, null);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[8]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*connectingErrorMessage*/ ctx[3]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*connectingErrorMessage*/ 8) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $8721fac3cbf33e27$var$create_if_block_1$3(ctx);
                    if_block0.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (dirty & /*checkConnected, wallets, connectingWalletLabel, selectWallet, windowWidth, MOBILE_WINDOW_WIDTH*/ 151) {
                each_value = /*wallets*/ ctx[0];
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $8721fac3cbf33e27$var$get_each_context(ctx, each_value, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        $8721fac3cbf33e27$export$d141bba7fdc215a3(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $8721fac3cbf33e27$var$create_each_block(child_ctx);
                        each_blocks[i].c();
                        $8721fac3cbf33e27$export$d141bba7fdc215a3(each_blocks[i], 1);
                        each_blocks[i].m(div0, t1);
                    }
                }
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                for(i = each_value.length; i < each_blocks.length; i += 1)out(i);
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (!/*connect*/ ctx[6].removeWhereIsMyWalletWarning) if_block1.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0);
            for(let i = 0; i < each_value.length; i += 1)$8721fac3cbf33e27$export$d141bba7fdc215a3(each_blocks[i]);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block0);
            each_blocks = each_blocks.filter(Boolean);
            for(let i = 0; i < each_blocks.length; i += 1)$8721fac3cbf33e27$export$ebd11618f299a286(each_blocks[i]);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            $8721fac3cbf33e27$export$ef35774e6d314e91(each_blocks, detaching);
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
const $8721fac3cbf33e27$var$wheresMyWalletDefault = 'https://www.blocknative.com/blog/metamask-wont-connect-web3-wallet-troubleshooting';
function $8721fac3cbf33e27$var$instance$6($$self, $$props, $$invalidate) {
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(5, $_ = $$value));
    let { wallets: wallets } = $$props;
    let { selectWallet: selectWallet } = $$props;
    let { connectingWalletLabel: connectingWalletLabel } = $$props;
    let { connectingErrorMessage: connectingErrorMessage } = $$props;
    let windowWidth;
    const { connect: connect } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    function checkConnected(label) {
        const { wallets: wallets } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
        return !!wallets.find((wallet)=>wallet.label === label);
    }
    function onwindowresize() {
        $$invalidate(4, windowWidth = window.innerWidth);
    }
    const func = (wallet)=>selectWallet(wallet);
    $$self.$$set = ($$props)=>{
        if ('wallets' in $$props) $$invalidate(0, wallets = $$props.wallets);
        if ('selectWallet' in $$props) $$invalidate(1, selectWallet = $$props.selectWallet);
        if ('connectingWalletLabel' in $$props) $$invalidate(2, connectingWalletLabel = $$props.connectingWalletLabel);
        if ('connectingErrorMessage' in $$props) $$invalidate(3, connectingErrorMessage = $$props.connectingErrorMessage);
    };
    return [
        wallets,
        selectWallet,
        connectingWalletLabel,
        connectingErrorMessage,
        windowWidth,
        $_,
        connect,
        checkConnected,
        onwindowresize,
        func
    ];
}
class $8721fac3cbf33e27$var$SelectingWallet extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$6, $8721fac3cbf33e27$var$create_fragment$6, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            wallets: 0,
            selectWallet: 1,
            connectingWalletLabel: 2,
            connectingErrorMessage: 3
        }, $8721fac3cbf33e27$var$add_css$6);
    }
}
/* src/views/connect/Sidebar.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$5(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-obaru3", ".sidebar.svelte-obaru3{--background-color:var(\n      --onboard-connect-sidebar-background,\n      var(--w3o-foreground-color, none)\n    );--text-color:var(--onboard-connect-sidebar-color, inherit);--border-color:var(--onboard-connect-sidebar-border-color, inherit);display:flex;flex-flow:column;gap:1rem;padding:1rem;align-items:center}.inner-container.svelte-obaru3{display:flex;flex-flow:column;align-items:center;align-self:stretch;gap:0.5rem;padding:1.5rem;text-align:center;border:1px solid transparent;border-radius:12px;border-color:var(--border-color);background:var(--background-color);color:var(--text-color)}.icon-container.svelte-obaru3{display:flex;height:3.5rem;width:auto;min-width:3.5rem;max-width:100%}.heading.svelte-obaru3{font-size:var(--onboard-font-size-3, var(--font-size-3));margin:0 0 var(--onboard-spacing-5, var(--spacing-5)) 0}.subheading.svelte-obaru3{line-height:1rem}.description.svelte-obaru3{line-height:1.25rem;font-size:var(--onboard-font-size-6, var(--font-size-6))}img.svelte-obaru3{max-width:100%;height:auto}.indicators.svelte-obaru3{margin-top:auto}.indicator.svelte-obaru3{box-sizing:content-box;width:8px;height:8px;border-radius:8px;background:var(\n      --onboard-connect-sidebar-progress-background,\n      var(--onboard-gray-700, var(--gray-700))\n    );transition:background 250ms ease-in-out}.indicator.on.svelte-obaru3{background:var(\n      --onboard-connect-sidebar-progress-color,\n      var(--action-color)\n    );border:2px solid\n      var(\n        --onboard-connect-sidebar-progress-background,\n        var(--onboard-gray-700, var(--gray-700))\n      )}.join.svelte-obaru3{box-sizing:content-box;z-index:1;right:4px;height:2px;background:var(\n      --onboard-connect-sidebar-progress-background,\n      var(--onboard-gray-700, var(--gray-700))\n    );transition:background 250ms ease-in-out}.join.active.svelte-obaru3{background:var(\n      --onboard-connect-sidebar-progress-color,\n      var(--action-color)\n    )}.no-link.svelte-obaru3{display:flex;flex-direction:row;align-items:center;padding:0.25rem 0.5rem 0.25rem 0.75rem;gap:0.25rem;font-size:var(--onboard-font-size-6, var(--font-size-6))}.info-icon.svelte-obaru3{width:1.25rem;display:flex;align-items:center}@media all and (min-width: 768px){.sidebar.svelte-obaru3{max-width:280px;border-right:1px solid;border-color:var(--border-color);background:var(--background-color)}.inner-container.svelte-obaru3{border:none;text-align:initial;flex:1;align-items:flex-start;gap:1rem}.indicators.svelte-obaru3{margin-bottom:0.25rem}}");
}
// (164:4) {#if windowWidth >= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block_3$2(ctx) {
    let div;
    let t;
    let show_if = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
        default: ''
    });
    let if_block1_anchor;
    function select_block_type(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) return $8721fac3cbf33e27$var$create_if_block_5$2;
        return $8721fac3cbf33e27$var$create_else_block_1$1;
    }
    let current_block_type = select_block_type(ctx);
    let if_block0 = current_block_type(ctx);
    let if_block1 = show_if && $8721fac3cbf33e27$var$create_if_block_4$2(ctx);
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if_block0.c();
            t = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            if_block1_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "icon-container svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            if_block0.m(div, null);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block1_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(div, null);
                }
            }
            if (dirty & /*$_, step*/ 9) show_if = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
                default: ''
            });
            if (show_if) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $8721fac3cbf33e27$var$create_if_block_4$2(ctx);
                    if_block1.c();
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            if_block0.d();
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block1_anchor);
        }
    };
}
// (172:8) {:else}
function $8721fac3cbf33e27$var$create_else_block_1$1(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $8721fac3cbf33e27$export$ce26c07117d59d6a(false);
            html_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m($8721fac3cbf33e27$var$defaultBnIcon, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (166:8) {#if $appMetadata$ && ($appMetadata$.logo || $appMetadata$.icon)}
function $8721fac3cbf33e27$var$create_if_block_5$2(ctx) {
    let show_if;
    let if_block_anchor;
    function select_block_type_1(ctx, dirty) {
        if (dirty & /*$appMetadata$*/ 4) show_if = null;
        if (show_if == null) show_if = !!$8721fac3cbf33e27$export$34aec0b863436764(/*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon);
        if (show_if) return $8721fac3cbf33e27$var$create_if_block_6$2;
        return $8721fac3cbf33e27$var$create_else_block$1;
    }
    let current_block_type = select_block_type_1(ctx, -1);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (169:10) {:else}
function $8721fac3cbf33e27$var$create_else_block$1(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $8721fac3cbf33e27$export$35e795649ee09318("img");
            if (!$8721fac3cbf33e27$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) $8721fac3cbf33e27$export$342063e11d6c3cad(img, "src", img_src_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(img, "alt", "logo");
            $8721fac3cbf33e27$export$342063e11d6c3cad(img, "class", "svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 4 && !$8721fac3cbf33e27$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) $8721fac3cbf33e27$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(img);
        }
    };
}
// (167:10) {#if isSVG($appMetadata$.logo || $appMetadata$.icon)}
function $8721fac3cbf33e27$var$create_if_block_6$2(ctx) {
    let html_tag;
    let raw_value = /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon) + "";
    let t;
    return {
        c () {
            html_tag = new $8721fac3cbf33e27$export$ce26c07117d59d6a(false);
            t = $8721fac3cbf33e27$export$625550452a3fa3ec("\u200B");
            html_tag.a = t;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 4 && raw_value !== (raw_value = /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon) + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) html_tag.d();
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t);
        }
    };
}
// (176:6) {#if $_(`connect.${step}.sidebar.header`, { default: '' })}
function $8721fac3cbf33e27$var$create_if_block_4$2(ctx) {
    let div;
    let t_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
        default: /*heading*/ ctx[7]
    }) + "";
    let t;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t = $8721fac3cbf33e27$export$625550452a3fa3ec(t_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "heading svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, step*/ 9 && t_value !== (t_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
                default: /*heading*/ ctx[7]
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
        }
    };
}
// (197:4) {#if !connect.removeIDontHaveAWalletInfoLink}
function $8721fac3cbf33e27$var$create_if_block_2$2(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[3]('connect.selectingWallet.sidebar.IDontHaveAWallet', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.sidebar.IDontHaveAWallet
    }) + "";
    let t0;
    let t1;
    let div;
    return {
        c () {
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "info-icon svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", /*connect*/ ctx[4].iDontHaveAWalletLink || 'https://ethereum.org/en/wallets/find-wallet/#main-content');
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "class", "no-link svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, a, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, div);
            div.innerHTML = $8721fac3cbf33e27$var$infoIcon;
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 8 && t0_value !== (t0_value = /*$_*/ ctx[3]('connect.selectingWallet.sidebar.IDontHaveAWallet', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect.selectingWallet.sidebar.IDontHaveAWallet
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(a);
        }
    };
}
// (210:4) {#if windowWidth < MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block_1$2(ctx) {
    let div5;
    let div0;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let t2;
    let div3;
    let div3_style_value;
    let t3;
    let div4;
    return {
        c () {
            div5 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t3 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "indicator relative svelte-obaru3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div0, "on", true);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "join relative svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value = `${ctx[0] !== 'selectingWallet' ? 'right: 4px; width: 52px;' : 'right: 2px; width: 54px;'}`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== 'selectingWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "indicator relative svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "style", `right: 8px;`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== 'selectingWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "join relative svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "style", div3_style_value = `${ctx[0] === 'connectedWallet' ? 'right: 12px; width: 52px;' : 'right: 10px; width: 54px;'}`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === 'connectedWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "style", `right: 16px;`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "indicator relative svelte-obaru3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === 'connectedWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div5, "class", "indicators flex items-center svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div5, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div4);
        },
        p (ctx, dirty) {
            if (dirty & /*step*/ 1 && div1_style_value !== (div1_style_value = `${ctx[0] !== 'selectingWallet' ? 'right: 4px; width: 52px;' : 'right: 2px; width: 54px;'}`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== 'selectingWallet');
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== 'selectingWallet');
            if (dirty & /*step*/ 1 && div3_style_value !== (div3_style_value = `${ctx[0] === 'connectedWallet' ? 'right: 12px; width: 52px;' : 'right: 10px; width: 54px;'}`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === 'connectedWallet');
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === 'connectedWallet');
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div5);
        }
    };
}
// (244:2) {#if windowWidth >= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block$3(ctx) {
    let div5;
    let div0;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let t2;
    let div3;
    let div3_style_value;
    let t3;
    let div4;
    return {
        c () {
            div5 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t3 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "indicator relative svelte-obaru3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div0, "on", true);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "join relative svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value = `right: 2px; ${ctx[0] !== 'selectingWallet' ? 'width: 78px;' : 'width: 82px;'}`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== 'selectingWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "indicator relative svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "style", `right: 4px;`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== 'selectingWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "join relative svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "style", div3_style_value = `right: 6px; ${ctx[0] === 'connectedWallet' ? 'width: 74px;' : 'width: 81px;'}`);
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === 'connectedWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "style", `right: 8px;`);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "indicator relative svelte-obaru3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === 'connectedWallet');
            $8721fac3cbf33e27$export$342063e11d6c3cad(div5, "class", "indicators flex items-center svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div5, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div5, div4);
        },
        p (ctx, dirty) {
            if (dirty & /*step*/ 1 && div1_style_value !== (div1_style_value = `right: 2px; ${ctx[0] !== 'selectingWallet' ? 'width: 78px;' : 'width: 82px;'}`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== 'selectingWallet');
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== 'selectingWallet');
            if (dirty & /*step*/ 1 && div3_style_value !== (div3_style_value = `right: 6px; ${ctx[0] === 'connectedWallet' ? 'width: 74px;' : 'width: 81px;'}`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === 'connectedWallet');
            if (dirty & /*step*/ 1) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === 'connectedWallet');
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div5);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$5(ctx) {
    let div4;
    let div2;
    let t0;
    let div0;
    let t1_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.subheading`, {
        default: /*subheading*/ ctx[5]
    }) + "";
    let t1;
    let t2;
    let div1;
    let t3_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.paragraph`, {
        values: {
            app: /*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ ctx[2].name || 'This App'
        },
        default: /*paragraph*/ ctx[6]
    }) + "";
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let div3;
    let a;
    let mounted;
    let dispose;
    $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[9]);
    let if_block0 = /*windowWidth*/ ctx[1] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && $8721fac3cbf33e27$var$create_if_block_3$2(ctx);
    let if_block1 = !/*connect*/ ctx[4].removeIDontHaveAWalletInfoLink && $8721fac3cbf33e27$var$create_if_block_2$2(ctx);
    let if_block2 = /*windowWidth*/ ctx[1] < $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && $8721fac3cbf33e27$var$create_if_block_1$2(ctx);
    let if_block3 = /*windowWidth*/ ctx[1] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && $8721fac3cbf33e27$var$create_if_block$3(ctx);
    return {
        c () {
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(t1_value);
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t3 = $8721fac3cbf33e27$export$625550452a3fa3ec(t3_value);
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t5 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t6 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            t7 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "subheading svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "description svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "inner-container svelte-obaru3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", "https://thirdweb.com/connect?utm_source=cw_text");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "sidebar svelte-obaru3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div4, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div2);
            if (if_block0) if_block0.m(div2, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t4);
            if (if_block1) if_block1.m(div2, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t5);
            if (if_block2) if_block2.m(div2, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, t6);
            if (if_block3) if_block3.m(div4, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, t7);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, a);
            a.innerHTML = $8721fac3cbf33e27$export$a93c5207d687da10;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[9]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*windowWidth*/ ctx[1] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) {
                if (if_block0) if_block0.p(ctx, dirty);
                else {
                    if_block0 = $8721fac3cbf33e27$var$create_if_block_3$2(ctx);
                    if_block0.c();
                    if_block0.m(div2, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (dirty & /*$_, step*/ 9 && t1_value !== (t1_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.subheading`, {
                default: /*subheading*/ ctx[5]
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, t1_value);
            if (dirty & /*$_, step, $appMetadata$*/ 13 && t3_value !== (t3_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.paragraph`, {
                values: {
                    app: /*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ ctx[2].name || 'This App'
                },
                default: /*paragraph*/ ctx[6]
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t3, t3_value);
            if (!/*connect*/ ctx[4].removeIDontHaveAWalletInfoLink) if_block1.p(ctx, dirty);
            if (/*windowWidth*/ ctx[1] < $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) {
                if (if_block2) if_block2.p(ctx, dirty);
                else {
                    if_block2 = $8721fac3cbf33e27$var$create_if_block_1$2(ctx);
                    if_block2.c();
                    if_block2.m(div2, null);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (/*windowWidth*/ ctx[1] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) {
                if (if_block3) if_block3.p(ctx, dirty);
                else {
                    if_block3 = $8721fac3cbf33e27$var$create_if_block$3(ctx);
                    if_block3.c();
                    if_block3.m(div4, t7);
                }
            } else if (if_block3) {
                if_block3.d(1);
                if_block3 = null;
            }
        },
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div4);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$instance$5($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(3, $_ = $$value));
    let { step: step } = $$props;
    const { connect: connect } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    const defaultContent = $8721fac3cbf33e27$export$e7094788287c5e9b.connect[step].sidebar;
    const { subheading: subheading, paragraph: paragraph } = defaultContent;
    const { heading: heading } = defaultContent;
    let windowWidth;
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(2, $appMetadata$ = value));
    function onwindowresize() {
        $$invalidate(1, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ('step' in $$props) $$invalidate(0, step = $$props.step);
    };
    return [
        step,
        windowWidth,
        $appMetadata$,
        $_,
        connect,
        subheading,
        paragraph,
        heading,
        appMetadata$,
        onwindowresize
    ];
}
class $8721fac3cbf33e27$var$Sidebar extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$5, $8721fac3cbf33e27$var$create_fragment$5, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            step: 0
        }, $8721fac3cbf33e27$var$add_css$5);
    }
}
/* src/views/connect/Index.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$4(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-1qwmck3", ".container.svelte-1qwmck3{--background-color:var(\n      --onboard-main-scroll-container-background,\n      var(--w3o-background-color)\n    );--foreground-color:var(--w3o-foreground-color);--text-color:var(--onboard-connect-text-color, var(--w3o-text-color));--border-color:var(--w3o-border-color, var(--gray-200));--action-color:var(--w3o-action-color, var(--primary-500));font-family:var(--onboard-font-family-normal, var(--font-family-normal));font-size:var(--onboard-font-size-5, 1rem);background:var(--background-color);color:var(--text-color);border-color:var(--border-color);line-height:24px;overflow:hidden;position:relative;display:flex;height:min-content;flex-flow:column-reverse}.content.svelte-1qwmck3{width:var(--onboard-connect-content-width, 100%)}.header.svelte-1qwmck3{display:flex;padding:1rem;border-bottom:1px solid transparent;background:var(--onboard-connect-header-background);color:var(--onboard-connect-header-color);border-color:var(--border-color)}.header-heading.svelte-1qwmck3{line-height:1rem}.button-container.svelte-1qwmck3{right:0.5rem;top:0.5rem}.mobile-header.svelte-1qwmck3{display:flex;gap:0.5rem;height:4.5rem;padding:1rem;border-bottom:1px solid;border-color:var(--border-color)}.mobile-subheader.svelte-1qwmck3{opacity:0.6;font-size:0.875rem;font-weight:400;line-height:1rem;margin-top:0.25rem}.icon-container.svelte-1qwmck3{display:flex;flex:0 0 auto;height:2.5rem;width:2.5rem;min-width:2.5rem;justify-content:center;align-items:center}.disabled.svelte-1qwmck3{opacity:0.2;pointer-events:none;overflow:hidden}.icon-container svg{display:block;height:100%;width:auto}.w-full.svelte-1qwmck3{width:100%}.scroll-container.svelte-1qwmck3{overflow-y:auto;transition:opacity 250ms ease-in-out;scrollbar-width:none}.scroll-container.svelte-1qwmck3::-webkit-scrollbar{display:none}@media all and (min-width: 768px){.container.svelte-1qwmck3{margin:0;flex-flow:row;height:var(--onboard-connect-content-height, 440px)}.content.svelte-1qwmck3{width:var(--onboard-connect-content-width, 488px)}.mobile-subheader.svelte-1qwmck3{display:none}.icon-container.svelte-1qwmck3{display:none}}");
}
// (441:0) {#if !autoSelect.disableModals}
function $8721fac3cbf33e27$var$create_if_block$2(ctx) {
    let modal;
    let current;
    modal = new $8721fac3cbf33e27$export$8743009a87fcb00f({
        props: {
            close: !/*connect*/ ctx[16].disableClose && /*close*/ ctx[20],
            $$slots: {
                default: [
                    $8721fac3cbf33e27$var$create_default_slot$2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const modal_changes = {};
            if (dirty[0] & /*scrollContainer, selectedWallet, $modalStep$, windowWidth, connectionRejected, previousConnectionRequest, displayConnectingWallet, agreed, wallets, connectingWalletLabel, connectingErrorMessage, availableWallets, $_, $appMetadata$*/ 32766 | dirty[1] & /*$$scope*/ 32) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(modal, detaching);
        }
    };
}
// (444:6) {#if connect.showSidebar}
function $8721fac3cbf33e27$var$create_if_block_9$1(ctx) {
    let sidebar;
    let current;
    sidebar = new $8721fac3cbf33e27$var$Sidebar({
        props: {
            step: /*$modalStep$*/ ctx[5]
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(sidebar.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(sidebar, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const sidebar_changes = {};
            if (dirty[0] & /*$modalStep$*/ 32) sidebar_changes.step = /*$modalStep$*/ ctx[5];
            sidebar.$set(sidebar_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(sidebar.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(sidebar.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(sidebar, detaching);
        }
    };
}
// (495:8) {:else}
function $8721fac3cbf33e27$var$create_else_block_3(ctx) {
    let div1;
    let div0;
    let t0_value = /*$_*/ ctx[14](`connect.${ctx[5]}.header`, {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header,
        values: {
            connectionRejected: /*connectionRejected*/ ctx[1],
            wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
        }
    }) + "";
    let t0;
    let t1;
    let t2_value = /*$modalStep$*/ (ctx[5] === 'selectingWallet' ? `(${ctx[12]})` : '') + "";
    let t2;
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            t2 = $8721fac3cbf33e27$export$625550452a3fa3ec(t2_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "header-heading svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "header relative flex items-center svelte-1qwmck3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t2);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$_, $modalStep$, connectionRejected, selectedWallet*/ 16426 && t0_value !== (t0_value = /*$_*/ ctx[14](`connect.${ctx[5]}.header`, {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header,
                values: {
                    connectionRejected: /*connectionRejected*/ ctx[1],
                    wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
            if (dirty[0] & /*$modalStep$, availableWallets*/ 4128 && t2_value !== (t2_value = /*$modalStep$*/ (ctx[5] === 'selectingWallet' ? `(${ctx[12]})` : '') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t2, t2_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
        }
    };
}
// (449:8) {#if windowWidth <= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block_6$1(ctx) {
    let div4;
    let div0;
    let t0;
    let div3;
    let div1;
    let t1_value = /*$_*/ ctx[14](/*$modalStep$*/ ctx[5] === 'connectingWallet' && /*selectedWallet*/ ctx[3] ? `connect.${ctx[5]}.header` : `connect.${ctx[5]}.sidebar.subheading`, {
        default: /*$modalStep$*/ ctx[5] === 'connectingWallet' && /*selectedWallet*/ ctx[3] ? $8721fac3cbf33e27$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header : $8721fac3cbf33e27$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].sidebar.subheading,
        values: {
            connectionRejected: /*connectionRejected*/ ctx[1],
            wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
        }
    }) + "";
    let t1;
    let t2;
    let div2;
    let t3_value = /*$modalStep$*/ (ctx[5] === 'selectingWallet' ? /*availableWallets*/ ctx[12] > 1 ? `${ctx[12]} ${ctx[14]('connect.selectingWallet.header').toLowerCase()}` : `1 ${ctx[14]('connect.connectedWallet.availableWallet').toLowerCase()}` : `1 ${ctx[14]('connect.connectedWallet.accountSelected').toLowerCase()}`) + "";
    let t3;
    function select_block_type_1(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[13] && /*$appMetadata$*/ ctx[13].icon) return $8721fac3cbf33e27$var$create_if_block_7$1;
        return $8721fac3cbf33e27$var$create_else_block_2;
    }
    let current_block_type = select_block_type_1(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            div4 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if_block.c();
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div3 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(t1_value);
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            t3 = $8721fac3cbf33e27$export$625550452a3fa3ec(t3_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "icon-container svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "header-heading svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "mobile-subheader svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div3, "class", "flex flex-column justify-center w-full svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div4, "class", "mobile-header svelte-1qwmck3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div4, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div0);
            if_block.m(div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div4, div3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div3, div2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t3);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(div0, null);
                }
            }
            if (dirty[0] & /*$_, $modalStep$, selectedWallet, connectionRejected*/ 16426 && t1_value !== (t1_value = /*$_*/ ctx[14](/*$modalStep$*/ ctx[5] === 'connectingWallet' && /*selectedWallet*/ ctx[3] ? `connect.${ctx[5]}.header` : `connect.${ctx[5]}.sidebar.subheading`, {
                default: /*$modalStep$*/ ctx[5] === 'connectingWallet' && /*selectedWallet*/ ctx[3] ? $8721fac3cbf33e27$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header : $8721fac3cbf33e27$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].sidebar.subheading,
                values: {
                    connectionRejected: /*connectionRejected*/ ctx[1],
                    wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, t1_value);
            if (dirty[0] & /*$modalStep$, availableWallets, $_*/ 20512 && t3_value !== (t3_value = /*$modalStep$*/ (ctx[5] === 'selectingWallet' ? /*availableWallets*/ ctx[12] > 1 ? `${ctx[12]} ${ctx[14]('connect.selectingWallet.header').toLowerCase()}` : `1 ${ctx[14]('connect.connectedWallet.availableWallet').toLowerCase()}` : `1 ${ctx[14]('connect.connectedWallet.accountSelected').toLowerCase()}`) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t3, t3_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div4);
            if_block.d();
        }
    };
}
// (458:14) {:else}
function $8721fac3cbf33e27$var$create_else_block_2(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $8721fac3cbf33e27$export$ce26c07117d59d6a(false);
            html_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m($8721fac3cbf33e27$var$defaultBnIcon, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (452:14) {#if $appMetadata$ && $appMetadata$.icon}
function $8721fac3cbf33e27$var$create_if_block_7$1(ctx) {
    let show_if;
    let if_block_anchor;
    function select_block_type_2(ctx, dirty) {
        if (dirty[0] & /*$appMetadata$*/ 8192) show_if = null;
        if (show_if == null) show_if = !!$8721fac3cbf33e27$export$34aec0b863436764(/*$appMetadata$*/ ctx[13].icon);
        if (show_if) return $8721fac3cbf33e27$var$create_if_block_8$1;
        return $8721fac3cbf33e27$var$create_else_block_1;
    }
    let current_block_type = select_block_type_2(ctx, [
        -1,
        -1
    ]);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_2(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (455:16) {:else}
function $8721fac3cbf33e27$var$create_else_block_1(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $8721fac3cbf33e27$export$35e795649ee09318("img");
            if (!$8721fac3cbf33e27$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[13].icon)) $8721fac3cbf33e27$export$342063e11d6c3cad(img, "src", img_src_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(img, "alt", "logo");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$appMetadata$*/ 8192 && !$8721fac3cbf33e27$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[13].icon)) $8721fac3cbf33e27$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(img);
        }
    };
}
// (453:16) {#if isSVG($appMetadata$.icon)}
function $8721fac3cbf33e27$var$create_if_block_8$1(ctx) {
    let html_tag;
    let raw_value = /*$appMetadata$*/ ctx[13].icon + "";
    let html_anchor;
    return {
        c () {
            html_tag = new $8721fac3cbf33e27$export$ce26c07117d59d6a(false);
            html_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$appMetadata$*/ 8192 && raw_value !== (raw_value = /*$appMetadata$*/ ctx[13].icon + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (509:8) {#if !connect.disableClose}
function $8721fac3cbf33e27$var$create_if_block_5$1(ctx) {
    let div;
    let closebutton;
    let current;
    let mounted;
    let dispose;
    closebutton = new $8721fac3cbf33e27$var$CloseButton({});
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(closebutton.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "button-container absolute svelte-1qwmck3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(closebutton, div, null);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(div, "click", /*close*/ ctx[20]);
                mounted = true;
            }
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(closebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(closebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(closebutton);
            mounted = false;
            dispose();
        }
    };
}
// (516:10) {#if $modalStep$ === 'selectingWallet' || windowWidth <= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block_3$1(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $8721fac3cbf33e27$var$create_if_block_4$1,
        $8721fac3cbf33e27$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type_3(ctx, dirty) {
        if (/*wallets*/ ctx[2].length) return 0;
        return 1;
    }
    current_block_type_index = select_block_type_3(ctx);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_3(ctx);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (528:12) {:else}
function $8721fac3cbf33e27$var$create_else_block(ctx) {
    let installwallet;
    let current;
    installwallet = new $8721fac3cbf33e27$var$InstallWallet({});
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(installwallet.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(installwallet, target, anchor);
            current = true;
        },
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(installwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(installwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(installwallet, detaching);
        }
    };
}
// (517:12) {#if wallets.length}
function $8721fac3cbf33e27$var$create_if_block_4$1(ctx) {
    let agreement;
    let updating_agreed;
    let t;
    let div;
    let selectingwallet;
    let current;
    function agreement_agreed_binding(value) {
        /*agreement_agreed_binding*/ ctx[24](value);
    }
    let agreement_props = {};
    if (/*agreed*/ ctx[7] !== void 0) agreement_props.agreed = /*agreed*/ ctx[7];
    agreement = new $8721fac3cbf33e27$var$Agreement({
        props: agreement_props
    });
    $8721fac3cbf33e27$export$39b482c5e57630a8.push(()=>$8721fac3cbf33e27$export$2219238a014317b0(agreement, 'agreed', agreement_agreed_binding));
    selectingwallet = new $8721fac3cbf33e27$var$SelectingWallet({
        props: {
            selectWallet: /*selectWallet*/ ctx[18],
            wallets: /*wallets*/ ctx[2],
            connectingWalletLabel: /*connectingWalletLabel*/ ctx[8],
            connectingErrorMessage: /*connectingErrorMessage*/ ctx[9]
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(agreement.$$.fragment);
            t = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(selectingwallet.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "svelte-1qwmck3");
            $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "disabled", !/*agreed*/ ctx[7]);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(agreement, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            $8721fac3cbf33e27$export$9bb611d729802a56(selectingwallet, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const agreement_changes = {};
            if (!updating_agreed && dirty[0] & /*agreed*/ 128) {
                updating_agreed = true;
                agreement_changes.agreed = /*agreed*/ ctx[7];
                $8721fac3cbf33e27$export$4c3d22f3d993c33f(()=>updating_agreed = false);
            }
            agreement.$set(agreement_changes);
            const selectingwallet_changes = {};
            if (dirty[0] & /*wallets*/ 4) selectingwallet_changes.wallets = /*wallets*/ ctx[2];
            if (dirty[0] & /*connectingWalletLabel*/ 256) selectingwallet_changes.connectingWalletLabel = /*connectingWalletLabel*/ ctx[8];
            if (dirty[0] & /*connectingErrorMessage*/ 512) selectingwallet_changes.connectingErrorMessage = /*connectingErrorMessage*/ ctx[9];
            selectingwallet.$set(selectingwallet_changes);
            if (!current || dirty[0] & /*agreed*/ 128) $8721fac3cbf33e27$export$7f8ddf7c7c20b3cd(div, "disabled", !/*agreed*/ ctx[7]);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(agreement.$$.fragment, local);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(selectingwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(agreement.$$.fragment, local);
            $8721fac3cbf33e27$export$ebd11618f299a286(selectingwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(agreement, detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            $8721fac3cbf33e27$export$3466f893ebf79586(selectingwallet);
        }
    };
}
// (533:10) {#if displayConnectingWallet}
function $8721fac3cbf33e27$var$create_if_block_2$1(ctx) {
    let connectingwallet;
    let current;
    connectingwallet = new $8721fac3cbf33e27$var$ConnectingWallet({
        props: {
            connectWallet: /*connectWallet*/ ctx[21],
            connectionRejected: /*connectionRejected*/ ctx[1],
            previousConnectionRequest: /*previousConnectionRequest*/ ctx[6],
            setStep: /*setStep*/ ctx[22],
            deselectWallet: /*deselectWallet*/ ctx[19],
            selectedWallet: /*selectedWallet*/ ctx[3]
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(connectingwallet.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(connectingwallet, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connectingwallet_changes = {};
            if (dirty[0] & /*connectionRejected*/ 2) connectingwallet_changes.connectionRejected = /*connectionRejected*/ ctx[1];
            if (dirty[0] & /*previousConnectionRequest*/ 64) connectingwallet_changes.previousConnectionRequest = /*previousConnectionRequest*/ ctx[6];
            if (dirty[0] & /*selectedWallet*/ 8) connectingwallet_changes.selectedWallet = /*selectedWallet*/ ctx[3];
            connectingwallet.$set(connectingwallet_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(connectingwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(connectingwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(connectingwallet, detaching);
        }
    };
}
// (544:10) {#if $modalStep$ === 'connectedWallet' && selectedWallet && windowWidth >= MOBILE_WINDOW_WIDTH}
function $8721fac3cbf33e27$var$create_if_block_1$1(ctx) {
    let connectedwallet;
    let current;
    connectedwallet = new $8721fac3cbf33e27$var$ConnectedWallet({
        props: {
            selectedWallet: /*selectedWallet*/ ctx[3]
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(connectedwallet.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(connectedwallet, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connectedwallet_changes = {};
            if (dirty[0] & /*selectedWallet*/ 8) connectedwallet_changes.selectedWallet = /*selectedWallet*/ ctx[3];
            connectedwallet.$set(connectedwallet_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(connectedwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(connectedwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(connectedwallet, detaching);
        }
    };
}
// (442:2) <Modal close={!connect.disableClose && close}>
function $8721fac3cbf33e27$var$create_default_slot$2(ctx) {
    let div2;
    let t0;
    let div1;
    let t1;
    let t2;
    let div0;
    let t3;
    let t4;
    let current;
    let if_block0 = /*connect*/ ctx[16].showSidebar && $8721fac3cbf33e27$var$create_if_block_9$1(ctx);
    function select_block_type(ctx, dirty) {
        if (/*windowWidth*/ ctx[4] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) return $8721fac3cbf33e27$var$create_if_block_6$1;
        return $8721fac3cbf33e27$var$create_else_block_3;
    }
    let current_block_type = select_block_type(ctx);
    let if_block1 = current_block_type(ctx);
    let if_block2 = !/*connect*/ ctx[16].disableClose && $8721fac3cbf33e27$var$create_if_block_5$1(ctx);
    let if_block3 = /*$modalStep$*/ (ctx[5] === 'selectingWallet' || /*windowWidth*/ ctx[4] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) && $8721fac3cbf33e27$var$create_if_block_3$1(ctx);
    let if_block4 = /*displayConnectingWallet*/ ctx[11] && $8721fac3cbf33e27$var$create_if_block_2$1(ctx);
    let if_block5 = /*$modalStep$*/ ctx[5] === 'connectedWallet' && /*selectedWallet*/ ctx[3] && /*windowWidth*/ ctx[4] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && $8721fac3cbf33e27$var$create_if_block_1$1(ctx);
    return {
        c () {
            div2 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if_block1.c();
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (if_block3) if_block3.c();
            t3 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block4) if_block4.c();
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block5) if_block5.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "scroll-container svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "content flex flex-column svelte-1qwmck3");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div2, "class", "container svelte-1qwmck3");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div2, anchor);
            if (if_block0) if_block0.m(div2, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div2, div1);
            if_block1.m(div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t1);
            if (if_block2) if_block2.m(div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            if (if_block3) if_block3.m(div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t3);
            if (if_block4) if_block4.m(div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div0, t4);
            if (if_block5) if_block5.m(div0, null);
            /*div0_binding*/ ctx[25](div0);
            current = true;
        },
        p (ctx, dirty) {
            if (/*connect*/ ctx[16].showSidebar) if_block0.p(ctx, dirty);
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) if_block1.p(ctx, dirty);
            else {
                if_block1.d(1);
                if_block1 = current_block_type(ctx);
                if (if_block1) {
                    if_block1.c();
                    if_block1.m(div1, t1);
                }
            }
            if (!/*connect*/ ctx[16].disableClose) if_block2.p(ctx, dirty);
            if (/*$modalStep$*/ ctx[5] === 'selectingWallet' || /*windowWidth*/ ctx[4] <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty[0] & /*$modalStep$, windowWidth*/ 48) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block3, 1);
                } else {
                    if_block3 = $8721fac3cbf33e27$var$create_if_block_3$1(ctx);
                    if_block3.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block3, 1);
                    if_block3.m(div0, t3);
                }
            } else if (if_block3) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*displayConnectingWallet*/ ctx[11]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty[0] & /*displayConnectingWallet*/ 2048) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block4, 1);
                } else {
                    if_block4 = $8721fac3cbf33e27$var$create_if_block_2$1(ctx);
                    if_block4.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block4, 1);
                    if_block4.m(div0, t4);
                }
            } else if (if_block4) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*$modalStep$*/ ctx[5] === 'connectedWallet' && /*selectedWallet*/ ctx[3] && /*windowWidth*/ ctx[4] >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty[0] & /*$modalStep$, selectedWallet, windowWidth*/ 56) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block5, 1);
                } else {
                    if_block5 = $8721fac3cbf33e27$var$create_if_block_1$1(ctx);
                    if_block5.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block5, 1);
                    if_block5.m(div0, null);
                }
            } else if (if_block5) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block2);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block3);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block4);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block5);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block0);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block2);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block3);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block4);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block5);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div2);
            if (if_block0) if_block0.d();
            if_block1.d();
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
            if (if_block4) if_block4.d();
            if (if_block5) if_block5.d();
            /*div0_binding*/ ctx[25](null);
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$4(ctx) {
    let if_block_anchor;
    let current;
    let mounted;
    let dispose;
    $8721fac3cbf33e27$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[23]);
    let if_block = !/*autoSelect*/ ctx[0].disableModals && $8721fac3cbf33e27$var$create_if_block$2(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[23]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (!/*autoSelect*/ ctx[0].disableModals) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty[0] & /*autoSelect*/ 1) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $8721fac3cbf33e27$var$create_if_block$2(ctx);
                    if_block.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$instance$4($$self, $$props, $$invalidate) {
    let availableWallets;
    let displayConnectingWallet;
    let $appMetadata$;
    let $modalStep$;
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(14, $_ = $$value));
    let { autoSelect: autoSelect } = $$props;
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(13, $appMetadata$ = value));
    const { walletModules: walletModules, connect: connect, chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
    const cancelPreviousConnect$ = new (0, $62AF9.Subject)();
    const { unstoppableResolution: unstoppableResolution, wagmi: wagmi } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    let connectionRejected = false;
    let previousConnectionRequest = false;
    let wallets = [];
    let selectedWallet;
    let agreed;
    let connectingWalletLabel;
    let connectingErrorMessage;
    let windowWidth;
    let scrollContainer;
    const modalStep$ = new (0, $a6zBK.BehaviorSubject)('selectingWallet');
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, modalStep$, (value)=>$$invalidate(5, $modalStep$ = value));
    // handle the edge case where disableModals was set to true on first call
    // and then set to false on second call and there is still a pending call
    $8721fac3cbf33e27$export$a07804094c3ecf2d.pipe((0, $44850.distinctUntilChanged)((prev, curr)=>prev.autoSelect && curr.autoSelect && prev.autoSelect.disableModals === curr.autoSelect.disableModals), (0, $9vj9x.filter)(({ autoSelect: autoSelect })=>autoSelect && autoSelect.disableModals === false), (0, $gybEh.takeUntil)($8721fac3cbf33e27$var$onDestroy$)).subscribe(()=>{
        selectedWallet && connectWallet();
    });
    // ==== SELECT WALLET ==== //
    async function selectWallet({ label: label, icon: icon, getInterface: getInterface }) {
        $$invalidate(8, connectingWalletLabel = label);
        try {
            const existingWallet = $8721fac3cbf33e27$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
            if (existingWallet) {
                // set as first wallet
                $8721fac3cbf33e27$var$addWallet(existingWallet);
                setTimeout(()=>setStep('connectedWallet'), 1);
                $$invalidate(3, selectedWallet = existingWallet);
                return;
            }
            const { chains: chains } = $8721fac3cbf33e27$export$6559d589eb85fbb6.get();
            const { provider: provider, instance: instance } = await getInterface({
                chains: chains,
                EventEmitter: (/*@__PURE__*/$parcel$interopDefault($1VClN)),
                appMetadata: $appMetadata$
            });
            const loadedIcon = await icon;
            $$invalidate(3, selectedWallet = {
                label: label,
                icon: loadedIcon,
                provider: provider,
                instance: instance,
                accounts: [],
                chains: [
                    {
                        namespace: 'evm',
                        id: '0x1'
                    }
                ]
            });
            $$invalidate(9, connectingErrorMessage = '');
            scrollToTop();
            // change step on next event loop
            setTimeout(()=>setStep('connectingWallet'), 1);
        } catch (error) {
            const { message: message } = error;
            $$invalidate(9, connectingErrorMessage = message);
            $$invalidate(8, connectingWalletLabel = '');
            scrollToTop();
        }
    }
    function deselectWallet() {
        $$invalidate(3, selectedWallet = null);
    }
    function updateSelectedWallet(update) {
        $$invalidate(3, selectedWallet = Object.assign(Object.assign({}, selectedWallet), update));
    }
    async function autoSelectWallet(wallet) {
        const { getIcon: getIcon, getInterface: getInterface, label: label } = wallet;
        const icon = getIcon();
        selectWallet({
            label: label,
            icon: icon,
            getInterface: getInterface
        });
    }
    async function loadWalletsForSelection() {
        $$invalidate(2, wallets = walletModules.map(({ getIcon: getIcon, getInterface: getInterface, label: label })=>{
            return {
                label: label,
                icon: getIcon(),
                getInterface: getInterface
            };
        }));
    }
    function close() {
        $8721fac3cbf33e27$export$a07804094c3ecf2d.next({
            inProgress: false
        });
    }
    // ==== CONNECT WALLET ==== //
    async function connectWallet() {
        $$invalidate(1, connectionRejected = false);
        const { provider: provider, label: label } = selectedWallet;
        cancelPreviousConnect$.next();
        try {
            let address;
            let wagmiConnector;
            if (wagmi) {
                const { buildWagmiConfig: buildWagmiConfig, wagmiConnect: wagmiConnect, getWagmiConnector: getWagmiConnector } = wagmi;
                const wagmiConfig = await buildWagmiConfig(chains, {
                    label: label,
                    provider: provider
                });
                $8721fac3cbf33e27$var$updateWagmiConfig(wagmiConfig);
                wagmiConnector = getWagmiConnector(label);
                const accountsReq = await Promise.race([
                    wagmiConnect(wagmiConfig, {
                        connector: wagmiConnector
                    }),
                    // or connect wallet is called again whilst waiting for response
                    (0, $lqWQ2.firstValueFrom)(cancelPreviousConnect$.pipe((0, $aXPYD.mapTo)([])))
                ]);
                // canceled previous request
                if (!accountsReq || !('accounts' in accountsReq)) return;
                const [connectedAddress] = accountsReq.accounts;
                address = connectedAddress;
            } else {
                const [connectedAddress] = await Promise.race([
                    // resolved account
                    $8721fac3cbf33e27$var$requestAccounts(provider),
                    // or connect wallet is called again whilst waiting for response
                    (0, $lqWQ2.firstValueFrom)(cancelPreviousConnect$.pipe((0, $aXPYD.mapTo)([])))
                ]);
                // canceled previous request
                if (!connectedAddress) return;
                address = connectedAddress;
            }
            // store last connected wallet
            if ($8721fac3cbf33e27$export$6559d589eb85fbb6.get().connect.autoConnectLastWallet || $8721fac3cbf33e27$export$6559d589eb85fbb6.get().connect.autoConnectAllPreviousWallet) {
                let labelsList = $8721fac3cbf33e27$var$getLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
                try {
                    let labelsListParsed = JSON.parse(labelsList);
                    if (labelsListParsed && Array.isArray(labelsListParsed)) {
                        const tempLabels = labelsListParsed;
                        labelsList = [
                            ...new Set([
                                label,
                                ...tempLabels
                            ])
                        ];
                    }
                } catch (err) {
                    if (err instanceof SyntaxError && labelsList && typeof labelsList === 'string') {
                        const tempLabel = labelsList;
                        labelsList = [
                            tempLabel
                        ];
                    } else throw new Error(err);
                }
                if (!labelsList) labelsList = [
                    label
                ];
                $8721fac3cbf33e27$var$setLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(labelsList));
            }
            const chain = await $8721fac3cbf33e27$var$getChainId(provider);
            const update = {
                accounts: [
                    {
                        address: address,
                        ens: null,
                        uns: null,
                        balance: null
                    }
                ],
                chains: [
                    {
                        namespace: 'evm',
                        id: chain
                    }
                ],
                wagmiConnector: wagmiConnector
            };
            $8721fac3cbf33e27$var$addWallet(Object.assign(Object.assign({}, selectedWallet), update));
            $8721fac3cbf33e27$var$trackWallet(provider, label);
            updateSelectedWallet(update);
            setStep('connectedWallet');
            scrollToTop();
        } catch (error) {
            const { code: code } = error;
            scrollToTop();
            // user rejected account access
            if (code === (0, $bKBH7.ProviderRpcErrorCode).ACCOUNT_ACCESS_REJECTED) {
                $$invalidate(1, connectionRejected = true);
                if (autoSelect.disableModals) $8721fac3cbf33e27$export$a07804094c3ecf2d.next({
                    inProgress: false
                });
                else if (autoSelect.label) $$invalidate(0, autoSelect.label = '', autoSelect);
                return;
            }
            // account access has already been requested and is awaiting approval
            if (code === (0, $bKBH7.ProviderRpcErrorCode).ACCOUNT_ACCESS_ALREADY_REQUESTED) {
                $$invalidate(6, previousConnectionRequest = true);
                if (autoSelect.disableModals) {
                    $8721fac3cbf33e27$export$a07804094c3ecf2d.next({
                        inProgress: false
                    });
                    return;
                }
                $8721fac3cbf33e27$var$listenAccountsChanged({
                    provider: selectedWallet.provider,
                    disconnected$: $8721fac3cbf33e27$export$a07804094c3ecf2d.pipe((0, $9vj9x.filter)(({ inProgress: inProgress })=>!inProgress), (0, $aXPYD.mapTo)(''))
                }).pipe((0, $kgoiB.take)(1)).subscribe(([account])=>{
                    account && connectWallet();
                });
                return;
            }
        }
    }
    // ==== CONNECTED WALLET ==== //
    async function updateAccountDetails() {
        const { accounts: accounts, chains: selectedWalletChains } = selectedWallet;
        const appChains = $8721fac3cbf33e27$export$6559d589eb85fbb6.get().chains;
        const [connectedWalletChain] = selectedWalletChains;
        const appChain = appChains.find(({ namespace: namespace, id: id })=>namespace === connectedWalletChain.namespace && id === connectedWalletChain.id);
        const { address: address } = accounts[0];
        let { balance: balance, ens: ens, uns: uns, secondaryTokens: secondaryTokens } = accounts[0];
        if (balance === null) $8721fac3cbf33e27$var$getBalance(address, appChain).then((balance)=>{
            $8721fac3cbf33e27$var$updateAccount(selectedWallet.label, address, {
                balance: balance
            });
        });
        if (appChain && !secondaryTokens && Array.isArray(appChain.secondaryTokens) && appChain.secondaryTokens.length) $8721fac3cbf33e27$var$updateSecondaryTokens(address, appChain).then((secondaryTokens)=>{
            $8721fac3cbf33e27$var$updateAccount(selectedWallet.label, address, {
                secondaryTokens: secondaryTokens
            });
        });
        if (ens === null && $8721fac3cbf33e27$var$validEnsChain(connectedWalletChain.id)) {
            const ensChain = chains.find(({ id: id })=>id === $8721fac3cbf33e27$var$validEnsChain(connectedWalletChain.id));
            $8721fac3cbf33e27$var$getEns(address, ensChain).then((ens)=>{
                $8721fac3cbf33e27$var$updateAccount(selectedWallet.label, address, {
                    ens: ens
                });
            });
        }
        if (uns === null && unstoppableResolution) $8721fac3cbf33e27$var$getUns(address, appChain).then((uns)=>{
            $8721fac3cbf33e27$var$updateAccount(selectedWallet.label, address, {
                uns: uns
            });
        });
        setTimeout(()=>$8721fac3cbf33e27$export$a07804094c3ecf2d.next({
                inProgress: false
            }), 1500);
    }
    modalStep$.pipe((0, $gybEh.takeUntil)($8721fac3cbf33e27$var$onDestroy$)).subscribe((step)=>{
        switch(step){
            case 'selectingWallet':
                if (autoSelect.label) {
                    const walletToAutoSelect = walletModules.find(({ label: label })=>label.toLowerCase() === autoSelect.label.toLowerCase());
                    if (walletToAutoSelect) autoSelectWallet(walletToAutoSelect);
                    else if (autoSelect.disableModals) $8721fac3cbf33e27$export$a07804094c3ecf2d.next({
                        inProgress: false
                    });
                } else {
                    $$invalidate(8, connectingWalletLabel = '');
                    loadWalletsForSelection();
                }
                break;
            case 'connectingWallet':
                connectWallet();
                break;
            case 'connectedWallet':
                $$invalidate(8, connectingWalletLabel = '');
                updateAccountDetails();
                break;
        }
    });
    function setStep(update) {
        cancelPreviousConnect$.next();
        modalStep$.next(update);
    }
    function scrollToTop() {
        scrollContainer && scrollContainer.scrollTo(0, 0);
    }
    function onwindowresize() {
        $$invalidate(4, windowWidth = window.innerWidth);
    }
    function agreement_agreed_binding(value) {
        agreed = value;
        $$invalidate(7, agreed);
    }
    function div0_binding($$value) {
        $8721fac3cbf33e27$export$39b482c5e57630a8[$$value ? 'unshift' : 'push'](()=>{
            scrollContainer = $$value;
            $$invalidate(10, scrollContainer);
        });
    }
    $$self.$$set = ($$props)=>{
        if ('autoSelect' in $$props) $$invalidate(0, autoSelect = $$props.autoSelect);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*wallets*/ 4) $$invalidate(12, availableWallets = wallets.length - $8721fac3cbf33e27$export$6559d589eb85fbb6.get().wallets.length);
        if ($$self.$$.dirty[0] & /*$modalStep$, selectedWallet, windowWidth, connectionRejected*/ 58) $$invalidate(11, displayConnectingWallet = $modalStep$ === 'connectingWallet' && selectedWallet && windowWidth >= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH || windowWidth <= $8721fac3cbf33e27$var$MOBILE_WINDOW_WIDTH && connectionRejected && $modalStep$ === 'connectingWallet' && selectedWallet);
    };
    return [
        autoSelect,
        connectionRejected,
        wallets,
        selectedWallet,
        windowWidth,
        $modalStep$,
        previousConnectionRequest,
        agreed,
        connectingWalletLabel,
        connectingErrorMessage,
        scrollContainer,
        displayConnectingWallet,
        availableWallets,
        $appMetadata$,
        $_,
        appMetadata$,
        connect,
        modalStep$,
        selectWallet,
        deselectWallet,
        close,
        connectWallet,
        setStep,
        onwindowresize,
        agreement_agreed_binding,
        div0_binding
    ];
}
class $8721fac3cbf33e27$var$Index$1 extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$4, $8721fac3cbf33e27$var$create_fragment$4, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            autoSelect: 0
        }, $8721fac3cbf33e27$var$add_css$4, [
            -1,
            -1
        ]);
    }
}
/* src/views/chain/SwitchChain.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$3(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-12yam41", ".container.svelte-12yam41{padding:var(--onboard-spacing-4, var(--spacing-4));font-family:var(--onboard-font-family-normal, var(--font-family-normal));line-height:16px;font-size:var(--onboard-font-size-5, var(--font-size-5))}.close.svelte-12yam41{top:var(--onboard-spacing-5, var(--spacing-5));right:var(--onboard-spacing-5, var(--spacing-5));padding:0.5rem}h4.svelte-12yam41{font-size:var(--onboard-font-size-3, var(--font-size-3));margin:var(--onboard-spacing-4, var(--spacing-4)) 0}p.svelte-12yam41{margin:0 0 var(--onboard-spacing-4, var(--spacing-4)) 0;max-width:488px}");
}
// (45:0) <Modal {close}>
function $8721fac3cbf33e27$var$create_default_slot$1(ctx) {
    let div1;
    let h4;
    let t0_value = /*$_*/ ctx[0]('modals.switchChain.heading', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.modals.switchChain.heading
    }) + "";
    let t0;
    let t1;
    let p0;
    let t2_value = /*$_*/ ctx[0]('modals.switchChain.paragraph1', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.modals.switchChain.paragraph1,
        values: {
            app: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].name || 'This app',
            nextNetworkName: /*nextNetworkName*/ ctx[2]
        }
    }) + "";
    let t2;
    let t3;
    let p1;
    let t4_value = /*$_*/ ctx[0]('modals.switchChain.paragraph2', {
        default: $8721fac3cbf33e27$export$e7094788287c5e9b.modals.switchChain.paragraph2
    }) + "";
    let t4;
    let t5;
    let div0;
    let closebutton;
    let current;
    let mounted;
    let dispose;
    closebutton = new $8721fac3cbf33e27$var$CloseButton({});
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            h4 = $8721fac3cbf33e27$export$35e795649ee09318("h4");
            t0 = $8721fac3cbf33e27$export$625550452a3fa3ec(t0_value);
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            p0 = $8721fac3cbf33e27$export$35e795649ee09318("p");
            t2 = $8721fac3cbf33e27$export$625550452a3fa3ec(t2_value);
            t3 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            p1 = $8721fac3cbf33e27$export$35e795649ee09318("p");
            t4 = $8721fac3cbf33e27$export$625550452a3fa3ec(t4_value);
            t5 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(closebutton.$$.fragment);
            $8721fac3cbf33e27$export$342063e11d6c3cad(h4, "class", "svelte-12yam41");
            $8721fac3cbf33e27$export$342063e11d6c3cad(p0, "class", "svelte-12yam41");
            $8721fac3cbf33e27$export$342063e11d6c3cad(p1, "class", "svelte-12yam41");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "close absolute svelte-12yam41");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "container relative svelte-12yam41");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, h4);
            $8721fac3cbf33e27$export$953cecd6e717a553(h4, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, p0);
            $8721fac3cbf33e27$export$953cecd6e717a553(p0, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, p1);
            $8721fac3cbf33e27$export$953cecd6e717a553(p1, t4);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t5);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            $8721fac3cbf33e27$export$9bb611d729802a56(closebutton, div0, null);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(div0, "click", /*close*/ ctx[3]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if ((!current || dirty & /*$_*/ 1) && t0_value !== (t0_value = /*$_*/ ctx[0]('modals.switchChain.heading', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.modals.switchChain.heading
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t0, t0_value);
            if ((!current || dirty & /*$_, $appMetadata$*/ 3) && t2_value !== (t2_value = /*$_*/ ctx[0]('modals.switchChain.paragraph1', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.modals.switchChain.paragraph1,
                values: {
                    app: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].name || 'This app',
                    nextNetworkName: /*nextNetworkName*/ ctx[2]
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t2, t2_value);
            if ((!current || dirty & /*$_*/ 1) && t4_value !== (t4_value = /*$_*/ ctx[0]('modals.switchChain.paragraph2', {
                default: $8721fac3cbf33e27$export$e7094788287c5e9b.modals.switchChain.paragraph2
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t4, t4_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(closebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(closebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
            $8721fac3cbf33e27$export$3466f893ebf79586(closebutton);
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$3(ctx) {
    let modal;
    let current;
    modal = new $8721fac3cbf33e27$export$8743009a87fcb00f({
        props: {
            close: /*close*/ ctx[3],
            $$slots: {
                default: [
                    $8721fac3cbf33e27$var$create_default_slot$1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const modal_changes = {};
            if (dirty & /*$$scope, $_, $appMetadata$*/ 67) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(modal, detaching);
        }
    };
}
function $8721fac3cbf33e27$var$instance$3($$self, $$props, $$invalidate) {
    let $switchChainModal$;
    let $_;
    let $appMetadata$;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, $8721fac3cbf33e27$var$switchChainModal$, ($$value)=>$$invalidate(5, $switchChainModal$ = $$value));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(0, $_ = $$value));
    const nextNetworkName = $switchChainModal$.chain.label;
    function close() {
        $8721fac3cbf33e27$var$switchChainModal$.next(null);
    }
    const appMetadata$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('appMetadata').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().appMetadata), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(1, $appMetadata$ = value));
    return [
        $_,
        $appMetadata$,
        nextNetworkName,
        close,
        appMetadata$
    ];
}
class $8721fac3cbf33e27$var$SwitchChain extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$3, $8721fac3cbf33e27$var$create_fragment$3, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {}, $8721fac3cbf33e27$var$add_css$3);
    }
}
/* src/views/shared/InfoIcon.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$2(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-z54y2j", ".icon.svelte-z54y2j{border-radius:50px;color:var(--onboard-primary-500, var(--primary-500))}");
}
function $8721fac3cbf33e27$var$create_fragment$2(ctx) {
    let div;
    let div_style_value;
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "icon flex svelte-z54y2j");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px;`);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $8721fac3cbf33e27$var$infoIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px;`)) $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value);
        },
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
        }
    };
}
function $8721fac3cbf33e27$var$instance$2($$self, $$props, $$invalidate) {
    let { size: size = 20 } = $$props;
    $$self.$$set = ($$props)=>{
        if ('size' in $$props) $$invalidate(0, size = $$props.size);
    };
    return [
        size
    ];
}
class $8721fac3cbf33e27$var$InfoIcon extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$2, $8721fac3cbf33e27$var$create_fragment$2, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            size: 0
        }, $8721fac3cbf33e27$var$add_css$2);
    }
}
/* src/views/connect/ActionRequired.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css$1(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-20hjq1", ".content.svelte-20hjq1{padding:1rem;width:300px;font-family:var(--onboard-font-family-normal, var(--font-family-normal));font-size:var(--onboard-font-size-5, var(--font-size-5));line-height:24px;background:var(\n      --onboard-action-required-modal-background,\n      var(--onboard-white, var(--white))\n    )}.icon-container.svelte-20hjq1{width:3rem;height:3rem;background:var(--onboard-primary-100, var(--primary-100));border-radius:24px}h4.svelte-20hjq1{margin:1.5rem 0 0.5rem 0;font-weight:600}.action-required-heading.svelte-20hjq1,.action-required-info.svelte-20hjq1{color:var(\n      --onboard-action-required-text-color,\n      var(--onboard-black, inherit)\n    )}.action-required-btn.svelte-20hjq1{color:var(\n      --onboard-action-required-btn-text-color,\n      var(--onboard-black, inherit)\n    )}p.svelte-20hjq1{margin:0;font-weight:400}a.svelte-20hjq1{font-weight:600}button.svelte-20hjq1{margin-top:1.5rem;font-weight:600}");
}
// (79:6) {#if wallet === 'MetaMask'}
function $8721fac3cbf33e27$var$create_if_block$1(ctx) {
    let a;
    let t_value = /*$_*/ ctx[1]('modals.actionRequired.linkText', {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t;
    return {
        c () {
            a = $8721fac3cbf33e27$export$35e795649ee09318("a");
            t = $8721fac3cbf33e27$export$625550452a3fa3ec(t_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "href", "https://metamask.zendesk.com/hc/en-us/articles/360061346311-Switching-accounts-in-MetaMask");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "target", "_blank");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
            $8721fac3cbf33e27$export$342063e11d6c3cad(a, "class", "svelte-20hjq1");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, a, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(a, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, wallet*/ 3 && t_value !== (t_value = /*$_*/ ctx[1]('modals.actionRequired.linkText', {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(a);
        }
    };
}
// (66:0) <Modal {close}>
function $8721fac3cbf33e27$var$create_default_slot(ctx) {
    let div1;
    let div0;
    let infoicon;
    let t0;
    let h4;
    let t1_value = /*$_*/ ctx[1]('modals.actionRequired.heading', {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t1;
    let t2;
    let p;
    let t3_value = /*$_*/ ctx[1]('modals.actionRequired.paragraph', {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t3;
    let t4;
    let t5;
    let button;
    let t6_value = /*$_*/ ctx[1]('modals.actionRequired.buttonText') + "";
    let t6;
    let current;
    let mounted;
    let dispose;
    infoicon = new $8721fac3cbf33e27$var$InfoIcon({});
    let if_block = /*wallet*/ ctx[0] === 'MetaMask' && $8721fac3cbf33e27$var$create_if_block$1(ctx);
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            $8721fac3cbf33e27$export$d66501df72047452(infoicon.$$.fragment);
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            h4 = $8721fac3cbf33e27$export$35e795649ee09318("h4");
            t1 = $8721fac3cbf33e27$export$625550452a3fa3ec(t1_value);
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            p = $8721fac3cbf33e27$export$35e795649ee09318("p");
            t3 = $8721fac3cbf33e27$export$625550452a3fa3ec(t3_value);
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            t5 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            button = $8721fac3cbf33e27$export$35e795649ee09318("button");
            t6 = $8721fac3cbf33e27$export$625550452a3fa3ec(t6_value);
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "class", "icon-container flex justify-center items-center svelte-20hjq1");
            $8721fac3cbf33e27$export$342063e11d6c3cad(h4, "class", "action-required-heading svelte-20hjq1");
            $8721fac3cbf33e27$export$342063e11d6c3cad(p, "class", "action-required-info svelte-20hjq1");
            $8721fac3cbf33e27$export$342063e11d6c3cad(button, "class", "button-neutral-solid rounded action-required-btn svelte-20hjq1");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "content svelte-20hjq1");
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            $8721fac3cbf33e27$export$9bb611d729802a56(infoicon, div0, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, h4);
            $8721fac3cbf33e27$export$953cecd6e717a553(h4, t1);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t2);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, p);
            $8721fac3cbf33e27$export$953cecd6e717a553(p, t3);
            $8721fac3cbf33e27$export$953cecd6e717a553(p, t4);
            if (if_block) if_block.m(p, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t5);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, button);
            $8721fac3cbf33e27$export$953cecd6e717a553(button, t6);
            current = true;
            if (!mounted) {
                dispose = $8721fac3cbf33e27$export$ffb5f4729a158638(button, "click", /*close*/ ctx[2]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if ((!current || dirty & /*$_, wallet*/ 3) && t1_value !== (t1_value = /*$_*/ ctx[1]('modals.actionRequired.heading', {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t1, t1_value);
            if ((!current || dirty & /*$_, wallet*/ 3) && t3_value !== (t3_value = /*$_*/ ctx[1]('modals.actionRequired.paragraph', {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t3, t3_value);
            if (/*wallet*/ ctx[0] === 'MetaMask') {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $8721fac3cbf33e27$var$create_if_block$1(ctx);
                    if_block.c();
                    if_block.m(p, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            if ((!current || dirty & /*$_*/ 2) && t6_value !== (t6_value = /*$_*/ ctx[1]('modals.actionRequired.buttonText') + "")) $8721fac3cbf33e27$export$90a7f3efeed30595(t6, t6_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(infoicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(infoicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
            $8721fac3cbf33e27$export$3466f893ebf79586(infoicon);
            if (if_block) if_block.d();
            mounted = false;
            dispose();
        }
    };
}
function $8721fac3cbf33e27$var$create_fragment$1(ctx) {
    let modal;
    let current;
    modal = new $8721fac3cbf33e27$export$8743009a87fcb00f({
        props: {
            close: /*close*/ ctx[2],
            $$slots: {
                default: [
                    $8721fac3cbf33e27$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const modal_changes = {};
            if (dirty & /*$$scope, $_, wallet*/ 11) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(modal, detaching);
        }
    };
}
function $8721fac3cbf33e27$var$instance$1($$self, $$props, $$invalidate) {
    let $_;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, (0, $fQSUm._), ($$value)=>$$invalidate(1, $_ = $$value));
    let { wallet: wallet } = $$props;
    function close() {
        $8721fac3cbf33e27$export$a07804094c3ecf2d.next({
            inProgress: false,
            actionRequired: ''
        });
    }
    $$self.$$set = ($$props)=>{
        if ('wallet' in $$props) $$invalidate(0, wallet = $$props.wallet);
    };
    return [
        wallet,
        $_,
        close
    ];
}
class $8721fac3cbf33e27$var$ActionRequired extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance$1, $8721fac3cbf33e27$var$create_fragment$1, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {
            wallet: 0
        }, $8721fac3cbf33e27$var$add_css$1);
    }
}
/* src/views/Index.svelte generated by Svelte v3.59.2 */ function $8721fac3cbf33e27$var$add_css(target) {
    $8721fac3cbf33e27$export$407448d2b89b1813(target, "svelte-w5zexe", ".flex{display:flex}.inline-flex{display:inline-flex}.flex-column{flex-direction:column}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-center{justify-content:center}.justify-start{justify-content:flex-start}.justify-between{justify-content:space-between}.justify-end{justify-content:flex-end}.justify-around{justify-content:space-around}.relative{position:relative}.absolute{position:absolute}.fixed{position:fixed}.pointer{cursor:pointer}.shadow-1{box-shadow:var(--onboard-shadow-1, var(--shadow-1))}.w-100{width:100%}*{box-sizing:border-box}input{background:var(--onboard-white, var(--white))}input{width:100%;padding:0.5rem 1rem;outline:2px solid var(--onboard-gray-200, var(--gray-200));border:none;border-radius:8px;font-size:1rem;line-height:1.5;color:var(--onboard-gray-600, var(--gray-600));transition:all 200ms ease-in-out}input[type='checkbox']{-webkit-appearance:none;appearance:none;width:auto;background:var(--onboard-white, var(--white));outline:1px solid var(--onboard-gray-300, var(--gray-300));border:none;padding:0.5em;border-radius:3px;display:flex;justify-content:center;align-items:center;position:relative;cursor:pointer}input[type='checkbox']:hover{border-color:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    )}input[type='checkbox']:checked{background:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    );border-color:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    );color:var(--onboard-checkbox-color, var(--onboard-white, var(--white)))}input[type='checkbox']:checked:after{content:url(\"data:image/svg+xml,%3Csvg width='0.885em' height='0.6em' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 6L5 11L14 2L12.59 0.58L5 8.17L1.41 4.59L0 6Z' fill='white'/%3E%3C/svg%3E\");font-size:12px;position:absolute;color:var(--onboard-checkbox-color, var(--onboard-white, var(--white)))}input:hover{border-color:var(\n      --onboard-checkbox-color,\n      var(--onboard-white, var(--white))\n    )}input:focus{border-color:var(--onboard-primary-500, var(--primary-500));box-shadow:0 0 1px 1px\n      var(\n        --onboard-checkbox-background,\n        var(--onboard-primary-500, var(--primary-500))\n      );box-shadow:0 0 0 1px -moz-mac-focusring}input:disabled, textarea:disabled, select:disabled{background:var(--gray-100)}input::-moz-focus-inner{outline:0;padding:0;margin-top:-2px;margin-bottom:-2px}a{color:var(\n      --onboard-link-color,\n      var(--onboard-primary-500, var(--primary-500))\n    );text-decoration:none}a:hover{text-decoration:underline}button{display:flex;align-items:center;justify-content:center;padding:calc(var(--onboard-spacing-4, var(--spacing-4)) - 1px);border-radius:24px;cursor:pointer;font:inherit;border:none;transition:background-color 150ms ease-in-out, color 150ms ease-in-out}.onboard-button-primary{background:var(--onboard-white, var(--white));padding:calc(var(--onboard-spacing-5, var(--spacing-5)) - 1px)\n      calc(var(--onboard-spacing-4, var(--spacing-4)) - 1px);color:var(--onboard-gray-500, var(--gray-500));font-size:var(--onboard-font-size-6, var(--font-size-6));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3));border:1px solid var(--onboard-gray-500, var(--gray-500));font-weight:600}.button-neutral-solid{width:100%;border-radius:8px;background:var(--onboard-gray-500, var(--gray-500));color:var(--onboard-white, var(--white));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3))}.button-neutral-solid-b{width:100%;background:var(--onboard-gray-100, var(--gray-100));color:var(--onboard-gray-500, var(--gray-500));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3))}button.rounded{border-radius:24px}.button-neutral-solid:hover{background:var(--onboard-gray-700, var(--gray-700))}.button-neutral-solid-b:hover{background:var(--onboard-gray-200, var(--gray-200))}.button-neutral-solid:active{color:var(--onboard-gray-300, var(--gray-300))}.button-neutral-solid-b:active{color:var(--onboard-gray-600, var(--gray-600));background:var(--onboard-gray-300, var(--gray-300))}.container.svelte-w5zexe{padding:16px;font-family:var(--onboard-font-family-normal, var(--font-family-normal));pointer-events:none;touch-action:none;width:100%}.z-indexed.svelte-w5zexe{z-index:var(--account-center-z-index)}@media all and (min-width: 428px){.container.svelte-w5zexe{max-width:348px}}");
}
// (364:0) {#if $connectWallet$.inProgress}
function $8721fac3cbf33e27$var$create_if_block_13(ctx) {
    let connect;
    let current;
    connect = new $8721fac3cbf33e27$var$Index$1({
        props: {
            autoSelect: /*$connectWallet$*/ ctx[8].autoSelect
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(connect.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(connect, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connect_changes = {};
            if (dirty & /*$connectWallet$*/ 256) connect_changes.autoSelect = /*$connectWallet$*/ ctx[8].autoSelect;
            connect.$set(connect_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(connect.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(connect.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(connect, detaching);
        }
    };
}
// (368:0) {#if $connectWallet$.actionRequired}
function $8721fac3cbf33e27$var$create_if_block_12(ctx) {
    let actionrequired;
    let current;
    actionrequired = new $8721fac3cbf33e27$var$ActionRequired({
        props: {
            wallet: /*$connectWallet$*/ ctx[8].actionRequired
        }
    });
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(actionrequired.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(actionrequired, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const actionrequired_changes = {};
            if (dirty & /*$connectWallet$*/ 256) actionrequired_changes.wallet = /*$connectWallet$*/ ctx[8].actionRequired;
            actionrequired.$set(actionrequired_changes);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(actionrequired.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(actionrequired.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(actionrequired, detaching);
        }
    };
}
// (372:0) {#if $switchChainModal$}
function $8721fac3cbf33e27$var$create_if_block_11(ctx) {
    let switchchain;
    let current;
    switchchain = new $8721fac3cbf33e27$var$SwitchChain({});
    return {
        c () {
            $8721fac3cbf33e27$export$d66501df72047452(switchchain.$$.fragment);
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$9bb611d729802a56(switchchain, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(switchchain.$$.fragment, local);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(switchchain.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $8721fac3cbf33e27$export$3466f893ebf79586(switchchain, detaching);
        }
    };
}
// (376:0) {#if displayAccountCenterNotifySameContainer}
function $8721fac3cbf33e27$var$create_if_block_5(ctx) {
    let div1;
    let show_if_1 = /*$notify$*/ ctx[3].position.includes('bottom') && /*$accountCenter$*/ ctx[1].position.includes('bottom') && /*samePositionOrMobile*/ ctx[7];
    let t0;
    let div0;
    let t1;
    let show_if = /*$notify$*/ ctx[3].position.includes('top') && /*$accountCenter$*/ ctx[1].position.includes('top') && /*samePositionOrMobile*/ ctx[7];
    let div1_style_value;
    let current;
    let if_block0 = show_if_1 && $8721fac3cbf33e27$var$create_if_block_9(ctx);
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $8721fac3cbf33e27$var$create_pending_block_3,
        then: $8721fac3cbf33e27$var$create_then_block_3,
        catch: $8721fac3cbf33e27$var$create_catch_block_3,
        value: 23,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $8721fac3cbf33e27$export$71511d61b312f219(/*accountCenterComponent*/ ctx[16], info);
    let if_block1 = show_if && $8721fac3cbf33e27$var$create_if_block_6(ctx);
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            info.block.c();
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div0, "id", "account-center-with-notify");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($8721fac3cbf33e27$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('top') ? 'padding-bottom: 0;' : /*device*/ ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('bottom') ? 'padding-top:0;' : '') + ""));
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t0);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            info.block.m(div0, info.anchor = null);
            info.mount = ()=>div0;
            info.anchor = null;
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, t1);
            if (if_block1) if_block1.m(div1, null);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) show_if_1 = /*$notify$*/ ctx[3].position.includes('bottom') && /*$accountCenter$*/ ctx[1].position.includes('bottom') && /*samePositionOrMobile*/ ctx[7];
            if (show_if_1) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $8721fac3cbf33e27$var$create_if_block_9(ctx);
                    if_block0.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty);
            if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) show_if = /*$notify$*/ ctx[3].position.includes('top') && /*$accountCenter$*/ ctx[1].position.includes('top') && /*samePositionOrMobile*/ ctx[7];
            if (show_if) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $8721fac3cbf33e27$var$create_if_block_6(ctx);
                    if_block1.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(div1, null);
                }
            } else if (if_block1) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (!current || dirty & /*$accountCenter$*/ 2 && div1_style_value !== (div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($8721fac3cbf33e27$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('top') ? 'padding-bottom: 0;' : /*device*/ ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('bottom') ? 'padding-top:0;' : '') + ""))) $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(info.block);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block0);
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $8721fac3cbf33e27$export$ebd11618f299a286(block);
            }
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            info.block.d();
            info.token = null;
            info = null;
            if (if_block1) if_block1.d();
        }
    };
}
// (387:4) {#if $notify$.position.includes('bottom') && $accountCenter$.position.includes('bottom') && samePositionOrMobile}
function $8721fac3cbf33e27$var$create_if_block_9(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $8721fac3cbf33e27$var$create_pending_block_4,
        then: $8721fac3cbf33e27$var$create_then_block_4,
        catch: $8721fac3cbf33e27$var$create_catch_block_4,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $8721fac3cbf33e27$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            await_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $8721fac3cbf33e27$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_catch_block_4(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (388:42)          {#if Notify}
function $8721fac3cbf33e27$var$create_then_block_4(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $8721fac3cbf33e27$var$create_if_block_10(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (389:8) {#if Notify}
function $8721fac3cbf33e27$var$create_if_block_10(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $8721fac3cbf33e27$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $8721fac3cbf33e27$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $8721fac3cbf33e27$export$3466f893ebf79586(old_component, 1);
                    });
                    $8721fac3cbf33e27$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $8721fac3cbf33e27$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $8721fac3cbf33e27$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_pending_block_4(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_catch_block_3(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (400:56)          {#if AccountCenter}
function $8721fac3cbf33e27$var$create_then_block_3(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*AccountCenter*/ ctx[23] && $8721fac3cbf33e27$var$create_if_block_8(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*AccountCenter*/ ctx[23]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (401:8) {#if AccountCenter}
function $8721fac3cbf33e27$var$create_if_block_8(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*AccountCenter*/ ctx[23];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props());
    return {
        c () {
            if (switch_instance) $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (switch_value !== (switch_value = /*AccountCenter*/ ctx[23])) {
                if (switch_instance) {
                    $8721fac3cbf33e27$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $8721fac3cbf33e27$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $8721fac3cbf33e27$export$3466f893ebf79586(old_component, 1);
                    });
                    $8721fac3cbf33e27$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props());
                    $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            }
        },
        i (local) {
            if (current) return;
            if (switch_instance) $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $8721fac3cbf33e27$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $8721fac3cbf33e27$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_pending_block_3(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (406:4) {#if $notify$.position.includes('top') && $accountCenter$.position.includes('top') && samePositionOrMobile}
function $8721fac3cbf33e27$var$create_if_block_6(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $8721fac3cbf33e27$var$create_pending_block_2,
        then: $8721fac3cbf33e27$var$create_then_block_2,
        catch: $8721fac3cbf33e27$var$create_catch_block_2,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $8721fac3cbf33e27$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            await_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $8721fac3cbf33e27$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_catch_block_2(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (407:42)          {#if Notify}
function $8721fac3cbf33e27$var$create_then_block_2(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $8721fac3cbf33e27$var$create_if_block_7(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (408:8) {#if Notify}
function $8721fac3cbf33e27$var$create_if_block_7(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $8721fac3cbf33e27$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $8721fac3cbf33e27$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $8721fac3cbf33e27$export$3466f893ebf79586(old_component, 1);
                    });
                    $8721fac3cbf33e27$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $8721fac3cbf33e27$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $8721fac3cbf33e27$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_pending_block_2(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (420:0) {#if displayAccountCenterSeparate}
function $8721fac3cbf33e27$var$create_if_block_2(ctx) {
    let div1;
    let div0;
    let div1_style_value;
    let current;
    let if_block = /*$accountCenter$*/ ctx[1].enabled && /*$wallets$*/ ctx[2].length && $8721fac3cbf33e27$var$create_if_block_3(ctx);
    return {
        c () {
            div1 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            div0 = $8721fac3cbf33e27$export$35e795649ee09318("div");
            if (if_block) if_block.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($8721fac3cbf33e27$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('top') ? 'padding-bottom: 0;' : /*device*/ ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('bottom') ? 'padding-top:0;' : '') + ""));
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div1, anchor);
            $8721fac3cbf33e27$export$953cecd6e717a553(div1, div0);
            if (if_block) if_block.m(div0, null);
            current = true;
        },
        p (ctx, dirty) {
            if (/*$accountCenter$*/ ctx[1].enabled && /*$wallets$*/ ctx[2].length) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*$accountCenter$, $wallets$*/ 6) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $8721fac3cbf33e27$var$create_if_block_3(ctx);
                    if_block.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(div0, null);
                }
            } else if (if_block) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (!current || dirty & /*$accountCenter$*/ 2 && div1_style_value !== (div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($8721fac3cbf33e27$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('top') ? 'padding-bottom: 0;' : /*device*/ ctx[11].type === 'mobile' && /*$accountCenter$*/ ctx[1].position.includes('bottom') ? 'padding-top:0;' : '') + ""))) $8721fac3cbf33e27$export$342063e11d6c3cad(div1, "style", div1_style_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div1);
            if (if_block) if_block.d();
        }
    };
}
// (432:6) {#if $accountCenter$.enabled && $wallets$.length}
function $8721fac3cbf33e27$var$create_if_block_3(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $8721fac3cbf33e27$var$create_pending_block_1,
        then: $8721fac3cbf33e27$var$create_then_block_1,
        catch: $8721fac3cbf33e27$var$create_catch_block_1,
        value: 23,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $8721fac3cbf33e27$export$71511d61b312f219(/*accountCenterComponent*/ ctx[16], info);
    return {
        c () {
            await_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $8721fac3cbf33e27$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_catch_block_1(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (433:58)            {#if AccountCenter}
function $8721fac3cbf33e27$var$create_then_block_1(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*AccountCenter*/ ctx[23] && $8721fac3cbf33e27$var$create_if_block_4(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*AccountCenter*/ ctx[23]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (434:10) {#if AccountCenter}
function $8721fac3cbf33e27$var$create_if_block_4(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*AccountCenter*/ ctx[23];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props());
    return {
        c () {
            if (switch_instance) $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (switch_value !== (switch_value = /*AccountCenter*/ ctx[23])) {
                if (switch_instance) {
                    $8721fac3cbf33e27$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $8721fac3cbf33e27$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $8721fac3cbf33e27$export$3466f893ebf79586(old_component, 1);
                    });
                    $8721fac3cbf33e27$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props());
                    $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            }
        },
        i (local) {
            if (current) return;
            if (switch_instance) $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $8721fac3cbf33e27$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $8721fac3cbf33e27$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_pending_block_1(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (442:0) {#if displayNotifySeparate}
function $8721fac3cbf33e27$var$create_if_block(ctx) {
    let div;
    let div_style_value;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $8721fac3cbf33e27$var$create_pending_block,
        then: $8721fac3cbf33e27$var$create_then_block,
        catch: $8721fac3cbf33e27$var$create_catch_block,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $8721fac3cbf33e27$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            div = $8721fac3cbf33e27$export$35e795649ee09318("div");
            info.block.c();
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($8721fac3cbf33e27$var$notifyPositioning)[/*$notify$*/ ctx[3].position] + "; " + /*device*/ (ctx[11].type === 'mobile' && /*$notify$*/ ctx[3].position.includes('top') ? 'padding-bottom: 0;' : /*device*/ ctx[11].type === 'mobile' && /*$notify$*/ ctx[3].position.includes('bottom') ? 'padding-top:0;' : '') + ""));
        },
        m (target, anchor) {
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, div, anchor);
            info.block.m(div, info.anchor = null);
            info.mount = ()=>div;
            info.anchor = null;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $8721fac3cbf33e27$export$3d8c2f653ac9d0b9(info, ctx, dirty);
            if (!current || dirty & /*$notify$*/ 8 && div_style_value !== (div_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($8721fac3cbf33e27$var$notifyPositioning)[/*$notify$*/ ctx[3].position] + "; " + /*device*/ (ctx[11].type === 'mobile' && /*$notify$*/ ctx[3].position.includes('top') ? 'padding-bottom: 0;' : /*device*/ ctx[11].type === 'mobile' && /*$notify$*/ ctx[3].position.includes('bottom') ? 'padding-top:0;' : '') + ""))) $8721fac3cbf33e27$export$342063e11d6c3cad(div, "style", div_style_value);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $8721fac3cbf33e27$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(div);
            info.block.d();
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_catch_block(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
// (453:40)        {#if Notify}
function $8721fac3cbf33e27$var$create_then_block(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $8721fac3cbf33e27$var$create_if_block_1(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (454:6) {#if Notify}
function $8721fac3cbf33e27$var$create_if_block_1(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $8721fac3cbf33e27$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $8721fac3cbf33e27$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $8721fac3cbf33e27$export$3466f893ebf79586(old_component, 1);
                    });
                    $8721fac3cbf33e27$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $8721fac3cbf33e27$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $8721fac3cbf33e27$export$d66501df72047452(switch_instance.$$.fragment);
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $8721fac3cbf33e27$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $8721fac3cbf33e27$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $8721fac3cbf33e27$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $8721fac3cbf33e27$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $8721fac3cbf33e27$var$create_pending_block(ctx) {
    return {
        c: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        m: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        p: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        i: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        o: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5,
        d: $8721fac3cbf33e27$export$7ccc53e8f1e7dfc5
    };
}
function $8721fac3cbf33e27$var$create_fragment(ctx) {
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let if_block5_anchor;
    let current;
    let if_block0 = /*$connectWallet$*/ ctx[8].inProgress && $8721fac3cbf33e27$var$create_if_block_13(ctx);
    let if_block1 = /*$connectWallet$*/ ctx[8].actionRequired && $8721fac3cbf33e27$var$create_if_block_12(ctx);
    let if_block2 = /*$switchChainModal$*/ ctx[9] && $8721fac3cbf33e27$var$create_if_block_11();
    let if_block3 = /*displayAccountCenterNotifySameContainer*/ ctx[4] && $8721fac3cbf33e27$var$create_if_block_5(ctx);
    let if_block4 = /*displayAccountCenterSeparate*/ ctx[5] && $8721fac3cbf33e27$var$create_if_block_2(ctx);
    let if_block5 = /*displayNotifySeparate*/ ctx[6] && $8721fac3cbf33e27$var$create_if_block(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t1 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t2 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            t3 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block4) if_block4.c();
            t4 = $8721fac3cbf33e27$export$2329c99376c9d0a4();
            if (if_block5) if_block5.c();
            if_block5_anchor = $8721fac3cbf33e27$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t1, anchor);
            if (if_block2) if_block2.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t2, anchor);
            if (if_block3) if_block3.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t3, anchor);
            if (if_block4) if_block4.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, t4, anchor);
            if (if_block5) if_block5.m(target, anchor);
            $8721fac3cbf33e27$export$8b22cf2602fb60ce(target, if_block5_anchor, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*$connectWallet$*/ ctx[8].inProgress) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$connectWallet$*/ 256) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $8721fac3cbf33e27$var$create_if_block_13(ctx);
                    if_block0.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*$connectWallet$*/ ctx[8].actionRequired) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$connectWallet$*/ 256) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $8721fac3cbf33e27$var$create_if_block_12(ctx);
                    if_block1.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*$switchChainModal$*/ ctx[9]) {
                if (if_block2) {
                    if (dirty & /*$switchChainModal$*/ 512) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block2, 1);
                } else {
                    if_block2 = $8721fac3cbf33e27$var$create_if_block_11();
                    if_block2.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block2, 1);
                    if_block2.m(t2.parentNode, t2);
                }
            } else if (if_block2) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*displayAccountCenterNotifySameContainer*/ ctx[4]) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty & /*displayAccountCenterNotifySameContainer*/ 16) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block3, 1);
                } else {
                    if_block3 = $8721fac3cbf33e27$var$create_if_block_5(ctx);
                    if_block3.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block3, 1);
                    if_block3.m(t3.parentNode, t3);
                }
            } else if (if_block3) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*displayAccountCenterSeparate*/ ctx[5]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty & /*displayAccountCenterSeparate*/ 32) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block4, 1);
                } else {
                    if_block4 = $8721fac3cbf33e27$var$create_if_block_2(ctx);
                    if_block4.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block4, 1);
                    if_block4.m(t4.parentNode, t4);
                }
            } else if (if_block4) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
            if (/*displayNotifySeparate*/ ctx[6]) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty & /*displayNotifySeparate*/ 64) $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block5, 1);
                } else {
                    if_block5 = $8721fac3cbf33e27$var$create_if_block(ctx);
                    if_block5.c();
                    $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block5, 1);
                    if_block5.m(if_block5_anchor.parentNode, if_block5_anchor);
                }
            } else if (if_block5) {
                $8721fac3cbf33e27$export$4a5767248b18ef41();
                $8721fac3cbf33e27$export$ebd11618f299a286(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                $8721fac3cbf33e27$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block0);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block1);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block2);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block3);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block4);
            $8721fac3cbf33e27$export$d141bba7fdc215a3(if_block5);
            current = true;
        },
        o (local) {
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block0);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block1);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block2);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block3);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block4);
            $8721fac3cbf33e27$export$ebd11618f299a286(if_block5);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t1);
            if (if_block2) if_block2.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t2);
            if (if_block3) if_block3.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t3);
            if (if_block4) if_block4.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(t4);
            if (if_block5) if_block5.d(detaching);
            if (detaching) $8721fac3cbf33e27$export$4368d992c4eafac0(if_block5_anchor);
        }
    };
}
const $8721fac3cbf33e27$var$accountCenterPositioning = 'account-center';
const $8721fac3cbf33e27$var$notifyPositioning = 'notify-onboard-container';


function $8721fac3cbf33e27$var$instance($$self, $$props, $$invalidate) {
    let sharedContainer;
    let samePositionOrMobile;
    let sharedMobileContainerCheck;
    let displayNotifySeparate;
    let displayAccountCenterSeparate;
    let displayAccountCenterNotifySameContainer;
    let $accountCenter$;
    let $wallets$;
    let $notify$;
    let $connectWallet$;
    let $switchChainModal$;
    let $notifications$;
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, $8721fac3cbf33e27$export$efccba1c4a2ef57b, ($$value)=>$$invalidate(2, $wallets$ = $$value));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, $8721fac3cbf33e27$export$a07804094c3ecf2d, ($$value)=>$$invalidate(8, $connectWallet$ = $$value));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, $8721fac3cbf33e27$var$switchChainModal$, ($$value)=>$$invalidate(9, $switchChainModal$ = $$value));
    const { device: device, containerElements: containerElements } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    const accountCenter$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('accountCenter').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().accountCenter), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, accountCenter$, (value)=>$$invalidate(1, $accountCenter$ = value));
    const notify$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('notify').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().notify), (0, $3nJ2a.shareReplay)(1));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, notify$, (value)=>$$invalidate(3, $notify$ = value));
    const notifications$ = $8721fac3cbf33e27$export$6559d589eb85fbb6.select('notifications').pipe((0, $fPFN5.startWith)($8721fac3cbf33e27$export$6559d589eb85fbb6.get().notifications));
    $8721fac3cbf33e27$export$db3b6bfb95261072($$self, notifications$, (value)=>$$invalidate(10, $notifications$ = value));
    const setPositioningDefaults = (targetComponentVariable)=>{
        return {
            topLeft: `
        top: var(--${targetComponentVariable}-position-top, 0); 
        left: var(--${targetComponentVariable}-position-left, 0);`,
            topRight: `
        top: var(--${targetComponentVariable}-position-top, 0); 
        right: var(--${targetComponentVariable}-position-right, 0);`,
            bottomRight: `
        bottom: var(--${targetComponentVariable}-position-bottom, 0); 
        right: var(--${targetComponentVariable}-position-right, 0);`,
            bottomLeft: `
        bottom: var(--${targetComponentVariable}-position-bottom, 0); 
        left: var(--${targetComponentVariable}-position-left, 0);`
        };
    };
    const accountCenterComponent = $accountCenter$.enabled ? (parcelRequire("4GCYn")).then((mod)=>mod.default) : Promise.resolve(null);
    const notifyComponent = $notify$.enabled ? (parcelRequire("5K51q")).then((mod)=>mod.default) : Promise.resolve(null);
    const accountCenterMountToElement = $accountCenter$.enabled && containerElements && containerElements.accountCenter;
    const attachCompToDom = (domEl, targetEl, component, compSettings)=>{
        const target = domEl.attachShadow({
            mode: 'open'
        });
        let getW3OEl = document.querySelector('onboard-v2');
        let w3OStyleSheets = getW3OEl.shadowRoot.styleSheets;
        const copiedStyleSheet = new CSSStyleSheet();
        // Copy Onboard stylesheets over to AccountCenter shadow DOM
        Object.values(w3OStyleSheets).forEach((sheet)=>{
            const styleRules = Object.values(sheet.cssRules);
            styleRules.forEach((rule)=>copiedStyleSheet.insertRule(rule.cssText));
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        target.adoptedStyleSheets = [
            copiedStyleSheet
        ];
        const containerElement = document.querySelector(targetEl);
        containerElement.appendChild(domEl);
        if (!containerElement) throw new Error(`Element with query ${targetEl} does not exist.`);
        const getACComp = async ()=>{
            let newComp = await component;
            if (newComp) new newComp({
                target: target,
                props: {
                    settings: compSettings,
                    mountInContainer: true
                }
            });
        };
        getACComp();
    };
    if (accountCenterMountToElement) {
        const accountCenter = document.createElement('onboard-account-center');
        attachCompToDom(accountCenter, accountCenterMountToElement, accountCenterComponent, $accountCenter$);
    }
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*$accountCenter$, $notify$*/ 10) $$invalidate(0, sharedContainer = !accountCenterMountToElement && $accountCenter$.enabled && $notify$.enabled && $notify$.position === $accountCenter$.position);
        if ($$self.$$.dirty & /*$accountCenter$, $notify$*/ 10) $$invalidate(7, samePositionOrMobile = device.type === 'mobile' || $accountCenter$.position === $notify$.position);
        if ($$self.$$.dirty & /*$notify$, $accountCenter$*/ 10) $$invalidate(18, sharedMobileContainerCheck = $notify$.position.includes('bottom') && $accountCenter$.position.includes('bottom') || $notify$.position.includes('top') && $accountCenter$.position.includes('top'));
        if ($$self.$$.dirty & /*$notify$, $accountCenter$, sharedMobileContainerCheck, $wallets$*/ 262158) $$invalidate(6, displayNotifySeparate = $notify$.enabled && (!$accountCenter$.enabled || accountCenterMountToElement || $notify$.position !== $accountCenter$.position && device.type !== 'mobile' || device.type === 'mobile' && !sharedMobileContainerCheck || !$wallets$.length));
        if ($$self.$$.dirty & /*$accountCenter$, $notify$, sharedMobileContainerCheck, $wallets$*/ 262158) $$invalidate(5, displayAccountCenterSeparate = $accountCenter$.enabled && (!$notify$.enabled || $notify$.position !== $accountCenter$.position && device.type !== 'mobile' || device.type === 'mobile' && !sharedMobileContainerCheck) && $wallets$.length);
        if ($$self.$$.dirty & /*$notify$, $accountCenter$, sharedContainer, sharedMobileContainerCheck, $wallets$*/ 262159) $$invalidate(4, displayAccountCenterNotifySameContainer = $notify$.enabled && $accountCenter$.enabled && (sharedContainer || device.type === 'mobile' && sharedMobileContainerCheck) && $wallets$.length);
    };
    return [
        sharedContainer,
        $accountCenter$,
        $wallets$,
        $notify$,
        displayAccountCenterNotifySameContainer,
        displayAccountCenterSeparate,
        displayNotifySeparate,
        samePositionOrMobile,
        $connectWallet$,
        $switchChainModal$,
        $notifications$,
        device,
        accountCenter$,
        notify$,
        notifications$,
        setPositioningDefaults,
        accountCenterComponent,
        notifyComponent,
        sharedMobileContainerCheck
    ];
}
class $8721fac3cbf33e27$var$Index extends $8721fac3cbf33e27$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $8721fac3cbf33e27$export$23f2a1d2818174ef(this, options, $8721fac3cbf33e27$var$instance, $8721fac3cbf33e27$var$create_fragment, $8721fac3cbf33e27$export$2408f22a0fab9ae5, {}, $8721fac3cbf33e27$var$add_css);
    }
}
const $8721fac3cbf33e27$var$API = {
    connectWallet: $8721fac3cbf33e27$export$3b513254972cfc9c,
    disconnectWallet: $8721fac3cbf33e27$export$56c0d5a1e737357d,
    setChain: $8721fac3cbf33e27$export$2d1720544b23b823,
    state: {
        get: $8721fac3cbf33e27$export$6559d589eb85fbb6.get,
        select: $8721fac3cbf33e27$export$6559d589eb85fbb6.select,
        actions: {
            setWalletModules: $8721fac3cbf33e27$var$setWalletModules,
            setLocale: $8721fac3cbf33e27$var$setLocale,
            updateNotify: $8721fac3cbf33e27$var$updateNotify,
            customNotification: $8721fac3cbf33e27$var$customNotification,
            updateBalances: $8721fac3cbf33e27$var$updateBalances,
            updateAccountCenter: $8721fac3cbf33e27$export$1a82df3d29112e01,
            setPrimaryWallet: $8721fac3cbf33e27$export$c4ce752e73470fba,
            updateTheme: $8721fac3cbf33e27$var$updateTheme,
            updateAppMetadata: $8721fac3cbf33e27$var$updateAppMetadata
        }
    }
};
function $8721fac3cbf33e27$export$9d398bebfec1c039(options) {
    if (typeof window === 'undefined') return $8721fac3cbf33e27$var$API;
    if (options) {
        const error = $8721fac3cbf33e27$var$validateInitOptions(options);
        if (error) throw error;
    }
    const { wallets: wallets, chains: chains, appMetadata: appMetadata, i18n: i18n, accountCenter: accountCenter, notify: notify, gas: gas, connect: connect, containerElements: containerElements, transactionPreview: transactionPreview, theme: theme, disableFontDownload: disableFontDownload, unstoppableResolution: unstoppableResolution, wagmi: wagmi } = options;
    if (containerElements) $8721fac3cbf33e27$var$updateConfiguration({
        containerElements: containerElements
    });
    const { device: device, svelteInstance: svelteInstance } = $8721fac3cbf33e27$export$c9170ad7d4cd7e57;
    if (svelteInstance) {
        // if already initialized, need to cleanup old instance
        console.warn('Re-initializing Onboard and resetting back to initial state');
        $8721fac3cbf33e27$var$reset$.next();
    }
    $8721fac3cbf33e27$var$initialize(i18n);
    $8721fac3cbf33e27$var$addChains($8721fac3cbf33e27$var$chainIdToHex(chains));
    if (typeof connect !== 'undefined') $8721fac3cbf33e27$var$updateConnectModal(connect);
    // update accountCenter
    if (typeof accountCenter !== 'undefined') {
        let accountCenterUpdate;
        const { hideTransactionProtectionBtn: hideTransactionProtectionBtn, transactionProtectionInfoLink: transactionProtectionInfoLink } = accountCenter;
        if (device.type === 'mobile') accountCenterUpdate = Object.assign(Object.assign(Object.assign({}, $8721fac3cbf33e27$var$APP_INITIAL_STATE.accountCenter), {
            hideTransactionProtectionBtn: hideTransactionProtectionBtn,
            transactionProtectionInfoLink: transactionProtectionInfoLink
        }), accountCenter.mobile ? accountCenter.mobile : {});
        else if (accountCenter.desktop) accountCenterUpdate = Object.assign(Object.assign(Object.assign({}, $8721fac3cbf33e27$var$APP_INITIAL_STATE.accountCenter), {
            hideTransactionProtectionBtn: hideTransactionProtectionBtn,
            transactionProtectionInfoLink: transactionProtectionInfoLink
        }), accountCenter.desktop);
        if (typeof accountCenterUpdate !== 'undefined') $8721fac3cbf33e27$export$1a82df3d29112e01(accountCenterUpdate);
    }
    let wagmiApi;
    if (typeof wagmi !== 'undefined') wagmiApi = wagmi(Object.assign({
        disconnect: $8721fac3cbf33e27$export$56c0d5a1e737357d,
        updateChain: $8721fac3cbf33e27$var$updateChain
    }, $8721fac3cbf33e27$var$wagmiProviderMethods()));
    // update notify
    if (typeof notify !== 'undefined') {
        console.warn(`Support for notifications on transaction state changes have been deprecated. Custom notifications can still be sent ot the user.`);
        if ('desktop' in notify || 'mobile' in notify) {
            const error = $8721fac3cbf33e27$var$validateNotifyOptions(notify);
            if (error) throw error;
            if (notify && notify.desktop && notify.desktop.position && accountCenter && accountCenter.desktop && accountCenter.desktop.position) notify.desktop.position = accountCenter.desktop.position;
            if (notify && notify.mobile && notify.mobile.position && accountCenter && accountCenter.mobile && accountCenter.mobile.position) notify.mobile.position = accountCenter.mobile.position;
            let notifyUpdate = {};
            if (device.type === 'mobile' && notify.mobile) notifyUpdate = Object.assign(Object.assign({}, $8721fac3cbf33e27$var$APP_INITIAL_STATE.notify), notify.mobile);
            else if (notify.desktop) notifyUpdate = Object.assign(Object.assign({}, $8721fac3cbf33e27$var$APP_INITIAL_STATE.notify), notify.desktop);
            $8721fac3cbf33e27$var$updateNotify(notifyUpdate);
        } else {
            const error = $8721fac3cbf33e27$var$validateNotify(notify);
            if (error) throw error;
            const notifyUpdate = Object.assign(Object.assign({}, $8721fac3cbf33e27$var$APP_INITIAL_STATE.notify), notify);
            $8721fac3cbf33e27$var$updateNotify(notifyUpdate);
        }
    } else {
        const notifyUpdate = $8721fac3cbf33e27$var$APP_INITIAL_STATE.notify;
        $8721fac3cbf33e27$var$updateNotify(notifyUpdate);
    }
    const app = svelteInstance || $8721fac3cbf33e27$var$mountApp(theme || {}, disableFontDownload || false);
    $8721fac3cbf33e27$var$updateConfiguration({
        svelteInstance: app,
        initialWalletInit: wallets,
        gas: gas,
        unstoppableResolution: unstoppableResolution,
        wagmi: wagmiApi
    });
    appMetadata && $8721fac3cbf33e27$var$updateAppMetadata(appMetadata);
    if (transactionPreview) console.error('Transaction Preview support has been removed and is no longer supported within Web3-Onboard');
    theme && $8721fac3cbf33e27$var$updateTheme(theme);
    // handle auto connection of last wallet
    if (connect && (connect.autoConnectLastWallet || connect.autoConnectAllPreviousWallet)) {
        const lastConnectedWallets = $8721fac3cbf33e27$var$getLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
        try {
            const lastConnectedWalletsParsed = JSON.parse(lastConnectedWallets);
            if (lastConnectedWalletsParsed && Array.isArray(lastConnectedWalletsParsed) && lastConnectedWalletsParsed.length) $8721fac3cbf33e27$var$connectAllPreviousWallets(lastConnectedWalletsParsed, connect);
            if (lastConnectedWalletsParsed && typeof lastConnectedWalletsParsed === 'string') $8721fac3cbf33e27$var$connectAllPreviousWallets([
                lastConnectedWalletsParsed
            ], connect);
        } catch (err) {
            // Handle for legacy single wallet approach
            // Above try will throw syntax error is local storage is not json
            if (err instanceof SyntaxError && lastConnectedWallets) $8721fac3cbf33e27$var$API.connectWallet({
                autoSelect: {
                    label: lastConnectedWallets,
                    disableModals: true
                }
            });
        }
    }
    return $8721fac3cbf33e27$var$API;
}
const $8721fac3cbf33e27$var$fontFamilyExternallyDefined = (theme, disableFontDownload)=>{
    if (disableFontDownload) return true;
    if (document.body && (getComputedStyle(document.body).getPropertyValue('--onboard-font-family-normal') || getComputedStyle(document.body).getPropertyValue('--w3o-font-family'))) return true;
    if (!theme) return false;
    if (typeof theme === 'object' && theme['--w3o-font-family']) return true;
    return false;
};

const $8721fac3cbf33e27$var$importInterFont = async ()=>{
    const { InterVar: InterVar } = await Promise.resolve((parcelRequire("8YciW")));
    // Add Fonts to main page
    const styleEl = document.createElement('style');
    styleEl.innerHTML = `
    ${InterVar}
  `;
    document.body.appendChild(styleEl);
};
const $8721fac3cbf33e27$var$connectAllPreviousWallets = async (lastConnectedWallets, connect)=>{
    const activeWalletsList = [];
    const parsedWalletList = lastConnectedWallets;
    if (!connect.autoConnectAllPreviousWallet) {
        $8721fac3cbf33e27$var$API.connectWallet({
            autoSelect: {
                label: parsedWalletList[0],
                disableModals: true
            }
        });
        activeWalletsList.push(parsedWalletList[0]);
    } else // Loop in reverse to maintain wallet order
    for(let i = parsedWalletList.length; i--;){
        const walletConnectionPromise = await $8721fac3cbf33e27$var$API.connectWallet({
            autoSelect: {
                label: parsedWalletList[i],
                disableModals: true
            }
        });
        // Update localStorage list for available wallets
        if (walletConnectionPromise.some((r)=>r.label === parsedWalletList[i])) activeWalletsList.unshift(parsedWalletList[i]);
    }
    $8721fac3cbf33e27$var$setLocalStore($8721fac3cbf33e27$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(activeWalletsList));
};
function $8721fac3cbf33e27$var$mountApp(theme, disableFontDownload) {
    class Onboard extends HTMLElement {
        constructor(){
            super();
        }
    }
    if (!customElements.get('onboard-v2')) customElements.define('onboard-v2', Onboard);
    if (!$8721fac3cbf33e27$var$fontFamilyExternallyDefined(theme, disableFontDownload)) $8721fac3cbf33e27$var$importInterFont();
    // add to DOM
    const onboard = document.createElement('onboard-v2');
    const target = onboard.attachShadow({
        mode: 'open'
    });
    onboard.style.all = 'initial';
    target.innerHTML = `

  <style>
    :host {
          /* COLORS */
          --white: white;
          --black: black;
          --primary-1: #2F80ED;
          --primary-100: #eff1fc;
          --primary-200: #d0d4f7;
          --primary-300: #b1b8f2;
          --primary-400: #929bed;
          --primary-500: #6370e5;
          --primary-600: #454ea0;
          --primary-700: #323873;
          --gray-100: #ebebed;
          --gray-200: #c2c4c9;
          --gray-300: #999ca5;
          --gray-400: #707481;
          --gray-500: #33394b;
          --gray-600: #242835;
          --gray-700: #1a1d26;
          --success-100: #d1fae3;
          --success-200: #baf7d5;
          --success-300: #a4f4c6;
          --success-400: #8df2b8;
          --success-500: #5aec99;
          --success-600: #18ce66;
          --success-700: #129b4d;
          --danger-100: #ffe5e6;
          --danger-200: #ffcccc;
          --danger-300: #ffb3b3;
          --danger-400: #ff8080;
          --danger-500: #ff4f4f;
          --danger-600: #cc0000;
          --danger-700: #660000;
          --warning-100: #ffefcc;
          --warning-200: #ffe7b3;
          --warning-300: #ffd780;
          --warning-400: #ffc74c;
          --warning-500: #ffaf00;
          --warning-600: #cc8c00;
          --warning-700: #664600;

          /* FONTS */
          --font-family-normal: var(--w3o-font-family, Inter, sans-serif);

          --font-size-1: 3rem;
          --font-size-2: 2.25rem;
          --font-size-3: 1.5rem;
          --font-size-4: 1.25rem;
          --font-size-5: 1rem;
          --font-size-6: .875rem;
          --font-size-7: .75rem;

          --font-line-height-1: 24px;
          --font-line-height-2: 20px;
          --font-line-height-3: 16px;
          --font-line-height-4: 12px;

          /* SPACING */
          --spacing-1: 3rem;
          --spacing-2: 2rem;
          --spacing-3: 1.5rem;
          --spacing-4: 1rem;
          --spacing-5: 0.5rem;
          --spacing-6: 0.25rem;
          --spacing-7: 0.125rem;

          /* BORDER RADIUS */
          --border-radius-1: 24px;
          --border-radius-2: 20px;
          --border-radius-3: 16px;
          --border-radius-4: 12px;
          --border-radius-5: 8px;

          /* SHADOWS */
          --shadow-0: none;
          --shadow-1: 0px 4px 12px rgba(0, 0, 0, 0.1);
          --shadow-2: inset 0px -1px 0px rgba(0, 0, 0, 0.1);
          --shadow-3: 0px 4px 16px rgba(0, 0, 0, 0.2);

          /* MODAL POSITIONING */
          --modal-z-index: 10;
          --modal-top: unset;
          --modal-right: unset;
          --modal-bottom: unset;
          --modal-left: unset;

          /* MODAL STYLES */
          --modal-backdrop: rgba(0, 0, 0, 0.6);

        }
      </style>
    `;
    let connectModalContEl;
    if ($8721fac3cbf33e27$export$c9170ad7d4cd7e57 && $8721fac3cbf33e27$export$c9170ad7d4cd7e57.containerElements && $8721fac3cbf33e27$export$c9170ad7d4cd7e57.containerElements.connectModal) connectModalContEl = $8721fac3cbf33e27$export$c9170ad7d4cd7e57.containerElements.connectModal;
    const containerElementQuery = connectModalContEl || $8721fac3cbf33e27$export$6559d589eb85fbb6.get().accountCenter.containerElement || 'body';
    const containerElement = document.querySelector(containerElementQuery);
    if (!containerElement) throw new Error(`Element with query ${containerElementQuery} does not exist.`);
    containerElement.appendChild(onboard);
    const app = new $8721fac3cbf33e27$var$Index({
        target: target
    });
    return app;
}

});
parcelRegister("a6zBK", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", () => $75b615e8451b076c$export$cc3d42e6b2b9cf8b);

var $bp3BB = parcelRequire("bp3BB");

var $62AF9 = parcelRequire("62AF9");
var $75b615e8451b076c$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $bp3BB.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $62AF9.Subject));

});
parcelRegister("bp3BB", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $d0d692a303f6e647$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $d0d692a303f6e647$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $d0d692a303f6e647$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $d0d692a303f6e647$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $d0d692a303f6e647$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $d0d692a303f6e647$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $d0d692a303f6e647$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $d0d692a303f6e647$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $d0d692a303f6e647$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $d0d692a303f6e647$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $d0d692a303f6e647$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $d0d692a303f6e647$var$extendStatics = function(d, b) {
    $d0d692a303f6e647$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d0d692a303f6e647$var$extendStatics(d, b);
};
function $d0d692a303f6e647$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d0d692a303f6e647$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d0d692a303f6e647$export$18ce0697a983be9b = function() {
    $d0d692a303f6e647$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d0d692a303f6e647$export$18ce0697a983be9b.apply(this, arguments);
};
function $d0d692a303f6e647$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d0d692a303f6e647$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d0d692a303f6e647$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d0d692a303f6e647$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d0d692a303f6e647$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d0d692a303f6e647$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d0d692a303f6e647$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d0d692a303f6e647$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d0d692a303f6e647$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d0d692a303f6e647$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d0d692a303f6e647$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d0d692a303f6e647$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d0d692a303f6e647$export$45d3717a4c69092e(o, m, p);
}
function $d0d692a303f6e647$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d0d692a303f6e647$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d0d692a303f6e647$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d0d692a303f6e647$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d0d692a303f6e647$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d0d692a303f6e647$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d0d692a303f6e647$export$10c90e4f7922046c(v) {
    return this instanceof $d0d692a303f6e647$export$10c90e4f7922046c ? (this.v = v, this) : new $d0d692a303f6e647$export$10c90e4f7922046c(v);
}
function $d0d692a303f6e647$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d0d692a303f6e647$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d0d692a303f6e647$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d0d692a303f6e647$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d0d692a303f6e647$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d0d692a303f6e647$export$19a8beecd37a4c45 === "function" ? $d0d692a303f6e647$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d0d692a303f6e647$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d0d692a303f6e647$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $d0d692a303f6e647$var$ownKeys = function(o) {
    $d0d692a303f6e647$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $d0d692a303f6e647$var$ownKeys(o);
};
function $d0d692a303f6e647$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $d0d692a303f6e647$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $d0d692a303f6e647$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $d0d692a303f6e647$var$__setModuleDefault(result, mod);
    return result;
}
function $d0d692a303f6e647$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d0d692a303f6e647$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d0d692a303f6e647$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d0d692a303f6e647$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d0d692a303f6e647$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d0d692a303f6e647$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d0d692a303f6e647$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d0d692a303f6e647$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $d0d692a303f6e647$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $d0d692a303f6e647$export$2e2bcd8739ae039 = {
    __extends: $d0d692a303f6e647$export$a8ba968b8961cb8a,
    __assign: $d0d692a303f6e647$export$18ce0697a983be9b,
    __rest: $d0d692a303f6e647$export$3c9a16f847548506,
    __decorate: $d0d692a303f6e647$export$29e00dfd3077644b,
    __param: $d0d692a303f6e647$export$d5ad3fd78186038f,
    __esDecorate: $d0d692a303f6e647$export$3a84e1ae4e97e9b0,
    __runInitializers: $d0d692a303f6e647$export$d831c04e792af3d,
    __propKey: $d0d692a303f6e647$export$6a2a36740a146cb8,
    __setFunctionName: $d0d692a303f6e647$export$d1a06452d3489bc7,
    __metadata: $d0d692a303f6e647$export$f1db080c865becb9,
    __awaiter: $d0d692a303f6e647$export$1050f835b63b671e,
    __generator: $d0d692a303f6e647$export$67ebef60e6f28a6,
    __createBinding: $d0d692a303f6e647$export$45d3717a4c69092e,
    __exportStar: $d0d692a303f6e647$export$f33643c0debef087,
    __values: $d0d692a303f6e647$export$19a8beecd37a4c45,
    __read: $d0d692a303f6e647$export$8d051b38c9118094,
    __spread: $d0d692a303f6e647$export$afc72e2116322959,
    __spreadArrays: $d0d692a303f6e647$export$6388937ca91ccae8,
    __spreadArray: $d0d692a303f6e647$export$1216008129fb82ed,
    __await: $d0d692a303f6e647$export$10c90e4f7922046c,
    __asyncGenerator: $d0d692a303f6e647$export$e427f37a30a4de9b,
    __asyncDelegator: $d0d692a303f6e647$export$bbd80228419bb833,
    __asyncValues: $d0d692a303f6e647$export$e3b29a3d6162315f,
    __makeTemplateObject: $d0d692a303f6e647$export$4fb47efe1390b86f,
    __importStar: $d0d692a303f6e647$export$c21735bcef00d192,
    __importDefault: $d0d692a303f6e647$export$da59b14a69baef04,
    __classPrivateFieldGet: $d0d692a303f6e647$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d0d692a303f6e647$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d0d692a303f6e647$export$81fdc39f203e4e04,
    __addDisposableResource: $d0d692a303f6e647$export$88ac25d8e944e405,
    __disposeResources: $d0d692a303f6e647$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $d0d692a303f6e647$export$889dfb5d17574b0b
};

});

parcelRegister("62AF9", function(module, exports) {

$parcel$export(module.exports, "Subject", () => $465f5e6a21a47850$export$b6bbab5a9b109038);

var $bp3BB = parcelRequire("bp3BB");

var $jJg4u = parcelRequire("jJg4u");

var $iyJaq = parcelRequire("iyJaq");

var $2v0qJ = parcelRequire("2v0qJ");

var $gXM9D = parcelRequire("gXM9D");

var $jQp2V = parcelRequire("jQp2V");
var $465f5e6a21a47850$export$b6bbab5a9b109038 = function(_super) {
    (0, $bp3BB.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $465f5e6a21a47850$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $2v0qJ.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $jQp2V.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $bp3BB.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $jQp2V.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $jQp2V.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $iyJaq.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $iyJaq.Subscription)(function() {
            _this.currentObservers = null;
            (0, $gXM9D.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $jJg4u.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $465f5e6a21a47850$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $jJg4u.Observable));
var $465f5e6a21a47850$export$155189cde295587d = function(_super) {
    (0, $bp3BB.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $iyJaq.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($465f5e6a21a47850$export$b6bbab5a9b109038);

});
parcelRegister("jJg4u", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $03b4e1cd71b9b470$export$77cea355fa80b5f4);

var $igo36 = parcelRequire("igo36");

var $iyJaq = parcelRequire("iyJaq");

var $4LWvV = parcelRequire("4LWvV");

var $j7TfU = parcelRequire("j7TfU");

var $ayI2u = parcelRequire("ayI2u");

var $e0fi7 = parcelRequire("e0fi7");

var $jQp2V = parcelRequire("jQp2V");
var $03b4e1cd71b9b470$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $03b4e1cd71b9b470$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $igo36.SafeSubscriber)(observerOrNext, error, complete);
        (0, $jQp2V.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $03b4e1cd71b9b470$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $igo36.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $4LWvV.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $j7TfU.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $03b4e1cd71b9b470$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $03b4e1cd71b9b470$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ayI2u.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $03b4e1cd71b9b470$var$isObserver(value) {
    return value && (0, $e0fi7.isFunction)(value.next) && (0, $e0fi7.isFunction)(value.error) && (0, $e0fi7.isFunction)(value.complete);
}
function $03b4e1cd71b9b470$var$isSubscriber(value) {
    return value && value instanceof (0, $igo36.Subscriber) || $03b4e1cd71b9b470$var$isObserver(value) && (0, $iyJaq.isSubscription)(value);
}

});
parcelRegister("igo36", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $d4bc6047127666b9$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $d4bc6047127666b9$export$94eeb6a328cab6c7);

var $bp3BB = parcelRequire("bp3BB");

var $e0fi7 = parcelRequire("e0fi7");

var $iyJaq = parcelRequire("iyJaq");

var $ayI2u = parcelRequire("ayI2u");

var $iMkl0 = parcelRequire("iMkl0");

var $8hj2G = parcelRequire("8hj2G");

var $kxLaL = parcelRequire("kxLaL");

var $ESytk = parcelRequire("ESytk");

var $jQp2V = parcelRequire("jQp2V");
var $d4bc6047127666b9$export$60959659b2c22881 = function(_super) {
    (0, $bp3BB.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $iyJaq.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $d4bc6047127666b9$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $d4bc6047127666b9$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $d4bc6047127666b9$var$handleStoppedNotification((0, $kxLaL.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $d4bc6047127666b9$var$handleStoppedNotification((0, $kxLaL.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $d4bc6047127666b9$var$handleStoppedNotification((0, $kxLaL.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $iyJaq.Subscription));
var $d4bc6047127666b9$var$_bind = Function.prototype.bind;
function $d4bc6047127666b9$var$bind(fn, thisArg) {
    return $d4bc6047127666b9$var$_bind.call(fn, thisArg);
}
var $d4bc6047127666b9$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $d4bc6047127666b9$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $d4bc6047127666b9$var$handleUnhandledError(error);
        }
        else $d4bc6047127666b9$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $d4bc6047127666b9$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $d4bc6047127666b9$export$94eeb6a328cab6c7 = function(_super) {
    (0, $bp3BB.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $e0fi7.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ayI2u.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $d4bc6047127666b9$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $d4bc6047127666b9$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $d4bc6047127666b9$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $d4bc6047127666b9$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($d4bc6047127666b9$export$60959659b2c22881);
function $d4bc6047127666b9$var$handleUnhandledError(error) {
    if ((0, $ayI2u.config).useDeprecatedSynchronousErrorHandling) (0, $jQp2V.captureError)(error);
    else (0, $iMkl0.reportUnhandledError)(error);
}
function $d4bc6047127666b9$var$defaultErrorHandler(err) {
    throw err;
}
function $d4bc6047127666b9$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ayI2u.config).onStoppedNotification;
    onStoppedNotification && (0, $ESytk.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $d4bc6047127666b9$export$88d395d20619a0af = {
    closed: true,
    next: (0, $8hj2G.noop),
    error: $d4bc6047127666b9$var$defaultErrorHandler,
    complete: (0, $8hj2G.noop)
};

});
parcelRegister("e0fi7", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $a31ced5059f1851d$export$f6e2535fb5126e54);
function $a31ced5059f1851d$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}

});

parcelRegister("iyJaq", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $d82e703e66bd7197$export$f55210826850c514);
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", () => $d82e703e66bd7197$export$610f9c3ca1a38dd8);
$parcel$export(module.exports, "isSubscription", () => $d82e703e66bd7197$export$4f9221cbada3c4fc);

var $bp3BB = parcelRequire("bp3BB");

var $e0fi7 = parcelRequire("e0fi7");

var $he26Q = parcelRequire("he26Q");

var $gXM9D = parcelRequire("gXM9D");
var $d82e703e66bd7197$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $bp3BB.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $e0fi7.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $he26Q.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $bp3BB.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $d82e703e66bd7197$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $he26Q.UnsubscriptionError)) errors = (0, $bp3BB.__spreadArray)((0, $bp3BB.__spreadArray)([], (0, $bp3BB.__read)(errors)), (0, $bp3BB.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $he26Q.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $d82e703e66bd7197$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $gXM9D.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $gXM9D.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $d82e703e66bd7197$export$610f9c3ca1a38dd8 = $d82e703e66bd7197$export$f55210826850c514.EMPTY;
function $d82e703e66bd7197$export$4f9221cbada3c4fc(value) {
    return value instanceof $d82e703e66bd7197$export$f55210826850c514 || value && 'closed' in value && (0, $e0fi7.isFunction)(value.remove) && (0, $e0fi7.isFunction)(value.add) && (0, $e0fi7.isFunction)(value.unsubscribe);
}
function $d82e703e66bd7197$var$execFinalizer(finalizer) {
    if ((0, $e0fi7.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("he26Q", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $c8a5615c91dd2893$export$c9648b76fd580c34);

var $6dM2B = parcelRequire("6dM2B");
var $c8a5615c91dd2893$export$c9648b76fd580c34 = (0, $6dM2B.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

});
parcelRegister("6dM2B", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $487938e58b991736$export$128a15b65d1b6041);
function $487938e58b991736$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("gXM9D", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $c597827a66101a76$export$dae3f38077fc36c0);
function $c597827a66101a76$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("ayI2u", function(module, exports) {

$parcel$export(module.exports, "config", () => $7aff3d9ab4a46f85$export$e506a1d27d1eaa20);
var $7aff3d9ab4a46f85$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("iMkl0", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $dabc7c59f724c560$export$ebf645db02d3e99f);

var $ayI2u = parcelRequire("ayI2u");

var $ESytk = parcelRequire("ESytk");
function $dabc7c59f724c560$export$ebf645db02d3e99f(err) {
    (0, $ESytk.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $ayI2u.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("ESytk", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $07ae0e073640f862$export$365aa6bd3c788e3d);

var $bp3BB = parcelRequire("bp3BB");
var $07ae0e073640f862$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $07ae0e073640f862$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $bp3BB.__spreadArray)([
            handler,
            timeout
        ], (0, $bp3BB.__read)(args)));
        return setTimeout.apply(void 0, (0, $bp3BB.__spreadArray)([
            handler,
            timeout
        ], (0, $bp3BB.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $07ae0e073640f862$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("8hj2G", function(module, exports) {

$parcel$export(module.exports, "noop", () => $606eaea66a559412$export$8793edee2d425525);
function $606eaea66a559412$export$8793edee2d425525() {}

});

parcelRegister("kxLaL", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $ef4b7b38d41fe9d2$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $ef4b7b38d41fe9d2$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $ef4b7b38d41fe9d2$export$ff9346b0d1d30313);
var $ef4b7b38d41fe9d2$export$b7f97edb34bc1f87 = function() {
    return $ef4b7b38d41fe9d2$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $ef4b7b38d41fe9d2$export$dd472c3d8fe5a85a(error) {
    return $ef4b7b38d41fe9d2$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $ef4b7b38d41fe9d2$export$ff9346b0d1d30313(value) {
    return $ef4b7b38d41fe9d2$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $ef4b7b38d41fe9d2$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("jQp2V", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $e7264d4c584dbe60$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $e7264d4c584dbe60$export$3e205fbb5df021e0);

var $ayI2u = parcelRequire("ayI2u");
var $e7264d4c584dbe60$var$context = null;
function $e7264d4c584dbe60$export$d974811edc77eafa(cb) {
    if ((0, $ayI2u.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$e7264d4c584dbe60$var$context;
        if (isRoot) $e7264d4c584dbe60$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $e7264d4c584dbe60$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $e7264d4c584dbe60$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $e7264d4c584dbe60$export$3e205fbb5df021e0(err) {
    if ((0, $ayI2u.config).useDeprecatedSynchronousErrorHandling && $e7264d4c584dbe60$var$context) {
        $e7264d4c584dbe60$var$context.errorThrown = true;
        $e7264d4c584dbe60$var$context.error = err;
    }
}

});


parcelRegister("4LWvV", function(module, exports) {

$parcel$export(module.exports, "observable", () => $3798f0dd74a805a2$export$5ab46cbf6120b33a);
var $3798f0dd74a805a2$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

});

parcelRegister("j7TfU", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $dec9886598227ae6$export$71f88a61afaa14d7);

var $ivVlb = parcelRequire("ivVlb");
function $dec9886598227ae6$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $dec9886598227ae6$export$71f88a61afaa14d7(fns);
}
function $dec9886598227ae6$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $ivVlb.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("ivVlb", function(module, exports) {

$parcel$export(module.exports, "identity", () => $d7a799e84651e9e2$export$f0954fd7d5368655);
function $d7a799e84651e9e2$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("2v0qJ", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", () => $1d1ecf70f06d08f5$export$f708eee25634bc80);

var $6dM2B = parcelRequire("6dM2B");
var $1d1ecf70f06d08f5$export$f708eee25634bc80 = (0, $6dM2B.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

});



parcelRegister("fcGyk", function(module, exports) {

$parcel$export(module.exports, "defer", () => $b118fc0ed441f179$export$260e5c0943f31606);

var $jJg4u = parcelRequire("jJg4u");

var $7ZDZq = parcelRequire("7ZDZq");
function $b118fc0ed441f179$export$260e5c0943f31606(observableFactory) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        (0, $7ZDZq.innerFrom)(observableFactory()).subscribe(subscriber);
    });
}

});
parcelRegister("7ZDZq", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $5d1d400e93374359$export$6a9cfa3ebc765910);

var $bp3BB = parcelRequire("bp3BB");

var $yJrMj = parcelRequire("yJrMj");

var $gd7c0 = parcelRequire("gd7c0");

var $jJg4u = parcelRequire("jJg4u");

var $ijSse = parcelRequire("ijSse");

var $lp6D1 = parcelRequire("lp6D1");

var $59Ni0 = parcelRequire("59Ni0");

var $hESeJ = parcelRequire("hESeJ");

var $b2Spd = parcelRequire("b2Spd");

var $e0fi7 = parcelRequire("e0fi7");

var $iMkl0 = parcelRequire("iMkl0");

var $4LWvV = parcelRequire("4LWvV");
function $5d1d400e93374359$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $jJg4u.Observable)) return input;
    if (input != null) {
        if ((0, $ijSse.isInteropObservable)(input)) return $5d1d400e93374359$export$aa3d41784b3267fa(input);
        if ((0, $yJrMj.isArrayLike)(input)) return $5d1d400e93374359$export$4cb2acdbcda2c253(input);
        if ((0, $gd7c0.isPromise)(input)) return $5d1d400e93374359$export$60f45028237c39d1(input);
        if ((0, $lp6D1.isAsyncIterable)(input)) return $5d1d400e93374359$export$e073fccf36d78cc1(input);
        if ((0, $hESeJ.isIterable)(input)) return $5d1d400e93374359$export$dcccc29c315dd646(input);
        if ((0, $b2Spd.isReadableStreamLike)(input)) return $5d1d400e93374359$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $59Ni0.createInvalidObservableTypeError)(input);
}
function $5d1d400e93374359$export$aa3d41784b3267fa(obj) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        var obs = obj[0, $4LWvV.observable]();
        if ((0, $e0fi7.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $5d1d400e93374359$export$4cb2acdbcda2c253(array) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $5d1d400e93374359$export$60f45028237c39d1(promise) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $iMkl0.reportUnhandledError));
    });
}
function $5d1d400e93374359$export$dcccc29c315dd646(iterable) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $bp3BB.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $5d1d400e93374359$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        $5d1d400e93374359$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $5d1d400e93374359$export$b2dcb11d46e7a4ad(readableStream) {
    return $5d1d400e93374359$export$e073fccf36d78cc1((0, $b2Spd.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $5d1d400e93374359$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $bp3BB.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $bp3BB.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $bp3BB.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("yJrMj", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $06866decd1c301c8$export$1e2f57719e155213);
var $06866decd1c301c8$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

});

parcelRegister("gd7c0", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $bcd370887920a7d5$export$4369c812aac99591);

var $e0fi7 = parcelRequire("e0fi7");
function $bcd370887920a7d5$export$4369c812aac99591(value) {
    return (0, $e0fi7.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("ijSse", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $d5643dd2f0a20645$export$48c0cddbc99c45c2);

var $4LWvV = parcelRequire("4LWvV");

var $e0fi7 = parcelRequire("e0fi7");
function $d5643dd2f0a20645$export$48c0cddbc99c45c2(input) {
    return (0, $e0fi7.isFunction)(input[0, $4LWvV.observable]);
}

});

parcelRegister("lp6D1", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $f9511307001dbaa1$export$edb10ab8dd75a915);

var $e0fi7 = parcelRequire("e0fi7");
function $f9511307001dbaa1$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $e0fi7.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("59Ni0", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $3c1406df556a4efd$export$7cbe71b9fa263484);
function $3c1406df556a4efd$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("hESeJ", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $cdb03e5db7a6d72d$export$9652023d9040757);

var $11Sa4 = parcelRequire("11Sa4");

var $e0fi7 = parcelRequire("e0fi7");
function $cdb03e5db7a6d72d$export$9652023d9040757(input) {
    return (0, $e0fi7.isFunction)(input === null || input === void 0 ? void 0 : input[0, $11Sa4.iterator]);
}

});
parcelRegister("11Sa4", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $0bffe5cac5339425$export$6f58e2338da23f4d);
function $0bffe5cac5339425$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0bffe5cac5339425$export$6f58e2338da23f4d = $0bffe5cac5339425$export$aa9956be4ae4fe8();

});


parcelRegister("b2Spd", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $80aa156eb0a6a9db$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $80aa156eb0a6a9db$export$c088ffafdba7405f);

var $bp3BB = parcelRequire("bp3BB");

var $e0fi7 = parcelRequire("e0fi7");
function $80aa156eb0a6a9db$export$cf4785e597badab3(readableStream) {
    return (0, $bp3BB.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $bp3BB.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $bp3BB.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $bp3BB.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $bp3BB.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $80aa156eb0a6a9db$export$c088ffafdba7405f(obj) {
    return (0, $e0fi7.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});



parcelRegister("44850", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", () => $2f5dcd9e3ab3be85$export$779c5fb865a0172e);

var $ivVlb = parcelRequire("ivVlb");

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");
function $2f5dcd9e3ab3be85$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $ivVlb.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $2f5dcd9e3ab3be85$var$defaultCompare;
    return (0, $21teh.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $2f5dcd9e3ab3be85$var$defaultCompare(a, b) {
    return a === b;
}

});
parcelRegister("21teh", function(module, exports) {

$parcel$export(module.exports, "operate", () => $17925913f2d0db16$export$871731df685d7753);

var $e0fi7 = parcelRequire("e0fi7");
function $17925913f2d0db16$export$ebec8610810318c5(source) {
    return (0, $e0fi7.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $17925913f2d0db16$export$871731df685d7753(init) {
    return function(source) {
        if ($17925913f2d0db16$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

});

parcelRegister("7y8nu", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $57f235113032eac4$export$b9e075132cc6937f);

var $bp3BB = parcelRequire("bp3BB");

var $igo36 = parcelRequire("igo36");
function $57f235113032eac4$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $57f235113032eac4$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $57f235113032eac4$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $bp3BB.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $igo36.Subscriber));

});


parcelRegister("9vj9x", function(module, exports) {

$parcel$export(module.exports, "filter", () => $6eb5ddab0a3a3ba7$export$3dea766d36a8935f);

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");
function $6eb5ddab0a3a3ba7$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $21teh.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("lqWQ2", function(module, exports) {

$parcel$export(module.exports, "firstValueFrom", () => $f9a9aac2e7d0b026$export$400f9f949cef996c);

var $enm90 = parcelRequire("enm90");

var $igo36 = parcelRequire("igo36");
function $f9a9aac2e7d0b026$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $igo36.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $enm90.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

});
parcelRegister("enm90", function(module, exports) {

$parcel$export(module.exports, "EmptyError", () => $a774640c89178f04$export$78f6d1b1dbcda304);

var $6dM2B = parcelRequire("6dM2B");
var $a774640c89178f04$export$78f6d1b1dbcda304 = (0, $6dM2B.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

});


parcelRegister("3U9xZ", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $2d7e01ef830ed585$export$a36e16046ae8f1bb);

var $bp3BB = parcelRequire("bp3BB");

var $7ZDZq = parcelRequire("7ZDZq");

var $jJg4u = parcelRequire("jJg4u");

var $hWJlW = parcelRequire("hWJlW");

var $yJrMj = parcelRequire("yJrMj");

var $e0fi7 = parcelRequire("e0fi7");

var $iz36i = parcelRequire("iz36i");
var $2d7e01ef830ed585$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $2d7e01ef830ed585$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $2d7e01ef830ed585$var$jqueryMethods = [
    'on',
    'off'
];
function $2d7e01ef830ed585$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $e0fi7.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $2d7e01ef830ed585$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $iz36i.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $bp3BB.__read)($2d7e01ef830ed585$var$isEventTarget(target) ? $2d7e01ef830ed585$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $2d7e01ef830ed585$var$isNodeStyleEventEmitter(target) ? $2d7e01ef830ed585$var$nodeEventEmitterMethods.map($2d7e01ef830ed585$var$toCommonHandlerRegistry(target, eventName)) : $2d7e01ef830ed585$var$isJQueryStyleEventEmitter(target) ? $2d7e01ef830ed585$var$jqueryMethods.map($2d7e01ef830ed585$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $yJrMj.isArrayLike)(target)) return (0, $hWJlW.mergeMap)(function(subTarget) {
            return $2d7e01ef830ed585$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $7ZDZq.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $jJg4u.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $2d7e01ef830ed585$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $2d7e01ef830ed585$var$isNodeStyleEventEmitter(target) {
    return (0, $e0fi7.isFunction)(target.addListener) && (0, $e0fi7.isFunction)(target.removeListener);
}
function $2d7e01ef830ed585$var$isJQueryStyleEventEmitter(target) {
    return (0, $e0fi7.isFunction)(target.on) && (0, $e0fi7.isFunction)(target.off);
}
function $2d7e01ef830ed585$var$isEventTarget(target) {
    return (0, $e0fi7.isFunction)(target.addEventListener) && (0, $e0fi7.isFunction)(target.removeEventListener);
}

});
parcelRegister("hWJlW", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $d10b089c623637ea$export$6b9f6c0d32c093f9);

var $jfdoI = parcelRequire("jfdoI");

var $7ZDZq = parcelRequire("7ZDZq");

var $21teh = parcelRequire("21teh");

var $4OXNz = parcelRequire("4OXNz");

var $e0fi7 = parcelRequire("e0fi7");
function $d10b089c623637ea$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $e0fi7.isFunction)(resultSelector)) return $d10b089c623637ea$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $jfdoI.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $7ZDZq.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $21teh.operate)(function(source, subscriber) {
        return (0, $4OXNz.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("jfdoI", function(module, exports) {

$parcel$export(module.exports, "map", () => $e029cf854246f0c0$export$871de8747c9eaa88);

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");
function $e029cf854246f0c0$export$871de8747c9eaa88(project, thisArg) {
    return (0, $21teh.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});

parcelRegister("4OXNz", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $382a37ad47dbfd92$export$600918ebaa9e0a1b);

var $7ZDZq = parcelRequire("7ZDZq");

var $jWw5C = parcelRequire("jWw5C");

var $7y8nu = parcelRequire("7y8nu");
function $382a37ad47dbfd92$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $7ZDZq.innerFrom)(project(value, index++)).subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $jWw5C.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});
parcelRegister("jWw5C", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $e84c536d7d0e079a$export$a2b7447487315232);
function $e84c536d7d0e079a$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});



parcelRegister("iz36i", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $d83de690b49b7df6$export$559affaa48f4288d);

var $bp3BB = parcelRequire("bp3BB");

var $jfdoI = parcelRequire("jfdoI");
var $d83de690b49b7df6$var$isArray = Array.isArray;
function $d83de690b49b7df6$var$callOrApply(fn, args) {
    return $d83de690b49b7df6$var$isArray(args) ? fn.apply(void 0, (0, $bp3BB.__spreadArray)([], (0, $bp3BB.__read)(args))) : fn(args);
}
function $d83de690b49b7df6$export$559affaa48f4288d(fn) {
    return (0, $jfdoI.map)(function(args) {
        return $d83de690b49b7df6$var$callOrApply(fn, args);
    });
}

});


parcelRegister("62g8m", function(module, exports) {

$parcel$export(module.exports, "fromEventPattern", () => $464f71d1230dcaa8$export$af596f9f0ff848f8);

var $jJg4u = parcelRequire("jJg4u");

var $e0fi7 = parcelRequire("e0fi7");

var $iz36i = parcelRequire("iz36i");
function $464f71d1230dcaa8$export$af596f9f0ff848f8(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $464f71d1230dcaa8$export$af596f9f0ff848f8(addHandler, removeHandler).pipe((0, $iz36i.mapOneOrManyArgs)(resultSelector));
    return new (0, $jJg4u.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, $e0fi7.isFunction)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}

});

parcelRegister("aXPYD", function(module, exports) {

$parcel$export(module.exports, "mapTo", () => $7fb7bba15f4ed2a2$export$e0eaf3a86c03b2ad);

var $jfdoI = parcelRequire("jfdoI");
function $7fb7bba15f4ed2a2$export$e0eaf3a86c03b2ad(value) {
    return (0, $jfdoI.map)(function() {
        return value;
    });
}

});

parcelRegister("3nJ2a", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $276673dc18f29fb1$export$db61d692014e534e);

var $fRekO = parcelRequire("fRekO");

var $b2hmj = parcelRequire("b2hmj");
function $276673dc18f29fb1$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $b2hmj.share)({
        connector: function() {
            return new (0, $fRekO.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

});
parcelRegister("fRekO", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", () => $b8b6ecd305c78843$export$915d2682b0aa0991);

var $bp3BB = parcelRequire("bp3BB");

var $62AF9 = parcelRequire("62AF9");

var $aS5Tr = parcelRequire("aS5Tr");
var $b8b6ecd305c78843$export$915d2682b0aa0991 = function(_super) {
    (0, $bp3BB.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $aS5Tr.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $62AF9.Subject));

});
parcelRegister("aS5Tr", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $7ea384caa7c9f3e7$export$c1895ea2d519a677);
var $7ea384caa7c9f3e7$export$c1895ea2d519a677 = {
    now: function() {
        return ($7ea384caa7c9f3e7$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});


parcelRegister("b2hmj", function(module, exports) {

$parcel$export(module.exports, "share", () => $808d58bb18f3cf14$export$ed80d9de1d9df928);

var $bp3BB = parcelRequire("bp3BB");

var $7ZDZq = parcelRequire("7ZDZq");

var $62AF9 = parcelRequire("62AF9");

var $igo36 = parcelRequire("igo36");

var $21teh = parcelRequire("21teh");
function $808d58bb18f3cf14$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $62AF9.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $21teh.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $808d58bb18f3cf14$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $igo36.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $808d58bb18f3cf14$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $808d58bb18f3cf14$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $7ZDZq.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $808d58bb18f3cf14$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $igo36.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $7ZDZq.innerFrom)(on.apply(void 0, (0, $bp3BB.__spreadArray)([], (0, $bp3BB.__read)(args)))).subscribe(onSubscriber);
}

});


parcelRegister("fPFN5", function(module, exports) {

$parcel$export(module.exports, "startWith", () => $b86c093815833956$export$a4fe86229b0e9bdd);

var $MlVkK = parcelRequire("MlVkK");

var $1rUs1 = parcelRequire("1rUs1");

var $21teh = parcelRequire("21teh");
function $b86c093815833956$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $1rUs1.popScheduler)(values);
    return (0, $21teh.operate)(function(source, subscriber) {
        (scheduler ? (0, $MlVkK.concat)(values, source, scheduler) : (0, $MlVkK.concat)(values, source)).subscribe(subscriber);
    });
}

});
parcelRegister("MlVkK", function(module, exports) {

$parcel$export(module.exports, "concat", () => $09157d6838bc17e5$export$ee1b3e54f0441b22);

var $3Lwc7 = parcelRequire("3Lwc7");

var $1rUs1 = parcelRequire("1rUs1");

var $7PIrn = parcelRequire("7PIrn");
function $09157d6838bc17e5$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $3Lwc7.concatAll)()((0, $7PIrn.from)(args, (0, $1rUs1.popScheduler)(args)));
}

});
parcelRegister("3Lwc7", function(module, exports) {

$parcel$export(module.exports, "concatAll", () => $2bdebc0a3ecb2c5a$export$b314777ae20abca9);

var $de8kV = parcelRequire("de8kV");
function $2bdebc0a3ecb2c5a$export$b314777ae20abca9() {
    return (0, $de8kV.mergeAll)(1);
}

});
parcelRegister("de8kV", function(module, exports) {

$parcel$export(module.exports, "mergeAll", () => $9a130c9fa226428e$export$18aef43295bbe906);

var $hWJlW = parcelRequire("hWJlW");

var $ivVlb = parcelRequire("ivVlb");
function $9a130c9fa226428e$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $hWJlW.mergeMap)((0, $ivVlb.identity), concurrent);
}

});


parcelRegister("1rUs1", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", () => $10e41a0bbea7aa12$export$9ae19b645239a61b);
$parcel$export(module.exports, "popScheduler", () => $10e41a0bbea7aa12$export$29534b2f653ae592);
$parcel$export(module.exports, "popNumber", () => $10e41a0bbea7aa12$export$3de14b735070dcd5);

var $e0fi7 = parcelRequire("e0fi7");

var $aZnGX = parcelRequire("aZnGX");
function $10e41a0bbea7aa12$var$last(arr) {
    return arr[arr.length - 1];
}
function $10e41a0bbea7aa12$export$9ae19b645239a61b(args) {
    return (0, $e0fi7.isFunction)($10e41a0bbea7aa12$var$last(args)) ? args.pop() : undefined;
}
function $10e41a0bbea7aa12$export$29534b2f653ae592(args) {
    return (0, $aZnGX.isScheduler)($10e41a0bbea7aa12$var$last(args)) ? args.pop() : undefined;
}
function $10e41a0bbea7aa12$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $10e41a0bbea7aa12$var$last(args) === 'number' ? args.pop() : defaultValue;
}

});
parcelRegister("aZnGX", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $8001fa99c61bb7a4$export$187e35932e88c15c);

var $e0fi7 = parcelRequire("e0fi7");
function $8001fa99c61bb7a4$export$187e35932e88c15c(value) {
    return value && (0, $e0fi7.isFunction)(value.schedule);
}

});


parcelRegister("7PIrn", function(module, exports) {

$parcel$export(module.exports, "from", () => $5b3fc4cfd9aeae34$export$6788812c4e6611e6);

var $2zwor = parcelRequire("2zwor");

var $7ZDZq = parcelRequire("7ZDZq");
function $5b3fc4cfd9aeae34$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $2zwor.scheduled)(input, scheduler) : (0, $7ZDZq.innerFrom)(input);
}

});
parcelRegister("2zwor", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $1df7fa493bb8fc89$export$49c44dfc2bb21d70);

var $atPno = parcelRequire("atPno");

var $ivNrm = parcelRequire("ivNrm");

var $lrtAo = parcelRequire("lrtAo");

var $hvP9n = parcelRequire("hvP9n");

var $eVncZ = parcelRequire("eVncZ");

var $ijSse = parcelRequire("ijSse");

var $gd7c0 = parcelRequire("gd7c0");

var $yJrMj = parcelRequire("yJrMj");

var $hESeJ = parcelRequire("hESeJ");

var $lp6D1 = parcelRequire("lp6D1");

var $59Ni0 = parcelRequire("59Ni0");

var $b2Spd = parcelRequire("b2Spd");

var $eyAkQ = parcelRequire("eyAkQ");
function $1df7fa493bb8fc89$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $ijSse.isInteropObservable)(input)) return (0, $atPno.scheduleObservable)(input, scheduler);
        if ((0, $yJrMj.isArrayLike)(input)) return (0, $lrtAo.scheduleArray)(input, scheduler);
        if ((0, $gd7c0.isPromise)(input)) return (0, $ivNrm.schedulePromise)(input, scheduler);
        if ((0, $lp6D1.isAsyncIterable)(input)) return (0, $eVncZ.scheduleAsyncIterable)(input, scheduler);
        if ((0, $hESeJ.isIterable)(input)) return (0, $hvP9n.scheduleIterable)(input, scheduler);
        if ((0, $b2Spd.isReadableStreamLike)(input)) return (0, $eyAkQ.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $59Ni0.createInvalidObservableTypeError)(input);
}

});
parcelRegister("atPno", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $7a14771af2511fce$export$ed8bd553a12b6a30);

var $7ZDZq = parcelRequire("7ZDZq");

var $kczK7 = parcelRequire("kczK7");

var $8ayOZ = parcelRequire("8ayOZ");
function $7a14771af2511fce$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $7ZDZq.innerFrom)(input).pipe((0, $8ayOZ.subscribeOn)(scheduler), (0, $kczK7.observeOn)(scheduler));
}

});
parcelRegister("kczK7", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $eb50a76de5f37293$export$9007f49c319d1ac7);

var $jWw5C = parcelRequire("jWw5C");

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");
function $eb50a76de5f37293$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $21teh.operate)(function(source, subscriber) {
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});

parcelRegister("8ayOZ", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $5f2a44af503bfa23$export$1eb44d8f5f64733b);

var $21teh = parcelRequire("21teh");
function $5f2a44af503bfa23$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $21teh.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("ivNrm", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $d7a1790ebb642311$export$fc9afd948577f0a8);

var $7ZDZq = parcelRequire("7ZDZq");

var $kczK7 = parcelRequire("kczK7");

var $8ayOZ = parcelRequire("8ayOZ");
function $d7a1790ebb642311$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $7ZDZq.innerFrom)(input).pipe((0, $8ayOZ.subscribeOn)(scheduler), (0, $kczK7.observeOn)(scheduler));
}

});

parcelRegister("lrtAo", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $f9c311c4337263d7$export$b34673931371729a);

var $jJg4u = parcelRequire("jJg4u");
function $f9c311c4337263d7$export$b34673931371729a(input, scheduler) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("hvP9n", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $cbfd02463d2337f6$export$2b75c58ab9b5b766);

var $jJg4u = parcelRequire("jJg4u");

var $11Sa4 = parcelRequire("11Sa4");

var $e0fi7 = parcelRequire("e0fi7");

var $jWw5C = parcelRequire("jWw5C");
function $cbfd02463d2337f6$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        var iterator;
        (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $11Sa4.iterator]();
            (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $e0fi7.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("eVncZ", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $add864445ebd30a1$export$7c7f0979b56a32f3);

var $jJg4u = parcelRequire("jJg4u");

var $jWw5C = parcelRequire("jWw5C");
function $add864445ebd30a1$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $jJg4u.Observable)(function(subscriber) {
        (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $jWw5C.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("eyAkQ", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $a9906d13ca95e111$export$3385251aeecad28a);

var $eVncZ = parcelRequire("eVncZ");

var $b2Spd = parcelRequire("b2Spd");
function $a9906d13ca95e111$export$3385251aeecad28a(input, scheduler) {
    return (0, $eVncZ.scheduleAsyncIterable)((0, $b2Spd.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});





parcelRegister("kgoiB", function(module, exports) {

$parcel$export(module.exports, "take", () => $ec082690cff1ec9c$export$b7df5d561049483a);

var $fk3zx = parcelRequire("fk3zx");

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");
function $ec082690cff1ec9c$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $fk3zx.EMPTY;
    } : (0, $21teh.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});
parcelRegister("fk3zx", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $b27b7ea19c78a2b4$export$ccb33e29d92c9a58);

var $jJg4u = parcelRequire("jJg4u");
var $b27b7ea19c78a2b4$export$ccb33e29d92c9a58 = new (0, $jJg4u.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $b27b7ea19c78a2b4$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $b27b7ea19c78a2b4$var$emptyScheduled(scheduler) : $b27b7ea19c78a2b4$export$ccb33e29d92c9a58;
}
function $b27b7ea19c78a2b4$var$emptyScheduled(scheduler) {
    return new (0, $jJg4u.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("gybEh", function(module, exports) {

$parcel$export(module.exports, "takeUntil", () => $c0c8db85c9782f81$export$ac8dfd3a7ad06e80);

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");

var $7ZDZq = parcelRequire("7ZDZq");

var $8hj2G = parcelRequire("8hj2G");
function $c0c8db85c9782f81$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $21teh.operate)(function(source, subscriber) {
        (0, $7ZDZq.innerFrom)(notifier).subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, $8hj2G.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

});

parcelRegister("9TSAA", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $7353985fae706329$export$571da16e28367bde);

var $44850 = parcelRequire("44850");
function $7353985fae706329$export$571da16e28367bde(key, compare) {
    return (0, $44850.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

});

parcelRegister("fIHKl", function(module, exports) {

$parcel$export(module.exports, "pluck", () => $b71ce63b6f95b08d$export$c44985b87d605eff);

var $jfdoI = parcelRequire("jfdoI");
function $b71ce63b6f95b08d$export$c44985b87d605eff() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return (0, $jfdoI.map)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}

});

parcelRegister("gltW7", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $be65d43de3616398$export$9f6ea8e48bc26eab);

var $7ZDZq = parcelRequire("7ZDZq");

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");
function $be65d43de3616398$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $21teh.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $7ZDZq.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $7y8nu.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});

parcelRegister("FNLtf", function(module, exports) {

$parcel$export(module.exports, "withLatestFrom", () => $07da6eacb9288bfb$export$d449030e5c10edf7);

var $bp3BB = parcelRequire("bp3BB");

var $21teh = parcelRequire("21teh");

var $7y8nu = parcelRequire("7y8nu");

var $7ZDZq = parcelRequire("7ZDZq");

var $ivVlb = parcelRequire("ivVlb");

var $8hj2G = parcelRequire("8hj2G");

var $1rUs1 = parcelRequire("1rUs1");
function $07da6eacb9288bfb$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $1rUs1.popResultSelector)(inputs);
    return (0, $21teh.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $7ZDZq.innerFrom)(inputs[i]).subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $ivVlb.identity))) && (hasValue = null);
                }
            }, (0, $8hj2G.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $7y8nu.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, $bp3BB.__spreadArray)([
                    value
                ], (0, $bp3BB.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $bp3BB.__spreadArray)([], (0, $bp3BB.__read)(values))) : values);
            }
        }));
    });
}

});

parcelRegister("dzDkt", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});

parcelRegister("fQSUm", function(module, exports) {

$parcel$export(module.exports, "addMessages", () => $b8a64deb33ab1998$export$e8c6a0d7313851e);
$parcel$export(module.exports, "init", () => $b8a64deb33ab1998$export$2cd8252107eb640b);
$parcel$export(module.exports, "locale", () => $b8a64deb33ab1998$export$162ce11d62a1ca51);
$parcel$export(module.exports, "getLocaleFromNavigator", () => $b8a64deb33ab1998$export$3de58040980076f2);
$parcel$export(module.exports, "_", () => $b8a64deb33ab1998$export$71511d61b312f219);
parcelRequire("hZwTv");
var $hR058 = parcelRequire("hR058");

var $dZhQD = parcelRequire("dZhQD");
parcelRequire("f30kt");
var $afnyo = parcelRequire("afnyo");
function $b8a64deb33ab1998$var$delve(obj, fullKey) {
    if (fullKey == null) return void 0;
    if (fullKey in obj) return obj[fullKey];
    const keys = fullKey.split(".");
    let result = obj;
    for(let p = 0; p < keys.length; p++)if (typeof result === "object") {
        if (p > 0) {
            const partialKey = keys.slice(p, keys.length).join(".");
            if (partialKey in result) {
                result = result[partialKey];
                break;
            }
        }
        result = result[keys[p]];
    } else result = void 0;
    return result;
}
const $b8a64deb33ab1998$var$lookupCache = {};
const $b8a64deb33ab1998$var$addToCache = (path, locale, message)=>{
    if (!message) return message;
    if (!(locale in $b8a64deb33ab1998$var$lookupCache)) $b8a64deb33ab1998$var$lookupCache[locale] = {};
    if (!(path in $b8a64deb33ab1998$var$lookupCache[locale])) $b8a64deb33ab1998$var$lookupCache[locale][path] = message;
    return message;
};
const $b8a64deb33ab1998$var$lookup = (path, refLocale)=>{
    if (refLocale == null) return void 0;
    if (refLocale in $b8a64deb33ab1998$var$lookupCache && path in $b8a64deb33ab1998$var$lookupCache[refLocale]) return $b8a64deb33ab1998$var$lookupCache[refLocale][path];
    const locales = $b8a64deb33ab1998$var$getPossibleLocales(refLocale);
    for(let i = 0; i < locales.length; i++){
        const locale = locales[i];
        const message = $b8a64deb33ab1998$var$getMessageFromDictionary(locale, path);
        if (message) return $b8a64deb33ab1998$var$addToCache(path, refLocale, message);
    }
    return void 0;
};
let $b8a64deb33ab1998$var$dictionary;
const $b8a64deb33ab1998$export$d3757880ed390b62 = (0, $hR058.writable)({});
function $b8a64deb33ab1998$var$getLocaleDictionary(locale) {
    return $b8a64deb33ab1998$var$dictionary[locale] || null;
}
function $b8a64deb33ab1998$var$hasLocaleDictionary(locale) {
    return locale in $b8a64deb33ab1998$var$dictionary;
}
function $b8a64deb33ab1998$var$getMessageFromDictionary(locale, id) {
    if (!$b8a64deb33ab1998$var$hasLocaleDictionary(locale)) return null;
    const localeDictionary = $b8a64deb33ab1998$var$getLocaleDictionary(locale);
    const match = $b8a64deb33ab1998$var$delve(localeDictionary, id);
    return match;
}
function $b8a64deb33ab1998$var$getClosestAvailableLocale(refLocale) {
    if (refLocale == null) return void 0;
    const relatedLocales = $b8a64deb33ab1998$var$getPossibleLocales(refLocale);
    for(let i = 0; i < relatedLocales.length; i++){
        const locale = relatedLocales[i];
        if ($b8a64deb33ab1998$var$hasLocaleDictionary(locale)) return locale;
    }
    return void 0;
}
function $b8a64deb33ab1998$export$e8c6a0d7313851e(locale, ...partials) {
    delete $b8a64deb33ab1998$var$lookupCache[locale];
    $b8a64deb33ab1998$export$d3757880ed390b62.update((d)=>{
        d[locale] = (0, (/*@__PURE__*/$parcel$interopDefault($dZhQD))).all([
            d[locale] || {},
            ...partials
        ]);
        return d;
    });
}
const $b8a64deb33ab1998$export$df1c34db1371eeed = (0, $hR058.derived)([
    $b8a64deb33ab1998$export$d3757880ed390b62
], ([dictionary2])=>Object.keys(dictionary2));
$b8a64deb33ab1998$export$d3757880ed390b62.subscribe((newDictionary)=>$b8a64deb33ab1998$var$dictionary = newDictionary);
const $b8a64deb33ab1998$var$queue = {};
function $b8a64deb33ab1998$var$createLocaleQueue(locale) {
    $b8a64deb33ab1998$var$queue[locale] = /* @__PURE__ */ new Set();
}
function $b8a64deb33ab1998$var$removeLoaderFromQueue(locale, loader) {
    $b8a64deb33ab1998$var$queue[locale].delete(loader);
    if ($b8a64deb33ab1998$var$queue[locale].size === 0) delete $b8a64deb33ab1998$var$queue[locale];
}
function $b8a64deb33ab1998$var$getLocaleQueue(locale) {
    return $b8a64deb33ab1998$var$queue[locale];
}
function $b8a64deb33ab1998$var$getLocalesQueues(locale) {
    return $b8a64deb33ab1998$var$getPossibleLocales(locale).map((localeItem)=>{
        const localeQueue = $b8a64deb33ab1998$var$getLocaleQueue(localeItem);
        return [
            localeItem,
            localeQueue ? [
                ...localeQueue
            ] : []
        ];
    }).filter(([, localeQueue])=>localeQueue.length > 0);
}
function $b8a64deb33ab1998$var$hasLocaleQueue(locale) {
    if (locale == null) return false;
    return $b8a64deb33ab1998$var$getPossibleLocales(locale).some((localeQueue)=>{
        var _a;
        return (_a = $b8a64deb33ab1998$var$getLocaleQueue(localeQueue)) == null ? void 0 : _a.size;
    });
}
function $b8a64deb33ab1998$var$loadLocaleQueue(locale, localeQueue) {
    const allLoadersPromise = Promise.all(localeQueue.map((loader)=>{
        $b8a64deb33ab1998$var$removeLoaderFromQueue(locale, loader);
        return loader().then((partial)=>partial.default || partial);
    }));
    return allLoadersPromise.then((partials)=>$b8a64deb33ab1998$export$e8c6a0d7313851e(locale, ...partials));
}
const $b8a64deb33ab1998$var$activeFlushes = {};
function $b8a64deb33ab1998$var$flush(locale) {
    if (!$b8a64deb33ab1998$var$hasLocaleQueue(locale)) {
        if (locale in $b8a64deb33ab1998$var$activeFlushes) return $b8a64deb33ab1998$var$activeFlushes[locale];
        return Promise.resolve();
    }
    const queues = $b8a64deb33ab1998$var$getLocalesQueues(locale);
    $b8a64deb33ab1998$var$activeFlushes[locale] = Promise.all(queues.map(([localeName, localeQueue])=>$b8a64deb33ab1998$var$loadLocaleQueue(localeName, localeQueue))).then(()=>{
        if ($b8a64deb33ab1998$var$hasLocaleQueue(locale)) return $b8a64deb33ab1998$var$flush(locale);
        delete $b8a64deb33ab1998$var$activeFlushes[locale];
    });
    return $b8a64deb33ab1998$var$activeFlushes[locale];
}
function $b8a64deb33ab1998$export$6503ec6e8aabbaf(locale, loader) {
    if (!$b8a64deb33ab1998$var$getLocaleQueue(locale)) $b8a64deb33ab1998$var$createLocaleQueue(locale);
    const localeQueue = $b8a64deb33ab1998$var$getLocaleQueue(locale);
    if ($b8a64deb33ab1998$var$getLocaleQueue(locale).has(loader)) return;
    if (!$b8a64deb33ab1998$var$hasLocaleDictionary(locale)) $b8a64deb33ab1998$export$d3757880ed390b62.update((d)=>{
        d[locale] = {};
        return d;
    });
    localeQueue.add(loader);
}
var $b8a64deb33ab1998$var$__getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var $b8a64deb33ab1998$var$__hasOwnProp$2 = Object.prototype.hasOwnProperty;
var $b8a64deb33ab1998$var$__propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var $b8a64deb33ab1998$var$__objRest$1 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b8a64deb33ab1998$var$__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b8a64deb33ab1998$var$__getOwnPropSymbols$2) {
        for (var prop of $b8a64deb33ab1998$var$__getOwnPropSymbols$2(source))if (exclude.indexOf(prop) < 0 && $b8a64deb33ab1998$var$__propIsEnum$2.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b8a64deb33ab1998$var$defaultFormats = {
    number: {
        scientific: {
            notation: "scientific"
        },
        engineering: {
            notation: "engineering"
        },
        compactLong: {
            notation: "compact",
            compactDisplay: "long"
        },
        compactShort: {
            notation: "compact",
            compactDisplay: "short"
        }
    },
    date: {
        short: {
            month: "numeric",
            day: "numeric",
            year: "2-digit"
        },
        medium: {
            month: "short",
            day: "numeric",
            year: "numeric"
        },
        long: {
            month: "long",
            day: "numeric",
            year: "numeric"
        },
        full: {
            weekday: "long",
            month: "long",
            day: "numeric",
            year: "numeric"
        }
    },
    time: {
        short: {
            hour: "numeric",
            minute: "numeric"
        },
        medium: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        },
        long: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short"
        },
        full: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short"
        }
    }
};
function $b8a64deb33ab1998$var$defaultMissingKeyHandler({ locale: locale, id: id }) {
    console.warn(`[svelte-i18n] The message "${id}" was not found in "${$b8a64deb33ab1998$var$getPossibleLocales(locale).join('", "')}".${$b8a64deb33ab1998$var$hasLocaleQueue($b8a64deb33ab1998$var$getCurrentLocale()) ? `

Note: there are at least one loader still registered to this locale that wasn't executed.` : ""}`);
}
const $b8a64deb33ab1998$var$defaultOptions = {
    fallbackLocale: null,
    loadingDelay: 200,
    formats: $b8a64deb33ab1998$var$defaultFormats,
    warnOnMissingMessages: true,
    handleMissingMessage: void 0,
    ignoreTag: true
};
const $b8a64deb33ab1998$var$options = $b8a64deb33ab1998$var$defaultOptions;
function $b8a64deb33ab1998$var$getOptions() {
    return $b8a64deb33ab1998$var$options;
}
function $b8a64deb33ab1998$export$2cd8252107eb640b(opts) {
    const _a = opts, { formats: formats } = _a, rest = $b8a64deb33ab1998$var$__objRest$1(_a, [
        "formats"
    ]);
    let initialLocale = opts.fallbackLocale;
    if (opts.initialLocale) try {
        if ((0, $afnyo.IntlMessageFormat).resolveLocale(opts.initialLocale)) initialLocale = opts.initialLocale;
    } catch (e) {
        console.warn(`[svelte-i18n] The initial locale "${opts.initialLocale}" is not a valid locale.`);
    }
    if (rest.warnOnMissingMessages) {
        delete rest.warnOnMissingMessages;
        if (rest.handleMissingMessage == null) rest.handleMissingMessage = $b8a64deb33ab1998$var$defaultMissingKeyHandler;
        else console.warn('[svelte-i18n] The "warnOnMissingMessages" option is deprecated. Please use the "handleMissingMessage" option instead.');
    }
    Object.assign($b8a64deb33ab1998$var$options, rest, {
        initialLocale: initialLocale
    });
    if (formats) {
        if ("number" in formats) Object.assign($b8a64deb33ab1998$var$options.formats.number, formats.number);
        if ("date" in formats) Object.assign($b8a64deb33ab1998$var$options.formats.date, formats.date);
        if ("time" in formats) Object.assign($b8a64deb33ab1998$var$options.formats.time, formats.time);
    }
    return $b8a64deb33ab1998$export$162ce11d62a1ca51.set(initialLocale);
}
const $b8a64deb33ab1998$export$20bb0d907fbbe433 = (0, $hR058.writable)(false);
var $b8a64deb33ab1998$var$__defProp$1 = Object.defineProperty;
var $b8a64deb33ab1998$var$__defProps = Object.defineProperties;
var $b8a64deb33ab1998$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b8a64deb33ab1998$var$__getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var $b8a64deb33ab1998$var$__hasOwnProp$1 = Object.prototype.hasOwnProperty;
var $b8a64deb33ab1998$var$__propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var $b8a64deb33ab1998$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $b8a64deb33ab1998$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b8a64deb33ab1998$var$__spreadValues$1 = (a, b)=>{
    for(var prop in b || (b = {}))if ($b8a64deb33ab1998$var$__hasOwnProp$1.call(b, prop)) $b8a64deb33ab1998$var$__defNormalProp$1(a, prop, b[prop]);
    if ($b8a64deb33ab1998$var$__getOwnPropSymbols$1) {
        for (var prop of $b8a64deb33ab1998$var$__getOwnPropSymbols$1(b))if ($b8a64deb33ab1998$var$__propIsEnum$1.call(b, prop)) $b8a64deb33ab1998$var$__defNormalProp$1(a, prop, b[prop]);
    }
    return a;
};
var $b8a64deb33ab1998$var$__spreadProps = (a, b)=>$b8a64deb33ab1998$var$__defProps(a, $b8a64deb33ab1998$var$__getOwnPropDescs(b));
let $b8a64deb33ab1998$var$current;
const $b8a64deb33ab1998$var$internalLocale = (0, $hR058.writable)(null);
function $b8a64deb33ab1998$var$getSubLocales(refLocale) {
    return refLocale.split("-").map((_, i, arr)=>arr.slice(0, i + 1).join("-")).reverse();
}
function $b8a64deb33ab1998$var$getPossibleLocales(refLocale, fallbackLocale = $b8a64deb33ab1998$var$getOptions().fallbackLocale) {
    const locales = $b8a64deb33ab1998$var$getSubLocales(refLocale);
    if (fallbackLocale) return [
        .../* @__PURE__ */ new Set([
            ...locales,
            ...$b8a64deb33ab1998$var$getSubLocales(fallbackLocale)
        ])
    ];
    return locales;
}
function $b8a64deb33ab1998$var$getCurrentLocale() {
    return $b8a64deb33ab1998$var$current != null ? $b8a64deb33ab1998$var$current : void 0;
}
$b8a64deb33ab1998$var$internalLocale.subscribe((newLocale)=>{
    $b8a64deb33ab1998$var$current = newLocale != null ? newLocale : void 0;
    if (typeof window !== "undefined" && newLocale != null) document.documentElement.setAttribute("lang", newLocale);
});
const $b8a64deb33ab1998$var$set = (newLocale)=>{
    if (newLocale && $b8a64deb33ab1998$var$getClosestAvailableLocale(newLocale) && $b8a64deb33ab1998$var$hasLocaleQueue(newLocale)) {
        const { loadingDelay: loadingDelay } = $b8a64deb33ab1998$var$getOptions();
        let loadingTimer;
        if (typeof window !== "undefined" && $b8a64deb33ab1998$var$getCurrentLocale() != null && loadingDelay) loadingTimer = window.setTimeout(()=>$b8a64deb33ab1998$export$20bb0d907fbbe433.set(true), loadingDelay);
        else $b8a64deb33ab1998$export$20bb0d907fbbe433.set(true);
        return $b8a64deb33ab1998$var$flush(newLocale).then(()=>{
            $b8a64deb33ab1998$var$internalLocale.set(newLocale);
        }).finally(()=>{
            clearTimeout(loadingTimer);
            $b8a64deb33ab1998$export$20bb0d907fbbe433.set(false);
        });
    }
    return $b8a64deb33ab1998$var$internalLocale.set(newLocale);
};
const $b8a64deb33ab1998$export$162ce11d62a1ca51 = $b8a64deb33ab1998$var$__spreadProps($b8a64deb33ab1998$var$__spreadValues$1({}, $b8a64deb33ab1998$var$internalLocale), {
    set: $b8a64deb33ab1998$var$set
});
const $b8a64deb33ab1998$var$getFromQueryString = (queryString, key)=>{
    const keyVal = queryString.split("&").find((i)=>i.indexOf(`${key}=`) === 0);
    if (keyVal) return keyVal.split("=").pop();
    return null;
};
const $b8a64deb33ab1998$var$getFirstMatch = (base, pattern)=>{
    const match = pattern.exec(base);
    if (!match) return null;
    return match[1] || null;
};
const $b8a64deb33ab1998$export$4b645ee0c03e8679 = (hostname)=>{
    if (typeof window === "undefined") return null;
    return $b8a64deb33ab1998$var$getFirstMatch(window.location.hostname, hostname);
};
const $b8a64deb33ab1998$export$7d7c6a2d1731fd0c = (pathname)=>{
    if (typeof window === "undefined") return null;
    return $b8a64deb33ab1998$var$getFirstMatch(window.location.pathname, pathname);
};
const $b8a64deb33ab1998$export$3de58040980076f2 = ()=>{
    if (typeof window === "undefined") return null;
    return window.navigator.language || window.navigator.languages[0];
};
const $b8a64deb33ab1998$export$ec45b8ee346340d7 = (search)=>{
    if (typeof window === "undefined") return null;
    return $b8a64deb33ab1998$var$getFromQueryString(window.location.search.substr(1), search);
};
const $b8a64deb33ab1998$export$c75599b9cea22398 = (hash)=>{
    if (typeof window === "undefined") return null;
    return $b8a64deb33ab1998$var$getFromQueryString(window.location.hash.substr(1), hash);
};
const $b8a64deb33ab1998$var$monadicMemoize = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    const memoizedFn = (arg)=>{
        const cacheKey = JSON.stringify(arg);
        if (cacheKey in cache) return cache[cacheKey];
        return cache[cacheKey] = fn(arg);
    };
    return memoizedFn;
};
var $b8a64deb33ab1998$var$__defProp = Object.defineProperty;
var $b8a64deb33ab1998$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b8a64deb33ab1998$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b8a64deb33ab1998$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b8a64deb33ab1998$var$__defNormalProp = (obj, key, value)=>key in obj ? $b8a64deb33ab1998$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b8a64deb33ab1998$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b8a64deb33ab1998$var$__hasOwnProp.call(b, prop)) $b8a64deb33ab1998$var$__defNormalProp(a, prop, b[prop]);
    if ($b8a64deb33ab1998$var$__getOwnPropSymbols) {
        for (var prop of $b8a64deb33ab1998$var$__getOwnPropSymbols(b))if ($b8a64deb33ab1998$var$__propIsEnum.call(b, prop)) $b8a64deb33ab1998$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b8a64deb33ab1998$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b8a64deb33ab1998$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b8a64deb33ab1998$var$__getOwnPropSymbols) {
        for (var prop of $b8a64deb33ab1998$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b8a64deb33ab1998$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b8a64deb33ab1998$var$getIntlFormatterOptions = (type, name)=>{
    const { formats: formats } = $b8a64deb33ab1998$var$getOptions();
    if (type in formats && name in formats[type]) return formats[type][name];
    throw new Error(`[svelte-i18n] Unknown "${name}" ${type} format.`);
};
const $b8a64deb33ab1998$var$createNumberFormatter = $b8a64deb33ab1998$var$monadicMemoize((_a)=>{
    var _b = _a, { locale: locale, format: format } = _b, options = $b8a64deb33ab1998$var$__objRest(_b, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format numbers');
    if (format) options = $b8a64deb33ab1998$var$getIntlFormatterOptions("number", format);
    return new Intl.NumberFormat(locale, options);
});
const $b8a64deb33ab1998$var$createDateFormatter = $b8a64deb33ab1998$var$monadicMemoize((_c)=>{
    var _d = _c, { locale: locale, format: format } = _d, options = $b8a64deb33ab1998$var$__objRest(_d, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format dates');
    if (format) options = $b8a64deb33ab1998$var$getIntlFormatterOptions("date", format);
    else if (Object.keys(options).length === 0) options = $b8a64deb33ab1998$var$getIntlFormatterOptions("date", "short");
    return new Intl.DateTimeFormat(locale, options);
});
const $b8a64deb33ab1998$var$createTimeFormatter = $b8a64deb33ab1998$var$monadicMemoize((_e)=>{
    var _f = _e, { locale: locale, format: format } = _f, options = $b8a64deb33ab1998$var$__objRest(_f, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format time values');
    if (format) options = $b8a64deb33ab1998$var$getIntlFormatterOptions("time", format);
    else if (Object.keys(options).length === 0) options = $b8a64deb33ab1998$var$getIntlFormatterOptions("time", "short");
    return new Intl.DateTimeFormat(locale, options);
});
const $b8a64deb33ab1998$export$c2604861dc73a731 = (_g = {})=>{
    var _h = _g, { locale: locale = $b8a64deb33ab1998$var$getCurrentLocale() } = _h, args = $b8a64deb33ab1998$var$__objRest(_h, [
        "locale"
    ]);
    return $b8a64deb33ab1998$var$createNumberFormatter($b8a64deb33ab1998$var$__spreadValues({
        locale: locale
    }, args));
};
const $b8a64deb33ab1998$export$dec541045008c8e3 = (_i = {})=>{
    var _j = _i, { locale: locale = $b8a64deb33ab1998$var$getCurrentLocale() } = _j, args = $b8a64deb33ab1998$var$__objRest(_j, [
        "locale"
    ]);
    return $b8a64deb33ab1998$var$createDateFormatter($b8a64deb33ab1998$var$__spreadValues({
        locale: locale
    }, args));
};
const $b8a64deb33ab1998$export$55180a88c41165a1 = (_k = {})=>{
    var _l = _k, { locale: locale = $b8a64deb33ab1998$var$getCurrentLocale() } = _l, args = $b8a64deb33ab1998$var$__objRest(_l, [
        "locale"
    ]);
    return $b8a64deb33ab1998$var$createTimeFormatter($b8a64deb33ab1998$var$__spreadValues({
        locale: locale
    }, args));
};
const $b8a64deb33ab1998$export$3b8be924e637e17c = $b8a64deb33ab1998$var$monadicMemoize(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(message, locale = $b8a64deb33ab1998$var$getCurrentLocale())=>new (0, $afnyo.IntlMessageFormat)(message, locale, $b8a64deb33ab1998$var$getOptions().formats, {
        ignoreTag: $b8a64deb33ab1998$var$getOptions().ignoreTag
    }));
const $b8a64deb33ab1998$var$formatMessage = (id, options = {})=>{
    var _a, _b, _c, _d;
    let messageObj = options;
    if (typeof id === "object") {
        messageObj = id;
        id = messageObj.id;
    }
    const { values: values, locale: locale = $b8a64deb33ab1998$var$getCurrentLocale(), default: defaultValue } = messageObj;
    if (locale == null) throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");
    let message = $b8a64deb33ab1998$var$lookup(id, locale);
    if (!message) message = (_d = (_c = (_b = (_a = $b8a64deb33ab1998$var$getOptions()).handleMissingMessage) == null ? void 0 : _b.call(_a, {
        locale: locale,
        id: id,
        defaultValue: defaultValue
    })) != null ? _c : defaultValue) != null ? _d : id;
    else if (typeof message !== "string") {
        console.warn(`[svelte-i18n] Message with id "${id}" must be of type "string", found: "${typeof message}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`);
        return message;
    }
    if (!values) return message;
    let result = message;
    try {
        result = $b8a64deb33ab1998$export$3b8be924e637e17c(message, locale).format(values);
    } catch (e) {
        if (e instanceof Error) console.warn(`[svelte-i18n] Message "${id}" has syntax error:`, e.message);
    }
    return result;
};
const $b8a64deb33ab1998$var$formatTime = (t, options)=>{
    return $b8a64deb33ab1998$export$55180a88c41165a1(options).format(t);
};
const $b8a64deb33ab1998$var$formatDate = (d, options)=>{
    return $b8a64deb33ab1998$export$dec541045008c8e3(options).format(d);
};
const $b8a64deb33ab1998$var$formatNumber = (n, options)=>{
    return $b8a64deb33ab1998$export$c2604861dc73a731(options).format(n);
};
const $b8a64deb33ab1998$var$getJSON = (id, locale = $b8a64deb33ab1998$var$getCurrentLocale())=>{
    return $b8a64deb33ab1998$var$lookup(id, locale);
};
const $b8a64deb33ab1998$export$71511d61b312f219 = (0, $hR058.derived)([
    $b8a64deb33ab1998$export$162ce11d62a1ca51,
    $b8a64deb33ab1998$export$d3757880ed390b62
], ()=>$b8a64deb33ab1998$var$formatMessage);
const $b8a64deb33ab1998$export$2da9be4cfdb689b1 = (0, $hR058.derived)([
    $b8a64deb33ab1998$export$162ce11d62a1ca51
], ()=>$b8a64deb33ab1998$var$formatTime);
const $b8a64deb33ab1998$export$324d90190a8b822a = (0, $hR058.derived)([
    $b8a64deb33ab1998$export$162ce11d62a1ca51
], ()=>$b8a64deb33ab1998$var$formatDate);
const $b8a64deb33ab1998$export$98e628dec113755e = (0, $hR058.derived)([
    $b8a64deb33ab1998$export$162ce11d62a1ca51
], ()=>$b8a64deb33ab1998$var$formatNumber);
const $b8a64deb33ab1998$export$7b419323e6ed4f31 = (0, $hR058.derived)([
    $b8a64deb33ab1998$export$162ce11d62a1ca51,
    $b8a64deb33ab1998$export$d3757880ed390b62
], ()=>$b8a64deb33ab1998$var$getJSON);
function $b8a64deb33ab1998$export$aa8691a29e6f19c5(store) {
    let localReference;
    const cancel = store.subscribe((value)=>localReference = value);
    const fn = (...args)=>localReference(...args);
    fn.freeze = cancel;
    return fn;
}
function $b8a64deb33ab1998$export$1adfeb024f5185b(i) {
    return i;
}
function $b8a64deb33ab1998$export$9d812b4fe93f6cb6(locale) {
    return $b8a64deb33ab1998$var$flush(locale || $b8a64deb33ab1998$var$getCurrentLocale() || $b8a64deb33ab1998$var$getOptions().initialLocale);
}

});
parcelRegister("hZwTv", function(module, exports) {

$parcel$export(module.exports, "derived", () => (parcelRequire("hR058")).derived);
$parcel$export(module.exports, "writable", () => (parcelRequire("hR058")).writable);
/** @import { Readable, Writable } from './public.js' */ 
var $kCMGX = parcelRequire("kCMGX");

var $hR058 = parcelRequire("hR058");

var $kQ6wH = parcelRequire("kQ6wH");

var $egVZE = parcelRequire("egVZE");
function $d191a646b78d9310$export$e7724d6bf19ab79b(get, set) {
    var effect = (0, $egVZE.active_effect);
    var reaction = (0, $egVZE.active_reaction);
    var init_value = get();
    const store = (0, $hR058.writable)(init_value, (set)=>{
        // If the value has changed before we call subscribe, then
        // we need to treat the value as already having run
        var ran = init_value !== get();
        // TODO do we need a different implementation on the server?
        var teardown;
        // Apply the reaction and effect at the time of toStore being called
        var previous_reaction = (0, $egVZE.active_reaction);
        var previous_effect = (0, $egVZE.active_effect);
        (0, $egVZE.set_active_reaction)(reaction);
        (0, $egVZE.set_active_effect)(effect);
        try {
            teardown = (0, $kCMGX.effect_root)(()=>{
                (0, $kCMGX.render_effect)(()=>{
                    const value = get();
                    if (ran) set(value);
                });
            });
        } finally{
            (0, $egVZE.set_active_reaction)(previous_reaction);
            (0, $egVZE.set_active_effect)(previous_effect);
        }
        ran = true;
        return teardown;
    });
    if (set) return {
        set: set,
        update: (fn)=>set(fn(get())),
        subscribe: store.subscribe
    };
    return {
        subscribe: store.subscribe
    };
}
function $d191a646b78d9310$export$528351d29d037c9c(store) {
    let value = /** @type {V} */ undefined;
    const subscribe = (0, $kQ6wH.createSubscriber)((update)=>{
        let ran = false;
        const unsubscribe = store.subscribe((v1)=>{
            value = v1;
            if (ran) update();
        });
        ran = true;
        return unsubscribe;
    });
    function current() {
        if ((0, $kCMGX.effect_tracking)()) {
            subscribe();
            return value;
        }
        return (0, $hR058.get)(store);
    }
    if ('set' in store) return {
        get current () {
            return current();
        },
        set current (v){
            store.set(v);
        }
    };
    return {
        get current () {
            return current();
        }
    };
}

});
parcelRegister("kCMGX", function(module, exports) {

$parcel$export(module.exports, "destroy_effect", () => $f03d207193083dd5$export$d36097075f3ddca0);
$parcel$export(module.exports, "effect_tracking", () => $f03d207193083dd5$export$8e7b4fbd1790ffd8);
$parcel$export(module.exports, "teardown", () => $f03d207193083dd5$export$4794d9b1949031cf);
$parcel$export(module.exports, "create_user_effect", () => $f03d207193083dd5$export$cbf2820cd5a8431a);
$parcel$export(module.exports, "eager_effect", () => $f03d207193083dd5$export$d6c1781616c57fd6);
$parcel$export(module.exports, "effect_root", () => $f03d207193083dd5$export$2911e4b9f4c9d6c3);
$parcel$export(module.exports, "render_effect", () => $f03d207193083dd5$export$29f8f6197189ded);
$parcel$export(module.exports, "async_effect", () => $f03d207193083dd5$export$de12dd69c53c02e2);
$parcel$export(module.exports, "execute_effect_teardown", () => $f03d207193083dd5$export$db4132e22c6101f4);
$parcel$export(module.exports, "destroy_effect_children", () => $f03d207193083dd5$export$f07ffb4d02e3f8bb);
$parcel$export(module.exports, "destroy_block_effect_children", () => $f03d207193083dd5$export$e943033917e13945);
$parcel$export(module.exports, "unlink_effect", () => $f03d207193083dd5$export$e8e63959fae22582);
$parcel$export(module.exports, "aborted", () => $f03d207193083dd5$export$bd75b6d981b9c7f2);
/** @import { Blocker, ComponentContext, ComponentContextLegacy, Derived, Effect, TemplateNode, TransitionManager } from '#client' */ 
var $egVZE = parcelRequire("egVZE");

var $8zILj = parcelRequire("8zILj");

var $1u5nX = parcelRequire("1u5nX");

var $gB48l = parcelRequire("gB48l");
parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $btEsq = parcelRequire("btEsq");

var $cGH1Z = parcelRequire("cGH1Z");

var $6bkva = parcelRequire("6bkva");

var $amPy2 = parcelRequire("amPy2");

var $9gIfi = parcelRequire("9gIfi");

var $4s4uP = parcelRequire("4s4uP");

var $1RLxH = parcelRequire("1RLxH");
function $f03d207193083dd5$export$311e5a377211bf9c(rune) {
    if ((0, $egVZE.active_effect) === null) {
        if ((0, $egVZE.active_reaction) === null) $gB48l.effect_orphan(rune);
        $gB48l.effect_in_unowned_derived();
    }
    if (0, $egVZE.is_destroying_effect) $gB48l.effect_in_teardown(rune);
}
/**
 * @param {Effect} effect
 * @param {Effect} parent_effect
 */ function $f03d207193083dd5$var$push_effect(effect, parent_effect) {
    var parent_last = parent_effect.last;
    if (parent_last === null) parent_effect.last = parent_effect.first = effect;
    else {
        parent_last.next = effect;
        effect.prev = parent_last;
        parent_effect.last = effect;
    }
}
/**
 * @param {number} type
 * @param {null | (() => void | (() => void))} fn
 * @returns {Effect}
 */ function $f03d207193083dd5$var$create_effect(type, fn) {
    var parent = (0, $egVZE.active_effect);
    if (0, $7YIuB.default) // Ensure the parent is never an inspect effect
    while(parent !== null && (parent.f & (0, $8zILj.EAGER_EFFECT)) !== 0)parent = parent.parent;
    if (parent !== null && (parent.f & (0, $8zILj.INERT)) !== 0) type |= (0, $8zILj.INERT);
    /** @type {Effect} */ var effect = {
        ctx: (0, $6bkva.component_context),
        deps: null,
        nodes: null,
        f: type | (0, $8zILj.DIRTY) | (0, $8zILj.CONNECTED),
        first: null,
        fn: fn,
        last: null,
        next: null,
        parent: parent,
        b: parent && parent.b,
        prev: null,
        teardown: null,
        wv: 0,
        ac: null
    };
    if (0, $7YIuB.default) effect.component_function = (0, $6bkva.dev_current_component_function);
    (0, $amPy2.current_batch)?.register_created_effect(effect);
    /** @type {Effect | null} */ var e = effect;
    if ((type & (0, $8zILj.EFFECT)) !== 0) {
        if ((0, $amPy2.collected_effects) !== null) // created during traversal — collect and run afterwards
        (0, $amPy2.collected_effects).push(effect);
        else // schedule for later
        (0, $amPy2.Batch).ensure().schedule(effect);
    } else if (fn !== null) {
        try {
            (0, $egVZE.update_effect)(effect);
        } catch (e) {
            $f03d207193083dd5$export$d36097075f3ddca0(effect);
            throw e;
        }
        // if an effect doesn't need to be kept in the tree (because it
        // won't re-run, has no DOM, and has no teardown etc)
        // then we skip it and go to its child (if any)
        if (e.deps === null && e.teardown === null && e.nodes === null && e.first === e.last && // either `null`, or a singular child
        (e.f & (0, $8zILj.EFFECT_PRESERVED)) === 0) {
            e = e.first;
            if ((type & (0, $8zILj.BLOCK_EFFECT)) !== 0 && (type & (0, $8zILj.EFFECT_TRANSPARENT)) !== 0 && e !== null) e.f |= (0, $8zILj.EFFECT_TRANSPARENT);
        }
    }
    if (e !== null) {
        e.parent = parent;
        if (parent !== null) $f03d207193083dd5$var$push_effect(e, parent);
        // if we're in a derived, add the effect there too
        if ((0, $egVZE.active_reaction) !== null && ((0, $egVZE.active_reaction).f & (0, $8zILj.DERIVED)) !== 0 && (type & (0, $8zILj.ROOT_EFFECT)) === 0) {
            var derived = /** @type {Derived} */ (0, $egVZE.active_reaction);
            (derived.effects ??= []).push(e);
        }
    }
    return effect;
}
function $f03d207193083dd5$export$8e7b4fbd1790ffd8() {
    return (0, $egVZE.active_reaction) !== null && !(0, $egVZE.untracking);
}
function $f03d207193083dd5$export$4794d9b1949031cf(fn) {
    const effect = $f03d207193083dd5$var$create_effect((0, $8zILj.RENDER_EFFECT), null);
    (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.CLEAN));
    effect.teardown = fn;
    return effect;
}
function $f03d207193083dd5$export$3b8ddb2d8aa8a96f(fn) {
    $f03d207193083dd5$export$311e5a377211bf9c('$effect');
    if (0, $7YIuB.default) (0, $btEsq.define_property)(fn, 'name', {
        value: '$effect'
    });
    // Non-nested `$effect(...)` in a component should be deferred
    // until the component is mounted
    var flags = /** @type {Effect} */ (0, $egVZE.active_effect).f;
    var defer = !(0, $egVZE.active_reaction) && (flags & (0, $8zILj.BRANCH_EFFECT)) !== 0 && (0, $6bkva.component_context) !== null && !(0, $6bkva.component_context).i;
    if (defer) {
        // Top-level `$effect(...)` in an unmounted component — defer until mount
        var context = /** @type {ComponentContext} */ (0, $6bkva.component_context);
        (context.e ??= []).push(fn);
    } else // Everything else — create immediately
    return $f03d207193083dd5$export$cbf2820cd5a8431a(fn);
}
function $f03d207193083dd5$export$cbf2820cd5a8431a(fn) {
    return $f03d207193083dd5$var$create_effect((0, $8zILj.EFFECT) | (0, $8zILj.USER_EFFECT), fn);
}
function $f03d207193083dd5$export$ce3789df848e44d1(fn) {
    $f03d207193083dd5$export$311e5a377211bf9c('$effect.pre');
    if (0, $7YIuB.default) (0, $btEsq.define_property)(fn, 'name', {
        value: '$effect.pre'
    });
    return $f03d207193083dd5$var$create_effect((0, $8zILj.RENDER_EFFECT) | (0, $8zILj.USER_EFFECT), fn);
}
function $f03d207193083dd5$export$d6c1781616c57fd6(fn) {
    return $f03d207193083dd5$var$create_effect((0, $8zILj.EAGER_EFFECT), fn);
}
function $f03d207193083dd5$export$2911e4b9f4c9d6c3(fn) {
    (0, $amPy2.Batch).ensure();
    const effect = $f03d207193083dd5$var$create_effect((0, $8zILj.ROOT_EFFECT) | (0, $8zILj.EFFECT_PRESERVED), fn);
    return ()=>{
        $f03d207193083dd5$export$d36097075f3ddca0(effect);
    };
}
function $f03d207193083dd5$export$656332f5a57c08e2(fn) {
    (0, $amPy2.Batch).ensure();
    const effect = $f03d207193083dd5$var$create_effect((0, $8zILj.ROOT_EFFECT) | (0, $8zILj.EFFECT_PRESERVED), fn);
    return (options = {})=>{
        return new Promise((fulfil)=>{
            if (options.outro) $f03d207193083dd5$export$3786d6034b1774df(effect, ()=>{
                $f03d207193083dd5$export$d36097075f3ddca0(effect);
                fulfil(undefined);
            });
            else {
                $f03d207193083dd5$export$d36097075f3ddca0(effect);
                fulfil(undefined);
            }
        });
    };
}
function $f03d207193083dd5$export$dc573d8a6576cdb3(fn) {
    return $f03d207193083dd5$var$create_effect((0, $8zILj.EFFECT), fn);
}
function $f03d207193083dd5$export$3661053b2c6dd2ee(deps, fn) {
    var context = /** @type {ComponentContextLegacy} */ (0, $6bkva.component_context);
    /** @type {{ effect: null | Effect, ran: boolean, deps: () => any }} */ var token = {
        effect: null,
        ran: false,
        deps: deps
    };
    context.l.$.push(token);
    token.effect = $f03d207193083dd5$export$29f8f6197189ded(()=>{
        deps();
        // If this legacy pre effect has already run before the end of the reset, then
        // bail out to emulate the same behavior.
        if (token.ran) return;
        token.ran = true;
        var effect = /** @type {Effect} */ (0, $egVZE.active_effect);
        // here, we lie: by setting `active_effect` to be the parent branch, any writes
        // that happen inside `fn` will _not_ cause an unnecessary reschedule, because
        // the affected effects will be children of `active_effect`. this is safe
        // because these effects are known to run in the correct order
        try {
            (0, $egVZE.set_active_effect)(effect.parent);
            (0, $egVZE.untrack)(fn);
        } finally{
            (0, $egVZE.set_active_effect)(effect);
        }
    });
}
function $f03d207193083dd5$export$7cbf7db0dce1478c() {
    var context = /** @type {ComponentContextLegacy} */ (0, $6bkva.component_context);
    $f03d207193083dd5$export$29f8f6197189ded(()=>{
        // Run dirty `$:` statements
        for (var token of context.l.$){
            token.deps();
            var effect = token.effect;
            // If the effect is CLEAN, then make it MAYBE_DIRTY. This ensures we traverse through
            // the effects dependencies and correctly ensure each dependency is up-to-date.
            if ((effect.f & (0, $8zILj.CLEAN)) !== 0 && effect.deps !== null) (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.MAYBE_DIRTY));
            if ((0, $egVZE.is_dirty)(effect)) (0, $egVZE.update_effect)(effect);
            token.ran = false;
        }
    });
}
function $f03d207193083dd5$export$de12dd69c53c02e2(fn) {
    return $f03d207193083dd5$var$create_effect((0, $8zILj.ASYNC) | (0, $8zILj.EFFECT_PRESERVED), fn);
}
function $f03d207193083dd5$export$29f8f6197189ded(fn, flags = 0) {
    return $f03d207193083dd5$var$create_effect((0, $8zILj.RENDER_EFFECT) | flags, fn);
}
function $f03d207193083dd5$export$31af2c2d12e5694(fn, sync = [], async = [], blockers = []) {
    (0, $9gIfi.flatten)(blockers, sync, async, (values)=>{
        $f03d207193083dd5$var$create_effect((0, $8zILj.RENDER_EFFECT), ()=>{
            fn(...values.map((0, $egVZE.get)));
        });
    });
}
function $f03d207193083dd5$export$7ae450a93333fe9b(fn, sync = [], async = [], blockers = []) {
    (0, $9gIfi.flatten)(blockers, sync, async, (values)=>{
        $f03d207193083dd5$var$create_effect((0, $8zILj.EFFECT), ()=>fn(...values.map((0, $egVZE.get))));
    });
}
function $f03d207193083dd5$export$837bd02682cd3db9(fn, flags = 0) {
    var effect = $f03d207193083dd5$var$create_effect((0, $8zILj.BLOCK_EFFECT) | flags, fn);
    if (0, $7YIuB.default) effect.dev_stack = (0, $6bkva.dev_stack);
    return effect;
}
function $f03d207193083dd5$export$9157bb928a386df(fn, flags = 0) {
    var effect = $f03d207193083dd5$var$create_effect((0, $8zILj.MANAGED_EFFECT) | flags, fn);
    if (0, $7YIuB.default) effect.dev_stack = (0, $6bkva.dev_stack);
    return effect;
}
function $f03d207193083dd5$export$7b927fb32d8824c0(fn) {
    return $f03d207193083dd5$var$create_effect((0, $8zILj.BRANCH_EFFECT) | (0, $8zILj.EFFECT_PRESERVED), fn);
}
function $f03d207193083dd5$export$db4132e22c6101f4(effect) {
    var teardown = effect.teardown;
    if (teardown !== null) {
        const previously_destroying_effect = (0, $egVZE.is_destroying_effect);
        const previous_reaction = (0, $egVZE.active_reaction);
        (0, $egVZE.set_is_destroying_effect)(true);
        (0, $egVZE.set_active_reaction)(null);
        try {
            teardown.call(null);
        } catch (error) {
            // Route teardown errors through the boundary system so that a live
            // ancestor <svelte:boundary> can handle them. Boundaries that are
            // themselves mid-teardown are skipped by invoke_error_boundary.
            (0, $1u5nX.invoke_error_boundary)(error, effect.parent);
        } finally{
            (0, $egVZE.set_is_destroying_effect)(previously_destroying_effect);
            (0, $egVZE.set_active_reaction)(previous_reaction);
        }
    }
}
function $f03d207193083dd5$export$f07ffb4d02e3f8bb(signal, remove_dom = false) {
    var effect = signal.first;
    signal.first = signal.last = null;
    while(effect !== null){
        const controller = effect.ac;
        if (controller !== null) (0, $4s4uP.without_reactive_context)(()=>{
            controller.abort((0, $8zILj.STALE_REACTION));
        });
        var next = effect.next;
        if ((effect.f & (0, $8zILj.ROOT_EFFECT)) !== 0) // this is now an independent root
        effect.parent = null;
        else $f03d207193083dd5$export$d36097075f3ddca0(effect, remove_dom);
        effect = next;
    }
}
function $f03d207193083dd5$export$e943033917e13945(signal) {
    var effect = signal.first;
    while(effect !== null){
        var next = effect.next;
        if ((effect.f & (0, $8zILj.BRANCH_EFFECT)) === 0) $f03d207193083dd5$export$d36097075f3ddca0(effect);
        effect = next;
    }
}
function $f03d207193083dd5$export$d36097075f3ddca0(effect, remove_dom = true) {
    var removed = false;
    if ((remove_dom || (effect.f & (0, $8zILj.HEAD_EFFECT)) !== 0) && effect.nodes !== null && effect.nodes.end !== null) {
        $f03d207193083dd5$export$1573e8ce9a10f642(effect.nodes.start, /** @type {TemplateNode} */ effect.nodes.end);
        removed = true;
    }
    effect.f |= (0, $8zILj.DESTROYING);
    $f03d207193083dd5$export$f07ffb4d02e3f8bb(effect, remove_dom && !removed);
    (0, $egVZE.remove_reactions)(effect, 0);
    var transitions = effect.nodes && effect.nodes.t;
    if (transitions !== null) for (const transition of transitions)transition.stop();
    $f03d207193083dd5$export$db4132e22c6101f4(effect);
    effect.f ^= (0, $8zILj.DESTROYING);
    effect.f |= (0, $8zILj.DESTROYED);
    var parent = effect.parent;
    // If the parent doesn't have any children, then skip this work altogether
    if (parent !== null && parent.first !== null) $f03d207193083dd5$export$e8e63959fae22582(effect);
    if (0, $7YIuB.default) effect.component_function = null;
    // `first` and `child` are nulled out in destroy_effect_children
    // we don't null out `parent` so that error propagation can work correctly
    effect.next = effect.prev = effect.teardown = effect.ctx = effect.deps = effect.fn = effect.nodes = effect.ac = effect.b = null;
}
function $f03d207193083dd5$export$1573e8ce9a10f642(node, end) {
    while(node !== null){
        /** @type {TemplateNode | null} */ var next = node === end ? null : (0, $cGH1Z.get_next_sibling)(node);
        node.remove();
        node = next;
    }
}
function $f03d207193083dd5$export$e8e63959fae22582(effect) {
    var parent = effect.parent;
    var prev = effect.prev;
    var next = effect.next;
    if (prev !== null) prev.next = next;
    if (next !== null) next.prev = prev;
    if (parent !== null) {
        if (parent.first === effect) parent.first = next;
        if (parent.last === effect) parent.last = prev;
    }
}
function $f03d207193083dd5$export$3786d6034b1774df(effect, callback, destroy = true) {
    /** @type {TransitionManager[]} */ var transitions = [];
    effect.f |= (0, $8zILj.PAUSED);
    $f03d207193083dd5$var$pause_children(effect, transitions, true);
    var fn = ()=>{
        if (destroy) $f03d207193083dd5$export$d36097075f3ddca0(effect);
        if (callback) callback();
    };
    var remaining = transitions.length;
    if (remaining > 0) {
        var check = ()=>--remaining || fn();
        for (var transition of transitions)transition.out(check);
    } else fn();
}
/**
 * @param {Effect} effect
 * @param {TransitionManager[]} transitions
 * @param {boolean} local
 */ function $f03d207193083dd5$var$pause_children(effect, transitions, local) {
    if ((effect.f & (0, $8zILj.INERT)) !== 0) return;
    effect.f ^= (0, $8zILj.INERT);
    var t = effect.nodes && effect.nodes.t;
    if (t !== null) {
        for (const transition of t)if (transition.is_global || local) transitions.push(transition);
    }
    var child = effect.first;
    while(child !== null){
        var sibling = child.next;
        // If this child is a root effect, then it will become an independent root when its parent
        // is destroyed, it should therefore not become inert nor partake in transitions.
        if ((child.f & (0, $8zILj.ROOT_EFFECT)) === 0) {
            var transparent = (child.f & (0, $8zILj.EFFECT_TRANSPARENT)) !== 0 || // If this is a branch effect without a block effect parent,
            // it means the parent block effect was pruned. In that case,
            // transparency information was transferred to the branch effect.
            (child.f & (0, $8zILj.BRANCH_EFFECT)) !== 0 && (effect.f & (0, $8zILj.BLOCK_EFFECT)) !== 0;
            // TODO we don't need to call pause_children recursively with a linked list in place
            // it's slightly more involved though as we have to account for `transparent` changing
            // through the tree.
            $f03d207193083dd5$var$pause_children(child, transitions, transparent ? local : false);
        }
        child = sibling;
    }
}
function $f03d207193083dd5$export$df93250cb0c63095(effect) {
    effect.f &= ~(0, $8zILj.PAUSED);
    $f03d207193083dd5$var$resume_children(effect, true);
}
/**
 * @param {Effect} effect
 * @param {boolean} local
 */ function $f03d207193083dd5$var$resume_children(effect, local) {
    // this subtree was paused for its own reasons (e.g. a block whose condition
    // is still false) — its controller will resume or destroy it
    if ((effect.f & (0, $8zILj.PAUSED)) !== 0) return;
    if ((effect.f & (0, $8zILj.INERT)) === 0) return;
    effect.f ^= (0, $8zILj.INERT);
    // If a dependency of this effect changed while it was paused,
    // schedule the effect to update. we don't use `is_dirty`
    // here because we don't want to eagerly recompute a derived like
    // `{#if foo}{foo.bar()}{/if}` if `foo` is now `undefined
    if ((effect.f & (0, $8zILj.CLEAN)) === 0) {
        (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.DIRTY));
        (0, $amPy2.Batch).ensure().schedule(effect); // Assumption: This happens during the commit phase of the batch, causing another flush, but it's safe
    }
    var child = effect.first;
    while(child !== null){
        var sibling = child.next;
        var transparent = (child.f & (0, $8zILj.EFFECT_TRANSPARENT)) !== 0 || (child.f & (0, $8zILj.BRANCH_EFFECT)) !== 0;
        // TODO we don't need to call resume_children recursively with a linked list in place
        // it's slightly more involved though as we have to account for `transparent` changing
        // through the tree.
        $f03d207193083dd5$var$resume_children(child, transparent ? local : false);
        child = sibling;
    }
    var t = effect.nodes && effect.nodes.t;
    if (t !== null) {
        for (const transition of t)if (transition.is_global || local) transition.in();
    }
}
function $f03d207193083dd5$export$bd75b6d981b9c7f2(effect = /** @type {Effect} */ (0, $egVZE.active_effect)) {
    return (effect.f & (0, $8zILj.DESTROYED)) !== 0;
}
function $f03d207193083dd5$export$a8dfde9c4dd34764(effect, fragment) {
    if (!effect.nodes) return;
    /** @type {TemplateNode | null} */ var node = effect.nodes.start;
    var end = effect.nodes.end;
    while(node !== null){
        /** @type {TemplateNode | null} */ var next = node === end ? null : (0, $cGH1Z.get_next_sibling)(node);
        fragment.append(node);
        node = next;
    }
}

});
parcelRegister("egVZE", function(module, exports) {

$parcel$export(module.exports, "is_destroying_effect", () => $a63f8b904c3db99a$export$b0d4cc440dd95a56);
$parcel$export(module.exports, "set_is_destroying_effect", () => $a63f8b904c3db99a$export$b5e127c1b6bdbebd);
$parcel$export(module.exports, "active_reaction", () => $a63f8b904c3db99a$export$84bdc7e9b9ee5f10);
$parcel$export(module.exports, "untracking", () => $a63f8b904c3db99a$export$36a609ab88fd4756);
$parcel$export(module.exports, "set_active_reaction", () => $a63f8b904c3db99a$export$8900241b145eef5d);
$parcel$export(module.exports, "active_effect", () => $a63f8b904c3db99a$export$4fb6f59607f7d410);
$parcel$export(module.exports, "set_active_effect", () => $a63f8b904c3db99a$export$b6ae4af6a1272e24);
$parcel$export(module.exports, "current_sources", () => $a63f8b904c3db99a$export$ccbac256300f7698);
$parcel$export(module.exports, "push_reaction_value", () => $a63f8b904c3db99a$export$68926f82103bf64e);
$parcel$export(module.exports, "new_deps", () => $a63f8b904c3db99a$export$dd9c545aac944829);
$parcel$export(module.exports, "skipped_deps", () => $a63f8b904c3db99a$export$fd2796ab0f9e3af7);
$parcel$export(module.exports, "untracked_writes", () => $a63f8b904c3db99a$export$a922e19dc0412eb1);
$parcel$export(module.exports, "set_untracked_writes", () => $a63f8b904c3db99a$export$67fb4484c3b3b878);
$parcel$export(module.exports, "update_version", () => $a63f8b904c3db99a$export$819a4dce32cc4ab);
$parcel$export(module.exports, "set_update_version", () => $a63f8b904c3db99a$export$8837b5cc3072eb6d);
$parcel$export(module.exports, "increment_write_version", () => $a63f8b904c3db99a$export$9ca082398235c4fc);
$parcel$export(module.exports, "is_dirty", () => $a63f8b904c3db99a$export$3d62653d8851da91);
$parcel$export(module.exports, "update_reaction", () => $a63f8b904c3db99a$export$16f2265e33632e80);
$parcel$export(module.exports, "remove_reactions", () => $a63f8b904c3db99a$export$641076aba0f23329);
$parcel$export(module.exports, "update_effect", () => $a63f8b904c3db99a$export$2fbe578f20899d4d);
$parcel$export(module.exports, "get", () => $a63f8b904c3db99a$export$3988ae62b71be9a3);
$parcel$export(module.exports, "untrack", () => $a63f8b904c3db99a$export$363ebc4b78b8f807);
/** @import { Derived, Effect, Reaction, Source, Value } from '#client' */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $btEsq = parcelRequire("btEsq");

var $kCMGX = parcelRequire("kCMGX");

var $8zILj = parcelRequire("8zILj");

var $kmhLl = parcelRequire("kmhLl");

var $3oHv7 = parcelRequire("3oHv7");

var $yJWNn = parcelRequire("yJWNn");

var $4Y2WV = parcelRequire("4Y2WV");

var $9AQvv = parcelRequire("9AQvv");

var $6bkva = parcelRequire("6bkva");

var $amPy2 = parcelRequire("amPy2");

var $1u5nX = parcelRequire("1u5nX");

var $56eus = parcelRequire("56eus");

var $1huCi = parcelRequire("1huCi");

var $4s4uP = parcelRequire("4s4uP");

var $1RLxH = parcelRequire("1RLxH");

var $9iF6l = parcelRequire("9iF6l");
/**
 * True if updating in an effect context that is reactive (i.e. not branch/root effects)
 */ let $a63f8b904c3db99a$var$is_updating_effect = false;
let $a63f8b904c3db99a$export$b0d4cc440dd95a56 = false;
function $a63f8b904c3db99a$export$b5e127c1b6bdbebd(value) {
    $a63f8b904c3db99a$export$b0d4cc440dd95a56 = value;
}
let $a63f8b904c3db99a$export$84bdc7e9b9ee5f10 = null;
let $a63f8b904c3db99a$export$36a609ab88fd4756 = false;
function $a63f8b904c3db99a$export$8900241b145eef5d(reaction) {
    $a63f8b904c3db99a$export$84bdc7e9b9ee5f10 = reaction;
}
let $a63f8b904c3db99a$export$4fb6f59607f7d410 = null;
function $a63f8b904c3db99a$export$b6ae4af6a1272e24(effect) {
    $a63f8b904c3db99a$export$4fb6f59607f7d410 = effect;
}
let $a63f8b904c3db99a$export$ccbac256300f7698 = null;
function $a63f8b904c3db99a$export$68926f82103bf64e(value) {
    if ($a63f8b904c3db99a$export$84bdc7e9b9ee5f10 !== null && (!(0, $yJWNn.async_mode_flag) && ($a63f8b904c3db99a$export$84bdc7e9b9ee5f10.f & (0, $8zILj.REACTION_IS_UPDATING)) !== 0 || ($a63f8b904c3db99a$export$84bdc7e9b9ee5f10.f & (0, $8zILj.DERIVED)) !== 0)) ($a63f8b904c3db99a$export$ccbac256300f7698 ??= new Set()).add(value);
}
let $a63f8b904c3db99a$export$dd9c545aac944829 = null;
let $a63f8b904c3db99a$export$fd2796ab0f9e3af7 = 0;
let $a63f8b904c3db99a$export$a922e19dc0412eb1 = null;
function $a63f8b904c3db99a$export$67fb4484c3b3b878(value) {
    $a63f8b904c3db99a$export$a922e19dc0412eb1 = value;
}
let $a63f8b904c3db99a$export$e0f703da31d5df07 = 1;
/** @type {number} Used to version each read of a source of derived to avoid duplicating dependencies inside a reaction */ let $a63f8b904c3db99a$var$read_version = 0;
let $a63f8b904c3db99a$export$819a4dce32cc4ab = $a63f8b904c3db99a$var$read_version;
function $a63f8b904c3db99a$export$8837b5cc3072eb6d(value) {
    $a63f8b904c3db99a$export$819a4dce32cc4ab = value;
}
function $a63f8b904c3db99a$export$9ca082398235c4fc() {
    return ++$a63f8b904c3db99a$export$e0f703da31d5df07;
}
function $a63f8b904c3db99a$export$3d62653d8851da91(reaction) {
    var flags = reaction.f;
    if ((flags & (0, $8zILj.DIRTY)) !== 0) return true;
    if ((flags & (0, $8zILj.MAYBE_DIRTY)) !== 0) {
        var dependencies = /** @type {Value[]} */ reaction.deps;
        var length = dependencies.length;
        for(var i = 0; i < length; i++){
            var dependency = dependencies[i];
            if ($a63f8b904c3db99a$export$3d62653d8851da91(/** @type {Derived} */ dependency)) (0, $3oHv7.update_derived)(/** @type {Derived} */ dependency);
            if (dependency.wv > reaction.wv) return true;
        }
        if ((flags & (0, $8zILj.CONNECTED)) !== 0 && // During time traveling we don't want to reset the status so that
        // traversal of the graph in the other batches still happens
        (0, $amPy2.batch_values) === null) (0, $1RLxH.set_signal_status)(reaction, (0, $8zILj.CLEAN));
    }
    return false;
}
/**
 * @param {Value} signal
 * @param {Effect} effect
 * @param {boolean} [root]
 */ function $a63f8b904c3db99a$var$schedule_possible_effect_self_invalidation(signal, effect, root = true) {
    var reactions = signal.reactions;
    if (reactions === null) return;
    if (!(0, $yJWNn.async_mode_flag) && $a63f8b904c3db99a$export$ccbac256300f7698 !== null && $a63f8b904c3db99a$export$ccbac256300f7698.has(signal)) return;
    for(var i = 0; i < reactions.length; i++){
        var reaction = reactions[i];
        if ((reaction.f & (0, $8zILj.DERIVED)) !== 0) $a63f8b904c3db99a$var$schedule_possible_effect_self_invalidation(/** @type {Derived} */ reaction, effect, false);
        else if (effect === reaction) {
            if (root) (0, $1RLxH.set_signal_status)(reaction, (0, $8zILj.DIRTY));
            else if ((reaction.f & (0, $8zILj.CLEAN)) !== 0) (0, $1RLxH.set_signal_status)(reaction, (0, $8zILj.MAYBE_DIRTY));
            (0, $amPy2.schedule_effect)(/** @type {Effect} */ reaction);
        }
    }
}
function $a63f8b904c3db99a$export$16f2265e33632e80(reaction) {
    var previous_deps = $a63f8b904c3db99a$export$dd9c545aac944829;
    var previous_skipped_deps = $a63f8b904c3db99a$export$fd2796ab0f9e3af7;
    var previous_untracked_writes = $a63f8b904c3db99a$export$a922e19dc0412eb1;
    var previous_reaction = $a63f8b904c3db99a$export$84bdc7e9b9ee5f10;
    var previous_sources = $a63f8b904c3db99a$export$ccbac256300f7698;
    var previous_component_context = (0, $6bkva.component_context);
    var previous_untracking = $a63f8b904c3db99a$export$36a609ab88fd4756;
    var previous_update_version = $a63f8b904c3db99a$export$819a4dce32cc4ab;
    var flags = reaction.f;
    $a63f8b904c3db99a$export$dd9c545aac944829 = /** @type {null | Value[]} */ null;
    $a63f8b904c3db99a$export$fd2796ab0f9e3af7 = 0;
    $a63f8b904c3db99a$export$a922e19dc0412eb1 = null;
    $a63f8b904c3db99a$export$84bdc7e9b9ee5f10 = (flags & ((0, $8zILj.BRANCH_EFFECT) | (0, $8zILj.ROOT_EFFECT))) === 0 ? reaction : null;
    $a63f8b904c3db99a$export$ccbac256300f7698 = null;
    (0, $6bkva.set_component_context)(reaction.ctx);
    $a63f8b904c3db99a$export$36a609ab88fd4756 = false;
    $a63f8b904c3db99a$export$819a4dce32cc4ab = ++$a63f8b904c3db99a$var$read_version;
    if (reaction.ac !== null) {
        (0, $4s4uP.without_reactive_context)(()=>{
            /** @type {AbortController} */ reaction.ac.abort((0, $8zILj.STALE_REACTION));
        });
        reaction.ac = null;
    }
    try {
        reaction.f |= (0, $8zILj.REACTION_IS_UPDATING);
        var fn = /** @type {Function} */ reaction.fn;
        var result = fn();
        reaction.f |= (0, $8zILj.REACTION_RAN);
        var deps = $a63f8b904c3db99a$var$update_dependencies(reaction);
        // If we're inside an effect and we have untracked writes, then we need to
        // ensure that if any of those untracked writes result in re-invalidation
        // of the current effect, then that happens accordingly
        if ((0, $6bkva.is_runes)() && $a63f8b904c3db99a$export$a922e19dc0412eb1 !== null && !$a63f8b904c3db99a$export$36a609ab88fd4756 && deps !== null && (reaction.f & ((0, $8zILj.DERIVED) | (0, $8zILj.MAYBE_DIRTY) | (0, $8zILj.DIRTY))) === 0) for(var i = 0; i < /** @type {Source[]} */ $a63f8b904c3db99a$export$a922e19dc0412eb1.length; i++)$a63f8b904c3db99a$var$schedule_possible_effect_self_invalidation($a63f8b904c3db99a$export$a922e19dc0412eb1[i], /** @type {Effect} */ reaction);
        // If we are returning to an previous reaction then
        // we need to increment the read version to ensure that
        // any dependencies in this reaction aren't marked with
        // the same version
        if (previous_reaction !== null && previous_reaction !== reaction) {
            $a63f8b904c3db99a$var$read_version++;
            // update the `rv` of the previous reaction's deps — both existing and new —
            // so that they are not added again
            if (previous_reaction.deps !== null) for(let i = 0; i < previous_skipped_deps; i += 1)previous_reaction.deps[i].rv = $a63f8b904c3db99a$var$read_version;
            if (previous_deps !== null) for (const dep of previous_deps)dep.rv = $a63f8b904c3db99a$var$read_version;
            if ($a63f8b904c3db99a$export$a922e19dc0412eb1 !== null) {
                if (previous_untracked_writes === null) previous_untracked_writes = $a63f8b904c3db99a$export$a922e19dc0412eb1;
                else previous_untracked_writes.push(.../** @type {Source[]} */ $a63f8b904c3db99a$export$a922e19dc0412eb1);
            }
        }
        if ((reaction.f & (0, $8zILj.ERROR_VALUE)) !== 0) reaction.f ^= (0, $8zILj.ERROR_VALUE);
        return result;
    } catch (error) {
        // still commit the deps read before the throw, otherwise deriveds connected by this run keep no reader and the reaction never re-runs when they change
        $a63f8b904c3db99a$var$update_dependencies(reaction);
        return (0, $1u5nX.handle_error)(error);
    } finally{
        reaction.f ^= (0, $8zILj.REACTION_IS_UPDATING);
        $a63f8b904c3db99a$export$dd9c545aac944829 = previous_deps;
        $a63f8b904c3db99a$export$fd2796ab0f9e3af7 = previous_skipped_deps;
        $a63f8b904c3db99a$export$a922e19dc0412eb1 = previous_untracked_writes;
        $a63f8b904c3db99a$export$84bdc7e9b9ee5f10 = previous_reaction;
        $a63f8b904c3db99a$export$ccbac256300f7698 = previous_sources;
        (0, $6bkva.set_component_context)(previous_component_context);
        $a63f8b904c3db99a$export$36a609ab88fd4756 = previous_untracking;
        $a63f8b904c3db99a$export$819a4dce32cc4ab = previous_update_version;
    }
}
/**
 * @param {Reaction} reaction
 */ function $a63f8b904c3db99a$var$update_dependencies(reaction) {
    var deps = reaction.deps;
    // Don't remove reactions during fork;
    // they must remain for when fork is discarded
    var is_fork = (0, $amPy2.current_batch)?.is_fork;
    if ($a63f8b904c3db99a$export$dd9c545aac944829 !== null) {
        var i;
        if (!is_fork) $a63f8b904c3db99a$export$641076aba0f23329(reaction, $a63f8b904c3db99a$export$fd2796ab0f9e3af7);
        if (deps !== null && $a63f8b904c3db99a$export$fd2796ab0f9e3af7 > 0) {
            deps.length = $a63f8b904c3db99a$export$fd2796ab0f9e3af7 + $a63f8b904c3db99a$export$dd9c545aac944829.length;
            for(i = 0; i < $a63f8b904c3db99a$export$dd9c545aac944829.length; i++)deps[$a63f8b904c3db99a$export$fd2796ab0f9e3af7 + i] = $a63f8b904c3db99a$export$dd9c545aac944829[i];
        } else reaction.deps = deps = $a63f8b904c3db99a$export$dd9c545aac944829;
        if ((0, $kCMGX.effect_tracking)() && (reaction.f & (0, $8zILj.CONNECTED)) !== 0) for(i = $a63f8b904c3db99a$export$fd2796ab0f9e3af7; i < deps.length; i++)(deps[i].reactions ??= []).push(reaction);
    } else if (!is_fork && deps !== null && $a63f8b904c3db99a$export$fd2796ab0f9e3af7 < deps.length) {
        $a63f8b904c3db99a$export$641076aba0f23329(reaction, $a63f8b904c3db99a$export$fd2796ab0f9e3af7);
        deps.length = $a63f8b904c3db99a$export$fd2796ab0f9e3af7;
    }
    return deps;
}
/**
 * @template V
 * @param {Reaction} signal
 * @param {Value<V>} dependency
 * @returns {void}
 */ function $a63f8b904c3db99a$var$remove_reaction(signal, dependency) {
    let reactions = dependency.reactions;
    if (reactions !== null) {
        var index = (0, $btEsq.index_of).call(reactions, signal);
        if (index !== -1) {
            var new_length = reactions.length - 1;
            if (new_length === 0) reactions = dependency.reactions = null;
            else {
                // Swap with last element and then remove.
                reactions[index] = reactions[new_length];
                reactions.pop();
            }
        }
    }
    // If the derived has no reactions, then we can disconnect it from the graph,
    // allowing it to either reconnect in the future, or be GC'd by the VM.
    if (reactions === null && (dependency.f & (0, $8zILj.DERIVED)) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
    // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
    // allows us to skip the expensive work of disconnecting and immediately reconnecting it
    ($a63f8b904c3db99a$export$dd9c545aac944829 === null || !(0, $btEsq.includes).call($a63f8b904c3db99a$export$dd9c545aac944829, dependency))) {
        var derived = /** @type {Derived} */ dependency;
        if ((derived.f & (0, $8zILj.CONNECTED)) !== 0) derived.f ^= (0, $8zILj.CONNECTED);
        // In a fork it's possible that a derived is executed and gets reactions, then commits, but is
        // never re-executed. This is possible when the derived is only executed once in the context
        // of a new branch which happens before fork.commit() runs. In this case, the derived still has
        // UNINITIALIZED as its value, and then when it's loosing its reactions we need to ensure it stays
        // DIRTY so it is reexecuted once someone wants its value again.
        if (derived.v !== (0, $56eus.UNINITIALIZED)) (0, $1RLxH.update_derived_status)(derived);
        // Call abort controller, noone's listening to this derived anymore
        if (derived.ac !== null) (0, $4s4uP.without_reactive_context)(()=>{
            /** @type {AbortController} */ derived.ac.abort((0, $8zILj.STALE_REACTION));
            derived.ac = null;
            // ensure it reruns right away next time instead of potentially returning a rejected promise as its value
            (0, $1RLxH.set_signal_status)(derived, (0, $8zILj.DIRTY));
        });
        // freeze any effects inside this derived
        (0, $3oHv7.freeze_derived_effects)(derived);
        // Disconnect any reactions owned by this reaction
        $a63f8b904c3db99a$export$641076aba0f23329(derived, 0);
    }
}
function $a63f8b904c3db99a$export$641076aba0f23329(signal, start_index) {
    var dependencies = signal.deps;
    if (dependencies === null) return;
    for(var i = start_index; i < dependencies.length; i++)$a63f8b904c3db99a$var$remove_reaction(signal, dependencies[i]);
}
function $a63f8b904c3db99a$export$2fbe578f20899d4d(effect) {
    var flags = effect.f;
    if ((flags & (0, $8zILj.DESTROYED)) !== 0) return;
    (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.CLEAN));
    var previous_effect = $a63f8b904c3db99a$export$4fb6f59607f7d410;
    var was_updating_effect = $a63f8b904c3db99a$var$is_updating_effect;
    $a63f8b904c3db99a$export$4fb6f59607f7d410 = effect;
    $a63f8b904c3db99a$var$is_updating_effect = (flags & ((0, $8zILj.BRANCH_EFFECT) | (0, $8zILj.ROOT_EFFECT))) === 0; // Branch/root effects are not reactive contexts
    if (0, $7YIuB.default) {
        var previous_component_fn = (0, $6bkva.dev_current_component_function);
        (0, $6bkva.set_dev_current_component_function)(effect.component_function);
        var previous_stack = /** @type {any} */ (0, $6bkva.dev_stack);
        // only block effects have a dev stack, keep the current one otherwise
        (0, $6bkva.set_dev_stack)(effect.dev_stack ?? (0, $6bkva.dev_stack));
    }
    try {
        if ((flags & ((0, $8zILj.BLOCK_EFFECT) | (0, $8zILj.MANAGED_EFFECT))) !== 0) (0, $kCMGX.destroy_block_effect_children)(effect);
        else (0, $kCMGX.destroy_effect_children)(effect);
        (0, $kCMGX.execute_effect_teardown)(effect);
        var teardown = $a63f8b904c3db99a$export$16f2265e33632e80(effect);
        effect.teardown = typeof teardown === 'function' ? teardown : null;
        effect.wv = $a63f8b904c3db99a$export$e0f703da31d5df07;
        // In DEV, increment versions of any sources that were written to during the effect,
        // so that they are correctly marked as dirty when the effect re-runs
        if ((0, $7YIuB.default) && (0, $yJWNn.tracing_mode_flag) && (effect.f & (0, $8zILj.DIRTY)) !== 0 && effect.deps !== null) {
            for (var dep of effect.deps)if (dep.set_during_effect) {
                dep.wv = $a63f8b904c3db99a$export$9ca082398235c4fc();
                dep.set_during_effect = false;
            }
        }
    } finally{
        $a63f8b904c3db99a$var$is_updating_effect = was_updating_effect;
        $a63f8b904c3db99a$export$4fb6f59607f7d410 = previous_effect;
        if (0, $7YIuB.default) {
            (0, $6bkva.set_dev_current_component_function)(previous_component_fn);
            (0, $6bkva.set_dev_stack)(previous_stack);
        }
    }
}
async function $a63f8b904c3db99a$export$55d7f61db91b7b70() {
    if (0, $yJWNn.async_mode_flag) return new Promise((f)=>{
        // Race them against each other - in almost all cases requestAnimationFrame will fire first,
        // but e.g. in case the window is not focused or a view transition happens, requestAnimationFrame
        // will be delayed and setTimeout helps us resolve fast enough in that case
        requestAnimationFrame(()=>f());
        setTimeout(()=>f());
    });
    await Promise.resolve();
    // By calling flushSync we guarantee that any pending state changes are applied after one tick.
    // TODO look into whether we can make flushing subsequent updates synchronously in the future.
    (0, $amPy2.flushSync)();
}
function $a63f8b904c3db99a$export$3910381886d0de18() {
    return (0, $amPy2.Batch).ensure().settled();
}
function $a63f8b904c3db99a$export$3988ae62b71be9a3(signal) {
    var flags = signal.f;
    var is_derived = (flags & (0, $8zILj.DERIVED)) !== 0;
    (0, $1huCi.captured_signals)?.add(signal);
    // Register the dependency on the current reaction signal.
    if ($a63f8b904c3db99a$export$84bdc7e9b9ee5f10 !== null && !$a63f8b904c3db99a$export$36a609ab88fd4756) {
        // if we're in a derived that is being read inside an _async_ derived,
        // it's possible that the effect was already destroyed. In this case,
        // we don't add the dependency, because that would create a memory leak
        var destroyed = $a63f8b904c3db99a$export$4fb6f59607f7d410 !== null && ($a63f8b904c3db99a$export$4fb6f59607f7d410.f & (0, $8zILj.DESTROYED)) !== 0;
        if (!destroyed && ($a63f8b904c3db99a$export$ccbac256300f7698 === null || !$a63f8b904c3db99a$export$ccbac256300f7698.has(signal))) {
            var deps = $a63f8b904c3db99a$export$84bdc7e9b9ee5f10.deps;
            if (($a63f8b904c3db99a$export$84bdc7e9b9ee5f10.f & (0, $8zILj.REACTION_IS_UPDATING)) !== 0) // we're in the effect init/update cycle
            {
                if (signal.rv < $a63f8b904c3db99a$var$read_version) {
                    signal.rv = $a63f8b904c3db99a$var$read_version;
                    // If the signal is accessing the same dependencies in the same
                    // order as it did last time, increment `skipped_deps`
                    // rather than updating `new_deps`, which creates GC cost
                    if ($a63f8b904c3db99a$export$dd9c545aac944829 === null && deps !== null && deps[$a63f8b904c3db99a$export$fd2796ab0f9e3af7] === signal) $a63f8b904c3db99a$export$fd2796ab0f9e3af7++;
                    else if ($a63f8b904c3db99a$export$dd9c545aac944829 === null) $a63f8b904c3db99a$export$dd9c545aac944829 = [
                        signal
                    ];
                    else $a63f8b904c3db99a$export$dd9c545aac944829.push(signal);
                }
            } else {
                // We're adding a dependency outside the init/update cycle (i.e. after an `await`).
                // We have to deduplicate deps/reactions in this case or remove_reactions could
                // disconnect deps/reactions that are actually still in use (if skip_deps says
                // "disconnect all after this index" and some of the signals are also present in
                // list prior to the cutoff index, i.e. that should be kept).
                $a63f8b904c3db99a$export$84bdc7e9b9ee5f10.deps ??= [];
                if (!(0, $btEsq.includes).call($a63f8b904c3db99a$export$84bdc7e9b9ee5f10.deps, signal)) $a63f8b904c3db99a$export$84bdc7e9b9ee5f10.deps.push(signal);
                var reactions = signal.reactions;
                if (reactions === null) signal.reactions = [
                    $a63f8b904c3db99a$export$84bdc7e9b9ee5f10
                ];
                else if (!(0, $btEsq.includes).call(reactions, $a63f8b904c3db99a$export$84bdc7e9b9ee5f10)) reactions.push($a63f8b904c3db99a$export$84bdc7e9b9ee5f10);
            }
        }
    }
    if (0, $7YIuB.default) {
        if (!$a63f8b904c3db99a$export$36a609ab88fd4756 && (0, $3oHv7.reactivity_loss_tracker) && // By checking that current/previous batch are null we filter out false positives.
        // reactivity_loss_tracker is only reset after a microtask, so if a flush happens
        // before that, we get warnings for things we shouldn't warn on.
        (0, $amPy2.current_batch) === null && (0, $amPy2.previous_batch) === null && !(0, $3oHv7.reactivity_loss_tracker).warned && ((0, $3oHv7.reactivity_loss_tracker).effect.f & (0, $8zILj.REACTION_IS_UPDATING)) === 0 && !(0, $3oHv7.reactivity_loss_tracker).effect_deps.has(signal)) {
            (0, $3oHv7.reactivity_loss_tracker).warned = true;
            $9iF6l.await_reactivity_loss(/** @type {string} */ signal.label);
            var trace = (0, $9AQvv.get_error)('traced at');
            // eslint-disable-next-line no-console
            if (trace) console.warn(trace);
        }
        (0, $3oHv7.recent_async_deriveds).delete(signal);
        if ((0, $yJWNn.tracing_mode_flag) && !$a63f8b904c3db99a$export$36a609ab88fd4756 && (0, $4Y2WV.tracing_expressions) !== null && $a63f8b904c3db99a$export$84bdc7e9b9ee5f10 !== null && (0, $4Y2WV.tracing_expressions).reaction === $a63f8b904c3db99a$export$84bdc7e9b9ee5f10) {
            // Used when mapping state between special blocks like `each`
            if (signal.trace) signal.trace();
            else {
                trace = (0, $9AQvv.get_error)('traced at');
                if (trace) {
                    var entry = (0, $4Y2WV.tracing_expressions).entries.get(signal);
                    if (entry === undefined) {
                        entry = {
                            traces: []
                        };
                        (0, $4Y2WV.tracing_expressions).entries.set(signal, entry);
                    }
                    var last = entry.traces[entry.traces.length - 1];
                    // traces can be duplicated, e.g. by `snapshot` invoking both
                    // both `getOwnPropertyDescriptor` and `get` traps at once
                    if (trace.stack !== last?.stack) entry.traces.push(trace);
                }
            }
        }
    }
    if ($a63f8b904c3db99a$export$b0d4cc440dd95a56 && (0, $kmhLl.old_values).has(signal)) return (0, $kmhLl.old_values).get(signal);
    if (is_derived) {
        var derived = /** @type {Derived} */ signal;
        if ($a63f8b904c3db99a$export$b0d4cc440dd95a56) {
            var value = derived.v;
            // if the derived is dirty and has reactions, or depends on the values that just changed, re-execute
            // (a derived can be maybe_dirty due to the effect destroy removing its last reaction)
            if ((derived.f & (0, $8zILj.CLEAN)) === 0 && derived.reactions !== null || $a63f8b904c3db99a$var$depends_on_old_values(derived)) value = (0, $3oHv7.execute_derived)(derived);
            (0, $kmhLl.old_values).set(derived, value);
            return value;
        }
        // connect disconnected deriveds if we are reading them inside an effect,
        // or inside another derived that is already connected
        var should_connect = (derived.f & (0, $8zILj.CONNECTED)) === 0 && !$a63f8b904c3db99a$export$36a609ab88fd4756 && $a63f8b904c3db99a$export$84bdc7e9b9ee5f10 !== null && ($a63f8b904c3db99a$var$is_updating_effect || ($a63f8b904c3db99a$export$84bdc7e9b9ee5f10.f & (0, $8zILj.CONNECTED)) !== 0);
        var is_new = (derived.f & (0, $8zILj.REACTION_RAN)) === 0;
        if ($a63f8b904c3db99a$export$3d62653d8851da91(derived)) {
            if (should_connect) // set the flag before `update_derived`, so that the derived
            // is added as a reaction to its dependencies
            derived.f |= (0, $8zILj.CONNECTED);
            (0, $3oHv7.update_derived)(derived);
        }
        if (should_connect && !is_new) {
            (0, $3oHv7.unfreeze_derived_effects)(derived);
            $a63f8b904c3db99a$var$reconnect(derived);
        }
    }
    if ((0, $amPy2.batch_values)?.has(signal)) return (0, $amPy2.batch_values).get(signal);
    if ((signal.f & (0, $8zILj.ERROR_VALUE)) !== 0) throw signal.v;
    return signal.v;
}
/**
 * (Re)connect a disconnected derived, so that it is notified
 * of changes in `mark_reactions`
 * @param {Derived} derived
 */ function $a63f8b904c3db99a$var$reconnect(derived) {
    derived.f |= (0, $8zILj.CONNECTED);
    if (derived.deps === null) return;
    for (const dep of derived.deps){
        (dep.reactions ??= []).push(derived);
        if ((dep.f & (0, $8zILj.DERIVED)) !== 0 && (dep.f & (0, $8zILj.CONNECTED)) === 0) {
            (0, $3oHv7.unfreeze_derived_effects)(/** @type {Derived} */ dep);
            $a63f8b904c3db99a$var$reconnect(/** @type {Derived} */ dep);
        }
    }
}
/** @param {Derived} derived */ function $a63f8b904c3db99a$var$depends_on_old_values(derived) {
    if (derived.v === (0, $56eus.UNINITIALIZED)) return true; // we don't know, so assume the worst
    if (derived.deps === null) return false;
    for (const dep of derived.deps){
        if ((0, $kmhLl.old_values).has(dep)) return true;
        if ((dep.f & (0, $8zILj.DERIVED)) !== 0 && $a63f8b904c3db99a$var$depends_on_old_values(/** @type {Derived} */ dep)) return true;
    }
    return false;
}
function $a63f8b904c3db99a$export$73c1c1ae71019157(signal) {
    return signal && $a63f8b904c3db99a$export$3988ae62b71be9a3(signal);
}
function $a63f8b904c3db99a$export$363ebc4b78b8f807(fn) {
    var previous_untracking = $a63f8b904c3db99a$export$36a609ab88fd4756;
    try {
        $a63f8b904c3db99a$export$36a609ab88fd4756 = true;
        return fn();
    } finally{
        $a63f8b904c3db99a$export$36a609ab88fd4756 = previous_untracking;
    }
}
function $a63f8b904c3db99a$export$1bd64e87083275a2(value) {
    if (typeof value !== 'object' || !value || value instanceof EventTarget) return;
    if ((0, $8zILj.STATE_SYMBOL) in value) $a63f8b904c3db99a$export$684fc8900ea94d6e(value);
    else if (!Array.isArray(value)) for(let key in value){
        const prop = value[key];
        if (typeof prop === 'object' && prop && (0, $8zILj.STATE_SYMBOL) in prop) $a63f8b904c3db99a$export$684fc8900ea94d6e(prop);
    }
}
function $a63f8b904c3db99a$export$684fc8900ea94d6e(value, visited = new Set()) {
    if (typeof value === 'object' && value !== null && // We don't want to traverse DOM elements
    !(value instanceof EventTarget) && !visited.has(value)) {
        visited.add(value);
        // When working with a possible SvelteDate, this
        // will ensure we capture changes to it.
        if (value instanceof Date) value.getTime();
        for(let key in value)try {
            $a63f8b904c3db99a$export$684fc8900ea94d6e(value[key], visited);
        } catch (e) {
        // continue
        }
        const proto = (0, $btEsq.get_prototype_of)(value);
        if (proto !== Object.prototype && proto !== Array.prototype && proto !== Map.prototype && proto !== Set.prototype && proto !== Date.prototype) {
            const descriptors = (0, $btEsq.get_descriptors)(proto);
            for(let key in descriptors){
                const get = descriptors[key].get;
                if (get) try {
                    get.call(value);
                } catch (e) {
                // continue
                }
            }
        }
    }
}

});
parcelRegister("j45IX", function(module, exports) {

$parcel$export(module.exports, "DEV", () => (parcelRequire("7YIuB")).default);

var $bWVhV = parcelRequire("bWVhV");

var $7YIuB = parcelRequire("7YIuB");

var $7YIuB = parcelRequire("7YIuB");

});
parcelRegister("bWVhV", function(module, exports) {
var $8b318cb8831345f7$export$2e2bcd8739ae039 = true;

});

parcelRegister("7YIuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf0a64932031bbf$export$2e2bcd8739ae039);
var $5cf0a64932031bbf$export$2e2bcd8739ae039 = false;

});


parcelRegister("btEsq", function(module, exports) {

$parcel$export(module.exports, "is_array", () => $85b1c922ed0e8976$export$e11d765514e26475);
$parcel$export(module.exports, "index_of", () => $85b1c922ed0e8976$export$a7868fb984614308);
$parcel$export(module.exports, "includes", () => $85b1c922ed0e8976$export$ee2e0f811dca1807);
$parcel$export(module.exports, "define_property", () => $85b1c922ed0e8976$export$60ea236f8cb922bc);
$parcel$export(module.exports, "get_descriptor", () => $85b1c922ed0e8976$export$2204aca04a4ad675);
$parcel$export(module.exports, "get_descriptors", () => $85b1c922ed0e8976$export$cb9de6e734501ffb);
$parcel$export(module.exports, "object_prototype", () => $85b1c922ed0e8976$export$2c3ee90b9996b9f0);
$parcel$export(module.exports, "array_prototype", () => $85b1c922ed0e8976$export$aa705f6cb7dea514);
$parcel$export(module.exports, "get_prototype_of", () => $85b1c922ed0e8976$export$5a1a440a36bf8583);
$parcel$export(module.exports, "is_extensible", () => $85b1c922ed0e8976$export$bd8dd56376bbb55c);
$parcel$export(module.exports, "noop", () => $85b1c922ed0e8976$export$8793edee2d425525);
$parcel$export(module.exports, "run_all", () => $85b1c922ed0e8976$export$3f1fcd837f99a9ab);
$parcel$export(module.exports, "deferred", () => $85b1c922ed0e8976$export$b37aab7cecdd910a);
// Store the references to globals in case someone tries to monkey patch these, causing the below
// to de-opt (this occurs often when using popular extensions).
var $85b1c922ed0e8976$export$e11d765514e26475 = Array.isArray;
var $85b1c922ed0e8976$export$a7868fb984614308 = Array.prototype.indexOf;
var $85b1c922ed0e8976$export$ee2e0f811dca1807 = Array.prototype.includes;
var $85b1c922ed0e8976$export$85baed4b429e2dd9 = Array.from;
var $85b1c922ed0e8976$export$78216dbaed710b3a = Object.keys;
var $85b1c922ed0e8976$export$60ea236f8cb922bc = Object.defineProperty;
var $85b1c922ed0e8976$export$2204aca04a4ad675 = Object.getOwnPropertyDescriptor;
var $85b1c922ed0e8976$export$cb9de6e734501ffb = Object.getOwnPropertyDescriptors;
var $85b1c922ed0e8976$export$2c3ee90b9996b9f0 = Object.prototype;
var $85b1c922ed0e8976$export$aa705f6cb7dea514 = Array.prototype;
var $85b1c922ed0e8976$export$5a1a440a36bf8583 = Object.getPrototypeOf;
var $85b1c922ed0e8976$export$bd8dd56376bbb55c = Object.isExtensible;
var $85b1c922ed0e8976$export$85d81721e606b4cf = Object.prototype.hasOwnProperty;
function $85b1c922ed0e8976$export$b451353ebd749597(thing) {
    return typeof thing === 'function';
}
const $85b1c922ed0e8976$export$8793edee2d425525 = ()=>{};
function $85b1c922ed0e8976$export$7666b03abe8479da(value) {
    return typeof value?.then === 'function';
}
function $85b1c922ed0e8976$export$889ea624f2cb2c57(fn) {
    return fn();
}
function $85b1c922ed0e8976$export$3f1fcd837f99a9ab(arr) {
    for(var i = 0; i < arr.length; i++)arr[i]();
}
function $85b1c922ed0e8976$export$b37aab7cecdd910a() {
    /** @type {(value: T) => void} */ var resolve;
    /** @type {(reason: any) => void} */ var reject;
    /** @type {Promise<T>} */ var promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    // @ts-expect-error
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
function $85b1c922ed0e8976$export$bcd1dd1f397bba12(value, fallback1, lazy = false) {
    return value === undefined ? lazy ? /** @type {() => V} */ fallback1() : /** @type {V} */ fallback1 : value;
}
function $85b1c922ed0e8976$export$637eacb6dd8246c8(value, n) {
    // return arrays unchanged
    if (Array.isArray(value)) return value;
    // if value is not iterable, or `n` is unspecified (indicates a rest
    // element, which means we're not concerned about unbounded iterables)
    // convert to an array with `Array.from`
    if (n === undefined || !(Symbol.iterator in value)) return Array.from(value);
    // otherwise, populate an array with `n` values
    /** @type {T[]} */ const array = [];
    for (const element of value){
        array.push(element);
        if (array.length === n) break;
    }
    return array;
}
function $85b1c922ed0e8976$export$88d7a2a5a2b84789(obj, keys) {
    /** @type {Record<string | symbol, unknown>} */ var result = {};
    for(var key in obj)if (!keys.includes(key)) result[key] = obj[key];
    for (var symbol of Object.getOwnPropertySymbols(obj))if (Object.propertyIsEnumerable.call(obj, symbol) && !keys.includes(symbol)) result[symbol] = obj[symbol];
    return result;
}

});

parcelRegister("8zILj", function(module, exports) {

$parcel$export(module.exports, "DERIVED", () => $63e4506e45707d16$export$3d42e8391a720aa4);
$parcel$export(module.exports, "EFFECT", () => $63e4506e45707d16$export$4afca9a08097ec4f);
$parcel$export(module.exports, "RENDER_EFFECT", () => $63e4506e45707d16$export$17da709bf94ab11e);
$parcel$export(module.exports, "MANAGED_EFFECT", () => $63e4506e45707d16$export$73d839b8bffc776f);
$parcel$export(module.exports, "BLOCK_EFFECT", () => $63e4506e45707d16$export$2b3a2feb15a53037);
$parcel$export(module.exports, "BRANCH_EFFECT", () => $63e4506e45707d16$export$c00de486fc41390d);
$parcel$export(module.exports, "ROOT_EFFECT", () => $63e4506e45707d16$export$2c751c5c4d16d61f);
$parcel$export(module.exports, "BOUNDARY_EFFECT", () => $63e4506e45707d16$export$9ff51563d2d1f517);
$parcel$export(module.exports, "PAUSED", () => $63e4506e45707d16$export$3ad39751a33c16b8);
$parcel$export(module.exports, "CONNECTED", () => $63e4506e45707d16$export$1a9cf3a686991f62);
$parcel$export(module.exports, "CLEAN", () => $63e4506e45707d16$export$1a70fabcf70df0f5);
$parcel$export(module.exports, "DIRTY", () => $63e4506e45707d16$export$325a211da9693fcf);
$parcel$export(module.exports, "MAYBE_DIRTY", () => $63e4506e45707d16$export$b19413bdbbd24758);
$parcel$export(module.exports, "INERT", () => $63e4506e45707d16$export$a5125ac49442f4e2);
$parcel$export(module.exports, "DESTROYED", () => $63e4506e45707d16$export$74e6752c3968d283);
$parcel$export(module.exports, "REACTION_RAN", () => $63e4506e45707d16$export$e60519ae5dfd8811);
$parcel$export(module.exports, "DESTROYING", () => $63e4506e45707d16$export$b3c1b08f59df5116);
$parcel$export(module.exports, "EFFECT_TRANSPARENT", () => $63e4506e45707d16$export$1fe53e6359c37f1d);
$parcel$export(module.exports, "EAGER_EFFECT", () => $63e4506e45707d16$export$8bb921ac5818f465);
$parcel$export(module.exports, "HEAD_EFFECT", () => $63e4506e45707d16$export$9c996fb87cd97aae);
$parcel$export(module.exports, "EFFECT_PRESERVED", () => $63e4506e45707d16$export$adc04c584906bf08);
$parcel$export(module.exports, "USER_EFFECT", () => $63e4506e45707d16$export$986b9ccf332b1422);
$parcel$export(module.exports, "REACTION_IS_UPDATING", () => $63e4506e45707d16$export$ad4ad13368986b64);
$parcel$export(module.exports, "ASYNC", () => $63e4506e45707d16$export$cb95a2b9f7879091);
$parcel$export(module.exports, "ERROR_VALUE", () => $63e4506e45707d16$export$9393653a7fa5dfc0);
$parcel$export(module.exports, "STATE_SYMBOL", () => $63e4506e45707d16$export$da1266d54dd469c1);
$parcel$export(module.exports, "COMPONENT_SYMBOL", () => $63e4506e45707d16$export$47f4402f338dd1fc);
$parcel$export(module.exports, "PROXY_PATH_SYMBOL", () => $63e4506e45707d16$export$6547deb671d317f8);
$parcel$export(module.exports, "ATTRIBUTES_CACHE", () => $63e4506e45707d16$export$f927efdfd934b912);
$parcel$export(module.exports, "CLASS_CACHE", () => $63e4506e45707d16$export$e2f0c05930078b5e);
$parcel$export(module.exports, "STYLE_CACHE", () => $63e4506e45707d16$export$d0fd66f19e3a14f6);
$parcel$export(module.exports, "TEXT_CACHE", () => $63e4506e45707d16$export$40a753efa10101d3);
$parcel$export(module.exports, "FORM_RESET_HANDLER", () => $63e4506e45707d16$export$6f1a4c2c867fcd62);
$parcel$export(module.exports, "STALE_REACTION", () => $63e4506e45707d16$export$8b70a2934d1dc30a);
$parcel$export(module.exports, "TEXT_NODE", () => $63e4506e45707d16$export$5bcc40203615fc2e);
$parcel$export(module.exports, "COMMENT_NODE", () => $63e4506e45707d16$export$3d597a6ef0f08b0a);
// General flags
const $63e4506e45707d16$export$3d42e8391a720aa4 = 2;
const $63e4506e45707d16$export$4afca9a08097ec4f = 4;
const $63e4506e45707d16$export$17da709bf94ab11e = 8;
const $63e4506e45707d16$export$73d839b8bffc776f = 16777216;
const $63e4506e45707d16$export$2b3a2feb15a53037 = 16;
const $63e4506e45707d16$export$c00de486fc41390d = 32;
const $63e4506e45707d16$export$2c751c5c4d16d61f = 64;
const $63e4506e45707d16$export$9ff51563d2d1f517 = 128;
const $63e4506e45707d16$export$3ad39751a33c16b8 = 256;
const $63e4506e45707d16$export$1a9cf3a686991f62 = 512;
const $63e4506e45707d16$export$1a70fabcf70df0f5 = 1024;
const $63e4506e45707d16$export$325a211da9693fcf = 2048;
const $63e4506e45707d16$export$b19413bdbbd24758 = 4096;
const $63e4506e45707d16$export$a5125ac49442f4e2 = 8192;
const $63e4506e45707d16$export$74e6752c3968d283 = 16384;
const $63e4506e45707d16$export$e60519ae5dfd8811 = 32768;
const $63e4506e45707d16$export$b3c1b08f59df5116 = 33554432;
const $63e4506e45707d16$export$1fe53e6359c37f1d = 65536;
const $63e4506e45707d16$export$8bb921ac5818f465 = 131072;
const $63e4506e45707d16$export$9c996fb87cd97aae = 262144;
const $63e4506e45707d16$export$adc04c584906bf08 = 524288;
const $63e4506e45707d16$export$986b9ccf332b1422 = 1048576;
const $63e4506e45707d16$export$76cb648b69b086ec = 33554432;
const $63e4506e45707d16$export$ad4ad13368986b64 = 2097152;
const $63e4506e45707d16$export$cb95a2b9f7879091 = 4194304;
const $63e4506e45707d16$export$9393653a7fa5dfc0 = 8388608;
const $63e4506e45707d16$export$da1266d54dd469c1 = Symbol('$state');
const $63e4506e45707d16$export$47f4402f338dd1fc = Symbol('component');
const $63e4506e45707d16$export$40eeb3adf09b8416 = Symbol('legacy props');
const $63e4506e45707d16$export$5b3e8854bb5b695d = Symbol('');
const $63e4506e45707d16$export$6547deb671d317f8 = Symbol('proxy path');
const $63e4506e45707d16$export$f927efdfd934b912 = Symbol('attributes');
const $63e4506e45707d16$export$e2f0c05930078b5e = Symbol('class');
const $63e4506e45707d16$export$d0fd66f19e3a14f6 = Symbol('style');
const $63e4506e45707d16$export$40a753efa10101d3 = Symbol('text');
const $63e4506e45707d16$export$6f1a4c2c867fcd62 = Symbol('form reset');
const $63e4506e45707d16$export$d6f2d34d1f6ea285 = Symbol('hmr anchor');
const $63e4506e45707d16$export$8b70a2934d1dc30a = new class StaleReactionError extends Error {
    name = 'StaleReactionError';
    message = 'The reaction that called `getAbortSignal()` was re-run or destroyed';
}();
const $63e4506e45707d16$export$c59e93578bc58a1c = // We gotta write it like this because after downleveling the pure comment may end up in the wrong location
!!globalThis.document?.contentType && /* @__PURE__ */ globalThis.document.contentType.includes('xml');
const $63e4506e45707d16$export$51c8a276ee4b8f51 = 1;
const $63e4506e45707d16$export$5bcc40203615fc2e = 3;
const $63e4506e45707d16$export$3d597a6ef0f08b0a = 8;
const $63e4506e45707d16$export$b86725031ae151ee = 11;

});

parcelRegister("kmhLl", function(module, exports) {

$parcel$export(module.exports, "eager_effects", () => $ed23a3fe80a2d7c7$export$16632224cc9b21d8);
$parcel$export(module.exports, "old_values", () => $ed23a3fe80a2d7c7$export$fa9184501df2b054);
$parcel$export(module.exports, "set_eager_effects", () => $ed23a3fe80a2d7c7$export$16e8d0a2010702f9);
$parcel$export(module.exports, "set_eager_effects_deferred", () => $ed23a3fe80a2d7c7$export$cc34e0c8b35a4df7);
$parcel$export(module.exports, "source", () => $ed23a3fe80a2d7c7$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "state", () => $ed23a3fe80a2d7c7$export$ca000e230c0caa3e);
$parcel$export(module.exports, "set", () => $ed23a3fe80a2d7c7$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "internal_set", () => $ed23a3fe80a2d7c7$export$87469028ce56ddf0);
$parcel$export(module.exports, "flush_eager_effects", () => $ed23a3fe80a2d7c7$export$e0b0b00c43bc2784);
$parcel$export(module.exports, "update", () => $ed23a3fe80a2d7c7$export$722fbec263ad908a);
$parcel$export(module.exports, "increment", () => $ed23a3fe80a2d7c7$export$a2647aa13413c947);
/** @import { Derived, Effect, Source, Value } from '#client' */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $egVZE = parcelRequire("egVZE");

var $f09ju = parcelRequire("f09ju");

var $8zILj = parcelRequire("8zILj");

var $gB48l = parcelRequire("gB48l");

var $yJWNn = parcelRequire("yJWNn");

var $4Y2WV = parcelRequire("4Y2WV");

var $9AQvv = parcelRequire("9AQvv");

var $6bkva = parcelRequire("6bkva");

var $amPy2 = parcelRequire("amPy2");

var $3o015 = parcelRequire("3o015");

var $3oHv7 = parcelRequire("3oHv7");

var $1RLxH = parcelRequire("1RLxH");
let $ed23a3fe80a2d7c7$export$16632224cc9b21d8 = new Set();
const $ed23a3fe80a2d7c7$export$fa9184501df2b054 = new Map();
function $ed23a3fe80a2d7c7$export$16e8d0a2010702f9(v) {
    $ed23a3fe80a2d7c7$export$16632224cc9b21d8 = v;
}
let $ed23a3fe80a2d7c7$var$eager_effects_deferred = false;
function $ed23a3fe80a2d7c7$export$cc34e0c8b35a4df7() {
    $ed23a3fe80a2d7c7$var$eager_effects_deferred = true;
}
function $ed23a3fe80a2d7c7$export$b4d5da5f34fb77ad(v, stack) {
    /** @type {Value} */ var signal = {
        f: 0,
        v: v,
        reactions: null,
        equals: $f09ju.equals,
        rv: 0,
        wv: 0
    };
    if ((0, $7YIuB.default) && (0, $yJWNn.tracing_mode_flag)) {
        signal.created = stack ?? (0, $9AQvv.get_error)('created at');
        signal.updated = null;
        signal.set_during_effect = false;
        signal.trace = null;
    }
    return signal;
}
function $ed23a3fe80a2d7c7$export$ca000e230c0caa3e(v, stack) {
    const s = $ed23a3fe80a2d7c7$export$b4d5da5f34fb77ad(v, stack);
    (0, $egVZE.push_reaction_value)(s);
    return s;
}
function $ed23a3fe80a2d7c7$export$69dcdcd5c2e225bc(initial_value, immutable = false, trackable = true) {
    const s = $ed23a3fe80a2d7c7$export$b4d5da5f34fb77ad(initial_value);
    if (!immutable) s.equals = (0, $f09ju.safe_equals);
    // bind the signal to the component context, in case we need to
    // track updates to trigger beforeUpdate/afterUpdate callbacks
    if ((0, $yJWNn.legacy_mode_flag) && trackable && (0, $6bkva.component_context) !== null && (0, $6bkva.component_context).l !== null) ((0, $6bkva.component_context).l.s ??= []).push(s);
    return s;
}
function $ed23a3fe80a2d7c7$export$57e795267c26e600(source, value) {
    $ed23a3fe80a2d7c7$export$adaa4cf7ef1b65be(source, (0, $egVZE.untrack)(()=>(0, $egVZE.get)(source)));
    return value;
}
function $ed23a3fe80a2d7c7$export$adaa4cf7ef1b65be(source, value, should_proxy = false) {
    if ((0, $egVZE.active_reaction) !== null && // since we are untracking the function inside `$inspect.with` we need to add this check
    // to ensure we error if state is set inside an inspect effect
    (!(0, $egVZE.untracking) || ((0, $egVZE.active_reaction).f & (0, $8zILj.EAGER_EFFECT)) !== 0) && (0, $6bkva.is_runes)() && ((0, $egVZE.active_reaction).f & ((0, $8zILj.DERIVED) | (0, $8zILj.BLOCK_EFFECT) | (0, $8zILj.ASYNC) | (0, $8zILj.EAGER_EFFECT))) !== 0 && ((0, $egVZE.current_sources) === null || !(0, $egVZE.current_sources).has(source))) $gB48l.state_unsafe_mutation();
    let new_value = should_proxy ? (0, $3o015.proxy)(value) : value;
    if (0, $7YIuB.default) (0, $4Y2WV.tag_proxy)(new_value, /** @type {string} */ source.label);
    return $ed23a3fe80a2d7c7$export$87469028ce56ddf0(source, new_value, (0, $amPy2.legacy_updates));
}
/**
 * A set of signals we have already seen while traversing in mark_reactions.
 * Not always set to balance the common case of sources only having a couple
 * of (transitive) dependencies (where always creating a Set would be bad for perf)
 * with the edge case of extremely deep or wide dependency arrays with cycles.
 * @type {Set<any> | null}
 */ var $ed23a3fe80a2d7c7$var$seen = null;
/** Number of transitive dependencies, see {@link seen} for more info */ var $ed23a3fe80a2d7c7$var$count_deps = 0;
function $ed23a3fe80a2d7c7$export$87469028ce56ddf0(source, value, updated_during_traversal = null) {
    if (!source.equals(value)) {
        if (0, $egVZE.is_destroying_effect) $ed23a3fe80a2d7c7$export$fa9184501df2b054.set(source, value);
        else if (!$ed23a3fe80a2d7c7$export$fa9184501df2b054.has(source)) // only record the value from before the first write in this flush, otherwise a
        // teardown would see the value from before whichever write happened to be last
        $ed23a3fe80a2d7c7$export$fa9184501df2b054.set(source, source.v);
        var batch = (0, $amPy2.Batch).ensure();
        batch.capture(source, value);
        if (0, $7YIuB.default) {
            if ((0, $yJWNn.tracing_mode_flag) || (0, $egVZE.active_effect) !== null) {
                source.updated ??= new Map();
                // For performance reasons, when not using $inspect.trace, we only start collecting stack traces
                // after the same source has been updated more than 5 times in the same flush cycle.
                const count = (source.updated.get('')?.count ?? 0) + 1;
                source.updated.set('', {
                    error: /** @type {any} */ null,
                    count: count
                });
                if ((0, $yJWNn.tracing_mode_flag) || count > 5) {
                    const error = (0, $9AQvv.get_error)('updated at');
                    if (error !== null) {
                        let entry = source.updated.get(error.stack);
                        if (!entry) {
                            entry = {
                                error: error,
                                count: 0
                            };
                            source.updated.set(error.stack, entry);
                        }
                        entry.count++;
                    }
                }
            }
            if ((0, $egVZE.active_effect) !== null) source.set_during_effect = true;
        }
        if ((source.f & (0, $8zILj.DERIVED)) !== 0) {
            const derived = /** @type {Derived} */ source;
            // if we are assigning to a dirty derived we set it to clean/maybe dirty but we also eagerly execute it to track the dependencies
            if ((source.f & (0, $8zILj.DIRTY)) !== 0) (0, $3oHv7.execute_derived)(derived);
            // During time traveling we don't want to reset the status so that
            // traversal of the graph in the other batches still happens
            if ((0, $amPy2.batch_values) === null) (0, $1RLxH.update_derived_status)(derived);
        }
        source.wv = (0, $egVZE.increment_write_version)();
        // For debugging, in case you want to know which reactions are being scheduled:
        // log_reactions(source);
        $ed23a3fe80a2d7c7$var$seen = null;
        $ed23a3fe80a2d7c7$var$count_deps = 0;
        $ed23a3fe80a2d7c7$var$mark_reactions(source, (0, $8zILj.DIRTY), updated_during_traversal);
        $ed23a3fe80a2d7c7$var$seen = null;
        // It's possible that the current reaction might not have up-to-date dependencies
        // whilst it's actively running. So in the case of ensuring it registers the reaction
        // properly for itself, we need to ensure the current effect actually gets
        // scheduled. i.e: `$effect(() => x++)`
        if ((0, $6bkva.is_runes)() && (0, $egVZE.active_effect) !== null && ((0, $egVZE.active_effect).f & (0, $8zILj.CLEAN)) !== 0 && ((0, $egVZE.active_effect).f & ((0, $8zILj.BRANCH_EFFECT) | (0, $8zILj.ROOT_EFFECT))) === 0) {
            if ((0, $egVZE.untracked_writes) === null) (0, $egVZE.set_untracked_writes)([
                source
            ]);
            else (0, $egVZE.untracked_writes).push(source);
        }
        if (!batch.is_fork && $ed23a3fe80a2d7c7$export$16632224cc9b21d8.size > 0 && !$ed23a3fe80a2d7c7$var$eager_effects_deferred) $ed23a3fe80a2d7c7$export$e0b0b00c43bc2784();
    }
    return value;
}
function $ed23a3fe80a2d7c7$export$e0b0b00c43bc2784() {
    $ed23a3fe80a2d7c7$var$eager_effects_deferred = false;
    for (const effect of $ed23a3fe80a2d7c7$export$16632224cc9b21d8){
        // Mark clean inspect-effects as maybe dirty and then check their dirtiness
        // instead of just updating the effects - this way we avoid overfiring.
        if ((effect.f & (0, $8zILj.CLEAN)) !== 0) (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.MAYBE_DIRTY));
        let dirty;
        try {
            dirty = (0, $egVZE.is_dirty)(effect);
        } catch  {
            // Dirty-checking can evaluate derived dependencies and throw in cases where
            // parent effects are about to destroy this eager effect. Run the effect so
            // its own error handling can deal with transient failures.
            dirty = true;
        }
        if (dirty) (0, $egVZE.update_effect)(effect);
    }
    $ed23a3fe80a2d7c7$export$16632224cc9b21d8.clear();
}
function $ed23a3fe80a2d7c7$export$722fbec263ad908a(source, d = 1) {
    var value = (0, $egVZE.get)(source);
    var result = d === 1 ? value++ : value--;
    $ed23a3fe80a2d7c7$export$adaa4cf7ef1b65be(source, value);
    // @ts-expect-error
    return result;
}
function $ed23a3fe80a2d7c7$export$baeebcc2a26e1da3(source, d = 1) {
    var value = (0, $egVZE.get)(source);
    // @ts-expect-error
    // eslint-disable-next-line no-useless-assignment -- `++`/`--` used for return value, not side effect on `value`
    return $ed23a3fe80a2d7c7$export$adaa4cf7ef1b65be(source, d === 1 ? ++value : --value);
}
function $ed23a3fe80a2d7c7$export$a2647aa13413c947(source) {
    $ed23a3fe80a2d7c7$export$adaa4cf7ef1b65be(source, source.v + 1);
}
/**
 * @param {Value} signal
 * @param {number} status should be DIRTY or MAYBE_DIRTY
 * @param {Effect[] | null} updated_during_traversal
 * @returns {void}
 */ function $ed23a3fe80a2d7c7$var$mark_reactions(signal, status, updated_during_traversal) {
    var reactions = signal.reactions;
    if (reactions === null) return;
    var runes = (0, $6bkva.is_runes)();
    var length = reactions.length;
    $ed23a3fe80a2d7c7$var$count_deps += length;
    // Activate the `seen` Set if we think from the unusually high number of deps that
    // there might be cycles in the graph, to avoid repeated lookups for reactions
    // Example: https://github.com/sveltejs/svelte/issues/16658 has a graph with one source
    // reaching ~10000 distinct deriveds/effects each, resulting in 65 million walks through repeated visits.
    if ($ed23a3fe80a2d7c7$var$count_deps > 100000 && $ed23a3fe80a2d7c7$var$seen === null) $ed23a3fe80a2d7c7$var$seen = new Set();
    if ($ed23a3fe80a2d7c7$var$seen !== null) {
        if ($ed23a3fe80a2d7c7$var$seen.has(signal)) return;
        $ed23a3fe80a2d7c7$var$seen.add(signal);
    }
    for(var i = 0; i < length; i++){
        var reaction = reactions[i];
        var flags = reaction.f;
        // In legacy mode, skip the current effect to prevent infinite loops
        if (!runes && reaction === (0, $egVZE.active_effect)) continue;
        var not_dirty = (flags & (0, $8zILj.DIRTY)) === 0;
        // don't set a DIRTY reaction to MAYBE_DIRTY
        if (not_dirty) (0, $1RLxH.set_signal_status)(reaction, status);
        if ((flags & (0, $8zILj.EAGER_EFFECT)) !== 0) // Eager effects need to run immediately:
        // - for $inspect so that the stack trace makes sense
        // - for $state.eager because they might be without an effect parent
        $ed23a3fe80a2d7c7$export$16632224cc9b21d8.add(/** @type {Effect} */ reaction);
        else if ((flags & (0, $8zILj.DERIVED)) !== 0) {
            var derived = /** @type {Derived} */ reaction;
            (0, $amPy2.batch_values)?.delete(derived);
            $ed23a3fe80a2d7c7$var$mark_reactions(derived, (0, $8zILj.MAYBE_DIRTY), updated_during_traversal);
        } else if (not_dirty) {
            var effect = /** @type {Effect} */ reaction;
            if ((flags & (0, $8zILj.BLOCK_EFFECT)) !== 0 && (0, $amPy2.eager_block_effects) !== null) (0, $amPy2.eager_block_effects).add(effect);
            if (updated_during_traversal !== null) updated_during_traversal.push(effect);
            else (0, $amPy2.schedule_effect)(effect);
        }
    }
}

});
parcelRegister("f09ju", function(module, exports) {

$parcel$export(module.exports, "equals", () => $aebe1484558b838f$export$e9bab7fafb253603);
$parcel$export(module.exports, "safe_not_equal", () => $aebe1484558b838f$export$170eaf694b129a16);
$parcel$export(module.exports, "safe_equals", () => $aebe1484558b838f$export$5fc66da6c8cd366b);
/** @import { Equals } from '#client' */ /** @type {Equals} */ function $aebe1484558b838f$export$e9bab7fafb253603(value) {
    return value === this.v;
}
function $aebe1484558b838f$export$170eaf694b129a16(a, b) {
    return a != a ? b == b : a !== b || a !== null && typeof a === 'object' || typeof a === 'function';
}
function $aebe1484558b838f$export$22fbbf144bff5d00(a, b) {
    return a !== b;
}
function $aebe1484558b838f$export$5fc66da6c8cd366b(value) {
    return !$aebe1484558b838f$export$170eaf694b129a16(value, this.v);
}

});

parcelRegister("gB48l", function(module, exports) {
$parcel$export(module.exports, "experimental_async_required", () => (parcelRequire("3gXWT")).experimental_async_required);
$parcel$export(module.exports, "set_context_after_init", () => (parcelRequire("3gXWT")).set_context_after_init);

$parcel$export(module.exports, "async_derived_orphan", () => $c1534ede8248e22b$export$607a89db4f9b469b);
$parcel$export(module.exports, "derived_references_self", () => $c1534ede8248e22b$export$b8da32ab261110e5);
$parcel$export(module.exports, "effect_in_teardown", () => $c1534ede8248e22b$export$595bfc15dfdc00d9);
$parcel$export(module.exports, "effect_in_unowned_derived", () => $c1534ede8248e22b$export$d8f3c9b0ce60b336);
$parcel$export(module.exports, "effect_orphan", () => $c1534ede8248e22b$export$147eb30e24bc668);
$parcel$export(module.exports, "effect_update_depth_exceeded", () => $c1534ede8248e22b$export$40d50af77a0eee50);
$parcel$export(module.exports, "fork_discarded", () => $c1534ede8248e22b$export$b5fd5d5ef29d9523);
$parcel$export(module.exports, "fork_timing", () => $c1534ede8248e22b$export$83c2ced200772b2d);
$parcel$export(module.exports, "state_descriptors_fixed", () => $c1534ede8248e22b$export$1de6c432c1f11140);
$parcel$export(module.exports, "state_prototype_fixed", () => $c1534ede8248e22b$export$9c5ef2f28a6c12d1);
$parcel$export(module.exports, "state_unsafe_mutation", () => $c1534ede8248e22b$export$353c6fea14587e83);
/* This file is generated by scripts/process-messages/index.js. Do not edit! */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");
parcelRequire("3gXWT");
function $c1534ede8248e22b$export$607a89db4f9b469b() {
    if (0, $7YIuB.default) {
        const error = new Error(`async_derived_orphan\nCannot create a \`$derived(...)\` with an \`await\` expression outside of an effect tree\nhttps://svelte.dev/e/async_derived_orphan`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/async_derived_orphan`);
}
function $c1534ede8248e22b$export$acc928771f4910ff() {
    if (0, $7YIuB.default) {
        const error = new Error(`bind_invalid_checkbox_value\nUsing \`bind:value\` together with a checkbox input is not allowed. Use \`bind:checked\` instead\nhttps://svelte.dev/e/bind_invalid_checkbox_value`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/bind_invalid_checkbox_value`);
}
function $c1534ede8248e22b$export$25f1e7a1f821dd5d(component, key, name) {
    if (0, $7YIuB.default) {
        const error = new Error(`bind_invalid_export\nComponent ${component} has an export named \`${key}\` that a consumer component is trying to access using \`bind:${key}\`, which is disallowed. Instead, use \`bind:this\` (e.g. \`<${name} bind:this={component} />\`) and then access the property on the bound component instance (e.g. \`component.${key}\`)\nhttps://svelte.dev/e/bind_invalid_export`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/bind_invalid_export`);
}
function $c1534ede8248e22b$export$c44b04069977dc5e(key, component, name) {
    if (0, $7YIuB.default) {
        const error = new Error(`bind_not_bindable\nA component is attempting to bind to a non-bindable property \`${key}\` belonging to ${component} (i.e. \`<${name} bind:${key}={...}>\`). To mark a property as bindable: \`let { ${key} = $bindable() } = $props()\`\nhttps://svelte.dev/e/bind_not_bindable`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/bind_not_bindable`);
}
function $c1534ede8248e22b$export$4bed5af81fc76f2f(method, component) {
    if (0, $7YIuB.default) {
        const error = new Error(`component_api_changed\nCalling \`${method}\` on a component instance (of ${component}) is no longer valid in Svelte 5\nhttps://svelte.dev/e/component_api_changed`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/component_api_changed`);
}
function $c1534ede8248e22b$export$f3e0406ec5490735(component, name) {
    if (0, $7YIuB.default) {
        const error = new Error(`component_api_invalid_new\nAttempted to instantiate ${component} with \`new ${name}\`, which is no longer valid in Svelte 5. If this component is not under your control, set the \`compatibility.componentApi\` compiler option to \`4\` to keep it working.\nhttps://svelte.dev/e/component_api_invalid_new`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/component_api_invalid_new`);
}
function $c1534ede8248e22b$export$b8da32ab261110e5() {
    if (0, $7YIuB.default) {
        const error = new Error(`derived_references_self\nA derived value cannot reference itself recursively\nhttps://svelte.dev/e/derived_references_self`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/derived_references_self`);
}
function $c1534ede8248e22b$export$62ae93d87d7a588a(a, b, value) {
    if (0, $7YIuB.default) {
        const error = new Error(`each_key_duplicate\n${value ? `Keyed each block has duplicate key \`${value}\` at indexes ${a} and ${b}` : `Keyed each block has duplicate key at indexes ${a} and ${b}`}\nhttps://svelte.dev/e/each_key_duplicate`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/each_key_duplicate`);
}
function $c1534ede8248e22b$export$b2701d1f4ab8f766(index, a, b) {
    if (0, $7YIuB.default) {
        const error = new Error(`each_key_volatile
Keyed each block has key that is not idempotent \u{2014} the key for item at index ${index} was \`${a}\` but is now \`${b}\`. Keys must be the same each time for a given item\nhttps://svelte.dev/e/each_key_volatile`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/each_key_volatile`);
}
function $c1534ede8248e22b$export$595bfc15dfdc00d9(rune) {
    if (0, $7YIuB.default) {
        const error = new Error(`effect_in_teardown\n\`${rune}\` cannot be used inside an effect cleanup function\nhttps://svelte.dev/e/effect_in_teardown`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/effect_in_teardown`);
}
function $c1534ede8248e22b$export$d8f3c9b0ce60b336() {
    if (0, $7YIuB.default) {
        const error = new Error(`effect_in_unowned_derived\nEffect cannot be created inside a \`$derived\` value that was not itself created inside an effect\nhttps://svelte.dev/e/effect_in_unowned_derived`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/effect_in_unowned_derived`);
}
function $c1534ede8248e22b$export$147eb30e24bc668(rune) {
    if (0, $7YIuB.default) {
        const error = new Error(`effect_orphan\n\`${rune}\` can only be used inside an effect (e.g. during component initialisation)\nhttps://svelte.dev/e/effect_orphan`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/effect_orphan`);
}
function $c1534ede8248e22b$export$a597a5abcc104e34() {
    if (0, $7YIuB.default) {
        const error = new Error(`effect_pending_outside_reaction\n\`$effect.pending()\` can only be called inside an effect or derived\nhttps://svelte.dev/e/effect_pending_outside_reaction`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/effect_pending_outside_reaction`);
}
function $c1534ede8248e22b$export$40d50af77a0eee50() {
    if (0, $7YIuB.default) {
        const error = new Error(`effect_update_depth_exceeded\nMaximum update depth exceeded. This typically indicates that an effect reads and writes the same piece of state\nhttps://svelte.dev/e/effect_update_depth_exceeded`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/effect_update_depth_exceeded`);
}
function $c1534ede8248e22b$export$ea24fea6edf2b84b() {
    if (0, $7YIuB.default) {
        const error = new Error(`flush_sync_in_effect\nCannot use \`flushSync\` inside an effect\nhttps://svelte.dev/e/flush_sync_in_effect`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/flush_sync_in_effect`);
}
function $c1534ede8248e22b$export$b5fd5d5ef29d9523() {
    if (0, $7YIuB.default) {
        const error = new Error(`fork_discarded\nCannot commit a fork that was already discarded\nhttps://svelte.dev/e/fork_discarded`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/fork_discarded`);
}
function $c1534ede8248e22b$export$83c2ced200772b2d() {
    if (0, $7YIuB.default) {
        const error = new Error(`fork_timing\nCannot create a fork inside an effect or when state changes are pending\nhttps://svelte.dev/e/fork_timing`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/fork_timing`);
}
function $c1534ede8248e22b$export$68dd8284c68dfbef() {
    if (0, $7YIuB.default) {
        const error = new Error(`get_abort_signal_outside_reaction\n\`getAbortSignal()\` can only be called inside an effect or derived\nhttps://svelte.dev/e/get_abort_signal_outside_reaction`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/get_abort_signal_outside_reaction`);
}
function $c1534ede8248e22b$export$a0e4b13b1fbb9469(key) {
    if (0, $7YIuB.default) {
        const error = new Error(`hydratable_missing_but_required\nExpected to find a hydratable with key \`${key}\` during hydration, but did not.\nhttps://svelte.dev/e/hydratable_missing_but_required`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/hydratable_missing_but_required`);
}
function $c1534ede8248e22b$export$89f3ba1b24d84bdb() {
    if (0, $7YIuB.default) {
        const error = new Error(`hydration_failed\nFailed to hydrate the application\nhttps://svelte.dev/e/hydration_failed`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/hydration_failed`);
}
function $c1534ede8248e22b$export$3dfdccec5d23d30b() {
    if (0, $7YIuB.default) {
        const error = new Error(`invalid_snippet\nCould not \`{@render}\` snippet due to the expression being \`null\` or \`undefined\`. Consider using optional chaining \`{@render snippet?.()}\`\nhttps://svelte.dev/e/invalid_snippet`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/invalid_snippet`);
}
function $c1534ede8248e22b$export$d02454ce0815a3a8(name) {
    if (0, $7YIuB.default) {
        const error = new Error(`lifecycle_legacy_only\n\`${name}(...)\` cannot be used in runes mode\nhttps://svelte.dev/e/lifecycle_legacy_only`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/lifecycle_legacy_only`);
}
function $c1534ede8248e22b$export$39a219bcbe19955f(key) {
    if (0, $7YIuB.default) {
        const error = new Error(`props_invalid_value\nCannot do \`bind:${key}={undefined}\` when \`${key}\` has a fallback value\nhttps://svelte.dev/e/props_invalid_value`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/props_invalid_value`);
}
function $c1534ede8248e22b$export$ebad642fe0d7f04(property) {
    if (0, $7YIuB.default) {
        const error = new Error(`props_rest_readonly\nRest element properties of \`$props()\` such as \`${property}\` are readonly\nhttps://svelte.dev/e/props_rest_readonly`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/props_rest_readonly`);
}
function $c1534ede8248e22b$export$1789ab9fcc6fe93e(rune) {
    if (0, $7YIuB.default) {
        const error = new Error(`rune_outside_svelte\nThe \`${rune}\` rune is only available inside \`.svelte\` and \`.svelte.js/ts\` files\nhttps://svelte.dev/e/rune_outside_svelte`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/rune_outside_svelte`);
}
function $c1534ede8248e22b$export$1de6c432c1f11140() {
    if (0, $7YIuB.default) {
        const error = new Error(`state_descriptors_fixed\nProperty descriptors defined on \`$state\` objects must contain \`value\` and always be \`enumerable\`, \`configurable\` and \`writable\`.\nhttps://svelte.dev/e/state_descriptors_fixed`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/state_descriptors_fixed`);
}
function $c1534ede8248e22b$export$9c5ef2f28a6c12d1() {
    if (0, $7YIuB.default) {
        const error = new Error(`state_prototype_fixed\nCannot set prototype of \`$state\` object\nhttps://svelte.dev/e/state_prototype_fixed`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/state_prototype_fixed`);
}
function $c1534ede8248e22b$export$353c6fea14587e83() {
    if (0, $7YIuB.default) {
        const error = new Error(`state_unsafe_mutation\nUpdating state inside \`$derived(...)\`, \`$inspect(...)\` or a template expression is forbidden. If the value should not be reactive, declare it without \`$state\`\nhttps://svelte.dev/e/state_unsafe_mutation`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/state_unsafe_mutation`);
}
function $c1534ede8248e22b$export$34760708d3313233() {
    if (0, $7YIuB.default) {
        const error = new Error(`svelte_boundary_reset_onerror\nA \`<svelte:boundary>\` \`reset\` function cannot be called while an error is still being handled\nhttps://svelte.dev/e/svelte_boundary_reset_onerror`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/svelte_boundary_reset_onerror`);
}

});
parcelRegister("3gXWT", function(module, exports) {

$parcel$export(module.exports, "experimental_async_required", () => $26215e4f87609ffc$export$767f3a7642915825);
$parcel$export(module.exports, "invariant_violation", () => $26215e4f87609ffc$export$6230f9cf8003038a);
$parcel$export(module.exports, "lifecycle_outside_component", () => $26215e4f87609ffc$export$c3376e0786825fe6);
$parcel$export(module.exports, "missing_context", () => $26215e4f87609ffc$export$acf395801541e638);
$parcel$export(module.exports, "set_context_after_init", () => $26215e4f87609ffc$export$d82573f23208ad35);
/* This file is generated by scripts/process-messages/index.js. Do not edit! */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");
function $26215e4f87609ffc$export$767f3a7642915825(name) {
    if (0, $7YIuB.default) {
        const error = new Error(`experimental_async_required\nCannot use \`${name}(...)\` unless the \`experimental.async\` compiler option is \`true\`\nhttps://svelte.dev/e/experimental_async_required`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/experimental_async_required`);
}
function $26215e4f87609ffc$export$b70025869e288934() {
    if (0, $7YIuB.default) {
        const error = new Error(`invalid_default_snippet\nCannot use \`{@render children(...)}\` if the parent component uses \`let:\` directives. Consider using a named snippet instead\nhttps://svelte.dev/e/invalid_default_snippet`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/invalid_default_snippet`);
}
function $26215e4f87609ffc$export$bef586a57a1bf1ed() {
    if (0, $7YIuB.default) {
        const error = new Error(`invalid_snippet_arguments\nA snippet function was passed invalid arguments. Snippets should only be instantiated via \`{@render ...}\`\nhttps://svelte.dev/e/invalid_snippet_arguments`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/invalid_snippet_arguments`);
}
function $26215e4f87609ffc$export$6230f9cf8003038a(message) {
    if (0, $7YIuB.default) {
        const error = new Error(`invariant_violation
An invariant violation occurred, meaning Svelte's internal assumptions were flawed. This is a bug in Svelte, not your app \u{2014} please open an issue at https://github.com/sveltejs/svelte, citing the following message: "${message}"\nhttps://svelte.dev/e/invariant_violation`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/invariant_violation`);
}
function $26215e4f87609ffc$export$c3376e0786825fe6(name) {
    if (0, $7YIuB.default) {
        const error = new Error(`lifecycle_outside_component\n\`${name}(...)\` can only be used during component initialisation\nhttps://svelte.dev/e/lifecycle_outside_component`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/lifecycle_outside_component`);
}
function $26215e4f87609ffc$export$acf395801541e638() {
    if (0, $7YIuB.default) {
        const error = new Error(`missing_context\nContext was not set in the current component or any of its ancestors\nhttps://svelte.dev/e/missing_context`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/missing_context`);
}
function $26215e4f87609ffc$export$d82573f23208ad35() {
    if (0, $7YIuB.default) {
        const error = new Error(`set_context_after_init\n\`setContext\` must be called when a component first initializes, not in a subsequent effect or after an \`await\` expression\nhttps://svelte.dev/e/set_context_after_init`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/set_context_after_init`);
}
function $26215e4f87609ffc$export$19fa7744f1b3e6a0() {
    if (0, $7YIuB.default) {
        const error = new Error(`snippet_without_render_tag\nAttempted to render a snippet without a \`{@render}\` block. This would cause the snippet code to be stringified instead of its content being rendered to the DOM. To fix this, change \`{snippet}\` to \`{@render snippet()}\`.\nhttps://svelte.dev/e/snippet_without_render_tag`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/snippet_without_render_tag`);
}
function $26215e4f87609ffc$export$9df653ac836618b1(name) {
    if (0, $7YIuB.default) {
        const error = new Error(`store_invalid_shape\n\`${name}\` is not a store with a \`subscribe\` method\nhttps://svelte.dev/e/store_invalid_shape`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/store_invalid_shape`);
}
function $26215e4f87609ffc$export$a784faadd4e98276() {
    if (0, $7YIuB.default) {
        const error = new Error(`svelte_element_invalid_this_value\nThe \`this\` prop on \`<svelte:element>\` must be a string, if defined\nhttps://svelte.dev/e/svelte_element_invalid_this_value`);
        error.name = 'Svelte error';
        throw error;
    } else throw new Error(`https://svelte.dev/e/svelte_element_invalid_this_value`);
}

});


parcelRegister("yJWNn", function(module, exports) {

$parcel$export(module.exports, "async_mode_flag", () => $0686d1451e0acca3$export$eadb99da47466715);
$parcel$export(module.exports, "legacy_mode_flag", () => $0686d1451e0acca3$export$398f5bfad4bc71f0);
$parcel$export(module.exports, "tracing_mode_flag", () => $0686d1451e0acca3$export$15d721c20cd50cfc);
/** True if experimental.async=true */ let $0686d1451e0acca3$export$eadb99da47466715 = false;
let $0686d1451e0acca3$export$398f5bfad4bc71f0 = false;
let $0686d1451e0acca3$export$15d721c20cd50cfc = false;
function $0686d1451e0acca3$export$f401c9eb109e0521() {
    $0686d1451e0acca3$export$eadb99da47466715 = true;
}
function $0686d1451e0acca3$export$eec88cb671a00081() {
    $0686d1451e0acca3$export$eadb99da47466715 = false;
}
function $0686d1451e0acca3$export$c1dbc457fa639f1b() {
    $0686d1451e0acca3$export$398f5bfad4bc71f0 = true;
}
function $0686d1451e0acca3$export$2ff4b51d8c6af7b0() {
    $0686d1451e0acca3$export$15d721c20cd50cfc = true;
}

});

parcelRegister("4Y2WV", function(module, exports) {

$parcel$export(module.exports, "tracing_expressions", () => $39df0db315d22861$export$8b8711aa2b04647f);
$parcel$export(module.exports, "tag", () => $39df0db315d22861$export$2b067c6666111485);
$parcel$export(module.exports, "tag_proxy", () => $39df0db315d22861$export$4b43cdfa43cefbef);
/** @import { Derived, Reaction, Value } from '#client' */ 
var $56eus = parcelRequire("56eus");

var $8CHUy = parcelRequire("8CHUy");

var $8zILj = parcelRequire("8zILj");

var $kCMGX = parcelRequire("kCMGX");

var $egVZE = parcelRequire("egVZE");
let $39df0db315d22861$export$8b8711aa2b04647f = null;
/**
 * @param {Value} signal
 * @param {TraceEntry} [entry]
 */ function $39df0db315d22861$var$log_entry(signal, entry) {
    const value = signal.v;
    if (value === (0, $56eus.UNINITIALIZED)) return;
    const type = $39df0db315d22861$var$get_type(signal);
    const current_reaction = /** @type {Reaction} */ (0, $egVZE.active_reaction);
    const dirty = signal.wv > current_reaction.wv || current_reaction.wv === 0;
    const style = dirty ? 'color: CornflowerBlue; font-weight: bold' : 'color: grey; font-weight: normal';
    // eslint-disable-next-line no-console
    console.groupCollapsed(signal.label ? `%c${type}%c ${signal.label}` : `%c${type}%c`, style, dirty ? 'font-weight: normal' : style, typeof value === 'object' && value !== null && (0, $8zILj.STATE_SYMBOL) in value ? (0, $8CHUy.snapshot)(value, true) : value);
    if (type === '$derived') {
        const deps = new Set(/** @type {Derived} */ signal.deps);
        for (const dep of deps)$39df0db315d22861$var$log_entry(dep);
    }
    if (signal.created) // eslint-disable-next-line no-console
    console.log(signal.created);
    if (dirty && signal.updated) {
        for (const updated of signal.updated.values())if (updated.error) // eslint-disable-next-line no-console
        console.log(updated.error);
    }
    if (entry) for (var trace of entry.traces)// eslint-disable-next-line no-console
    console.log(trace);
    // eslint-disable-next-line no-console
    console.groupEnd();
}
/**
 * @param {Value} signal
 * @returns {'$state' | '$derived' | 'store'}
 */ function $39df0db315d22861$var$get_type(signal) {
    if ((signal.f & ((0, $8zILj.DERIVED) | (0, $8zILj.ASYNC))) !== 0) return '$derived';
    return signal.label?.startsWith('$') ? 'store' : '$state';
}
function $39df0db315d22861$export$357889f174732d38(label, fn) {
    var previously_tracing_expressions = $39df0db315d22861$export$8b8711aa2b04647f;
    try {
        $39df0db315d22861$export$8b8711aa2b04647f = {
            entries: new Map(),
            reaction: (0, $egVZE.active_reaction)
        };
        var start = performance.now();
        var value = fn();
        var time = (performance.now() - start).toFixed(2);
        var prefix = (0, $egVZE.untrack)(label);
        if (!(0, $kCMGX.effect_tracking)()) // eslint-disable-next-line no-console
        console.log(`${prefix} %cran outside of an effect (${time}ms)`, 'color: grey');
        else if ($39df0db315d22861$export$8b8711aa2b04647f.entries.size === 0) // eslint-disable-next-line no-console
        console.log(`${prefix} %cno reactive dependencies (${time}ms)`, 'color: grey');
        else {
            // eslint-disable-next-line no-console
            console.group(`${prefix} %c(${time}ms)`, 'color: grey');
            var entries = $39df0db315d22861$export$8b8711aa2b04647f.entries;
            (0, $egVZE.untrack)(()=>{
                for (const [signal, traces] of entries)$39df0db315d22861$var$log_entry(signal, traces);
            });
            $39df0db315d22861$export$8b8711aa2b04647f = null;
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        return value;
    } finally{
        $39df0db315d22861$export$8b8711aa2b04647f = previously_tracing_expressions;
    }
}
function $39df0db315d22861$export$2b067c6666111485(source, label) {
    source.label = label;
    $39df0db315d22861$export$4b43cdfa43cefbef(source.v, label);
    return source;
}
function $39df0db315d22861$export$4b43cdfa43cefbef(value, label) {
    // @ts-expect-error
    value?.[0, $8zILj.PROXY_PATH_SYMBOL]?.(label);
    return value;
}
function $39df0db315d22861$export$1237798dc640739a(value) {
    if (typeof value === 'symbol') return `Symbol(${value.description})`;
    if (typeof value === 'function') return '<function>';
    if (typeof value === 'object' && value) return '<object>';
    return String(value);
}

});
parcelRegister("56eus", function(module, exports) {

$parcel$export(module.exports, "HYDRATION_START", () => $3b68c0bf859faf21$export$a55607cdaec80f3f);
$parcel$export(module.exports, "HYDRATION_START_ELSE", () => $3b68c0bf859faf21$export$bb59a856ab8a0d0a);
$parcel$export(module.exports, "HYDRATION_END", () => $3b68c0bf859faf21$export$800477bc6f9cd49e);
$parcel$export(module.exports, "HYDRATION_ERROR", () => $3b68c0bf859faf21$export$80f38ccf1c61dd2a);
$parcel$export(module.exports, "UNINITIALIZED", () => $3b68c0bf859faf21$export$4a6822a78b52b70d);
$parcel$export(module.exports, "FILENAME", () => $3b68c0bf859faf21$export$2f2bee6aafbb051c);
$parcel$export(module.exports, "NAMESPACE_HTML", () => $3b68c0bf859faf21$export$12b751c0d777b211);
const $3b68c0bf859faf21$export$812925a3c232c06 = 1;
const $3b68c0bf859faf21$export$c4c795237e263489 = 2;
const $3b68c0bf859faf21$export$52d8f455a1b97fb3 = 4;
const $3b68c0bf859faf21$export$4b53626dfc7dac26 = 8;
const $3b68c0bf859faf21$export$47f33c8ed8af3ec6 = 16;
const $3b68c0bf859faf21$export$db57b9aa8bc279fb = 1;
const $3b68c0bf859faf21$export$fe1675d653cce36a = 2;
const $3b68c0bf859faf21$export$6f67eb9d85d929c2 = 4;
const $3b68c0bf859faf21$export$2f99cd4479c17701 = 8;
const $3b68c0bf859faf21$export$e1923a8b3472ec23 = 16;
const $3b68c0bf859faf21$export$8991a1c155acc547 = 1;
const $3b68c0bf859faf21$export$5739ef8323a1e987 = 2;
const $3b68c0bf859faf21$export$3d8c09fe358be0b2 = 4;
const $3b68c0bf859faf21$export$e0b3111379a4dae4 = 1;
const $3b68c0bf859faf21$export$f31c954c84982b0c = 2;
const $3b68c0bf859faf21$export$d8f5a892ddb5f64 = 4;
const $3b68c0bf859faf21$export$b371a58506945f13 = 8;
const $3b68c0bf859faf21$export$a55607cdaec80f3f = '[';
const $3b68c0bf859faf21$export$bb59a856ab8a0d0a = '[!';
const $3b68c0bf859faf21$export$849bdccff388bec5 = '[?';
const $3b68c0bf859faf21$export$800477bc6f9cd49e = ']';
const $3b68c0bf859faf21$export$80f38ccf1c61dd2a = {};
const $3b68c0bf859faf21$export$d3d03d39d05edba2 = 1;
const $3b68c0bf859faf21$export$fe8af68e959ca683 = 2;
const $3b68c0bf859faf21$export$e38c9553b683512a = 4;
const $3b68c0bf859faf21$export$4a6822a78b52b70d = Symbol('uninitialized');
const $3b68c0bf859faf21$export$2f2bee6aafbb051c = Symbol('filename');
const $3b68c0bf859faf21$export$261422280c63b22 = Symbol('hmr');
const $3b68c0bf859faf21$export$12b751c0d777b211 = 'http://www.w3.org/1999/xhtml';
const $3b68c0bf859faf21$export$4e74f81c62691bd0 = 'http://www.w3.org/2000/svg';
const $3b68c0bf859faf21$export$de24c5a9ed97b92f = 'http://www.w3.org/1998/Math/MathML';
const $3b68c0bf859faf21$export$e2c14fef5785b695 = /** @type {const} */ [
    'await_waterfall',
    'await_reactivity_loss',
    'state_snapshot_uncloneable',
    'binding_property_non_reactive',
    'hydration_attribute_changed',
    'hydration_html_changed',
    'ownership_invalid_binding',
    'ownership_invalid_mutation'
];
const $3b68c0bf859faf21$export$24d0deb6e5bed313 = [
    'audio',
    'datalist',
    'dl',
    'optgroup',
    'select',
    'video'
];
const $3b68c0bf859faf21$export$a0acc05aea89ef72 = '@attach';

});

parcelRegister("8CHUy", function(module, exports) {

$parcel$export(module.exports, "snapshot", () => $6473ef3163b71df7$export$b8801ea43165ed7d);
/** @import { Snapshot } from './types' */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $6bDSm = parcelRequire("6bDSm");

var $btEsq = parcelRequire("btEsq");
/**
 * In dev, we keep track of which properties could not be cloned. In prod
 * we don't bother, but we keep a dummy array around so that the
 * signature stays the same
 * @type {string[]}
 */ const $6473ef3163b71df7$var$empty = [];
function $6473ef3163b71df7$export$b8801ea43165ed7d(value, skip_warning = false, no_tojson = false) {
    if ((0, $7YIuB.default) && !skip_warning) {
        /** @type {string[]} */ const paths = [];
        const copy = $6473ef3163b71df7$var$clone(value, new Map(), '', paths, null, no_tojson);
        if (paths.length === 1 && paths[0] === '') // value could not be cloned
        $6bDSm.state_snapshot_uncloneable();
        else if (paths.length > 0) {
            // some properties could not be cloned
            const slice = paths.length > 10 ? paths.slice(0, 7) : paths.slice(0, 10);
            const excess = paths.length - slice.length;
            let uncloned = slice.map((path)=>`- <value>${path}`).join('\n');
            if (excess > 0) uncloned += `\n- ...and ${excess} more`;
            $6bDSm.state_snapshot_uncloneable(uncloned);
        }
        return copy;
    }
    return $6473ef3163b71df7$var$clone(value, new Map(), '', $6473ef3163b71df7$var$empty, null, no_tojson);
}
/**
 * @template T
 * @param {T} value
 * @param {Map<T, Snapshot<T>>} cloned
 * @param {string} path
 * @param {string[]} paths
 * @param {null | T} [original] The original value, if `value` was produced from a `toJSON` call
 * @param {boolean} [no_tojson]
 * @returns {Snapshot<T>}
 */ function $6473ef3163b71df7$var$clone(value, cloned, path, paths, original = null, no_tojson = false) {
    if (typeof value === 'object' && value !== null) {
        var unwrapped = cloned.get(value);
        if (unwrapped !== undefined) return unwrapped;
        if (value instanceof Map) return /** @type {Snapshot<T>} */ new Map(value);
        if (value instanceof Set) return /** @type {Snapshot<T>} */ new Set(value);
        if ((0, $btEsq.is_array)(value)) {
            var copy = /** @type {Snapshot<any>} */ Array(value.length);
            cloned.set(value, copy);
            if (original !== null) cloned.set(original, copy);
            for(var i = 0; i < value.length; i += 1){
                var element = value[i];
                if (i in value) copy[i] = $6473ef3163b71df7$var$clone(element, cloned, (0, $7YIuB.default) ? `${path}[${i}]` : path, paths, null, no_tojson);
            }
            return copy;
        }
        if ((0, $btEsq.get_prototype_of)(value) === (0, $btEsq.object_prototype)) {
            /** @type {Snapshot<any>} */ copy = {};
            cloned.set(value, copy);
            if (original !== null) cloned.set(original, copy);
            for (var key of Object.keys(value))copy[key] = $6473ef3163b71df7$var$clone(// @ts-expect-error
            value[key], cloned, (0, $7YIuB.default) ? `${path}.${key}` : path, paths, null, no_tojson);
            return copy;
        }
        if (value instanceof Date) {
            // Ensure SvelteDate snapshots are tracked
            value.getTime();
            return /** @type {Snapshot<T>} */ structuredClone(value);
        }
        if (typeof /** @type {T & { toJSON?: any } } */ value.toJSON === 'function' && !no_tojson) return $6473ef3163b71df7$var$clone(/** @type {T & { toJSON(): any } } */ value.toJSON(), cloned, (0, $7YIuB.default) ? `${path}.toJSON()` : path, paths, // Associate the instance with the toJSON clone
        value);
    }
    if (value instanceof EventTarget) // can't be cloned
    return /** @type {Snapshot<T>} */ value;
    try {
        return /** @type {Snapshot<T>} */ structuredClone(value);
    } catch (e) {
        if (0, $7YIuB.default) paths.push(path);
        return /** @type {Snapshot<T>} */ value;
    }
}

});
parcelRegister("6bDSm", function(module, exports) {

$parcel$export(module.exports, "state_snapshot_uncloneable", () => $4812b3a437360ff9$export$a15e6716bf702b63);
/* This file is generated by scripts/process-messages/index.js. Do not edit! */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");
var $4812b3a437360ff9$var$bold = 'font-weight: bold';
var $4812b3a437360ff9$var$normal = 'font-weight: normal';
function $4812b3a437360ff9$export$27278b1a15473329(tag) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] dynamic_void_element_content\n%c\`<svelte:element this="${tag}">\` is a void element \u{2014} it cannot have content
https://svelte.dev/e/dynamic_void_element_content`, $4812b3a437360ff9$var$bold, $4812b3a437360ff9$var$normal);
    else console.warn(`https://svelte.dev/e/dynamic_void_element_content`);
}
function $4812b3a437360ff9$export$a15e6716bf702b63(properties) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] state_snapshot_uncloneable\n%c${properties ? `The following properties cannot be cloned with \`$state.snapshot\` \u{2014} the return value contains the originals:

${properties}` : "Value cannot be cloned with `$state.snapshot` \u2014 the original value was returned"}\nhttps://svelte.dev/e/state_snapshot_uncloneable`, $4812b3a437360ff9$var$bold, $4812b3a437360ff9$var$normal);
    else console.warn(`https://svelte.dev/e/state_snapshot_uncloneable`);
}

});



parcelRegister("9AQvv", function(module, exports) {

$parcel$export(module.exports, "get_error", () => $6fc034b3cb6828bb$export$bfbf4be1e73628ef);
$parcel$export(module.exports, "invariant", () => $6fc034b3cb6828bb$export$f5708dca728d7177);
parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $btEsq = parcelRequire("btEsq");

var $3gXWT = parcelRequire("3gXWT");
function $6fc034b3cb6828bb$export$bfbf4be1e73628ef(label) {
    const error = new Error();
    const stack = $6fc034b3cb6828bb$export$fcec473f19cfc878();
    if (stack.length === 0) return null;
    stack.unshift('\n');
    (0, $btEsq.define_property)(error, 'stack', {
        value: stack.join('\n')
    });
    (0, $btEsq.define_property)(error, 'name', {
        value: label
    });
    return /** @type {Error & { stack: string }} */ error;
}
function $6fc034b3cb6828bb$export$fcec473f19cfc878() {
    // @ts-ignore - doesn't exist everywhere
    const limit = Error.stackTraceLimit;
    // @ts-ignore - doesn't exist everywhere
    Error.stackTraceLimit = Infinity;
    const stack = new Error().stack;
    // @ts-ignore - doesn't exist everywhere
    Error.stackTraceLimit = limit;
    if (!stack) return [];
    const lines = stack.split('\n');
    const new_lines = [];
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        const posixified = line.replaceAll('\\', '/');
        if (line.trim() === 'Error') continue;
        if (line.includes('validate_each_keys')) return [];
        if (posixified.includes('svelte/src/internal') || posixified.includes('node_modules/.vite')) continue;
        new_lines.push(line);
    }
    return new_lines;
}
function $6fc034b3cb6828bb$export$f5708dca728d7177(condition, message) {
    if (!(0, $7YIuB.default)) throw new Error('invariant(...) was not guarded by if (DEV)');
    if (!condition) $3gXWT.invariant_violation(message);
}

});

parcelRegister("6bkva", function(module, exports) {

$parcel$export(module.exports, "component_context", () => $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd);
$parcel$export(module.exports, "set_component_context", () => $4803ac5cd071c0fc$export$ea7d6316d2ef8c04);
$parcel$export(module.exports, "dev_stack", () => $4803ac5cd071c0fc$export$19c6133b21f846f4);
$parcel$export(module.exports, "set_dev_stack", () => $4803ac5cd071c0fc$export$87206a8bba84df13);
$parcel$export(module.exports, "dev_current_component_function", () => $4803ac5cd071c0fc$export$20bdb63657dee00d);
$parcel$export(module.exports, "set_dev_current_component_function", () => $4803ac5cd071c0fc$export$56d76cff37bec1e8);
$parcel$export(module.exports, "is_runes", () => $4803ac5cd071c0fc$export$6eac58a364a8d770);
/** @import { ComponentContext, DevStackEntry, Effect } from '#client' */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");
parcelRequire("gB48l");
var $3gXWT = parcelRequire("3gXWT");

var $egVZE = parcelRequire("egVZE");

var $kCMGX = parcelRequire("kCMGX");

var $yJWNn = parcelRequire("yJWNn");

var $56eus = parcelRequire("56eus");

var $8zILj = parcelRequire("8zILj");

var $btEsq = parcelRequire("btEsq");

var $5e9bA = parcelRequire("5e9bA");
let $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd = null;
function $4803ac5cd071c0fc$export$ea7d6316d2ef8c04(context) {
    $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd = context;
}
let $4803ac5cd071c0fc$export$19c6133b21f846f4 = null;
function $4803ac5cd071c0fc$export$87206a8bba84df13(stack) {
    $4803ac5cd071c0fc$export$19c6133b21f846f4 = stack;
}
function $4803ac5cd071c0fc$export$7d90b65f7bef179c(callback, type, component, line, column, additional) {
    const parent = $4803ac5cd071c0fc$export$19c6133b21f846f4;
    $4803ac5cd071c0fc$export$19c6133b21f846f4 = {
        type: type,
        file: component[0, $56eus.FILENAME],
        line: line,
        column: column,
        parent: parent,
        ...additional
    };
    try {
        return callback();
    } finally{
        $4803ac5cd071c0fc$export$19c6133b21f846f4 = parent;
    }
}
let $4803ac5cd071c0fc$export$20bdb63657dee00d = null;
function $4803ac5cd071c0fc$export$56d76cff37bec1e8(fn) {
    $4803ac5cd071c0fc$export$20bdb63657dee00d = fn;
}
function $4803ac5cd071c0fc$export$fd42f52fd3ae1109() {
    return /** @type {[() => T, (context: T) => T, () => boolean]} */ (0, $5e9bA.create_context)($4803ac5cd071c0fc$export$31553aaa555c1514, $4803ac5cd071c0fc$export$2f04de43fe27971a, $4803ac5cd071c0fc$export$1fda64d8edbe0e8d);
}
function $4803ac5cd071c0fc$export$31553aaa555c1514(key) {
    const context_map = (0, $5e9bA.get_or_init_context_map)($4803ac5cd071c0fc$export$e2e1c5f373c7d8bd, 'getContext');
    const result = /** @type {T} */ context_map.get(key);
    return result;
}
function $4803ac5cd071c0fc$export$2f04de43fe27971a(key, context) {
    const context_map = (0, $5e9bA.get_or_init_context_map)($4803ac5cd071c0fc$export$e2e1c5f373c7d8bd, 'setContext');
    if (0, $yJWNn.async_mode_flag) {
        var flags = /** @type {Effect} */ (0, $egVZE.active_effect).f;
        var valid = !(0, $egVZE.active_reaction) && (flags & (0, $8zILj.BRANCH_EFFECT)) !== 0 && // pop() runs synchronously, so this indicates we're setting context after an await
        !/** @type {ComponentContext} */ $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd.i;
        if (!valid) $3gXWT.set_context_after_init();
    }
    context_map.set(key, context);
    return context;
}
function $4803ac5cd071c0fc$export$1fda64d8edbe0e8d(key) {
    const context_map = (0, $5e9bA.get_or_init_context_map)($4803ac5cd071c0fc$export$e2e1c5f373c7d8bd, 'hasContext');
    return context_map.has(key);
}
function $4803ac5cd071c0fc$export$58bb8454a8b39484() {
    const context_map = (0, $5e9bA.get_or_init_context_map)($4803ac5cd071c0fc$export$e2e1c5f373c7d8bd, 'getAllContexts');
    return /** @type {T} */ context_map;
}
function $4803ac5cd071c0fc$export$4cbf152802aa238(props, runes = false, fn) {
    $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd = {
        p: $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd,
        i: false,
        c: null,
        e: null,
        s: props,
        x: null,
        r: /** @type {Effect} */ (0, $egVZE.active_effect),
        l: (0, $yJWNn.legacy_mode_flag) && !runes ? {
            s: null,
            u: null,
            $: []
        } : null
    };
    if (0, $7YIuB.default) {
        // component function
        $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd.function = fn;
        $4803ac5cd071c0fc$export$20bdb63657dee00d = fn;
    }
}
function $4803ac5cd071c0fc$export$3e41007ebfff0e64(component) {
    var context = /** @type {ComponentContext} */ $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd;
    var effects = context.e;
    if (effects !== null) {
        context.e = null;
        for (var fn of effects)(0, $kCMGX.create_user_effect)(fn);
    }
    if (component !== undefined) context.x = component;
    context.i = true;
    $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd = context.p;
    if (0, $7YIuB.default) $4803ac5cd071c0fc$export$20bdb63657dee00d = $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd?.function ?? null;
    return $4803ac5cd071c0fc$export$4089b6bf332fd91(component);
}
function $4803ac5cd071c0fc$export$4089b6bf332fd91(component = {}) {
    (0, $btEsq.define_property)(component, (0, $8zILj.COMPONENT_SYMBOL), {
        value: true
    });
    return component;
}
function $4803ac5cd071c0fc$export$6eac58a364a8d770() {
    return !(0, $yJWNn.legacy_mode_flag) || $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd !== null && $4803ac5cd071c0fc$export$e2e1c5f373c7d8bd.l === null;
}

});
parcelRegister("5e9bA", function(module, exports) {

$parcel$export(module.exports, "create_context", () => $3ce562adc637fda8$export$75ade98f9f0396f2);
$parcel$export(module.exports, "get_or_init_context_map", () => $3ce562adc637fda8$export$261e4a9a5e4827e2);

var $3gXWT = parcelRequire("3gXWT");
function $3ce562adc637fda8$export$75ade98f9f0396f2(get_context, set_context, has_context) {
    const key = {};
    return [
        ()=>{
            if (!has_context(key)) (0, $3gXWT.missing_context)();
            return get_context(key);
        },
        (context)=>set_context(key, context),
        ()=>has_context(key)
    ];
}
/**
 * @typedef {{ p: Context | null, c: Map<unknown, unknown> | null }} Context
 */ /**
 * @param {Context} context
 * @returns {Map<unknown, unknown> | null}
 */ function $3ce562adc637fda8$var$get_parent_context(context) {
    let parent = context.p;
    while(parent !== null && parent.c === null)parent = parent.p;
    return parent?.c ?? null;
}
function $3ce562adc637fda8$export$261e4a9a5e4827e2(context, name) {
    if (context === null) (0, $3gXWT.lifecycle_outside_component)(name);
    return context.c ??= new Map($3ce562adc637fda8$var$get_parent_context(context) || undefined);
}

});


parcelRegister("amPy2", function(module, exports) {

$parcel$export(module.exports, "current_batch", () => $78c3f1cd4c4ec9c4$export$8dd36da296c3437e);
$parcel$export(module.exports, "previous_batch", () => $78c3f1cd4c4ec9c4$export$6f437ce6c6dab6db);
$parcel$export(module.exports, "batch_values", () => $78c3f1cd4c4ec9c4$export$70a171f1ec84867d);
$parcel$export(module.exports, "is_flushing_sync", () => $78c3f1cd4c4ec9c4$export$90566adb2ab13b3e);
$parcel$export(module.exports, "collected_effects", () => $78c3f1cd4c4ec9c4$export$d753ff03de3b7dce);
$parcel$export(module.exports, "legacy_updates", () => $78c3f1cd4c4ec9c4$export$6b5c91f2341ad2f6);
$parcel$export(module.exports, "Batch", () => $78c3f1cd4c4ec9c4$export$33b107562567fc47);
$parcel$export(module.exports, "flushSync", () => $78c3f1cd4c4ec9c4$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "eager_block_effects", () => $78c3f1cd4c4ec9c4$export$d6deee6e561f6210);
$parcel$export(module.exports, "schedule_effect", () => $78c3f1cd4c4ec9c4$export$d3d339c14fbcf78d);
/** @import { Fork } from 'svelte' */ /** @import { Derived, Effect, Reaction, Source, Value } from '#client' */ 
var $8zILj = parcelRequire("8zILj");

var $yJWNn = parcelRequire("yJWNn");

var $btEsq = parcelRequire("btEsq");

var $egVZE = parcelRequire("egVZE");

var $gB48l = parcelRequire("gB48l");
var $3gXWT = parcelRequire("3gXWT");

var $c2wsH = parcelRequire("c2wsH");
parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $1u5nX = parcelRequire("1u5nX");

var $kmhLl = parcelRequire("kmhLl");

var $kCMGX = parcelRequire("kCMGX");

var $7Bsuc = parcelRequire("7Bsuc");

var $56eus = parcelRequire("56eus");

var $1RLxH = parcelRequire("1RLxH");

var $9AQvv = parcelRequire("9AQvv");
parcelRequire("mS8IQ");

var $3oHv7 = parcelRequire("3oHv7");
/** @type {Batch | null} */ let $78c3f1cd4c4ec9c4$var$first_batch = null;
/** @type {Batch | null} */ let $78c3f1cd4c4ec9c4$var$last_batch = null;
let $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = null;
let $78c3f1cd4c4ec9c4$export$6f437ce6c6dab6db = null;
let $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = null;
/** @type {Effect | null} */ let $78c3f1cd4c4ec9c4$var$last_scheduled_effect = null;
let $78c3f1cd4c4ec9c4$export$90566adb2ab13b3e = false;
let $78c3f1cd4c4ec9c4$var$is_processing = false;
let $78c3f1cd4c4ec9c4$export$d753ff03de3b7dce = null;
let $78c3f1cd4c4ec9c4$export$6b5c91f2341ad2f6 = null;
var $78c3f1cd4c4ec9c4$var$flush_count = 0;
/** @type {Set<Value>} */ var $78c3f1cd4c4ec9c4$var$source_stacks = new Set();
let $78c3f1cd4c4ec9c4$var$uid = 1;
class $78c3f1cd4c4ec9c4$export$33b107562567fc47 {
    id = $78c3f1cd4c4ec9c4$var$uid++;
    /** True as soon as `#process` was called */ #started = false;
    linked = true;
    /** @type {Batch | null} */ #prev = null;
    /** @type {Batch | null} */ #next = null;
    /** @type {Map<Effect, ReturnType<typeof deferred<any>>>} */ async_deriveds = new Map();
    /**
	 * The current values of any signals that are updated in this batch.
	 * Tuple format: [value, is_derived] (note: is_derived is false for deriveds, too, if they were overridden via assignment)
	 * They keys of this map are identical to `this.#previous`
	 * @type {Map<Value, [any, boolean]>}
	 */ current = new Map();
    /**
	 * The values of any signals (sources and deriveds) that are updated in this batch _before_ those updates took place.
	 * They keys of this map are identical to `this.#current`
	 * @type {Map<Value, any>}
	 */ previous = new Map();
    /**
	 * When the batch is committed (and the DOM is updated), we need to remove old branches
	 * and append new ones by calling the functions added inside (if/each/key/etc) blocks
	 * @type {Set<(batch: Batch) => void>}
	 */ #commit_callbacks = new Set();
    /**
	 * If a fork is discarded, we need to destroy any effects that are no longer needed
	 * @type {Set<(batch: Batch) => void>}
	 */ #discard_callbacks = new Set();
    /**
	 * The number of async effects that are currently in flight
	 */ #pending = 0;
    /**
	 * Async effects that are currently in flight, _not_ inside a pending boundary
	 * @type {Map<Effect, number>}
	 */ #blocking_pending = new Map();
    /**
	 * A deferred that resolves when the batch is committed, used with `settled()`
	 * TODO replace with Promise.withResolvers once supported widely enough
	 * @type {{ promise: Promise<void>, resolve: (value?: any) => void, reject: (reason: unknown) => void } | null}
	 */ #deferred = null;
    /**
	 * Effects that were scheduled in this batch but not yet 'resolved' into the
	 * root effects that need to be flushed. Resolving — the upwards traversal that
	 * marks the path to each effect on the shared effect tree (see #resolve) — is
	 * deferred until the batch is processed, so that the markers are created and
	 * consumed within a single traversal. Scheduling into other batches (which can
	 * happen concurrently, e.g. while a batch is committed) can therefore never
	 * observe (and be confused by) this batch's markers.
	 * May contain duplicates — deduplication happens during resolving
	 * @type {Effect[]}
	 */ #scheduled = [];
    /**
	 * Effects created while this batch was active.
	 * @type {Effect[]}
	 */ #new_effects = [];
    /**
	 * Deferred effects (which run after async work has completed) that are DIRTY
	 * @type {Set<Effect>}
	 */ #dirty_effects = new Set();
    /**
	 * Deferred effects that are MAYBE_DIRTY
	 * @type {Set<Effect>}
	 */ #maybe_dirty_effects = new Set();
    /**
	 * A map of branches that still exist, but will be destroyed when this batch
	 * is committed — we skip over these during `process`.
	 * The value contains child effects that were dirty/maybe_dirty before being reset,
	 * so they can be rescheduled if the branch survives.
	 * @type {Map<Effect, { d: Effect[], m: Effect[] }>}
	 */ #skipped_branches = new Map();
    /**
	 * Inverse of #skipped_branches which we need to tell prior batches to unskip them when committing
	 * @type {Set<Effect>}
	 */ #unskipped_branches = new Set();
    is_fork = false;
    #decrement_queued = false;
    constructor(){
        // link batch
        if ($78c3f1cd4c4ec9c4$var$last_batch === null) $78c3f1cd4c4ec9c4$var$first_batch = $78c3f1cd4c4ec9c4$var$last_batch = this;
        else {
            $78c3f1cd4c4ec9c4$var$last_batch.#next = this;
            this.#prev = $78c3f1cd4c4ec9c4$var$last_batch;
        }
        $78c3f1cd4c4ec9c4$var$last_batch = this;
    }
    #is_deferred() {
        if (this.is_fork) return true;
        for (const effect of this.#blocking_pending.keys()){
            var e = effect;
            var skipped = false;
            while(e.parent !== null){
                if (this.#skipped_branches.has(e)) {
                    skipped = true;
                    break;
                }
                e = e.parent;
            }
            if (!skipped) return true;
        }
        return false;
    }
    /**
	 * Add an effect to the #skipped_branches map and reset its children
	 * @param {Effect} effect
	 */ skip_effect(effect) {
        if (!this.#skipped_branches.has(effect)) this.#skipped_branches.set(effect, {
            d: [],
            m: []
        });
        this.#unskipped_branches.delete(effect);
    }
    /**
	 * Remove an effect from the #skipped_branches map and reschedule
	 * any tracked dirty/maybe_dirty child effects
	 * @param {Effect} effect
	 * @param {(e: Effect) => void} callback
	 */ unskip_effect(effect, callback = (e)=>this.schedule(e)) {
        var tracked = this.#skipped_branches.get(effect);
        if (tracked) {
            this.#skipped_branches.delete(effect);
            for (var e of tracked.d){
                (0, $1RLxH.set_signal_status)(e, (0, $8zILj.DIRTY));
                callback(e);
            }
            for (e of tracked.m){
                (0, $1RLxH.set_signal_status)(e, (0, $8zILj.MAYBE_DIRTY));
                callback(e);
            }
        }
        this.#unskipped_branches.add(effect);
    }
    /**
	 * Convert the effects that were scheduled in this batch into the root effects
	 * that need to be traversed, marking the path to each effect (by clearing the
	 * `CLEAN` flag on ancestor branches) so that the traversal can find them.
	 * This happens right before traversal rather than at scheduling time, so that
	 * the markers left on the (shared) effect tree are created and consumed within
	 * a single traversal — scheduling into other batches can never observe them
	 * @returns {Effect[]}
	 */ #resolve() {
        /** @type {Effect[]} */ var roots = [];
        for (const effect of this.#scheduled){
            // skip effects that are destroyed, or that already ran (e.g. because
            // they were reached by the traversal that preceded a drain iteration,
            // or because they were scheduled twice)
            if ((effect.f & (0, $8zILj.DESTROYED)) !== 0 || (effect.f & ((0, $8zILj.DIRTY) | (0, $8zILj.MAYBE_DIRTY))) === 0) continue;
            var e = effect;
            var covered = false;
            while(e.parent !== null){
                e = e.parent;
                var flags = e.f;
                if ((flags & ((0, $8zILj.ROOT_EFFECT) | (0, $8zILj.BRANCH_EFFECT))) !== 0) {
                    if ((flags & (0, $8zILj.CLEAN)) === 0) {
                        // the path to the root was already marked, meaning the
                        // root was already collected — nothing left to do
                        covered = true;
                        break;
                    }
                    e.f ^= (0, $8zILj.CLEAN);
                }
            }
            if (!covered) roots.push(e);
        }
        this.#scheduled = [];
        return roots;
    }
    #process() {
        this.#started = true;
        if (0, $7YIuB.default) // track all the values that were updated during this flush,
        // so that they can be reset afterwards
        for (const value of this.current.keys())$78c3f1cd4c4ec9c4$var$source_stacks.add(value);
        // We always reschedule previously-deferred effects, not just when
        // #is_deferred() is true, because traversing the tree could make
        // an if block that contains the last blocking pending effect falsy,
        // causing the block to no longer be deferred.
        for (const e of this.#dirty_effects){
            this.#maybe_dirty_effects.delete(e);
            (0, $1RLxH.set_signal_status)(e, (0, $8zILj.DIRTY));
            this.schedule(e);
        }
        for (const e of this.#maybe_dirty_effects){
            (0, $1RLxH.set_signal_status)(e, (0, $8zILj.MAYBE_DIRTY));
            this.schedule(e);
        }
        this.apply();
        /** @type {Effect[]} */ var effects = $78c3f1cd4c4ec9c4$export$d753ff03de3b7dce = [];
        /** @type {Effect[]} */ var render_effects = [];
        /**
		 * @type {Effect[]}
		 * @deprecated when we get rid of legacy mode and stores, we can get rid of this
		 */ var updates = $78c3f1cd4c4ec9c4$export$6b5c91f2341ad2f6 = [];
        // Effects can be scheduled during traversal (e.g. because a parent each/await/etc
        // block updated an internal source, or because an effect invalidated itself)
        // hence we loop until there are no more scheduled effects.
        while(this.#scheduled.length > 0){
            if ($78c3f1cd4c4ec9c4$var$flush_count++ > 1000) {
                this.#unlink();
                $78c3f1cd4c4ec9c4$var$infinite_loop_guard(); // TODO try to reset_all() here?
            }
            for (const root of this.#resolve())try {
                this.#traverse(root, effects, render_effects);
            } catch (e) {
                $78c3f1cd4c4ec9c4$var$reset_all(root);
                // If there's no async work left, this branch is now dead and needs
                // to be discarded to not become a zombie that is never cleaned up.
                // See https://github.com/sveltejs/svelte/issues/18221#issuecomment-4497918414
                // for a (non-minimal) reproduction that demonstrates a case where this is necessary
                // to not get follow-up false-positives via "batch has scheduled roots" invariant errors.
                if (!this.#is_deferred()) this.discard();
                throw e;
            }
        }
        // any writes should take effect in a subsequent batch
        $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = null;
        if (updates.length > 0) {
            var batch = $78c3f1cd4c4ec9c4$export$33b107562567fc47.ensure();
            for (const e of updates)batch.schedule(e);
        }
        $78c3f1cd4c4ec9c4$export$d753ff03de3b7dce = null;
        $78c3f1cd4c4ec9c4$export$6b5c91f2341ad2f6 = null;
        // if the batch has outstanding pending work, stash effects and bail
        if (this.#is_deferred()) {
            this.#defer_effects(render_effects);
            this.#defer_effects(effects);
            for (const [e, t] of this.#skipped_branches)$78c3f1cd4c4ec9c4$var$reset_branch(e, t);
            if (updates.length > 0) /** @type {unknown} */ $78c3f1cd4c4ec9c4$export$8dd36da296c3437e.#process();
            return;
        }
        const earlier_batch = this.#find_earlier_batch();
        if (earlier_batch) {
            // If this batch collected deferred effects during traversal, they still need
            // to run after being merged into the earlier batch.
            this.#defer_effects(render_effects);
            this.#defer_effects(effects);
            earlier_batch.#merge(this);
            return;
        }
        // clear effects. Those that are still needed will be rescheduled through unskipping the skipped branches.
        this.#dirty_effects.clear();
        this.#maybe_dirty_effects.clear();
        // append/remove branches
        for (const fn of this.#commit_callbacks)fn(this);
        this.#commit_callbacks.clear();
        $78c3f1cd4c4ec9c4$export$6f437ce6c6dab6db = this;
        $78c3f1cd4c4ec9c4$var$flush_queued_effects(render_effects);
        $78c3f1cd4c4ec9c4$var$flush_queued_effects(effects);
        $78c3f1cd4c4ec9c4$export$6f437ce6c6dab6db = null;
        this.#deferred?.resolve();
        var next_batch = /** @type {unknown} */ $78c3f1cd4c4ec9c4$export$8dd36da296c3437e;
        if (this.#pending === 0 && (this.#scheduled.length === 0 || next_batch !== null)) {
            this.#unlink();
            // Order matters here - we need to commit and THEN continue flushing new batches, not the other way around,
            // else we could start flushing a new batch and then, if it has pending work, rebase it right afterwards, which is wrong.
            // In sync mode flushSync can cause #commit to wrongfully think that there needs to be a rebase, so we only do it in async mode
            // TODO fix the underlying cause, otherwise this will likely regress when non-async mode is removed
            if (0, $yJWNn.async_mode_flag) {
                this.#commit();
                // Rebases can activate other batches or null it out, therefore restore the new one here
                $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = next_batch;
            }
        }
        // Edge case: During traversal new branches might create effects that run immediately and set state,
        // causing an effect to be scheduled again. We need to traverse the current batch
        // once more in that case - most of the time this will just clean up dirty branches.
        if (this.#scheduled.length > 0) {
            if (next_batch !== null) {
                for (const e of this.#scheduled)next_batch.#scheduled.push(e);
                this.#scheduled = [];
            } else next_batch = this;
        }
        if (next_batch !== null) {
            (0, $kmhLl.old_values).clear();
            next_batch.#process();
        }
    }
    /**
	 * Traverse the effect tree, executing effects or stashing
	 * them for later execution as appropriate
	 * @param {Effect} root
	 * @param {Effect[]} effects
	 * @param {Effect[]} render_effects
	 */ #traverse(root, effects, render_effects) {
        root.f ^= (0, $8zILj.CLEAN);
        var effect = root.first;
        while(effect !== null){
            var flags = effect.f;
            var is_branch = (flags & ((0, $8zILj.BRANCH_EFFECT) | (0, $8zILj.ROOT_EFFECT))) !== 0;
            var is_skippable_branch = is_branch && (flags & (0, $8zILj.CLEAN)) !== 0;
            var skip = is_skippable_branch || (flags & (0, $8zILj.INERT)) !== 0 || this.#skipped_branches.has(effect);
            if (!skip && effect.fn !== null) {
                if (is_branch) effect.f ^= (0, $8zILj.CLEAN);
                else if ((flags & (0, $8zILj.EFFECT)) !== 0) effects.push(effect);
                else if ((0, $yJWNn.async_mode_flag) && (flags & ((0, $8zILj.RENDER_EFFECT) | (0, $8zILj.MANAGED_EFFECT))) !== 0) render_effects.push(effect);
                else if ((0, $egVZE.is_dirty)(effect)) {
                    if ((flags & (0, $8zILj.BLOCK_EFFECT)) !== 0) this.#maybe_dirty_effects.add(effect);
                    (0, $egVZE.update_effect)(effect);
                }
                var child = effect.first;
                if (child !== null) {
                    effect = child;
                    continue;
                }
            }
            while(effect !== null){
                var next = effect.next;
                if (next !== null) {
                    effect = next;
                    break;
                }
                effect = effect.parent;
            }
        }
    }
    #find_earlier_batch() {
        var batch = this.#prev;
        while(batch !== null){
            if (!batch.is_fork) // if the batches are connected, break
            for (const [value, [, is_derived]] of this.current){
                if (batch.current.has(value) && !is_derived) return batch;
            }
            batch = batch.#prev;
        }
        return null;
    }
    /**
	 * @param {Batch} batch
	 */ #merge(batch) {
        for (const [source, value] of batch.current){
            if (!this.previous.has(source) && batch.previous.has(source)) this.previous.set(source, batch.previous.get(source));
            this.current.set(source, value);
        }
        for (const [effect, deferred] of batch.async_deriveds){
            const d = this.async_deriveds.get(effect);
            if (d) deferred.promise.then(d.resolve).catch(d.reject);
        }
        // Clear them or else those that are still pending might get rejected on discard (after merged-into batch is done).
        // This can happen when batch Y merged into X and Y has a pending boundary and therefore still-pending async deriveds inside.
        batch.async_deriveds.clear();
        // Mark is not guaranteed not touch these, so we transfer them
        this.transfer_effects(batch.#dirty_effects, batch.#maybe_dirty_effects);
        /**
		 * mark all effects that depend on `batch.current`, except the
		 * async effects that we just resolved (TODO unless they depend
		 * on values in this batch that are NOT in the later batch?).
		 * Through this we also will populate the correct #skipped_branches,
		 * oncommit callbacks etc, so we don't need to merge them separately.
		 * @param {Value} value
		 */ const mark = (value)=>{
            var reactions = value.reactions;
            if (reactions === null) return;
            // skip if value is derived and is neither dirty nor maybe dirty. transitive
            // deriveds (a derived depending on another derived) are only MAYBE_DIRTY, so
            // we must continue traversing them to reach the effects that depend on them
            if ((value.f & (0, $8zILj.DERIVED)) !== 0 && (value.f & ((0, $8zILj.DIRTY) | (0, $8zILj.MAYBE_DIRTY))) === 0) return;
            for (const reaction of reactions){
                var flags = reaction.f;
                if ((flags & (0, $8zILj.DERIVED)) !== 0) mark(/** @type {Derived} */ reaction);
                else {
                    var effect = /** @type {Effect} */ reaction;
                    if (flags & ((0, $8zILj.ASYNC) | (0, $8zILj.BLOCK_EFFECT)) && !this.async_deriveds.has(effect)) {
                        this.#maybe_dirty_effects.delete(effect);
                        (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.DIRTY));
                        this.schedule(effect);
                    }
                }
            }
        };
        for (const source of this.current.keys())mark(source);
        this.oncommit(()=>batch.discard());
        batch.#unlink();
        $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = this;
        this.#process();
    }
    /**
	 * @param {Effect[]} effects
	 */ #defer_effects(effects) {
        for(var i = 0; i < effects.length; i += 1)(0, $7Bsuc.defer_effect)(effects[i], this.#dirty_effects, this.#maybe_dirty_effects);
    }
    /**
	 * Associate a change to a given source with the current
	 * batch, noting its previous and current values
	 * @param {Value} source
	 * @param {any} value
	 * @param {boolean} [is_derived]
	 */ capture(source, value, is_derived = false) {
        if (source.v !== (0, $56eus.UNINITIALIZED) && !this.previous.has(source)) this.previous.set(source, source.v);
        // Don't save errors in `batch_values`, or they won't be thrown in `runtime.js#get`
        if ((source.f & (0, $8zILj.ERROR_VALUE)) === 0) {
            this.current.set(source, [
                value,
                is_derived
            ]);
            $78c3f1cd4c4ec9c4$export$70a171f1ec84867d?.set(source, value);
        }
        if (!this.is_fork) source.v = value;
    }
    activate() {
        $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = this;
    }
    deactivate() {
        $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = null;
        $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = null;
    }
    flush() {
        try {
            if (0, $7YIuB.default) $78c3f1cd4c4ec9c4$var$source_stacks.clear();
            $78c3f1cd4c4ec9c4$var$is_processing = true;
            $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = this;
            this.#process();
        } finally{
            $78c3f1cd4c4ec9c4$var$flush_count = 0;
            $78c3f1cd4c4ec9c4$var$last_scheduled_effect = null;
            $78c3f1cd4c4ec9c4$export$d753ff03de3b7dce = null;
            $78c3f1cd4c4ec9c4$export$6b5c91f2341ad2f6 = null;
            $78c3f1cd4c4ec9c4$var$is_processing = false;
            $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = null;
            $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = null;
            (0, $kmhLl.old_values).clear();
            if (0, $7YIuB.default) for (const source of $78c3f1cd4c4ec9c4$var$source_stacks)source.updated = null;
        }
    }
    discard() {
        for (const fn of this.#discard_callbacks)fn(this);
        this.#discard_callbacks.clear();
        for (const deferred of this.async_deriveds.values())deferred.reject((0, $3oHv7.OBSOLETE));
        this.#unlink();
        this.#deferred?.resolve();
    }
    /**
	 * @param {Effect} effect
	 */ register_created_effect(effect) {
        this.#new_effects.push(effect);
    }
    #commit() {
        // If there are other pending batches, they now need to be 'rebased' —
        // in other words, we re-run block/async effects with the newly
        // committed state, unless the batch in question has a more
        // recent value for a given source
        for(let batch = $78c3f1cd4c4ec9c4$var$first_batch; batch !== null; batch = batch.#next){
            var is_earlier = batch.id < this.id;
            /** @type {Source[]} */ var sources = [];
            for (const [source, [value, is_derived]] of this.current){
                if (batch.current.has(source)) {
                    var batch_value = /** @type {[any, boolean]} */ batch.current.get(source)[0]; // faster than destructuring
                    if (is_earlier && value !== batch_value) // bring the value up to date
                    batch.current.set(source, [
                        value,
                        is_derived
                    ]);
                    else continue;
                }
                sources.push(source);
            }
            if (is_earlier) // TODO do we need to restart these in some cases, instead of
            // immediately resolving them? Likely not because of how this.apply() works.
            for (const [effect, deferred] of this.async_deriveds){
                const d = batch.async_deriveds.get(effect);
                if (d) deferred.promise.then(d.resolve).catch(d.reject);
            }
            var current = [
                ...batch.current.keys()
            ].filter((source)=>!/** @type {[any, boolean]} */ batch.current.get(source)[1]);
            // If not started yet or no sources to update (which is e.g. possible for the very first batch) then bail
            if (!batch.#started || current.length === 0) continue;
            // Re-run async/block effects that depend on distinct values changed in both batches (ignoring deriveds)
            var others = current.filter((source)=>!this.current.has(source));
            if (others.length === 0) {
                if (is_earlier) // this batch is now obsolete and can be discarded
                batch.discard();
            } else if (sources.length > 0) {
                // The microtask queue can contain the batch already scheduled to run right
                // after this one is finished, so throwing the invariant would be wrong here.
                if ((0, $7YIuB.default) && !batch.#decrement_queued) (0, $9AQvv.invariant)(batch.#scheduled.length === 0, 'Batch has scheduled effects');
                // A batch was unskipped in a later batch -> tell prior batches to unskip it, too
                if (is_earlier) for (const unskipped of this.#unskipped_branches)batch.unskip_effect(unskipped, (e)=>{
                    if ((e.f & ((0, $8zILj.BLOCK_EFFECT) | (0, $8zILj.ASYNC))) !== 0) batch.schedule(e);
                    else batch.#defer_effects([
                        e
                    ]);
                });
                batch.activate();
                /** @type {Set<Value>} */ var marked = new Set();
                /** @type {Map<Reaction, boolean>} */ var checked = new Map();
                for (var source of sources)$78c3f1cd4c4ec9c4$var$mark_effects(source, others, marked, checked);
                checked = new Map();
                var current_unequal = [
                    ...batch.current
                ].filter(([c, v1])=>{
                    const v2 = this.current.get(c);
                    if (!v2) return true;
                    // Either their values are different or one is a derived but not the other
                    return v2[0] !== v1[0] || v2[1] !== v1[1];
                }).map(([c])=>c);
                if (current_unequal.length > 0) {
                    for (const effect of this.#new_effects)if ((effect.f & ((0, $8zILj.DESTROYED) | (0, $8zILj.INERT) | (0, $8zILj.EAGER_EFFECT))) === 0 && $78c3f1cd4c4ec9c4$var$depends_on(effect, current_unequal, checked)) {
                        if ((effect.f & ((0, $8zILj.ASYNC) | (0, $8zILj.BLOCK_EFFECT))) !== 0) {
                            (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.DIRTY));
                            batch.schedule(effect);
                        } else batch.#dirty_effects.add(effect);
                    }
                }
                // Only apply and traverse when we know we triggered async work with marking the effects
                // and know this won't run anyway right afterwards
                if (batch.#scheduled.length > 0 && !batch.#decrement_queued) {
                    batch.apply();
                    for (var root of batch.#resolve())batch.#traverse(root, [], []);
                }
                batch.deactivate();
            }
        }
    }
    /**
	 * @param {boolean} blocking
	 * @param {Effect} effect
	 */ increment(blocking, effect) {
        this.#pending += 1;
        if (blocking) {
            let blocking_pending_count = this.#blocking_pending.get(effect) ?? 0;
            this.#blocking_pending.set(effect, blocking_pending_count + 1);
        }
    }
    /**
	 * @param {boolean} blocking
	 * @param {Effect} effect
	 */ decrement(blocking, effect) {
        this.#pending -= 1;
        if (blocking) {
            let blocking_pending_count = this.#blocking_pending.get(effect) ?? 0;
            if (blocking_pending_count === 1) this.#blocking_pending.delete(effect);
            else this.#blocking_pending.set(effect, blocking_pending_count - 1);
        }
        if (this.#decrement_queued) return;
        this.#decrement_queued = true;
        (0, $c2wsH.queue_micro_task)(()=>{
            this.#decrement_queued = false;
            if (this.linked) this.flush();
        });
    }
    /**
	 * @param {Set<Effect>} dirty_effects
	 * @param {Set<Effect>} maybe_dirty_effects
	 */ transfer_effects(dirty_effects, maybe_dirty_effects) {
        for (const e of dirty_effects)this.#dirty_effects.add(e);
        for (const e of maybe_dirty_effects)this.#maybe_dirty_effects.add(e);
        dirty_effects.clear();
        maybe_dirty_effects.clear();
    }
    /** @param {(batch: Batch) => void} fn */ oncommit(fn) {
        this.#commit_callbacks.add(fn);
    }
    /** @param {(batch: Batch) => void} fn */ ondiscard(fn) {
        this.#discard_callbacks.add(fn);
    }
    settled() {
        return (this.#deferred ??= (0, $btEsq.deferred)()).promise;
    }
    static ensure() {
        if ($78c3f1cd4c4ec9c4$export$8dd36da296c3437e === null) {
            const batch = $78c3f1cd4c4ec9c4$export$8dd36da296c3437e = new $78c3f1cd4c4ec9c4$export$33b107562567fc47();
            if (!$78c3f1cd4c4ec9c4$var$is_processing && !$78c3f1cd4c4ec9c4$export$90566adb2ab13b3e) (0, $c2wsH.queue_micro_task)(()=>{
                if (!batch.#started) batch.flush();
            });
        }
        return $78c3f1cd4c4ec9c4$export$8dd36da296c3437e;
    }
    apply() {
        if (!(0, $yJWNn.async_mode_flag) || !this.is_fork && this.#prev === null && this.#next === null) {
            $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = null;
            return;
        }
        // if there are multiple batches, we are 'time travelling' —
        // we need to override values with the ones in this batch...
        $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = new Map();
        for (const [source, [value]] of this.current)$78c3f1cd4c4ec9c4$export$70a171f1ec84867d.set(source, value);
        // ...and undo changes belonging to other batches unless they intersect
        for(let batch = $78c3f1cd4c4ec9c4$var$first_batch; batch !== null; batch = batch.#next){
            if (batch === this || batch.is_fork) continue;
            // If two batches intersect, the latter batch will be merged into the earlier batch,
            // and we should treat them as a single set of changes
            var intersects = false;
            if (batch.id < this.id) for (const [source, [, is_derived]] of batch.current){
                // Derived values don't partake in the intersection mechanism, because a derived could
                // be triggered in one batch already but not the other one yet, causing a false-positive
                if (is_derived) continue;
                if (this.current.has(source)) {
                    intersects = true;
                    break;
                }
            }
            // Since the latter batch merges into the earlier (if it resolves before the earlier one),
            // we treat the earlier values as "already applied". This way we don't need to rerun async
            // effects of the earlier batch in case they are merged.
            // As a result you can think of batch_values as having the latest values of all intersecting
            // batches up until this batch.
            if (!intersects) {
                for (const [source, previous] of batch.previous)if (!$78c3f1cd4c4ec9c4$export$70a171f1ec84867d.has(source)) $78c3f1cd4c4ec9c4$export$70a171f1ec84867d.set(source, previous);
            }
        }
    }
    /**
	 *
	 * @param {Effect} effect
	 */ schedule(effect) {
        $78c3f1cd4c4ec9c4$var$last_scheduled_effect = effect;
        // defer render effects inside a pending boundary
        // TODO the `REACTION_RAN` check is only necessary because of legacy `$:` effects AFAICT — we can remove later
        if (effect.b?.is_pending && (effect.f & ((0, $8zILj.EFFECT) | (0, $8zILj.RENDER_EFFECT) | (0, $8zILj.MANAGED_EFFECT))) !== 0 && (effect.f & (0, $8zILj.REACTION_RAN)) === 0) {
            effect.b.defer_effect(effect);
            return;
        }
        this.#scheduled.push(effect);
    }
    #unlink() {
        // #merge calls #unlink, discard later on does it again - prevent
        // running it multiple times to not corrupt the linked list
        if (!this.linked) return;
        var prev = this.#prev;
        var next = this.#next;
        if (prev === null) $78c3f1cd4c4ec9c4$var$first_batch = next;
        else prev.#next = next;
        if (next === null) $78c3f1cd4c4ec9c4$var$last_batch = prev;
        else next.#prev = prev;
        this.linked = false;
    }
}
function $78c3f1cd4c4ec9c4$export$cd75ccfd720a3cd4(fn) {
    var was_flushing_sync = $78c3f1cd4c4ec9c4$export$90566adb2ab13b3e;
    $78c3f1cd4c4ec9c4$export$90566adb2ab13b3e = true;
    try {
        var result;
        if (fn) {
            if ($78c3f1cd4c4ec9c4$export$8dd36da296c3437e !== null && !$78c3f1cd4c4ec9c4$export$8dd36da296c3437e.is_fork) $78c3f1cd4c4ec9c4$export$8dd36da296c3437e.flush();
            result = fn();
        }
        while(true){
            (0, $c2wsH.flush_tasks)();
            if ($78c3f1cd4c4ec9c4$export$8dd36da296c3437e === null) return /** @type {T} */ result;
            $78c3f1cd4c4ec9c4$export$8dd36da296c3437e.flush();
        }
    } finally{
        $78c3f1cd4c4ec9c4$export$90566adb2ab13b3e = was_flushing_sync;
    }
}
function $78c3f1cd4c4ec9c4$var$infinite_loop_guard() {
    if (0, $7YIuB.default) {
        var updates = new Map();
        for (const source of $78c3f1cd4c4ec9c4$export$8dd36da296c3437e.current.keys())for (const [stack, update] of source.updated ?? []){
            var entry = updates.get(stack);
            if (!entry) {
                entry = {
                    error: update.error,
                    count: 0
                };
                updates.set(stack, entry);
            }
            entry.count += update.count;
        }
        for (const update of updates.values())if (update.error) // eslint-disable-next-line no-console
        console.error(update.error);
    }
    try {
        $gB48l.effect_update_depth_exceeded();
    } catch (error) {
        if (0, $7YIuB.default) // stack contains no useful information, replace it
        (0, $btEsq.define_property)(error, 'stack', {
            value: ''
        });
        // Best effort: invoke the boundary nearest the most recent
        // effect and hope that it's relevant to the infinite loop
        (0, $1u5nX.invoke_error_boundary)(error, $78c3f1cd4c4ec9c4$var$last_scheduled_effect);
    }
}
let $78c3f1cd4c4ec9c4$export$d6deee6e561f6210 = null;
/**
 * @param {Array<Effect>} effects
 * @returns {void}
 */ function $78c3f1cd4c4ec9c4$var$flush_queued_effects(effects) {
    var length = effects.length;
    if (length === 0) return;
    var i = 0;
    while(i < length){
        var effect = effects[i++];
        if ((effect.f & ((0, $8zILj.DESTROYED) | (0, $8zILj.INERT))) === 0 && (0, $egVZE.is_dirty)(effect)) {
            $78c3f1cd4c4ec9c4$export$d6deee6e561f6210 = new Set();
            (0, $egVZE.update_effect)(effect);
            // Effects with no dependencies or teardown do not get added to the effect tree.
            // Deferred effects (e.g. `$effect(...)`) _are_ added to the tree because we
            // don't know if we need to keep them until they are executed. Doing the check
            // here (rather than in `update_effect`) allows us to skip the work for
            // immediate effects.
            if (effect.deps === null && effect.first === null && effect.nodes === null && effect.teardown === null && effect.ac === null) // remove this effect from the graph
            (0, $kCMGX.unlink_effect)(effect);
            // If update_effect() has a flushSync() in it, we may have flushed another flush_queued_effects(),
            // which already handled this logic and did set eager_block_effects to null.
            if ($78c3f1cd4c4ec9c4$export$d6deee6e561f6210?.size > 0) {
                (0, $kmhLl.old_values).clear();
                for (const e of $78c3f1cd4c4ec9c4$export$d6deee6e561f6210){
                    // Skip eager effects that have already been unmounted
                    if ((e.f & ((0, $8zILj.DESTROYED) | (0, $8zILj.INERT))) !== 0) continue;
                    // Run effects in order from ancestor to descendant, else we could run into nullpointers
                    /** @type {Effect[]} */ const ordered_effects = [
                        e
                    ];
                    let ancestor = e.parent;
                    while(ancestor !== null){
                        if ($78c3f1cd4c4ec9c4$export$d6deee6e561f6210.has(ancestor)) {
                            $78c3f1cd4c4ec9c4$export$d6deee6e561f6210.delete(ancestor);
                            ordered_effects.push(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                    for(let j = ordered_effects.length - 1; j >= 0; j--){
                        const e = ordered_effects[j];
                        // Skip eager effects that have already been unmounted
                        if ((e.f & ((0, $8zILj.DESTROYED) | (0, $8zILj.INERT))) !== 0) continue;
                        (0, $egVZE.update_effect)(e);
                    }
                }
                $78c3f1cd4c4ec9c4$export$d6deee6e561f6210.clear();
            }
        }
    }
    $78c3f1cd4c4ec9c4$export$d6deee6e561f6210 = null;
}
/**
 * This is similar to `mark_reactions`, but it only marks async/block effects
 * depending on `value` and at least one of the other `sources`, so that
 * these effects can re-run after another batch has been committed
 * @param {Value} value
 * @param {Source[]} sources
 * @param {Set<Value>} marked
 * @param {Map<Reaction, boolean>} checked
 */ function $78c3f1cd4c4ec9c4$var$mark_effects(value, sources, marked, checked) {
    if (marked.has(value)) return;
    marked.add(value);
    if (value.reactions !== null) for (const reaction of value.reactions){
        const flags = reaction.f;
        if ((flags & (0, $8zILj.DERIVED)) !== 0) $78c3f1cd4c4ec9c4$var$mark_effects(/** @type {Derived} */ reaction, sources, marked, checked);
        else if ((flags & ((0, $8zILj.ASYNC) | (0, $8zILj.BLOCK_EFFECT))) !== 0 && (flags & (0, $8zILj.DIRTY)) === 0 && $78c3f1cd4c4ec9c4$var$depends_on(reaction, sources, checked)) {
            (0, $1RLxH.set_signal_status)(reaction, (0, $8zILj.DIRTY));
            $78c3f1cd4c4ec9c4$export$d3d339c14fbcf78d(/** @type {Effect} */ reaction);
        }
    }
}
/**
 * When committing a fork, we need to trigger eager effects so that
 * any `$state.eager(...)` expressions update immediately. This
 * function allows us to discover them
 * @param {Value} value
 * @param {Set<Effect>} effects
 */ function $78c3f1cd4c4ec9c4$var$mark_eager_effects(value, effects) {
    if (value.reactions === null) return;
    for (const reaction of value.reactions){
        const flags = reaction.f;
        if ((flags & (0, $8zILj.DERIVED)) !== 0) $78c3f1cd4c4ec9c4$var$mark_eager_effects(/** @type {Derived} */ reaction, effects);
        else if ((flags & (0, $8zILj.EAGER_EFFECT)) !== 0) {
            (0, $1RLxH.set_signal_status)(reaction, (0, $8zILj.DIRTY));
            effects.add(/** @type {Effect} */ reaction);
        }
    }
}
/**
 * @param {Reaction} reaction
 * @param {Source[]} sources
 * @param {Map<Reaction, boolean>} checked
 */ function $78c3f1cd4c4ec9c4$var$depends_on(reaction, sources, checked) {
    const depends = checked.get(reaction);
    if (depends !== undefined) return depends;
    if (reaction.deps !== null) for (const dep of reaction.deps){
        if ((0, $btEsq.includes).call(sources, dep)) return true;
        if ((dep.f & (0, $8zILj.DERIVED)) !== 0 && $78c3f1cd4c4ec9c4$var$depends_on(/** @type {Derived} */ dep, sources, checked)) {
            checked.set(/** @type {Derived} */ dep, true);
            return true;
        }
    }
    checked.set(reaction, false);
    return false;
}
function $78c3f1cd4c4ec9c4$export$d3d339c14fbcf78d(effect) {
    /** @type {Batch} */ $78c3f1cd4c4ec9c4$export$8dd36da296c3437e.schedule(effect);
}
/** @type {Source<number>[]} */ let $78c3f1cd4c4ec9c4$var$eager_versions = [];
function $78c3f1cd4c4ec9c4$var$eager_flush() {
    $78c3f1cd4c4ec9c4$export$cd75ccfd720a3cd4(()=>{
        const eager = $78c3f1cd4c4ec9c4$var$eager_versions;
        $78c3f1cd4c4ec9c4$var$eager_versions = [];
        for (const version of eager)(0, $kmhLl.update)(version);
    });
}
/** @type {Map<Reaction, Source<number>>} */ var $78c3f1cd4c4ec9c4$var$version_map = new Map();
function $78c3f1cd4c4ec9c4$export$2f05d171a6c178a4(fn) {
    var initial = true;
    var value = /** @type {T} */ undefined;
    if ((0, $egVZE.active_reaction) === null) return fn();
    let parent = (0, $egVZE.active_reaction);
    let version = $78c3f1cd4c4ec9c4$var$version_map.get(parent) ?? (0, $kmhLl.source)(0);
    $78c3f1cd4c4ec9c4$var$version_map.set(parent, version);
    (0, $kCMGX.teardown)(()=>{
        if (parent.f & (0, $8zILj.DESTROYING)) $78c3f1cd4c4ec9c4$var$version_map.delete(parent);
    });
    (0, $egVZE.get)(version);
    (0, $kCMGX.eager_effect)(()=>{
        if (initial) {
            // the first time this runs, we create an eager effect
            // that will run eagerly whenever the expression changes
            var previous_batch_values = $78c3f1cd4c4ec9c4$export$70a171f1ec84867d;
            try {
                $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = null;
                value = fn();
            } finally{
                $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = previous_batch_values;
            }
            return;
        }
        // the second time this effect runs, it's to schedule a
        // `version` update. since this will recreate the effect,
        // we don't need to evaluate the expression here
        if ($78c3f1cd4c4ec9c4$var$eager_versions.length === 0) (0, $c2wsH.queue_micro_task)($78c3f1cd4c4ec9c4$var$eager_flush);
        $78c3f1cd4c4ec9c4$var$eager_versions.push(version);
    });
    initial = false;
    return value;
}
/**
 * Mark all the effects inside a skipped branch CLEAN, so that
 * they can be correctly rescheduled later. Tracks dirty and maybe_dirty
 * effects so they can be rescheduled if the branch survives.
 * @param {Effect} effect
 * @param {{ d: Effect[], m: Effect[] }} tracked
 */ function $78c3f1cd4c4ec9c4$var$reset_branch(effect, tracked) {
    // clean branch = nothing dirty inside, no need to traverse further
    if ((effect.f & (0, $8zILj.BRANCH_EFFECT)) !== 0 && (effect.f & (0, $8zILj.CLEAN)) !== 0) return;
    if ((effect.f & (0, $8zILj.DIRTY)) !== 0) tracked.d.push(effect);
    else if ((effect.f & (0, $8zILj.MAYBE_DIRTY)) !== 0) tracked.m.push(effect);
    (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.CLEAN));
    var e = effect.first;
    while(e !== null){
        $78c3f1cd4c4ec9c4$var$reset_branch(e, tracked);
        e = e.next;
    }
}
/**
 * Mark an entire effect tree clean following an error
 * @param {Effect} effect
 */ function $78c3f1cd4c4ec9c4$var$reset_all(effect) {
    (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.CLEAN));
    var e = effect.first;
    while(e !== null){
        $78c3f1cd4c4ec9c4$var$reset_all(e);
        e = e.next;
    }
}
function $78c3f1cd4c4ec9c4$export$7a5058c6b79333e0(fn) {
    if (!(0, $yJWNn.async_mode_flag)) $3gXWT.experimental_async_required('fork');
    if ($78c3f1cd4c4ec9c4$export$8dd36da296c3437e !== null) $gB48l.fork_timing();
    var batch = $78c3f1cd4c4ec9c4$export$33b107562567fc47.ensure();
    batch.is_fork = true;
    $78c3f1cd4c4ec9c4$export$70a171f1ec84867d = new Map();
    var committed = false;
    var settled = batch.settled();
    $78c3f1cd4c4ec9c4$export$cd75ccfd720a3cd4(fn);
    return {
        commit: async ()=>{
            if (committed) {
                await settled;
                return;
            }
            if (!batch.linked) $gB48l.fork_discarded();
            committed = true;
            batch.is_fork = false;
            // apply changes and update write versions so deriveds see the change
            for (var [source, [value]] of batch.current){
                source.v = value;
                source.wv = (0, $egVZE.increment_write_version)();
            }
            // trigger any `$state.eager(...)` expressions with the new state.
            // eager effects don't get scheduled like other effects, so we
            // can't just encounter them during traversal, we need to
            // proactively flush them
            // TODO maybe there's a better implementation?
            $78c3f1cd4c4ec9c4$export$cd75ccfd720a3cd4(()=>{
                /** @type {Set<Effect>} */ var eager_effects = new Set();
                for (var source of batch.current.keys())$78c3f1cd4c4ec9c4$var$mark_eager_effects(source, eager_effects);
                (0, $kmhLl.set_eager_effects)(eager_effects);
                (0, $kmhLl.flush_eager_effects)();
            });
            batch.flush();
            await settled;
        },
        discard: ()=>{
            // cause any MAYBE_DIRTY deriveds to update
            // if they depend on things thath changed
            // inside the discarded fork
            for (var source of batch.current.keys())source.wv = (0, $egVZE.increment_write_version)();
            if (!committed && batch.linked) batch.discard();
        }
    };
}
function $78c3f1cd4c4ec9c4$export$42ffd38884aecdac() {
    $78c3f1cd4c4ec9c4$var$first_batch = $78c3f1cd4c4ec9c4$var$last_batch = null;
}

});
parcelRegister("c2wsH", function(module, exports) {

$parcel$export(module.exports, "queue_micro_task", () => $8c3eda3268c5286a$export$87c5cc9ba98a83a1);
$parcel$export(module.exports, "flush_tasks", () => $8c3eda3268c5286a$export$583a98b4ec13c68b);

var $btEsq = parcelRequire("btEsq");

var $amPy2 = parcelRequire("amPy2");
/** @type {Array<() => void>} */ let $8c3eda3268c5286a$var$micro_tasks = [];
function $8c3eda3268c5286a$var$run_micro_tasks() {
    var tasks = $8c3eda3268c5286a$var$micro_tasks;
    $8c3eda3268c5286a$var$micro_tasks = [];
    (0, $btEsq.run_all)(tasks);
}
function $8c3eda3268c5286a$export$87c5cc9ba98a83a1(fn) {
    if ($8c3eda3268c5286a$var$micro_tasks.length === 0 && !(0, $amPy2.is_flushing_sync)) {
        var tasks = $8c3eda3268c5286a$var$micro_tasks;
        queueMicrotask(()=>{
            // If this is false, a flushSync happened in the meantime. Do _not_ run new scheduled microtasks in that case
            // as the ordering of microtasks would be broken at that point - consider this case:
            // - queue_micro_task schedules microtask A to flush task X
            // - synchronously after, flushSync runs, processing task X
            // - synchronously after, some other microtask B is scheduled, but not through queue_micro_task but for example a Promise.resolve() in user code
            // - synchronously after, queue_micro_task schedules microtask C to flush task Y
            // - one tick later, microtask A now resolves, flushing task Y before microtask B, which is incorrect
            // This if check prevents that race condition (that realistically will only happen in tests)
            if (tasks === $8c3eda3268c5286a$var$micro_tasks) $8c3eda3268c5286a$var$run_micro_tasks();
        });
    }
    $8c3eda3268c5286a$var$micro_tasks.push(fn);
}
function $8c3eda3268c5286a$export$583a98b4ec13c68b() {
    while($8c3eda3268c5286a$var$micro_tasks.length > 0)$8c3eda3268c5286a$var$run_micro_tasks();
}

});

parcelRegister("1u5nX", function(module, exports) {

$parcel$export(module.exports, "handle_error", () => $114cc53b5598f6cc$export$6b78da7a8f65bcbb);
$parcel$export(module.exports, "invoke_error_boundary", () => $114cc53b5598f6cc$export$37c9c3c7b08549f5);
/** @import { Derived, Effect } from '#client' */ /** @import { Boundary } from './dom/blocks/boundary.js' */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $56eus = parcelRequire("56eus");

var $cGH1Z = parcelRequire("cGH1Z");

var $8zILj = parcelRequire("8zILj");

var $btEsq = parcelRequire("btEsq");

var $egVZE = parcelRequire("egVZE");
const $114cc53b5598f6cc$var$adjustments = new WeakMap();
function $114cc53b5598f6cc$export$6b78da7a8f65bcbb(error) {
    var effect = (0, $egVZE.active_effect);
    // for unowned deriveds, don't throw until we read the value
    if (effect === null) {
        /** @type {Derived} */ (0, $egVZE.active_reaction).f |= (0, $8zILj.ERROR_VALUE);
        return error;
    }
    if ((0, $7YIuB.default) && error instanceof Error && !$114cc53b5598f6cc$var$adjustments.has(error)) $114cc53b5598f6cc$var$adjustments.set(error, $114cc53b5598f6cc$var$get_adjustments(error, effect));
    // if the error occurred while creating this subtree, we let it
    // bubble up until it hits a boundary that can handle it, unless
    // it's an $effect in which case it doesn't run immediately
    if ((effect.f & (0, $8zILj.REACTION_RAN)) === 0 && (effect.f & (0, $8zILj.EFFECT)) === 0) {
        if ((0, $7YIuB.default) && !effect.parent && error instanceof Error) $114cc53b5598f6cc$var$apply_adjustments(error);
        throw error;
    }
    // otherwise we bubble up the effect tree ourselves
    $114cc53b5598f6cc$export$37c9c3c7b08549f5(error, effect);
}
function $114cc53b5598f6cc$export$37c9c3c7b08549f5(error, effect) {
    if (effect !== null && (effect.f & (0, $8zILj.DESTROYED)) !== 0) return;
    while(effect !== null){
        // Skip boundaries that are destroyed/destroying and cannot meaningfully handle the error.
        if ((effect.f & (0, $8zILj.BOUNDARY_EFFECT)) !== 0 && (effect.f & ((0, $8zILj.DESTROYED) | (0, $8zILj.DESTROYING))) === 0) {
            if ((effect.f & (0, $8zILj.REACTION_RAN)) === 0) // we are still creating the boundary effect
            throw error;
            try {
                /** @type {Boundary} */ effect.b.error(error);
                return;
            } catch (e) {
                error = e;
            }
        }
        effect = effect.parent;
    }
    if ((0, $7YIuB.default) && error instanceof Error) $114cc53b5598f6cc$var$apply_adjustments(error);
    throw error;
}
/**
 * Add useful information to the error message/stack in development
 * @param {Error} error
 * @param {Effect} effect
 */ function $114cc53b5598f6cc$var$get_adjustments(error, effect) {
    const message_descriptor = (0, $btEsq.get_descriptor)(error, 'message');
    // if the message was already changed and it's not configurable we can't change it
    // or it will throw a different error swallowing the original error
    if (message_descriptor && !message_descriptor.configurable) return;
    var indent = (0, $cGH1Z.is_firefox) ? '  ' : '\t';
    var component_stack = `\n${indent}in ${effect.fn?.name || '<unknown>'}`;
    var context = effect.ctx;
    while(context !== null){
        component_stack += `\n${indent}in ${context.function?.[0, $56eus.FILENAME].split('/').pop()}`;
        context = context.p;
    }
    return {
        message: error.message + `\n${component_stack}\n`,
        stack: error.stack?.split('\n').filter((line)=>!line.includes('svelte/src/internal')).join('\n')
    };
}
/**
 * @param {Error} error
 */ function $114cc53b5598f6cc$var$apply_adjustments(error) {
    const adjusted = $114cc53b5598f6cc$var$adjustments.get(error);
    if (adjusted) {
        (0, $btEsq.define_property)(error, 'message', {
            value: adjusted.message
        });
        (0, $btEsq.define_property)(error, 'stack', {
            value: adjusted.stack
        });
    }
}

});
parcelRegister("cGH1Z", function(module, exports) {

$parcel$export(module.exports, "is_firefox", () => $93cac95618ab2896$export$3f6a852dbb1306f2);
$parcel$export(module.exports, "get_first_child", () => $93cac95618ab2896$export$410939cfcdc7e426);
$parcel$export(module.exports, "get_next_sibling", () => $93cac95618ab2896$export$3fc453b205590d04);
$parcel$export(module.exports, "clear_text_content", () => $93cac95618ab2896$export$4618ff5f75170f1a);
/** @import { Effect, TemplateNode } from '#client' */ 
var $48zFZ = parcelRequire("48zFZ");
parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $ZER7t = parcelRequire("ZER7t");

var $btEsq = parcelRequire("btEsq");

var $egVZE = parcelRequire("egVZE");

var $yJWNn = parcelRequire("yJWNn");

var $8zILj = parcelRequire("8zILj");

var $amPy2 = parcelRequire("amPy2");

var $56eus = parcelRequire("56eus");
var $93cac95618ab2896$export$f3fe7f07061a5af8;
var $93cac95618ab2896$export$81dbbbf987bfbc02;
var $93cac95618ab2896$export$3f6a852dbb1306f2;
/** @type {() => Node | null} */ var $93cac95618ab2896$var$first_child_getter;
/** @type {() => Node | null} */ var $93cac95618ab2896$var$next_sibling_getter;
function $93cac95618ab2896$export$cf68e7bf66a9c23b() {
    if ($93cac95618ab2896$export$f3fe7f07061a5af8 !== undefined) return;
    $93cac95618ab2896$export$f3fe7f07061a5af8 = window;
    $93cac95618ab2896$export$81dbbbf987bfbc02 = document;
    $93cac95618ab2896$export$3f6a852dbb1306f2 = /Firefox/.test(navigator.userAgent);
    var element_prototype = Element.prototype;
    var node_prototype = Node.prototype;
    var text_prototype = Text.prototype;
    // @ts-ignore
    $93cac95618ab2896$var$first_child_getter = (0, $btEsq.get_descriptor)(node_prototype, 'firstChild').get;
    // @ts-ignore
    $93cac95618ab2896$var$next_sibling_getter = (0, $btEsq.get_descriptor)(node_prototype, 'nextSibling').get;
    if ((0, $btEsq.is_extensible)(element_prototype)) {
        // the following assignments improve perf of lookups on DOM nodes
        /** @type {any} */ element_prototype[0, $8zILj.CLASS_CACHE] = undefined;
        /** @type {any} */ element_prototype[0, $8zILj.ATTRIBUTES_CACHE] = null;
        /** @type {any} */ element_prototype[0, $8zILj.STYLE_CACHE] = undefined;
        // @ts-expect-error
        element_prototype.__e = undefined;
    }
    if ((0, $btEsq.is_extensible)(text_prototype)) /** @type {any} */ text_prototype[0, $8zILj.TEXT_CACHE] = undefined;
    if (0, $7YIuB.default) {
        // @ts-expect-error
        element_prototype.__svelte_meta = null;
        (0, $ZER7t.init_array_prototype_warnings)();
    }
}
function $93cac95618ab2896$export$d8264455fff964d2(value = '') {
    return document.createTextNode(value);
}
function $93cac95618ab2896$export$410939cfcdc7e426(node) {
    return /** @type {TemplateNode | null} */ $93cac95618ab2896$var$first_child_getter.call(node);
}
function $93cac95618ab2896$export$3fc453b205590d04(node) {
    return /** @type {TemplateNode | null} */ $93cac95618ab2896$var$next_sibling_getter.call(node);
}
function $93cac95618ab2896$export$f9574b70e1d95d9d(node, is_text) {
    if (!(0, $48zFZ.hydrating)) return $93cac95618ab2896$export$410939cfcdc7e426(node);
    var child = $93cac95618ab2896$export$410939cfcdc7e426((0, $48zFZ.hydrate_node));
    // Child can be null if we have an element with a single child, like `<p>{text}</p>`, where `text` is empty
    if (child === null) child = (0, $48zFZ.hydrate_node).appendChild($93cac95618ab2896$export$d8264455fff964d2());
    else if (is_text && child.nodeType !== (0, $8zILj.TEXT_NODE)) {
        var text = $93cac95618ab2896$export$d8264455fff964d2();
        child?.before(text);
        (0, $48zFZ.set_hydrate_node)(text);
        return text;
    }
    if (is_text) $93cac95618ab2896$export$b8a63c85fb5e9173(/** @type {Text} */ child);
    (0, $48zFZ.set_hydrate_node)(child);
    return child;
}
function $93cac95618ab2896$export$eb14db6f23c66741(node, is_text = false) {
    if (!(0, $48zFZ.hydrating)) {
        var first = $93cac95618ab2896$export$410939cfcdc7e426(node);
        // TODO prevent user comments with the empty string when preserveComments is true
        if (first instanceof Comment && first.data === '') return $93cac95618ab2896$export$3fc453b205590d04(first);
        return first;
    }
    if (is_text) {
        // if an {expression} is empty during SSR, there might be no
        // text node to hydrate — we must therefore create one
        if ((0, $48zFZ.hydrate_node)?.nodeType !== (0, $8zILj.TEXT_NODE)) {
            var text = $93cac95618ab2896$export$d8264455fff964d2();
            (0, $48zFZ.hydrate_node)?.before(text);
            (0, $48zFZ.set_hydrate_node)(text);
            return text;
        }
        $93cac95618ab2896$export$b8a63c85fb5e9173(/** @type {Text} */ (0, $48zFZ.hydrate_node));
    }
    return 0, $48zFZ.hydrate_node;
}
function $93cac95618ab2896$export$19f71570fc53fba9(node, is_text = false) {
    if (!(0, $48zFZ.hydrating)) return $93cac95618ab2896$export$410939cfcdc7e426(node);
    var first = $93cac95618ab2896$export$f9574b70e1d95d9d(node, is_text);
    (0, $48zFZ.reset)(node);
    return first;
}
function $93cac95618ab2896$export$122008dee415a085(node, count = 1, is_text = false) {
    let next_sibling = (0, $48zFZ.hydrating) ? (0, $48zFZ.hydrate_node) : node;
    var last_sibling;
    while(count--){
        last_sibling = next_sibling;
        next_sibling = /** @type {TemplateNode} */ $93cac95618ab2896$export$3fc453b205590d04(next_sibling);
    }
    if (!(0, $48zFZ.hydrating)) return next_sibling;
    if (is_text) {
        // if a sibling {expression} is empty during SSR, there might be no
        // text node to hydrate — we must therefore create one
        if (next_sibling?.nodeType !== (0, $8zILj.TEXT_NODE)) {
            var text = $93cac95618ab2896$export$d8264455fff964d2();
            // If the next sibling is `null` and we're handling text then it's because
            // the SSR content was empty for the text, so we need to generate a new text
            // node and insert it after the last sibling
            if (next_sibling === null) last_sibling?.after(text);
            else next_sibling.before(text);
            (0, $48zFZ.set_hydrate_node)(text);
            return text;
        }
        $93cac95618ab2896$export$b8a63c85fb5e9173(/** @type {Text} */ next_sibling);
    }
    (0, $48zFZ.set_hydrate_node)(next_sibling);
    return next_sibling;
}
function $93cac95618ab2896$export$4618ff5f75170f1a(node) {
    node.textContent = '';
}
function $93cac95618ab2896$export$1afc9fc613318634() {
    if (!(0, $yJWNn.async_mode_flag)) return false;
    if ((0, $amPy2.eager_block_effects) !== null) return false;
    var flags = /** @type {Effect} */ (0, $egVZE.active_effect).f;
    return (flags & (0, $8zILj.REACTION_RAN)) !== 0;
}
function $93cac95618ab2896$export$bbccd1580afdb49a(tag, namespace, is) {
    if (namespace == null || namespace === (0, $56eus.NAMESPACE_HTML)) return /** @type {T extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[T] : Element} */ is ? document.createElement(tag, {
        is: is
    }) : document.createElement(tag);
    return /** @type {T extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[T] : Element} */ is ? document.createElementNS(namespace, tag, {
        is: is
    }) : document.createElementNS(namespace, tag);
}
function $93cac95618ab2896$export$305d6e989cbd4da9() {
    return document.createDocumentFragment();
}
function $93cac95618ab2896$export$55d64ef8c5a8cb8b(data = '') {
    return document.createComment(data);
}
function $93cac95618ab2896$export$70e4f835e056a16c(element, key, value = '') {
    if (key.startsWith('xlink:')) {
        element.setAttributeNS('http://www.w3.org/1999/xlink', key, value);
        return;
    }
    return element.setAttribute(key, value);
}
function $93cac95618ab2896$export$b8a63c85fb5e9173(text) {
    if (/** @type {string} */ text.nodeValue.length < 65536) return;
    let next = text.nextSibling;
    while(next !== null && next.nodeType === (0, $8zILj.TEXT_NODE)){
        next.remove();
        /** @type {string} */ text.nodeValue += /** @type {string} */ next.nodeValue;
        next = text.nextSibling;
    }
}

});
parcelRegister("48zFZ", function(module, exports) {

$parcel$export(module.exports, "hydrating", () => $3033955d003e9c62$export$c8ccca63a0bc77d1);
$parcel$export(module.exports, "hydrate_node", () => $3033955d003e9c62$export$3f8543ef023c5ebe);
$parcel$export(module.exports, "set_hydrate_node", () => $3033955d003e9c62$export$6ab5f68d238f3354);
$parcel$export(module.exports, "reset", () => $3033955d003e9c62$export$aad8462122ac592b);
/** @import { TemplateNode } from '#client' */ 
var $8zILj = parcelRequire("8zILj");

var $56eus = parcelRequire("56eus");

var $9iF6l = parcelRequire("9iF6l");

var $cGH1Z = parcelRequire("cGH1Z");
let $3033955d003e9c62$export$c8ccca63a0bc77d1 = false;
function $3033955d003e9c62$export$dbf01c0576a83e5b(value) {
    $3033955d003e9c62$export$c8ccca63a0bc77d1 = value;
}
let $3033955d003e9c62$export$3f8543ef023c5ebe;
function $3033955d003e9c62$export$6ab5f68d238f3354(node) {
    if (node === null) {
        $9iF6l.hydration_mismatch();
        throw 0, $56eus.HYDRATION_ERROR;
    }
    return $3033955d003e9c62$export$3f8543ef023c5ebe = node;
}
function $3033955d003e9c62$export$11126b8ea74b5268() {
    return $3033955d003e9c62$export$6ab5f68d238f3354((0, $cGH1Z.get_next_sibling)($3033955d003e9c62$export$3f8543ef023c5ebe));
}
function $3033955d003e9c62$export$aad8462122ac592b(node) {
    if (!$3033955d003e9c62$export$c8ccca63a0bc77d1) return;
    // If the node has remaining siblings, something has gone wrong
    if ((0, $cGH1Z.get_next_sibling)($3033955d003e9c62$export$3f8543ef023c5ebe) !== null) {
        $9iF6l.hydration_mismatch();
        throw 0, $56eus.HYDRATION_ERROR;
    }
    $3033955d003e9c62$export$3f8543ef023c5ebe = node;
}
function $3033955d003e9c62$export$826ca54b567dc6f1(template) {
    if ($3033955d003e9c62$export$c8ccca63a0bc77d1) // @ts-expect-error TemplateNode doesn't include DocumentFragment, but it's actually fine
    $3033955d003e9c62$export$3f8543ef023c5ebe = template.content;
}
function $3033955d003e9c62$export$48cfd1e771a65c4f(count = 1) {
    if ($3033955d003e9c62$export$c8ccca63a0bc77d1) {
        var i = count;
        var node = $3033955d003e9c62$export$3f8543ef023c5ebe;
        while(i--)node = /** @type {TemplateNode} */ (0, $cGH1Z.get_next_sibling)(node);
        $3033955d003e9c62$export$3f8543ef023c5ebe = node;
    }
}
function $3033955d003e9c62$export$bc6aabeb31040dc9(remove = true) {
    var depth = 0;
    var node = $3033955d003e9c62$export$3f8543ef023c5ebe;
    while(true){
        if (node.nodeType === (0, $8zILj.COMMENT_NODE)) {
            var data = /** @type {Comment} */ node.data;
            if (data === (0, $56eus.HYDRATION_END)) {
                if (depth === 0) return node;
                depth -= 1;
            } else if (data === (0, $56eus.HYDRATION_START) || data === (0, $56eus.HYDRATION_START_ELSE) || // "[1", "[2", etc. for if blocks
            data[0] === '[' && !isNaN(Number(data.slice(1)))) depth += 1;
        }
        var next = /** @type {TemplateNode} */ (0, $cGH1Z.get_next_sibling)(node);
        if (remove) node.remove();
        node = next;
    }
}
function $3033955d003e9c62$export$494ac8eaa2b5ff2e(node) {
    if (!node || node.nodeType !== (0, $8zILj.COMMENT_NODE)) {
        $9iF6l.hydration_mismatch();
        throw 0, $56eus.HYDRATION_ERROR;
    }
    return /** @type {Comment} */ node.data;
}

});
parcelRegister("9iF6l", function(module, exports) {

$parcel$export(module.exports, "await_reactivity_loss", () => $6c55ad5718b3f2c4$export$3a124f5a50682b3d);
$parcel$export(module.exports, "await_waterfall", () => $6c55ad5718b3f2c4$export$94a61ca10f354d1c);
$parcel$export(module.exports, "derived_inert", () => $6c55ad5718b3f2c4$export$6feb6e65e6b41f8f);
$parcel$export(module.exports, "hydration_mismatch", () => $6c55ad5718b3f2c4$export$591f269e86a53ddb);
$parcel$export(module.exports, "state_proxy_equality_mismatch", () => $6c55ad5718b3f2c4$export$93ef6385eae3678);
/* This file is generated by scripts/process-messages/index.js. Do not edit! */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");
var $6c55ad5718b3f2c4$var$bold = 'font-weight: bold';
var $6c55ad5718b3f2c4$var$normal = 'font-weight: normal';
function $6c55ad5718b3f2c4$export$c3d4d1d100514625(property, location) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] assignment_value_stale\n%cAssignment to \`${property}\` property (${location}) will evaluate to the right-hand side, not the value of \`${property}\` following the assignment. This may result in unexpected behaviour.\nhttps://svelte.dev/e/assignment_value_stale`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/assignment_value_stale`);
}
function $6c55ad5718b3f2c4$export$3a124f5a50682b3d(name) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] await_reactivity_loss\n%cDetected reactivity loss when reading \`${name}\`. This happens when state is read in an async function after an earlier \`await\`\nhttps://svelte.dev/e/await_reactivity_loss`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/await_reactivity_loss`);
}
function $6c55ad5718b3f2c4$export$94a61ca10f354d1c(name, location) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] await_waterfall\n%cAn async derived, \`${name}\` (${location}) was not read immediately after it resolved. This often indicates an unnecessary waterfall, which can slow down your app\nhttps://svelte.dev/e/await_waterfall`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/await_waterfall`);
}
function $6c55ad5718b3f2c4$export$a51e7e2e09506b16(binding, location) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] binding_property_non_reactive\n%c${location ? `\`${binding}\` (${location}) is binding to a non-reactive property` : `\`${binding}\` is binding to a non-reactive property`}\nhttps://svelte.dev/e/binding_property_non_reactive`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/binding_property_non_reactive`);
}
function $6c55ad5718b3f2c4$export$24c208776fb2c0bb(method) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] console_log_state\n%cYour \`console.${method}\` contained \`$state\` proxies. Consider using \`$inspect(...)\` or \`$state.snapshot(...)\` instead\nhttps://svelte.dev/e/console_log_state`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/console_log_state`);
}
function $6c55ad5718b3f2c4$export$6feb6e65e6b41f8f() {
    if (0, $7YIuB.default) console.warn(`%c[svelte] derived_inert\n%cReading a derived belonging to a now-destroyed effect may result in stale values\nhttps://svelte.dev/e/derived_inert`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/derived_inert`);
}
function $6c55ad5718b3f2c4$export$50ff4d8bb9f2650b(handler, suggestion) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] event_handler_invalid\n%c${handler} should be a function. Did you mean to ${suggestion}?\nhttps://svelte.dev/e/event_handler_invalid`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/event_handler_invalid`);
}
function $6c55ad5718b3f2c4$export$9c54add883794b14(key) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] hydratable_missing_but_expected\n%cExpected to find a hydratable with key \`${key}\` during hydration, but did not.\nhttps://svelte.dev/e/hydratable_missing_but_expected`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/hydratable_missing_but_expected`);
}
function $6c55ad5718b3f2c4$export$211598e123a539b7(attribute, html, value) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] hydration_attribute_changed\n%cThe \`${attribute}\` attribute on \`${html}\` changed its value between server and client renders. The client value, \`${value}\`, will be ignored in favour of the server value\nhttps://svelte.dev/e/hydration_attribute_changed`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/hydration_attribute_changed`);
}
function $6c55ad5718b3f2c4$export$803477e391f7b9b2(location) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] hydration_html_changed\n%c${location ? `The value of an \`{@html ...}\` block ${location} changed between server and client renders. The client value will be ignored in favour of the server value` : 'The value of an `{@html ...}` block changed between server and client renders. The client value will be ignored in favour of the server value'}\nhttps://svelte.dev/e/hydration_html_changed`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/hydration_html_changed`);
}
function $6c55ad5718b3f2c4$export$591f269e86a53ddb(location) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] hydration_mismatch\n%c${location ? `Hydration failed because the initial UI does not match what was rendered on the server. The error occurred near ${location}` : 'Hydration failed because the initial UI does not match what was rendered on the server'}\nhttps://svelte.dev/e/hydration_mismatch`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/hydration_mismatch`);
}
function $6c55ad5718b3f2c4$export$84943fdfa578fe3c() {
    if (0, $7YIuB.default) console.warn(`%c[svelte] invalid_raw_snippet_render\n%cThe \`render\` function passed to \`createRawSnippet\` should return HTML for a single element\nhttps://svelte.dev/e/invalid_raw_snippet_render`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/invalid_raw_snippet_render`);
}
function $6c55ad5718b3f2c4$export$aacd0d6c76acef23(filename) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] legacy_recursive_reactive_block\n%cDetected a migrated \`$:\` reactive block in \`${filename}\` that both accesses and updates the same reactive value. This may cause recursive updates when converted to an \`$effect\`.\nhttps://svelte.dev/e/legacy_recursive_reactive_block`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/legacy_recursive_reactive_block`);
}
function $6c55ad5718b3f2c4$export$ba7cb563f76e98aa() {
    if (0, $7YIuB.default) console.warn(`%c[svelte] lifecycle_double_unmount\n%cTried to unmount a component that was not mounted\nhttps://svelte.dev/e/lifecycle_double_unmount`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/lifecycle_double_unmount`);
}
function $6c55ad5718b3f2c4$export$ca9117a5b4317159(parent, prop, child, owner) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] ownership_invalid_binding\n%c${parent} passed property \`${prop}\` to ${child} with \`bind:\`, but its parent component ${owner} did not declare \`${prop}\` as a binding. Consider creating a binding between ${owner} and ${parent} (e.g. \`bind:${prop}={...}\` instead of \`${prop}={...}\`)\nhttps://svelte.dev/e/ownership_invalid_binding`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/ownership_invalid_binding`);
}
function $6c55ad5718b3f2c4$export$17950919dabb572e(name, location, prop, parent) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] ownership_invalid_mutation\n%cMutating unbound props (\`${name}\`, at ${location}) is strongly discouraged. Consider using \`bind:${prop}={...}\` in ${parent} (or using a callback) instead\nhttps://svelte.dev/e/ownership_invalid_mutation`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/ownership_invalid_mutation`);
}
function $6c55ad5718b3f2c4$export$6cb2dc8a9ae4e83f() {
    if (0, $7YIuB.default) console.warn(`%c[svelte] select_multiple_invalid_value\n%cThe \`value\` property of a \`<select multiple>\` element should be an array, but it received a non-array value. The selection will be kept as is.\nhttps://svelte.dev/e/select_multiple_invalid_value`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/select_multiple_invalid_value`);
}
function $6c55ad5718b3f2c4$export$93ef6385eae3678(operator) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] state_proxy_equality_mismatch\n%cReactive \`$state(...)\` proxies and the values they proxy have different identities. Because of this, comparisons with \`${operator}\` will produce unexpected results\nhttps://svelte.dev/e/state_proxy_equality_mismatch`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/state_proxy_equality_mismatch`);
}
function $6c55ad5718b3f2c4$export$39f3a8b4fbffc26b() {
    if (0, $7YIuB.default) console.warn(`%c[svelte] svelte_boundary_reset_noop\n%cA \`<svelte:boundary>\` \`reset\` function only resets the boundary the first time it is called\nhttps://svelte.dev/e/svelte_boundary_reset_noop`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/svelte_boundary_reset_noop`);
}
function $6c55ad5718b3f2c4$export$1e20b65cfaa7cddb(value) {
    if (0, $7YIuB.default) console.warn(`%c[svelte] transition_slide_display\n%cThe \`slide\` transition does not work correctly for elements with \`display: ${value}\`\nhttps://svelte.dev/e/transition_slide_display`, $6c55ad5718b3f2c4$var$bold, $6c55ad5718b3f2c4$var$normal);
    else console.warn(`https://svelte.dev/e/transition_slide_display`);
}

});


parcelRegister("ZER7t", function(module, exports) {

$parcel$export(module.exports, "init_array_prototype_warnings", () => $0b9563b96b0d936f$export$fb5730c6f6fd53cc);

var $9iF6l = parcelRequire("9iF6l");

var $3o015 = parcelRequire("3o015");
function $0b9563b96b0d936f$export$fb5730c6f6fd53cc() {
    const array_prototype = Array.prototype;
    // The REPL ends up here over and over, and this prevents it from adding more and more patches
    // of the same kind to the prototype, which would slow down everything over time.
    // @ts-expect-error
    const cleanup = Array.__svelte_cleanup;
    if (cleanup) cleanup();
    const { indexOf: indexOf, lastIndexOf: lastIndexOf, includes: includes } = array_prototype;
    array_prototype.indexOf = function(item, from_index) {
        const index = indexOf.call(this, item, from_index);
        if (index === -1) {
            for(let i = from_index ?? 0; i < this.length; i += 1)if ((0, $3o015.get_proxied_value)(this[i]) === item) {
                $9iF6l.state_proxy_equality_mismatch('array.indexOf(...)');
                break;
            }
        }
        return index;
    };
    array_prototype.lastIndexOf = function(item, from_index) {
        // we need to specify this.length - 1 because it's probably using something like
        // `arguments` inside so passing undefined is different from not passing anything
        const index = lastIndexOf.call(this, item, from_index ?? this.length - 1);
        if (index === -1) {
            for(let i = 0; i <= (from_index ?? this.length - 1); i += 1)if ((0, $3o015.get_proxied_value)(this[i]) === item) {
                $9iF6l.state_proxy_equality_mismatch('array.lastIndexOf(...)');
                break;
            }
        }
        return index;
    };
    array_prototype.includes = function(item, from_index) {
        const has = includes.call(this, item, from_index);
        if (!has) {
            for(let i = 0; i < this.length; i += 1)if ((0, $3o015.get_proxied_value)(this[i]) === item) {
                $9iF6l.state_proxy_equality_mismatch('array.includes(...)');
                break;
            }
        }
        return has;
    };
    // @ts-expect-error
    Array.__svelte_cleanup = ()=>{
        array_prototype.indexOf = indexOf;
        array_prototype.lastIndexOf = lastIndexOf;
        array_prototype.includes = includes;
    };
}
function $0b9563b96b0d936f$export$ebea6bfa70727d28(a, b, equal = true) {
    // try-catch needed because this tries to read properties of `a` and `b`,
    // which could be disallowed for example in a secure context
    try {
        if (a === b !== ((0, $3o015.get_proxied_value)(a) === (0, $3o015.get_proxied_value)(b))) $9iF6l.state_proxy_equality_mismatch(equal ? '===' : '!==');
    } catch  {}
    return a === b === equal;
}
function $0b9563b96b0d936f$export$e9bab7fafb253603(a, b, equal = true) {
    if (a == b !== ((0, $3o015.get_proxied_value)(a) == (0, $3o015.get_proxied_value)(b))) $9iF6l.state_proxy_equality_mismatch(equal ? '==' : '!=');
    return a == b === equal;
}

});
parcelRegister("3o015", function(module, exports) {

$parcel$export(module.exports, "proxy", () => $2773a044dfd75461$export$923f96dd5afa9ce6);
$parcel$export(module.exports, "get_proxied_value", () => $2773a044dfd75461$export$e7a76095f1bf2f14);
/** @import { Source } from '#client' */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $egVZE = parcelRequire("egVZE");

var $btEsq = parcelRequire("btEsq");

var $kmhLl = parcelRequire("kmhLl");

var $8zILj = parcelRequire("8zILj");

var $56eus = parcelRequire("56eus");

var $gB48l = parcelRequire("gB48l");

var $4Y2WV = parcelRequire("4Y2WV");

var $9AQvv = parcelRequire("9AQvv");

var $yJWNn = parcelRequire("yJWNn");
// TODO move all regexes into shared module?
const $2773a044dfd75461$var$regex_is_valid_identifier = /^[a-zA-Z_$][a-zA-Z_$0-9]*$/;
function $2773a044dfd75461$export$923f96dd5afa9ce6(value) {
    // if non-proxyable, a component instance, or already a proxy, return `value`
    if (typeof value !== 'object' || value === null || (0, $8zILj.STATE_SYMBOL) in value || (0, $8zILj.COMPONENT_SYMBOL) in value) return value;
    const prototype = (0, $btEsq.get_prototype_of)(value);
    if (prototype !== (0, $btEsq.object_prototype) && prototype !== (0, $btEsq.array_prototype)) return value;
    /** @type {Map<any, Source<any>>} */ var sources = new Map();
    var is_proxied_array = (0, $btEsq.is_array)(value);
    var version = (0, $kmhLl.state)(0);
    var stack = (0, $7YIuB.default) && (0, $yJWNn.tracing_mode_flag) ? (0, $9AQvv.get_error)('created at') : null;
    var parent_version = (0, $egVZE.update_version);
    /**
	 * Executes the proxy in the context of the reaction it was originally created in, if any
	 * @template T
	 * @param {() => T} fn
	 */ var with_parent = (fn)=>{
        if ((0, $egVZE.update_version) === parent_version) return fn();
        // child source is being created after the initial proxy —
        // prevent it from being associated with the current reaction
        var reaction = (0, $egVZE.active_reaction);
        var version = (0, $egVZE.update_version);
        (0, $egVZE.set_active_reaction)(null);
        (0, $egVZE.set_update_version)(parent_version);
        var result = fn();
        (0, $egVZE.set_active_reaction)(reaction);
        (0, $egVZE.set_update_version)(version);
        return result;
    };
    if (is_proxied_array) {
        // We need to create the length source eagerly to ensure that
        // mutations to the array are properly synced with our proxy
        sources.set('length', (0, $kmhLl.state)(/** @type {any[]} */ value.length, stack));
        if (0, $7YIuB.default) value = /** @type {any} */ $2773a044dfd75461$var$inspectable_array(/** @type {any[]} */ value);
    }
    /** Used in dev for $inspect.trace() */ var path = '';
    let updating = false;
    /** @param {string} new_path */ function update_path(new_path) {
        if (updating) return;
        updating = true;
        path = new_path;
        (0, $4Y2WV.tag)(version, `${path} version`);
        // rename all child sources and child proxies
        for (const [prop, source] of sources)(0, $4Y2WV.tag)(source, $2773a044dfd75461$var$get_label(path, prop));
        updating = false;
    }
    return new Proxy(/** @type {any} */ value, {
        defineProperty (_, prop, descriptor) {
            if (!('value' in descriptor) || descriptor.configurable === false || descriptor.enumerable === false || descriptor.writable === false) // we disallow non-basic descriptors, because unless they are applied to the
            // target object — which we avoid, so that state can be forked — we will run
            // afoul of the various invariants
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/getOwnPropertyDescriptor#invariants
            $gB48l.state_descriptors_fixed();
            var s = sources.get(prop);
            if (s === undefined) with_parent(()=>{
                var s = (0, $kmhLl.state)(descriptor.value, stack);
                sources.set(prop, s);
                if ((0, $7YIuB.default) && typeof prop === 'string') (0, $4Y2WV.tag)(s, $2773a044dfd75461$var$get_label(path, prop));
                return s;
            });
            else (0, $kmhLl.set)(s, descriptor.value, true);
            return true;
        },
        deleteProperty (target, prop) {
            var s = sources.get(prop);
            if (s === undefined) {
                if (prop in target) {
                    const s = with_parent(()=>(0, $kmhLl.state)((0, $56eus.UNINITIALIZED), stack));
                    sources.set(prop, s);
                    (0, $kmhLl.increment)(version);
                    if (0, $7YIuB.default) (0, $4Y2WV.tag)(s, $2773a044dfd75461$var$get_label(path, prop));
                }
            } else {
                (0, $kmhLl.set)(s, (0, $56eus.UNINITIALIZED));
                (0, $kmhLl.increment)(version);
            }
            return true;
        },
        get (target, prop, receiver) {
            if (prop === (0, $8zILj.STATE_SYMBOL)) return value;
            if ((0, $7YIuB.default) && prop === (0, $8zILj.PROXY_PATH_SYMBOL)) return update_path;
            var s = sources.get(prop);
            var exists = prop in target;
            // create a source, but only if it's an own property and not a prototype property
            if (s === undefined && (!exists || (0, $btEsq.get_descriptor)(target, prop)?.writable)) {
                s = with_parent(()=>{
                    var p = $2773a044dfd75461$export$923f96dd5afa9ce6(exists ? target[prop] : (0, $56eus.UNINITIALIZED));
                    var s = (0, $kmhLl.state)(p, stack);
                    if (0, $7YIuB.default) (0, $4Y2WV.tag)(s, $2773a044dfd75461$var$get_label(path, prop));
                    return s;
                });
                sources.set(prop, s);
            }
            if (s !== undefined) {
                var v = (0, $egVZE.get)(s);
                return v === (0, $56eus.UNINITIALIZED) ? undefined : v;
            }
            return Reflect.get(target, prop, receiver);
        },
        getOwnPropertyDescriptor (target, prop) {
            this.has?.(target, prop);
            var descriptor = Reflect.getOwnPropertyDescriptor(target, prop);
            var s = sources.get(prop);
            if (s !== undefined) {
                var value = (0, $egVZE.get)(s);
                if (value === (0, $56eus.UNINITIALIZED)) return undefined;
                if (descriptor && 'value' in descriptor) descriptor.value = value;
                else return {
                    enumerable: true,
                    configurable: true,
                    value: value,
                    writable: true
                };
            }
            return descriptor;
        },
        has (target, prop) {
            if (prop === (0, $8zILj.STATE_SYMBOL)) return true;
            var s = sources.get(prop);
            var has = s !== undefined && s.v !== (0, $56eus.UNINITIALIZED) || Reflect.has(target, prop);
            if (s !== undefined || (0, $egVZE.active_effect) !== null && (!has || (0, $btEsq.get_descriptor)(target, prop)?.writable)) {
                if (s === undefined) {
                    s = with_parent(()=>{
                        var p = has ? $2773a044dfd75461$export$923f96dd5afa9ce6(target[prop]) : (0, $56eus.UNINITIALIZED);
                        var s = (0, $kmhLl.state)(p, stack);
                        if (0, $7YIuB.default) (0, $4Y2WV.tag)(s, $2773a044dfd75461$var$get_label(path, prop));
                        return s;
                    });
                    sources.set(prop, s);
                }
                var value = (0, $egVZE.get)(s);
                if (value === (0, $56eus.UNINITIALIZED)) return false;
            }
            return has;
        },
        set (target, prop, value, receiver) {
            var s = sources.get(prop);
            var has = prop in target;
            // variable.length = value -> clear all signals with index >= value
            if (is_proxied_array && prop === 'length') for(var i = value; i < /** @type {Source<number>} */ s.v; i += 1){
                var other_s = sources.get(i + '');
                if (other_s !== undefined) (0, $kmhLl.set)(other_s, (0, $56eus.UNINITIALIZED));
                else if (i in target) {
                    // If the item exists in the original, we need to create an uninitialized source,
                    // else a later read of the property would result in a source being created with
                    // the value of the original item at that index.
                    other_s = with_parent(()=>(0, $kmhLl.state)((0, $56eus.UNINITIALIZED), stack));
                    sources.set(i + '', other_s);
                    if (0, $7YIuB.default) (0, $4Y2WV.tag)(other_s, $2773a044dfd75461$var$get_label(path, i));
                }
            }
            // If we haven't yet created a source for this property, we need to ensure
            // we do so otherwise if we read it later, then the write won't be tracked and
            // the heuristics of effects will be different vs if we had read the proxied
            // object property before writing to that property.
            if (s === undefined) {
                if (!has || (0, $btEsq.get_descriptor)(target, prop)?.writable) {
                    s = with_parent(()=>(0, $kmhLl.state)(undefined, stack));
                    if (0, $7YIuB.default) (0, $4Y2WV.tag)(s, $2773a044dfd75461$var$get_label(path, prop));
                    (0, $kmhLl.set)(s, $2773a044dfd75461$export$923f96dd5afa9ce6(value));
                    sources.set(prop, s);
                }
            } else {
                has = s.v !== (0, $56eus.UNINITIALIZED);
                var p = with_parent(()=>$2773a044dfd75461$export$923f96dd5afa9ce6(value));
                (0, $kmhLl.set)(s, p);
            }
            var descriptor = Reflect.getOwnPropertyDescriptor(target, prop);
            // Set the new value before updating any signals so that any listeners get the new value
            if (descriptor?.set) descriptor.set.call(receiver, value);
            if (!has) {
                // If we have mutated an array directly, we might need to
                // signal that length has also changed. Do it before updating metadata
                // to ensure that iterating over the array as a result of a metadata update
                // will not cause the length to be out of sync.
                if (is_proxied_array && typeof prop === 'string') {
                    var ls = /** @type {Source<number>} */ sources.get('length');
                    var n = Number(prop);
                    if (Number.isInteger(n) && n >= ls.v) (0, $kmhLl.set)(ls, n + 1);
                }
                (0, $kmhLl.increment)(version);
            }
            return true;
        },
        ownKeys (target) {
            (0, $egVZE.get)(version);
            var own_keys = Reflect.ownKeys(target).filter((key)=>{
                var source = sources.get(key);
                return source === undefined || source.v !== (0, $56eus.UNINITIALIZED);
            });
            for (var [key, source] of sources)if (source.v !== (0, $56eus.UNINITIALIZED) && !(key in target)) own_keys.push(key);
            return own_keys;
        },
        setPrototypeOf () {
            $gB48l.state_prototype_fixed();
        }
    });
}
/**
 * @param {string} path
 * @param {string | symbol} prop
 */ function $2773a044dfd75461$var$get_label(path, prop) {
    if (typeof prop === 'symbol') return `${path}[Symbol(${prop.description ?? ''})]`;
    if ($2773a044dfd75461$var$regex_is_valid_identifier.test(prop)) return `${path}.${prop}`;
    return /^\d+$/.test(prop) ? `${path}[${prop}]` : `${path}['${prop}']`;
}
function $2773a044dfd75461$export$e7a76095f1bf2f14(value) {
    try {
        if (value !== null && typeof value === 'object' && (0, $8zILj.STATE_SYMBOL) in value) return value[0, $8zILj.STATE_SYMBOL];
    } catch  {
    // the above if check can throw an error if the value in question
    // is the contentWindow of an iframe on another domain, in which
    // case we want to just return the value (because it's definitely
    // not a proxied value) so we don't break any JavaScript interacting
    // with that iframe (such as various payment companies client side
    // JavaScript libraries interacting with their iframes on the same
    // domain)
    }
    return value;
}
function $2773a044dfd75461$export$226b3eccf92c9ed9(a, b) {
    return Object.is($2773a044dfd75461$export$e7a76095f1bf2f14(a), $2773a044dfd75461$export$e7a76095f1bf2f14(b));
}
const $2773a044dfd75461$var$ARRAY_MUTATING_METHODS = new Set([
    'copyWithin',
    'fill',
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
]);
/**
 * Wrap array mutating methods so $inspect is triggered only once and
 * to prevent logging an array in intermediate state (e.g. with an empty slot)
 * @param {any[]} array
 */ function $2773a044dfd75461$var$inspectable_array(array) {
    return new Proxy(array, {
        get (target, prop, receiver) {
            var value = Reflect.get(target, prop, receiver);
            if (!$2773a044dfd75461$var$ARRAY_MUTATING_METHODS.has(/** @type {string} */ prop)) return value;
            /**
			 * @this {any[]}
			 * @param {any[]} args
			 */ return function(...args) {
                (0, $kmhLl.set_eager_effects_deferred)();
                var result = value.apply(this, args);
                (0, $kmhLl.flush_eager_effects)();
                return result;
            };
        }
    });
}

});




parcelRegister("7Bsuc", function(module, exports) {

$parcel$export(module.exports, "defer_effect", () => $589215dcf4532ab8$export$bfeabc31f5d6c761);
/** @import { Effect } from '#client' */ 
var $8zILj = parcelRequire("8zILj");

var $1RLxH = parcelRequire("1RLxH");
function $589215dcf4532ab8$export$bfeabc31f5d6c761(effect, dirty_effects, maybe_dirty_effects) {
    if ((effect.f & (0, $8zILj.DIRTY)) !== 0) dirty_effects.add(effect);
    else if ((effect.f & (0, $8zILj.MAYBE_DIRTY)) !== 0) maybe_dirty_effects.add(effect);
    // mark as clean so they get scheduled if they depend on pending async state
    (0, $1RLxH.set_signal_status)(effect, (0, $8zILj.CLEAN));
}

});
parcelRegister("1RLxH", function(module, exports) {

$parcel$export(module.exports, "set_signal_status", () => $15bf9ea4e3db5f6c$export$453ac37495fe1882);
$parcel$export(module.exports, "update_derived_status", () => $15bf9ea4e3db5f6c$export$93fd9c1b91cb5d02);
/** @import { Derived, Signal } from '#client' */ 
var $8zILj = parcelRequire("8zILj");
const $15bf9ea4e3db5f6c$var$STATUS_MASK = ~((0, $8zILj.DIRTY) | (0, $8zILj.MAYBE_DIRTY) | (0, $8zILj.CLEAN));
function $15bf9ea4e3db5f6c$export$453ac37495fe1882(signal, status) {
    signal.f = signal.f & $15bf9ea4e3db5f6c$var$STATUS_MASK | status;
}
function $15bf9ea4e3db5f6c$export$93fd9c1b91cb5d02(derived) {
    // Only mark as MAYBE_DIRTY if disconnected and has dependencies.
    if ((derived.f & (0, $8zILj.CONNECTED)) !== 0 || derived.deps === null) $15bf9ea4e3db5f6c$export$453ac37495fe1882(derived, (0, $8zILj.CLEAN));
    else $15bf9ea4e3db5f6c$export$453ac37495fe1882(derived, (0, $8zILj.MAYBE_DIRTY));
}

});


parcelRegister("mS8IQ", function(module, exports) {
/** @import { Derived, Effect, Value } from '#client' */ 
var $8zILj = parcelRequire("8zILj");

var $8CHUy = parcelRequire("8CHUy");

var $egVZE = parcelRequire("egVZE");
function $044c0d33bcd17022$export$e8e78c978b129247(effect) {
    while(effect.parent !== null)effect = effect.parent;
    return effect;
}
/**
 *
 * @param {Effect} effect
 * @param {boolean} append_effect
 * @returns {string}
 */ function $044c0d33bcd17022$var$effect_label(effect, append_effect = false) {
    const flags = effect.f;
    let label = `(unknown ${append_effect ? 'effect' : ''})`;
    if ((flags & (0, $8zILj.ROOT_EFFECT)) !== 0) label = 'root';
    else if ((flags & (0, $8zILj.BOUNDARY_EFFECT)) !== 0) label = 'boundary';
    else if ((flags & (0, $8zILj.BLOCK_EFFECT)) !== 0) label = 'block';
    else if ((flags & (0, $8zILj.MANAGED_EFFECT)) !== 0) label = 'managed';
    else if ((flags & (0, $8zILj.ASYNC)) !== 0) label = 'async';
    else if ((flags & (0, $8zILj.BRANCH_EFFECT)) !== 0) label = 'branch';
    else if ((flags & (0, $8zILj.RENDER_EFFECT)) !== 0) label = 'render effect';
    else if ((flags & (0, $8zILj.EFFECT)) !== 0) label = 'effect';
    if (append_effect && !label.endsWith('effect')) label += ' effect';
    return label;
}
function $044c0d33bcd17022$export$b3a6be96af772eb5(effect, highlighted = [], depth = 0, is_reachable = true) {
    const flags = effect.f;
    let label = $044c0d33bcd17022$var$effect_label(effect);
    let status = (flags & (0, $8zILj.CLEAN)) !== 0 ? 'clean' : (flags & (0, $8zILj.MAYBE_DIRTY)) !== 0 ? 'maybe dirty' : 'dirty';
    let styles = [
        `font-weight: ${status === 'clean' ? 'normal' : 'bold'}`
    ];
    if (status !== 'clean' && !is_reachable) {
        label = `\u{26A0}\u{FE0F} ${label}`;
        styles.push(`color: red`);
    }
    if ((flags & (0, $8zILj.INERT)) !== 0) styles.push('font-style: italic');
    if (highlighted.includes(effect)) styles.push('background-color: yellow');
    // eslint-disable-next-line no-console
    console.group(`%c${label} (${status})`, styles.join('; '));
    if (depth === 0) {
        const callsite = new Error().stack?.split('\n')[2].replace(/\s+at (?: \w+\(?)?(.+)\)?/, (m, $1)=>$1.replace(/\?[^:]+/, ''));
        // eslint-disable-next-line no-console
        console.log(callsite);
    } else {
        // eslint-disable-next-line no-console
        console.groupCollapsed(`%cfn`, `font-weight: normal`);
        // eslint-disable-next-line no-console
        console.log(effect.fn);
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
    if (effect.deps !== null) {
        // eslint-disable-next-line no-console
        console.groupCollapsed('%cdeps', 'font-weight: normal');
        for (const dep of effect.deps)$044c0d33bcd17022$var$log_dep(dep);
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
    if (effect.nodes) {
        // eslint-disable-next-line no-console
        console.log(effect.nodes.start);
        if (effect.nodes.start !== effect.nodes.end) // eslint-disable-next-line no-console
        console.log(effect.nodes.end);
    }
    var child_is_reachable = is_reachable && ((flags & (0, $8zILj.BRANCH_EFFECT)) === 0 || (flags & (0, $8zILj.CLEAN)) === 0);
    let child = effect.first;
    while(child !== null){
        $044c0d33bcd17022$export$b3a6be96af772eb5(child, highlighted, depth + 1, child_is_reachable);
        child = child.next;
    }
    // eslint-disable-next-line no-console
    console.groupEnd();
}
/**
 *
 * @param {Value} dep
 */ function $044c0d33bcd17022$var$log_dep(dep) {
    if ((dep.f & (0, $8zILj.DERIVED)) !== 0) {
        const derived = /** @type {Derived} */ dep;
        // eslint-disable-next-line no-console
        console.groupCollapsed(`%c$derived %c${dep.label ?? '<unknown>'}`, 'font-weight: bold; color: CornflowerBlue', 'font-weight: normal', (0, $egVZE.untrack)(()=>(0, $8CHUy.snapshot)(derived.v)));
        if (derived.deps) for (const d of derived.deps)$044c0d33bcd17022$var$log_dep(d);
        // eslint-disable-next-line no-console
        console.groupEnd();
    } else // eslint-disable-next-line no-console
    console.log(`%c$state %c${dep.label ?? '<unknown>'}`, 'font-weight: bold; color: CornflowerBlue', 'font-weight: normal', (0, $egVZE.untrack)(()=>(0, $8CHUy.snapshot)(dep.v)));
}
function $044c0d33bcd17022$export$902d3c1b1a9c796c(signal) {
    /** @type {Set<Derived | Value>} */ const visited = new Set();
    /**
	 * Returns an array of flag names that are set on the given flags bitmask
	 * @param {number} flags
	 * @returns {string[]}
	 */ function get_derived_flag_names(flags) {
        /** @type {string[]} */ const names = [];
        if ((flags & (0, $8zILj.CLEAN)) !== 0) names.push('CLEAN');
        if ((flags & (0, $8zILj.DIRTY)) !== 0) names.push('DIRTY');
        if ((flags & (0, $8zILj.MAYBE_DIRTY)) !== 0) names.push('MAYBE_DIRTY');
        if ((flags & (0, $8zILj.CONNECTED)) !== 0) names.push('CONNECTED');
        if ((flags & (0, $8zILj.INERT)) !== 0) names.push('INERT');
        if ((flags & (0, $8zILj.DESTROYED)) !== 0) names.push('DESTROYED');
        return names;
    }
    /**
	 * @param {Derived | Value} d
	 * @param {number} depth
	 */ function log_derived(d, depth) {
        const flags = d.f;
        const flag_names = get_derived_flag_names(flags);
        const flags_str = flag_names.length > 0 ? `(${flag_names.join(', ')})` : '(no flags)';
        // eslint-disable-next-line no-console
        console.group(`%c${flags & (0, $8zILj.DERIVED) ? '$derived' : '$state'} %c${d.label ?? '<unknown>'} %c${flags_str}`, 'font-weight: bold; color: CornflowerBlue', 'font-weight: normal; color: inherit', 'font-weight: normal; color: gray');
        // eslint-disable-next-line no-console
        console.log((0, $egVZE.untrack)(()=>(0, $8CHUy.snapshot)(d.v)));
        if ('fn' in d) // eslint-disable-next-line no-console
        console.log('%cfn:', 'font-weight: bold', d.fn);
        if (d.reactions !== null && d.reactions.length > 0) {
            // eslint-disable-next-line no-console
            console.group('%creactions', 'font-weight: bold');
            for (const reaction of d.reactions)if ((reaction.f & (0, $8zILj.DERIVED)) !== 0) {
                const derived_reaction = /** @type {Derived} */ reaction;
                if (visited.has(derived_reaction)) // eslint-disable-next-line no-console
                console.log(`%c$derived %c${derived_reaction.label ?? '<unknown>'} %c(already seen)`, 'font-weight: bold; color: CornflowerBlue', 'font-weight: normal; color: inherit', 'font-weight: bold; color: orange');
                else {
                    visited.add(derived_reaction);
                    log_derived(derived_reaction, depth + 1);
                }
            } else {
                // It's an effect
                const label = $044c0d33bcd17022$var$effect_label(/** @type {Effect} */ reaction, true);
                const status = (flags & (0, $8zILj.MAYBE_DIRTY)) !== 0 ? 'maybe dirty' : 'dirty';
                // Collect parent statuses
                /** @type {string[]} */ const parent_statuses = [];
                let show = false;
                let current = /** @type {Effect} */ reaction.parent;
                while(current !== null){
                    const parent_flags = current.f;
                    if ((parent_flags & ((0, $8zILj.ROOT_EFFECT) | (0, $8zILj.BRANCH_EFFECT))) !== 0) {
                        const parent_status = (parent_flags & (0, $8zILj.CLEAN)) !== 0 ? 'clean' : 'not clean';
                        if (parent_status === 'clean' && parent_statuses.includes('not clean')) show = true;
                        parent_statuses.push(parent_status);
                    }
                    if (!current.parent) break;
                    current = current.parent;
                }
                // Check if reaction is reachable from root
                const seen_effects = new Set();
                let reachable = false;
                /**
					 * @param {Effect | null} effect
					 */ function check_reachable(effect) {
                    if (effect === null || reachable) return;
                    if (effect === reaction) {
                        reachable = true;
                        return;
                    }
                    if (effect.f & (0, $8zILj.DESTROYED)) return;
                    if (seen_effects.has(effect)) throw new Error('');
                    seen_effects.add(effect);
                    let child = effect.first;
                    while(child !== null){
                        check_reachable(child);
                        child = child.next;
                    }
                }
                try {
                    if (current) check_reachable(current);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log(`%c\u{26A0}\u{FE0F} Circular reference detected in effect tree`, 'font-weight: bold; color: red', seen_effects);
                }
                if (!reachable) // eslint-disable-next-line no-console
                console.log(`%c\u{26A0}\u{FE0F} Effect is NOT reachable from its parent chain`, 'font-weight: bold; color: red');
                const parent_status_str = show ? ` (${parent_statuses.join(', ')})` : '';
                // eslint-disable-next-line no-console
                console.log(`%c${label} (${status})${parent_status_str}`, `font-weight: bold; color: ${parent_status_str ? 'red' : 'green'}`, reaction);
            }
            // eslint-disable-next-line no-console
            console.groupEnd();
        } else // eslint-disable-next-line no-console
        console.log('%cno reactions', 'font-style: italic; color: gray');
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
    // eslint-disable-next-line no-console
    console.group(`%cDerived Reactions Graph`, 'font-weight: bold; color: purple');
    visited.add(signal);
    log_derived(signal, 0);
    // eslint-disable-next-line no-console
    console.groupEnd();
}
function $044c0d33bcd17022$export$774bb6e963889caa(effect) {
    const root_effect = $044c0d33bcd17022$export$e8e78c978b129247(effect);
    /**
	 * @typedef {{
	 *   effect: Effect,
	 *   status: 'clean' | 'maybe dirty' | 'dirty',
	 *   parent_clean: boolean,
	 *   children: BranchInfo[]
	 * }} BranchInfo
	 */ /**
	 * Collects branch effects from the tree
	 * @param {Effect} eff
	 * @param {boolean} parent_clean - whether any ancestor branch is clean
	 * @returns {BranchInfo[]}
	 */ function collect_branches(eff, parent_clean) {
        /** @type {BranchInfo[]} */ const branches = [];
        const flags = eff.f;
        const is_branch = (flags & (0, $8zILj.BRANCH_EFFECT)) !== 0;
        if (is_branch) {
            const status = (flags & (0, $8zILj.CLEAN)) !== 0 ? 'clean' : (flags & (0, $8zILj.MAYBE_DIRTY)) !== 0 ? 'maybe dirty' : 'dirty';
            /** @type {BranchInfo[]} */ const child_branches = [];
            let child = eff.first;
            while(child !== null){
                child_branches.push(...collect_branches(child, status === 'clean'));
                child = child.next;
            }
            branches.push({
                effect: eff,
                status: status,
                parent_clean: parent_clean,
                children: child_branches
            });
        } else {
            // Not a branch, continue traversing
            let child = eff.first;
            while(child !== null){
                branches.push(...collect_branches(child, parent_clean));
                child = child.next;
            }
        }
        return branches;
    }
    /**
	 * Checks if a branch tree contains any inconsistencies (non-clean below clean)
	 * @param {BranchInfo} branch
	 * @param {boolean} ancestor_clean
	 * @returns {boolean}
	 */ function has_inconsistency(branch, ancestor_clean) {
        const is_inconsistent = ancestor_clean && branch.status !== 'clean';
        if (is_inconsistent) return true;
        const new_ancestor_clean = ancestor_clean || branch.status === 'clean';
        for (const child of branch.children){
            if (has_inconsistency(child, new_ancestor_clean)) return true;
        }
        return false;
    }
    /**
	 * Logs a branch and its children, but only if there are inconsistencies
	 * @param {BranchInfo} branch
	 * @param {boolean} ancestor_clean
	 * @param {number} depth
	 */ function log_branch(branch, ancestor_clean, depth) {
        const is_inconsistent = ancestor_clean && branch.status !== 'clean';
        const new_ancestor_clean = ancestor_clean || branch.status === 'clean';
        // Only log if this branch or any descendant has an inconsistency
        if (!has_inconsistency(branch, ancestor_clean) && !is_inconsistent) return;
        const style = is_inconsistent ? 'font-weight: bold; color: red' : branch.status === 'clean' ? 'font-weight: normal; color: green' : 'font-weight: bold; color: orange';
        const warning = is_inconsistent ? " \u26A0\uFE0F INCONSISTENT" : '';
        // eslint-disable-next-line no-console
        console.group(`%cbranch (${branch.status})${warning}`, style);
        // eslint-disable-next-line no-console
        console.log('%ceffect:', 'font-weight: bold', branch.effect);
        if (branch.effect.fn) // eslint-disable-next-line no-console
        console.log('%cfn:', 'font-weight: bold', branch.effect.fn);
        if (branch.effect.deps !== null) {
            // eslint-disable-next-line no-console
            console.groupCollapsed('%cdeps', 'font-weight: normal');
            for (const dep of branch.effect.deps)$044c0d33bcd17022$var$log_dep(dep);
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        if (is_inconsistent) $044c0d33bcd17022$export$b3a6be96af772eb5(branch.effect);
        else if (branch.children.length > 0) {
            // eslint-disable-next-line no-console
            console.group('%cchild branches', 'font-weight: bold');
            for (const child of branch.children)log_branch(child, new_ancestor_clean, depth + 1);
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
    const branches = collect_branches(root_effect, false);
    // Check if there are any inconsistencies at all
    let has_any_inconsistency = false;
    for (const branch of branches)if (has_inconsistency(branch, false)) {
        has_any_inconsistency = true;
        break;
    }
    if (!has_any_inconsistency) {
        // eslint-disable-next-line no-console
        console.log('%cNo inconsistent branches found', 'font-weight: bold; color: green');
        return;
    }
    // eslint-disable-next-line no-console
    console.group(`%cInconsistent Branches (non-clean below clean)`, 'font-weight: bold; color: red');
    for (const branch of branches)log_branch(branch, false, 0);
    // eslint-disable-next-line no-console
    console.groupEnd();
    return true;
}

});

parcelRegister("3oHv7", function(module, exports) {

$parcel$export(module.exports, "reactivity_loss_tracker", () => $27955b57f18f7b75$export$ac8c02aae89cbb3a);
$parcel$export(module.exports, "set_reactivity_loss_tracker", () => $27955b57f18f7b75$export$7afd371f9e656b3d);
$parcel$export(module.exports, "recent_async_deriveds", () => $27955b57f18f7b75$export$4a9c529468ad58b3);
$parcel$export(module.exports, "derived", () => $27955b57f18f7b75$export$90b0b54dab0a340a);
$parcel$export(module.exports, "OBSOLETE", () => $27955b57f18f7b75$export$e4590bcfba36e11b);
$parcel$export(module.exports, "async_derived", () => $27955b57f18f7b75$export$31a5c90409b7e149);
$parcel$export(module.exports, "derived_safe_equal", () => $27955b57f18f7b75$export$21eb66ff899c08a1);
$parcel$export(module.exports, "execute_derived", () => $27955b57f18f7b75$export$fef7f056c2a803f7);
$parcel$export(module.exports, "update_derived", () => $27955b57f18f7b75$export$feaf30bee8797321);
$parcel$export(module.exports, "freeze_derived_effects", () => $27955b57f18f7b75$export$93b1e1a218760d1c);
$parcel$export(module.exports, "unfreeze_derived_effects", () => $27955b57f18f7b75$export$782f34b5d911d3bd);
/** @import { Derived, Effect, Reaction, Source, Value } from '#client' */ /** @import { Batch } from './batch.js'; */ /** @import { Boundary } from '../dom/blocks/boundary.js'; */ parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $8zILj = parcelRequire("8zILj");

var $egVZE = parcelRequire("egVZE");

var $4s4uP = parcelRequire("4s4uP");

var $f09ju = parcelRequire("f09ju");

var $gB48l = parcelRequire("gB48l");

var $9iF6l = parcelRequire("9iF6l");

var $kCMGX = parcelRequire("kCMGX");

var $kmhLl = parcelRequire("kmhLl");

var $9AQvv = parcelRequire("9AQvv");

var $yJWNn = parcelRequire("yJWNn");

var $6bkva = parcelRequire("6bkva");

var $56eus = parcelRequire("56eus");

var $amPy2 = parcelRequire("amPy2");

var $9gIfi = parcelRequire("9gIfi");

var $btEsq = parcelRequire("btEsq");

var $1RLxH = parcelRequire("1RLxH");
let $27955b57f18f7b75$export$ac8c02aae89cbb3a = null;
function $27955b57f18f7b75$export$7afd371f9e656b3d(v) {
    $27955b57f18f7b75$export$ac8c02aae89cbb3a = v;
}
const $27955b57f18f7b75$export$4a9c529468ad58b3 = new Set();
function $27955b57f18f7b75$export$90b0b54dab0a340a(fn) {
    var flags = (0, $8zILj.DERIVED) | (0, $8zILj.DIRTY);
    if ((0, $egVZE.active_effect) !== null) // Since deriveds are evaluated lazily, any effects created inside them are
    // created too late to ensure that the parent effect is added to the tree
    (0, $egVZE.active_effect).f |= (0, $8zILj.EFFECT_PRESERVED);
    /** @type {Derived<V>} */ const signal = {
        ctx: (0, $6bkva.component_context),
        deps: null,
        effects: null,
        equals: $f09ju.equals,
        f: flags,
        fn: fn,
        reactions: null,
        rv: 0,
        v: /** @type {V} */ (0, $56eus.UNINITIALIZED),
        wv: 0,
        parent: (0, $egVZE.active_effect),
        ac: null
    };
    if ((0, $7YIuB.default) && (0, $yJWNn.tracing_mode_flag)) signal.created = (0, $9AQvv.get_error)('created at');
    return signal;
}
const $27955b57f18f7b75$export$e4590bcfba36e11b = Symbol('obsolete');
function $27955b57f18f7b75$export$31a5c90409b7e149(fn, label, location) {
    let parent = /** @type {Effect | null} */ (0, $egVZE.active_effect);
    if (parent === null) $gB48l.async_derived_orphan();
    var promise = /** @type {unknown} */ undefined;
    var signal = (0, $kmhLl.source)(/** @type {V} */ (0, $56eus.UNINITIALIZED));
    if (0, $7YIuB.default) signal.label = label ?? fn.toString();
    // only suspend in async deriveds created on initialisation
    var should_suspend = !(0, $egVZE.active_reaction);
    /** @type {Set<ReturnType<typeof deferred<V>>>} */ var deferreds = new Set();
    (0, $kCMGX.async_effect)(()=>{
        var effect = /** @type {Effect} */ (0, $egVZE.active_effect);
        if (0, $7YIuB.default) $27955b57f18f7b75$export$ac8c02aae89cbb3a = {
            effect: effect,
            effect_deps: new Set(),
            warned: false
        };
        /** @type {ReturnType<typeof deferred<V>>} */ var d = (0, $btEsq.deferred)();
        promise = d.promise;
        try {
            // If this code is changed at some point, make sure to still access the then property
            // of fn() to read any signals it might access, so that we track them as dependencies.
            // We call `unset_context` to undo any `save` calls that happen inside `fn()`
            Promise.resolve(fn()).then(d.resolve, (e)=>{
                // if the promise was rejected by the user, via `getAbortSignal`, then
                // wait for a subsequent resolution instead of flushing the batch
                if (e !== (0, $8zILj.STALE_REACTION)) d.reject(e);
            }).finally((0, $9gIfi.unset_context));
        } catch (error) {
            d.reject(error);
            (0, $9gIfi.unset_context)();
        }
        if (0, $7YIuB.default) {
            if ($27955b57f18f7b75$export$ac8c02aae89cbb3a) {
                // Reused deps from previous run (indices 0 to skipped_deps-1)
                // We deliberately only track direct dependencies of the async expression to encourage
                // dependencies being directly visible at the point of the expression
                if (effect.deps !== null) for(let i = 0; i < (0, $egVZE.skipped_deps); i += 1)$27955b57f18f7b75$export$ac8c02aae89cbb3a.effect_deps.add(effect.deps[i]);
                // New deps discovered this run
                if ((0, $egVZE.new_deps) !== null) for(let i = 0; i < (0, $egVZE.new_deps).length; i += 1)$27955b57f18f7b75$export$ac8c02aae89cbb3a.effect_deps.add((0, $egVZE.new_deps)[i]);
            }
            $27955b57f18f7b75$export$ac8c02aae89cbb3a = null;
        }
        var batch = /** @type {Batch} */ (0, $amPy2.current_batch);
        if (should_suspend) {
            // we only increment the batch's pending state for updates, not creation, otherwise
            // we will decrement to zero before the work that depends on this promise (e.g. a
            // template effect) has initialized, causing the batch to resolve prematurely
            if ((effect.f & (0, $8zILj.REACTION_RAN)) !== 0) var decrement_pending = (0, $9gIfi.increment_pending)();
            if (// boundary can be null if the async derived is inside an $effect.root not connected to the component render tree
            parent.b?.is_rendered()) batch.async_deriveds.get(effect)?.reject($27955b57f18f7b75$export$e4590bcfba36e11b);
            else // While the boundary is still showing pending, a new run supersedes all older in-flight runs
            // for this async expression. Cancel eagerly so resolution cannot commit stale values.
            for (const d of deferreds.values())d.reject($27955b57f18f7b75$export$e4590bcfba36e11b);
            deferreds.add(d);
            batch.async_deriveds.set(effect, d);
        }
        /**
		 * @param {any} value
		 * @param {unknown} error
		 */ const handler = (value, error)=>{
            if (0, $7YIuB.default) $27955b57f18f7b75$export$ac8c02aae89cbb3a = null;
            decrement_pending?.();
            deferreds.delete(d);
            if (error === $27955b57f18f7b75$export$e4590bcfba36e11b) return;
            batch.activate();
            if (error) {
                signal.f |= (0, $8zILj.ERROR_VALUE);
                // @ts-expect-error the error is the wrong type, but we don't care
                (0, $kmhLl.internal_set)(signal, error);
            } else {
                if ((signal.f & (0, $8zILj.ERROR_VALUE)) !== 0) signal.f ^= (0, $8zILj.ERROR_VALUE);
                if ((0, $7YIuB.default) && location !== undefined && !signal.equals(value)) {
                    $27955b57f18f7b75$export$4a9c529468ad58b3.add(signal);
                    setTimeout(()=>{
                        if ($27955b57f18f7b75$export$4a9c529468ad58b3.has(signal) && (effect.f & (0, $8zILj.DESTROYED)) === 0) {
                            $9iF6l.await_waterfall(/** @type {string} */ signal.label, location);
                            $27955b57f18f7b75$export$4a9c529468ad58b3.delete(signal);
                        }
                    });
                }
                (0, $kmhLl.internal_set)(signal, value);
            }
            batch.deactivate();
        };
        d.promise.then(handler, (e)=>handler(null, e || 'unknown'));
    });
    (0, $kCMGX.teardown)(()=>{
        for (const d of deferreds)d.reject($27955b57f18f7b75$export$e4590bcfba36e11b);
    });
    if (0, $7YIuB.default) // add a flag that lets this be printed as a derived
    // when using `$inspect.trace()`
    signal.f |= (0, $8zILj.ASYNC);
    return new Promise((fulfil)=>{
        /** @param {Promise<V>} p */ function next(p) {
            function go() {
                if (p === promise) fulfil(signal);
                else // if the effect re-runs before the initial promise
                // resolves, delay resolution until we have a value
                next(promise);
            }
            p.then(go, go);
        }
        next(promise);
    });
}
function $27955b57f18f7b75$export$8fe0e05ae6df0552(fn) {
    const d = $27955b57f18f7b75$export$90b0b54dab0a340a(fn);
    if (!(0, $yJWNn.async_mode_flag)) (0, $egVZE.push_reaction_value)(d);
    return d;
}
function $27955b57f18f7b75$export$21eb66ff899c08a1(fn) {
    const signal = $27955b57f18f7b75$export$90b0b54dab0a340a(fn);
    signal.equals = (0, $f09ju.safe_equals);
    return signal;
}
function $27955b57f18f7b75$export$20857467d6067335(derived) {
    var effects = derived.effects;
    if (effects !== null) {
        derived.effects = null;
        for(var i = 0; i < effects.length; i += 1)(0, $kCMGX.destroy_effect)(/** @type {Effect} */ effects[i]);
    }
}
/**
 * The currently updating deriveds, used to detect infinite recursion
 * in dev mode and provide a nicer error than 'too much recursion'
 * @type {Derived[]}
 */ let $27955b57f18f7b75$var$stack = [];
function $27955b57f18f7b75$export$fef7f056c2a803f7(derived) {
    var value;
    var prev_active_effect = (0, $egVZE.active_effect);
    var parent = derived.parent;
    if (!(0, $egVZE.is_destroying_effect) && parent !== null && derived.v !== (0, $56eus.UNINITIALIZED) && // if it was never evaluated before, it's guaranteed to fail downstream, so we try to execute instead
    (parent.f & ((0, $8zILj.DESTROYED) | (0, $8zILj.INERT))) !== 0) {
        $9iF6l.derived_inert();
        return derived.v;
    }
    (0, $egVZE.set_active_effect)(parent);
    if (0, $7YIuB.default) {
        let prev_eager_effects = (0, $kmhLl.eager_effects);
        (0, $kmhLl.set_eager_effects)(new Set());
        try {
            if ((0, $btEsq.includes).call($27955b57f18f7b75$var$stack, derived)) $gB48l.derived_references_self();
            $27955b57f18f7b75$var$stack.push(derived);
            $27955b57f18f7b75$export$20857467d6067335(derived);
            value = (0, $egVZE.update_reaction)(derived);
        } finally{
            (0, $egVZE.set_active_effect)(prev_active_effect);
            (0, $kmhLl.set_eager_effects)(prev_eager_effects);
            $27955b57f18f7b75$var$stack.pop();
        }
    } else try {
        $27955b57f18f7b75$export$20857467d6067335(derived);
        value = (0, $egVZE.update_reaction)(derived);
    } finally{
        (0, $egVZE.set_active_effect)(prev_active_effect);
    }
    return value;
}
function $27955b57f18f7b75$export$feaf30bee8797321(derived) {
    var value = $27955b57f18f7b75$export$fef7f056c2a803f7(derived);
    if (!derived.equals(value)) {
        derived.wv = (0, $egVZE.increment_write_version)();
        // in a fork, we don't update the underlying value, just `batch_values`.
        // the underlying value will be updated when the fork is committed.
        // otherwise, the next time we get here after a 'real world' state
        // change, `derived.equals` may incorrectly return `true`
        if (!(0, $amPy2.current_batch)?.is_fork || derived.deps === null) {
            if ((0, $amPy2.current_batch) !== null) {
                // We also write to previous_batch because if it exists, it is a sign that we're
                // currently in the process of flushing effects. These updates to deriveds may belong
                // to the previous batch, not the new one (which can already exist if an earlier
                // effect wrote to a source). This can cause bugs when running batch.#commit() later,
                // but not adding it to current_batch can, too, so we add it to both.
                // See https://github.com/sveltejs/svelte/pull/18117 for more details.
                (0, $amPy2.current_batch).capture(derived, value, true);
                (0, $amPy2.previous_batch)?.capture(derived, value, true);
            } else derived.v = value;
            // deriveds without dependencies should never be recomputed
            if (derived.deps === null) {
                (0, $1RLxH.set_signal_status)(derived, (0, $8zILj.CLEAN));
                return;
            }
        }
    }
    // don't mark derived clean if we're reading it inside a
    // cleanup function, or it will cache a stale value
    if (0, $egVZE.is_destroying_effect) return;
    // During time traveling we don't want to reset the status so that
    // traversal of the graph in the other batches still happens
    if ((0, $amPy2.batch_values) !== null) // only cache the value if we're in a tracking context, otherwise we won't
    // clear the cache in `mark_reactions` when dependencies are updated
    {
        if ((0, $kCMGX.effect_tracking)() || (0, $amPy2.current_batch)?.is_fork) (0, $amPy2.batch_values).set(derived, value);
    } else (0, $1RLxH.update_derived_status)(derived);
}
function $27955b57f18f7b75$export$93b1e1a218760d1c(derived) {
    if (derived.effects === null) return;
    for (const e of derived.effects)// if the effect has a teardown function or abort signal, call it
    if (e.teardown || e.ac) {
        e.teardown?.();
        if (e.ac !== null) (0, $4s4uP.without_reactive_context)(()=>{
            /** @type {AbortController} */ e.ac.abort((0, $8zILj.STALE_REACTION));
            e.ac = null;
        });
        // make it a noop so it doesn't get called again if the derived
        // is unfrozen. we don't set it to `null`, because the existence
        // of a teardown function is what determines whether the
        // effect runs again during unfreezing (but not for teardown-only effects)
        if (e.fn !== null) e.teardown = (0, $btEsq.noop);
        (0, $egVZE.remove_reactions)(e, 0);
        (0, $kCMGX.destroy_effect_children)(e);
    }
}
function $27955b57f18f7b75$export$782f34b5d911d3bd(derived) {
    if (derived.effects === null) return;
    for (const e of derived.effects)// if the effect was previously frozen — indicated by the presence
    // of a teardown function — unfreeze it
    if (e.teardown && e.fn !== null) (0, $egVZE.update_effect)(e);
}

});
parcelRegister("4s4uP", function(module, exports) {

$parcel$export(module.exports, "without_reactive_context", () => $33dd43d440d66804$export$ffbb6b1b59f471fa);

var $kCMGX = parcelRequire("kCMGX");

var $egVZE = parcelRequire("egVZE");

var $8zILj = parcelRequire("8zILj");

var $5EmV7 = parcelRequire("5EmV7");
function $33dd43d440d66804$export$63174c828edd6ff8(target, events, handler, call_handler_immediately = true) {
    if (call_handler_immediately) handler();
    for (var name of events)target.addEventListener(name, handler);
    (0, $kCMGX.teardown)(()=>{
        for (var name of events)target.removeEventListener(name, handler);
    });
}
function $33dd43d440d66804$export$ffbb6b1b59f471fa(fn) {
    var previous_reaction = (0, $egVZE.active_reaction);
    var previous_effect = (0, $egVZE.active_effect);
    (0, $egVZE.set_active_reaction)(null);
    (0, $egVZE.set_active_effect)(null);
    try {
        return fn();
    } finally{
        (0, $egVZE.set_active_reaction)(previous_reaction);
        (0, $egVZE.set_active_effect)(previous_effect);
    }
}
function $33dd43d440d66804$export$76705e68ebc8a14b(element, event, handler, on_reset = handler) {
    element.addEventListener(event, ()=>$33dd43d440d66804$export$ffbb6b1b59f471fa(handler));
    const prev = /** @type {any} */ element[0, $8zILj.FORM_RESET_HANDLER];
    if (prev) // special case for checkbox that can have multiple binds (group & checked)
    /** @type {any} */ element[0, $8zILj.FORM_RESET_HANDLER] = ()=>{
        prev();
        on_reset(true);
    };
    else /** @type {any} */ element[0, $8zILj.FORM_RESET_HANDLER] = ()=>on_reset(true);
    (0, $5EmV7.add_form_reset_listener)();
}

});
parcelRegister("5EmV7", function(module, exports) {

$parcel$export(module.exports, "add_form_reset_listener", () => $41d277a885a1af08$export$214872c4fbda6a1e);

var $48zFZ = parcelRequire("48zFZ");

var $cGH1Z = parcelRequire("cGH1Z");

var $c2wsH = parcelRequire("c2wsH");

var $8zILj = parcelRequire("8zILj");
function $41d277a885a1af08$export$4c47992fc278c9a0(dom, value) {
    if (value) {
        const body = document.body;
        dom.autofocus = true;
        (0, $c2wsH.queue_micro_task)(()=>{
            if (document.activeElement === body) dom.focus();
        });
    }
}
function $41d277a885a1af08$export$3f577c5bc1117528(dom) {
    if ((0, $48zFZ.hydrating) && (0, $cGH1Z.get_first_child)(dom) !== null) (0, $cGH1Z.clear_text_content)(dom);
}
let $41d277a885a1af08$var$listening_to_form_reset = false;
function $41d277a885a1af08$export$214872c4fbda6a1e() {
    if (!$41d277a885a1af08$var$listening_to_form_reset) {
        $41d277a885a1af08$var$listening_to_form_reset = true;
        document.addEventListener('reset', (evt)=>{
            // Needs to happen one tick later or else the dom properties of the form
            // elements have not updated to their reset values yet
            Promise.resolve().then(()=>{
                if (!evt.defaultPrevented) for (const e of evt.target.elements)/** @type {any} */ e[0, $8zILj.FORM_RESET_HANDLER]?.();
            });
        }, // In the capture phase to guarantee we get noticed of it (no possibility of stopPropagation)
        {
            capture: true
        });
    }
}

});


parcelRegister("9gIfi", function(module, exports) {

$parcel$export(module.exports, "flatten", () => $6bf7edf0ebca10e5$export$bffa455ba8c619a6);
$parcel$export(module.exports, "unset_context", () => $6bf7edf0ebca10e5$export$5b8ae2049698c031);
$parcel$export(module.exports, "increment_pending", () => $6bf7edf0ebca10e5$export$483c2536b4b2911b);
/** @import { Blocker, Effect, Source, Value } from '#client' */ 
var $8zILj = parcelRequire("8zILj");
parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $6bkva = parcelRequire("6bkva");

var $1u5nX = parcelRequire("1u5nX");

var $egVZE = parcelRequire("egVZE");

var $amPy2 = parcelRequire("amPy2");

var $3oHv7 = parcelRequire("3oHv7");

var $kCMGX = parcelRequire("kCMGX");
function $6bf7edf0ebca10e5$export$bffa455ba8c619a6(blockers, sync, async, fn) {
    const d = (0, $6bkva.is_runes)() ? (0, $3oHv7.derived) : (0, $3oHv7.derived_safe_equal);
    // Filter out already-settled blockers - no need to wait for them
    var pending = blockers.filter((b)=>!b.settled);
    var deriveds = sync.map(d);
    if (0, $7YIuB.default) deriveds.forEach((d, i)=>{
        // TODO this is kinda useful for debugging but a lousy implementation —
        // maybe the compiler could pass through the template string
        d.label = sync[i].toString().replace('() => ', '').replaceAll('$.eager(() => ', '$state.eager(').replace(/\$\.get\((.+?)\)/g, (_, id)=>id);
    });
    if (async.length === 0 && pending.length === 0) {
        fn(deriveds);
        return;
    }
    var parent = /** @type {Effect} */ (0, $egVZE.active_effect);
    var restore = $6bf7edf0ebca10e5$export$6f6534ba0edb1cf4();
    var blocker_promise = pending.length === 1 ? pending[0].promise : pending.length > 1 ? Promise.all(pending.map((b)=>b.promise)) : null;
    /**
	 * @param {Source[]} async
	 */ function finish(async) {
        if ((parent.f & (0, $8zILj.DESTROYED)) !== 0) return;
        restore();
        try {
            fn([
                ...deriveds,
                ...async
            ]);
        } catch (error) {
            (0, $1u5nX.invoke_error_boundary)(error, parent);
        }
        $6bf7edf0ebca10e5$export$5b8ae2049698c031();
    }
    var decrement_pending = $6bf7edf0ebca10e5$export$483c2536b4b2911b();
    // Fast path: blockers but no async expressions
    if (async.length === 0) {
        /** @type {Promise<any>} */ blocker_promise.then(()=>finish([])).finally(decrement_pending);
        return;
    }
    // Full path: has async expressions
    function run() {
        Promise.all(async.map((expression)=>(0, $3oHv7.async_derived)(expression))).then(finish).catch((error)=>(0, $1u5nX.invoke_error_boundary)(error, parent)).finally(decrement_pending);
    }
    if (blocker_promise) blocker_promise.then(()=>{
        restore();
        run();
        $6bf7edf0ebca10e5$export$5b8ae2049698c031();
    });
    else run();
}
function $6bf7edf0ebca10e5$export$78e21497150abde4(blockers, fn) {
    $6bf7edf0ebca10e5$export$bffa455ba8c619a6(blockers, [], [], fn);
}
function $6bf7edf0ebca10e5$export$6f6534ba0edb1cf4() {
    var previous_effect = /** @type {Effect} */ (0, $egVZE.active_effect);
    var previous_reaction = (0, $egVZE.active_reaction);
    var previous_component_context = (0, $6bkva.component_context);
    var previous_batch = /** @type {Batch} */ (0, $amPy2.current_batch);
    if (0, $7YIuB.default) var previous_dev_stack = (0, $6bkva.dev_stack);
    return function restore(activate_batch = true) {
        (0, $egVZE.set_active_effect)(previous_effect);
        (0, $egVZE.set_active_reaction)(previous_reaction);
        (0, $6bkva.set_component_context)(previous_component_context);
        if (activate_batch && (previous_effect.f & (0, $8zILj.DESTROYED)) === 0) {
            // TODO we only need optional chaining here because `{#await ...}` blocks
            // are anomalous. Once we retire them we can get rid of it
            previous_batch?.activate();
            previous_batch?.apply();
        }
        if (0, $7YIuB.default) {
            (0, $3oHv7.set_reactivity_loss_tracker)(null);
            (0, $6bkva.set_dev_stack)(previous_dev_stack);
        }
    };
}
/** `true` between a `save` thunk restoring a context and the end of that synchronous segment */ var $6bf7edf0ebca10e5$var$restored = false;
async function $6bf7edf0ebca10e5$export$a1544dad697b423d(promise) {
    var restore = $6bf7edf0ebca10e5$export$6f6534ba0edb1cf4();
    // the context restored by an earlier `save` in this expression must not
    // outlive the synchronous segment that is about to end at this `await`
    $6bf7edf0ebca10e5$export$6dec0f717fea25b4();
    var value = await promise;
    return ()=>{
        restore();
        $6bf7edf0ebca10e5$var$restored = true;
        return value;
    };
}
function $6bf7edf0ebca10e5$export$6dec0f717fea25b4(value) {
    if ($6bf7edf0ebca10e5$var$restored) $6bf7edf0ebca10e5$export$5b8ae2049698c031();
    return /** @type {T} */ value;
}
async function $6bf7edf0ebca10e5$export$236a663091eb572b(promise) {
    $6bf7edf0ebca10e5$export$6dec0f717fea25b4();
    var previous_reactivity_loss_tracker = (0, $3oHv7.reactivity_loss_tracker);
    // Ensure that unrelated reads after an async operation is kicked off don't cause false positives
    queueMicrotask(()=>{
        if ((0, $3oHv7.reactivity_loss_tracker) === previous_reactivity_loss_tracker) (0, $3oHv7.set_reactivity_loss_tracker)(null);
    });
    var value = await promise;
    return ()=>{
        (0, $3oHv7.set_reactivity_loss_tracker)(previous_reactivity_loss_tracker);
        // While this can result in false negatives it also guards against the more important
        // false positives that would occur if this is the last in a chain of async operations,
        // and the reactivity_loss_tracker would then stay around until the next async operation happens.
        queueMicrotask(()=>{
            if ((0, $3oHv7.reactivity_loss_tracker) === previous_reactivity_loss_tracker) (0, $3oHv7.set_reactivity_loss_tracker)(null);
        });
        return value;
    };
}
async function* $6bf7edf0ebca10e5$export$61ff7372ef21b454(iterable) {
    // This is based on the algorithms described in ECMA-262:
    // ForIn/OfBodyEvaluation
    // https://tc39.es/ecma262/multipage/ecmascript-language-statements-and-declarations.html#sec-runtime-semantics-forin-div-ofbodyevaluation-lhs-stmt-iterator-lhskind-labelset
    // AsyncIteratorClose
    // https://tc39.es/ecma262/multipage/abstract-operations.html#sec-asynciteratorclose
    /** @type {AsyncIterator<T, TReturn>} */ // @ts-ignore
    const iterator = iterable[Symbol.asyncIterator]?.() ?? iterable[Symbol.iterator]?.();
    if (iterator === undefined) throw new TypeError('value is not async iterable');
    // eslint-disable-next-line no-useless-assignment
    let invoke_return = true;
    try {
        while(true){
            const { done: done, value: value } = (await $6bf7edf0ebca10e5$export$236a663091eb572b(iterator.next()))();
            if (done) {
                invoke_return = false;
                break;
            }
            var prev = (0, $3oHv7.reactivity_loss_tracker);
            try {
                yield value;
            } catch (e) {
                (0, $3oHv7.set_reactivity_loss_tracker)(prev);
                // If the yield throws, we need to call `return` but not return its value, instead rethrow
                if (iterator.return !== undefined) (await $6bf7edf0ebca10e5$export$236a663091eb572b(iterator.return()))();
                throw e;
            }
            (0, $3oHv7.set_reactivity_loss_tracker)(prev);
        }
    } catch (error) {
        invoke_return = false;
        throw error;
    } finally{
        // If the iterator had an abrupt completion (break) and `return` is defined on the iterator, call it and return the value
        if (invoke_return && iterator.return !== undefined) // eslint-disable-next-line no-unsafe-finally
        return /** @type {TReturn} */ (await $6bf7edf0ebca10e5$export$236a663091eb572b(iterator.return()))().value;
    }
}
function $6bf7edf0ebca10e5$export$5b8ae2049698c031(deactivate_batch = true) {
    $6bf7edf0ebca10e5$var$restored = false;
    (0, $egVZE.set_active_effect)(null);
    (0, $egVZE.set_active_reaction)(null);
    (0, $6bkva.set_component_context)(null);
    if (deactivate_batch) (0, $amPy2.current_batch)?.deactivate();
    if (0, $7YIuB.default) {
        (0, $3oHv7.set_reactivity_loss_tracker)(null);
        (0, $6bkva.set_dev_stack)(null);
    }
}
function $6bf7edf0ebca10e5$export$889ea624f2cb2c57(thunks) {
    const restore = $6bf7edf0ebca10e5$export$6f6534ba0edb1cf4();
    const decrement_pending = $6bf7edf0ebca10e5$export$483c2536b4b2911b();
    var active = /** @type {Effect} */ (0, $egVZE.active_effect);
    /** @type {null | { error: any }} */ var errored = null;
    /** @param {any} error */ const handle_error = (error)=>{
        errored = {
            error: error
        }; // wrap in object in case a promise rejects with a falsy value
        if (!(0, $kCMGX.aborted)(active)) (0, $1u5nX.invoke_error_boundary)(error, active);
    };
    var promise = Promise.resolve(thunks[0]()).catch(handle_error);
    /** @type {Blocker} */ var blocker = {
        promise: promise,
        settled: false
    };
    var blockers = [
        blocker
    ];
    promise.finally(()=>{
        blocker.settled = true;
        $6bf7edf0ebca10e5$export$5b8ae2049698c031();
    });
    for (const fn of thunks.slice(1)){
        promise = promise.then(()=>{
            restore();
            try {
                if (errored) throw errored.error;
                if ((0, $kCMGX.aborted)(active)) throw 0, $8zILj.STALE_REACTION;
                return fn();
            } finally{
                // We gotta unset context directly in case the function returns a promise, in which case
                // unset_context in .finally() would be too late ...
                $6bf7edf0ebca10e5$export$5b8ae2049698c031();
            }
        }).catch(handle_error);
        const blocker = {
            promise: promise,
            settled: false
        };
        blockers.push(blocker);
        promise.finally(()=>{
            blocker.settled = true;
            // ... but we also need it after such a promise has resolved in case it restores our context
            $6bf7edf0ebca10e5$export$5b8ae2049698c031();
        });
    }
    promise// wait one more tick, so that template effects are
    // guaranteed to run before `$effect(...)`
    .then(()=>Promise.resolve()).finally(decrement_pending);
    return blockers;
}
function $6bf7edf0ebca10e5$export$5c069c93d2b7493f(blockers) {
    return Promise.all(blockers.map((b)=>b.promise));
}
function $6bf7edf0ebca10e5$export$483c2536b4b2911b() {
    var effect = /** @type {Effect} */ (0, $egVZE.active_effect);
    var boundary = effect.b; // undefined if called outside the render tree, e.g. a standalone $effect.root
    var batch = /** @type {Batch} */ (0, $amPy2.current_batch);
    var blocking = !!boundary?.is_rendered();
    boundary?.update_pending_count(1, batch);
    batch.increment(blocking, effect);
    return ()=>{
        boundary?.update_pending_count(-1, batch);
        batch.decrement(blocking, effect);
    };
}

});




parcelRegister("1huCi", function(module, exports) {

$parcel$export(module.exports, "captured_signals", () => $0eef20c998542c91$export$60575837946191ef);
/** @import { Value } from '#client' */ 
var $kmhLl = parcelRequire("kmhLl");

var $egVZE = parcelRequire("egVZE");
let $0eef20c998542c91$export$60575837946191ef = null;
/**
 * Capture an array of all the signals that are read when `fn` is called
 * @template T
 * @param {() => T} fn
 */ function $0eef20c998542c91$var$capture_signals(fn) {
    var previous_captured_signals = $0eef20c998542c91$export$60575837946191ef;
    try {
        $0eef20c998542c91$export$60575837946191ef = new Set();
        (0, $egVZE.untrack)(fn);
        if (previous_captured_signals !== null) for (var signal of $0eef20c998542c91$export$60575837946191ef)previous_captured_signals.add(signal);
        return $0eef20c998542c91$export$60575837946191ef;
    } finally{
        $0eef20c998542c91$export$60575837946191ef = previous_captured_signals;
    }
}
function $0eef20c998542c91$export$84eb53439eae7170(fn) {
    for (var signal of $0eef20c998542c91$var$capture_signals(fn))(0, $kmhLl.internal_set)(signal, signal.v);
}

});



parcelRegister("hR058", function(module, exports) {

$parcel$export(module.exports, "writable", () => $cff7732b0b4b1e28$export$e6d3eada50a007b1);
$parcel$export(module.exports, "derived", () => $cff7732b0b4b1e28$export$90b0b54dab0a340a);
$parcel$export(module.exports, "get", () => $cff7732b0b4b1e28$export$3988ae62b71be9a3);
/** @import { Readable, StartStopNotifier, Subscriber, Unsubscriber, Updater, Writable } from '../public.js' */ /** @import { Stores, StoresValues, SubscribeInvalidateTuple } from '../private.js' */ 
var $btEsq = parcelRequire("btEsq");

var $f09ju = parcelRequire("f09ju");

var $i6Ql7 = parcelRequire("i6Ql7");
/**
 * @type {Array<SubscribeInvalidateTuple<any> | any>}
 */ const $cff7732b0b4b1e28$var$subscriber_queue = [];
function $cff7732b0b4b1e28$export$1e3fc3ecfda8b1c3(value, start) {
    return {
        subscribe: $cff7732b0b4b1e28$export$e6d3eada50a007b1(value, start).subscribe
    };
}
function $cff7732b0b4b1e28$export$e6d3eada50a007b1(value, start = (0, $btEsq.noop)) {
    /** @type {Unsubscriber | null} */ let stop = null;
    /** @type {Set<SubscribeInvalidateTuple<T>>} */ const subscribers = new Set();
    /**
	 * @param {T} new_value
	 * @returns {void}
	 */ function set(new_value) {
        if ((0, $f09ju.safe_not_equal)(value, new_value)) {
            value = new_value;
            if (stop) {
                // store is ready
                const run_queue = !$cff7732b0b4b1e28$var$subscriber_queue.length;
                for (const subscriber of subscribers){
                    subscriber[1]();
                    $cff7732b0b4b1e28$var$subscriber_queue.push(subscriber, value);
                }
                if (run_queue) {
                    for(let i = 0; i < $cff7732b0b4b1e28$var$subscriber_queue.length; i += 2)$cff7732b0b4b1e28$var$subscriber_queue[i][0]($cff7732b0b4b1e28$var$subscriber_queue[i + 1]);
                    $cff7732b0b4b1e28$var$subscriber_queue.length = 0;
                }
            }
        }
    }
    /**
	 * @param {Updater<T>} fn
	 * @returns {void}
	 */ function update(fn) {
        set(fn(/** @type {T} */ value));
    }
    /**
	 * @param {Subscriber<T>} run
	 * @param {() => void} [invalidate]
	 * @returns {Unsubscriber}
	 */ function subscribe(run, invalidate = (0, $btEsq.noop)) {
        /** @type {SubscribeInvalidateTuple<T>} */ const subscriber = [
            run,
            invalidate
        ];
        subscribers.add(subscriber);
        if (subscribers.size === 1) stop = start(set, update) || (0, $btEsq.noop);
        run(/** @type {T} */ value);
        return ()=>{
            subscribers.delete(subscriber);
            if (subscribers.size === 0 && stop) {
                stop();
                stop = null;
            }
        };
    }
    return {
        set: set,
        update: update,
        subscribe: subscribe
    };
}
function $cff7732b0b4b1e28$export$90b0b54dab0a340a(stores, fn, initial_value) {
    const single = !Array.isArray(stores);
    /** @type {Array<Readable<any>>} */ const stores_array = single ? [
        stores
    ] : stores;
    if (!stores_array.every(Boolean)) throw new Error('derived() expects stores as input, got a falsy value');
    const auto = fn.length < 2;
    return $cff7732b0b4b1e28$export$1e3fc3ecfda8b1c3(initial_value, (set, update)=>{
        let started = false;
        /** @type {T[]} */ const values = [];
        let pending = 0;
        let cleanup = (0, $btEsq.noop);
        const sync = ()=>{
            if (pending) return;
            cleanup();
            const result = fn(single ? values[0] : values, set, update);
            if (auto) set(result);
            else cleanup = typeof result === 'function' ? result : (0, $btEsq.noop);
        };
        const unsubscribers = stores_array.map((store, i)=>(0, $i6Ql7.subscribe_to_store)(store, (value)=>{
                values[i] = value;
                pending &= ~(1 << i);
                if (started) sync();
            }, ()=>{
                pending |= 1 << i;
            }));
        started = true;
        sync();
        return function stop() {
            (0, $btEsq.run_all)(unsubscribers);
            cleanup();
            // We need to set this to false because callbacks can still happen despite having unsubscribed:
            // Callbacks might already be placed in the queue which doesn't know it should no longer
            // invoke this derived store.
            started = false;
        };
    });
}
function $cff7732b0b4b1e28$export$6ec456bd5b7b3c51(store) {
    return {
        // @ts-expect-error TODO i suspect the bind is unnecessary
        subscribe: store.subscribe.bind(store)
    };
}
function $cff7732b0b4b1e28$export$3988ae62b71be9a3(store) {
    let value;
    (0, $i6Ql7.subscribe_to_store)(store, (_)=>value = _)();
    // @ts-expect-error
    return value;
}

});
parcelRegister("i6Ql7", function(module, exports) {

$parcel$export(module.exports, "subscribe_to_store", () => $d2f163123bf98820$export$3d3e4662c827882d);
/** @import { Readable } from './public' */ 
var $egVZE = parcelRequire("egVZE");

var $btEsq = parcelRequire("btEsq");
function $d2f163123bf98820$export$3d3e4662c827882d(store, run, invalidate) {
    if (store == null) {
        // @ts-expect-error
        run(undefined);
        // @ts-expect-error
        if (invalidate) invalidate(undefined);
        return 0, $btEsq.noop;
    }
    // Svelte store takes a private second argument
    // StartStopNotifier could mutate state, and we want to silence the corresponding validation error
    const unsub = (0, $egVZE.untrack)(()=>store.subscribe(run, // @ts-expect-error
        invalidate));
    // Also support RxJS
    // @ts-expect-error TODO fix this in the types?
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}

});


parcelRegister("kQ6wH", function(module, exports) {

$parcel$export(module.exports, "createSubscriber", () => $f2bdb9f8b66dff1e$export$48f338a7e080595c);

var $egVZE = parcelRequire("egVZE");

var $kCMGX = parcelRequire("kCMGX");

var $kmhLl = parcelRequire("kmhLl");

var $4Y2WV = parcelRequire("4Y2WV");
parcelRequire("j45IX");
var $7YIuB = parcelRequire("7YIuB");

var $c2wsH = parcelRequire("c2wsH");
function $f2bdb9f8b66dff1e$export$48f338a7e080595c(start) {
    let subscribers = 0;
    let version = (0, $kmhLl.source)(0);
    /** @type {(() => void) | void} */ let stop;
    if (0, $7YIuB.default) (0, $4Y2WV.tag)(version, 'createSubscriber version');
    return ()=>{
        if ((0, $kCMGX.effect_tracking)()) {
            (0, $egVZE.get)(version);
            (0, $kCMGX.render_effect)(()=>{
                if (subscribers === 0) stop = (0, $egVZE.untrack)(()=>start(()=>(0, $kmhLl.increment)(version)));
                subscribers += 1;
                return ()=>{
                    (0, $c2wsH.queue_micro_task)(()=>{
                        // Only count down after a microtask, else we would reach 0 before our own render effect reruns,
                        // but reach 1 again when the tick callback of the prior teardown runs. That would mean we
                        // re-subcribe unnecessarily and create a memory leak because the old subscription is never cleaned up.
                        subscribers -= 1;
                        if (subscribers === 0) {
                            stop?.();
                            stop = undefined;
                            // Increment the version to ensure any dependent deriveds are marked dirty when the subscription is picked up again later.
                            // If we didn't do this then the comparison of write versions would determine that the derived has a later version than
                            // the subscriber, and it would not be re-run.
                            (0, $kmhLl.increment)(version);
                        }
                    });
                };
            });
        }
    };
}

});


parcelRegister("dZhQD", function(module, exports) {
'use strict';
var $a2eed1199ffea6f2$var$isMergeableObject = function isMergeableObject(value) {
    return $a2eed1199ffea6f2$var$isNonNullObject(value) && !$a2eed1199ffea6f2$var$isSpecial(value);
};
function $a2eed1199ffea6f2$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $a2eed1199ffea6f2$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $a2eed1199ffea6f2$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $a2eed1199ffea6f2$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $a2eed1199ffea6f2$var$REACT_ELEMENT_TYPE = $a2eed1199ffea6f2$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $a2eed1199ffea6f2$var$isReactElement(value) {
    return value.$$typeof === $a2eed1199ffea6f2$var$REACT_ELEMENT_TYPE;
}
function $a2eed1199ffea6f2$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $a2eed1199ffea6f2$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $a2eed1199ffea6f2$var$deepmerge($a2eed1199ffea6f2$var$emptyTarget(value), value, options) : value;
}
function $a2eed1199ffea6f2$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $a2eed1199ffea6f2$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $a2eed1199ffea6f2$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $a2eed1199ffea6f2$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $a2eed1199ffea6f2$var$deepmerge;
}
function $a2eed1199ffea6f2$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $a2eed1199ffea6f2$var$getKeys(target) {
    return Object.keys(target).concat($a2eed1199ffea6f2$var$getEnumerableOwnPropertySymbols(target));
}
function $a2eed1199ffea6f2$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $a2eed1199ffea6f2$var$propertyIsUnsafe(target, key) {
    return $a2eed1199ffea6f2$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $a2eed1199ffea6f2$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $a2eed1199ffea6f2$var$getKeys(target).forEach(function(key) {
        destination[key] = $a2eed1199ffea6f2$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $a2eed1199ffea6f2$var$getKeys(source).forEach(function(key) {
        if ($a2eed1199ffea6f2$var$propertyIsUnsafe(target, key)) return;
        if ($a2eed1199ffea6f2$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $a2eed1199ffea6f2$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $a2eed1199ffea6f2$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $a2eed1199ffea6f2$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $a2eed1199ffea6f2$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $a2eed1199ffea6f2$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $a2eed1199ffea6f2$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $a2eed1199ffea6f2$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $a2eed1199ffea6f2$var$mergeObject(target, source, options);
}
$a2eed1199ffea6f2$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $a2eed1199ffea6f2$var$deepmerge(prev, next, options);
    }, {});
};
var $a2eed1199ffea6f2$var$deepmerge_1 = $a2eed1199ffea6f2$var$deepmerge;
module.exports = $a2eed1199ffea6f2$var$deepmerge_1;

});

parcelRegister("f30kt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("afnyo")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $afnyo = parcelRequire("afnyo");


var $af47643a27b8a86e$export$2e2bcd8739ae039 = (0, $afnyo.IntlMessageFormat);

});
parcelRegister("afnyo", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $775d936592fde14f$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $bp3BB = parcelRequire("bp3BB");

var $7aAMG = parcelRequire("7aAMG");

var $3Pnot = parcelRequire("3Pnot");

var $ilsM3 = parcelRequire("ilsM3");
// -- MessageFormat --------------------------------------------------------
function $775d936592fde14f$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $bp3BB.__assign)((0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $775d936592fde14f$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $775d936592fde14f$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $bp3BB.__assign)({}, defaultConfig));
}
function $775d936592fde14f$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $775d936592fde14f$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $7aAMG.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $bp3BB.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $775d936592fde14f$var$createFastMemoizeCache(cache.number),
            strategy: (0, $7aAMG.strategies).variadic
        }),
        getDateTimeFormat: (0, $7aAMG.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $bp3BB.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $775d936592fde14f$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $7aAMG.strategies).variadic
        }),
        getPluralRules: (0, $7aAMG.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $bp3BB.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $775d936592fde14f$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $7aAMG.strategies).variadic
        })
    };
}
var $775d936592fde14f$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $ilsM3.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $ilsM3.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $bp3BB.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $775d936592fde14f$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $775d936592fde14f$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $3Pnot.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("7aAMG", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $538600233769a7f2$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $538600233769a7f2$export$c5491a8691a23b9e);
//
// Main
//
function $538600233769a7f2$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $538600233769a7f2$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $538600233769a7f2$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $538600233769a7f2$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $538600233769a7f2$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $538600233769a7f2$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $538600233769a7f2$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $538600233769a7f2$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $538600233769a7f2$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $538600233769a7f2$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $538600233769a7f2$var$monadic : $538600233769a7f2$var$variadic;
    return $538600233769a7f2$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $538600233769a7f2$var$strategyVariadic(fn, options) {
    return $538600233769a7f2$var$assemble(fn, this, $538600233769a7f2$var$variadic, options.cache.create(), options.serializer);
}
function $538600233769a7f2$var$strategyMonadic(fn, options) {
    return $538600233769a7f2$var$assemble(fn, this, $538600233769a7f2$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $538600233769a7f2$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $538600233769a7f2$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $538600233769a7f2$var$cacheDefault = {
    create: function create() {
        return new $538600233769a7f2$var$ObjectWithoutPrototypeCache();
    }
};
var $538600233769a7f2$export$c5491a8691a23b9e = {
    variadic: $538600233769a7f2$var$strategyVariadic,
    monadic: $538600233769a7f2$var$strategyMonadic
};

});

parcelRegister("3Pnot", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("i1QTk")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("i1QTk")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("i1QTk")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("i1QTk")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("i1QTk")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("i1QTk")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("i1QTk")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("i1QTk")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("i1QTk")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("i1QTk")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("i1QTk")).isTimeElement);

$parcel$export(module.exports, "parse", () => $2c9848040001f0d7$export$98e6a39c04603d36);

var $bp3BB = parcelRequire("bp3BB");

var $aQqd8 = parcelRequire("aQqd8");

var $bgymQ = parcelRequire("bgymQ");

var $i1QTk = parcelRequire("i1QTk");

var $13zab = parcelRequire("13zab");
function $2c9848040001f0d7$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $i1QTk.isSelectElement)(el) || (0, $i1QTk.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $2c9848040001f0d7$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $i1QTk.isNumberElement)(el) && (0, $i1QTk.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $i1QTk.isDateElement)(el) || (0, $i1QTk.isTimeElement)(el)) && (0, $i1QTk.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $i1QTk.isTagElement)(el)) $2c9848040001f0d7$var$pruneLocation(el.children);
    });
}
function $2c9848040001f0d7$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $bp3BB.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $bgymQ.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $aQqd8.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $2c9848040001f0d7$var$pruneLocation(result.val);
    return result.val;
}
var $2c9848040001f0d7$export$d3c1bfa0f7d806e9 = (0, $bgymQ.Parser);

});
parcelRegister("aQqd8", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $7e5317a87d91d451$export$896afd8541959ee5);
var $7e5317a87d91d451$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($7e5317a87d91d451$export$896afd8541959ee5 || ($7e5317a87d91d451$export$896afd8541959ee5 = {}));

});

parcelRegister("bgymQ", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $833bd8fbf248b8f1$export$7acfa6ed01010e37);

var $bp3BB = parcelRequire("bp3BB");

var $aQqd8 = parcelRequire("aQqd8");

var $i1QTk = parcelRequire("i1QTk");

var $7nRob = parcelRequire("7nRob");
parcelRequire("eTFLq");
var $7VzF6 = parcelRequire("7VzF6");
var $e8sz2 = parcelRequire("e8sz2");

var $g3ff8 = parcelRequire("g3ff8");
var $833bd8fbf248b8f1$var$_a;
var $833bd8fbf248b8f1$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $7nRob.SPACE_SEPARATOR_REGEX).source, "*"));
var $833bd8fbf248b8f1$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $7nRob.SPACE_SEPARATOR_REGEX).source, "*$"));
function $833bd8fbf248b8f1$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $833bd8fbf248b8f1$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $833bd8fbf248b8f1$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $833bd8fbf248b8f1$var$hasNativeFromEntries = !!Object.fromEntries;
var $833bd8fbf248b8f1$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $833bd8fbf248b8f1$var$hasTrimStart = !!String.prototype.trimStart;
var $833bd8fbf248b8f1$var$hasTrimEnd = !!String.prototype.trimEnd;
var $833bd8fbf248b8f1$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $833bd8fbf248b8f1$var$isSafeInteger = $833bd8fbf248b8f1$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $833bd8fbf248b8f1$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $833bd8fbf248b8f1$var$re = $833bd8fbf248b8f1$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $833bd8fbf248b8f1$var$REGEX_SUPPORTS_U_AND_Y = (($833bd8fbf248b8f1$var$_a = $833bd8fbf248b8f1$var$re.exec('a')) === null || $833bd8fbf248b8f1$var$_a === void 0 ? void 0 : $833bd8fbf248b8f1$var$_a[0]) === 'a';
} catch (_) {
    $833bd8fbf248b8f1$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $833bd8fbf248b8f1$var$startsWith = $833bd8fbf248b8f1$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $833bd8fbf248b8f1$var$fromCodePoint = $833bd8fbf248b8f1$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $833bd8fbf248b8f1$var$fromEntries = // native
$833bd8fbf248b8f1$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $833bd8fbf248b8f1$var$codePointAt = $833bd8fbf248b8f1$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $833bd8fbf248b8f1$var$trimStart = $833bd8fbf248b8f1$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($833bd8fbf248b8f1$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $833bd8fbf248b8f1$var$trimEnd = $833bd8fbf248b8f1$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($833bd8fbf248b8f1$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $833bd8fbf248b8f1$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $833bd8fbf248b8f1$var$matchIdentifierAtIndex;
if ($833bd8fbf248b8f1$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $833bd8fbf248b8f1$var$IDENTIFIER_PREFIX_RE_1 = $833bd8fbf248b8f1$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $833bd8fbf248b8f1$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $833bd8fbf248b8f1$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $833bd8fbf248b8f1$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$833bd8fbf248b8f1$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $833bd8fbf248b8f1$var$codePointAt(s, index);
        if (c === undefined || $833bd8fbf248b8f1$var$_isWhiteSpace(c) || $833bd8fbf248b8f1$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $833bd8fbf248b8f1$var$fromCodePoint.apply(void 0, match);
};
var $833bd8fbf248b8f1$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $i1QTk.TYPE).pound,
                    location: $833bd8fbf248b8f1$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $aQqd8.ErrorKind).UNMATCHED_CLOSING_TAG, $833bd8fbf248b8f1$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $833bd8fbf248b8f1$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $i1QTk.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $833bd8fbf248b8f1$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$833bd8fbf248b8f1$var$_isAlpha(this.char())) return this.error((0, $aQqd8.ErrorKind).INVALID_TAG, $833bd8fbf248b8f1$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $aQqd8.ErrorKind).UNMATCHED_CLOSING_TAG, $833bd8fbf248b8f1$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $aQqd8.ErrorKind).INVALID_TAG, $833bd8fbf248b8f1$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $i1QTk.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $833bd8fbf248b8f1$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $aQqd8.ErrorKind).UNCLOSED_TAG, $833bd8fbf248b8f1$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $aQqd8.ErrorKind).INVALID_TAG, $833bd8fbf248b8f1$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $833bd8fbf248b8f1$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $833bd8fbf248b8f1$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $i1QTk.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$833bd8fbf248b8f1$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $833bd8fbf248b8f1$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $833bd8fbf248b8f1$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $aQqd8.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $aQqd8.ErrorKind).EMPTY_ARGUMENT, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $aQqd8.ErrorKind).MALFORMED_ARGUMENT, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $aQqd8.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $i1QTk.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $aQqd8.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $aQqd8.ErrorKind).MALFORMED_ARGUMENT, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $833bd8fbf248b8f1$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $833bd8fbf248b8f1$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $aQqd8.ErrorKind).EXPECT_ARGUMENT_TYPE, $833bd8fbf248b8f1$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $833bd8fbf248b8f1$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $aQqd8.ErrorKind).EXPECT_ARGUMENT_STYLE, $833bd8fbf248b8f1$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $833bd8fbf248b8f1$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $833bd8fbf248b8f1$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $833bd8fbf248b8f1$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $i1QTk.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $aQqd8.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $g3ff8.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $i1QTk.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $7VzF6.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $i1QTk.TYPE).date : (0, $i1QTk.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $i1QTk.TYPE).number : argType === 'date' ? (0, $i1QTk.TYPE).date : (0, $i1QTk.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $aQqd8.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $833bd8fbf248b8f1$var$createLocation(typeEndPosition_1, (0, $bp3BB.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $aQqd8.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $833bd8fbf248b8f1$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $aQqd8.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $aQqd8.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $i1QTk.TYPE).select,
                        value: value,
                        options: $833bd8fbf248b8f1$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $i1QTk.TYPE).plural,
                        value: value,
                        options: $833bd8fbf248b8f1$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $aQqd8.ErrorKind).INVALID_ARGUMENT_TYPE, $833bd8fbf248b8f1$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $aQqd8.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $aQqd8.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $833bd8fbf248b8f1$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $e8sz2.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $aQqd8.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $i1QTk.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $e8sz2.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $aQqd8.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $aQqd8.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $833bd8fbf248b8f1$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $aQqd8.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $aQqd8.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $aQqd8.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $aQqd8.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $833bd8fbf248b8f1$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $833bd8fbf248b8f1$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $aQqd8.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $aQqd8.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $833bd8fbf248b8f1$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $aQqd8.ErrorKind).MISSING_OTHER_CLAUSE, $833bd8fbf248b8f1$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $833bd8fbf248b8f1$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$833bd8fbf248b8f1$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $833bd8fbf248b8f1$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($833bd8fbf248b8f1$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $833bd8fbf248b8f1$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $833bd8fbf248b8f1$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $833bd8fbf248b8f1$var$_isAlphaOrSlash(codepoint) {
    return $833bd8fbf248b8f1$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $833bd8fbf248b8f1$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $833bd8fbf248b8f1$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $833bd8fbf248b8f1$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("i1QTk", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $d201591c5d95ede5$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $d201591c5d95ede5$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $d201591c5d95ede5$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $d201591c5d95ede5$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $d201591c5d95ede5$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $d201591c5d95ede5$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $d201591c5d95ede5$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $d201591c5d95ede5$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $d201591c5d95ede5$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $d201591c5d95ede5$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $d201591c5d95ede5$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $d201591c5d95ede5$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $d201591c5d95ede5$export$7680c41f1a55f4cf);
var $d201591c5d95ede5$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($d201591c5d95ede5$export$b87f371cbc396fcf || ($d201591c5d95ede5$export$b87f371cbc396fcf = {}));
var $d201591c5d95ede5$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($d201591c5d95ede5$export$906452485466fa53 || ($d201591c5d95ede5$export$906452485466fa53 = {}));
function $d201591c5d95ede5$export$cfa10c5697238752(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.literal;
}
function $d201591c5d95ede5$export$4f55724281bdfaf9(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.argument;
}
function $d201591c5d95ede5$export$e11187b219e191e1(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.number;
}
function $d201591c5d95ede5$export$32d811605da75f40(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.date;
}
function $d201591c5d95ede5$export$34ec46f596b1702f(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.time;
}
function $d201591c5d95ede5$export$dcfe1c11d168b5a1(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.select;
}
function $d201591c5d95ede5$export$6c796d116f0a4fbc(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.plural;
}
function $d201591c5d95ede5$export$c0ece297bdd0c082(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.pound;
}
function $d201591c5d95ede5$export$5c83de34745812b(el) {
    return el.type === $d201591c5d95ede5$export$b87f371cbc396fcf.tag;
}
function $d201591c5d95ede5$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $d201591c5d95ede5$export$906452485466fa53.number);
}
function $d201591c5d95ede5$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $d201591c5d95ede5$export$906452485466fa53.dateTime);
}
function $d201591c5d95ede5$export$f0ac572c1121c662(value) {
    return {
        type: $d201591c5d95ede5$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $d201591c5d95ede5$export$425e864b0ba114f1(value, style) {
    return {
        type: $d201591c5d95ede5$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("7nRob", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $5604185c011baf35$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $5604185c011baf35$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $5604185c011baf35$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("eTFLq", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("7VzF6")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("e8sz2")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("e8sz2")).parseNumberSkeletonFromString);
parcelRequire("7VzF6");
parcelRequire("e8sz2");

});
parcelRegister("7VzF6", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $5c5984fc812302bd$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $5c5984fc812302bd$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $5c5984fc812302bd$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($5c5984fc812302bd$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("e8sz2", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $a4a7f84bb3be8a34$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $a4a7f84bb3be8a34$export$47c6f8480bda3e11);

var $bp3BB = parcelRequire("bp3BB");

var $6lDPo = parcelRequire("6lDPo");
function $a4a7f84bb3be8a34$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $6lDPo.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $a4a7f84bb3be8a34$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $a4a7f84bb3be8a34$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $a4a7f84bb3be8a34$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $a4a7f84bb3be8a34$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $a4a7f84bb3be8a34$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $a4a7f84bb3be8a34$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($a4a7f84bb3be8a34$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $a4a7f84bb3be8a34$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $a4a7f84bb3be8a34$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$a4a7f84bb3be8a34$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $a4a7f84bb3be8a34$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $a4a7f84bb3be8a34$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $a4a7f84bb3be8a34$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $a4a7f84bb3be8a34$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, all), $a4a7f84bb3be8a34$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, all), $a4a7f84bb3be8a34$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($a4a7f84bb3be8a34$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($a4a7f84bb3be8a34$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($a4a7f84bb3be8a34$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($a4a7f84bb3be8a34$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), $a4a7f84bb3be8a34$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($a4a7f84bb3be8a34$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), $a4a7f84bb3be8a34$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $a4a7f84bb3be8a34$var$parseSign(token.stem);
        if (signOpts) result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $a4a7f84bb3be8a34$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $bp3BB.__assign)((0, $bp3BB.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("6lDPo", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $49f3993ae6b12ac2$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $49f3993ae6b12ac2$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("g3ff8", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $baf8c01fccda0e12$export$29c5368be8904d27);

var $4Hxhf = parcelRequire("4Hxhf");
function $baf8c01fccda0e12$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $baf8c01fccda0e12$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $baf8c01fccda0e12$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $4Hxhf.timeData)[regionTag || ''] || (0, $4Hxhf.timeData)[languageTag || ''] || (0, $4Hxhf.timeData)["".concat(languageTag, "-001")] || (0, $4Hxhf.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("4Hxhf", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $36c4fdb65d5d62da$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $36c4fdb65d5d62da$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("13zab", function(module, exports) {

var $bp3BB = parcelRequire("bp3BB");

var $i1QTk = parcelRequire("i1QTk");
function $0c5158efcd8520b3$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $bp3BB.__spreadArray)([], obj.map($0c5158efcd8520b3$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $0c5158efcd8520b3$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $0c5158efcd8520b3$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $0c5158efcd8520b3$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $0c5158efcd8520b3$export$be5687ba8bbdf416((0, $bp3BB.__spreadArray)((0, $bp3BB.__spreadArray)((0, $bp3BB.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $0c5158efcd8520b3$var$isPluralOrSelectElement(el) {
    return (0, $i1QTk.isPluralElement)(el) || (0, $i1QTk.isSelectElement)(el);
}
function $0c5158efcd8520b3$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($0c5158efcd8520b3$var$isPluralOrSelectElement(el)) return true;
        if ((0, $i1QTk.isTagElement)(el)) return $0c5158efcd8520b3$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $0c5158efcd8520b3$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($0c5158efcd8520b3$var$isPluralOrSelectElement(el)) return [
            $0c5158efcd8520b3$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $i1QTk.isTagElement)(el) && $0c5158efcd8520b3$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $0c5158efcd8520b3$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $i1QTk.isArgumentElement)(el) || (0, $i1QTk.isDateElement)(el) || (0, $i1QTk.isTimeElement)(el) || (0, $i1QTk.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $i1QTk.isPluralElement)(el) || (0, $i1QTk.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $0c5158efcd8520b3$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $i1QTk.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $0c5158efcd8520b3$var$collectVariables(el.children, vars);
        }
    });
}
function $0c5158efcd8520b3$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $0c5158efcd8520b3$var$collectVariables(a, aVars);
    $0c5158efcd8520b3$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $i1QTk.TYPE)[type], " vs ").concat((0, $i1QTk.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("ilsM3", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $d5b0821983e47379$export$49694c2877b44c57);
$parcel$export(module.exports, "formatToParts", () => $d5b0821983e47379$export$275d4a3bb5f66fda);
parcelRequire("3Pnot");
var $i1QTk = parcelRequire("i1QTk");

var $8zpCU = parcelRequire("8zpCU");
var $d5b0821983e47379$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($d5b0821983e47379$export$49694c2877b44c57 || ($d5b0821983e47379$export$49694c2877b44c57 = {}));
function $d5b0821983e47379$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $d5b0821983e47379$export$49694c2877b44c57.literal || part.type !== $d5b0821983e47379$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $d5b0821983e47379$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $d5b0821983e47379$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $i1QTk.isLiteralElement)(els[0])) return [
        {
            type: $d5b0821983e47379$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $i1QTk.isLiteralElement)(el)) {
            result.push({
                type: $d5b0821983e47379$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $i1QTk.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $d5b0821983e47379$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $8zpCU.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $i1QTk.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $d5b0821983e47379$export$49694c2877b44c57.literal : $d5b0821983e47379$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $i1QTk.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $i1QTk.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $d5b0821983e47379$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $i1QTk.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $i1QTk.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $d5b0821983e47379$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $i1QTk.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $i1QTk.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $d5b0821983e47379$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $i1QTk.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$d5b0821983e47379$export$df0c12a2d414a163(formatFn)) throw new (0, $8zpCU.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $d5b0821983e47379$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $d5b0821983e47379$export$49694c2877b44c57.literal : $d5b0821983e47379$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $i1QTk.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $8zpCU.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d5b0821983e47379$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $i1QTk.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $8zpCU.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $8zpCU.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $8zpCU.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d5b0821983e47379$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $d5b0821983e47379$var$mergeLiteral(result);
}

});
parcelRegister("8zpCU", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $63d5788075118f91$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $63d5788075118f91$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $63d5788075118f91$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $63d5788075118f91$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $63d5788075118f91$export$8bfc137e4d23fdf0);

var $bp3BB = parcelRequire("bp3BB");
var $63d5788075118f91$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($63d5788075118f91$export$d4e71bc0b80dc0fb || ($63d5788075118f91$export$d4e71bc0b80dc0fb = {}));
var $63d5788075118f91$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $bp3BB.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $63d5788075118f91$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $bp3BB.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $63d5788075118f91$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($63d5788075118f91$export$7369836851cc1329);
var $63d5788075118f91$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $bp3BB.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $63d5788075118f91$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($63d5788075118f91$export$7369836851cc1329);
var $63d5788075118f91$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $bp3BB.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $63d5788075118f91$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($63d5788075118f91$export$7369836851cc1329);

});





parcelRegister("8FKcp", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $6505fd3b0ba6e099$export$ac4959f4f1338dfc);

var $a0boq = parcelRequire("a0boq");
let $6505fd3b0ba6e099$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $6505fd3b0ba6e099$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let safeByteCutoff = 256 - 256 % alphabet.length;
    if (safeByteCutoff === 256) {
        let mask = alphabet.length - 1;
        return (size = defaultSize)=>{
            if (!size) return '';
            let id = '';
            while(true){
                let bytes = getRandom(size);
                let j = size;
                while(j--){
                    id += alphabet[bytes[j] & mask];
                    if (id.length >= size) return id;
                }
            }
        };
    }
    let step = Math.ceil(409.6 * defaultSize / safeByteCutoff);
    return (size = defaultSize)=>{
        if (!size) return '';
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--)if (bytes[j] < safeByteCutoff) {
                id += alphabet[bytes[j] % alphabet.length];
                if (id.length >= size) return id;
            }
        }
    };
};
let $6505fd3b0ba6e099$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$6505fd3b0ba6e099$export$a5cee9e955a615e5(alphabet, size | 0, $6505fd3b0ba6e099$export$4385e60b38654f68);
let $6505fd3b0ba6e099$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $a0boq.urlAlphabet)[bytes[size] & 63];
    return id;
};

});
parcelRegister("a0boq", function(module, exports) {

$parcel$export(module.exports, "urlAlphabet", () => $7482bddf18f59726$export$2b646eea95309f00);
let $7482bddf18f59726$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});


parcelRegister("a6eMa", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(self, ()=>(()=>{
        var e = {
            2115 (e, t, r) {
                "use strict";
                const { assert: s, clone: n, deepEqual: a, merge: o } = r(3115), i = r(2130), l = r(9415), c = r(3541), u = r(8013), f = r(2062), m = r(9017), h = r(6162), p = r(5844), d = r(8529), g = r(125), y = r(1190), b = r(6220), _ = {
                    standardTypes: new Set([
                        "string",
                        "number",
                        "integer",
                        "boolean",
                        "object",
                        "array",
                        "null"
                    ]),
                    jsonSchemaTarget: "draft-2020-12",
                    primitiveTypes: new Set([
                        "string",
                        "number",
                        "boolean"
                    ]),
                    nullSchema: ()=>({
                            type: "null"
                        }),
                    Base: class {
                        constructor(e){
                            this.type = e, this.$_root = null, this._definition = {}, this._reset();
                        }
                        _reset() {
                            this._ids = new p.Ids, this._preferences = null, this._refs = new d.Manager, this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map, this.$_terms = {}, this.$_temp = {
                                ruleset: null,
                                whens: {}
                            };
                        }
                        describe() {
                            return s("function" == typeof m.describe, "Manifest functionality disabled"), m.describe(this);
                        }
                        $_jsonSchema(e, t = {}) {
                            var r;
                            if (void 0 !== t.target && t.target !== _.jsonSchemaTarget) throw new Error(`Unsupported JSON Schema target: ${t.target}`);
                            const s = !t.$defs, n = null !== (r = t.$defs) && void 0 !== r ? r : {};
                            let o = {};
                            const i = "any" === this.type, c = this._flags.only, u = this._valids && Array.from(this._valids._values).filter((e)=>null !== e);
                            let f = !0;
                            if (u && u.length && c && !i) {
                                const e = new Set(u.map((e)=>typeof e));
                                f = e.has(this.type) || "date" === this.type && e.has("object");
                            }
                            !i && f && _.standardTypes.has(this.type) && (o.type = this.type), this._flags.description && (o.description = this._flags.description), void 0 !== this._flags.default && "function" != typeof this._flags.default && (o.default = this._flags.default);
                            const m = {
                                ...t,
                                $defs: n
                            };
                            this._definition.jsonSchema && f && (o = this._definition.jsonSchema(this, o, e, m));
                            for (const t of this._rules){
                                const r = this._definition.rules[t.name];
                                r.jsonSchema && f && !t._resolve.length && (o = r.jsonSchema(t, o, c, e, m));
                            }
                            if (this.$_terms.shared) for (const t of this.$_terms.shared)n[t._flags.id] = t.$_jsonSchema(e, m);
                            if (s && Object.keys(n).length && (o.$defs = n), this._valids) {
                                const e = u.filter((e)=>"symbol" != typeof e);
                                if (e.length) {
                                    if (this._flags.only) {
                                        o.enum = e;
                                        const t = l.intersect(new Set(e.map((e)=>typeof e)), _.primitiveTypes);
                                        if (t.size) {
                                            const e = [
                                                ...t
                                            ];
                                            o.type = 1 === e.length ? e[0] : e;
                                        }
                                    } else {
                                        const t = e.filter((e)=>typeof e !== this.type || i);
                                        !t.length || i && !c || (o.anyOf || (o = {
                                            anyOf: [
                                                o
                                            ]
                                        }), o.anyOf.push({
                                            enum: t
                                        }));
                                    }
                                }
                            }
                            if (this._valids && this._valids.has(null) && (!i || c) && (1 === this._valids.length && (i || c) ? o.type = "null" : o.type ? o.type = [
                                o.type,
                                "null"
                            ] : o.anyOf ? o.anyOf.unshift(_.nullSchema()) : o = {
                                anyOf: [
                                    _.nullSchema(),
                                    o
                                ]
                            }), this.$_terms.whens) {
                                const t = this.clone();
                                t.$_terms.whens = null;
                                const r = [];
                                for (const s of this.$_terms.whens){
                                    const n = s.is ? [
                                        s
                                    ] : s.switch;
                                    for(let s = 0; s < n.length; ++s){
                                        const a = n[s];
                                        a.then && r.push(t.concat(a.then).$_jsonSchema(e, m)), a.otherwise && r.push(t.concat(a.otherwise).$_jsonSchema(e, m)), a.then && (s !== n.length - 1 || a.otherwise) || r.push(t.$_jsonSchema(e, m));
                                    }
                                }
                                const s = [];
                                for (const e of r)s.some((t)=>a(t, e)) || s.push(e);
                                return {
                                    anyOf: s
                                };
                            }
                            return o;
                        }
                        allow(...e) {
                            return l.verifyFlat(e, "allow"), this._values(e, "_valids");
                        }
                        alter(e) {
                            s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
                            const t = this.clone();
                            t.$_terms.alterations = t.$_terms.alterations || [];
                            for (const r of Object.keys(e)){
                                const n = e[r];
                                s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                                    target: r,
                                    adjuster: n
                                });
                            }
                            return t.$_temp.ruleset = !1, t;
                        }
                        artifact(e) {
                            return s(void 0 !== e, "Artifact cannot be undefined"), s(!this._cache, "Cannot set an artifact with a rule cache"), this.$_setFlag("artifact", e);
                        }
                        cast(e) {
                            return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
                        }
                        default(e, t) {
                            return this._default("default", e, t);
                        }
                        description(e) {
                            return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
                        }
                        empty(e) {
                            const t = this.clone();
                            return void 0 !== e && (e = t.$_compile(e, {
                                override: !1
                            })), t.$_setFlag("empty", e, {
                                clone: !1
                            });
                        }
                        error(e) {
                            return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
                        }
                        example(e, t = {}) {
                            return s(void 0 !== e, "Missing example"), l.assertOptions(t, [
                                "override"
                            ]), this._inner("examples", e, {
                                single: !0,
                                override: t.override
                            });
                        }
                        external(e, t) {
                            return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                                method: e,
                                description: t
                            }, {
                                single: !0
                            });
                        }
                        failover(e, t) {
                            return this._default("failover", e, t);
                        }
                        forbidden() {
                            return this.presence("forbidden");
                        }
                        id(e) {
                            return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
                        }
                        invalid(...e) {
                            return this._values(e, "_invalids");
                        }
                        label(e) {
                            return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
                        }
                        meta(e) {
                            return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                                single: !0
                            });
                        }
                        note(...e) {
                            s(e.length, "Missing notes");
                            for (const t of e)s(t && "string" == typeof t, "Notes must be non-empty strings");
                            return this._inner("notes", e);
                        }
                        only(e = !0) {
                            return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
                        }
                        optional() {
                            return this.presence("optional");
                        }
                        prefs(e) {
                            s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
                            const t = this.clone();
                            return t._preferences = l.preferences(t._preferences, e), t;
                        }
                        presence(e) {
                            return s([
                                "optional",
                                "required",
                                "forbidden"
                            ].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
                        }
                        raw(e = !0) {
                            return this.$_setFlag("result", e ? "raw" : void 0);
                        }
                        result(e) {
                            return s([
                                "raw",
                                "strip"
                            ].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
                        }
                        required() {
                            return this.presence("required");
                        }
                        strict(e) {
                            const t = this.clone(), r = void 0 !== e && !e;
                            return t._preferences = l.preferences(t._preferences, {
                                convert: r
                            }), t;
                        }
                        strip(e = !0) {
                            return this.$_setFlag("result", e ? "strip" : void 0);
                        }
                        tag(...e) {
                            s(e.length, "Missing tags");
                            for (const t of e)s(t && "string" == typeof t, "Tags must be non-empty strings");
                            return this._inner("tags", e);
                        }
                        unit(e) {
                            return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
                        }
                        valid(...e) {
                            l.verifyFlat(e, "valid");
                            const t = this.allow(...e);
                            return t.$_setFlag("only", !!t._valids, {
                                clone: !1
                            }), t;
                        }
                        when(e, t) {
                            const r = this.clone();
                            r.$_terms.whens || (r.$_terms.whens = []);
                            const n = c.when(r, e, t);
                            if (![
                                "any",
                                "link"
                            ].includes(r.type)) {
                                const e = n.is ? [
                                    n
                                ] : n.switch;
                                for (const t of e)s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
                            }
                            return r.$_terms.whens.push(n), r.$_mutateRebuild();
                        }
                        cache(e) {
                            s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache"), s(void 0 === this._flags.artifact, "Cannot cache a rule with an artifact");
                            const t = this.clone();
                            return t._cache = e || i.provider.provision(), t.$_temp.ruleset = !1, t;
                        }
                        clone() {
                            const e = Object.create(Object.getPrototypeOf(this));
                            return this._assign(e);
                        }
                        concat(e) {
                            s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
                            let t = this.clone();
                            if ("any" === this.type && "any" !== e.type) {
                                const r = e.clone();
                                for (const e of Object.keys(t))"type" !== e && (r[e] = t[e]);
                                t = r;
                            }
                            t._ids.concat(e._ids), t._refs.register(e, d.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
                            for (const r of e._singleRules.keys())t._singleRules.has(r) && (t._rules = t._rules.filter((e)=>e.keep || e.name !== r), t._singleRules.delete(r));
                            for (const r of e._rules)e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);
                            if (t._flags.empty && e._flags.empty) {
                                t._flags.empty = t._flags.empty.concat(e._flags.empty);
                                const r = Object.assign({}, e._flags);
                                delete r.empty, o(t._flags, r);
                            } else if (e._flags.empty) {
                                t._flags.empty = e._flags.empty;
                                const r = Object.assign({}, e._flags);
                                delete r.empty, o(t._flags, r);
                            } else o(t._flags, e._flags);
                            for (const r of Object.keys(e.$_terms)){
                                const s = e.$_terms[r];
                                s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
                            }
                            return this.$_root._tracer && this.$_root._tracer._combine(t, [
                                this,
                                e
                            ]), t.$_mutateRebuild();
                        }
                        extend(e) {
                            return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
                        }
                        extract(e) {
                            return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
                        }
                        fork(e, t) {
                            s(!this._inRuleset(), "Cannot fork inside a ruleset");
                            let r = this;
                            for (let s of [].concat(e))s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);
                            return r.$_temp.ruleset = !1, r;
                        }
                        isAsync() {
                            var e;
                            if (Boolean(null === (e = this.$_terms.externals) || void 0 === e ? void 0 : e.length)) return !0;
                            if (this.$_terms.whens) for (const e of this.$_terms.whens){
                                var t, r;
                                if (null !== (t = e.then) && void 0 !== t && t.isAsync()) return !0;
                                if (null !== (r = e.otherwise) && void 0 !== r && r.isAsync()) return !0;
                                if (e.switch) for (const t of e.switch){
                                    var s, n;
                                    if (null !== (s = t.then) && void 0 !== s && s.isAsync()) return !0;
                                    if (null !== (n = t.otherwise) && void 0 !== n && n.isAsync()) return !0;
                                }
                            }
                            return !1;
                        }
                        rule(e) {
                            const t = this._definition;
                            l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
                            const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
                            s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
                            const a = this.clone();
                            for(let o = r; o < a._rules.length; ++o){
                                const r = a._rules[o], i = n(r);
                                for (const n of Object.keys(e))t.modifiers[n](i, e[n]), s(i.name === r.name, "Cannot change rule name");
                                a._rules[o] = i, a._singleRules.get(i.name) === r && a._singleRules.set(i.name, i);
                            }
                            return a.$_temp.ruleset = !1, a.$_mutateRebuild();
                        }
                        get ruleset() {
                            s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
                            const e = this.clone();
                            return e.$_temp.ruleset = e._rules.length, e;
                        }
                        get $() {
                            return this.ruleset;
                        }
                        tailor(e) {
                            e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
                            let t = this;
                            if (this.$_terms.alterations) for (const { target: r, adjuster: n } of this.$_terms.alterations)e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
                            return t = t.$_modify({
                                each: (t)=>t.tailor(e),
                                ref: !1
                            }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
                        }
                        tracer() {
                            return g.location ? g.location(this) : this;
                        }
                        validate(e, t) {
                            return y.entry(e, this, t);
                        }
                        validateAsync(e, t) {
                            return y.entryAsync(e, this, t);
                        }
                        $_addRule(e) {
                            "string" == typeof e && (e = {
                                name: e
                            }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");
                            for (const t of Object.keys(e))s("_" !== t[0], "Cannot set private rule properties");
                            const t = Object.assign({}, e);
                            t._resolve = [], t.method = t.method || t.name;
                            const r = this._definition.rules[t.method], n = t.args;
                            s(r, "Unknown rule", t.method);
                            const a = this.clone();
                            if (n) {
                                const e = Object.keys(n);
                                s(1 === e.length || e.length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);
                                for (const o of e){
                                    let e = n[o];
                                    if (r.argsByName) {
                                        const i = r.argsByName.get(o);
                                        if (i.ref && l.isResolvable(e)) t._resolve.push(o), a.$_mutateRegister(e);
                                        else if (i.normalize && (e = i.normalize(e), n[o] = e), i.assert) {
                                            const t = l.validateArg(e, o, i);
                                            s(!t, t, "or reference");
                                        }
                                    }
                                    void 0 !== e ? n[o] = e : delete n[o];
                                }
                            }
                            return r.multi || (a._ruleRemove(t.name, {
                                clone: !1
                            }), a._singleRules.set(t.name, t)), !1 === a.$_temp.ruleset && (a.$_temp.ruleset = null), r.priority ? a._rules.unshift(t) : a._rules.push(t), a;
                        }
                        $_compile(e, t) {
                            return c.schema(this.$_root, e, t);
                        }
                        $_createError(e, t, r, s, n, a = {}) {
                            const o = !1 !== a.flags ? this._flags : {}, i = a.messages ? h.merge(this._definition.messages, a.messages) : this._definition.messages;
                            return new u.Report(e, t, r, o, i, s, n);
                        }
                        $_getFlag(e) {
                            return this._flags[e];
                        }
                        $_getRule(e) {
                            return this._singleRules.get(e);
                        }
                        $_mapLabels(e) {
                            return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
                        }
                        $_match(e, t, r, s) {
                            (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
                            const n = !y.validate(e, this, t, r, s).errors;
                            return t.restore(), n;
                        }
                        $_modify(e) {
                            return l.assertOptions(e, [
                                "each",
                                "once",
                                "ref",
                                "schema"
                            ]), p.schema(this, e) || this;
                        }
                        $_mutateRebuild() {
                            return s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset(), this.$_modify({
                                each: (e, { source: t, name: r, path: s, key: n })=>{
                                    const a = this._definition[t][r] && this._definition[t][r].register;
                                    !1 !== a && this.$_mutateRegister(e, {
                                        family: a,
                                        key: n
                                    });
                                }
                            }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
                        }
                        $_mutateRegister(e, { family: t, key: r } = {}) {
                            this._refs.register(e, t), this._ids.register(e, {
                                key: r
                            });
                        }
                        $_property(e) {
                            return this._definition.properties[e];
                        }
                        $_reach(e) {
                            return this._ids.reach(e);
                        }
                        $_rootReferences() {
                            return this._refs.roots();
                        }
                        $_setFlag(e, t, r = {}) {
                            s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
                            const n = this._definition.flags[e] || {};
                            if (a(t, n.default) && (t = void 0), a(t, this._flags[e])) return this;
                            const o = !1 !== r.clone ? this.clone() : this;
                            return void 0 !== t ? (o._flags[e] = t, o.$_mutateRegister(t)) : delete o._flags[e], "_" !== e[0] && (o.$_temp.ruleset = !1), o;
                        }
                        $_parent(e, ...t) {
                            return this[e][l.symbols.parent].call(this, ...t);
                        }
                        $_validate(e, t, r) {
                            return y.validate(e, this, t, r);
                        }
                        _assign(e) {
                            e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = new Map(this._singleRules), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};
                            for (const t of Object.keys(this.$_terms))e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;
                            if (e.$_super = {}, this.$_super) for (const t of Object.keys(this.$_super))e.$_super[t] = this._super[t].bind(e);
                            return e;
                        }
                        _bare() {
                            const e = this.clone();
                            e._reset();
                            const t = e._definition.terms;
                            for (const r of Object.keys(t)){
                                const s = t[r];
                                e.$_terms[r] = s.init;
                            }
                            return e.$_mutateRebuild();
                        }
                        _default(e, t, r = {}) {
                            return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                                [l.symbols.literal]: !0,
                                literal: t
                            }), this.$_setFlag(e, t);
                        }
                        _generate(e, t, r) {
                            if (!this.$_terms.whens) return {
                                schema: this
                            };
                            const s = [], n = [];
                            for(let a = 0; a < this.$_terms.whens.length; ++a){
                                const o = this.$_terms.whens[a];
                                if (o.concat) {
                                    s.push(o.concat), n.push(`${a}.concat`);
                                    continue;
                                }
                                const i = o.ref ? o.ref.resolve(e, t, r) : e, l = o.is ? [
                                    o
                                ] : o.switch, c = n.length;
                                for(let c = 0; c < l.length; ++c){
                                    const { is: u, then: f, otherwise: m } = l[c], h = `${a}${o.switch ? "." + c : ""}`;
                                    if (u.$_match(i, t.nest(u, `${h}.is`), r)) {
                                        if (f) {
                                            const a = t.localize([
                                                ...t.path,
                                                `${h}.then`
                                            ], t.ancestors, t.schemas), { schema: o, id: i } = f._generate(e, a, r);
                                            s.push(o), n.push(`${h}.then${i ? `(${i})` : ""}`);
                                            break;
                                        }
                                    } else if (m) {
                                        const a = t.localize([
                                            ...t.path,
                                            `${h}.otherwise`
                                        ], t.ancestors, t.schemas), { schema: o, id: i } = m._generate(e, a, r);
                                        s.push(o), n.push(`${h}.otherwise${i ? `(${i})` : ""}`);
                                        break;
                                    }
                                }
                                if (o.break && n.length > c) break;
                            }
                            const a = n.join(", ");
                            if (t.mainstay.tracer.debug(t, "rule", "when", a), !a) return {
                                schema: this
                            };
                            if (!t.mainstay.tracer.active && this.$_temp.whens[a]) return {
                                schema: this.$_temp.whens[a],
                                id: a
                            };
                            let o = this;
                            this._definition.generate && (o = this._definition.generate(this, e, t, r));
                            for (const e of s)o = o.concat(e);
                            return this.$_root._tracer && this.$_root._tracer._combine(o, [
                                this,
                                ...s
                            ]), this.$_temp.whens[a] = o, {
                                schema: o,
                                id: a
                            };
                        }
                        _inner(e, t, r = {}) {
                            s(!this._inRuleset(), `Cannot set ${e} inside a ruleset`);
                            const n = this.clone();
                            return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
                        }
                        _inRuleset() {
                            return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
                        }
                        _ruleRemove(e, t = {}) {
                            if (!this._singleRules.has(e)) return this;
                            const r = !1 !== t.clone ? this.clone() : this;
                            r._singleRules.delete(e);
                            const s = [];
                            for(let t = 0; t < r._rules.length; ++t){
                                const n = r._rules[t];
                                n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
                            }
                            return r._rules = s, r;
                        }
                        _values(e, t) {
                            l.verifyFlat(e, t.slice(1, -1));
                            const r = this.clone(), n = e[0] === l.symbols.override;
                            if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b : n && (r[t] = e.length ? new b : null, r.$_mutateRebuild()), !r[t]) return r;
                            n && r[t].override();
                            for (const n of e){
                                s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                                const e = "_invalids" === t ? "_valids" : "_invalids";
                                r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
                            }
                            return r;
                        }
                        get "~standard"() {
                            const e = (e)=>{
                                let t;
                                return t = u.ValidationError.isError(e) ? e.details.map(({ message: e, path: t })=>({
                                        message: e,
                                        path: t
                                    })) : [
                                    {
                                        message: e.message
                                    }
                                ], {
                                    issues: t
                                };
                            }, t = (e)=>({
                                    value: e
                                });
                            return {
                                version: 1,
                                vendor: "joi",
                                validate: (r, s)=>{
                                    const n = y.standard(r, this, s);
                                    return n instanceof Promise ? n.then(t, e) : n.error ? e(n.error) : t(n.value);
                                },
                                jsonSchema: {
                                    input: (e)=>this.$_jsonSchema("input", e),
                                    output: (e)=>this.$_jsonSchema("output", e)
                                }
                            };
                        }
                    }
                };
                _.Base.prototype[l.symbols.any] = {
                    version: l.version,
                    compile: c.compile,
                    root: "$_root"
                }, _.Base.prototype.isImmutable = !0, _.Base.prototype.deny = _.Base.prototype.invalid, _.Base.prototype.disallow = _.Base.prototype.invalid, _.Base.prototype.equal = _.Base.prototype.valid, _.Base.prototype.exist = _.Base.prototype.required, _.Base.prototype.not = _.Base.prototype.invalid, _.Base.prototype.options = _.Base.prototype.prefs, _.Base.prototype.preferences = _.Base.prototype.prefs, e.exports = new _.Base;
            },
            2130 (e, t, r) {
                "use strict";
                const { assert: s, clone: n } = r(3115), a = r(9415), o = {
                    max: 1e3,
                    supported: new Set([
                        "undefined",
                        "boolean",
                        "number",
                        "string"
                    ])
                };
                t.provider = {
                    provision: (e)=>new o.Cache(e)
                }, o.Cache = class {
                    constructor(e = {}){
                        a.assertOptions(e, [
                            "max"
                        ]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || o.max, this._map = new Map, this._list = new o.List;
                    }
                    get length() {
                        return this._map.size;
                    }
                    set(e, t) {
                        if (null !== e && !o.supported.has(typeof e)) return;
                        let r = this._map.get(e);
                        if (r) return r.value = t, void this._list.first(r);
                        r = this._list.unshift({
                            key: e,
                            value: t
                        }), this._map.set(e, r), this._compact();
                    }
                    get(e) {
                        const t = this._map.get(e);
                        if (t) return this._list.first(t), n(t.value);
                    }
                    _compact() {
                        if (this._map.size > this._max) {
                            const e = this._list.pop();
                            this._map.delete(e.key);
                        }
                    }
                }, o.List = class {
                    constructor(){
                        this.tail = null, this.head = null;
                    }
                    unshift(e) {
                        return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
                    }
                    first(e) {
                        e !== this.head && (this._remove(e), this.unshift(e));
                    }
                    pop() {
                        return this._remove(this.tail);
                    }
                    _remove(e) {
                        const { next: t, prev: r } = e;
                        return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
                    }
                };
            },
            9415 (e, t, r) {
                "use strict";
                const { assert: s, AssertError: n } = r(3115), a = r(6913);
                let o, i;
                const l = {
                    isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
                };
                t.version = a.version, t.defaults = {
                    abortEarly: !0,
                    allowUnknown: !1,
                    artifacts: !1,
                    cache: !0,
                    context: null,
                    convert: !0,
                    dateFormat: "iso",
                    errors: {
                        escapeHtml: !1,
                        label: "path",
                        language: null,
                        render: !0,
                        stack: !1,
                        wrap: {
                            label: '"',
                            array: "[]"
                        }
                    },
                    externals: !0,
                    messages: {},
                    nonEnumerables: !1,
                    noDefaults: !1,
                    presence: "optional",
                    skipFunctions: !1,
                    stripUnknown: !1,
                    warnings: !1
                }, t.symbols = {
                    any: Symbol.for("@hapi/joi/schema"),
                    arraySingle: Symbol("arraySingle"),
                    deepDefault: Symbol("deepDefault"),
                    errors: Symbol("errors"),
                    literal: Symbol("literal"),
                    override: Symbol("override"),
                    parent: Symbol("parent"),
                    prefs: Symbol("prefs"),
                    ref: Symbol("ref"),
                    template: Symbol("template"),
                    values: Symbol("values")
                }, t.assertOptions = function(e, t, r = "Options") {
                    s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
                    const n = Object.keys(e).filter((e)=>!t.includes(e));
                    s(0 === n.length, `${r} contain unknown keys: ${n}`);
                }, t.checkPreferences = function(e) {
                    i = i || r(1688);
                    const t = i.preferences.validate(e);
                    if (t.error) throw new n([
                        t.error.details[0].message
                    ]);
                }, t.compare = function(e, t, r) {
                    switch(r){
                        case "=":
                            return e === t;
                        case ">":
                            return e > t;
                        case "<":
                            return e < t;
                        case ">=":
                            return e >= t;
                        case "<=":
                            return e <= t;
                    }
                }, t.default = function(e, t) {
                    return void 0 === e ? t : e;
                }, t.intersect = function(e, t) {
                    if ("function" == typeof e.intersection) return e.intersection(t);
                    const r = new Set;
                    for (const s of e)t.has(s) && r.add(s);
                    return r;
                }, t.isIsoDate = function(e) {
                    return l.isoDate.test(e);
                }, t.isNumber = function(e) {
                    return "number" == typeof e && !isNaN(e);
                }, t.isResolvable = function(e) {
                    return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
                }, t.isSchema = function(e, r = {}) {
                    const n = e && e[t.symbols.any];
                    return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
                }, t.isValues = function(e) {
                    return e[t.symbols.values];
                }, t.limit = function(e) {
                    return Number.isSafeInteger(e) && e >= 0;
                }, t.preferences = function(e, s) {
                    o = o || r(6162), e = e || {}, s = s || {};
                    const n = Object.assign({}, e, s);
                    return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = o.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
                }, t.tryWithPath = function(e, t, r = {}) {
                    try {
                        return e();
                    } catch (e) {
                        throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = `${e.message} (${e.path})`), e;
                    }
                }, t.validateArg = function(e, r, { assert: s, message: n }) {
                    if (t.isSchema(s)) {
                        const t = s.validate(e);
                        if (!t.error) return;
                        return t.error.message;
                    }
                    if (!s(e)) return r ? `${r} ${n}` : n;
                }, t.verifyFlat = function(e, t) {
                    for (const r of e)s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
                };
            },
            3541 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(9415), a = r(8529), o = {};
                t.schema = function(e, t, r = {}) {
                    n.assertOptions(r, [
                        "appendPath",
                        "override"
                    ]);
                    try {
                        return o.schema(e, t, r);
                    } catch (e) {
                        throw r.appendPath && void 0 !== e.path && (e.message = `${e.message} (${e.path})`), e;
                    }
                }, o.schema = function(e, t, r) {
                    s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));
                    const a = (t, ...s)=>!1 !== r.override ? t.valid(e.override, ...s) : t.valid(...s);
                    if (o.simple(t)) return a(e, t);
                    if ("function" == typeof t) return e.custom(t);
                    if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return a(e, t);
                    if (n.isSchema(t)) return t;
                    if (Array.isArray(t)) {
                        for (const r of t)if (!o.simple(r)) return e.alternatives().try(...t);
                        return a(e, ...t);
                    }
                    return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? a(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
                }, t.ref = function(e, t) {
                    return a.isRef(e) ? e : a.create(e, t);
                }, t.compile = function(e, r, a = {}) {
                    n.assertOptions(a, [
                        "legacy"
                    ]);
                    const i = r && r[n.symbols.any];
                    if (i) return s(a.legacy || i.version === n.version, "Cannot mix different versions of joi schemas:", i.version, n.version), r;
                    if ("object" != typeof r || !a.legacy) return t.schema(e, r, {
                        appendPath: !0
                    });
                    const l = o.walk(r);
                    return l ? l.compile(l.root, r) : t.schema(e, r, {
                        appendPath: !0
                    });
                }, o.walk = function(e) {
                    if ("object" != typeof e) return null;
                    if (Array.isArray(e)) {
                        for (const t of e){
                            const e = o.walk(t);
                            if (e) return e;
                        }
                        return null;
                    }
                    const t = e[n.symbols.any];
                    if (t) return {
                        root: e[t.root],
                        compile: t.compile
                    };
                    s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");
                    for (const t of Object.keys(e)){
                        const r = o.walk(e[t]);
                        if (r) return r;
                    }
                    return null;
                }, o.simple = function(e) {
                    return null === e || [
                        "boolean",
                        "string",
                        "number"
                    ].includes(typeof e);
                }, t.when = function(e, r, i) {
                    if (void 0 === i && (s(r && "object" == typeof r, "Missing options"), i = r, r = a.create(".")), Array.isArray(i) && (i = {
                        switch: i
                    }), n.assertOptions(i, [
                        "is",
                        "not",
                        "then",
                        "otherwise",
                        "switch",
                        "break"
                    ]), n.isSchema(r)) return s(void 0 === i.is, '"is" can not be used with a schema condition'), s(void 0 === i.not, '"not" can not be used with a schema condition'), s(void 0 === i.switch, '"switch" can not be used with a schema condition'), o.condition(e, {
                        is: r,
                        then: i.then,
                        otherwise: i.otherwise,
                        break: i.break
                    });
                    if (s(a.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === i.not || void 0 === i.is, 'Cannot combine "is" with "not"'), void 0 === i.switch) {
                        let l = i;
                        void 0 !== i.not && (l = {
                            is: i.not,
                            then: i.otherwise,
                            otherwise: i.then,
                            break: i.break
                        });
                        let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
                        return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === i.is || a.isRef(i.is) || n.isSchema(i.is) || (c = c.required()), o.condition(e, {
                            ref: t.ref(r),
                            is: c,
                            then: l.then,
                            otherwise: l.otherwise,
                            break: l.break
                        });
                    }
                    s(Array.isArray(i.switch), '"switch" must be an array'), s(void 0 === i.is, 'Cannot combine "switch" with "is"'), s(void 0 === i.not, 'Cannot combine "switch" with "not"'), s(void 0 === i.then, 'Cannot combine "switch" with "then"');
                    const l = {
                        ref: t.ref(r),
                        switch: [],
                        break: i.break
                    };
                    for(let t = 0; t < i.switch.length; ++t){
                        const r = i.switch[t], o = t === i.switch.length - 1;
                        n.assertOptions(r, o ? [
                            "is",
                            "then",
                            "otherwise"
                        ] : [
                            "is",
                            "then"
                        ]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
                        const c = {
                            is: e.$_compile(r.is),
                            then: e.$_compile(r.then)
                        };
                        if (a.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), o) {
                            s(void 0 === i.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
                            const t = void 0 !== i.otherwise ? i.otherwise : r.otherwise;
                            void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
                        }
                        l.switch.push(c);
                    }
                    return l;
                }, o.condition = function(e, t) {
                    for (const r of [
                        "then",
                        "otherwise"
                    ])void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);
                    return t;
                };
            },
            8013 (e, t, r) {
                "use strict";
                const s = r(9415), n = r(1532);
                t.Report = class {
                    constructor(e, r, s, n, a, o, i){
                        if (this.code = e, this.flags = n, this.messages = a, this.path = o.path, this.prefs = i, this.state = o, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
                            const e = this.path[this.path.length - 1];
                            "object" != typeof e && (this.local.key = e);
                        }
                    }
                    _setTemplate(e) {
                        if (this.template = e, !this.flags.label && 0 === this.path.length) {
                            const e = this._template(this.template, "root");
                            e && (this.local.label = e);
                        }
                    }
                    toString() {
                        if (this.message) return this.message;
                        const e = this.code;
                        if (!this.prefs.errors.render) return this.code;
                        const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
                        return void 0 === t ? `Error code "${e}" is not defined, your custom type is missing the correct messages definition` : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
                            errors: this.prefs.errors,
                            messages: [
                                this.prefs.messages,
                                this.messages
                            ]
                        }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
                    }
                    _template(e, r) {
                        return t.template(this.value, e, r || this.code, this.state, this.prefs);
                    }
                }, t.path = function(e) {
                    let t = "";
                    for (const r of e)"object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += `[${r}]`);
                    return t;
                }, t.template = function(e, t, r, a, o) {
                    if (!t) return;
                    if (n.isTemplate(t)) return "root" !== r ? t : null;
                    let i = o.errors.language;
                    if (s.isResolvable(i) && (i = i.resolve(e, a, o)), i && t[i]) {
                        if (void 0 !== t[i][r]) return t[i][r];
                        if (void 0 !== t[i]["*"]) return t[i]["*"];
                    }
                    return t[r] ? t[r] : t["*"];
                }, t.label = function(e, r, s, n) {
                    if (!s.errors.label) return "";
                    if (e.label) return e.label;
                    let a = r.path;
                    "key" === s.errors.label && r.path.length > 1 && (a = r.path.slice(-1));
                    return t.path(a) || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
                }, t.process = function(e, r, s) {
                    if (!e) return null;
                    const { override: n, message: a, details: o } = t.details(e);
                    if (n) return n;
                    if (s.errors.stack) return new t.ValidationError(a, o, r);
                    const i = Error.stackTraceLimit;
                    Error.stackTraceLimit = 0;
                    const l = new t.ValidationError(a, o, r);
                    return Error.stackTraceLimit = i, l;
                }, t.details = function(e, t = {}) {
                    let r = [];
                    const s = [];
                    for (const n of e){
                        if (n instanceof Error) {
                            if (!1 !== t.override) return {
                                override: n
                            };
                            const e = n.toString();
                            r.push(e), s.push({
                                message: e,
                                type: "override",
                                context: {
                                    error: n
                                }
                            });
                            continue;
                        }
                        const e = n.toString();
                        r.push(e), s.push({
                            message: e,
                            path: n.path.filter((e)=>"object" != typeof e),
                            type: n.code,
                            context: n.local
                        });
                    }
                    return r.length > 1 && (r = [
                        ...new Set(r)
                    ]), {
                        message: r.join(". "),
                        details: s
                    };
                }, t.ValidationError = class extends Error {
                    constructor(e, t, r){
                        super(e), this._original = r, this.details = t;
                    }
                    static isError(e) {
                        return e instanceof t.ValidationError;
                    }
                }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = r(554).error;
            },
            2062 (e, t, r) {
                "use strict";
                const { assert: s, clone: n } = r(3115), a = r(9415), o = r(6162), i = {};
                t.type = function(e, t) {
                    const r = Object.getPrototypeOf(e), l = n(r), c = e._assign(Object.create(l)), u = Object.assign({}, t);
                    delete u.base, l._definition = u;
                    const f = r._definition || {};
                    u.messages = o.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
                    const m = Object.assign({}, f.terms);
                    if (u.terms) for (const e of Object.keys(u.terms)){
                        const t = u.terms[e];
                        s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, m[e] = t;
                    }
                    if (u.terms = m, u.args || (u.args = f.args), u.prepare) {
                        const { method: e, undefined: t } = "function" == typeof u.prepare ? {
                            method: u.prepare
                        } : u.prepare;
                        u.prepare = t ? e : (t, r)=>{
                            if (void 0 !== t) return e(t, r);
                        };
                    }
                    u.prepare = i.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
                        method: u.coerce
                    }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
                        method: u.coerce.method,
                        from: [].concat(u.coerce.from)
                    })), u.coerce = i.coerce(u.coerce, f.coerce), u.validate = i.validate(u.validate, f.validate);
                    const h = Object.assign({}, f.rules);
                    if (u.rules) for (const e of Object.keys(u.rules)){
                        const t = u.rules[e];
                        s("object" == typeof t, "Invalid rule definition for", u.type, e);
                        let r = t.method;
                        if (void 0 === r && (r = function() {
                            return this.$_addRule(e);
                        }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!h[e], "Rule conflict in", u.type, e), h[e] = t, t.alias) {
                            const e = [].concat(t.alias);
                            for (const r of e)l[r] = t.method;
                        }
                        t.args && (t.argsByName = new Map, t.args = t.args.map((e)=>("string" == typeof e && (e = {
                                name: e
                            }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), a.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
                    }
                    u.rules = h, u.jsonSchema || (u.jsonSchema = f.jsonSchema);
                    const p = Object.assign({}, f.modifiers);
                    if (u.modifiers) for (const e of Object.keys(u.modifiers)){
                        s(!l[e], "Rule conflict in", u.type, e);
                        const t = u.modifiers[e];
                        s("function" == typeof t, "Invalid modifier definition for", u.type, e);
                        const r = function(t) {
                            return this.rule({
                                [e]: t
                            });
                        };
                        l[e] = r, p[e] = t;
                    }
                    if (u.modifiers = p, u.overrides) {
                        l._super = r, c.$_super = {};
                        for (const e of Object.keys(u.overrides))s(r[e], "Cannot override missing", e), u.overrides[e][a.symbols.parent] = r[e], c.$_super[e] = r[e].bind(c);
                        Object.assign(l, u.overrides);
                    }
                    u.cast = Object.assign({}, f.cast, u.cast);
                    const d = Object.assign({}, f.manifest, u.manifest);
                    return d.build = i.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = d, u.rebuild = i.rebuild(u.rebuild, f.rebuild), c;
                }, i.build = function(e, t) {
                    return e && t ? function(r, s) {
                        return t(e(r, s), s);
                    } : e || t;
                }, i.coerce = function(e, t) {
                    return e && t ? {
                        from: e.from && t.from ? [
                            ...new Set([
                                ...e.from,
                                ...t.from
                            ])
                        ] : null,
                        method (r, s) {
                            let n;
                            if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                                if (n.errors || void 0 === n.value) return n;
                                r = n.value;
                            }
                            if (!e.from || e.from.includes(typeof r)) {
                                const t = e.method(r, s);
                                if (t) return t;
                            }
                            return n;
                        }
                    } : e || t;
                }, i.prepare = function(e, t) {
                    return e && t ? function(r, s) {
                        const n = e(r, s);
                        if (n) {
                            if (n.errors || void 0 === n.value) return n;
                            r = n.value;
                        }
                        return t(r, s) || n;
                    } : e || t;
                }, i.rebuild = function(e, t) {
                    return e && t ? function(r) {
                        t(r), e(r);
                    } : e || t;
                }, i.validate = function(e, t) {
                    return e && t ? function(r, s) {
                        const n = t(r, s);
                        if (n) {
                            if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
                            r = n.value;
                        }
                        return e(r, s) || n;
                    } : e || t;
                };
            },
            1100 (e, t, r) {
                "use strict";
                const { assert: s, clone: n } = r(3115), a = r(2130), o = r(9415), i = r(3541), l = r(8013), c = r(2062), u = r(9017), f = r(8529), m = r(1532), h = r(125);
                let p;
                const d = {
                    types: {
                        alternatives: r(4972),
                        any: r(680),
                        array: r(2591),
                        boolean: r(6186),
                        date: r(2588),
                        function: r(4840),
                        link: r(9556),
                        number: r(4709),
                        object: r(7487),
                        string: r(9033),
                        symbol: r(5008)
                    },
                    aliases: {
                        alt: "alternatives",
                        bool: "boolean",
                        func: "function"
                    },
                    root: function() {
                        const e = {
                            _types: new Set(Object.keys(d.types))
                        };
                        for (const t of e._types)e[t] = function(...e) {
                            return s(!e.length || [
                                "alternatives",
                                "link",
                                "object"
                            ].includes(t), "The", t, "type does not allow arguments"), d.generate(this, d.types[t], e);
                        };
                        for (const t of [
                            "allow",
                            "custom",
                            "disallow",
                            "equal",
                            "exist",
                            "forbidden",
                            "invalid",
                            "not",
                            "only",
                            "optional",
                            "options",
                            "prefs",
                            "preferences",
                            "required",
                            "strip",
                            "valid",
                            "when"
                        ])e[t] = function(...e) {
                            return this.any()[t](...e);
                        };
                        Object.assign(e, d.methods);
                        for (const t of Object.keys(d.aliases)){
                            const r = d.aliases[t];
                            e[t] = e[r];
                        }
                        return e.x = e.expression, h.setup && h.setup(e), e;
                    }
                };
                d.methods = {
                    ValidationError: l.ValidationError,
                    version: o.version,
                    cache: a.provider,
                    assert (e, t, ...r) {
                        d.assert(e, t, !0, r);
                    },
                    attempt: (e, t, ...r)=>d.assert(e, t, !1, r),
                    build (e) {
                        return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
                    },
                    checkPreferences (e) {
                        o.checkPreferences(e);
                    },
                    compile (e, t) {
                        return i.compile(this, e, t);
                    },
                    defaults (e) {
                        s("function" == typeof e, "modifier must be a function");
                        const t = Object.assign({}, this);
                        for (const r of t._types){
                            const n = e(t[r]());
                            s(o.isSchema(n), "modifier must return a valid schema object"), t[r] = function(...e) {
                                return d.generate(this, n, e);
                            };
                        }
                        return t;
                    },
                    expression: (...e)=>new m(...e),
                    extend (...e) {
                        o.verifyFlat(e, "extend"), p = p || r(1688), s(e.length, "You need to provide at least one extension"), this.assert(e, p.extensions);
                        const t = Object.assign({}, this);
                        t._types = new Set(t._types);
                        for (let r of e){
                            "function" == typeof r && (r = r(t)), this.assert(r, p.extension);
                            const e = d.expandExtension(r, t);
                            for (const r of e){
                                s(void 0 === t[r.type] || t._types.has(r.type), "Cannot override name", r.type);
                                const e = r.base || this.any(), n = c.type(e, r);
                                t._types.add(r.type), t[r.type] = function(...e) {
                                    return d.generate(this, n, e);
                                };
                            }
                        }
                        return t;
                    },
                    isError: l.ValidationError.isError,
                    isExpression: m.isTemplate,
                    isRef: f.isRef,
                    isSchema: o.isSchema,
                    in: (...e)=>f.in(...e),
                    override: o.symbols.override,
                    ref: (...e)=>f.create(...e),
                    types () {
                        const e = {};
                        for (const t of this._types)e[t] = this[t]();
                        for (const t of Object.keys(d.aliases))e[t] = this[t]();
                        return e;
                    }
                }, d.assert = function(e, t, r, s) {
                    const a = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null, i = null !== a ? s[1] : s[0], c = t.validate(e, o.preferences({
                        errors: {
                            stack: !0
                        }
                    }, i || {}));
                    let u = c.error;
                    if (!u) return c.value;
                    if (a instanceof Error) throw a;
                    const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
                    throw u instanceof l.ValidationError == 0 && (u = n(u)), u.message = a ? `${a} ${f}` : f, u;
                }, d.generate = function(e, t, r) {
                    return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
                }, d.expandExtension = function(e, t) {
                    if ("string" == typeof e.type) return [
                        e
                    ];
                    const r = [];
                    for (const s of t._types)if (e.type.test(s)) {
                        const n = Object.assign({}, e);
                        n.type = s, n.base = t[s](), r.push(n);
                    }
                    return r;
                }, e.exports = d.root();
            },
            6162 (e, t, r) {
                "use strict";
                const { assert: s, clone: n } = r(3115), a = r(1532);
                t.compile = function(e, t) {
                    if ("string" == typeof e) return s(!t, "Cannot set single message string"), new a(e);
                    if (a.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
                    s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};
                    for (const r of Object.keys(e)){
                        const n = e[r];
                        if ("root" === r || a.isTemplate(n)) {
                            s("__proto__" !== r, "Cannot use __proto__ as a message code"), t[r] = n;
                            continue;
                        }
                        if ("string" == typeof n) {
                            s("__proto__" !== r, "Cannot use __proto__ as a message code"), t[r] = new a(n);
                            continue;
                        }
                        s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
                        const o = r;
                        s("__proto__" !== o, "Cannot use __proto__ as a language");
                        const i = Object.hasOwn(t, o) ? t[o] : {};
                        t[o] = i;
                        for (const e of Object.keys(n)){
                            const t = n[e];
                            s("__proto__" !== e, "Cannot use __proto__ as a message code"), "root" === e || a.isTemplate(t) ? i[e] = t : (s("string" == typeof t, "Invalid message for", e, "in", o), i[e] = new a(t));
                        }
                    }
                    return t;
                }, t.decompile = function(e) {
                    const t = {};
                    for (const r of Object.keys(e)){
                        const s = e[r];
                        if ("root" === r) {
                            t.root = s;
                            continue;
                        }
                        if (a.isTemplate(s)) {
                            t[r] = s.describe({
                                compact: !0
                            });
                            continue;
                        }
                        const n = r;
                        t[n] = {};
                        for (const e of Object.keys(s)){
                            const r = s[e];
                            "root" !== e ? t[n][e] = r.describe({
                                compact: !0
                            }) : t[n].root = r;
                        }
                    }
                    return t;
                }, t.merge = function(e, r) {
                    if (!e) return t.compile(r);
                    if (!r) return e;
                    if ("string" == typeof r) return new a(r);
                    if (a.isTemplate(r)) return r;
                    const o = n(e);
                    for (const e of Object.keys(r)){
                        const t = r[e];
                        if ("root" === e || a.isTemplate(t)) {
                            s("__proto__" !== e, "Cannot use __proto__ as a message code"), o[e] = t;
                            continue;
                        }
                        if ("string" == typeof t) {
                            s("__proto__" !== e, "Cannot use __proto__ as a message code"), o[e] = new a(t);
                            continue;
                        }
                        s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
                        const n = e;
                        s("__proto__" !== n, "Cannot use __proto__ as a language");
                        const i = Object.hasOwn(o, n) ? o[n] : {};
                        o[n] = i;
                        for (const e of Object.keys(t)){
                            const r = t[e];
                            s("__proto__" !== e, "Cannot use __proto__ as a message code"), "root" === e || a.isTemplate(r) ? i[e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), i[e] = new a(r));
                        }
                    }
                    return o;
                };
            },
            5844 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(9415), a = r(8529), o = {};
                t.Ids = o.Ids = class {
                    constructor(){
                        this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                    }
                    clone() {
                        const e = new o.Ids;
                        return this._byId.size && (e._byId = new Map(this._byId)), this._byKey.size && (e._byKey = new Map(this._byKey)), e._schemaChain = this._schemaChain, e;
                    }
                    concat(e) {
                        e._schemaChain && (this._schemaChain = !0);
                        for (const [t, r] of e._byId.entries())s(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);
                        for (const [t, r] of e._byKey.entries())s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
                    }
                    fork(e, t, r) {
                        const a = this._collect(e);
                        a.push({
                            schema: r
                        });
                        const i = a.shift();
                        let l = {
                            id: i.id,
                            schema: t(i.schema)
                        };
                        s(n.isSchema(l.schema), "adjuster function failed to return a joi schema type");
                        for (const e of a)l = {
                            id: e.id,
                            schema: o.fork(e.schema, l.id, l.schema)
                        };
                        return l.schema;
                    }
                    labels(e, t = []) {
                        const r = e[0], s = this._get(r);
                        if (!s) return [
                            ...t,
                            ...e
                        ].join(".");
                        const n = e.slice(1);
                        return t = [
                            ...t,
                            s.schema._flags.label || r
                        ], n.length ? s.schema._ids.labels(n, t) : t.join(".");
                    }
                    reach(e, t = []) {
                        const r = e[0], n = this._get(r);
                        s(n, "Schema does not contain path", [
                            ...t,
                            ...e
                        ].join("."));
                        const a = e.slice(1);
                        return a.length ? n.schema._ids.reach(a, [
                            ...t,
                            r
                        ]) : n.schema;
                    }
                    register(e, { key: t } = {}) {
                        if (!e || !n.isSchema(e)) return;
                        (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
                        const r = e._flags.id;
                        if (r) {
                            const t = this._byId.get(r);
                            s(!t || t.schema === e, "Cannot add different schemas with the same id:", r), s(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                                schema: e,
                                id: r
                            });
                        }
                        t && (s(!this._byKey.has(t), "Schema already contains key:", t), s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
                            schema: e,
                            id: t
                        }));
                    }
                    reset() {
                        this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                    }
                    _collect(e, t = [], r = []) {
                        const n = e[0], a = this._get(n);
                        s(a, "Schema does not contain path", [
                            ...t,
                            ...e
                        ].join(".")), r = [
                            a,
                            ...r
                        ];
                        const o = e.slice(1);
                        return o.length ? a.schema._ids._collect(o, [
                            ...t,
                            n
                        ], r) : r;
                    }
                    _get(e) {
                        return this._byId.get(e) || this._byKey.get(e);
                    }
                }, o.fork = function(e, r, s) {
                    const n = t.schema(e, {
                        each: (e, { key: t })=>{
                            if (r === (e._flags.id || t)) return s;
                        },
                        ref: !1
                    });
                    return n ? n.$_mutateRebuild() : e;
                }, t.schema = function(e, t) {
                    let r;
                    for (const s of Object.keys(e._flags)){
                        if ("_" === s[0]) continue;
                        const n = o.scan(e._flags[s], {
                            source: "flags",
                            name: s
                        }, t);
                        void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
                    }
                    for(let s = 0; s < e._rules.length; ++s){
                        const n = e._rules[s], a = o.scan(n.args, {
                            source: "rules",
                            name: n.name
                        }, t);
                        if (void 0 !== a) {
                            r = r || e.clone();
                            const t = Object.assign({}, n);
                            t.args = a, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
                        }
                    }
                    for (const s of Object.keys(e.$_terms)){
                        if ("_" === s[0]) continue;
                        const n = o.scan(e.$_terms[s], {
                            source: "terms",
                            name: s
                        }, t);
                        void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
                    }
                    return r;
                }, o.scan = function(e, t, r, s, i) {
                    const l = s || [];
                    if (null === e || "object" != typeof e) return;
                    let c;
                    if (Array.isArray(e)) {
                        for(let s = 0; s < e.length; ++s){
                            const n = "terms" === t.source && "keys" === t.name && e[s].key, a = o.scan(e[s], t, r, [
                                s,
                                ...l
                            ], n);
                            void 0 !== a && (c = c || e.slice(), c[s] = a);
                        }
                        return c;
                    }
                    if (!1 !== r.schema && n.isSchema(e) || !1 !== r.ref && a.isRef(e)) {
                        const s = r.each(e, {
                            ...t,
                            path: l,
                            key: i
                        });
                        if (s === e) return;
                        return s;
                    }
                    for (const s of Object.keys(e)){
                        if ("_" === s[0]) continue;
                        const n = o.scan(e[s], t, r, [
                            s,
                            ...l
                        ], i);
                        void 0 !== n && (c = c || Object.assign({}, e), c[s] = n);
                    }
                    return c;
                };
            },
            8529 (e, t, r) {
                "use strict";
                const { assert: s, reach: n } = r(3115), a = r(9415);
                let o;
                const i = {
                    symbol: Symbol("ref"),
                    defaults: {
                        adjust: null,
                        in: !1,
                        iterables: null,
                        map: null,
                        separator: ".",
                        type: "value"
                    }
                };
                t.create = function(e, t = {}) {
                    s("string" == typeof e, "Invalid reference key:", e), a.assertOptions(t, [
                        "adjust",
                        "ancestor",
                        "in",
                        "iterables",
                        "map",
                        "prefix",
                        "render",
                        "separator"
                    ]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
                    const r = Object.assign({}, i.defaults, t);
                    delete r.prefix;
                    const n = r.separator, o = i.context(e, n, t.prefix);
                    if (r.type = o.type, e = o.key, "value" === r.type) {
                        if (o.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;
                        else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");
                        else {
                            const [t, s] = i.ancestor(e, n);
                            s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
                        }
                    }
                    return r.path = n ? null === e ? [] : e.split(n) : [
                        e
                    ], new i.Ref(r);
                }, t.in = function(e, r = {}) {
                    return t.create(e, {
                        ...r,
                        in: !0
                    });
                }, t.isRef = function(e) {
                    return !!e && !!e[a.symbols.ref];
                }, i.Ref = class {
                    constructor(e){
                        s("object" == typeof e, "Invalid reference construction"), a.assertOptions(e, [
                            "adjust",
                            "ancestor",
                            "in",
                            "iterables",
                            "map",
                            "path",
                            "render",
                            "separator",
                            "type",
                            "depth",
                            "key",
                            "root",
                            "display"
                        ]), s([
                            !1,
                            void 0
                        ].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, i.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
                    }
                    resolve(e, t, r, n, a = {}) {
                        return s(!this.in || a.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, a) : "local" === this.type ? this._resolve(n, t, a) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, a) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, a)) : this._resolve(e, t, a);
                    }
                    _resolve(e, t, r) {
                        let s;
                        if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = n(e, this.path, {
                            iterables: this.iterables,
                            functions: !0
                        })), this.adjust && (s = this.adjust(s)), this.map) {
                            const e = this.map.get(s);
                            void 0 !== e && (s = e);
                        }
                        return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
                    }
                    toString() {
                        return this.display;
                    }
                    absolute(e) {
                        return [
                            ...e.path.slice(0, -this.ancestor),
                            ...this.path
                        ];
                    }
                    clone() {
                        return new i.Ref(this);
                    }
                    describe() {
                        const e = {
                            path: this.path
                        };
                        "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [
                            ...this.map
                        ]);
                        for (const t of [
                            "adjust",
                            "iterables",
                            "render"
                        ])null !== this[t] && void 0 !== this[t] && (e[t] = this[t]);
                        return !1 !== this.in && (e.in = !0), {
                            ref: e
                        };
                    }
                    updateDisplay() {
                        const e = null !== this.key ? this.key : "";
                        if ("value" !== this.type) return void (this.display = `ref:${this.type}:${e}`);
                        if (!this.separator) return void (this.display = `ref:${e}`);
                        if (!this.ancestor) return void (this.display = `ref:${this.separator}${e}`);
                        if ("root" === this.ancestor) return void (this.display = `ref:root:${e}`);
                        if (1 === this.ancestor) return void (this.display = `ref:${e || ".."}`);
                        const t = new Array(this.ancestor + 1).fill(this.separator).join("");
                        this.display = `ref:${t}${e || ""}`;
                    }
                }, i.Ref.prototype[a.symbols.ref] = !0, t.build = function(e) {
                    return "value" === (e = Object.assign({}, i.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new i.Ref(e);
                }, i.context = function(e, t, r = {}) {
                    if (e = e.trim(), r) {
                        const s = void 0 === r.global ? "$" : r.global;
                        if (s !== t && e.startsWith(s)) return {
                            key: e.slice(s.length),
                            type: "global"
                        };
                        const n = void 0 === r.local ? "#" : r.local;
                        if (n !== t && e.startsWith(n)) return {
                            key: e.slice(n.length),
                            type: "local"
                        };
                        const a = void 0 === r.root ? "/" : r.root;
                        if (a !== t && e.startsWith(a)) return {
                            key: e.slice(a.length),
                            type: "value",
                            root: !0
                        };
                    }
                    return {
                        key: e,
                        type: "value"
                    };
                }, i.ancestor = function(e, t) {
                    if (!t) return [
                        1,
                        0
                    ];
                    if (e[0] !== t) return [
                        1,
                        0
                    ];
                    if (e[1] !== t) return [
                        0,
                        1
                    ];
                    let r = 2;
                    for(; e[r] === t;)++r;
                    return [
                        r - 1,
                        r
                    ];
                }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
                    constructor(){
                        this.refs = [];
                    }
                    register(e, s) {
                        if (e) {
                            if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e)this.register(t, s);
                            else if (a.isSchema(e)) for (const t of e._refs.refs)t.ancestor - s >= 0 && this.refs.push({
                                ancestor: t.ancestor - s,
                                root: t.root
                            });
                            else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
                                ancestor: e.ancestor - s,
                                root: e.root
                            }), o = o || r(1532), o.isTemplate(e) && this.register(e.refs(), s);
                        }
                    }
                    get length() {
                        return this.refs.length;
                    }
                    clone() {
                        const e = new t.Manager;
                        return e.refs = this.refs.slice(), e;
                    }
                    reset() {
                        this.refs = [];
                    }
                    roots() {
                        return this.refs.filter((e)=>!e.ancestor).map((e)=>e.root);
                    }
                };
            },
            1688 (e, t, r) {
                "use strict";
                const s = r(1100), n = {};
                n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
                    allowUnknown: s.boolean(),
                    abortEarly: s.boolean(),
                    artifacts: s.boolean(),
                    cache: s.boolean(),
                    context: s.object(),
                    convert: s.boolean(),
                    dateFormat: s.valid("date", "iso", "string", "time", "utc"),
                    debug: s.boolean(),
                    errors: {
                        escapeHtml: s.boolean(),
                        label: s.valid("path", "key", !1),
                        language: [
                            s.string(),
                            s.object().ref()
                        ],
                        render: s.boolean(),
                        stack: s.boolean(),
                        wrap: {
                            label: n.wrap,
                            array: n.wrap,
                            string: n.wrap
                        }
                    },
                    externals: s.boolean(),
                    messages: s.object(),
                    noDefaults: s.boolean(),
                    nonEnumerables: s.boolean(),
                    presence: s.valid("required", "optional", "forbidden"),
                    skipFunctions: s.boolean(),
                    stripUnknown: s.object({
                        arrays: s.boolean(),
                        objects: s.boolean()
                    }).or("arrays", "objects").allow(!0, !1),
                    warnings: s.boolean()
                }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.hook = s.function().maxArity(3), n.rule = s.object({
                    alias: s.array().items(s.string().pattern(n.nameRx)).single(),
                    args: s.array().items(s.string(), s.object({
                        name: s.string().pattern(n.nameRx).required(),
                        ref: s.boolean(),
                        assert: s.alternatives([
                            s.function(),
                            s.object().schema()
                        ]).conditional("ref", {
                            is: !0,
                            then: s.required()
                        }),
                        normalize: s.function(),
                        message: s.string().when("assert", {
                            is: s.function(),
                            then: s.required()
                        })
                    })),
                    convert: s.boolean(),
                    manifest: s.boolean(),
                    method: s.function().allow(!1),
                    multi: s.boolean(),
                    validate: s.function(),
                    jsonSchema: s.function()
                }), t.extension = s.object({
                    type: s.alternatives([
                        s.string(),
                        s.object().regex()
                    ]).required(),
                    args: s.function(),
                    cast: s.object().pattern(n.nameRx, s.object({
                        from: s.function().maxArity(1).required(),
                        to: s.function().minArity(1).maxArity(2).required()
                    })),
                    base: s.object().schema().when("type", {
                        is: s.object().regex(),
                        then: s.forbidden()
                    }),
                    coerce: [
                        n.hook,
                        s.object({
                            method: n.hook.required(),
                            from: s.array().items(s.string()).single()
                        })
                    ],
                    flags: s.object().pattern(n.nameRx, s.object({
                        setter: s.string(),
                        default: s.any()
                    })),
                    manifest: {
                        build: s.function().arity(2)
                    },
                    messages: [
                        s.object(),
                        s.string()
                    ],
                    modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
                    overrides: s.object().pattern(n.nameRx, s.function()),
                    prepare: [
                        n.hook,
                        s.object({
                            method: n.hook.required(),
                            undefined: s.boolean()
                        })
                    ],
                    rebuild: s.function().arity(1),
                    rules: s.object().pattern(n.nameRx, n.rule),
                    jsonSchema: s.function(),
                    terms: s.object().pattern(n.nameRx, s.object({
                        init: s.array().allow(null).required(),
                        manifest: s.object().pattern(/.+/, [
                            s.valid("schema", "single"),
                            s.object({
                                mapped: s.object({
                                    from: s.string().required(),
                                    to: s.string().required()
                                }).required()
                            })
                        ])
                    })),
                    validate: n.hook
                }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
                    buffer: s.object({
                        buffer: s.string()
                    }),
                    func: s.object({
                        function: s.function().required(),
                        options: {
                            literal: !0
                        }
                    }),
                    override: s.object({
                        override: !0
                    }),
                    ref: s.object({
                        ref: s.object({
                            type: s.valid("value", "global", "local"),
                            path: s.array().required(),
                            separator: s.string().length(1).allow(!1),
                            ancestor: s.number().min(0).integer().allow("root"),
                            map: s.array().items(s.array().length(2)).min(1),
                            adjust: s.function(),
                            iterables: s.boolean(),
                            in: s.boolean(),
                            render: s.boolean()
                        }).required()
                    }),
                    regex: s.object({
                        regex: s.string().min(3)
                    }),
                    special: s.object({
                        special: s.valid("deep").required()
                    }),
                    template: s.object({
                        template: s.string().required(),
                        options: s.object()
                    }),
                    value: s.object({
                        value: s.alternatives([
                            s.object(),
                            s.array()
                        ]).required()
                    })
                }, n.desc.entity = s.alternatives([
                    s.array().items(s.link("...")),
                    s.boolean(),
                    s.function(),
                    s.number(),
                    s.string(),
                    n.desc.buffer,
                    n.desc.func,
                    n.desc.ref,
                    n.desc.regex,
                    n.desc.special,
                    n.desc.template,
                    n.desc.value,
                    s.link("/")
                ]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0, NaN), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [
                    s.string(),
                    n.desc.template,
                    s.object().pattern(/.+/, [
                        s.string(),
                        n.desc.template
                    ])
                ]), t.description = s.object({
                    type: s.string().required(),
                    flags: s.object({
                        cast: s.string(),
                        default: s.any(),
                        description: s.string(),
                        empty: s.link("/"),
                        failover: n.desc.entity,
                        id: s.string(),
                        label: s.string(),
                        only: !0,
                        presence: [
                            "optional",
                            "required",
                            "forbidden"
                        ],
                        result: [
                            "raw",
                            "strip"
                        ],
                        strip: s.boolean(),
                        unit: s.string()
                    }).unknown(),
                    preferences: {
                        allowUnknown: s.boolean(),
                        abortEarly: s.boolean(),
                        artifacts: s.boolean(),
                        cache: s.boolean(),
                        convert: s.boolean(),
                        dateFormat: [
                            "date",
                            "iso",
                            "string",
                            "time",
                            "utc"
                        ],
                        errors: {
                            escapeHtml: s.boolean(),
                            label: [
                                "path",
                                "key"
                            ],
                            language: [
                                s.string(),
                                n.desc.ref
                            ],
                            wrap: {
                                label: n.wrap,
                                array: n.wrap
                            }
                        },
                        externals: s.boolean(),
                        messages: n.desc.messages,
                        noDefaults: s.boolean(),
                        nonEnumerables: s.boolean(),
                        presence: [
                            "required",
                            "optional",
                            "forbidden"
                        ],
                        skipFunctions: s.boolean(),
                        stripUnknown: s.object({
                            arrays: s.boolean(),
                            objects: s.boolean()
                        }).or("arrays", "objects").allow(!0, !1),
                        warnings: s.boolean()
                    },
                    allow: n.desc.values,
                    invalid: n.desc.values,
                    rules: s.array().min(1).items({
                        name: s.string().required(),
                        args: s.object().min(1),
                        keep: s.boolean(),
                        message: [
                            s.string(),
                            n.desc.messages
                        ],
                        warn: s.boolean()
                    }),
                    keys: s.object().pattern(/.*/, s.link("/")),
                    link: n.desc.ref
                }).pattern(/^[a-z]\w*$/, s.any());
            },
            4957 (e, t, r) {
                "use strict";
                const { clone: s, reach: n } = r(3115), a = r(9415), o = {
                    value: Symbol("value")
                };
                e.exports = o.State = class {
                    constructor(e, t, r){
                        this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
                    }
                    localize(e, t = null, r = null) {
                        const s = new o.State(e, t, this);
                        return r && s.schemas && (s.schemas = [
                            o.schemas(r),
                            ...s.schemas
                        ]), s;
                    }
                    nest(e, t) {
                        const r = new o.State(this.path, this.ancestors, this);
                        return r.schemas = r.schemas && [
                            o.schemas(e),
                            ...r.schemas
                        ], r.debug = t, r;
                    }
                    shadow(e, t) {
                        this.mainstay.shadow = this.mainstay.shadow || new o.Shadow, this.mainstay.shadow.set(this.path, e, t);
                    }
                    snapshot() {
                        this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path))), this.mainstay.snapshot();
                    }
                    restore() {
                        this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.restore();
                    }
                    commit() {
                        this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.commit();
                    }
                }, o.schemas = function(e) {
                    return a.isSchema(e) ? {
                        schema: e
                    } : e;
                }, o.Shadow = class {
                    constructor(){
                        this._values = null;
                    }
                    set(e, t, r) {
                        if (!e.length) return;
                        if ("strip" === r && "number" == typeof e[e.length - 1]) return;
                        this._values = this._values || new Map;
                        let s = this._values;
                        for(let t = 0; t < e.length; ++t){
                            const r = e[t];
                            let n = s.get(r);
                            n || (n = new Map, s.set(r, n)), s = n;
                        }
                        s[o.value] = t;
                    }
                    get(e) {
                        const t = this.node(e);
                        if (t) return t[o.value];
                    }
                    node(e) {
                        if (this._values) return n(this._values, e, {
                            iterables: !0
                        });
                    }
                    override(e, t) {
                        if (!this._values) return;
                        const r = e.slice(0, -1), s = e[e.length - 1], a = n(this._values, r, {
                            iterables: !0
                        });
                        t ? a.set(s, t) : a && a.delete(s);
                    }
                };
            },
            1532 (e, t, r) {
                "use strict";
                const { assert: s, clone: n, escapeHtml: a } = r(3115), o = r(679), i = r(9415), l = r(8013), c = r(8529), u = {
                    symbol: Symbol("template"),
                    opens: new Array(1e3).join("\0"),
                    closes: new Array(1e3).join(""),
                    dateFormat: {
                        date: Date.prototype.toDateString,
                        iso: Date.prototype.toISOString,
                        string: Date.prototype.toString,
                        time: Date.prototype.toTimeString,
                        utc: Date.prototype.toUTCString
                    }
                };
                e.exports = u.Template = class {
                    constructor(e, t){
                        if (s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes(""), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, t) {
                            const { functions: e, ...r } = t;
                            this._settings = Object.keys(r).length ? n(r) : void 0, this._functions = e, this._functions && (s(Object.keys(this._functions).every((e)=>"string" == typeof e), "Functions keys must be strings"), s(Object.values(this._functions).every((e)=>"function" == typeof e), "Functions values must be functions"));
                        } else this._settings = void 0, this._functions = void 0;
                        this._parse();
                    }
                    _parse() {
                        if (!this.source.includes("{")) return;
                        const e = u.encode(this.source), t = u.split(e);
                        let r = !1;
                        const s = [], n = t.shift();
                        n && s.push(u.decode(n));
                        for (const e of t){
                            const t = "{" !== e[0], n = t ? "}" : "}}", a = e.indexOf(n);
                            if (-1 === a || "{" === e[1]) {
                                s.push(`{${u.decode(e)}`);
                                continue;
                            }
                            let o = e.slice(t ? 0 : 1, a);
                            const i = ":" === o[0];
                            i && (o = o.slice(1));
                            const l = this._ref(u.decode(o), {
                                raw: t,
                                wrapped: i
                            });
                            s.push(l), "string" != typeof l && (r = !0);
                            const c = e.slice(a + n.length);
                            c && s.push(u.decode(c));
                        }
                        r ? this._template = s : this.rendered = s.join("");
                    }
                    static date(e, t) {
                        return u.dateFormat[t.dateFormat].call(e);
                    }
                    describe(e = {}) {
                        if (!this._settings && e.compact) return this.source;
                        const t = {
                            template: this.source
                        };
                        return this._settings && (t.options = this._settings), this._functions && (t.functions = this._functions), t;
                    }
                    static build(e) {
                        return new u.Template(e.template, e.options || e.functions ? {
                            ...e.options,
                            functions: e.functions
                        } : void 0);
                    }
                    isDynamic() {
                        return !!this._template;
                    }
                    static isTemplate(e) {
                        return !!e && !!e[i.symbols.template];
                    }
                    refs() {
                        if (!this._template) return;
                        const e = [];
                        for (const t of this._template)"string" != typeof t && e.push(...t.refs);
                        return e;
                    }
                    resolve(e, t, r, s) {
                        return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
                    }
                    _part(e, ...t) {
                        return e.ref ? e.ref.resolve(...t) : e.formula.evaluate(t);
                    }
                    render(e, t, r, s, n = {}) {
                        if (!this.isDynamic()) return this.rendered;
                        const o = [];
                        for (const i of this._template)if ("string" == typeof i) o.push(i);
                        else {
                            const l = this._part(i, e, t, r, s, n), c = u.stringify(l, e, t, r, s, n);
                            if (void 0 !== c) {
                                const e = i.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : a(c);
                                o.push(u.wrap(e, i.wrapped && r.errors.wrap.label));
                            }
                        }
                        return o.join("");
                    }
                    _ref(e, { raw: t, wrapped: r }) {
                        const s = [], n = (e)=>{
                            const t = c.create(e, this._settings);
                            return s.push(t), (e)=>{
                                const r = t.resolve(...e);
                                return void 0 !== r ? r : null;
                            };
                        };
                        try {
                            const t = this._functions ? {
                                ...u.functions,
                                ...this._functions
                            } : u.functions;
                            var a = new o.Parser(e, {
                                reference: n,
                                functions: t,
                                constants: u.constants
                            });
                        } catch (t) {
                            throw t.message = `Invalid template variable "${e}" fails due to: ${t.message}`, t;
                        }
                        if (a.single) {
                            if ("reference" === a.single.type) {
                                const e = s[0];
                                return {
                                    ref: e,
                                    raw: t,
                                    refs: s,
                                    wrapped: r || "local" === e.type && "label" === e.key
                                };
                            }
                            return u.stringify(a.single.value);
                        }
                        return {
                            formula: a,
                            raw: t,
                            refs: s
                        };
                    }
                    toString() {
                        return this.source;
                    }
                }, u.Template.prototype[i.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function(e) {
                    return e.replace(/\\(\{+)/g, (e, t)=>u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t)=>u.closes.slice(0, t.length));
                }, u.decode = function(e) {
                    return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
                }, u.split = function(e) {
                    const t = [];
                    let r = "";
                    for(let s = 0; s < e.length; ++s){
                        const n = e[s];
                        if ("{" === n) {
                            let n = "";
                            for(; s + 1 < e.length && "{" === e[s + 1];)n += "{", ++s;
                            t.push(r), r = n;
                        } else r += n;
                    }
                    return t.push(r), t;
                }, u.wrap = function(e, t) {
                    return t ? 1 === t.length ? `${t}${e}${t}` : `${t[0]}${e}${t[1]}` : e;
                }, u.stringify = function(e, t, r, s, n, a = {}) {
                    const o = typeof e, i = s && s.errors && s.errors.wrap || {};
                    let l = !1;
                    if (c.isRef(e) && e.render && (l = e.in, e = e.resolve(t, r, s, n, {
                        in: e.in,
                        ...a
                    })), null === e) return "null";
                    if ("string" === o) return u.wrap(e, a.arrayItems && i.string);
                    if ("number" === o || "function" === o || "symbol" === o) return e.toString();
                    if ("object" !== o) return JSON.stringify(e);
                    if (e instanceof Date) return u.Template.date(e, s);
                    if (e instanceof Map) {
                        const t = [];
                        for (const [r, s] of e.entries())t.push(`${r.toString()} -> ${s.toString()}`);
                        e = t;
                    }
                    if (!Array.isArray(e)) return e.toString();
                    const f = [];
                    for (const o of e)f.push(u.stringify(o, t, r, s, n, {
                        arrayItems: !0,
                        ...a
                    }));
                    return u.wrap(f.join(", "), !l && i.array);
                }, u.constants = {
                    true: !0,
                    false: !1,
                    null: null,
                    second: 1e3,
                    minute: 6e4,
                    hour: 36e5,
                    day: 864e5
                }, u.functions = {
                    if: (e, t, r)=>e ? t : r,
                    length: (e)=>"string" == typeof e ? e.length : e && "object" == typeof e ? Array.isArray(e) ? e.length : Object.keys(e).length : null,
                    msg (e) {
                        const [t, r, s, n, a] = this, o = a.messages;
                        if (!o) return "";
                        const i = l.template(t, o[0], e, r, s) || l.template(t, o[1], e, r, s);
                        return i ? i.render(t, r, s, n, a) : "";
                    },
                    number: (e)=>"number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
                };
            },
            4972 (e, t, r) {
                "use strict";
                const { assert: s, merge: n } = r(3115), a = r(680), o = r(9415), i = r(3541), l = r(8013), c = r(8529), u = {};
                e.exports = a.extend({
                    type: "alternatives",
                    flags: {
                        match: {
                            default: "any"
                        }
                    },
                    terms: {
                        matches: {
                            init: [],
                            register: c.toSibling
                        }
                    },
                    args: (e, ...t)=>1 === t.length && Array.isArray(t[0]) ? e.try(...t[0]) : e.try(...t),
                    validate (e, t) {
                        const { schema: r, error: s, state: a, prefs: o } = t;
                        if (r._flags.match) {
                            const t = [], i = [];
                            for(let s = 0; s < r.$_terms.matches.length; ++s){
                                const n = r.$_terms.matches[s], l = a.nest(n.schema, `match.${s}`);
                                l.snapshot();
                                const c = n.schema.$_validate(e, l, o);
                                c.errors ? (i.push(c.errors), l.restore()) : (t.push(c.value), l.commit());
                            }
                            if (0 === t.length) return {
                                errors: s("alternatives.any", {
                                    details: i.map((e)=>l.details(e, {
                                            override: !1
                                        }))
                                })
                            };
                            if ("one" === r._flags.match) return 1 === t.length ? {
                                value: t[0]
                            } : {
                                errors: s("alternatives.one")
                            };
                            if (t.length !== r.$_terms.matches.length) return {
                                errors: s("alternatives.all", {
                                    details: i.map((e)=>l.details(e, {
                                            override: !1
                                        }))
                                })
                            };
                            const c = (e)=>e.$_terms.matches.some((e)=>"object" === e.schema.type || "alternatives" === e.schema.type && c(e.schema));
                            return c(r) ? {
                                value: t.reduce((e, t)=>n(e, t, {
                                        mergeArrays: !1
                                    }))
                            } : {
                                value: t[t.length - 1]
                            };
                        }
                        const i = [];
                        for(let t = 0; t < r.$_terms.matches.length; ++t){
                            const s = r.$_terms.matches[t];
                            if (s.schema) {
                                const r = a.nest(s.schema, `match.${t}`);
                                r.snapshot();
                                const n = s.schema.$_validate(e, r, o);
                                if (!n.errors) return r.commit(), n;
                                r.restore(), i.push({
                                    schema: s.schema,
                                    reports: n.errors
                                });
                                continue;
                            }
                            const n = s.ref ? s.ref.resolve(e, a, o) : e, l = s.is ? [
                                s
                            ] : s.switch;
                            for(let r = 0; r < l.length; ++r){
                                const i = l[r], { is: c, then: u, otherwise: f } = i, m = `match.${t}${s.switch ? "." + r : ""}`;
                                if (c.$_match(n, a.nest(c, `${m}.is`), o)) {
                                    if (u) return u.$_validate(e, a.nest(u, `${m}.then`), o);
                                } else if (f) return f.$_validate(e, a.nest(f, `${m}.otherwise`), o);
                            }
                        }
                        return u.errors(i, t);
                    },
                    jsonSchema (e, t, r, s) {
                        const n = [];
                        for (const t of e.$_terms.matches)if (t.schema) n.push(t.schema.$_jsonSchema(r, s));
                        else {
                            const e = t.is ? [
                                t
                            ] : t.switch;
                            for (const t of e)t.then && n.push(t.then.$_jsonSchema(r, s)), t.otherwise && n.push(t.otherwise.$_jsonSchema(r, s));
                        }
                        if (n.length) {
                            var a;
                            delete t.type;
                            const r = null !== (a = e._flags.match) && void 0 !== a ? a : "any";
                            "one" === r ? t.oneOf = n : "all" === r ? t.allOf = n : t.anyOf = n;
                        }
                        return t;
                    },
                    rules: {
                        conditional: {
                            method (e, t) {
                                s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                                const r = this.clone(), n = i.when(r, e, t), a = n.is ? [
                                    n
                                ] : n.switch;
                                for (const e of a)if (e.then && e.otherwise) {
                                    r.$_setFlag("_endedSwitch", !0, {
                                        clone: !1
                                    });
                                    break;
                                }
                                return r.$_terms.matches.push(n), r.$_mutateRebuild();
                            }
                        },
                        match: {
                            method (e) {
                                if (s([
                                    "any",
                                    "one",
                                    "all"
                                ].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches)s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                                return this.$_setFlag("match", e);
                            }
                        },
                        try: {
                            method (...e) {
                                s(e.length, "Missing alternative schemas"), o.verifyFlat(e, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                                const t = this.clone();
                                for (const r of e)t.$_terms.matches.push({
                                    schema: t.$_compile(r)
                                });
                                return t.$_mutateRebuild();
                            }
                        }
                    },
                    overrides: {
                        label (e) {
                            return this.$_parent("label", e).$_modify({
                                each: (t, r)=>"is" !== r.path[0] && "string" != typeof t._flags.label ? t.label(e) : void 0,
                                ref: !1
                            });
                        },
                        isAsync () {
                            var e;
                            if (null !== (e = this.$_terms.externals) && void 0 !== e && e.length) return !0;
                            for (const e of this.$_terms.matches){
                                var t, r, s;
                                if (null !== (t = e.schema) && void 0 !== t && t.isAsync()) return !0;
                                if (null !== (r = e.then) && void 0 !== r && r.isAsync()) return !0;
                                if (null !== (s = e.otherwise) && void 0 !== s && s.isAsync()) return !0;
                            }
                            return !1;
                        }
                    },
                    rebuild (e) {
                        e.$_modify({
                            each: (t)=>{
                                o.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                                    clone: !1
                                });
                            }
                        });
                    },
                    manifest: {
                        build (e, t) {
                            if (t.matches) for (const r of t.matches){
                                const { schema: t, ref: s, is: n, not: a, then: o, otherwise: i } = r;
                                e = t ? e.try(t) : s ? e.conditional(s, {
                                    is: n,
                                    then: o,
                                    not: a,
                                    otherwise: i,
                                    switch: r.switch
                                }) : e.conditional(n, {
                                    then: o,
                                    otherwise: i
                                });
                            }
                            return e;
                        }
                    },
                    messages: {
                        "alternatives.all": "{{#label}} does not match all of the required types",
                        "alternatives.any": "{{#label}} does not match any of the allowed types",
                        "alternatives.match": "{{#label}} does not match any of the allowed types",
                        "alternatives.one": "{{#label}} matches more than one allowed type",
                        "alternatives.types": "{{#label}} must be one of {{#types}}"
                    }
                }), u.errors = function(e, { error: t, state: r }) {
                    if (!e.length) return {
                        errors: t("alternatives.any")
                    };
                    if (1 === e.length) return {
                        errors: e[0].reports
                    };
                    const s = new Set, n = [];
                    for (const { reports: a, schema: o } of e){
                        if (a.length > 1) return u.unmatched(e, t);
                        const i = a[0];
                        if (i instanceof l.Report == 0) return u.unmatched(e, t);
                        if (i.state.path.length !== r.path.length) {
                            n.push({
                                type: o.type,
                                report: i
                            });
                            continue;
                        }
                        if ("any.only" === i.code) {
                            for (const e of i.local.valids)s.add(e);
                            continue;
                        }
                        const [c, f] = i.code.split(".");
                        "base" !== f ? n.push({
                            type: o.type,
                            report: i
                        }) : "object.base" === i.code ? s.add(i.local.type) : s.add(c);
                    }
                    return n.length ? 1 === n.length ? {
                        errors: n[0].report
                    } : u.unmatched(e, t) : {
                        errors: t("alternatives.types", {
                            types: [
                                ...s
                            ]
                        })
                    };
                }, u.unmatched = function(e, t) {
                    const r = [];
                    for (const t of e)r.push(...t.reports);
                    return {
                        errors: t("alternatives.match", l.details(r, {
                            override: !1
                        }))
                    };
                };
            },
            680 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(2115), a = r(9415), o = r(6162);
                e.exports = n.extend({
                    type: "any",
                    flags: {
                        only: {
                            default: !1
                        }
                    },
                    terms: {
                        alterations: {
                            init: null
                        },
                        examples: {
                            init: null
                        },
                        externals: {
                            init: null
                        },
                        metas: {
                            init: []
                        },
                        notes: {
                            init: []
                        },
                        shared: {
                            init: null
                        },
                        tags: {
                            init: []
                        },
                        whens: {
                            init: null
                        }
                    },
                    rules: {
                        custom: {
                            method (e, t) {
                                return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                                    name: "custom",
                                    args: {
                                        method: e,
                                        description: t
                                    }
                                });
                            },
                            validate (e, t, { method: r }) {
                                try {
                                    return r(e, t);
                                } catch (e) {
                                    return t.error("any.custom", {
                                        error: e
                                    });
                                }
                            },
                            args: [
                                "method",
                                "description"
                            ],
                            multi: !0
                        },
                        messages: {
                            method (e) {
                                return this.prefs({
                                    messages: e
                                });
                            }
                        },
                        shared: {
                            method (e) {
                                s(a.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                                const t = this.clone();
                                return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
                            }
                        },
                        warning: {
                            method (e, t) {
                                return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                                    name: "warning",
                                    args: {
                                        code: e,
                                        local: t
                                    },
                                    warn: !0
                                });
                            },
                            validate: (e, t, { code: r, local: s })=>t.error(r, s),
                            args: [
                                "code",
                                "local"
                            ],
                            multi: !0
                        }
                    },
                    modifiers: {
                        keep (e, t = !0) {
                            e.keep = t;
                        },
                        message (e, t) {
                            e.message = o.compile(t);
                        },
                        warn (e, t = !0) {
                            e.warn = t;
                        }
                    },
                    manifest: {
                        build (e, t) {
                            for (const r of Object.keys(t)){
                                const s = t[r];
                                if ([
                                    "examples",
                                    "externals",
                                    "metas",
                                    "notes",
                                    "tags"
                                ].includes(r)) for (const t of s)e = e[r.slice(0, -1)](t);
                                else {
                                    if ("alterations" === r) {
                                        const t = {};
                                        for (const { target: e, adjuster: r } of s)t[e] = r;
                                        e = e.alter(t);
                                        continue;
                                    }
                                    if ("whens" !== r) {
                                        if ("shared" === r) for (const t of s)e = e.shared(t);
                                    } else for (const t of s){
                                        const { ref: r, is: s, not: n, then: a, otherwise: o, concat: i } = t;
                                        e = i ? e.concat(i) : r ? e.when(r, {
                                            is: s,
                                            not: n,
                                            then: a,
                                            otherwise: o,
                                            switch: t.switch,
                                            break: t.break
                                        }) : e.when(s, {
                                            then: a,
                                            otherwise: o,
                                            break: t.break
                                        });
                                    }
                                }
                            }
                            return e;
                        }
                    },
                    messages: {
                        "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
                        "any.default": "{{#label}} threw an error when running default method",
                        "any.failover": "{{#label}} threw an error when running failover method",
                        "any.invalid": "{{#label}} contains an invalid value",
                        "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
                        "any.ref": "{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}",
                        "any.required": "{{#label}} is required",
                        "any.unknown": "{{#label}} is not allowed"
                    }
                });
            },
            2591 (e, t, r) {
                "use strict";
                const { assert: s, deepEqual: n, reach: a } = r(3115), o = r(680), i = r(9415), l = r(3541), c = {};
                e.exports = o.extend({
                    type: "array",
                    flags: {
                        single: {
                            default: !1
                        },
                        sparse: {
                            default: !1
                        }
                    },
                    terms: {
                        items: {
                            init: [],
                            manifest: "schema"
                        },
                        ordered: {
                            init: [],
                            manifest: "schema"
                        },
                        _exclusions: {
                            init: []
                        },
                        _inclusions: {
                            init: []
                        },
                        _requireds: {
                            init: []
                        }
                    },
                    coerce: {
                        from: "object",
                        method (e, { schema: t, state: r, prefs: s }) {
                            if (!Array.isArray(e)) return;
                            const n = t.$_getRule("sort");
                            return n ? c.sort(t, e, n.args.options, r, s) : void 0;
                        }
                    },
                    validate (e, { schema: t, error: r }) {
                        if (!Array.isArray(e)) {
                            if (t._flags.single) {
                                const t = [
                                    e
                                ];
                                return t[i.symbols.arraySingle] = !0, {
                                    value: t
                                };
                            }
                            return {
                                errors: r("array.base")
                            };
                        }
                        if (t.$_getRule("items") || t.$_terms.externals) return {
                            value: e.slice()
                        };
                    },
                    jsonSchema (e, t, r, s) {
                        const n = e.$_terms.ordered;
                        if (n.length && (t.prefixItems = n.map((e)=>e.$_jsonSchema(r, s))), e.$_terms.items.length) {
                            let a;
                            a = 1 === e.$_terms.items.length ? e.$_terms.items[0].$_jsonSchema(r, s) : {
                                anyOf: e.$_terms.items.map((e)=>e.$_jsonSchema(r, s))
                            }, n.length ? (t.unevaluatedItems = a, c.setOrderedMinItems(t, n)) : t.items = a;
                        } else n.length && (t.unevaluatedItems = !1, c.setOrderedMinItems(t, n), t.maxItems = n.length);
                        const a = [];
                        for (const t of e._rules)"has" !== t.name || t.args.schema._refs.refs.length || a.push(t.args.schema.$_jsonSchema(r, s));
                        if (a.length && (1 === a.length ? t.contains = a[0] : t.allOf = a.map((e)=>({
                                contains: e
                            }))), e._flags.single && e.$_terms.items.length) {
                            let n;
                            n = 1 === e.$_terms.items.length ? e.$_terms.items[0].$_jsonSchema(r, s) : {
                                anyOf: e.$_terms.items.map((e)=>e.$_jsonSchema(r, s))
                            }, t = {
                                anyOf: [
                                    t,
                                    n
                                ]
                            };
                        }
                        return t;
                    },
                    rules: {
                        has: {
                            method (e) {
                                e = this.$_compile(e, {
                                    appendPath: !0
                                });
                                const t = this.$_addRule({
                                    name: "has",
                                    args: {
                                        schema: e
                                    }
                                });
                                return t.$_mutateRegister(e), t;
                            },
                            validate (e, { state: t, prefs: r, error: s }, { schema: n }) {
                                const a = [
                                    e,
                                    ...t.ancestors
                                ];
                                for(let s = 0; s < e.length; ++s){
                                    const o = t.localize([
                                        ...t.path,
                                        s
                                    ], a, n);
                                    if (n.$_match(e[s], o, r)) return e;
                                }
                                const o = n._flags.label;
                                return o ? s("array.hasKnown", {
                                    patternLabel: o
                                }) : s("array.hasUnknown", null);
                            },
                            multi: !0
                        },
                        items: {
                            method (...e) {
                                i.verifyFlat(e, "items");
                                const t = this.$_addRule("items");
                                for(let r = 0; r < e.length; ++r){
                                    const s = i.tryWithPath(()=>this.$_compile(e[r]), r, {
                                        append: !0
                                    });
                                    t.$_terms.items.push(s);
                                }
                                return t.$_mutateRebuild();
                            },
                            validate (e, { schema: t, error: r, state: s, prefs: n, errorsArray: a }) {
                                const o = t.$_terms._requireds.slice(), l = t.$_terms.ordered.slice(), u = [
                                    ...t.$_terms._inclusions,
                                    ...o
                                ], f = !e[i.symbols.arraySingle];
                                delete e[i.symbols.arraySingle];
                                const m = a();
                                let h = e.length;
                                for(let a = 0; a < h; ++a){
                                    const i = e[a];
                                    let p = !1, d = !1;
                                    const g = f ? a : new Number(a), y = [
                                        ...s.path,
                                        g
                                    ];
                                    if (!t._flags.sparse && void 0 === i) {
                                        if (m.push(r("array.sparse", {
                                            key: g,
                                            path: y,
                                            pos: a,
                                            value: void 0
                                        }, s.localize(y))), n.abortEarly) return m;
                                        l.shift();
                                        continue;
                                    }
                                    const b = [
                                        e,
                                        ...s.ancestors
                                    ];
                                    for (const e of t.$_terms._exclusions)if (e.$_match(i, s.localize(y, b, e), n, {
                                        presence: "ignore"
                                    })) {
                                        if (m.push(r("array.excludes", {
                                            pos: a,
                                            value: i
                                        }, s.localize(y))), n.abortEarly) return m;
                                        p = !0, l.shift();
                                        break;
                                    }
                                    if (p) continue;
                                    if (t.$_terms.ordered.length) {
                                        if (l.length) {
                                            const o = l.shift(), u = o.$_validate(i, s.localize(y, b, o), n);
                                            if (u.errors) {
                                                if (m.push(...u.errors), n.abortEarly) return m;
                                            } else if ("strip" === o._flags.result) c.fastSplice(e, a), --a, --h;
                                            else {
                                                if (!t._flags.sparse && void 0 === u.value) {
                                                    if (m.push(r("array.sparse", {
                                                        key: g,
                                                        path: y,
                                                        pos: a,
                                                        value: void 0
                                                    }, s.localize(y))), n.abortEarly) return m;
                                                    continue;
                                                }
                                                e[a] = u.value;
                                            }
                                            continue;
                                        }
                                        if (!t.$_terms.items.length) {
                                            if (m.push(r("array.orderedLength", {
                                                pos: a,
                                                limit: t.$_terms.ordered.length
                                            })), n.abortEarly) return m;
                                            break;
                                        }
                                    }
                                    const _ = [];
                                    let v = o.length;
                                    for(let l = 0; l < v; ++l){
                                        const u = s.localize(y, b, o[l]);
                                        u.snapshot();
                                        const f = o[l].$_validate(i, u, n);
                                        if (_[l] = f, !f.errors) {
                                            if (u.commit(), e[a] = f.value, d = !0, c.fastSplice(o, l), --l, --v, !t._flags.sparse && void 0 === f.value && (m.push(r("array.sparse", {
                                                key: g,
                                                path: y,
                                                pos: a,
                                                value: void 0
                                            }, s.localize(y))), n.abortEarly)) return m;
                                            break;
                                        }
                                        u.restore();
                                    }
                                    if (d) continue;
                                    const A = n.stripUnknown && !!n.stripUnknown.arrays || !1;
                                    v = u.length;
                                    for (const l of u){
                                        let u;
                                        const f = o.indexOf(l);
                                        if (-1 !== f) u = _[f];
                                        else {
                                            const o = s.localize(y, b, l);
                                            if (o.snapshot(), u = l.$_validate(i, o, n), !u.errors) {
                                                o.commit(), "strip" === l._flags.result ? (c.fastSplice(e, a), --a, --h) : t._flags.sparse || void 0 !== u.value ? e[a] = u.value : (m.push(r("array.sparse", {
                                                    key: g,
                                                    path: y,
                                                    pos: a,
                                                    value: void 0
                                                }, s.localize(y))), p = !0), d = !0;
                                                break;
                                            }
                                            o.restore();
                                        }
                                        if (1 === v) {
                                            if (A) {
                                                c.fastSplice(e, a), --a, --h, d = !0;
                                                break;
                                            }
                                            if (m.push(...u.errors), n.abortEarly) return m;
                                            p = !0;
                                            break;
                                        }
                                    }
                                    if (!p && (t.$_terms._inclusions.length || t.$_terms._requireds.length) && !d) {
                                        if (A) {
                                            c.fastSplice(e, a), --a, --h;
                                            continue;
                                        }
                                        if (m.push(r("array.includes", {
                                            pos: a,
                                            value: i
                                        }, s.localize(y))), n.abortEarly) return m;
                                    }
                                }
                                return o.length && c.fillMissedErrors(t, m, o, e, s, n), l.length && (c.fillOrderedErrors(t, m, l, e, s, n), m.length || c.fillDefault(l, e, s, n)), m.length ? m : e;
                            },
                            priority: !0,
                            manifest: !1
                        },
                        length: {
                            method (e) {
                                return this.$_addRule({
                                    name: "length",
                                    args: {
                                        limit: e
                                    },
                                    operator: "="
                                });
                            },
                            validate: (e, t, { limit: r }, { name: s, operator: n, args: a })=>i.compare(e.length, r, n) ? e : t.error("array." + s, {
                                    limit: a.limit,
                                    value: e
                                }),
                            jsonSchema: (e, t)=>(t.minItems = e.args.limit, t.maxItems = e.args.limit, t),
                            args: [
                                {
                                    name: "limit",
                                    ref: !0,
                                    assert: i.limit,
                                    message: "must be a positive integer"
                                }
                            ]
                        },
                        max: {
                            method (e) {
                                return this.$_addRule({
                                    name: "max",
                                    method: "length",
                                    args: {
                                        limit: e
                                    },
                                    operator: "<="
                                });
                            },
                            jsonSchema: (e, t)=>(t.maxItems = e.args.limit, t)
                        },
                        min: {
                            method (e) {
                                return this.$_addRule({
                                    name: "min",
                                    method: "length",
                                    args: {
                                        limit: e
                                    },
                                    operator: ">="
                                });
                            },
                            jsonSchema: (e, t)=>(t.minItems = e.args.limit, t)
                        },
                        ordered: {
                            method (...e) {
                                i.verifyFlat(e, "ordered");
                                const t = this.$_addRule("items");
                                for(let r = 0; r < e.length; ++r){
                                    const s = i.tryWithPath(()=>this.$_compile(e[r]), r, {
                                        append: !0
                                    });
                                    c.validateSingle(s, t), t.$_mutateRegister(s), t.$_terms.ordered.push(s);
                                }
                                return t.$_mutateRebuild();
                            }
                        },
                        single: {
                            method (e) {
                                const t = void 0 === e || !!e;
                                return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
                            }
                        },
                        sort: {
                            method (e = {}) {
                                i.assertOptions(e, [
                                    "by",
                                    "order"
                                ]);
                                const t = {
                                    order: e.order || "ascending"
                                };
                                return e.by && (t.by = l.ref(e.by, {
                                    ancestor: 0
                                }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                                    name: "sort",
                                    args: {
                                        options: t
                                    }
                                });
                            },
                            validate (e, { error: t, state: r, prefs: s, schema: n }, { options: a }) {
                                const { value: o, errors: i } = c.sort(n, e, a, r, s);
                                if (i) return i;
                                for(let r = 0; r < e.length; ++r)if (e[r] !== o[r]) return t("array.sort", {
                                    order: a.order,
                                    by: a.by ? a.by.key : "value"
                                });
                                return e;
                            },
                            convert: !0
                        },
                        sparse: {
                            method (e) {
                                const t = void 0 === e || !!e;
                                return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                                    clone: !1
                                });
                            }
                        },
                        unique: {
                            method (e, t = {}) {
                                s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), i.assertOptions(t, [
                                    "ignoreUndefined",
                                    "separator"
                                ]);
                                const r = {
                                    name: "unique",
                                    args: {
                                        options: t,
                                        comparator: e
                                    }
                                };
                                if (e) {
                                    if ("string" == typeof e) {
                                        const s = i.default(t.separator, ".");
                                        r.path = s ? e.split(s) : [
                                            e
                                        ];
                                    } else r.comparator = e;
                                }
                                return this.$_addRule(r);
                            },
                            validate (e, { state: t, error: r, schema: o }, { comparator: i, options: l }, { comparator: c, path: u }) {
                                const f = {
                                    string: Object.create(null),
                                    number: Object.create(null),
                                    undefined: Object.create(null),
                                    boolean: Object.create(null),
                                    bigint: Object.create(null),
                                    object: new Map,
                                    function: new Map,
                                    custom: new Map
                                }, m = c || n, h = l.ignoreUndefined;
                                for(let n = 0; n < e.length; ++n){
                                    const o = u ? a(e[n], u) : e[n], l = c ? f.custom : f[typeof o];
                                    if (s(l, "Failed to find unique map container for type", typeof o), l instanceof Map) {
                                        const s = l.entries();
                                        let a;
                                        for(; !(a = s.next()).done;)if (m(a.value[0], o)) {
                                            const s = t.localize([
                                                ...t.path,
                                                n
                                            ], [
                                                e,
                                                ...t.ancestors
                                            ]), o = {
                                                pos: n,
                                                value: e[n],
                                                dupePos: a.value[1],
                                                dupeValue: e[a.value[1]]
                                            };
                                            return u && (o.path = i), r("array.unique", o, s);
                                        }
                                        l.set(o, n);
                                    } else {
                                        if ((!h || void 0 !== o) && void 0 !== l[o]) {
                                            const s = {
                                                pos: n,
                                                value: e[n],
                                                dupePos: l[o],
                                                dupeValue: e[l[o]]
                                            };
                                            return u && (s.path = i), r("array.unique", s, t.localize([
                                                ...t.path,
                                                n
                                            ], [
                                                e,
                                                ...t.ancestors
                                            ]));
                                        }
                                        l[o] = n;
                                    }
                                }
                                return e;
                            },
                            jsonSchema: (e, t)=>(e.args.comparator || (t.uniqueItems = !0), t),
                            args: [
                                "comparator",
                                "options"
                            ],
                            multi: !0
                        }
                    },
                    overrides: {
                        isAsync () {
                            var e;
                            if (null !== (e = this.$_terms.externals) && void 0 !== e && e.length) return !0;
                            for (const e of this.$_terms.items)if (e.isAsync()) return !0;
                            for (const e of this.$_terms.ordered)if (e.isAsync()) return !0;
                            return !1;
                        }
                    },
                    cast: {
                        set: {
                            from: Array.isArray,
                            to: (e, t)=>new Set(e)
                        }
                    },
                    rebuild (e) {
                        e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
                        for (const t of e.$_terms.items)c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);
                        for (const t of e.$_terms.ordered)c.validateSingle(t, e);
                    },
                    manifest: {
                        build: (e, t)=>(t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
                    },
                    messages: {
                        "array.base": "{{#label}} must be an array",
                        "array.excludes": "{{#label}} contains an excluded value",
                        "array.hasKnown": "{{#label}} does not contain at least one required match for type {:#patternLabel}",
                        "array.hasUnknown": "{{#label}} does not contain at least one required match",
                        "array.includes": "{{#label}} does not match any of the allowed types",
                        "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
                        "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
                        "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
                        "array.length": "{{#label}} must contain {{#limit}} items",
                        "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
                        "array.min": "{{#label}} must contain at least {{#limit}} items",
                        "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
                        "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
                        "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
                        "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
                        "array.sparse": "{{#label}} must not be a sparse array item",
                        "array.unique": "{{#label}} contains a duplicate value"
                    }
                }), c.setOrderedMinItems = function(e, t) {
                    const r = c.orderedMinItems(t);
                    r && (e.minItems = r);
                }, c.orderedMinItems = function(e) {
                    for(let t = e.length - 1; t >= 0; --t)if ("required" === e[t]._flags.presence) return t + 1;
                    return 0;
                }, c.fillMissedErrors = function(e, t, r, s, n, a) {
                    const o = [];
                    let i = 0;
                    for (const e of r){
                        const t = e._flags.label;
                        t ? o.push(t) : ++i;
                    }
                    o.length ? i ? t.push(e.$_createError("array.includesRequiredBoth", s, {
                        knownMisses: o,
                        unknownMisses: i
                    }, n, a)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
                        knownMisses: o
                    }, n, a)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
                        unknownMisses: i
                    }, n, a));
                }, c.fillOrderedErrors = function(e, t, r, s, n, a) {
                    const o = [];
                    for (const e of r)"required" === e._flags.presence && o.push(e);
                    o.length && c.fillMissedErrors(e, t, o, s, n, a);
                }, c.fillDefault = function(e, t, r, s) {
                    const n = [];
                    let a = !0;
                    for(let o = e.length - 1; o >= 0; --o){
                        const i = e[o], l = [
                            t,
                            ...r.ancestors
                        ], c = i.$_validate(void 0, r.localize(r.path, l, i), s).value;
                        if (a) {
                            if (void 0 === c) continue;
                            a = !1;
                        }
                        n.unshift(c);
                    }
                    n.length && t.push(...n);
                }, c.fastSplice = function(e, t) {
                    let r = t;
                    for(; r < e.length;)e[r++] = e[r];
                    --e.length;
                }, c.validateSingle = function(e, t) {
                    ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
                        clone: !1
                    }));
                }, c.sort = function(e, t, r, s, n) {
                    const a = "ascending" === r.order ? 1 : -1, o = -1 * a, i = a, l = (l, u)=>{
                        let f = c.compare(l, u, o, i);
                        if (null !== f) return f;
                        if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, o, i), null !== f) return f;
                        const m = typeof l;
                        if (m !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
                        if ("number" !== m && "string" !== m) throw e.$_createError("array.sort.unsupported", t, {
                            type: m
                        }, s, n);
                        return "number" === m ? (l - u) * a : l < u ? o : i;
                    };
                    try {
                        return {
                            value: t.slice().sort(l)
                        };
                    } catch (e) {
                        return {
                            errors: e
                        };
                    }
                }, c.compare = function(e, t, r, s) {
                    return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
                };
            },
            6186 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(680), a = r(9415), o = r(6220), i = {
                    isBool: function(e) {
                        return "boolean" == typeof e;
                    }
                };
                e.exports = n.extend({
                    type: "boolean",
                    flags: {
                        sensitive: {
                            default: !1
                        }
                    },
                    terms: {
                        falsy: {
                            init: null,
                            manifest: "values"
                        },
                        truthy: {
                            init: null,
                            manifest: "values"
                        }
                    },
                    coerce (e, { schema: t }) {
                        if ("boolean" != typeof e) {
                            if ("string" == typeof e) {
                                const r = e.trim(), s = t._flags.sensitive ? r : r.toLowerCase();
                                e = "true" === s || "false" !== s && e;
                            }
                            return "boolean" != typeof e && (e = t.$_terms.truthy && t.$_terms.truthy.has(e, null, null, !t._flags.sensitive) || (!t.$_terms.falsy || !t.$_terms.falsy.has(e, null, null, !t._flags.sensitive)) && e), {
                                value: e
                            };
                        }
                    },
                    validate (e, { error: t }) {
                        if ("boolean" != typeof e) return {
                            value: e,
                            errors: t("boolean.base")
                        };
                    },
                    rules: {
                        truthy: {
                            method (...e) {
                                a.verifyFlat(e, "truthy");
                                const t = this.clone();
                                t.$_terms.truthy = t.$_terms.truthy || new o;
                                for(let r = 0; r < e.length; ++r){
                                    const n = e[r];
                                    s(void 0 !== n, "Cannot call truthy with undefined"), t.$_terms.truthy.add(n);
                                }
                                return t;
                            }
                        },
                        falsy: {
                            method (...e) {
                                a.verifyFlat(e, "falsy");
                                const t = this.clone();
                                t.$_terms.falsy = t.$_terms.falsy || new o;
                                for(let r = 0; r < e.length; ++r){
                                    const n = e[r];
                                    s(void 0 !== n, "Cannot call falsy with undefined"), t.$_terms.falsy.add(n);
                                }
                                return t;
                            }
                        },
                        sensitive: {
                            method (e = !0) {
                                return this.$_setFlag("sensitive", e);
                            }
                        }
                    },
                    cast: {
                        number: {
                            from: i.isBool,
                            to: (e, t)=>e ? 1 : 0
                        },
                        string: {
                            from: i.isBool,
                            to: (e, t)=>e ? "true" : "false"
                        }
                    },
                    manifest: {
                        build: (e, t)=>(t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
                    },
                    messages: {
                        "boolean.base": "{{#label}} must be a boolean"
                    }
                });
            },
            2588 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(680), a = r(9415), o = r(1532), i = {
                    formats: [
                        "iso",
                        "javascript",
                        "unix"
                    ],
                    isDate: function(e) {
                        return e instanceof Date;
                    }
                };
                e.exports = n.extend({
                    type: "date",
                    coerce: {
                        from: [
                            "number",
                            "string"
                        ],
                        method: (e, { schema: t })=>({
                                value: i.parse(e, t._flags.format) || e
                            })
                    },
                    validate (e, { schema: t, error: r, prefs: s }) {
                        if (e instanceof Date && !isNaN(e.getTime())) return;
                        const n = t._flags.format;
                        return s.convert && n && "string" == typeof e ? {
                            value: e,
                            errors: r("date.format", {
                                format: n
                            })
                        } : {
                            value: e,
                            errors: r("date.base")
                        };
                    },
                    jsonSchema: (e, t, r, s)=>(t.type = "string", t.format = "date-time", t),
                    rules: {
                        compare: {
                            method: !1,
                            validate (e, t, { date: r }, { name: s, operator: n, args: o }) {
                                const i = "now" === r ? Date.now() : r.getTime();
                                return a.compare(e.getTime(), i, n) ? e : t.error("date." + s, {
                                    limit: o.date,
                                    value: e
                                });
                            },
                            args: [
                                {
                                    name: "date",
                                    ref: !0,
                                    normalize: (e)=>"now" === e ? e : i.parse(e),
                                    assert: (e)=>null !== e,
                                    message: "must have a valid date format"
                                }
                            ]
                        },
                        format: {
                            method (e) {
                                return s(i.formats.includes(e), "Unknown date format", e), this.$_setFlag("format", e);
                            }
                        },
                        greater: {
                            method (e) {
                                return this.$_addRule({
                                    name: "greater",
                                    method: "compare",
                                    args: {
                                        date: e
                                    },
                                    operator: ">"
                                });
                            },
                            jsonSchema (e, t) {
                                const r = e.args.date;
                                return r instanceof Date && (t["x-constraint"] = {
                                    ...t["x-constraint"],
                                    greater: r.toISOString()
                                }), t;
                            }
                        },
                        iso: {
                            method () {
                                return this.format("iso");
                            }
                        },
                        less: {
                            method (e) {
                                return this.$_addRule({
                                    name: "less",
                                    method: "compare",
                                    args: {
                                        date: e
                                    },
                                    operator: "<"
                                });
                            },
                            jsonSchema (e, t) {
                                const r = e.args.date;
                                return r instanceof Date && (t["x-constraint"] = {
                                    ...t["x-constraint"],
                                    less: r.toISOString()
                                }), t;
                            }
                        },
                        max: {
                            method (e) {
                                return this.$_addRule({
                                    name: "max",
                                    method: "compare",
                                    args: {
                                        date: e
                                    },
                                    operator: "<="
                                });
                            },
                            jsonSchema (e, t) {
                                const r = e.args.date;
                                return r instanceof Date && (t["x-constraint"] = {
                                    ...t["x-constraint"],
                                    max: r.toISOString()
                                }), t;
                            }
                        },
                        min: {
                            method (e) {
                                return this.$_addRule({
                                    name: "min",
                                    method: "compare",
                                    args: {
                                        date: e
                                    },
                                    operator: ">="
                                });
                            },
                            jsonSchema (e, t) {
                                const r = e.args.date;
                                return r instanceof Date && (t["x-constraint"] = {
                                    ...t["x-constraint"],
                                    min: r.toISOString()
                                }), t;
                            }
                        },
                        timestamp: {
                            method (e = "javascript") {
                                return s([
                                    "javascript",
                                    "unix"
                                ].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
                            }
                        }
                    },
                    cast: {
                        number: {
                            from: i.isDate,
                            to: (e, t)=>e.getTime()
                        },
                        string: {
                            from: i.isDate,
                            to: (e, { prefs: t })=>o.date(e, t)
                        }
                    },
                    messages: {
                        "date.base": "{{#label}} must be a valid date",
                        "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
                        "date.greater": "{{#label}} must be greater than {{:#limit}}",
                        "date.less": "{{#label}} must be less than {{:#limit}}",
                        "date.max": "{{#label}} must be less than or equal to {{:#limit}}",
                        "date.min": "{{#label}} must be greater than or equal to {{:#limit}}",
                        "date.format.iso": "ISO 8601 date",
                        "date.format.javascript": "timestamp or number of milliseconds",
                        "date.format.unix": "timestamp or number of seconds"
                    }
                }), i.parse = function(e, t) {
                    if (e instanceof Date) return e;
                    if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
                    if (/^\s*$/.test(e)) return null;
                    if ("iso" === t) return a.isIsoDate(e) ? i.date(e.toString()) : null;
                    const r = e;
                    if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
                        if ("javascript" === t) return i.date(1 * e);
                        if ("unix" === t) return i.date(1e3 * e);
                        if ("string" == typeof r) return null;
                    }
                    return i.date(e);
                }, i.date = function(e) {
                    const t = new Date(e);
                    return isNaN(t.getTime()) ? null : t;
                };
            },
            4840 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(2888);
                e.exports = n.extend({
                    type: "function",
                    properties: {
                        typeof: "function"
                    },
                    rules: {
                        arity: {
                            method (e) {
                                return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                    name: "arity",
                                    args: {
                                        n: e
                                    }
                                });
                            },
                            validate: (e, t, { n: r })=>e.length === r ? e : t.error("function.arity", {
                                    n: r
                                })
                        },
                        class: {
                            method () {
                                return this.$_addRule("class");
                            },
                            validate: (e, t)=>/^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                                    value: e
                                })
                        },
                        minArity: {
                            method (e) {
                                return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                                    name: "minArity",
                                    args: {
                                        n: e
                                    }
                                });
                            },
                            validate: (e, t, { n: r })=>e.length >= r ? e : t.error("function.minArity", {
                                    n: r
                                })
                        },
                        maxArity: {
                            method (e) {
                                return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                    name: "maxArity",
                                    args: {
                                        n: e
                                    }
                                });
                            },
                            validate: (e, t, { n: r })=>e.length <= r ? e : t.error("function.maxArity", {
                                    n: r
                                })
                        }
                    },
                    messages: {
                        "function.arity": "{{#label}} must have an arity of {{#n}}",
                        "function.class": "{{#label}} must be a class",
                        "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
                        "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
                    }
                });
            },
            2888 (e, t, r) {
                "use strict";
                const { applyToDefaults: s, assert: n, clone: a } = r(3115), o = r(8248), i = r(680), l = r(9415), c = r(3541), u = r(8013), f = r(8529), m = r(1532), h = {
                    renameDefaults: {
                        alias: !1,
                        multiple: !1,
                        override: !1
                    }
                };
                e.exports = i.extend({
                    type: "_keys",
                    properties: {
                        typeof: "object"
                    },
                    flags: {
                        unknown: {
                            default: void 0
                        }
                    },
                    terms: {
                        dependencies: {
                            init: null
                        },
                        keys: {
                            init: null,
                            manifest: {
                                mapped: {
                                    from: "schema",
                                    to: "key"
                                }
                            }
                        },
                        patterns: {
                            init: null
                        },
                        renames: {
                            init: null
                        }
                    },
                    args: (e, t)=>e.keys(t),
                    jsonSchema (e, t, r, s) {
                        if (t.type = "object", e.$_terms.keys) {
                            t.properties = {};
                            const n = [];
                            for (const a of e.$_terms.keys){
                                const e = a.schema.$_jsonSchema(r, s);
                                t.properties[a.key] = e, a.schema._flags.id && (s.$defs[a.schema._flags.id] = e), ("required" === a.schema._flags.presence || "output" === r && void 0 !== a.schema._flags.default) && n.push(a.key);
                            }
                            n.length && (t.required = n.sort());
                        }
                        if (e.$_terms.patterns) {
                            const n = {};
                            for (const a of e.$_terms.patterns)a.regex ? n[a.regex.source] = a.rule.$_jsonSchema(r, s) : "any" === a.schema.type ? t.additionalProperties = a.rule.$_jsonSchema(r, s) : n[".*"] = a.rule.$_jsonSchema(r, s);
                            Object.keys(n).length && (t.patternProperties = n);
                        }
                        return void 0 === t.additionalProperties && !1 == (!0 === e._flags.unknown || void 0 === e._flags.unknown && !e.$_terms.keys && !e.$_terms.patterns && !e._flags.only) && (t.additionalProperties = !1), t;
                    },
                    validate (e, { schema: t, error: r, state: s, prefs: n }) {
                        if (!e || typeof e !== t.$_property("typeof") || Array.isArray(e)) return {
                            value: e,
                            errors: r("object.base", {
                                type: t.$_property("typeof")
                            })
                        };
                        if (!(t.$_terms.renames || t.$_terms.dependencies || t.$_terms.keys || t.$_terms.patterns || t.$_terms.externals)) return;
                        e = h.clone(e, n);
                        const a = [];
                        if (t.$_terms.renames && !h.rename(t, e, s, n, a)) return {
                            value: e,
                            errors: a
                        };
                        if (!t.$_terms.keys && !t.$_terms.patterns && !t.$_terms.dependencies) return {
                            value: e,
                            errors: a
                        };
                        const o = new Set(Object.keys(e));
                        if (t.$_terms.keys) {
                            const r = [
                                e,
                                ...s.ancestors
                            ];
                            for (const i of t.$_terms.keys){
                                const t = i.key, l = e[t];
                                o.delete(t);
                                const c = s.localize([
                                    ...s.path,
                                    t
                                ], r, i), u = i.schema.$_validate(l, c, n);
                                if (u.errors) {
                                    if (n.abortEarly) return {
                                        value: e,
                                        errors: u.errors
                                    };
                                    void 0 !== u.value && (e[t] = u.value), a.push(...u.errors);
                                } else "strip" === i.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[t] : void 0 !== u.value && (e[t] = u.value);
                            }
                        }
                        if (o.size || t._flags._hasPatternMatch) {
                            const r = h.unknown(t, e, o, a, s, n);
                            if (r) return r;
                        }
                        if (t.$_terms.dependencies) for (const r of t.$_terms.dependencies){
                            if (null !== r.key && !1 === h.isPresent(r.options)(r.key.resolve(e, s, n, null, {
                                shadow: !1
                            }))) continue;
                            const o = h.dependencies[r.rel](t, r, e, s, n);
                            if (o) {
                                const r = t.$_createError(o.code, e, o.context, s, n);
                                if (n.abortEarly) return {
                                    value: e,
                                    errors: r
                                };
                                a.push(r);
                            }
                        }
                        return {
                            value: e,
                            errors: a
                        };
                    },
                    rules: {
                        and: {
                            method (...e) {
                                return l.verifyFlat(e, "and"), h.dependency(this, "and", null, e);
                            }
                        },
                        append: {
                            method (e) {
                                return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
                            }
                        },
                        assert: {
                            method (e, t, r) {
                                m.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                                    appendPath: !0
                                });
                                const s = this.$_addRule({
                                    name: "assert",
                                    args: {
                                        subject: e,
                                        schema: t,
                                        message: r
                                    }
                                });
                                return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
                            },
                            validate (e, { error: t, prefs: r, state: s }, { subject: n, schema: a, message: o }) {
                                const i = n.resolve(e, s, r), l = f.isRef(n) ? n.absolute(s) : [];
                                return a.$_match(i, s.localize(l, [
                                    e,
                                    ...s.ancestors
                                ], a), r) ? e : t("object.assert", {
                                    subject: n,
                                    message: o
                                });
                            },
                            args: [
                                "subject",
                                "schema",
                                "message"
                            ],
                            multi: !0
                        },
                        instance: {
                            method (e, t) {
                                return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                                    name: "instance",
                                    args: {
                                        constructor: e,
                                        name: t
                                    }
                                });
                            },
                            validate: (e, t, { constructor: r, name: s })=>e instanceof r ? e : t.error("object.instance", {
                                    type: s,
                                    value: e
                                }),
                            args: [
                                "constructor",
                                "name"
                            ]
                        },
                        keys: {
                            method (e) {
                                n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                                const t = this.clone();
                                if (e) {
                                    if (Object.keys(e).length) {
                                        t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter((t)=>!e.hasOwnProperty(t.key)) : new h.Keys;
                                        for (const r of Object.keys(e))l.tryWithPath(()=>t.$_terms.keys.push({
                                                key: r,
                                                schema: this.$_compile(e[r])
                                            }), r);
                                    } else t.$_terms.keys = new h.Keys;
                                } else t.$_terms.keys = null;
                                return t.$_mutateRebuild();
                            }
                        },
                        length: {
                            method (e) {
                                return this.$_addRule({
                                    name: "length",
                                    args: {
                                        limit: e
                                    },
                                    operator: "="
                                });
                            },
                            validate: (e, t, { limit: r }, { name: s, operator: n, args: a })=>l.compare(Object.keys(e).length, r, n) ? e : t.error("object." + s, {
                                    limit: a.limit,
                                    value: e
                                }),
                            jsonSchema: (e, t)=>(t.minProperties = e.args.limit, t.maxProperties = e.args.limit, t),
                            args: [
                                {
                                    name: "limit",
                                    ref: !0,
                                    assert: l.limit,
                                    message: "must be a positive integer"
                                }
                            ]
                        },
                        max: {
                            method (e) {
                                return this.$_addRule({
                                    name: "max",
                                    method: "length",
                                    args: {
                                        limit: e
                                    },
                                    operator: "<="
                                });
                            },
                            jsonSchema: (e, t)=>(t.maxProperties = e.args.limit, t)
                        },
                        min: {
                            method (e) {
                                return this.$_addRule({
                                    name: "min",
                                    method: "length",
                                    args: {
                                        limit: e
                                    },
                                    operator: ">="
                                });
                            },
                            jsonSchema: (e, t)=>(t.minProperties = e.args.limit, t)
                        },
                        nand: {
                            method (...e) {
                                return l.verifyFlat(e, "nand"), h.dependency(this, "nand", null, e);
                            }
                        },
                        or: {
                            method (...e) {
                                return l.verifyFlat(e, "or"), h.dependency(this, "or", null, e);
                            }
                        },
                        oxor: {
                            method (...e) {
                                return h.dependency(this, "oxor", null, e);
                            }
                        },
                        pattern: {
                            method (e, t, r = {}) {
                                const s = e instanceof RegExp;
                                s || (e = this.$_compile(e, {
                                    appendPath: !0
                                })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, [
                                    "fallthrough",
                                    "matches"
                                ]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                                    appendPath: !0
                                });
                                const a = this.clone();
                                a.$_terms.patterns = a.$_terms.patterns || [];
                                const o = {
                                    [s ? "regex" : "schema"]: e,
                                    rule: t
                                };
                                return r.matches && (o.matches = this.$_compile(r.matches), "array" !== o.matches.type && (o.matches = o.matches.$_root.array().items(o.matches)), a.$_mutateRegister(o.matches), a.$_setFlag("_hasPatternMatch", !0, {
                                    clone: !1
                                })), r.fallthrough && (o.fallthrough = !0), a.$_terms.patterns.push(o), a.$_mutateRegister(t), a;
                            }
                        },
                        ref: {
                            method () {
                                return this.$_addRule("ref");
                            },
                            validate: (e, t)=>f.isRef(e) ? e : t.error("object.refType", {
                                    value: e
                                })
                        },
                        regex: {
                            method () {
                                return this.$_addRule("regex");
                            },
                            validate: (e, t)=>e instanceof RegExp ? e : t.error("object.regex", {
                                    value: e
                                })
                        },
                        rename: {
                            method (e, t, r = {}) {
                                n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof m, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, [
                                    "alias",
                                    "ignoreUndefined",
                                    "override",
                                    "multiple"
                                ]);
                                const a = this.clone();
                                a.$_terms.renames = a.$_terms.renames || [];
                                for (const t of a.$_terms.renames)n(t.from !== e, "Cannot rename the same key multiple times");
                                return t instanceof m && a.$_mutateRegister(t), a.$_terms.renames.push({
                                    from: e,
                                    to: t,
                                    options: s(h.renameDefaults, r)
                                }), a;
                            }
                        },
                        schema: {
                            method (e = "any") {
                                return this.$_addRule({
                                    name: "schema",
                                    args: {
                                        type: e
                                    }
                                });
                            },
                            validate: (e, t, { type: r })=>!l.isSchema(e) || "any" !== r && e.type !== r ? t.error("object.schema", {
                                    type: r
                                }) : e
                        },
                        unknown: {
                            method (e) {
                                return this.$_setFlag("unknown", !1 !== e);
                            }
                        },
                        with: {
                            method (e, t, r = {}) {
                                return h.dependency(this, "with", e, t, r);
                            }
                        },
                        without: {
                            method (e, t, r = {}) {
                                return h.dependency(this, "without", e, t, r);
                            }
                        },
                        xor: {
                            method (...e) {
                                return l.verifyFlat(e, "xor"), h.dependency(this, "xor", null, e);
                            }
                        }
                    },
                    overrides: {
                        default (e, t) {
                            return void 0 === e && (e = l.symbols.deepDefault), this.$_parent("default", e, t);
                        },
                        isAsync () {
                            var e, t, r;
                            if (null !== (e = this.$_terms.externals) && void 0 !== e && e.length) return !0;
                            if (null !== (t = this.$_terms.keys) && void 0 !== t && t.length) {
                                for (const e of this.$_terms.keys)if (e.schema.isAsync()) return !0;
                            }
                            if (null !== (r = this.$_terms.patterns) && void 0 !== r && r.length) {
                                for (const e of this.$_terms.patterns)if (e.rule.isAsync()) return !0;
                            }
                            return !1;
                        }
                    },
                    rebuild (e) {
                        e.$_terms.keys && (e.$_terms.keys = new h.Keys(...h.sortKeys(e.$_terms.keys)));
                    },
                    manifest: {
                        build (e, t) {
                            if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const { rel: r, key: s = null, peers: n, options: a } of t.dependencies)e = h.dependency(e, r, s, n, a);
                            if (t.patterns) for (const { regex: r, schema: s, rule: n, fallthrough: a, matches: o } of t.patterns)e = e.pattern(r || s, n, {
                                fallthrough: a,
                                matches: o
                            });
                            if (t.renames) for (const { from: r, to: s, options: n } of t.renames)e = e.rename(r, s, n);
                            return e;
                        }
                    },
                    messages: {
                        "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
                        "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
                        "object.base": "{{#label}} must be of type {{#type}}",
                        "object.instance": "{{#label}} must be an instance of {{:#type}}",
                        "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
                        "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
                        "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
                        "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
                        "object.nand": "{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}",
                        "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
                        "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
                        "object.refType": "{{#label}} must be a Joi reference",
                        "object.regex": "{{#label}} must be a RegExp object",
                        "object.rename.multiple": "{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}",
                        "object.rename.override": "{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists",
                        "object.rename.proto": "{{#label}} cannot rename {{:#from}} because target {{:#to}} is a reserved key",
                        "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
                        "object.unknown": "{{#label}} is not allowed",
                        "object.with": "{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}",
                        "object.without": "{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}",
                        "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
                    }
                }), h.clone = function(e, t) {
                    if ("object" == typeof e) {
                        if (t.nonEnumerables) return a(e, {
                            shallow: !0
                        });
                        const r = Object.getPrototypeOf(e), s = Object.create(r);
                        return Object.assign(s, e), Object.getPrototypeOf(s) !== r && Object.setPrototypeOf(s, r), s;
                    }
                    const r = function(...t) {
                        return e.apply(this, t);
                    };
                    return r.prototype = a(e.prototype), Object.defineProperty(r, "name", {
                        value: e.name,
                        writable: !1
                    }), Object.defineProperty(r, "length", {
                        value: e.length,
                        writable: !1
                    }), Object.assign(r, e), r;
                }, h.dependency = function(e, t, r, s, a) {
                    n(null === r || "string" == typeof r, t, "key must be a strings"), a || (a = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(a, [
                        "separator",
                        "isPresent"
                    ]), s = [].concat(s);
                    const o = l.default(a.separator, "."), i = [];
                    for (const e of s)n("string" == typeof e, t, "peers must be strings"), i.push(c.ref(e, {
                        separator: o,
                        ancestor: 0,
                        prefix: !1
                    }));
                    null !== r && (r = c.ref(r, {
                        separator: o,
                        ancestor: 0,
                        prefix: !1
                    }));
                    const u = e.clone();
                    return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new h.Dependency(t, r, i, s, a)), u;
                }, h.dependencies = {
                    and (e, t, r, s, n) {
                        const a = [], o = [], i = t.peers.length, l = h.isPresent(t.options);
                        for (const e of t.peers)!1 === l(e.resolve(r, s, n, null, {
                            shadow: !1
                        })) ? a.push(e.key) : o.push(e.key);
                        if (a.length !== i && o.length !== i) return {
                            code: "object.and",
                            context: {
                                present: o,
                                presentWithLabels: h.keysToLabels(e, o),
                                missing: a,
                                missingWithLabels: h.keysToLabels(e, a)
                            }
                        };
                    },
                    nand (e, t, r, s, n) {
                        const a = [], o = h.isPresent(t.options);
                        for (const e of t.peers)o(e.resolve(r, s, n, null, {
                            shadow: !1
                        })) && a.push(e.key);
                        if (a.length !== t.peers.length) return;
                        const i = t.paths[0], l = t.paths.slice(1);
                        return {
                            code: "object.nand",
                            context: {
                                main: i,
                                mainWithLabel: h.keysToLabels(e, i),
                                peers: l,
                                peersWithLabels: h.keysToLabels(e, l)
                            }
                        };
                    },
                    or (e, t, r, s, n) {
                        const a = h.isPresent(t.options);
                        for (const e of t.peers)if (a(e.resolve(r, s, n, null, {
                            shadow: !1
                        }))) return;
                        return {
                            code: "object.missing",
                            context: {
                                peers: t.paths,
                                peersWithLabels: h.keysToLabels(e, t.paths)
                            }
                        };
                    },
                    oxor (e, t, r, s, n) {
                        const a = [], o = h.isPresent(t.options);
                        for (const e of t.peers)o(e.resolve(r, s, n, null, {
                            shadow: !1
                        })) && a.push(e.key);
                        if (!a.length || 1 === a.length) return;
                        const i = {
                            peers: t.paths,
                            peersWithLabels: h.keysToLabels(e, t.paths)
                        };
                        return i.present = a, i.presentWithLabels = h.keysToLabels(e, a), {
                            code: "object.oxor",
                            context: i
                        };
                    },
                    with (e, t, r, s, n) {
                        const a = h.isPresent(t.options);
                        for (const o of t.peers)if (!1 === a(o.resolve(r, s, n, null, {
                            shadow: !1
                        }))) return {
                            code: "object.with",
                            context: {
                                main: t.key.key,
                                mainWithLabel: h.keysToLabels(e, t.key.key),
                                peer: o.key,
                                peerWithLabel: h.keysToLabels(e, o.key)
                            }
                        };
                    },
                    without (e, t, r, s, n) {
                        const a = h.isPresent(t.options);
                        for (const o of t.peers)if (a(o.resolve(r, s, n, null, {
                            shadow: !1
                        }))) return {
                            code: "object.without",
                            context: {
                                main: t.key.key,
                                mainWithLabel: h.keysToLabels(e, t.key.key),
                                peer: o.key,
                                peerWithLabel: h.keysToLabels(e, o.key)
                            }
                        };
                    },
                    xor (e, t, r, s, n) {
                        const a = [], o = h.isPresent(t.options);
                        for (const e of t.peers)o(e.resolve(r, s, n, null, {
                            shadow: !1
                        })) && a.push(e.key);
                        if (1 === a.length) return;
                        const i = {
                            peers: t.paths,
                            peersWithLabels: h.keysToLabels(e, t.paths)
                        };
                        return 0 === a.length ? {
                            code: "object.missing",
                            context: i
                        } : (i.present = a, i.presentWithLabels = h.keysToLabels(e, a), {
                            code: "object.xor",
                            context: i
                        });
                    }
                }, h.sortKeys = function(e, t = !0) {
                    const r = new o.Sorter;
                    for (const s of e)l.tryWithPath(()=>r.add(s, {
                            after: s.schema.$_rootReferences(),
                            group: s.key,
                            manual: t
                        }), s.key);
                    try {
                        return r.sort();
                    } catch  {
                        return h.sortKeys(e, !1);
                    }
                }, h.keysToLabels = function(e, t) {
                    return Array.isArray(t) ? t.map((t)=>e.$_mapLabels(t)) : e.$_mapLabels(t);
                }, h.isPresent = function(e) {
                    return "function" == typeof e.isPresent ? e.isPresent : (e)=>void 0 !== e;
                }, h.rename = function(e, t, r, s, n) {
                    const a = Object.create(null);
                    for (const o of e.$_terms.renames){
                        const i = [], l = "string" != typeof o.from;
                        if (l) for (const e of Object.keys(t)){
                            if (void 0 === t[e] && o.options.ignoreUndefined) continue;
                            if (e === o.to) continue;
                            const r = o.from.exec(e);
                            r && i.push({
                                from: e,
                                to: o.to,
                                match: r
                            });
                        }
                        else !Object.prototype.hasOwnProperty.call(t, o.from) || void 0 === t[o.from] && o.options.ignoreUndefined || i.push(o);
                        for (const c of i){
                            const i = c.from;
                            let u = c.to;
                            if (u instanceof m && (u = u.render(t, r, s, c.match)), i !== u) {
                                if (!o.options.multiple && a[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                                    from: i,
                                    to: u,
                                    pattern: l
                                }, r, s)), s.abortEarly)) return !1;
                                if (Object.prototype.hasOwnProperty.call(t, u) && !o.options.override && !a[u] && (n.push(e.$_createError("object.rename.override", t, {
                                    from: i,
                                    to: u,
                                    pattern: l
                                }, r, s)), s.abortEarly)) return !1;
                                if ("__proto__" !== u) void 0 === t[i] ? delete t[u] : t[u] = t[i], a[u] = !0, o.options.alias || delete t[i];
                                else if (n.push(e.$_createError("object.rename.proto", t, {
                                    from: i,
                                    to: u,
                                    pattern: l
                                }, r, s)), s.abortEarly) return !1;
                            }
                        }
                    }
                    return !0;
                }, h.unknown = function(e, t, r, s, n, a) {
                    if (e.$_terms.patterns) {
                        let o = !1;
                        const i = e.$_terms.patterns.map((e)=>{
                            if (e.matches) return o = !0, [];
                        }), l = [
                            t,
                            ...n.ancestors
                        ];
                        for (const o of r){
                            const c = t[o], u = [
                                ...n.path,
                                o
                            ];
                            for(let f = 0; f < e.$_terms.patterns.length; ++f){
                                const m = e.$_terms.patterns[f];
                                if (m.regex) {
                                    const e = m.regex.test(o);
                                    if (n.mainstay.tracer.debug(n, "rule", `pattern.${f}`, e ? "pass" : "error"), !e) continue;
                                } else if (!m.schema.$_match(o, n.nest(m.schema, `pattern.${f}`), a)) continue;
                                r.delete(o);
                                const h = n.localize(u, l, {
                                    schema: m.rule,
                                    key: o
                                }), p = m.rule.$_validate(c, h, a);
                                if (p.errors) {
                                    if (a.abortEarly) return {
                                        value: t,
                                        errors: p.errors
                                    };
                                    s.push(...p.errors);
                                }
                                if (m.matches && i[f].push(o), t[o] = p.value, !m.fallthrough) break;
                            }
                        }
                        if (o) for(let r = 0; r < i.length; ++r){
                            const o = i[r];
                            if (!o) continue;
                            const c = e.$_terms.patterns[r].matches, f = n.localize(n.path, l, c), m = c.$_validate(o, f, a);
                            if (m.errors) {
                                const r = u.details(m.errors, {
                                    override: !1
                                });
                                r.matches = o;
                                const i = e.$_createError("object.pattern.match", t, r, n, a);
                                if (a.abortEarly) return {
                                    value: t,
                                    errors: i
                                };
                                s.push(i);
                            }
                        }
                    }
                    if (r.size && (e.$_terms.keys || e.$_terms.patterns)) {
                        if (a.stripUnknown && void 0 === e._flags.unknown || a.skipFunctions) {
                            const e = !(!a.stripUnknown || !0 !== a.stripUnknown && !a.stripUnknown.objects);
                            for (const s of r)e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
                        }
                        if (!l.default(e._flags.unknown, a.allowUnknown)) for (const o of r){
                            const r = n.localize([
                                ...n.path,
                                o
                            ], []), i = e.$_createError("object.unknown", t[o], {
                                child: o
                            }, r, a, {
                                flags: !1
                            });
                            if (a.abortEarly) return {
                                value: t,
                                errors: i
                            };
                            s.push(i);
                        }
                    }
                }, h.Dependency = class {
                    constructor(e, t, r, s, n){
                        this.rel = e, this.key = t, this.peers = r, this.paths = s, this.options = n;
                    }
                    describe() {
                        const e = {
                            rel: this.rel,
                            peers: this.paths
                        };
                        return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
                            ...e.options,
                            separator: this.peers[0].separator
                        }), this.options.isPresent && (e.options = {
                            ...e.options,
                            isPresent: this.options.isPresent
                        }), e;
                    }
                }, h.Keys = class extends Array {
                    concat(e) {
                        const t = this.slice(), r = new Map;
                        for(let e = 0; e < t.length; ++e)r.set(t[e].key, e);
                        for (const s of e){
                            const e = s.key, n = r.get(e);
                            void 0 !== n ? t[n] = {
                                key: e,
                                schema: t[n].schema.concat(s.schema)
                            } : t.push(s);
                        }
                        return t;
                    }
                };
            },
            9556 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(680), a = r(9415), o = r(3541), i = r(8013), l = {};
                e.exports = n.extend({
                    type: "link",
                    properties: {
                        schemaChain: !0
                    },
                    terms: {
                        link: {
                            init: null,
                            manifest: "single",
                            register: !1
                        }
                    },
                    args: (e, t)=>e.ref(t),
                    jsonSchema (e, t, r, s) {
                        if (!e.$_terms.link) return t;
                        const { ref: n } = e.$_terms.link[0];
                        return "root" === n.ancestor || n.ancestor > 0 ? (t.$ref = `#/${n.path.map((e)=>`properties/${e}`).join("/")}`, t) : (1 === n.path.length ? t.$ref = `#/$defs/${n.path[0]}` : t.$ref = `#/${n.path.slice(1).map((e)=>`properties/${e}`).join("/")}`, t);
                    },
                    validate (e, { schema: t, state: r, prefs: n, error: a }) {
                        s(t.$_terms.link, "Uninitialized link schema");
                        const o = t._flags.maxRecursion;
                        if (void 0 !== o && r.schemas.filter((e)=>e.schema === t).length > o) return {
                            value: e,
                            errors: a("link.maxRecursion", {
                                limit: o
                            })
                        };
                        const i = l.generate(t, e, r, n), c = t.$_terms.link[0].ref;
                        try {
                            return i.$_validate(e, r.nest(i, `link:${c.display}:${i.type}`), n);
                        } catch (t) {
                            if (!(t instanceof RangeError)) throw t;
                            return {
                                value: e,
                                errors: a("link.depth")
                            };
                        }
                    },
                    generate: (e, t, r, s)=>l.generate(e, t, r, s),
                    rules: {
                        ref: {
                            method (e) {
                                s(!this.$_terms.link, "Cannot reinitialize schema"), e = o.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                                const t = this.clone();
                                return t.$_terms.link = [
                                    {
                                        ref: e
                                    }
                                ], t;
                            }
                        },
                        relative: {
                            method (e = !0) {
                                return this.$_setFlag("relative", e);
                            }
                        },
                        maxRecursion: {
                            method (e) {
                                return s(Number.isSafeInteger(e) && e >= 1, "limit must be a positive integer"), this.$_setFlag("maxRecursion", e);
                            }
                        }
                    },
                    messages: {
                        "link.depth": "{{#label}} exceeds maximum recursion depth supported by the runtime",
                        "link.maxRecursion": "{{#label}} exceeds maximum recursion depth of {{#limit}}"
                    },
                    overrides: {
                        concat (e) {
                            s(this.$_terms.link, "Uninitialized link schema"), s(a.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
                            const t = this.clone();
                            return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                                concat: e
                            }), t.$_mutateRebuild();
                        }
                    },
                    manifest: {
                        build: (e, t)=>(s(t.link, "Invalid link description missing link"), e.ref(t.link))
                    }
                }), l.generate = function(e, t, r, s) {
                    let n = r.mainstay.links.get(e);
                    if (n) return n._generate(t, r, s).schema;
                    const a = e.$_terms.link[0].ref, { perspective: o, path: i } = l.perspective(a, r);
                    l.assert(o, "which is outside of schema boundaries", a, e, r, s);
                    try {
                        n = i.length ? o.$_reach(i) : o;
                    } catch  {
                        l.assert(!1, "to non-existing schema", a, e, r, s);
                    }
                    return l.assert("link" !== n.type, "which is another link", a, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
                }, l.perspective = function(e, t) {
                    if ("local" === e.type) {
                        for (const { schema: r, key: s } of t.schemas){
                            if ((r._flags.id || s) === e.path[0]) return {
                                perspective: r,
                                path: e.path.slice(1)
                            };
                            if (r.$_terms.shared) {
                                for (const t of r.$_terms.shared)if (t._flags.id === e.path[0]) return {
                                    perspective: t,
                                    path: e.path.slice(1)
                                };
                            }
                        }
                        return {
                            perspective: null,
                            path: null
                        };
                    }
                    return "root" === e.ancestor ? {
                        perspective: t.schemas[t.schemas.length - 1].schema,
                        path: e.path
                    } : {
                        perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
                        path: e.path
                    };
                }, l.assert = function(e, t, r, n, a, o) {
                    e || s(!1, `"${i.label(n._flags, a, o)}" contains link reference "${r.display}" ${t}`);
                };
            },
            4709 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(680), a = r(9415), o = {
                    numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
                    precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/,
                    exponentialPartRegex: /[eE][+-]?\d+$/,
                    leadingSignAndZerosRegex: /^[+-]?(0*)?/,
                    dotRegex: /\./,
                    trailingZerosRegex: /0+$/,
                    decimalPlaces (e) {
                        const t = e.toString(), r = t.indexOf("."), s = t.indexOf("e");
                        return (r < 0 ? 0 : (s < 0 ? t.length : s) - r - 1) + (s < 0 ? 0 : Math.max(0, -parseInt(t.slice(s + 1))));
                    }
                };
                e.exports = n.extend({
                    type: "number",
                    flags: {
                        unsafe: {
                            default: !1
                        }
                    },
                    coerce: {
                        from: "string",
                        method (e, { schema: t, error: r }) {
                            if (!e.match(o.numberRx)) return;
                            e = e.trim();
                            const s = {
                                value: parseFloat(e)
                            };
                            if (0 === s.value && (s.value = 0), !t._flags.unsafe) {
                                if (e.match(/e/i)) {
                                    if (o.extractSignificantDigits(e) !== o.extractSignificantDigits(String(s.value))) return s.errors = r("number.unsafe"), s;
                                } else {
                                    const t = s.value.toString();
                                    if (t.match(/e/i)) return s;
                                    if (t !== o.normalizeDecimal(e)) return s.errors = r("number.unsafe"), s;
                                }
                            }
                            return s;
                        }
                    },
                    validate (e, { schema: t, error: r, prefs: s }) {
                        if (e === 1 / 0 || e === -1 / 0) return {
                            value: e,
                            errors: r("number.infinity")
                        };
                        if (!a.isNumber(e)) return {
                            value: e,
                            errors: r("number.base")
                        };
                        const n = {
                            value: e
                        };
                        if (s.convert) {
                            const e = t.$_getRule("precision");
                            if (e) {
                                const t = Math.pow(10, e.args.limit);
                                n.value = Math.round(n.value * t) / t;
                            }
                        }
                        return 0 === n.value && (n.value = 0), !t._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (n.errors = r("number.unsafe")), n;
                    },
                    rules: {
                        compare: {
                            method: !1,
                            validate: (e, t, { limit: r }, { name: s, operator: n, args: o })=>a.compare(e, r, n) ? e : t.error("number." + s, {
                                    limit: o.limit,
                                    value: e
                                }),
                            args: [
                                {
                                    name: "limit",
                                    ref: !0,
                                    assert: a.isNumber,
                                    message: "must be a number"
                                }
                            ]
                        },
                        greater: {
                            method (e) {
                                return this.$_addRule({
                                    name: "greater",
                                    method: "compare",
                                    args: {
                                        limit: e
                                    },
                                    operator: ">"
                                });
                            },
                            jsonSchema: (e, t)=>(t.exclusiveMinimum = e.args.limit, t)
                        },
                        integer: {
                            method () {
                                return this.$_addRule("integer");
                            },
                            validate: (e, t)=>Math.trunc(e) - e === 0 ? e : t.error("number.integer"),
                            jsonSchema: (e, t)=>(t.type = "integer", t)
                        },
                        less: {
                            method (e) {
                                return this.$_addRule({
                                    name: "less",
                                    method: "compare",
                                    args: {
                                        limit: e
                                    },
                                    operator: "<"
                                });
                            },
                            jsonSchema: (e, t)=>(t.exclusiveMaximum = e.args.limit, t)
                        },
                        max: {
                            method (e) {
                                return this.$_addRule({
                                    name: "max",
                                    method: "compare",
                                    args: {
                                        limit: e
                                    },
                                    operator: "<="
                                });
                            },
                            jsonSchema: (e, t)=>(t.maximum = e.args.limit, t)
                        },
                        min: {
                            method (e) {
                                return this.$_addRule({
                                    name: "min",
                                    method: "compare",
                                    args: {
                                        limit: e
                                    },
                                    operator: ">="
                                });
                            },
                            jsonSchema: (e, t)=>(t.minimum = e.args.limit, t)
                        },
                        multiple: {
                            method (e) {
                                const t = "number" == typeof e ? o.decimalPlaces(e) : null, r = Math.pow(10, t);
                                return this.$_addRule({
                                    name: "multiple",
                                    args: {
                                        base: e,
                                        baseDecimalPlace: t,
                                        pfactor: r
                                    }
                                });
                            },
                            validate: (e, t, { base: r, baseDecimalPlace: s, pfactor: n }, a)=>o.decimalPlaces(e) > s ? t.error("number.multiple", {
                                    multiple: a.args.base,
                                    value: e
                                }) : Math.round(n * e) % Math.round(n * r) === 0 ? e : t.error("number.multiple", {
                                    multiple: a.args.base,
                                    value: e
                                }),
                            jsonSchema: (e, t)=>(t.multipleOf = e.args.base, t),
                            args: [
                                {
                                    name: "base",
                                    ref: !0,
                                    assert: (e)=>"number" == typeof e && isFinite(e) && e > 0,
                                    message: "must be a positive number"
                                },
                                "baseDecimalPlace",
                                "pfactor"
                            ],
                            multi: !0
                        },
                        negative: {
                            method () {
                                return this.sign("negative");
                            }
                        },
                        port: {
                            method () {
                                return this.$_addRule("port");
                            },
                            validate: (e, t)=>Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port"),
                            jsonSchema: (e, t)=>(t.type = "integer", t.minimum = 0, t.maximum = 65535, t)
                        },
                        positive: {
                            method () {
                                return this.sign("positive");
                            }
                        },
                        precision: {
                            method (e) {
                                return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                                    name: "precision",
                                    args: {
                                        limit: e
                                    }
                                });
                            },
                            validate (e, t, { limit: r }) {
                                const s = e.toString().match(o.precisionRx);
                                return Math.max((s[1] ? s[1].length : 0) - (s[2] ? parseInt(s[2], 10) : 0), 0) <= r ? e : t.error("number.precision", {
                                    limit: r,
                                    value: e
                                });
                            },
                            convert: !0
                        },
                        sign: {
                            method (e) {
                                return s([
                                    "negative",
                                    "positive"
                                ].includes(e), "Invalid sign", e), this.$_addRule({
                                    name: "sign",
                                    args: {
                                        sign: e
                                    }
                                });
                            },
                            validate: (e, t, { sign: r })=>"negative" === r && e < 0 || "positive" === r && e > 0 ? e : t.error(`number.${r}`),
                            jsonSchema: (e, t)=>("positive" === e.args.sign ? t.exclusiveMinimum = 0 : t.exclusiveMaximum = 0, t)
                        },
                        unsafe: {
                            method (e = !0) {
                                return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
                            }
                        }
                    },
                    cast: {
                        string: {
                            from: (e)=>"number" == typeof e,
                            to: (e, t)=>e.toString()
                        }
                    },
                    messages: {
                        "number.base": "{{#label}} must be a number",
                        "number.greater": "{{#label}} must be greater than {{#limit}}",
                        "number.infinity": "{{#label}} cannot be infinity",
                        "number.integer": "{{#label}} must be an integer",
                        "number.less": "{{#label}} must be less than {{#limit}}",
                        "number.max": "{{#label}} must be less than or equal to {{#limit}}",
                        "number.min": "{{#label}} must be greater than or equal to {{#limit}}",
                        "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
                        "number.negative": "{{#label}} must be a negative number",
                        "number.port": "{{#label}} must be a valid port",
                        "number.positive": "{{#label}} must be a positive number",
                        "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
                        "number.unsafe": "{{#label}} must be a safe number"
                    }
                }), o.extractSignificantDigits = function(e) {
                    return e.replace(o.exponentialPartRegex, "").replace(o.dotRegex, "").replace(o.trailingZerosRegex, "").replace(o.leadingSignAndZerosRegex, "");
                }, o.normalizeDecimal = function(e) {
                    return (e = e.replace(/^\+/, "").replace(/\.0*$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([0-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
                };
            },
            7487 (e, t, r) {
                "use strict";
                const s = r(2888);
                e.exports = s.extend({
                    type: "object",
                    cast: {
                        map: {
                            from: (e)=>e && "object" == typeof e,
                            to: (e, t)=>new Map(Object.entries(e))
                        }
                    }
                });
            },
            9033 (e, t, r) {
                "use strict";
                const { assert: s, escapeRegex: n } = r(3115), { isDomainValid: a, isEmailValid: o, ipRegex: i, uriRegex: l } = r(9089), c = r(7368), u = r(680), f = r(9415), m = {
                    tlds: c.tlds instanceof Set && {
                        tlds: {
                            allow: c.tlds,
                            deny: null
                        }
                    },
                    base64Regex: {
                        true: {
                            true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
                            false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
                        },
                        false: {
                            true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
                            false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
                        }
                    },
                    dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
                    hexRegex: {
                        withPrefix: /^0x[0-9a-f]+$/i,
                        withOptionalPrefix: /^(?:0x)?[0-9a-f]+$/i,
                        withoutPrefix: /^[0-9a-f]+$/i
                    },
                    ipRegex: i({
                        cidr: "forbidden"
                    }).regex,
                    isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
                    guidBrackets: {
                        "{": "}",
                        "[": "]",
                        "(": ")",
                        "": ""
                    },
                    guidVersions: {
                        uuidv1: "1",
                        uuidv2: "2",
                        uuidv3: "3",
                        uuidv4: "4",
                        uuidv5: "5",
                        uuidv6: "6",
                        uuidv7: "7",
                        uuidv8: "8"
                    },
                    guidSeparators: new Set([
                        void 0,
                        !0,
                        !1,
                        "-",
                        ":"
                    ]),
                    normalizationForms: [
                        "NFC",
                        "NFD",
                        "NFKC",
                        "NFKD"
                    ]
                };
                e.exports = u.extend({
                    type: "string",
                    flags: {
                        insensitive: {
                            default: !1
                        },
                        truncate: {
                            default: !1
                        }
                    },
                    terms: {
                        replacements: {
                            init: null
                        }
                    },
                    coerce: {
                        from: "string",
                        method (e, { schema: t, state: r, prefs: s }) {
                            const n = t.$_getRule("normalize");
                            n && (e = e.normalize(n.args.form));
                            const a = t.$_getRule("case");
                            a && (e = "upper" === a.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
                            const o = t.$_getRule("trim");
                            if (o && o.args.enabled && (e = e.trim()), t.$_terms.replacements) for (const r of t.$_terms.replacements)e = e.replace(r.pattern, r.replacement);
                            const i = t.$_getRule("hex");
                            if (i && i.args.options.byteAligned && e.length % 2 != 0 && (e = `0${e}`), t.$_getRule("isoDate")) {
                                const t = m.isoDate(e);
                                t && (e = t);
                            }
                            if (t._flags.truncate) {
                                const n = t.$_getRule("max");
                                if (n) {
                                    let a = n.args.limit;
                                    if (f.isResolvable(a) && (a = a.resolve(e, r, s), !f.limit(a))) return {
                                        value: e,
                                        errors: t.$_createError("any.ref", a, {
                                            ref: n.args.limit,
                                            arg: "limit",
                                            reason: "must be a positive integer"
                                        }, r, s)
                                    };
                                    e = e.slice(0, a);
                                }
                            }
                            return {
                                value: e
                            };
                        }
                    },
                    validate (e, { schema: t, error: r }) {
                        if ("string" != typeof e) return {
                            value: e,
                            errors: r("string.base")
                        };
                        if ("" === e) {
                            const s = t.$_getRule("min");
                            if (s && 0 === s.args.limit) return;
                            return {
                                value: e,
                                errors: r("string.empty")
                            };
                        }
                    },
                    jsonSchema (e, t, r, s) {
                        var n;
                        if (!(null !== (n = e._valids) && void 0 !== n && n.has("") || e._flags.only)) {
                            const r = e.$_getRule("min"), s = e.$_getRule("length");
                            (!r || r.args.limit > 0) && (!s || s.args.limit > 0) && (t.minLength = 1);
                        }
                        return t;
                    },
                    rules: {
                        alphanum: {
                            method () {
                                return this.$_addRule("alphanum");
                            },
                            validate: (e, t)=>/^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
                        },
                        base64: {
                            method (e = {}) {
                                return f.assertOptions(e, [
                                    "paddingRequired",
                                    "urlSafe"
                                ]), e = {
                                    urlSafe: !1,
                                    paddingRequired: !0,
                                    ...e
                                }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), s("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                                    name: "base64",
                                    args: {
                                        options: e
                                    }
                                });
                            },
                            validate: (e, t, { options: r })=>m.base64Regex[r.paddingRequired][r.urlSafe].test(e) ? e : t.error("string.base64"),
                            jsonSchema: (e, t)=>(t.format = "base64", t)
                        },
                        case: {
                            method (e) {
                                return s([
                                    "lower",
                                    "upper"
                                ].includes(e), "Invalid case:", e), this.$_addRule({
                                    name: "case",
                                    args: {
                                        direction: e
                                    }
                                });
                            },
                            validate: (e, t, { direction: r })=>"lower" === r && e === e.toLocaleLowerCase() || "upper" === r && e === e.toLocaleUpperCase() ? e : t.error(`string.${r}case`),
                            convert: !0
                        },
                        creditCard: {
                            method () {
                                return this.$_addRule("creditCard");
                            },
                            validate (e, t) {
                                let r = e.length, s = 0, n = 1;
                                for(; r--;){
                                    const t = e.charAt(r) * n;
                                    s += t - 9 * (t > 9), n ^= 3;
                                }
                                return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
                            }
                        },
                        dataUri: {
                            method (e = {}) {
                                return f.assertOptions(e, [
                                    "paddingRequired"
                                ]), e = {
                                    paddingRequired: !0,
                                    ...e
                                }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                                    name: "dataUri",
                                    args: {
                                        options: e
                                    }
                                });
                            },
                            validate (e, t, { options: r }) {
                                const s = e.match(m.dataUriRegex);
                                if (s) {
                                    if (!s[2]) return e;
                                    if ("base64" !== s[2]) return e;
                                    if (m.base64Regex[r.paddingRequired].false.test(s[3])) return e;
                                }
                                return t.error("string.dataUri");
                            },
                            jsonSchema: (e, t)=>(t.format = "data-uri", t)
                        },
                        domain: {
                            method (e) {
                                e && f.assertOptions(e, [
                                    "allowFullyQualified",
                                    "allowUnicode",
                                    "allowUnderscore",
                                    "maxDomainSegments",
                                    "minDomainSegments",
                                    "tlds"
                                ]);
                                const t = m.addressOptions(e);
                                return this.$_addRule({
                                    name: "domain",
                                    args: {
                                        options: e
                                    },
                                    address: t
                                });
                            },
                            validate: (e, t, r, { address: s })=>a(e, s) ? e : t.error("string.domain")
                        },
                        email: {
                            method (e = {}) {
                                f.assertOptions(e, [
                                    "allowFullyQualified",
                                    "allowUnicode",
                                    "allowUnderscore",
                                    "ignoreLength",
                                    "maxDomainSegments",
                                    "minDomainSegments",
                                    "multiple",
                                    "separator",
                                    "tlds"
                                ]), s(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                                const t = m.addressOptions(e), r = e.multiple ? new RegExp(`(?:(?<!\\s)\\s+)?[${e.separator ? n(e.separator) : ","}]\\s*`) : void 0;
                                return this.$_addRule({
                                    name: "email",
                                    args: {
                                        options: e
                                    },
                                    regex: r,
                                    address: t
                                });
                            },
                            validate (e, t, { options: r }, { regex: s, address: n }) {
                                const a = r.multiple ? e.split(s) : [
                                    e
                                ], i = [];
                                for (const e of a)o(e, n) || i.push(e);
                                return i.length ? t.error("string.email", {
                                    value: e,
                                    invalids: i
                                }) : e;
                            },
                            jsonSchema: (e, t)=>(t.format = "email", t)
                        },
                        guid: {
                            alias: "uuid",
                            method (e = {}) {
                                f.assertOptions(e, [
                                    "version",
                                    "separator",
                                    "wrapper"
                                ]), s(void 0 === e.wrapper || "boolean" == typeof e.wrapper || "string" == typeof e.wrapper && "string" == typeof m.guidBrackets[e.wrapper], `"wrapper" must be true, false, or one of "${Object.keys(m.guidBrackets).filter(Boolean).join('", "')}"`);
                                let t = "";
                                if (e.version) {
                                    const r = [].concat(e.version);
                                    s(r.length >= 1, "version must have at least 1 valid version specified");
                                    const n = new Set;
                                    for(let e = 0; e < r.length; ++e){
                                        const a = r[e];
                                        s("string" == typeof a, "version at position " + e + " must be a string");
                                        const o = m.guidVersions[a.toLowerCase()];
                                        s(o, "version at position " + e + " must be one of " + Object.keys(m.guidVersions).join(", ")), s(!n.has(o), "version at position " + e + " must not be a duplicate"), t += o, n.add(o);
                                    }
                                }
                                s(m.guidSeparators.has(e.separator), 'separator must be one of true, false, "-", or ":"');
                                const r = void 0 === e.separator ? "[:-]?" : !0 === e.separator ? "[:-]" : !1 === e.separator ? "[]?" : `\\${e.separator}`;
                                let a, o;
                                void 0 === e.wrapper ? (a = "[\\[{\\(]?", o = "[\\]}\\)]?") : !0 === e.wrapper ? (a = "[\\[{\\(]", o = "[\\]}\\)]") : !1 === e.wrapper ? (a = "", o = "") : (a = n(e.wrapper), o = n(m.guidBrackets[e.wrapper]));
                                const i = new RegExp(`^(${a})[0-9A-F]{8}(${r})[0-9A-F]{4}\\2?[${t || "0-9A-F"}][0-9A-F]{3}\\2?[${t ? "89AB" : "0-9A-F"}][0-9A-F]{3}\\2?[0-9A-F]{12}(${o})$`, "i");
                                return this.$_addRule({
                                    name: "guid",
                                    args: {
                                        options: e
                                    },
                                    regex: i
                                });
                            },
                            validate (e, t, r, { regex: s }) {
                                const n = s.exec(e);
                                if (!n) return t.error("string.guid");
                                const a = n[1], o = n[n.length - 1];
                                return (a || o) && m.guidBrackets[a] !== o ? t.error("string.guid") : e;
                            },
                            jsonSchema: (e, t)=>(t.format = "uuid", t)
                        },
                        hex: {
                            method (e = {}) {
                                return f.assertOptions(e, [
                                    "byteAligned",
                                    "prefix"
                                ]), e = {
                                    byteAligned: !1,
                                    prefix: !1,
                                    ...e
                                }, s("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), s("boolean" == typeof e.prefix || "optional" === e.prefix, 'prefix must be boolean or "optional"'), this.$_addRule({
                                    name: "hex",
                                    args: {
                                        options: e
                                    }
                                });
                            },
                            validate: (e, t, { options: r })=>("optional" === r.prefix ? m.hexRegex.withOptionalPrefix : !0 === r.prefix ? m.hexRegex.withPrefix : m.hexRegex.withoutPrefix).test(e) ? r.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex"),
                            jsonSchema: (e, t)=>(t.format = "hex", t)
                        },
                        hostname: {
                            method () {
                                return this.$_addRule("hostname");
                            },
                            validate: (e, t)=>a(e, {
                                    minDomainSegments: 1
                                }) || m.ipRegex.test(e) ? e : t.error("string.hostname"),
                            jsonSchema: (e, t)=>(t.format = "hostname", t)
                        },
                        insensitive: {
                            method () {
                                return this.$_setFlag("insensitive", !0);
                            }
                        },
                        ip: {
                            method (e = {}) {
                                f.assertOptions(e, [
                                    "cidr",
                                    "version"
                                ]);
                                const { cidr: t, versions: r, regex: s } = i(e), n = e.version ? r : void 0;
                                return this.$_addRule({
                                    name: "ip",
                                    args: {
                                        options: {
                                            cidr: t,
                                            version: n
                                        }
                                    },
                                    regex: s
                                });
                            },
                            validate: (e, t, { options: r }, { regex: s })=>s.test(e) ? e : r.version ? t.error("string.ipVersion", {
                                    value: e,
                                    cidr: r.cidr,
                                    version: r.version
                                }) : t.error("string.ip", {
                                    value: e,
                                    cidr: r.cidr
                                }),
                            jsonSchema (e, t) {
                                const r = e.args.options.version;
                                return r && 1 === r.length ? t.format = r[0] : t.format = "ip", t;
                            }
                        },
                        isoDate: {
                            method () {
                                return this.$_addRule("isoDate");
                            },
                            validate: (e, { error: t })=>m.isoDate(e) ? e : t("string.isoDate"),
                            jsonSchema: (e, t)=>(t.format = "date-time", t)
                        },
                        isoDuration: {
                            method () {
                                return this.$_addRule("isoDuration");
                            },
                            validate: (e, t)=>m.isoDurationRegex.test(e) ? e : t.error("string.isoDuration"),
                            jsonSchema: (e, t)=>(t.format = "duration", t)
                        },
                        length: {
                            method (e, t) {
                                return m.length(this, "length", e, "=", t);
                            },
                            validate (e, t, { limit: r, encoding: s }, { name: n, operator: a, args: o }) {
                                const i = !s && e.length;
                                return f.compare(i, r, a) ? e : t.error("string." + n, {
                                    limit: o.limit,
                                    value: e,
                                    encoding: s
                                });
                            },
                            jsonSchema: (e, t)=>(t.minLength = e.args.limit, t.maxLength = e.args.limit, t),
                            args: [
                                {
                                    name: "limit",
                                    ref: !0,
                                    assert: f.limit,
                                    message: "must be a positive integer"
                                },
                                "encoding"
                            ]
                        },
                        lowercase: {
                            method () {
                                return this.case("lower");
                            }
                        },
                        max: {
                            method (e, t) {
                                return m.length(this, "max", e, "<=", t);
                            },
                            jsonSchema: (e, t)=>(t.maxLength = e.args.limit, t),
                            args: [
                                "limit",
                                "encoding"
                            ]
                        },
                        min: {
                            method (e, t) {
                                return m.length(this, "min", e, ">=", t);
                            },
                            jsonSchema: (e, t)=>(e.args.limit > 0 && (t.minLength = e.args.limit), t),
                            args: [
                                "limit",
                                "encoding"
                            ]
                        },
                        normalize: {
                            method (e = "NFC") {
                                return s(m.normalizationForms.includes(e), "normalization form must be one of " + m.normalizationForms.join(", ")), this.$_addRule({
                                    name: "normalize",
                                    args: {
                                        form: e
                                    }
                                });
                            },
                            validate: (e, { error: t }, { form: r })=>e === e.normalize(r) ? e : t("string.normalize", {
                                    value: e,
                                    form: r
                                }),
                            convert: !0
                        },
                        pattern: {
                            alias: "regex",
                            method (e, t = {}) {
                                s(e instanceof RegExp, "regex must be a RegExp"), s(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                                    name: t
                                }), f.assertOptions(t, [
                                    "invert",
                                    "name"
                                ]);
                                const r = [
                                    "string.pattern",
                                    t.invert ? ".invert" : "",
                                    t.name ? ".name" : ".base"
                                ].join("");
                                return this.$_addRule({
                                    name: "pattern",
                                    args: {
                                        regex: e,
                                        options: t
                                    },
                                    errorCode: r
                                });
                            },
                            validate: (e, t, { regex: r, options: s }, { errorCode: n })=>r.test(e) ^ s.invert ? e : t.error(n, {
                                    name: s.name,
                                    regex: r,
                                    value: e
                                }),
                            jsonSchema (e, t) {
                                const r = e.args.regex.source;
                                return t.allOf ? t.allOf.push({
                                    pattern: r
                                }) : void 0 !== t.pattern ? (t.allOf = [
                                    {
                                        pattern: t.pattern
                                    },
                                    {
                                        pattern: r
                                    }
                                ], delete t.pattern) : t.pattern = r, t;
                            },
                            args: [
                                "regex",
                                "options"
                            ],
                            multi: !0
                        },
                        replace: {
                            method (e, t) {
                                "string" == typeof e && (e = new RegExp(n(e), "g")), s(e instanceof RegExp, "pattern must be a RegExp"), s("string" == typeof t, "replacement must be a String");
                                const r = this.clone();
                                return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                                    pattern: e,
                                    replacement: t
                                }), r;
                            }
                        },
                        token: {
                            method () {
                                return this.$_addRule("token");
                            },
                            validate: (e, t)=>/^\w+$/.test(e) ? e : t.error("string.token"),
                            jsonSchema: (e, t)=>(t.format = "token", t)
                        },
                        trim: {
                            method (e = !0) {
                                return s("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                                    name: "trim",
                                    args: {
                                        enabled: e
                                    }
                                });
                            },
                            validate: (e, t, { enabled: r })=>r && e !== e.trim() ? t.error("string.trim") : e,
                            convert: !0
                        },
                        truncate: {
                            method (e = !0) {
                                return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
                            }
                        },
                        uppercase: {
                            method () {
                                return this.case("upper");
                            }
                        },
                        uri: {
                            method (e = {}) {
                                f.assertOptions(e, [
                                    "allowRelative",
                                    "allowQuerySquareBrackets",
                                    "domain",
                                    "relativeOnly",
                                    "scheme",
                                    "encodeUri"
                                ]), e.domain && f.assertOptions(e.domain, [
                                    "allowFullyQualified",
                                    "allowUnicode",
                                    "maxDomainSegments",
                                    "minDomainSegments",
                                    "tlds"
                                ]);
                                const { regex: t, scheme: r } = l(e), s = e.domain ? m.addressOptions(e.domain) : null;
                                return this.$_addRule({
                                    name: "uri",
                                    args: {
                                        options: e
                                    },
                                    regex: t,
                                    domain: s,
                                    scheme: r
                                });
                            },
                            validate (e, t, { options: r }, { regex: s, domain: n, scheme: o }) {
                                if ([
                                    "http:/",
                                    "https:/"
                                ].includes(e)) return t.error("string.uri");
                                let i = s.exec(e);
                                if (!i && t.prefs.convert && r.encodeUri) {
                                    const t = encodeURI(e);
                                    i = s.exec(t), i && (e = t);
                                }
                                if (i) {
                                    const s = i[1] || i[2];
                                    return !n || r.allowRelative && !s || a(s, n) ? e : t.error("string.domain", {
                                        value: s
                                    });
                                }
                                return r.relativeOnly ? t.error("string.uriRelativeOnly") : r.scheme ? t.error("string.uriCustomScheme", {
                                    scheme: o,
                                    value: e
                                }) : t.error("string.uri");
                            },
                            jsonSchema: (e, t)=>(t.format = "uri", t)
                        }
                    },
                    manifest: {
                        build (e, t) {
                            if (t.replacements) for (const { pattern: r, replacement: s } of t.replacements)e = e.replace(r, s);
                            return e;
                        }
                    },
                    messages: {
                        "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
                        "string.base": "{{#label}} must be a string",
                        "string.base64": "{{#label}} must be a valid base64 string",
                        "string.creditCard": "{{#label}} must be a credit card",
                        "string.dataUri": "{{#label}} must be a valid dataUri string",
                        "string.domain": "{{#label}} must contain a valid domain name",
                        "string.email": "{{#label}} must be a valid email",
                        "string.empty": "{{#label}} is not allowed to be empty",
                        "string.guid": "{{#label}} must be a valid GUID",
                        "string.hex": "{{#label}} must only contain hexadecimal characters",
                        "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
                        "string.hostname": "{{#label}} must be a valid hostname",
                        "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
                        "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
                        "string.isoDate": "{{#label}} must be in iso format",
                        "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
                        "string.length": "{{#label}} length must be {{#limit}} characters long",
                        "string.lowercase": "{{#label}} must only contain lowercase characters",
                        "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
                        "string.min": "{{#label}} length must be at least {{#limit}} characters long",
                        "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
                        "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
                        "string.pattern.base": "{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}",
                        "string.pattern.name": "{{#label}} with value {:[.]} fails to match the {{#name}} pattern",
                        "string.pattern.invert.base": "{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}",
                        "string.pattern.invert.name": "{{#label}} with value {:[.]} matches the inverted {{#name}} pattern",
                        "string.trim": "{{#label}} must not have leading or trailing whitespace",
                        "string.uri": "{{#label}} must be a valid uri",
                        "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
                        "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
                        "string.uppercase": "{{#label}} must only contain uppercase characters"
                    }
                }), m.addressOptions = function(e) {
                    if (!e) return m.tlds || e;
                    if (s(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), s(void 0 === e.maxDomainSegments || Number.isSafeInteger(e.maxDomainSegments) && e.maxDomainSegments > 0, "maxDomainSegments must be a positive integer"), !1 === e.tlds) return e;
                    if (!0 === e.tlds || void 0 === e.tlds) return s(m.tlds, "Built-in TLD list disabled"), Object.assign({}, e, m.tlds);
                    s("object" == typeof e.tlds, "tlds must be true, false, or an object");
                    const t = e.tlds.deny;
                    if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
                        tlds: {
                            deny: new Set(t)
                        }
                    })), s(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), s(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), m.validateTlds(e.tlds.deny, "tlds.deny"), e;
                    const r = e.tlds.allow;
                    return r ? !0 === r ? (s(m.tlds, "Built-in TLD list disabled"), Object.assign({}, e, m.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
                        tlds: {
                            allow: new Set(r)
                        }
                    })), s(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), m.validateTlds(e.tlds.allow, "tlds.allow"), e) : {
                        ...e,
                        tlds: !1
                    };
                }, m.validateTlds = function(e, t) {
                    for (const r of e)s(a(r, {
                        minDomainSegments: 1,
                        maxDomainSegments: 1
                    }), `${t} must contain valid top level domain names`);
                }, m.isoDate = function(e) {
                    if (!f.isIsoDate(e)) return null;
                    /T.*[+-]\d\d$/.test(e) && (e += ":00");
                    const t = new Date(e);
                    return isNaN(t.getTime()) ? null : t.toISOString();
                }, m.length = function(e, t, r, n, a) {
                    return s(!a || !1, "Invalid encoding:", a), e.$_addRule({
                        name: t,
                        method: "length",
                        args: {
                            limit: r,
                            encoding: a
                        },
                        operator: n
                    });
                };
            },
            5008 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = r(680), a = {};
                a.Map = class extends Map {
                    slice() {
                        return new a.Map(this);
                    }
                }, e.exports = n.extend({
                    type: "symbol",
                    terms: {
                        map: {
                            init: new a.Map
                        }
                    },
                    coerce: {
                        method (e, { schema: t, error: r }) {
                            const s = t.$_terms.map.get(e);
                            return s && (e = s), t._flags.only && "symbol" != typeof e ? {
                                value: e,
                                errors: r("symbol.map", {
                                    map: t.$_terms.map
                                })
                            } : {
                                value: e
                            };
                        }
                    },
                    validate (e, { error: t }) {
                        if ("symbol" != typeof e) return {
                            value: e,
                            errors: t("symbol.base")
                        };
                    },
                    rules: {
                        map: {
                            method (e) {
                                e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                                const t = this.clone(), r = [];
                                for (const n of e){
                                    s(n && n[Symbol.iterator], "Entry must be an iterable");
                                    const [e, a] = n;
                                    s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof a, "Value must be a Symbol"), t.$_terms.map.set(e, a), r.push(a);
                                }
                                return t.valid(...r);
                            }
                        }
                    },
                    manifest: {
                        build: (e, t)=>(t.map && (e = e.map(t.map)), e)
                    },
                    jsonSchema (e, t, r, s) {
                        const n = e.$_terms.map;
                        return n.size ? {
                            anyOf: Array.from(n.keys()).map((e)=>({
                                    const: e
                                }))
                        } : {};
                    },
                    messages: {
                        "symbol.base": "{{#label}} must be a symbol",
                        "symbol.map": "{{#label}} must be one of {{#map}}"
                    }
                });
            },
            1190 (e, t, r) {
                "use strict";
                const { assert: s, clone: n, ignore: a, reach: o } = r(3115), i = r(9415), l = r(8013), c = r(4957), u = {
                    result: Symbol("result")
                };
                t.entry = function(e, t, r) {
                    let n = i.defaults;
                    r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), s(void 0 === r.artifacts, "Cannot override artifacts preference in synchronous validation"), n = i.preferences(i.defaults, r));
                    const a = u.entry(e, t, n);
                    s(!a.mainstay.externals.length, "Schema with external rules must use validateAsync()");
                    const o = {
                        value: a.value
                    };
                    return a.error && (o.error = a.error), a.mainstay.warnings.length && (o.warning = l.details(a.mainstay.warnings)), a.mainstay.debug && (o.debug = a.mainstay.debug), a.mainstay.artifacts && (o.artifacts = a.mainstay.artifacts), o;
                }, t.entryAsync = async function(e, t, r) {
                    let s = i.defaults;
                    r && (s = i.preferences(i.defaults, r));
                    const n = u.entry(e, t, s), a = n.mainstay;
                    if (n.error) throw a.debug && (n.error.debug = a.debug), n.error;
                    if (a.externals.length) {
                        let t = n.value;
                        const c = [];
                        for (const n of a.externals){
                            const f = n.state.path, m = "link" === n.schema.type ? a.links.get(n.schema) : null;
                            let h, p, d = t;
                            const g = f.length ? [
                                t
                            ] : [], y = f.length ? o(e, f) : e;
                            if (f.length) {
                                h = f[f.length - 1];
                                let e = t;
                                for (const t of f.slice(0, -1))e = e[t], g.unshift(e);
                                p = g[0], d = p[h];
                            }
                            try {
                                const e = (e, t)=>(m || n.schema).$_createError(e, d, t, n.state, s), o = await n.method(d, {
                                    schema: n.schema,
                                    linked: m,
                                    state: n.state,
                                    prefs: r,
                                    original: y,
                                    error: e,
                                    errorsArray: u.errorsArray,
                                    warn: (e, t)=>a.warnings.push((m || n.schema).$_createError(e, d, t, n.state, s)),
                                    message: (e, t)=>(m || n.schema).$_createError("external", d, t, n.state, s, {
                                            messages: e
                                        })
                                });
                                if (void 0 === o || o === d) continue;
                                if (o instanceof l.Report) {
                                    if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(o), s.abortEarly) break;
                                    continue;
                                }
                                if (Array.isArray(o) && o[i.symbols.errors]) {
                                    if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(...o), s.abortEarly) break;
                                    continue;
                                }
                                p ? (a.tracer.value(n.state, "rule", d, o, "external"), p[h] = o) : (a.tracer.value(n.state, "rule", t, o, "external"), t = o);
                            } catch (e) {
                                throw s.errors.label && (e.message += ` (${n.label})`), e;
                            }
                        }
                        if (n.value = t, c.length) throw n.error = l.process(c, e, s), a.debug && (n.error.debug = a.debug), n.error;
                    }
                    if (!s.warnings && !s.debug && !s.artifacts) return n.value;
                    const c = {
                        value: n.value
                    };
                    return a.warnings.length && (c.warning = l.details(a.warnings)), a.debug && (c.debug = a.debug), a.artifacts && (c.artifacts = a.artifacts), c;
                }, t.standard = function(e, r, s) {
                    const n = null == s ? void 0 : s.libraryOptions;
                    return r.isAsync() ? t.entryAsync(e, r, n) : t.entry(e, r, n);
                }, u.Mainstay = class {
                    constructor(e, t, r){
                        this.externals = [], this.warnings = [], this.tracer = e, this.debug = t, this.links = r, this.shadow = null, this.artifacts = null, this._snapshots = [];
                    }
                    snapshot() {
                        this._snapshots.push({
                            externals: this.externals.length,
                            warnings: this.warnings.length
                        });
                    }
                    restore() {
                        const e = this._snapshots.pop();
                        this.externals.length = e.externals, this.warnings.length = e.warnings;
                    }
                    commit() {
                        this._snapshots.pop();
                    }
                }, u.entry = function(e, r, s) {
                    const { tracer: n, cleanup: a } = u.tracer(r, s), o = s.debug ? [] : null, i = r._ids._schemaChain ? new Map : null, f = new u.Mainstay(n, o, i), m = r._ids._schemaChain ? [
                        {
                            schema: r
                        }
                    ] : null, h = new c([], [], {
                        mainstay: f,
                        schemas: m
                    }), p = t.validate(e, r, h, s);
                    a && r.$_root.untrace();
                    const d = l.process(p.errors, e, s);
                    return {
                        value: p.value,
                        error: d,
                        mainstay: f
                    };
                }, u.tracer = function(e, t) {
                    return e.$_root._tracer ? {
                        tracer: e.$_root._tracer._register(e)
                    } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
                        tracer: e.$_root.trace()._register(e),
                        cleanup: !0
                    }) : {
                        tracer: u.ignore
                    };
                }, t.validate = function(e, t, r, s, n = {}) {
                    if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
                        const s = t._cache.get(e);
                        if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
                    }
                    void 0 !== t._flags.failover && r.snapshot();
                    const a = (n, a, o)=>t.$_createError(n, e, a, o || r, s), o = {
                        original: e,
                        prefs: s,
                        schema: t,
                        state: r,
                        error: a,
                        errorsArray: u.errorsArray,
                        warn: (e, t, s)=>r.mainstay.warnings.push(a(e, t, s)),
                        message: (n, a)=>t.$_createError("custom", e, a, r, s, {
                                messages: n
                            })
                    };
                    r.mainstay.tracer.entry(t, r);
                    const l = t._definition;
                    if (l.prepare && s.convert) {
                        const t = l.prepare(e, o);
                        if (t) {
                            if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), o);
                            e = t.value;
                        }
                    }
                    if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
                        const t = l.coerce.method(e, o);
                        if (t) {
                            if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), o);
                            e = t.value;
                        }
                    }
                    const c = t._flags.empty;
                    c && c.$_match(u.trim(e, t), r.nest(c), i.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
                    const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? null : s.presence);
                    if (void 0 === e) {
                        if ("forbidden" === f) return u.finalize(e, null, o);
                        if ("required" === f) return u.finalize(e, [
                            t.$_createError("any.required", e, null, r, s)
                        ], o);
                        if ("optional" === f) {
                            if (t._flags.default !== i.symbols.deepDefault) return u.finalize(e, null, o);
                            r.mainstay.tracer.value(r, "default", e, {}), e = {};
                        }
                    } else if ("forbidden" === f) return u.finalize(e, [
                        t.$_createError("any.unknown", e, null, r, s)
                    ], o);
                    const m = [];
                    if (t._valids) {
                        const n = t._valids.get(e, r, s, t._flags.insensitive);
                        if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, o);
                        if (t._flags.only) {
                            const n = t.$_createError("any.only", e, {
                                valids: t._valids.values({
                                    display: !0
                                })
                            }, r, s);
                            if (s.abortEarly) return u.finalize(e, [
                                n
                            ], o);
                            m.push(n);
                        }
                    }
                    if (t._invalids) {
                        const n = t._invalids.get(e, r, s, t._flags.insensitive);
                        if (n) {
                            r.mainstay.tracer.filter(t, r, "invalid", n);
                            const a = t.$_createError("any.invalid", e, {
                                invalids: t._invalids.values({
                                    display: !0
                                })
                            }, r, s);
                            if (s.abortEarly) return u.finalize(e, [
                                a
                            ], o);
                            m.push(a);
                        }
                    }
                    if (l.validate) {
                        const t = l.validate(e, o);
                        if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
                            if (!Array.isArray(t.errors)) return m.push(t.errors), u.finalize(e, m, o);
                            if (t.errors.length) return m.push(...t.errors), u.finalize(e, m, o);
                        }
                    }
                    return t._rules.length ? u.rules(e, m, o) : u.finalize(e, m, o);
                }, u.rules = function(e, t, r) {
                    const { schema: s, state: n, prefs: a } = r;
                    for (const o of s._rules){
                        const l = s._definition.rules[o.method];
                        if (l.convert && a.convert) {
                            n.mainstay.tracer.log(s, n, "rule", o.name, "full");
                            continue;
                        }
                        let c, f = o.args;
                        if (o._resolve.length) {
                            f = Object.assign({}, f);
                            for (const t of o._resolve){
                                const r = l.argsByName.get(t), o = f[t].resolve(e, n, a), u = r.normalize ? r.normalize(o) : o, m = i.validateArg(u, null, r);
                                if (m) {
                                    c = s.$_createError("any.ref", o, {
                                        arg: t,
                                        ref: f[t],
                                        reason: m
                                    }, n, a);
                                    break;
                                }
                                f[t] = u;
                            }
                        }
                        c = c || l.validate(e, r, f, o);
                        const m = u.rule(c, o);
                        if (m.errors) {
                            if (n.mainstay.tracer.log(s, n, "rule", o.name, "error"), o.warn) {
                                n.mainstay.warnings.push(...m.errors);
                                continue;
                            }
                            if (a.abortEarly) return u.finalize(e, m.errors, r);
                            t.push(...m.errors);
                        } else n.mainstay.tracer.log(s, n, "rule", o.name, "pass"), n.mainstay.tracer.value(n, "rule", e, m.value, o.name), e = m.value;
                    }
                    return u.finalize(e, t, r);
                }, u.rule = function(e, t) {
                    return e instanceof l.Report ? (u.error(e, t), {
                        errors: [
                            e
                        ],
                        value: null
                    }) : Array.isArray(e) && e[i.symbols.errors] ? (e.forEach((e)=>u.error(e, t)), {
                        errors: e,
                        value: null
                    }) : {
                        errors: null,
                        value: e
                    };
                }, u.error = function(e, t) {
                    return t.message && e._setTemplate(t.message), e;
                }, u.finalize = function(e, t, r) {
                    t = t || [];
                    const { schema: n, state: a, prefs: o } = r;
                    if (void 0 !== n._flags.failover) {
                        let s = !1;
                        if (t.length) {
                            const n = u.default("failover", void 0, t, r);
                            void 0 !== n && (a.mainstay.tracer.value(a, "failover", e, n), e = n, t = [], s = !0);
                        }
                        s ? a.restore() : a.commit();
                    }
                    if (t.length && n._flags.error) {
                        if ("function" == typeof n._flags.error) {
                            t = n._flags.error(t), Array.isArray(t) || (t = [
                                t
                            ]);
                            for (const e of t)s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
                        } else t = [
                            n._flags.error
                        ];
                    }
                    if (void 0 === e) {
                        const s = u.default("default", e, t, r);
                        a.mainstay.tracer.value(a, "default", e, s), e = s;
                    }
                    if (n._flags.cast && void 0 !== e) {
                        const t = n._definition.cast[n._flags.cast];
                        if (t.from(e)) {
                            const s = t.to(e, r);
                            a.mainstay.tracer.value(a, "cast", e, s, n._flags.cast), e = s;
                        }
                    }
                    if (n.$_terms.externals && o.externals && !1 !== o._externals) for (const { method: e } of n.$_terms.externals)a.mainstay.externals.push({
                        method: e,
                        schema: n,
                        state: a,
                        label: l.label(n._flags, a, o)
                    });
                    const i = {
                        value: e,
                        errors: t.length ? t : null
                    };
                    return n._flags.result && (i.value = "strip" === n._flags.result ? void 0 : r.original, a.mainstay.tracer.value(a, n._flags.result, e, i.value), a.shadow(e, n._flags.result)), n._cache && !1 !== o.cache && !n._refs.length && n._cache.set(r.original, i), void 0 === e || i.errors || void 0 === n._flags.artifact || (a.mainstay.artifacts = a.mainstay.artifacts || new Map, a.mainstay.artifacts.has(n._flags.artifact) || a.mainstay.artifacts.set(n._flags.artifact, []), a.mainstay.artifacts.get(n._flags.artifact).push(a.path)), i;
                }, u.prefs = function(e, t) {
                    const r = t === i.defaults;
                    return r && e._preferences[i.symbols.prefs] ? e._preferences[i.symbols.prefs] : (t = i.preferences(t, e._preferences), r && (e._preferences[i.symbols.prefs] = t), t);
                }, u.default = function(e, t, r, s) {
                    const { schema: a, state: o, prefs: l } = s, c = a._flags[e];
                    if (l.noDefaults || void 0 === c) return t;
                    if (o.mainstay.tracer.log(a, o, "rule", e, "full"), !c) return c;
                    if ("function" == typeof c) {
                        const t = c.length ? [
                            n(o.ancestors[0]),
                            s
                        ] : [];
                        try {
                            return c(...t);
                        } catch (t) {
                            return void r.push(a.$_createError(`any.${e}`, null, {
                                error: t
                            }, o, l));
                        }
                    }
                    return "object" != typeof c ? c : c[i.symbols.literal] ? c.literal : i.isResolvable(c) ? c.resolve(t, o, l) : n(c);
                }, u.trim = function(e, t) {
                    if ("string" != typeof e) return e;
                    const r = t.$_getRule("trim");
                    return r && r.args.enabled ? e.trim() : e;
                }, u.ignore = {
                    active: !1,
                    debug: a,
                    entry: a,
                    filter: a,
                    log: a,
                    resolve: a,
                    value: a
                }, u.errorsArray = function() {
                    const e = [];
                    return e[i.symbols.errors] = !0, e;
                };
            },
            6220 (e, t, r) {
                "use strict";
                const { assert: s, deepEqual: n } = r(3115), a = r(9415), o = {};
                e.exports = o.Values = class {
                    constructor(e, t){
                        this._values = new Set(e), this._refs = new Set(t), this._lowercase = o.lowercases(e), this._override = !1;
                    }
                    get length() {
                        return this._values.size + this._refs.size;
                    }
                    add(e, t) {
                        a.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
                    }
                    static merge(e, t, r) {
                        if (e = e || new o.Values, t) {
                            if (t._override) return t.clone();
                            for (const r of [
                                ...t._values,
                                ...t._refs
                            ])e.add(r);
                        }
                        if (r) for (const t of [
                            ...r._values,
                            ...r._refs
                        ])e.remove(t);
                        return e.length ? e : null;
                    }
                    remove(e) {
                        a.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
                    }
                    has(e, t, r, s) {
                        return !!this.get(e, t, r, s);
                    }
                    get(e, t, r, s) {
                        if (!this.length) return !1;
                        if (this._values.has(e)) return {
                            value: e
                        };
                        if ("string" == typeof e && e && s) {
                            const t = this._lowercase.get(e.toLowerCase());
                            if (t) return {
                                value: t
                            };
                        }
                        if (!this._refs.size && "object" != typeof e) return !1;
                        if ("object" == typeof e) {
                            for (const t of this._values)if (n(t, e)) return {
                                value: t
                            };
                        }
                        if (t) for (const a of this._refs){
                            const o = a.resolve(e, t, r, null, {
                                in: !0
                            });
                            if (void 0 === o) continue;
                            const i = a.in && "object" == typeof o ? Array.isArray(o) ? o : Object.keys(o) : [
                                o
                            ];
                            for (const t of i)if (typeof t == typeof e) {
                                if (s && e && "string" == typeof e) {
                                    if (t.toLowerCase() === e.toLowerCase()) return {
                                        value: t,
                                        ref: a
                                    };
                                } else if (n(t, e)) return {
                                    value: t,
                                    ref: a
                                };
                            }
                        }
                        return !1;
                    }
                    override() {
                        this._override = !0;
                    }
                    values(e) {
                        if (e && e.display) {
                            const e = [];
                            for (const t of [
                                ...this._values,
                                ...this._refs
                            ])void 0 !== t && e.push(t);
                            return e;
                        }
                        return Array.from([
                            ...this._values,
                            ...this._refs
                        ]);
                    }
                    clone() {
                        const e = new o.Values(this._values, this._refs);
                        return e._override = this._override, e;
                    }
                    concat(e) {
                        s(!e._override, "Cannot concat override set of values");
                        const t = new o.Values([
                            ...this._values,
                            ...e._values
                        ], [
                            ...this._refs,
                            ...e._refs
                        ]);
                        return t._override = this._override, t;
                    }
                    describe() {
                        const e = [];
                        this._override && e.push({
                            override: !0
                        });
                        for (const t of this._values.values())e.push(t && "object" == typeof t ? {
                            value: t
                        } : t);
                        for (const t of this._refs.values())e.push(t.describe());
                        return e;
                    }
                }, o.Values.prototype[a.symbols.values] = !0, o.Values.prototype.slice = o.Values.prototype.clone, o.lowercases = function(e) {
                    const t = new Map;
                    if (e) for (const r of e)"string" == typeof r && t.set(r.toLowerCase(), r);
                    return t;
                };
            },
            9089 (e, t, r) {
                "use strict";
                r.d(t, {
                    ipRegex: ()=>T,
                    isDomainValid: ()=>h,
                    isEmailValid: ()=>y,
                    uriRegex: ()=>C
                });
                var s = r(8663);
                const n = {
                    EMPTY_STRING: "Address must be a non-empty string",
                    FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
                    MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
                    MISSING_AT_CHAR: "Address must contain one @ character",
                    EMPTY_LOCAL: "Address local part cannot be empty",
                    ADDRESS_TOO_LONG: "Address too long",
                    LOCAL_TOO_LONG: "Address local part too long",
                    EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
                    INVALID_LOCAL_CHARS: "Address local part contains invalid character",
                    DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
                    DOMAIN_TOO_LONG: "Domain too long",
                    DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
                    DOMAIN_INVALID_CHARS: "Domain contains invalid character",
                    DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
                    DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
                    DOMAIN_SEGMENTS_COUNT_MAX: "Domain contains too many segments",
                    DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
                    DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
                    DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
                };
                function a(e) {
                    return {
                        code: e,
                        error: n[e]
                    };
                }
                const o = /[^\x00-\x7f]/, i = /[\x00-\x20@\:\/\\#!\$&\'\(\)\*\+,;=\?]/, l = /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/, c = /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/, u = /^[a-zA-Z0-9_](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/, f = s.URL || URL;
                function m(e, t = {}) {
                    if (!e) return a("DOMAIN_NON_EMPTY_STRING");
                    if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
                    if (e.length > 256) return a("DOMAIN_TOO_LONG");
                    if (o.test(e)) {
                        if (!1 === t.allowUnicode) return a("DOMAIN_INVALID_UNICODE_CHARS");
                        e = e.normalize("NFC");
                    }
                    if (i.test(e)) return a("DOMAIN_INVALID_CHARS");
                    e = function(e) {
                        e.includes("%") && (e = e.replace(/%/g, "%25"));
                        try {
                            return new f(`http://${e}`).host;
                        } catch (t) {
                            return e;
                        }
                    }(e), t.allowFullyQualified && "." === e[e.length - 1] && (e = e.slice(0, -1));
                    const r = t.minDomainSegments || 2, s = e.split(".");
                    if (s.length < r) return a("DOMAIN_SEGMENTS_COUNT");
                    if (t.maxDomainSegments && s.length > t.maxDomainSegments) return a("DOMAIN_SEGMENTS_COUNT_MAX");
                    const n = t.tlds;
                    if (n) {
                        const e = s[s.length - 1].toLowerCase();
                        if (function(e) {
                            return !!e.allow;
                        }(n)) {
                            if (!n.allow.has(e)) return a("DOMAIN_FORBIDDEN_TLDS");
                        } else if (n.deny.has(e)) return a("DOMAIN_FORBIDDEN_TLDS");
                    }
                    for(let e = 0; e < s.length; ++e){
                        const r = s[e];
                        if (!r.length) return a("DOMAIN_EMPTY_SEGMENT");
                        if (r.length > 63) return a("DOMAIN_LONG_SEGMENT");
                        if (e < s.length - 1) {
                            if (t.allowUnderscore) {
                                if (!u.test(r)) return a("DOMAIN_INVALID_CHARS");
                            } else if (!c.test(r)) return a("DOMAIN_INVALID_CHARS");
                        } else if (!l.test(r)) return a("DOMAIN_INVALID_TLDS_CHARS");
                    }
                    return null;
                }
                function h(e, t) {
                    return !m(e, t);
                }
                var p = r(6984);
                const d = /[^\x00-\x7f]/, g = new (p.TextEncoder || TextEncoder);
                function y(e, t) {
                    return !function(e, t = {}) {
                        if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
                        if (!e) return a("EMPTY_STRING");
                        const r = !d.test(e);
                        if (!r) {
                            if (!1 === t.allowUnicode) return a("FORBIDDEN_UNICODE");
                            e = e.normalize("NFC");
                        }
                        const s = e.split("@");
                        if (2 !== s.length) return s.length > 2 ? a("MULTIPLE_AT_CHAR") : a("MISSING_AT_CHAR");
                        const [n, o] = s;
                        if (!n) return a("EMPTY_LOCAL");
                        if (!t.ignoreLength) {
                            if (e.length > 254) return a("ADDRESS_TOO_LONG");
                            if (g.encode(n).length > 64) return a("LOCAL_TOO_LONG");
                        }
                        return function(e, t) {
                            const r = e.split(".");
                            for (const e of r){
                                if (!e.length) return a("EMPTY_LOCAL_SEGMENT");
                                if (t) {
                                    if (!_.test(e)) return a("INVALID_LOCAL_CHARS");
                                } else for (const t of e){
                                    if (_.test(t)) continue;
                                    const e = b(t);
                                    if (!v.test(e)) return a("INVALID_LOCAL_CHARS");
                                }
                            }
                            return null;
                        }(n, r) || m(o, t);
                    }(e, t);
                }
                function b(e) {
                    return Array.from(g.encode(e), (e)=>String.fromCharCode(e)).join("");
                }
                const _ = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, v = new RegExp([
                    "(?:[\\xc2-\\xdf][\\x80-\\xbf])",
                    "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})",
                    "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"
                ].join("|"));
                var A = r(8253), S = r.n(A), E = r(8669), O = r.n(E);
                const R = function() {
                    const e = {}, t = "\\dA-Fa-f", r = "[" + t + "]", s = "\\w-\\.~", n = "!\\$&'\\(\\)\\*\\+,;=", a = "%" + t, o = s + a + n + ":@", i = "[" + o + "]", l = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
                    e.ipv4address = "(?:" + l + "\\.){3}" + l;
                    const c = r + "{1,4}", u = "(?:" + c + ":" + c + "|" + e.ipv4address + ")", f = "(?:" + c + ":){6}" + u, m = "::(?:" + c + ":){5}" + u, h = "(?:" + c + ")?::(?:" + c + ":){4}" + u, p = "(?:(?:" + c + ":){0,1}" + c + ")?::(?:" + c + ":){3}" + u, d = "(?:(?:" + c + ":){0,2}" + c + ")?::(?:" + c + ":){2}" + u, g = "(?:(?:" + c + ":){0,3}" + c + ")?::" + c + ":" + u, y = "(?:(?:" + c + ":){0,4}" + c + ")?::" + u, b = "(?:(?:" + c + ":){0,5}" + c + ")?::" + c, _ = "(?:(?:" + c + ":){0,6}" + c + ")?::";
                    e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + f + "|" + m + "|" + h + "|" + p + "|" + d + "|" + g + "|" + y + "|" + b + "|" + _ + ")", e.ipvFuture = "v" + r + "+\\.[" + s + n + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);
                    const v = "[" + s + a + n + ":]*", A = "[" + s + a + n + "]{1,255}", S = "(?:\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]|" + e.ipv4address + "|" + A + ")", E = "(?:" + v + "@)?" + S + "(?::\\d*)?", O = "(?:" + v + "@)?(" + S + ")(?::\\d*)?", R = i + "*", N = i + "+", I = "(?:\\/" + R + ")*", w = "\\/(?:" + N + I + ")?", $ = N + I, C = "[" + s + a + n + "@]+" + I, T = "(?:\\/\\/\\/" + R + I + ")";
                    return e.hierPart = "(?:(?:\\/\\/" + E + I + ")|" + w + "|" + $ + "|" + T + ")", e.hierPartCapture = "(?:(?:\\/\\/" + O + I + ")|" + w + "|" + $ + ")", e.relativeRef = "(?:(?:\\/\\/" + E + I + ")|" + w + "|" + C + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + O + I + ")|" + w + "|" + C + "|)", e.query = "[" + o + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + o + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + o + "\\/\\?]*", e;
                }(), N = {
                    v4Cidr: R.ipv4Cidr,
                    v6Cidr: R.ipv6Cidr,
                    ipv4: R.ipv4address,
                    ipv6: R.ipv6address,
                    ipvfuture: R.ipvFuture
                };
                function I(e) {
                    const t = R, r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?", s = e.domain ? t.relativeRefCapture : t.relativeRef;
                    if (e.relativeOnly) return w(s + r);
                    let n = "";
                    if (e.scheme) {
                        S()(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
                        const r = [].concat(e.scheme);
                        S()(r.length >= 1, "scheme must have at least 1 scheme specified");
                        const s = [];
                        for(let e = 0; e < r.length; ++e){
                            const n = r[e];
                            S()(n instanceof RegExp || "string" == typeof n, "scheme at position " + e + " must be a RegExp or String"), n instanceof RegExp ? s.push(n.source.toString()) : (S()(t.schemeRegex.test(n), "scheme at position " + e + " must be a valid scheme"), s.push(O()(n)));
                        }
                        n = s.join("|");
                    }
                    const a = "(?:" + (n ? "(?:" + n + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")";
                    return w((e.allowRelative ? "(?:" + a + "|" + s + ")" : a) + r, n);
                }
                function w(e, t = null) {
                    return {
                        raw: e = `(?=.)(?!https?:/(?:$|[^/]))(?!https?:///)(?!https?:[^/])${e}`,
                        regex: new RegExp(`^${e}$`),
                        scheme: t
                    };
                }
                const $ = I({});
                function C(e = {}) {
                    return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? I(e) : $;
                }
                function T(e = {}) {
                    const t = e.cidr || "optional";
                    S()([
                        "required",
                        "optional",
                        "forbidden"
                    ].includes(t), "options.cidr must be one of required, optional, forbidden"), S()(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
                    let r = e.version || [
                        "ipv4",
                        "ipv6",
                        "ipvfuture"
                    ];
                    Array.isArray(r) || (r = [
                        r
                    ]), S()(r.length >= 1, "options.version must have at least 1 version specified");
                    for (const e of r)S()("string" == typeof e && e === e.toLowerCase(), "Invalid options.version value"), S()([
                        "ipv4",
                        "ipv6",
                        "ipvfuture"
                    ].includes(e), "options.version contains unknown version " + e + " - must be one of ipv4, ipv6, ipvfuture");
                    r = Array.from(new Set(r));
                    const s = `(?:${r.map((e)=>{
                        if ("forbidden" === t) return N[e];
                        const r = `\\/${"ipv4" === e ? N.v4Cidr : N.v6Cidr}`;
                        return "required" === t ? `${N[e]}${r}` : `${N[e]}(?:${r})?`;
                    }).join("|")})`, n = new RegExp(`^${s}$`);
                    return {
                        cidr: t,
                        versions: r,
                        regex: n,
                        raw: s
                    };
                }
            },
            679 (e, t) {
                "use strict";
                const r = {
                    operators: [
                        "!",
                        "^",
                        "*",
                        "/",
                        "%",
                        "+",
                        "-",
                        "<",
                        "<=",
                        ">",
                        ">=",
                        "==",
                        "!=",
                        "&&",
                        "||",
                        "??"
                    ],
                    operatorCharacters: [
                        "!",
                        "^",
                        "*",
                        "/",
                        "%",
                        "+",
                        "-",
                        "<",
                        "=",
                        ">",
                        "&",
                        "|",
                        "?"
                    ],
                    operatorsOrder: [
                        [
                            "^"
                        ],
                        [
                            "*",
                            "/",
                            "%"
                        ],
                        [
                            "+",
                            "-"
                        ],
                        [
                            "<",
                            "<=",
                            ">",
                            ">="
                        ],
                        [
                            "==",
                            "!="
                        ],
                        [
                            "&&"
                        ],
                        [
                            "||",
                            "??"
                        ]
                    ],
                    operatorsPrefix: [
                        "!",
                        "n"
                    ],
                    literals: {
                        '"': '"',
                        "`": "`",
                        "'": "'",
                        "[": "]"
                    },
                    numberRx: /^(?:[0-9]*(\.[0-9]*)?){1}$/,
                    tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
                    symbol: Symbol("formula"),
                    settings: Symbol("settings")
                };
                t.Parser = class {
                    constructor(e, t = {}){
                        if (!t[r.settings] && t.constants) for(const e in t.constants){
                            const r = t.constants[e];
                            if (null !== r && ![
                                "boolean",
                                "number",
                                "string"
                            ].includes(typeof r)) throw new Error(`Formula constant ${e} contains invalid ${typeof r} value type`);
                        }
                        this.settings = t[r.settings] ? t : Object.assign({
                            [r.settings]: !0,
                            constants: {},
                            functions: {}
                        }, t), this.single = null, this._parts = null, this._parse(e);
                    }
                    _parse(e) {
                        let s = [], n = "", a = 0, o = !1;
                        const i = (e)=>{
                            if (a) throw new Error("Formula missing closing parenthesis");
                            const i = s.length ? s[s.length - 1] : null;
                            if (o || n || e) {
                                if (i && "reference" === i.type && ")" === e) return i.type = "function", i.value = this._subFormula(n, i.value), void (n = "");
                                if (")" === e) {
                                    const e = new t.Parser(n, this.settings);
                                    s.push({
                                        type: "segment",
                                        value: e
                                    });
                                } else if (o) {
                                    if ("]" === o) return s.push({
                                        type: "reference",
                                        value: n
                                    }), void (n = "");
                                    s.push({
                                        type: "literal",
                                        value: n
                                    });
                                } else if (r.operatorCharacters.includes(n)) i && "operator" === i.type && r.operators.includes(i.value + n) ? i.value += n : s.push({
                                    type: "operator",
                                    value: n
                                });
                                else if (n.match(r.numberRx)) s.push({
                                    type: "constant",
                                    value: parseFloat(n)
                                });
                                else if (void 0 !== this.settings.constants[n]) s.push({
                                    type: "constant",
                                    value: this.settings.constants[n]
                                });
                                else {
                                    if (!n.match(r.tokenRx)) throw new Error(`Formula contains invalid token: ${n}`);
                                    s.push({
                                        type: "reference",
                                        value: n
                                    });
                                }
                                n = "";
                            }
                        };
                        for (const t of e)o ? t === o ? (i(), o = !1) : n += t : a ? "(" === t ? (n += t, ++a) : ")" === t ? (--a, a ? n += t : i(t)) : n += t : t in r.literals ? o = r.literals[t] : "(" === t ? (i(), ++a) : r.operatorCharacters.includes(t) ? (i(), n = t, i()) : " " !== t ? n += t : i();
                        i(), s = s.map((e, t)=>"operator" !== e.type || "-" !== e.value || t && "operator" !== s[t - 1].type ? e : {
                                type: "operator",
                                value: "n"
                            });
                        let l = !1;
                        for (const e of s){
                            if ("operator" === e.type) {
                                if (r.operatorsPrefix.includes(e.value)) continue;
                                if (!l) throw new Error("Formula contains an operator in invalid position");
                                if (!r.operators.includes(e.value)) throw new Error(`Formula contains an unknown operator ${e.value}`);
                            } else if (l) throw new Error("Formula missing expected operator");
                            l = !l;
                        }
                        if (!l) throw new Error("Formula contains invalid trailing operator");
                        1 === s.length && [
                            "reference",
                            "literal",
                            "constant"
                        ].includes(s[0].type) && (this.single = {
                            type: "reference" === s[0].type ? "reference" : "value",
                            value: s[0].value
                        }), this._parts = s.map((e)=>{
                            if ("operator" === e.type) return r.operatorsPrefix.includes(e.value) ? e : e.value;
                            if ("reference" !== e.type) return e.value;
                            if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error(`Formula contains invalid reference ${e.value}`);
                            return this.settings.reference ? this.settings.reference(e.value) : r.reference(e.value);
                        });
                    }
                    _subFormula(e, s) {
                        const n = this.settings.functions[s];
                        if ("function" != typeof n) throw new Error(`Formula contains unknown function ${s}`);
                        let a = [];
                        if (e) {
                            let t = "", n = 0, o = !1;
                            const i = ()=>{
                                if (!t) throw new Error(`Formula contains function ${s} with invalid arguments ${e}`);
                                a.push(t), t = "";
                            };
                            for(let s = 0; s < e.length; ++s){
                                const a = e[s];
                                o ? (t += a, a === o && (o = !1)) : a in r.literals && !n ? (t += a, o = r.literals[a]) : "," !== a || n ? (t += a, "(" === a ? ++n : ")" === a && --n) : i();
                            }
                            i();
                        }
                        return a = a.map((e)=>new t.Parser(e, this.settings)), function(e) {
                            const t = [];
                            for (const r of a)t.push(r.evaluate(e));
                            return n.call(e, ...t);
                        };
                    }
                    evaluate(e) {
                        const t = this._parts.slice();
                        for(let s = t.length - 2; s >= 0; --s){
                            const n = t[s];
                            if (n && "operator" === n.type) {
                                const a = t[s + 1];
                                t.splice(s + 1, 1);
                                const o = r.evaluate(a, e);
                                t[s] = r.single(n.value, o);
                            }
                        }
                        return r.operatorsOrder.forEach((s)=>{
                            for(let n = 1; n < t.length - 1;)if (s.includes(t[n])) {
                                const s = t[n], a = r.evaluate(t[n - 1], e), o = r.evaluate(t[n + 1], e);
                                t.splice(n, 2);
                                const i = r.calculate(s, a, o);
                                t[n - 1] = 0 === i ? 0 : i;
                            } else n += 2;
                        }), r.evaluate(t[0], e);
                    }
                }, t.Parser.prototype[r.symbol] = !0, r.reference = function(e) {
                    return function(t) {
                        return t && void 0 !== t[e] ? t[e] : null;
                    };
                }, r.evaluate = function(e, t) {
                    return null === e ? null : "function" == typeof e ? e(t) : e[r.symbol] ? e.evaluate(t) : e;
                }, r.single = function(e, t) {
                    if ("!" === e) return !t;
                    const r = -t;
                    return 0 === r ? 0 : r;
                }, r.calculate = function(e, t, s) {
                    if ("??" === e) return r.exists(t) ? t : s;
                    if ("string" == typeof t || "string" == typeof s) {
                        if ("+" === e) return (t = r.exists(t) ? t : "") + (r.exists(s) ? s : "");
                    } else switch(e){
                        case "^":
                            return Math.pow(t, s);
                        case "*":
                            return t * s;
                        case "/":
                            return t / s;
                        case "%":
                            return t % s;
                        case "+":
                            return t + s;
                        case "-":
                            return t - s;
                    }
                    switch(e){
                        case "<":
                            return t < s;
                        case "<=":
                            return t <= s;
                        case ">":
                            return t > s;
                        case ">=":
                            return t >= s;
                        case "==":
                            return t === s;
                        case "!=":
                            return t !== s;
                        case "&&":
                            return t && s;
                        case "||":
                            return t || s;
                    }
                    return null;
                }, r.exists = function(e) {
                    return null != e;
                };
            },
            6084 (e, t, r) {
                "use strict";
                const s = r(8253), n = r(4126), a = r(9315), o = r(1528), i = {};
                e.exports = function(e, t, r = {}) {
                    if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
                    if (r.shallow) return i.applyToDefaultsWithShallow(e, t, r);
                    const o = n(e);
                    if (!0 === t) return o;
                    const l = void 0 !== r.nullOverride && r.nullOverride;
                    return a(o, t, {
                        nullOverride: l,
                        mergeArrays: !1
                    });
                }, i.applyToDefaultsWithShallow = function(e, t, r) {
                    const l = r.shallow;
                    s(Array.isArray(l), "Invalid keys");
                    const c = new Map, u = !0 === t ? null : new Set;
                    for (let r of l){
                        r = Array.isArray(r) ? r : r.split(".");
                        const s = o(e, r);
                        s && "object" == typeof s ? c.set(s, u && o(t, r) || s) : u && u.add(r);
                    }
                    const f = n(e, {}, c);
                    if (!u) return f;
                    for (const e of u)i.reachCopy(f, t, e);
                    const m = void 0 !== r.nullOverride && r.nullOverride;
                    return a(f, t, {
                        nullOverride: m,
                        mergeArrays: !1
                    });
                }, i.reachCopy = function(e, t, r) {
                    for (const e of r){
                        if (!(e in t)) return;
                        const r = t[e];
                        if ("object" != typeof r || null === r) return;
                        t = r;
                    }
                    const s = t;
                    let n = e;
                    for(let e = 0; e < r.length - 1; ++e){
                        const t = r[e];
                        "object" != typeof n[t] && (n[t] = {}), n = n[t];
                    }
                    n[r[r.length - 1]] = s;
                };
            },
            8253 (e, t, r) {
                "use strict";
                const s = r(1803), n = r(8314), a = e.exports = function(e, ...t) {
                    if (e) return;
                    if (1 === t.length && t[0] instanceof Error) throw t[0];
                    const r = t.filter((e)=>"" !== e).map((e)=>"string" == typeof e ? e : e instanceof Error ? e.message : n(e));
                    throw new s(r.join(" "), a);
                };
            },
            1803 (e) {
                "use strict";
                e.exports = class extends Error {
                    constructor(e, t){
                        var r, s, n;
                        super(e || "Unknown error"), r = this, n = "AssertError", (s = function(e) {
                            var t = function(e) {
                                if ("object" != typeof e || !e) return e;
                                var t;
                                if ("undefined" != typeof Symbol && void 0 !== (t = e[Symbol.toPrimitive])) {
                                    var r = t.call(e, "string");
                                    if ("object" != typeof r) return r;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(e);
                            }(e);
                            return "symbol" == typeof t ? t : t + "";
                        }(s = "name")) in r ? Object.defineProperty(r, s, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : r[s] = n, "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t);
                    }
                };
            },
            4126 (e, t, r) {
                "use strict";
                const s = r(1528), n = r(3738), a = r(86), o = {
                    needsProtoHack: new Set([
                        n.set,
                        n.map,
                        n.weakSet,
                        n.weakMap
                    ]),
                    structuredCloneExists: "function" == typeof structuredClone
                };
                e.exports = o.clone = function(e, t = {}, r = null) {
                    if ("object" != typeof e || null === e) return e;
                    let s = o.clone, i = r;
                    if (t.shallow) {
                        if (!0 !== t.shallow) return o.cloneWithShallow(e, t);
                        s = (e)=>e;
                    } else if (i) {
                        const t = i.get(e);
                        if (t) return t;
                    } else i = new Map;
                    const l = n.getInternalProto(e);
                    switch(l){
                        case n.buffer:
                            return false.from(e);
                        case n.date:
                            return new Date(e.getTime());
                        case n.regex:
                        case n.url:
                            return new l.constructor(e);
                    }
                    const c = o.base(e, l, t);
                    if (c === e) return e;
                    if (i && i.set(e, c), l === n.set) for (const r of e)c.add(s(r, t, i));
                    else if (l === n.map) for (const [r, n] of e)c.set(r, s(n, t, i));
                    const u = a.keys(e, t);
                    for (const r of u){
                        if ("__proto__" === r) continue;
                        if (l === n.array && "length" === r) {
                            c.length = e.length;
                            continue;
                        }
                        if (o.structuredCloneExists && l === n.error && "stack" === r) continue;
                        const a = Object.getOwnPropertyDescriptor(e, r);
                        a ? a.get || a.set ? Object.defineProperty(c, r, a) : a.enumerable ? c[r] = s(e[r], t, i) : Object.defineProperty(c, r, {
                            enumerable: !1,
                            writable: !0,
                            configurable: !0,
                            value: s(e[r], t, i)
                        }) : Object.defineProperty(c, r, {
                            enumerable: !0,
                            writable: !0,
                            configurable: !0,
                            value: s(e[r], t, i)
                        });
                    }
                    return c;
                }, o.cloneWithShallow = function(e, t) {
                    const r = t.shallow;
                    (t = Object.assign({}, t)).shallow = !1;
                    const n = new Map;
                    for (const t of r){
                        const r = s(e, t);
                        "object" != typeof r && "function" != typeof r || n.set(r, r);
                    }
                    return o.clone(e, t, n);
                }, o.base = function(e, t, r) {
                    if (!1 === r.prototype) return o.needsProtoHack.has(t) ? new t.constructor : t === n.array ? [] : {};
                    const s = Object.getPrototypeOf(e);
                    if (s && s.isImmutable) return e;
                    if (t === n.array) {
                        const e = [];
                        return s !== t && Object.setPrototypeOf(e, s), e;
                    }
                    if (t === n.error && o.structuredCloneExists && (s === t || Error.isPrototypeOf(s.constructor))) {
                        const t = structuredClone(e);
                        return Object.getPrototypeOf(t) !== s && Object.setPrototypeOf(t, s), t;
                    }
                    if (o.needsProtoHack.has(t)) {
                        const e = new s.constructor;
                        return s !== t && Object.setPrototypeOf(e, s), e;
                    }
                    return Object.create(s);
                };
            },
            7125 (e, t, r) {
                "use strict";
                const s = r(3738), n = {
                    mismatched: null
                };
                e.exports = function(e, t, r) {
                    return r = Object.assign({
                        prototype: !0
                    }, r), !!n.isDeepEqual(e, t, r, []);
                }, n.isDeepEqual = function(e, t, r, a) {
                    if (e === t) return 0 !== e || 1 / e == 1 / t;
                    const o = typeof e;
                    if (o !== typeof t) return !1;
                    if (null === e || null === t) return !1;
                    if ("function" === o) {
                        if (!r.deepFunction || e.toString() !== t.toString()) return !1;
                    } else if ("object" !== o) return e != e && t != t;
                    const i = n.getSharedType(e, t, !!r.prototype);
                    switch(i){
                        case s.buffer:
                            return !1;
                        case s.promise:
                            return e === t;
                        case s.regex:
                        case s.url:
                            return e.toString() === t.toString();
                        case n.mismatched:
                            return !1;
                    }
                    for(let r = a.length - 1; r >= 0; --r)if (a[r].isSame(e, t)) return !0;
                    a.push(new n.SeenEntry(e, t));
                    try {
                        return !!n.isDeepEqualObj(i, e, t, r, a);
                    } finally{
                        a.pop();
                    }
                }, n.getSharedType = function(e, t, r) {
                    if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
                    const a = s.getInternalProto(e);
                    return a !== s.getInternalProto(t) ? n.mismatched : a;
                }, n.valueOf = function(e) {
                    const t = e.valueOf;
                    if (void 0 === t) return e;
                    try {
                        return t.call(e);
                    } catch (e) {
                        return e;
                    }
                }, n.hasOwnEnumerableProperty = function(e, t) {
                    return Object.prototype.propertyIsEnumerable.call(e, t);
                }, n.isSetSimpleEqual = function(e, t) {
                    for (const r of Set.prototype.values.call(e))if (!Set.prototype.has.call(t, r)) return !1;
                    return !0;
                }, n.isDeepEqualObj = function(e, t, r, a, o) {
                    const { isDeepEqual: i, valueOf: l, hasOwnEnumerableProperty: c } = n, { keys: u, getOwnPropertySymbols: f } = Object;
                    if (e === s.array) {
                        if (!a.part) {
                            if (t.length !== r.length) return !1;
                            for(let e = 0; e < t.length; ++e)if (!i(t[e], r[e], a, o)) return !1;
                            return !0;
                        }
                        for (const e of t)for (const t of r)if (i(e, t, a, o)) return !0;
                    } else if (e === s.set) {
                        if (t.size !== r.size) return !1;
                        if (!n.isSetSimpleEqual(t, r)) {
                            const e = new Set(Set.prototype.values.call(r));
                            for (const r of Set.prototype.values.call(t)){
                                if (e.delete(r)) continue;
                                let t = !1;
                                for (const s of e)if (i(r, s, a, o)) {
                                    e.delete(s), t = !0;
                                    break;
                                }
                                if (!t) return !1;
                            }
                        }
                    } else if (e === s.map) {
                        if (t.size !== r.size) return !1;
                        for (const [e, s] of Map.prototype.entries.call(t)){
                            if (void 0 === s && !Map.prototype.has.call(r, e)) return !1;
                            if (!i(s, Map.prototype.get.call(r, e), a, o)) return !1;
                        }
                    } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;
                    const m = l(t), h = l(r);
                    if ((t !== m || r !== h) && !i(m, h, a, o)) return !1;
                    const p = u(t);
                    if (!a.part && p.length !== u(r).length && !a.skip) return !1;
                    let d = 0;
                    for (const e of p)if (a.skip && a.skip.includes(e)) void 0 === r[e] && ++d;
                    else {
                        if (!c(r, e)) return !1;
                        if (!i(t[e], r[e], a, o)) return !1;
                    }
                    if (!a.part && p.length - d !== u(r).length) return !1;
                    if (!1 !== a.symbols) {
                        const e = f(t), s = new Set(f(r));
                        for (const n of e){
                            var g;
                            if (null === (g = a.skip) || void 0 === g || !g.includes(n)) {
                                if (c(t, n)) {
                                    if (!c(r, n)) return !1;
                                    if (!i(t[n], r[n], a, o)) return !1;
                                } else if (c(r, n)) return !1;
                            }
                            s.delete(n);
                        }
                        for (const e of s)if (c(r, e)) return !1;
                    }
                    return !0;
                }, n.SeenEntry = class {
                    constructor(e, t){
                        this.obj = e, this.ref = t;
                    }
                    isSame(e, t) {
                        return this.obj === e && this.ref === t;
                    }
                };
            },
            8121 (e) {
                "use strict";
                const t = {};
                e.exports = function(e) {
                    if (!e) return "";
                    let r = "";
                    for(let s = 0; s < e.length; ++s){
                        const n = e.charCodeAt(s);
                        t.isSafe(n) ? r += e[s] : r += t.escapeHtmlChar(n);
                    }
                    return r;
                }, t.escapeHtmlChar = function(e) {
                    const r = t.namedHtml.get(e);
                    return r || (e >= 256 ? "&#" + e + ";" : `&#x${e.toString(16).padStart(2, "0")};`);
                }, t.isSafe = function(e) {
                    return t.safeCharCodes.has(e);
                }, t.namedHtml = new Map([
                    [
                        38,
                        "&amp;"
                    ],
                    [
                        60,
                        "&lt;"
                    ],
                    [
                        62,
                        "&gt;"
                    ],
                    [
                        34,
                        "&quot;"
                    ],
                    [
                        160,
                        "&nbsp;"
                    ],
                    [
                        162,
                        "&cent;"
                    ],
                    [
                        163,
                        "&pound;"
                    ],
                    [
                        164,
                        "&curren;"
                    ],
                    [
                        169,
                        "&copy;"
                    ],
                    [
                        174,
                        "&reg;"
                    ]
                ]), t.safeCharCodes = function() {
                    const e = new Set;
                    for(let t = 32; t < 123; ++t)(t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && e.add(t);
                    return e;
                }();
            },
            8669 (e) {
                "use strict";
                e.exports = function(e) {
                    return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
                };
            },
            9725 (e) {
                "use strict";
                e.exports = function() {};
            },
            3115 (e, t, r) {
                "use strict";
                t.applyToDefaults = r(6084), t.assert = r(8253), t.AssertError = r(1803), t.clone = r(4126), t.deepEqual = r(7125), t.escapeHtml = r(8121), t.escapeRegex = r(8669), t.ignore = r(9725), t.merge = r(9315), t.reach = r(1528);
            },
            9315 (e, t, r) {
                "use strict";
                const s = r(8253), n = r(4126), a = r(86), o = {};
                e.exports = o.merge = function(e, t, r) {
                    if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;
                    if (r = Object.assign({
                        nullOverride: !0,
                        mergeArrays: !0
                    }, r), Array.isArray(t)) {
                        s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);
                        for(let s = 0; s < t.length; ++s)e.push(n(t[s], {
                            symbols: r.symbols
                        }));
                        return e;
                    }
                    const i = a.keys(t, r);
                    for(let s = 0; s < i.length; ++s){
                        const a = i[s];
                        if ("__proto__" === a || !Object.prototype.propertyIsEnumerable.call(t, a)) continue;
                        const l = t[a];
                        if (l && "object" == typeof l) {
                            if (e[a] === l) continue;
                            !e[a] || "object" != typeof e[a] || Array.isArray(e[a]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[a] = n(l, {
                                symbols: r.symbols
                            }) : o.merge(e[a], l, r);
                        } else (null != l || r.nullOverride) && (e[a] = l);
                    }
                    return e;
                };
            },
            1528 (e, t, r) {
                "use strict";
                const s = r(8253), n = {};
                e.exports = function(e, t, r) {
                    if (!1 === t || null == t) return e;
                    "string" == typeof (r = r || {}) && (r = {
                        separator: r
                    });
                    const a = Array.isArray(t);
                    s(!a || !r.separator, "Separator option is not valid for array-based chain");
                    const o = a ? t : t.split(r.separator || ".");
                    let i = e;
                    for(let e = 0; e < o.length; ++e){
                        let a = o[e];
                        const l = r.iterables && n.iterables(i);
                        if (Array.isArray(i) || "set" === l) {
                            const e = Number(a);
                            Number.isInteger(e) && (a = e < 0 ? i.length + e : e);
                        }
                        if (!i || "function" == typeof i && !1 === r.functions || !l && void 0 === i[a]) {
                            s(!r.strict || e + 1 === o.length, "Missing segment", a, "in reach path ", t), s("object" == typeof i || !0 === r.functions || "function" != typeof i, "Invalid segment", a, "in reach path ", t), i = r.default;
                            break;
                        }
                        i = l ? "set" === l ? [
                            ...i
                        ][a] : i.get(a) : i[a];
                    }
                    return i;
                }, n.iterables = function(e) {
                    return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
                };
            },
            8314 (e) {
                "use strict";
                e.exports = function(...e) {
                    try {
                        return JSON.stringify(...e);
                    } catch (e) {
                        return "[Cannot display object: " + e.message + "]";
                    }
                };
            },
            3738 (e, t) {
                "use strict";
                const r = {};
                t = e.exports = {
                    array: Array.prototype,
                    buffer: !1,
                    date: Date.prototype,
                    error: Error.prototype,
                    generic: Object.prototype,
                    map: Map.prototype,
                    promise: Promise.prototype,
                    regex: RegExp.prototype,
                    set: Set.prototype,
                    url: URL.prototype,
                    weakMap: WeakMap.prototype,
                    weakSet: WeakSet.prototype
                }, r.typeMap = new Map([
                    [
                        "[object Error]",
                        t.error
                    ],
                    [
                        "[object Map]",
                        t.map
                    ],
                    [
                        "[object Promise]",
                        t.promise
                    ],
                    [
                        "[object Set]",
                        t.set
                    ],
                    [
                        "[object URL]",
                        t.url
                    ],
                    [
                        "[object WeakMap]",
                        t.weakMap
                    ],
                    [
                        "[object WeakSet]",
                        t.weakSet
                    ]
                ]), t.getInternalProto = function(e) {
                    if (Array.isArray(e)) return t.array;
                    if (e instanceof Date) return t.date;
                    if (e instanceof RegExp) return t.regex;
                    if (e instanceof Error) return t.error;
                    const s = Object.prototype.toString.call(e);
                    return r.typeMap.get(s) || t.generic;
                };
            },
            86 (e, t) {
                "use strict";
                t.keys = function(e, t = {}) {
                    return !1 !== t.symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
                };
            },
            8248 (e, t, r) {
                "use strict";
                const { assert: s } = r(3115), n = {};
                t.Sorter = class {
                    constructor(){
                        this._items = [], this.nodes = [];
                    }
                    add(e, t) {
                        var r, n, a, o;
                        const i = [].concat(null !== (r = (t = null != t ? t : {}).before) && void 0 !== r ? r : []), l = [].concat(null !== (n = t.after) && void 0 !== n ? n : []), c = null !== (a = t.group) && void 0 !== a ? a : "?", u = null !== (o = t.sort) && void 0 !== o ? o : 0;
                        s(!i.includes(c), `Item cannot come before itself: ${c}`), s(!i.includes("?"), "Item cannot come before unassociated items"), s(!l.includes(c), `Item cannot come after itself: ${c}`), s(!l.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [
                            e
                        ]);
                        for (const t of e){
                            const e = {
                                seq: this._items.length,
                                sort: u,
                                before: i,
                                after: l,
                                group: c,
                                node: t
                            };
                            this._items.push(e);
                        }
                        if (!t.manual) {
                            const e = this._sort();
                            s(e, "item", "?" !== c ? `added into group ${c}` : "", "created a dependencies error");
                        }
                        return this.nodes;
                    }
                    merge(e) {
                        Array.isArray(e) || (e = [
                            e
                        ]);
                        for (const t of e)if (t) for (const e of t._items)this._items.push(Object.assign({}, e));
                        this._items.sort(n.mergeSort);
                        for(let e = 0; e < this._items.length; ++e)this._items[e].seq = e;
                        const t = this._sort();
                        return s(t, "merge created a dependencies error"), this.nodes;
                    }
                    sort() {
                        const e = this._sort();
                        return s(e, "sort created a dependencies error"), this.nodes;
                    }
                    _sort() {
                        const e = {}, t = Object.create(null), r = Object.create(null);
                        for (const a of this._items){
                            var s;
                            const o = a.seq, i = a.group;
                            r[i] = null !== (s = r[i]) && void 0 !== s ? s : [], r[i].push(o), e[o] = a.before;
                            for (const e of a.after){
                                var n;
                                t[e] = null !== (n = t[e]) && void 0 !== n ? n : [], t[e].push(o);
                            }
                        }
                        for(const t in e){
                            const s = [];
                            for(const n in e[t]){
                                var a;
                                const o = e[t][n];
                                r[o] = null !== (a = r[o]) && void 0 !== a ? a : [], s.push(...r[o]);
                            }
                            e[t] = s;
                        }
                        for(const s in t)if (r[s]) for (const n of r[s])e[n].push(...t[s]);
                        const o = {};
                        for(const t in e){
                            const r = e[t];
                            for (const e of r){
                                var i;
                                o[e] = null !== (i = o[e]) && void 0 !== i ? i : [], o[e].push(t);
                            }
                        }
                        const l = {}, c = [];
                        for(let e = 0; e < this._items.length; ++e){
                            let t = e;
                            if (o[e]) {
                                t = null;
                                for(let e = 0; e < this._items.length; ++e){
                                    if (!0 === l[e]) continue;
                                    o[e] || (o[e] = []);
                                    const r = o[e].length;
                                    let s = 0;
                                    for(let t = 0; t < r; ++t)l[o[e][t]] && ++s;
                                    if (s === r) {
                                        t = e;
                                        break;
                                    }
                                }
                            }
                            null !== t && (l[t] = !0, c.push(t));
                        }
                        if (c.length !== this._items.length) return !1;
                        const u = {};
                        for (const e of this._items)u[e.seq] = e;
                        this._items = [], this.nodes = [];
                        for (const e of c){
                            const t = u[e];
                            this.nodes.push(t.node), this._items.push(t);
                        }
                        return !0;
                    }
                }, n.mergeSort = (e, t)=>e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
            },
            554 () {},
            9017 () {},
            125 () {},
            8663 () {},
            6984 () {},
            7368 (e, t, r) {
                "use strict";
                t.tlds = void 0;
                const s = r(1044);
                t.tlds = new Set(s.TLDS.map((e)=>e.toLowerCase()));
            },
            1044 (e, t) {
                "use strict";
                t.TLDS = void 0, t.TLDS = [
                    "AAA",
                    "AARP",
                    "ABB",
                    "ABBOTT",
                    "ABBVIE",
                    "ABC",
                    "ABLE",
                    "ABOGADO",
                    "ABUDHABI",
                    "AC",
                    "ACADEMY",
                    "ACCENTURE",
                    "ACCOUNTANT",
                    "ACCOUNTANTS",
                    "ACO",
                    "ACTOR",
                    "AD",
                    "ADS",
                    "ADULT",
                    "AE",
                    "AEG",
                    "AERO",
                    "AETNA",
                    "AF",
                    "AFL",
                    "AFRICA",
                    "AG",
                    "AGAKHAN",
                    "AGENCY",
                    "AI",
                    "AIG",
                    "AIRBUS",
                    "AIRFORCE",
                    "AIRTEL",
                    "AKDN",
                    "AL",
                    "ALIBABA",
                    "ALIPAY",
                    "ALLFINANZ",
                    "ALLSTATE",
                    "ALLY",
                    "ALSACE",
                    "ALSTOM",
                    "AM",
                    "AMAZON",
                    "AMERICANEXPRESS",
                    "AMERICANFAMILY",
                    "AMEX",
                    "AMFAM",
                    "AMICA",
                    "AMSTERDAM",
                    "ANALYTICS",
                    "ANDROID",
                    "ANQUAN",
                    "ANZ",
                    "AO",
                    "AOL",
                    "APARTMENTS",
                    "APP",
                    "APPLE",
                    "AQ",
                    "AQUARELLE",
                    "AR",
                    "ARAB",
                    "ARAMCO",
                    "ARCHI",
                    "ARMY",
                    "ARPA",
                    "ART",
                    "ARTE",
                    "AS",
                    "ASDA",
                    "ASIA",
                    "ASSOCIATES",
                    "AT",
                    "ATHLETA",
                    "ATTORNEY",
                    "AU",
                    "AUCTION",
                    "AUDI",
                    "AUDIBLE",
                    "AUDIO",
                    "AUSPOST",
                    "AUTHOR",
                    "AUTO",
                    "AUTOS",
                    "AW",
                    "AWS",
                    "AX",
                    "AXA",
                    "AZ",
                    "AZURE",
                    "BA",
                    "BABY",
                    "BAIDU",
                    "BANAMEX",
                    "BAND",
                    "BANK",
                    "BAR",
                    "BARCELONA",
                    "BARCLAYCARD",
                    "BARCLAYS",
                    "BAREFOOT",
                    "BARGAINS",
                    "BASEBALL",
                    "BASKETBALL",
                    "BAUHAUS",
                    "BAYERN",
                    "BB",
                    "BBC",
                    "BBT",
                    "BBVA",
                    "BCG",
                    "BCN",
                    "BD",
                    "BE",
                    "BEATS",
                    "BEAUTY",
                    "BEER",
                    "BERLIN",
                    "BEST",
                    "BESTBUY",
                    "BET",
                    "BF",
                    "BG",
                    "BH",
                    "BHARTI",
                    "BI",
                    "BIBLE",
                    "BID",
                    "BIKE",
                    "BING",
                    "BINGO",
                    "BIO",
                    "BIZ",
                    "BJ",
                    "BLACK",
                    "BLACKFRIDAY",
                    "BLOCKBUSTER",
                    "BLOG",
                    "BLOOMBERG",
                    "BLUE",
                    "BM",
                    "BMS",
                    "BMW",
                    "BN",
                    "BNPPARIBAS",
                    "BO",
                    "BOATS",
                    "BOEHRINGER",
                    "BOFA",
                    "BOM",
                    "BOND",
                    "BOO",
                    "BOOK",
                    "BOOKING",
                    "BOSCH",
                    "BOSTIK",
                    "BOSTON",
                    "BOT",
                    "BOUTIQUE",
                    "BOX",
                    "BR",
                    "BRADESCO",
                    "BRIDGESTONE",
                    "BROADWAY",
                    "BROKER",
                    "BROTHER",
                    "BRUSSELS",
                    "BS",
                    "BT",
                    "BUILD",
                    "BUILDERS",
                    "BUSINESS",
                    "BUY",
                    "BUZZ",
                    "BV",
                    "BW",
                    "BY",
                    "BZ",
                    "BZH",
                    "CA",
                    "CAB",
                    "CAFE",
                    "CAL",
                    "CALL",
                    "CALVINKLEIN",
                    "CAM",
                    "CAMERA",
                    "CAMP",
                    "CANON",
                    "CAPETOWN",
                    "CAPITAL",
                    "CAPITALONE",
                    "CAR",
                    "CARAVAN",
                    "CARDS",
                    "CARE",
                    "CAREER",
                    "CAREERS",
                    "CARS",
                    "CASA",
                    "CASE",
                    "CASH",
                    "CASINO",
                    "CAT",
                    "CATERING",
                    "CATHOLIC",
                    "CBA",
                    "CBN",
                    "CBRE",
                    "CC",
                    "CD",
                    "CENTER",
                    "CEO",
                    "CERN",
                    "CF",
                    "CFA",
                    "CFD",
                    "CG",
                    "CH",
                    "CHANEL",
                    "CHANNEL",
                    "CHARITY",
                    "CHASE",
                    "CHAT",
                    "CHEAP",
                    "CHINTAI",
                    "CHRISTMAS",
                    "CHROME",
                    "CHURCH",
                    "CI",
                    "CIPRIANI",
                    "CIRCLE",
                    "CISCO",
                    "CITADEL",
                    "CITI",
                    "CITIC",
                    "CITY",
                    "CK",
                    "CL",
                    "CLAIMS",
                    "CLEANING",
                    "CLICK",
                    "CLINIC",
                    "CLINIQUE",
                    "CLOTHING",
                    "CLOUD",
                    "CLUB",
                    "CLUBMED",
                    "CM",
                    "CN",
                    "CO",
                    "COACH",
                    "CODES",
                    "COFFEE",
                    "COLLEGE",
                    "COLOGNE",
                    "COM",
                    "COMMBANK",
                    "COMMUNITY",
                    "COMPANY",
                    "COMPARE",
                    "COMPUTER",
                    "COMSEC",
                    "CONDOS",
                    "CONSTRUCTION",
                    "CONSULTING",
                    "CONTACT",
                    "CONTRACTORS",
                    "COOKING",
                    "COOL",
                    "COOP",
                    "CORSICA",
                    "COUNTRY",
                    "COUPON",
                    "COUPONS",
                    "COURSES",
                    "CPA",
                    "CR",
                    "CREDIT",
                    "CREDITCARD",
                    "CREDITUNION",
                    "CRICKET",
                    "CROWN",
                    "CRS",
                    "CRUISE",
                    "CRUISES",
                    "CU",
                    "CUISINELLA",
                    "CV",
                    "CW",
                    "CX",
                    "CY",
                    "CYMRU",
                    "CYOU",
                    "CZ",
                    "DAD",
                    "DANCE",
                    "DATA",
                    "DATE",
                    "DATING",
                    "DATSUN",
                    "DAY",
                    "DCLK",
                    "DDS",
                    "DE",
                    "DEAL",
                    "DEALER",
                    "DEALS",
                    "DEGREE",
                    "DELIVERY",
                    "DELL",
                    "DELOITTE",
                    "DELTA",
                    "DEMOCRAT",
                    "DENTAL",
                    "DENTIST",
                    "DESI",
                    "DESIGN",
                    "DEV",
                    "DHL",
                    "DIAMONDS",
                    "DIET",
                    "DIGITAL",
                    "DIRECT",
                    "DIRECTORY",
                    "DISCOUNT",
                    "DISCOVER",
                    "DISH",
                    "DIY",
                    "DJ",
                    "DK",
                    "DM",
                    "DNP",
                    "DO",
                    "DOCS",
                    "DOCTOR",
                    "DOG",
                    "DOMAINS",
                    "DOT",
                    "DOWNLOAD",
                    "DRIVE",
                    "DTV",
                    "DUBAI",
                    "DUPONT",
                    "DURBAN",
                    "DVAG",
                    "DVR",
                    "DZ",
                    "EARTH",
                    "EAT",
                    "EC",
                    "ECO",
                    "EDEKA",
                    "EDU",
                    "EDUCATION",
                    "EE",
                    "EG",
                    "EMAIL",
                    "EMERCK",
                    "ENERGY",
                    "ENGINEER",
                    "ENGINEERING",
                    "ENTERPRISES",
                    "EPSON",
                    "EQUIPMENT",
                    "ER",
                    "ERICSSON",
                    "ERNI",
                    "ES",
                    "ESQ",
                    "ESTATE",
                    "ET",
                    "EU",
                    "EUROVISION",
                    "EUS",
                    "EVENTS",
                    "EXCHANGE",
                    "EXPERT",
                    "EXPOSED",
                    "EXPRESS",
                    "EXTRASPACE",
                    "FAGE",
                    "FAIL",
                    "FAIRWINDS",
                    "FAITH",
                    "FAMILY",
                    "FAN",
                    "FANS",
                    "FARM",
                    "FARMERS",
                    "FASHION",
                    "FAST",
                    "FEDEX",
                    "FEEDBACK",
                    "FERRARI",
                    "FERRERO",
                    "FI",
                    "FIDELITY",
                    "FIDO",
                    "FILM",
                    "FINAL",
                    "FINANCE",
                    "FINANCIAL",
                    "FIRE",
                    "FIRESTONE",
                    "FIRMDALE",
                    "FISH",
                    "FISHING",
                    "FIT",
                    "FITNESS",
                    "FJ",
                    "FK",
                    "FLICKR",
                    "FLIGHTS",
                    "FLIR",
                    "FLORIST",
                    "FLOWERS",
                    "FLY",
                    "FM",
                    "FO",
                    "FOO",
                    "FOOD",
                    "FOOTBALL",
                    "FORD",
                    "FOREX",
                    "FORSALE",
                    "FORUM",
                    "FOUNDATION",
                    "FOX",
                    "FR",
                    "FREE",
                    "FRESENIUS",
                    "FRL",
                    "FROGANS",
                    "FRONTIER",
                    "FTR",
                    "FUJITSU",
                    "FUN",
                    "FUND",
                    "FURNITURE",
                    "FUTBOL",
                    "FYI",
                    "GA",
                    "GAL",
                    "GALLERY",
                    "GALLO",
                    "GALLUP",
                    "GAME",
                    "GAMES",
                    "GAP",
                    "GARDEN",
                    "GAY",
                    "GB",
                    "GBIZ",
                    "GD",
                    "GDN",
                    "GE",
                    "GEA",
                    "GENT",
                    "GENTING",
                    "GEORGE",
                    "GF",
                    "GG",
                    "GGEE",
                    "GH",
                    "GI",
                    "GIFT",
                    "GIFTS",
                    "GIVES",
                    "GIVING",
                    "GL",
                    "GLASS",
                    "GLE",
                    "GLOBAL",
                    "GLOBO",
                    "GM",
                    "GMAIL",
                    "GMBH",
                    "GMO",
                    "GMX",
                    "GN",
                    "GODADDY",
                    "GOLD",
                    "GOLDPOINT",
                    "GOLF",
                    "GOODYEAR",
                    "GOOG",
                    "GOOGLE",
                    "GOP",
                    "GOT",
                    "GOV",
                    "GP",
                    "GQ",
                    "GR",
                    "GRAINGER",
                    "GRAPHICS",
                    "GRATIS",
                    "GREEN",
                    "GRIPE",
                    "GROCERY",
                    "GROUP",
                    "GS",
                    "GT",
                    "GU",
                    "GUCCI",
                    "GUGE",
                    "GUIDE",
                    "GUITARS",
                    "GURU",
                    "GW",
                    "GY",
                    "HAIR",
                    "HAMBURG",
                    "HANGOUT",
                    "HAUS",
                    "HBO",
                    "HDFC",
                    "HDFCBANK",
                    "HEALTH",
                    "HEALTHCARE",
                    "HELP",
                    "HELSINKI",
                    "HERE",
                    "HERMES",
                    "HIPHOP",
                    "HISAMITSU",
                    "HITACHI",
                    "HIV",
                    "HK",
                    "HKT",
                    "HM",
                    "HN",
                    "HOCKEY",
                    "HOLDINGS",
                    "HOLIDAY",
                    "HOMEDEPOT",
                    "HOMEGOODS",
                    "HOMES",
                    "HOMESENSE",
                    "HONDA",
                    "HORSE",
                    "HOSPITAL",
                    "HOST",
                    "HOSTING",
                    "HOT",
                    "HOTELS",
                    "HOTMAIL",
                    "HOUSE",
                    "HOW",
                    "HR",
                    "HSBC",
                    "HT",
                    "HU",
                    "HUGHES",
                    "HYATT",
                    "HYUNDAI",
                    "IBM",
                    "ICBC",
                    "ICE",
                    "ICU",
                    "ID",
                    "IE",
                    "IEEE",
                    "IFM",
                    "IKANO",
                    "IL",
                    "IM",
                    "IMAMAT",
                    "IMDB",
                    "IMMO",
                    "IMMOBILIEN",
                    "IN",
                    "INC",
                    "INDUSTRIES",
                    "INFINITI",
                    "INFO",
                    "ING",
                    "INK",
                    "INSTITUTE",
                    "INSURANCE",
                    "INSURE",
                    "INT",
                    "INTERNATIONAL",
                    "INTUIT",
                    "INVESTMENTS",
                    "IO",
                    "IPIRANGA",
                    "IQ",
                    "IR",
                    "IRISH",
                    "IS",
                    "ISMAILI",
                    "IST",
                    "ISTANBUL",
                    "IT",
                    "ITAU",
                    "ITV",
                    "JAGUAR",
                    "JAVA",
                    "JCB",
                    "JE",
                    "JEEP",
                    "JETZT",
                    "JEWELRY",
                    "JIO",
                    "JLL",
                    "JM",
                    "JMP",
                    "JNJ",
                    "JO",
                    "JOBS",
                    "JOBURG",
                    "JOT",
                    "JOY",
                    "JP",
                    "JPMORGAN",
                    "JPRS",
                    "JUEGOS",
                    "JUNIPER",
                    "KAUFEN",
                    "KDDI",
                    "KE",
                    "KERRYHOTELS",
                    "KERRYPROPERTIES",
                    "KFH",
                    "KG",
                    "KH",
                    "KI",
                    "KIA",
                    "KIDS",
                    "KIM",
                    "KINDLE",
                    "KITCHEN",
                    "KIWI",
                    "KM",
                    "KN",
                    "KOELN",
                    "KOMATSU",
                    "KOSHER",
                    "KP",
                    "KPMG",
                    "KPN",
                    "KR",
                    "KRD",
                    "KRED",
                    "KUOKGROUP",
                    "KW",
                    "KY",
                    "KYOTO",
                    "KZ",
                    "LA",
                    "LACAIXA",
                    "LAMBORGHINI",
                    "LAMER",
                    "LAND",
                    "LANDROVER",
                    "LANXESS",
                    "LASALLE",
                    "LAT",
                    "LATINO",
                    "LATROBE",
                    "LAW",
                    "LAWYER",
                    "LB",
                    "LC",
                    "LDS",
                    "LEASE",
                    "LECLERC",
                    "LEFRAK",
                    "LEGAL",
                    "LEGO",
                    "LEXUS",
                    "LGBT",
                    "LI",
                    "LIDL",
                    "LIFE",
                    "LIFEINSURANCE",
                    "LIFESTYLE",
                    "LIGHTING",
                    "LIKE",
                    "LILLY",
                    "LIMITED",
                    "LIMO",
                    "LINCOLN",
                    "LINK",
                    "LIVE",
                    "LIVING",
                    "LK",
                    "LLC",
                    "LLP",
                    "LOAN",
                    "LOANS",
                    "LOCKER",
                    "LOCUS",
                    "LOL",
                    "LONDON",
                    "LOTTE",
                    "LOTTO",
                    "LOVE",
                    "LPL",
                    "LPLFINANCIAL",
                    "LR",
                    "LS",
                    "LT",
                    "LTD",
                    "LTDA",
                    "LU",
                    "LUNDBECK",
                    "LUXE",
                    "LUXURY",
                    "LV",
                    "LY",
                    "MA",
                    "MADRID",
                    "MAIF",
                    "MAISON",
                    "MAKEUP",
                    "MAN",
                    "MANAGEMENT",
                    "MANGO",
                    "MAP",
                    "MARKET",
                    "MARKETING",
                    "MARKETS",
                    "MARRIOTT",
                    "MARSHALLS",
                    "MATTEL",
                    "MBA",
                    "MC",
                    "MCKINSEY",
                    "MD",
                    "ME",
                    "MED",
                    "MEDIA",
                    "MEET",
                    "MELBOURNE",
                    "MEME",
                    "MEMORIAL",
                    "MEN",
                    "MENU",
                    "MERCK",
                    "MERCKMSD",
                    "MG",
                    "MH",
                    "MIAMI",
                    "MICROSOFT",
                    "MIL",
                    "MINI",
                    "MINT",
                    "MIT",
                    "MITSUBISHI",
                    "MK",
                    "ML",
                    "MLB",
                    "MLS",
                    "MM",
                    "MMA",
                    "MN",
                    "MO",
                    "MOBI",
                    "MOBILE",
                    "MODA",
                    "MOE",
                    "MOI",
                    "MOM",
                    "MONASH",
                    "MONEY",
                    "MONSTER",
                    "MORMON",
                    "MORTGAGE",
                    "MOSCOW",
                    "MOTO",
                    "MOTORCYCLES",
                    "MOV",
                    "MOVIE",
                    "MP",
                    "MQ",
                    "MR",
                    "MS",
                    "MSD",
                    "MT",
                    "MTN",
                    "MTR",
                    "MU",
                    "MUSEUM",
                    "MUSIC",
                    "MV",
                    "MW",
                    "MX",
                    "MY",
                    "MZ",
                    "NA",
                    "NAB",
                    "NAGOYA",
                    "NAME",
                    "NAVY",
                    "NBA",
                    "NC",
                    "NE",
                    "NEC",
                    "NET",
                    "NETBANK",
                    "NETFLIX",
                    "NETWORK",
                    "NEUSTAR",
                    "NEW",
                    "NEWS",
                    "NEXT",
                    "NEXTDIRECT",
                    "NEXUS",
                    "NF",
                    "NFL",
                    "NG",
                    "NGO",
                    "NHK",
                    "NI",
                    "NICO",
                    "NIKE",
                    "NIKON",
                    "NINJA",
                    "NISSAN",
                    "NISSAY",
                    "NL",
                    "NO",
                    "NOKIA",
                    "NORTON",
                    "NOW",
                    "NOWRUZ",
                    "NOWTV",
                    "NP",
                    "NR",
                    "NRA",
                    "NRW",
                    "NTT",
                    "NU",
                    "NYC",
                    "NZ",
                    "OBI",
                    "OBSERVER",
                    "OFFICE",
                    "OKINAWA",
                    "OLAYAN",
                    "OLAYANGROUP",
                    "OLLO",
                    "OM",
                    "OMEGA",
                    "ONE",
                    "ONG",
                    "ONL",
                    "ONLINE",
                    "OOO",
                    "OPEN",
                    "ORACLE",
                    "ORANGE",
                    "ORG",
                    "ORGANIC",
                    "ORIGINS",
                    "OSAKA",
                    "OTSUKA",
                    "OTT",
                    "OVH",
                    "PA",
                    "PAGE",
                    "PANASONIC",
                    "PARIS",
                    "PARS",
                    "PARTNERS",
                    "PARTS",
                    "PARTY",
                    "PAY",
                    "PCCW",
                    "PE",
                    "PET",
                    "PF",
                    "PFIZER",
                    "PG",
                    "PH",
                    "PHARMACY",
                    "PHD",
                    "PHILIPS",
                    "PHONE",
                    "PHOTO",
                    "PHOTOGRAPHY",
                    "PHOTOS",
                    "PHYSIO",
                    "PICS",
                    "PICTET",
                    "PICTURES",
                    "PID",
                    "PIN",
                    "PING",
                    "PINK",
                    "PIONEER",
                    "PIZZA",
                    "PK",
                    "PL",
                    "PLACE",
                    "PLAY",
                    "PLAYSTATION",
                    "PLUMBING",
                    "PLUS",
                    "PM",
                    "PN",
                    "PNC",
                    "POHL",
                    "POKER",
                    "POLITIE",
                    "PORN",
                    "POST",
                    "PR",
                    "PRAXI",
                    "PRESS",
                    "PRIME",
                    "PRO",
                    "PROD",
                    "PRODUCTIONS",
                    "PROF",
                    "PROGRESSIVE",
                    "PROMO",
                    "PROPERTIES",
                    "PROPERTY",
                    "PROTECTION",
                    "PRU",
                    "PRUDENTIAL",
                    "PS",
                    "PT",
                    "PUB",
                    "PW",
                    "PWC",
                    "PY",
                    "QA",
                    "QPON",
                    "QUEBEC",
                    "QUEST",
                    "RACING",
                    "RADIO",
                    "RE",
                    "READ",
                    "REALESTATE",
                    "REALTOR",
                    "REALTY",
                    "RECIPES",
                    "RED",
                    "REDUMBRELLA",
                    "REHAB",
                    "REISE",
                    "REISEN",
                    "REIT",
                    "RELIANCE",
                    "REN",
                    "RENT",
                    "RENTALS",
                    "REPAIR",
                    "REPORT",
                    "REPUBLICAN",
                    "REST",
                    "RESTAURANT",
                    "REVIEW",
                    "REVIEWS",
                    "REXROTH",
                    "RICH",
                    "RICHARDLI",
                    "RICOH",
                    "RIL",
                    "RIO",
                    "RIP",
                    "RO",
                    "ROCKS",
                    "RODEO",
                    "ROGERS",
                    "ROOM",
                    "RS",
                    "RSVP",
                    "RU",
                    "RUGBY",
                    "RUHR",
                    "RUN",
                    "RW",
                    "RWE",
                    "RYUKYU",
                    "SA",
                    "SAARLAND",
                    "SAFE",
                    "SAFETY",
                    "SAKURA",
                    "SALE",
                    "SALON",
                    "SAMSCLUB",
                    "SAMSUNG",
                    "SANDVIK",
                    "SANDVIKCOROMANT",
                    "SANOFI",
                    "SAP",
                    "SARL",
                    "SAS",
                    "SAVE",
                    "SAXO",
                    "SB",
                    "SBI",
                    "SBS",
                    "SC",
                    "SCB",
                    "SCHAEFFLER",
                    "SCHMIDT",
                    "SCHOLARSHIPS",
                    "SCHOOL",
                    "SCHULE",
                    "SCHWARZ",
                    "SCIENCE",
                    "SCOT",
                    "SD",
                    "SE",
                    "SEARCH",
                    "SEAT",
                    "SECURE",
                    "SECURITY",
                    "SEEK",
                    "SELECT",
                    "SENER",
                    "SERVICES",
                    "SEVEN",
                    "SEW",
                    "SEX",
                    "SEXY",
                    "SFR",
                    "SG",
                    "SH",
                    "SHANGRILA",
                    "SHARP",
                    "SHELL",
                    "SHIA",
                    "SHIKSHA",
                    "SHOES",
                    "SHOP",
                    "SHOPPING",
                    "SHOUJI",
                    "SHOW",
                    "SI",
                    "SILK",
                    "SINA",
                    "SINGLES",
                    "SITE",
                    "SJ",
                    "SK",
                    "SKI",
                    "SKIN",
                    "SKY",
                    "SKYPE",
                    "SL",
                    "SLING",
                    "SM",
                    "SMART",
                    "SMILE",
                    "SN",
                    "SNCF",
                    "SO",
                    "SOCCER",
                    "SOCIAL",
                    "SOFTBANK",
                    "SOFTWARE",
                    "SOHU",
                    "SOLAR",
                    "SOLUTIONS",
                    "SONG",
                    "SONY",
                    "SOY",
                    "SPA",
                    "SPACE",
                    "SPORT",
                    "SPOT",
                    "SR",
                    "SRL",
                    "SS",
                    "ST",
                    "STADA",
                    "STAPLES",
                    "STAR",
                    "STATEBANK",
                    "STATEFARM",
                    "STC",
                    "STCGROUP",
                    "STOCKHOLM",
                    "STORAGE",
                    "STORE",
                    "STREAM",
                    "STUDIO",
                    "STUDY",
                    "STYLE",
                    "SU",
                    "SUCKS",
                    "SUPPLIES",
                    "SUPPLY",
                    "SUPPORT",
                    "SURF",
                    "SURGERY",
                    "SUZUKI",
                    "SV",
                    "SWATCH",
                    "SWISS",
                    "SX",
                    "SY",
                    "SYDNEY",
                    "SYSTEMS",
                    "SZ",
                    "TAB",
                    "TAIPEI",
                    "TALK",
                    "TAOBAO",
                    "TARGET",
                    "TATAMOTORS",
                    "TATAR",
                    "TATTOO",
                    "TAX",
                    "TAXI",
                    "TC",
                    "TCI",
                    "TD",
                    "TDK",
                    "TEAM",
                    "TECH",
                    "TECHNOLOGY",
                    "TEL",
                    "TEMASEK",
                    "TENNIS",
                    "TEVA",
                    "TF",
                    "TG",
                    "TH",
                    "THD",
                    "THEATER",
                    "THEATRE",
                    "TIAA",
                    "TICKETS",
                    "TIENDA",
                    "TIPS",
                    "TIRES",
                    "TIROL",
                    "TJ",
                    "TJMAXX",
                    "TJX",
                    "TK",
                    "TKMAXX",
                    "TL",
                    "TM",
                    "TMALL",
                    "TN",
                    "TO",
                    "TODAY",
                    "TOKYO",
                    "TOOLS",
                    "TOP",
                    "TORAY",
                    "TOSHIBA",
                    "TOTAL",
                    "TOURS",
                    "TOWN",
                    "TOYOTA",
                    "TOYS",
                    "TR",
                    "TRADE",
                    "TRADING",
                    "TRAINING",
                    "TRAVEL",
                    "TRAVELERS",
                    "TRAVELERSINSURANCE",
                    "TRUST",
                    "TRV",
                    "TT",
                    "TUBE",
                    "TUI",
                    "TUNES",
                    "TUSHU",
                    "TV",
                    "TVS",
                    "TW",
                    "TZ",
                    "UA",
                    "UBANK",
                    "UBS",
                    "UG",
                    "UK",
                    "UNICOM",
                    "UNIVERSITY",
                    "UNO",
                    "UOL",
                    "UPS",
                    "US",
                    "UY",
                    "UZ",
                    "VA",
                    "VACATIONS",
                    "VANA",
                    "VANGUARD",
                    "VC",
                    "VE",
                    "VEGAS",
                    "VENTURES",
                    "VERISIGN",
                    "VERSICHERUNG",
                    "VET",
                    "VG",
                    "VI",
                    "VIAJES",
                    "VIDEO",
                    "VIG",
                    "VIKING",
                    "VILLAS",
                    "VIN",
                    "VIP",
                    "VIRGIN",
                    "VISA",
                    "VISION",
                    "VIVA",
                    "VIVO",
                    "VLAANDEREN",
                    "VN",
                    "VODKA",
                    "VOLVO",
                    "VOTE",
                    "VOTING",
                    "VOTO",
                    "VOYAGE",
                    "VU",
                    "WALES",
                    "WALMART",
                    "WALTER",
                    "WANG",
                    "WANGGOU",
                    "WATCH",
                    "WATCHES",
                    "WEATHER",
                    "WEATHERCHANNEL",
                    "WEBCAM",
                    "WEBER",
                    "WEBSITE",
                    "WED",
                    "WEDDING",
                    "WEIBO",
                    "WEIR",
                    "WF",
                    "WHOSWHO",
                    "WIEN",
                    "WIKI",
                    "WILLIAMHILL",
                    "WIN",
                    "WINDOWS",
                    "WINE",
                    "WINNERS",
                    "WME",
                    "WOODSIDE",
                    "WORK",
                    "WORKS",
                    "WORLD",
                    "WOW",
                    "WS",
                    "WTC",
                    "WTF",
                    "XBOX",
                    "XEROX",
                    "XIHUAN",
                    "XIN",
                    "XN--11B4C3D",
                    "XN--1CK2E1B",
                    "XN--1QQW23A",
                    "XN--2SCRJ9C",
                    "XN--30RR7Y",
                    "XN--3BST00M",
                    "XN--3DS443G",
                    "XN--3E0B707E",
                    "XN--3HCRJ9C",
                    "XN--3PXU8K",
                    "XN--42C2D9A",
                    "XN--45BR5CYL",
                    "XN--45BRJ9C",
                    "XN--45Q11C",
                    "XN--4DBRK0CE",
                    "XN--4GBRIM",
                    "XN--54B7FTA0CC",
                    "XN--55QW42G",
                    "XN--55QX5D",
                    "XN--5SU34J936BGSG",
                    "XN--5TZM5G",
                    "XN--6FRZ82G",
                    "XN--6QQ986B3XL",
                    "XN--80ADXHKS",
                    "XN--80AO21A",
                    "XN--80AQECDR1A",
                    "XN--80ASEHDB",
                    "XN--80ASWG",
                    "XN--8Y0A063A",
                    "XN--90A3AC",
                    "XN--90AE",
                    "XN--90AIS",
                    "XN--9DBQ2A",
                    "XN--9ET52U",
                    "XN--9KRT00A",
                    "XN--B4W605FERD",
                    "XN--BCK1B9A5DRE4C",
                    "XN--C1AVG",
                    "XN--C2BR7G",
                    "XN--CCK2B3B",
                    "XN--CCKWCXETD",
                    "XN--CG4BKI",
                    "XN--CLCHC0EA0B2G2A9GCD",
                    "XN--CZR694B",
                    "XN--CZRS0T",
                    "XN--CZRU2D",
                    "XN--D1ACJ3B",
                    "XN--D1ALF",
                    "XN--E1A4C",
                    "XN--ECKVDTC9D",
                    "XN--EFVY88H",
                    "XN--FCT429K",
                    "XN--FHBEI",
                    "XN--FIQ228C5HS",
                    "XN--FIQ64B",
                    "XN--FIQS8S",
                    "XN--FIQZ9S",
                    "XN--FJQ720A",
                    "XN--FLW351E",
                    "XN--FPCRJ9C3D",
                    "XN--FZC2C9E2C",
                    "XN--FZYS8D69UVGM",
                    "XN--G2XX48C",
                    "XN--GCKR3F0F",
                    "XN--GECRJ9C",
                    "XN--GK3AT1E",
                    "XN--H2BREG3EVE",
                    "XN--H2BRJ9C",
                    "XN--H2BRJ9C8C",
                    "XN--HXT814E",
                    "XN--I1B6B1A6A2E",
                    "XN--IMR513N",
                    "XN--IO0A7I",
                    "XN--J1AEF",
                    "XN--J1AMH",
                    "XN--J6W193G",
                    "XN--JLQ480N2RG",
                    "XN--JVR189M",
                    "XN--KCRX77D1X4A",
                    "XN--KPRW13D",
                    "XN--KPRY57D",
                    "XN--KPUT3I",
                    "XN--L1ACC",
                    "XN--LGBBAT1AD8J",
                    "XN--MGB9AWBF",
                    "XN--MGBA3A3EJT",
                    "XN--MGBA3A4F16A",
                    "XN--MGBA7C0BBN0A",
                    "XN--MGBAAM7A8H",
                    "XN--MGBAB2BD",
                    "XN--MGBAH1A3HJKRD",
                    "XN--MGBAI9AZGQP6J",
                    "XN--MGBAYH7GPA",
                    "XN--MGBBH1A",
                    "XN--MGBBH1A71E",
                    "XN--MGBC0A9AZCG",
                    "XN--MGBCA7DZDO",
                    "XN--MGBCPQ6GPA1A",
                    "XN--MGBERP4A5D4AR",
                    "XN--MGBGU82A",
                    "XN--MGBI4ECEXP",
                    "XN--MGBPL2FH",
                    "XN--MGBT3DHD",
                    "XN--MGBTX2B",
                    "XN--MGBX4CD0AB",
                    "XN--MIX891F",
                    "XN--MK1BU44C",
                    "XN--MXTQ1M",
                    "XN--NGBC5AZD",
                    "XN--NGBE9E0A",
                    "XN--NGBRX",
                    "XN--NODE",
                    "XN--NQV7F",
                    "XN--NQV7FS00EMA",
                    "XN--NYQY26A",
                    "XN--O3CW4H",
                    "XN--OGBPF8FL",
                    "XN--OTU796D",
                    "XN--P1ACF",
                    "XN--P1AI",
                    "XN--PGBS0DH",
                    "XN--PSSY2U",
                    "XN--Q7CE6A",
                    "XN--Q9JYB4C",
                    "XN--QCKA1PMC",
                    "XN--QXA6A",
                    "XN--QXAM",
                    "XN--RHQV96G",
                    "XN--ROVU88B",
                    "XN--RVC1E0AM3E",
                    "XN--S9BRJ9C",
                    "XN--SES554G",
                    "XN--T60B56A",
                    "XN--TCKWE",
                    "XN--TIQ49XQYJ",
                    "XN--UNUP4Y",
                    "XN--VERMGENSBERATER-CTB",
                    "XN--VERMGENSBERATUNG-PWB",
                    "XN--VHQUV",
                    "XN--VUQ861B",
                    "XN--W4R85EL8FHU5DNRA",
                    "XN--W4RS40L",
                    "XN--WGBH1C",
                    "XN--WGBL6A",
                    "XN--XHQ521B",
                    "XN--XKC2AL3HYE2A",
                    "XN--XKC2DL3A5EE0H",
                    "XN--Y9A3AQ",
                    "XN--YFRO4I67O",
                    "XN--YGBI2AMMX",
                    "XN--ZFR164B",
                    "XXX",
                    "XYZ",
                    "YACHTS",
                    "YAHOO",
                    "YAMAXUN",
                    "YANDEX",
                    "YE",
                    "YODOBASHI",
                    "YOGA",
                    "YOKOHAMA",
                    "YOU",
                    "YOUTUBE",
                    "YT",
                    "YUN",
                    "ZA",
                    "ZAPPOS",
                    "ZARA",
                    "ZERO",
                    "ZIP",
                    "ZM",
                    "ZONE",
                    "ZUERICH",
                    "ZW"
                ];
            },
            6913 (e) {
                "use strict";
                e.exports = {
                    version: "18.3.1"
                };
            }
        };
        const t = {};
        function r(s) {
            const n = t[s];
            if (void 0 !== n) return n.exports;
            const a = t[s] = {
                exports: {}
            };
            return e[s](a, a.exports, r), a.exports;
        }
        return r.n = (e)=>{
            const t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var s in t)r.o(t, s) && !r.o(e, s) && Object.defineProperty(e, s, {
                enumerable: !0,
                get: t[s]
            });
        }, r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r(1100);
    })());

});

parcelRegister("8YciW", function(module, exports) {
$parcel$export(module.exports, "ProviderRpcErrorCode", () => (parcelRequire("bKBH7")).ProviderRpcErrorCode);
$parcel$export(module.exports, "chainIdValidation", () => (parcelRequire("dkXem")).chainIdValidation);
$parcel$export(module.exports, "chainNamespaceValidation", () => (parcelRequire("dkXem")).chainNamespaceValidation);
$parcel$export(module.exports, "chainValidation", () => (parcelRequire("dkXem")).chainValidation);
$parcel$export(module.exports, "validate", () => (parcelRequire("dkXem")).validate);

$parcel$export(module.exports, "ProviderRpcError", () => (parcelRequire("avfUB")).ProviderRpcError);
$parcel$export(module.exports, "createEIP1193Provider", () => (parcelRequire("eieBU")).createEIP1193Provider);
$parcel$export(module.exports, "InterVar", () => (parcelRequire("kEwFP")).InterVar);
$parcel$export(module.exports, "weiHexToEth", () => (parcelRequire("6hARo")).weiHexToEth);
$parcel$export(module.exports, "weiToEth", () => (parcelRequire("6hARo")).weiToEth);
$parcel$export(module.exports, "isAddress", () => (parcelRequire("6hARo")).isAddress);
$parcel$export(module.exports, "bigIntToHex", () => (parcelRequire("6hARo")).bigIntToHex);
$parcel$export(module.exports, "chainIdToViemImport", () => (parcelRequire("6hARo")).chainIdToViemImport);
$parcel$export(module.exports, "isHex", () => (parcelRequire("16b1X")).isHex);
$parcel$export(module.exports, "toHex", () => (parcelRequire("8bum0")).toHex);
$parcel$export(module.exports, "fromHex", () => (parcelRequire("7p6KH")).fromHex);

var $avfUB = parcelRequire("avfUB");

var $eieBU = parcelRequire("eieBU");

var $kEwFP = parcelRequire("kEwFP");

var $6hARo = parcelRequire("6hARo");
parcelRequire("bKBH7");
parcelRequire("dkXem");

var $7p6KH = parcelRequire("7p6KH");
var $16b1X = parcelRequire("16b1X");
var $8bum0 = parcelRequire("8bum0");

});
parcelRegister("avfUB", function(module, exports) {

$parcel$export(module.exports, "ProviderRpcError", () => $7a592466f2a6fda2$export$417589b978208a8f);
class $7a592466f2a6fda2$export$417589b978208a8f extends Error {
    constructor(error){
        super(error.message);
        this.message = error.message;
        this.code = error.code;
        this.data = error.data;
    }
}

});

parcelRegister("eieBU", function(module, exports) {

$parcel$export(module.exports, "createEIP1193Provider", () => $a67e1471bd08d266$export$3179d0f9b8fae2a4);

var $avfUB = parcelRequire("avfUB");
const $a67e1471bd08d266$export$3179d0f9b8fae2a4 = (provider, requestPatch)=>{
    let baseRequest;
    if (provider.request) // Copy the original request method and bind the provider context to it
    baseRequest = provider.request.bind(provider);
    else if (provider.sendAsync) baseRequest = $a67e1471bd08d266$var$createRequest(provider);
    const request = async ({ method: method, params: params })=>{
        const key = method;
        // If the request method is set to null
        // this indicates this method is not supported
        if (requestPatch && requestPatch[key] === null) throw new (0, $avfUB.ProviderRpcError)({
            code: 4200,
            message: `The Provider does not support the requested method: ${method}`
        });
        if (requestPatch && requestPatch[key]) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore // @TODO - Fix this type error
        return requestPatch[key]({
            baseRequest: baseRequest,
            params: params
        });
        else if (baseRequest) return baseRequest({
            method: method,
            params: params
        });
        else throw new (0, $avfUB.ProviderRpcError)({
            code: 4200,
            message: `The Provider does not support the requested method: ${method}`
        });
    };
    provider.request = request;
    return provider;
};
const $a67e1471bd08d266$var$createRequest = (provider)=>({ method: method, params: params })=>new Promise((resolve, reject)=>{
            provider.sendAsync({
                id: 0,
                jsonrpc: '2.0',
                method: method,
                params: params
            }, (error, { result: result })=>{
                if (error) reject(JSON.parse(error));
                else resolve(result == undefined ? null : result);
            });
        });

});

parcelRegister("kEwFP", function(module, exports) {

$parcel$export(module.exports, "InterVar", () => $f090e35c851fed9b$export$c6987e893c5dcce7);
const $f090e35c851fed9b$export$c6987e893c5dcce7 = `
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 300 600;
  font-display: swap;
  src: url("https://rsms.me/inter/font-files/InterVariable.woff2") format("woff2-variations");
}
`;

});

parcelRegister("6hARo", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $4930ec48845f6798$export$977e255126d763d6);
$parcel$export(module.exports, "weiHexToEth", () => $4930ec48845f6798$export$6846f3b2c0d31273);
$parcel$export(module.exports, "weiToEth", () => $4930ec48845f6798$export$5c738bdb4a4e27c5);
$parcel$export(module.exports, "bigIntToHex", () => $4930ec48845f6798$export$6b5b2c7ca7a3fdfa);
$parcel$export(module.exports, "chainIdToViemImport", () => $4930ec48845f6798$export$5b0e9e8c7ba03442);

var $bMUjY = parcelRequire("bMUjY");
var $7p6KH = parcelRequire("7p6KH");
var $8bum0 = parcelRequire("8bum0");
var $a2wq0 = parcelRequire("a2wq0");
const $4930ec48845f6798$export$977e255126d763d6 = (address)=>{
    return $4930ec48845f6798$export$977e255126d763d6(address);
};
const $4930ec48845f6798$export$6846f3b2c0d31273 = (wei)=>{
    const weiBigInt = (0, $7p6KH.hexToBigInt)(wei);
    return (0, $bMUjY.formatEther)(weiBigInt);
};
const $4930ec48845f6798$export$5c738bdb4a4e27c5 = (wei)=>{
    if (!wei) return wei;
    const weiBigInt = (0, $7p6KH.fromHex)(wei, 'bigint');
    return (0, $bMUjY.formatEther)(weiBigInt);
};
const $4930ec48845f6798$export$42317bc65128ed6f = (eth)=>{
    if (typeof eth !== 'string' && typeof eth !== 'number') throw new Error('eth must be a string or number value');
    const ethString = typeof eth === 'number' ? eth.toString() : eth;
    return (0, $a2wq0.parseEther)(ethString);
};
const $4930ec48845f6798$export$6b5b2c7ca7a3fdfa = (value)=>{
    return (0, $8bum0.numberToHex)(value);
};
const $4930ec48845f6798$export$efcedc5c94b00089 = (walletLabel, download)=>{
    if (!download) return `Please switch to ${walletLabel} to continue`;
    if (typeof download === 'function') return `Please <a href="#" onclick="${()=>download()}">install</a> or enable to ${walletLabel} to continue`;
    else return `Please <a href="${download}" target="_blank">install</a> or enable to ${walletLabel} to continue`;
};


const $4930ec48845f6798$export$5b0e9e8c7ba03442 = async (w3oChain)=>{
    const viemChains = await (parcelRequire("9veww"));
    const { id: id, label: label, token: token, publicRpcUrl: publicRpcUrl, blockExplorerUrl: blockExplorerUrl, rpcUrl: rpcUrl } = w3oChain;
    switch(id){
        case '0x89':
            {
                const { polygon: polygon } = viemChains;
                return polygon;
            }
        case '0xa':
            {
                const { optimism: optimism } = viemChains;
                return optimism;
            }
        case '0xa4b1':
            {
                const { arbitrum: arbitrum } = viemChains;
                return arbitrum;
            }
        case '0x144':
            {
                const { zkSync: zkSync } = viemChains;
                return zkSync;
            }
        case '0x38':
            {
                const { bsc: bsc } = viemChains;
                return bsc;
            }
        case '0x1':
            {
                const { mainnet: mainnet } = viemChains;
                return mainnet;
            }
        case '0xaa36a7':
            {
                const { sepolia: sepolia } = viemChains;
                return sepolia;
            }
        case '0xfa':
            {
                const { fantom: fantom } = viemChains;
                return fantom;
            }
        case '0xa86a':
            {
                const { avalanche: avalanche } = viemChains;
                return avalanche;
            }
        case '0xa4ec':
            {
                const { celo: celo } = viemChains;
                return celo;
            }
        case '0x2105':
            {
                const { base: base } = viemChains;
                return base;
            }
        case '0x14a33':
            {
                const { baseGoerli: baseGoerli } = viemChains;
                return baseGoerli;
            }
        case '0x64':
            {
                const { gnosis: gnosis } = viemChains;
                return gnosis;
            }
        case '0x63564C40':
            {
                const { harmonyOne: harmonyOne } = viemChains;
                return harmonyOne;
            }
        case '0x27bc86aa':
            {
                const { degen: degen } = viemChains;
                return degen;
            }
        default:
            {
                const { extractChain: extractChain, defineChain: defineChain } = await (parcelRequire("5nYMs"));
                const nonNativeChain = extractChain({
                    chains: Object.values(viemChains),
                    id: (0, $7p6KH.fromHex)(id, 'number')
                });
                if (nonNativeChain) return nonNativeChain;
                return defineChain({
                    id: (0, $7p6KH.fromHex)(id, 'number'),
                    name: label !== null && label !== void 0 ? label : '',
                    nativeCurrency: {
                        decimals: 18,
                        name: token !== null && token !== void 0 ? token : '',
                        symbol: token !== null && token !== void 0 ? token : ''
                    },
                    rpcUrls: {
                        default: {
                            http: [
                                rpcUrl !== null && rpcUrl !== void 0 ? rpcUrl : '',
                                publicRpcUrl !== null && publicRpcUrl !== void 0 ? publicRpcUrl : ''
                            ]
                        }
                    },
                    blockExplorers: {
                        default: {
                            name: 'Explorer',
                            url: blockExplorerUrl !== null && blockExplorerUrl !== void 0 ? blockExplorerUrl : ''
                        }
                    }
                });
            }
    }
};

});
parcelRegister("bMUjY", function(module, exports) {

$parcel$export(module.exports, "formatEther", () => $894fdd9f45eef2bb$export$11bc63b4c03ea518);

var $lUWuG = parcelRequire("lUWuG");

var $1QfSp = parcelRequire("1QfSp");
function $894fdd9f45eef2bb$export$11bc63b4c03ea518(wei, unit = 'wei') {
    return (0, $1QfSp.formatUnits)(wei, (0, $lUWuG.etherUnits)[unit]);
}

});
parcelRegister("lUWuG", function(module, exports) {

$parcel$export(module.exports, "etherUnits", () => $ff4c339ab1970c99$export$5bbd813111ed9646);
$parcel$export(module.exports, "gweiUnits", () => $ff4c339ab1970c99$export$a26120bf8be88528);
const $ff4c339ab1970c99$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $ff4c339ab1970c99$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $ff4c339ab1970c99$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("1QfSp", function(module, exports) {

$parcel$export(module.exports, "formatUnits", () => $1576f682a2d282bc$export$bd39b96f71da1885);
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $1576f682a2d282bc$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith('-');
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, '0');
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, '');
    return `${negative ? '-' : ''}${integer || '0'}${fraction ? `.${fraction}` : ''}`;
}

});


parcelRegister("7p6KH", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $56401b0ffea36a5f$export$2af489edb7fa35fe);
$parcel$export(module.exports, "fromHex", () => $56401b0ffea36a5f$export$1a8ceedbd5845648);
$parcel$export(module.exports, "hexToNumber", () => $56401b0ffea36a5f$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $56401b0ffea36a5f$export$92a44656ec81b584);

var $8mLTQ = parcelRequire("8mLTQ");

var $70Cuf = parcelRequire("70Cuf");

var $4w8tX = parcelRequire("4w8tX");

var $g9Vcz = parcelRequire("g9Vcz");
function $56401b0ffea36a5f$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $70Cuf.size)(hexOrBytes) > size) throw new (0, $8mLTQ.SizeOverflowError)({
        givenSize: (0, $70Cuf.size)(hexOrBytes),
        maxSize: size
    });
}
function $56401b0ffea36a5f$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === 'string' ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === 'number') return $56401b0ffea36a5f$export$d57f2bacc26b4249(hex, opts);
    if (to === 'bigint') return $56401b0ffea36a5f$export$92a44656ec81b584(hex, opts);
    if (to === 'string') return $56401b0ffea36a5f$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === 'boolean') return $56401b0ffea36a5f$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $g9Vcz.hexToBytes)(hex, opts);
}
function $56401b0ffea36a5f$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $56401b0ffea36a5f$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${'f'.padStart(size * 2, 'f')}`) - 1n;
}
function $56401b0ffea36a5f$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $56401b0ffea36a5f$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $4w8tX.trim)(hex);
    }
    if ((0, $4w8tX.trim)(hex) === '0x00') return false;
    if ((0, $4w8tX.trim)(hex) === '0x01') return true;
    throw new (0, $8mLTQ.InvalidHexBooleanError)(hex);
}
function $56401b0ffea36a5f$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($56401b0ffea36a5f$export$92a44656ec81b584(hex, opts));
}
function $56401b0ffea36a5f$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $g9Vcz.hexToBytes)(hex);
    if (opts.size) {
        $56401b0ffea36a5f$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $4w8tX.trim)(bytes, {
            dir: 'right'
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("8mLTQ", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $617588b10d31753e$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $617588b10d31753e$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $617588b10d31753e$export$beb44ed4f8747d0e);

var $8KUaf = parcelRequire("8KUaf");
class $617588b10d31753e$export$47d164a8071229a9 extends (0, $8KUaf.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? 'signed' : 'unsigned'} ` : ''}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'IntegerOutOfRangeError'
        });
    }
}
class $617588b10d31753e$export$52fc62e5266c8838 extends (0, $8KUaf.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidBytesBooleanError'
        });
    }
}
class $617588b10d31753e$export$f574ac54e35514c extends (0, $8KUaf.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidHexBooleanError'
        });
    }
}
class $617588b10d31753e$export$ef05eafd11dd4a83 extends (0, $8KUaf.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidHexValueError'
        });
    }
}
class $617588b10d31753e$export$beb44ed4f8747d0e extends (0, $8KUaf.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SizeOverflowError'
        });
    }
}

});
parcelRegister("8KUaf", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $65fe2faec8acec0b$export$a490eb03cb7a0a5e);

var $kwFjj = parcelRequire("kwFjj");
class $65fe2faec8acec0b$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        super();
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ViemError'
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $kwFjj.getVersion)()
        });
        const details = args.cause instanceof $65fe2faec8acec0b$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $65fe2faec8acec0b$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        this.message = [
            shortMessage || 'An error occurred.',
            '',
            ...args.metaMessages ? [
                ...args.metaMessages,
                ''
            ] : [],
            ...docsPath ? [
                `Docs: https://viem.sh${docsPath}${args.docsSlug ? `#${args.docsSlug}` : ''}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join('\n');
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $65fe2faec8acec0b$var$walk(this, fn);
    }
}
function $65fe2faec8acec0b$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === 'object' && 'cause' in err) return $65fe2faec8acec0b$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("kwFjj", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $ef16d73c120c1166$export$c506eb22e615ba4a);

var $hKDyh = parcelRequire("hKDyh");
const $ef16d73c120c1166$export$b7fbffef12272e40 = (address)=>address;
const $ef16d73c120c1166$export$94df0e59ebebf4a7 = (url)=>url;
const $ef16d73c120c1166$export$c506eb22e615ba4a = ()=>`viem@${0, $hKDyh.version}`;

});
parcelRegister("hKDyh", function(module, exports) {

$parcel$export(module.exports, "version", () => $cec569be5d3a46c3$export$83d89fbfd8236492);
const $cec569be5d3a46c3$export$83d89fbfd8236492 = '2.12.0';

});




parcelRegister("70Cuf", function(module, exports) {

$parcel$export(module.exports, "size", () => $51a6632806b357a4$export$346677f925de839c);

var $16b1X = parcelRequire("16b1X");
function $51a6632806b357a4$export$346677f925de839c(value) {
    if ((0, $16b1X.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("16b1X", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $0ccee8679df738f8$export$8a9b6341a7c96bc);
function $0ccee8679df738f8$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== 'string') return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
}

});


parcelRegister("4w8tX", function(module, exports) {

$parcel$export(module.exports, "trim", () => $34a0baf4967132be$export$87c2784dc9fc4ab);
function $34a0baf4967132be$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = 'left' } = {}) {
    let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0') sliceLength++;
        else break;
    }
    data = dir === 'left' ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === 'string') {
        if (data.length === 1 && dir === 'right') data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("g9Vcz", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $bc39dbb1c2095790$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $bc39dbb1c2095790$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $bc39dbb1c2095790$export$c8dd6bc66a63753c);

var $8KUaf = parcelRequire("8KUaf");

var $16b1X = parcelRequire("16b1X");

var $gqKpH = parcelRequire("gqKpH");

var $7p6KH = parcelRequire("7p6KH");

var $8bum0 = parcelRequire("8bum0");
const $bc39dbb1c2095790$var$encoder = /*#__PURE__*/ new TextEncoder();
function $bc39dbb1c2095790$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $bc39dbb1c2095790$export$49ad9be85c347998(value, opts);
    if (typeof value === 'boolean') return $bc39dbb1c2095790$export$771517697a68241(value, opts);
    if ((0, $16b1X.isHex)(value)) return $bc39dbb1c2095790$export$31c96b9df38bc8d4(value, opts);
    return $bc39dbb1c2095790$export$c8dd6bc66a63753c(value, opts);
}
function $bc39dbb1c2095790$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === 'number') {
        (0, $7p6KH.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $gqKpH.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $bc39dbb1c2095790$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $bc39dbb1c2095790$var$charCodeToBase16(char) {
    if (char >= $bc39dbb1c2095790$var$charCodeMap.zero && char <= $bc39dbb1c2095790$var$charCodeMap.nine) return char - $bc39dbb1c2095790$var$charCodeMap.zero;
    if (char >= $bc39dbb1c2095790$var$charCodeMap.A && char <= $bc39dbb1c2095790$var$charCodeMap.F) return char - ($bc39dbb1c2095790$var$charCodeMap.A - 10);
    if (char >= $bc39dbb1c2095790$var$charCodeMap.a && char <= $bc39dbb1c2095790$var$charCodeMap.f) return char - ($bc39dbb1c2095790$var$charCodeMap.a - 10);
    return undefined;
}
function $bc39dbb1c2095790$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $7p6KH.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $gqKpH.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $bc39dbb1c2095790$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $bc39dbb1c2095790$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $8KUaf.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $bc39dbb1c2095790$export$49ad9be85c347998(value, opts) {
    const hex = (0, $8bum0.numberToHex)(value, opts);
    return $bc39dbb1c2095790$export$31c96b9df38bc8d4(hex);
}
function $bc39dbb1c2095790$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $bc39dbb1c2095790$var$encoder.encode(value);
    if (typeof opts.size === 'number') {
        (0, $7p6KH.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $gqKpH.pad)(bytes, {
            dir: 'right',
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("gqKpH", function(module, exports) {

$parcel$export(module.exports, "pad", () => $bf6313d373196e2e$export$5d04458e2a6c373e);

var $ahVcY = parcelRequire("ahVcY");
function $bf6313d373196e2e$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === 'string') return $bf6313d373196e2e$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $bf6313d373196e2e$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $bf6313d373196e2e$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace('0x', '');
    if (hex.length > size * 2) throw new (0, $ahVcY.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: 'hex'
    });
    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
}
function $bf6313d373196e2e$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $ahVcY.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: 'bytes'
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === 'right';
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("ahVcY", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $77d7de4e260360fe$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $77d7de4e260360fe$export$70445dc308a7f3d5);

var $8KUaf = parcelRequire("8KUaf");
class $77d7de4e260360fe$export$cfcd41bba8b36dbd extends (0, $8KUaf.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === 'start' ? 'starting' : 'ending'} at offset "${offset}" is out-of-bounds (size: ${size}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SliceOffsetOutOfBoundsError'
        });
    }
}
class $77d7de4e260360fe$export$70445dc308a7f3d5 extends (0, $8KUaf.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SizeExceedsPaddingSizeError'
        });
    }
}
class $77d7de4e260360fe$export$8a5469becf223114 extends (0, $8KUaf.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidBytesLengthError'
        });
    }
}

});


parcelRegister("8bum0", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $5f56e5728da9f78d$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $5f56e5728da9f78d$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "bytesToHex", () => $5f56e5728da9f78d$export$58b867e287a802c8);

var $8mLTQ = parcelRequire("8mLTQ");

var $gqKpH = parcelRequire("gqKpH");

var $7p6KH = parcelRequire("7p6KH");
const $5f56e5728da9f78d$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, '0'));
function $5f56e5728da9f78d$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $5f56e5728da9f78d$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === 'string') return $5f56e5728da9f78d$export$551c48dea6f88e6d(value, opts);
    if (typeof value === 'boolean') return $5f56e5728da9f78d$export$b5c95dec4f62ef7a(value, opts);
    return $5f56e5728da9f78d$export$58b867e287a802c8(value, opts);
}
function $5f56e5728da9f78d$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === 'number') {
        (0, $7p6KH.assertSize)(hex, {
            size: opts.size
        });
        return (0, $gqKpH.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $5f56e5728da9f78d$export$58b867e287a802c8(value, opts = {}) {
    let string = '';
    for(let i = 0; i < value.length; i++)string += $5f56e5728da9f78d$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === 'number') {
        (0, $7p6KH.assertSize)(hex, {
            size: opts.size
        });
        return (0, $gqKpH.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    return hex;
}
function $5f56e5728da9f78d$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === 'number') maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === 'bigint' ? 'n' : '';
        throw new (0, $8mLTQ.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $gqKpH.pad)(hex, {
        size: size
    });
    return hex;
}
const $5f56e5728da9f78d$var$encoder = /*#__PURE__*/ new TextEncoder();
function $5f56e5728da9f78d$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $5f56e5728da9f78d$var$encoder.encode(value_);
    return $5f56e5728da9f78d$export$58b867e287a802c8(value, opts);
}

});



parcelRegister("a2wq0", function(module, exports) {

$parcel$export(module.exports, "parseEther", () => $74f33ceb1fd1c8bc$export$642c4e67bbdc0bc7);

var $lUWuG = parcelRequire("lUWuG");

var $5hXx1 = parcelRequire("5hXx1");
function $74f33ceb1fd1c8bc$export$642c4e67bbdc0bc7(ether, unit = 'wei') {
    return (0, $5hXx1.parseUnits)(ether, (0, $lUWuG.etherUnits)[unit]);
}

});
parcelRegister("5hXx1", function(module, exports) {

$parcel$export(module.exports, "parseUnits", () => $3d9cb8078faa8541$export$203ae30b4f6490b3);
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $3d9cb8078faa8541$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = '0'] = value.split('.');
    const negative = integer.startsWith('-');
    if (negative) integer = integer.slice(1);
    // trim leading zeros.
    fraction = fraction.replace(/(0+)$/, '');
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = '';
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, '0');
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, '0');
    return BigInt(`${negative ? '-' : ''}${integer}${fraction}`);
}

});


parcelRegister("9veww", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("4FOPA")).then(()=>parcelRequire('OjTYK'));

});
parcelRegister("cCFDP", function(module, exports) {
"use strict";

var $4ZsUb = parcelRequire("4ZsUb");
module.exports = $4ZsUb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("4ZsUb", function(module, exports) {
"use strict";
var $3a2347e1983e6cff$var$cachedBundles = {};
var $3a2347e1983e6cff$var$cachedPreloads = {};
var $3a2347e1983e6cff$var$cachedPrefetches = {};
function $3a2347e1983e6cff$var$getCache(type) {
    switch(type){
        case 'preload':
            return $3a2347e1983e6cff$var$cachedPreloads;
        case 'prefetch':
            return $3a2347e1983e6cff$var$cachedPrefetches;
        default:
            return $3a2347e1983e6cff$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3a2347e1983e6cff$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("5nYMs", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("7HPhe")).then(()=>parcelRequire('1C3v6'));

});


parcelRegister("bKBH7", function(module, exports) {

$parcel$export(module.exports, "ProviderRpcErrorCode", () => $02352e5eb85084e7$export$a9b3d16f1898eb51);
var $02352e5eb85084e7$export$a9b3d16f1898eb51;
(function(ProviderRpcErrorCode) {
    ProviderRpcErrorCode[ProviderRpcErrorCode["ACCOUNT_ACCESS_REJECTED"] = 4001] = "ACCOUNT_ACCESS_REJECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["ACCOUNT_ACCESS_ALREADY_REQUESTED"] = -32002] = "ACCOUNT_ACCESS_ALREADY_REQUESTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNAUTHORIZED"] = 4100] = "UNAUTHORIZED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
    ProviderRpcErrorCode[ProviderRpcErrorCode["DISCONNECTED"] = 4900] = "DISCONNECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["CHAIN_DISCONNECTED"] = 4901] = "CHAIN_DISCONNECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["CHAIN_NOT_ADDED"] = 4902] = "CHAIN_NOT_ADDED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["DOES_NOT_EXIST"] = -32601] = "DOES_NOT_EXIST";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNRECOGNIZED_CHAIN_ID"] = -32603] = "UNRECOGNIZED_CHAIN_ID";
})($02352e5eb85084e7$export$a9b3d16f1898eb51 || ($02352e5eb85084e7$export$a9b3d16f1898eb51 = {}));

});

parcelRegister("dkXem", function(module, exports) {

$parcel$export(module.exports, "validate", () => $9b5b1691aa375ef0$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "chainIdValidation", () => $9b5b1691aa375ef0$export$82499834ac435e76);
$parcel$export(module.exports, "chainNamespaceValidation", () => $9b5b1691aa375ef0$export$339f369556873e03);
$parcel$export(module.exports, "chainValidation", () => $9b5b1691aa375ef0$export$392a124a91f4a641);

var $a6eMa = parcelRequire("a6eMa");
function $9b5b1691aa375ef0$export$a22775fa5e2eebd9(validator, data) {
    const result = validator.validate(data);
    return result.error ? result : null;
}
const $9b5b1691aa375ef0$export$82499834ac435e76 = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).alternatives().try((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().pattern(/^0x[0-9a-fA-F]+$/), (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number().positive());
const $9b5b1691aa375ef0$export$339f369556873e03 = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().valid('evm');
const $9b5b1691aa375ef0$var$secondaryTokenValidation = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().optional()
});
const $9b5b1691aa375ef0$export$392a124a91f4a641 = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    namespace: $9b5b1691aa375ef0$export$339f369556873e03,
    id: $9b5b1691aa375ef0$export$82499834ac435e76.required(),
    rpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    token: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    secondaryTokens: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().max(5).items($9b5b1691aa375ef0$var$secondaryTokenValidation).optional(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    publicRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    protectedRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    blockExplorerUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});

});


parcelRegister("dHSHZ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push('');
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var partition = createAggregator(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = partition;

});

parcelRegister("6bixs", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $4802268578a7b8ee$export$8a9b6341a7c96bc);
function $4802268578a7b8ee$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== 'string') return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
}

});

parcelRegister("lOW8k", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $fe2b5c8f8493fee8$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $fe2b5c8f8493fee8$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "stringToHex", () => $fe2b5c8f8493fee8$export$551c48dea6f88e6d);
$parcel$export(module.exports, "boolToHex", () => $fe2b5c8f8493fee8$export$b5c95dec4f62ef7a);
$parcel$export(module.exports, "bytesToHex", () => $fe2b5c8f8493fee8$export$58b867e287a802c8);

var $6q3cA = parcelRequire("6q3cA");

var $7o0DJ = parcelRequire("7o0DJ");

var $b45dE = parcelRequire("b45dE");
const $fe2b5c8f8493fee8$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, '0'));
function $fe2b5c8f8493fee8$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $fe2b5c8f8493fee8$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === 'string') return $fe2b5c8f8493fee8$export$551c48dea6f88e6d(value, opts);
    if (typeof value === 'boolean') return $fe2b5c8f8493fee8$export$b5c95dec4f62ef7a(value, opts);
    return $fe2b5c8f8493fee8$export$58b867e287a802c8(value, opts);
}
function $fe2b5c8f8493fee8$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === 'number') {
        (0, $b45dE.assertSize)(hex, {
            size: opts.size
        });
        return (0, $7o0DJ.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $fe2b5c8f8493fee8$export$58b867e287a802c8(value, opts = {}) {
    let string = '';
    for(let i = 0; i < value.length; i++)string += $fe2b5c8f8493fee8$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === 'number') {
        (0, $b45dE.assertSize)(hex, {
            size: opts.size
        });
        return (0, $7o0DJ.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    return hex;
}
function $fe2b5c8f8493fee8$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === 'number') maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === 'bigint' ? 'n' : '';
        throw new (0, $6q3cA.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $7o0DJ.pad)(hex, {
        size: size
    });
    return hex;
}
const $fe2b5c8f8493fee8$var$encoder = /*#__PURE__*/ new TextEncoder();
function $fe2b5c8f8493fee8$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $fe2b5c8f8493fee8$var$encoder.encode(value_);
    return $fe2b5c8f8493fee8$export$58b867e287a802c8(value, opts);
}

});
parcelRegister("6q3cA", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $4ac7a7a9a92520bb$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidBytesBooleanError", () => $4ac7a7a9a92520bb$export$52fc62e5266c8838);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $4ac7a7a9a92520bb$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $4ac7a7a9a92520bb$export$beb44ed4f8747d0e);

var $6Soy4 = parcelRequire("6Soy4");
class $4ac7a7a9a92520bb$export$47d164a8071229a9 extends (0, $6Soy4.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? 'signed' : 'unsigned'} ` : ''}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'IntegerOutOfRangeError'
        });
    }
}
class $4ac7a7a9a92520bb$export$52fc62e5266c8838 extends (0, $6Soy4.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidBytesBooleanError'
        });
    }
}
class $4ac7a7a9a92520bb$export$f574ac54e35514c extends (0, $6Soy4.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidHexBooleanError'
        });
    }
}
class $4ac7a7a9a92520bb$export$ef05eafd11dd4a83 extends (0, $6Soy4.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidHexValueError'
        });
    }
}
class $4ac7a7a9a92520bb$export$beb44ed4f8747d0e extends (0, $6Soy4.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SizeOverflowError'
        });
    }
}

});
parcelRegister("6Soy4", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $501ad40a70721c67$export$a490eb03cb7a0a5e);

var $dCCuN = parcelRequire("dCCuN");
class $501ad40a70721c67$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        super();
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ViemError'
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $dCCuN.getVersion)()
        });
        const details = args.cause instanceof $501ad40a70721c67$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $501ad40a70721c67$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        this.message = [
            shortMessage || 'An error occurred.',
            '',
            ...args.metaMessages ? [
                ...args.metaMessages,
                ''
            ] : [],
            ...docsPath ? [
                `Docs: https://viem.sh${docsPath}${args.docsSlug ? `#${args.docsSlug}` : ''}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join('\n');
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $501ad40a70721c67$var$walk(this, fn);
    }
}
function $501ad40a70721c67$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === 'object' && 'cause' in err) return $501ad40a70721c67$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("dCCuN", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", () => $9eacaf6aacf575aa$export$b7fbffef12272e40);
$parcel$export(module.exports, "getUrl", () => $9eacaf6aacf575aa$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getVersion", () => $9eacaf6aacf575aa$export$c506eb22e615ba4a);

var $lwgD7 = parcelRequire("lwgD7");
const $9eacaf6aacf575aa$export$b7fbffef12272e40 = (address)=>address;
const $9eacaf6aacf575aa$export$94df0e59ebebf4a7 = (url)=>url;
const $9eacaf6aacf575aa$export$c506eb22e615ba4a = ()=>`viem@${0, $lwgD7.version}`;

});
parcelRegister("lwgD7", function(module, exports) {

$parcel$export(module.exports, "version", () => $faa97c7ead8c8146$export$83d89fbfd8236492);
const $faa97c7ead8c8146$export$83d89fbfd8236492 = '2.12.0';

});




parcelRegister("7o0DJ", function(module, exports) {

$parcel$export(module.exports, "pad", () => $560b455c8d2bb0bd$export$5d04458e2a6c373e);
$parcel$export(module.exports, "padHex", () => $560b455c8d2bb0bd$export$1bcd51c0fce8ee55);

var $7b4Kv = parcelRequire("7b4Kv");
function $560b455c8d2bb0bd$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === 'string') return $560b455c8d2bb0bd$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $560b455c8d2bb0bd$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $560b455c8d2bb0bd$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace('0x', '');
    if (hex.length > size * 2) throw new (0, $7b4Kv.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: 'hex'
    });
    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
}
function $560b455c8d2bb0bd$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $7b4Kv.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: 'bytes'
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === 'right';
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("7b4Kv", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $539d3e8e5a261eea$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $539d3e8e5a261eea$export$70445dc308a7f3d5);
$parcel$export(module.exports, "InvalidBytesLengthError", () => $539d3e8e5a261eea$export$8a5469becf223114);

var $6Soy4 = parcelRequire("6Soy4");
class $539d3e8e5a261eea$export$cfcd41bba8b36dbd extends (0, $6Soy4.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === 'start' ? 'starting' : 'ending'} at offset "${offset}" is out-of-bounds (size: ${size}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SliceOffsetOutOfBoundsError'
        });
    }
}
class $539d3e8e5a261eea$export$70445dc308a7f3d5 extends (0, $6Soy4.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SizeExceedsPaddingSizeError'
        });
    }
}
class $539d3e8e5a261eea$export$8a5469becf223114 extends (0, $6Soy4.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidBytesLengthError'
        });
    }
}

});


parcelRegister("b45dE", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $80e41dd716de8b95$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $80e41dd716de8b95$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $80e41dd716de8b95$export$92a44656ec81b584);

var $6q3cA = parcelRequire("6q3cA");

var $b7p3B = parcelRequire("b7p3B");

var $6OitG = parcelRequire("6OitG");

var $kiZ2S = parcelRequire("kiZ2S");
function $80e41dd716de8b95$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $b7p3B.size)(hexOrBytes) > size) throw new (0, $6q3cA.SizeOverflowError)({
        givenSize: (0, $b7p3B.size)(hexOrBytes),
        maxSize: size
    });
}
function $80e41dd716de8b95$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === 'string' ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === 'number') return $80e41dd716de8b95$export$d57f2bacc26b4249(hex, opts);
    if (to === 'bigint') return $80e41dd716de8b95$export$92a44656ec81b584(hex, opts);
    if (to === 'string') return $80e41dd716de8b95$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === 'boolean') return $80e41dd716de8b95$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $kiZ2S.hexToBytes)(hex, opts);
}
function $80e41dd716de8b95$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $80e41dd716de8b95$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${'f'.padStart(size * 2, 'f')}`) - 1n;
}
function $80e41dd716de8b95$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $80e41dd716de8b95$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $6OitG.trim)(hex);
    }
    if ((0, $6OitG.trim)(hex) === '0x00') return false;
    if ((0, $6OitG.trim)(hex) === '0x01') return true;
    throw new (0, $6q3cA.InvalidHexBooleanError)(hex);
}
function $80e41dd716de8b95$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($80e41dd716de8b95$export$92a44656ec81b584(hex, opts));
}
function $80e41dd716de8b95$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $kiZ2S.hexToBytes)(hex);
    if (opts.size) {
        $80e41dd716de8b95$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $6OitG.trim)(bytes, {
            dir: 'right'
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("b7p3B", function(module, exports) {

$parcel$export(module.exports, "size", () => $8183c8f3676e7ff0$export$346677f925de839c);

var $6bixs = parcelRequire("6bixs");
function $8183c8f3676e7ff0$export$346677f925de839c(value) {
    if ((0, $6bixs.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});

parcelRegister("6OitG", function(module, exports) {

$parcel$export(module.exports, "trim", () => $014793983db83f76$export$87c2784dc9fc4ab);
function $014793983db83f76$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = 'left' } = {}) {
    let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0') sliceLength++;
        else break;
    }
    data = dir === 'left' ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === 'string') {
        if (data.length === 1 && dir === 'right') data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("kiZ2S", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $ec84d77256f79420$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $ec84d77256f79420$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $ec84d77256f79420$export$c8dd6bc66a63753c);

var $6Soy4 = parcelRequire("6Soy4");

var $6bixs = parcelRequire("6bixs");

var $7o0DJ = parcelRequire("7o0DJ");

var $b45dE = parcelRequire("b45dE");

var $lOW8k = parcelRequire("lOW8k");
const $ec84d77256f79420$var$encoder = /*#__PURE__*/ new TextEncoder();
function $ec84d77256f79420$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $ec84d77256f79420$export$49ad9be85c347998(value, opts);
    if (typeof value === 'boolean') return $ec84d77256f79420$export$771517697a68241(value, opts);
    if ((0, $6bixs.isHex)(value)) return $ec84d77256f79420$export$31c96b9df38bc8d4(value, opts);
    return $ec84d77256f79420$export$c8dd6bc66a63753c(value, opts);
}
function $ec84d77256f79420$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === 'number') {
        (0, $b45dE.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $7o0DJ.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $ec84d77256f79420$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $ec84d77256f79420$var$charCodeToBase16(char) {
    if (char >= $ec84d77256f79420$var$charCodeMap.zero && char <= $ec84d77256f79420$var$charCodeMap.nine) return char - $ec84d77256f79420$var$charCodeMap.zero;
    if (char >= $ec84d77256f79420$var$charCodeMap.A && char <= $ec84d77256f79420$var$charCodeMap.F) return char - ($ec84d77256f79420$var$charCodeMap.A - 10);
    if (char >= $ec84d77256f79420$var$charCodeMap.a && char <= $ec84d77256f79420$var$charCodeMap.f) return char - ($ec84d77256f79420$var$charCodeMap.a - 10);
    return undefined;
}
function $ec84d77256f79420$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $b45dE.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $7o0DJ.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $ec84d77256f79420$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $ec84d77256f79420$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $6Soy4.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $ec84d77256f79420$export$49ad9be85c347998(value, opts) {
    const hex = (0, $lOW8k.numberToHex)(value, opts);
    return $ec84d77256f79420$export$31c96b9df38bc8d4(hex);
}
function $ec84d77256f79420$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $ec84d77256f79420$var$encoder.encode(value);
    if (typeof opts.size === 'number') {
        (0, $b45dE.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $7o0DJ.pad)(bytes, {
            dir: 'right',
            size: opts.size
        });
    }
    return bytes;
}

});



parcelRegister("j9N2Z", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("1VClN", function(module, exports) {
'use strict';
var $1678dcee38975512$var$has = Object.prototype.hasOwnProperty, $1678dcee38975512$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $1678dcee38975512$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $1678dcee38975512$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $1678dcee38975512$var$Events().__proto__) $1678dcee38975512$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $1678dcee38975512$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $1678dcee38975512$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $1678dcee38975512$var$EE(fn, context || emitter, once), evt = $1678dcee38975512$var$prefix ? $1678dcee38975512$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $1678dcee38975512$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $1678dcee38975512$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $1678dcee38975512$var$EventEmitter() {
    this._events = new $1678dcee38975512$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($1678dcee38975512$var$has.call(events, name)) names.push($1678dcee38975512$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $1678dcee38975512$var$prefix ? $1678dcee38975512$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $1678dcee38975512$var$prefix ? $1678dcee38975512$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $1678dcee38975512$var$prefix ? $1678dcee38975512$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $1678dcee38975512$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $1678dcee38975512$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $1678dcee38975512$var$prefix ? $1678dcee38975512$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $1678dcee38975512$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $1678dcee38975512$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $1678dcee38975512$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1678dcee38975512$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $1678dcee38975512$var$prefix ? $1678dcee38975512$var$prefix + event : event;
        if (this._events[evt]) $1678dcee38975512$var$clearEvent(this, evt);
    } else {
        this._events = new $1678dcee38975512$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$1678dcee38975512$var$EventEmitter.prototype.off = $1678dcee38975512$var$EventEmitter.prototype.removeListener;
$1678dcee38975512$var$EventEmitter.prototype.addListener = $1678dcee38975512$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$1678dcee38975512$var$EventEmitter.prefixed = $1678dcee38975512$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$1678dcee38975512$var$EventEmitter.EventEmitter = $1678dcee38975512$var$EventEmitter;
module.exports = $1678dcee38975512$var$EventEmitter;

});

parcelRegister("gU9dM", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("cCFDP"))($parcel$resolve("8A0ae")),
    (parcelRequire("cCFDP"))($parcel$resolve("608iJ"))
]).then(()=>parcelRequire('ev7Sz'));

});

parcelRegister("hn1oL", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("bvKMD")).then(()=>parcelRequire('02WKC'));

});

parcelRegister("7R2Xu", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("cCFDP"))($parcel$resolve("8A0ae")),
    (parcelRequire("cCFDP"))($parcel$resolve("jwM8j"))
]).then(()=>parcelRequire('kvCk7'));

});

parcelRegister("4GCYn", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("3Wrzc")).then(()=>parcelRequire('1s4ev'));

});

parcelRegister("5K51q", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("fmb5T")).then(()=>parcelRequire('4d1Ps'));

});


parcelRegister("k5e8S", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    if (value !== value) return baseFindIndex(array, baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push('');
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = uniqBy;

});

parcelRegister("lPkpG", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("izmtx")).then(()=>parcelRequire('hfWOL'));

});

parcelRegister("lY98e", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("cLOfI")).then(()=>parcelRequire('9iEpr'));

});

parcelRegister("cvBEH", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("ja1ke")).then(()=>parcelRequire('jBYBC'));

});

parcelRegister("bjvWi", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("c5AGx")).then(()=>parcelRequire('dMWJM'));

});

parcelRegister("hrSpo", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("189cm")).then(()=>parcelRequire('31Kai'));

});

parcelRegister("iSvEX", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("aCs8E")).then(()=>parcelRequire('ewJQx'));

});

parcelRegister("7qi1p", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("7k8ah")).then(()=>parcelRequire('6z5V7'));

});

parcelRegister("aP3Ob", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("hj1Jx")).then(()=>parcelRequire('likHj'));

});

parcelRegister("iwnJX", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("3LHuW")).then(()=>parcelRequire('ht2mg'));

});

parcelRegister("8R9Ds", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("3X0ht")).then(()=>parcelRequire('lzNru'));

});

parcelRegister("6Y9Ga", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("j68z6")).then(()=>parcelRequire('UQQbA'));

});

parcelRegister("41VeC", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("9IWZP")).then(()=>parcelRequire('1bogq'));

});

parcelRegister("l2MjS", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("1wKOc")).then(()=>parcelRequire('jyz5E'));

});

parcelRegister("hqSqA", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("hewuD")).then(()=>parcelRequire('aruMk'));

});

parcelRegister("6s35B", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("9kqZl")).then(()=>parcelRequire('gCDZL'));

});

parcelRegister("bhVLK", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("l90bq")).then(()=>parcelRequire('1zttb'));

});

parcelRegister("bF8sC", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("bYPZQ")).then(()=>parcelRequire('iinmz'));

});

parcelRegister("8gdKT", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("d9EfO")).then(()=>parcelRequire('j62bA'));

});

parcelRegister("2DY3Q", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("5uNia")).then(()=>parcelRequire('9pSXx'));

});

parcelRegister("amD3h", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("k14R1")).then(()=>parcelRequire('jq4Xf'));

});

parcelRegister("cs7kV", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("4Jjda")).then(()=>parcelRequire('hISQG'));

});

parcelRegister("cWiEz", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("djeOd")).then(()=>parcelRequire('3YhEA'));

});

parcelRegister("oi1V7", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("kERVQ")).then(()=>parcelRequire('03LsN'));

});

parcelRegister("c6wZG", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("57Gvu")).then(()=>parcelRequire('53Uuz'));

});

parcelRegister("5xK4V", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("bQxCY")).then(()=>parcelRequire('eGqYP'));

});

parcelRegister("beeWa", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("1qD4q")).then(()=>parcelRequire('4wGVx'));

});

parcelRegister("6rIji", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("iXy7I")).then(()=>parcelRequire('9BdWD'));

});

parcelRegister("6PZYg", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("jSVXT")).then(()=>parcelRequire('5grdL'));

});

parcelRegister("5Eqey", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("jiTjN")).then(()=>parcelRequire('ldRQM'));

});

parcelRegister("01jVR", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("6QGmu")).then(()=>parcelRequire('hoBu0'));

});

parcelRegister("6g0xv", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("gHcgZ")).then(()=>parcelRequire('91v2L'));

});

parcelRegister("hwLyE", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("e0UQW")).then(()=>parcelRequire('9lTvQ'));

});

parcelRegister("kgGph", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("bWbf8")).then(()=>parcelRequire('1mKil'));

});

parcelRegister("hhcUO", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("bv3Rp")).then(()=>parcelRequire('ipUcL'));

});

parcelRegister("jqOTI", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("iKwOR")).then(()=>parcelRequire('lGUX7'));

});

parcelRegister("8fJGs", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("1PXIB")).then(()=>parcelRequire('50puO'));

});

parcelRegister("9PgGg", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("8kLVB")).then(()=>parcelRequire('l1agI'));

});

parcelRegister("gmReZ", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("169RU")).then(()=>parcelRequire('jmeiF'));

});

parcelRegister("1tnfd", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("enCaa")).then(()=>parcelRequire('8fJPf'));

});

parcelRegister("8dRW4", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("gjV0E")).then(()=>parcelRequire('kf6VE'));

});

parcelRegister("fczkx", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("fvf4k")).then(()=>parcelRequire('9IRUA'));

});

parcelRegister("hiwSd", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("yqlH2")).then(()=>parcelRequire('hitxw'));

});

parcelRegister("2QA47", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("10G6i")).then(()=>parcelRequire('iC1wo'));

});

parcelRegister("f9kxq", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("6J5XV")).then(()=>parcelRequire('5kRae'));

});

parcelRegister("dnOdR", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("j4fQd")).then(()=>parcelRequire('6DF9M'));

});

parcelRegister("d4w4J", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("kYwRe")).then(()=>parcelRequire('96muI'));

});

parcelRegister("br9bz", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("63bzI")).then(()=>parcelRequire('1Ssm8'));

});

parcelRegister("76kYH", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("elJHC")).then(()=>parcelRequire('8NivJ'));

});

parcelRegister("3qOkN", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("12Pfe")).then(()=>parcelRequire('iAwJt'));

});

parcelRegister("fIO9w", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("kwo0I")).then(()=>parcelRequire('jTRg4'));

});

parcelRegister("kpMiz", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("iggay")).then(()=>parcelRequire('2Efrz'));

});

parcelRegister("cgsO6", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("byHVD")).then(()=>parcelRequire('4invS'));

});

parcelRegister("3XZwR", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("1ujMp")).then(()=>parcelRequire('bzDJC'));

});

parcelRegister("bGTTA", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("alFXZ")).then(()=>parcelRequire('gnwIO'));

});

parcelRegister("cXBVA", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("6Xg79")).then(()=>parcelRequire('50Agd'));

});

parcelRegister("jQrvS", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("dteXQ")).then(()=>parcelRequire('h3Nk0'));

});

parcelRegister("1JxDt", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("uUrei")).then(()=>parcelRequire('9ttrU'));

});

parcelRegister("7tRJ6", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("gQf27")).then(()=>parcelRequire('aJkyY'));

});

parcelRegister("4orHX", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("aVmNf")).then(()=>parcelRequire('3kqDn'));

});

parcelRegister("2oNaq", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("4PnPh")).then(()=>parcelRequire('6Q26D'));

});

parcelRegister("e4KMZ", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("cqTjD")).then(()=>parcelRequire('gahTG'));

});

parcelRegister("byoNu", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("bzcv9")).then(()=>parcelRequire('887oD'));

});

parcelRegister("hy1tT", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("oChuu")).then(()=>parcelRequire('3QWdX'));

});

parcelRegister("at7NX", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("jFDyd")).then(()=>parcelRequire('bLCMm'));

});

parcelRegister("lKreI", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("cCFDP"))($parcel$resolve("2kgYl")),
    (parcelRequire("cCFDP"))($parcel$resolve("9B2SW"))
]).then(()=>parcelRequire('ict0o'));

});

parcelRegister("h6ye4", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("1TuEN")).then(()=>parcelRequire('3LYRK'));

});

parcelRegister("78Hhk", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("cCFDP"))($parcel$resolve("9BNdm")),
    (parcelRequire("cCFDP"))($parcel$resolve("cbUSJ"))
]).then(()=>parcelRequire('2UEDw'));

});

parcelRegister("jYbj1", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("cCFDP"))($parcel$resolve("9BNdm")),
    (parcelRequire("cCFDP"))($parcel$resolve("2kgYl")),
    (parcelRequire("cCFDP"))($parcel$resolve("4oDNo"))
]).then(()=>parcelRequire('OhTGQ'));

});

parcelRegister("ewB2v", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("gOG4l")).then(()=>parcelRequire('keUCh'));

});

parcelRegister("iciN3", function(module, exports) {

module.exports = (parcelRequire("cCFDP"))($parcel$resolve("1Fbbl")).then(()=>parcelRequire('6nTnq'));

});

parcelRegister("5Hedk", function(module, exports) {

$parcel$export(module.exports, "formatUnits", () => $425bfe80324ea04b$export$bd39b96f71da1885);
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $425bfe80324ea04b$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith('-');
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, '0');
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, '');
    return `${negative ? '-' : ''}${integer || '0'}${fraction ? `.${fraction}` : ''}`;
}

});

parcelRegister("5jfXj", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $3ddb1a9375171893$export$a490eb03cb7a0a5e);

var $f6QyN = parcelRequire("f6QyN");
let $3ddb1a9375171893$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = '', docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? 'https://viem.sh'}${docsPath}${docsSlug ? `#${docsSlug}` : ''}` : undefined,
    version: `viem@${(0, $f6QyN.version)}`
};
function $3ddb1a9375171893$export$4ac109df0c5244e9(config) {
    $3ddb1a9375171893$var$errorConfig = config;
}
class $3ddb1a9375171893$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $3ddb1a9375171893$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $3ddb1a9375171893$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $3ddb1a9375171893$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || 'An error occurred.',
            '',
            ...args.metaMessages ? [
                ...args.metaMessages,
                ''
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$3ddb1a9375171893$var$errorConfig.version ? [
                `Version: ${$3ddb1a9375171893$var$errorConfig.version}`
            ] : []
        ].join('\n');
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'BaseError'
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $f6QyN.version);
    }
    walk(fn) {
        return $3ddb1a9375171893$var$walk(this, fn);
    }
}
function $3ddb1a9375171893$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === 'object' && 'cause' in err && err.cause !== undefined) return $3ddb1a9375171893$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("f6QyN", function(module, exports) {

$parcel$export(module.exports, "version", () => $b0002fe5f0110699$export$83d89fbfd8236492);
const $b0002fe5f0110699$export$83d89fbfd8236492 = '2.52.2';

});


parcelRegister("l8lWo", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", () => $f62b5d52028fd8a3$export$a558573a20f90d54);
$parcel$export(module.exports, "FeeCapTooHighError", () => $f62b5d52028fd8a3$export$63c545de2a2ec844);
$parcel$export(module.exports, "FeeCapTooLowError", () => $f62b5d52028fd8a3$export$dbd5936ae1758966);
$parcel$export(module.exports, "NonceTooHighError", () => $f62b5d52028fd8a3$export$6147426561fdc965);
$parcel$export(module.exports, "NonceTooLowError", () => $f62b5d52028fd8a3$export$2bb6d6395b589b3b);
$parcel$export(module.exports, "NonceMaxValueError", () => $f62b5d52028fd8a3$export$71cf1d500f9be262);
$parcel$export(module.exports, "InsufficientFundsError", () => $f62b5d52028fd8a3$export$b276096bbba16879);
$parcel$export(module.exports, "IntrinsicGasTooHighError", () => $f62b5d52028fd8a3$export$7ad883b4998b9615);
$parcel$export(module.exports, "IntrinsicGasTooLowError", () => $f62b5d52028fd8a3$export$813ccdcce0428bcf);
$parcel$export(module.exports, "TransactionTypeNotSupportedError", () => $f62b5d52028fd8a3$export$a20c52a8beca5c20);
$parcel$export(module.exports, "TipAboveFeeCapError", () => $f62b5d52028fd8a3$export$6ef9dd5e2f836046);
$parcel$export(module.exports, "UnknownNodeError", () => $f62b5d52028fd8a3$export$d6085363229de344);

var $3vvQ3 = parcelRequire("3vvQ3");

var $5jfXj = parcelRequire("5jfXj");
class $f62b5d52028fd8a3$export$a558573a20f90d54 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace('execution reverted: ', '')?.replace('execution reverted', '');
        super(`Execution reverted ${reason ? `with reason: ${reason}` : 'for an unknown reason'}.`, {
            cause: cause,
            name: 'ExecutionRevertedError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($f62b5d52028fd8a3$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted|gas required exceeds allowance/
});
class $f62b5d52028fd8a3$export$63c545de2a2ec844 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $3vvQ3.formatGwei)(maxFeePerGas)} gwei` : ''}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause,
            name: 'FeeCapTooHighError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $f62b5d52028fd8a3$export$dbd5936ae1758966 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $3vvQ3.formatGwei)(maxFeePerGas)}` : ''} gwei) cannot be lower than the block base fee.`, {
            cause: cause,
            name: 'FeeCapTooLowError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $f62b5d52028fd8a3$export$6147426561fdc965 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}is higher than the next one expected.`, {
            cause: cause,
            name: 'NonceTooHighError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $f62b5d52028fd8a3$export$2bb6d6395b589b3b extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}is lower than the current nonce of the account.`,
            'Try increasing the nonce or find the latest nonce with `getTransactionCount`.'
        ].join('\n'), {
            cause: cause,
            name: 'NonceTooLowError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $f62b5d52028fd8a3$export$71cf1d500f9be262 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}exceeds the maximum allowed nonce.`, {
            cause: cause,
            name: 'NonceMaxValueError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $f62b5d52028fd8a3$export$b276096bbba16879 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            'The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.'
        ].join('\n'), {
            cause: cause,
            metaMessages: [
                'This error could arise when the account does not have enough funds to:',
                ' - pay for the total gas fee,',
                ' - pay for the value to send.',
                ' ',
                'The cost of the transaction is calculated as `gas * gas fee + value`, where:',
                ' - `gas` is the amount of gas needed for transaction to execute,',
                ' - `gas fee` is the gas fee,',
                ' - `value` is the amount of ether to send to the recipient.'
            ],
            name: 'InsufficientFundsError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds|exceeds transaction sender account balance/
});
class $f62b5d52028fd8a3$export$7ad883b4998b9615 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ''}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause,
            name: 'IntrinsicGasTooHighError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $f62b5d52028fd8a3$export$813ccdcce0428bcf extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ''}provided for the transaction is too low.`, {
            cause: cause,
            name: 'IntrinsicGasTooLowError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $f62b5d52028fd8a3$export$a20c52a8beca5c20 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause }){
        super('The transaction type is not supported for this chain.', {
            cause: cause,
            name: 'TransactionTypeNotSupportedError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $f62b5d52028fd8a3$export$6ef9dd5e2f836046 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $3vvQ3.formatGwei)(maxPriorityFeePerGas)} gwei` : ''}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $3vvQ3.formatGwei)(maxFeePerGas)} gwei` : ''}).`
        ].join('\n'), {
            cause: cause,
            name: 'TipAboveFeeCapError'
        });
    }
}
Object.defineProperty($f62b5d52028fd8a3$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $f62b5d52028fd8a3$export$d6085363229de344 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause,
            name: 'UnknownNodeError'
        });
    }
}

});
parcelRegister("3vvQ3", function(module, exports) {

$parcel$export(module.exports, "formatGwei", () => $28dcf6d05ab6c273$export$a716d64a7f646b61);

var $fTKJh = parcelRequire("fTKJh");

var $5Hedk = parcelRequire("5Hedk");
function $28dcf6d05ab6c273$export$a716d64a7f646b61(wei, unit = 'wei') {
    return (0, $5Hedk.formatUnits)(wei, (0, $fTKJh.gweiUnits)[unit]);
}

});
parcelRegister("fTKJh", function(module, exports) {

$parcel$export(module.exports, "etherUnits", () => $b9303d8952bc6587$export$5bbd813111ed9646);
$parcel$export(module.exports, "gweiUnits", () => $b9303d8952bc6587$export$a26120bf8be88528);
const $b9303d8952bc6587$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $b9303d8952bc6587$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $b9303d8952bc6587$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});



parcelRegister("jLSJ6", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", () => $e64cdba6037771dc$export$715ba3385e9f2cf0);
$parcel$export(module.exports, "RpcRequestError", () => $e64cdba6037771dc$export$a823590631c47261);
$parcel$export(module.exports, "TimeoutError", () => $e64cdba6037771dc$export$66d311bf29d5c89c);

var $XRcTc = parcelRequire("XRcTc");

var $5jfXj = parcelRequire("5jfXj");

var $ebsn0 = parcelRequire("ebsn0");
class $e64cdba6037771dc$export$715ba3385e9f2cf0 extends (0, $5jfXj.BaseError) {
    constructor({ body: body, cause: cause, details: details, headers: headers, status: status, url: url }){
        super('HTTP request failed.', {
            cause: cause,
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $ebsn0.getUrl)(url)}`,
                body && `Request body: ${(0, $XRcTc.stringify)(body)}`
            ].filter(Boolean),
            name: 'HttpRequestError'
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $e64cdba6037771dc$export$e1d72a3a26ed1bc extends (0, $5jfXj.BaseError) {
    constructor({ body: body, cause: cause, details: details, url: url }){
        super('WebSocket request failed.', {
            cause: cause,
            details: details,
            metaMessages: [
                `URL: ${(0, $ebsn0.getUrl)(url)}`,
                body && `Request body: ${(0, $XRcTc.stringify)(body)}`
            ].filter(Boolean),
            name: 'WebSocketRequestError'
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.url = url;
    }
}
class $e64cdba6037771dc$export$a823590631c47261 extends (0, $5jfXj.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super('RPC Request failed.', {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $ebsn0.getUrl)(url)}`,
                `Request body: ${(0, $XRcTc.stringify)(body)}`
            ],
            name: 'RpcRequestError'
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
        this.data = error.data;
        this.url = url;
    }
}
class $e64cdba6037771dc$export$a52f6cfb6f69ff4d extends (0, $5jfXj.BaseError) {
    constructor({ url: url } = {}){
        super('The socket has been closed.', {
            metaMessages: [
                url && `URL: ${(0, $ebsn0.getUrl)(url)}`
            ].filter(Boolean),
            name: 'SocketClosedError'
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.url = url;
    }
}
class $e64cdba6037771dc$export$66d311bf29d5c89c extends (0, $5jfXj.BaseError) {
    constructor({ body: body, url: url }){
        super('The request took too long to respond.', {
            details: 'The request timed out.',
            metaMessages: [
                `URL: ${(0, $ebsn0.getUrl)(url)}`,
                `Request body: ${(0, $XRcTc.stringify)(body)}`
            ],
            name: 'TimeoutError'
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.url = url;
    }
}

});
parcelRegister("XRcTc", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $0b3ec89556a581dd$export$fac44ee5b035f737);
const $0b3ec89556a581dd$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === 'bigint' ? value_.toString() : value_;
        return typeof replacer === 'function' ? replacer(key, value) : value;
    }, space);

});

parcelRegister("ebsn0", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", () => $a538197c77b1b1e0$export$b7fbffef12272e40);
$parcel$export(module.exports, "getAbortError", () => $a538197c77b1b1e0$export$89c5315abe9c8ad1);
$parcel$export(module.exports, "isAbortError", () => $a538197c77b1b1e0$export$d2c30ea522b3259e);
$parcel$export(module.exports, "getUrl", () => $a538197c77b1b1e0$export$94df0e59ebebf4a7);
const $a538197c77b1b1e0$export$b7fbffef12272e40 = (address)=>address;
function $a538197c77b1b1e0$export$89c5315abe9c8ad1(signal) {
    if (signal?.reason) return signal.reason;
    if (typeof DOMException === 'function') return new DOMException('This operation was aborted', 'AbortError');
    const error = new Error('This operation was aborted');
    error.name = 'AbortError';
    return error;
}
function $a538197c77b1b1e0$export$d2c30ea522b3259e(error) {
    return typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError';
}
const $a538197c77b1b1e0$export$94df0e59ebebf4a7 = (url)=>{
    try {
        const parsed = new URL(url);
        if (!parsed.username && !parsed.password) return url;
        parsed.username = '';
        parsed.password = '';
        return parsed.toString();
    } catch  {
        return url;
    }
};

});


parcelRegister("atQmZ", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", () => $7a153c59f22bedd4$export$aa31e6432f136746);
$parcel$export(module.exports, "InvalidRequestRpcError", () => $7a153c59f22bedd4$export$ff7b9f15f3eb8d4d);
$parcel$export(module.exports, "MethodNotFoundRpcError", () => $7a153c59f22bedd4$export$4c4044ac99c8d2d3);
$parcel$export(module.exports, "InvalidParamsRpcError", () => $7a153c59f22bedd4$export$c600faffd3cbd390);
$parcel$export(module.exports, "InternalRpcError", () => $7a153c59f22bedd4$export$4e62fafb20e19fd7);
$parcel$export(module.exports, "InvalidInputRpcError", () => $7a153c59f22bedd4$export$3ba2994324ab015e);
$parcel$export(module.exports, "ResourceNotFoundRpcError", () => $7a153c59f22bedd4$export$466772c50c6d6751);
$parcel$export(module.exports, "ResourceUnavailableRpcError", () => $7a153c59f22bedd4$export$270451347568a637);
$parcel$export(module.exports, "TransactionRejectedRpcError", () => $7a153c59f22bedd4$export$f714565c9176e28);
$parcel$export(module.exports, "MethodNotSupportedRpcError", () => $7a153c59f22bedd4$export$b106fe05a02d89c5);
$parcel$export(module.exports, "LimitExceededRpcError", () => $7a153c59f22bedd4$export$2c6f5ab73129d9d7);
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", () => $7a153c59f22bedd4$export$662f3764fa426a13);
$parcel$export(module.exports, "UserRejectedRequestError", () => $7a153c59f22bedd4$export$4af5b080d9e9e1a6);
$parcel$export(module.exports, "UnauthorizedProviderError", () => $7a153c59f22bedd4$export$cc1057a5779c7ffa);
$parcel$export(module.exports, "UnsupportedProviderMethodError", () => $7a153c59f22bedd4$export$6a557500ae315a49);
$parcel$export(module.exports, "ProviderDisconnectedError", () => $7a153c59f22bedd4$export$abb104bf1dd9c38b);
$parcel$export(module.exports, "ChainDisconnectedError", () => $7a153c59f22bedd4$export$ef186cf1cda0444);
$parcel$export(module.exports, "SwitchChainError", () => $7a153c59f22bedd4$export$d4ddb31968a9d366);
$parcel$export(module.exports, "UnsupportedNonOptionalCapabilityError", () => $7a153c59f22bedd4$export$2e2034789e203e09);
$parcel$export(module.exports, "UnsupportedChainIdError", () => $7a153c59f22bedd4$export$fc97cac2ba066ec7);
$parcel$export(module.exports, "DuplicateIdError", () => $7a153c59f22bedd4$export$5037bf500375aebd);
$parcel$export(module.exports, "UnknownBundleIdError", () => $7a153c59f22bedd4$export$dafa4532fa5beea2);
$parcel$export(module.exports, "BundleTooLargeError", () => $7a153c59f22bedd4$export$9e5f099cd963515a);
$parcel$export(module.exports, "AtomicReadyWalletRejectedUpgradeError", () => $7a153c59f22bedd4$export$ec7a64b1ed968f39);
$parcel$export(module.exports, "AtomicityNotSupportedError", () => $7a153c59f22bedd4$export$7aa24bfbf721a0aa);
$parcel$export(module.exports, "WalletConnectSessionSettlementError", () => $7a153c59f22bedd4$export$a139ad100f44a12a);
$parcel$export(module.exports, "UnknownRpcError", () => $7a153c59f22bedd4$export$bfc830e1ec76e31b);

var $5jfXj = parcelRequire("5jfXj");

var $jLSJ6 = parcelRequire("jLSJ6");
const $7a153c59f22bedd4$var$unknownErrorCode = -1;
class $7a153c59f22bedd4$export$5460eff990f31920 extends (0, $5jfXj.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, name: name, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages,
            name: name || 'RpcError'
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name || cause.name;
        this.code = cause instanceof (0, $jLSJ6.RpcRequestError) ? cause.code : code ?? $7a153c59f22bedd4$var$unknownErrorCode;
    }
}
class $7a153c59f22bedd4$export$417589b978208a8f extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $7a153c59f22bedd4$export$aa31e6432f136746 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$aa31e6432f136746.code,
            name: 'ParseRpcError',
            shortMessage: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $7a153c59f22bedd4$export$ff7b9f15f3eb8d4d extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$ff7b9f15f3eb8d4d.code,
            name: 'InvalidRequestRpcError',
            shortMessage: 'JSON is not a valid request object.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $7a153c59f22bedd4$export$4c4044ac99c8d2d3 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $7a153c59f22bedd4$export$4c4044ac99c8d2d3.code,
            name: 'MethodNotFoundRpcError',
            shortMessage: `The method${method ? ` "${method}"` : ''} does not exist / is not available.`
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $7a153c59f22bedd4$export$c600faffd3cbd390 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$c600faffd3cbd390.code,
            name: 'InvalidParamsRpcError',
            shortMessage: [
                'Invalid parameters were provided to the RPC method.',
                'Double check you have provided the correct parameters.'
            ].join('\n')
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $7a153c59f22bedd4$export$4e62fafb20e19fd7 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$4e62fafb20e19fd7.code,
            name: 'InternalRpcError',
            shortMessage: 'An internal error was received.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $7a153c59f22bedd4$export$3ba2994324ab015e extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$3ba2994324ab015e.code,
            name: 'InvalidInputRpcError',
            shortMessage: [
                'Missing or invalid parameters.',
                'Double check you have provided the correct parameters.'
            ].join('\n')
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $7a153c59f22bedd4$export$466772c50c6d6751 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$466772c50c6d6751.code,
            name: 'ResourceNotFoundRpcError',
            shortMessage: 'Requested resource not found.'
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ResourceNotFoundRpcError'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $7a153c59f22bedd4$export$270451347568a637 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$270451347568a637.code,
            name: 'ResourceUnavailableRpcError',
            shortMessage: 'Requested resource not available.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $7a153c59f22bedd4$export$f714565c9176e28 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$f714565c9176e28.code,
            name: 'TransactionRejectedRpcError',
            shortMessage: 'Transaction creation failed.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $7a153c59f22bedd4$export$b106fe05a02d89c5 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $7a153c59f22bedd4$export$b106fe05a02d89c5.code,
            name: 'MethodNotSupportedRpcError',
            shortMessage: `Method${method ? ` "${method}"` : ''} is not supported.`
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $7a153c59f22bedd4$export$2c6f5ab73129d9d7 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$2c6f5ab73129d9d7.code,
            name: 'LimitExceededRpcError',
            shortMessage: 'Request exceeds defined limit.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $7a153c59f22bedd4$export$662f3764fa426a13 extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$662f3764fa426a13.code,
            name: 'JsonRpcVersionUnsupportedError',
            shortMessage: 'Version of JSON-RPC protocol is not supported.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $7a153c59f22bedd4$export$4af5b080d9e9e1a6 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$4af5b080d9e9e1a6.code,
            name: 'UserRejectedRequestError',
            shortMessage: 'User rejected the request.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $7a153c59f22bedd4$export$cc1057a5779c7ffa extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$cc1057a5779c7ffa.code,
            name: 'UnauthorizedProviderError',
            shortMessage: 'The requested method and/or account has not been authorized by the user.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $7a153c59f22bedd4$export$6a557500ae315a49 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $7a153c59f22bedd4$export$6a557500ae315a49.code,
            name: 'UnsupportedProviderMethodError',
            shortMessage: `The Provider does not support the requested method${method ? ` " ${method}"` : ''}.`
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $7a153c59f22bedd4$export$abb104bf1dd9c38b extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$abb104bf1dd9c38b.code,
            name: 'ProviderDisconnectedError',
            shortMessage: 'The Provider is disconnected from all chains.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $7a153c59f22bedd4$export$ef186cf1cda0444 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$ef186cf1cda0444.code,
            name: 'ChainDisconnectedError',
            shortMessage: 'The Provider is not connected to the requested chain.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $7a153c59f22bedd4$export$d4ddb31968a9d366 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$d4ddb31968a9d366.code,
            name: 'SwitchChainError',
            shortMessage: 'An error occurred when attempting to switch chain.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $7a153c59f22bedd4$export$2e2034789e203e09 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$2e2034789e203e09.code,
            name: 'UnsupportedNonOptionalCapabilityError',
            shortMessage: 'This Wallet does not support a capability that was not marked as optional.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$2e2034789e203e09, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5700
});
class $7a153c59f22bedd4$export$fc97cac2ba066ec7 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$fc97cac2ba066ec7.code,
            name: 'UnsupportedChainIdError',
            shortMessage: 'This Wallet does not support the requested chain ID.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$fc97cac2ba066ec7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5710
});
class $7a153c59f22bedd4$export$5037bf500375aebd extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$5037bf500375aebd.code,
            name: 'DuplicateIdError',
            shortMessage: 'There is already a bundle submitted with this ID.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$5037bf500375aebd, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5720
});
class $7a153c59f22bedd4$export$dafa4532fa5beea2 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$dafa4532fa5beea2.code,
            name: 'UnknownBundleIdError',
            shortMessage: 'This bundle id is unknown / has not been submitted'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$dafa4532fa5beea2, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5730
});
class $7a153c59f22bedd4$export$9e5f099cd963515a extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$9e5f099cd963515a.code,
            name: 'BundleTooLargeError',
            shortMessage: 'The call bundle is too large for the Wallet to process.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$9e5f099cd963515a, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5740
});
class $7a153c59f22bedd4$export$ec7a64b1ed968f39 extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$ec7a64b1ed968f39.code,
            name: 'AtomicReadyWalletRejectedUpgradeError',
            shortMessage: 'The Wallet can support atomicity after an upgrade, but the user rejected the upgrade.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$ec7a64b1ed968f39, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5750
});
class $7a153c59f22bedd4$export$7aa24bfbf721a0aa extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$7aa24bfbf721a0aa.code,
            name: 'AtomicityNotSupportedError',
            shortMessage: 'The wallet does not support atomic execution but the request requires it.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$7aa24bfbf721a0aa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5760
});
class $7a153c59f22bedd4$export$a139ad100f44a12a extends $7a153c59f22bedd4$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $7a153c59f22bedd4$export$a139ad100f44a12a.code,
            name: 'WalletConnectSessionSettlementError',
            shortMessage: 'WalletConnect session settlement failed.'
        });
    }
}
Object.defineProperty($7a153c59f22bedd4$export$a139ad100f44a12a, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 7000
});
class $7a153c59f22bedd4$export$bfc830e1ec76e31b extends $7a153c59f22bedd4$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            name: 'UnknownRpcError',
            shortMessage: 'An unknown RPC error occurred.'
        });
    }
}

});

parcelRegister("2u1VO", function(module, exports) {

$parcel$export(module.exports, "size", () => $1cefe1a2c48112e9$export$346677f925de839c);

var $dem4j = parcelRequire("dem4j");
function $1cefe1a2c48112e9$export$346677f925de839c(value) {
    if ((0, $dem4j.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("dem4j", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $9a1db38a53216b38$export$8a9b6341a7c96bc);
function $9a1db38a53216b38$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== 'string') return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
}

});


parcelRegister("cD3gI", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $931ba9a5786b5623$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $931ba9a5786b5623$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "stringToHex", () => $931ba9a5786b5623$export$551c48dea6f88e6d);
$parcel$export(module.exports, "boolToHex", () => $931ba9a5786b5623$export$b5c95dec4f62ef7a);
$parcel$export(module.exports, "bytesToHex", () => $931ba9a5786b5623$export$58b867e287a802c8);

var $9Ckzf = parcelRequire("9Ckzf");

var $gbm88 = parcelRequire("gbm88");

var $lz1vU = parcelRequire("lz1vU");
const $931ba9a5786b5623$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, '0'));
function $931ba9a5786b5623$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $931ba9a5786b5623$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === 'string') return $931ba9a5786b5623$export$551c48dea6f88e6d(value, opts);
    if (typeof value === 'boolean') return $931ba9a5786b5623$export$b5c95dec4f62ef7a(value, opts);
    return $931ba9a5786b5623$export$58b867e287a802c8(value, opts);
}
function $931ba9a5786b5623$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === 'number') {
        (0, $lz1vU.assertSize)(hex, {
            size: opts.size
        });
        return (0, $gbm88.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $931ba9a5786b5623$export$58b867e287a802c8(value, opts = {}) {
    let string = '';
    for(let i = 0; i < value.length; i++)string += $931ba9a5786b5623$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === 'number') {
        (0, $lz1vU.assertSize)(hex, {
            size: opts.size
        });
        return (0, $gbm88.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    return hex;
}
function $931ba9a5786b5623$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === 'number') maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === 'bigint' ? 'n' : '';
        throw new (0, $9Ckzf.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $gbm88.pad)(hex, {
        size: size
    });
    return hex;
}
const $931ba9a5786b5623$var$encoder = /*#__PURE__*/ new TextEncoder();
function $931ba9a5786b5623$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $931ba9a5786b5623$var$encoder.encode(value_);
    return $931ba9a5786b5623$export$58b867e287a802c8(value, opts);
}

});
parcelRegister("9Ckzf", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $70079df0fea5e549$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidBytesBooleanError", () => $70079df0fea5e549$export$52fc62e5266c8838);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $70079df0fea5e549$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $70079df0fea5e549$export$beb44ed4f8747d0e);

var $5jfXj = parcelRequire("5jfXj");
class $70079df0fea5e549$export$47d164a8071229a9 extends (0, $5jfXj.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? 'signed' : 'unsigned'} ` : ''}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: 'IntegerOutOfRangeError'
        });
    }
}
class $70079df0fea5e549$export$52fc62e5266c8838 extends (0, $5jfXj.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: 'InvalidBytesBooleanError'
        });
    }
}
class $70079df0fea5e549$export$f574ac54e35514c extends (0, $5jfXj.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: 'InvalidHexBooleanError'
        });
    }
}
class $70079df0fea5e549$export$ef05eafd11dd4a83 extends (0, $5jfXj.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: 'InvalidHexValueError'
        });
    }
}
class $70079df0fea5e549$export$beb44ed4f8747d0e extends (0, $5jfXj.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: 'SizeOverflowError'
        });
    }
}

});

parcelRegister("gbm88", function(module, exports) {

$parcel$export(module.exports, "pad", () => $bc7ed7035b1de76c$export$5d04458e2a6c373e);
$parcel$export(module.exports, "padHex", () => $bc7ed7035b1de76c$export$1bcd51c0fce8ee55);

var $crrQA = parcelRequire("crrQA");
function $bc7ed7035b1de76c$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === 'string') return $bc7ed7035b1de76c$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $bc7ed7035b1de76c$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $bc7ed7035b1de76c$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace('0x', '');
    if (hex.length > size * 2) throw new (0, $crrQA.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: 'hex'
    });
    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
}
function $bc7ed7035b1de76c$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $crrQA.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: 'bytes'
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === 'right';
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("crrQA", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $90ed9b839f33bcb8$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $90ed9b839f33bcb8$export$70445dc308a7f3d5);
$parcel$export(module.exports, "InvalidBytesLengthError", () => $90ed9b839f33bcb8$export$8a5469becf223114);

var $5jfXj = parcelRequire("5jfXj");
class $90ed9b839f33bcb8$export$cfcd41bba8b36dbd extends (0, $5jfXj.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === 'start' ? 'starting' : 'ending'} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: 'SliceOffsetOutOfBoundsError'
        });
    }
}
class $90ed9b839f33bcb8$export$70445dc308a7f3d5 extends (0, $5jfXj.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: 'SizeExceedsPaddingSizeError'
        });
    }
}
class $90ed9b839f33bcb8$export$8a5469becf223114 extends (0, $5jfXj.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: 'InvalidBytesLengthError'
        });
    }
}

});


parcelRegister("lz1vU", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $fb2e0a70dd818158$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $fb2e0a70dd818158$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $fb2e0a70dd818158$export$92a44656ec81b584);

var $9Ckzf = parcelRequire("9Ckzf");

var $2u1VO = parcelRequire("2u1VO");

var $2ThTG = parcelRequire("2ThTG");

var $kc9Jh = parcelRequire("kc9Jh");
function $fb2e0a70dd818158$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $2u1VO.size)(hexOrBytes) > size) throw new (0, $9Ckzf.SizeOverflowError)({
        givenSize: (0, $2u1VO.size)(hexOrBytes),
        maxSize: size
    });
}
function $fb2e0a70dd818158$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === 'string' ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === 'number') return $fb2e0a70dd818158$export$d57f2bacc26b4249(hex, opts);
    if (to === 'bigint') return $fb2e0a70dd818158$export$92a44656ec81b584(hex, opts);
    if (to === 'string') return $fb2e0a70dd818158$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === 'boolean') return $fb2e0a70dd818158$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $kc9Jh.hexToBytes)(hex, opts);
}
function $fb2e0a70dd818158$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $fb2e0a70dd818158$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${'f'.padStart(size * 2, 'f')}`) - 1n;
}
function $fb2e0a70dd818158$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $fb2e0a70dd818158$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $2ThTG.trim)(hex);
    }
    if ((0, $2ThTG.trim)(hex) === '0x00') return false;
    if ((0, $2ThTG.trim)(hex) === '0x01') return true;
    throw new (0, $9Ckzf.InvalidHexBooleanError)(hex);
}
function $fb2e0a70dd818158$export$d57f2bacc26b4249(hex, opts = {}) {
    const value = $fb2e0a70dd818158$export$92a44656ec81b584(hex, opts);
    const number = Number(value);
    if (!Number.isSafeInteger(number)) throw new (0, $9Ckzf.IntegerOutOfRangeError)({
        max: `${Number.MAX_SAFE_INTEGER}`,
        min: `${Number.MIN_SAFE_INTEGER}`,
        signed: opts.signed,
        size: opts.size,
        value: `${value}n`
    });
    return number;
}
function $fb2e0a70dd818158$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $kc9Jh.hexToBytes)(hex);
    if (opts.size) {
        $fb2e0a70dd818158$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $2ThTG.trim)(bytes, {
            dir: 'right'
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("2ThTG", function(module, exports) {

$parcel$export(module.exports, "trim", () => $21ae99d6fa426651$export$87c2784dc9fc4ab);
function $21ae99d6fa426651$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = 'left' } = {}) {
    let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0') sliceLength++;
        else break;
    }
    data = dir === 'left' ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === 'string') {
        if (data.length === 1 && dir === 'right') data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("kc9Jh", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $eb3c79a88f3ce605$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $eb3c79a88f3ce605$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $eb3c79a88f3ce605$export$c8dd6bc66a63753c);

var $5jfXj = parcelRequire("5jfXj");

var $dem4j = parcelRequire("dem4j");

var $gbm88 = parcelRequire("gbm88");

var $lz1vU = parcelRequire("lz1vU");

var $cD3gI = parcelRequire("cD3gI");
const $eb3c79a88f3ce605$var$encoder = /*#__PURE__*/ new TextEncoder();
function $eb3c79a88f3ce605$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $eb3c79a88f3ce605$export$49ad9be85c347998(value, opts);
    if (typeof value === 'boolean') return $eb3c79a88f3ce605$export$771517697a68241(value, opts);
    if ((0, $dem4j.isHex)(value)) return $eb3c79a88f3ce605$export$31c96b9df38bc8d4(value, opts);
    return $eb3c79a88f3ce605$export$c8dd6bc66a63753c(value, opts);
}
function $eb3c79a88f3ce605$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === 'number') {
        (0, $lz1vU.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $gbm88.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $eb3c79a88f3ce605$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $eb3c79a88f3ce605$var$charCodeToBase16(char) {
    if (char >= $eb3c79a88f3ce605$var$charCodeMap.zero && char <= $eb3c79a88f3ce605$var$charCodeMap.nine) return char - $eb3c79a88f3ce605$var$charCodeMap.zero;
    if (char >= $eb3c79a88f3ce605$var$charCodeMap.A && char <= $eb3c79a88f3ce605$var$charCodeMap.F) return char - ($eb3c79a88f3ce605$var$charCodeMap.A - 10);
    if (char >= $eb3c79a88f3ce605$var$charCodeMap.a && char <= $eb3c79a88f3ce605$var$charCodeMap.f) return char - ($eb3c79a88f3ce605$var$charCodeMap.a - 10);
    return undefined;
}
function $eb3c79a88f3ce605$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $lz1vU.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $gbm88.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $eb3c79a88f3ce605$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $eb3c79a88f3ce605$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $5jfXj.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $eb3c79a88f3ce605$export$49ad9be85c347998(value, opts) {
    const hex = (0, $cD3gI.numberToHex)(value, opts);
    return $eb3c79a88f3ce605$export$31c96b9df38bc8d4(hex);
}
function $eb3c79a88f3ce605$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $eb3c79a88f3ce605$var$encoder.encode(value);
    if (typeof opts.size === 'number') {
        (0, $lz1vU.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $gbm88.pad)(bytes, {
            dir: 'right',
            size: opts.size
        });
    }
    return bytes;
}

});



parcelRegister("1YOOf", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $1712cebc62526b7d$export$f8151fce47ad1c35);

var $5rp32 = parcelRequire("5rp32");

var $dem4j = parcelRequire("dem4j");

var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");
function $1712cebc62526b7d$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || 'hex';
    const bytes = (0, $5rp32.keccak_256)((0, $dem4j.isHex)(value, {
        strict: false
    }) ? (0, $kc9Jh.toBytes)(value) : value);
    if (to === 'bytes') return bytes;
    return (0, $cD3gI.toHex)(bytes);
}

});
parcelRegister("5rp32", function(module, exports) {

$parcel$export(module.exports, "keccak_256", () => $3f62e75c22f53777$export$860ddaa9ca84a66d);
/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ 
var $dz2u8 = parcelRequire("dz2u8");

var $hPdhr = parcelRequire("hPdhr");
// No __PURE__ annotations in sha3 header:
// EVERYTHING is in fact used on every export.
// Various per round constants calculations
const $3f62e75c22f53777$var$_0n = BigInt(0);
const $3f62e75c22f53777$var$_1n = BigInt(1);
const $3f62e75c22f53777$var$_2n = BigInt(2);
const $3f62e75c22f53777$var$_7n = BigInt(7);
const $3f62e75c22f53777$var$_256n = BigInt(256);
const $3f62e75c22f53777$var$_0x71n = BigInt(0x71);
const $3f62e75c22f53777$var$SHA3_PI = [];
const $3f62e75c22f53777$var$SHA3_ROTL = [];
const $3f62e75c22f53777$var$_SHA3_IOTA = [];
for(let round = 0, R = $3f62e75c22f53777$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $3f62e75c22f53777$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $3f62e75c22f53777$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $3f62e75c22f53777$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $3f62e75c22f53777$var$_1n ^ (R >> $3f62e75c22f53777$var$_7n) * $3f62e75c22f53777$var$_0x71n) % $3f62e75c22f53777$var$_256n;
        if (R & $3f62e75c22f53777$var$_2n) t ^= $3f62e75c22f53777$var$_1n << ($3f62e75c22f53777$var$_1n << /* @__PURE__ */ BigInt(j)) - $3f62e75c22f53777$var$_1n;
    }
    $3f62e75c22f53777$var$_SHA3_IOTA.push(t);
}
const $3f62e75c22f53777$var$IOTAS = (0, $dz2u8.split)($3f62e75c22f53777$var$_SHA3_IOTA, true);
const $3f62e75c22f53777$var$SHA3_IOTA_H = $3f62e75c22f53777$var$IOTAS[0];
const $3f62e75c22f53777$var$SHA3_IOTA_L = $3f62e75c22f53777$var$IOTAS[1];
// Left rotation (without 0, 32, 64)
const $3f62e75c22f53777$var$rotlH = (h, l, s)=>s > 32 ? (0, $dz2u8.rotlBH)(h, l, s) : (0, $dz2u8.rotlSH)(h, l, s);
const $3f62e75c22f53777$var$rotlL = (h, l, s)=>s > 32 ? (0, $dz2u8.rotlBL)(h, l, s) : (0, $dz2u8.rotlSL)(h, l, s);
function $3f62e75c22f53777$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $3f62e75c22f53777$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $3f62e75c22f53777$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $3f62e75c22f53777$var$SHA3_ROTL[t];
            const Th = $3f62e75c22f53777$var$rotlH(curH, curL, shift);
            const Tl = $3f62e75c22f53777$var$rotlL(curH, curL, shift);
            const PI = $3f62e75c22f53777$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $3f62e75c22f53777$var$SHA3_IOTA_H[round];
        s[1] ^= $3f62e75c22f53777$var$SHA3_IOTA_L[round];
    }
    (0, $hPdhr.clean)(B);
}
class $3f62e75c22f53777$export$f7374b8b4498bc2e extends (0, $hPdhr.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        this.enableXOF = false;
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        // Can be passed from user as dkLen
        (0, $hPdhr.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (!(0 < blockLen && blockLen < 200)) throw new Error('only keccak-f1600 function is supported');
        this.state = new Uint8Array(200);
        this.state32 = (0, $hPdhr.u32)(this.state);
    }
    clone() {
        return this._cloneInto();
    }
    keccak() {
        (0, $hPdhr.swap32IfBE)(this.state32);
        $3f62e75c22f53777$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        (0, $hPdhr.swap32IfBE)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $hPdhr.aexists)(this);
        data = (0, $hPdhr.toBytes)(data);
        (0, $hPdhr.abytes)(data);
        const { blockLen: blockLen, state: state } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $hPdhr.aexists)(this, false);
        (0, $hPdhr.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $hPdhr.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $hPdhr.aoutput)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        (0, $hPdhr.clean)(this.state);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $3f62e75c22f53777$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $3f62e75c22f53777$var$gen = (suffix, blockLen, outputLen)=>(0, $hPdhr.createHasher)(()=>new $3f62e75c22f53777$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $3f62e75c22f53777$export$fe6c2b96a79338e9 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x06, 144, 28))();
const $3f62e75c22f53777$export$76e19b6966813b14 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x06, 136, 32))();
const $3f62e75c22f53777$export$a58509fa80f30d15 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x06, 104, 48))();
const $3f62e75c22f53777$export$20ed324dbdf09b7c = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x06, 72, 64))();
const $3f62e75c22f53777$export$2f7fb3c6fac246bc = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x01, 144, 28))();
const $3f62e75c22f53777$export$860ddaa9ca84a66d = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x01, 136, 32))();
const $3f62e75c22f53777$export$46fcdeb4c5686552 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x01, 104, 48))();
const $3f62e75c22f53777$export$aec1ddaf6c1ba495 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$gen(0x01, 72, 64))();
const $3f62e75c22f53777$var$genShake = (suffix, blockLen, outputLen)=>(0, $hPdhr.createXOFer)((opts = {})=>new $3f62e75c22f53777$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $3f62e75c22f53777$export$f43dc3bb86efbba2 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$genShake(0x1f, 168, 16))();
const $3f62e75c22f53777$export$c240d011f1520440 = /* @__PURE__ */ (()=>$3f62e75c22f53777$var$genShake(0x1f, 136, 32))();

});
parcelRegister("dz2u8", function(module, exports) {

$parcel$export(module.exports, "split", () => $9e0078b472854cf4$export$65980d18b75784e2);
$parcel$export(module.exports, "shrSH", () => $9e0078b472854cf4$export$75aa78dc5bd52853);
$parcel$export(module.exports, "shrSL", () => $9e0078b472854cf4$export$a0225ff0aee14e25);
$parcel$export(module.exports, "rotrSH", () => $9e0078b472854cf4$export$97f812dfd830ca87);
$parcel$export(module.exports, "rotrSL", () => $9e0078b472854cf4$export$60987e30e2c9d9d);
$parcel$export(module.exports, "rotrBH", () => $9e0078b472854cf4$export$af9c7fbac44dcb76);
$parcel$export(module.exports, "rotrBL", () => $9e0078b472854cf4$export$f619171d6d5ac414);
$parcel$export(module.exports, "rotlSH", () => $9e0078b472854cf4$export$4b80a2917447870e);
$parcel$export(module.exports, "rotlSL", () => $9e0078b472854cf4$export$20652918a7b63b3);
$parcel$export(module.exports, "rotlBH", () => $9e0078b472854cf4$export$a52f14bf902f9977);
$parcel$export(module.exports, "rotlBL", () => $9e0078b472854cf4$export$5d12cc1da441323f);
$parcel$export(module.exports, "add", () => $9e0078b472854cf4$export$e16d8520af44a096);
$parcel$export(module.exports, "add3L", () => $9e0078b472854cf4$export$c0c22b91f08911f);
$parcel$export(module.exports, "add3H", () => $9e0078b472854cf4$export$ef7b26044977a8ec);
$parcel$export(module.exports, "add4L", () => $9e0078b472854cf4$export$2f4e199c560f545d);
$parcel$export(module.exports, "add4H", () => $9e0078b472854cf4$export$e909220d675a7741);
$parcel$export(module.exports, "add5L", () => $9e0078b472854cf4$export$d732b061fe9c9ae4);
$parcel$export(module.exports, "add5H", () => $9e0078b472854cf4$export$b45ee8d78c965098);
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $9e0078b472854cf4$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $9e0078b472854cf4$var$_32n = /* @__PURE__ */ BigInt(32);
function $9e0078b472854cf4$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $9e0078b472854cf4$var$U32_MASK64),
        l: Number(n >> $9e0078b472854cf4$var$_32n & $9e0078b472854cf4$var$U32_MASK64)
    };
    return {
        h: Number(n >> $9e0078b472854cf4$var$_32n & $9e0078b472854cf4$var$U32_MASK64) | 0,
        l: Number(n & $9e0078b472854cf4$var$U32_MASK64) | 0
    };
}
function $9e0078b472854cf4$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $9e0078b472854cf4$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $9e0078b472854cf4$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $9e0078b472854cf4$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $9e0078b472854cf4$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $9e0078b472854cf4$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $9e0078b472854cf4$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $9e0078b472854cf4$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9e0078b472854cf4$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $9e0078b472854cf4$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $9e0078b472854cf4$export$a088d44bd387d2a3 = (_h, l)=>l;
const $9e0078b472854cf4$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $9e0078b472854cf4$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $9e0078b472854cf4$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9e0078b472854cf4$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $9e0078b472854cf4$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $9e0078b472854cf4$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $9e0078b472854cf4$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $9e0078b472854cf4$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $9e0078b472854cf4$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $9e0078b472854cf4$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $9e0078b472854cf4$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $9e0078b472854cf4$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $9e0078b472854cf4$var$u64 = {
    fromBig: $9e0078b472854cf4$export$9625d4333cb56c3f,
    split: $9e0078b472854cf4$export$65980d18b75784e2,
    toBig: $9e0078b472854cf4$export$30f78adcaaa2eb7,
    shrSH: $9e0078b472854cf4$export$75aa78dc5bd52853,
    shrSL: $9e0078b472854cf4$export$a0225ff0aee14e25,
    rotrSH: $9e0078b472854cf4$export$97f812dfd830ca87,
    rotrSL: $9e0078b472854cf4$export$60987e30e2c9d9d,
    rotrBH: $9e0078b472854cf4$export$af9c7fbac44dcb76,
    rotrBL: $9e0078b472854cf4$export$f619171d6d5ac414,
    rotr32H: $9e0078b472854cf4$export$a088d44bd387d2a3,
    rotr32L: $9e0078b472854cf4$export$8415aae4d1f69577,
    rotlSH: $9e0078b472854cf4$export$4b80a2917447870e,
    rotlSL: $9e0078b472854cf4$export$20652918a7b63b3,
    rotlBH: $9e0078b472854cf4$export$a52f14bf902f9977,
    rotlBL: $9e0078b472854cf4$export$5d12cc1da441323f,
    add: $9e0078b472854cf4$export$e16d8520af44a096,
    add3L: $9e0078b472854cf4$export$c0c22b91f08911f,
    add3H: $9e0078b472854cf4$export$ef7b26044977a8ec,
    add4L: $9e0078b472854cf4$export$2f4e199c560f545d,
    add4H: $9e0078b472854cf4$export$e909220d675a7741,
    add5H: $9e0078b472854cf4$export$b45ee8d78c965098,
    add5L: $9e0078b472854cf4$export$d732b061fe9c9ae4
};
var $9e0078b472854cf4$export$2e2bcd8739ae039 = $9e0078b472854cf4$var$u64;

});

parcelRegister("hPdhr", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $cfa1804db9217baf$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "anumber", () => $cfa1804db9217baf$export$75364c6cb16d43b6);
$parcel$export(module.exports, "abytes", () => $cfa1804db9217baf$export$e8a750b9efad93f5);
$parcel$export(module.exports, "ahash", () => $cfa1804db9217baf$export$3ff5a4f04de7e52e);
$parcel$export(module.exports, "aexists", () => $cfa1804db9217baf$export$20871f6b1d047d77);
$parcel$export(module.exports, "aoutput", () => $cfa1804db9217baf$export$e8e53abee12b995e);
$parcel$export(module.exports, "u32", () => $cfa1804db9217baf$export$8bacf4ad828c7fe7);
$parcel$export(module.exports, "clean", () => $cfa1804db9217baf$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "createView", () => $cfa1804db9217baf$export$d7febe7b891e79f0);
$parcel$export(module.exports, "rotr", () => $cfa1804db9217baf$export$466993d7d0d272aa);
$parcel$export(module.exports, "rotl", () => $cfa1804db9217baf$export$ac5e39599698b562);
$parcel$export(module.exports, "swap32IfBE", () => $cfa1804db9217baf$export$f3e5ccb1e5f96d20);
$parcel$export(module.exports, "bytesToHex", () => $cfa1804db9217baf$export$58b867e287a802c8);
$parcel$export(module.exports, "hexToBytes", () => $cfa1804db9217baf$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "utf8ToBytes", () => $cfa1804db9217baf$export$3df70a15530b5e81);
$parcel$export(module.exports, "bytesToUtf8", () => $cfa1804db9217baf$export$5f46301b4a1d43db);
$parcel$export(module.exports, "toBytes", () => $cfa1804db9217baf$export$30a71edf0753ed6b);
$parcel$export(module.exports, "concatBytes", () => $cfa1804db9217baf$export$287dd7971339c972);
$parcel$export(module.exports, "Hash", () => $cfa1804db9217baf$export$ab85ecd77ce6a5cd);
$parcel$export(module.exports, "createHasher", () => $cfa1804db9217baf$export$14b114effbc08b6b);
$parcel$export(module.exports, "createXOFer", () => $cfa1804db9217baf$export$741ac6dc04ed5295);
$parcel$export(module.exports, "randomBytes", () => $cfa1804db9217baf$export$5f828d93ff035aa8);
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $hhJ3e = parcelRequire("hhJ3e");
function $cfa1804db9217baf$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $cfa1804db9217baf$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
function $cfa1804db9217baf$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$cfa1804db9217baf$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $cfa1804db9217baf$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $cfa1804db9217baf$export$75364c6cb16d43b6(h.outputLen);
    $cfa1804db9217baf$export$75364c6cb16d43b6(h.blockLen);
}
function $cfa1804db9217baf$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $cfa1804db9217baf$export$e8e53abee12b995e(out, instance) {
    $cfa1804db9217baf$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $cfa1804db9217baf$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $cfa1804db9217baf$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $cfa1804db9217baf$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $cfa1804db9217baf$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $cfa1804db9217baf$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $cfa1804db9217baf$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $cfa1804db9217baf$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $cfa1804db9217baf$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $cfa1804db9217baf$export$e108944b32ae0e38 = $cfa1804db9217baf$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$cfa1804db9217baf$export$a4170f7f8be47425(n);
const $cfa1804db9217baf$export$4a0a88cc2d284e7f = $cfa1804db9217baf$export$e108944b32ae0e38;
function $cfa1804db9217baf$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $cfa1804db9217baf$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $cfa1804db9217baf$export$f3e5ccb1e5f96d20 = $cfa1804db9217baf$export$a0f88e38d4cf9577 ? (u)=>u : $cfa1804db9217baf$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $cfa1804db9217baf$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $cfa1804db9217baf$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $cfa1804db9217baf$export$58b867e287a802c8(bytes) {
    $cfa1804db9217baf$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($cfa1804db9217baf$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $cfa1804db9217baf$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $cfa1804db9217baf$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $cfa1804db9217baf$var$asciiToBase16(ch) {
    if (ch >= $cfa1804db9217baf$var$asciis._0 && ch <= $cfa1804db9217baf$var$asciis._9) return ch - $cfa1804db9217baf$var$asciis._0; // '2' => 50-48
    if (ch >= $cfa1804db9217baf$var$asciis.A && ch <= $cfa1804db9217baf$var$asciis.F) return ch - ($cfa1804db9217baf$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $cfa1804db9217baf$var$asciis.a && ch <= $cfa1804db9217baf$var$asciis.f) return ch - ($cfa1804db9217baf$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $cfa1804db9217baf$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($cfa1804db9217baf$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $cfa1804db9217baf$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $cfa1804db9217baf$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $cfa1804db9217baf$export$bdd553fddd433dcb = async ()=>{};
async function $cfa1804db9217baf$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $cfa1804db9217baf$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $cfa1804db9217baf$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $cfa1804db9217baf$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $cfa1804db9217baf$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $cfa1804db9217baf$export$3df70a15530b5e81(data);
    $cfa1804db9217baf$export$e8a750b9efad93f5(data);
    return data;
}
function $cfa1804db9217baf$export$e01ba4a527b8942d(data) {
    if (typeof data === 'string') data = $cfa1804db9217baf$export$3df70a15530b5e81(data);
    $cfa1804db9217baf$export$e8a750b9efad93f5(data);
    return data;
}
function $cfa1804db9217baf$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $cfa1804db9217baf$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $cfa1804db9217baf$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
class $cfa1804db9217baf$export$ab85ecd77ce6a5cd {
}
function $cfa1804db9217baf$export$14b114effbc08b6b(hashCons) {
    const hashC = (msg)=>hashCons().update($cfa1804db9217baf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $cfa1804db9217baf$export$aaa6b3684f701ca2(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($cfa1804db9217baf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $cfa1804db9217baf$export$741ac6dc04ed5295(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($cfa1804db9217baf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
const $cfa1804db9217baf$export$f081816339df1972 = $cfa1804db9217baf$export$14b114effbc08b6b;
const $cfa1804db9217baf$export$b465638d1569a3ae = $cfa1804db9217baf$export$aaa6b3684f701ca2;
const $cfa1804db9217baf$export$e18964dbd6e083c1 = $cfa1804db9217baf$export$741ac6dc04ed5295;
function $cfa1804db9217baf$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $hhJ3e.crypto) && typeof (0, $hhJ3e.crypto).getRandomValues === 'function') return (0, $hhJ3e.crypto).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $hhJ3e.crypto) && typeof (0, $hhJ3e.crypto).randomBytes === 'function') return Uint8Array.from((0, $hhJ3e.crypto).randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("hhJ3e", function(module, exports) {

$parcel$export(module.exports, "crypto", () => $c956f870130081c5$export$7effb53edfc7fa2d);
const $c956f870130081c5$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("4KuzL", function(module, exports) {

$parcel$export(module.exports, "concat", () => $37532d0d3de0eb56$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatHex", () => $37532d0d3de0eb56$export$f6cc0b64b5a999af);
function $37532d0d3de0eb56$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === 'string') return $37532d0d3de0eb56$export$f6cc0b64b5a999af(values);
    return $37532d0d3de0eb56$export$287dd7971339c972(values);
}
function $37532d0d3de0eb56$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $37532d0d3de0eb56$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace('0x', ''), '')}`;
}

});

parcelRegister("a7QVs", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $75f39cc642605a55$export$bced8d2aada2d1c9);
/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 * @deprecated
 */ 
var $bxlAd = parcelRequire("bxlAd");
const $75f39cc642605a55$export$397b834fceb5b168 = (0, $bxlAd.SHA256);
const $75f39cc642605a55$export$bced8d2aada2d1c9 = (0, $bxlAd.sha256);
const $75f39cc642605a55$export$d90fcf4a65424421 = (0, $bxlAd.SHA224);
const $75f39cc642605a55$export$97b70509d4e397ea = (0, $bxlAd.sha224);

});
parcelRegister("bxlAd", function(module, exports) {

$parcel$export(module.exports, "SHA256", () => $866384b920eb7833$export$397b834fceb5b168);
$parcel$export(module.exports, "SHA224", () => $866384b920eb7833$export$d90fcf4a65424421);
$parcel$export(module.exports, "sha256", () => $866384b920eb7833$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha224", () => $866384b920eb7833$export$97b70509d4e397ea);
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ 
var $e2Izz = parcelRequire("e2Izz");

var $dz2u8 = parcelRequire("dz2u8");

var $hPdhr = parcelRequire("hPdhr");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $866384b920eb7833$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $866384b920eb7833$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $866384b920eb7833$export$397b834fceb5b168 extends (0, $e2Izz.HashMD) {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = (0, $e2Izz.SHA256_IV)[0] | 0;
        this.B = (0, $e2Izz.SHA256_IV)[1] | 0;
        this.C = (0, $e2Izz.SHA256_IV)[2] | 0;
        this.D = (0, $e2Izz.SHA256_IV)[3] | 0;
        this.E = (0, $e2Izz.SHA256_IV)[4] | 0;
        this.F = (0, $e2Izz.SHA256_IV)[5] | 0;
        this.G = (0, $e2Izz.SHA256_IV)[6] | 0;
        this.H = (0, $e2Izz.SHA256_IV)[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$866384b920eb7833$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $866384b920eb7833$var$SHA256_W[i - 15];
            const W2 = $866384b920eb7833$var$SHA256_W[i - 2];
            const s0 = (0, $hPdhr.rotr)(W15, 7) ^ (0, $hPdhr.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $hPdhr.rotr)(W2, 17) ^ (0, $hPdhr.rotr)(W2, 19) ^ W2 >>> 10;
            $866384b920eb7833$var$SHA256_W[i] = s1 + $866384b920eb7833$var$SHA256_W[i - 7] + s0 + $866384b920eb7833$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $hPdhr.rotr)(E, 6) ^ (0, $hPdhr.rotr)(E, 11) ^ (0, $hPdhr.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $e2Izz.Chi)(E, F, G) + $866384b920eb7833$var$SHA256_K[i] + $866384b920eb7833$var$SHA256_W[i] | 0;
            const sigma0 = (0, $hPdhr.rotr)(A, 2) ^ (0, $hPdhr.rotr)(A, 13) ^ (0, $hPdhr.rotr)(A, 22);
            const T2 = sigma0 + (0, $e2Izz.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $hPdhr.clean)($866384b920eb7833$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $hPdhr.clean)(this.buffer);
    }
}
class $866384b920eb7833$export$d90fcf4a65424421 extends $866384b920eb7833$export$397b834fceb5b168 {
    constructor(){
        super(28);
        this.A = (0, $e2Izz.SHA224_IV)[0] | 0;
        this.B = (0, $e2Izz.SHA224_IV)[1] | 0;
        this.C = (0, $e2Izz.SHA224_IV)[2] | 0;
        this.D = (0, $e2Izz.SHA224_IV)[3] | 0;
        this.E = (0, $e2Izz.SHA224_IV)[4] | 0;
        this.F = (0, $e2Izz.SHA224_IV)[5] | 0;
        this.G = (0, $e2Izz.SHA224_IV)[6] | 0;
        this.H = (0, $e2Izz.SHA224_IV)[7] | 0;
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $866384b920eb7833$var$K512 = /* @__PURE__ */ (()=>$dz2u8.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $866384b920eb7833$var$SHA512_Kh = /* @__PURE__ */ (()=>$866384b920eb7833$var$K512[0])();
const $866384b920eb7833$var$SHA512_Kl = /* @__PURE__ */ (()=>$866384b920eb7833$var$K512[1])();
// Reusable temporary buffers
const $866384b920eb7833$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $866384b920eb7833$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $866384b920eb7833$export$d655fdb8a1cad5df extends (0, $e2Izz.HashMD) {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = (0, $e2Izz.SHA512_IV)[0] | 0;
        this.Al = (0, $e2Izz.SHA512_IV)[1] | 0;
        this.Bh = (0, $e2Izz.SHA512_IV)[2] | 0;
        this.Bl = (0, $e2Izz.SHA512_IV)[3] | 0;
        this.Ch = (0, $e2Izz.SHA512_IV)[4] | 0;
        this.Cl = (0, $e2Izz.SHA512_IV)[5] | 0;
        this.Dh = (0, $e2Izz.SHA512_IV)[6] | 0;
        this.Dl = (0, $e2Izz.SHA512_IV)[7] | 0;
        this.Eh = (0, $e2Izz.SHA512_IV)[8] | 0;
        this.El = (0, $e2Izz.SHA512_IV)[9] | 0;
        this.Fh = (0, $e2Izz.SHA512_IV)[10] | 0;
        this.Fl = (0, $e2Izz.SHA512_IV)[11] | 0;
        this.Gh = (0, $e2Izz.SHA512_IV)[12] | 0;
        this.Gl = (0, $e2Izz.SHA512_IV)[13] | 0;
        this.Hh = (0, $e2Izz.SHA512_IV)[14] | 0;
        this.Hl = (0, $e2Izz.SHA512_IV)[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $866384b920eb7833$var$SHA512_W_H[i] = view.getUint32(offset);
            $866384b920eb7833$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $866384b920eb7833$var$SHA512_W_H[i - 15] | 0;
            const W15l = $866384b920eb7833$var$SHA512_W_L[i - 15] | 0;
            const s0h = $dz2u8.rotrSH(W15h, W15l, 1) ^ $dz2u8.rotrSH(W15h, W15l, 8) ^ $dz2u8.shrSH(W15h, W15l, 7);
            const s0l = $dz2u8.rotrSL(W15h, W15l, 1) ^ $dz2u8.rotrSL(W15h, W15l, 8) ^ $dz2u8.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $866384b920eb7833$var$SHA512_W_H[i - 2] | 0;
            const W2l = $866384b920eb7833$var$SHA512_W_L[i - 2] | 0;
            const s1h = $dz2u8.rotrSH(W2h, W2l, 19) ^ $dz2u8.rotrBH(W2h, W2l, 61) ^ $dz2u8.shrSH(W2h, W2l, 6);
            const s1l = $dz2u8.rotrSL(W2h, W2l, 19) ^ $dz2u8.rotrBL(W2h, W2l, 61) ^ $dz2u8.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $dz2u8.add4L(s0l, s1l, $866384b920eb7833$var$SHA512_W_L[i - 7], $866384b920eb7833$var$SHA512_W_L[i - 16]);
            const SUMh = $dz2u8.add4H(SUMl, s0h, s1h, $866384b920eb7833$var$SHA512_W_H[i - 7], $866384b920eb7833$var$SHA512_W_H[i - 16]);
            $866384b920eb7833$var$SHA512_W_H[i] = SUMh | 0;
            $866384b920eb7833$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $dz2u8.rotrSH(Eh, El, 14) ^ $dz2u8.rotrSH(Eh, El, 18) ^ $dz2u8.rotrBH(Eh, El, 41);
            const sigma1l = $dz2u8.rotrSL(Eh, El, 14) ^ $dz2u8.rotrSL(Eh, El, 18) ^ $dz2u8.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $dz2u8.add5L(Hl, sigma1l, CHIl, $866384b920eb7833$var$SHA512_Kl[i], $866384b920eb7833$var$SHA512_W_L[i]);
            const T1h = $dz2u8.add5H(T1ll, Hh, sigma1h, CHIh, $866384b920eb7833$var$SHA512_Kh[i], $866384b920eb7833$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $dz2u8.rotrSH(Ah, Al, 28) ^ $dz2u8.rotrBH(Ah, Al, 34) ^ $dz2u8.rotrBH(Ah, Al, 39);
            const sigma0l = $dz2u8.rotrSL(Ah, Al, 28) ^ $dz2u8.rotrBL(Ah, Al, 34) ^ $dz2u8.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $dz2u8.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $dz2u8.add3L(T1l, sigma0l, MAJl);
            Ah = $dz2u8.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $dz2u8.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $dz2u8.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $dz2u8.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $dz2u8.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $dz2u8.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $dz2u8.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $dz2u8.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $dz2u8.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $hPdhr.clean)($866384b920eb7833$var$SHA512_W_H, $866384b920eb7833$var$SHA512_W_L);
    }
    destroy() {
        (0, $hPdhr.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $866384b920eb7833$export$b4bd5cd48f62bcf0 extends $866384b920eb7833$export$d655fdb8a1cad5df {
    constructor(){
        super(48);
        this.Ah = (0, $e2Izz.SHA384_IV)[0] | 0;
        this.Al = (0, $e2Izz.SHA384_IV)[1] | 0;
        this.Bh = (0, $e2Izz.SHA384_IV)[2] | 0;
        this.Bl = (0, $e2Izz.SHA384_IV)[3] | 0;
        this.Ch = (0, $e2Izz.SHA384_IV)[4] | 0;
        this.Cl = (0, $e2Izz.SHA384_IV)[5] | 0;
        this.Dh = (0, $e2Izz.SHA384_IV)[6] | 0;
        this.Dl = (0, $e2Izz.SHA384_IV)[7] | 0;
        this.Eh = (0, $e2Izz.SHA384_IV)[8] | 0;
        this.El = (0, $e2Izz.SHA384_IV)[9] | 0;
        this.Fh = (0, $e2Izz.SHA384_IV)[10] | 0;
        this.Fl = (0, $e2Izz.SHA384_IV)[11] | 0;
        this.Gh = (0, $e2Izz.SHA384_IV)[12] | 0;
        this.Gl = (0, $e2Izz.SHA384_IV)[13] | 0;
        this.Hh = (0, $e2Izz.SHA384_IV)[14] | 0;
        this.Hl = (0, $e2Izz.SHA384_IV)[15] | 0;
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $866384b920eb7833$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $866384b920eb7833$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $866384b920eb7833$export$9269e18873efb8a1 extends $866384b920eb7833$export$d655fdb8a1cad5df {
    constructor(){
        super(28);
        this.Ah = $866384b920eb7833$var$T224_IV[0] | 0;
        this.Al = $866384b920eb7833$var$T224_IV[1] | 0;
        this.Bh = $866384b920eb7833$var$T224_IV[2] | 0;
        this.Bl = $866384b920eb7833$var$T224_IV[3] | 0;
        this.Ch = $866384b920eb7833$var$T224_IV[4] | 0;
        this.Cl = $866384b920eb7833$var$T224_IV[5] | 0;
        this.Dh = $866384b920eb7833$var$T224_IV[6] | 0;
        this.Dl = $866384b920eb7833$var$T224_IV[7] | 0;
        this.Eh = $866384b920eb7833$var$T224_IV[8] | 0;
        this.El = $866384b920eb7833$var$T224_IV[9] | 0;
        this.Fh = $866384b920eb7833$var$T224_IV[10] | 0;
        this.Fl = $866384b920eb7833$var$T224_IV[11] | 0;
        this.Gh = $866384b920eb7833$var$T224_IV[12] | 0;
        this.Gl = $866384b920eb7833$var$T224_IV[13] | 0;
        this.Hh = $866384b920eb7833$var$T224_IV[14] | 0;
        this.Hl = $866384b920eb7833$var$T224_IV[15] | 0;
    }
}
class $866384b920eb7833$export$70b84015054354f1 extends $866384b920eb7833$export$d655fdb8a1cad5df {
    constructor(){
        super(32);
        this.Ah = $866384b920eb7833$var$T256_IV[0] | 0;
        this.Al = $866384b920eb7833$var$T256_IV[1] | 0;
        this.Bh = $866384b920eb7833$var$T256_IV[2] | 0;
        this.Bl = $866384b920eb7833$var$T256_IV[3] | 0;
        this.Ch = $866384b920eb7833$var$T256_IV[4] | 0;
        this.Cl = $866384b920eb7833$var$T256_IV[5] | 0;
        this.Dh = $866384b920eb7833$var$T256_IV[6] | 0;
        this.Dl = $866384b920eb7833$var$T256_IV[7] | 0;
        this.Eh = $866384b920eb7833$var$T256_IV[8] | 0;
        this.El = $866384b920eb7833$var$T256_IV[9] | 0;
        this.Fh = $866384b920eb7833$var$T256_IV[10] | 0;
        this.Fl = $866384b920eb7833$var$T256_IV[11] | 0;
        this.Gh = $866384b920eb7833$var$T256_IV[12] | 0;
        this.Gl = $866384b920eb7833$var$T256_IV[13] | 0;
        this.Hh = $866384b920eb7833$var$T256_IV[14] | 0;
        this.Hl = $866384b920eb7833$var$T256_IV[15] | 0;
    }
}
const $866384b920eb7833$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $hPdhr.createHasher)(()=>new $866384b920eb7833$export$397b834fceb5b168());
const $866384b920eb7833$export$97b70509d4e397ea = /* @__PURE__ */ (0, $hPdhr.createHasher)(()=>new $866384b920eb7833$export$d90fcf4a65424421());
const $866384b920eb7833$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $hPdhr.createHasher)(()=>new $866384b920eb7833$export$d655fdb8a1cad5df());
const $866384b920eb7833$export$612d47d55dedde45 = /* @__PURE__ */ (0, $hPdhr.createHasher)(()=>new $866384b920eb7833$export$b4bd5cd48f62bcf0());
const $866384b920eb7833$export$c78786b6da86db2a = /* @__PURE__ */ (0, $hPdhr.createHasher)(()=>new $866384b920eb7833$export$70b84015054354f1());
const $866384b920eb7833$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $hPdhr.createHasher)(()=>new $866384b920eb7833$export$9269e18873efb8a1());

});
parcelRegister("e2Izz", function(module, exports) {

$parcel$export(module.exports, "Chi", () => $a393d3cff710f75b$export$d0d97f016526eaf0);
$parcel$export(module.exports, "Maj", () => $a393d3cff710f75b$export$8b1d810b1bd30adf);
$parcel$export(module.exports, "HashMD", () => $a393d3cff710f75b$export$f9f830659f932cb2);
$parcel$export(module.exports, "SHA256_IV", () => $a393d3cff710f75b$export$a986fdf7a5bdfdf8);
$parcel$export(module.exports, "SHA224_IV", () => $a393d3cff710f75b$export$104dc246f4c65f21);
$parcel$export(module.exports, "SHA384_IV", () => $a393d3cff710f75b$export$b5217b4b948279ee);
$parcel$export(module.exports, "SHA512_IV", () => $a393d3cff710f75b$export$f2cbb88a1784d2d1);
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ 
var $hPdhr = parcelRequire("hPdhr");
function $a393d3cff710f75b$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $a393d3cff710f75b$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $a393d3cff710f75b$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $a393d3cff710f75b$export$f9f830659f932cb2 extends (0, $hPdhr.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $hPdhr.createView)(this.buffer);
    }
    update(data) {
        (0, $hPdhr.aexists)(this);
        data = (0, $hPdhr.toBytes)(data);
        (0, $hPdhr.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $hPdhr.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $hPdhr.aexists)(this);
        (0, $hPdhr.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $hPdhr.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $a393d3cff710f75b$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $hPdhr.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $a393d3cff710f75b$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $a393d3cff710f75b$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $a393d3cff710f75b$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $a393d3cff710f75b$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});



parcelRegister("24Ila", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", () => $182e5991afd25282$export$f4ee15df45da9f03);

var $4KuzL = parcelRequire("4KuzL");

var $lBZMD = parcelRequire("lBZMD");

var $leBZh = parcelRequire("leBZh");
function $182e5991afd25282$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith('0x')) return parameters;
        return (0, $leBZh.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = 'inputs' in abiItem && abiItem.inputs ? (0, $lBZMD.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $4KuzL.concatHex)([
        signature,
        data ?? '0x'
    ]);
}

});
parcelRegister("lBZMD", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", () => $fbbcfa95408f8731$export$448ea0950d6dd7d7);
$parcel$export(module.exports, "getArrayComponents", () => $fbbcfa95408f8731$export$ab502cfdbb1a0d07);

var $dZdNo = parcelRequire("dZdNo");

var $eCsKB = parcelRequire("eCsKB");

var $5jfXj = parcelRequire("5jfXj");

var $9Ckzf = parcelRequire("9Ckzf");

var $9GvsK = parcelRequire("9GvsK");

var $4KuzL = parcelRequire("4KuzL");

var $gbm88 = parcelRequire("gbm88");

var $2u1VO = parcelRequire("2u1VO");

var $cadfc = parcelRequire("cadfc");

var $cD3gI = parcelRequire("cD3gI");

var $6B71n = parcelRequire("6B71n");
function $fbbcfa95408f8731$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $dZdNo.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $fbbcfa95408f8731$var$prepareParams({
        params: params,
        values: values
    });
    const data = $fbbcfa95408f8731$var$encodeParams(preparedParams);
    if (data.length === 0) return '0x';
    return data;
}
function $fbbcfa95408f8731$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($fbbcfa95408f8731$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $fbbcfa95408f8731$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $fbbcfa95408f8731$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $fbbcfa95408f8731$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === 'tuple') return $fbbcfa95408f8731$var$encodeTuple(value, {
        param: param
    });
    if (param.type === 'address') return $fbbcfa95408f8731$var$encodeAddress(value);
    if (param.type === 'bool') return $fbbcfa95408f8731$var$encodeBool(value);
    if (param.type.startsWith('uint') || param.type.startsWith('int')) {
        const signed = param.type.startsWith('int');
        const [, , size = '256'] = (0, $6B71n.integerRegex).exec(param.type) ?? [];
        return $fbbcfa95408f8731$var$encodeNumber(value, {
            signed: signed,
            size: Number(size)
        });
    }
    if (param.type.startsWith('bytes')) return $fbbcfa95408f8731$var$encodeBytes(value, {
        param: param
    });
    if (param.type === 'string') return $fbbcfa95408f8731$var$encodeString(value);
    throw new (0, $dZdNo.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: '/docs/contract/encodeAbiParameters'
    });
}
function $fbbcfa95408f8731$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $2u1VO.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $cD3gI.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $2u1VO.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $4KuzL.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $fbbcfa95408f8731$var$encodeAddress(value) {
    if (!(0, $9GvsK.isAddress)(value)) throw new (0, $eCsKB.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $gbm88.padHex)(value.toLowerCase())
    };
}
function $fbbcfa95408f8731$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $dZdNo.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $dZdNo.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $fbbcfa95408f8731$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $fbbcfa95408f8731$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $cD3gI.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $4KuzL.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $4KuzL.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $fbbcfa95408f8731$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split('bytes');
    const bytesSize = (0, $2u1VO.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $gbm88.padHex)(value_, {
            dir: 'right',
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $4KuzL.concat)([
                (0, $gbm88.padHex)((0, $cD3gI.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize, 10)) throw new (0, $dZdNo.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize, 10),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $gbm88.padHex)(value, {
            dir: 'right'
        })
    };
}
function $fbbcfa95408f8731$var$encodeBool(value) {
    if (typeof value !== 'boolean') throw new (0, $5jfXj.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $gbm88.padHex)((0, $cD3gI.boolToHex)(value))
    };
}
function $fbbcfa95408f8731$var$encodeNumber(value, { signed: signed, size: size = 256 }) {
    if (typeof size === 'number') {
        const max = 2n ** (BigInt(size) - (signed ? 1n : 0n)) - 1n;
        const min = signed ? -max - 1n : 0n;
        if (value > max || value < min) throw new (0, $9Ckzf.IntegerOutOfRangeError)({
            max: max.toString(),
            min: min.toString(),
            signed: signed,
            size: size / 8,
            value: value.toString()
        });
    }
    return {
        dynamic: false,
        encoded: (0, $cD3gI.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $fbbcfa95408f8731$var$encodeString(value) {
    const hexValue = (0, $cD3gI.stringToHex)(value);
    const partsLength = Math.ceil((0, $2u1VO.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $gbm88.padHex)((0, $cadfc.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: 'right'
    }));
    return {
        dynamic: true,
        encoded: (0, $4KuzL.concat)([
            (0, $gbm88.padHex)((0, $cD3gI.numberToHex)((0, $2u1VO.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $fbbcfa95408f8731$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $fbbcfa95408f8731$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $fbbcfa95408f8731$var$encodeParams(preparedParams) : (0, $4KuzL.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $fbbcfa95408f8731$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("dZdNo", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", () => $a2ebac6c71efc3f7$export$efa723f306cf6168);
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", () => $a2ebac6c71efc3f7$export$4faec14323ef9c47);
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", () => $a2ebac6c71efc3f7$export$7a409e433c5f3a8c);
$parcel$export(module.exports, "AbiDecodingZeroDataError", () => $a2ebac6c71efc3f7$export$a063cde4013f1935);
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", () => $a2ebac6c71efc3f7$export$a851da9bf50b557);
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", () => $a2ebac6c71efc3f7$export$19c281dc8e23a2ea);
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", () => $a2ebac6c71efc3f7$export$20737d495bb13c2d);
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", () => $a2ebac6c71efc3f7$export$8959cb729fefe1ea);
$parcel$export(module.exports, "AbiFunctionNotFoundError", () => $a2ebac6c71efc3f7$export$c4faa308ea7f9b2);
$parcel$export(module.exports, "AbiItemAmbiguityError", () => $a2ebac6c71efc3f7$export$fdbba54ba15f2c2d);
$parcel$export(module.exports, "BytesSizeMismatchError", () => $a2ebac6c71efc3f7$export$a0eb884ede5c87eb);
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", () => $a2ebac6c71efc3f7$export$53ed98b886965f49);
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", () => $a2ebac6c71efc3f7$export$cf94ccff0ff97c65);
$parcel$export(module.exports, "InvalidArrayError", () => $a2ebac6c71efc3f7$export$710dd6d4f78cc47e);
$parcel$export(module.exports, "InvalidDefinitionTypeError", () => $a2ebac6c71efc3f7$export$81781a0fcfb9ed95);

var $3IdOg = parcelRequire("3IdOg");

var $2u1VO = parcelRequire("2u1VO");

var $5jfXj = parcelRequire("5jfXj");
class $a2ebac6c71efc3f7$export$efa723f306cf6168 extends (0, $5jfXj.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            'A constructor was not found on the ABI.',
            'Make sure you are using the correct ABI and that the constructor exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiConstructorNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$4faec14323ef9c47 extends (0, $5jfXj.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            'Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.',
            'Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiConstructorParamsNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$68a7b570091cba69 extends (0, $5jfXj.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            'Size must be in increments of 32 bytes (size % 32 === 0).'
        ].join('\n'), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: 'AbiDecodingDataSizeInvalidError'
        });
    }
}
class $a2ebac6c71efc3f7$export$7a409e433c5f3a8c extends (0, $5jfXj.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join('\n'), {
            metaMessages: [
                `Params: (${(0, $3IdOg.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: 'AbiDecodingDataSizeTooSmallError'
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $a2ebac6c71efc3f7$export$a063cde4013f1935 extends (0, $5jfXj.BaseError) {
    constructor({ cause: cause } = {}){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: 'AbiDecodingZeroDataError',
            cause: cause
        });
    }
}
class $a2ebac6c71efc3f7$export$a851da9bf50b557 extends (0, $5jfXj.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join('\n'), {
            name: 'AbiEncodingArrayLengthMismatchError'
        });
    }
}
class $a2ebac6c71efc3f7$export$19c281dc8e23a2ea extends (0, $5jfXj.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $2u1VO.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: 'AbiEncodingBytesSizeMismatchError'
        });
    }
}
class $a2ebac6c71efc3f7$export$20737d495bb13c2d extends (0, $5jfXj.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            'ABI encoding params/values length mismatch.',
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join('\n'), {
            name: 'AbiEncodingLengthMismatchError'
        });
    }
}
class $a2ebac6c71efc3f7$export$d47cf5ef47eda817 extends (0, $5jfXj.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            'Cannot encode error result without knowing what the parameter types are.',
            'Make sure you are using the correct ABI and that the inputs exist on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiErrorInputsNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$86b719574b683f04 extends (0, $5jfXj.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the error exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiErrorNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$8959cb729fefe1ea extends (0, $5jfXj.BaseError) {
    constructor(signature, { docsPath: docsPath, cause: cause }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the error exists on it.',
            `You can look up the decoded signature here: https://4byte.sourcify.dev/?q=${signature}.`
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiErrorSignatureNotFoundError',
            cause: cause
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $a2ebac6c71efc3f7$export$f83210ce5f9b901f extends (0, $5jfXj.BaseError) {
    constructor({ docsPath: docsPath }){
        super('Cannot extract event signature from empty topics.', {
            docsPath: docsPath,
            name: 'AbiEventSignatureEmptyTopicsError'
        });
    }
}
class $a2ebac6c71efc3f7$export$3b44baeac92e4d3a extends (0, $5jfXj.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the event exists on it.',
            `You can look up the signature here: https://4byte.sourcify.dev/?q=${signature}.`
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiEventSignatureNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$c7be62baad13b157 extends (0, $5jfXj.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the event exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiEventNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$c4faa308ea7f9b2 extends (0, $5jfXj.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the function exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiFunctionNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$26f2edb605108b34 extends (0, $5jfXj.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            'Cannot decode function result without knowing what the parameter types are.',
            'Make sure you are using the correct ABI and that the function exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiFunctionOutputsNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$14373147a0e60810 extends (0, $5jfXj.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the function exists on it.',
            `You can look up the signature here: https://4byte.sourcify.dev/?q=${signature}.`
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiFunctionSignatureNotFoundError'
        });
    }
}
class $a2ebac6c71efc3f7$export$fdbba54ba15f2c2d extends (0, $5jfXj.BaseError) {
    constructor(x, y){
        super('Found ambiguous types in overloaded ABI items.', {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $3IdOg.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $3IdOg.formatAbiItem)(y.abiItem)}\``,
                '',
                'These types encode differently and cannot be distinguished at runtime.',
                'Remove one of the ambiguous items in the ABI.'
            ],
            name: 'AbiItemAmbiguityError'
        });
    }
}
class $a2ebac6c71efc3f7$export$a0eb884ede5c87eb extends (0, $5jfXj.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: 'BytesSizeMismatchError'
        });
    }
}
class $a2ebac6c71efc3f7$export$3978f86c08fc8c25 extends (0, $5jfXj.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join('\n'), {
            metaMessages: [
                `Params: (${(0, $3IdOg.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: 'DecodeLogDataMismatch'
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $a2ebac6c71efc3f7$export$6d7c6f419cf52377 extends (0, $5jfXj.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ''} on event "${(0, $3IdOg.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join('\n'), {
            name: 'DecodeLogTopicsMismatch'
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $a2ebac6c71efc3f7$export$53ed98b886965f49 extends (0, $5jfXj.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            'Please provide a valid ABI type.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'InvalidAbiEncodingType'
        });
    }
}
class $a2ebac6c71efc3f7$export$cf94ccff0ff97c65 extends (0, $5jfXj.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            'Please provide a valid ABI type.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'InvalidAbiDecodingType'
        });
    }
}
class $a2ebac6c71efc3f7$export$710dd6d4f78cc47e extends (0, $5jfXj.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join('\n'), {
            name: 'InvalidArrayError'
        });
    }
}
class $a2ebac6c71efc3f7$export$81781a0fcfb9ed95 extends (0, $5jfXj.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join('\n'), {
            name: 'InvalidDefinitionTypeError'
        });
    }
}
class $a2ebac6c71efc3f7$export$a16541e2fe420ef1 extends (0, $5jfXj.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: 'UnsupportedPackedAbiType'
        });
    }
}

});
parcelRegister("3IdOg", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $2b40317f72297f1a$export$dc5d0ff4fc2fdee1);
$parcel$export(module.exports, "formatAbiParams", () => $2b40317f72297f1a$export$849e499971de75b3);

var $dZdNo = parcelRequire("dZdNo");
function $2b40317f72297f1a$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== 'function' && abiItem.type !== 'event' && abiItem.type !== 'error') throw new (0, $dZdNo.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$2b40317f72297f1a$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $2b40317f72297f1a$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return '';
    return params.map((param)=>$2b40317f72297f1a$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ', ' : ',');
}
function $2b40317f72297f1a$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith('tuple')) return `(${$2b40317f72297f1a$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : '');
}

});


parcelRegister("eCsKB", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", () => $aa4aea92c460b467$export$66c44d927ffead98);

var $5jfXj = parcelRequire("5jfXj");
class $aa4aea92c460b467$export$66c44d927ffead98 extends (0, $5jfXj.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                '- Address must be a hex value of 20 bytes (40 hex characters).',
                '- Address must match its checksum counterpart.'
            ],
            name: 'InvalidAddressError'
        });
    }
}

});

parcelRegister("9GvsK", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $70d0712774ca72c0$export$977e255126d763d6);

var $4nYJj = parcelRequire("4nYJj");

var $kiDAM = parcelRequire("kiDAM");
const $70d0712774ca72c0$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $70d0712774ca72c0$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $4nYJj.LruMap)(8192);
function $70d0712774ca72c0$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($70d0712774ca72c0$export$ef83598cc5072ce.has(cacheKey)) return $70d0712774ca72c0$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$70d0712774ca72c0$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $kiDAM.checksumAddress)(address) === address;
        return true;
    })();
    $70d0712774ca72c0$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});
parcelRegister("4nYJj", function(module, exports) {

$parcel$export(module.exports, "LruMap", () => $33186b155dfb7537$export$fcb3b6cad79d7e3a);
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $33186b155dfb7537$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key)) {
            super.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (super.has(key)) super.delete(key);
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = super.keys().next().value;
            if (firstKey !== undefined) super.delete(firstKey);
        }
        return this;
    }
}

});

parcelRegister("kiDAM", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", () => $ec743347c0ae5119$export$9ff46e8f6df13548);
$parcel$export(module.exports, "getAddress", () => $ec743347c0ae5119$export$88411125f012957a);

var $eCsKB = parcelRequire("eCsKB");

var $kc9Jh = parcelRequire("kc9Jh");

var $1YOOf = parcelRequire("1YOOf");

var $4nYJj = parcelRequire("4nYJj");

var $9GvsK = parcelRequire("9GvsK");
const $ec743347c0ae5119$var$checksumAddressCache = /*#__PURE__*/ new (0, $4nYJj.LruMap)(8192);
function $ec743347c0ae5119$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($ec743347c0ae5119$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $ec743347c0ae5119$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $1YOOf.keccak256)((0, $kc9Jh.stringToBytes)(hexAddress), 'bytes');
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split('');
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join('')}`;
    $ec743347c0ae5119$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $ec743347c0ae5119$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $9GvsK.isAddress)(address, {
        strict: false
    })) throw new (0, $eCsKB.InvalidAddressError)({
        address: address
    });
    return $ec743347c0ae5119$export$9ff46e8f6df13548(address, chainId);
}

});


parcelRegister("cadfc", function(module, exports) {

$parcel$export(module.exports, "slice", () => $8db0b13b9ee36053$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceHex", () => $8db0b13b9ee36053$export$728fe14c970402fe);
$parcel$export(module.exports, "sliceBytes", () => $8db0b13b9ee36053$export$8bac03c8c1da551);

var $crrQA = parcelRequire("crrQA");

var $dem4j = parcelRequire("dem4j");

var $2u1VO = parcelRequire("2u1VO");
function $8db0b13b9ee36053$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $dem4j.isHex)(value, {
        strict: false
    })) return $8db0b13b9ee36053$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $8db0b13b9ee36053$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $8db0b13b9ee36053$var$assertStartOffset(value, start) {
    if (typeof start === 'number' && start > 0 && start > (0, $2u1VO.size)(value) - 1) throw new (0, $crrQA.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: 'start',
        size: (0, $2u1VO.size)(value)
    });
}
function $8db0b13b9ee36053$var$assertEndOffset(value, start, end) {
    if (typeof start === 'number' && typeof end === 'number' && (0, $2u1VO.size)(value) !== end - start) throw new (0, $crrQA.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: 'end',
        size: (0, $2u1VO.size)(value)
    });
}
function $8db0b13b9ee36053$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $8db0b13b9ee36053$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $8db0b13b9ee36053$var$assertEndOffset(value, start, end);
    return value;
}
function $8db0b13b9ee36053$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $8db0b13b9ee36053$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace('0x', '').slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $8db0b13b9ee36053$var$assertEndOffset(value, start, end);
    return value;
}

});

parcelRegister("6B71n", function(module, exports) {

$parcel$export(module.exports, "bytesRegex", () => $4cdba50be3719fd0$export$94d7303c0d9f263a);
$parcel$export(module.exports, "integerRegex", () => $4cdba50be3719fd0$export$45902cc189596eef);
const $4cdba50be3719fd0$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $4cdba50be3719fd0$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $4cdba50be3719fd0$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});


parcelRegister("leBZh", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", () => $f7585f451c77eb91$export$bb3e0a434581ff8);

var $dZdNo = parcelRequire("dZdNo");

var $eIg5H = parcelRequire("eIg5H");

var $3IdOg = parcelRequire("3IdOg");

var $7zR8F = parcelRequire("7zR8F");
const $f7585f451c77eb91$var$docsPath = '/docs/contract/encodeFunctionData';
function $f7585f451c77eb91$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $7zR8F.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $dZdNo.AbiFunctionNotFoundError)(functionName, {
            docsPath: $f7585f451c77eb91$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== 'function') throw new (0, $dZdNo.AbiFunctionNotFoundError)(undefined, {
        docsPath: $f7585f451c77eb91$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $eIg5H.toFunctionSelector)((0, $3IdOg.formatAbiItem)(abiItem))
    };
}

});
parcelRegister("eIg5H", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", () => $ab61a80cb5e9a206$export$e2442488533809cb);

var $cadfc = parcelRequire("cadfc");

var $hcYAF = parcelRequire("hcYAF");
const $ab61a80cb5e9a206$export$e2442488533809cb = (fn)=>(0, $cadfc.slice)((0, $hcYAF.toSignatureHash)(fn), 0, 4);

});
parcelRegister("hcYAF", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", () => $c8728ea9e544ec2f$export$d809beebc9c913db);

var $kfUr7 = parcelRequire("kfUr7");

var $7b1ec = parcelRequire("7b1ec");
function $c8728ea9e544ec2f$export$d809beebc9c913db(fn) {
    return (0, $kfUr7.hashSignature)((0, $7b1ec.toSignature)(fn));
}

});
parcelRegister("kfUr7", function(module, exports) {

$parcel$export(module.exports, "hashSignature", () => $ebf0fc709164bbce$export$77bbcd7aaec17976);

var $kc9Jh = parcelRequire("kc9Jh");

var $1YOOf = parcelRequire("1YOOf");
const $ebf0fc709164bbce$var$hash = (value)=>(0, $1YOOf.keccak256)((0, $kc9Jh.toBytes)(value));
function $ebf0fc709164bbce$export$77bbcd7aaec17976(sig) {
    return $ebf0fc709164bbce$var$hash(sig);
}

});

parcelRegister("7b1ec", function(module, exports) {

$parcel$export(module.exports, "toSignature", () => $539a835ae9f4ddd1$export$d075a2fd83e0ecb);

var $hKvo8 = parcelRequire("hKvo8");

var $l2vBO = parcelRequire("l2vBO");
const $539a835ae9f4ddd1$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === 'string') return def;
        return (0, $hKvo8.formatAbiItem)(def);
    })();
    return (0, $l2vBO.normalizeSignature)(def_);
};

});
parcelRegister("hKvo8", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $cebf14965b58936a$export$dc5d0ff4fc2fdee1);

var $gP9WI = parcelRequire("gP9WI");
function $cebf14965b58936a$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === 'function') return `function ${abiItem.name}(${(0, $gP9WI.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== 'nonpayable' ? ` ${abiItem.stateMutability}` : ''}${abiItem.outputs?.length ? ` returns (${(0, $gP9WI.formatAbiParameters)(abiItem.outputs)})` : ''}`;
    if (abiItem.type === 'event') return `event ${abiItem.name}(${(0, $gP9WI.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === 'error') return `error ${abiItem.name}(${(0, $gP9WI.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === 'constructor') return `constructor(${(0, $gP9WI.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === 'payable' ? ' payable' : ''}`;
    if (abiItem.type === 'fallback') return `fallback() external${abiItem.stateMutability === 'payable' ? ' payable' : ''}`;
    return 'receive() external payable';
}

});
parcelRegister("gP9WI", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", () => $c3f91fd36b8709c6$export$c55dbda1a081631e);

var $cE22x = parcelRequire("cE22x");
function $c3f91fd36b8709c6$export$c55dbda1a081631e(abiParameters) {
    let params = '';
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $cE22x.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ', ';
    }
    return params;
}

});
parcelRegister("cE22x", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", () => $934acd8d413c4dd9$export$c75e01ebc733dc6b);

var $jsFt5 = parcelRequire("jsFt5");
// https://regexr.com/7f7rv
const $934acd8d413c4dd9$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $934acd8d413c4dd9$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($934acd8d413c4dd9$var$tupleRegex.test(abiParameter.type) && 'components' in abiParameter) {
        type = '(';
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $934acd8d413c4dd9$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ', ';
        }
        const result = (0, $jsFt5.execTyped)($934acd8d413c4dd9$var$tupleRegex, abiParameter.type);
        type += `)${result?.array || ''}`;
        return $934acd8d413c4dd9$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ('indexed' in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("jsFt5", function(module, exports) {

$parcel$export(module.exports, "execTyped", () => $e2b0cc91446400d6$export$1cca4755fb17f5bd);
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $e2b0cc91446400d6$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $e2b0cc91446400d6$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $e2b0cc91446400d6$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $e2b0cc91446400d6$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("l2vBO", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", () => $f5124dbd4cbdb695$export$5cba87ebe4d0307a);

var $5jfXj = parcelRequire("5jfXj");
function $f5124dbd4cbdb695$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = '';
    let level = 0;
    let result = '';
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            '(',
            ')',
            ','
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === '(') level++;
        if (char === ')') level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === ' ' && [
                'event',
                'function',
                ''
            ].includes(result)) result = '';
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ')') {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === ' ') {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== ',' && current !== ',' && current !== ',(') {
                current = '';
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $5jfXj.BaseError)('Unable to normalize signature.');
    return result;
}

});




parcelRegister("7zR8F", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", () => $58450585afb919ec$export$99b134cd177e9574);

var $dZdNo = parcelRequire("dZdNo");

var $dem4j = parcelRequire("dem4j");

var $9GvsK = parcelRequire("9GvsK");

var $7K7SS = parcelRequire("7K7SS");

var $eIg5H = parcelRequire("eIg5H");
function $58450585afb919ec$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $dem4j.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === 'function') return (0, $eIg5H.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === 'event') return (0, $7K7SS.toEventSelector)(abiItem) === name;
            return false;
        }
        return 'name' in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem;
    for (const abiItem of abiItems){
        if (!('inputs' in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = 'inputs' in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $58450585afb919ec$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && 'inputs' in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $58450585afb919ec$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $dZdNo.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $58450585afb919ec$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case 'address':
            return (0, $9GvsK.isAddress)(arg, {
                strict: false
            });
        case 'bool':
            return argType === 'boolean';
        case 'function':
            return argType === 'string';
        case 'string':
            return argType === 'string';
        default:
            if (abiParameterType === 'tuple' && 'components' in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return argType === 'object' && $58450585afb919ec$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === 'number' || argType === 'bigint';
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === 'string' || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$58450585afb919ec$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, '')
                }));
            return false;
    }
}
function $58450585afb919ec$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === 'tuple' && targetParameter.type === 'tuple' && 'components' in sourceParameter && 'components' in targetParameter) return $58450585afb919ec$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes('address') && types.includes('bytes20')) return true;
            if (types.includes('address') && types.includes('string')) return (0, $9GvsK.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes('address') && types.includes('bytes')) return (0, $9GvsK.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("7K7SS", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", () => $5a32f1e3c8b41abe$export$351f40ec61b2972);

var $hcYAF = parcelRequire("hcYAF");
const $5a32f1e3c8b41abe$export$351f40ec61b2972 = (0, $hcYAF.toSignatureHash);

});




parcelRegister("h08PT", function(module, exports) {

$parcel$export(module.exports, "wait", () => $c6094a65afd467af$export$5c069c93d2b7493f);

var $ebsn0 = parcelRequire("ebsn0");
async function $c6094a65afd467af$export$5c069c93d2b7493f(time, { signal: signal } = {}) {
    return new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject((0, $ebsn0.getAbortError)(signal));
            return;
        }
        const cleanup = ()=>signal?.removeEventListener('abort', onAbort);
        const timeout = setTimeout(()=>{
            cleanup();
            resolve();
        }, time);
        const onAbort = ()=>{
            clearTimeout(timeout);
            cleanup();
            reject((0, $ebsn0.getAbortError)(signal));
        };
        signal?.addEventListener('abort', onAbort, {
            once: true
        });
    });
}

});

parcelRegister("3izIq", function(module, exports) {

$parcel$export(module.exports, "withResolvers", () => $266ec1e65c192b33$export$88ce28fd4287e6ef);
/** @internal */ function $266ec1e65c192b33$export$88ce28fd4287e6ef() {
    let resolve = ()=>undefined;
    let reject = ()=>undefined;
    const promise = new Promise((resolve_, reject_)=>{
        resolve = resolve_;
        reject = reject_;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});

parcelRegister("aGqN7", function(module, exports) {

$parcel$export(module.exports, "hashTypedData", () => $7c729bcae4d085b9$export$9e2bd399d9aaab56);
$parcel$export(module.exports, "hashDomain", () => $7c729bcae4d085b9$export$d4e887b08c47faea);
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $lBZMD = parcelRequire("lBZMD");

var $4KuzL = parcelRequire("4KuzL");

var $cD3gI = parcelRequire("cD3gI");

var $1YOOf = parcelRequire("1YOOf");

var $ltkM7 = parcelRequire("ltkM7");
function $7c729bcae4d085b9$export$9e2bd399d9aaab56(parameters) {
    const { domain: domain = {}, message: message, primaryType: primaryType } = parameters;
    const types = {
        EIP712Domain: (0, $ltkM7.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $ltkM7.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        '0x1901'
    ];
    if (domain) parts.push($7c729bcae4d085b9$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== 'EIP712Domain') parts.push($7c729bcae4d085b9$export$4b8f67c208624fdf({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $1YOOf.keccak256)((0, $4KuzL.concat)(parts));
}
function $7c729bcae4d085b9$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $7c729bcae4d085b9$export$4b8f67c208624fdf({
        data: domain,
        primaryType: 'EIP712Domain',
        types: types
    });
}
function $7c729bcae4d085b9$export$4b8f67c208624fdf({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $7c729bcae4d085b9$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $1YOOf.keccak256)(encoded);
}
function $7c729bcae4d085b9$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: 'bytes32'
        }
    ];
    const encodedValues = [
        $7c729bcae4d085b9$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $7c729bcae4d085b9$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $lBZMD.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $7c729bcae4d085b9$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $cD3gI.toHex)($7c729bcae4d085b9$export$432cbecf661dce2b({
        primaryType: primaryType,
        types: types
    }));
    return (0, $1YOOf.keccak256)(encodedHashType);
}
function $7c729bcae4d085b9$export$432cbecf661dce2b({ primaryType: primaryType, types: types }) {
    let result = '';
    const unsortedDeps = $7c729bcae4d085b9$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(',')})`;
    return result;
}
function $7c729bcae4d085b9$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$7c729bcae4d085b9$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $7c729bcae4d085b9$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: 'bytes32'
        },
        (0, $1YOOf.keccak256)($7c729bcae4d085b9$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === 'bytes') return [
        {
            type: 'bytes32'
        },
        (0, $1YOOf.keccak256)(value)
    ];
    if (type === 'string') return [
        {
            type: 'bytes32'
        },
        (0, $1YOOf.keccak256)((0, $cD3gI.toHex)(value))
    ];
    if (type.lastIndexOf(']') === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf('['));
        const typeValuePairs = value.map((item)=>$7c729bcae4d085b9$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: 'bytes32'
            },
            (0, $1YOOf.keccak256)((0, $lBZMD.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}

});
parcelRegister("ltkM7", function(module, exports) {

$parcel$export(module.exports, "serializeTypedData", () => $fa1c6beb48afa579$export$ce8e1cf733064451);
$parcel$export(module.exports, "validateTypedData", () => $fa1c6beb48afa579$export$fac174f558903e26);
$parcel$export(module.exports, "getTypesForEIP712Domain", () => $fa1c6beb48afa579$export$6a292159484ee032);

var $dZdNo = parcelRequire("dZdNo");

var $eCsKB = parcelRequire("eCsKB");

var $aOLXi = parcelRequire("aOLXi");

var $9GvsK = parcelRequire("9GvsK");

var $2u1VO = parcelRequire("2u1VO");

var $cD3gI = parcelRequire("cD3gI");

var $6B71n = parcelRequire("6B71n");

var $aGqN7 = parcelRequire("aGqN7");

var $XRcTc = parcelRequire("XRcTc");
function $fa1c6beb48afa579$export$ce8e1cf733064451(parameters) {
    const { domain: domain_, message: message_, primaryType: primaryType, types: types } = parameters;
    const normalizeData = (struct, data_)=>{
        const data = {
            ...data_
        };
        for (const param of struct){
            const { name: name, type: type } = param;
            if (type === 'address') data[name] = data[name].toLowerCase();
        }
        return data;
    };
    const domain = (()=>{
        if (!types.EIP712Domain) return {};
        if (!domain_) return {};
        return normalizeData(types.EIP712Domain, domain_);
    })();
    const message = (()=>{
        if (primaryType === 'EIP712Domain') return undefined;
        return normalizeData(types[primaryType], message_);
    })();
    return (0, $XRcTc.stringify)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $fa1c6beb48afa579$export$fac174f558903e26(parameters) {
    const { domain: domain, message: message, primaryType: primaryType, types: types } = parameters;
    const validateData = (struct, data)=>{
        for (const param of struct){
            const { name: name, type: type } = param;
            const value = data[name];
            const integerMatch = type.match((0, $6B71n.integerRegex));
            if (integerMatch && (typeof value === 'number' || typeof value === 'bigint')) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $cD3gI.numberToHex)(value, {
                    signed: base === 'int',
                    size: Number.parseInt(size_, 10) / 8
                });
            }
            if (type === 'address' && typeof value === 'string' && !(0, $9GvsK.isAddress)(value)) throw new (0, $eCsKB.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $6B71n.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $2u1VO.size)(value) !== Number.parseInt(size_, 10)) throw new (0, $dZdNo.BytesSizeMismatchError)({
                    expectedSize: Number.parseInt(size_, 10),
                    givenSize: (0, $2u1VO.size)(value)
                });
            }
            const struct = types[type];
            if (struct) {
                $fa1c6beb48afa579$var$validateReference(type);
                validateData(struct, value);
            }
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) {
        if (typeof domain !== 'object') throw new (0, $aOLXi.InvalidDomainError)({
            domain: domain
        });
        validateData(types.EIP712Domain, domain);
    }
    // Validate message types.
    if (primaryType !== 'EIP712Domain') {
        if (types[primaryType]) validateData(types[primaryType], message);
        else throw new (0, $aOLXi.InvalidPrimaryTypeError)({
            primaryType: primaryType,
            types: types
        });
    }
}
function $fa1c6beb48afa579$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === 'string' && {
            name: 'name',
            type: 'string'
        },
        domain?.version && {
            name: 'version',
            type: 'string'
        },
        (typeof domain?.chainId === 'number' || typeof domain?.chainId === 'bigint') && {
            name: 'chainId',
            type: 'uint256'
        },
        domain?.verifyingContract && {
            name: 'verifyingContract',
            type: 'address'
        },
        domain?.salt && {
            name: 'salt',
            type: 'bytes32'
        }
    ].filter(Boolean);
}
function $fa1c6beb48afa579$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $aGqN7.hashDomain)({
        domain: domain,
        types: {
            EIP712Domain: $fa1c6beb48afa579$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}
/** @internal */ function $fa1c6beb48afa579$var$validateReference(type) {
    // Struct type must not be a Solidity type.
    if (type === 'address' || type === 'bool' || type === 'string' || type.startsWith('bytes') || type.startsWith('uint') || type.startsWith('int')) throw new (0, $aOLXi.InvalidStructTypeError)({
        type: type
    });
}

});
parcelRegister("aOLXi", function(module, exports) {

$parcel$export(module.exports, "InvalidDomainError", () => $7e03c5dac376aaba$export$2f1f6ca5fa8229f7);
$parcel$export(module.exports, "InvalidPrimaryTypeError", () => $7e03c5dac376aaba$export$7417b0e1e11c4de0);
$parcel$export(module.exports, "InvalidStructTypeError", () => $7e03c5dac376aaba$export$f3b7c25eb573510a);

var $XRcTc = parcelRequire("XRcTc");

var $5jfXj = parcelRequire("5jfXj");
class $7e03c5dac376aaba$export$2f1f6ca5fa8229f7 extends (0, $5jfXj.BaseError) {
    constructor({ domain: domain }){
        super(`Invalid domain "${(0, $XRcTc.stringify)(domain)}".`, {
            metaMessages: [
                'Must be a valid EIP-712 domain.'
            ]
        });
    }
}
class $7e03c5dac376aaba$export$7417b0e1e11c4de0 extends (0, $5jfXj.BaseError) {
    constructor({ primaryType: primaryType, types: types }){
        super(`Invalid primary type \`${primaryType}\` must be one of \`${JSON.stringify(Object.keys(types))}\`.`, {
            docsPath: '/api/glossary/Errors#typeddatainvalidprimarytypeerror',
            metaMessages: [
                'Check that the primary type is a key in `types`.'
            ]
        });
    }
}
class $7e03c5dac376aaba$export$f3b7c25eb573510a extends (0, $5jfXj.BaseError) {
    constructor({ type: type }){
        super(`Struct type "${type}" is invalid.`, {
            metaMessages: [
                'Struct type must not be a Solidity type.'
            ],
            name: 'InvalidStructTypeError'
        });
    }
}

});



parcelRegister("5QBI3", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $441f0f6ab0623e69$export$d09f50d9ab7f7b69);

var $7JEE8 = parcelRequire("7JEE8");

var $4zvKQ = parcelRequire("4zvKQ");
function $441f0f6ab0623e69$export$d09f50d9ab7f7b69({ key: key, methods: methods, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    const uid = (0, $4zvKQ.uid)();
    return {
        config: {
            key: key,
            methods: methods,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $7JEE8.buildRequest)(request, {
            methods: methods,
            retryCount: retryCount,
            retryDelay: retryDelay,
            uid: uid
        }),
        value: value
    };
}

});
parcelRegister("7JEE8", function(module, exports) {

$parcel$export(module.exports, "buildRequest", () => $5a1c43df0f4b4ba2$export$6c5295ef7e82f2b2);

var $5jfXj = parcelRequire("5jfXj");

var $jLSJ6 = parcelRequire("jLSJ6");

var $atQmZ = parcelRequire("atQmZ");

var $ebsn0 = parcelRequire("ebsn0");

var $gbXwm = parcelRequire("gbXwm");

var $3A9zH = parcelRequire("3A9zH");

var $XRcTc = parcelRequire("XRcTc");
function $5a1c43df0f4b4ba2$export$6c5295ef7e82f2b2(request, options = {}) {
    return async (args, overrideOptions = {})=>{
        const { dedupe: dedupe = false, methods: methods, retryDelay: retryDelay = 150, retryCount: retryCount = 3, signal: signal, uid: uid } = {
            ...options,
            ...overrideOptions
        };
        const { method: method } = args;
        if (methods?.exclude?.includes(method)) throw new (0, $atQmZ.MethodNotSupportedRpcError)(new Error('method not supported'), {
            method: method
        });
        if (methods?.include && !methods.include.includes(method)) throw new (0, $atQmZ.MethodNotSupportedRpcError)(new Error('method not supported'), {
            method: method
        });
        if (signal?.aborted) throw (0, $ebsn0.getAbortError)(signal);
        const requestId = dedupe ? $5a1c43df0f4b4ba2$var$hashString(`${uid}.${(0, $XRcTc.stringify)(args)}`) : undefined;
        return (0, $gbXwm.withDedupe)(()=>(0, $3A9zH.withRetry)(async ()=>{
                try {
                    return await request(args, signal ? {
                        signal: signal
                    } : undefined);
                } catch (err_) {
                    if (signal?.aborted) throw (0, $ebsn0.getAbortError)(signal);
                    if ((0, $ebsn0.isAbortError)(err_)) throw err_;
                    const err = err_;
                    switch(err.code){
                        // -32700
                        case (0, $atQmZ.ParseRpcError).code:
                            throw new (0, $atQmZ.ParseRpcError)(err);
                        // -32600
                        case (0, $atQmZ.InvalidRequestRpcError).code:
                            throw new (0, $atQmZ.InvalidRequestRpcError)(err);
                        // -32601
                        case (0, $atQmZ.MethodNotFoundRpcError).code:
                            throw new (0, $atQmZ.MethodNotFoundRpcError)(err, {
                                method: args.method
                            });
                        // -32602
                        case (0, $atQmZ.InvalidParamsRpcError).code:
                            throw new (0, $atQmZ.InvalidParamsRpcError)(err);
                        // -32603
                        case (0, $atQmZ.InternalRpcError).code:
                            throw new (0, $atQmZ.InternalRpcError)(err);
                        // -32000
                        case (0, $atQmZ.InvalidInputRpcError).code:
                            throw new (0, $atQmZ.InvalidInputRpcError)(err);
                        // -32001
                        case (0, $atQmZ.ResourceNotFoundRpcError).code:
                            throw new (0, $atQmZ.ResourceNotFoundRpcError)(err);
                        // -32002
                        case (0, $atQmZ.ResourceUnavailableRpcError).code:
                            throw new (0, $atQmZ.ResourceUnavailableRpcError)(err);
                        // -32003
                        case (0, $atQmZ.TransactionRejectedRpcError).code:
                            throw new (0, $atQmZ.TransactionRejectedRpcError)(err);
                        // -32004
                        case (0, $atQmZ.MethodNotSupportedRpcError).code:
                            throw new (0, $atQmZ.MethodNotSupportedRpcError)(err, {
                                method: args.method
                            });
                        // -32005
                        case (0, $atQmZ.LimitExceededRpcError).code:
                            throw new (0, $atQmZ.LimitExceededRpcError)(err);
                        // -32006
                        case (0, $atQmZ.JsonRpcVersionUnsupportedError).code:
                            throw new (0, $atQmZ.JsonRpcVersionUnsupportedError)(err);
                        // 4001
                        case (0, $atQmZ.UserRejectedRequestError).code:
                            throw new (0, $atQmZ.UserRejectedRequestError)(err);
                        // 4100
                        case (0, $atQmZ.UnauthorizedProviderError).code:
                            throw new (0, $atQmZ.UnauthorizedProviderError)(err);
                        // 4200
                        case (0, $atQmZ.UnsupportedProviderMethodError).code:
                            throw new (0, $atQmZ.UnsupportedProviderMethodError)(err);
                        // 4900
                        case (0, $atQmZ.ProviderDisconnectedError).code:
                            throw new (0, $atQmZ.ProviderDisconnectedError)(err);
                        // 4901
                        case (0, $atQmZ.ChainDisconnectedError).code:
                            throw new (0, $atQmZ.ChainDisconnectedError)(err);
                        // 4902
                        case (0, $atQmZ.SwitchChainError).code:
                            throw new (0, $atQmZ.SwitchChainError)(err);
                        // 5700
                        case (0, $atQmZ.UnsupportedNonOptionalCapabilityError).code:
                            throw new (0, $atQmZ.UnsupportedNonOptionalCapabilityError)(err);
                        // 5710
                        case (0, $atQmZ.UnsupportedChainIdError).code:
                            throw new (0, $atQmZ.UnsupportedChainIdError)(err);
                        // 5720
                        case (0, $atQmZ.DuplicateIdError).code:
                            throw new (0, $atQmZ.DuplicateIdError)(err);
                        // 5730
                        case (0, $atQmZ.UnknownBundleIdError).code:
                            throw new (0, $atQmZ.UnknownBundleIdError)(err);
                        // 5740
                        case (0, $atQmZ.BundleTooLargeError).code:
                            throw new (0, $atQmZ.BundleTooLargeError)(err);
                        // 5750
                        case (0, $atQmZ.AtomicReadyWalletRejectedUpgradeError).code:
                            throw new (0, $atQmZ.AtomicReadyWalletRejectedUpgradeError)(err);
                        // 5760
                        case (0, $atQmZ.AtomicityNotSupportedError).code:
                            throw new (0, $atQmZ.AtomicityNotSupportedError)(err);
                        // CAIP-25: User Rejected Error
                        // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                        case 5000:
                            throw new (0, $atQmZ.UserRejectedRequestError)(err);
                        // WalletConnect: Session Settlement Failed
                        // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes
                        case (0, $atQmZ.WalletConnectSessionSettlementError).code:
                            throw new (0, $atQmZ.WalletConnectSessionSettlementError)(err);
                        default:
                            if (err_ instanceof (0, $5jfXj.BaseError)) throw err_;
                            throw new (0, $atQmZ.UnknownRpcError)(err);
                    }
                }
            }, {
                delay: ({ count: count, error: error })=>{
                    // If we find a Retry-After header, let's retry after the given time.
                    if (error && error instanceof (0, $jLSJ6.HttpRequestError)) {
                        const retryAfter = error?.headers?.get('Retry-After');
                        if (retryAfter?.match(/\d/)) return Number.parseInt(retryAfter, 10) * 1000;
                    }
                    // Otherwise, let's retry with an exponential backoff.
                    return ~~(1 << count) * retryDelay;
                },
                retryCount: retryCount,
                signal: signal,
                shouldRetry: ({ error: error })=>$5a1c43df0f4b4ba2$export$7bfea3c3d460ecd8(error)
            }), {
            enabled: dedupe,
            id: requestId
        });
    };
}
function $5a1c43df0f4b4ba2$export$7bfea3c3d460ecd8(error) {
    if ((0, $ebsn0.isAbortError)(error)) return false;
    if ('code' in error && typeof error.code === 'number') {
        if (error.code === -1) return true; // Unknown error
        if (error.code === (0, $atQmZ.LimitExceededRpcError).code) return true;
        if (error.code === (0, $atQmZ.InternalRpcError).code) return true;
        // Too Many Requests — some providers (e.g. Alchemy in batch mode) return
        // HTTP 200 with a JSON-RPC body of `{ code: 429 }` instead of an HTTP 429,
        // so we need to handle this code in addition to the HTTP status check below.
        if (error.code === 429) return true;
        return false;
    }
    if (error instanceof (0, $jLSJ6.HttpRequestError) && error.status) {
        // Forbidden
        if (error.status === 403) return true;
        // Request Timeout
        if (error.status === 408) return true;
        // Request Entity Too Large
        if (error.status === 413) return true;
        // Too Many Requests
        if (error.status === 429) return true;
        // Internal Server Error
        if (error.status === 500) return true;
        // Bad Gateway
        if (error.status === 502) return true;
        // Service Unavailable
        if (error.status === 503) return true;
        // Gateway Timeout
        if (error.status === 504) return true;
        return false;
    }
    return true;
}
/** @internal cyrb53 – fast, non-cryptographic 53-bit string hash */ function $5a1c43df0f4b4ba2$var$hashString(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed;
    let h2 = 0x41c6ce57 ^ seed;
    for(let i = 0; i < str.length; i++){
        const ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 16, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 16, 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
}

});
parcelRegister("gbXwm", function(module, exports) {

$parcel$export(module.exports, "withDedupe", () => $bc9bd80bab485ea3$export$387c3b0c09132fc3);

var $4nYJj = parcelRequire("4nYJj");
const $bc9bd80bab485ea3$export$e89e805418f4d2c = /*#__PURE__*/ new (0, $4nYJj.LruMap)(8192);
function $bc9bd80bab485ea3$export$387c3b0c09132fc3(fn, { enabled: enabled = true, id: id }) {
    if (!enabled || !id) return fn();
    if ($bc9bd80bab485ea3$export$e89e805418f4d2c.get(id)) return $bc9bd80bab485ea3$export$e89e805418f4d2c.get(id);
    const promise = fn().finally(()=>$bc9bd80bab485ea3$export$e89e805418f4d2c.delete(id));
    $bc9bd80bab485ea3$export$e89e805418f4d2c.set(id, promise);
    return promise;
}

});

parcelRegister("3A9zH", function(module, exports) {

$parcel$export(module.exports, "withRetry", () => $29bc293a108140f2$export$188df5ecf8e7961a);

var $ebsn0 = parcelRequire("ebsn0");

var $h08PT = parcelRequire("h08PT");
function $29bc293a108140f2$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true, signal: signal } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            if (signal?.aborted) {
                reject((0, $ebsn0.getAbortError)(signal));
                return;
            }
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === 'function' ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) try {
                    await (0, $h08PT.wait)(delay, {
                        signal: signal
                    });
                } catch (err) {
                    reject(err);
                    return;
                }
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (signal?.aborted) {
                    reject((0, $ebsn0.getAbortError)(signal));
                    return;
                }
                if ((0, $ebsn0.isAbortError)(err)) {
                    reject(err);
                    return;
                }
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}

});


parcelRegister("4zvKQ", function(module, exports) {

$parcel$export(module.exports, "uid", () => $354310209ea4c546$export$e2a22331486dcca0);
const $354310209ea4c546$var$size = 256;
let $354310209ea4c546$var$index = $354310209ea4c546$var$size;
let $354310209ea4c546$var$buffer;
function $354310209ea4c546$export$e2a22331486dcca0(length = 11) {
    if (!$354310209ea4c546$var$buffer || $354310209ea4c546$var$index + length > $354310209ea4c546$var$size * 2) {
        $354310209ea4c546$var$buffer = '';
        $354310209ea4c546$var$index = 0;
        for(let i = 0; i < $354310209ea4c546$var$size; i++)$354310209ea4c546$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $354310209ea4c546$var$buffer.substring($354310209ea4c546$var$index, $354310209ea4c546$var$index++ + length);
}

});


parcelRegister("4XGvQ", function(module, exports) {

$parcel$export(module.exports, "secp256k1", () => $39cda63dbd5b7ce0$export$529e6123e9353a90);
/**
 * SECG secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Belongs to Koblitz curves: it has efficiently-computable GLV endomorphism ψ,
 * check out {@link EndomorphismOpts}. Seems to be rigid (not backdoored).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $bxlAd = parcelRequire("bxlAd");

var $hPdhr = parcelRequire("hPdhr");

var $jJK5w = parcelRequire("jJK5w");

var $eSCtp = parcelRequire("eSCtp");

var $5uCeY = parcelRequire("5uCeY");

var $67ErI = parcelRequire("67ErI");

var $hfStd = parcelRequire("hfStd");
var $hPdhr = parcelRequire("hPdhr");
var $hPdhr = parcelRequire("hPdhr");
// Seems like generator was produced from some seed:
// `Point.BASE.multiply(Point.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const $39cda63dbd5b7ce0$var$secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')
};
const $39cda63dbd5b7ce0$var$secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [
            BigInt('0x3086d221a7d46bcde86c90e49284eb15'),
            -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')
        ],
        [
            BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'),
            BigInt('0x3086d221a7d46bcde86c90e49284eb15')
        ]
    ]
};
const $39cda63dbd5b7ce0$var$_0n = /* @__PURE__ */ BigInt(0);
const $39cda63dbd5b7ce0$var$_1n = /* @__PURE__ */ BigInt(1);
const $39cda63dbd5b7ce0$var$_2n = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $39cda63dbd5b7ce0$var$sqrtMod(y) {
    const P = $39cda63dbd5b7ce0$var$secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $5uCeY.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $5uCeY.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $5uCeY.pow2)(b9, $39cda63dbd5b7ce0$var$_2n, P) * b2 % P;
    const b22 = (0, $5uCeY.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $5uCeY.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $5uCeY.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $5uCeY.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $5uCeY.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $5uCeY.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $5uCeY.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $5uCeY.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $5uCeY.pow2)(t2, $39cda63dbd5b7ce0$var$_2n, P);
    if (!$39cda63dbd5b7ce0$var$Fpk1.eql($39cda63dbd5b7ce0$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $39cda63dbd5b7ce0$var$Fpk1 = (0, $5uCeY.Field)($39cda63dbd5b7ce0$var$secp256k1_CURVE.p, {
    sqrt: $39cda63dbd5b7ce0$var$sqrtMod
});
const $39cda63dbd5b7ce0$export$529e6123e9353a90 = (0, $jJK5w.createCurve)({
    ...$39cda63dbd5b7ce0$var$secp256k1_CURVE,
    Fp: $39cda63dbd5b7ce0$var$Fpk1,
    lowS: true,
    endo: $39cda63dbd5b7ce0$var$secp256k1_ENDO
}, (0, $bxlAd.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $39cda63dbd5b7ce0$var$TAGGED_HASH_PREFIXES = {};
function $39cda63dbd5b7ce0$var$taggedHash(tag, ...messages) {
    let tagP = $39cda63dbd5b7ce0$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $bxlAd.sha256)((0, $hPdhr.utf8ToBytes)(tag));
        tagP = (0, $hPdhr.concatBytes)(tagH, tagH);
        $39cda63dbd5b7ce0$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $bxlAd.sha256)((0, $hPdhr.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $39cda63dbd5b7ce0$var$pointToBytes = (point)=>point.toBytes(true).slice(1);
const $39cda63dbd5b7ce0$var$Pointk1 = /* @__PURE__ */ (()=>$39cda63dbd5b7ce0$export$529e6123e9353a90.Point)();
const $39cda63dbd5b7ce0$var$hasEven = (y)=>y % $39cda63dbd5b7ce0$var$_2n === $39cda63dbd5b7ce0$var$_0n;
// Calculate point, scalar and bytes
function $39cda63dbd5b7ce0$var$schnorrGetExtPubKey(priv) {
    const { Fn: Fn, BASE: BASE } = $39cda63dbd5b7ce0$var$Pointk1;
    const d_ = (0, $67ErI._normFnElement)(Fn, priv);
    const p = BASE.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = $39cda63dbd5b7ce0$var$hasEven(p.y) ? d_ : Fn.neg(d_);
    return {
        scalar: scalar,
        bytes: $39cda63dbd5b7ce0$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $39cda63dbd5b7ce0$var$lift_x(x) {
    const Fp = $39cda63dbd5b7ce0$var$Fpk1;
    if (!Fp.isValidNot0(x)) throw new Error("invalid x: Fail if x \u2265 p");
    const xx = Fp.create(x * x);
    const c = Fp.create(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = Fp.sqrt(c); // Let y = c^(p+1)/4 mod p. Same as sqrt().
    // Return the unique point P such that x(P) = x and
    // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    if (!$39cda63dbd5b7ce0$var$hasEven(y)) y = Fp.neg(y);
    const p = $39cda63dbd5b7ce0$var$Pointk1.fromAffine({
        x: x,
        y: y
    });
    p.assertValidity();
    return p;
}
const $39cda63dbd5b7ce0$var$num = (0, $hfStd.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $39cda63dbd5b7ce0$var$challenge(...args) {
    return $39cda63dbd5b7ce0$var$Pointk1.Fn.create($39cda63dbd5b7ce0$var$num($39cda63dbd5b7ce0$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $39cda63dbd5b7ce0$var$schnorrGetPublicKey(secretKey) {
    return $39cda63dbd5b7ce0$var$schnorrGetExtPubKey(secretKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $39cda63dbd5b7ce0$var$schnorrSign(message, secretKey, auxRand = (0, $hPdhr.randomBytes)(32)) {
    const { Fn: Fn } = $39cda63dbd5b7ce0$var$Pointk1;
    const m = (0, $hfStd.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = $39cda63dbd5b7ce0$var$schnorrGetExtPubKey(secretKey); // checks for isWithinCurveOrder
    const a = (0, $hfStd.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = Fn.toBytes(d ^ $39cda63dbd5b7ce0$var$num($39cda63dbd5b7ce0$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $39cda63dbd5b7ce0$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    // Let k' = int(rand) mod n. Fail if k' = 0. Let R = k'⋅G
    const { bytes: rx, scalar: k } = $39cda63dbd5b7ce0$var$schnorrGetExtPubKey(rand);
    const e = $39cda63dbd5b7ce0$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(Fn.toBytes(Fn.create(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$39cda63dbd5b7ce0$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $39cda63dbd5b7ce0$var$schnorrVerify(signature, message, publicKey) {
    const { Fn: Fn, BASE: BASE } = $39cda63dbd5b7ce0$var$Pointk1;
    const sig = (0, $hfStd.ensureBytes)('signature', signature, 64);
    const m = (0, $hfStd.ensureBytes)('message', message);
    const pub = (0, $hfStd.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = $39cda63dbd5b7ce0$var$lift_x($39cda63dbd5b7ce0$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $39cda63dbd5b7ce0$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $hfStd.inRange)(r, $39cda63dbd5b7ce0$var$_1n, $39cda63dbd5b7ce0$var$secp256k1_CURVE.p)) return false;
        const s = $39cda63dbd5b7ce0$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $hfStd.inRange)(s, $39cda63dbd5b7ce0$var$_1n, $39cda63dbd5b7ce0$var$secp256k1_CURVE.n)) return false;
        // int(challenge(bytes(r)||bytes(P)||m))%n
        const e = $39cda63dbd5b7ce0$var$challenge(Fn.toBytes(r), $39cda63dbd5b7ce0$var$pointToBytes(P), m);
        // R = s⋅G - e⋅P, where -eP == (n-e)P
        const R = BASE.multiplyUnsafe(s).add(P.multiplyUnsafe(Fn.neg(e)));
        const { x: x, y: y } = R.toAffine();
        // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        if (R.is0() || !$39cda63dbd5b7ce0$var$hasEven(y) || x !== r) return false;
        return true;
    } catch (error) {
        return false;
    }
}
const $39cda63dbd5b7ce0$export$1f2401df071be9f = /* @__PURE__ */ (()=>{
    const size = 32;
    const seedLength = 48;
    const randomSecretKey = (seed = (0, $hPdhr.randomBytes)(seedLength))=>{
        return (0, $5uCeY.mapHashToField)(seed, $39cda63dbd5b7ce0$var$secp256k1_CURVE.n);
    };
    // TODO: remove
    $39cda63dbd5b7ce0$export$529e6123e9353a90.utils.randomSecretKey;
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: $39cda63dbd5b7ce0$var$schnorrGetPublicKey(secretKey)
        };
    }
    return {
        keygen: keygen,
        getPublicKey: $39cda63dbd5b7ce0$var$schnorrGetPublicKey,
        sign: $39cda63dbd5b7ce0$var$schnorrSign,
        verify: $39cda63dbd5b7ce0$var$schnorrVerify,
        Point: $39cda63dbd5b7ce0$var$Pointk1,
        utils: {
            randomSecretKey: randomSecretKey,
            randomPrivateKey: randomSecretKey,
            taggedHash: $39cda63dbd5b7ce0$var$taggedHash,
            lift_x: // TODO: remove
            $39cda63dbd5b7ce0$var$lift_x,
            pointToBytes: $39cda63dbd5b7ce0$var$pointToBytes,
            numberToBytesBE: $hfStd.numberToBytesBE,
            bytesToNumberBE: $hfStd.bytesToNumberBE,
            mod: $5uCeY.mod
        },
        lengths: {
            secretKey: size,
            publicKey: size,
            publicKeyHasPrefix: false,
            signature: size * 2,
            seed: seedLength
        }
    };
})();
const $39cda63dbd5b7ce0$var$isoMap = /* @__PURE__ */ (()=>(0, $eSCtp.isogenyMap)($39cda63dbd5b7ce0$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $39cda63dbd5b7ce0$var$mapSWU = /* @__PURE__ */ (()=>(0, $67ErI.mapToCurveSimpleSWU)($39cda63dbd5b7ce0$var$Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $39cda63dbd5b7ce0$var$Fpk1.create(BigInt('-11'))
    }))();
const $39cda63dbd5b7ce0$export$e7a33585c78e532a = /* @__PURE__ */ (()=>(0, $eSCtp.createHasher)($39cda63dbd5b7ce0$export$529e6123e9353a90.Point, (scalars)=>{
        const { x: x, y: y } = $39cda63dbd5b7ce0$var$mapSWU($39cda63dbd5b7ce0$var$Fpk1.create(scalars[0]));
        return $39cda63dbd5b7ce0$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $39cda63dbd5b7ce0$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $bxlAd.sha256)
    }))();
const $39cda63dbd5b7ce0$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$39cda63dbd5b7ce0$export$e7a33585c78e532a.hashToCurve)();
const $39cda63dbd5b7ce0$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$39cda63dbd5b7ce0$export$e7a33585c78e532a.encodeToCurve)();

});
parcelRegister("jJK5w", function(module, exports) {

$parcel$export(module.exports, "createCurve", () => $e5e5f8711334e882$export$3f2f6721dd02558a);
/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $67ErI = parcelRequire("67ErI");
function $e5e5f8711334e882$export$adaba664e531641c(hash) {
    return {
        hash: hash
    };
}
function $e5e5f8711334e882$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $67ErI.weierstrass)({
            ...curveDef,
            hash: hash
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("67ErI", function(module, exports) {

$parcel$export(module.exports, "_normFnElement", () => $4752c543c21ed315$export$e10a6dd187c1fa22);
$parcel$export(module.exports, "mapToCurveSimpleSWU", () => $4752c543c21ed315$export$cc7fea9756a17416);
$parcel$export(module.exports, "weierstrass", () => $4752c543c21ed315$export$350b8ea6f1c27fae);
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $cfqW9 = parcelRequire("cfqW9");

var $hPdhr = parcelRequire("hPdhr");

var $hfStd = parcelRequire("hfStd");
var $hPdhr = parcelRequire("hPdhr");
var $hPdhr = parcelRequire("hPdhr");

var $c8GJ8 = parcelRequire("c8GJ8");

var $5uCeY = parcelRequire("5uCeY");
// We construct basis in such way that den is always positive and equals n, but num sign depends on basis (not on secret value)
const $4752c543c21ed315$var$divNearest = (num, den)=>(num + (num >= 0 ? den : -den) / $4752c543c21ed315$var$_2n) / den;
function $4752c543c21ed315$export$2e78c1c514ef8576(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = $4752c543c21ed315$var$divNearest(b2 * k, n);
    const c2 = $4752c543c21ed315$var$divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < $4752c543c21ed315$var$_0n;
    const k2neg = k2 < $4752c543c21ed315$var$_0n;
    if (k1neg) k1 = -k1;
    if (k2neg) k2 = -k2;
    // Double check that resulting scalar less than half bits of N: otherwise wNAF will fail.
    // This should only happen on wrong basises. Also, math inside is too complex and I don't trust it.
    const MAX_NUM = (0, $hfStd.bitMask)(Math.ceil((0, $hfStd.bitLen)(n) / 2)) + $4752c543c21ed315$var$_1n; // Half bits of N
    if (k1 < $4752c543c21ed315$var$_0n || k1 >= MAX_NUM || k2 < $4752c543c21ed315$var$_0n || k2 >= MAX_NUM) throw new Error('splitScalar (endomorphism): failed, k=' + k);
    return {
        k1neg: k1neg,
        k1: k1,
        k2neg: k2neg,
        k2: k2
    };
}
function $4752c543c21ed315$var$validateSigFormat(format) {
    if (![
        'compact',
        'recovered',
        'der'
    ].includes(format)) throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function $4752c543c21ed315$var$validateSigOpts(opts, def) {
    const optsn = {};
    for (let optName of Object.keys(def))// @ts-ignore
    optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    (0, $hfStd._abool2)(optsn.lowS, 'lowS');
    (0, $hfStd._abool2)(optsn.prehash, 'prehash');
    if (optsn.format !== undefined) $4752c543c21ed315$var$validateSigFormat(optsn.format);
    return optsn;
}
class $4752c543c21ed315$export$523a36accd0afb37 extends Error {
    constructor(m = ''){
        super(m);
    }
}
const $4752c543c21ed315$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: $4752c543c21ed315$export$523a36accd0afb37,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $4752c543c21ed315$export$56ac33195d7076db;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = (0, $hfStd.numberToHexUnpadded)(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, $hfStd.numberToHexUnpadded)(len.length / 2 | 128) : '';
            const t = (0, $hfStd.numberToHexUnpadded)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $4752c543c21ed315$export$56ac33195d7076db;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $4752c543c21ed315$export$56ac33195d7076db;
            if (num < $4752c543c21ed315$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = (0, $hfStd.numberToHexUnpadded)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = $4752c543c21ed315$export$56ac33195d7076db;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return (0, $hfStd.bytesToNumberBE)(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $4752c543c21ed315$export$56ac33195d7076db;
        const data = (0, $hfStd.ensureBytes)('signature', hex);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $4752c543c21ed315$export$56ac33195d7076db;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $4752c543c21ed315$var$_0n = BigInt(0), $4752c543c21ed315$var$_1n = BigInt(1), $4752c543c21ed315$var$_2n = BigInt(2), $4752c543c21ed315$var$_3n = BigInt(3), $4752c543c21ed315$var$_4n = BigInt(4);
function $4752c543c21ed315$export$e10a6dd187c1fa22(Fn, key) {
    const { BYTES: expected } = Fn;
    let num;
    if (typeof key === 'bigint') num = key;
    else {
        let bytes = (0, $hfStd.ensureBytes)('private key', key);
        try {
            num = Fn.fromBytes(bytes);
        } catch (error) {
            throw new Error(`invalid private key: expected ui8a of size ${expected}, got ${typeof key}`);
        }
    }
    if (!Fn.isValidNot0(num)) throw new Error('invalid private key: out of range [1..N-1]');
    return num;
}
function $4752c543c21ed315$export$66856fb9690920c4(params, extraOpts = {}) {
    const validated = (0, $c8GJ8._createCurveFields)('weierstrass', params, extraOpts);
    const { Fp: Fp, Fn: Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    (0, $hfStd._validateObject)(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object',
        wrapPrivateKey: 'boolean'
    });
    const { endo: endo } = extraOpts;
    if (endo) {
        // validateObject(endo, { beta: 'bigint', splitScalar: 'function' });
        if (!Fp.is0(CURVE.a) || typeof endo.beta !== 'bigint' || !Array.isArray(endo.basises)) throw new Error('invalid endo: expected "beta": bigint and "basises": array');
    }
    const lengths = $4752c543c21ed315$var$getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd) throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        const { x: x, y: y } = point.toAffine();
        const bx = Fp.toBytes(x);
        (0, $hfStd._abool2)(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return (0, $hPdhr.concatBytes)($4752c543c21ed315$var$pprefix(hasEvenY), bx);
        } else return (0, $hPdhr.concatBytes)(Uint8Array.of(0x04), bx, Fp.toBytes(y));
    }
    function pointFromBytes(bytes) {
        (0, $hfStd._abytes2)(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x)) throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            } catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const isYOdd = Fp.isOdd(y); // (y & _1n) === _1n;
            const isHeadOdd = (head & 1) === 1; // ECDSA-specific
            if (isHeadOdd !== isYOdd) y = Fp.neg(y);
            return {
                x: x,
                y: y
            };
        } else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y)) throw new Error('bad point: is not on curve');
            return {
                x: x,
                y: y
            };
        } else throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
    }
    const encodePoint = extraOpts.toBytes || pointToBytes;
    const decodePoint = extraOpts.fromBytes || pointFromBytes;
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */ function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, $4752c543c21ed315$var$_3n), $4752c543c21ed315$var$_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2))) throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */ function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || banZero && Fp.is0(n)) throw new Error(`bad point coordinate ${title}`);
        return n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises) throw new Error('no endo');
        return $4752c543c21ed315$export$2e78c1c514ef8576(k, endo.basises, Fn.ORDER);
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = (0, $hfStd.memoized)((p, iz)=>{
        const { X: X, Y: Y, Z: Z } = p;
        // Fast-path for normalized points
        if (Fp.eql(Z, Fp.ONE)) return {
            x: X,
            y: Y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(Z);
        const x = Fp.mul(X, iz);
        const y = Fp.mul(Y, iz);
        const zz = Fp.mul(Z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: x,
            y: y
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $hfStd.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (extraOpts.allowInfinityPoint && !Fp.is0(p.Y)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not field elements');
        if (!isValidXY(x, y)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    function finishEndo(endoBeta, k1p, k2p, k1neg, k2neg) {
        k2p = new Point(Fp.mul(k2p.X, endoBeta), k2p.Y, k2p.Z);
        k1p = (0, $c8GJ8.negateCt)(k1neg, k1p);
        k2p = (0, $c8GJ8.negateCt)(k2neg, k2p);
        return k1p.add(k2p);
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ constructor(X, Y, Z){
            this.X = acoord('x', X);
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint((0, $hfStd._abytes2)(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes((0, $hfStd.ensureBytes)('pointHex', hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */ precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy) this.multiply($4752c543c21ed315$var$_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */ assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (!Fp.isOdd) throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */ equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */ negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $4752c543c21ed315$var$_3n);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $4752c543c21ed315$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo } = extraOpts;
            if (!Fn.isValidNot0(scalar)) throw new Error('invalid scalar: out of range'); // 0 is invalid
            let point, fake; // Fake point is used to const-time mult
            const mul = (n)=>wnaf.cached(this, n, (p)=>(0, $c8GJ8.normalizeZ)(Point, p));
            /** See docs for {@link EndomorphismOpts} */ if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(scalar);
                const { p: k1p, f: k1f } = mul(k1);
                const { p: k2p, f: k2f } = mul(k2);
                fake = k1f.add(k2f);
                point = finishEndo(endo.beta, k1p, k2p, k1neg, k2neg);
            } else {
                const { p: p, f: f } = mul(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return (0, $c8GJ8.normalizeZ)(Point, [
                point,
                fake
            ])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo } = extraOpts;
            const p = this;
            if (!Fn.isValid(sc)) throw new Error('invalid scalar: out of range'); // 0 is valid
            if (sc === $4752c543c21ed315$var$_0n || p.is0()) return Point.ZERO;
            if (sc === $4752c543c21ed315$var$_1n) return p; // fast-path
            if (wnaf.hasCache(this)) return this.multiply(sc);
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(sc);
                const { p1: p1, p2: p2 } = (0, $c8GJ8.mulEndoUnsafe)(Point, p, k1, k2); // 30% faster vs wnaf.unsafe
                return finishEndo(endo.beta, p1, p2, k1neg, k2neg);
            } else return wnaf.unsafe(p, sc);
        }
        multiplyAndAddUnsafe(Q, a, b) {
            const sum = this.multiplyUnsafe(a).add(Q.multiplyUnsafe(b));
            return sum.is0() ? undefined : sum;
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */ toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */ isTorsionFree() {
            const { isTorsionFree: isTorsionFree } = extraOpts;
            if (cofactor === $4752c543c21ed315$var$_1n) return true;
            if (isTorsionFree) return isTorsionFree(Point, this);
            return wnaf.unsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            const { clearCofactor: clearCofactor } = extraOpts;
            if (cofactor === $4752c543c21ed315$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            // can we use this.clearCofactor()?
            return this.multiplyUnsafe(cofactor).is0();
        }
        toBytes(isCompressed = true) {
            (0, $hfStd._abool2)(isCompressed, 'isCompressed');
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return (0, $hPdhr.bytesToHex)(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
        // TODO: remove
        get px() {
            return this.X;
        }
        get py() {
            return this.X;
        }
        get pz() {
            return this.Z;
        }
        toRawBytes(isCompressed = true) {
            return this.toBytes(isCompressed);
        }
        _setWindowSize(windowSize) {
            this.precompute(windowSize);
        }
        static normalizeZ(points) {
            return (0, $c8GJ8.normalizeZ)(Point, points);
        }
        static msm(points, scalars) {
            return (0, $c8GJ8.pippenger)(Point, Fn, points, scalars);
        }
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply($4752c543c21ed315$export$e10a6dd187c1fa22(Fn, privateKey));
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    // zero / infinity / identity point
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
    // math field
    Point.Fp = Fp;
    // scalar field
    Point.Fn = Fn;
    const bits = Fn.BITS;
    const wnaf = new (0, $c8GJ8.wNAF)(Point, extraOpts.endo ? Math.ceil(bits / 2) : bits);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function $4752c543c21ed315$var$pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
function $4752c543c21ed315$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $4752c543c21ed315$var$_0n;
    for(let o = q - $4752c543c21ed315$var$_1n; o % $4752c543c21ed315$var$_2n === $4752c543c21ed315$var$_0n; o /= $4752c543c21ed315$var$_2n)l += $4752c543c21ed315$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $4752c543c21ed315$var$_2n << c1 - $4752c543c21ed315$var$_1n - $4752c543c21ed315$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $4752c543c21ed315$var$_2n;
    const c2 = (q - $4752c543c21ed315$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $4752c543c21ed315$var$_1n) / $4752c543c21ed315$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $4752c543c21ed315$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $4752c543c21ed315$var$_1n) / $4752c543c21ed315$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $4752c543c21ed315$var$_1n; i--){
            let tv5 = i - $4752c543c21ed315$var$_2n; // 18.    tv5 = i - 2
            tv5 = $4752c543c21ed315$var$_2n << tv5 - $4752c543c21ed315$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $4752c543c21ed315$var$_4n === $4752c543c21ed315$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $4752c543c21ed315$var$_3n) / $4752c543c21ed315$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $4752c543c21ed315$export$cc7fea9756a17416(Fp, opts) {
    (0, $5uCeY.validateField)(Fp);
    const { A: A, B: B, Z: Z } = opts;
    if (!Fp.isValid(A) || !Fp.isValid(B) || !Fp.isValid(Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $4752c543c21ed315$export$8324ae9483e33241(Fp, Z);
    if (!Fp.isOdd) throw new Error('Field does not have .isOdd()');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, $5uCeY.FpInvertBatch)(Fp, [
            tv4
        ], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
function $4752c543c21ed315$var$getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        signature: 2 * Fn.BYTES
    };
}
function $4752c543c21ed315$export$cb44b25bcf287f5d(Point, ecdhOpts = {}) {
    const { Fn: Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes || (0, $hPdhr.randomBytes);
    const lengths = Object.assign($4752c543c21ed315$var$getWLengths(Point.Fp, Fn), {
        seed: (0, $5uCeY.getMinHashLength)(Fn.ORDER)
    });
    function isValidSecretKey(secretKey) {
        try {
            return !!$4752c543c21ed315$export$e10a6dd187c1fa22(Fn, secretKey);
        } catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp) return false;
            if (isCompressed === false && l !== publicKeyUncompressed) return false;
            return !!Point.fromBytes(publicKey);
        } catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */ function randomSecretKey(seed = randomBytes_(lengths.seed)) {
        return (0, $5uCeY.mapHashToField)((0, $hfStd._abytes2)(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply($4752c543c21ed315$export$e10a6dd187c1fa22(Fn, secretKey)).toBytes(isCompressed);
    }
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        if (typeof item === 'bigint') return false;
        if (item instanceof Point) return true;
        const { secretKey: secretKey, publicKey: publicKey, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        if (Fn.allowedLengths || secretKey === publicKey) return undefined;
        const l = (0, $hfStd.ensureBytes)('key', item).length;
        return l === publicKey || l === publicKeyUncompressed;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true) throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false) throw new Error('second arg must be public key');
        const s = $4752c543c21ed315$export$e10a6dd187c1fa22(Fn, secretKeyA);
        const b = Point.fromHex(publicKeyB); // checks for being on-curve
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        randomSecretKey: randomSecretKey,
        // TODO: remove
        isValidPrivateKey: isValidSecretKey,
        randomPrivateKey: randomSecretKey,
        normPrivateKeyToScalar: (key)=>$4752c543c21ed315$export$e10a6dd187c1fa22(Fn, key),
        precompute (windowSize = 8, point = Point.BASE) {
            return point.precompute(windowSize, false);
        }
    };
    return Object.freeze({
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        keygen: keygen,
        Point: Point,
        utils: utils,
        lengths: lengths
    });
}
function $4752c543c21ed315$export$4812c9a1c4ca02a(Point, hash, ecdsaOpts = {}) {
    (0, $hPdhr.ahash)(hash);
    (0, $hfStd._validateObject)(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function'
    });
    const randomBytes = ecdsaOpts.randomBytes || (0, $hPdhr.randomBytes);
    const hmac = ecdsaOpts.hmac || ((key, ...msgs)=>(0, $cfqW9.hmac)(hash, key, (0, $hPdhr.concatBytes)(...msgs)));
    const { Fp: Fp, Fn: Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    const { keygen: keygen, getPublicKey: getPublicKey, getSharedSecret: getSharedSecret, utils: utils, lengths: lengths } = $4752c543c21ed315$export$cb44b25bcf287f5d(Point, ecdsaOpts);
    const defaultSigOpts = {
        prehash: false,
        lowS: typeof ecdsaOpts.lowS === 'boolean' ? ecdsaOpts.lowS : false,
        format: undefined,
        extraEntropy: false
    };
    const defaultSigOpts_format = 'compact';
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $4752c543c21ed315$var$_1n;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num)) throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function validateSigLength(bytes, format) {
        $4752c543c21ed315$var$validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return (0, $hfStd._abytes2)(bytes, sizer, `${format} signature`);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null) this.recovery = recovery;
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts_format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                const { r: r, s: s } = $4752c543c21ed315$export$56ac33195d7076db.toSig((0, $hfStd._abytes2)(bytes));
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = Fn.BYTES;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes((0, $hPdhr.hexToBytes)(hex), format);
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(messageHash) {
            const FIELD_ORDER = Fp.ORDER;
            const { r: r, s: s, recovery: rec } = this;
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            // ECDSA recovery is hard for cofactor > 1 curves.
            // In sign, `r = q.x mod n`, and here we recover q.x from r.
            // While recovering q.x >= n, we need to add r+n for cofactor=1 curves.
            // However, for cofactor>1, r+n may not get q.x:
            // r+n*i would need to be done instead where i is unknown.
            // To easily get i, we either need to:
            // a. increase amount of valid recid values (4, 5...); OR
            // b. prohibit non-prime-order signatures (recid > 1).
            const hasCofactor = CURVE_ORDER * $4752c543c21ed315$var$_2n < FIELD_ORDER;
            if (hasCofactor && rec > 1) throw new Error('recovery id is ambiguous for h>1 curve');
            const radj = rec === 2 || rec === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj)) throw new Error('recovery id 2 or 3 invalid');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes((0, $hPdhr.concatBytes)($4752c543c21ed315$var$pprefix((rec & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN((0, $hfStd.ensureBytes)('msgHash', messageHash)); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.multiplyUnsafe(u1).add(R.multiplyUnsafe(u2));
            if (Q.is0()) throw new Error('point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts_format) {
            $4752c543c21ed315$var$validateSigFormat(format);
            if (format === 'der') return (0, $hPdhr.hexToBytes)($4752c543c21ed315$export$56ac33195d7076db.hexFromSig(this));
            const r = Fn.toBytes(this.r);
            const s = Fn.toBytes(this.s);
            if (format === 'recovered') {
                if (this.recovery == null) throw new Error('recovery bit must be present');
                return (0, $hPdhr.concatBytes)(Uint8Array.of(this.recovery), r, s);
            }
            return (0, $hPdhr.concatBytes)(r, s);
        }
        toHex(format) {
            return (0, $hPdhr.bytesToHex)(this.toBytes(format));
        }
        // TODO: remove
        assertValidity() {}
        static fromCompact(hex) {
            return Signature.fromBytes((0, $hfStd.ensureBytes)('sig', hex), 'compact');
        }
        static fromDER(hex) {
            return Signature.fromBytes((0, $hfStd.ensureBytes)('sig', hex), 'der');
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, Fn.neg(this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return this.toBytes('der');
        }
        toDERHex() {
            return (0, $hPdhr.bytesToHex)(this.toBytes('der'));
        }
        toCompactRawBytes() {
            return this.toBytes('compact');
        }
        toCompactHex() {
            return (0, $hPdhr.bytesToHex)(this.toBytes('compact'));
        }
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = ecdsaOpts.bits2int || function bits2int_def(bytes) {
        // Our custom check "just in case", for protection against DoS
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, $hfStd.bytesToNumberBE)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = ecdsaOpts.bits2int_modN || function bits2int_modN_def(bytes) {
        return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // Pads output with zero as per spec
    const ORDER_MASK = (0, $hfStd.bitMask)(fnBits);
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */ function int2octets(num) {
        // IMPORTANT: the check ensures working for case `Fn.BYTES != Fn.BITS * 8`
        (0, $hfStd.aInRange)('num < 2^' + fnBits, num, $4752c543c21ed315$var$_0n, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        (0, $hfStd._abytes2)(message, undefined, 'message');
        return prehash ? (0, $hfStd._abytes2)(hash(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */ function prepSig(message, privateKey, opts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { lowS: lowS, prehash: prehash, extraEntropy: extraEntropy } = $4752c543c21ed315$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = $4752c543c21ed315$export$e10a6dd187c1fa22(Fn, privateKey); // validate secret key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes(lengths.secretKey) : extraEntropy;
            seedArgs.push((0, $hfStd.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = (0, $hPdhr.concatBytes)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
        // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // mod n, not mod p
            if (!Fn.isValidNot0(k)) return; // Valid scalars (including k) must be in 1..N-1
            const ik = Fn.inv(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === $4752c543c21ed315$var$_0n) return;
            const s = Fn.create(ik * Fn.create(m + r * d)); // Not using blinding here, see comment above
            if (s === $4752c543c21ed315$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $4752c543c21ed315$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    /**
     * Signs message hash with a secret key.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */ function sign(message, secretKey, opts = {}) {
        message = (0, $hfStd.ensureBytes)('message', message);
        const { seed: seed, k2sig: k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = (0, $hfStd.createHmacDrbg)(hash.outputLen, Fn.BYTES, hmac);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig;
    }
    function tryParsingSig(sg) {
        // Try to deduce format
        let sig = undefined;
        const isHex = typeof sg === 'string' || (0, $hPdhr.isBytes)(sg);
        const isObj = !isHex && sg !== null && typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint';
        if (!isHex && !isObj) throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        if (isObj) sig = new Signature(sg.r, sg.s);
        else if (isHex) {
            try {
                sig = Signature.fromBytes((0, $hfStd.ensureBytes)('sig', sg), 'der');
            } catch (derError) {
                if (!(derError instanceof $4752c543c21ed315$export$56ac33195d7076db.Err)) throw derError;
            }
            if (!sig) try {
                sig = Signature.fromBytes((0, $hfStd.ensureBytes)('sig', sg), 'compact');
            } catch (error) {
                return false;
            }
        }
        if (!sig) return false;
        return sig;
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, message, publicKey, opts = {}) {
        const { lowS: lowS, prehash: prehash, format: format } = $4752c543c21ed315$var$validateSigOpts(opts, defaultSigOpts);
        publicKey = (0, $hfStd.ensureBytes)('publicKey', publicKey);
        message = validateMsgAndHash((0, $hfStd.ensureBytes)('message', message), prehash);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        const sig = format === undefined ? tryParsingSig(signature) : Signature.fromBytes((0, $hfStd.ensureBytes)('sig', signature), format);
        if (sig === false) return false;
        try {
            const P = Point.fromBytes(publicKey);
            if (lowS && sig.hasHighS()) return false;
            const { r: r, s: s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.multiplyUnsafe(u1).add(P.multiplyUnsafe(u2)); // u1⋅G + u2⋅P
            if (R.is0()) return false;
            const v = Fn.create(R.x); // v = r.x mod n
            return v === r;
        } catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        const { prehash: prehash } = $4752c543c21ed315$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        utils: utils,
        lengths: lengths,
        Point: Point,
        sign: sign,
        verify: verify,
        recoverPublicKey: recoverPublicKey,
        Signature: Signature,
        hash: hash
    });
}
function $4752c543c21ed315$export$fa783af82e4fe0fc(c) {
    const { CURVE: CURVE, curveOpts: curveOpts } = $4752c543c21ed315$var$_weierstrass_legacy_opts_to_new(c);
    const Point = $4752c543c21ed315$export$66856fb9690920c4(CURVE, curveOpts);
    return $4752c543c21ed315$var$_weierstrass_new_output_to_legacy(c, Point);
}
function $4752c543c21ed315$var$_weierstrass_legacy_opts_to_new(c) {
    const CURVE = {
        a: c.a,
        b: c.b,
        p: c.Fp.ORDER,
        n: c.n,
        h: c.h,
        Gx: c.Gx,
        Gy: c.Gy
    };
    const Fp = c.Fp;
    let allowedLengths = c.allowedPrivateKeyLengths ? Array.from(new Set(c.allowedPrivateKeyLengths.map((l)=>Math.ceil(l / 2)))) : undefined;
    const Fn = (0, $5uCeY.Field)(CURVE.n, {
        BITS: c.nBitLength,
        allowedLengths: allowedLengths,
        modFromBytes: c.wrapPrivateKey
    });
    const curveOpts = {
        Fp: Fp,
        Fn: Fn,
        allowInfinityPoint: c.allowInfinityPoint,
        endo: c.endo,
        isTorsionFree: c.isTorsionFree,
        clearCofactor: c.clearCofactor,
        fromBytes: c.fromBytes,
        toBytes: c.toBytes
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts
    };
}
function $4752c543c21ed315$var$_ecdsa_legacy_opts_to_new(c) {
    const { CURVE: CURVE, curveOpts: curveOpts } = $4752c543c21ed315$var$_weierstrass_legacy_opts_to_new(c);
    const ecdsaOpts = {
        hmac: c.hmac,
        randomBytes: c.randomBytes,
        lowS: c.lowS,
        bits2int: c.bits2int,
        bits2int_modN: c.bits2int_modN
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts,
        hash: c.hash,
        ecdsaOpts: ecdsaOpts
    };
}
function $4752c543c21ed315$export$69061cf37a03f1(Fp, a, b) {
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula. Takes x, returns y².
     * @returns y²
     */ function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x³ + a * x + b
    }
    return weierstrassEquation;
}
function $4752c543c21ed315$var$_weierstrass_new_output_to_legacy(c, Point) {
    const { Fp: Fp, Fn: Fn } = Point;
    function isWithinCurveOrder(num) {
        return (0, $hfStd.inRange)(num, $4752c543c21ed315$var$_1n, Fn.ORDER);
    }
    const weierstrassEquation = $4752c543c21ed315$export$69061cf37a03f1(Fp, c.a, c.b);
    return Object.assign({}, {
        CURVE: c,
        Point: Point,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: (key)=>$4752c543c21ed315$export$e10a6dd187c1fa22(Fn, key),
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    });
}
function $4752c543c21ed315$var$_ecdsa_new_output_to_legacy(c, _ecdsa) {
    const Point = _ecdsa.Point;
    return Object.assign({}, _ecdsa, {
        ProjectivePoint: Point,
        CURVE: Object.assign({}, c, (0, $5uCeY.nLength)(Point.Fn.ORDER, Point.Fn.BITS))
    });
}
function $4752c543c21ed315$export$350b8ea6f1c27fae(c) {
    const { CURVE: CURVE, curveOpts: curveOpts, hash: hash, ecdsaOpts: ecdsaOpts } = $4752c543c21ed315$var$_ecdsa_legacy_opts_to_new(c);
    const Point = $4752c543c21ed315$export$66856fb9690920c4(CURVE, curveOpts);
    const signs = $4752c543c21ed315$export$4812c9a1c4ca02a(Point, hash, ecdsaOpts);
    return $4752c543c21ed315$var$_ecdsa_new_output_to_legacy(c, signs);
}

});
parcelRegister("cfqW9", function(module, exports) {

$parcel$export(module.exports, "hmac", () => $8eabc7d905fe40f7$export$355af40f8ab02f34);
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ 
var $hPdhr = parcelRequire("hPdhr");
class $8eabc7d905fe40f7$export$7b9cf41ebec74f45 extends (0, $hPdhr.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $hPdhr.ahash)(hash);
        const key = (0, $hPdhr.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $hPdhr.clean)(pad);
    }
    update(buf) {
        (0, $hPdhr.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $hPdhr.aexists)(this);
        (0, $hPdhr.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $8eabc7d905fe40f7$export$355af40f8ab02f34 = (hash, key, message)=>new $8eabc7d905fe40f7$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$8eabc7d905fe40f7$export$355af40f8ab02f34.create = (hash, key)=>new $8eabc7d905fe40f7$export$7b9cf41ebec74f45(hash, key);

});

parcelRegister("hfStd", function(module, exports) {

$parcel$export(module.exports, "abool", () => $c8fe170b55505a15$export$809304d28d77d92d);
$parcel$export(module.exports, "_abool2", () => $c8fe170b55505a15$export$dcc04a11b0f94c2a);
$parcel$export(module.exports, "_abytes2", () => $c8fe170b55505a15$export$8b73a320627a4b4b);
$parcel$export(module.exports, "numberToHexUnpadded", () => $c8fe170b55505a15$export$4ed2545b622827c1);
$parcel$export(module.exports, "hexToNumber", () => $c8fe170b55505a15$export$d57f2bacc26b4249);
$parcel$export(module.exports, "bytesToNumberBE", () => $c8fe170b55505a15$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $c8fe170b55505a15$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $c8fe170b55505a15$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $c8fe170b55505a15$export$ba2172e58d139f6d);
$parcel$export(module.exports, "numberToVarBytesBE", () => $c8fe170b55505a15$export$80ee8c1914de6dde);
$parcel$export(module.exports, "ensureBytes", () => $c8fe170b55505a15$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "equalBytes", () => $c8fe170b55505a15$export$2aa59cef064b0333);
$parcel$export(module.exports, "copyBytes", () => $c8fe170b55505a15$export$56728fb2d7dba34e);
$parcel$export(module.exports, "asciiToBytes", () => $c8fe170b55505a15$export$e151636497a65339);
$parcel$export(module.exports, "inRange", () => $c8fe170b55505a15$export$ddf89a9c5af38f94);
$parcel$export(module.exports, "aInRange", () => $c8fe170b55505a15$export$86cc12b5dde3c1e4);
$parcel$export(module.exports, "bitLen", () => $c8fe170b55505a15$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitGet", () => $c8fe170b55505a15$export$9577d112d1fd46ad);
$parcel$export(module.exports, "bitSet", () => $c8fe170b55505a15$export$967bb2b9787441cb);
$parcel$export(module.exports, "bitMask", () => $c8fe170b55505a15$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $c8fe170b55505a15$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $c8fe170b55505a15$export$381bae2d0f08004f);
$parcel$export(module.exports, "isHash", () => $c8fe170b55505a15$export$e8eff8fe65a171f3);
$parcel$export(module.exports, "_validateObject", () => $c8fe170b55505a15$export$1b8d274177e893f0);
$parcel$export(module.exports, "notImplemented", () => $c8fe170b55505a15$export$94a5f06e658f87e2);
$parcel$export(module.exports, "memoized", () => $c8fe170b55505a15$export$9756366f7cb6f62b);
$parcel$export(module.exports, "abytes", () => (parcelRequire("hPdhr")).abytes);
$parcel$export(module.exports, "bytesToHex", () => (parcelRequire("hPdhr")).bytesToHex);
$parcel$export(module.exports, "concatBytes", () => (parcelRequire("hPdhr")).concatBytes);
$parcel$export(module.exports, "hexToBytes", () => (parcelRequire("hPdhr")).hexToBytes);
$parcel$export(module.exports, "isBytes", () => (parcelRequire("hPdhr")).isBytes);
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $hPdhr = parcelRequire("hPdhr");
const $c8fe170b55505a15$var$_0n = /* @__PURE__ */ BigInt(0);
const $c8fe170b55505a15$var$_1n = /* @__PURE__ */ BigInt(1);
function $c8fe170b55505a15$export$809304d28d77d92d(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
function $c8fe170b55505a15$export$dcc04a11b0f94c2a(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}"`;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
function $c8fe170b55505a15$export$8b73a320627a4b4b(value, length, title = '') {
    const bytes = (0, $hPdhr.isBytes)(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
function $c8fe170b55505a15$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $c8fe170b55505a15$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $c8fe170b55505a15$var$_0n : BigInt('0x' + hex); // Big Endian
}
function $c8fe170b55505a15$export$d609354794974f8(bytes) {
    return $c8fe170b55505a15$export$d57f2bacc26b4249((0, $hPdhr.bytesToHex)(bytes));
}
function $c8fe170b55505a15$export$d67b1d03392107e7(bytes) {
    (0, $hPdhr.abytes)(bytes);
    return $c8fe170b55505a15$export$d57f2bacc26b4249((0, $hPdhr.bytesToHex)(Uint8Array.from(bytes).reverse()));
}
function $c8fe170b55505a15$export$1459dafd057611cb(n, len) {
    return (0, $hPdhr.hexToBytes)(n.toString(16).padStart(len * 2, '0'));
}
function $c8fe170b55505a15$export$ba2172e58d139f6d(n, len) {
    return $c8fe170b55505a15$export$1459dafd057611cb(n, len).reverse();
}
function $c8fe170b55505a15$export$80ee8c1914de6dde(n) {
    return (0, $hPdhr.hexToBytes)($c8fe170b55505a15$export$4ed2545b622827c1(n));
}
function $c8fe170b55505a15$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = (0, $hPdhr.hexToBytes)(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if ((0, $hPdhr.isBytes)(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
function $c8fe170b55505a15$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $c8fe170b55505a15$export$56728fb2d7dba34e(bytes) {
    return Uint8Array.from(bytes);
}
function $c8fe170b55505a15$export$e151636497a65339(ascii) {
    return Uint8Array.from(ascii, (c, i)=>{
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) throw new Error(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        return charCode;
    });
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ // export const utf8ToBytes: typeof utf8ToBytes_ = utf8ToBytes_;
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ // export const bytesToUtf8: typeof bytesToUtf8_ = bytesToUtf8_;
// Is positive bigint
const $c8fe170b55505a15$var$isPosBig = (n)=>typeof n === 'bigint' && $c8fe170b55505a15$var$_0n <= n;
function $c8fe170b55505a15$export$ddf89a9c5af38f94(n, min, max) {
    return $c8fe170b55505a15$var$isPosBig(n) && $c8fe170b55505a15$var$isPosBig(min) && $c8fe170b55505a15$var$isPosBig(max) && min <= n && n < max;
}
function $c8fe170b55505a15$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$c8fe170b55505a15$export$ddf89a9c5af38f94(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
function $c8fe170b55505a15$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $c8fe170b55505a15$var$_0n; n >>= $c8fe170b55505a15$var$_1n, len += 1);
    return len;
}
function $c8fe170b55505a15$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $c8fe170b55505a15$var$_1n;
}
function $c8fe170b55505a15$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $c8fe170b55505a15$var$_1n : $c8fe170b55505a15$var$_0n) << BigInt(pos);
}
const $c8fe170b55505a15$export$803efa2fa1c7279 = (n)=>($c8fe170b55505a15$var$_1n << BigInt(n)) - $c8fe170b55505a15$var$_1n;
function $c8fe170b55505a15$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    const u8n = (len)=>new Uint8Array(len); // creates Uint8Array
    const u8of = (byte)=>Uint8Array.of(byte); // another shortcut
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n(0))=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8of(0x00), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8of(0x01), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return (0, $hPdhr.concatBytes)(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $c8fe170b55505a15$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || (0, $hPdhr.isBytes)(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
function $c8fe170b55505a15$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $c8fe170b55505a15$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
function $c8fe170b55505a15$export$e8eff8fe65a171f3(val) {
    return typeof val === 'function' && Number.isSafeInteger(val.outputLen);
}
function $c8fe170b55505a15$export$1b8d274177e893f0(object, fields, optFields = {}) {
    if (!object || typeof object !== 'object') throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    Object.entries(fields).forEach(([k, v])=>checkField(k, v, false));
    Object.entries(optFields).forEach(([k, v])=>checkField(k, v, true));
}
const $c8fe170b55505a15$export$94a5f06e658f87e2 = ()=>{
    throw new Error('not implemented');
};
function $c8fe170b55505a15$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});

parcelRegister("c8GJ8", function(module, exports) {

$parcel$export(module.exports, "negateCt", () => $8d676015174a6dee$export$c6bd445aafe431ea);
$parcel$export(module.exports, "normalizeZ", () => $8d676015174a6dee$export$bc27bc65d7bff1c7);
$parcel$export(module.exports, "wNAF", () => $8d676015174a6dee$export$1c8afd86ce547420);
$parcel$export(module.exports, "mulEndoUnsafe", () => $8d676015174a6dee$export$4e37e5581461a31);
$parcel$export(module.exports, "pippenger", () => $8d676015174a6dee$export$8e2f6717424463a3);
$parcel$export(module.exports, "_createCurveFields", () => $8d676015174a6dee$export$a26f87e9b807e0c6);
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $hfStd = parcelRequire("hfStd");

var $5uCeY = parcelRequire("5uCeY");
const $8d676015174a6dee$var$_0n = BigInt(0);
const $8d676015174a6dee$var$_1n = BigInt(1);
function $8d676015174a6dee$export$c6bd445aafe431ea(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function $8d676015174a6dee$export$bc27bc65d7bff1c7(c, points) {
    const invertedZs = (0, $5uCeY.FpInvertBatch)(c.Fp, points.map((p)=>p.Z));
    return points.map((p, i)=>c.fromAffine(p.toAffine(invertedZs[i])));
}
function $8d676015174a6dee$var$validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function $8d676015174a6dee$var$calcWOpts(W, scalarBits) {
    $8d676015174a6dee$var$validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, $hfStd.bitMask)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows: windows,
        windowSize: windowSize,
        mask: mask,
        maxNumber: maxNumber,
        shiftBy: shiftBy
    };
}
function $8d676015174a6dee$var$calcOffsets(n, window, wOpts) {
    const { windowSize: windowSize, mask: mask, maxNumber: maxNumber, shiftBy: shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += $8d676015174a6dee$var$_1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN: nextN,
        offset: offset,
        isZero: isZero,
        isNeg: isNeg,
        isNegF: isNegF,
        offsetF: offsetF
    };
}
function $8d676015174a6dee$var$validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function $8d676015174a6dee$var$validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const $8d676015174a6dee$var$pointPrecomputes = new WeakMap();
const $8d676015174a6dee$var$pointWindowSizes = new WeakMap();
function $8d676015174a6dee$var$getW(P) {
    // To disable precomputes:
    // return 1;
    return $8d676015174a6dee$var$pointWindowSizes.get(P) || 1;
}
function $8d676015174a6dee$var$assert0(n) {
    if (n !== $8d676015174a6dee$var$_0n) throw new Error('invalid wNAF');
}
class $8d676015174a6dee$export$1c8afd86ce547420 {
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits){
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while(n > $8d676015174a6dee$var$_0n){
            if (n & $8d676015174a6dee$var$_1n) p = p.add(d);
            d = d.double();
            n >>= $8d676015174a6dee$var$_1n;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */ precomputeWindow(point, W) {
        const { windows: windows, windowSize: windowSize } = $8d676015174a6dee$var$calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for(let i = 1; i < windowSize; i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */ wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n)) throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = $8d676015174a6dee$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg, isNegF: isNegF, offsetF: offsetF } = $8d676015174a6dee$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) // bits are 0: add garbage to fake point
            // Important part for const-time getPublicKey: add random "noise" point to f.
            f = f.add($8d676015174a6dee$export$c6bd445aafe431ea(isNegF, precomputes[offsetF]));
            else // bits are 1: add to result point
            p = p.add($8d676015174a6dee$export$c6bd445aafe431ea(isNeg, precomputes[offset]));
        }
        $8d676015174a6dee$var$assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return {
            p: p,
            f: f
        };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */ wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = $8d676015174a6dee$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            if (n === $8d676015174a6dee$var$_0n) break; // Early-exit, skip 0 value
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg } = $8d676015174a6dee$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) continue;
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        $8d676015174a6dee$var$assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = $8d676015174a6dee$var$pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function') comp = transform(comp);
                $8d676015174a6dee$var$pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = $8d676015174a6dee$var$getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = $8d676015174a6dee$var$getW(point);
        if (W === 1) return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        $8d676015174a6dee$var$validateW(W, this.bits);
        $8d676015174a6dee$var$pointWindowSizes.set(P, W);
        $8d676015174a6dee$var$pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return $8d676015174a6dee$var$getW(elm) !== 1;
    }
}
function $8d676015174a6dee$export$4e37e5581461a31(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while(k1 > $8d676015174a6dee$var$_0n || k2 > $8d676015174a6dee$var$_0n){
        if (k1 & $8d676015174a6dee$var$_1n) p1 = p1.add(acc);
        if (k2 & $8d676015174a6dee$var$_1n) p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= $8d676015174a6dee$var$_1n;
        k2 >>= $8d676015174a6dee$var$_1n;
    }
    return {
        p1: p1,
        p2: p2
    };
}
function $8d676015174a6dee$export$8e2f6717424463a3(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    $8d676015174a6dee$var$validateMSMPoints(points, c);
    $8d676015174a6dee$var$validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = (0, $hfStd.bitLen)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $hfStd.bitMask)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function $8d676015174a6dee$export$c33f75a98e3bde1d(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ $8d676015174a6dee$var$validateW(windowSize, fieldN.BITS);
    $8d676015174a6dee$var$validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, $hfStd.bitMask)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        $8d676015174a6dee$var$validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function $8d676015174a6dee$export$8ffa17c2a9bceb5e(curve) {
    (0, $5uCeY.validateField)(curve.Fp);
    (0, $hfStd.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $5uCeY.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
function $8d676015174a6dee$var$createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order) throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        (0, $5uCeY.validateField)(field);
        return field;
    } else return (0, $5uCeY.Field)(order, {
        isLE: isLE
    });
}
function $8d676015174a6dee$export$a26f87e9b807e0c6(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined) FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object') throw new Error(`expected valid ${type} CURVE object`);
    for (const p of [
        'p',
        'n',
        'h'
    ]){
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > $8d676015174a6dee$var$_0n)) throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = $8d676015174a6dee$var$createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = $8d676015174a6dee$var$createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = [
        'Gx',
        'Gy',
        'a',
        _b
    ];
    for (const p of params){
        // @ts-ignore
        if (!Fp.isValid(CURVE[p])) throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return {
        CURVE: CURVE,
        Fp: Fp,
        Fn: Fn
    };
}

});
parcelRegister("5uCeY", function(module, exports) {

$parcel$export(module.exports, "mod", () => $3ffd6ad8cc9254ef$export$842a2cf37af977e1);
$parcel$export(module.exports, "Field", () => $3ffd6ad8cc9254ef$export$a455218a85c89869);
$parcel$export(module.exports, "pow2", () => $3ffd6ad8cc9254ef$export$fa569bd808b67eef);
$parcel$export(module.exports, "validateField", () => $3ffd6ad8cc9254ef$export$bd454f0cef11418d);
$parcel$export(module.exports, "FpInvertBatch", () => $3ffd6ad8cc9254ef$export$a492e3387142c0e9);
$parcel$export(module.exports, "nLength", () => $3ffd6ad8cc9254ef$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "getMinHashLength", () => $3ffd6ad8cc9254ef$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $3ffd6ad8cc9254ef$export$20cb21dbfa61dac3);
/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $hfStd = parcelRequire("hfStd");
var $hPdhr = parcelRequire("hPdhr");
// prettier-ignore
const $3ffd6ad8cc9254ef$var$_0n = BigInt(0), $3ffd6ad8cc9254ef$var$_1n = BigInt(1), $3ffd6ad8cc9254ef$var$_2n = /* @__PURE__ */ BigInt(2), $3ffd6ad8cc9254ef$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $3ffd6ad8cc9254ef$var$_4n = /* @__PURE__ */ BigInt(4), $3ffd6ad8cc9254ef$var$_5n = /* @__PURE__ */ BigInt(5), $3ffd6ad8cc9254ef$var$_7n = /* @__PURE__ */ BigInt(7);
// prettier-ignore
const $3ffd6ad8cc9254ef$var$_8n = /* @__PURE__ */ BigInt(8), $3ffd6ad8cc9254ef$var$_9n = /* @__PURE__ */ BigInt(9), $3ffd6ad8cc9254ef$var$_16n = /* @__PURE__ */ BigInt(16);
function $3ffd6ad8cc9254ef$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $3ffd6ad8cc9254ef$var$_0n ? result : b + result;
}
function $3ffd6ad8cc9254ef$export$9c297f60e22e3389(num, power, modulo) {
    return $3ffd6ad8cc9254ef$export$5d8ce3717733a987($3ffd6ad8cc9254ef$export$a455218a85c89869(modulo), num, power);
}
function $3ffd6ad8cc9254ef$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $3ffd6ad8cc9254ef$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $3ffd6ad8cc9254ef$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $3ffd6ad8cc9254ef$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $3ffd6ad8cc9254ef$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $3ffd6ad8cc9254ef$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $3ffd6ad8cc9254ef$var$_0n, y = $3ffd6ad8cc9254ef$var$_1n, u = $3ffd6ad8cc9254ef$var$_1n, v = $3ffd6ad8cc9254ef$var$_0n;
    while(a !== $3ffd6ad8cc9254ef$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $3ffd6ad8cc9254ef$var$_1n) throw new Error('invert: does not exist');
    return $3ffd6ad8cc9254ef$export$842a2cf37af977e1(x, modulo);
}
function $3ffd6ad8cc9254ef$var$assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $3ffd6ad8cc9254ef$var$sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + $3ffd6ad8cc9254ef$var$_1n) / $3ffd6ad8cc9254ef$var$_4n;
    const root = Fp.pow(n, p1div4);
    $3ffd6ad8cc9254ef$var$assertIsSquare(Fp, root, n);
    return root;
}
function $3ffd6ad8cc9254ef$var$sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - $3ffd6ad8cc9254ef$var$_5n) / $3ffd6ad8cc9254ef$var$_8n;
    const n2 = Fp.mul(n, $3ffd6ad8cc9254ef$var$_2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, $3ffd6ad8cc9254ef$var$_2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    $3ffd6ad8cc9254ef$var$assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function $3ffd6ad8cc9254ef$var$sqrt9mod16(P) {
    const Fp_ = $3ffd6ad8cc9254ef$export$a455218a85c89869(P);
    const tn = $3ffd6ad8cc9254ef$export$69f29ab1f3e9a234(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + $3ffd6ad8cc9254ef$var$_7n) / $3ffd6ad8cc9254ef$var$_16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n)=>{
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        $3ffd6ad8cc9254ef$var$assertIsSquare(Fp, root, n);
        return root;
    };
}
function $3ffd6ad8cc9254ef$export$69f29ab1f3e9a234(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < $3ffd6ad8cc9254ef$var$_3n) throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $3ffd6ad8cc9254ef$var$_1n;
    let S = 0;
    while(Q % $3ffd6ad8cc9254ef$var$_2n === $3ffd6ad8cc9254ef$var$_0n){
        Q /= $3ffd6ad8cc9254ef$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $3ffd6ad8cc9254ef$var$_2n;
    const _Fp = $3ffd6ad8cc9254ef$export$a455218a85c89869(P);
    while($3ffd6ad8cc9254ef$export$77ed22730026dd0d(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $3ffd6ad8cc9254ef$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $3ffd6ad8cc9254ef$var$_1n) / $3ffd6ad8cc9254ef$var$_2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($3ffd6ad8cc9254ef$export$77ed22730026dd0d(Fp, n) !== 1) throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!Fp.eql(t, Fp.ONE)){
            if (Fp.is0(t)) return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while(!Fp.eql(t_tmp, Fp.ONE)){
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $3ffd6ad8cc9254ef$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
function $3ffd6ad8cc9254ef$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $3ffd6ad8cc9254ef$var$_4n === $3ffd6ad8cc9254ef$var$_3n) return $3ffd6ad8cc9254ef$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $3ffd6ad8cc9254ef$var$_8n === $3ffd6ad8cc9254ef$var$_5n) return $3ffd6ad8cc9254ef$var$sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % $3ffd6ad8cc9254ef$var$_16n === $3ffd6ad8cc9254ef$var$_9n) return $3ffd6ad8cc9254ef$var$sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return $3ffd6ad8cc9254ef$export$69f29ab1f3e9a234(P);
}
const $3ffd6ad8cc9254ef$export$7806f13ad5078b2f = (num, modulo)=>($3ffd6ad8cc9254ef$export$842a2cf37af977e1(num, modulo) & $3ffd6ad8cc9254ef$var$_1n) === $3ffd6ad8cc9254ef$var$_1n;
// prettier-ignore
const $3ffd6ad8cc9254ef$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $3ffd6ad8cc9254ef$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'number',
        BITS: 'number'
    };
    const opts = $3ffd6ad8cc9254ef$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    (0, $hfStd._validateObject)(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
function $3ffd6ad8cc9254ef$export$5d8ce3717733a987(Fp, num, power) {
    if (power < $3ffd6ad8cc9254ef$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $3ffd6ad8cc9254ef$var$_0n) return Fp.ONE;
    if (power === $3ffd6ad8cc9254ef$var$_1n) return num;
    let p = Fp.ONE;
    let d = num;
    while(power > $3ffd6ad8cc9254ef$var$_0n){
        if (power & $3ffd6ad8cc9254ef$var$_1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= $3ffd6ad8cc9254ef$var$_1n;
    }
    return p;
}
function $3ffd6ad8cc9254ef$export$a492e3387142c0e9(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
function $3ffd6ad8cc9254ef$export$e74c665040343df6(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? $3ffd6ad8cc9254ef$export$6897c284b6f9f4dc(rhs, Fp.ORDER) : Fp.inv(rhs));
}
function $3ffd6ad8cc9254ef$export$77ed22730026dd0d(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - $3ffd6ad8cc9254ef$var$_1n) / $3ffd6ad8cc9254ef$var$_2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
function $3ffd6ad8cc9254ef$export$5e2b6e87f2891ea7(Fp, n) {
    const l = $3ffd6ad8cc9254ef$export$77ed22730026dd0d(Fp, n);
    return l === 1;
}
function $3ffd6ad8cc9254ef$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $hPdhr.anumber)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $3ffd6ad8cc9254ef$export$a455218a85c89869(ORDER, bitLenOrOpts, isLE = false, opts = {}) {
    if (ORDER <= $3ffd6ad8cc9254ef$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    let _nbitLength = undefined;
    let _sqrt = undefined;
    let modFromBytes = false;
    let allowedLengths = undefined;
    if (typeof bitLenOrOpts === 'object' && bitLenOrOpts != null) {
        if (opts.sqrt || isLE) throw new Error('cannot specify opts in two arguments');
        const _opts = bitLenOrOpts;
        if (_opts.BITS) _nbitLength = _opts.BITS;
        if (_opts.sqrt) _sqrt = _opts.sqrt;
        if (typeof _opts.isLE === 'boolean') isLE = _opts.isLE;
        if (typeof _opts.modFromBytes === 'boolean') modFromBytes = _opts.modFromBytes;
        allowedLengths = _opts.allowedLengths;
    } else {
        if (typeof bitLenOrOpts === 'number') _nbitLength = bitLenOrOpts;
        if (opts.sqrt) _sqrt = opts.sqrt;
    }
    const { nBitLength: BITS, nByteLength: BYTES } = $3ffd6ad8cc9254ef$export$c79df43ecd7e66c2(ORDER, _nbitLength);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $hfStd.bitMask)(BITS),
        ZERO: $3ffd6ad8cc9254ef$var$_0n,
        ONE: $3ffd6ad8cc9254ef$var$_1n,
        allowedLengths: allowedLengths,
        create: (num)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return $3ffd6ad8cc9254ef$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $3ffd6ad8cc9254ef$var$_0n,
        // is valid and invertible
        isValidNot0: (num)=>!f.is0(num) && f.isValid(num),
        isOdd: (num)=>(num & $3ffd6ad8cc9254ef$var$_1n) === $3ffd6ad8cc9254ef$var$_1n,
        neg: (num)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$3ffd6ad8cc9254ef$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$3ffd6ad8cc9254ef$export$842a2cf37af977e1(lhs * $3ffd6ad8cc9254ef$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$3ffd6ad8cc9254ef$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: _sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $3ffd6ad8cc9254ef$export$33bda048c6b8ea7d(ORDER);
            return sqrtP(f, n);
        }),
        toBytes: (num)=>isLE ? (0, $hfStd.numberToBytesLE)(num, BYTES) : (0, $hfStd.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes, skipValidation = true)=>{
            if (allowedLengths) {
                if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
                const padded = new Uint8Array(BYTES);
                // isLE add 0 to right, !isLE to the left.
                padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
                bytes = padded;
            }
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            let scalar = isLE ? (0, $hfStd.bytesToNumberLE)(bytes) : (0, $hfStd.bytesToNumberBE)(bytes);
            if (modFromBytes) scalar = $3ffd6ad8cc9254ef$export$842a2cf37af977e1(scalar, ORDER);
            if (!skipValidation) {
                if (!f.isValid(scalar)) throw new Error('invalid field element: outside of range 0..ORDER');
            }
            // NOTE: we don't validate scalar here, please use isValid. This done such way because some
            // protocol may allow non-reduced scalar that reduced later or changed some other way.
            return scalar;
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst)=>$3ffd6ad8cc9254ef$export$a492e3387142c0e9(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c)=>c ? b : a
    });
    return Object.freeze(f);
}
function $3ffd6ad8cc9254ef$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $3ffd6ad8cc9254ef$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $3ffd6ad8cc9254ef$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $hfStd.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $3ffd6ad8cc9254ef$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, $hfStd.bytesToNumberLE)(hash) : (0, $hfStd.bytesToNumberBE)(hash);
    return $3ffd6ad8cc9254ef$export$842a2cf37af977e1(num, groupOrder - $3ffd6ad8cc9254ef$var$_1n) + $3ffd6ad8cc9254ef$var$_1n;
}
function $3ffd6ad8cc9254ef$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $3ffd6ad8cc9254ef$export$d058763b563056af(fieldOrder) {
    const length = $3ffd6ad8cc9254ef$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $3ffd6ad8cc9254ef$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $3ffd6ad8cc9254ef$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $3ffd6ad8cc9254ef$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $hfStd.bytesToNumberLE)(key) : (0, $hfStd.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $3ffd6ad8cc9254ef$export$842a2cf37af977e1(num, fieldOrder - $3ffd6ad8cc9254ef$var$_1n) + $3ffd6ad8cc9254ef$var$_1n;
    return isLE ? (0, $hfStd.numberToBytesLE)(reduced, fieldLen) : (0, $hfStd.numberToBytesBE)(reduced, fieldLen);
}

});




parcelRegister("eSCtp", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", () => $ad53f3d89b824bef$export$9393380cf1075f28);
$parcel$export(module.exports, "createHasher", () => $ad53f3d89b824bef$export$14b114effbc08b6b);

var $hfStd = parcelRequire("hfStd");
var $hPdhr = parcelRequire("hPdhr");
var $hPdhr = parcelRequire("hPdhr");

var $5uCeY = parcelRequire("5uCeY");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $ad53f3d89b824bef$var$os2ip = (0, $hfStd.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $ad53f3d89b824bef$var$i2osp(value, length) {
    $ad53f3d89b824bef$var$anum(value);
    $ad53f3d89b824bef$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $ad53f3d89b824bef$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $ad53f3d89b824bef$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
function $ad53f3d89b824bef$var$normDST(DST) {
    if (!(0, $hPdhr.isBytes)(DST) && typeof DST !== 'string') throw new Error('DST must be Uint8Array or string');
    return typeof DST === 'string' ? (0, $hPdhr.utf8ToBytes)(DST) : DST;
}
function $ad53f3d89b824bef$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $hPdhr.abytes)(msg);
    $ad53f3d89b824bef$var$anum(lenInBytes);
    DST = $ad53f3d89b824bef$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $hPdhr.concatBytes)((0, $hPdhr.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $hPdhr.concatBytes)(DST, $ad53f3d89b824bef$var$i2osp(DST.length, 1));
    const Z_pad = $ad53f3d89b824bef$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $ad53f3d89b824bef$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $hPdhr.concatBytes)(Z_pad, msg, l_i_b_str, $ad53f3d89b824bef$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $hPdhr.concatBytes)(b_0, $ad53f3d89b824bef$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $ad53f3d89b824bef$var$strxor(b_0, b[i - 1]),
            $ad53f3d89b824bef$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $hPdhr.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $hPdhr.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $ad53f3d89b824bef$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $hPdhr.abytes)(msg);
    $ad53f3d89b824bef$var$anum(lenInBytes);
    DST = $ad53f3d89b824bef$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $hPdhr.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($ad53f3d89b824bef$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($ad53f3d89b824bef$var$i2osp(DST.length, 1)).digest();
}
function $ad53f3d89b824bef$export$97cdd5ee18de8172(msg, count, options) {
    (0, $hfStd._validateObject)(options, {
        p: 'bigint',
        m: 'number',
        k: 'number',
        hash: 'function'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: DST } = options;
    if (!(0, $hfStd.isHash)(options.hash)) throw new Error('expected valid hash');
    (0, $hPdhr.abytes)(msg);
    $ad53f3d89b824bef$var$anum(count);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $ad53f3d89b824bef$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $ad53f3d89b824bef$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $5uCeY.mod)($ad53f3d89b824bef$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $ad53f3d89b824bef$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, $5uCeY.FpInvertBatch)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
const $ad53f3d89b824bef$export$eaf8c8caa9e37fdf = (0, $hPdhr.utf8ToBytes)('HashToScalar-');
function $ad53f3d89b824bef$export$14b114effbc08b6b(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults: defaults,
        hashToCurve (msg, options) {
            const opts = Object.assign({}, defaults, options);
            const u = $ad53f3d89b824bef$export$97cdd5ee18de8172(msg, 2, opts);
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        encodeToCurve (msg, options) {
            const optsDst = defaults.encodeDST ? {
                DST: defaults.encodeDST
            } : {};
            const opts = Object.assign({}, defaults, optsDst, options);
            const u = $ad53f3d89b824bef$export$97cdd5ee18de8172(msg, 1, opts);
            const u0 = map(u[0]);
            return clear(u0);
        },
        /** See {@link H2CHasher} */ mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar (msg, options) {
            // @ts-ignore
            const N = Point.Fn.ORDER;
            const opts = Object.assign({}, defaults, {
                p: N,
                m: 1,
                DST: $ad53f3d89b824bef$export$eaf8c8caa9e37fdf
            }, options);
            return $ad53f3d89b824bef$export$97cdd5ee18de8172(msg, 1, opts)[0][0];
        }
    };
}

});


var $3a98d0612255f10a$exports = {};
$parcel$extendImportMap({
    "4FOPA": "chains.9d20f13d.js",
    "7HPhe": "_esm.91c78bba.js",
    "608iJ": "index-40a497ea.e45b78f4.js",
    "8A0ae": "index-40a497ea.d39aa0bd.js",
    "bvKMD": "_esm.9ae678ce.js",
    "go0Da": "ccip.e4e53ed8.js",
    "jwM8j": "index-021f6a62.bbc8b3d9.js",
    "bZqeB": "ccip-c78d2f16.a04a9811.js",
    "3Wrzc": "Index-1e31d199.700e3d6e.js",
    "fmb5T": "Index-6078f122.28a549ca.js",
    "izmtx": "metamask.4006a642.js",
    "cLOfI": "infinitywallet.84f55e2a.js",
    "ja1ke": "exodus.47706a43.js",
    "c5AGx": "frontier.0a575686.js",
    "189cm": "brave.ae32ed1e.js",
    "aCs8E": "binance.2894eb43.js",
    "7k8ah": "coinbase.16d3c54e.js",
    "hj1Jx": "detected.7296c3f3.js",
    "3LHuW": "trust.e0dd7c7a.js",
    "3X0ht": "opera.e994facc.js",
    "j68z6": "status.98887b28.js",
    "9IWZP": "alphawallet.73368115.js",
    "1wKOc": "apexwallet.0e09628f.js",
    "hewuD": "atoken.e23fcf77.js",
    "9kqZl": "bifrostwallet.726953a2.js",
    "l90bq": "bitpie.c372049e.js",
    "bYPZQ": "blockwallet.d8bf3a61.js",
    "d9EfO": "frame.f3660a7a.js",
    "5uNia": "huobiwallet.a869f59b.js",
    "k14R1": "hyperpay.d70a8dfd.js",
    "4Jjda": "imtoken.521b2b52.js",
    "djeOd": "liquality.cb3996e0.js",
    "kERVQ": "meetone.f65bcf36.js",
    "57Gvu": "mykey.e6bde4f3.js",
    "bQxCY": "ownbit.6d363e07.js",
    "1qD4q": "tokenpocket.67c0868d.js",
    "iXy7I": "tp.1636532c.js",
    "jSVXT": "xdefi.2eb2d52f.js",
    "jiTjN": "oneInch.d2663353.js",
    "6QGmu": "tokenary.556f6953.js",
    "gHcgZ": "tallywallet.4128f6d9.js",
    "e0UQW": "zeal.ac98872d.js",
    "bWbf8": "rabby.1d0adc3c.js",
    "bv3Rp": "mathwallet.c26ae436.js",
    "iKwOR": "bitget.05ea3da6.js",
    "1PXIB": "sequence.b320ba86.js",
    "8kLVB": "core.8153366b.js",
    "169RU": "bitski.987737a8.js",
    "enCaa": "zerion.ca2e2e40.js",
    "gjV0E": "enkrypt.8088758a.js",
    "fvf4k": "phantom.2d36e65e.js",
    "yqlH2": "safepal.59256b09.js",
    "10G6i": "rainbow.a644208f.js",
    "6J5XV": "okxwallet.f9c23e3b.js",
    "j4fQd": "defiwallet.b928fcc8.js",
    "kYwRe": "safeheron.87b0b4a0.js",
    "63bzI": "talisman.f5245271.js",
    "elJHC": "roninwallet.e23d0eab.js",
    "12Pfe": "onekey.42666e1a.js",
    "kwo0I": "fordefi.aafba370.js",
    "iggay": "coin98wallet.60253492.js",
    "byHVD": "subwallet.b9ab1e8e.js",
    "1ujMp": "kayros.9b2099d4.js",
    "alFXZ": "foxwallet.1f7cf566.js",
    "6Xg79": "lif3wallet.65e04b1f.js",
    "dteXQ": "zodiacpilot.ddfae26a.js",
    "uUrei": "stablewallet.c56d3879.js",
    "gQf27": "echooo.a847648a.js",
    "aVmNf": "keplr.fdeb90b2.js",
    "4PnPh": "icon.5ccff632.js",
    "cqTjD": "index.es.aa7258c2.js",
    "9DD1b": "core.61e88fb7.js",
    "FEvfQ": "features.b35ee4db.js",
    "3yuAh": "basic.5569c932.js",
    "jvY7g": "basic.58e5c607.js",
    "ejuUd": "PhArrowCircleDown.866f7755.js",
    "lsu7O": "PhArrowCircleDown.70eef6f6.js",
    "9Tii9": "PhArrowClockwise.56312ecf.js",
    "go54e": "PhArrowDown.a9cf7d6d.js",
    "4StIi": "PhArrowLeft.fd55d94e.js",
    "4L20h": "PhArrowRight.651ade68.js",
    "bizLz": "PhArrowSquareOut.acb54bbb.js",
    "1gMwZ": "PhArrowsDownUp.54e042d8.js",
    "9KLoY": "PhArrowsLeftRight.80872f1e.js",
    "gEFya": "PhArrowUp.9a348d49.js",
    "7Yb6q": "PhArrowUpRight.7f73616e.js",
    "gttAi": "PhArrowsClockwise.40a06d23.js",
    "dkwqn": "PhBank.052b340b.js",
    "lBDSY": "PhBrowser.03516765.js",
    "g7n54": "PhCaretDown.d4cc8822.js",
    "hjhs8": "PhCaretLeft.29a372b3.js",
    "lqgoK": "PhCaretRight.38536f6f.js",
    "37Xz1": "PhCaretUp.513bd81a.js",
    "1RwER": "PhCheck.aaf44465.js",
    "ilL7n": "PhCircleHalf.efc92f07.js",
    "1Wgmk": "PhClock.72a40260.js",
    "lKtzE": "PhCompass.01d39661.js",
    "cYVbZ": "PhCopy.f2634717.js",
    "hfydT": "PhCreditCard.3df6a867.js",
    "29RKA": "PhCurrencyDollar.e127a543.js",
    "ffIMf": "PhDesktop.f5bfb9b9.js",
    "1naE9": "PhDeviceMobile.cb73e90d.js",
    "hJGng": "PhDotsThree.4bd29484.js",
    "8l224": "PhVault.e459e1ea.js",
    "jB7ni": "PhEnvelope.cfaf8866.js",
    "1Hjeo": "PhFunnelSimple.ff3b38d9.js",
    "dify8": "PhGlobe.36078be8.js",
    "67jeQ": "PhIdentificationCard.bd2ea226.js",
    "jJ64p": "PhImage.2a9812ac.js",
    "5Ok3Q": "PhInfo.2f7db8b4.js",
    "6l66v": "PhLightbulb.01dadc86.js",
    "hN8fI": "PhMagnifyingGlass.6221d879.js",
    "kSNaE": "PhPaperPlaneRight.6255ebb8.js",
    "2nUKZ": "PhPlus.4d55e874.js",
    "ec033": "PhPower.855b46b3.js",
    "gYJX8": "PhPuzzlePiece.9d5a8cc6.js",
    "hWWIg": "PhQrCode.ab66c1d1.js",
    "f3EbI": "PhQuestion.6fd68e64.js",
    "1T9se": "PhQuestionMark.ae2ee975.js",
    "gDX1T": "PhSealCheck.723d6855.js",
    "98eWc": "PhSignOut.818452a1.js",
    "B2AYl": "PhSpinner.67165127.js",
    "aoFSk": "PhTrash.821cb6b8.js",
    "knYEX": "PhUser.858bee99.js",
    "fyOUp": "PhWallet.70c5b4c9.js",
    "fwOsb": "PhWarning.c9618783.js",
    "8BlI5": "PhWarningCircle.6384d2ac.js",
    "2DmN6": "PhX.9eca2805.js",
    "fwXEY": "w3m-modal.07b18546.js",
    "bzcv9": "esm5.710d59bd.js",
    "oChuu": "operators.adf6b1d8.js",
    "jFDyd": "icon.146d9f46.js",
    "9B2SW": "dist.714adddd.js",
    "2kgYl": "dist.79e3edb8.js",
    "1TuEN": "icon.b47c06aa.js",
    "cbUSJ": "esm.92e0db16.js",
    "9BNdm": "esm.87425787.js",
    "4oDNo": "dist.f16ff2c5.js",
    "gOG4l": "metamask-sdk.97d7bc8e.js",
    "1Fbbl": "icon.fd9eb826.js"
});

/*!
Turbo 8.0.23
Copyright © 2026 37signals LLC
 */ const $16d9fec6fae182d5$export$65f98fefe20dbcb6 = {
    eager: "eager",
    lazy: "lazy"
};
/**
 * Contains a fragment of HTML which is updated based on navigation within
 * it (e.g. via links or form submissions).
 *
 * @customElement turbo-frame
 * @example
 *   <turbo-frame id="messages">
 *     <a href="/messages/expanded">
 *       Show all expanded messages in this frame.
 *     </a>
 *
 *     <form action="/messages">
 *       Show response from this form within this frame.
 *     </form>
 *   </turbo-frame>
 */ class $16d9fec6fae182d5$export$f464a8f0ffa32c44 extends HTMLElement {
    static delegateConstructor = undefined;
    loaded = Promise.resolve();
    static get observedAttributes() {
        return [
            "disabled",
            "loading",
            "src"
        ];
    }
    constructor(){
        super();
        this.delegate = new $16d9fec6fae182d5$export$f464a8f0ffa32c44.delegateConstructor(this);
    }
    connectedCallback() {
        this.delegate.connect();
    }
    disconnectedCallback() {
        this.delegate.disconnect();
    }
    reload() {
        return this.delegate.sourceURLReloaded();
    }
    attributeChangedCallback(name) {
        if (name == "loading") this.delegate.loadingStyleChanged();
        else if (name == "src") this.delegate.sourceURLChanged();
        else if (name == "disabled") this.delegate.disabledChanged();
    }
    /**
   * Gets the URL to lazily load source HTML from
   */ get src() {
        return this.getAttribute("src");
    }
    /**
   * Sets the URL to lazily load source HTML from
   */ set src(value) {
        if (value) this.setAttribute("src", value);
        else this.removeAttribute("src");
    }
    /**
   * Gets the refresh mode for the frame.
   */ get refresh() {
        return this.getAttribute("refresh");
    }
    /**
   * Sets the refresh mode for the frame.
   */ set refresh(value) {
        if (value) this.setAttribute("refresh", value);
        else this.removeAttribute("refresh");
    }
    get shouldReloadWithMorph() {
        return this.src && this.refresh === "morph";
    }
    /**
   * Determines if the element is loading
   */ get loading() {
        return $16d9fec6fae182d5$var$frameLoadingStyleFromString(this.getAttribute("loading") || "");
    }
    /**
   * Sets the value of if the element is loading
   */ set loading(value) {
        if (value) this.setAttribute("loading", value);
        else this.removeAttribute("loading");
    }
    /**
   * Gets the disabled state of the frame.
   *
   * If disabled, no requests will be intercepted by the frame.
   */ get disabled() {
        return this.hasAttribute("disabled");
    }
    /**
   * Sets the disabled state of the frame.
   *
   * If disabled, no requests will be intercepted by the frame.
   */ set disabled(value) {
        if (value) this.setAttribute("disabled", "");
        else this.removeAttribute("disabled");
    }
    /**
   * Gets the autoscroll state of the frame.
   *
   * If true, the frame will be scrolled into view automatically on update.
   */ get autoscroll() {
        return this.hasAttribute("autoscroll");
    }
    /**
   * Sets the autoscroll state of the frame.
   *
   * If true, the frame will be scrolled into view automatically on update.
   */ set autoscroll(value) {
        if (value) this.setAttribute("autoscroll", "");
        else this.removeAttribute("autoscroll");
    }
    /**
   * Determines if the element has finished loading
   */ get complete() {
        return !this.delegate.isLoading;
    }
    /**
   * Gets the active state of the frame.
   *
   * If inactive, source changes will not be observed.
   */ get isActive() {
        return this.ownerDocument === document && !this.isPreview;
    }
    /**
   * Sets the active state of the frame.
   *
   * If inactive, source changes will not be observed.
   */ get isPreview() {
        return this.ownerDocument?.documentElement?.hasAttribute("data-turbo-preview");
    }
}
function $16d9fec6fae182d5$var$frameLoadingStyleFromString(style) {
    switch(style.toLowerCase()){
        case "lazy":
            return $16d9fec6fae182d5$export$65f98fefe20dbcb6.lazy;
        default:
            return $16d9fec6fae182d5$export$65f98fefe20dbcb6.eager;
    }
}
const $16d9fec6fae182d5$var$drive = {
    enabled: true,
    progressBarDelay: 500,
    unvisitableExtensions: new Set([
        ".7z",
        ".aac",
        ".apk",
        ".avi",
        ".bmp",
        ".bz2",
        ".css",
        ".csv",
        ".deb",
        ".dmg",
        ".doc",
        ".docx",
        ".exe",
        ".gif",
        ".gz",
        ".heic",
        ".heif",
        ".ico",
        ".iso",
        ".jpeg",
        ".jpg",
        ".js",
        ".json",
        ".m4a",
        ".mkv",
        ".mov",
        ".mp3",
        ".mp4",
        ".mpeg",
        ".mpg",
        ".msi",
        ".ogg",
        ".ogv",
        ".pdf",
        ".pkg",
        ".png",
        ".ppt",
        ".pptx",
        ".rar",
        ".rtf",
        ".svg",
        ".tar",
        ".tif",
        ".tiff",
        ".txt",
        ".wav",
        ".webm",
        ".webp",
        ".wma",
        ".wmv",
        ".xls",
        ".xlsx",
        ".xml",
        ".zip"
    ])
};
function $16d9fec6fae182d5$var$activateScriptElement(element) {
    if (element.getAttribute("data-turbo-eval") == "false") return element;
    else {
        const createdScriptElement = document.createElement("script");
        const cspNonce = $16d9fec6fae182d5$var$getCspNonce();
        if (cspNonce) createdScriptElement.nonce = cspNonce;
        createdScriptElement.textContent = element.textContent;
        createdScriptElement.async = false;
        $16d9fec6fae182d5$var$copyElementAttributes(createdScriptElement, element);
        return createdScriptElement;
    }
}
function $16d9fec6fae182d5$var$copyElementAttributes(destinationElement, sourceElement) {
    for (const { name: name, value: value } of sourceElement.attributes)destinationElement.setAttribute(name, value);
}
function $16d9fec6fae182d5$var$createDocumentFragment(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function $16d9fec6fae182d5$var$dispatch(eventName, { target: target, cancelable: cancelable, detail: detail } = {}) {
    const event = new CustomEvent(eventName, {
        cancelable: cancelable,
        bubbles: true,
        composed: true,
        detail: detail
    });
    if (target && target.isConnected) target.dispatchEvent(event);
    else document.documentElement.dispatchEvent(event);
    return event;
}
function $16d9fec6fae182d5$var$cancelEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
function $16d9fec6fae182d5$var$nextRepaint() {
    if (document.visibilityState === "hidden") return $16d9fec6fae182d5$var$nextEventLoopTick();
    else return $16d9fec6fae182d5$var$nextAnimationFrame();
}
function $16d9fec6fae182d5$var$nextAnimationFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $16d9fec6fae182d5$var$nextEventLoopTick() {
    return new Promise((resolve)=>setTimeout(()=>resolve(), 0));
}
function $16d9fec6fae182d5$var$parseHTMLDocument(html = "") {
    return new DOMParser().parseFromString(html, "text/html");
}
function $16d9fec6fae182d5$var$unindent(strings, ...values) {
    const lines = $16d9fec6fae182d5$var$interpolate(strings, values).replace(/^\n/, "").split("\n");
    const match = lines[0].match(/^\s+/);
    const indent = match ? match[0].length : 0;
    return lines.map((line)=>line.slice(indent)).join("\n");
}
function $16d9fec6fae182d5$var$interpolate(strings, values) {
    return strings.reduce((result, string, i)=>{
        const value = values[i] == undefined ? "" : values[i];
        return result + string + value;
    }, "");
}
function $16d9fec6fae182d5$var$uuid() {
    return Array.from({
        length: 36
    }).map((_, i)=>{
        if (i == 8 || i == 13 || i == 18 || i == 23) return "-";
        else if (i == 14) return "4";
        else if (i == 19) return (Math.floor(Math.random() * 4) + 8).toString(16);
        else return Math.floor(Math.random() * 16).toString(16);
    }).join("");
}
function $16d9fec6fae182d5$var$getAttribute(attributeName, ...elements) {
    for (const value of elements.map((element)=>element?.getAttribute(attributeName))){
        if (typeof value == "string") return value;
    }
    return null;
}
function $16d9fec6fae182d5$var$hasAttribute(attributeName, ...elements) {
    return elements.some((element)=>element && element.hasAttribute(attributeName));
}
function $16d9fec6fae182d5$var$markAsBusy(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.setAttribute("busy", "");
        element.setAttribute("aria-busy", "true");
    }
}
function $16d9fec6fae182d5$var$clearBusyState(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.removeAttribute("busy");
        element.removeAttribute("aria-busy");
    }
}
function $16d9fec6fae182d5$var$waitForLoad(element, timeoutInMilliseconds = 2000) {
    return new Promise((resolve)=>{
        const onComplete = ()=>{
            element.removeEventListener("error", onComplete);
            element.removeEventListener("load", onComplete);
            resolve();
        };
        element.addEventListener("load", onComplete, {
            once: true
        });
        element.addEventListener("error", onComplete, {
            once: true
        });
        setTimeout(resolve, timeoutInMilliseconds);
    });
}
function $16d9fec6fae182d5$var$getHistoryMethodForAction(action) {
    switch(action){
        case "replace":
            return history.replaceState;
        case "advance":
        case "restore":
            return history.pushState;
    }
}
function $16d9fec6fae182d5$var$isAction(action) {
    return action == "advance" || action == "replace" || action == "restore";
}
function $16d9fec6fae182d5$var$getVisitAction(...elements) {
    const action = $16d9fec6fae182d5$var$getAttribute("data-turbo-action", ...elements);
    return $16d9fec6fae182d5$var$isAction(action) ? action : null;
}
function $16d9fec6fae182d5$var$getMetaElement(name) {
    return document.querySelector(`meta[name="${name}"]`);
}
function $16d9fec6fae182d5$var$getMetaContent(name) {
    const element = $16d9fec6fae182d5$var$getMetaElement(name);
    return element && element.content;
}
function $16d9fec6fae182d5$var$getCspNonce() {
    const element = $16d9fec6fae182d5$var$getMetaElement("csp-nonce");
    if (element) {
        const { nonce: nonce, content: content } = element;
        return nonce == "" ? content : nonce;
    }
}
function $16d9fec6fae182d5$var$setMetaContent(name, content) {
    let element = $16d9fec6fae182d5$var$getMetaElement(name);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
    return element;
}
function $16d9fec6fae182d5$var$findClosestRecursively(element, selector) {
    if (element instanceof Element) return element.closest(selector) || $16d9fec6fae182d5$var$findClosestRecursively(element.assignedSlot || element.getRootNode()?.host, selector);
}
function $16d9fec6fae182d5$var$elementIsFocusable(element) {
    const inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
    return !!element && element.closest(inertDisabledOrHidden) == null && typeof element.focus == "function";
}
function $16d9fec6fae182d5$var$queryAutofocusableElement(elementOrDocumentFragment) {
    return Array.from(elementOrDocumentFragment.querySelectorAll("[autofocus]")).find($16d9fec6fae182d5$var$elementIsFocusable);
}
async function $16d9fec6fae182d5$var$around(callback, reader) {
    const before = reader();
    callback();
    await $16d9fec6fae182d5$var$nextAnimationFrame();
    const after = reader();
    return [
        before,
        after
    ];
}
function $16d9fec6fae182d5$var$doesNotTargetIFrame(name) {
    if (name === "_blank") return false;
    else if (name) {
        for (const element of document.getElementsByName(name)){
            if (element instanceof HTMLIFrameElement) return false;
        }
        return true;
    } else return true;
}
function $16d9fec6fae182d5$var$findLinkFromClickTarget(target) {
    const link = $16d9fec6fae182d5$var$findClosestRecursively(target, "a[href], a[xlink\\:href]");
    if (!link) return null;
    if (link.href.startsWith("#")) return null;
    if (link.hasAttribute("download")) return null;
    const linkTarget = link.getAttribute("target");
    if (linkTarget && linkTarget !== "_self") return null;
    return link;
}
function $16d9fec6fae182d5$var$debounce(fn, delay) {
    let timeoutId = null;
    return (...args)=>{
        const callback = ()=>fn.apply(this, args);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, delay);
    };
}
const $16d9fec6fae182d5$var$submitter = {
    "aria-disabled": {
        beforeSubmit: (submitter)=>{
            submitter.setAttribute("aria-disabled", "true");
            submitter.addEventListener("click", $16d9fec6fae182d5$var$cancelEvent);
        },
        afterSubmit: (submitter)=>{
            submitter.removeAttribute("aria-disabled");
            submitter.removeEventListener("click", $16d9fec6fae182d5$var$cancelEvent);
        }
    },
    "disabled": {
        beforeSubmit: (submitter)=>submitter.disabled = true,
        afterSubmit: (submitter)=>submitter.disabled = false
    }
};
class $16d9fec6fae182d5$var$Config {
    #submitter = null;
    constructor(config){
        Object.assign(this, config);
    }
    get submitter() {
        return this.#submitter;
    }
    set submitter(value) {
        this.#submitter = $16d9fec6fae182d5$var$submitter[value] || value;
    }
}
const $16d9fec6fae182d5$var$forms = new $16d9fec6fae182d5$var$Config({
    mode: "on",
    submitter: "disabled"
});
const $16d9fec6fae182d5$export$e506a1d27d1eaa20 = {
    drive: $16d9fec6fae182d5$var$drive,
    forms: $16d9fec6fae182d5$var$forms
};
function $16d9fec6fae182d5$var$expandURL(locatable) {
    return new URL(locatable.toString(), document.baseURI);
}
function $16d9fec6fae182d5$var$getAnchor(url) {
    let anchorMatch;
    if (url.hash) return url.hash.slice(1);
    else if (anchorMatch = url.href.match(/#(.*)$/)) return anchorMatch[1];
}
function $16d9fec6fae182d5$var$getAction$1(form, submitter) {
    const action = submitter?.getAttribute("formaction") || form.getAttribute("action") || form.action;
    return $16d9fec6fae182d5$var$expandURL(action);
}
function $16d9fec6fae182d5$var$getExtension(url) {
    return ($16d9fec6fae182d5$var$getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function $16d9fec6fae182d5$var$isPrefixedBy(baseURL, url) {
    const prefix = $16d9fec6fae182d5$var$addTrailingSlash(url.origin + url.pathname);
    return $16d9fec6fae182d5$var$addTrailingSlash(baseURL.href) === prefix || baseURL.href.startsWith(prefix);
}
function $16d9fec6fae182d5$var$locationIsVisitable(location1, rootLocation) {
    return $16d9fec6fae182d5$var$isPrefixedBy(location1, rootLocation) && !$16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.unvisitableExtensions.has($16d9fec6fae182d5$var$getExtension(location1));
}
function $16d9fec6fae182d5$var$getLocationForLink(link) {
    return $16d9fec6fae182d5$var$expandURL(link.getAttribute("href") || "");
}
function $16d9fec6fae182d5$var$getRequestURL(url) {
    const anchor = $16d9fec6fae182d5$var$getAnchor(url);
    return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function $16d9fec6fae182d5$var$toCacheKey(url) {
    return $16d9fec6fae182d5$var$getRequestURL(url);
}
function $16d9fec6fae182d5$var$urlsAreEqual(left, right) {
    return $16d9fec6fae182d5$var$expandURL(left).href == $16d9fec6fae182d5$var$expandURL(right).href;
}
function $16d9fec6fae182d5$var$getPathComponents(url) {
    return url.pathname.split("/").slice(1);
}
function $16d9fec6fae182d5$var$getLastPathComponent(url) {
    return $16d9fec6fae182d5$var$getPathComponents(url).slice(-1)[0];
}
function $16d9fec6fae182d5$var$addTrailingSlash(value) {
    return value.endsWith("/") ? value : value + "/";
}
class $16d9fec6fae182d5$export$3ae09bba5b6b906e {
    constructor(response){
        this.response = response;
    }
    get succeeded() {
        return this.response.ok;
    }
    get failed() {
        return !this.succeeded;
    }
    get clientError() {
        return this.statusCode >= 400 && this.statusCode <= 499;
    }
    get serverError() {
        return this.statusCode >= 500 && this.statusCode <= 599;
    }
    get redirected() {
        return this.response.redirected;
    }
    get location() {
        return $16d9fec6fae182d5$var$expandURL(this.response.url);
    }
    get isHTML() {
        return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
    }
    get statusCode() {
        return this.response.status;
    }
    get contentType() {
        return this.header("Content-Type");
    }
    get responseText() {
        return this.response.clone().text();
    }
    get responseHTML() {
        if (this.isHTML) return this.response.clone().text();
        else return Promise.resolve(undefined);
    }
    header(name) {
        return this.response.headers.get(name);
    }
}
class $16d9fec6fae182d5$var$LimitedSet extends Set {
    constructor(maxSize){
        super();
        this.maxSize = maxSize;
    }
    add(value) {
        if (this.size >= this.maxSize) {
            const iterator = this.values();
            const oldestValue = iterator.next().value;
            this.delete(oldestValue);
        }
        super.add(value);
    }
}
const $16d9fec6fae182d5$var$recentRequests = new $16d9fec6fae182d5$var$LimitedSet(20);
function $16d9fec6fae182d5$export$e7aa7bc5c1b3cfb3(url, options = {}) {
    const modifiedHeaders = new Headers(options.headers || {});
    const requestUID = $16d9fec6fae182d5$var$uuid();
    $16d9fec6fae182d5$var$recentRequests.add(requestUID);
    modifiedHeaders.append("X-Turbo-Request-Id", requestUID);
    return window.fetch(url, {
        ...options,
        headers: modifiedHeaders
    });
}
function $16d9fec6fae182d5$export$4d71dd6e9f25af75(method) {
    switch(method.toLowerCase()){
        case "get":
            return $16d9fec6fae182d5$export$76f6869e29ff06ee.get;
        case "post":
            return $16d9fec6fae182d5$export$76f6869e29ff06ee.post;
        case "put":
            return $16d9fec6fae182d5$export$76f6869e29ff06ee.put;
        case "patch":
            return $16d9fec6fae182d5$export$76f6869e29ff06ee.patch;
        case "delete":
            return $16d9fec6fae182d5$export$76f6869e29ff06ee.delete;
    }
}
const $16d9fec6fae182d5$export$76f6869e29ff06ee = {
    get: "get",
    post: "post",
    put: "put",
    patch: "patch",
    delete: "delete"
};
function $16d9fec6fae182d5$export$4894fff9b16f993d(encoding) {
    switch(encoding.toLowerCase()){
        case $16d9fec6fae182d5$export$12bb94f0959cac5.multipart:
            return $16d9fec6fae182d5$export$12bb94f0959cac5.multipart;
        case $16d9fec6fae182d5$export$12bb94f0959cac5.plain:
            return $16d9fec6fae182d5$export$12bb94f0959cac5.plain;
        default:
            return $16d9fec6fae182d5$export$12bb94f0959cac5.urlEncoded;
    }
}
const $16d9fec6fae182d5$export$12bb94f0959cac5 = {
    urlEncoded: "application/x-www-form-urlencoded",
    multipart: "multipart/form-data",
    plain: "text/plain"
};
class $16d9fec6fae182d5$export$319b96fe59834522 {
    abortController = new AbortController();
    #resolveRequestPromise = (_value)=>{};
    constructor(delegate, method, location1, requestBody = new URLSearchParams(), target = null, enctype = $16d9fec6fae182d5$export$12bb94f0959cac5.urlEncoded){
        const [url, body] = $16d9fec6fae182d5$var$buildResourceAndBody($16d9fec6fae182d5$var$expandURL(location1), method, requestBody, enctype);
        this.delegate = delegate;
        this.url = url;
        this.target = target;
        this.fetchOptions = {
            credentials: "same-origin",
            redirect: "follow",
            method: method.toUpperCase(),
            headers: {
                ...this.defaultHeaders
            },
            body: body,
            signal: this.abortSignal,
            referrer: this.delegate.referrer?.href
        };
        this.enctype = enctype;
    }
    get method() {
        return this.fetchOptions.method;
    }
    set method(value) {
        const fetchBody = this.isSafe ? this.url.searchParams : this.fetchOptions.body || new FormData();
        const fetchMethod = $16d9fec6fae182d5$export$4d71dd6e9f25af75(value) || $16d9fec6fae182d5$export$76f6869e29ff06ee.get;
        this.url.search = "";
        const [url, body] = $16d9fec6fae182d5$var$buildResourceAndBody(this.url, fetchMethod, fetchBody, this.enctype);
        this.url = url;
        this.fetchOptions.body = body;
        this.fetchOptions.method = fetchMethod.toUpperCase();
    }
    get headers() {
        return this.fetchOptions.headers;
    }
    set headers(value) {
        this.fetchOptions.headers = value;
    }
    get body() {
        if (this.isSafe) return this.url.searchParams;
        else return this.fetchOptions.body;
    }
    set body(value) {
        this.fetchOptions.body = value;
    }
    get location() {
        return this.url;
    }
    get params() {
        return this.url.searchParams;
    }
    get entries() {
        return this.body ? Array.from(this.body.entries()) : [];
    }
    cancel() {
        this.abortController.abort();
    }
    async perform() {
        const { fetchOptions: fetchOptions } = this;
        this.delegate.prepareRequest(this);
        const event = await this.#allowRequestToBeIntercepted(fetchOptions);
        try {
            this.delegate.requestStarted(this);
            if (event.detail.fetchRequest) this.response = event.detail.fetchRequest.response;
            else this.response = $16d9fec6fae182d5$export$e7aa7bc5c1b3cfb3(this.url.href, fetchOptions);
            const response = await this.response;
            return await this.receive(response);
        } catch (error) {
            if (error.name !== "AbortError") {
                if (this.#willDelegateErrorHandling(error)) this.delegate.requestErrored(this, error);
                throw error;
            }
        } finally{
            this.delegate.requestFinished(this);
        }
    }
    async receive(response) {
        const fetchResponse = new $16d9fec6fae182d5$export$3ae09bba5b6b906e(response);
        const event = $16d9fec6fae182d5$var$dispatch("turbo:before-fetch-response", {
            cancelable: true,
            detail: {
                fetchResponse: fetchResponse
            },
            target: this.target
        });
        if (event.defaultPrevented) this.delegate.requestPreventedHandlingResponse(this, fetchResponse);
        else if (fetchResponse.succeeded) this.delegate.requestSucceededWithResponse(this, fetchResponse);
        else this.delegate.requestFailedWithResponse(this, fetchResponse);
        return fetchResponse;
    }
    get defaultHeaders() {
        return {
            Accept: "text/html, application/xhtml+xml"
        };
    }
    get isSafe() {
        return $16d9fec6fae182d5$export$26e0721b40973527(this.method);
    }
    get abortSignal() {
        return this.abortController.signal;
    }
    acceptResponseType(mimeType) {
        this.headers["Accept"] = [
            mimeType,
            this.headers["Accept"]
        ].join(", ");
    }
    async #allowRequestToBeIntercepted(fetchOptions) {
        const requestInterception = new Promise((resolve)=>this.#resolveRequestPromise = resolve);
        const event = $16d9fec6fae182d5$var$dispatch("turbo:before-fetch-request", {
            cancelable: true,
            detail: {
                fetchOptions: fetchOptions,
                url: this.url,
                resume: this.#resolveRequestPromise
            },
            target: this.target
        });
        this.url = event.detail.url;
        if (event.defaultPrevented) await requestInterception;
        return event;
    }
    #willDelegateErrorHandling(error) {
        const event = $16d9fec6fae182d5$var$dispatch("turbo:fetch-request-error", {
            target: this.target,
            cancelable: true,
            detail: {
                request: this,
                error: error
            }
        });
        return !event.defaultPrevented;
    }
}
function $16d9fec6fae182d5$export$26e0721b40973527(fetchMethod) {
    return $16d9fec6fae182d5$export$4d71dd6e9f25af75(fetchMethod) == $16d9fec6fae182d5$export$76f6869e29ff06ee.get;
}
function $16d9fec6fae182d5$var$buildResourceAndBody(resource, method, requestBody, enctype) {
    const searchParams = Array.from(requestBody).length > 0 ? new URLSearchParams($16d9fec6fae182d5$var$entriesExcludingFiles(requestBody)) : resource.searchParams;
    if ($16d9fec6fae182d5$export$26e0721b40973527(method)) return [
        $16d9fec6fae182d5$var$mergeIntoURLSearchParams(resource, searchParams),
        null
    ];
    else if (enctype == $16d9fec6fae182d5$export$12bb94f0959cac5.urlEncoded) return [
        resource,
        searchParams
    ];
    else return [
        resource,
        requestBody
    ];
}
function $16d9fec6fae182d5$var$entriesExcludingFiles(requestBody) {
    const entries = [];
    for (const [name, value] of requestBody){
        if (value instanceof File) continue;
        else entries.push([
            name,
            value
        ]);
    }
    return entries;
}
function $16d9fec6fae182d5$var$mergeIntoURLSearchParams(url, requestBody) {
    const searchParams = new URLSearchParams($16d9fec6fae182d5$var$entriesExcludingFiles(requestBody));
    url.search = searchParams.toString();
    return url;
}
class $16d9fec6fae182d5$var$AppearanceObserver {
    started = false;
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
        this.intersectionObserver = new IntersectionObserver(this.intersect);
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.intersectionObserver.observe(this.element);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.intersectionObserver.unobserve(this.element);
        }
    }
    intersect = (entries)=>{
        const lastEntry = entries.slice(-1)[0];
        if (lastEntry?.isIntersecting) this.delegate.elementAppearedInViewport(this.element);
    };
}
class $16d9fec6fae182d5$var$StreamMessage {
    static contentType = "text/vnd.turbo-stream.html";
    static wrap(message) {
        if (typeof message == "string") return new this($16d9fec6fae182d5$var$createDocumentFragment(message));
        else return message;
    }
    constructor(fragment){
        this.fragment = $16d9fec6fae182d5$var$importStreamElements(fragment);
    }
}
function $16d9fec6fae182d5$var$importStreamElements(fragment) {
    for (const element of fragment.querySelectorAll("turbo-stream")){
        const streamElement = document.importNode(element, true);
        for (const inertScriptElement of streamElement.templateElement.content.querySelectorAll("script"))inertScriptElement.replaceWith($16d9fec6fae182d5$var$activateScriptElement(inertScriptElement));
        element.replaceWith(streamElement);
    }
    return fragment;
}
const $16d9fec6fae182d5$var$identity = (key)=>key;
class $16d9fec6fae182d5$var$LRUCache {
    keys = [];
    entries = {};
    #toCacheKey;
    constructor(size, toCacheKey = $16d9fec6fae182d5$var$identity){
        this.size = size;
        this.#toCacheKey = toCacheKey;
    }
    has(key) {
        return this.#toCacheKey(key) in this.entries;
    }
    get(key) {
        if (this.has(key)) {
            const entry = this.read(key);
            this.touch(key);
            return entry;
        }
    }
    put(key, entry) {
        this.write(key, entry);
        this.touch(key);
        return entry;
    }
    clear() {
        for (const key of Object.keys(this.entries))this.evict(key);
    }
    // Private
    read(key) {
        return this.entries[this.#toCacheKey(key)];
    }
    write(key, entry) {
        this.entries[this.#toCacheKey(key)] = entry;
    }
    touch(key) {
        key = this.#toCacheKey(key);
        const index = this.keys.indexOf(key);
        if (index > -1) this.keys.splice(index, 1);
        this.keys.unshift(key);
        this.trim();
    }
    trim() {
        for (const key of this.keys.splice(this.size))this.evict(key);
    }
    evict(key) {
        delete this.entries[key];
    }
}
const $16d9fec6fae182d5$var$PREFETCH_DELAY = 100;
class $16d9fec6fae182d5$var$PrefetchCache extends $16d9fec6fae182d5$var$LRUCache {
    #prefetchTimeout = null;
    #maxAges = {};
    constructor(size = 1, prefetchDelay = $16d9fec6fae182d5$var$PREFETCH_DELAY){
        super(size, $16d9fec6fae182d5$var$toCacheKey);
        this.prefetchDelay = prefetchDelay;
    }
    putLater(url, request, ttl) {
        this.#prefetchTimeout = setTimeout(()=>{
            request.perform();
            this.put(url, request, ttl);
            this.#prefetchTimeout = null;
        }, this.prefetchDelay);
    }
    put(url, request, ttl = $16d9fec6fae182d5$var$cacheTtl) {
        super.put(url, request);
        this.#maxAges[$16d9fec6fae182d5$var$toCacheKey(url)] = new Date(new Date().getTime() + ttl);
    }
    clear() {
        super.clear();
        if (this.#prefetchTimeout) clearTimeout(this.#prefetchTimeout);
    }
    evict(key) {
        super.evict(key);
        delete this.#maxAges[key];
    }
    has(key) {
        if (super.has(key)) {
            const maxAge = this.#maxAges[$16d9fec6fae182d5$var$toCacheKey(key)];
            return maxAge && maxAge > Date.now();
        } else return false;
    }
}
const $16d9fec6fae182d5$var$cacheTtl = 10000;
const $16d9fec6fae182d5$var$prefetchCache = new $16d9fec6fae182d5$var$PrefetchCache();
const $16d9fec6fae182d5$var$FormSubmissionState = {
    initialized: "initialized",
    requesting: "requesting",
    waiting: "waiting",
    receiving: "receiving",
    stopping: "stopping",
    stopped: "stopped"
};
class $16d9fec6fae182d5$var$FormSubmission {
    state = $16d9fec6fae182d5$var$FormSubmissionState.initialized;
    static confirmMethod(message) {
        return Promise.resolve(confirm(message));
    }
    constructor(delegate, formElement, submitter, mustRedirect = false){
        const method = $16d9fec6fae182d5$var$getMethod(formElement, submitter);
        const action = $16d9fec6fae182d5$var$getAction($16d9fec6fae182d5$var$getFormAction(formElement, submitter), method);
        const body = $16d9fec6fae182d5$var$buildFormData(formElement, submitter);
        const enctype = $16d9fec6fae182d5$var$getEnctype(formElement, submitter);
        this.delegate = delegate;
        this.formElement = formElement;
        this.submitter = submitter;
        this.fetchRequest = new $16d9fec6fae182d5$export$319b96fe59834522(this, method, action, body, formElement, enctype);
        this.mustRedirect = mustRedirect;
    }
    get method() {
        return this.fetchRequest.method;
    }
    set method(value) {
        this.fetchRequest.method = value;
    }
    get action() {
        return this.fetchRequest.url.toString();
    }
    set action(value) {
        this.fetchRequest.url = $16d9fec6fae182d5$var$expandURL(value);
    }
    get body() {
        return this.fetchRequest.body;
    }
    get enctype() {
        return this.fetchRequest.enctype;
    }
    get isSafe() {
        return this.fetchRequest.isSafe;
    }
    get location() {
        return this.fetchRequest.url;
    }
    // The submission process
    async start() {
        const { initialized: initialized, requesting: requesting } = $16d9fec6fae182d5$var$FormSubmissionState;
        const confirmationMessage = $16d9fec6fae182d5$var$getAttribute("data-turbo-confirm", this.submitter, this.formElement);
        if (typeof confirmationMessage === "string") {
            const confirmMethod = typeof $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.confirm === "function" ? $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.confirm : $16d9fec6fae182d5$var$FormSubmission.confirmMethod;
            const answer = await confirmMethod(confirmationMessage, this.formElement, this.submitter);
            if (!answer) return;
        }
        if (this.state == initialized) {
            this.state = requesting;
            return this.fetchRequest.perform();
        }
    }
    stop() {
        const { stopping: stopping, stopped: stopped } = $16d9fec6fae182d5$var$FormSubmissionState;
        if (this.state != stopping && this.state != stopped) {
            this.state = stopping;
            this.fetchRequest.cancel();
            return true;
        }
    }
    // Fetch request delegate
    prepareRequest(request) {
        if (!request.isSafe) {
            const token = $16d9fec6fae182d5$var$getCookieValue($16d9fec6fae182d5$var$getMetaContent("csrf-param")) || $16d9fec6fae182d5$var$getMetaContent("csrf-token");
            if (token) request.headers["X-CSRF-Token"] = token;
        }
        if (this.requestAcceptsTurboStreamResponse(request)) request.acceptResponseType($16d9fec6fae182d5$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        this.state = $16d9fec6fae182d5$var$FormSubmissionState.waiting;
        if (this.submitter) $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.submitter.beforeSubmit(this.submitter);
        this.setSubmitsWith();
        $16d9fec6fae182d5$var$markAsBusy(this.formElement);
        $16d9fec6fae182d5$var$dispatch("turbo:submit-start", {
            target: this.formElement,
            detail: {
                formSubmission: this
            }
        });
        this.delegate.formSubmissionStarted(this);
    }
    requestPreventedHandlingResponse(request, response) {
        $16d9fec6fae182d5$var$prefetchCache.clear();
        this.result = {
            success: response.succeeded,
            fetchResponse: response
        };
    }
    requestSucceededWithResponse(request, response) {
        if (response.clientError || response.serverError) {
            this.delegate.formSubmissionFailedWithResponse(this, response);
            return;
        }
        $16d9fec6fae182d5$var$prefetchCache.clear();
        if (this.requestMustRedirect(request) && $16d9fec6fae182d5$var$responseSucceededWithoutRedirect(response)) {
            const error = new Error("Form responses must redirect to another location");
            this.delegate.formSubmissionErrored(this, error);
        } else {
            this.state = $16d9fec6fae182d5$var$FormSubmissionState.receiving;
            this.result = {
                success: true,
                fetchResponse: response
            };
            this.delegate.formSubmissionSucceededWithResponse(this, response);
        }
    }
    requestFailedWithResponse(request, response) {
        this.result = {
            success: false,
            fetchResponse: response
        };
        this.delegate.formSubmissionFailedWithResponse(this, response);
    }
    requestErrored(request, error) {
        this.result = {
            success: false,
            error: error
        };
        this.delegate.formSubmissionErrored(this, error);
    }
    requestFinished(_request) {
        this.state = $16d9fec6fae182d5$var$FormSubmissionState.stopped;
        if (this.submitter) $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.submitter.afterSubmit(this.submitter);
        this.resetSubmitterText();
        $16d9fec6fae182d5$var$clearBusyState(this.formElement);
        $16d9fec6fae182d5$var$dispatch("turbo:submit-end", {
            target: this.formElement,
            detail: {
                formSubmission: this,
                ...this.result
            }
        });
        this.delegate.formSubmissionFinished(this);
    }
    // Private
    setSubmitsWith() {
        if (!this.submitter || !this.submitsWith) return;
        if (this.submitter.matches("button")) {
            this.originalSubmitText = this.submitter.innerHTML;
            this.submitter.innerHTML = this.submitsWith;
        } else if (this.submitter.matches("input")) {
            const input = this.submitter;
            this.originalSubmitText = input.value;
            input.value = this.submitsWith;
        }
    }
    resetSubmitterText() {
        if (!this.submitter || !this.originalSubmitText) return;
        if (this.submitter.matches("button")) this.submitter.innerHTML = this.originalSubmitText;
        else if (this.submitter.matches("input")) {
            const input = this.submitter;
            input.value = this.originalSubmitText;
        }
    }
    requestMustRedirect(request) {
        return !request.isSafe && this.mustRedirect;
    }
    requestAcceptsTurboStreamResponse(request) {
        return !request.isSafe || $16d9fec6fae182d5$var$hasAttribute("data-turbo-stream", this.submitter, this.formElement);
    }
    get submitsWith() {
        return this.submitter?.getAttribute("data-turbo-submits-with");
    }
}
function $16d9fec6fae182d5$var$buildFormData(formElement, submitter) {
    const formData = new FormData(formElement);
    const name = submitter?.getAttribute("name");
    const value = submitter?.getAttribute("value");
    if (name) formData.append(name, value || "");
    return formData;
}
function $16d9fec6fae182d5$var$getCookieValue(cookieName) {
    if (cookieName != null) {
        const cookies = document.cookie ? document.cookie.split("; ") : [];
        const cookie = cookies.find((cookie)=>cookie.startsWith(cookieName));
        if (cookie) {
            const value = cookie.split("=").slice(1).join("=");
            return value ? decodeURIComponent(value) : undefined;
        }
    }
}
function $16d9fec6fae182d5$var$responseSucceededWithoutRedirect(response) {
    return response.statusCode == 200 && !response.redirected;
}
function $16d9fec6fae182d5$var$getFormAction(formElement, submitter) {
    const formElementAction = typeof formElement.action === "string" ? formElement.action : null;
    if (submitter?.hasAttribute("formaction")) return submitter.getAttribute("formaction") || "";
    else return formElement.getAttribute("action") || formElementAction || "";
}
function $16d9fec6fae182d5$var$getAction(formAction, fetchMethod) {
    const action = $16d9fec6fae182d5$var$expandURL(formAction);
    if ($16d9fec6fae182d5$export$26e0721b40973527(fetchMethod)) action.search = "";
    return action;
}
function $16d9fec6fae182d5$var$getMethod(formElement, submitter) {
    const method = submitter?.getAttribute("formmethod") || formElement.getAttribute("method") || "";
    return $16d9fec6fae182d5$export$4d71dd6e9f25af75(method.toLowerCase()) || $16d9fec6fae182d5$export$76f6869e29ff06ee.get;
}
function $16d9fec6fae182d5$var$getEnctype(formElement, submitter) {
    return $16d9fec6fae182d5$export$4894fff9b16f993d(submitter?.getAttribute("formenctype") || formElement.enctype);
}
class $16d9fec6fae182d5$var$Snapshot {
    constructor(element){
        this.element = element;
    }
    get activeElement() {
        return this.element.ownerDocument.activeElement;
    }
    get children() {
        return [
            ...this.element.children
        ];
    }
    hasAnchor(anchor) {
        return this.getElementForAnchor(anchor) != null;
    }
    getElementForAnchor(anchor) {
        return anchor ? this.element.querySelector(`[id='${anchor}'], a[name='${anchor}']`) : null;
    }
    get isConnected() {
        return this.element.isConnected;
    }
    get firstAutofocusableElement() {
        return $16d9fec6fae182d5$var$queryAutofocusableElement(this.element);
    }
    get permanentElements() {
        return $16d9fec6fae182d5$var$queryPermanentElementsAll(this.element);
    }
    getPermanentElementById(id) {
        return $16d9fec6fae182d5$var$getPermanentElementById(this.element, id);
    }
    getPermanentElementMapForSnapshot(snapshot) {
        const permanentElementMap = {};
        for (const currentPermanentElement of this.permanentElements){
            const { id: id } = currentPermanentElement;
            const newPermanentElement = snapshot.getPermanentElementById(id);
            if (newPermanentElement) permanentElementMap[id] = [
                currentPermanentElement,
                newPermanentElement
            ];
        }
        return permanentElementMap;
    }
}
function $16d9fec6fae182d5$var$getPermanentElementById(node, id) {
    return node.querySelector(`#${id}[data-turbo-permanent]`);
}
function $16d9fec6fae182d5$var$queryPermanentElementsAll(node) {
    return node.querySelectorAll("[id][data-turbo-permanent]");
}
class $16d9fec6fae182d5$var$FormSubmitObserver {
    started = false;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("submit", this.submitCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
            this.started = false;
        }
    }
    submitCaptured = ()=>{
        this.eventTarget.removeEventListener("submit", this.submitBubbled, false);
        this.eventTarget.addEventListener("submit", this.submitBubbled, false);
    };
    submitBubbled = (event)=>{
        if (!event.defaultPrevented) {
            const form = event.target instanceof HTMLFormElement ? event.target : undefined;
            const submitter = event.submitter || undefined;
            if (form && $16d9fec6fae182d5$var$submissionDoesNotDismissDialog(form, submitter) && $16d9fec6fae182d5$var$submissionDoesNotTargetIFrame(form, submitter) && this.delegate.willSubmitForm(form, submitter)) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.delegate.formSubmitted(form, submitter);
            }
        }
    };
}
function $16d9fec6fae182d5$var$submissionDoesNotDismissDialog(form, submitter) {
    const method = submitter?.getAttribute("formmethod") || form.getAttribute("method");
    return method != "dialog";
}
function $16d9fec6fae182d5$var$submissionDoesNotTargetIFrame(form, submitter) {
    const target = submitter?.getAttribute("formtarget") || form.getAttribute("target");
    return $16d9fec6fae182d5$var$doesNotTargetIFrame(target);
}
class $16d9fec6fae182d5$var$View {
    #resolveRenderPromise = (_value)=>{};
    #resolveInterceptionPromise = (_value)=>{};
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
    }
    // Scrolling
    scrollToAnchor(anchor) {
        const element = this.snapshot.getElementForAnchor(anchor);
        if (element) {
            this.focusElement(element);
            this.scrollToElement(element);
        } else this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    scrollToAnchorFromLocation(location1) {
        this.scrollToAnchor($16d9fec6fae182d5$var$getAnchor(location1));
    }
    scrollToElement(element) {
        element.scrollIntoView();
    }
    focusElement(element) {
        if (element instanceof HTMLElement) {
            if (element.hasAttribute("tabindex")) element.focus();
            else {
                element.setAttribute("tabindex", "-1");
                element.focus();
                element.removeAttribute("tabindex");
            }
        }
    }
    scrollToPosition({ x: x, y: y }) {
        this.scrollRoot.scrollTo(x, y);
    }
    scrollToTop() {
        this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    get scrollRoot() {
        return window;
    }
    // Rendering
    async render(renderer) {
        const { isPreview: isPreview, shouldRender: shouldRender, willRender: willRender, newSnapshot: snapshot } = renderer;
        // A workaround to ignore tracked element mismatch reloads when performing
        // a promoted Visit from a frame navigation
        const shouldInvalidate = willRender;
        if (shouldRender) try {
            this.renderPromise = new Promise((resolve)=>this.#resolveRenderPromise = resolve);
            this.renderer = renderer;
            await this.prepareToRenderSnapshot(renderer);
            const renderInterception = new Promise((resolve)=>this.#resolveInterceptionPromise = resolve);
            const options = {
                resume: this.#resolveInterceptionPromise,
                render: this.renderer.renderElement,
                renderMethod: this.renderer.renderMethod
            };
            const immediateRender = this.delegate.allowsImmediateRender(snapshot, options);
            if (!immediateRender) await renderInterception;
            await this.renderSnapshot(renderer);
            this.delegate.viewRenderedSnapshot(snapshot, isPreview, this.renderer.renderMethod);
            this.delegate.preloadOnLoadLinksForView(this.element);
            this.finishRenderingSnapshot(renderer);
        } finally{
            delete this.renderer;
            this.#resolveRenderPromise(undefined);
            delete this.renderPromise;
        }
        else if (shouldInvalidate) this.invalidate(renderer.reloadReason);
    }
    invalidate(reason) {
        this.delegate.viewInvalidated(reason);
    }
    async prepareToRenderSnapshot(renderer) {
        this.markAsPreview(renderer.isPreview);
        await renderer.prepareToRender();
    }
    markAsPreview(isPreview) {
        if (isPreview) this.element.setAttribute("data-turbo-preview", "");
        else this.element.removeAttribute("data-turbo-preview");
    }
    markVisitDirection(direction) {
        this.element.setAttribute("data-turbo-visit-direction", direction);
    }
    unmarkVisitDirection() {
        this.element.removeAttribute("data-turbo-visit-direction");
    }
    async renderSnapshot(renderer) {
        await renderer.render();
    }
    finishRenderingSnapshot(renderer) {
        renderer.finishRendering();
    }
}
class $16d9fec6fae182d5$var$FrameView extends $16d9fec6fae182d5$var$View {
    missing() {
        this.element.innerHTML = `<strong class="turbo-frame-error">Content missing</strong>`;
    }
    get snapshot() {
        return new $16d9fec6fae182d5$var$Snapshot(this.element);
    }
}
class $16d9fec6fae182d5$var$LinkInterceptor {
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
    }
    start() {
        this.element.addEventListener("click", this.clickBubbled);
        document.addEventListener("turbo:click", this.linkClicked);
        document.addEventListener("turbo:before-visit", this.willVisit);
    }
    stop() {
        this.element.removeEventListener("click", this.clickBubbled);
        document.removeEventListener("turbo:click", this.linkClicked);
        document.removeEventListener("turbo:before-visit", this.willVisit);
    }
    clickBubbled = (event)=>{
        if (this.clickEventIsSignificant(event)) this.clickEvent = event;
        else delete this.clickEvent;
    };
    linkClicked = (event)=>{
        if (this.clickEvent && this.clickEventIsSignificant(event)) {
            if (this.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
                this.clickEvent.preventDefault();
                event.preventDefault();
                this.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
            }
        }
        delete this.clickEvent;
    };
    willVisit = (_event)=>{
        delete this.clickEvent;
    };
    clickEventIsSignificant(event) {
        const target = event.composed ? event.target?.parentElement : event.target;
        const element = $16d9fec6fae182d5$var$findLinkFromClickTarget(target) || target;
        return element instanceof Element && element.closest("turbo-frame, html") == this.element;
    }
}
class $16d9fec6fae182d5$var$LinkClickObserver {
    started = false;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("click", this.clickCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("click", this.clickCaptured, true);
            this.started = false;
        }
    }
    clickCaptured = ()=>{
        this.eventTarget.removeEventListener("click", this.clickBubbled, false);
        this.eventTarget.addEventListener("click", this.clickBubbled, false);
    };
    clickBubbled = (event)=>{
        if (event instanceof MouseEvent && this.clickEventIsSignificant(event)) {
            const target = event.composedPath && event.composedPath()[0] || event.target;
            const link = $16d9fec6fae182d5$var$findLinkFromClickTarget(target);
            if (link && $16d9fec6fae182d5$var$doesNotTargetIFrame(link.target)) {
                const location1 = $16d9fec6fae182d5$var$getLocationForLink(link);
                if (this.delegate.willFollowLinkToLocation(link, location1, event)) {
                    event.preventDefault();
                    this.delegate.followedLinkToLocation(link, location1);
                }
            }
        }
    };
    clickEventIsSignificant(event) {
        return !(event.target && event.target.isContentEditable || event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
    }
}
class $16d9fec6fae182d5$var$FormLinkClickObserver {
    constructor(delegate, element){
        this.delegate = delegate;
        this.linkInterceptor = new $16d9fec6fae182d5$var$LinkClickObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
    }
    stop() {
        this.linkInterceptor.stop();
    }
    // Link hover observer delegate
    canPrefetchRequestToLocation(link, location1) {
        return false;
    }
    prefetchAndCacheRequestToLocation(link, location1) {
        return;
    }
    // Link click observer delegate
    willFollowLinkToLocation(link, location1, originalEvent) {
        return this.delegate.willSubmitFormLinkToLocation(link, location1, originalEvent) && (link.hasAttribute("data-turbo-method") || link.hasAttribute("data-turbo-stream"));
    }
    followedLinkToLocation(link, location1) {
        const form = document.createElement("form");
        const type = "hidden";
        for (const [name, value] of location1.searchParams)form.append(Object.assign(document.createElement("input"), {
            type: type,
            name: name,
            value: value
        }));
        const action = Object.assign(location1, {
            search: ""
        });
        form.setAttribute("data-turbo", "true");
        form.setAttribute("action", action.href);
        form.setAttribute("hidden", "");
        const method = link.getAttribute("data-turbo-method");
        if (method) form.setAttribute("method", method);
        const turboFrame = link.getAttribute("data-turbo-frame");
        if (turboFrame) form.setAttribute("data-turbo-frame", turboFrame);
        const turboAction = $16d9fec6fae182d5$var$getVisitAction(link);
        if (turboAction) form.setAttribute("data-turbo-action", turboAction);
        const turboConfirm = link.getAttribute("data-turbo-confirm");
        if (turboConfirm) form.setAttribute("data-turbo-confirm", turboConfirm);
        const turboStream = link.hasAttribute("data-turbo-stream");
        if (turboStream) form.setAttribute("data-turbo-stream", "");
        this.delegate.submittedFormLinkToLocation(link, location1, form);
        document.body.appendChild(form);
        form.addEventListener("turbo:submit-end", ()=>form.remove(), {
            once: true
        });
        requestAnimationFrame(()=>form.requestSubmit());
    }
}
class $16d9fec6fae182d5$var$Bardo {
    static async preservingPermanentElements(delegate, permanentElementMap, callback) {
        const bardo = new this(delegate, permanentElementMap);
        bardo.enter();
        await callback();
        bardo.leave();
    }
    constructor(delegate, permanentElementMap){
        this.delegate = delegate;
        this.permanentElementMap = permanentElementMap;
    }
    enter() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement, newPermanentElement] = this.permanentElementMap[id];
            this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
            this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
        }
    }
    leave() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement] = this.permanentElementMap[id];
            this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
            this.replacePlaceholderWithPermanentElement(currentPermanentElement);
            this.delegate.leavingBardo(currentPermanentElement);
        }
    }
    replaceNewPermanentElementWithPlaceholder(permanentElement) {
        const placeholder = $16d9fec6fae182d5$var$createPlaceholderForPermanentElement(permanentElement);
        permanentElement.replaceWith(placeholder);
    }
    replaceCurrentPermanentElementWithClone(permanentElement) {
        const clone = permanentElement.cloneNode(true);
        permanentElement.replaceWith(clone);
    }
    replacePlaceholderWithPermanentElement(permanentElement) {
        const placeholder = this.getPlaceholderById(permanentElement.id);
        placeholder?.replaceWith(permanentElement);
    }
    getPlaceholderById(id) {
        return this.placeholders.find((element)=>element.content == id);
    }
    get placeholders() {
        return [
            ...document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]")
        ];
    }
}
function $16d9fec6fae182d5$var$createPlaceholderForPermanentElement(permanentElement) {
    const element = document.createElement("meta");
    element.setAttribute("name", "turbo-permanent-placeholder");
    element.setAttribute("content", permanentElement.id);
    return element;
}
class $16d9fec6fae182d5$var$Renderer {
    #activeElement = null;
    static renderElement(currentElement, newElement) {
    // Abstract method
    }
    constructor(currentSnapshot, newSnapshot, isPreview, willRender = true){
        this.currentSnapshot = currentSnapshot;
        this.newSnapshot = newSnapshot;
        this.isPreview = isPreview;
        this.willRender = willRender;
        this.renderElement = this.constructor.renderElement;
        this.promise = new Promise((resolve, reject)=>this.resolvingFunctions = {
                resolve: resolve,
                reject: reject
            });
    }
    get shouldRender() {
        return true;
    }
    get shouldAutofocus() {
        return true;
    }
    get reloadReason() {
        return;
    }
    prepareToRender() {
        return;
    }
    render() {
    // Abstract method
    }
    finishRendering() {
        if (this.resolvingFunctions) {
            this.resolvingFunctions.resolve();
            delete this.resolvingFunctions;
        }
    }
    async preservingPermanentElements(callback) {
        await $16d9fec6fae182d5$var$Bardo.preservingPermanentElements(this, this.permanentElementMap, callback);
    }
    focusFirstAutofocusableElement() {
        if (this.shouldAutofocus) {
            const element = this.connectedSnapshot.firstAutofocusableElement;
            if (element) element.focus();
        }
    }
    // Bardo delegate
    enteringBardo(currentPermanentElement) {
        if (this.#activeElement) return;
        if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) this.#activeElement = this.currentSnapshot.activeElement;
    }
    leavingBardo(currentPermanentElement) {
        if (currentPermanentElement.contains(this.#activeElement) && this.#activeElement instanceof HTMLElement) {
            this.#activeElement.focus();
            this.#activeElement = null;
        }
    }
    get connectedSnapshot() {
        return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
    }
    get currentElement() {
        return this.currentSnapshot.element;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    get permanentElementMap() {
        return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
    }
    get renderMethod() {
        return "replace";
    }
}
class $16d9fec6fae182d5$export$f09c4165d16bb2b7 extends $16d9fec6fae182d5$var$Renderer {
    static renderElement(currentElement, newElement) {
        const destinationRange = document.createRange();
        destinationRange.selectNodeContents(currentElement);
        destinationRange.deleteContents();
        const frameElement = newElement;
        const sourceRange = frameElement.ownerDocument?.createRange();
        if (sourceRange) {
            sourceRange.selectNodeContents(frameElement);
            currentElement.appendChild(sourceRange.extractContents());
        }
    }
    constructor(delegate, currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true){
        super(currentSnapshot, newSnapshot, renderElement, isPreview, willRender);
        this.delegate = delegate;
    }
    get shouldRender() {
        return true;
    }
    async render() {
        await $16d9fec6fae182d5$var$nextRepaint();
        this.preservingPermanentElements(()=>{
            this.loadFrameElement();
        });
        this.scrollFrameIntoView();
        await $16d9fec6fae182d5$var$nextRepaint();
        this.focusFirstAutofocusableElement();
        await $16d9fec6fae182d5$var$nextRepaint();
        this.activateScriptElements();
    }
    loadFrameElement() {
        this.delegate.willRenderFrame(this.currentElement, this.newElement);
        this.renderElement(this.currentElement, this.newElement);
    }
    scrollFrameIntoView() {
        if (this.currentElement.autoscroll || this.newElement.autoscroll) {
            const element = this.currentElement.firstElementChild;
            const block = $16d9fec6fae182d5$var$readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
            const behavior = $16d9fec6fae182d5$var$readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
            if (element) {
                element.scrollIntoView({
                    block: block,
                    behavior: behavior
                });
                return true;
            }
        }
        return false;
    }
    activateScriptElements() {
        for (const inertScriptElement of this.newScriptElements){
            const activatedScriptElement = $16d9fec6fae182d5$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    get newScriptElements() {
        return this.currentElement.querySelectorAll("script");
    }
}
function $16d9fec6fae182d5$var$readScrollLogicalPosition(value, defaultValue) {
    if (value == "end" || value == "start" || value == "center" || value == "nearest") return value;
    else return defaultValue;
}
function $16d9fec6fae182d5$var$readScrollBehavior(value, defaultValue) {
    if (value == "auto" || value == "smooth") return value;
    else return defaultValue;
}
/**
 * @typedef {object} ConfigHead
 *
 * @property {'merge' | 'append' | 'morph' | 'none'} [style]
 * @property {boolean} [block]
 * @property {boolean} [ignore]
 * @property {function(Element): boolean} [shouldPreserve]
 * @property {function(Element): boolean} [shouldReAppend]
 * @property {function(Element): boolean} [shouldRemove]
 * @property {function(Element, {added: Node[], kept: Element[], removed: Element[]}): void} [afterHeadMorphed]
 */ /**
 * @typedef {object} ConfigCallbacks
 *
 * @property {function(Node): boolean} [beforeNodeAdded]
 * @property {function(Node): void} [afterNodeAdded]
 * @property {function(Element, Node): boolean} [beforeNodeMorphed]
 * @property {function(Element, Node): void} [afterNodeMorphed]
 * @property {function(Element): boolean} [beforeNodeRemoved]
 * @property {function(Element): void} [afterNodeRemoved]
 * @property {function(string, Element, "update" | "remove"): boolean} [beforeAttributeUpdated]
 */ /**
 * @typedef {object} Config
 *
 * @property {'outerHTML' | 'innerHTML'} [morphStyle]
 * @property {boolean} [ignoreActive]
 * @property {boolean} [ignoreActiveValue]
 * @property {boolean} [restoreFocus]
 * @property {ConfigCallbacks} [callbacks]
 * @property {ConfigHead} [head]
 */ /**
 * @typedef {function} NoOp
 *
 * @returns {void}
 */ /**
 * @typedef {object} ConfigHeadInternal
 *
 * @property {'merge' | 'append' | 'morph' | 'none'} style
 * @property {boolean} [block]
 * @property {boolean} [ignore]
 * @property {(function(Element): boolean) | NoOp} shouldPreserve
 * @property {(function(Element): boolean) | NoOp} shouldReAppend
 * @property {(function(Element): boolean) | NoOp} shouldRemove
 * @property {(function(Element, {added: Node[], kept: Element[], removed: Element[]}): void) | NoOp} afterHeadMorphed
 */ /**
 * @typedef {object} ConfigCallbacksInternal
 *
 * @property {(function(Node): boolean) | NoOp} beforeNodeAdded
 * @property {(function(Node): void) | NoOp} afterNodeAdded
 * @property {(function(Node, Node): boolean) | NoOp} beforeNodeMorphed
 * @property {(function(Node, Node): void) | NoOp} afterNodeMorphed
 * @property {(function(Node): boolean) | NoOp} beforeNodeRemoved
 * @property {(function(Node): void) | NoOp} afterNodeRemoved
 * @property {(function(string, Element, "update" | "remove"): boolean) | NoOp} beforeAttributeUpdated
 */ /**
 * @typedef {object} ConfigInternal
 *
 * @property {'outerHTML' | 'innerHTML'} morphStyle
 * @property {boolean} [ignoreActive]
 * @property {boolean} [ignoreActiveValue]
 * @property {boolean} [restoreFocus]
 * @property {ConfigCallbacksInternal} callbacks
 * @property {ConfigHeadInternal} head
 */ /**
 * @typedef {Object} IdSets
 * @property {Set<string>} persistentIds
 * @property {Map<Node, Set<string>>} idMap
 */ /**
 * @typedef {Function} Morph
 *
 * @param {Element | Document} oldNode
 * @param {Element | Node | HTMLCollection | Node[] | string | null} newContent
 * @param {Config} [config]
 * @returns {undefined | Node[]}
 */ // base IIFE to define idiomorph
/**
 *
 * @type {{defaults: ConfigInternal, morph: Morph}}
 */ var $16d9fec6fae182d5$var$Idiomorph = function() {
    /**
   * @typedef {object} MorphContext
   *
   * @property {Element} target
   * @property {Element} newContent
   * @property {ConfigInternal} config
   * @property {ConfigInternal['morphStyle']} morphStyle
   * @property {ConfigInternal['ignoreActive']} ignoreActive
   * @property {ConfigInternal['ignoreActiveValue']} ignoreActiveValue
   * @property {ConfigInternal['restoreFocus']} restoreFocus
   * @property {Map<Node, Set<string>>} idMap
   * @property {Set<string>} persistentIds
   * @property {ConfigInternal['callbacks']} callbacks
   * @property {ConfigInternal['head']} head
   * @property {HTMLDivElement} pantry
   * @property {Element[]} activeElementAndParents
   */ //=============================================================================
    // AND NOW IT BEGINS...
    //=============================================================================
    const noOp = ()=>{};
    /**
   * Default configuration values, updatable by users now
   * @type {ConfigInternal}
   */ const defaults = {
        morphStyle: "outerHTML",
        callbacks: {
            beforeNodeAdded: noOp,
            afterNodeAdded: noOp,
            beforeNodeMorphed: noOp,
            afterNodeMorphed: noOp,
            beforeNodeRemoved: noOp,
            afterNodeRemoved: noOp,
            beforeAttributeUpdated: noOp
        },
        head: {
            style: "merge",
            shouldPreserve: (elt)=>elt.getAttribute("im-preserve") === "true",
            shouldReAppend: (elt)=>elt.getAttribute("im-re-append") === "true",
            shouldRemove: noOp,
            afterHeadMorphed: noOp
        },
        restoreFocus: true
    };
    /**
   * Core idiomorph function for morphing one DOM tree to another
   *
   * @param {Element | Document} oldNode
   * @param {Element | Node | HTMLCollection | Node[] | string | null} newContent
   * @param {Config} [config]
   * @returns {Promise<Node[]> | Node[]}
   */ function morph(oldNode, newContent, config = {}) {
        oldNode = normalizeElement(oldNode);
        const newNode = normalizeParent(newContent);
        const ctx = createMorphContext(oldNode, newNode, config);
        const morphedNodes = saveAndRestoreFocus(ctx, ()=>{
            return withHeadBlocking(ctx, oldNode, newNode, /** @param {MorphContext} ctx */ (ctx)=>{
                if (ctx.morphStyle === "innerHTML") {
                    morphChildren(ctx, oldNode, newNode);
                    return Array.from(oldNode.childNodes);
                } else return morphOuterHTML(ctx, oldNode, newNode);
            });
        });
        ctx.pantry.remove();
        return morphedNodes;
    }
    /**
   * Morph just the outerHTML of the oldNode to the newContent
   * We have to be careful because the oldNode could have siblings which need to be untouched
   * @param {MorphContext} ctx
   * @param {Element} oldNode
   * @param {Element} newNode
   * @returns {Node[]}
   */ function morphOuterHTML(ctx, oldNode, newNode) {
        const oldParent = normalizeParent(oldNode);
        morphChildren(ctx, oldParent, newNode, // these two optional params are the secret sauce
        oldNode, oldNode.nextSibling);
        // this is safe even with siblings, because normalizeParent returns a SlicedParentNode if needed.
        return Array.from(oldParent.childNodes);
    }
    /**
   * @param {MorphContext} ctx
   * @param {Function} fn
   * @returns {Promise<Node[]> | Node[]}
   */ function saveAndRestoreFocus(ctx, fn) {
        if (!ctx.config.restoreFocus) return fn();
        let activeElement = /** @type {HTMLInputElement|HTMLTextAreaElement|null} */ document.activeElement;
        // don't bother if the active element is not an input or textarea
        if (!(activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement)) return fn();
        const { id: activeElementId, selectionStart: selectionStart, selectionEnd: selectionEnd } = activeElement;
        const results = fn();
        if (activeElementId && activeElementId !== document.activeElement?.getAttribute("id")) {
            activeElement = ctx.target.querySelector(`[id="${activeElementId}"]`);
            activeElement?.focus();
        }
        if (activeElement && !activeElement.selectionEnd && selectionEnd) activeElement.setSelectionRange(selectionStart, selectionEnd);
        return results;
    }
    const morphChildren = function() {
        /**
     * This is the core algorithm for matching up children.  The idea is to use id sets to try to match up
     * nodes as faithfully as possible.  We greedily match, which allows us to keep the algorithm fast, but
     * by using id sets, we are able to better match up with content deeper in the DOM.
     *
     * Basic algorithm:
     * - for each node in the new content:
     *   - search self and siblings for an id set match, falling back to a soft match
     *   - if match found
     *     - remove any nodes up to the match:
     *       - pantry persistent nodes
     *       - delete the rest
     *     - morph the match
     *   - elsif no match found, and node is persistent
     *     - find its match by querying the old root (future) and pantry (past)
     *     - move it and its children here
     *     - morph it
     *   - else
     *     - create a new node from scratch as a last result
     *
     * @param {MorphContext} ctx the merge context
     * @param {Element} oldParent the old content that we are merging the new content into
     * @param {Element} newParent the parent element of the new content
     * @param {Node|null} [insertionPoint] the point in the DOM we start morphing at (defaults to first child)
     * @param {Node|null} [endPoint] the point in the DOM we stop morphing at (defaults to after last child)
     */ function morphChildren(ctx, oldParent, newParent, insertionPoint = null, endPoint = null) {
            // normalize
            if (oldParent instanceof HTMLTemplateElement && newParent instanceof HTMLTemplateElement) {
                // @ts-ignore we can pretend the DocumentFragment is an Element
                oldParent = oldParent.content;
                // @ts-ignore ditto
                newParent = newParent.content;
            }
            insertionPoint ||= oldParent.firstChild;
            // run through all the new content
            for (const newChild of newParent.childNodes){
                // once we reach the end of the old parent content skip to the end and insert the rest
                if (insertionPoint && insertionPoint != endPoint) {
                    const bestMatch = findBestMatch(ctx, newChild, insertionPoint, endPoint);
                    if (bestMatch) {
                        // if the node to morph is not at the insertion point then remove/move up to it
                        if (bestMatch !== insertionPoint) removeNodesBetween(ctx, insertionPoint, bestMatch);
                        morphNode(bestMatch, newChild, ctx);
                        insertionPoint = bestMatch.nextSibling;
                        continue;
                    }
                }
                // if the matching node is elsewhere in the original content
                if (newChild instanceof Element) {
                    // we can pretend the id is non-null because the next `.has` line will reject it if not
                    const newChildId = /** @type {String} */ newChild.getAttribute("id");
                    if (ctx.persistentIds.has(newChildId)) {
                        // move it and all its children here and morph
                        const movedChild = moveBeforeById(oldParent, newChildId, insertionPoint, ctx);
                        morphNode(movedChild, newChild, ctx);
                        insertionPoint = movedChild.nextSibling;
                        continue;
                    }
                }
                // last resort: insert the new node from scratch
                const insertedNode = createNode(oldParent, newChild, insertionPoint, ctx);
                // could be null if beforeNodeAdded prevented insertion
                if (insertedNode) insertionPoint = insertedNode.nextSibling;
            }
            // remove any remaining old nodes that didn't match up with new content
            while(insertionPoint && insertionPoint != endPoint){
                const tempNode = insertionPoint;
                insertionPoint = insertionPoint.nextSibling;
                removeNode(ctx, tempNode);
            }
        }
        /**
     * This performs the action of inserting a new node while handling situations where the node contains
     * elements with persistent ids and possible state info we can still preserve by moving in and then morphing
     *
     * @param {Element} oldParent
     * @param {Node} newChild
     * @param {Node|null} insertionPoint
     * @param {MorphContext} ctx
     * @returns {Node|null}
     */ function createNode(oldParent, newChild, insertionPoint, ctx) {
            if (ctx.callbacks.beforeNodeAdded(newChild) === false) return null;
            if (ctx.idMap.has(newChild)) {
                // node has children with ids with possible state so create a dummy elt of same type and apply full morph algorithm
                const newEmptyChild = document.createElement(/** @type {Element} */ newChild.tagName);
                oldParent.insertBefore(newEmptyChild, insertionPoint);
                morphNode(newEmptyChild, newChild, ctx);
                ctx.callbacks.afterNodeAdded(newEmptyChild);
                return newEmptyChild;
            } else {
                // optimisation: no id state to preserve so we can just insert a clone of the newChild and its descendants
                const newClonedChild = document.importNode(newChild, true); // importNode to not mutate newParent
                oldParent.insertBefore(newClonedChild, insertionPoint);
                ctx.callbacks.afterNodeAdded(newClonedChild);
                return newClonedChild;
            }
        }
        //=============================================================================
        // Matching Functions
        //=============================================================================
        const findBestMatch = function() {
            /**
       * Scans forward from the startPoint to the endPoint looking for a match
       * for the node. It looks for an id set match first, then a soft match.
       * We abort softmatching if we find two future soft matches, to reduce churn.
       * @param {Node} node
       * @param {MorphContext} ctx
       * @param {Node | null} startPoint
       * @param {Node | null} endPoint
       * @returns {Node | null}
       */ function findBestMatch(ctx, node, startPoint, endPoint) {
                let softMatch = null;
                let nextSibling = node.nextSibling;
                let siblingSoftMatchCount = 0;
                let cursor = startPoint;
                while(cursor && cursor != endPoint){
                    // soft matching is a prerequisite for id set matching
                    if (isSoftMatch(cursor, node)) {
                        if (isIdSetMatch(ctx, cursor, node)) return cursor; // found an id set match, we're done!
                        // we haven't yet saved a soft match fallback
                        if (softMatch === null) // the current soft match will hard match something else in the future, leave it
                        {
                            if (!ctx.idMap.has(cursor)) // save this as the fallback if we get through the loop without finding a hard match
                            softMatch = cursor;
                        }
                    }
                    if (softMatch === null && nextSibling && isSoftMatch(cursor, nextSibling)) {
                        // The next new node has a soft match with this node, so
                        // increment the count of future soft matches
                        siblingSoftMatchCount++;
                        nextSibling = nextSibling.nextSibling;
                        // If there are two future soft matches, block soft matching for this node to allow
                        // future siblings to soft match. This is to reduce churn in the DOM when an element
                        // is prepended.
                        if (siblingSoftMatchCount >= 2) softMatch = undefined;
                    }
                    // if the current node contains active element, stop looking for better future matches,
                    // because if one is found, this node will be moved to the pantry, reparenting it and thus losing focus
                    // @ts-ignore pretend cursor is Element rather than Node, we're just testing for array inclusion
                    if (ctx.activeElementAndParents.includes(cursor)) break;
                    cursor = cursor.nextSibling;
                }
                return softMatch || null;
            }
            /**
       *
       * @param {MorphContext} ctx
       * @param {Node} oldNode
       * @param {Node} newNode
       * @returns {boolean}
       */ function isIdSetMatch(ctx, oldNode, newNode) {
                let oldSet = ctx.idMap.get(oldNode);
                let newSet = ctx.idMap.get(newNode);
                if (!newSet || !oldSet) return false;
                for (const id of oldSet){
                    // a potential match is an id in the new and old nodes that
                    // has not already been merged into the DOM
                    // But the newNode content we call this on has not been
                    // merged yet and we don't allow duplicate IDs so it is simple
                    if (newSet.has(id)) return true;
                }
                return false;
            }
            /**
       *
       * @param {Node} oldNode
       * @param {Node} newNode
       * @returns {boolean}
       */ function isSoftMatch(oldNode, newNode) {
                // ok to cast: if one is not element, `id` and `tagName` will be undefined and we'll just compare that.
                const oldElt = /** @type {Element} */ oldNode;
                const newElt = /** @type {Element} */ newNode;
                return oldElt.nodeType === newElt.nodeType && oldElt.tagName === newElt.tagName && // If oldElt has an `id` with possible state and it doesn't match newElt.id then avoid morphing.
                // We'll still match an anonymous node with an IDed newElt, though, because if it got this far,
                // its not persistent, and new nodes can't have any hidden state.
                // We can't use .id because of form input shadowing, and we can't count on .getAttribute's presence because it could be a document-fragment
                (!oldElt.getAttribute?.("id") || oldElt.getAttribute?.("id") === newElt.getAttribute?.("id"));
            }
            return findBestMatch;
        }();
        //=============================================================================
        // DOM Manipulation Functions
        //=============================================================================
        /**
     * Gets rid of an unwanted DOM node; strategy depends on nature of its reuse:
     * - Persistent nodes will be moved to the pantry for later reuse
     * - Other nodes will have their hooks called, and then are removed
     * @param {MorphContext} ctx
     * @param {Node} node
     */ function removeNode(ctx, node) {
            // are we going to id set match this later?
            if (ctx.idMap.has(node)) // skip callbacks and move to pantry
            moveBefore(ctx.pantry, node, null);
            else {
                // remove for realsies
                if (ctx.callbacks.beforeNodeRemoved(node) === false) return;
                node.parentNode?.removeChild(node);
                ctx.callbacks.afterNodeRemoved(node);
            }
        }
        /**
     * Remove nodes between the start and end nodes
     * @param {MorphContext} ctx
     * @param {Node} startInclusive
     * @param {Node} endExclusive
     * @returns {Node|null}
     */ function removeNodesBetween(ctx, startInclusive, endExclusive) {
            /** @type {Node | null} */ let cursor = startInclusive;
            // remove nodes until the endExclusive node
            while(cursor && cursor !== endExclusive){
                let tempNode = /** @type {Node} */ cursor;
                cursor = cursor.nextSibling;
                removeNode(ctx, tempNode);
            }
            return cursor;
        }
        /**
     * Search for an element by id within the document and pantry, and move it using moveBefore.
     *
     * @param {Element} parentNode - The parent node to which the element will be moved.
     * @param {string} id - The ID of the element to be moved.
     * @param {Node | null} after - The reference node to insert the element before.
     *                              If `null`, the element is appended as the last child.
     * @param {MorphContext} ctx
     * @returns {Element} The found element
     */ function moveBeforeById(parentNode, id, after, ctx) {
            const target = /** @type {Element} - will always be found */ // ctx.target.id unsafe because of form input shadowing
            // ctx.target could be a document fragment which doesn't have `getAttribute`
            ctx.target.getAttribute?.("id") === id && ctx.target || ctx.target.querySelector(`[id="${id}"]`) || ctx.pantry.querySelector(`[id="${id}"]`);
            removeElementFromAncestorsIdMaps(target, ctx);
            moveBefore(parentNode, target, after);
            return target;
        }
        /**
     * Removes an element from its ancestors' id maps. This is needed when an element is moved from the
     * "future" via `moveBeforeId`. Otherwise, its erstwhile ancestors could be mistakenly moved to the
     * pantry rather than being deleted, preventing their removal hooks from being called.
     *
     * @param {Element} element - element to remove from its ancestors' id maps
     * @param {MorphContext} ctx
     */ function removeElementFromAncestorsIdMaps(element, ctx) {
            // we know id is non-null String, because this function is only called on elements with ids
            const id = /** @type {String} */ element.getAttribute("id");
            /** @ts-ignore - safe to loop in this way **/ while(element = element.parentNode){
                let idSet = ctx.idMap.get(element);
                if (idSet) {
                    idSet.delete(id);
                    if (!idSet.size) ctx.idMap.delete(element);
                }
            }
        }
        /**
     * Moves an element before another element within the same parent.
     * Uses the proposed `moveBefore` API if available (and working), otherwise falls back to `insertBefore`.
     * This is essentialy a forward-compat wrapper.
     *
     * @param {Element} parentNode - The parent node containing the after element.
     * @param {Node} element - The element to be moved.
     * @param {Node | null} after - The reference node to insert `element` before.
     *                              If `null`, `element` is appended as the last child.
     */ function moveBefore(parentNode, element, after) {
            // @ts-ignore - use proposed moveBefore feature
            if (parentNode.moveBefore) try {
                // @ts-ignore - use proposed moveBefore feature
                parentNode.moveBefore(element, after);
            } catch (e) {
                // fall back to insertBefore as some browsers may fail on moveBefore when trying to move Dom disconnected nodes to pantry
                parentNode.insertBefore(element, after);
            }
            else parentNode.insertBefore(element, after);
        }
        return morphChildren;
    }();
    //=============================================================================
    // Single Node Morphing Code
    //=============================================================================
    const morphNode = function() {
        /**
     * @param {Node} oldNode root node to merge content into
     * @param {Node} newContent new content to merge
     * @param {MorphContext} ctx the merge context
     * @returns {Node | null} the element that ended up in the DOM
     */ function morphNode(oldNode, newContent, ctx) {
            if (ctx.ignoreActive && oldNode === document.activeElement) // don't morph focused element
            return null;
            if (ctx.callbacks.beforeNodeMorphed(oldNode, newContent) === false) return oldNode;
            if (oldNode instanceof HTMLHeadElement && ctx.head.ignore) ;
            else if (oldNode instanceof HTMLHeadElement && ctx.head.style !== "morph") // ok to cast: if newContent wasn't also a <head>, it would've got caught in the `!isSoftMatch` branch above
            handleHeadElement(oldNode, /** @type {HTMLHeadElement} */ newContent, ctx);
            else {
                morphAttributes(oldNode, newContent, ctx);
                if (!ignoreValueOfActiveElement(oldNode, ctx)) // @ts-ignore newContent can be a node here because .firstChild will be null
                morphChildren(ctx, oldNode, newContent);
            }
            ctx.callbacks.afterNodeMorphed(oldNode, newContent);
            return oldNode;
        }
        /**
     * syncs the oldNode to the newNode, copying over all attributes and
     * inner element state from the newNode to the oldNode
     *
     * @param {Node} oldNode the node to copy attributes & state to
     * @param {Node} newNode the node to copy attributes & state from
     * @param {MorphContext} ctx the merge context
     */ function morphAttributes(oldNode, newNode, ctx) {
            let type = newNode.nodeType;
            // if is an element type, sync the attributes from the
            // new node into the new node
            if (type === 1 /* element type */ ) {
                const oldElt = /** @type {Element} */ oldNode;
                const newElt = /** @type {Element} */ newNode;
                const oldAttributes = oldElt.attributes;
                const newAttributes = newElt.attributes;
                for (const newAttribute of newAttributes){
                    if (ignoreAttribute(newAttribute.name, oldElt, "update", ctx)) continue;
                    if (oldElt.getAttribute(newAttribute.name) !== newAttribute.value) oldElt.setAttribute(newAttribute.name, newAttribute.value);
                }
                // iterate backwards to avoid skipping over items when a delete occurs
                for(let i = oldAttributes.length - 1; 0 <= i; i--){
                    const oldAttribute = oldAttributes[i];
                    // toAttributes is a live NamedNodeMap, so iteration+mutation is unsafe
                    // e.g. custom element attribute callbacks can remove other attributes
                    if (!oldAttribute) continue;
                    if (!newElt.hasAttribute(oldAttribute.name)) {
                        if (ignoreAttribute(oldAttribute.name, oldElt, "remove", ctx)) continue;
                        oldElt.removeAttribute(oldAttribute.name);
                    }
                }
                if (!ignoreValueOfActiveElement(oldElt, ctx)) syncInputValue(oldElt, newElt, ctx);
            }
            // sync text nodes
            if (type === 8 /* comment */  || type === 3 /* text */ ) {
                if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
            }
        }
        /**
     * NB: many bothans died to bring us information:
     *
     *  https://github.com/patrick-steele-idem/morphdom/blob/master/src/specialElHandlers.js
     *  https://github.com/choojs/nanomorph/blob/master/lib/morph.jsL113
     *
     * @param {Element} oldElement the element to sync the input value to
     * @param {Element} newElement the element to sync the input value from
     * @param {MorphContext} ctx the merge context
     */ function syncInputValue(oldElement, newElement, ctx) {
            if (oldElement instanceof HTMLInputElement && newElement instanceof HTMLInputElement && newElement.type !== "file") {
                let newValue = newElement.value;
                let oldValue = oldElement.value;
                // sync boolean attributes
                syncBooleanAttribute(oldElement, newElement, "checked", ctx);
                syncBooleanAttribute(oldElement, newElement, "disabled", ctx);
                if (!newElement.hasAttribute("value")) {
                    if (!ignoreAttribute("value", oldElement, "remove", ctx)) {
                        oldElement.value = "";
                        oldElement.removeAttribute("value");
                    }
                } else if (oldValue !== newValue) {
                    if (!ignoreAttribute("value", oldElement, "update", ctx)) {
                        oldElement.setAttribute("value", newValue);
                        oldElement.value = newValue;
                    }
                }
            // TODO: QUESTION(1cg): this used to only check `newElement` unlike the other branches -- why?
            // did I break something?
            } else if (oldElement instanceof HTMLOptionElement && newElement instanceof HTMLOptionElement) syncBooleanAttribute(oldElement, newElement, "selected", ctx);
            else if (oldElement instanceof HTMLTextAreaElement && newElement instanceof HTMLTextAreaElement) {
                let newValue = newElement.value;
                let oldValue = oldElement.value;
                if (ignoreAttribute("value", oldElement, "update", ctx)) return;
                if (newValue !== oldValue) oldElement.value = newValue;
                if (oldElement.firstChild && oldElement.firstChild.nodeValue !== newValue) oldElement.firstChild.nodeValue = newValue;
            }
        }
        /**
     * @param {Element} oldElement element to write the value to
     * @param {Element} newElement element to read the value from
     * @param {string} attributeName the attribute name
     * @param {MorphContext} ctx the merge context
     */ function syncBooleanAttribute(oldElement, newElement, attributeName, ctx) {
            // @ts-ignore this function is only used on boolean attrs that are reflected as dom properties
            const newLiveValue = newElement[attributeName], // @ts-ignore ditto
            oldLiveValue = oldElement[attributeName];
            if (newLiveValue !== oldLiveValue) {
                const ignoreUpdate = ignoreAttribute(attributeName, oldElement, "update", ctx);
                if (!ignoreUpdate) // update attribute's associated DOM property
                // @ts-ignore this function is only used on boolean attrs that are reflected as dom properties
                oldElement[attributeName] = newElement[attributeName];
                if (newLiveValue) {
                    if (!ignoreUpdate) // https://developer.mozilla.org/en-US/docs/Glossary/Boolean/HTML
                    // this is the correct way to set a boolean attribute to "true"
                    oldElement.setAttribute(attributeName, "");
                } else if (!ignoreAttribute(attributeName, oldElement, "remove", ctx)) oldElement.removeAttribute(attributeName);
            }
        }
        /**
     * @param {string} attr the attribute to be mutated
     * @param {Element} element the element that is going to be updated
     * @param {"update" | "remove"} updateType
     * @param {MorphContext} ctx the merge context
     * @returns {boolean} true if the attribute should be ignored, false otherwise
     */ function ignoreAttribute(attr, element, updateType, ctx) {
            if (attr === "value" && ctx.ignoreActiveValue && element === document.activeElement) return true;
            return ctx.callbacks.beforeAttributeUpdated(attr, element, updateType) === false;
        }
        /**
     * @param {Node} possibleActiveElement
     * @param {MorphContext} ctx
     * @returns {boolean}
     */ function ignoreValueOfActiveElement(possibleActiveElement, ctx) {
            return !!ctx.ignoreActiveValue && possibleActiveElement === document.activeElement && possibleActiveElement !== document.body;
        }
        return morphNode;
    }();
    //=============================================================================
    // Head Management Functions
    //=============================================================================
    /**
   * @param {MorphContext} ctx
   * @param {Element} oldNode
   * @param {Element} newNode
   * @param {function} callback
   * @returns {Node[] | Promise<Node[]>}
   */ function withHeadBlocking(ctx, oldNode, newNode, callback) {
        if (ctx.head.block) {
            const oldHead = oldNode.querySelector("head");
            const newHead = newNode.querySelector("head");
            if (oldHead && newHead) {
                const promises = handleHeadElement(oldHead, newHead, ctx);
                // when head promises resolve, proceed ignoring the head tag
                return Promise.all(promises).then(()=>{
                    const newCtx = Object.assign(ctx, {
                        head: {
                            block: false,
                            ignore: true
                        }
                    });
                    return callback(newCtx);
                });
            }
        }
        // just proceed if we not head blocking
        return callback(ctx);
    }
    /**
   *  The HEAD tag can be handled specially, either w/ a 'merge' or 'append' style
   *
   * @param {Element} oldHead
   * @param {Element} newHead
   * @param {MorphContext} ctx
   * @returns {Promise<void>[]}
   */ function handleHeadElement(oldHead, newHead, ctx) {
        let added = [];
        let removed = [];
        let preserved = [];
        let nodesToAppend = [];
        // put all new head elements into a Map, by their outerHTML
        let srcToNewHeadNodes = new Map();
        for (const newHeadChild of newHead.children)srcToNewHeadNodes.set(newHeadChild.outerHTML, newHeadChild);
        // for each elt in the current head
        for (const currentHeadElt of oldHead.children){
            // If the current head element is in the map
            let inNewContent = srcToNewHeadNodes.has(currentHeadElt.outerHTML);
            let isReAppended = ctx.head.shouldReAppend(currentHeadElt);
            let isPreserved = ctx.head.shouldPreserve(currentHeadElt);
            if (inNewContent || isPreserved) {
                if (isReAppended) // remove the current version and let the new version replace it and re-execute
                removed.push(currentHeadElt);
                else {
                    // this element already exists and should not be re-appended, so remove it from
                    // the new content map, preserving it in the DOM
                    srcToNewHeadNodes.delete(currentHeadElt.outerHTML);
                    preserved.push(currentHeadElt);
                }
            } else {
                if (ctx.head.style === "append") // we are appending and this existing element is not new content
                // so if and only if it is marked for re-append do we do anything
                {
                    if (isReAppended) {
                        removed.push(currentHeadElt);
                        nodesToAppend.push(currentHeadElt);
                    }
                } else // if this is a merge, we remove this content since it is not in the new head
                if (ctx.head.shouldRemove(currentHeadElt) !== false) removed.push(currentHeadElt);
            }
        }
        // Push the remaining new head elements in the Map into the
        // nodes to append to the head tag
        nodesToAppend.push(...srcToNewHeadNodes.values());
        let promises = [];
        for (const newNode of nodesToAppend){
            // TODO: This could theoretically be null, based on type
            let newElt = /** @type {ChildNode} */ document.createRange().createContextualFragment(newNode.outerHTML).firstChild;
            if (ctx.callbacks.beforeNodeAdded(newElt) !== false) {
                if ("href" in newElt && newElt.href || "src" in newElt && newElt.src) {
                    /** @type {(result?: any) => void} */ let resolve;
                    let promise = new Promise(function(_resolve) {
                        resolve = _resolve;
                    });
                    newElt.addEventListener("load", function() {
                        resolve();
                    });
                    promises.push(promise);
                }
                oldHead.appendChild(newElt);
                ctx.callbacks.afterNodeAdded(newElt);
                added.push(newElt);
            }
        }
        // remove all removed elements, after we have appended the new elements to avoid
        // additional network requests for things like style sheets
        for (const removedElement of removed)if (ctx.callbacks.beforeNodeRemoved(removedElement) !== false) {
            oldHead.removeChild(removedElement);
            ctx.callbacks.afterNodeRemoved(removedElement);
        }
        ctx.head.afterHeadMorphed(oldHead, {
            added: added,
            kept: preserved,
            removed: removed
        });
        return promises;
    }
    //=============================================================================
    // Create Morph Context Functions
    //=============================================================================
    const createMorphContext = function() {
        /**
     *
     * @param {Element} oldNode
     * @param {Element} newContent
     * @param {Config} config
     * @returns {MorphContext}
     */ function createMorphContext(oldNode, newContent, config) {
            const { persistentIds: persistentIds, idMap: idMap } = createIdMaps(oldNode, newContent);
            const mergedConfig = mergeDefaults(config);
            const morphStyle = mergedConfig.morphStyle || "outerHTML";
            if (![
                "innerHTML",
                "outerHTML"
            ].includes(morphStyle)) throw `Do not understand how to morph style ${morphStyle}`;
            return {
                target: oldNode,
                newContent: newContent,
                config: mergedConfig,
                morphStyle: morphStyle,
                ignoreActive: mergedConfig.ignoreActive,
                ignoreActiveValue: mergedConfig.ignoreActiveValue,
                restoreFocus: mergedConfig.restoreFocus,
                idMap: idMap,
                persistentIds: persistentIds,
                pantry: createPantry(),
                activeElementAndParents: createActiveElementAndParents(oldNode),
                callbacks: mergedConfig.callbacks,
                head: mergedConfig.head
            };
        }
        /**
     * Deep merges the config object and the Idiomorph.defaults object to
     * produce a final configuration object
     * @param {Config} config
     * @returns {ConfigInternal}
     */ function mergeDefaults(config) {
            let finalConfig = Object.assign({}, defaults);
            // copy top level stuff into final config
            Object.assign(finalConfig, config);
            // copy callbacks into final config (do this to deep merge the callbacks)
            finalConfig.callbacks = Object.assign({}, defaults.callbacks, config.callbacks);
            // copy head config into final config  (do this to deep merge the head)
            finalConfig.head = Object.assign({}, defaults.head, config.head);
            return finalConfig;
        }
        /**
     * @returns {HTMLDivElement}
     */ function createPantry() {
            const pantry = document.createElement("div");
            pantry.hidden = true;
            document.body.insertAdjacentElement("afterend", pantry);
            return pantry;
        }
        /**
     * @param {Element} oldNode
     * @returns {Element[]}
     */ function createActiveElementAndParents(oldNode) {
            /** @type {Element[]} */ let activeElementAndParents = [];
            let elt = document.activeElement;
            if (elt?.tagName !== "BODY" && oldNode.contains(elt)) while(elt){
                activeElementAndParents.push(elt);
                if (elt === oldNode) break;
                elt = elt.parentElement;
            }
            return activeElementAndParents;
        }
        /**
     * Returns all elements with an ID contained within the root element and its descendants
     *
     * @param {Element} root
     * @returns {Element[]}
     */ function findIdElements(root) {
            let elements = Array.from(root.querySelectorAll("[id]"));
            // root could be a document fragment which doesn't have `getAttribute`
            if (root.getAttribute?.("id")) elements.push(root);
            return elements;
        }
        /**
     * A bottom-up algorithm that populates a map of Element -> IdSet.
     * The idSet for a given element is the set of all IDs contained within its subtree.
     * As an optimzation, we filter these IDs through the given list of persistent IDs,
     * because we don't need to bother considering IDed elements that won't be in the new content.
     *
     * @param {Map<Node, Set<string>>} idMap
     * @param {Set<string>} persistentIds
     * @param {Element} root
     * @param {Element[]} elements
     */ function populateIdMapWithTree(idMap, persistentIds, root, elements) {
            for (const elt of elements){
                // we can pretend id is non-null String, because the .has line will reject it immediately if not
                const id = /** @type {String} */ elt.getAttribute("id");
                if (persistentIds.has(id)) {
                    /** @type {Element|null} */ let current = elt;
                    // walk up the parent hierarchy of that element, adding the id
                    // of element to the parent's id set
                    while(current){
                        let idSet = idMap.get(current);
                        // if the id set doesn't exist, create it and insert it in the map
                        if (idSet == null) {
                            idSet = new Set();
                            idMap.set(current, idSet);
                        }
                        idSet.add(id);
                        if (current === root) break;
                        current = current.parentElement;
                    }
                }
            }
        }
        /**
     * This function computes a map of nodes to all ids contained within that node (inclusive of the
     * node).  This map can be used to ask if two nodes have intersecting sets of ids, which allows
     * for a looser definition of "matching" than tradition id matching, and allows child nodes
     * to contribute to a parent nodes matching.
     *
     * @param {Element} oldContent  the old content that will be morphed
     * @param {Element} newContent  the new content to morph to
     * @returns {IdSets}
     */ function createIdMaps(oldContent, newContent) {
            const oldIdElements = findIdElements(oldContent);
            const newIdElements = findIdElements(newContent);
            const persistentIds = createPersistentIds(oldIdElements, newIdElements);
            /** @type {Map<Node, Set<string>>} */ let idMap = new Map();
            populateIdMapWithTree(idMap, persistentIds, oldContent, oldIdElements);
            /** @ts-ignore - if newContent is a duck-typed parent, pass its single child node as the root to halt upwards iteration */ const newRoot = newContent.__idiomorphRoot || newContent;
            populateIdMapWithTree(idMap, persistentIds, newRoot, newIdElements);
            return {
                persistentIds: persistentIds,
                idMap: idMap
            };
        }
        /**
     * This function computes the set of ids that persist between the two contents excluding duplicates
     *
     * @param {Element[]} oldIdElements
     * @param {Element[]} newIdElements
     * @returns {Set<string>}
     */ function createPersistentIds(oldIdElements, newIdElements) {
            let duplicateIds = new Set();
            /** @type {Map<string, string>} */ let oldIdTagNameMap = new Map();
            for (const { id: id, tagName: tagName } of oldIdElements)if (oldIdTagNameMap.has(id)) duplicateIds.add(id);
            else oldIdTagNameMap.set(id, tagName);
            let persistentIds = new Set();
            for (const { id: id, tagName: tagName } of newIdElements){
                if (persistentIds.has(id)) duplicateIds.add(id);
                else if (oldIdTagNameMap.get(id) === tagName) persistentIds.add(id);
            // skip if tag types mismatch because its not possible to morph one tag into another
            }
            for (const id of duplicateIds)persistentIds.delete(id);
            return persistentIds;
        }
        return createMorphContext;
    }();
    //=============================================================================
    // HTML Normalization Functions
    //=============================================================================
    const { normalizeElement: normalizeElement, normalizeParent: normalizeParent } = function() {
        /** @type {WeakSet<Node>} */ const generatedByIdiomorph = new WeakSet();
        /**
     *
     * @param {Element | Document} content
     * @returns {Element}
     */ function normalizeElement(content) {
            if (content instanceof Document) return content.documentElement;
            else return content;
        }
        /**
     *
     * @param {null | string | Node | HTMLCollection | Node[] | Document & {generatedByIdiomorph:boolean}} newContent
     * @returns {Element}
     */ function normalizeParent(newContent) {
            if (newContent == null) return document.createElement("div"); // dummy parent element
            else if (typeof newContent === "string") return normalizeParent(parseContent(newContent));
            else if (generatedByIdiomorph.has(/** @type {Element} */ newContent)) // the template tag created by idiomorph parsing can serve as a dummy parent
            return /** @type {Element} */ newContent;
            else if (newContent instanceof Node) {
                if (newContent.parentNode) // we can't use the parent directly because newContent may have siblings
                // that we don't want in the morph, and reparenting might be expensive (TODO is it?),
                // so instead we create a fake parent node that only sees a slice of its children.
                /** @type {Element} */ return /** @type {any} */ new SlicedParentNode(newContent);
                else {
                    // a single node is added as a child to a dummy parent
                    const dummyParent = document.createElement("div");
                    dummyParent.append(newContent);
                    return dummyParent;
                }
            } else {
                // all nodes in the array or HTMLElement collection are consolidated under
                // a single dummy parent element
                const dummyParent = document.createElement("div");
                for (const elt of [
                    ...newContent
                ])dummyParent.append(elt);
                return dummyParent;
            }
        }
        /**
     * A fake duck-typed parent element to wrap a single node, without actually reparenting it.
     * This is useful because the node may have siblings that we don't want in the morph, and it may also be moved
     * or replaced with one or more elements during the morph. This class effectively allows us a window into
     * a slice of a node's children.
     * "If it walks like a duck, and quacks like a duck, then it must be a duck!" -- James Whitcomb Riley (1849–1916)
     */ class SlicedParentNode {
            /** @param {Node} node */ constructor(node){
                this.originalNode = node;
                this.realParentNode = /** @type {Element} */ node.parentNode;
                this.previousSibling = node.previousSibling;
                this.nextSibling = node.nextSibling;
            }
            /** @returns {Node[]} */ get childNodes() {
                // return slice of realParent's current childNodes, based on previousSibling and nextSibling
                const nodes = [];
                let cursor = this.previousSibling ? this.previousSibling.nextSibling : this.realParentNode.firstChild;
                while(cursor && cursor != this.nextSibling){
                    nodes.push(cursor);
                    cursor = cursor.nextSibling;
                }
                return nodes;
            }
            /**
       * @param {string} selector
       * @returns {Element[]}
       */ querySelectorAll(selector) {
                return this.childNodes.reduce((results, node)=>{
                    if (node instanceof Element) {
                        if (node.matches(selector)) results.push(node);
                        const nodeList = node.querySelectorAll(selector);
                        for(let i = 0; i < nodeList.length; i++)results.push(nodeList[i]);
                    }
                    return results;
                }, /** @type {Element[]} */ []);
            }
            /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */ insertBefore(node, referenceNode) {
                return this.realParentNode.insertBefore(node, referenceNode);
            }
            /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */ moveBefore(node, referenceNode) {
                // @ts-ignore - use new moveBefore feature
                return this.realParentNode.moveBefore(node, referenceNode);
            }
            /**
       * for later use with populateIdMapWithTree to halt upwards iteration
       * @returns {Node}
       */ get __idiomorphRoot() {
                return this.originalNode;
            }
        }
        /**
     *
     * @param {string} newContent
     * @returns {Node | null | DocumentFragment}
     */ function parseContent(newContent) {
            let parser = new DOMParser();
            // remove svgs to avoid false-positive matches on head, etc.
            let contentWithSvgsRemoved = newContent.replace(/<svg(\s[^>]*>|>)([\s\S]*?)<\/svg>/gim, "");
            // if the newContent contains a html, head or body tag, we can simply parse it w/o wrapping
            if (contentWithSvgsRemoved.match(/<\/html>/) || contentWithSvgsRemoved.match(/<\/head>/) || contentWithSvgsRemoved.match(/<\/body>/)) {
                let content = parser.parseFromString(newContent, "text/html");
                // if it is a full HTML document, return the document itself as the parent container
                if (contentWithSvgsRemoved.match(/<\/html>/)) {
                    generatedByIdiomorph.add(content);
                    return content;
                } else {
                    // otherwise return the html element as the parent container
                    let htmlElement = content.firstChild;
                    if (htmlElement) generatedByIdiomorph.add(htmlElement);
                    return htmlElement;
                }
            } else {
                // if it is partial HTML, wrap it in a template tag to provide a parent element and also to help
                // deal with touchy tags like tr, tbody, etc.
                let responseDoc = parser.parseFromString("<body><template>" + newContent + "</template></body>", "text/html");
                let content = /** @type {HTMLTemplateElement} */ responseDoc.body.querySelector("template").content;
                generatedByIdiomorph.add(content);
                return content;
            }
        }
        return {
            normalizeElement: normalizeElement,
            normalizeParent: normalizeParent
        };
    }();
    //=============================================================================
    // This is what ends up becoming the Idiomorph global object
    //=============================================================================
    return {
        morph: morph,
        defaults: defaults
    };
}();
/**
 * Morph the state of the currentElement based on the attributes and contents of
 * the newElement. Morphing may dispatch turbo:before-morph-element,
 * turbo:before-morph-attribute, and turbo:morph-element events.
 *
 * @param currentElement Element destination of morphing changes
 * @param newElement Element source of morphing changes
 */ function $16d9fec6fae182d5$export$dc74801294c91b10(currentElement, newElement, { callbacks: callbacks, ...options } = {}) {
    $16d9fec6fae182d5$var$Idiomorph.morph(currentElement, newElement, {
        ...options,
        callbacks: new $16d9fec6fae182d5$var$DefaultIdiomorphCallbacks(callbacks)
    });
}
/**
 * Morph the child elements of the currentElement based on the child elements of
 * the newElement. Morphing children may dispatch turbo:before-morph-element,
 * turbo:before-morph-attribute, and turbo:morph-element events.
 *
 * @param currentElement Element destination of morphing children changes
 * @param newElement Element source of morphing children changes
 */ function $16d9fec6fae182d5$export$e0eeaf5bc84bd47b(currentElement, newElement, options = {}) {
    $16d9fec6fae182d5$export$dc74801294c91b10(currentElement, newElement.childNodes, {
        ...options,
        morphStyle: "innerHTML"
    });
}
function $16d9fec6fae182d5$var$shouldRefreshFrameWithMorphing(currentFrame, newFrame) {
    return currentFrame instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44 && currentFrame.shouldReloadWithMorph && (!newFrame || $16d9fec6fae182d5$var$areFramesCompatibleForRefreshing(currentFrame, newFrame)) && !currentFrame.closest("[data-turbo-permanent]");
}
function $16d9fec6fae182d5$var$areFramesCompatibleForRefreshing(currentFrame, newFrame) {
    // newFrame cannot yet be an instance of FrameElement because custom
    // elements don't get initialized until they're attached to the DOM, so
    // test its Element#nodeName instead
    return newFrame instanceof Element && newFrame.nodeName === "TURBO-FRAME" && currentFrame.id === newFrame.id && (!newFrame.getAttribute("src") || $16d9fec6fae182d5$var$urlsAreEqual(currentFrame.src, newFrame.getAttribute("src")));
}
function $16d9fec6fae182d5$var$closestFrameReloadableWithMorphing(node) {
    return node.parentElement.closest("turbo-frame[src][refresh=morph]");
}
class $16d9fec6fae182d5$var$DefaultIdiomorphCallbacks {
    #beforeNodeMorphed;
    constructor({ beforeNodeMorphed: beforeNodeMorphed } = {}){
        this.#beforeNodeMorphed = beforeNodeMorphed || (()=>true);
    }
    beforeNodeAdded = (node)=>{
        return !(node.id && node.hasAttribute("data-turbo-permanent") && document.getElementById(node.id));
    };
    beforeNodeMorphed = (currentElement, newElement)=>{
        if (currentElement instanceof Element) {
            if (!currentElement.hasAttribute("data-turbo-permanent") && this.#beforeNodeMorphed(currentElement, newElement)) {
                const event = $16d9fec6fae182d5$var$dispatch("turbo:before-morph-element", {
                    cancelable: true,
                    target: currentElement,
                    detail: {
                        currentElement: currentElement,
                        newElement: newElement
                    }
                });
                return !event.defaultPrevented;
            } else return false;
        }
    };
    beforeAttributeUpdated = (attributeName, target, mutationType)=>{
        const event = $16d9fec6fae182d5$var$dispatch("turbo:before-morph-attribute", {
            cancelable: true,
            target: target,
            detail: {
                attributeName: attributeName,
                mutationType: mutationType
            }
        });
        return !event.defaultPrevented;
    };
    beforeNodeRemoved = (node)=>{
        return this.beforeNodeMorphed(node);
    };
    afterNodeMorphed = (currentElement, newElement)=>{
        if (currentElement instanceof Element) $16d9fec6fae182d5$var$dispatch("turbo:morph-element", {
            target: currentElement,
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
    };
}
class $16d9fec6fae182d5$var$MorphingFrameRenderer extends $16d9fec6fae182d5$export$f09c4165d16bb2b7 {
    static renderElement(currentElement, newElement) {
        $16d9fec6fae182d5$var$dispatch("turbo:before-frame-morph", {
            target: currentElement,
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
        $16d9fec6fae182d5$export$e0eeaf5bc84bd47b(currentElement, newElement, {
            callbacks: {
                beforeNodeMorphed: (node, newNode)=>{
                    if ($16d9fec6fae182d5$var$shouldRefreshFrameWithMorphing(node, newNode) && $16d9fec6fae182d5$var$closestFrameReloadableWithMorphing(node) === currentElement) {
                        node.reload();
                        return false;
                    }
                    return true;
                }
            }
        });
    }
    async preservingPermanentElements(callback) {
        return await callback();
    }
}
class $16d9fec6fae182d5$var$ProgressBar {
    static animationDuration = 300 /*ms*/ ;
    static get defaultCSS() {
        return $16d9fec6fae182d5$var$unindent`
      .turbo-progress-bar {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        height: 3px;
        background: #0076ff;
        z-index: 2147483647;
        transition:
          width ${$16d9fec6fae182d5$var$ProgressBar.animationDuration}ms ease-out,
          opacity ${$16d9fec6fae182d5$var$ProgressBar.animationDuration / 2}ms ${$16d9fec6fae182d5$var$ProgressBar.animationDuration / 2}ms ease-in;
        transform: translate3d(0, 0, 0);
      }
    `;
    }
    hiding = false;
    value = 0;
    visible = false;
    constructor(){
        this.stylesheetElement = this.createStylesheetElement();
        this.progressElement = this.createProgressElement();
        this.installStylesheetElement();
        this.setValue(0);
    }
    show() {
        if (!this.visible) {
            this.visible = true;
            this.installProgressElement();
            this.startTrickling();
        }
    }
    hide() {
        if (this.visible && !this.hiding) {
            this.hiding = true;
            this.fadeProgressElement(()=>{
                this.uninstallProgressElement();
                this.stopTrickling();
                this.visible = false;
                this.hiding = false;
            });
        }
    }
    setValue(value) {
        this.value = value;
        this.refresh();
    }
    // Private
    installStylesheetElement() {
        document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
    }
    installProgressElement() {
        this.progressElement.style.width = "0";
        this.progressElement.style.opacity = "1";
        document.documentElement.insertBefore(this.progressElement, document.body);
        this.refresh();
    }
    fadeProgressElement(callback) {
        this.progressElement.style.opacity = "0";
        setTimeout(callback, $16d9fec6fae182d5$var$ProgressBar.animationDuration * 1.5);
    }
    uninstallProgressElement() {
        if (this.progressElement.parentNode) document.documentElement.removeChild(this.progressElement);
    }
    startTrickling() {
        if (!this.trickleInterval) this.trickleInterval = window.setInterval(this.trickle, $16d9fec6fae182d5$var$ProgressBar.animationDuration);
    }
    stopTrickling() {
        window.clearInterval(this.trickleInterval);
        delete this.trickleInterval;
    }
    trickle = ()=>{
        this.setValue(this.value + Math.random() / 100);
    };
    refresh() {
        requestAnimationFrame(()=>{
            this.progressElement.style.width = `${10 + this.value * 90}%`;
        });
    }
    createStylesheetElement() {
        const element = document.createElement("style");
        element.type = "text/css";
        element.textContent = $16d9fec6fae182d5$var$ProgressBar.defaultCSS;
        const cspNonce = $16d9fec6fae182d5$var$getCspNonce();
        if (cspNonce) element.nonce = cspNonce;
        return element;
    }
    createProgressElement() {
        const element = document.createElement("div");
        element.className = "turbo-progress-bar";
        return element;
    }
}
class $16d9fec6fae182d5$var$HeadSnapshot extends $16d9fec6fae182d5$var$Snapshot {
    detailsByOuterHTML = this.children.filter((element)=>!$16d9fec6fae182d5$var$elementIsNoscript(element)).map((element)=>$16d9fec6fae182d5$var$elementWithoutNonce(element)).reduce((result, element)=>{
        const { outerHTML: outerHTML } = element;
        const details = outerHTML in result ? result[outerHTML] : {
            type: $16d9fec6fae182d5$var$elementType(element),
            tracked: $16d9fec6fae182d5$var$elementIsTracked(element),
            elements: []
        };
        return {
            ...result,
            [outerHTML]: {
                ...details,
                elements: [
                    ...details.elements,
                    element
                ]
            }
        };
    }, {});
    get trackedElementSignature() {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>this.detailsByOuterHTML[outerHTML].tracked).join("");
    }
    getScriptElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
    }
    getStylesheetElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
    }
    getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>!(outerHTML in snapshot.detailsByOuterHTML)).map((outerHTML)=>this.detailsByOuterHTML[outerHTML]).filter(({ type: type })=>type == matchedType).map(({ elements: [element] })=>element);
    }
    get provisionalElements() {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { type: type, tracked: tracked, elements: elements } = this.detailsByOuterHTML[outerHTML];
            if (type == null && !tracked) return [
                ...result,
                ...elements
            ];
            else if (elements.length > 1) return [
                ...result,
                ...elements.slice(1)
            ];
            else return result;
        }, []);
    }
    getMetaValue(name) {
        const element = this.findMetaElementByName(name);
        return element ? element.getAttribute("content") : null;
    }
    findMetaElementByName(name) {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { elements: [element] } = this.detailsByOuterHTML[outerHTML];
            return $16d9fec6fae182d5$var$elementIsMetaElementWithName(element, name) ? element : result;
        }, 0);
    }
}
function $16d9fec6fae182d5$var$elementType(element) {
    if ($16d9fec6fae182d5$var$elementIsScript(element)) return "script";
    else if ($16d9fec6fae182d5$var$elementIsStylesheet(element)) return "stylesheet";
}
function $16d9fec6fae182d5$var$elementIsTracked(element) {
    return element.getAttribute("data-turbo-track") == "reload";
}
function $16d9fec6fae182d5$var$elementIsScript(element) {
    const tagName = element.localName;
    return tagName == "script";
}
function $16d9fec6fae182d5$var$elementIsNoscript(element) {
    const tagName = element.localName;
    return tagName == "noscript";
}
function $16d9fec6fae182d5$var$elementIsStylesheet(element) {
    const tagName = element.localName;
    return tagName == "style" || tagName == "link" && element.getAttribute("rel") == "stylesheet";
}
function $16d9fec6fae182d5$var$elementIsMetaElementWithName(element, name) {
    const tagName = element.localName;
    return tagName == "meta" && element.getAttribute("name") == name;
}
function $16d9fec6fae182d5$var$elementWithoutNonce(element) {
    if (element.hasAttribute("nonce")) element.setAttribute("nonce", "");
    return element;
}
class $16d9fec6fae182d5$export$4f11b95e473fd113 extends $16d9fec6fae182d5$var$Snapshot {
    static fromHTMLString(html = "") {
        return this.fromDocument($16d9fec6fae182d5$var$parseHTMLDocument(html));
    }
    static fromElement(element) {
        return this.fromDocument(element.ownerDocument);
    }
    static fromDocument({ documentElement: documentElement, body: body, head: head }) {
        return new this(documentElement, body, new $16d9fec6fae182d5$var$HeadSnapshot(head));
    }
    constructor(documentElement, body, headSnapshot){
        super(body);
        this.documentElement = documentElement;
        this.headSnapshot = headSnapshot;
    }
    clone() {
        const clonedElement = this.element.cloneNode(true);
        const selectElements = this.element.querySelectorAll("select");
        const clonedSelectElements = clonedElement.querySelectorAll("select");
        for (const [index, source] of selectElements.entries()){
            const clone = clonedSelectElements[index];
            for (const option of clone.selectedOptions)option.selected = false;
            for (const option of source.selectedOptions)clone.options[option.index].selected = true;
        }
        for (const clonedPasswordInput of clonedElement.querySelectorAll('input[type="password"]'))clonedPasswordInput.value = "";
        for (const clonedNoscriptElement of clonedElement.querySelectorAll("noscript"))clonedNoscriptElement.remove();
        return new $16d9fec6fae182d5$export$4f11b95e473fd113(this.documentElement, clonedElement, this.headSnapshot);
    }
    get lang() {
        return this.documentElement.getAttribute("lang");
    }
    get dir() {
        return this.documentElement.getAttribute("dir");
    }
    get headElement() {
        return this.headSnapshot.element;
    }
    get rootLocation() {
        const root = this.getSetting("root") ?? "/";
        return $16d9fec6fae182d5$var$expandURL(root);
    }
    get cacheControlValue() {
        return this.getSetting("cache-control");
    }
    get isPreviewable() {
        return this.cacheControlValue != "no-preview";
    }
    get isCacheable() {
        return this.cacheControlValue != "no-cache";
    }
    get isVisitable() {
        return this.getSetting("visit-control") != "reload";
    }
    get prefersViewTransitions() {
        const viewTransitionEnabled = this.getSetting("view-transition") === "true" || this.headSnapshot.getMetaValue("view-transition") === "same-origin";
        return viewTransitionEnabled && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    get refreshMethod() {
        return this.getSetting("refresh-method");
    }
    get refreshScroll() {
        return this.getSetting("refresh-scroll");
    }
    // Private
    getSetting(name) {
        return this.headSnapshot.getMetaValue(`turbo-${name}`);
    }
}
class $16d9fec6fae182d5$var$ViewTransitioner {
    #viewTransitionStarted = false;
    #lastOperation = Promise.resolve();
    renderChange(useViewTransition, render) {
        if (useViewTransition && this.viewTransitionsAvailable && !this.#viewTransitionStarted) {
            this.#viewTransitionStarted = true;
            this.#lastOperation = this.#lastOperation.then(async ()=>{
                await document.startViewTransition(render).finished;
            });
        } else this.#lastOperation = this.#lastOperation.then(render);
        return this.#lastOperation;
    }
    get viewTransitionsAvailable() {
        return document.startViewTransition;
    }
}
const $16d9fec6fae182d5$var$defaultOptions = {
    action: "advance",
    historyChanged: false,
    visitCachedSnapshot: ()=>{},
    willRender: true,
    updateHistory: true,
    shouldCacheSnapshot: true,
    acceptsStreamResponse: false,
    refresh: {}
};
const $16d9fec6fae182d5$var$TimingMetric = {
    visitStart: "visitStart",
    requestStart: "requestStart",
    requestEnd: "requestEnd",
    visitEnd: "visitEnd"
};
const $16d9fec6fae182d5$var$VisitState = {
    initialized: "initialized",
    started: "started",
    canceled: "canceled",
    failed: "failed",
    completed: "completed"
};
const $16d9fec6fae182d5$var$SystemStatusCode = {
    networkFailure: 0,
    timeoutFailure: -1,
    contentTypeMismatch: -2
};
const $16d9fec6fae182d5$var$Direction = {
    advance: "forward",
    restore: "back",
    replace: "none"
};
class $16d9fec6fae182d5$var$Visit {
    identifier = $16d9fec6fae182d5$var$uuid() // Required by turbo-ios
    ;
    timingMetrics = {};
    followedRedirect = false;
    historyChanged = false;
    scrolled = false;
    shouldCacheSnapshot = true;
    acceptsStreamResponse = false;
    snapshotCached = false;
    state = $16d9fec6fae182d5$var$VisitState.initialized;
    viewTransitioner = new $16d9fec6fae182d5$var$ViewTransitioner();
    constructor(delegate, location1, restorationIdentifier, options = {}){
        this.delegate = delegate;
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier || $16d9fec6fae182d5$var$uuid();
        const { action: action, historyChanged: historyChanged, referrer: referrer, snapshot: snapshot, snapshotHTML: snapshotHTML, response: response, visitCachedSnapshot: visitCachedSnapshot, willRender: willRender, updateHistory: updateHistory, shouldCacheSnapshot: shouldCacheSnapshot, acceptsStreamResponse: acceptsStreamResponse, direction: direction, refresh: refresh } = {
            ...$16d9fec6fae182d5$var$defaultOptions,
            ...options
        };
        this.action = action;
        this.historyChanged = historyChanged;
        this.referrer = referrer;
        this.snapshot = snapshot;
        this.snapshotHTML = snapshotHTML;
        this.response = response;
        this.isPageRefresh = this.view.isPageRefresh(this);
        this.visitCachedSnapshot = visitCachedSnapshot;
        this.willRender = willRender;
        this.updateHistory = updateHistory;
        this.scrolled = !willRender;
        this.shouldCacheSnapshot = shouldCacheSnapshot;
        this.acceptsStreamResponse = acceptsStreamResponse;
        this.direction = direction || $16d9fec6fae182d5$var$Direction[action];
        this.refresh = refresh;
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    get restorationData() {
        return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
    }
    start() {
        if (this.state == $16d9fec6fae182d5$var$VisitState.initialized) {
            this.recordTimingMetric($16d9fec6fae182d5$var$TimingMetric.visitStart);
            this.state = $16d9fec6fae182d5$var$VisitState.started;
            this.adapter.visitStarted(this);
            this.delegate.visitStarted(this);
        }
    }
    cancel() {
        if (this.state == $16d9fec6fae182d5$var$VisitState.started) {
            if (this.request) this.request.cancel();
            this.cancelRender();
            this.state = $16d9fec6fae182d5$var$VisitState.canceled;
        }
    }
    complete() {
        if (this.state == $16d9fec6fae182d5$var$VisitState.started) {
            this.recordTimingMetric($16d9fec6fae182d5$var$TimingMetric.visitEnd);
            this.adapter.visitCompleted(this);
            this.state = $16d9fec6fae182d5$var$VisitState.completed;
            this.followRedirect();
            if (!this.followedRedirect) this.delegate.visitCompleted(this);
        }
    }
    fail() {
        if (this.state == $16d9fec6fae182d5$var$VisitState.started) {
            this.state = $16d9fec6fae182d5$var$VisitState.failed;
            this.adapter.visitFailed(this);
            this.delegate.visitCompleted(this);
        }
    }
    changeHistory() {
        if (!this.historyChanged && this.updateHistory) {
            const actionForHistory = this.location.href === this.referrer?.href ? "replace" : this.action;
            const method = $16d9fec6fae182d5$var$getHistoryMethodForAction(actionForHistory);
            this.history.update(method, this.location, this.restorationIdentifier);
            this.historyChanged = true;
        }
    }
    issueRequest() {
        if (this.hasPreloadedResponse()) this.simulateRequest();
        else if (this.shouldIssueRequest() && !this.request) {
            this.request = new $16d9fec6fae182d5$export$319b96fe59834522(this, $16d9fec6fae182d5$export$76f6869e29ff06ee.get, this.location);
            this.request.perform();
        }
    }
    simulateRequest() {
        if (this.response) {
            this.startRequest();
            this.recordResponse();
            this.finishRequest();
        }
    }
    startRequest() {
        this.recordTimingMetric($16d9fec6fae182d5$var$TimingMetric.requestStart);
        this.adapter.visitRequestStarted(this);
    }
    recordResponse(response = this.response) {
        this.response = response;
        if (response) {
            const { statusCode: statusCode } = response;
            if ($16d9fec6fae182d5$var$isSuccessful(statusCode)) this.adapter.visitRequestCompleted(this);
            else this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
        }
    }
    finishRequest() {
        this.recordTimingMetric($16d9fec6fae182d5$var$TimingMetric.requestEnd);
        this.adapter.visitRequestFinished(this);
    }
    loadResponse() {
        if (this.response) {
            const { statusCode: statusCode, responseHTML: responseHTML } = this.response;
            this.render(async ()=>{
                if (this.shouldCacheSnapshot) this.cacheSnapshot();
                if (this.view.renderPromise) await this.view.renderPromise;
                if ($16d9fec6fae182d5$var$isSuccessful(statusCode) && responseHTML != null) {
                    const snapshot = $16d9fec6fae182d5$export$4f11b95e473fd113.fromHTMLString(responseHTML);
                    await this.renderPageSnapshot(snapshot, false);
                    this.adapter.visitRendered(this);
                    this.complete();
                } else {
                    await this.view.renderError($16d9fec6fae182d5$export$4f11b95e473fd113.fromHTMLString(responseHTML), this);
                    this.adapter.visitRendered(this);
                    this.fail();
                }
            });
        }
    }
    getCachedSnapshot() {
        const snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
        if (snapshot && (!$16d9fec6fae182d5$var$getAnchor(this.location) || snapshot.hasAnchor($16d9fec6fae182d5$var$getAnchor(this.location)))) {
            if (this.action == "restore" || snapshot.isPreviewable) return snapshot;
        }
    }
    getPreloadedSnapshot() {
        if (this.snapshotHTML) return $16d9fec6fae182d5$export$4f11b95e473fd113.fromHTMLString(this.snapshotHTML);
    }
    hasCachedSnapshot() {
        return this.getCachedSnapshot() != null;
    }
    loadCachedSnapshot() {
        const snapshot = this.getCachedSnapshot();
        if (snapshot) {
            const isPreview = this.shouldIssueRequest();
            this.render(async ()=>{
                this.cacheSnapshot();
                if (this.isPageRefresh) this.adapter.visitRendered(this);
                else {
                    if (this.view.renderPromise) await this.view.renderPromise;
                    await this.renderPageSnapshot(snapshot, isPreview);
                    this.adapter.visitRendered(this);
                    if (!isPreview) this.complete();
                }
            });
        }
    }
    followRedirect() {
        if (this.redirectedToLocation && !this.followedRedirect && this.response?.redirected) {
            this.adapter.visitProposedToLocation(this.redirectedToLocation, {
                action: "replace",
                response: this.response,
                shouldCacheSnapshot: false,
                willRender: false
            });
            this.followedRedirect = true;
        }
    }
    // Fetch request delegate
    prepareRequest(request) {
        if (this.acceptsStreamResponse) request.acceptResponseType($16d9fec6fae182d5$var$StreamMessage.contentType);
    }
    requestStarted() {
        this.startRequest();
    }
    requestPreventedHandlingResponse(_request, _response) {}
    async requestSucceededWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $16d9fec6fae182d5$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else {
            this.redirectedToLocation = response.redirected ? response.location : undefined;
            this.recordResponse({
                statusCode: statusCode,
                responseHTML: responseHTML,
                redirected: redirected
            });
        }
    }
    async requestFailedWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $16d9fec6fae182d5$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else this.recordResponse({
            statusCode: statusCode,
            responseHTML: responseHTML,
            redirected: redirected
        });
    }
    requestErrored(_request, _error) {
        this.recordResponse({
            statusCode: $16d9fec6fae182d5$var$SystemStatusCode.networkFailure,
            redirected: false
        });
    }
    requestFinished() {
        this.finishRequest();
    }
    // Scrolling
    performScroll() {
        if (!this.scrolled && !this.view.forceReloaded && !this.view.shouldPreserveScrollPosition(this)) {
            if (this.action == "restore") this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
            else this.scrollToAnchor() || this.view.scrollToTop();
            this.scrolled = true;
        }
    }
    scrollToRestoredPosition() {
        const { scrollPosition: scrollPosition } = this.restorationData;
        if (scrollPosition) {
            this.view.scrollToPosition(scrollPosition);
            return true;
        }
    }
    scrollToAnchor() {
        const anchor = $16d9fec6fae182d5$var$getAnchor(this.location);
        if (anchor != null) {
            this.view.scrollToAnchor(anchor);
            return true;
        }
    }
    // Instrumentation
    recordTimingMetric(metric) {
        this.timingMetrics[metric] = new Date().getTime();
    }
    getTimingMetrics() {
        return {
            ...this.timingMetrics
        };
    }
    // Private
    hasPreloadedResponse() {
        return typeof this.response == "object";
    }
    shouldIssueRequest() {
        if (this.action == "restore") return !this.hasCachedSnapshot();
        else return this.willRender;
    }
    cacheSnapshot() {
        if (!this.snapshotCached) {
            this.view.cacheSnapshot(this.snapshot).then((snapshot)=>snapshot && this.visitCachedSnapshot(snapshot));
            this.snapshotCached = true;
        }
    }
    async render(callback) {
        this.cancelRender();
        await new Promise((resolve)=>{
            this.frame = document.visibilityState === "hidden" ? setTimeout(()=>resolve(), 0) : requestAnimationFrame(()=>resolve());
        });
        await callback();
        delete this.frame;
    }
    async renderPageSnapshot(snapshot, isPreview) {
        await this.viewTransitioner.renderChange(this.view.shouldTransitionTo(snapshot), async ()=>{
            await this.view.renderPage(snapshot, isPreview, this.willRender, this);
            this.performScroll();
        });
    }
    cancelRender() {
        if (this.frame) {
            cancelAnimationFrame(this.frame);
            delete this.frame;
        }
    }
}
function $16d9fec6fae182d5$var$isSuccessful(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
class $16d9fec6fae182d5$var$BrowserAdapter {
    progressBar = new $16d9fec6fae182d5$var$ProgressBar();
    constructor(session){
        this.session = session;
    }
    visitProposedToLocation(location1, options) {
        if ($16d9fec6fae182d5$var$locationIsVisitable(location1, this.navigator.rootLocation)) this.navigator.startVisit(location1, options?.restorationIdentifier || $16d9fec6fae182d5$var$uuid(), options);
        else window.location.href = location1.toString();
    }
    visitStarted(visit) {
        this.location = visit.location;
        this.redirectedToLocation = null;
        visit.loadCachedSnapshot();
        visit.issueRequest();
    }
    visitRequestStarted(visit) {
        this.progressBar.setValue(0);
        if (visit.hasCachedSnapshot() || visit.action != "restore") this.showVisitProgressBarAfterDelay();
        else this.showProgressBar();
    }
    visitRequestCompleted(visit) {
        visit.loadResponse();
        if (visit.response.redirected) this.redirectedToLocation = visit.redirectedToLocation;
    }
    visitRequestFailedWithStatusCode(visit, statusCode) {
        switch(statusCode){
            case $16d9fec6fae182d5$var$SystemStatusCode.networkFailure:
            case $16d9fec6fae182d5$var$SystemStatusCode.timeoutFailure:
            case $16d9fec6fae182d5$var$SystemStatusCode.contentTypeMismatch:
                return this.reload({
                    reason: "request_failed",
                    context: {
                        statusCode: statusCode
                    }
                });
            default:
                return visit.loadResponse();
        }
    }
    visitRequestFinished(_visit) {}
    visitCompleted(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    pageInvalidated(reason) {
        this.reload(reason);
    }
    visitFailed(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    visitRendered(_visit) {}
    // Link prefetching
    linkPrefetchingIsEnabledForLocation(location1) {
        return true;
    }
    // Form Submission Delegate
    formSubmissionStarted(_formSubmission) {
        this.progressBar.setValue(0);
        this.showFormProgressBarAfterDelay();
    }
    formSubmissionFinished(_formSubmission) {
        this.progressBar.setValue(1);
        this.hideFormProgressBar();
    }
    // Private
    showVisitProgressBarAfterDelay() {
        this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideVisitProgressBar() {
        this.progressBar.hide();
        if (this.visitProgressBarTimeout != null) {
            window.clearTimeout(this.visitProgressBarTimeout);
            delete this.visitProgressBarTimeout;
        }
    }
    showFormProgressBarAfterDelay() {
        if (this.formProgressBarTimeout == null) this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideFormProgressBar() {
        this.progressBar.hide();
        if (this.formProgressBarTimeout != null) {
            window.clearTimeout(this.formProgressBarTimeout);
            delete this.formProgressBarTimeout;
        }
    }
    showProgressBar = ()=>{
        this.progressBar.show();
    };
    reload(reason) {
        $16d9fec6fae182d5$var$dispatch("turbo:reload", {
            detail: reason
        });
        window.location.href = (this.redirectedToLocation || this.location)?.toString() || window.location.href;
    }
    get navigator() {
        return this.session.navigator;
    }
}
class $16d9fec6fae182d5$var$CacheObserver {
    selector = "[data-turbo-temporary]";
    started = false;
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    removeTemporaryElements = (_event)=>{
        for (const element of this.temporaryElements)element.remove();
    };
    get temporaryElements() {
        return [
            ...document.querySelectorAll(this.selector)
        ];
    }
}
class $16d9fec6fae182d5$var$FrameRedirector {
    constructor(session, element){
        this.session = session;
        this.element = element;
        this.linkInterceptor = new $16d9fec6fae182d5$var$LinkInterceptor(this, element);
        this.formSubmitObserver = new $16d9fec6fae182d5$var$FormSubmitObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
        this.formSubmitObserver.start();
    }
    stop() {
        this.linkInterceptor.stop();
        this.formSubmitObserver.stop();
    }
    // Link interceptor delegate
    shouldInterceptLinkClick(element, _location, _event) {
        return this.#shouldRedirect(element);
    }
    linkClickIntercepted(element, url, event) {
        const frame = this.#findFrameElement(element);
        if (frame) frame.delegate.linkClickIntercepted(element, url, event);
    }
    // Form submit observer delegate
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == null && this.#shouldSubmit(element, submitter) && this.#shouldRedirect(element, submitter);
    }
    formSubmitted(element, submitter) {
        const frame = this.#findFrameElement(element, submitter);
        if (frame) frame.delegate.formSubmitted(element, submitter);
    }
    #shouldSubmit(form, submitter) {
        const action = $16d9fec6fae182d5$var$getAction$1(form, submitter);
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const rootLocation = $16d9fec6fae182d5$var$expandURL(meta?.content ?? "/");
        return this.#shouldRedirect(form, submitter) && $16d9fec6fae182d5$var$locationIsVisitable(action, rootLocation);
    }
    #shouldRedirect(element, submitter) {
        const isNavigatable = element instanceof HTMLFormElement ? this.session.submissionIsNavigatable(element, submitter) : this.session.elementIsNavigatable(element);
        if (isNavigatable) {
            const frame = this.#findFrameElement(element, submitter);
            return frame ? frame != element.closest("turbo-frame") : false;
        } else return false;
    }
    #findFrameElement(element, submitter) {
        const id = submitter?.getAttribute("data-turbo-frame") || element.getAttribute("data-turbo-frame");
        if (id && id != "_top") {
            const frame = this.element.querySelector(`#${id}:not([disabled])`);
            if (frame instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44) return frame;
        }
    }
}
class $16d9fec6fae182d5$var$History {
    location;
    restorationIdentifier = $16d9fec6fae182d5$var$uuid();
    restorationData = {};
    started = false;
    currentIndex = 0;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("popstate", this.onPopState, false);
            this.currentIndex = history.state?.turbo?.restorationIndex || 0;
            this.started = true;
            this.replace(new URL(window.location.href));
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("popstate", this.onPopState, false);
            this.started = false;
        }
    }
    push(location1, restorationIdentifier) {
        this.update(history.pushState, location1, restorationIdentifier);
    }
    replace(location1, restorationIdentifier) {
        this.update(history.replaceState, location1, restorationIdentifier);
    }
    update(method, location1, restorationIdentifier = $16d9fec6fae182d5$var$uuid()) {
        if (method === history.pushState) ++this.currentIndex;
        const state = {
            turbo: {
                restorationIdentifier: restorationIdentifier,
                restorationIndex: this.currentIndex
            }
        };
        method.call(history, state, "", location1.href);
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier;
    }
    // Restoration data
    getRestorationDataForIdentifier(restorationIdentifier) {
        return this.restorationData[restorationIdentifier] || {};
    }
    updateRestorationData(additionalData) {
        const { restorationIdentifier: restorationIdentifier } = this;
        const restorationData = this.restorationData[restorationIdentifier];
        this.restorationData[restorationIdentifier] = {
            ...restorationData,
            ...additionalData
        };
    }
    // Scroll restoration
    assumeControlOfScrollRestoration() {
        if (!this.previousScrollRestoration) {
            this.previousScrollRestoration = history.scrollRestoration ?? "auto";
            history.scrollRestoration = "manual";
        }
    }
    relinquishControlOfScrollRestoration() {
        if (this.previousScrollRestoration) {
            history.scrollRestoration = this.previousScrollRestoration;
            delete this.previousScrollRestoration;
        }
    }
    // Event handlers
    onPopState = (event)=>{
        const { turbo: turbo } = event.state || {};
        this.location = new URL(window.location.href);
        if (turbo) {
            const { restorationIdentifier: restorationIdentifier, restorationIndex: restorationIndex } = turbo;
            this.restorationIdentifier = restorationIdentifier;
            const direction = restorationIndex > this.currentIndex ? "forward" : "back";
            this.delegate.historyPoppedToLocationWithRestorationIdentifierAndDirection(this.location, restorationIdentifier, direction);
            this.currentIndex = restorationIndex;
        } else {
            this.currentIndex++;
            this.delegate.historyPoppedWithEmptyState(this.location);
        }
    };
}
class $16d9fec6fae182d5$var$LinkPrefetchObserver {
    started = false;
    #prefetchedLink = null;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (this.started) return;
        if (this.eventTarget.readyState === "loading") this.eventTarget.addEventListener("DOMContentLoaded", this.#enable, {
            once: true
        });
        else this.#enable();
    }
    stop() {
        if (!this.started) return;
        this.eventTarget.removeEventListener("mouseenter", this.#tryToPrefetchRequest, {
            capture: true,
            passive: true
        });
        this.eventTarget.removeEventListener("mouseleave", this.#cancelRequestIfObsolete, {
            capture: true,
            passive: true
        });
        this.eventTarget.removeEventListener("turbo:before-fetch-request", this.#tryToUsePrefetchedRequest, true);
        this.started = false;
    }
    #enable = ()=>{
        this.eventTarget.addEventListener("mouseenter", this.#tryToPrefetchRequest, {
            capture: true,
            passive: true
        });
        this.eventTarget.addEventListener("mouseleave", this.#cancelRequestIfObsolete, {
            capture: true,
            passive: true
        });
        this.eventTarget.addEventListener("turbo:before-fetch-request", this.#tryToUsePrefetchedRequest, true);
        this.started = true;
    };
    #tryToPrefetchRequest = (event)=>{
        if ($16d9fec6fae182d5$var$getMetaContent("turbo-prefetch") === "false") return;
        const target = event.target;
        const isLink = target.matches && target.matches("a[href]:not([target^=_]):not([download])");
        if (isLink && this.#isPrefetchable(target)) {
            const link = target;
            const location1 = $16d9fec6fae182d5$var$getLocationForLink(link);
            if (this.delegate.canPrefetchRequestToLocation(link, location1)) {
                this.#prefetchedLink = link;
                const fetchRequest = new $16d9fec6fae182d5$export$319b96fe59834522(this, $16d9fec6fae182d5$export$76f6869e29ff06ee.get, location1, new URLSearchParams(), target);
                fetchRequest.fetchOptions.priority = "low";
                $16d9fec6fae182d5$var$prefetchCache.putLater(location1, fetchRequest, this.#cacheTtl);
            }
        }
    };
    #cancelRequestIfObsolete = (event)=>{
        if (event.target === this.#prefetchedLink) this.#cancelPrefetchRequest();
    };
    #cancelPrefetchRequest = ()=>{
        $16d9fec6fae182d5$var$prefetchCache.clear();
        this.#prefetchedLink = null;
    };
    #tryToUsePrefetchedRequest = (event)=>{
        if (event.target.tagName !== "FORM" && event.detail.fetchOptions.method === "GET") {
            const cached = $16d9fec6fae182d5$var$prefetchCache.get(event.detail.url);
            if (cached) // User clicked link, use cache response
            event.detail.fetchRequest = cached;
            $16d9fec6fae182d5$var$prefetchCache.clear();
        }
    };
    prepareRequest(request) {
        const link = request.target;
        request.headers["X-Sec-Purpose"] = "prefetch";
        const turboFrame = link.closest("turbo-frame");
        const turboFrameTarget = link.getAttribute("data-turbo-frame") || turboFrame?.getAttribute("target") || turboFrame?.id;
        if (turboFrameTarget && turboFrameTarget !== "_top") request.headers["Turbo-Frame"] = turboFrameTarget;
    }
    // Fetch request interface
    requestSucceededWithResponse() {}
    requestStarted(fetchRequest) {}
    requestErrored(fetchRequest) {}
    requestFinished(fetchRequest) {}
    requestPreventedHandlingResponse(fetchRequest, fetchResponse) {}
    requestFailedWithResponse(fetchRequest, fetchResponse) {}
    get #cacheTtl() {
        return Number($16d9fec6fae182d5$var$getMetaContent("turbo-prefetch-cache-time")) || $16d9fec6fae182d5$var$cacheTtl;
    }
    #isPrefetchable(link) {
        const href = link.getAttribute("href");
        if (!href) return false;
        if ($16d9fec6fae182d5$var$unfetchableLink(link)) return false;
        if ($16d9fec6fae182d5$var$linkToTheSamePage(link)) return false;
        if ($16d9fec6fae182d5$var$linkOptsOut(link)) return false;
        if ($16d9fec6fae182d5$var$nonSafeLink(link)) return false;
        if ($16d9fec6fae182d5$var$eventPrevented(link)) return false;
        return true;
    }
}
const $16d9fec6fae182d5$var$unfetchableLink = (link)=>{
    return link.origin !== document.location.origin || ![
        "http:",
        "https:"
    ].includes(link.protocol) || link.hasAttribute("target");
};
const $16d9fec6fae182d5$var$linkToTheSamePage = (link)=>{
    return link.pathname + link.search === document.location.pathname + document.location.search || link.href.startsWith("#");
};
const $16d9fec6fae182d5$var$linkOptsOut = (link)=>{
    if (link.getAttribute("data-turbo-prefetch") === "false") return true;
    if (link.getAttribute("data-turbo") === "false") return true;
    const turboPrefetchParent = $16d9fec6fae182d5$var$findClosestRecursively(link, "[data-turbo-prefetch]");
    if (turboPrefetchParent && turboPrefetchParent.getAttribute("data-turbo-prefetch") === "false") return true;
    return false;
};
const $16d9fec6fae182d5$var$nonSafeLink = (link)=>{
    const turboMethod = link.getAttribute("data-turbo-method");
    if (turboMethod && turboMethod.toLowerCase() !== "get") return true;
    if ($16d9fec6fae182d5$var$isUJS(link)) return true;
    if (link.hasAttribute("data-turbo-confirm")) return true;
    if (link.hasAttribute("data-turbo-stream")) return true;
    return false;
};
const $16d9fec6fae182d5$var$isUJS = (link)=>{
    return link.hasAttribute("data-remote") || link.hasAttribute("data-behavior") || link.hasAttribute("data-confirm") || link.hasAttribute("data-method");
};
const $16d9fec6fae182d5$var$eventPrevented = (link)=>{
    const event = $16d9fec6fae182d5$var$dispatch("turbo:before-prefetch", {
        target: link,
        cancelable: true
    });
    return event.defaultPrevented;
};
class $16d9fec6fae182d5$var$Navigator {
    constructor(delegate){
        this.delegate = delegate;
    }
    proposeVisit(location1, options = {}) {
        if (this.delegate.allowsVisitingLocationWithAction(location1, options.action)) this.delegate.visitProposedToLocation(location1, options);
    }
    startVisit(locatable, restorationIdentifier, options = {}) {
        this.stop();
        this.currentVisit = new $16d9fec6fae182d5$var$Visit(this, $16d9fec6fae182d5$var$expandURL(locatable), restorationIdentifier, {
            referrer: this.location,
            ...options
        });
        this.currentVisit.start();
    }
    submitForm(form, submitter) {
        this.stop();
        this.formSubmission = new $16d9fec6fae182d5$var$FormSubmission(this, form, submitter, true);
        this.formSubmission.start();
    }
    stop() {
        if (this.formSubmission) {
            this.formSubmission.stop();
            delete this.formSubmission;
        }
        if (this.currentVisit) {
            this.currentVisit.cancel();
            delete this.currentVisit;
        }
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get rootLocation() {
        return this.view.snapshot.rootLocation;
    }
    get history() {
        return this.delegate.history;
    }
    // Form submission delegate
    formSubmissionStarted(formSubmission) {
        // Not all adapters implement formSubmissionStarted
        if (typeof this.adapter.formSubmissionStarted === "function") this.adapter.formSubmissionStarted(formSubmission);
    }
    async formSubmissionSucceededWithResponse(formSubmission, fetchResponse) {
        if (formSubmission == this.formSubmission) {
            const responseHTML = await fetchResponse.responseHTML;
            if (responseHTML) {
                const shouldCacheSnapshot = formSubmission.isSafe;
                if (!shouldCacheSnapshot) this.view.clearSnapshotCache();
                const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                const action = this.#getActionForFormSubmission(formSubmission, fetchResponse);
                const visitOptions = {
                    action: action,
                    shouldCacheSnapshot: shouldCacheSnapshot,
                    response: {
                        statusCode: statusCode,
                        responseHTML: responseHTML,
                        redirected: redirected
                    }
                };
                this.proposeVisit(fetchResponse.location, visitOptions);
            }
        }
    }
    async formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        const responseHTML = await fetchResponse.responseHTML;
        if (responseHTML) {
            const snapshot = $16d9fec6fae182d5$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            if (fetchResponse.serverError) await this.view.renderError(snapshot, this.currentVisit);
            else await this.view.renderPage(snapshot, false, true, this.currentVisit);
            if (snapshot.refreshScroll !== "preserve") this.view.scrollToTop();
            this.view.clearSnapshotCache();
        }
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished(formSubmission) {
        // Not all adapters implement formSubmissionFinished
        if (typeof this.adapter.formSubmissionFinished === "function") this.adapter.formSubmissionFinished(formSubmission);
    }
    // Link prefetching
    linkPrefetchingIsEnabledForLocation(location1) {
        // Not all adapters implement linkPrefetchingIsEnabledForLocation
        if (typeof this.adapter.linkPrefetchingIsEnabledForLocation === "function") return this.adapter.linkPrefetchingIsEnabledForLocation(location1);
        return true;
    }
    // Visit delegate
    visitStarted(visit) {
        this.delegate.visitStarted(visit);
    }
    visitCompleted(visit) {
        this.delegate.visitCompleted(visit);
        delete this.currentVisit;
    }
    // Same-page links are no longer handled with a Visit.
    // This method is still needed for Turbo Native adapters.
    locationWithActionIsSamePage(location1, action) {
        return false;
    }
    // Visits
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    #getActionForFormSubmission(formSubmission, fetchResponse) {
        const { submitter: submitter, formElement: formElement } = formSubmission;
        return $16d9fec6fae182d5$var$getVisitAction(submitter, formElement) || this.#getDefaultAction(fetchResponse);
    }
    #getDefaultAction(fetchResponse) {
        const sameLocationRedirect = fetchResponse.redirected && fetchResponse.location.href === this.location?.href;
        return sameLocationRedirect ? "replace" : "advance";
    }
}
const $16d9fec6fae182d5$var$PageStage = {
    initial: 0,
    loading: 1,
    interactive: 2,
    complete: 3
};
class $16d9fec6fae182d5$var$PageObserver {
    stage = $16d9fec6fae182d5$var$PageStage.initial;
    started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            if (this.stage == $16d9fec6fae182d5$var$PageStage.initial) this.stage = $16d9fec6fae182d5$var$PageStage.loading;
            document.addEventListener("readystatechange", this.interpretReadyState, false);
            addEventListener("pagehide", this.pageWillUnload, false);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            document.removeEventListener("readystatechange", this.interpretReadyState, false);
            removeEventListener("pagehide", this.pageWillUnload, false);
            this.started = false;
        }
    }
    interpretReadyState = ()=>{
        const { readyState: readyState } = this;
        if (readyState == "interactive") this.pageIsInteractive();
        else if (readyState == "complete") this.pageIsComplete();
    };
    pageIsInteractive() {
        if (this.stage == $16d9fec6fae182d5$var$PageStage.loading) {
            this.stage = $16d9fec6fae182d5$var$PageStage.interactive;
            this.delegate.pageBecameInteractive();
        }
    }
    pageIsComplete() {
        this.pageIsInteractive();
        if (this.stage == $16d9fec6fae182d5$var$PageStage.interactive) {
            this.stage = $16d9fec6fae182d5$var$PageStage.complete;
            this.delegate.pageLoaded();
        }
    }
    pageWillUnload = ()=>{
        this.delegate.pageWillUnload();
    };
    get readyState() {
        return document.readyState;
    }
}
class $16d9fec6fae182d5$var$ScrollObserver {
    started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("scroll", this.onScroll, false);
            this.onScroll();
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("scroll", this.onScroll, false);
            this.started = false;
        }
    }
    onScroll = ()=>{
        this.updatePosition({
            x: window.pageXOffset,
            y: window.pageYOffset
        });
    };
    // Private
    updatePosition(position) {
        this.delegate.scrollPositionChanged(position);
    }
}
class $16d9fec6fae182d5$var$StreamMessageRenderer {
    render({ fragment: fragment }) {
        $16d9fec6fae182d5$var$Bardo.preservingPermanentElements(this, $16d9fec6fae182d5$var$getPermanentElementMapForFragment(fragment), ()=>{
            $16d9fec6fae182d5$var$withAutofocusFromFragment(fragment, ()=>{
                $16d9fec6fae182d5$var$withPreservedFocus(()=>{
                    document.documentElement.appendChild(fragment);
                });
            });
        });
    }
    // Bardo delegate
    enteringBardo(currentPermanentElement, newPermanentElement) {
        newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
    }
    leavingBardo() {}
}
function $16d9fec6fae182d5$var$getPermanentElementMapForFragment(fragment) {
    const permanentElementsInDocument = $16d9fec6fae182d5$var$queryPermanentElementsAll(document.documentElement);
    const permanentElementMap = {};
    for (const permanentElementInDocument of permanentElementsInDocument){
        const { id: id } = permanentElementInDocument;
        for (const streamElement of fragment.querySelectorAll("turbo-stream")){
            const elementInStream = $16d9fec6fae182d5$var$getPermanentElementById(streamElement.templateElement.content, id);
            if (elementInStream) permanentElementMap[id] = [
                permanentElementInDocument,
                elementInStream
            ];
        }
    }
    return permanentElementMap;
}
async function $16d9fec6fae182d5$var$withAutofocusFromFragment(fragment, callback) {
    const generatedID = `turbo-stream-autofocus-${$16d9fec6fae182d5$var$uuid()}`;
    const turboStreams = fragment.querySelectorAll("turbo-stream");
    const elementWithAutofocus = $16d9fec6fae182d5$var$firstAutofocusableElementInStreams(turboStreams);
    let willAutofocusId = null;
    if (elementWithAutofocus) {
        if (elementWithAutofocus.id) willAutofocusId = elementWithAutofocus.id;
        else willAutofocusId = generatedID;
        elementWithAutofocus.id = willAutofocusId;
    }
    callback();
    await $16d9fec6fae182d5$var$nextRepaint();
    const hasNoActiveElement = document.activeElement == null || document.activeElement == document.body;
    if (hasNoActiveElement && willAutofocusId) {
        const elementToAutofocus = document.getElementById(willAutofocusId);
        if ($16d9fec6fae182d5$var$elementIsFocusable(elementToAutofocus)) elementToAutofocus.focus();
        if (elementToAutofocus && elementToAutofocus.id == generatedID) elementToAutofocus.removeAttribute("id");
    }
}
async function $16d9fec6fae182d5$var$withPreservedFocus(callback) {
    const [activeElementBeforeRender, activeElementAfterRender] = await $16d9fec6fae182d5$var$around(callback, ()=>document.activeElement);
    const restoreFocusTo = activeElementBeforeRender && activeElementBeforeRender.id;
    if (restoreFocusTo) {
        const elementToFocus = document.getElementById(restoreFocusTo);
        if ($16d9fec6fae182d5$var$elementIsFocusable(elementToFocus) && elementToFocus != activeElementAfterRender) elementToFocus.focus();
    }
}
function $16d9fec6fae182d5$var$firstAutofocusableElementInStreams(nodeListOfStreamElements) {
    for (const streamElement of nodeListOfStreamElements){
        const elementWithAutofocus = $16d9fec6fae182d5$var$queryAutofocusableElement(streamElement.templateElement.content);
        if (elementWithAutofocus) return elementWithAutofocus;
    }
    return null;
}
class $16d9fec6fae182d5$var$StreamObserver {
    sources = new Set();
    #started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.#started) {
            this.#started = true;
            addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    stop() {
        if (this.#started) {
            this.#started = false;
            removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    connectStreamSource(source) {
        if (!this.streamSourceIsConnected(source)) {
            this.sources.add(source);
            source.addEventListener("message", this.receiveMessageEvent, false);
        }
    }
    disconnectStreamSource(source) {
        if (this.streamSourceIsConnected(source)) {
            this.sources.delete(source);
            source.removeEventListener("message", this.receiveMessageEvent, false);
        }
    }
    streamSourceIsConnected(source) {
        return this.sources.has(source);
    }
    inspectFetchResponse = (event)=>{
        const response = $16d9fec6fae182d5$var$fetchResponseFromEvent(event);
        if (response && $16d9fec6fae182d5$var$fetchResponseIsStream(response)) {
            event.preventDefault();
            this.receiveMessageResponse(response);
        }
    };
    receiveMessageEvent = (event)=>{
        if (this.#started && typeof event.data == "string") this.receiveMessageHTML(event.data);
    };
    async receiveMessageResponse(response) {
        const html = await response.responseHTML;
        if (html) this.receiveMessageHTML(html);
    }
    receiveMessageHTML(html) {
        this.delegate.receivedMessageFromStream($16d9fec6fae182d5$var$StreamMessage.wrap(html));
    }
}
function $16d9fec6fae182d5$var$fetchResponseFromEvent(event) {
    const fetchResponse = event.detail?.fetchResponse;
    if (fetchResponse instanceof $16d9fec6fae182d5$export$3ae09bba5b6b906e) return fetchResponse;
}
function $16d9fec6fae182d5$var$fetchResponseIsStream(response) {
    const contentType = response.contentType ?? "";
    return contentType.startsWith($16d9fec6fae182d5$var$StreamMessage.contentType);
}
class $16d9fec6fae182d5$var$ErrorRenderer extends $16d9fec6fae182d5$var$Renderer {
    static renderElement(currentElement, newElement) {
        const { documentElement: documentElement, body: body } = document;
        documentElement.replaceChild(newElement, body);
    }
    async render() {
        this.replaceHeadAndBody();
        this.activateScriptElements();
    }
    replaceHeadAndBody() {
        const { documentElement: documentElement, head: head } = document;
        documentElement.replaceChild(this.newHead, head);
        this.renderElement(this.currentElement, this.newElement);
    }
    activateScriptElements() {
        for (const replaceableElement of this.scriptElements){
            const parentNode = replaceableElement.parentNode;
            if (parentNode) {
                const element = $16d9fec6fae182d5$var$activateScriptElement(replaceableElement);
                parentNode.replaceChild(element, replaceableElement);
            }
        }
    }
    get newHead() {
        return this.newSnapshot.headSnapshot.element;
    }
    get scriptElements() {
        return document.documentElement.querySelectorAll("script");
    }
}
class $16d9fec6fae182d5$export$ac9642242cf7b3ce extends $16d9fec6fae182d5$var$Renderer {
    static renderElement(currentElement, newElement) {
        if (document.body && newElement instanceof HTMLBodyElement) document.body.replaceWith(newElement);
        else document.documentElement.appendChild(newElement);
    }
    get shouldRender() {
        return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
    }
    get reloadReason() {
        if (!this.newSnapshot.isVisitable) return {
            reason: "turbo_visit_control_is_reload"
        };
        if (!this.trackedElementsAreIdentical) return {
            reason: "tracked_element_mismatch"
        };
    }
    async prepareToRender() {
        this.#setLanguage();
        await this.mergeHead();
    }
    async render() {
        if (this.willRender) await this.replaceBody();
    }
    finishRendering() {
        super.finishRendering();
        if (!this.isPreview) this.focusFirstAutofocusableElement();
    }
    get currentHeadSnapshot() {
        return this.currentSnapshot.headSnapshot;
    }
    get newHeadSnapshot() {
        return this.newSnapshot.headSnapshot;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    #setLanguage() {
        const { documentElement: documentElement } = this.currentSnapshot;
        const { dir: dir, lang: lang } = this.newSnapshot;
        if (lang) documentElement.setAttribute("lang", lang);
        else documentElement.removeAttribute("lang");
        if (dir) documentElement.setAttribute("dir", dir);
        else documentElement.removeAttribute("dir");
    }
    async mergeHead() {
        const mergedHeadElements = this.mergeProvisionalElements();
        const newStylesheetElements = this.copyNewHeadStylesheetElements();
        this.copyNewHeadScriptElements();
        await mergedHeadElements;
        await newStylesheetElements;
        if (this.willRender) this.removeUnusedDynamicStylesheetElements();
    }
    async replaceBody() {
        await this.preservingPermanentElements(async ()=>{
            this.activateNewBody();
            await this.assignNewBody();
        });
    }
    get trackedElementsAreIdentical() {
        return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
    }
    async copyNewHeadStylesheetElements() {
        const loadingElements = [];
        for (const element of this.newHeadStylesheetElements){
            loadingElements.push($16d9fec6fae182d5$var$waitForLoad(element));
            document.head.appendChild(element);
        }
        await Promise.all(loadingElements);
    }
    copyNewHeadScriptElements() {
        for (const element of this.newHeadScriptElements)document.head.appendChild($16d9fec6fae182d5$var$activateScriptElement(element));
    }
    removeUnusedDynamicStylesheetElements() {
        for (const element of this.unusedDynamicStylesheetElements)document.head.removeChild(element);
    }
    async mergeProvisionalElements() {
        const newHeadElements = [
            ...this.newHeadProvisionalElements
        ];
        for (const element of this.currentHeadProvisionalElements)if (!this.isCurrentElementInElementList(element, newHeadElements)) document.head.removeChild(element);
        for (const element of newHeadElements)document.head.appendChild(element);
    }
    isCurrentElementInElementList(element, elementList) {
        for (const [index, newElement] of elementList.entries()){
            // if title element...
            if (element.tagName == "TITLE") {
                if (newElement.tagName != "TITLE") continue;
                if (element.innerHTML == newElement.innerHTML) {
                    elementList.splice(index, 1);
                    return true;
                }
            }
            // if any other element...
            if (newElement.isEqualNode(element)) {
                elementList.splice(index, 1);
                return true;
            }
        }
        return false;
    }
    removeCurrentHeadProvisionalElements() {
        for (const element of this.currentHeadProvisionalElements)document.head.removeChild(element);
    }
    copyNewHeadProvisionalElements() {
        for (const element of this.newHeadProvisionalElements)document.head.appendChild(element);
    }
    activateNewBody() {
        document.adoptNode(this.newElement);
        this.removeNoscriptElements();
        this.activateNewBodyScriptElements();
    }
    removeNoscriptElements() {
        for (const noscriptElement of this.newElement.querySelectorAll("noscript"))noscriptElement.remove();
    }
    activateNewBodyScriptElements() {
        for (const inertScriptElement of this.newBodyScriptElements){
            const activatedScriptElement = $16d9fec6fae182d5$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    async assignNewBody() {
        await this.renderElement(this.currentElement, this.newElement);
    }
    get unusedDynamicStylesheetElements() {
        return this.oldHeadStylesheetElements.filter((element)=>{
            return element.getAttribute("data-turbo-track") === "dynamic";
        });
    }
    get oldHeadStylesheetElements() {
        return this.currentHeadSnapshot.getStylesheetElementsNotInSnapshot(this.newHeadSnapshot);
    }
    get newHeadStylesheetElements() {
        return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get newHeadScriptElements() {
        return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get currentHeadProvisionalElements() {
        return this.currentHeadSnapshot.provisionalElements;
    }
    get newHeadProvisionalElements() {
        return this.newHeadSnapshot.provisionalElements;
    }
    get newBodyScriptElements() {
        return this.newElement.querySelectorAll("script");
    }
}
class $16d9fec6fae182d5$var$MorphingPageRenderer extends $16d9fec6fae182d5$export$ac9642242cf7b3ce {
    static renderElement(currentElement, newElement) {
        $16d9fec6fae182d5$export$dc74801294c91b10(currentElement, newElement, {
            callbacks: {
                beforeNodeMorphed: (node, newNode)=>{
                    if ($16d9fec6fae182d5$var$shouldRefreshFrameWithMorphing(node, newNode) && !$16d9fec6fae182d5$var$closestFrameReloadableWithMorphing(node)) {
                        node.reload();
                        return false;
                    }
                    return true;
                }
            }
        });
        $16d9fec6fae182d5$var$dispatch("turbo:morph", {
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
    }
    async preservingPermanentElements(callback) {
        return await callback();
    }
    get renderMethod() {
        return "morph";
    }
    get shouldAutofocus() {
        return false;
    }
}
class $16d9fec6fae182d5$var$SnapshotCache extends $16d9fec6fae182d5$var$LRUCache {
    constructor(size){
        super(size, $16d9fec6fae182d5$var$toCacheKey);
    }
    get snapshots() {
        return this.entries;
    }
}
class $16d9fec6fae182d5$var$PageView extends $16d9fec6fae182d5$var$View {
    snapshotCache = new $16d9fec6fae182d5$var$SnapshotCache(10);
    lastRenderedLocation = new URL(location.href);
    forceReloaded = false;
    shouldTransitionTo(newSnapshot) {
        return this.snapshot.prefersViewTransitions && newSnapshot.prefersViewTransitions;
    }
    renderPage(snapshot, isPreview = false, willRender = true, visit) {
        const shouldMorphPage = this.isPageRefresh(visit) && (visit?.refresh?.method || this.snapshot.refreshMethod) === "morph";
        const rendererClass = shouldMorphPage ? $16d9fec6fae182d5$var$MorphingPageRenderer : $16d9fec6fae182d5$export$ac9642242cf7b3ce;
        const renderer = new rendererClass(this.snapshot, snapshot, isPreview, willRender);
        if (!renderer.shouldRender) this.forceReloaded = true;
        else visit?.changeHistory();
        return this.render(renderer);
    }
    renderError(snapshot, visit) {
        visit?.changeHistory();
        const renderer = new $16d9fec6fae182d5$var$ErrorRenderer(this.snapshot, snapshot, false);
        return this.render(renderer);
    }
    clearSnapshotCache() {
        this.snapshotCache.clear();
    }
    async cacheSnapshot(snapshot = this.snapshot) {
        if (snapshot.isCacheable) {
            this.delegate.viewWillCacheSnapshot();
            const { lastRenderedLocation: location1 } = this;
            await $16d9fec6fae182d5$var$nextEventLoopTick();
            const cachedSnapshot = snapshot.clone();
            this.snapshotCache.put(location1, cachedSnapshot);
            return cachedSnapshot;
        }
    }
    getCachedSnapshotForLocation(location1) {
        return this.snapshotCache.get(location1);
    }
    isPageRefresh(visit) {
        return !visit || this.lastRenderedLocation.pathname === visit.location.pathname && visit.action === "replace";
    }
    shouldPreserveScrollPosition(visit) {
        return this.isPageRefresh(visit) && (visit?.refresh?.scroll || this.snapshot.refreshScroll) === "preserve";
    }
    get snapshot() {
        return $16d9fec6fae182d5$export$4f11b95e473fd113.fromElement(this.element);
    }
}
class $16d9fec6fae182d5$var$Preloader {
    selector = "a[data-turbo-preload]";
    constructor(delegate, snapshotCache){
        this.delegate = delegate;
        this.snapshotCache = snapshotCache;
    }
    start() {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", this.#preloadAll);
        else this.preloadOnLoadLinksForView(document.body);
    }
    stop() {
        document.removeEventListener("DOMContentLoaded", this.#preloadAll);
    }
    preloadOnLoadLinksForView(element) {
        for (const link of element.querySelectorAll(this.selector))if (this.delegate.shouldPreloadLink(link)) this.preloadURL(link);
    }
    async preloadURL(link) {
        const location1 = new URL(link.href);
        if (this.snapshotCache.has(location1)) return;
        const fetchRequest = new $16d9fec6fae182d5$export$319b96fe59834522(this, $16d9fec6fae182d5$export$76f6869e29ff06ee.get, location1, new URLSearchParams(), link);
        await fetchRequest.perform();
    }
    // Fetch request delegate
    prepareRequest(fetchRequest) {
        fetchRequest.headers["X-Sec-Purpose"] = "prefetch";
    }
    async requestSucceededWithResponse(fetchRequest, fetchResponse) {
        try {
            const responseHTML = await fetchResponse.responseHTML;
            const snapshot = $16d9fec6fae182d5$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            this.snapshotCache.put(fetchRequest.url, snapshot);
        } catch (_) {
        // If we cannot preload that is ok!
        }
    }
    requestStarted(fetchRequest) {}
    requestErrored(fetchRequest) {}
    requestFinished(fetchRequest) {}
    requestPreventedHandlingResponse(fetchRequest, fetchResponse) {}
    requestFailedWithResponse(fetchRequest, fetchResponse) {}
    #preloadAll = ()=>{
        this.preloadOnLoadLinksForView(document.body);
    };
}
class $16d9fec6fae182d5$var$Cache {
    constructor(session){
        this.session = session;
    }
    clear() {
        this.session.clearCache();
    }
    resetCacheControl() {
        this.#setCacheControl("");
    }
    exemptPageFromCache() {
        this.#setCacheControl("no-cache");
    }
    exemptPageFromPreview() {
        this.#setCacheControl("no-preview");
    }
    #setCacheControl(value) {
        $16d9fec6fae182d5$var$setMetaContent("turbo-cache-control", value);
    }
}
class $16d9fec6fae182d5$var$Session {
    navigator = new $16d9fec6fae182d5$var$Navigator(this);
    history = new $16d9fec6fae182d5$var$History(this);
    view = new $16d9fec6fae182d5$var$PageView(this, document.documentElement);
    adapter = new $16d9fec6fae182d5$var$BrowserAdapter(this);
    pageObserver = new $16d9fec6fae182d5$var$PageObserver(this);
    cacheObserver = new $16d9fec6fae182d5$var$CacheObserver();
    linkPrefetchObserver = new $16d9fec6fae182d5$var$LinkPrefetchObserver(this, document);
    linkClickObserver = new $16d9fec6fae182d5$var$LinkClickObserver(this, window);
    formSubmitObserver = new $16d9fec6fae182d5$var$FormSubmitObserver(this, document);
    scrollObserver = new $16d9fec6fae182d5$var$ScrollObserver(this);
    streamObserver = new $16d9fec6fae182d5$var$StreamObserver(this);
    formLinkClickObserver = new $16d9fec6fae182d5$var$FormLinkClickObserver(this, document.documentElement);
    frameRedirector = new $16d9fec6fae182d5$var$FrameRedirector(this, document.documentElement);
    streamMessageRenderer = new $16d9fec6fae182d5$var$StreamMessageRenderer();
    cache = new $16d9fec6fae182d5$var$Cache(this);
    enabled = true;
    started = false;
    #pageRefreshDebouncePeriod = 150;
    constructor(recentRequests){
        this.recentRequests = recentRequests;
        this.preloader = new $16d9fec6fae182d5$var$Preloader(this, this.view.snapshotCache);
        this.debouncedRefresh = this.refresh;
        this.pageRefreshDebouncePeriod = this.pageRefreshDebouncePeriod;
    }
    start() {
        if (!this.started) {
            this.pageObserver.start();
            this.cacheObserver.start();
            this.linkPrefetchObserver.start();
            this.formLinkClickObserver.start();
            this.linkClickObserver.start();
            this.formSubmitObserver.start();
            this.scrollObserver.start();
            this.streamObserver.start();
            this.frameRedirector.start();
            this.history.start();
            this.preloader.start();
            this.started = true;
            this.enabled = true;
        }
    }
    disable() {
        this.enabled = false;
    }
    stop() {
        if (this.started) {
            this.pageObserver.stop();
            this.cacheObserver.stop();
            this.linkPrefetchObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkClickObserver.stop();
            this.formSubmitObserver.stop();
            this.scrollObserver.stop();
            this.streamObserver.stop();
            this.frameRedirector.stop();
            this.history.stop();
            this.preloader.stop();
            this.started = false;
        }
    }
    registerAdapter(adapter) {
        this.adapter = adapter;
    }
    visit(location1, options = {}) {
        const frameElement = options.frame ? document.getElementById(options.frame) : null;
        if (frameElement instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44) {
            const action = options.action || $16d9fec6fae182d5$var$getVisitAction(frameElement);
            frameElement.delegate.proposeVisitIfNavigatedWithAction(frameElement, action);
            frameElement.src = location1.toString();
        } else this.navigator.proposeVisit($16d9fec6fae182d5$var$expandURL(location1), options);
    }
    refresh(url, options = {}) {
        options = typeof options === "string" ? {
            requestId: options
        } : options;
        const { method: method, requestId: requestId, scroll: scroll } = options;
        const isRecentRequest = requestId && this.recentRequests.has(requestId);
        const isCurrentUrl = url === document.baseURI;
        if (!isRecentRequest && !this.navigator.currentVisit && isCurrentUrl) this.visit(url, {
            action: "replace",
            shouldCacheSnapshot: false,
            refresh: {
                method: method,
                scroll: scroll
            }
        });
    }
    connectStreamSource(source) {
        this.streamObserver.connectStreamSource(source);
    }
    disconnectStreamSource(source) {
        this.streamObserver.disconnectStreamSource(source);
    }
    renderStreamMessage(message) {
        this.streamMessageRenderer.render($16d9fec6fae182d5$var$StreamMessage.wrap(message));
    }
    clearCache() {
        this.view.clearSnapshotCache();
    }
    setProgressBarDelay(delay) {
        console.warn("Please replace `session.setProgressBarDelay(delay)` with `session.progressBarDelay = delay`. The function is deprecated and will be removed in a future version of Turbo.`");
        this.progressBarDelay = delay;
    }
    set progressBarDelay(delay) {
        $16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.progressBarDelay = delay;
    }
    get progressBarDelay() {
        return $16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.progressBarDelay;
    }
    set drive(value) {
        $16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.enabled = value;
    }
    get drive() {
        return $16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.enabled;
    }
    set formMode(value) {
        $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.mode = value;
    }
    get formMode() {
        return $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.mode;
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    get pageRefreshDebouncePeriod() {
        return this.#pageRefreshDebouncePeriod;
    }
    set pageRefreshDebouncePeriod(value) {
        this.refresh = $16d9fec6fae182d5$var$debounce(this.debouncedRefresh.bind(this), value);
        this.#pageRefreshDebouncePeriod = value;
    }
    // Preloader delegate
    shouldPreloadLink(element) {
        const isUnsafe = element.hasAttribute("data-turbo-method");
        const isStream = element.hasAttribute("data-turbo-stream");
        const frameTarget = element.getAttribute("data-turbo-frame");
        const frame = frameTarget == "_top" ? null : document.getElementById(frameTarget) || $16d9fec6fae182d5$var$findClosestRecursively(element, "turbo-frame:not([disabled])");
        if (isUnsafe || isStream || frame instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44) return false;
        else {
            const location1 = new URL(element.href);
            return this.elementIsNavigatable(element) && $16d9fec6fae182d5$var$locationIsVisitable(location1, this.snapshot.rootLocation);
        }
    }
    // History delegate
    historyPoppedToLocationWithRestorationIdentifierAndDirection(location1, restorationIdentifier, direction) {
        if (this.enabled) this.navigator.startVisit(location1, restorationIdentifier, {
            action: "restore",
            historyChanged: true,
            direction: direction
        });
        else this.adapter.pageInvalidated({
            reason: "turbo_disabled"
        });
    }
    historyPoppedWithEmptyState(location1) {
        this.history.replace(location1);
        this.view.lastRenderedLocation = location1;
        this.view.cacheSnapshot();
    }
    // Scroll observer delegate
    scrollPositionChanged(position) {
        this.history.updateRestorationData({
            scrollPosition: position
        });
    }
    // Form click observer delegate
    willSubmitFormLinkToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $16d9fec6fae182d5$var$locationIsVisitable(location1, this.snapshot.rootLocation);
    }
    submittedFormLinkToLocation() {}
    // Link hover observer delegate
    canPrefetchRequestToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $16d9fec6fae182d5$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.navigator.linkPrefetchingIsEnabledForLocation(location1);
    }
    // Link click observer delegate
    willFollowLinkToLocation(link, location1, event) {
        return this.elementIsNavigatable(link) && $16d9fec6fae182d5$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.applicationAllowsFollowingLinkToLocation(link, location1, event);
    }
    followedLinkToLocation(link, location1) {
        const action = this.getActionForLink(link);
        const acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
        this.visit(location1.href, {
            action: action,
            acceptsStreamResponse: acceptsStreamResponse
        });
    }
    // Navigator delegate
    allowsVisitingLocationWithAction(location1, action) {
        return this.applicationAllowsVisitingLocation(location1);
    }
    visitProposedToLocation(location1, options) {
        $16d9fec6fae182d5$var$extendURLWithDeprecatedProperties(location1);
        this.adapter.visitProposedToLocation(location1, options);
    }
    // Visit delegate
    visitStarted(visit) {
        if (!visit.acceptsStreamResponse) {
            $16d9fec6fae182d5$var$markAsBusy(document.documentElement);
            this.view.markVisitDirection(visit.direction);
        }
        $16d9fec6fae182d5$var$extendURLWithDeprecatedProperties(visit.location);
        this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
    }
    visitCompleted(visit) {
        this.view.unmarkVisitDirection();
        $16d9fec6fae182d5$var$clearBusyState(document.documentElement);
        this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
    }
    // Form submit observer delegate
    willSubmitForm(form, submitter) {
        const action = $16d9fec6fae182d5$var$getAction$1(form, submitter);
        return this.submissionIsNavigatable(form, submitter) && $16d9fec6fae182d5$var$locationIsVisitable($16d9fec6fae182d5$var$expandURL(action), this.snapshot.rootLocation);
    }
    formSubmitted(form, submitter) {
        this.navigator.submitForm(form, submitter);
    }
    // Page observer delegate
    pageBecameInteractive() {
        this.view.lastRenderedLocation = this.location;
        this.notifyApplicationAfterPageLoad();
    }
    pageLoaded() {
        this.history.assumeControlOfScrollRestoration();
    }
    pageWillUnload() {
        this.history.relinquishControlOfScrollRestoration();
    }
    // Stream observer delegate
    receivedMessageFromStream(message) {
        this.renderStreamMessage(message);
    }
    // Page view delegate
    viewWillCacheSnapshot() {
        this.notifyApplicationBeforeCachingSnapshot();
    }
    allowsImmediateRender({ element: element }, options) {
        const event = this.notifyApplicationBeforeRender(element, options);
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview, renderMethod) {
        this.view.lastRenderedLocation = this.history.location;
        this.notifyApplicationAfterRender(renderMethod);
    }
    preloadOnLoadLinksForView(element) {
        this.preloader.preloadOnLoadLinksForView(element);
    }
    viewInvalidated(reason) {
        this.adapter.pageInvalidated(reason);
    }
    // Frame element
    frameLoaded(frame) {
        this.notifyApplicationAfterFrameLoad(frame);
    }
    frameRendered(fetchResponse, frame) {
        this.notifyApplicationAfterFrameRender(fetchResponse, frame);
    }
    // Application events
    applicationAllowsFollowingLinkToLocation(link, location1, ev) {
        const event = this.notifyApplicationAfterClickingLinkToLocation(link, location1, ev);
        return !event.defaultPrevented;
    }
    applicationAllowsVisitingLocation(location1) {
        const event = this.notifyApplicationBeforeVisitingLocation(location1);
        return !event.defaultPrevented;
    }
    notifyApplicationAfterClickingLinkToLocation(link, location1, event) {
        return $16d9fec6fae182d5$var$dispatch("turbo:click", {
            target: link,
            detail: {
                url: location1.href,
                originalEvent: event
            },
            cancelable: true
        });
    }
    notifyApplicationBeforeVisitingLocation(location1) {
        return $16d9fec6fae182d5$var$dispatch("turbo:before-visit", {
            detail: {
                url: location1.href
            },
            cancelable: true
        });
    }
    notifyApplicationAfterVisitingLocation(location1, action) {
        return $16d9fec6fae182d5$var$dispatch("turbo:visit", {
            detail: {
                url: location1.href,
                action: action
            }
        });
    }
    notifyApplicationBeforeCachingSnapshot() {
        return $16d9fec6fae182d5$var$dispatch("turbo:before-cache");
    }
    notifyApplicationBeforeRender(newBody, options) {
        return $16d9fec6fae182d5$var$dispatch("turbo:before-render", {
            detail: {
                newBody: newBody,
                ...options
            },
            cancelable: true
        });
    }
    notifyApplicationAfterRender(renderMethod) {
        return $16d9fec6fae182d5$var$dispatch("turbo:render", {
            detail: {
                renderMethod: renderMethod
            }
        });
    }
    notifyApplicationAfterPageLoad(timing = {}) {
        return $16d9fec6fae182d5$var$dispatch("turbo:load", {
            detail: {
                url: this.location.href,
                timing: timing
            }
        });
    }
    notifyApplicationAfterFrameLoad(frame) {
        return $16d9fec6fae182d5$var$dispatch("turbo:frame-load", {
            target: frame
        });
    }
    notifyApplicationAfterFrameRender(fetchResponse, frame) {
        return $16d9fec6fae182d5$var$dispatch("turbo:frame-render", {
            detail: {
                fetchResponse: fetchResponse
            },
            target: frame,
            cancelable: true
        });
    }
    // Helpers
    submissionIsNavigatable(form, submitter) {
        if ($16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.mode == "off") return false;
        else {
            const submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
            if ($16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.mode == "optin") return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
            else return submitterIsNavigatable && this.elementIsNavigatable(form);
        }
    }
    elementIsNavigatable(element) {
        const container = $16d9fec6fae182d5$var$findClosestRecursively(element, "[data-turbo]");
        const withinFrame = $16d9fec6fae182d5$var$findClosestRecursively(element, "turbo-frame");
        // Check if Drive is enabled on the session or we're within a Frame.
        if ($16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.enabled || withinFrame) {
            // Element is navigatable by default, unless `data-turbo="false"`.
            if (container) return container.getAttribute("data-turbo") != "false";
            else return true;
        } else {
            // Element isn't navigatable by default, unless `data-turbo="true"`.
            if (container) return container.getAttribute("data-turbo") == "true";
            else return false;
        }
    }
    // Private
    getActionForLink(link) {
        return $16d9fec6fae182d5$var$getVisitAction(link) || "advance";
    }
    get snapshot() {
        return this.view.snapshot;
    }
}
// Older versions of the Turbo Native adapters referenced the
// `Location#absoluteURL` property in their implementations of
// the `Adapter#visitProposedToLocation()` and `#visitStarted()`
// methods. The Location class has since been removed in favor
// of the DOM URL API, and accordingly all Adapter methods now
// receive URL objects.
//
// We alias #absoluteURL to #toString() here to avoid crashing
// older adapters which do not expect URL objects. We should
// consider removing this support at some point in the future.
function $16d9fec6fae182d5$var$extendURLWithDeprecatedProperties(url) {
    Object.defineProperties(url, $16d9fec6fae182d5$var$deprecatedLocationPropertyDescriptors);
}
const $16d9fec6fae182d5$var$deprecatedLocationPropertyDescriptors = {
    absoluteURL: {
        get () {
            return this.toString();
        }
    }
};
const $16d9fec6fae182d5$export$55427e926be628d4 = new $16d9fec6fae182d5$var$Session($16d9fec6fae182d5$var$recentRequests);
// Rename `navigator` to avoid shadowing `window.navigator`
const { cache: $16d9fec6fae182d5$export$69a3209f1a06c04d, navigator: $16d9fec6fae182d5$export$ec7c8efa7f5790ae } = $16d9fec6fae182d5$export$55427e926be628d4;
/**
 * Starts the main session.
 * This initialises any necessary observers such as those to monitor
 * link interactions.
 */ function $16d9fec6fae182d5$export$b3571188c770cc5a() {
    $16d9fec6fae182d5$export$55427e926be628d4.start();
}
/**
 * Registers an adapter for the main session.
 *
 * @param adapter Adapter to register
 */ function $16d9fec6fae182d5$export$ddf4d3602a252674(adapter) {
    $16d9fec6fae182d5$export$55427e926be628d4.registerAdapter(adapter);
}
/**
 * Performs an application visit to the given location.
 *
 * @param location Location to visit (a URL or path)
 * @param options Options to apply
 * @param options.action Type of history navigation to apply ("restore",
 * "replace" or "advance")
 * @param options.historyChanged Specifies whether the browser history has
 * already been changed for this visit or not
 * @param options.referrer Specifies the referrer of this visit such that
 * navigations to the same page will not result in a new history entry.
 * @param options.snapshotHTML Cached snapshot to render
 * @param options.response Response of the specified location
 */ function $16d9fec6fae182d5$export$bf638b60ea8b89b7(location1, options) {
    $16d9fec6fae182d5$export$55427e926be628d4.visit(location1, options);
}
/**
 * Connects a stream source to the main session.
 *
 * @param source Stream source to connect
 */ function $16d9fec6fae182d5$export$83667c2845c80463(source) {
    $16d9fec6fae182d5$export$55427e926be628d4.connectStreamSource(source);
}
/**
 * Disconnects a stream source from the main session.
 *
 * @param source Stream source to disconnect
 */ function $16d9fec6fae182d5$export$26c56c74e3b67c59(source) {
    $16d9fec6fae182d5$export$55427e926be628d4.disconnectStreamSource(source);
}
/**
 * Renders a stream message to the main session by appending it to the
 * current document.
 *
 * @param message Message to render
 */ function $16d9fec6fae182d5$export$ebdee272e46e11d9(message) {
    $16d9fec6fae182d5$export$55427e926be628d4.renderStreamMessage(message);
}
/**
 * Sets the delay after which the progress bar will appear during navigation.
 *
 * The progress bar appears after 500ms by default.
 *
 * Note that this method has no effect when used with the iOS or Android
 * adapters.
 *
 * @param delay Time to delay in milliseconds
 */ function $16d9fec6fae182d5$export$ddcc6947144c476c(delay) {
    console.warn("Please replace `Turbo.setProgressBarDelay(delay)` with `Turbo.config.drive.progressBarDelay = delay`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $16d9fec6fae182d5$export$e506a1d27d1eaa20.drive.progressBarDelay = delay;
}
function $16d9fec6fae182d5$export$4696f1315e6aae7c(confirmMethod) {
    console.warn("Please replace `Turbo.setConfirmMethod(confirmMethod)` with `Turbo.config.forms.confirm = confirmMethod`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.confirm = confirmMethod;
}
function $16d9fec6fae182d5$export$a94cfbb71d90abbd(mode) {
    console.warn("Please replace `Turbo.setFormMode(mode)` with `Turbo.config.forms.mode = mode`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $16d9fec6fae182d5$export$e506a1d27d1eaa20.forms.mode = mode;
}
/**
 * Morph the state of the currentBody based on the attributes and contents of
 * the newBody. Morphing body elements may dispatch turbo:morph,
 * turbo:before-morph-element, turbo:before-morph-attribute, and
 * turbo:morph-element events.
 *
 * @param currentBody HTMLBodyElement destination of morphing changes
 * @param newBody HTMLBodyElement source of morphing changes
 */ function $16d9fec6fae182d5$export$3692fe532534b56a(currentBody, newBody) {
    $16d9fec6fae182d5$var$MorphingPageRenderer.renderElement(currentBody, newBody);
}
/**
 * Morph the child elements of the currentFrame based on the child elements of
 * the newFrame. Morphing turbo-frame elements may dispatch turbo:before-frame-morph,
 * turbo:before-morph-element, turbo:before-morph-attribute, and
 * turbo:morph-element events.
 *
 * @param currentFrame FrameElement destination of morphing children changes
 * @param newFrame FrameElement source of morphing children changes
 */ function $16d9fec6fae182d5$export$e23c491af5621dca(currentFrame, newFrame) {
    $16d9fec6fae182d5$var$MorphingFrameRenderer.renderElement(currentFrame, newFrame);
}
var $16d9fec6fae182d5$var$Turbo = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    PageRenderer: $16d9fec6fae182d5$export$ac9642242cf7b3ce,
    PageSnapshot: $16d9fec6fae182d5$export$4f11b95e473fd113,
    FrameRenderer: $16d9fec6fae182d5$export$f09c4165d16bb2b7,
    fetch: $16d9fec6fae182d5$export$e7aa7bc5c1b3cfb3,
    config: $16d9fec6fae182d5$export$e506a1d27d1eaa20,
    session: $16d9fec6fae182d5$export$55427e926be628d4,
    cache: $16d9fec6fae182d5$export$69a3209f1a06c04d,
    navigator: $16d9fec6fae182d5$export$ec7c8efa7f5790ae,
    start: $16d9fec6fae182d5$export$b3571188c770cc5a,
    registerAdapter: $16d9fec6fae182d5$export$ddf4d3602a252674,
    visit: $16d9fec6fae182d5$export$bf638b60ea8b89b7,
    connectStreamSource: $16d9fec6fae182d5$export$83667c2845c80463,
    disconnectStreamSource: $16d9fec6fae182d5$export$26c56c74e3b67c59,
    renderStreamMessage: $16d9fec6fae182d5$export$ebdee272e46e11d9,
    setProgressBarDelay: $16d9fec6fae182d5$export$ddcc6947144c476c,
    setConfirmMethod: $16d9fec6fae182d5$export$4696f1315e6aae7c,
    setFormMode: $16d9fec6fae182d5$export$a94cfbb71d90abbd,
    morphBodyElements: $16d9fec6fae182d5$export$3692fe532534b56a,
    morphTurboFrameElements: $16d9fec6fae182d5$export$e23c491af5621dca,
    morphChildren: $16d9fec6fae182d5$export$e0eeaf5bc84bd47b,
    morphElements: $16d9fec6fae182d5$export$dc74801294c91b10
});
class $16d9fec6fae182d5$var$TurboFrameMissingError extends Error {
}
class $16d9fec6fae182d5$var$FrameController {
    fetchResponseLoaded = (_fetchResponse)=>Promise.resolve();
    #currentFetchRequest = null;
    #resolveVisitPromise = ()=>{};
    #connected = false;
    #hasBeenLoaded = false;
    #ignoredAttributes = new Set();
    #shouldMorphFrame = false;
    action = null;
    constructor(element){
        this.element = element;
        this.view = new $16d9fec6fae182d5$var$FrameView(this, this.element);
        this.appearanceObserver = new $16d9fec6fae182d5$var$AppearanceObserver(this, this.element);
        this.formLinkClickObserver = new $16d9fec6fae182d5$var$FormLinkClickObserver(this, this.element);
        this.linkInterceptor = new $16d9fec6fae182d5$var$LinkInterceptor(this, this.element);
        this.restorationIdentifier = $16d9fec6fae182d5$var$uuid();
        this.formSubmitObserver = new $16d9fec6fae182d5$var$FormSubmitObserver(this, this.element);
    }
    // Frame delegate
    connect() {
        if (!this.#connected) {
            this.#connected = true;
            if (this.loadingStyle == $16d9fec6fae182d5$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
            else this.#loadSourceURL();
            this.formLinkClickObserver.start();
            this.linkInterceptor.start();
            this.formSubmitObserver.start();
        }
    }
    disconnect() {
        if (this.#connected) {
            this.#connected = false;
            this.appearanceObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkInterceptor.stop();
            this.formSubmitObserver.stop();
            if (!this.element.hasAttribute("recurse")) this.#currentFetchRequest?.cancel();
        }
    }
    disabledChanged() {
        if (this.disabled) this.#currentFetchRequest?.cancel();
        else if (this.loadingStyle == $16d9fec6fae182d5$export$65f98fefe20dbcb6.eager) this.#loadSourceURL();
    }
    sourceURLChanged() {
        if (this.#isIgnoringChangesTo("src")) return;
        if (!this.sourceURL) this.#currentFetchRequest?.cancel();
        if (this.element.isConnected) this.complete = false;
        if (this.loadingStyle == $16d9fec6fae182d5$export$65f98fefe20dbcb6.eager || this.#hasBeenLoaded) this.#loadSourceURL();
    }
    sourceURLReloaded() {
        const { refresh: refresh, src: src } = this.element;
        this.#shouldMorphFrame = src && refresh === "morph";
        this.element.removeAttribute("complete");
        this.element.src = null;
        this.element.src = src;
        return this.element.loaded;
    }
    loadingStyleChanged() {
        if (this.loadingStyle == $16d9fec6fae182d5$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
        else {
            this.appearanceObserver.stop();
            this.#loadSourceURL();
        }
    }
    async #loadSourceURL() {
        if (this.enabled && this.isActive && !this.complete && this.sourceURL) {
            this.element.loaded = this.#visit($16d9fec6fae182d5$var$expandURL(this.sourceURL));
            this.appearanceObserver.stop();
            await this.element.loaded;
            this.#hasBeenLoaded = true;
        }
    }
    async loadResponse(fetchResponse) {
        if (fetchResponse.redirected || fetchResponse.succeeded && fetchResponse.isHTML) this.sourceURL = fetchResponse.response.url;
        try {
            const html = await fetchResponse.responseHTML;
            if (html) {
                const document1 = $16d9fec6fae182d5$var$parseHTMLDocument(html);
                const pageSnapshot = $16d9fec6fae182d5$export$4f11b95e473fd113.fromDocument(document1);
                if (pageSnapshot.isVisitable) await this.#loadFrameResponse(fetchResponse, document1);
                else await this.#handleUnvisitableFrameResponse(fetchResponse);
            }
        } finally{
            this.#shouldMorphFrame = false;
            this.fetchResponseLoaded = ()=>Promise.resolve();
        }
    }
    // Appearance observer delegate
    elementAppearedInViewport(element) {
        this.proposeVisitIfNavigatedWithAction(element, $16d9fec6fae182d5$var$getVisitAction(element));
        this.#loadSourceURL();
    }
    // Form link click observer delegate
    willSubmitFormLinkToLocation(link) {
        return this.#shouldInterceptNavigation(link);
    }
    submittedFormLinkToLocation(link, _location, form) {
        const frame = this.#findFrameElement(link);
        if (frame) form.setAttribute("data-turbo-frame", frame.id);
    }
    // Link interceptor delegate
    shouldInterceptLinkClick(element, _location, _event) {
        return this.#shouldInterceptNavigation(element);
    }
    linkClickIntercepted(element, location1) {
        this.#navigateFrame(element, location1);
    }
    // Form submit observer delegate
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == this.element && this.#shouldInterceptNavigation(element, submitter);
    }
    formSubmitted(element, submitter) {
        if (this.formSubmission) this.formSubmission.stop();
        this.formSubmission = new $16d9fec6fae182d5$var$FormSubmission(this, element, submitter);
        const { fetchRequest: fetchRequest } = this.formSubmission;
        const frame = this.#findFrameElement(element, submitter);
        this.prepareRequest(fetchRequest, frame);
        this.formSubmission.start();
    }
    // Fetch request delegate
    prepareRequest(request, frame = this) {
        request.headers["Turbo-Frame"] = frame.id;
        if (this.currentNavigationElement?.hasAttribute("data-turbo-stream")) request.acceptResponseType($16d9fec6fae182d5$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        $16d9fec6fae182d5$var$markAsBusy(this.element);
    }
    requestPreventedHandlingResponse(_request, _response) {
        this.#resolveVisitPromise();
    }
    async requestSucceededWithResponse(request, response) {
        await this.loadResponse(response);
        this.#resolveVisitPromise();
    }
    async requestFailedWithResponse(request, response) {
        await this.loadResponse(response);
        this.#resolveVisitPromise();
    }
    requestErrored(request, error) {
        console.error(error);
        this.#resolveVisitPromise();
    }
    requestFinished(_request) {
        $16d9fec6fae182d5$var$clearBusyState(this.element);
    }
    // Form submission delegate
    formSubmissionStarted({ formElement: formElement }) {
        $16d9fec6fae182d5$var$markAsBusy(formElement, this.#findFrameElement(formElement));
    }
    formSubmissionSucceededWithResponse(formSubmission, response) {
        const frame = this.#findFrameElement(formSubmission.formElement, formSubmission.submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, $16d9fec6fae182d5$var$getVisitAction(formSubmission.submitter, formSubmission.formElement, frame));
        frame.delegate.loadResponse(response);
        if (!formSubmission.isSafe) $16d9fec6fae182d5$export$55427e926be628d4.clearCache();
    }
    formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        this.element.delegate.loadResponse(fetchResponse);
        $16d9fec6fae182d5$export$55427e926be628d4.clearCache();
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished({ formElement: formElement }) {
        $16d9fec6fae182d5$var$clearBusyState(formElement, this.#findFrameElement(formElement));
    }
    // View delegate
    allowsImmediateRender({ element: newFrame }, options) {
        const event = $16d9fec6fae182d5$var$dispatch("turbo:before-frame-render", {
            target: this.element,
            detail: {
                newFrame: newFrame,
                ...options
            },
            cancelable: true
        });
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview, _renderMethod) {}
    preloadOnLoadLinksForView(element) {
        $16d9fec6fae182d5$export$55427e926be628d4.preloadOnLoadLinksForView(element);
    }
    viewInvalidated() {}
    // Frame renderer delegate
    willRenderFrame(currentElement, _newElement) {
        this.previousFrameElement = currentElement.cloneNode(true);
    }
    visitCachedSnapshot = ({ element: element })=>{
        const frame = element.querySelector("#" + this.element.id);
        if (frame && this.previousFrameElement) frame.replaceChildren(...this.previousFrameElement.children);
        delete this.previousFrameElement;
    };
    // Private
    async #loadFrameResponse(fetchResponse, document1) {
        const newFrameElement = await this.extractForeignFrameElement(document1.body);
        const rendererClass = this.#shouldMorphFrame ? $16d9fec6fae182d5$var$MorphingFrameRenderer : $16d9fec6fae182d5$export$f09c4165d16bb2b7;
        if (newFrameElement) {
            const snapshot = new $16d9fec6fae182d5$var$Snapshot(newFrameElement);
            const renderer = new rendererClass(this, this.view.snapshot, snapshot, false, false);
            if (this.view.renderPromise) await this.view.renderPromise;
            this.changeHistory();
            await this.view.render(renderer);
            this.complete = true;
            $16d9fec6fae182d5$export$55427e926be628d4.frameRendered(fetchResponse, this.element);
            $16d9fec6fae182d5$export$55427e926be628d4.frameLoaded(this.element);
            await this.fetchResponseLoaded(fetchResponse);
        } else if (this.#willHandleFrameMissingFromResponse(fetchResponse)) this.#handleFrameMissingFromResponse(fetchResponse);
    }
    async #visit(url) {
        const request = new $16d9fec6fae182d5$export$319b96fe59834522(this, $16d9fec6fae182d5$export$76f6869e29ff06ee.get, url, new URLSearchParams(), this.element);
        this.#currentFetchRequest?.cancel();
        this.#currentFetchRequest = request;
        return new Promise((resolve)=>{
            this.#resolveVisitPromise = ()=>{
                this.#resolveVisitPromise = ()=>{};
                this.#currentFetchRequest = null;
                resolve();
            };
            request.perform();
        });
    }
    #navigateFrame(element, url, submitter) {
        const frame = this.#findFrameElement(element, submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, $16d9fec6fae182d5$var$getVisitAction(submitter, element, frame));
        this.#withCurrentNavigationElement(element, ()=>{
            frame.src = url;
        });
    }
    proposeVisitIfNavigatedWithAction(frame, action = null) {
        this.action = action;
        if (this.action) {
            const pageSnapshot = $16d9fec6fae182d5$export$4f11b95e473fd113.fromElement(frame).clone();
            const { visitCachedSnapshot: visitCachedSnapshot } = frame.delegate;
            frame.delegate.fetchResponseLoaded = async (fetchResponse)=>{
                if (frame.src) {
                    const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                    const responseHTML = await fetchResponse.responseHTML;
                    const response = {
                        statusCode: statusCode,
                        redirected: redirected,
                        responseHTML: responseHTML
                    };
                    const options = {
                        response: response,
                        visitCachedSnapshot: visitCachedSnapshot,
                        willRender: false,
                        updateHistory: false,
                        restorationIdentifier: this.restorationIdentifier,
                        snapshot: pageSnapshot
                    };
                    if (this.action) options.action = this.action;
                    $16d9fec6fae182d5$export$55427e926be628d4.visit(frame.src, options);
                }
            };
        }
    }
    changeHistory() {
        if (this.action) {
            const method = $16d9fec6fae182d5$var$getHistoryMethodForAction(this.action);
            $16d9fec6fae182d5$export$55427e926be628d4.history.update(method, $16d9fec6fae182d5$var$expandURL(this.element.src || ""), this.restorationIdentifier);
        }
    }
    async #handleUnvisitableFrameResponse(fetchResponse) {
        console.warn(`The response (${fetchResponse.statusCode}) from <turbo-frame id="${this.element.id}"> is performing a full page visit due to turbo-visit-control.`);
        await this.#visitResponse(fetchResponse.response);
    }
    #willHandleFrameMissingFromResponse(fetchResponse) {
        this.element.setAttribute("complete", "");
        const response = fetchResponse.response;
        const visit = async (url, options)=>{
            if (url instanceof Response) this.#visitResponse(url);
            else $16d9fec6fae182d5$export$55427e926be628d4.visit(url, options);
        };
        const event = $16d9fec6fae182d5$var$dispatch("turbo:frame-missing", {
            target: this.element,
            detail: {
                response: response,
                visit: visit
            },
            cancelable: true
        });
        return !event.defaultPrevented;
    }
    #handleFrameMissingFromResponse(fetchResponse) {
        this.view.missing();
        this.#throwFrameMissingError(fetchResponse);
    }
    #throwFrameMissingError(fetchResponse) {
        const message = `The response (${fetchResponse.statusCode}) did not contain the expected <turbo-frame id="${this.element.id}"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.`;
        throw new $16d9fec6fae182d5$var$TurboFrameMissingError(message);
    }
    async #visitResponse(response) {
        const wrapped = new $16d9fec6fae182d5$export$3ae09bba5b6b906e(response);
        const responseHTML = await wrapped.responseHTML;
        const { location: location1, redirected: redirected, statusCode: statusCode } = wrapped;
        return $16d9fec6fae182d5$export$55427e926be628d4.visit(location1, {
            response: {
                redirected: redirected,
                statusCode: statusCode,
                responseHTML: responseHTML
            }
        });
    }
    #findFrameElement(element, submitter) {
        const id = $16d9fec6fae182d5$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        const target = this.#getFrameElementById(id);
        return target instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44 ? target : this.element;
    }
    async extractForeignFrameElement(container) {
        let element;
        const id = CSS.escape(this.id);
        try {
            element = $16d9fec6fae182d5$var$activateElement(container.querySelector(`turbo-frame#${id}`), this.sourceURL);
            if (element) return element;
            element = $16d9fec6fae182d5$var$activateElement(container.querySelector(`turbo-frame[src][recurse~=${id}]`), this.sourceURL);
            if (element) {
                await element.loaded;
                return await this.extractForeignFrameElement(element);
            }
        } catch (error) {
            console.error(error);
            return new $16d9fec6fae182d5$export$f464a8f0ffa32c44();
        }
        return null;
    }
    #formActionIsVisitable(form, submitter) {
        const action = $16d9fec6fae182d5$var$getAction$1(form, submitter);
        return $16d9fec6fae182d5$var$locationIsVisitable($16d9fec6fae182d5$var$expandURL(action), this.rootLocation);
    }
    #shouldInterceptNavigation(element, submitter) {
        const id = $16d9fec6fae182d5$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        if (element instanceof HTMLFormElement && !this.#formActionIsVisitable(element, submitter)) return false;
        if (!this.enabled || id == "_top") return false;
        if (id) {
            const frameElement = this.#getFrameElementById(id);
            if (frameElement) return !frameElement.disabled;
            else if (id == "_parent") return false;
        }
        if (!$16d9fec6fae182d5$export$55427e926be628d4.elementIsNavigatable(element)) return false;
        if (submitter && !$16d9fec6fae182d5$export$55427e926be628d4.elementIsNavigatable(submitter)) return false;
        return true;
    }
    // Computed properties
    get id() {
        return this.element.id;
    }
    get disabled() {
        return this.element.disabled;
    }
    get enabled() {
        return !this.disabled;
    }
    get sourceURL() {
        if (this.element.src) return this.element.src;
    }
    set sourceURL(sourceURL) {
        this.#ignoringChangesToAttribute("src", ()=>{
            this.element.src = sourceURL ?? null;
        });
    }
    get loadingStyle() {
        return this.element.loading;
    }
    get isLoading() {
        return this.formSubmission !== undefined || this.#resolveVisitPromise() !== undefined;
    }
    get complete() {
        return this.element.hasAttribute("complete");
    }
    set complete(value) {
        if (value) this.element.setAttribute("complete", "");
        else this.element.removeAttribute("complete");
    }
    get isActive() {
        return this.element.isActive && this.#connected;
    }
    get rootLocation() {
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const root = meta?.content ?? "/";
        return $16d9fec6fae182d5$var$expandURL(root);
    }
    #isIgnoringChangesTo(attributeName) {
        return this.#ignoredAttributes.has(attributeName);
    }
    #ignoringChangesToAttribute(attributeName, callback) {
        this.#ignoredAttributes.add(attributeName);
        callback();
        this.#ignoredAttributes.delete(attributeName);
    }
    #withCurrentNavigationElement(element, callback) {
        this.currentNavigationElement = element;
        callback();
        delete this.currentNavigationElement;
    }
    #getFrameElementById(id) {
        if (id != null) {
            const element = id === "_parent" ? this.element.parentElement.closest("turbo-frame") : document.getElementById(id);
            if (element instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44) return element;
        }
    }
}
function $16d9fec6fae182d5$var$activateElement(element, currentURL) {
    if (element) {
        const src = element.getAttribute("src");
        if (src != null && currentURL != null && $16d9fec6fae182d5$var$urlsAreEqual(src, currentURL)) throw new Error(`Matching <turbo-frame id="${element.id}"> element has a source URL which references itself`);
        if (element.ownerDocument !== document) element = document.importNode(element, true);
        if (element instanceof $16d9fec6fae182d5$export$f464a8f0ffa32c44) {
            element.connectedCallback();
            element.disconnectedCallback();
            return element;
        }
    }
}
const $16d9fec6fae182d5$export$1b814a67c3a57eeb = {
    after () {
        this.removeDuplicateTargetSiblings();
        this.targetElements.forEach((e)=>e.parentElement?.insertBefore(this.templateContent, e.nextSibling));
    },
    append () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.append(this.templateContent));
    },
    before () {
        this.removeDuplicateTargetSiblings();
        this.targetElements.forEach((e)=>e.parentElement?.insertBefore(this.templateContent, e));
    },
    prepend () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.prepend(this.templateContent));
    },
    remove () {
        this.targetElements.forEach((e)=>e.remove());
    },
    replace () {
        const method = this.getAttribute("method");
        this.targetElements.forEach((targetElement)=>{
            if (method === "morph") $16d9fec6fae182d5$export$dc74801294c91b10(targetElement, this.templateContent);
            else targetElement.replaceWith(this.templateContent);
        });
    },
    update () {
        const method = this.getAttribute("method");
        this.targetElements.forEach((targetElement)=>{
            if (method === "morph") $16d9fec6fae182d5$export$e0eeaf5bc84bd47b(targetElement, this.templateContent);
            else {
                targetElement.innerHTML = "";
                targetElement.append(this.templateContent);
            }
        });
    },
    refresh () {
        const method = this.getAttribute("method");
        const requestId = this.requestId;
        const scroll = this.getAttribute("scroll");
        $16d9fec6fae182d5$export$55427e926be628d4.refresh(this.baseURI, {
            method: method,
            requestId: requestId,
            scroll: scroll
        });
    }
};
// <turbo-stream action=replace target=id><template>...
/**
 * Renders updates to the page from a stream of messages.
 *
 * Using the `action` attribute, this can be configured one of eight ways:
 *
 * - `after` - inserts the result after the target
 * - `append` - appends the result to the target
 * - `before` - inserts the result before the target
 * - `prepend` - prepends the result to the target
 * - `refresh` - initiates a page refresh
 * - `remove` - removes the target
 * - `replace` - replaces the outer HTML of the target
 * - `update` - replaces the inner HTML of the target
 *
 * @customElement turbo-stream
 * @example
 *   <turbo-stream action="append" target="dom_id">
 *     <template>
 *       Content to append to target designated with the dom_id.
 *     </template>
 *   </turbo-stream>
 */ class $16d9fec6fae182d5$export$144d499d37929ea8 extends HTMLElement {
    static async renderElement(newElement) {
        await newElement.performAction();
    }
    async connectedCallback() {
        try {
            await this.render();
        } catch (error) {
            console.error(error);
        } finally{
            this.disconnect();
        }
    }
    async render() {
        return this.renderPromise ??= (async ()=>{
            const event = this.beforeRenderEvent;
            if (this.dispatchEvent(event)) {
                await $16d9fec6fae182d5$var$nextRepaint();
                await event.detail.render(this);
            }
        })();
    }
    disconnect() {
        try {
            this.remove();
        // eslint-disable-next-line no-empty
        } catch  {}
    }
    /**
   * Removes duplicate children (by ID)
   */ removeDuplicateTargetChildren() {
        this.duplicateChildren.forEach((c)=>c.remove());
    }
    /**
   * Gets the list of duplicate children (i.e. those with the same ID)
   */ get duplicateChildren() {
        const existingChildren = this.targetElements.flatMap((e)=>[
                ...e.children
            ]).filter((c)=>!!c.getAttribute("id"));
        const newChildrenIds = [
            ...this.templateContent?.children || []
        ].filter((c)=>!!c.getAttribute("id")).map((c)=>c.getAttribute("id"));
        return existingChildren.filter((c)=>newChildrenIds.includes(c.getAttribute("id")));
    }
    /**
  * Removes duplicate siblings (by ID)
  */ removeDuplicateTargetSiblings() {
        this.duplicateSiblings.forEach((c)=>c.remove());
    }
    /**
  * Gets the list of duplicate siblings (i.e. those with the same ID)
  */ get duplicateSiblings() {
        const existingChildren = this.targetElements.flatMap((e)=>[
                ...e.parentElement.children
            ]).filter((c)=>!!c.id);
        const newChildrenIds = [
            ...this.templateContent?.children || []
        ].filter((c)=>!!c.id).map((c)=>c.id);
        return existingChildren.filter((c)=>newChildrenIds.includes(c.id));
    }
    /**
   * Gets the action function to be performed.
   */ get performAction() {
        if (this.action) {
            const actionFunction = $16d9fec6fae182d5$export$1b814a67c3a57eeb[this.action];
            if (actionFunction) return actionFunction;
            this.#raise("unknown action");
        }
        this.#raise("action attribute is missing");
    }
    /**
   * Gets the target elements which the template will be rendered to.
   */ get targetElements() {
        if (this.target) return this.targetElementsById;
        else if (this.targets) return this.targetElementsByQuery;
        else this.#raise("target or targets attribute is missing");
    }
    /**
   * Gets the contents of the main `<template>`.
   */ get templateContent() {
        return this.templateElement.content.cloneNode(true);
    }
    /**
   * Gets the main `<template>` used for rendering
   */ get templateElement() {
        if (this.firstElementChild === null) {
            const template = this.ownerDocument.createElement("template");
            this.appendChild(template);
            return template;
        } else if (this.firstElementChild instanceof HTMLTemplateElement) return this.firstElementChild;
        this.#raise("first child element must be a <template> element");
    }
    /**
   * Gets the current action.
   */ get action() {
        return this.getAttribute("action");
    }
    /**
   * Gets the current target (an element ID) to which the result will
   * be rendered.
   */ get target() {
        return this.getAttribute("target");
    }
    /**
   * Gets the current "targets" selector (a CSS selector)
   */ get targets() {
        return this.getAttribute("targets");
    }
    /**
   * Reads the request-id attribute
   */ get requestId() {
        return this.getAttribute("request-id");
    }
    #raise(message) {
        throw new Error(`${this.description}: ${message}`);
    }
    get description() {
        return (this.outerHTML.match(/<[^>]+>/) ?? [])[0] ?? "<turbo-stream>";
    }
    get beforeRenderEvent() {
        return new CustomEvent("turbo:before-stream-render", {
            bubbles: true,
            cancelable: true,
            detail: {
                newStream: this,
                render: $16d9fec6fae182d5$export$144d499d37929ea8.renderElement
            }
        });
    }
    get targetElementsById() {
        const element = this.ownerDocument?.getElementById(this.target);
        if (element !== null) return [
            element
        ];
        else return [];
    }
    get targetElementsByQuery() {
        const elements = this.ownerDocument?.querySelectorAll(this.targets);
        if (elements.length !== 0) return Array.prototype.slice.call(elements);
        else return [];
    }
}
class $16d9fec6fae182d5$export$e87d51a4385a3903 extends HTMLElement {
    streamSource = null;
    connectedCallback() {
        this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
        $16d9fec6fae182d5$export$83667c2845c80463(this.streamSource);
    }
    disconnectedCallback() {
        if (this.streamSource) {
            this.streamSource.close();
            $16d9fec6fae182d5$export$26c56c74e3b67c59(this.streamSource);
        }
    }
    get src() {
        return this.getAttribute("src") || "";
    }
}
$16d9fec6fae182d5$export$f464a8f0ffa32c44.delegateConstructor = $16d9fec6fae182d5$var$FrameController;
if (customElements.get("turbo-frame") === undefined) customElements.define("turbo-frame", $16d9fec6fae182d5$export$f464a8f0ffa32c44);
if (customElements.get("turbo-stream") === undefined) customElements.define("turbo-stream", $16d9fec6fae182d5$export$144d499d37929ea8);
if (customElements.get("turbo-stream-source") === undefined) customElements.define("turbo-stream-source", $16d9fec6fae182d5$export$e87d51a4385a3903);
(()=>{
    const scriptElement = document.currentScript;
    if (!scriptElement) return;
    if (scriptElement.hasAttribute("data-turbo-suppress-warning")) return;
    let element = scriptElement.parentElement;
    while(element){
        if (element == document.body) return console.warn($16d9fec6fae182d5$var$unindent`
        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!

        Load your application’s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.

        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements

        ——
        Suppress this warning by adding a "data-turbo-suppress-warning" attribute to: %s
      `, scriptElement.outerHTML);
        element = element.parentElement;
    }
})();
window.Turbo = {
    ...$16d9fec6fae182d5$var$Turbo,
    StreamActions: $16d9fec6fae182d5$export$1b814a67c3a57eeb
};
$16d9fec6fae182d5$export$b3571188c770cc5a();


/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ class $a7248a23ab27f746$var$EventListener {
    constructor(eventTarget, eventName, eventOptions){
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    }
    disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    }
    bindingConnected(binding) {
        this.unorderedBindings.add(binding);
    }
    bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
    }
    handleEvent(event) {
        const extendedEvent = $a7248a23ab27f746$var$extendEvent(event);
        for (const binding of this.bindings){
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    }
    hasBindings() {
        return this.unorderedBindings.size > 0;
    }
    get bindings() {
        return Array.from(this.unorderedBindings).sort((left, right)=>{
            const leftIndex = left.index, rightIndex = right.index;
            return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
    }
}
function $a7248a23ab27f746$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        const { stopImmediatePropagation: stopImmediatePropagation } = event;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation () {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
class $a7248a23ab27f746$var$Dispatcher {
    constructor(application){
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach((eventListener)=>eventListener.connect());
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach((eventListener)=>eventListener.disconnect());
        }
    }
    get eventListeners() {
        return Array.from(this.eventListenerMaps.values()).reduce((listeners, map)=>listeners.concat(Array.from(map.values())), []);
    }
    bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    }
    bindingDisconnected(binding, clearEventListeners = false) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
    }
    handleError(error, message, detail = {}) {
        this.application.handleError(error, `Error ${message}`, detail);
    }
    clearEventListenersForBinding(binding) {
        const eventListener = this.fetchEventListenerForBinding(binding);
        if (!eventListener.hasBindings()) {
            eventListener.disconnect();
            this.removeMappedEventListenerFor(binding);
        }
    }
    removeMappedEventListenerFor(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
    }
    fetchEventListenerForBinding(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    }
    fetchEventListener(eventTarget, eventName, eventOptions) {
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        let eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    }
    createEventListener(eventTarget, eventName, eventOptions) {
        const eventListener = new $a7248a23ab27f746$var$EventListener(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    }
    fetchEventListenerMapForEventTarget(eventTarget) {
        let eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map();
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    }
    cacheKey(eventName, eventOptions) {
        const parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach((key)=>{
            parts.push(`${eventOptions[key] ? "" : "!"}${key}`);
        });
        return parts.join(":");
    }
}
const $a7248a23ab27f746$var$defaultActionDescriptorFilters = {
    stop ({ event: event, value: value }) {
        if (value) event.stopPropagation();
        return true;
    },
    prevent ({ event: event, value: value }) {
        if (value) event.preventDefault();
        return true;
    },
    self ({ event: event, value: value, element: element }) {
        if (value) return element === event.target;
        else return true;
    }
};
const $a7248a23ab27f746$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $a7248a23ab27f746$var$parseActionDescriptorString(descriptorString) {
    const source = descriptorString.trim();
    const matches = source.match($a7248a23ab27f746$var$descriptorPattern) || [];
    let eventName = matches[2];
    let keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += `.${keyFilter}`;
        keyFilter = "";
    }
    return {
        eventTarget: $a7248a23ab27f746$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $a7248a23ab27f746$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $a7248a23ab27f746$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $a7248a23ab27f746$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce((options, token)=>Object.assign(options, {
            [token.replace(/^!/, "")]: !/^!/.test(token)
        }), {});
}
function $a7248a23ab27f746$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $a7248a23ab27f746$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, (_, char)=>char.toUpperCase());
}
function $a7248a23ab27f746$var$namespaceCamelize(value) {
    return $a7248a23ab27f746$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $a7248a23ab27f746$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $a7248a23ab27f746$var$dasherize(value) {
    return value.replace(/([A-Z])/g, (_, char)=>`-${char.toLowerCase()}`);
}
function $a7248a23ab27f746$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $a7248a23ab27f746$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $a7248a23ab27f746$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
const $a7248a23ab27f746$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
class $a7248a23ab27f746$var$Action {
    constructor(element, index, descriptor, schema){
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $a7248a23ab27f746$var$getDefaultEventNameForElement(element) || $a7248a23ab27f746$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $a7248a23ab27f746$var$error("missing identifier");
        this.methodName = descriptor.methodName || $a7248a23ab27f746$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    static forToken(token, schema) {
        return new this(token.element, token.index, $a7248a23ab27f746$var$parseActionDescriptorString(token.content), schema);
    }
    toString() {
        const eventFilter = this.keyFilter ? `.${this.keyFilter}` : "";
        const eventTarget = this.eventTargetName ? `@${this.eventTargetName}` : "";
        return `${this.eventName}${eventFilter}${eventTarget}->${this.identifier}#${this.methodName}`;
    }
    shouldIgnoreKeyboardEvent(event) {
        if (!this.keyFilter) return false;
        const filters = this.keyFilter.split("+");
        if (this.keyFilterDissatisfied(event, filters)) return true;
        const standardFilter = filters.filter((key)=>!$a7248a23ab27f746$var$allModifiers.includes(key))[0];
        if (!standardFilter) return false;
        if (!$a7248a23ab27f746$var$hasProperty(this.keyMappings, standardFilter)) $a7248a23ab27f746$var$error(`contains unknown key filter: ${this.keyFilter}`);
        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
    }
    shouldIgnoreMouseEvent(event) {
        if (!this.keyFilter) return false;
        const filters = [
            this.keyFilter
        ];
        if (this.keyFilterDissatisfied(event, filters)) return true;
        return false;
    }
    get params() {
        const params = {};
        const pattern = new RegExp(`^data-${this.identifier}-(.+)-param$`, "i");
        for (const { name: name, value: value } of Array.from(this.element.attributes)){
            const match = name.match(pattern);
            const key = match && match[1];
            if (key) params[$a7248a23ab27f746$var$camelize(key)] = $a7248a23ab27f746$var$typecast(value);
        }
        return params;
    }
    get eventTargetName() {
        return $a7248a23ab27f746$var$stringifyEventTarget(this.eventTarget);
    }
    get keyMappings() {
        return this.schema.keyMappings;
    }
    keyFilterDissatisfied(event, filters) {
        const [meta, ctrl, alt, shift] = $a7248a23ab27f746$var$allModifiers.map((modifier)=>filters.includes(modifier));
        return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
    }
}
const $a7248a23ab27f746$var$defaultEventNames = {
    a: ()=>"click",
    button: ()=>"click",
    form: ()=>"submit",
    details: ()=>"toggle",
    input: (e)=>e.getAttribute("type") == "submit" ? "click" : "input",
    select: ()=>"change",
    textarea: ()=>"input"
};
function $a7248a23ab27f746$var$getDefaultEventNameForElement(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName in $a7248a23ab27f746$var$defaultEventNames) return $a7248a23ab27f746$var$defaultEventNames[tagName](element);
}
function $a7248a23ab27f746$var$error(message) {
    throw new Error(message);
}
function $a7248a23ab27f746$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
class $a7248a23ab27f746$var$Binding {
    constructor(context, action){
        this.context = context;
        this.action = action;
    }
    get index() {
        return this.action.index;
    }
    get eventTarget() {
        return this.action.eventTarget;
    }
    get eventOptions() {
        return this.action.eventOptions;
    }
    get identifier() {
        return this.context.identifier;
    }
    handleEvent(event) {
        const actionEvent = this.prepareActionEvent(event);
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
    }
    get eventName() {
        return this.action.eventName;
    }
    get method() {
        const method = this.controller[this.methodName];
        if (typeof method == "function") return method;
        throw new Error(`Action "${this.action}" references undefined method "${this.methodName}"`);
    }
    applyEventModifiers(event) {
        const { element: element } = this.action;
        const { actionDescriptorFilters: actionDescriptorFilters } = this.context.application;
        const { controller: controller } = this.context;
        let passes = true;
        for (const [name, value] of Object.entries(this.eventOptions)){
            if (name in actionDescriptorFilters) {
                const filter = actionDescriptorFilters[name];
                passes = passes && filter({
                    name: name,
                    value: value,
                    event: event,
                    element: element,
                    controller: controller
                });
            } else continue;
        }
        return passes;
    }
    prepareActionEvent(event) {
        return Object.assign(event, {
            params: this.action.params
        });
    }
    invokeWithEvent(event) {
        const { target: target, currentTarget: currentTarget } = event;
        try {
            this.method.call(this.controller, event);
            this.context.logDebugActivity(this.methodName, {
                event: event,
                target: target,
                currentTarget: currentTarget,
                action: this.methodName
            });
        } catch (error) {
            const { identifier: identifier, controller: controller, element: element, index: index } = this;
            const detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, `invoking action "${this.action}"`, detail);
        }
    }
    willBeInvokedByEvent(event) {
        const eventTarget = event.target;
        if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
        if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    }
    get controller() {
        return this.context.controller;
    }
    get methodName() {
        return this.action.methodName;
    }
    get element() {
        return this.scope.element;
    }
    get scope() {
        return this.context.scope;
    }
}
class $a7248a23ab27f746$export$12e07a2a9f87578a {
    constructor(element, delegate){
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.refresh();
        }
    }
    pause(callback) {
        if (this.started) {
            this.mutationObserver.disconnect();
            this.started = false;
        }
        callback();
        if (!this.started) {
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) {
            const matches = new Set(this.matchElementsInTree());
            for (const element of Array.from(this.elements))if (!matches.has(element)) this.removeElement(element);
            for (const element of Array.from(matches))this.addElement(element);
        }
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    }
    processAttributeChange(element, attributeName) {
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    }
    processRemovedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    }
    processAddedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    }
    matchElement(element) {
        return this.delegate.matchElement(element);
    }
    matchElementsInTree(tree = this.element) {
        return this.delegate.matchElementsInTree(tree);
    }
    processTree(tree, processor) {
        for (const element of this.matchElementsInTree(tree))processor.call(this, element);
    }
    elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    }
    elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    }
    addElement(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    }
    removeElement(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    }
}
class $a7248a23ab27f746$export$fe68319d413d05cb {
    constructor(element, attributeName, delegate){
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $a7248a23ab27f746$export$12e07a2a9f87578a(element, this);
    }
    get element() {
        return this.elementObserver.element;
    }
    get selector() {
        return `[${this.attributeName}]`;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get started() {
        return this.elementObserver.started;
    }
    matchElement(element) {
        return element.hasAttribute(this.attributeName);
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    }
    elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    }
    elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    }
    elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    }
}
function $a7248a23ab27f746$export$e16d8520af44a096(map, key, value) {
    $a7248a23ab27f746$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $a7248a23ab27f746$export$1d2f21e549771e67(map, key, value) {
    $a7248a23ab27f746$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $a7248a23ab27f746$export$d6cf75919f12ca5a(map, key);
}
function $a7248a23ab27f746$export$e7aa7bc5c1b3cfb3(map, key) {
    let values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $a7248a23ab27f746$export$d6cf75919f12ca5a(map, key) {
    const values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
class $a7248a23ab27f746$export$8bd4ad37b76db6ba {
    constructor(){
        this.valuesByKey = new Map();
    }
    get keys() {
        return Array.from(this.valuesByKey.keys());
    }
    get values() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((values, set)=>values.concat(Array.from(set)), []);
    }
    get size() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((size, set)=>size + set.size, 0);
    }
    add(key, value) {
        $a7248a23ab27f746$export$e16d8520af44a096(this.valuesByKey, key, value);
    }
    delete(key, value) {
        $a7248a23ab27f746$export$1d2f21e549771e67(this.valuesByKey, key, value);
    }
    has(key, value) {
        const values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    }
    hasKey(key) {
        return this.valuesByKey.has(key);
    }
    hasValue(value) {
        const sets = Array.from(this.valuesByKey.values());
        return sets.some((set)=>set.has(value));
    }
    getValuesForKey(key) {
        const values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    }
    getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(([_key, values])=>values.has(value)).map(([key, _values])=>key);
    }
}
class $a7248a23ab27f746$export$a7c3d2c2552a674d extends $a7248a23ab27f746$export$8bd4ad37b76db6ba {
    constructor(){
        super();
        this.keysByValue = new Map();
    }
    get values() {
        return Array.from(this.keysByValue.keys());
    }
    add(key, value) {
        super.add(key, value);
        $a7248a23ab27f746$export$e16d8520af44a096(this.keysByValue, value, key);
    }
    delete(key, value) {
        super.delete(key, value);
        $a7248a23ab27f746$export$1d2f21e549771e67(this.keysByValue, value, key);
    }
    hasValue(value) {
        return this.keysByValue.has(value);
    }
    getKeysForValue(value) {
        const set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    }
}
class $a7248a23ab27f746$export$116e0b48509995b {
    constructor(element, selector, delegate, details){
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $a7248a23ab27f746$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.elementObserver.started;
    }
    get selector() {
        return this._selector;
    }
    set selector(selector) {
        this._selector = selector;
        this.refresh();
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get element() {
        return this.elementObserver.element;
    }
    matchElement(element) {
        const { selector: selector } = this;
        if (selector) {
            const matches = element.matches(selector);
            if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
            return matches;
        } else return false;
    }
    matchElementsInTree(tree) {
        const { selector: selector } = this;
        if (selector) {
            const match = this.matchElement(tree) ? [
                tree
            ] : [];
            const matches = Array.from(tree.querySelectorAll(selector)).filter((match)=>this.matchElement(match));
            return match.concat(matches);
        } else return [];
    }
    elementMatched(element) {
        const { selector: selector } = this;
        if (selector) this.selectorMatched(element, selector);
    }
    elementUnmatched(element) {
        const selectors = this.matchesByElement.getKeysForValue(element);
        for (const selector of selectors)this.selectorUnmatched(element, selector);
    }
    elementAttributeChanged(element, _attributeName) {
        const { selector: selector } = this;
        if (selector) {
            const matches = this.matchElement(element);
            const matchedBefore = this.matchesByElement.has(selector, element);
            if (matches && !matchedBefore) this.selectorMatched(element, selector);
            else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
        }
    }
    selectorMatched(element, selector) {
        this.delegate.selectorMatched(element, selector, this.details);
        this.matchesByElement.add(selector, element);
    }
    selectorUnmatched(element, selector) {
        this.delegate.selectorUnmatched(element, selector, this.details);
        this.matchesByElement.delete(selector, element);
    }
}
class $a7248a23ab27f746$export$da226bebbf7f6caa {
    constructor(element, delegate){
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                attributeOldValue: true
            });
            this.refresh();
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) for (const attributeName of this.knownAttributeNames)this.refreshAttribute(attributeName, null);
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        const attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
    }
    refreshAttribute(attributeName, oldValue) {
        const key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            const value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
            if (value == null) {
                const oldValue = this.stringMap.get(attributeName);
                this.stringMap.delete(attributeName);
                if (oldValue) this.stringMapKeyRemoved(key, attributeName, oldValue);
            } else this.stringMap.set(attributeName, value);
        }
    }
    stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    }
    stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
    }
    get knownAttributeNames() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
    }
    get currentAttributeNames() {
        return Array.from(this.element.attributes).map((attribute)=>attribute.name);
    }
    get recordedAttributeNames() {
        return Array.from(this.stringMap.keys());
    }
}
class $a7248a23ab27f746$export$3aa21c2f03ef6b3b {
    constructor(element, attributeName, delegate){
        this.attributeObserver = new $a7248a23ab27f746$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.attributeObserver.started;
    }
    start() {
        this.attributeObserver.start();
    }
    pause(callback) {
        this.attributeObserver.pause(callback);
    }
    stop() {
        this.attributeObserver.stop();
    }
    refresh() {
        this.attributeObserver.refresh();
    }
    get element() {
        return this.attributeObserver.element;
    }
    get attributeName() {
        return this.attributeObserver.attributeName;
    }
    elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
    }
    elementAttributeValueChanged(element) {
        const [unmatchedTokens, matchedTokens] = this.refreshTokensForElement(element);
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    }
    elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    }
    tokensMatched(tokens) {
        tokens.forEach((token)=>this.tokenMatched(token));
    }
    tokensUnmatched(tokens) {
        tokens.forEach((token)=>this.tokenUnmatched(token));
    }
    tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    }
    tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    }
    refreshTokensForElement(element) {
        const previousTokens = this.tokensByElement.getValuesForKey(element);
        const currentTokens = this.readTokensForElement(element);
        const firstDifferingIndex = $a7248a23ab27f746$var$zip(previousTokens, currentTokens).findIndex(([previousToken, currentToken])=>!$a7248a23ab27f746$var$tokensAreEqual(previousToken, currentToken));
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    }
    readTokensForElement(element) {
        const attributeName = this.attributeName;
        const tokenString = element.getAttribute(attributeName) || "";
        return $a7248a23ab27f746$var$parseTokenString(tokenString, element, attributeName);
    }
}
function $a7248a23ab27f746$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter((content)=>content.length).map((content, index)=>({
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        }));
}
function $a7248a23ab27f746$var$zip(left, right) {
    const length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, (_, index)=>[
            left[index],
            right[index]
        ]);
}
function $a7248a23ab27f746$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
class $a7248a23ab27f746$export$d27fa4c7330a452e {
    constructor(element, attributeName, delegate){
        this.tokenListObserver = new $a7248a23ab27f746$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    get started() {
        return this.tokenListObserver.started;
    }
    start() {
        this.tokenListObserver.start();
    }
    stop() {
        this.tokenListObserver.stop();
    }
    refresh() {
        this.tokenListObserver.refresh();
    }
    get element() {
        return this.tokenListObserver.element;
    }
    get attributeName() {
        return this.tokenListObserver.attributeName;
    }
    tokenMatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    }
    tokenUnmatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    }
    fetchParseResultForToken(token) {
        let parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    }
    fetchValuesByTokenForElement(element) {
        let valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map();
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    }
    parseToken(token) {
        try {
            const value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class $a7248a23ab27f746$var$BindingObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    start() {
        if (!this.valueListObserver) {
            this.valueListObserver = new $a7248a23ab27f746$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    }
    stop() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    }
    get element() {
        return this.context.element;
    }
    get identifier() {
        return this.context.identifier;
    }
    get actionAttribute() {
        return this.schema.actionAttribute;
    }
    get schema() {
        return this.context.schema;
    }
    get bindings() {
        return Array.from(this.bindingsByAction.values());
    }
    connectAction(action) {
        const binding = new $a7248a23ab27f746$var$Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    }
    disconnectAction(action) {
        const binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    }
    disconnectAllActions() {
        this.bindings.forEach((binding)=>this.delegate.bindingDisconnected(binding, true));
        this.bindingsByAction.clear();
    }
    parseValueForToken(token) {
        const action = $a7248a23ab27f746$var$Action.forToken(token, this.schema);
        if (action.identifier == this.identifier) return action;
    }
    elementMatchedValue(element, action) {
        this.connectAction(action);
    }
    elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
    }
}
class $a7248a23ab27f746$var$ValueObserver {
    constructor(context, receiver){
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $a7248a23ab27f746$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
    }
    stop() {
        this.stringMapObserver.stop();
    }
    get element() {
        return this.context.element;
    }
    get controller() {
        return this.context.controller;
    }
    getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    }
    stringMapKeyAdded(key, attributeName) {
        const descriptor = this.valueDescriptorMap[attributeName];
        if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
    }
    stringMapValueChanged(value, name, oldValue) {
        const descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;
        if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
        this.invokeChangedCallback(name, value, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        const descriptor = this.valueDescriptorNameMap[key];
        if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
    }
    invokeChangedCallbacksForDefaultValues() {
        for (const { key: key, name: name, defaultValue: defaultValue, writer: writer } of this.valueDescriptors)if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
    }
    invokeChangedCallback(name, rawValue, rawOldValue) {
        const changedMethodName = `${name}Changed`;
        const changedMethod = this.receiver[changedMethodName];
        if (typeof changedMethod == "function") {
            const descriptor = this.valueDescriptorNameMap[name];
            try {
                const value = descriptor.reader(rawValue);
                let oldValue = rawOldValue;
                if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                changedMethod.call(this.receiver, value, oldValue);
            } catch (error) {
                if (error instanceof TypeError) error.message = `Stimulus Value "${this.context.identifier}.${descriptor.name}" - ${error.message}`;
                throw error;
            }
        }
    }
    get valueDescriptors() {
        const { valueDescriptorMap: valueDescriptorMap } = this;
        return Object.keys(valueDescriptorMap).map((key)=>valueDescriptorMap[key]);
    }
    get valueDescriptorNameMap() {
        const descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach((key)=>{
            const descriptor = this.valueDescriptorMap[key];
            descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
    }
    hasValue(attributeName) {
        const descriptor = this.valueDescriptorNameMap[attributeName];
        const hasMethodName = `has${$a7248a23ab27f746$var$capitalize(descriptor.name)}`;
        return this.receiver[hasMethodName];
    }
}
class $a7248a23ab27f746$var$TargetObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
    }
    start() {
        if (!this.tokenListObserver) {
            this.tokenListObserver = new $a7248a23ab27f746$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
            this.tokenListObserver.start();
        }
    }
    stop() {
        if (this.tokenListObserver) {
            this.disconnectAllTargets();
            this.tokenListObserver.stop();
            delete this.tokenListObserver;
        }
    }
    tokenMatched({ element: element, content: name }) {
        if (this.scope.containsElement(element)) this.connectTarget(element, name);
    }
    tokenUnmatched({ element: element, content: name }) {
        this.disconnectTarget(element, name);
    }
    connectTarget(element, name) {
        var _a;
        if (!this.targetsByName.has(name, element)) {
            this.targetsByName.add(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetConnected(element, name));
        }
    }
    disconnectTarget(element, name) {
        var _a;
        if (this.targetsByName.has(name, element)) {
            this.targetsByName.delete(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetDisconnected(element, name));
        }
    }
    disconnectAllTargets() {
        for (const name of this.targetsByName.keys)for (const element of this.targetsByName.getValuesForKey(name))this.disconnectTarget(element, name);
    }
    get attributeName() {
        return `data-${this.context.identifier}-target`;
    }
    get element() {
        return this.context.element;
    }
    get scope() {
        return this.context.scope;
    }
}
function $a7248a23ab27f746$var$readInheritableStaticArrayValues(constructor, propertyName) {
    const ancestors = $a7248a23ab27f746$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce((values, constructor)=>{
        $a7248a23ab27f746$var$getOwnStaticArrayValues(constructor, propertyName).forEach((name)=>values.add(name));
        return values;
    }, new Set()));
}
function $a7248a23ab27f746$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    const ancestors = $a7248a23ab27f746$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce((pairs, constructor)=>{
        pairs.push(...$a7248a23ab27f746$var$getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function $a7248a23ab27f746$var$getAncestorsForConstructor(constructor) {
    const ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $a7248a23ab27f746$var$getOwnStaticArrayValues(constructor, propertyName) {
    const definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $a7248a23ab27f746$var$getOwnStaticObjectPairs(constructor, propertyName) {
    const definition = constructor[propertyName];
    return definition ? Object.keys(definition).map((key)=>[
            key,
            definition[key]
        ]) : [];
}
class $a7248a23ab27f746$var$OutletObserver {
    constructor(context, delegate){
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    start() {
        if (!this.started) {
            this.outletDefinitions.forEach((outletName)=>{
                this.setupSelectorObserverForOutlet(outletName);
                this.setupAttributeObserverForOutlet(outletName);
            });
            this.started = true;
            this.dependentContexts.forEach((context)=>context.refresh());
        }
    }
    refresh() {
        this.selectorObserverMap.forEach((observer)=>observer.refresh());
        this.attributeObserverMap.forEach((observer)=>observer.refresh());
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.disconnectAllOutlets();
            this.stopSelectorObservers();
            this.stopAttributeObservers();
        }
    }
    stopSelectorObservers() {
        if (this.selectorObserverMap.size > 0) {
            this.selectorObserverMap.forEach((observer)=>observer.stop());
            this.selectorObserverMap.clear();
        }
    }
    stopAttributeObservers() {
        if (this.attributeObserverMap.size > 0) {
            this.attributeObserverMap.forEach((observer)=>observer.stop());
            this.attributeObserverMap.clear();
        }
    }
    selectorMatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutlet(element, outletName);
        if (outlet) this.connectOutlet(outlet, element, outletName);
    }
    selectorUnmatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutletFromMap(element, outletName);
        if (outlet) this.disconnectOutlet(outlet, element, outletName);
    }
    selectorMatchElement(element, { outletName: outletName }) {
        const selector = this.selector(outletName);
        const hasOutlet = this.hasOutlet(element, outletName);
        const hasOutletController = element.matches(`[${this.schema.controllerAttribute}~=${outletName}]`);
        if (selector) return hasOutlet && hasOutletController && element.matches(selector);
        else return false;
    }
    elementMatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementAttributeValueChanged(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementUnmatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    connectOutlet(outlet, element, outletName) {
        var _a;
        if (!this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.add(outletName, outlet);
            this.outletElementsByName.add(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletConnected(outlet, element, outletName));
        }
    }
    disconnectOutlet(outlet, element, outletName) {
        var _a;
        if (this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.delete(outletName, outlet);
            this.outletElementsByName.delete(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletDisconnected(outlet, element, outletName));
        }
    }
    disconnectAllOutlets() {
        for (const outletName of this.outletElementsByName.keys){
            for (const element of this.outletElementsByName.getValuesForKey(outletName))for (const outlet of this.outletsByName.getValuesForKey(outletName))this.disconnectOutlet(outlet, element, outletName);
        }
    }
    updateSelectorObserverForOutlet(outletName) {
        const observer = this.selectorObserverMap.get(outletName);
        if (observer) observer.selector = this.selector(outletName);
    }
    setupSelectorObserverForOutlet(outletName) {
        const selector = this.selector(outletName);
        const selectorObserver = new $a7248a23ab27f746$export$116e0b48509995b(document.body, selector, this, {
            outletName: outletName
        });
        this.selectorObserverMap.set(outletName, selectorObserver);
        selectorObserver.start();
    }
    setupAttributeObserverForOutlet(outletName) {
        const attributeName = this.attributeNameForOutletName(outletName);
        const attributeObserver = new $a7248a23ab27f746$export$fe68319d413d05cb(this.scope.element, attributeName, this);
        this.attributeObserverMap.set(outletName, attributeObserver);
        attributeObserver.start();
    }
    selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
    }
    attributeNameForOutletName(outletName) {
        return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
    }
    getOutletNameFromOutletAttributeName(attributeName) {
        return this.outletDefinitions.find((outletName)=>this.attributeNameForOutletName(outletName) === attributeName);
    }
    get outletDependencies() {
        const dependencies = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
        this.router.modules.forEach((module)=>{
            const constructor = module.definition.controllerConstructor;
            const outlets = $a7248a23ab27f746$var$readInheritableStaticArrayValues(constructor, "outlets");
            outlets.forEach((outlet)=>dependencies.add(outlet, module.identifier));
        });
        return dependencies;
    }
    get outletDefinitions() {
        return this.outletDependencies.getKeysForValue(this.identifier);
    }
    get dependentControllerIdentifiers() {
        return this.outletDependencies.getValuesForKey(this.identifier);
    }
    get dependentContexts() {
        const identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter((context)=>identifiers.includes(context.identifier));
    }
    hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
    }
    getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
    }
    getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find((outlet)=>outlet.element === element);
    }
    get scope() {
        return this.context.scope;
    }
    get schema() {
        return this.context.schema;
    }
    get identifier() {
        return this.context.identifier;
    }
    get application() {
        return this.context.application;
    }
    get router() {
        return this.application.router;
    }
}
class $a7248a23ab27f746$export$841858b892ce1f4c {
    constructor(module, scope){
        this.logDebugActivity = (functionName, detail = {})=>{
            const { identifier: identifier, controller: controller, element: element } = this;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            this.application.logDebugActivity(this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $a7248a23ab27f746$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $a7248a23ab27f746$var$ValueObserver(this, this.controller);
        this.targetObserver = new $a7248a23ab27f746$var$TargetObserver(this, this);
        this.outletObserver = new $a7248a23ab27f746$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();
        try {
            this.controller.connect();
            this.logDebugActivity("connect");
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    }
    refresh() {
        this.outletObserver.refresh();
    }
    disconnect() {
        try {
            this.controller.disconnect();
            this.logDebugActivity("disconnect");
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
    }
    get application() {
        return this.module.application;
    }
    get identifier() {
        return this.module.identifier;
    }
    get schema() {
        return this.application.schema;
    }
    get dispatcher() {
        return this.application.dispatcher;
    }
    get element() {
        return this.scope.element;
    }
    get parentElement() {
        return this.element.parentElement;
    }
    handleError(error, message, detail = {}) {
        const { identifier: identifier, controller: controller, element: element } = this;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, `Error ${message}`, detail);
    }
    targetConnected(element, name) {
        this.invokeControllerMethod(`${name}TargetConnected`, element);
    }
    targetDisconnected(element, name) {
        this.invokeControllerMethod(`${name}TargetDisconnected`, element);
    }
    outletConnected(outlet, element, name) {
        this.invokeControllerMethod(`${$a7248a23ab27f746$var$namespaceCamelize(name)}OutletConnected`, outlet, element);
    }
    outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod(`${$a7248a23ab27f746$var$namespaceCamelize(name)}OutletDisconnected`, outlet, element);
    }
    invokeControllerMethod(methodName, ...args) {
        const controller = this.controller;
        if (typeof controller[methodName] == "function") controller[methodName](...args);
    }
}
function $a7248a23ab27f746$var$bless(constructor) {
    return $a7248a23ab27f746$var$shadow(constructor, $a7248a23ab27f746$var$getBlessedProperties(constructor));
}
function $a7248a23ab27f746$var$shadow(constructor, properties) {
    const shadowConstructor = $a7248a23ab27f746$var$extend(constructor);
    const shadowProperties = $a7248a23ab27f746$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $a7248a23ab27f746$var$getBlessedProperties(constructor) {
    const blessings = $a7248a23ab27f746$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce((blessedProperties, blessing)=>{
        const properties = blessing(constructor);
        for(const key in properties){
            const descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $a7248a23ab27f746$var$getShadowProperties(prototype, properties) {
    return $a7248a23ab27f746$var$getOwnKeys(properties).reduce((shadowProperties, key)=>{
        const descriptor = $a7248a23ab27f746$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, {
            [key]: descriptor
        });
        return shadowProperties;
    }, {});
}
function $a7248a23ab27f746$var$getShadowedDescriptor(prototype, properties, key) {
    const shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    const shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        const descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
const $a7248a23ab27f746$var$getOwnKeys = (()=>{
    if (typeof Object.getOwnPropertySymbols == "function") return (object)=>[
            ...Object.getOwnPropertyNames(object),
            ...Object.getOwnPropertySymbols(object)
        ];
    else return Object.getOwnPropertyNames;
})();
const $a7248a23ab27f746$var$extend = (()=>{
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, new.target);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        const a = function() {
            this.a.call(this);
        };
        const b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return (constructor)=>class extended extends constructor {
            };
    }
})();
function $a7248a23ab27f746$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $a7248a23ab27f746$var$bless(definition.controllerConstructor)
    };
}
class $a7248a23ab27f746$var$Module {
    constructor(application, definition){
        this.application = application;
        this.definition = $a7248a23ab27f746$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    get identifier() {
        return this.definition.identifier;
    }
    get controllerConstructor() {
        return this.definition.controllerConstructor;
    }
    get contexts() {
        return Array.from(this.connectedContexts);
    }
    connectContextForScope(scope) {
        const context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    }
    disconnectContextForScope(scope) {
        const context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    }
    fetchContextForScope(scope) {
        let context = this.contextsByScope.get(scope);
        if (!context) {
            context = new $a7248a23ab27f746$export$841858b892ce1f4c(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    }
}
class $a7248a23ab27f746$var$ClassMap {
    constructor(scope){
        this.scope = scope;
    }
    has(name) {
        return this.data.has(this.getDataKey(name));
    }
    get(name) {
        return this.getAll(name)[0];
    }
    getAll(name) {
        const tokenString = this.data.get(this.getDataKey(name)) || "";
        return $a7248a23ab27f746$var$tokenize(tokenString);
    }
    getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    }
    getDataKey(name) {
        return `${name}-class`;
    }
    get data() {
        return this.scope.data;
    }
}
class $a7248a23ab27f746$var$DataMap {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    }
    set(key, value) {
        const name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    }
    has(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    }
    delete(key) {
        if (this.has(key)) {
            const name = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name);
            return true;
        } else return false;
    }
    getAttributeNameForKey(key) {
        return `data-${this.identifier}-${$a7248a23ab27f746$var$dasherize(key)}`;
    }
}
class $a7248a23ab27f746$var$Guide {
    constructor(logger){
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    warn(object, key, message) {
        let warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set();
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    }
}
function $a7248a23ab27f746$var$attributeValueContainsToken(attributeName, token) {
    return `[${attributeName}~="${token}"]`;
}
class $a7248a23ab27f746$var$TargetSet {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(targetName) {
        return this.find(targetName) != null;
    }
    find(...targetNames) {
        return targetNames.reduce((target, targetName)=>target || this.findTarget(targetName) || this.findLegacyTarget(targetName), undefined);
    }
    findAll(...targetNames) {
        return targetNames.reduce((targets, targetName)=>[
                ...targets,
                ...this.findAllTargets(targetName),
                ...this.findAllLegacyTargets(targetName)
            ], []);
    }
    findTarget(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    }
    findAllTargets(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    }
    getSelectorForTargetName(targetName) {
        const attributeName = this.schema.targetAttributeForScope(this.identifier);
        return $a7248a23ab27f746$var$attributeValueContainsToken(attributeName, targetName);
    }
    findLegacyTarget(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    }
    findAllLegacyTargets(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map((element)=>this.deprecate(element, targetName));
    }
    getLegacySelectorForTargetName(targetName) {
        const targetDescriptor = `${this.identifier}.${targetName}`;
        return $a7248a23ab27f746$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
    }
    deprecate(element, targetName) {
        if (element) {
            const { identifier: identifier } = this;
            const attributeName = this.schema.targetAttribute;
            const revisedAttributeName = this.schema.targetAttributeForScope(identifier);
            this.guide.warn(element, `target:${targetName}`, `Please replace ${attributeName}="${identifier}.${targetName}" with ${revisedAttributeName}="${targetName}". ` + `The ${attributeName} attribute is deprecated and will be removed in a future version of Stimulus.`);
        }
        return element;
    }
    get guide() {
        return this.scope.guide;
    }
}
class $a7248a23ab27f746$var$OutletSet {
    constructor(scope, controllerElement){
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(outletName) {
        return this.find(outletName) != null;
    }
    find(...outletNames) {
        return outletNames.reduce((outlet, outletName)=>outlet || this.findOutlet(outletName), undefined);
    }
    findAll(...outletNames) {
        return outletNames.reduce((outlets, outletName)=>[
                ...outlets,
                ...this.findAllOutlets(outletName)
            ], []);
    }
    getSelectorForOutletName(outletName) {
        const attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
    }
    findOutlet(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
    }
    findAllOutlets(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
    }
    findElement(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName))[0];
    }
    findAllElements(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName));
    }
    matchesElement(element, selector, outletName) {
        const controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
    }
}
class $a7248a23ab27f746$var$Scope {
    constructor(schema, element, identifier, logger){
        this.targets = new $a7248a23ab27f746$var$TargetSet(this);
        this.classes = new $a7248a23ab27f746$var$ClassMap(this);
        this.data = new $a7248a23ab27f746$var$DataMap(this);
        this.containsElement = (element)=>{
            return element.closest(this.controllerSelector) === this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $a7248a23ab27f746$var$Guide(logger);
        this.outlets = new $a7248a23ab27f746$var$OutletSet(this.documentScope, element);
    }
    findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    }
    findAllElements(selector) {
        return [
            ...this.element.matches(selector) ? [
                this.element
            ] : [],
            ...this.queryElements(selector).filter(this.containsElement)
        ];
    }
    queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
    get controllerSelector() {
        return $a7248a23ab27f746$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    }
    get isDocumentScope() {
        return this.element === document.documentElement;
    }
    get documentScope() {
        return this.isDocumentScope ? this : new $a7248a23ab27f746$var$Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
    }
}
class $a7248a23ab27f746$var$ScopeObserver {
    constructor(element, schema, delegate){
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $a7248a23ab27f746$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    start() {
        this.valueListObserver.start();
    }
    stop() {
        this.valueListObserver.stop();
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    parseValueForToken(token) {
        const { element: element, content: identifier } = token;
        return this.parseValueForElementAndIdentifier(element, identifier);
    }
    parseValueForElementAndIdentifier(element, identifier) {
        const scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        let scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    }
    elementMatchedValue(element, value) {
        const referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    }
    elementUnmatchedValue(element, value) {
        const referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    }
    fetchScopesByIdentifierForElement(element) {
        let scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map();
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    }
}
class $a7248a23ab27f746$var$Router {
    constructor(application){
        this.application = application;
        this.scopeObserver = new $a7248a23ab27f746$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $a7248a23ab27f746$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    get element() {
        return this.application.element;
    }
    get schema() {
        return this.application.schema;
    }
    get logger() {
        return this.application.logger;
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    get modules() {
        return Array.from(this.modulesByIdentifier.values());
    }
    get contexts() {
        return this.modules.reduce((contexts, module)=>contexts.concat(module.contexts), []);
    }
    start() {
        this.scopeObserver.start();
    }
    stop() {
        this.scopeObserver.stop();
    }
    loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        const module = new $a7248a23ab27f746$var$Module(this.application, definition);
        this.connectModule(module);
        const afterLoad = definition.controllerConstructor.afterLoad;
        if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
    }
    unloadIdentifier(identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    }
    getContextForElementAndIdentifier(element, identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find((context)=>context.element == element);
    }
    proposeToConnectScopeForElementAndIdentifier(element, identifier) {
        const scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
        if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
        else console.error(`Couldn't find or create scope for identifier: "${identifier}" and element:`, element);
    }
    handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
    }
    createScopeForElementAndIdentifier(element, identifier) {
        return new $a7248a23ab27f746$var$Scope(this.schema, element, identifier, this.logger);
    }
    scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    }
    scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    }
    connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.connectContextForScope(scope));
    }
    disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.disconnectContextForScope(scope));
    }
}
const $a7248a23ab27f746$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: (identifier)=>`data-${identifier}-target`,
    outletAttributeForScope: (identifier, outlet)=>`data-${identifier}-${outlet}-outlet`,
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $a7248a23ab27f746$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map((c)=>[
            c,
            c
        ]))), $a7248a23ab27f746$var$objectFromEntries("0123456789".split("").map((n)=>[
            n,
            n
        ])))
};
function $a7248a23ab27f746$var$objectFromEntries(array) {
    return array.reduce((memo, [k, v])=>Object.assign(Object.assign({}, memo), {
            [k]: v
        }), {});
}
class $a7248a23ab27f746$export$16975c34e60e1e61 {
    constructor(element = document.documentElement, schema = $a7248a23ab27f746$export$1db618b7b2275ea1){
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = (identifier, functionName, detail = {})=>{
            if (this.debug) this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $a7248a23ab27f746$var$Dispatcher(this);
        this.router = new $a7248a23ab27f746$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $a7248a23ab27f746$var$defaultActionDescriptorFilters);
    }
    static start(element, schema) {
        const application = new this(element, schema);
        application.start();
        return application;
    }
    async start() {
        await $a7248a23ab27f746$var$domReady();
        this.logDebugActivity("application", "starting");
        this.dispatcher.start();
        this.router.start();
        this.logDebugActivity("application", "start");
    }
    stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
    }
    register(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    }
    registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
    }
    load(head, ...rest) {
        const definitions = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        definitions.forEach((definition)=>{
            if (definition.controllerConstructor.shouldLoad) this.router.loadDefinition(definition);
        });
    }
    unload(head, ...rest) {
        const identifiers = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        identifiers.forEach((identifier)=>this.router.unloadIdentifier(identifier));
    }
    get controllers() {
        return this.router.contexts.map((context)=>context.controller);
    }
    getControllerForElementAndIdentifier(element, identifier) {
        const context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    }
    handleError(error, message, detail) {
        var _a;
        this.logger.error(`%s\n\n%o\n\n%o`, message, error, detail);
        (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
    }
    logFormattedMessage(identifier, functionName, detail = {}) {
        detail = Object.assign({
            application: this
        }, detail);
        this.logger.groupCollapsed(`${identifier} #${functionName}`);
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
    }
}
function $a7248a23ab27f746$var$domReady() {
    return new Promise((resolve)=>{
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", ()=>resolve());
        else resolve();
    });
}
function $a7248a23ab27f746$var$ClassPropertiesBlessing(constructor) {
    const classes = $a7248a23ab27f746$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce((properties, classDefinition)=>{
        return Object.assign(properties, $a7248a23ab27f746$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $a7248a23ab27f746$var$propertiesForClassDefinition(key) {
    return {
        [`${key}Class`]: {
            get () {
                const { classes: classes } = this;
                if (classes.has(key)) return classes.get(key);
                else {
                    const attribute = classes.getAttributeName(key);
                    throw new Error(`Missing attribute "${attribute}"`);
                }
            }
        },
        [`${key}Classes`]: {
            get () {
                return this.classes.getAll(key);
            }
        },
        [`has${$a7248a23ab27f746$var$capitalize(key)}Class`]: {
            get () {
                return this.classes.has(key);
            }
        }
    };
}
function $a7248a23ab27f746$var$OutletPropertiesBlessing(constructor) {
    const outlets = $a7248a23ab27f746$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce((properties, outletDefinition)=>{
        return Object.assign(properties, $a7248a23ab27f746$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $a7248a23ab27f746$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $a7248a23ab27f746$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    let outletController = $a7248a23ab27f746$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $a7248a23ab27f746$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $a7248a23ab27f746$var$propertiesForOutletDefinition(name) {
    const camelizedName = $a7248a23ab27f746$var$namespaceCamelize(name);
    return {
        [`${camelizedName}Outlet`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) {
                    const outletController = $a7248a23ab27f746$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    throw new Error(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`);
                }
                throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}Outlets`]: {
            get () {
                const outlets = this.outlets.findAll(name);
                if (outlets.length > 0) return outlets.map((outletElement)=>{
                    const outletController = $a7248a23ab27f746$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    console.warn(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`, outletElement);
                }).filter((controller)=>controller);
                return [];
            }
        },
        [`${camelizedName}OutletElement`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) return outletElement;
                else throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}OutletElements`]: {
            get () {
                return this.outlets.findAll(name);
            }
        },
        [`has${$a7248a23ab27f746$var$capitalize(camelizedName)}Outlet`]: {
            get () {
                return this.outlets.has(name);
            }
        }
    };
}
function $a7248a23ab27f746$var$TargetPropertiesBlessing(constructor) {
    const targets = $a7248a23ab27f746$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce((properties, targetDefinition)=>{
        return Object.assign(properties, $a7248a23ab27f746$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $a7248a23ab27f746$var$propertiesForTargetDefinition(name) {
    return {
        [`${name}Target`]: {
            get () {
                const target = this.targets.find(name);
                if (target) return target;
                else throw new Error(`Missing target element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${name}Targets`]: {
            get () {
                return this.targets.findAll(name);
            }
        },
        [`has${$a7248a23ab27f746$var$capitalize(name)}Target`]: {
            get () {
                return this.targets.has(name);
            }
        }
    };
}
function $a7248a23ab27f746$var$ValuePropertiesBlessing(constructor) {
    const valueDefinitionPairs = $a7248a23ab27f746$var$readInheritableStaticObjectPairs(constructor, "values");
    const propertyDescriptorMap = {
        valueDescriptorMap: {
            get () {
                return valueDefinitionPairs.reduce((result, valueDefinitionPair)=>{
                    const valueDescriptor = $a7248a23ab27f746$var$parseValueDefinitionPair(valueDefinitionPair, this.identifier);
                    const attributeName = this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, {
                        [attributeName]: valueDescriptor
                    });
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce((properties, valueDefinitionPair)=>{
        return Object.assign(properties, $a7248a23ab27f746$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $a7248a23ab27f746$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    const definition = $a7248a23ab27f746$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    const { key: key, name: name, reader: read, writer: write } = definition;
    return {
        [name]: {
            get () {
                const value = this.data.get(key);
                if (value !== null) return read(value);
                else return definition.defaultValue;
            },
            set (value) {
                if (value === undefined) this.data.delete(key);
                else this.data.set(key, write(value));
            }
        },
        [`has${$a7248a23ab27f746$var$capitalize(name)}`]: {
            get () {
                return this.data.has(key) || definition.hasCustomDefaultValue;
            }
        }
    };
}
function $a7248a23ab27f746$var$parseValueDefinitionPair([token, typeDefinition], controller) {
    return $a7248a23ab27f746$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $a7248a23ab27f746$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $a7248a23ab27f746$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $a7248a23ab27f746$var$parseValueTypeObject(payload) {
    const { controller: controller, token: token, typeObject: typeObject } = payload;
    const hasType = $a7248a23ab27f746$var$isSomething(typeObject.type);
    const hasDefault = $a7248a23ab27f746$var$isSomething(typeObject.default);
    const fullObject = hasType && hasDefault;
    const onlyType = hasType && !hasDefault;
    const onlyDefault = !hasType && hasDefault;
    const typeFromObject = $a7248a23ab27f746$var$parseValueTypeConstant(typeObject.type);
    const typeFromDefaultValue = $a7248a23ab27f746$var$parseValueTypeDefault(payload.typeObject.default);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        const propertyPath = controller ? `${controller}.${token}` : token;
        throw new Error(`The specified default value for the Stimulus Value "${propertyPath}" must match the defined type "${typeFromObject}". The provided default value of "${typeObject.default}" is of type "${typeFromDefaultValue}".`);
    }
    if (fullObject) return typeFromObject;
}
function $a7248a23ab27f746$var$parseValueTypeDefinition(payload) {
    const { controller: controller, token: token, typeDefinition: typeDefinition } = payload;
    const typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    const typeFromObject = $a7248a23ab27f746$var$parseValueTypeObject(typeObject);
    const typeFromDefaultValue = $a7248a23ab27f746$var$parseValueTypeDefault(typeDefinition);
    const typeFromConstant = $a7248a23ab27f746$var$parseValueTypeConstant(typeDefinition);
    const type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    const propertyPath = controller ? `${controller}.${typeDefinition}` : token;
    throw new Error(`Unknown value type "${propertyPath}" for "${token}" value`);
}
function $a7248a23ab27f746$var$defaultValueForDefinition(typeDefinition) {
    const constant = $a7248a23ab27f746$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $a7248a23ab27f746$var$defaultValuesByType[constant];
    const hasDefault = $a7248a23ab27f746$var$hasProperty(typeDefinition, "default");
    const hasType = $a7248a23ab27f746$var$hasProperty(typeDefinition, "type");
    const typeObject = typeDefinition;
    if (hasDefault) return typeObject.default;
    if (hasType) {
        const { type: type } = typeObject;
        const constantFromType = $a7248a23ab27f746$var$parseValueTypeConstant(type);
        if (constantFromType) return $a7248a23ab27f746$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $a7248a23ab27f746$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    const { token: token, typeDefinition: typeDefinition } = payload;
    const key = `${$a7248a23ab27f746$var$dasherize(token)}-value`;
    const type = $a7248a23ab27f746$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $a7248a23ab27f746$var$camelize(key),
        get defaultValue () {
            return $a7248a23ab27f746$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $a7248a23ab27f746$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $a7248a23ab27f746$var$readers[type],
        writer: $a7248a23ab27f746$var$writers[type] || $a7248a23ab27f746$var$writers.default
    };
}
const $a7248a23ab27f746$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
const $a7248a23ab27f746$var$readers = {
    array (value) {
        const array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError(`expected value of type "array" but instead got value "${value}" of type "${$a7248a23ab27f746$var$parseValueTypeDefault(array)}"`);
        return array;
    },
    boolean (value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number (value) {
        return Number(value.replace(/_/g, ""));
    },
    object (value) {
        const object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError(`expected value of type "object" but instead got value "${value}" of type "${$a7248a23ab27f746$var$parseValueTypeDefault(object)}"`);
        return object;
    },
    string (value) {
        return value;
    }
};
const $a7248a23ab27f746$var$writers = {
    default: $a7248a23ab27f746$var$writeString,
    array: $a7248a23ab27f746$var$writeJSON,
    object: $a7248a23ab27f746$var$writeJSON
};
function $a7248a23ab27f746$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $a7248a23ab27f746$var$writeString(value) {
    return `${value}`;
}
class $a7248a23ab27f746$export$bd0bf19f25da8474 {
    constructor(context){
        this.context = context;
    }
    static get shouldLoad() {
        return true;
    }
    static afterLoad(_identifier, _application) {
        return;
    }
    get application() {
        return this.context.application;
    }
    get scope() {
        return this.context.scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get targets() {
        return this.scope.targets;
    }
    get outlets() {
        return this.scope.outlets;
    }
    get classes() {
        return this.scope.classes;
    }
    get data() {
        return this.scope.data;
    }
    initialize() {}
    connect() {}
    disconnect() {}
    dispatch(eventName, { target: target = this.element, detail: detail = {}, prefix: prefix = this.identifier, bubbles: bubbles = true, cancelable: cancelable = true } = {}) {
        const type = prefix ? `${prefix}:${eventName}` : eventName;
        const event = new CustomEvent(type, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
    }
}
$a7248a23ab27f746$export$bd0bf19f25da8474.blessings = [
    $a7248a23ab27f746$var$ClassPropertiesBlessing,
    $a7248a23ab27f746$var$TargetPropertiesBlessing,
    $a7248a23ab27f746$var$ValuePropertiesBlessing,
    $a7248a23ab27f746$var$OutletPropertiesBlessing
];
$a7248a23ab27f746$export$bd0bf19f25da8474.targets = [];
$a7248a23ab27f746$export$bd0bf19f25da8474.outlets = [];
$a7248a23ab27f746$export$bd0bf19f25da8474.values = {};


// debugUtils.js
function $df5856b8963e2c0f$export$140d7860bc6d1e6e(...args) {
    console.log(...args);
}
function $df5856b8963e2c0f$export$280f90b954565303(...args) {
    console.error(...args);
}


// Updates the static order-summary panel (left side / mobile bar) to reflect a
// just-resolved fast-track network + amount. Called from each fast-track step
// controller on connect so the user sees the auto-selected network everywhere.
//
// BlockchainProgressController.connect() also reads `#checkout_payment_method`'s
// text content to populate the post-payment Network field, so this also has the
// side-effect of fixing the otherwise-empty Network column on the success view.
function $232ee993f4f32bc5$export$ab11b11b7f1fcc6b({ networkName: networkName, amountDisplay: amountDisplay } = {}) {
    const trimmedAmount = (amountDisplay || "").trim();
    const amountWithCurrency = trimmedAmount ? `${trimmedAmount} USD` : "";
    const trimmedNetwork = (networkName || "").trim();
    const checkoutTotalAmount = document.getElementById("checkout_total_amount");
    if (checkoutTotalAmount && amountWithCurrency) checkoutTotalAmount.textContent = amountWithCurrency;
    const checkoutPriceMobile = document.getElementById("checkout_price_mobile");
    if (checkoutPriceMobile && amountWithCurrency) checkoutPriceMobile.textContent = amountWithCurrency;
    const checkoutPaymentMethod = document.getElementById("checkout_payment_method");
    if (checkoutPaymentMethod && trimmedNetwork) checkoutPaymentMethod.textContent = `${trimmedNetwork} / USD`;
}


function $bd5e7d73d15230a4$export$4e80b7f9eaacb389() {
    return window.location.host.includes("coinsub.io");
}
function $bd5e7d73d15230a4$export$ccf64f7f116a94f(seconds) {
    if (!seconds || seconds < 0 || typeof seconds !== 'number') return "0:00";
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec.toString().padStart(2, '0')}`;
}



const $6278b20997bc647a$export$ddcffe0146c8f882 = {
    CODE: "code",
    COMPANY_NAME: "companyname",
    DOMAIN: "domain",
    SESSION: "session",
    /** Direct transfer flow: chosen asset for direct deposit screen (set on payment-options) */ DIRECT_TRANSFER_SYMBOL: "directTransferSymbol",
    DIRECT_TRANSFER_NETWORK: "directTransferNetwork",
    DIRECT_TRANSFER_ICON: "directTransferIcon",
    /** EVM chain ID from direct_deposit_networks.chain_id (Solana uses DB value) */ DIRECT_TRANSFER_CHAIN_ID: "directTransferChainId",
    /** One-time display payload for insufficient direct deposit result page */ DIRECT_DEPOSIT_INSUFFICIENT_RESULT: "directDepositInsufficientResult",
    /** Client Back/restore guard: "false" | "already_paid" | "payment_failed" */ SESSION_COMPLETED: "sessionCompleted",
    /** Source step to return to from third-party payment options */ THIRD_PARTY_BACK_TARGET: "thirdPartyBackTarget",
    /** Flag set when Turbo performs browser history restoration */ TURBO_RESTORE_PENDING: "turboRestorePending",
    /** One-time guard to avoid reload loops on restore */ TURBO_RESTORE_RELOADED: "turboRestoreReloaded",
    /** DirectDeposit Explorer URL */ DIRECT_DEPOSIT_EXPLORER_URL: "directDepositExplorerURL",
    /** WM funnel: first timestamp (ms) for time_in_wm_ms Statsig metadata */ WM_FUNNEL_START_MS: "wmFunnelStartMs",
    /** WM funnel: last wallet balance (USD) after waas_funded — used to derive purchase increment */ WM_LAST_BALANCE_USD: "wmLastBalanceUsd"
};


class $9089923ccb187870$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "firstName",
        "lastName",
        "email",
        "validationResult",
        "connectWalletBtn"
    ];
    static values = {
        code: String,
        session: String
    };
    connect() {
        this.hideLoadingScreen();
        // Necessary to read from session storage
        // Because values cannot be read from X-Headers
        this.codeValue = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
        // Server-side prefill (personal-info skip back-navigation) must enable
        // the Continue button without requiring a keystroke.
        this.checkValidation();
    }
    validateName(field, nameString) {
        if (nameString.length === 0) return false;
        // Check if all characters are letters.
        const characters = nameString.trim();
        // Check if characters are not numbers or special characters.
        const charactersAreValid = /^[\p{L} ]+$/u.test(characters);
        if (!charactersAreValid) return `Invalid character(s) in ${field}.`;
        return true;
    }
    validateEmail(email) {
        if (email.length === 0) return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email) ? true : "Please enter a valid email address.";
    }
    createValidationFeedbackBullet(string) {
        const bullet = document.createElement("li");
        bullet.textContent = string;
        return bullet;
    }
    checkValidation() {
        // Clear earlier validation feedback;
        this.validationResultTarget.innerHTML = "";
        const firstNameValidation = this.validateName("First Name", this.firstNameTarget.value);
        const lastNameValidation = this.validateName("Last Name", this.lastNameTarget.value);
        const emailValidation = this.validateEmail(this.emailTarget.value);
        const validationIsSuccessful = firstNameValidation === true && lastNameValidation === true && emailValidation === true;
        this.connectWalletBtnTarget.classList.toggle("is-disabled", !validationIsSuccessful);
        if (!validationIsSuccessful) {
            if (typeof firstNameValidation === "string") this.validationResultTarget.appendChild(this.createValidationFeedbackBullet(firstNameValidation));
            if (typeof lastNameValidation === "string") this.validationResultTarget.appendChild(this.createValidationFeedbackBullet(lastNameValidation));
            if (typeof emailValidation === "string") this.validationResultTarget.appendChild(this.createValidationFeedbackBullet(emailValidation));
        }
    }
    async connectButtonHandler(_) {
        this.showLoadingScreen();
        const form = document.getElementById("frame-post-form");
        form.action = `/${this.codeValue}/payment-options?session=${this.sessionValue}`;
        form.requestSubmit();
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}



function $f154d6de68471e5b$export$79fb1ec4128903c9() {
    const origin = typeof window !== "undefined" && window.location ? window.location.origin : "";
    try {
        if (typeof navigator === "undefined") return {
            origin: origin,
            isMobile: false,
            platform: "Unknown",
            browser: "Unknown"
        };
        let browser = "Unknown";
        let platform = "Unknown";
        let isMobile = false;
        if (navigator.userAgentData) {
            const uaData = navigator.userAgentData;
            platform = uaData.platform || "Unknown";
            isMobile = uaData.mobile || false;
            const brandEntries = Array.isArray(uaData.brands) ? uaData.brands.filter((b)=>b.brand !== "Not)A;Brand") : [];
            const lastBrand = brandEntries[brandEntries.length - 1];
            browser = lastBrand ? `${lastBrand.brand} ${lastBrand.version}` : "Unknown";
        } else if (navigator.userAgent) {
            const ua = navigator.userAgent;
            const browserMatchers = [
                {
                    regex: /Chrome\/(\d+)/,
                    name: "Chrome"
                },
                {
                    regex: /Safari\/(\d+)/,
                    name: "Safari"
                },
                {
                    regex: /Firefox\/(\d+)/,
                    name: "Firefox"
                },
                {
                    regex: /Edg\/(\d+)/,
                    name: "Edge"
                }
            ];
            for (const { regex: regex, name: name } of browserMatchers){
                const match = ua.match(regex);
                if (match) {
                    browser = `${name} ${match[1]}`;
                    break;
                }
            }
            if (/Android/i.test(ua)) {
                platform = "Android";
                isMobile = true;
            } else if (/iPhone|iPad|iPod/i.test(ua)) {
                platform = "iOS";
                isMobile = true;
            } else if (/Mac OS X/i.test(ua)) platform = "macOS";
            else if (/Windows/i.test(ua)) platform = "Windows";
        }
        return {
            origin: origin,
            isMobile: isMobile,
            platform: platform,
            browser: browser
        };
    } catch (error) {
        return {
            origin: origin,
            isMobile: false,
            platform: "Unknown",
            browser: "Unknown"
        };
    }
}



/**
 * otpInputDigits reads what an `input` event left in one OTP box.
 *  - code:  a full code arrived in a single box (one-time-code autofill puts the whole
 *           code into the focused box), to be spread across every box like a paste
 *  - digit: the single digit the box should keep ("" to clear it)
 */ function $7b3b0ce3448947ed$export$26e21f446c8be20f(value, boxCount) {
    const digits = String(value ?? "").replace(/\D/g, "");
    if (digits.length >= boxCount) return {
        code: digits.slice(0, boxCount),
        digit: ""
    };
    return {
        code: "",
        digit: digits.slice(-1)
    };
}


class $bb3e1c8304151088$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "password",
        "timer",
        "expirationCounter",
        "resendButton",
        "invalidPasswordError",
        "internalServerError"
    ];
    static values = {
        code: String,
        session: String,
        email: String,
        maskedEmail: String,
        resendIntervalInSeconds: {
            type: Number,
            default: 60
        },
        /**
     * Where to POST the OTP form:
     * - "verify-otp" → POST /verify-otp/ (DFNS / Coinsub wallet email verification — handleOTPVerification)
     * - otherwise → POST /:code/{value}?session=… (e.g. fast-track-otp-verification, not-enough-crypto-otp-verification)
     */ verificationEndpoint: {
            type: String,
            default: "verify-otp"
        },
        /** fast-track: resend via verify-otp/resend. not-enough-crypto: reload OTP page to resend email. */ resendMode: {
            type: String,
            default: "fast-track"
        }
    };
    connect() {
        document.getElementById("email_holder").textContent = this.maskedEmailValue;
        this.startResendOTPCountdown();
        this.hideLoadingScreen();
    }
    startResendOTPCountdown() {
        let remainingSeconds = this.resendIntervalInSecondsValue;
        if (this.timerInterval) clearInterval(this.timerInterval);
        this.expirationCounterTarget.style.display = "inline";
        this.resendButtonTarget.disabled = true;
        this.resendButtonTarget.textContent = "";
        // Update the timer immediately
        this.timerTarget.textContent = (0, $bd5e7d73d15230a4$export$ccf64f7f116a94f)(remainingSeconds);
        this.timerInterval = setInterval(()=>{
            remainingSeconds -= 1;
            this.timerTarget.textContent = (0, $bd5e7d73d15230a4$export$ccf64f7f116a94f)(remainingSeconds);
            if (remainingSeconds === 0) {
                clearInterval(this.timerInterval);
                this.expirationCounterTarget.style.display = "none";
                this.resendButtonTarget.disabled = false;
                this.resendButtonTarget.textContent = "Resend";
            }
        }, 1000);
    }
    async resendPassword() {
        if (this.resendModeValue === "not-enough-crypto") {
            Turbo.visit(`/${this.codeValue}/not-enough-crypto-otp?session=${encodeURIComponent(this.sessionValue)}`);
            return;
        }
        this.showLoadingScreen();
        try {
            const request = await fetch("/verify-otp/resend/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Session": this.sessionValue,
                    "X-Code": this.codeValue
                },
                body: JSON.stringify({
                    wallet_type: "DFNS"
                })
            });
            if (!request.ok) {
                // Catalog envelope (OTP-07): render the server's code-not-sent card
                // instead of collapsing to the generic auto-hide error.
                const errorBody = await request.json().catch(()=>({}));
                if (errorBody.error_html) {
                    Turbo.renderStreamMessage(errorBody.error_html);
                    return;
                }
                throw new Error(`Resend OTP failed: ${request.status}`);
            }
            await request.json();
            this.startResendOTPCountdown();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error resending OTP:", error);
            this.showInternalServerError();
        } finally{
            this.hideLoadingScreen();
        }
    }
    handlePasswordInput(passwordInput) {
        const trimmedInput = passwordInput.trim();
        const numericInput = trimmedInput.replace(/\D/g, "").slice(0, 6);
        this.handleOTPInput(numericInput);
    }
    async handleOTPInput(password) {
        this.showLoadingScreen();
        const metadata = (0, $f154d6de68471e5b$export$79fb1ec4128903c9)();
        metadata.appType = "buy";
        const jsonMetadata = JSON.stringify(metadata);
        try {
            const formData = new FormData();
            formData.append("form_email", this.emailValue);
            formData.append("form_password", password);
            formData.append("form_metadata", jsonMetadata);
            const verifyURL = this.verificationEndpointValue === "verify-otp" ? `/verify-otp/?session=${encodeURIComponent(this.sessionValue)}` : `/${this.codeValue}/${this.verificationEndpointValue}?session=${encodeURIComponent(this.sessionValue)}`;
            const response = await fetch(verifyURL, {
                method: "POST",
                headers: {
                    "X-Session": this.sessionValue,
                    "X-Code": this.codeValue,
                    "Turbo-Frame": "step_content"
                },
                body: formData,
                redirect: "follow"
            });
            if (!response.ok) {
                // Handle error response
                let errorData;
                try {
                    errorData = await response.json();
                } catch (e) {
                    errorData = {
                        error: "An error occurred"
                    };
                }
                this.hideLoadingScreen();
                if (response.status === 400) {
                    if (errorData.error_key) this.showCatalogError(errorData.title || "", errorData.message || "");
                    else {
                        (0, $df5856b8963e2c0f$export$280f90b954565303)("Unexpected error message from BE. Showing the standard error message.");
                        this.showInvalidPasswordError();
                    }
                } else this.showInternalServerError();
                return;
            }
            // Success - handle redirect or HTML response
            if (response.redirected) {
                // Backend redirected (e.g., to passkey page or payment-options)
                // Use Turbo to navigate to maintain Turbo's navigation state
                // Fast track: replace the spent OTP step in history so browser back
                // lands on the email step, same as the pay page's back arrow.
                if (this.verificationEndpointValue === "fast-track-otp-verification") Turbo.visit(response.url, {
                    action: "replace"
                });
                else Turbo.visit(response.url);
                return;
            }
            const contentType = response.headers.get("Content-Type") || "";
            if (contentType.includes("text/html")) {
                // HTML/Turbo Stream response
                const html = await response.text();
                Turbo.renderStreamMessage(html);
                this.hideLoadingScreen();
            } else {
                // JSON response
                const data = await response.json();
                if (data.type === "html" && data.data) Turbo.renderStreamMessage(data.data);
                this.hideLoadingScreen();
            }
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error in handleOTPInput:", error);
            this.hideLoadingScreen();
            this.showInternalServerError();
        }
    }
    pasteFromClipboard() {
        navigator.clipboard.readText().then((passwordInput)=>{
            // Trim whitespace and filter out non-numeric characters, then take first 6 digits
            const trimmedInput = passwordInput.trim();
            const numericInput = trimmedInput.replace(/\D/g, "").slice(0, 6);
            this.passwordTargets.forEach((passwordTarget, index)=>{
                passwordTarget.value = numericInput[index] || "";
            });
            // If we have a complete OTP, trigger verification
            if (numericInput.length === 6) this.handlePasswordInput(numericInput);
        });
    }
    handleOTPInputChange(e) {
        // A fresh attempt dismisses the persistent catalog error.
        this.invalidPasswordErrorTarget.classList.add("hidden");
        const { code: code, digit: digit } = (0, $7b3b0ce3448947ed$export$26e21f446c8be20f)(e.target.value, this.passwordTargets.length);
        if (code) {
            this.passwordTargets.forEach((passwordTarget, index)=>{
                passwordTarget.value = code[index];
            });
            this.passwordTargets[this.passwordTargets.length - 1].focus();
            this.handlePasswordInput(code);
            return;
        }
        // This will prevent any non-numeric characters.
        e.target.value = digit;
        if (!digit) return;
        // allow user to enter the next input without clicking
        if (e.target.value.length === 1) {
            if (e.target.nextElementSibling) e.target.nextElementSibling.focus();
        }
        // Check if all 6 digits are entered after any input change
        const allDigitsEntered = this.passwordTargets.every((password)=>password.value.length === 1);
        if (allDigitsEntered) {
            const passwordInput = this.passwordTargets.map((code)=>code.value).join("");
            this.handlePasswordInput(passwordInput);
        }
    }
    handleOTPInputKeyDown(e) {
        if ((e.key === "Backspace" || e.key === "Delete") && e.target.value === "") // Move focus to previous input if exists
        {
            if (e.target.previousElementSibling) e.target.previousElementSibling.focus();
        }
    }
    handleOTPInputPaste(e) {
        e.preventDefault(); // Prevent default paste behavior
        this.pasteFromClipboard();
    }
    // Renders a catalog inline-field error (title bold, body below). Unlike the
    // legacy messages this does NOT auto-hide: a lockout that vanishes after 5s
    // sends the customer back to retrying a code that cannot work. It clears
    // when the customer starts typing again.
    showCatalogError(title, message) {
        const container = this.invalidPasswordErrorTarget;
        container.textContent = "";
        if (title) {
            const titleElement = document.createElement("div");
            titleElement.className = "font-semibold";
            titleElement.textContent = title;
            container.appendChild(titleElement);
        }
        const bodyElement = document.createElement("div");
        bodyElement.textContent = message;
        container.appendChild(bodyElement);
        container.classList.remove("hidden");
        this.passwordTargets.forEach((passwordTarget)=>{
            passwordTarget.value = "";
        });
        if (this.passwordTargets.length > 0) this.passwordTargets[0].focus();
    }
    showInvalidPasswordError() {
        this.invalidPasswordErrorTarget.classList.remove("hidden");
        // Clear all OTP input fields
        this.passwordTargets.forEach((passwordTarget)=>{
            passwordTarget.value = "";
        });
        // Focus on the first input field for better UX
        if (this.passwordTargets.length > 0) this.passwordTargets[0].focus();
        setTimeout(()=>{
            this.invalidPasswordErrorTarget.classList.add("hidden");
        }, 5000);
    }
    showInternalServerError() {
        this.internalServerErrorTarget.classList.remove("hidden");
        // Clear all OTP input fields
        this.passwordTargets.forEach((passwordTarget)=>{
            passwordTarget.value = "";
        });
        // Focus on the first input field for better UX
        if (this.passwordTargets.length > 0) this.passwordTargets[0].focus();
        setTimeout(()=>{
            this.internalServerErrorTarget.classList.add("hidden");
        }, 5000);
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}



var $fb9ea7e7c6187a50$exports = {};
"use strict";
Object.defineProperty($fb9ea7e7c6187a50$exports, "__esModule", {
    value: true
});
$fb9ea7e7c6187a50$exports.WebAuthnSigner = $fb9ea7e7c6187a50$exports.BrowserKeySigner = void 0;
var $717a9eaac71e784e$exports = {};
"use strict";
Object.defineProperty($717a9eaac71e784e$exports, "__esModule", {
    value: true
});
$717a9eaac71e784e$exports.BrowserKeySigner = void 0;
var $984534081770a41b$exports = {};
"use strict";
var $984534081770a41b$var$__createBinding = $984534081770a41b$exports && $984534081770a41b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $984534081770a41b$var$__exportStar = $984534081770a41b$exports && $984534081770a41b$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $984534081770a41b$var$__createBinding(exports1, m, p);
};
Object.defineProperty($984534081770a41b$exports, "__esModule", {
    value: true
});

$984534081770a41b$var$__exportStar((parcelRequire("hU107")), $984534081770a41b$exports);

$984534081770a41b$var$__exportStar((parcelRequire("6M1yn")), $984534081770a41b$exports);

$984534081770a41b$var$__exportStar((parcelRequire("9bDGB")), $984534081770a41b$exports);

$984534081770a41b$var$__exportStar((parcelRequire("lKg8n")), $984534081770a41b$exports);

$984534081770a41b$var$__exportStar((parcelRequire("21L47")), $984534081770a41b$exports);

$984534081770a41b$var$__exportStar((parcelRequire("6sZi9")), $984534081770a41b$exports);

$984534081770a41b$var$__exportStar((parcelRequire("8wOwi")), $984534081770a41b$exports);


var $ebfc165cc3dc09d7$exports = {};
"use strict";
var $ebfc165cc3dc09d7$var$__createBinding = $ebfc165cc3dc09d7$exports && $ebfc165cc3dc09d7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ebfc165cc3dc09d7$var$__exportStar = $ebfc165cc3dc09d7$exports && $ebfc165cc3dc09d7$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ebfc165cc3dc09d7$var$__createBinding(exports1, m, p);
};
Object.defineProperty($ebfc165cc3dc09d7$exports, "__esModule", {
    value: true
});
$ebfc165cc3dc09d7$exports.generateRandom = void 0;

$ebfc165cc3dc09d7$var$__exportStar((parcelRequire("hWIAg")), $ebfc165cc3dc09d7$exports);

$ebfc165cc3dc09d7$var$__exportStar((parcelRequire("tBfT8")), $ebfc165cc3dc09d7$exports);

$ebfc165cc3dc09d7$var$__exportStar((parcelRequire("lDIUv")), $ebfc165cc3dc09d7$exports);

$ebfc165cc3dc09d7$var$__exportStar((parcelRequire("3TYuV")), $ebfc165cc3dc09d7$exports);

$ebfc165cc3dc09d7$var$__exportStar((parcelRequire("3VCKu")), $ebfc165cc3dc09d7$exports);

$ebfc165cc3dc09d7$var$__exportStar((parcelRequire("c8Pib")), $ebfc165cc3dc09d7$exports);
const $ebfc165cc3dc09d7$var$generateRandom = (size)=>{
    const buffer = new Uint8Array(size);
    for(let i = 0; i < size; i++)buffer[i] = Math.floor(Math.random() * 256);
    return buffer;
};
$ebfc165cc3dc09d7$exports.generateRandom = $ebfc165cc3dc09d7$var$generateRandom;



var $hAePC = parcelRequire("hAePC");
class $717a9eaac71e784e$var$BrowserKeySigner {
    constructor(options){
        this.options = options;
    }
    async create(challenge) {
        let credId = this.options.credId;
        if (credId === undefined || credId === '') {
            credId = (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from((0, $ebfc165cc3dc09d7$exports.generateRandom)(32)));
            this.options.credId = credId;
        }
        const publicKeyPem = await (0, $ebfc165cc3dc09d7$exports.exportPublicKeyInPemFormatBrowser)(this.options.keyPair);
        const clientData = JSON.stringify({
            type: 'key.create',
            challenge: challenge.challenge
        });
        const clientDataHash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(clientData));
        const clientDataHashHex = (0, $ebfc165cc3dc09d7$exports.toHex)(clientDataHash);
        const credInfoFingerprint = JSON.stringify({
            clientDataHash: clientDataHashHex,
            publicKey: publicKeyPem
        });
        let rawSignature;
        const algorithm = this.options.keyPair.privateKey.algorithm.name;
        if (algorithm == 'ECDSA') rawSignature = await crypto.subtle.sign({
            name: 'ECDSA',
            hash: {
                name: 'SHA-256'
            }
        }, this.options.keyPair.privateKey, new TextEncoder().encode(credInfoFingerprint));
        else throw new $984534081770a41b$exports.DfnsError(-1, `${algorithm} is not supported`);
        const signature = (0, $ebfc165cc3dc09d7$exports.rawSignatureToAns1)(new Uint8Array(rawSignature));
        const attestationData = JSON.stringify({
            publicKey: publicKeyPem,
            signature: (0, $ebfc165cc3dc09d7$exports.toHex)(signature.buffer)
        });
        return {
            credentialKind: 'Key',
            credentialInfo: {
                credId: credId,
                clientData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)(clientData),
                attestationData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)(attestationData)
            }
        };
    }
    async sign(challenge) {
        const credId = this.options.credId;
        if (credId === undefined || credId === '') throw new $984534081770a41b$exports.DfnsError(-1, 'credId is needed to sign');
        const allowedCredId = challenge.allowCredentials.key.map((cred)=>cred.id);
        if (!allowedCredId.includes(credId)) throw new $984534081770a41b$exports.DfnsError(-1, `${credId} does not match allowed credentials: ${allowedCredId}`);
        const clientData = JSON.stringify({
            type: 'key.get',
            challenge: challenge.challenge
        });
        let rawSignature;
        const algorithm = this.options.keyPair.privateKey.algorithm.name;
        if (algorithm == 'ECDSA') rawSignature = await crypto.subtle.sign({
            name: 'ECDSA',
            hash: {
                name: 'SHA-256'
            }
        }, this.options.keyPair.privateKey, new TextEncoder().encode(clientData));
        else throw new $984534081770a41b$exports.DfnsError(-1, `${algorithm} is not supported`);
        const signature = (0, $ebfc165cc3dc09d7$exports.rawSignatureToAns1)(new Uint8Array(rawSignature));
        return {
            kind: 'Key',
            credentialAssertion: {
                credId: this.options.credId ?? '',
                clientData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)(clientData),
                signature: (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(signature))
            }
        };
    }
}
$717a9eaac71e784e$exports.BrowserKeySigner = $717a9eaac71e784e$var$BrowserKeySigner;


Object.defineProperty($fb9ea7e7c6187a50$exports, "BrowserKeySigner", {
    enumerable: true,
    get: function() {
        return $717a9eaac71e784e$exports.BrowserKeySigner;
    }
});
var $e40ca0dd5d20c909$exports = {};
"use strict";
Object.defineProperty($e40ca0dd5d20c909$exports, "__esModule", {
    value: true
});
$e40ca0dd5d20c909$exports.WebAuthnSigner = $e40ca0dd5d20c909$exports.DEFAULT_WAIT_TIMEOUT = void 0;



var $hAePC = parcelRequire("hAePC");
$e40ca0dd5d20c909$exports.DEFAULT_WAIT_TIMEOUT = 60000;
class $e40ca0dd5d20c909$var$WebAuthnSigner {
    constructor(conf){
        this.conf = conf;
        if (!this.conf?.relyingParty?.id || !this.conf?.relyingParty?.name) throw new $984534081770a41b$exports.DfnsError(-1, `Relying party ID and name must be specified in the WebauthnSigner initializer`);
    }
    async sign(challenge) {
        const response = await navigator.credentials.get({
            publicKey: {
                challenge: $hAePC.Buffer.from(challenge.challenge),
                allowCredentials: challenge.allowCredentials.webauthn.map(({ id: id, type: type })=>({
                        id: (0, $ebfc165cc3dc09d7$exports.fromBase64Url)(id).buffer,
                        type: type
                    })),
                rpId: this.conf.relyingParty.id,
                userVerification: challenge.userVerification,
                timeout: this.conf.timeout ?? $e40ca0dd5d20c909$exports.DEFAULT_WAIT_TIMEOUT
            }
        });
        if (response === null) throw new $984534081770a41b$exports.DfnsError(-1, 'Failed to sign with WebAuthn credential');
        const credential = response;
        const assertion = credential.response;
        return {
            kind: 'Fido2',
            credentialAssertion: {
                credId: credential.id,
                clientData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(assertion.clientDataJSON)),
                authenticatorData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(assertion.authenticatorData)),
                signature: (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(assertion.signature)),
                userHandle: assertion.userHandle ? (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(assertion.userHandle)) : undefined
            }
        };
    }
    async create(challenge) {
        const options = {
            publicKey: {
                challenge: $hAePC.Buffer.from(challenge.challenge),
                pubKeyCredParams: challenge.pubKeyCredParams,
                rp: this.conf.relyingParty,
                user: {
                    displayName: challenge.user.displayName,
                    id: $hAePC.Buffer.from(challenge.user.id),
                    name: challenge.user.name
                },
                attestation: challenge.attestation,
                excludeCredentials: challenge.excludeCredentials.map(({ id: id, type: type })=>({
                        id: (0, $ebfc165cc3dc09d7$exports.fromBase64Url)(id).buffer,
                        type: type
                    })),
                authenticatorSelection: challenge.authenticatorSelection,
                timeout: this.conf.timeout ?? $e40ca0dd5d20c909$exports.DEFAULT_WAIT_TIMEOUT
            }
        };
        const response = await navigator.credentials.create(options);
        if (response === null) throw new $984534081770a41b$exports.DfnsError(-1, `Failed to create and sign with WebAuthn credential`);
        const credential = response;
        const attestation = credential.response;
        return {
            credentialKind: 'Fido2',
            credentialInfo: {
                credId: credential.id,
                attestationData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(attestation.attestationObject)),
                clientData: (0, $ebfc165cc3dc09d7$exports.toBase64Url)($hAePC.Buffer.from(attestation.clientDataJSON))
            }
        };
    }
}
$e40ca0dd5d20c909$exports.WebAuthnSigner = $e40ca0dd5d20c909$var$WebAuthnSigner;


Object.defineProperty($fb9ea7e7c6187a50$exports, "WebAuthnSigner", {
    enumerable: true,
    get: function() {
        return $e40ca0dd5d20c909$exports.WebAuthnSigner;
    }
});




// Error code -> translation key for checkout (COI-779, ADR-0032).
//
// Generated from the [errors] table of internal/buy/locales/en.toml, whose
// copy is in turn the approved SHORT form of the message from the checkout
// error catalog (the "Checkout Error Catalog Documentation" Confluence page,
// mirrored in internal/buy/buy_errorcatalog). A toast and the server-rendered
// card for the same condition therefore say the same thing, the toast just
// says less of it — never less than the part that carries safety.
//
// A code that is absent renders the canonical message the server sent — that
// is the documented fallback, not a gap. Codes checkout has no approved
// presentation for are deliberately absent.
// Client-side resolution of a coded API error into display copy (COI-779,
// ADR-0032).
//
// The server answers every migrated route with
//   {"error": {"code", "message", "details", "request_id"}}
// and one canonical English message — i18n is client-side only. Each app
// declares which codes it renders itself, as a code -> translation key map,
// and the page carries a dictionary of translation key -> localised message
// for the request's language (rendered by pkg/errors/errori18n into a
// <script type="application/json" id="error-translations"> element).
//
// The fallback chain is deliberate and shallow:
//   1. the app maps the code AND the page localises that key -> localised copy
//   2. otherwise the server's message -> always correct, just not localised
//   3. otherwise the caller's fallback
//
// Step 2 is what makes a newly added server code safe: it renders the server's
// wording until the frontend is taught about it, instead of rendering nothing.
const $b58abba83329c6b7$export$54cb9b7052b28d2a = "error-translations";
const $b58abba83329c6b7$export$711117ad6ad27992 = "errors.";
function $b58abba83329c6b7$export$ece3124d05bff402(code) {
    if (!code || typeof code !== "string") return "";
    return $b58abba83329c6b7$export$711117ad6ad27992 + code.toLowerCase();
}
let $b58abba83329c6b7$var$cachedTranslations = null;
function $b58abba83329c6b7$export$db2e52950db3187d(doc) {
    const target = doc || (typeof document === "undefined" ? null : document);
    if (!target) return {};
    if (!doc && $b58abba83329c6b7$var$cachedTranslations) return $b58abba83329c6b7$var$cachedTranslations;
    let parsed = {};
    const element = target.getElementById($b58abba83329c6b7$export$54cb9b7052b28d2a);
    if (element?.textContent) try {
        const candidate = JSON.parse(element.textContent);
        if (candidate && typeof candidate === "object") parsed = candidate;
    } catch  {
        // A malformed dictionary must not break error rendering — that would
        // swallow the error the customer is being told about.
        parsed = {};
    }
    if (!doc) $b58abba83329c6b7$var$cachedTranslations = parsed;
    return parsed;
}
function $b58abba83329c6b7$export$7f667c364d89276d() {
    $b58abba83329c6b7$var$cachedTranslations = null;
}
function $b58abba83329c6b7$export$aaf161f05ffb8bad(source) {
    if (!source || typeof source !== "object") return null;
    const body = source.error;
    if (body && typeof body === "object") return {
        code: body.code || "",
        message: body.message || "",
        details: body.details || null,
        requestId: body.request_id || ""
    };
    // An Error carrying the envelope fields, or a legacy body: {"message": …} /
    // {"error": "…"}.
    return {
        code: source.code || "",
        message: source.message || (typeof body === "string" ? body : ""),
        details: source.details || null,
        requestId: source.requestId || source.request_id || ""
    };
}
function $b58abba83329c6b7$export$cfbc26ba8078f2d1(source, { keys: keys = {}, fallback: fallback = "", translations: translations } = {}) {
    const envelope = $b58abba83329c6b7$export$aaf161f05ffb8bad(source);
    if (!envelope) return fallback;
    const key = keys[envelope.code];
    if (key) {
        const dictionary = translations || $b58abba83329c6b7$export$db2e52950db3187d();
        const localised = dictionary[key];
        if (localised) return localised;
    }
    return envelope.message || fallback;
}
function $b58abba83329c6b7$export$e50f9ae597e1ea02(keys) {
    return function translateError(source, fallback = "") {
        return $b58abba83329c6b7$export$cfbc26ba8078f2d1(source, {
            keys: keys,
            fallback: fallback
        });
    };
}


const $871593c39ddb32a9$export$14847bd804e4fed5 = {
    AUTH_ACCOUNT_UNAVAILABLE: "errors.auth_account_unavailable",
    AUTH_EMAIL_NOT_RECOGNIZED: "errors.auth_email_not_recognized",
    AUTH_INVALID_TOKEN: "errors.auth_invalid_token",
    AUTH_OTP_EXPIRED: "errors.auth_otp_expired",
    AUTH_OTP_INVALID: "errors.auth_otp_invalid",
    AUTH_OTP_LOCKED: "errors.auth_otp_locked",
    AUTH_OTP_RATE_LIMITED: "errors.auth_otp_rate_limited",
    AUTH_OTP_SEND_FAILED: "errors.auth_otp_send_failed",
    AUTH_PASSKEY_CANCELLED: "errors.auth_passkey_cancelled",
    AUTH_SESSION_EXPIRED: "errors.auth_session_expired",
    AUTH_UNAUTHENTICATED: "errors.auth_unauthenticated",
    INTERNAL: "errors.internal",
    PAYMENT_ALREADY_COMPLETED: "errors.payment_already_completed",
    PAYMENT_BALANCE_UNAVAILABLE: "errors.payment_balance_unavailable",
    PAYMENT_CHECKOUT_UNAVAILABLE: "errors.payment_checkout_unavailable",
    PAYMENT_DECLINED_IN_WALLET: "errors.payment_declined_in_wallet",
    PAYMENT_DEPOSIT_ADDRESS_EXPIRED: "errors.payment_deposit_address_expired",
    PAYMENT_DEPOSIT_SETUP_FAILED: "errors.payment_deposit_setup_failed",
    PAYMENT_DEPOSIT_SHORT: "errors.payment_deposit_short",
    PAYMENT_FAILED: "errors.payment_failed",
    PAYMENT_IDEMPOTENCY_CONFLICT: "errors.payment_idempotency_conflict",
    PAYMENT_INSUFFICIENT_BALANCE: "errors.payment_insufficient_balance",
    PAYMENT_LINK_EXPIRED: "errors.payment_link_expired",
    PAYMENT_METHOD_UNAVAILABLE: "errors.payment_method_unavailable",
    PAYMENT_NETWORK_SWITCH_REQUIRED: "errors.payment_network_switch_required",
    PAYMENT_NETWORK_UNAVAILABLE: "errors.payment_network_unavailable",
    PAYMENT_NOT_FOUND: "errors.payment_not_found",
    PAYMENT_NOT_PERMITTED: "errors.payment_not_permitted",
    PAYMENT_PENDING: "errors.payment_pending",
    PAYMENT_PRICING_UNAVAILABLE: "errors.payment_pricing_unavailable",
    PAYMENT_REVERTED_ON_CHAIN: "errors.payment_reverted_on_chain",
    PAYMENT_STATUS_UNCONFIRMED: "errors.payment_status_unconfirmed",
    PAYMENT_UNSUPPORTED_NETWORK: "errors.payment_unsupported_network",
    PAYMENT_WALLET_CONNECT_CANCELLED: "errors.payment_wallet_connect_cancelled",
    PAYMENT_WALLET_CONNECT_FAILED: "errors.payment_wallet_connect_failed",
    SIGNER_CHALLENGE_EXPIRED: "errors.signer_challenge_expired",
    SIGNER_REJECTED: "errors.signer_rejected",
    SIGNER_UNAVAILABLE: "errors.signer_unavailable",
    SIGNER_WALLET_SETUP_FAILED: "errors.signer_wallet_setup_failed",
    VALIDATION_INVALID_EMAIL: "errors.validation_invalid_email",
    VALIDATION_INVALID_FIELD: "errors.validation_invalid_field",
    VALIDATION_INVALID_REQUEST: "errors.validation_invalid_request"
};
const $871593c39ddb32a9$export$dbb77d813a78f040 = (0, $b58abba83329c6b7$export$e50f9ae597e1ea02)($871593c39ddb32a9$export$14847bd804e4fed5);


// Client-side entry points to the checkout error catalog (CS-2942).
// Toast copy lives here because cancellations are client-detected events;
// card/full-page surfaces are server-rendered via /:code/error-card.
// copyForCode renders the wire code's localised copy, falling back to the
// English wording checkout has always shown for it (COI-779).
function $9286460a480b22e8$var$copyForCode(code, english) {
    return (0, $871593c39ddb32a9$export$dbb77d813a78f040)({
        error: {
            code: code,
            message: english
        }
    }, english);
}
const $9286460a480b22e8$export$63a19fa2452e67ad = {
    get passkeyCancelled () {
        return $9286460a480b22e8$var$copyForCode("AUTH_PASSKEY_CANCELLED", "Passkey cancelled");
    },
    get walletConnectCancelled () {
        return $9286460a480b22e8$var$copyForCode("PAYMENT_WALLET_CONNECT_CANCELLED", "Wallet connection cancelled");
    },
    get paymentDeclinedInWallet () {
        return $9286460a480b22e8$var$copyForCode("PAYMENT_DECLINED_IN_WALLET", "Payment cancelled. No funds were taken.");
    }
};
function $9286460a480b22e8$export$739bcfea9ba481d2(message) {
    document.dispatchEvent(new CustomEvent("toast:show", {
        detail: {
            message: message
        }
    }));
}
function $9286460a480b22e8$export$638ad2c71ea7d97b(error, fallback) {
    const message = (0, $871593c39ddb32a9$export$dbb77d813a78f040)(error, fallback);
    if (!message) return false;
    $9286460a480b22e8$export$739bcfea9ba481d2(message);
    return true;
}
async function $9286460a480b22e8$export$b542b247691f8019(errorKey, { code: code, session: session } = {}) {
    const url = new URL(window.location.href);
    const resolvedCode = code || url.pathname.split("/").filter(Boolean)[0] || "";
    const resolvedSession = session || url.searchParams.get("session") || "";
    if (!errorKey || !resolvedCode || !resolvedSession) return false;
    try {
        const response = await fetch(`/${resolvedCode}/error-card?key=${encodeURIComponent(errorKey)}&session=${encodeURIComponent(resolvedSession)}`, {
            headers: {
                Accept: "text/vnd.turbo-stream.html"
            }
        });
        if (!response.ok) return false;
        Turbo.renderStreamMessage(await response.text());
        return true;
    } catch (error) {
        (0, $df5856b8963e2c0f$export$280f90b954565303)("showErrorCard: fetch failed", error);
        return false;
    }
}
function $9286460a480b22e8$export$a5837bf4a7a2713a(error) {
    if (!error) return false;
    if (error.name === "NotAllowedError" || error.name === "AbortError") return true;
    if (error.code === 4001 || error.cause?.code === 4001) return true;
    const message = String(error.message || "").toLowerCase();
    return message.includes("user rejected") || message.includes("user denied");
}




class $ebfc04dcf68de6b9$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        dfnsChallenge: String,
        session: String,
        code: String
    };
    connect() {
        this.showLoadingScreen();
        this.getDFNSChallengeValue();
    }
    async getDFNSChallengeValue() {
        const metadata = (0, $f154d6de68471e5b$export$79fb1ec4128903c9)();
        metadata.appType = "buy";
        const jsonMetadata = JSON.stringify(metadata);
        const request = await fetch("/get-dfns-challenge-value", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Session": this.sessionValue,
                "X-Code": this.codeValue
            },
            body: JSON.stringify({
                metadata: jsonMetadata
            })
        });
        if (!request.ok) {
            this.hideLoadingScreen();
            const errorBody = await request.json().catch(()=>({}));
            if (errorBody.error_html) Turbo.renderStreamMessage(errorBody.error_html);
            return;
        }
        const response = await request.json();
        if (response.response_type === "dfns_key_user") {
            // Created new key credential
            if (response.redirect_url) Turbo.visit(response.redirect_url);
            return;
        }
        this.dfnsChallengeValue = response.dfns_challenge;
        this.handlePasskeyCreation();
    }
    async handlePasskeyCreation(_) {
        try {
            // Webauthn flow
            const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                relyingParty: {
                    id: sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN) ?? "coinsub.io",
                    name: sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).COMPANY_NAME) ?? "Coinsub"
                }
            });
            const parsedDFNSChallenge = JSON.parse(this.dfnsChallengeValue);
            const attestation = await webauthn.create(parsedDFNSChallenge);
            const responseDFNSRegister = await fetch("/dfns/register/complete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    signedChallenge: {
                        firstFactorCredential: attestation
                    },
                    temporaryAuthenticationToken: parsedDFNSChallenge.temporaryAuthenticationToken,
                    session: this.sessionValue
                })
            });
            if (!responseDFNSRegister.ok) {
                this.hideLoadingScreen();
                const errorBody = await responseDFNSRegister.json().catch(()=>({}));
                if (errorBody.error_html) Turbo.renderStreamMessage(errorBody.error_html);
                else (0, $9286460a480b22e8$export$b542b247691f8019)("wallet-setup-failed", {
                    session: this.sessionValue
                });
                return;
            }
            const responseDFNSRegisterData = await responseDFNSRegister.json();
            this.hideLoadingScreen();
            if (responseDFNSRegisterData.redirectPath) Turbo.visit(responseDFNSRegister.redirectPath);
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error during passkey creation:", error);
            this.hideLoadingScreen();
            // Deliberate cancellation keeps the step and its CTA in place — a toast
            // is enough. Real failures get the wallet-setup-failed retry card.
            if (error.name === "NotAllowedError" || error.message?.includes("NotAllowedError") || error.name === "AbortError" || error.name === "InvalidStateError") (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).passkeyCancelled);
            else (0, $9286460a480b22e8$export$b542b247691f8019)("wallet-setup-failed", {
                session: this.sessionValue
            });
        }
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}





var $kFTZb = parcelRequire("kFTZb");

var $bBj7l = parcelRequire("bBj7l");


parcelRequire("dzDkt");
parcelRequire("fQSUm");

parcelRequire("a6eMa");
parcelRequire("8YciW");
parcelRequire("dHSHZ");

parcelRequire("j9N2Z");
parcelRequire("1VClN");


var $bBj7l = parcelRequire("bBj7l");

var $k5e8S = parcelRequire("k5e8S");
/**
 * The `ProviderIdentityFlag` is a property on an injected provider
 * that uniquely identifies that provider
 */ var $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4;
(function(ProviderIdentityFlag) {
    ProviderIdentityFlag["AlphaWallet"] = "isAlphaWallet";
    ProviderIdentityFlag["ApexWallet"] = "isApexWallet";
    ProviderIdentityFlag["AToken"] = "isAToken";
    ProviderIdentityFlag["BifrostWallet"] = "isBifrost";
    ProviderIdentityFlag["Binance"] = "bbcSignTx";
    ProviderIdentityFlag["Bitpie"] = "isBitpie";
    ProviderIdentityFlag["BlockWallet"] = "isBlockWallet";
    ProviderIdentityFlag["Coinbase"] = "isToshi";
    ProviderIdentityFlag["CoinbaseExtension"] = "isCoinbaseWallet";
    ProviderIdentityFlag["Detected"] = "request";
    ProviderIdentityFlag["Dcent"] = "isDcentWallet";
    ProviderIdentityFlag["Exodus"] = "isExodus";
    ProviderIdentityFlag["Frontier"] = "isFrontier";
    ProviderIdentityFlag["Frame"] = "isFrame";
    ProviderIdentityFlag["HuobiWallet"] = "isHbWallet";
    ProviderIdentityFlag["HyperPay"] = "isHyperPay";
    ProviderIdentityFlag["ImToken"] = "isImToken";
    ProviderIdentityFlag["InfinityWallet"] = "isInfinityWallet";
    ProviderIdentityFlag["Liquality"] = "isLiquality";
    ProviderIdentityFlag["MeetOne"] = "wallet";
    ProviderIdentityFlag["MetaMask"] = "isMetaMask";
    ProviderIdentityFlag["MyKey"] = "isMYKEY";
    ProviderIdentityFlag["OwnBit"] = "isOwnbit";
    ProviderIdentityFlag["Status"] = "isStatus";
    ProviderIdentityFlag["Trust"] = "isTrust";
    ProviderIdentityFlag["TokenPocket"] = "isTokenPocket";
    ProviderIdentityFlag["TP"] = "isTp";
    ProviderIdentityFlag["WalletIo"] = "isWalletIO";
    ProviderIdentityFlag["XDEFI"] = "isXDEFI";
    ProviderIdentityFlag["OneInch"] = "isOneInchIOSWallet";
    ProviderIdentityFlag["Tokenary"] = "isTokenary";
    ProviderIdentityFlag["Tally"] = "isTally";
    ProviderIdentityFlag["BraveWallet"] = "isBraveWallet";
    ProviderIdentityFlag["Rabby"] = "isRabby";
    ProviderIdentityFlag["MathWallet"] = "isMathWallet";
    ProviderIdentityFlag["Bitget"] = "isBitKeep";
    ProviderIdentityFlag["Sequence"] = "isSequence";
    ProviderIdentityFlag["Core"] = "isAvalanche";
    ProviderIdentityFlag["Opera"] = "isOpera";
    ProviderIdentityFlag["Bitski"] = "isBitski";
    ProviderIdentityFlag["Enkrypt"] = "isEnkrypt";
    ProviderIdentityFlag["Phantom"] = "isPhantom";
    ProviderIdentityFlag["OKXWallet"] = "isOkxWallet";
    ProviderIdentityFlag["Zeal"] = "isZeal";
    ProviderIdentityFlag["Zerion"] = "isZerion";
    ProviderIdentityFlag["Rainbow"] = "isRainbow";
    ProviderIdentityFlag["SafePal"] = "isSafePal";
    ProviderIdentityFlag["DeFiWallet"] = "isDeficonnectProvider";
    ProviderIdentityFlag["Safeheron"] = "isSafeheron";
    ProviderIdentityFlag["Talisman"] = "isTalisman";
    ProviderIdentityFlag["OneKey"] = "isOneKey";
    ProviderIdentityFlag["Fordefi"] = "isFordefi";
    ProviderIdentityFlag["Coin98Wallet"] = "isCoin98";
    ProviderIdentityFlag["SubWallet"] = "isSubWallet";
    ProviderIdentityFlag["Kayros"] = "isKayros";
    ProviderIdentityFlag["FoxWallet"] = "isFoxWallet";
    ProviderIdentityFlag["Lif3Wallet"] = "isLif3Wallet";
    ProviderIdentityFlag["ZodiacPilot"] = "isZodiacPilot";
    ProviderIdentityFlag["StableWallet"] = "isStableWallet";
    ProviderIdentityFlag["Echooo"] = "isEchooo";
    ProviderIdentityFlag["Keplr"] = "keplr";
})($8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4 || ($8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4 = {}));
var $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5;
(function(ProviderExternalUrl) {
    ProviderExternalUrl["Binance"] = "https://www.bnbchain.org/ru/blog/binance-extension-wallet/";
    ProviderExternalUrl["Bitget"] = "https://web3.bitget.com/en/wallet-download";
    ProviderExternalUrl["Coinbase"] = "https://www.coinbase.com/wallet/downloads";
    ProviderExternalUrl["MetaMask"] = "https://metamask.io/download/";
    ProviderExternalUrl["OKXWallet"] = "https://okx.com/download";
    ProviderExternalUrl["Phantom"] = "https://phantom.app/ul/v1/connect";
    ProviderExternalUrl["Talisman"] = "https://www.talisman.xyz/";
    ProviderExternalUrl["Trust"] = "https://link.trustwallet.com";
    ProviderExternalUrl["OneKey"] = "https://onekey.so/download/";
    ProviderExternalUrl["RoninWallet"] = "https://wallet.skymavis.com/";
    ProviderExternalUrl["Coin98Wallet"] = "https://coin98.com/wallet/";
    ProviderExternalUrl["SubWallet"] = "https://www.subwallet.app/";
    ProviderExternalUrl["Kayros"] = "https://www.kayros.games/wallet/";
    ProviderExternalUrl["XDEFI"] = "https://xdefi.io/";
    ProviderExternalUrl["FoxWallet"] = "https://foxwallet.com/download";
    ProviderExternalUrl["Lif3Wallet"] = "https://lif3.com";
    ProviderExternalUrl["Rabby"] = "https://rabby.io";
    ProviderExternalUrl["ZodiacPilot"] = "https://pilot.gnosisguild.org/";
    ProviderExternalUrl["Echooo"] = "https://www.echooo.xyz";
    ProviderExternalUrl["Keplr"] = "https://www.keplr.app/download";
})($8d6f5efb5e8e7c50$export$a9253ba86c8edfd5 || ($8d6f5efb5e8e7c50$export$a9253ba86c8edfd5 = {}));
var $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a;
(function(ProviderLabel) {
    ProviderLabel["AlphaWallet"] = "AlphaWallet";
    ProviderLabel["ApexWallet"] = "Apex Wallet";
    ProviderLabel["AToken"] = "AToken";
    ProviderLabel["BifrostWallet"] = "Bifrost Wallet";
    ProviderLabel["Binance"] = "Binance Smart Wallet";
    ProviderLabel["Bitpie"] = "Bitpie";
    ProviderLabel["Bitski"] = "Bitski";
    ProviderLabel["BlockWallet"] = "BlockWallet";
    ProviderLabel["Brave"] = "Brave Wallet";
    ProviderLabel["Coinbase"] = "Coinbase Wallet";
    ProviderLabel["Dcent"] = "D'CENT";
    ProviderLabel["Detected"] = "Detected Wallet";
    ProviderLabel["Exodus"] = "Exodus";
    ProviderLabel["Frame"] = "Frame";
    ProviderLabel["Frontier"] = "Frontier";
    ProviderLabel["HuobiWallet"] = "Huobi Wallet";
    ProviderLabel["HyperPay"] = "HyperPay";
    ProviderLabel["ImToken"] = "imToken";
    ProviderLabel["InfinityWallet"] = "Infinity Wallet";
    ProviderLabel["Liquality"] = "Liquality";
    ProviderLabel["MeetOne"] = "MeetOne";
    ProviderLabel["MetaMask"] = "MetaMask";
    ProviderLabel["MyKey"] = "MyKey";
    ProviderLabel["Opera"] = "Opera Wallet";
    ProviderLabel["OwnBit"] = "OwnBit";
    ProviderLabel["Status"] = "Status Wallet";
    ProviderLabel["Trust"] = "Trust Wallet";
    ProviderLabel["TokenPocket"] = "TokenPocket";
    ProviderLabel["TP"] = "TP Wallet";
    ProviderLabel["WalletIo"] = "Wallet.io";
    ProviderLabel["XDEFI"] = "XDEFI Wallet";
    ProviderLabel["OneInch"] = "1inch Wallet";
    ProviderLabel["Tokenary"] = "Tokenary Wallet";
    ProviderLabel["Tally"] = "Taho";
    ProviderLabel["Rabby"] = "Rabby Wallet";
    ProviderLabel["MathWallet"] = "MathWallet";
    ProviderLabel["Bitget"] = "Bitget Wallet";
    ProviderLabel["Sequence"] = "Sequence";
    ProviderLabel["Core"] = "Core";
    ProviderLabel["Enkrypt"] = "Enkrypt";
    ProviderLabel["Zeal"] = "Zeal";
    ProviderLabel["Phantom"] = "Phantom";
    ProviderLabel["OKXWallet"] = "OKX Wallet";
    ProviderLabel["Zerion"] = "Zerion";
    ProviderLabel["Rainbow"] = "Rainbow";
    ProviderLabel["SafePal"] = "SafePal";
    ProviderLabel["DeFiWallet"] = "DeFi Wallet";
    ProviderLabel["Safeheron"] = "Safeheron";
    ProviderLabel["Talisman"] = "Talisman";
    ProviderLabel["OneKey"] = "OneKey";
    ProviderLabel["Fordefi"] = "Fordefi";
    ProviderLabel["RoninWallet"] = "Ronin Wallet";
    ProviderLabel["Coin98Wallet"] = "Coin98 Wallet";
    ProviderLabel["SubWallet"] = "SubWallet";
    ProviderLabel["Kayros"] = "Kayros";
    ProviderLabel["FoxWallet"] = "FoxWallet";
    ProviderLabel["Lif3Wallet"] = "Lif3 Wallet";
    ProviderLabel["ZodiacPilot"] = "Zodiac Pilot";
    ProviderLabel["StableWallet"] = "StableWallet";
    ProviderLabel["Echooo"] = "Echooo";
    ProviderLabel["Keplr"] = "Keplr";
})($8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a || ($8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a = {}));
var $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2;
(function(InjectedNameSpace) {
    InjectedNameSpace["Ethereum"] = "ethereum";
    InjectedNameSpace["Binance"] = "BinanceChain";
    InjectedNameSpace["Tally"] = "tally";
    InjectedNameSpace["Web3"] = "web3";
    InjectedNameSpace["Arbitrum"] = "arbitrum";
    InjectedNameSpace["XFI"] = "xfi";
    InjectedNameSpace["Bitget"] = "bitkeep";
    InjectedNameSpace["Avalanche"] = "avalanche";
    InjectedNameSpace["Bitski"] = "Bitski";
    InjectedNameSpace["Enkrypt"] = "enkrypt";
    InjectedNameSpace["Zeal"] = "zeal";
    InjectedNameSpace["Phantom"] = "phantom";
    InjectedNameSpace["OKXWallet"] = "okxwallet";
    InjectedNameSpace["Trust"] = "trustwallet";
    InjectedNameSpace["Frontier"] = "frontier";
    InjectedNameSpace["DeFiConnectProvider"] = "deficonnectProvider";
    InjectedNameSpace["Safeheron"] = "safeheron";
    InjectedNameSpace["Talisman"] = "talismanEth";
    InjectedNameSpace["OneKey"] = "$onekey";
    InjectedNameSpace["RoninWallet"] = "ronin";
    InjectedNameSpace["Coin98Wallet"] = "coin98";
    InjectedNameSpace["SubWallet"] = "SubWallet";
    InjectedNameSpace["Kayros"] = "kayros";
    InjectedNameSpace["FoxWallet"] = "foxwallet";
    InjectedNameSpace["Echooo"] = "echooo";
})($8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2 || ($8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2 = {}));
class $8d6f5efb5e8e7c50$export$9c8150830466b77e extends Event {
    constructor(){
        super('eip6963:requestProvider');
    }
}


parcelRequire("8YciW");
var $eieBU = parcelRequire("eieBU");

const $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD = null;
function $21c6e0fb7add73ac$var$getInjectedInterface(identity, checkOtherProviderFlags) {
    return async ()=>({
            provider: window.ethereum.providers && Array.isArray(window.ethereum.providers) ? $21c6e0fb7add73ac$var$getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) : window.ethereum
        });
}
function $21c6e0fb7add73ac$var$getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) {
    return window.ethereum.providers.find((provider)=>{
        return checkOtherProviderFlags ? !!provider[identity] && !$21c6e0fb7add73ac$var$otherProviderFlagsExist(identity, provider) : !!provider[identity];
    });
}
function $21c6e0fb7add73ac$var$otherProviderFlagsExist(identity, provider) {
    const otherProviderFlags = Object.values((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4)).filter((id)=>id !== identity && id !== (0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Detected);
    return otherProviderFlags.some((id)=>!!provider[id]);
}

const $21c6e0fb7add73ac$var$metamask = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).MetaMask,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MetaMask] && !$21c6e0fb7add73ac$var$otherProviderFlagsExist((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MetaMask, provider),
    getIcon: async ()=>(await (parcelRequire("lPkpG"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MetaMask, true),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).MetaMask
};

const $21c6e0fb7add73ac$var$infinitywallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).InfinityWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).InfinityWallet],
    getIcon: async ()=>(await (parcelRequire("lY98e"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).InfinityWallet),
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$exodus = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Exodus,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Exodus],
    getIcon: async ()=>(await (parcelRequire("cvBEH"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Exodus),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$frontier = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Frontier,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Frontier,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider['ethereum'] && !!provider['ethereum'][(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Frontier],
    getIcon: async ()=>(await (parcelRequire("bjvWi"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.frontier.ethereum)
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$brave = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Brave,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).BraveWallet],
    getIcon: async ()=>(await (parcelRequire("hrSpo"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).BraveWallet),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$binance = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Binance,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Binance,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Binance],
    getIcon: async ()=>(await (parcelRequire("iSvEX"))).default,
    getInterface: async ()=>{
        // Replace the provider as the BNB provider is readonly
        let tempBNBProvider = {
            ...window.BinanceChain
        };
        window.BinanceChain = tempBNBProvider;
        const addListener = window.BinanceChain.on.bind(window.BinanceChain);
        window.BinanceChain.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === 'chainChanged') addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        const provider = (0, $eieBU.createEIP1193Provider)(window.BinanceChain, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: 'eth_chainId'
                }).then((id)=>`0x${parseInt(id).toString(16)}`),
            // Unsupported method -- will throw error
            eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
            wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        'desktop'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Binance
};

const $21c6e0fb7add73ac$var$coinbase = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Coinbase,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Coinbase] || !!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).CoinbaseExtension],
    getIcon: async ()=>(await (parcelRequire("7qi1p"))).default,
    getInterface: async ()=>{
        const { provider: provider } = await $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).CoinbaseExtension)();
        const addListener = provider.on.bind(provider);
        provider.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === 'chainChanged') addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        return {
            provider: provider
        };
    },
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Coinbase
};

const $21c6e0fb7add73ac$var$detected = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Detected,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Detected],
    getIcon: async ()=>(await (parcelRequire("aP3Ob"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$trust = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Trust,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Trust,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Trust],
    getIcon: async ()=>(await (parcelRequire("iwnJX"))).default,
    getInterface: async ()=>{
        const ethereumInjectionExists = window.hasOwnProperty((0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum);
        let provider;
        // check if trust is injected into window.ethereum
        if (ethereumInjectionExists && window[(0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum].isTrust) provider = window[(0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum];
        else // directly use the window.trustwallet injection
        provider = window[(0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Trust];
        return {
            provider: provider
        };
    },
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Trust
};

const $21c6e0fb7add73ac$var$opera = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Opera,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Opera],
    getIcon: async ()=>(await (parcelRequire("8R9Ds"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                eth_requestAccounts: async ({ baseRequest: baseRequest })=>baseRequest({
                        method: 'eth_accounts'
                    }),
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$status = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Status,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Status],
    getIcon: async ()=>(await (parcelRequire("6Y9Ga"))).default,
    getInterface: async ()=>{
        const provider = window.ethereum;
        return {
            provider: provider
        };
    },
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$alphawallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).AlphaWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).AlphaWallet],
    getIcon: async ()=>(await (parcelRequire("41VeC"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$apexwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).ApexWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).ApexWallet],
    getIcon: async ()=>(await (parcelRequire("l2MjS"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        'desktop',
        'Chrome',
        'Chromium',
        'Microsoft Edge'
    ]
};

const $21c6e0fb7add73ac$var$atoken = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).AToken,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).AToken],
    getIcon: async ()=>(await (parcelRequire("hqSqA"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$bifrostwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).BifrostWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).BifrostWallet],
    getIcon: async ()=>(await (parcelRequire("6s35B"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).BifrostWallet),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$bitpie = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Bitpie,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ()=>!!window.Bitpie,
    getIcon: async ()=>(await (parcelRequire("bhVLK"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$blockwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).BlockWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).BlockWallet],
    getIcon: async ()=>(await (parcelRequire("bF8sC"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).BlockWallet),
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$frame = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Frame,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Frame],
    getIcon: async ()=>(await (parcelRequire("8gdKT"))).default,
    getInterface: async ()=>{
        const provider = window.ethereum;
        if (!provider || !provider.connected) throw new Error('Frame App must be open with a hot wallet connected. If not installed first download the Frame App.');
        return {
            provider: provider
        };
    },
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$huobiwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).HuobiWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).HuobiWallet],
    getIcon: async ()=>(await (parcelRequire("2DY3Q"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$hyperpay = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).HyperPay,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    // Note: The property `hiWallet` is as of now the only known way of identifying hyperpay
    // wallet as it is a direct clone of metamask. `checkProviderIdentity` implementation is subject to
    // future changes
    checkProviderIdentity: ()=>!!window.hiWallet,
    getIcon: async ()=>(await (parcelRequire("amD3h"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$imtoken = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).ImToken,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).ImToken],
    getIcon: async ()=>(await (parcelRequire("cs7kV"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$liquality = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Liquality,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Liquality],
    getIcon: async ()=>(await (parcelRequire("cWiEz"))).default,
    getInterface: async ()=>{
        const provider = (0, $eieBU.createEIP1193Provider)(window.ethereum, {
            wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
            eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$meetone = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).MeetOne,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MeetOne] === 'MEETONE',
    getIcon: async ()=>(await (parcelRequire("oi1V7"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$mykey = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).MyKey,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MyKey],
    getIcon: async ()=>(await (parcelRequire("c6wZG"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$ownbit = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).OwnBit,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).OwnBit],
    getIcon: async ()=>(await (parcelRequire("5xK4V"))).default,
    getInterface: async ()=>{
        const provider = (0, $eieBU.createEIP1193Provider)(window.ethereum, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: 'eth_chainId'
                }).then((id)=>`0x${parseInt(id).toString(16)}`),
            wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
            eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, listener)=>{};
        provider.on = (event, listener)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$tokenpocket = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).TokenPocket,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).TokenPocket] && !provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).TP],
    getIcon: async ()=>(await (parcelRequire("beeWa"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).TokenPocket),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$tp = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).TP,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).TP],
    getIcon: async ()=>(await (parcelRequire("6rIji"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$xdefi = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).XDEFI,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).XFI,
    checkProviderIdentity: ({ provider: provider })=>provider && provider.ethereum && provider.ethereum[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).XDEFI],
    getIcon: async ()=>(await (parcelRequire("6PZYg"))).default,
    getInterface: async ()=>({
            provider: window.xfi && window.xfi.ethereum
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).XDEFI
};

const $21c6e0fb7add73ac$var$oneInch = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).OneInch,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).OneInch],
    getIcon: async ()=>(await (parcelRequire("5Eqey"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$tokenary = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Tokenary,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Tokenary],
    getIcon: async ()=>(await (parcelRequire("01jVR"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$tally = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Tally,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Tally,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Tally],
    getIcon: async ()=>(await (parcelRequire("6g0xv"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.tally)
        }),
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$zeal = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Zeal,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Zeal,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Zeal],
    getIcon: async ()=>(await (parcelRequire("hwLyE"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.zeal)
        }),
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$rabby = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Rabby,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Rabby],
    getIcon: async ()=>(await (parcelRequire("kgGph"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        'desktop',
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$mathwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).MathWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MathWallet],
    getIcon: async ()=>(await (parcelRequire("hhcUO"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).MathWallet),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$bitget = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Bitget,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Bitget,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider['ethereum'] && !!provider['ethereum'][(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Bitget],
    getIcon: async ()=>(await (parcelRequire("jqOTI"))).default,
    getInterface: async ()=>({
            provider: window.bitkeep && window.bitkeep.ethereum
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Bitget
};

const $21c6e0fb7add73ac$var$sequence = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Sequence,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Sequence],
    getIcon: async ()=>(await (parcelRequire("8fJGs"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$core = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Core,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Avalanche,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Core],
    getIcon: async ()=>(await (parcelRequire("9PgGg"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Core),
    // Core wallet is only tested in chrome or chromium browser
    platforms: [
        'desktop',
        'Chrome',
        'Chromium',
        'Microsoft Edge'
    ]
};

const $21c6e0fb7add73ac$var$bitski = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Bitski,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Bitski,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.getProvider && !!provider.getProvider().isBitski,
    getIcon: async ()=>(await (parcelRequire("gmReZ"))).default,
    getInterface: async ()=>({
            provider: window.Bitski && window.Bitski.getProvider && window.Bitski.getProvider()
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$zerion = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Zerion,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Zerion],
    getIcon: async ()=>(await (parcelRequire("1tnfd"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$enkrypt = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Enkrypt,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Enkrypt,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.providers && !!provider.providers.ethereum,
    getIcon: async ()=>(await (parcelRequire("8dRW4"))).default,
    getInterface: async ()=>{
        const addListener = window.enkrypt.providers.ethereum.on.bind(window.enkrypt.providers.ethereum);
        window.enkrypt.providers.ethereum.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === 'chainChanged') addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        const provider = (0, $eieBU.createEIP1193Provider)(window.enkrypt.providers.ethereum, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: 'eth_chainId'
                }).then((id)=>`0x${parseInt(id).toString(16)}`)
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$phantom = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Phantom,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Phantom,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider['ethereum'] && !!provider['ethereum'][(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Phantom],
    getIcon: async ()=>(await (parcelRequire("fczkx"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.phantom.ethereum)
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Phantom
};

const $21c6e0fb7add73ac$var$safepal = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).SafePal,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).SafePal],
    getIcon: async ()=>(await (parcelRequire("hiwSd"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$rainbow = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Rainbow,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Rainbow],
    getIcon: async ()=>(await (parcelRequire("2QA47"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Rainbow),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$okxwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).OKXWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).OKXWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).OKXWallet],
    getIcon: async ()=>(await (parcelRequire("f9kxq"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.okxwallet)
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).OKXWallet
};

const $21c6e0fb7add73ac$var$defiwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).DeFiWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).DeFiConnectProvider,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).DeFiWallet],
    getIcon: async ()=>(await (parcelRequire("dnOdR"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.deficonnectProvider)
        }),
    platforms: [
        'all'
    ]
};

const $21c6e0fb7add73ac$var$safeheron = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Safeheron,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Safeheron,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Safeheron],
    getIcon: async ()=>(await (parcelRequire("d4w4J"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.safeheron)
        }),
    platforms: [
        'desktop',
        'Chrome',
        'Chromium',
        'Microsoft Edge'
    ]
};

const $21c6e0fb7add73ac$var$talisman = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Talisman,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Talisman,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Talisman],
    getIcon: async ()=>(await (parcelRequire("br9bz"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.talismanEth)
        }),
    platforms: [
        'desktop'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Talisman
};

const $21c6e0fb7add73ac$var$ronin = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).RoninWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).RoninWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider,
    getIcon: async ()=>(await (parcelRequire("76kYH"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ronin.provider)
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).RoninWallet
};

const $21c6e0fb7add73ac$var$onekey = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).OneKey,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).OneKey,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.ethereum && !!provider.ethereum[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).OneKey],
    getIcon: async ()=>(await (parcelRequire("3qOkN"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.$onekey.ethereum)
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).OneKey
};

const $21c6e0fb7add73ac$var$fordefi = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Fordefi,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Fordefi],
    getIcon: async ()=>(await (parcelRequire("fIO9w"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Fordefi, true),
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$coin98wallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Coin98Wallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Coin98Wallet],
    getIcon: async ()=>(await (parcelRequire("kpMiz"))).default,
    getInterface: async ()=>{
        const ethereumInjectionExists = window.hasOwnProperty((0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum);
        let provider;
        // check if coin98 is injected into window.ethereum
        if (ethereumInjectionExists && window[(0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum].isCoin98) provider = window[(0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum];
        else // directly use the window.coin98 injection
        provider = window[(0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Coin98Wallet].provider;
        return {
            provider: provider
        };
    },
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Coin98Wallet
};

const $21c6e0fb7add73ac$var$subwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).SubWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).SubWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).SubWallet],
    getIcon: async ()=>(await (parcelRequire("cgsO6"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.SubWallet)
        }),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).SubWallet
};

const $21c6e0fb7add73ac$var$kayros = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Kayros,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Kayros,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Kayros],
    getIcon: async ()=>(await (parcelRequire("3XZwR"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.kayros)
        }),
    platforms: [
        'desktop'
    ]
};

const $21c6e0fb7add73ac$var$foxwallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).FoxWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).FoxWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).FoxWallet],
    getIcon: async ()=>(await (parcelRequire("bGTTA"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.foxwallet)
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$Lif3Wallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Lif3Wallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Lif3Wallet],
    getIcon: async ()=>(await (parcelRequire("cXBVA"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $21c6e0fb7add73ac$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$zodiacPilot = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).ZodiacPilot,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).ZodiacPilot],
    getIcon: async ()=>(await (parcelRequire("jQrvS"))).default,
    getInterface: async ()=>({
            provider: (0, $eieBU.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        'desktop'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).ZodiacPilot
};

const $21c6e0fb7add73ac$var$stablewallet = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).StableWallet,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).StableWallet],
    getIcon: async ()=>(await (parcelRequire("1JxDt"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).StableWallet),
    platforms: [
        'mobile'
    ]
};

const $21c6e0fb7add73ac$var$echooo = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Echooo,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Echooo],
    getIcon: async ()=>(await (parcelRequire("7tRJ6"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Echooo),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Echooo
};

const $21c6e0fb7add73ac$var$keplr = {
    label: (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Keplr,
    injectedNamespace: (0, $8d6f5efb5e8e7c50$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Keplr],
    getIcon: async ()=>(await (parcelRequire("4orHX"))).default,
    getInterface: $21c6e0fb7add73ac$var$getInjectedInterface((0, $8d6f5efb5e8e7c50$export$ed1aacaf3c5fdac4).Keplr),
    platforms: [
        'all'
    ],
    externalUrl: (0, $8d6f5efb5e8e7c50$export$a9253ba86c8edfd5).Keplr
};
const $21c6e0fb7add73ac$var$wallets = [
    $21c6e0fb7add73ac$var$zeal,
    $21c6e0fb7add73ac$var$exodus,
    $21c6e0fb7add73ac$var$frontier,
    $21c6e0fb7add73ac$var$metamask,
    $21c6e0fb7add73ac$var$bifrostwallet,
    $21c6e0fb7add73ac$var$binance,
    $21c6e0fb7add73ac$var$coinbase,
    $21c6e0fb7add73ac$var$detected,
    $21c6e0fb7add73ac$var$trust,
    $21c6e0fb7add73ac$var$opera,
    $21c6e0fb7add73ac$var$status,
    $21c6e0fb7add73ac$var$alphawallet,
    $21c6e0fb7add73ac$var$apexwallet,
    $21c6e0fb7add73ac$var$atoken,
    $21c6e0fb7add73ac$var$bitget,
    $21c6e0fb7add73ac$var$bitpie,
    $21c6e0fb7add73ac$var$blockwallet,
    $21c6e0fb7add73ac$var$brave,
    $21c6e0fb7add73ac$var$frame,
    $21c6e0fb7add73ac$var$huobiwallet,
    $21c6e0fb7add73ac$var$hyperpay,
    $21c6e0fb7add73ac$var$imtoken,
    $21c6e0fb7add73ac$var$liquality,
    $21c6e0fb7add73ac$var$meetone,
    $21c6e0fb7add73ac$var$mykey,
    $21c6e0fb7add73ac$var$ownbit,
    $21c6e0fb7add73ac$var$tokenpocket,
    $21c6e0fb7add73ac$var$tp,
    $21c6e0fb7add73ac$var$xdefi,
    $21c6e0fb7add73ac$var$oneInch,
    $21c6e0fb7add73ac$var$tokenary,
    $21c6e0fb7add73ac$var$tally,
    $21c6e0fb7add73ac$var$rabby,
    $21c6e0fb7add73ac$var$mathwallet,
    $21c6e0fb7add73ac$var$sequence,
    $21c6e0fb7add73ac$var$core,
    $21c6e0fb7add73ac$var$bitski,
    $21c6e0fb7add73ac$var$enkrypt,
    $21c6e0fb7add73ac$var$phantom,
    $21c6e0fb7add73ac$var$okxwallet,
    $21c6e0fb7add73ac$var$zerion,
    $21c6e0fb7add73ac$var$rainbow,
    $21c6e0fb7add73ac$var$safepal,
    $21c6e0fb7add73ac$var$defiwallet,
    $21c6e0fb7add73ac$var$infinitywallet,
    $21c6e0fb7add73ac$var$safeheron,
    $21c6e0fb7add73ac$var$talisman,
    $21c6e0fb7add73ac$var$onekey,
    $21c6e0fb7add73ac$var$fordefi,
    $21c6e0fb7add73ac$var$ronin,
    $21c6e0fb7add73ac$var$coin98wallet,
    $21c6e0fb7add73ac$var$subwallet,
    $21c6e0fb7add73ac$var$kayros,
    $21c6e0fb7add73ac$var$foxwallet,
    $21c6e0fb7add73ac$var$Lif3Wallet,
    $21c6e0fb7add73ac$var$zodiacPilot,
    $21c6e0fb7add73ac$var$stablewallet,
    $21c6e0fb7add73ac$var$echooo,
    $21c6e0fb7add73ac$var$keplr
];
var $21c6e0fb7add73ac$export$2e2bcd8739ae039 = $21c6e0fb7add73ac$var$wallets;



var $a6eMa = parcelRequire("a6eMa");
parcelRequire("8YciW");
var $dkXem = parcelRequire("dkXem");
const $5211390e9135388e$var$walletModule = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    getIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().arity(0).required(),
    getInterface: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().maxArity(1).required(),
    injectedNamespace: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    checkProviderIdentity: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function().arity(1).required(),
    platforms: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()),
    externalUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()
});
const $5211390e9135388e$var$wallets = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items($5211390e9135388e$var$walletModule);
const $5211390e9135388e$var$filter = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object().pattern(/\w+/, (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(), (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string())));
const $5211390e9135388e$var$walletOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    custom: $5211390e9135388e$var$wallets,
    filter: $5211390e9135388e$var$filter,
    displayUnavailable: [
        (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean(),
        (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string())
    ],
    walletUnavailableMessage: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    sort: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).function(),
    externalUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string(),
    disable6963Support: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).boolean()
});
const $5211390e9135388e$export$579090a152b2b16 = (data)=>(0, $dkXem.validate)($5211390e9135388e$var$walletOptions, data);
const $5211390e9135388e$var$eip6963ProviderInfo = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required(),
    rdns: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().required()
});
const $5211390e9135388e$var$eip6963ProviderDetail = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    info: $5211390e9135388e$var$eip6963ProviderInfo.required(),
    provider: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object().required()
});
const $5211390e9135388e$export$9f850aef0c7d58e5 = (data)=>(0, $dkXem.validate)($5211390e9135388e$var$eip6963ProviderDetail, data);


class $3a67a5a0aa960742$export$417589b978208a8f extends Error {
    constructor(error){
        super(error.message);
        this.message = error.message;
        this.code = error.code;
        this.data = error.data;
    }
}
const $3a67a5a0aa960742$export$edcd15c5afc9c733 = ({ label: label, externalUrl: externalUrl })=>externalUrl ? `Please <a href="${externalUrl}" target="_blank">install or switch to</a> ${label} to continue` : `Please install or enable ${label} to continue`;
const $3a67a5a0aa960742$export$4e06f978fc4aa878 = (provider, checkProviderIdentity, device)=>{
    // No injected providers exist.
    if (!provider) return false;
    // Many injected providers add their own object into window.
    if (checkProviderIdentity({
        provider: provider,
        device: device
    })) return true;
    // For multiple injected providers, check providers array
    // example coinbase inj wallet pushes over-ridden wallets
    // into a providers array at window.ethereum
    return Array.isArray(provider.providers) && !!provider.providers?.some((provider)=>checkProviderIdentity({
            provider: provider,
            device: device
        }));
};
function $3a67a5a0aa960742$export$303e63c37a8e91ee(svgString) {
    if (!svgString) return false;
    // Regular expression to match <script> tags
    const scriptTagRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    // Regular expression to match event handler attributes (e.g., onclick, onload)
    const eventHandlerRegex = /\bon[a-z]+\s*=\s*["']?(?:javascript:)?/gi;
    // Regular expression to match href or xlink:href attributes containing "javascript:"
    const hrefJavaScriptRegex = /\b(href|xlink:href)\s*=\s*["']?javascript:/gi;
    // Check for <script> tags
    if (scriptTagRegex.test(svgString)) return true;
    // Check for event handlers
    if (eventHandlerRegex.test(svgString)) return true;
    // Check for "javascript:" in href or xlink:href
    if (hrefJavaScriptRegex.test(svgString)) return true;
    // No executable JavaScript found
    return false;
}


const $7be82505d1105913$var$providers6963 = [];
function $7be82505d1105913$var$checkFor6963Providers() {
    // Add event listener for 'eip6963:announceProvider' event
    window.addEventListener('eip6963:announceProvider', (event)=>{
        const eipEvent = event;
        const { detail: detail } = eipEvent;
        if (!detail) return;
        if (eipEvent) {
            const result = (0, $5211390e9135388e$export$9f850aef0c7d58e5)(detail);
            if (result && result.error) throw result.error;
        }
        const { info: info, provider: provider } = detail;
        const { name: name, icon: icon } = info;
        if ((0, $3a67a5a0aa960742$export$303e63c37a8e91ee)(icon)) {
            console.error(`The icon for injected wallet: ${name} contains executable JavaScript and has been blocked.`);
            return;
        }
        // Push the provider information to the providers6963 array
        $7be82505d1105913$var$providers6963.push({
            label: name,
            getIcon: async ()=>icon,
            getInterface: async ()=>({
                    provider: provider
                }),
            platforms: [
                'all'
            ],
            eip6963Provider: provider,
            checkProviderIdentity: ({ provider: provider })=>!!provider
        });
    });
    // Dispatch a custom event to request the provider information
    window.dispatchEvent(new CustomEvent('eip6963:requestProvider'));
}
function $7be82505d1105913$var$injected(options) {
    if (typeof window === 'undefined') return ()=>null;
    if (options) {
        const result = (0, $5211390e9135388e$export$579090a152b2b16)(options);
        if (result && result.error) throw result.error;
    }
    !options?.disable6963Support && $7be82505d1105913$var$checkFor6963Providers();
    return (helpers)=>{
        const { device: device } = helpers;
        const { custom: custom = [], filter: filter = {}, displayUnavailable: displayUnavailable, sort: sort, walletUnavailableMessage: walletUnavailableMessage } = options || {};
        // combine custom with standard wallets and dedupe
        const allWallets = (0, (/*@__PURE__*/$parcel$interopDefault($k5e8S)))([
            ...custom,
            ...$7be82505d1105913$var$providers6963,
            ...(0, $21c6e0fb7add73ac$export$2e2bcd8739ae039)
        ], ({ label: label })=>label);
        const wallets = allWallets.reduce((acc, wallet)=>{
            const { label: label, platforms: platforms, injectedNamespace: injectedNamespace, checkProviderIdentity: checkProviderIdentity, eip6963Provider: eip6963Provider } = wallet;
            const walletFilters = filter[label];
            const filteredWallet = walletFilters === false;
            const provider = eip6963Provider || window[injectedNamespace];
            const walletAvailable = (0, $3a67a5a0aa960742$export$4e06f978fc4aa878)(provider, checkProviderIdentity, device);
            let excludedDevice = false;
            // dev specified platform filters
            if (Array.isArray(walletFilters) && (walletFilters.includes(device.type) || device.os && walletFilters.includes(device.os.name))) excludedDevice = true;
            // unavailable filter
            if (walletFilters === 'unavailable' && !walletAvailable) excludedDevice = true;
            // wallet specified platform filters
            const invalidPlatform = !platforms.includes('all') && device.type !== null && !platforms.includes(device.type) && !platforms.includes(device.os.name);
            const supportedWallet = !filteredWallet && !excludedDevice && !invalidPlatform && (walletAvailable || displayUnavailable === true || Array.isArray(displayUnavailable) && displayUnavailable.length && displayUnavailable.includes(wallet.label));
            if (supportedWallet) acc.push(// modify wallet to display error if unavailable but displayUnavailable is set
            (displayUnavailable === true || Array.isArray(displayUnavailable) && displayUnavailable.length && displayUnavailable.includes(wallet.label)) && !walletAvailable ? {
                ...wallet,
                getInterface: async ()=>{
                    throw new Error(walletUnavailableMessage ? walletUnavailableMessage(wallet) : (0, $3a67a5a0aa960742$export$edcd15c5afc9c733)(wallet));
                }
            } : wallet);
            return acc;
        }, []);
        if (wallets.length) {
            const moreThanOneWallet = wallets.length > 1;
            // if more than one wallet, then remove detected wallet
            const formattedWallets = wallets.filter((wallet)=>{
                const { label: label } = wallet;
                return !(label === (0, $8d6f5efb5e8e7c50$export$f0b712b78e0e0d3a).Detected && moreThanOneWallet);
            })// then map to the WalletModule interface
            .map(({ label: label, getIcon: getIcon, getInterface: getInterface })=>({
                    label: label,
                    getIcon: getIcon,
                    getInterface: getInterface
                }))// default sort by alphabetical
            .sort((a, b)=>a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
            return sort ? sort(formattedWallets) : formattedWallets;
        }
        return [];
    };
}
var $7be82505d1105913$export$2e2bcd8739ae039 = $7be82505d1105913$var$injected;



var $a6eMa = parcelRequire("a6eMa");
const $126946bc4b92765f$var$wcOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object({
    handleUri: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).func().optional(),
    version: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number().optional().custom((value, helpers)=>{
        if (value === 1) console.warn('Version 1 of WalletConnect has been fully deprecated. This version of @web3-onboard/walletconnect only supports version 2');
        else if (value !== 2 && value !== undefined) return helpers.error('any.invalid', {
            message: 'Invalid version number. This version of @web3-onboard/walletconnect only supports version 2'
        });
        return value; // return the value unchanged if it's valid or not provided
    }, 'Custom version validation'),
    projectId: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().messages({
        'any.required': `WalletConnect version 2 requires a projectId. Please visit https://cloud.walletconnect.com to get one.`
    }),
    dappUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string().optional().custom((value, helpers)=>{
        if (!value) return helpers.message({
            message: 'It is strongly recommended to supply a dappUrl as it is required by some wallets (i.e. MetaMask) to allow connection.',
            type: 'any.custom'
        });
        return value; // return the value unchanged if it's provided
    }, 'Custom dappUrl validation'),
    requiredChains: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number()).optional(),
    optionalChains: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).number()).optional(),
    qrModalOptions: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).object().optional(),
    additionalRequiredMethods: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()).optional(),
    additionalOptionalMethods: (0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($a6eMa))).string()).optional()
});
const $126946bc4b92765f$var$validate = (validator, data)=>{
    const result = validator.validate(data);
    return result.error ? result : null;
};
const $126946bc4b92765f$export$16afb597f1bff25e = (data)=>{
    return $126946bc4b92765f$var$validate($126946bc4b92765f$var$wcOptions, data);
};



// methods that require user interaction
const $dd005ff806a85779$var$methods = [
    'eth_sendTransaction',
    'eth_signTransaction',
    'personal_sign',
    'eth_sign',
    'eth_signTypedData',
    'eth_signTypedData_v4',
    'wallet_addEthereumChain',
    'wallet_switchEthereumChain'
];





function $dd005ff806a85779$var$walletConnect(options) {
    if (!options.projectId) throw new Error('WalletConnect requires a projectId. Please visit https://cloud.walletconnect.com to get one.');
    if (!options.dappUrl) console.warn(`It is strongly recommended to supply a dappUrl to the WalletConnect init object as it is required by some wallets (i.e. MetaMask) to allow connection.`);
    const { projectId: projectId, handleUri: handleUri, requiredChains: requiredChains, optionalChains: optionalChains, qrModalOptions: qrModalOptions, additionalRequiredMethods: additionalRequiredMethods, additionalOptionalMethods: additionalOptionalMethods, dappUrl: dappUrl } = options;
    let instance;
    return ()=>{
        return {
            label: 'WalletConnect',
            getIcon: async ()=>(await (parcelRequire("2oNaq"))).default,
            getInterface: async ({ chains: chains, EventEmitter: EventEmitter, appMetadata: appMetadata })=>{
                const { ProviderRpcError: ProviderRpcError, ProviderRpcErrorCode: ProviderRpcErrorCode } = await Promise.resolve((parcelRequire("8YciW")));
                const { default: EthereumProvider, REQUIRED_METHODS: REQUIRED_METHODS } = await (parcelRequire("e4KMZ"));
                const { Subject: Subject, fromEvent: fromEvent } = await (parcelRequire("byoNu"));
                const { takeUntil: takeUntil, take: take } = await (parcelRequire("hy1tT"));
                const getMetaData = ()=>{
                    if (!appMetadata) return undefined;
                    const url = dappUrl || appMetadata.explore || '';
                    !url && !url.length && console.warn(`It is strongly recommended to supply a dappUrl as it is required by some wallets (i.e. MetaMask) to allow connection.`);
                    const wcMetaData = {
                        name: appMetadata.name,
                        description: appMetadata.description || '',
                        url: url,
                        icons: []
                    };
                    if (appMetadata.icon !== undefined && appMetadata.icon.length) wcMetaData.icons = [
                        appMetadata.icon
                    ];
                    if (appMetadata.logo !== undefined && appMetadata.logo.length) wcMetaData.icons = wcMetaData.icons.length ? [
                        ...wcMetaData.icons,
                        appMetadata.logo
                    ] : [
                        appMetadata.logo
                    ];
                    return wcMetaData;
                };
                // default to mainnet
                const requiredChainsParsed = Array.isArray(requiredChains) && requiredChains.length && requiredChains.every((num)=>!isNaN(num)) ? // Required as WC package does not support hex numbers
                requiredChains.map((chainID)=>parseInt(chainID)) : [];
                // Defaults to the chains provided within the web3-onboard init chain property
                const optionalChainsParsed = Array.isArray(optionalChains) && optionalChains.length && optionalChains.every((num)=>!isNaN(num)) ? // Required as WC package does not support hex numbers
                optionalChains.map((chainID)=>parseInt(chainID)) : chains.map(({ id: id })=>parseInt(id, 16));
                const requiredMethodsSet = new Set(additionalRequiredMethods && Array.isArray(additionalRequiredMethods) ? [
                    ...additionalRequiredMethods,
                    ...REQUIRED_METHODS
                ] : REQUIRED_METHODS);
                const requiredMethods = Array.from(requiredMethodsSet);
                const optionalMethods = additionalOptionalMethods && Array.isArray(additionalOptionalMethods) ? [
                    ...additionalOptionalMethods,
                    ...$dd005ff806a85779$var$methods
                ] : $dd005ff806a85779$var$methods;
                const connector = await EthereumProvider.init({
                    projectId: projectId,
                    chains: requiredChainsParsed,
                    methods: requiredMethods,
                    optionalChains: optionalChainsParsed,
                    optionalMethods: optionalMethods,
                    showQrModal: true,
                    rpcMap: chains.map(({ id: id, rpcUrl: rpcUrl })=>({
                            id: id,
                            rpcUrl: rpcUrl
                        })).reduce((rpcMap, { id: id, rpcUrl: rpcUrl })=>{
                        rpcMap[parseInt(id, 16)] = rpcUrl || '';
                        return rpcMap;
                    }, {}),
                    metadata: getMetaData(),
                    qrModalOptions: qrModalOptions
                });
                const emitter = new EventEmitter();
                class EthProvider {
                    constructor({ connector: connector, chains: chains }){
                        this.emit = emitter.emit.bind(emitter);
                        this.on = emitter.on.bind(emitter);
                        this.removeListener = emitter.removeListener.bind(emitter);
                        this.connector = connector;
                        this.chains = chains;
                        this.disconnected$ = new Subject();
                        // listen for accountsChanged
                        fromEvent(this.connector, 'accountsChanged', (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe({
                            next: (payload)=>{
                                const accounts = Array.isArray(payload) ? payload : [
                                    payload
                                ];
                                this.emit('accountsChanged', accounts);
                            },
                            error: console.warn
                        });
                        // listen for chainChanged
                        fromEvent(this.connector, 'chainChanged', (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe({
                            next: (chainId)=>{
                                const hexChainId = (0, $24fc5fc17ae2250f$export$b02a40aff8e4ad18)(chainId) ? chainId : `0x${chainId.toString(16)}`;
                                this.emit('chainChanged', hexChainId);
                            },
                            error: console.warn
                        });
                        // listen for disconnect event
                        fromEvent(this.connector, 'session_delete', (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe({
                            next: ()=>{
                                this.emit('accountsChanged', []);
                                this.disconnected$.next(true);
                                typeof localStorage !== 'undefined' && localStorage.removeItem('walletconnect');
                            },
                            error: console.warn
                        });
                        this.disconnect = ()=>{
                            if (this.connector.session) {
                                this.connector.disconnect();
                                instance = null;
                            }
                        };
                        if (options && handleUri) // listen for uri event
                        fromEvent(this.connector, 'display_uri', (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe(async (uri)=>{
                            try {
                                handleUri && await handleUri(uri);
                            } catch (error) {
                                throw `An error occurred when handling the URI. Error: ${error}`;
                            }
                        });
                        const checkForSession = ()=>{
                            const session = this.connector.session;
                            instance = session;
                            if (session) {
                                this.emit('accountsChanged', this.connector.accounts);
                                this.emit('chainChanged', this.connector.chainId);
                            }
                        };
                        checkForSession();
                        this.request = async ({ method: method, params: params })=>{
                            if (method === 'eth_chainId') return (0, $24fc5fc17ae2250f$export$b02a40aff8e4ad18)(this.connector.chainId) ? this.connector.chainId : `0x${this.connector.chainId.toString(16)}`;
                            if (method === 'eth_requestAccounts') return new Promise(async (resolve, reject)=>{
                                // Subscribe to connection events
                                fromEvent(this.connector, 'connect', (payload)=>payload).pipe(take(1)).subscribe({
                                    next: ({ chainId: chainId })=>{
                                        this.emit('accountsChanged', this.connector.accounts);
                                        const hexChainId = (0, $24fc5fc17ae2250f$export$b02a40aff8e4ad18)(chainId) ? chainId : `0x${chainId.toString(16)}`;
                                        this.emit('chainChanged', hexChainId);
                                        resolve(this.connector.accounts);
                                    },
                                    error: reject
                                });
                                // Check if connection is already established
                                if (!this.connector.session) // create new session
                                await this.connector.connect().catch((err)=>{
                                    console.error('err creating new session: ', err);
                                    reject(new ProviderRpcError({
                                        code: 4001,
                                        message: 'User rejected the request.'
                                    }));
                                });
                                else {
                                    // update ethereum provider to load accounts & chainId
                                    const accounts = this.connector.accounts;
                                    const chainId = this.connector.chainId;
                                    instance = this.connector.session;
                                    const hexChainId = `0x${chainId.toString(16)}`;
                                    this.emit('chainChanged', hexChainId);
                                    return resolve(accounts);
                                }
                            });
                            if (method === 'eth_selectAccounts') throw new ProviderRpcError({
                                code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
                                message: `The Provider does not support the requested method: ${method}`
                            });
                            if (method == 'wallet_switchEthereumChain') {
                                if (!params) throw new ProviderRpcError({
                                    code: ProviderRpcErrorCode.INVALID_PARAMS,
                                    message: `The Provider requires a chainId to be passed in as an argument`
                                });
                                const chainIdObj = params[0];
                                if (!chainIdObj.hasOwnProperty('chainId') || typeof chainIdObj['chainId'] === 'undefined') throw new ProviderRpcError({
                                    code: ProviderRpcErrorCode.INVALID_PARAMS,
                                    message: `The Provider requires a chainId to be passed in as an argument`
                                });
                                return this.connector.request({
                                    method: 'wallet_switchEthereumChain',
                                    params: [
                                        {
                                            chainId: chainIdObj.chainId
                                        }
                                    ]
                                });
                            }
                            return this.connector.request({
                                method: method,
                                params: params
                            });
                        };
                    }
                }
                return {
                    provider: new EthProvider({
                        chains: chains,
                        connector: connector
                    }),
                    instance: instance
                };
            }
        };
    };
}
var $dd005ff806a85779$export$2e2bcd8739ae039 = $dd005ff806a85779$var$walletConnect;


const $24fc5fc17ae2250f$export$b02a40aff8e4ad18 = (value)=>{
    if (typeof value !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    return true;
};
function $24fc5fc17ae2250f$var$initWalletConnect(options) {
    if (!options) throw new Error(`WalletConnect requires an initialization object to be passed - see the official docs for an example: https://web3onboard.thirdweb.com/docs/wallets/walletconnect`);
    if (options) {
        const error = (0, $126946bc4b92765f$export$16afb597f1bff25e)(options);
        if (error) throw error;
    }
    return (0, $dd005ff806a85779$export$2e2bcd8739ae039)(options);
}
var $24fc5fc17ae2250f$export$2e2bcd8739ae039 = $24fc5fc17ae2250f$var$initWalletConnect;





function $0be495f738215320$var$coinbaseWallet({ supportedWalletType: supportedWalletType = 'all', darkMode: darkMode = false, enableMobileWalletLink: enableMobileWalletLink = false, reloadOnDisconnect: reloadOnDisconnect = true } = {}) {
    return ()=>{
        return {
            label: 'Coinbase Wallet',
            getIcon: async ()=>(await (parcelRequire("at7NX"))).default,
            getInterface: async ({ chains: chains, appMetadata: appMetadata })=>{
                if (enableMobileWalletLink || reloadOnDisconnect || darkMode) console.warn('darkMode, enableMobileWalletLink and reloadOnDisconnect init props are deprecated after version 2.2.7 of @web3-onboard/coinbase');
                const { name: name, icon: icon } = appMetadata || {};
                // according to https://github.com/wagmi-dev/wagmi/issues/383
                // @coinbase/wallet-sdk export double default fields
                // so we need to detect it to get the real constructor
                const { default: CoinbaseWalletSDK } = await (parcelRequire("lKreI"));
                const CoinbaseWalletSDKConstructor = CoinbaseWalletSDK.default ? CoinbaseWalletSDK.default : CoinbaseWalletSDK;
                const { isHex: isHex, toHex: toHex, createEIP1193Provider: createEIP1193Provider, fromHex: fromHex } = await Promise.resolve((parcelRequire("8YciW")));
                const base64 = window.btoa(icon || '');
                const appLogoUrl = `data:image/svg+xml;base64,${base64}`;
                const appChainIds = chains.map(({ id: id })=>fromHex(id, 'number'));
                const instance = new CoinbaseWalletSDKConstructor({
                    appName: name || '',
                    appLogoUrl: appLogoUrl,
                    appChainIds: appChainIds
                });
                const coinbaseWalletProvider = instance.makeWeb3Provider({
                    options: supportedWalletType
                });
                // patch the chainChanged event
                const on = coinbaseWalletProvider.on.bind(coinbaseWalletProvider);
                coinbaseWalletProvider.on = (event, listener)=>{
                    // @ts-ignore
                    on(event, (val)=>{
                        if (event === 'chainChanged') {
                            let hexVal;
                            if (isHex(val)) hexVal = val;
                            else hexVal = toHex(val);
                            // @ts-ignore
                            listener(hexVal);
                            return;
                        }
                        listener(val);
                    });
                    return coinbaseWalletProvider;
                };
                const provider = createEIP1193Provider(coinbaseWalletProvider);
                provider.removeListener = (event, func)=>{};
                return {
                    provider: provider,
                    instance: instance
                };
            }
        };
    };
}
var $0be495f738215320$export$2e2bcd8739ae039 = $0be495f738215320$var$coinbaseWallet;






function $5fbc42cca8c58e58$var$gnosis(options) {
    const { whitelistedDomains: whitelistedDomains = [
        /^https:\/\/app\.safe\.global$/,
        /^https:\/\/safe\.global$/,
        /^https:\/\/.*\.blockscout\.com$/,
        /^https:\/\/pilot\.gnosisguild\.org$/
    ] } = options || {};
    return ()=>{
        const loadedInIframe = window.self !== window.top;
        return loadedInIframe ? {
            label: 'Safe',
            getIcon: async ()=>(await (parcelRequire("h6ye4"))).default,
            getInterface: async ()=>{
                const { default: SafeAppsSDK } = await (parcelRequire("78Hhk"));
                const { SafeAppProvider: SafeAppProvider } = await (parcelRequire("jYbj1"));
                const { createEIP1193Provider: createEIP1193Provider } = await Promise.resolve((parcelRequire("8YciW")));
                const SafeAppProviderConstructor = // @ts-ignore
                SafeAppsSDK.default || SafeAppsSDK;
                const opts = {
                    allowedDomains: whitelistedDomains
                };
                const appsSdk = new SafeAppProviderConstructor(opts);
                const safe = await Promise.race([
                    appsSdk.safe.getInfo(),
                    new Promise((resolve)=>setTimeout(resolve, 200))
                ]);
                if (!safe) throw new Error(`App must be loaded in a Safe App context, head to <a href="https://app.safe.global/">the Safe</a> and open this website as an app.`);
                const provider = new SafeAppProvider(safe, // @ts-ignore
                appsSdk);
                const patchedProvider = createEIP1193Provider(provider, {
                    eth_requestAccounts: ()=>Promise.resolve([
                            safe.safeAddress
                        ])
                });
                return {
                    provider: patchedProvider,
                    instance: appsSdk
                };
            }
        } : [];
    };
}
var $5fbc42cca8c58e58$export$2e2bcd8739ae039 = $5fbc42cca8c58e58$var$gnosis;




const $4073165241fd3590$var$loadImports = async ()=>{
    if ($4073165241fd3590$var$importPromise) return await $4073165241fd3590$var$importPromise;
    const { createEIP1193Provider: createEIP1193Provider } = await Promise.resolve((parcelRequire("8YciW")));
    const importedSDK = await (parcelRequire("ewB2v"));
    const MetaMaskSDKConstructor = // @ts-ignore
    importedSDK.MetaMaskSDK || importedSDK.default.MetaMaskSDK;
    if (!MetaMaskSDKConstructor) throw new Error('Error importing and initializing MetaMask SDK');
    return {
        createEIP1193Provider: createEIP1193Provider,
        MetaMaskSDKConstructor: MetaMaskSDKConstructor
    };
};
let $4073165241fd3590$var$importPromise = null;
let $4073165241fd3590$var$sdk = null;

function $4073165241fd3590$var$metamask({ options: options }) {
    return ()=>{
        $4073165241fd3590$var$importPromise = $4073165241fd3590$var$loadImports().catch((error)=>{
            throw error;
        });
        return {
            label: 'MetaMask',
            getIcon: async ()=>(await (parcelRequire("iciN3"))).default,
            getInterface: async ({ appMetadata: appMetadata })=>{
                var _a, _b;
                $4073165241fd3590$var$sdk = window.mmsdk || $4073165241fd3590$var$sdk; // Prevent conflict with existing mmsdk instances
                if ($4073165241fd3590$var$sdk) // Prevent re-initializing instance as it causes issues with MetaMask sdk mobile provider.
                return {
                    provider: $4073165241fd3590$var$sdk.getProvider(),
                    instance: $4073165241fd3590$var$sdk
                };
                const { name: name, icon: icon } = appMetadata || {};
                const base64 = window.btoa(icon || '');
                const appLogoUrl = `data:image/svg+xml;base64,${base64}`;
                const imports = await $4073165241fd3590$var$importPromise;
                if (!(imports === null || imports === void 0 ? void 0 : imports.MetaMaskSDKConstructor)) throw new Error('Error importing and initializing MetaMask SDK');
                const { MetaMaskSDKConstructor: MetaMaskSDKConstructor } = imports;
                $4073165241fd3590$var$sdk = new MetaMaskSDKConstructor({
                    ...options,
                    dappMetadata: {
                        name: ((_a = options.dappMetadata) === null || _a === void 0 ? void 0 : _a.name) || name || '',
                        url: ((_b = options.dappMetadata) === null || _b === void 0 ? void 0 : _b.url) || window.location.origin,
                        base64Icon: appLogoUrl
                    },
                    _source: 'web3-onboard'
                });
                await $4073165241fd3590$var$sdk.init();
                const provider = $4073165241fd3590$var$sdk.getProvider();
                if (provider) provider.disconnect = ()=>{
                    $4073165241fd3590$var$sdk === null || $4073165241fd3590$var$sdk === void 0 || $4073165241fd3590$var$sdk.terminate();
                };
                return {
                    provider: provider,
                    instance: $4073165241fd3590$var$sdk
                };
            }
        };
    };
}
var $4073165241fd3590$export$2e2bcd8739ae039 = $4073165241fd3590$var$metamask;


function $92cf10dad360a3d9$export$11027cbf6cf15da2(account) {
    if (typeof account === 'string') return {
        address: account,
        type: 'json-rpc'
    };
    return account;
}



var $4zvKQ = parcelRequire("4zvKQ");
function $50efdd063d6eb24a$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, chain: chain, ccipRead: ccipRead, dataSuffix: dataSuffix, key: key = 'base', name: name = 'Base Client', type: type = 'base' } = parameters;
    const experimental_blockTag = parameters.experimental_blockTag ?? (typeof chain?.experimental_preconfirmationTime === 'number' ? 'pending' : undefined);
    const blockTime = chain?.blockTime ?? 12000;
    const defaultPollingInterval = Math.min(Math.max(Math.floor(blockTime / 2), 500), 4000);
    const pollingInterval = parameters.pollingInterval ?? defaultPollingInterval;
    const cacheTime = parameters.cacheTime ?? pollingInterval;
    const account = parameters.account ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        account: account,
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        ccipRead: ccipRead,
        chain: chain,
        dataSuffix: dataSuffix,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $4zvKQ.uid)(),
        ...experimental_blockTag ? {
            experimental_blockTag: experimental_blockTag
        } : {}
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}
function $50efdd063d6eb24a$export$3db60a9e016ddd81() {
    return null;
}




var $3vvQ3 = parcelRequire("3vvQ3");

var $5jfXj = parcelRequire("5jfXj");
class $c631a92240a7f7f4$export$200c092bedf29ac0 extends (0, $5jfXj.BaseError) {
    constructor(){
        super('`baseFeeMultiplier` must be greater than 1.', {
            name: 'BaseFeeScalarError'
        });
    }
}
class $c631a92240a7f7f4$export$dcf53c0ae183fb46 extends (0, $5jfXj.BaseError) {
    constructor(){
        super('Chain does not support EIP-1559 fees.', {
            name: 'Eip1559FeesNotSupportedError'
        });
    }
}
class $c631a92240a7f7f4$export$bcf9730904a1086f extends (0, $5jfXj.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $3vvQ3.formatGwei)(maxPriorityFeePerGas)} gwei).`, {
            name: 'MaxFeePerGasTooLowError'
        });
    }
}



var $l8lWo = parcelRequire("l8lWo");

var $fTKJh = parcelRequire("fTKJh");

var $5Hedk = parcelRequire("5Hedk");
function $35711cc57a2002ea$export$11bc63b4c03ea518(wei, unit = 'wei') {
    return (0, $5Hedk.formatUnits)(wei, (0, $fTKJh.etherUnits)[unit]);
}



var $3vvQ3 = parcelRequire("3vvQ3");

var $5jfXj = parcelRequire("5jfXj");
function $8f6a5f9d053a5a2a$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join('\n');
}
class $8f6a5f9d053a5a2a$export$4e13f9693b10724d extends (0, $5jfXj.BaseError) {
    constructor(){
        super([
            'Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.',
            'Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others.'
        ].join('\n'), {
            name: 'FeeConflictError'
        });
    }
}
class $8f6a5f9d053a5a2a$export$8ffce3f13fa2ade4 extends (0, $5jfXj.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
            name: 'InvalidLegacyVError'
        });
    }
}
class $8f6a5f9d053a5a2a$export$f2282ba9c8899971 extends (0, $5jfXj.BaseError) {
    constructor({ transaction: transaction }){
        super('Cannot infer a transaction type from provided transaction.', {
            metaMessages: [
                'Provided Transaction:',
                '{',
                $8f6a5f9d053a5a2a$export$cde3d1388a9feac3(transaction),
                '}',
                '',
                'To infer the type, either provide:',
                '- a `type` to the Transaction, or',
                '- an EIP-1559 Transaction with `maxFeePerGas`, or',
                '- an EIP-2930 Transaction with `gasPrice` & `accessList`, or',
                '- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or',
                '- an EIP-7702 Transaction with `authorizationList`, or',
                '- a Legacy Transaction with `gasPrice`'
            ],
            name: 'InvalidSerializableTransactionError'
        });
    }
}
class $8f6a5f9d053a5a2a$export$e410925d6bb07863 extends (0, $5jfXj.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`, {
            name: 'InvalidSerializedTransactionType'
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $8f6a5f9d053a5a2a$export$75fa267d8b74b3b9 extends (0, $5jfXj.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === 'undefined' ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(', ')}` : ''
            ].filter(Boolean),
            name: 'InvalidSerializedTransactionError'
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $8f6a5f9d053a5a2a$export$f5e370fd7cd91580 extends (0, $5jfXj.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, {
            name: 'InvalidStorageKeySizeError'
        });
    }
}
class $8f6a5f9d053a5a2a$export$17fc407b5aeb1e96 extends (0, $5jfXj.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $8f6a5f9d053a5a2a$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== 'undefined' && `${(0, $35711cc57a2002ea$export$11bc63b4c03ea518)(value)} ${chain?.nativeCurrency?.symbol || 'ETH'}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== 'undefined' && `${(0, $3vvQ3.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== 'undefined' && `${(0, $3vvQ3.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' && `${(0, $3vvQ3.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    ' '
                ] : [],
                'Request Arguments:',
                prettyArgs
            ].filter(Boolean),
            name: 'TransactionExecutionError'
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $8f6a5f9d053a5a2a$export$23c42bc218867b7c extends (0, $5jfXj.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = 'Transaction';
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`, {
            name: 'TransactionNotFoundError'
        });
    }
}
class $8f6a5f9d053a5a2a$export$df65591684d92652 extends (0, $5jfXj.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`, {
            name: 'TransactionReceiptNotFoundError'
        });
    }
}
class $8f6a5f9d053a5a2a$export$f0f1b8be51f0d2a2 extends (0, $5jfXj.BaseError) {
    constructor({ receipt: receipt }){
        super(`Transaction with hash "${receipt.transactionHash}" reverted.`, {
            metaMessages: [
                'The receipt marked the transaction as "reverted". This could mean that the function on the contract you are trying to call threw an error.',
                ' ',
                'You can attempt to extract the revert reason by:',
                '- calling the `simulateContract` or `simulateCalls` Action with the `abi` and `functionName` of the contract',
                '- using the `call` Action with raw `data`'
            ],
            name: 'TransactionReceiptRevertedError'
        });
        Object.defineProperty(this, "receipt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.receipt = receipt;
    }
}
class $8f6a5f9d053a5a2a$export$69578a09754f4b33 extends (0, $5jfXj.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`, {
            name: 'WaitForTransactionReceiptTimeoutError'
        });
    }
}



var $5jfXj = parcelRequire("5jfXj");

var $l8lWo = parcelRequire("l8lWo");

var $jLSJ6 = parcelRequire("jLSJ6");

var $atQmZ = parcelRequire("atQmZ");
function $10675c8d6dde5afa$export$620efda101db5601(err) {
    return err instanceof (0, $atQmZ.TransactionRejectedRpcError) || err instanceof (0, $atQmZ.InvalidInputRpcError) || err instanceof (0, $jLSJ6.RpcRequestError) && err.code === (0, $l8lWo.ExecutionRevertedError).code;
}
function $10675c8d6dde5afa$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || '').toLowerCase();
    const executionRevertedError = err instanceof (0, $5jfXj.BaseError) ? err.walk((e)=>e?.code === (0, $l8lWo.ExecutionRevertedError).code) : err;
    if (executionRevertedError instanceof (0, $5jfXj.BaseError)) return new (0, $l8lWo.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $l8lWo.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $l8lWo.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $l8lWo.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $l8lWo.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $l8lWo.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $l8lWo.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $l8lWo.NonceTooHighError).nodeMessage.test(message)) return new (0, $l8lWo.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $l8lWo.NonceTooLowError).nodeMessage.test(message)) return new (0, $l8lWo.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $l8lWo.NonceMaxValueError).nodeMessage.test(message)) return new (0, $l8lWo.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $l8lWo.InsufficientFundsError).nodeMessage.test(message)) return new (0, $l8lWo.InsufficientFundsError)({
        cause: err
    });
    if ((0, $l8lWo.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $l8lWo.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $l8lWo.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $l8lWo.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $l8lWo.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $l8lWo.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $l8lWo.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $l8lWo.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $l8lWo.UnknownNodeError)({
        cause: err
    });
}


function $db3d75d11c8bc083$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $10675c8d6dde5afa$export$218ee3a1c831c34e)(err, args);
        if (cause instanceof (0, $l8lWo.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $8f6a5f9d053a5a2a$export$17fc407b5aeb1e96)(cause, {
        docsPath: docsPath,
        ...args
    });
}


/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $0c055ac55d996b1d$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === 'object' && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}



var $lz1vU = parcelRequire("lz1vU");
function $67ba667d98a92ada$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args, action)=>{
                const formatted = format(args, action);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args, action)
                };
            },
            type: type
        };
    };
}


const $014d88210c5bc9cd$export$cd5f936b62a5e91 = {
    '0x0': 'legacy',
    '0x1': 'eip2930',
    '0x2': 'eip1559',
    '0x3': 'eip4844',
    '0x4': 'eip7702'
};
function $014d88210c5bc9cd$export$b02b16590d26dadc(transaction, _) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        ...transaction.blockTimestamp != null && {
            blockTimestamp: BigInt(transaction.blockTimestamp)
        },
        chainId: transaction.chainId ? (0, $lz1vU.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $lz1vU.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $014d88210c5bc9cd$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    if (transaction.authorizationList) transaction_.authorizationList = $014d88210c5bc9cd$var$formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === 'bigint') {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === 'legacy') {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === 'eip2930') {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === 'eip1559') delete transaction_.maxFeePerBlobGas;
    return transaction_;
}
const $014d88210c5bc9cd$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $67ba667d98a92ada$export$5d08535cc975931a)('transaction', $014d88210c5bc9cd$export$b02b16590d26dadc);
//////////////////////////////////////////////////////////////////////////////
function $014d88210c5bc9cd$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.address,
            chainId: Number(authorization.chainId),
            nonce: Number(authorization.nonce),
            r: authorization.r,
            s: authorization.s,
            yParity: Number(authorization.yParity)
        }));
}



var $cD3gI = parcelRequire("cD3gI");

const $1df22e1e5334c1dd$export$b2a848539dcbb25f = {
    legacy: '0x0',
    eip2930: '0x1',
    eip1559: '0x2',
    eip4844: '0x3',
    eip7702: '0x4'
};
function $1df22e1e5334c1dd$export$d23fcba447c86a8e(request, _) {
    const rpcRequest = {};
    if (typeof request.authorizationList !== 'undefined') rpcRequest.authorizationList = $1df22e1e5334c1dd$var$formatAuthorizationList(request.authorizationList);
    if (typeof request.accessList !== 'undefined') rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== 'undefined') rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== 'undefined') {
        if (typeof request.blobs[0] !== 'string') rpcRequest.blobs = request.blobs.map((x)=>(0, $cD3gI.bytesToHex)(x));
        else rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== 'undefined') rpcRequest.data = request.data;
    if (request.account) rpcRequest.from = request.account.address;
    if (typeof request.from !== 'undefined') rpcRequest.from = request.from;
    if (typeof request.gas !== 'undefined') rpcRequest.gas = (0, $cD3gI.numberToHex)(request.gas);
    if (typeof request.gasPrice !== 'undefined') rpcRequest.gasPrice = (0, $cD3gI.numberToHex)(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== 'undefined') rpcRequest.maxFeePerBlobGas = (0, $cD3gI.numberToHex)(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== 'undefined') rpcRequest.maxFeePerGas = (0, $cD3gI.numberToHex)(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== 'undefined') rpcRequest.maxPriorityFeePerGas = (0, $cD3gI.numberToHex)(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== 'undefined') rpcRequest.nonce = (0, $cD3gI.numberToHex)(request.nonce);
    if (typeof request.to !== 'undefined') rpcRequest.to = request.to;
    if (typeof request.type !== 'undefined') rpcRequest.type = $1df22e1e5334c1dd$export$b2a848539dcbb25f[request.type];
    if (typeof request.value !== 'undefined') rpcRequest.value = (0, $cD3gI.numberToHex)(request.value);
    return rpcRequest;
}
const $1df22e1e5334c1dd$export$aba208618cee26e3 = /*#__PURE__*/ (0, $67ba667d98a92ada$export$5d08535cc975931a)('transactionRequest', $1df22e1e5334c1dd$export$d23fcba447c86a8e);
//////////////////////////////////////////////////////////////////////////////
function $1df22e1e5334c1dd$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.address,
            r: authorization.r ? (0, $cD3gI.numberToHex)(BigInt(authorization.r)) : authorization.r,
            s: authorization.s ? (0, $cD3gI.numberToHex)(BigInt(authorization.s)) : authorization.s,
            chainId: (0, $cD3gI.numberToHex)(authorization.chainId),
            nonce: (0, $cD3gI.numberToHex)(authorization.nonce),
            ...typeof authorization.yParity !== 'undefined' ? {
                yParity: (0, $cD3gI.numberToHex)(authorization.yParity)
            } : {},
            ...typeof authorization.v !== 'undefined' && typeof authorization.yParity === 'undefined' ? {
                v: (0, $cD3gI.numberToHex)(authorization.v)
            } : {}
        }));
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $26baef92b6d9efec$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === 'function') return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === 'function') return action_explicit;
    return (params)=>actionFn(client, params);
}



const $16127c6b6c27d616$export$bdd7109439799cdf = 2n ** (8n - 1n) - 1n;
const $16127c6b6c27d616$export$eee94935c9b963a1 = 2n ** (16n - 1n) - 1n;
const $16127c6b6c27d616$export$e91fe5d90cd4a2f6 = 2n ** (24n - 1n) - 1n;
const $16127c6b6c27d616$export$25c0796c740353c4 = 2n ** (32n - 1n) - 1n;
const $16127c6b6c27d616$export$ac2072b1e721a92d = 2n ** (40n - 1n) - 1n;
const $16127c6b6c27d616$export$7b7c71fa48943f3 = 2n ** (48n - 1n) - 1n;
const $16127c6b6c27d616$export$e27ce19a567c9842 = 2n ** (56n - 1n) - 1n;
const $16127c6b6c27d616$export$a51b0cf29ddb8e40 = 2n ** (64n - 1n) - 1n;
const $16127c6b6c27d616$export$347f40d3f7572e5a = 2n ** (72n - 1n) - 1n;
const $16127c6b6c27d616$export$940f45cde4f61aed = 2n ** (80n - 1n) - 1n;
const $16127c6b6c27d616$export$13cad54caf92841d = 2n ** (88n - 1n) - 1n;
const $16127c6b6c27d616$export$872296ce91d7dabe = 2n ** (96n - 1n) - 1n;
const $16127c6b6c27d616$export$404112bd52c31da4 = 2n ** (104n - 1n) - 1n;
const $16127c6b6c27d616$export$1d4284abecdbf56d = 2n ** (112n - 1n) - 1n;
const $16127c6b6c27d616$export$35201a0fd5d34f18 = 2n ** (120n - 1n) - 1n;
const $16127c6b6c27d616$export$92415df5352289c7 = 2n ** (128n - 1n) - 1n;
const $16127c6b6c27d616$export$ccb03f6a03d6e182 = 2n ** (136n - 1n) - 1n;
const $16127c6b6c27d616$export$cbf030aa46ccd63 = 2n ** (144n - 1n) - 1n;
const $16127c6b6c27d616$export$33ad14852d23a660 = 2n ** (152n - 1n) - 1n;
const $16127c6b6c27d616$export$6429af277dbaae06 = 2n ** (160n - 1n) - 1n;
const $16127c6b6c27d616$export$2b154fcf8b3c7a42 = 2n ** (168n - 1n) - 1n;
const $16127c6b6c27d616$export$6ba90f949100477a = 2n ** (176n - 1n) - 1n;
const $16127c6b6c27d616$export$a353fb8a621e38fd = 2n ** (184n - 1n) - 1n;
const $16127c6b6c27d616$export$ad4f6360abea4fa4 = 2n ** (192n - 1n) - 1n;
const $16127c6b6c27d616$export$381549e0b0f272ab = 2n ** (200n - 1n) - 1n;
const $16127c6b6c27d616$export$a083a4afa1a2c00c = 2n ** (208n - 1n) - 1n;
const $16127c6b6c27d616$export$ee8f6a880c431cd3 = 2n ** (216n - 1n) - 1n;
const $16127c6b6c27d616$export$a8672844e0af1027 = 2n ** (224n - 1n) - 1n;
const $16127c6b6c27d616$export$57c45c845403e7a5 = 2n ** (232n - 1n) - 1n;
const $16127c6b6c27d616$export$e8e88f55ae4a3354 = 2n ** (240n - 1n) - 1n;
const $16127c6b6c27d616$export$ebbd894fe518c064 = 2n ** (248n - 1n) - 1n;
const $16127c6b6c27d616$export$e4d673aa7367981c = 2n ** (256n - 1n) - 1n;
const $16127c6b6c27d616$export$ef9b9e1988c51720 = -(2n ** (8n - 1n));
const $16127c6b6c27d616$export$b923fba4a82cad48 = -(2n ** (16n - 1n));
const $16127c6b6c27d616$export$7b0286602251a7c7 = -(2n ** (24n - 1n));
const $16127c6b6c27d616$export$5f0d0d25b56bbb4f = -(2n ** (32n - 1n));
const $16127c6b6c27d616$export$4c07a8deea2258b1 = -(2n ** (40n - 1n));
const $16127c6b6c27d616$export$6a6c2e4f279545ff = -(2n ** (48n - 1n));
const $16127c6b6c27d616$export$1739c13d967d68b1 = -(2n ** (56n - 1n));
const $16127c6b6c27d616$export$14e6fedf9fb9d75c = -(2n ** (64n - 1n));
const $16127c6b6c27d616$export$bc3defde0bfb8bd = -(2n ** (72n - 1n));
const $16127c6b6c27d616$export$8efa66e0d946dfd2 = -(2n ** (80n - 1n));
const $16127c6b6c27d616$export$80ab8bed90b29bfe = -(2n ** (88n - 1n));
const $16127c6b6c27d616$export$39c4444aac2d0d86 = -(2n ** (96n - 1n));
const $16127c6b6c27d616$export$28fd4a9e64dafe7b = -(2n ** (104n - 1n));
const $16127c6b6c27d616$export$38cae674fedc8f74 = -(2n ** (112n - 1n));
const $16127c6b6c27d616$export$6779113dfecc5d69 = -(2n ** (120n - 1n));
const $16127c6b6c27d616$export$93cc92d28d07644b = -(2n ** (128n - 1n));
const $16127c6b6c27d616$export$4acf8238e6d61d3e = -(2n ** (136n - 1n));
const $16127c6b6c27d616$export$ac974246b2ca90ec = -(2n ** (144n - 1n));
const $16127c6b6c27d616$export$77d4dfc3aa958440 = -(2n ** (152n - 1n));
const $16127c6b6c27d616$export$a9a1ab546428ca6f = -(2n ** (160n - 1n));
const $16127c6b6c27d616$export$aca1dbffc71a377a = -(2n ** (168n - 1n));
const $16127c6b6c27d616$export$1ca77ffa68208066 = -(2n ** (176n - 1n));
const $16127c6b6c27d616$export$e74092b0e35f2385 = -(2n ** (184n - 1n));
const $16127c6b6c27d616$export$5f53c97c87f852f4 = -(2n ** (192n - 1n));
const $16127c6b6c27d616$export$df01e80cffe255dc = -(2n ** (200n - 1n));
const $16127c6b6c27d616$export$155f043c7b06e008 = -(2n ** (208n - 1n));
const $16127c6b6c27d616$export$195a5ffec9c679b8 = -(2n ** (216n - 1n));
const $16127c6b6c27d616$export$b1ee6eacfb96c50c = -(2n ** (224n - 1n));
const $16127c6b6c27d616$export$16bdbfee8230ad51 = -(2n ** (232n - 1n));
const $16127c6b6c27d616$export$5715ad8f9991a9a2 = -(2n ** (240n - 1n));
const $16127c6b6c27d616$export$9146117a246b63ab = -(2n ** (248n - 1n));
const $16127c6b6c27d616$export$5d31694d80b27ae5 = -(2n ** (256n - 1n));
const $16127c6b6c27d616$export$7db2ab1a72670716 = 2n ** 8n - 1n;
const $16127c6b6c27d616$export$e4e112958a94d87f = 2n ** 16n - 1n;
const $16127c6b6c27d616$export$1bea6075c2df6828 = 2n ** 24n - 1n;
const $16127c6b6c27d616$export$48716e5eecd83bf7 = 2n ** 32n - 1n;
const $16127c6b6c27d616$export$dc2184b5c9263ac7 = 2n ** 40n - 1n;
const $16127c6b6c27d616$export$e639b3656891925b = 2n ** 48n - 1n;
const $16127c6b6c27d616$export$bea470c1abdb1310 = 2n ** 56n - 1n;
const $16127c6b6c27d616$export$3f17b1570950699c = 2n ** 64n - 1n;
const $16127c6b6c27d616$export$8135da85ae9b595b = 2n ** 72n - 1n;
const $16127c6b6c27d616$export$caa80683240e3b73 = 2n ** 80n - 1n;
const $16127c6b6c27d616$export$8e50c223f761a8cf = 2n ** 88n - 1n;
const $16127c6b6c27d616$export$621d3d87b73138e5 = 2n ** 96n - 1n;
const $16127c6b6c27d616$export$4e5098f4748a9a4d = 2n ** 104n - 1n;
const $16127c6b6c27d616$export$1435b580b943ede2 = 2n ** 112n - 1n;
const $16127c6b6c27d616$export$4362e740aadf7dab = 2n ** 120n - 1n;
const $16127c6b6c27d616$export$380ebe6b2fc5caa9 = 2n ** 128n - 1n;
const $16127c6b6c27d616$export$6c13d06e0cefb9aa = 2n ** 136n - 1n;
const $16127c6b6c27d616$export$fe2d415b41e5f433 = 2n ** 144n - 1n;
const $16127c6b6c27d616$export$c2f2754e23c5488a = 2n ** 152n - 1n;
const $16127c6b6c27d616$export$34fcca92c372a91b = 2n ** 160n - 1n;
const $16127c6b6c27d616$export$32e3523cb82cc8a0 = 2n ** 168n - 1n;
const $16127c6b6c27d616$export$d36711d6637bde95 = 2n ** 176n - 1n;
const $16127c6b6c27d616$export$9211611648dd09a2 = 2n ** 184n - 1n;
const $16127c6b6c27d616$export$4e61cbaa2231cfdd = 2n ** 192n - 1n;
const $16127c6b6c27d616$export$9187c63f331d335b = 2n ** 200n - 1n;
const $16127c6b6c27d616$export$7f910799edc7ae97 = 2n ** 208n - 1n;
const $16127c6b6c27d616$export$64506e5a2676ecb0 = 2n ** 216n - 1n;
const $16127c6b6c27d616$export$a060896418206521 = 2n ** 224n - 1n;
const $16127c6b6c27d616$export$18b000c2bc5e114 = 2n ** 232n - 1n;
const $16127c6b6c27d616$export$253bb52e7f7a3909 = 2n ** 240n - 1n;
const $16127c6b6c27d616$export$d5a8ad83a637081c = 2n ** 248n - 1n;
const $16127c6b6c27d616$export$48de485e50a67ffa = 2n ** 256n - 1n;



var $eCsKB = parcelRequire("eCsKB");

var $l8lWo = parcelRequire("l8lWo");

var $9GvsK = parcelRequire("9GvsK");
function $6f98ca205ab4eb0c$export$5378021d985ceaf8(args) {
    const { account: account_, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : undefined;
    if (account && !(0, $9GvsK.isAddress)(account.address)) throw new (0, $eCsKB.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $9GvsK.isAddress)(to)) throw new (0, $eCsKB.InvalidAddressError)({
        address: to
    });
    if (maxFeePerGas && maxFeePerGas > (0, $16127c6b6c27d616$export$48de485e50a67ffa)) throw new (0, $l8lWo.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $l8lWo.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}



var $5jfXj = parcelRequire("5jfXj");
class $14a6621c64bc60b5$export$f5a00468af285e38 extends (0, $5jfXj.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = 'Block';
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`, {
            name: 'BlockNotFoundError'
        });
    }
}



var $cD3gI = parcelRequire("cD3gI");


function $a314c9ea89117125$export$ba1152bc4017d62a(block, _) {
    const transactions = (block.transactions ?? []).map((transaction)=>{
        if (typeof transaction === 'string') return transaction;
        return (0, $014d88210c5bc9cd$export$b02b16590d26dadc)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $a314c9ea89117125$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $67ba667d98a92ada$export$5d08535cc975931a)('block', $a314c9ea89117125$export$ba1152bc4017d62a);


async function $e100edce7d3d8fad$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = client.experimental_blockTag ?? 'latest', includeTransactions: includeTransactions_ } = {}) {
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $cD3gI.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: 'eth_getBlockByHash',
        params: [
            blockHash,
            includeTransactions
        ]
    }, {
        dedupe: true
    });
    else block = await client.request({
        method: 'eth_getBlockByNumber',
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!block) throw new (0, $14a6621c64bc60b5$export$f5a00468af285e38)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $a314c9ea89117125$export$ba1152bc4017d62a);
    return format(block, 'getBlock');
}



var $lz1vU = parcelRequire("lz1vU");
async function $2e97a4a9ea5cb029$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: 'eth_chainId'
    }, {
        dedupe: true
    });
    return (0, $lz1vU.hexToNumber)(chainIdHex);
}


async function $b4b7601bc7c36213$export$ee39896fd0c30b0(client, parameters) {
    const { account: account = client.account, accessList: accessList, authorizationList: authorizationList, chain: chain = client.chain, blobVersionedHashes: blobVersionedHashes, blobs: blobs, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce_, nonceManager: nonceManager, to: to, type: type, value: value, ...rest } = parameters;
    const nonce = await (async ()=>{
        if (!account) return nonce_;
        if (!nonceManager) return nonce_;
        if (typeof nonce_ !== 'undefined') return nonce_;
        const account_ = (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account);
        const chainId = chain ? chain.id : await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
        return await nonceManager.consume({
            address: account_.address,
            chainId: chainId,
            client: client
        });
    })();
    (0, $6f98ca205ab4eb0c$export$5378021d985ceaf8)(parameters);
    const chainFormat = chain?.formatters?.transactionRequest?.format;
    const format = chainFormat || (0, $1df22e1e5334c1dd$export$d23fcba447c86a8e);
    const request = format({
        // Pick out extra data that might exist on the chain's transaction request type.
        ...(0, $0c055ac55d996b1d$export$f9380c9a627682d3)(rest, {
            format: chainFormat
        }),
        account: account ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account) : undefined,
        accessList: accessList,
        authorizationList: authorizationList,
        blobs: blobs,
        blobVersionedHashes: blobVersionedHashes,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerBlobGas: maxFeePerBlobGas,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        type: type,
        value: value
    }, 'fillTransaction');
    try {
        const response = await client.request({
            method: 'eth_fillTransaction',
            params: [
                request
            ]
        });
        const format = chain?.formatters?.transaction?.format || (0, $014d88210c5bc9cd$export$b02b16590d26dadc);
        const transaction = format(response.tx);
        // Remove unnecessary fields.
        delete transaction.blockHash;
        delete transaction.blockNumber;
        delete transaction.r;
        delete transaction.s;
        delete transaction.transactionIndex;
        delete transaction.v;
        delete transaction.yParity;
        // Rewrite fields.
        transaction.data = transaction.input;
        // Preference supplied fees (some nodes do not take these preferences).
        if (transaction.gas) transaction.gas = parameters.gas ?? transaction.gas;
        if (transaction.gasPrice) transaction.gasPrice = parameters.gasPrice ?? transaction.gasPrice;
        if (transaction.maxFeePerBlobGas) transaction.maxFeePerBlobGas = parameters.maxFeePerBlobGas ?? transaction.maxFeePerBlobGas;
        if (transaction.maxFeePerGas) transaction.maxFeePerGas = parameters.maxFeePerGas ?? transaction.maxFeePerGas;
        if (transaction.maxPriorityFeePerGas) transaction.maxPriorityFeePerGas = parameters.maxPriorityFeePerGas ?? transaction.maxPriorityFeePerGas;
        if (typeof transaction.nonce !== 'undefined') transaction.nonce = parameters.nonce ?? transaction.nonce;
        // Build fee multiplier function.
        const feeMultiplier = await (async ()=>{
            if (typeof chain?.fees?.baseFeeMultiplier === 'function') {
                const block = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $e100edce7d3d8fad$export$ea0af84ed2e77902), 'getBlock')({});
                return chain.fees.baseFeeMultiplier({
                    block: block,
                    client: client,
                    request: parameters
                });
            }
            return chain?.fees?.baseFeeMultiplier ?? 1.2;
        })();
        if (feeMultiplier < 1) throw new (0, $c631a92240a7f7f4$export$200c092bedf29ac0)();
        const decimals = feeMultiplier.toString().split('.')[1]?.length ?? 0;
        const denominator = 10 ** decimals;
        const multiplyFee = (base)=>base * BigInt(Math.ceil(feeMultiplier * denominator)) / BigInt(denominator);
        // Apply fee multiplier.
        if (!transaction.feePayerSignature) {
            if (transaction.maxFeePerGas && !parameters.maxFeePerGas) transaction.maxFeePerGas = multiplyFee(transaction.maxFeePerGas);
            if (transaction.gasPrice && !parameters.gasPrice) transaction.gasPrice = multiplyFee(transaction.gasPrice);
        }
        return {
            raw: response.raw,
            transaction: {
                from: request.from,
                ...transaction
            },
            ...response.capabilities ? {
                capabilities: response.capabilities
            } : {}
        };
    } catch (err) {
        throw (0, $db3d75d11c8bc083$export$da1758db1985646e)(err, {
            ...parameters,
            chain: client.chain
        });
    }
}




var $cD3gI = parcelRequire("cD3gI");
async function $1cecf0d6e55be63d$export$e648161d6b1bb565(client, { chain: chain }) {
    const { id: id, name: name, nativeCurrency: nativeCurrency, rpcUrls: rpcUrls, blockExplorers: blockExplorers } = chain;
    await client.request({
        method: 'wallet_addEthereumChain',
        params: [
            {
                chainId: (0, $cD3gI.numberToHex)(id),
                chainName: name,
                nativeCurrency: nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url: url })=>url) : undefined
            }
        ]
    }, {
        dedupe: true,
        retryCount: 0
    });
}



var $dZdNo = parcelRequire("dZdNo");

var $4KuzL = parcelRequire("4KuzL");

var $lBZMD = parcelRequire("lBZMD");
const $fd6cebf717099104$var$docsPath = '/docs/contract/encodeDeployData';
function $fd6cebf717099104$export$d7a7276006273fbd(parameters) {
    const { abi: abi, args: args, bytecode: bytecode } = parameters;
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>'type' in x && x.type === 'constructor');
    if (!description) throw new (0, $dZdNo.AbiConstructorNotFoundError)({
        docsPath: $fd6cebf717099104$var$docsPath
    });
    if (!('inputs' in description)) throw new (0, $dZdNo.AbiConstructorParamsNotFoundError)({
        docsPath: $fd6cebf717099104$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $dZdNo.AbiConstructorParamsNotFoundError)({
        docsPath: $fd6cebf717099104$var$docsPath
    });
    const data = (0, $lBZMD.encodeAbiParameters)(description.inputs, args);
    return (0, $4KuzL.concatHex)([
        bytecode,
        data
    ]);
}




var $5jfXj = parcelRequire("5jfXj");
class $f8213a878aaa4056$export$62ee6b05f0767f28 extends (0, $5jfXj.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            'Could not find an Account to execute with this Action.',
            'Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client.'
        ].join('\n'), {
            docsPath: docsPath,
            docsSlug: 'account',
            name: 'AccountNotFoundError'
        });
    }
}
class $f8213a878aaa4056$export$22c1d840ef5fbc66 extends (0, $5jfXj.BaseError) {
    constructor({ docsPath: docsPath, metaMessages: metaMessages, type: type }){
        super(`Account type "${type}" is not supported.`, {
            docsPath: docsPath,
            metaMessages: metaMessages,
            name: 'AccountTypeNotSupportedError'
        });
    }
}



var $5jfXj = parcelRequire("5jfXj");

var $kiDAM = parcelRequire("kiDAM");

var $1YOOf = parcelRequire("1YOOf");
function $489cb8570280381f$export$462669520a9d12d1(publicKey) {
    const address = (0, $1YOOf.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $kiDAM.checksumAddress)(`0x${address}`);
}



var $dem4j = parcelRequire("dem4j");

var $2u1VO = parcelRequire("2u1VO");

var $lz1vU = parcelRequire("lz1vU");

var $cD3gI = parcelRequire("cD3gI");

async function $821f0bacfa9dd6a7$export$952dd09fbe0232b7({ hash: hash, signature: signature }) {
    const hashHex = (0, $dem4j.isHex)(hash) ? hash : (0, $cD3gI.toHex)(hash);
    const { secp256k1: secp256k1 } = await Promise.resolve((parcelRequire("4XGvQ")));
    const signature_ = (()=>{
        // typeof signature: `Signature`
        if (typeof signature === 'object' && 'r' in signature && 's' in signature) {
            const { r: r, s: s, v: v, yParity: yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = $821f0bacfa9dd6a7$var$toRecoveryBit(yParityOrV);
            return new secp256k1.Signature((0, $lz1vU.hexToBigInt)(r), (0, $lz1vU.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = (0, $dem4j.isHex)(signature) ? signature : (0, $cD3gI.toHex)(signature);
        if ((0, $2u1VO.size)(signatureHex) !== 65) throw new Error('invalid signature length');
        const yParityOrV = (0, $lz1vU.hexToNumber)(`0x${signatureHex.slice(130)}`);
        const recoveryBit = $821f0bacfa9dd6a7$var$toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
}
function $821f0bacfa9dd6a7$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error('Invalid yParityOrV value');
}


async function $bcbd31226194babe$export$23cc18f96d8510e2({ hash: hash, signature: signature }) {
    return (0, $489cb8570280381f$export$462669520a9d12d1)(await (0, $821f0bacfa9dd6a7$export$952dd09fbe0232b7)({
        hash: hash,
        signature: signature
    }));
}



var $4KuzL = parcelRequire("4KuzL");

var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");

var $5jfXj = parcelRequire("5jfXj");

var $5jfXj = parcelRequire("5jfXj");
class $5427062e231ea4dc$export$4741ff085e62ac19 extends (0, $5jfXj.BaseError) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: 'NegativeOffsetError'
        });
    }
}
class $5427062e231ea4dc$export$72dcc4230cbf50ba extends (0, $5jfXj.BaseError) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, {
            name: 'PositionOutOfBoundsError'
        });
    }
}
class $5427062e231ea4dc$export$4952f5c6336a7cc7 extends (0, $5jfXj.BaseError) {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, {
            name: 'RecursiveReadLimitExceededError'
        });
    }
}


const $3c2e56287ee84b48$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $5427062e231ea4dc$export$4952f5c6336a7cc7)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $5427062e231ea4dc$export$72dcc4230cbf50ba)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $5427062e231ea4dc$export$4741ff085e62ac19)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $5427062e231ea4dc$export$4741ff085e62ac19)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $3c2e56287ee84b48$export$fb542681b7c0dc55(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($3c2e56287ee84b48$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer ?? bytes, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}



var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");
function $d35bee29afe2a349$export$140c78e750979cda(bytes, to = 'hex') {
    const encodable = $d35bee29afe2a349$var$getEncodable(bytes);
    const cursor = (0, $3c2e56287ee84b48$export$fb542681b7c0dc55)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === 'hex') return (0, $cD3gI.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $d35bee29afe2a349$export$643d3163062ff0f3(bytes, to = 'bytes') {
    return $d35bee29afe2a349$export$140c78e750979cda(bytes, to);
}
function $d35bee29afe2a349$export$e01da38311234e95(hex, to = 'hex') {
    return $d35bee29afe2a349$export$140c78e750979cda(hex, to);
}
function $d35bee29afe2a349$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $d35bee29afe2a349$var$getEncodableList(bytes.map((x)=>$d35bee29afe2a349$var$getEncodable(x)));
    return $d35bee29afe2a349$var$getEncodableBytes(bytes);
}
function $d35bee29afe2a349$var$getEncodableList(list) {
    const bodyLength = list.reduce((acc, x)=>acc + x.length, 0);
    const sizeOfBodyLength = $d35bee29afe2a349$var$getSizeOfLength(bodyLength);
    const length = (()=>{
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            for (const { encode: encode } of list)encode(cursor);
        }
    };
}
function $d35bee29afe2a349$var$getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === 'string' ? (0, $kc9Jh.hexToBytes)(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = $d35bee29afe2a349$var$getSizeOfLength(bytes.length);
    const length = (()=>{
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $d35bee29afe2a349$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < 2 ** 16) return 2;
    if (length < 2 ** 24) return 3;
    if (length < 2 ** 32) return 4;
    throw new (0, $5jfXj.BaseError)('Length is too large.');
}



var $1YOOf = parcelRequire("1YOOf");
function $a93b627e553d667d$export$52e574e057b290dc(parameters) {
    const { chainId: chainId, nonce: nonce, to: to } = parameters;
    const address = parameters.contractAddress ?? parameters.address;
    const hash = (0, $1YOOf.keccak256)((0, $4KuzL.concatHex)([
        '0x05',
        (0, $d35bee29afe2a349$export$140c78e750979cda)([
            chainId ? (0, $cD3gI.numberToHex)(chainId) : '0x',
            address,
            nonce ? (0, $cD3gI.numberToHex)(nonce) : '0x'
        ])
    ]));
    if (to === 'bytes') return (0, $kc9Jh.hexToBytes)(hash);
    return hash;
}


async function $2a378a322473ef36$export$415d0315604a8515(parameters) {
    const { authorization: authorization, signature: signature } = parameters;
    return (0, $bcbd31226194babe$export$23cc18f96d8510e2)({
        hash: (0, $a93b627e553d667d$export$52e574e057b290dc)(authorization),
        signature: signature ?? authorization
    });
}



var $5jfXj = parcelRequire("5jfXj");
class $16aad06d6e6fffb4$export$f2b2bfa70417796b extends (0, $5jfXj.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                'This could be due to any of the following:',
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ],
            name: 'ChainDoesNotSupportContract'
        });
    }
}
class $16aad06d6e6fffb4$export$535d82255cc17992 extends (0, $5jfXj.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ],
            name: 'ChainMismatchError'
        });
    }
}
class $16aad06d6e6fffb4$export$b7f33b26fea1ae0b extends (0, $5jfXj.BaseError) {
    constructor(){
        super([
            'No chain was provided to the request.',
            'Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient.'
        ].join('\n'), {
            name: 'ChainNotFoundError'
        });
    }
}
class $16aad06d6e6fffb4$export$64807f0e18658482 extends (0, $5jfXj.BaseError) {
    constructor(){
        super('No chain was provided to the Client.', {
            name: 'ClientChainNotConfiguredError'
        });
    }
}
class $16aad06d6e6fffb4$export$4836eb835ffca5b2 extends (0, $5jfXj.BaseError) {
    constructor({ chainId: chainId }){
        super(typeof chainId === 'number' ? `Chain ID "${chainId}" is invalid.` : 'Chain ID is invalid.', {
            name: 'InvalidChainIdError'
        });
    }
}


function $3798f49dfdfe1015$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $16aad06d6e6fffb4$export$b7f33b26fea1ae0b)();
    if (currentChainId !== chain.id) throw new (0, $16aad06d6e6fffb4$export$535d82255cc17992)({
        chain: chain,
        currentChainId: currentChainId
    });
}



var $4KuzL = parcelRequire("4KuzL");





var $4nYJj = parcelRequire("4nYJj");







var $lz1vU = parcelRequire("lz1vU");


/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $69cd3dc09bf5d826$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: 'eth_gasPrice'
    });
    return BigInt(gasPrice);
}


async function $54bcab49dd4f54cb$export$fd79a693887f886c(client, args) {
    return $54bcab49dd4f54cb$export$59275bafd388148(client, args);
}
async function $54bcab49dd4f54cb$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    try {
        const maxPriorityFeePerGas = chain?.fees?.maxPriorityFeePerGas ?? chain?.fees?.defaultPriorityFee;
        if (typeof maxPriorityFeePerGas === 'function') {
            const block = block_ || await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $e100edce7d3d8fad$export$ea0af84ed2e77902), 'getBlock')({});
            const maxPriorityFeePerGas_ = await maxPriorityFeePerGas({
                block: block,
                client: client,
                request: request
            });
            if (maxPriorityFeePerGas_ === null) throw new Error();
            return maxPriorityFeePerGas_;
        }
        if (typeof maxPriorityFeePerGas !== 'undefined') return maxPriorityFeePerGas;
        const maxPriorityFeePerGasHex = await client.request({
            method: 'eth_maxPriorityFeePerGas'
        });
        return (0, $lz1vU.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $e100edce7d3d8fad$export$ea0af84ed2e77902), 'getBlock')({}),
            (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $69cd3dc09bf5d826$export$89c15b50d46d3f8c), 'getGasPrice')({})
        ]);
        if (typeof block.baseFeePerGas !== 'bigint') throw new (0, $c631a92240a7f7f4$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}




async function $b5773b6d54c3769e$export$8193bed8c46d2831(client, args) {
    return $b5773b6d54c3769e$export$67115e8707c5a9e(client, args);
}
async function $b5773b6d54c3769e$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = 'eip1559' } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === 'function') return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $c631a92240a7f7f4$export$200c092bedf29ac0)();
    const decimals = baseFeeMultiplier.toString().split('.')[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $e100edce7d3d8fad$export$ea0af84ed2e77902), 'getBlock')({});
    if (typeof chain?.fees?.estimateFeesPerGas === 'function') {
        const fees = await chain.fees.estimateFeesPerGas({
            block: block_,
            client: client,
            multiply: multiply,
            request: request,
            type: type
        });
        if (fees !== null) return fees;
    }
    if (type === 'eip1559') {
        if (typeof block.baseFeePerGas !== 'bigint') throw new (0, $c631a92240a7f7f4$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = typeof request?.maxPriorityFeePerGas === 'bigint' ? request.maxPriorityFeePerGas : await (0, $54bcab49dd4f54cb$export$59275bafd388148)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $69cd3dc09bf5d826$export$89c15b50d46d3f8c), 'getGasPrice')({}));
    return {
        gasPrice: gasPrice
    };
}




var $5jfXj = parcelRequire("5jfXj");


var $cD3gI = parcelRequire("cD3gI");


var $3vvQ3 = parcelRequire("3vvQ3");

var $5jfXj = parcelRequire("5jfXj");

class $d0dcd09eb899cdd2$export$9e393e362ab0c102 extends (0, $5jfXj.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $8f6a5f9d053a5a2a$export$cde3d1388a9feac3)({
            from: account?.address,
            to: to,
            value: typeof value !== 'undefined' && `${(0, $35711cc57a2002ea$export$11bc63b4c03ea518)(value)} ${chain?.nativeCurrency?.symbol || 'ETH'}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== 'undefined' && `${(0, $3vvQ3.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== 'undefined' && `${(0, $3vvQ3.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' && `${(0, $3vvQ3.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    ' '
                ] : [],
                'Estimate Gas Arguments:',
                prettyArgs
            ].filter(Boolean),
            name: 'EstimateGasExecutionError'
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}



var $l8lWo = parcelRequire("l8lWo");

function $2a73956ebf0ab84d$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $10675c8d6dde5afa$export$218ee3a1c831c34e)(err, args);
        if (cause instanceof (0, $l8lWo.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $d0dcd09eb899cdd2$export$9e393e362ab0c102)(cause, {
        docsPath: docsPath,
        ...args
    });
}





var $eCsKB = parcelRequire("eCsKB");

var $crrQA = parcelRequire("crrQA");

var $5jfXj = parcelRequire("5jfXj");
class $a00e5ec647ff8f90$export$eb92af66de2d34c1 extends (0, $5jfXj.BaseError) {
    constructor({ address: address }){
        super(`State for account "${address}" is set multiple times.`, {
            name: 'AccountStateConflictError'
        });
    }
}
class $a00e5ec647ff8f90$export$3f829f5a43fdcc2e extends (0, $5jfXj.BaseError) {
    constructor(){
        super('state and stateDiff are set on the same account.', {
            name: 'StateAssignmentConflictError'
        });
    }
}
function $a00e5ec647ff8f90$export$4afb15becff191ad(stateMapping) {
    return stateMapping.reduce((pretty, { slot: slot, value: value })=>{
        return `${pretty}        ${slot}: ${value}\n`;
    }, '');
}
function $a00e5ec647ff8f90$export$d08c47f9c4a87c67(stateOverride) {
    return stateOverride.reduce((pretty, { address: address, ...state })=>{
        let val = `${pretty}    ${address}:\n`;
        if (state.nonce) val += `      nonce: ${state.nonce}\n`;
        if (state.balance) val += `      balance: ${state.balance}\n`;
        if (state.code) val += `      code: ${state.code}\n`;
        if (state.state) {
            val += '      state:\n';
            val += $a00e5ec647ff8f90$export$4afb15becff191ad(state.state);
        }
        if (state.stateDiff) {
            val += '      stateDiff:\n';
            val += $a00e5ec647ff8f90$export$4afb15becff191ad(state.stateDiff);
        }
        return val;
    }, '  State Override:\n').slice(0, -1);
}



var $9GvsK = parcelRequire("9GvsK");

var $cD3gI = parcelRequire("cD3gI");
function $1171e220a6360ed8$export$29e73cd11b306a76(stateMapping) {
    if (!stateMapping || stateMapping.length === 0) return undefined;
    return stateMapping.reduce((acc, { slot: slot, value: value })=>{
        if (slot.length !== 66) throw new (0, $crrQA.InvalidBytesLengthError)({
            size: slot.length,
            targetSize: 66,
            type: 'hex'
        });
        if (value.length !== 66) throw new (0, $crrQA.InvalidBytesLengthError)({
            size: value.length,
            targetSize: 66,
            type: 'hex'
        });
        acc[slot] = value;
        return acc;
    }, {});
}
function $1171e220a6360ed8$export$ff6c86decd3de345(parameters) {
    const { balance: balance, nonce: nonce, state: state, stateDiff: stateDiff, code: code } = parameters;
    const rpcAccountStateOverride = {};
    if (code !== undefined) rpcAccountStateOverride.code = code;
    if (balance !== undefined) rpcAccountStateOverride.balance = (0, $cD3gI.numberToHex)(balance);
    if (nonce !== undefined) rpcAccountStateOverride.nonce = (0, $cD3gI.numberToHex)(nonce);
    if (state !== undefined) rpcAccountStateOverride.state = $1171e220a6360ed8$export$29e73cd11b306a76(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state) throw new (0, $a00e5ec647ff8f90$export$3f829f5a43fdcc2e)();
        rpcAccountStateOverride.stateDiff = $1171e220a6360ed8$export$29e73cd11b306a76(stateDiff);
    }
    return rpcAccountStateOverride;
}
function $1171e220a6360ed8$export$f6da3c954eb711d6(parameters) {
    if (!parameters) return undefined;
    const rpcStateOverride = {};
    for (const { address: address, ...accountState } of parameters){
        if (!(0, $9GvsK.isAddress)(address, {
            strict: false
        })) throw new (0, $eCsKB.InvalidAddressError)({
            address: address
        });
        if (rpcStateOverride[address]) throw new (0, $a00e5ec647ff8f90$export$eb92af66de2d34c1)({
            address: address
        });
        rpcStateOverride[address] = $1171e220a6360ed8$export$ff6c86decd3de345(accountState);
    }
    return rpcStateOverride;
}




async function $d4ca7fabdc22d50d$export$e0580ae1f48db848(client, args) {
    const { account: account_ = client.account, prepare: prepare = true } = args;
    const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : undefined;
    const parameters = (()=>{
        if (Array.isArray(prepare)) return prepare;
        // Some RPC Providers do not compute versioned hashes from blobs. We will need
        // to compute them.
        if (account?.type !== 'local') return [
            'blobVersionedHashes'
        ];
        return undefined;
    })();
    try {
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (args.to) return args.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (args.authorizationList && args.authorizationList.length > 0) return await (0, $2a378a322473ef36$export$415d0315604a8515)({
                authorization: args.authorizationList[0]
            }).catch(()=>{
                throw new (0, $5jfXj.BaseError)('`to` is required. Could not infer from `authorizationList`');
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        const { accessList: accessList, authorizationList: authorizationList, blobs: blobs, blobVersionedHashes: blobVersionedHashes, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, stateOverride: stateOverride, ...rest } = prepare ? await (0, $672e074fa9a15fa8$export$2e8a9232fb815d77)(client, {
            ...args,
            parameters: parameters,
            to: to
        }) : args;
        // If we get `gas` back from the prepared transaction request, which is
        // different from the `gas` we provided, it was likely filled by other means
        // during request preparation (e.g. `eth_fillTransaction` or `chain.transactionRequest.prepare`).
        // (e.g. `eth_fillTransaction` or `chain.transactionRequest.prepare`).
        if (gas && args.gas !== gas) return gas;
        const blockNumberHex = typeof blockNumber === 'bigint' ? (0, $cD3gI.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $1171e220a6360ed8$export$f6da3c954eb711d6)(stateOverride);
        (0, $6f98ca205ab4eb0c$export$5378021d985ceaf8)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $1df22e1e5334c1dd$export$d23fcba447c86a8e);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $0c055ac55d996b1d$export$f9380c9a627682d3)(rest, {
                format: chainFormat
            }),
            account: account,
            accessList: accessList,
            authorizationList: authorizationList,
            blobs: blobs,
            blobVersionedHashes: blobVersionedHashes,
            data: data,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        }, 'estimateGas');
        return BigInt(await client.request({
            method: 'eth_estimateGas',
            params: rpcStateOverride ? [
                request,
                block ?? client.experimental_blockTag ?? 'latest',
                rpcStateOverride
            ] : block ? [
                request,
                block
            ] : [
                request
            ]
        }));
    } catch (err) {
        throw (0, $2a73956ebf0ab84d$export$f201b805dbcd7c48)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}




var $5jfXj = parcelRequire("5jfXj");

var $cD3gI = parcelRequire("cD3gI");
function $e5e5d22720938ec8$export$39699c61b9baf1a4(parameters) {
    const { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, requireCanonical: requireCanonical } = parameters;
    if (requireCanonical !== undefined && !blockHash) throw new (0, $5jfXj.BaseError)('`requireCanonical` can only be provided when `blockHash` is set.');
    if (blockHash) return requireCanonical ? {
        blockHash: blockHash,
        requireCanonical: requireCanonical
    } : {
        blockHash: blockHash
    };
    if (typeof blockNumber === 'bigint') return (0, $cD3gI.numberToHex)(blockNumber);
    return blockTag ?? 'latest';
}



var $lz1vU = parcelRequire("lz1vU");
async function $38940ece51e7e6e5$export$b18e66333ec1361e(client, { address: address, blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = 'latest', requireCanonical: requireCanonical }) {
    const block = (0, $e5e5d22720938ec8$export$39699c61b9baf1a4)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        requireCanonical: requireCanonical
    });
    const count = await client.request({
        method: 'eth_getTransactionCount',
        params: [
            address,
            block
        ]
    }, {
        dedupe: typeof blockNumber === 'bigint' || blockHash !== undefined
    });
    return (0, $lz1vU.hexToNumber)(count);
}




var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");
function $de0209608b41db84$export$b67626aab22a659b(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === 'string' ? 'hex' : 'bytes');
    const blobs = typeof parameters.blobs[0] === 'string' ? parameters.blobs.map((x)=>(0, $kc9Jh.hexToBytes)(x)) : parameters.blobs;
    const commitments = [];
    for (const blob of blobs)commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
    return to === 'bytes' ? commitments : commitments.map((x)=>(0, $cD3gI.bytesToHex)(x));
}



var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");
function $0716f0f9a4a3cbdc$export$78a225f8922765eb(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === 'string' ? 'hex' : 'bytes');
    const blobs = typeof parameters.blobs[0] === 'string' ? parameters.blobs.map((x)=>(0, $kc9Jh.hexToBytes)(x)) : parameters.blobs;
    const commitments = typeof parameters.commitments[0] === 'string' ? parameters.commitments.map((x)=>(0, $kc9Jh.hexToBytes)(x)) : parameters.commitments;
    const proofs = [];
    for(let i = 0; i < blobs.length; i++){
        const blob = blobs[i];
        const commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return to === 'bytes' ? proofs : proofs.map((x)=>(0, $cD3gI.bytesToHex)(x));
}



var $cD3gI = parcelRequire("cD3gI");

var $a7QVs = parcelRequire("a7QVs");

var $dem4j = parcelRequire("dem4j");

var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");
function $30644c42d71652dd$export$bced8d2aada2d1c9(value, to_) {
    const to = to_ || 'hex';
    const bytes = (0, $a7QVs.sha256)((0, $dem4j.isHex)(value, {
        strict: false
    }) ? (0, $kc9Jh.toBytes)(value) : value);
    if (to === 'bytes') return bytes;
    return (0, $cD3gI.toHex)(bytes);
}


function $ffd81213bdb41018$export$7b2f762c7eb1ecea(parameters) {
    const { commitment: commitment, version: version = 1 } = parameters;
    const to = parameters.to ?? (typeof commitment === 'string' ? 'hex' : 'bytes');
    const versionedHash = (0, $30644c42d71652dd$export$bced8d2aada2d1c9)(commitment, 'bytes');
    versionedHash.set([
        version
    ], 0);
    return to === 'bytes' ? versionedHash : (0, $cD3gI.bytesToHex)(versionedHash);
}


function $ffb2e1595d3a548b$export$e31b3e59dda37b17(parameters) {
    const { commitments: commitments, version: version } = parameters;
    const to = parameters.to ?? (typeof commitments[0] === 'string' ? 'hex' : 'bytes');
    const hashes = [];
    for (const commitment of commitments)hashes.push((0, $ffd81213bdb41018$export$7b2f762c7eb1ecea)({
        commitment: commitment,
        to: to,
        version: version
    }));
    return hashes;
}




// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */ const $6cef82ebf01a9978$var$blobsPerTransaction = 6;
const $6cef82ebf01a9978$export$a5d2a246d959344 = 32;
const $6cef82ebf01a9978$export$57577a1a84b7e334 = 4096;
const $6cef82ebf01a9978$export$6f30828563a6c6ef = $6cef82ebf01a9978$export$a5d2a246d959344 * $6cef82ebf01a9978$export$57577a1a84b7e334;
const $6cef82ebf01a9978$export$b8db4e3f07d08e09 = $6cef82ebf01a9978$export$6f30828563a6c6ef * $6cef82ebf01a9978$var$blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * $6cef82ebf01a9978$export$57577a1a84b7e334 * $6cef82ebf01a9978$var$blobsPerTransaction;


// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
const $ed6a6d82e55f1902$export$de38d5f871f0b1cd = 1;



var $5jfXj = parcelRequire("5jfXj");
class $6efd5b462ed1478d$export$4000e90bfe41caa1 extends (0, $5jfXj.BaseError) {
    constructor({ maxSize: maxSize, size: size }){
        super('Blob size is too large.', {
            metaMessages: [
                `Max: ${maxSize} bytes`,
                `Given: ${size} bytes`
            ],
            name: 'BlobSizeTooLargeError'
        });
    }
}
class $6efd5b462ed1478d$export$d145394ceab4d1c3 extends (0, $5jfXj.BaseError) {
    constructor(){
        super('Blob data must not be empty.', {
            name: 'EmptyBlobError'
        });
    }
}
class $6efd5b462ed1478d$export$ebd5b15dd92c680 extends (0, $5jfXj.BaseError) {
    constructor({ hash: hash, size: size }){
        super(`Versioned hash "${hash}" size is invalid.`, {
            metaMessages: [
                'Expected: 32',
                `Received: ${size}`
            ],
            name: 'InvalidVersionedHashSizeError'
        });
    }
}
class $6efd5b462ed1478d$export$509ed1d312c500 extends (0, $5jfXj.BaseError) {
    constructor({ hash: hash, version: version }){
        super(`Versioned hash "${hash}" version is invalid.`, {
            metaMessages: [
                `Expected: ${(0, $ed6a6d82e55f1902$export$de38d5f871f0b1cd)}`,
                `Received: ${version}`
            ],
            name: 'InvalidVersionedHashVersionError'
        });
    }
}




var $2u1VO = parcelRequire("2u1VO");

var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");
function $eaf6bfef915c3dc2$export$7ec339bd77d6ed92(parameters) {
    const to = parameters.to ?? (typeof parameters.data === 'string' ? 'hex' : 'bytes');
    const data = typeof parameters.data === 'string' ? (0, $kc9Jh.hexToBytes)(parameters.data) : parameters.data;
    const size_ = (0, $2u1VO.size)(data);
    if (!size_) throw new (0, $6efd5b462ed1478d$export$d145394ceab4d1c3)();
    if (size_ > (0, $6cef82ebf01a9978$export$b8db4e3f07d08e09)) throw new (0, $6efd5b462ed1478d$export$4000e90bfe41caa1)({
        maxSize: (0, $6cef82ebf01a9978$export$b8db4e3f07d08e09),
        size: size_
    });
    const blobs = [];
    let active = true;
    let position = 0;
    while(active){
        const blob = (0, $3c2e56287ee84b48$export$fb542681b7c0dc55)(new Uint8Array((0, $6cef82ebf01a9978$export$6f30828563a6c6ef)));
        let size = 0;
        while(size < (0, $6cef82ebf01a9978$export$57577a1a84b7e334)){
            const bytes = data.slice(position, position + ((0, $6cef82ebf01a9978$export$a5d2a246d959344) - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return to === 'bytes' ? blobs.map((x)=>x.bytes) : blobs.map((x)=>(0, $cD3gI.bytesToHex)(x.bytes));
}


function $8c25da7d015526bf$export$44960962e1c9641b(parameters) {
    const { data: data, kzg: kzg, to: to } = parameters;
    const blobs = parameters.blobs ?? (0, $eaf6bfef915c3dc2$export$7ec339bd77d6ed92)({
        data: data,
        to: to
    });
    const commitments = parameters.commitments ?? (0, $de0209608b41db84$export$b67626aab22a659b)({
        blobs: blobs,
        kzg: kzg,
        to: to
    });
    const proofs = parameters.proofs ?? (0, $0716f0f9a4a3cbdc$export$78a225f8922765eb)({
        blobs: blobs,
        commitments: commitments,
        kzg: kzg,
        to: to
    });
    const sidecars = [];
    for(let i = 0; i < blobs.length; i++)sidecars.push({
        blob: blobs[i],
        commitment: commitments[i],
        proof: proofs[i]
    });
    return sidecars;
}




var $4nYJj = parcelRequire("4nYJj");


function $172cd6246177605b$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.authorizationList !== 'undefined') return 'eip7702';
    if (typeof transaction.blobs !== 'undefined' || typeof transaction.blobVersionedHashes !== 'undefined' || typeof transaction.maxFeePerBlobGas !== 'undefined' || typeof transaction.sidecars !== 'undefined') return 'eip4844';
    if (typeof transaction.maxFeePerGas !== 'undefined' || typeof transaction.maxPriorityFeePerGas !== 'undefined') return 'eip1559';
    if (typeof transaction.gasPrice !== 'undefined') {
        if (typeof transaction.accessList !== 'undefined') return 'eip2930';
        return 'legacy';
    }
    throw new (0, $8f6a5f9d053a5a2a$export$f2282ba9c8899971)({
        transaction: transaction
    });
}




const $672e074fa9a15fa8$export$4f3e0c2bc77eca55 = [
    'blobVersionedHashes',
    'chainId',
    'fees',
    'gas',
    'nonce',
    'type'
];
const $672e074fa9a15fa8$export$1cdc34309351bc26 = /*#__PURE__*/ new Map();
const $672e074fa9a15fa8$export$25f01917017e7300 = /*#__PURE__*/ new (0, $4nYJj.LruMap)(128);
async function $672e074fa9a15fa8$export$2e8a9232fb815d77(client, args) {
    let request = args;
    request.account ??= client.account;
    request.parameters ??= $672e074fa9a15fa8$export$4f3e0c2bc77eca55;
    const { account: account_, chain: chain = client.chain, nonceManager: nonceManager, parameters: parameters } = request;
    const prepareTransactionRequest = (()=>{
        if (typeof chain?.prepareTransactionRequest === 'function') return {
            fn: chain.prepareTransactionRequest,
            runAt: [
                'beforeFillTransaction'
            ]
        };
        if (Array.isArray(chain?.prepareTransactionRequest)) return {
            fn: chain.prepareTransactionRequest[0],
            runAt: chain.prepareTransactionRequest[1].runAt
        };
        return undefined;
    })();
    let chainId;
    async function getChainId() {
        if (chainId) return chainId;
        if (typeof request.chainId !== 'undefined') return request.chainId;
        if (chain) return chain.id;
        const chainId_ = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
        chainId = chainId_;
        return chainId;
    }
    const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : account_;
    let nonce = request.nonce;
    if (parameters.includes('nonce') && typeof nonce === 'undefined' && account && nonceManager) {
        const chainId = await getChainId();
        nonce = await nonceManager.consume({
            address: account.address,
            chainId: chainId,
            client: client
        });
    }
    if (prepareTransactionRequest?.fn && prepareTransactionRequest.runAt?.includes('beforeFillTransaction')) {
        request = await prepareTransactionRequest.fn({
            ...request,
            chain: chain
        }, {
            client: client,
            phase: 'beforeFillTransaction'
        });
        nonce ??= request.nonce;
    }
    const attemptFill = (()=>{
        // Do not attempt if blobs are provided.
        if ((parameters.includes('blobVersionedHashes') || parameters.includes('sidecars')) && request.kzg && request.blobs) return false;
        // Do not attempt if `eth_fillTransaction` is not supported.
        if ($672e074fa9a15fa8$export$25f01917017e7300.get(client.uid) === false) return false;
        // Should attempt `eth_fillTransaction` if "fees" or "gas" are required to be populated,
        // otherwise, can just use the other individual calls.
        const shouldAttempt = [
            'fees',
            'gas'
        ].some((parameter)=>parameters.includes(parameter));
        if (!shouldAttempt) return false;
        // Check if `eth_fillTransaction` needs to be called.
        if (parameters.includes('chainId') && typeof request.chainId !== 'number') return true;
        if (parameters.includes('nonce') && typeof nonce !== 'number') return true;
        if (parameters.includes('fees') && typeof request.gasPrice !== 'bigint' && (typeof request.maxFeePerGas !== 'bigint' || typeof request.maxPriorityFeePerGas !== 'bigint')) return true;
        if (parameters.includes('gas') && typeof request.gas !== 'bigint') return true;
        return false;
    })();
    const fillResult = attemptFill ? await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $b4b7601bc7c36213$export$ee39896fd0c30b0), 'fillTransaction')({
        ...request,
        nonce: nonce
    }).then((result)=>{
        const { chainId: chainId, from: from, gas: gas, gasPrice: gasPrice, nonce: nonce, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, type: type, ...rest } = result.transaction;
        $672e074fa9a15fa8$export$25f01917017e7300.set(client.uid, true);
        return {
            ...request,
            ...from ? {
                from: from
            } : {},
            ...type && !request.type ? {
                type: type
            } : {},
            ...typeof chainId !== 'undefined' ? {
                chainId: chainId
            } : {},
            ...typeof gas !== 'undefined' ? {
                gas: gas
            } : {},
            ...typeof gasPrice !== 'undefined' ? {
                gasPrice: gasPrice
            } : {},
            ...typeof nonce !== 'undefined' ? {
                nonce: nonce
            } : {},
            ...typeof maxFeePerBlobGas !== 'undefined' && request.type !== 'legacy' && request.type !== 'eip2930' ? {
                maxFeePerBlobGas: maxFeePerBlobGas
            } : {},
            ...typeof maxFeePerGas !== 'undefined' && request.type !== 'legacy' && request.type !== 'eip2930' ? {
                maxFeePerGas: maxFeePerGas
            } : {},
            ...typeof maxPriorityFeePerGas !== 'undefined' && request.type !== 'legacy' && request.type !== 'eip2930' ? {
                maxPriorityFeePerGas: maxPriorityFeePerGas
            } : {},
            ...'nonceKey' in rest && typeof rest.nonceKey !== 'undefined' ? {
                nonceKey: rest.nonceKey
            } : {},
            ...'keyAuthorization' in rest && typeof rest.keyAuthorization !== 'undefined' && rest.keyAuthorization !== null && !('keyAuthorization' in request) ? {
                keyAuthorization: rest.keyAuthorization
            } : {},
            ...'feePayerSignature' in rest && typeof rest.feePayerSignature !== 'undefined' && rest.feePayerSignature !== null ? {
                feePayerSignature: rest.feePayerSignature
            } : {},
            ...'feeToken' in rest && typeof rest.feeToken !== 'undefined' && rest.feeToken !== null && !('feeToken' in request) ? {
                feeToken: rest.feeToken
            } : {},
            ...result.capabilities ? {
                _capabilities: result.capabilities
            } : {}
        };
    }).catch((e)=>{
        const error = e;
        if (error.name !== 'TransactionExecutionError') return request;
        const executionReverted = error.walk?.((e)=>{
            const error = e;
            return error.name === 'ExecutionRevertedError';
        });
        if (executionReverted) throw e;
        const unsupported = error.walk?.((e)=>{
            const error = e;
            return error.name === 'MethodNotFoundRpcError' || error.name === 'MethodNotSupportedRpcError' || error.message?.includes('eth_fillTransaction is not available');
        });
        if (unsupported) $672e074fa9a15fa8$export$25f01917017e7300.set(client.uid, false);
        return request;
    }) : request;
    nonce ??= fillResult.nonce;
    request = {
        ...fillResult,
        ...account ? {
            from: account?.address
        } : {},
        ...typeof nonce !== 'undefined' ? {
            nonce: nonce
        } : {}
    };
    const { blobs: blobs, gas: gas, kzg: kzg, type: type } = request;
    if (prepareTransactionRequest?.fn && prepareTransactionRequest.runAt?.includes('beforeFillParameters')) request = await prepareTransactionRequest.fn({
        ...request,
        chain: chain
    }, {
        client: client,
        phase: 'beforeFillParameters'
    });
    let block;
    async function getBlock() {
        if (block) return block;
        block = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $e100edce7d3d8fad$export$ea0af84ed2e77902), 'getBlock')({
            blockTag: 'latest'
        });
        return block;
    }
    if (parameters.includes('nonce') && typeof nonce === 'undefined' && account && !nonceManager) request.nonce = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $38940ece51e7e6e5$export$b18e66333ec1361e), 'getTransactionCount')({
        address: account.address,
        blockTag: 'pending'
    });
    if ((parameters.includes('blobVersionedHashes') || parameters.includes('sidecars')) && blobs && kzg) {
        const commitments = (0, $de0209608b41db84$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (parameters.includes('blobVersionedHashes')) {
            const versionedHashes = (0, $ffb2e1595d3a548b$export$e31b3e59dda37b17)({
                commitments: commitments,
                to: 'hex'
            });
            request.blobVersionedHashes = versionedHashes;
        }
        if (parameters.includes('sidecars')) {
            const proofs = (0, $0716f0f9a4a3cbdc$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            const sidecars = (0, $8c25da7d015526bf$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs,
                to: 'hex'
            });
            request.sidecars = sidecars;
        }
    }
    if (parameters.includes('chainId')) request.chainId = await getChainId();
    if ((parameters.includes('fees') || parameters.includes('type')) && typeof type === 'undefined') try {
        request.type = (0, $172cd6246177605b$export$944c6678cd5a1ea8)(request);
    } catch  {
        let isEip1559Network = $672e074fa9a15fa8$export$1cdc34309351bc26.get(client.uid);
        if (typeof isEip1559Network === 'undefined') {
            const block = await getBlock();
            isEip1559Network = typeof block?.baseFeePerGas === 'bigint';
            $672e074fa9a15fa8$export$1cdc34309351bc26.set(client.uid, isEip1559Network);
        }
        request.type = isEip1559Network ? 'eip1559' : 'legacy';
    }
    if (parameters.includes('fees')) {
        // TODO(4844): derive blob base fees once https://github.com/ethereum/execution-apis/pull/486 is merged.
        if (request.type !== 'legacy' && request.type !== 'eip2930') // EIP-1559 fees
        {
            if (typeof request.maxFeePerGas === 'undefined' || typeof request.maxPriorityFeePerGas === 'undefined') {
                const block = await getBlock();
                const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $b5773b6d54c3769e$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request
                });
                if (typeof request.maxPriorityFeePerGas === 'undefined' && request.maxFeePerGas && request.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $c631a92240a7f7f4$export$bcf9730904a1086f)({
                    maxPriorityFeePerGas: maxPriorityFeePerGas
                });
                request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                request.maxFeePerGas = maxFeePerGas;
            }
        } else {
            // Legacy fees
            if (typeof request.maxFeePerGas !== 'undefined' || typeof request.maxPriorityFeePerGas !== 'undefined') throw new (0, $c631a92240a7f7f4$export$dcf53c0ae183fb46)();
            if (typeof request.gasPrice === 'undefined') {
                const block = await getBlock();
                const { gasPrice: gasPrice_ } = await (0, $b5773b6d54c3769e$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request,
                    type: 'legacy'
                });
                request.gasPrice = gasPrice_;
            }
        }
    }
    if (parameters.includes('gas') && typeof gas === 'undefined') request.gas = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $d4ca7fabdc22d50d$export$e0580ae1f48db848), 'estimateGas')({
        ...request,
        account: account,
        prepare: account?.type === 'local' ? [] : [
            'blobVersionedHashes'
        ]
    });
    if (prepareTransactionRequest?.fn && prepareTransactionRequest.runAt?.includes('afterFillParameters')) request = await prepareTransactionRequest.fn({
        ...request,
        chain: chain
    }, {
        client: client,
        phase: 'afterFillParameters'
    });
    (0, $6f98ca205ab4eb0c$export$5378021d985ceaf8)(request);
    delete request.parameters;
    return request;
}


/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $6e49bb3761464a91$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: 'eth_sendRawTransaction',
        params: [
            serializedTransaction
        ]
    }, {
        retryCount: 0
    });
}


const $91338b1bb84aec8d$var$supportsWalletNamespace = new (0, $4nYJj.LruMap)(128);
async function $91338b1bb84aec8d$export$8e0e7ffc78696d30(client, parameters) {
    const { account: account_ = client.account, assertChainId: assertChainId = true, chain: chain = client.chain, accessList: accessList, authorizationList: authorizationList, blobs: blobs, data: data, dataSuffix: dataSuffix = typeof client.dataSuffix === 'string' ? client.dataSuffix : client.dataSuffix?.value, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, type: type, value: value, ...rest } = parameters;
    if (typeof account_ === 'undefined') throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/actions/wallet/sendTransaction'
    });
    const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : null;
    let nonceManagerParameters;
    try {
        (0, $6f98ca205ab4eb0c$export$5378021d985ceaf8)(parameters);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (parameters.to) return parameters.to;
            // If `to` is null, we are sending a deployment transaction.
            if (parameters.to === null) return undefined;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $2a378a322473ef36$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $5jfXj.BaseError)('`to` is required. Could not infer from `authorizationList`.');
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account?.type === 'json-rpc' || account === null) {
            let chainId;
            if (chain !== null) {
                chainId = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
                if (assertChainId) (0, $3798f49dfdfe1015$export$390d312ab46d0597)({
                    currentChainId: chainId,
                    chain: chain
                });
            }
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || (0, $1df22e1e5334c1dd$export$d23fcba447c86a8e);
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...(0, $0c055ac55d996b1d$export$f9380c9a627682d3)(rest, {
                    format: chainFormat
                }),
                accessList: accessList,
                account: account,
                authorizationList: authorizationList,
                blobs: blobs,
                chainId: chainId,
                data: dataSuffix ? (0, $4KuzL.concat)([
                    data ?? '0x',
                    dataSuffix
                ]) : data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                type: type,
                value: value
            }, 'sendTransaction');
            const isWalletNamespaceSupported = $91338b1bb84aec8d$var$supportsWalletNamespace.get(client.uid);
            const method = isWalletNamespaceSupported ? 'wallet_sendTransaction' : 'eth_sendTransaction';
            try {
                return await client.request({
                    method: method,
                    params: [
                        request
                    ]
                }, {
                    retryCount: 0
                });
            } catch (e) {
                if (isWalletNamespaceSupported === false) throw e;
                const error = e;
                // If the transport does not support the method or input, attempt to use the
                // `wallet_sendTransaction` method.
                if (error.name === 'InvalidInputRpcError' || error.name === 'InvalidParamsRpcError' || error.name === 'MethodNotFoundRpcError' || error.name === 'MethodNotSupportedRpcError') return await client.request({
                    method: 'wallet_sendTransaction',
                    params: [
                        request
                    ]
                }, {
                    retryCount: 0
                }).then((hash)=>{
                    $91338b1bb84aec8d$var$supportsWalletNamespace.set(client.uid, true);
                    return hash;
                }).catch((e)=>{
                    const walletNamespaceError = e;
                    if (walletNamespaceError.name === 'MethodNotFoundRpcError' || walletNamespaceError.name === 'MethodNotSupportedRpcError') {
                        $91338b1bb84aec8d$var$supportsWalletNamespace.set(client.uid, false);
                        throw error;
                    }
                    throw walletNamespaceError;
                });
                throw error;
            }
        }
        if (account?.type === 'local') {
            if (account.nonceManager && typeof nonce === 'undefined') {
                const requestChainId = rest.chainId;
                const chainId = await (async ()=>{
                    if (typeof requestChainId === 'number') return requestChainId;
                    if (chain) return chain.id;
                    return (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
                })();
                nonceManagerParameters = {
                    address: account.address,
                    chainId: chainId
                };
            }
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $672e074fa9a15fa8$export$2e8a9232fb815d77), 'prepareTransactionRequest')({
                account: account,
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chain: chain,
                data: dataSuffix ? (0, $4KuzL.concat)([
                    data ?? '0x',
                    dataSuffix
                ]) : data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                nonceManager: account.nonceManager,
                parameters: [
                    ...(0, $672e074fa9a15fa8$export$4f3e0c2bc77eca55),
                    'sidecars'
                ],
                type: type,
                value: value,
                ...rest,
                to: to
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction(request, {
                serializer: serializer
            });
            return await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $6e49bb3761464a91$export$4e309754b4830e29), 'sendRawTransaction')({
                serializedTransaction: serializedTransaction
            });
        }
        if (account?.type === 'smart') throw new (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)({
            metaMessages: [
                'Consider using the `sendUserOperation` Action instead.'
            ],
            docsPath: '/docs/actions/bundler/sendUserOperation',
            type: 'smart'
        });
        throw new (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)({
            docsPath: '/docs/actions/wallet/sendTransaction',
            type: account?.type
        });
    } catch (err) {
        if (err instanceof (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)) throw err;
        if (nonceManagerParameters) account?.nonceManager?.reset(nonceManagerParameters);
        throw (0, $db3d75d11c8bc083$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain || undefined
        });
    }
}


function $8beaa8c5b2a6e9ee$export$46c7a79747abe6a9(walletClient, parameters) {
    const { abi: abi, args: args, bytecode: bytecode, ...request } = parameters;
    const calldata = (0, $fd6cebf717099104$export$d7a7276006273fbd)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $91338b1bb84aec8d$export$8e0e7ffc78696d30)(walletClient, {
        ...request,
        ...request.authorizationList ? {
            to: null
        } : {},
        data: calldata
    });
}



var $kiDAM = parcelRequire("kiDAM");
async function $25a1e844e3faa29d$export$17d5f00cfd692b8a(client) {
    if (client.account?.type === 'local') return [
        client.account.address
    ];
    const addresses = await client.request({
        method: 'eth_accounts'
    }, {
        dedupe: true
    });
    return addresses.map((address)=>(0, $kiDAM.checksumAddress)(address));
}



var $cadfc = parcelRequire("cadfc");

var $2ThTG = parcelRequire("2ThTG");

var $lz1vU = parcelRequire("lz1vU");

var $lz1vU = parcelRequire("lz1vU");

function $4fcb1298977b5f1c$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        blockTimestamp: log.blockTimestamp ? BigInt(log.blockTimestamp) : log.blockTimestamp === null ? null : undefined,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}



const $06be2920925d5dc8$export$3f17d120ae0df04 = {
    '0x0': 'reverted',
    '0x1': 'success'
};
function $06be2920925d5dc8$export$30da670e49d6fc31(transactionReceipt, _) {
    const receipt = {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $4fcb1298977b5f1c$export$fccdbdc2b9d7893)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $lz1vU.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $06be2920925d5dc8$export$3f17d120ae0df04[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $014d88210c5bc9cd$export$cd5f936b62a5e91)[transactionReceipt.type] || transactionReceipt.type : null
    };
    if (transactionReceipt.blobGasPrice) receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed) receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
const $06be2920925d5dc8$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $67ba667d98a92ada$export$5d08535cc975931a)('transactionReceipt', $06be2920925d5dc8$export$30da670e49d6fc31);




var $5jfXj = parcelRequire("5jfXj");

var $atQmZ = parcelRequire("atQmZ");

var $24Ila = parcelRequire("24Ila");

var $4KuzL = parcelRequire("4KuzL");

var $lz1vU = parcelRequire("lz1vU");

var $cD3gI = parcelRequire("cD3gI");


const $26c9d7e6b80fcb43$export$6647b8a5470d08d0 = '0x5792579257925792579257925792579257925792579257925792579257925792';
const $26c9d7e6b80fcb43$export$76641de2a1de883e = (0, $cD3gI.numberToHex)(0, {
    size: 32
});
async function $26c9d7e6b80fcb43$export$855abd4eafd73115(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, experimental_fallback: experimental_fallback, experimental_fallbackDelay: experimental_fallbackDelay = 32, forceAtomic: forceAtomic = false, id: id, version: version = '2.0.0' } = parameters;
    const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : null;
    let capabilities = parameters.capabilities;
    if (client.dataSuffix && !parameters.capabilities?.dataSuffix) {
        if (typeof client.dataSuffix === 'string') capabilities = {
            ...parameters.capabilities,
            dataSuffix: {
                value: client.dataSuffix,
                optional: true
            }
        };
        else capabilities = {
            ...parameters.capabilities,
            dataSuffix: {
                value: client.dataSuffix.value,
                ...client.dataSuffix.required ? {} : {
                    optional: true
                }
            }
        };
    }
    const calls = parameters.calls.map((call_)=>{
        const call = call_;
        const data = call.abi ? (0, $24Ila.encodeFunctionData)({
            abi: call.abi,
            functionName: call.functionName,
            args: call.args
        }) : call.data;
        return {
            data: call.dataSuffix && data ? (0, $4KuzL.concat)([
                data,
                call.dataSuffix
            ]) : data,
            to: call.to,
            value: call.value ? (0, $cD3gI.numberToHex)(call.value) : undefined
        };
    });
    try {
        const response = await client.request({
            method: 'wallet_sendCalls',
            params: [
                {
                    atomicRequired: forceAtomic,
                    calls: calls,
                    capabilities: capabilities,
                    chainId: (0, $cD3gI.numberToHex)(chain.id),
                    from: account?.address,
                    id: id,
                    version: version
                }
            ]
        }, {
            retryCount: 0
        });
        if (typeof response === 'string') return {
            id: response
        };
        return response;
    } catch (err) {
        const error = err;
        // If the transport does not support EIP-5792, fall back to
        // `eth_sendTransaction`.
        if (experimental_fallback && (error.name === 'MethodNotFoundRpcError' || error.name === 'MethodNotSupportedRpcError' || error.name === 'UnknownRpcError' || error.details.toLowerCase().includes('does not exist / is not available') || error.details.toLowerCase().includes('missing or invalid. request()') || error.details.toLowerCase().includes('did not match any variant of untagged enum') || error.details.toLowerCase().includes('account upgraded to unsupported contract') || error.details.toLowerCase().includes('eip-7702 not supported') || error.details.toLowerCase().includes('unsupported wc_ method') || // magic.link
        error.details.toLowerCase().includes('feature toggled misconfigured') || // Trust Wallet
        error.details.toLowerCase().includes('jsonrpcengine: response has no error or result for request'))) {
            if (capabilities) {
                const hasNonOptionalCapability = Object.values(capabilities).some((capability)=>!capability.optional);
                if (hasNonOptionalCapability) {
                    const message = 'non-optional `capabilities` are not supported on fallback to `eth_sendTransaction`.';
                    throw new (0, $atQmZ.UnsupportedNonOptionalCapabilityError)(new (0, $5jfXj.BaseError)(message, {
                        details: message
                    }));
                }
            }
            if (forceAtomic && calls.length > 1) {
                const message = '`forceAtomic` is not supported on fallback to `eth_sendTransaction`.';
                throw new (0, $atQmZ.AtomicityNotSupportedError)(new (0, $5jfXj.BaseError)(message, {
                    details: message
                }));
            }
            const results = [];
            for (const call of calls){
                try {
                    const value = await (0, $91338b1bb84aec8d$export$8e0e7ffc78696d30)(client, {
                        account: account,
                        chain: chain,
                        data: call.data,
                        to: call.to,
                        value: call.value ? (0, $lz1vU.hexToBigInt)(call.value) : undefined
                    });
                    results.push({
                        status: 'fulfilled',
                        value: value
                    });
                } catch (reason) {
                    results.push({
                        reason: reason,
                        status: 'rejected'
                    });
                }
                // Note: some browser wallets require a small delay between transactions
                // to prevent duplicate JSON-RPC requests.
                if (experimental_fallbackDelay > 0) await new Promise((resolve)=>setTimeout(resolve, experimental_fallbackDelay));
            }
            if (results.every((r)=>r.status === 'rejected')) throw results[0].reason;
            const hashes = results.map((result)=>{
                if (result.status === 'fulfilled') return result.value;
                return $26c9d7e6b80fcb43$export$76641de2a1de883e;
            });
            return {
                id: (0, $4KuzL.concat)([
                    ...hashes,
                    (0, $cD3gI.numberToHex)(chain.id, {
                        size: 32
                    }),
                    $26c9d7e6b80fcb43$export$6647b8a5470d08d0
                ])
            };
        }
        throw (0, $db3d75d11c8bc083$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain
        });
    }
}


async function $6db4cc8fe48ab573$export$e006d787f2407823(client, parameters) {
    async function getStatus(id) {
        const isTransactions = id.endsWith((0, $26c9d7e6b80fcb43$export$6647b8a5470d08d0).slice(2));
        if (isTransactions) {
            const chainId = (0, $2ThTG.trim)((0, $cadfc.sliceHex)(id, -64, -32));
            const hashes = (0, $cadfc.sliceHex)(id, 0, -64).slice(2).match(/.{1,64}/g);
            const receipts = await Promise.all(hashes.map((hash)=>(0, $26c9d7e6b80fcb43$export$76641de2a1de883e).slice(2) !== hash ? client.request({
                    method: 'eth_getTransactionReceipt',
                    params: [
                        `0x${hash}`
                    ]
                }, {
                    dedupe: true
                }) : undefined));
            const status = (()=>{
                if (receipts.some((r)=>r === null)) return 100; // pending
                if (receipts.every((r)=>r?.status === '0x1')) return 200; // success
                if (receipts.every((r)=>r?.status === '0x0')) return 500; // complete failure
                return 600; // partial failure
            })();
            return {
                atomic: false,
                chainId: (0, $lz1vU.hexToNumber)(chainId),
                receipts: receipts.filter(Boolean),
                status: status,
                version: '2.0.0'
            };
        }
        return client.request({
            method: 'wallet_getCallsStatus',
            params: [
                id
            ]
        });
    }
    const { atomic: atomic = false, chainId: chainId, receipts: receipts, version: version = '2.0.0', ...response } = await getStatus(parameters.id);
    const [status, statusCode] = (()=>{
        const statusCode = response.status;
        if (statusCode >= 100 && statusCode < 200) return [
            'pending',
            statusCode
        ];
        if (statusCode >= 200 && statusCode < 300) return [
            'success',
            statusCode
        ];
        if (statusCode >= 300 && statusCode < 700) return [
            'failure',
            statusCode
        ];
        // @ts-expect-error: for backwards compatibility
        if (statusCode === 'CONFIRMED') return [
            'success',
            200
        ];
        // @ts-expect-error: for backwards compatibility
        if (statusCode === 'PENDING') return [
            'pending',
            100
        ];
        return [
            undefined,
            statusCode
        ];
    })();
    return {
        ...response,
        atomic: atomic,
        // @ts-expect-error: for backwards compatibility
        chainId: chainId ? (0, $lz1vU.hexToNumber)(chainId) : undefined,
        receipts: receipts?.map((receipt)=>({
                ...receipt,
                blockNumber: (0, $lz1vU.hexToBigInt)(receipt.blockNumber),
                gasUsed: (0, $lz1vU.hexToBigInt)(receipt.gasUsed),
                status: (0, $06be2920925d5dc8$export$3f17d120ae0df04)[receipt.status]
            })) ?? [],
        statusCode: statusCode,
        status: status,
        version: version
    };
}




var $cD3gI = parcelRequire("cD3gI");
async function $955b2cb8f6ef3967$export$80a6dbd652bdbd9e(client, parameters = {}) {
    const { account: account = client.account, chainId: chainId } = parameters;
    const account_ = account ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account) : undefined;
    const params = chainId ? [
        account_?.address,
        [
            (0, $cD3gI.numberToHex)(chainId)
        ]
    ] : [
        account_?.address
    ];
    const capabilities_raw = await client.request({
        method: 'wallet_getCapabilities',
        params: params
    });
    const capabilities = {};
    for (const [chainId, capabilities_] of Object.entries(capabilities_raw)){
        capabilities[Number(chainId)] = {};
        for (let [key, value] of Object.entries(capabilities_)){
            if (key === 'addSubAccount') key = 'unstable_addSubAccount';
            capabilities[Number(chainId)][key] = value;
        }
    }
    return typeof chainId === 'number' ? capabilities[chainId] : capabilities;
}


/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ async function $54608cfb8e4867b5$export$e10fd44ca431fa8e(client) {
    const permissions = await client.request({
        method: 'wallet_getPermissions'
    }, {
        dedupe: true
    });
    return permissions;
}





var $eCsKB = parcelRequire("eCsKB");

var $9GvsK = parcelRequire("9GvsK");
function $4f315ada2038a243$export$34ca016df7f376b8(a, b) {
    if (!(0, $9GvsK.isAddress)(a, {
        strict: false
    })) throw new (0, $eCsKB.InvalidAddressError)({
        address: a
    });
    if (!(0, $9GvsK.isAddress)(b, {
        strict: false
    })) throw new (0, $eCsKB.InvalidAddressError)({
        address: b
    });
    return a.toLowerCase() === b.toLowerCase();
}





async function $b9def78457a71b09$export$38b9b896ebe80b77(client, parameters) {
    const { account: account_ = client.account, chainId: chainId, nonce: nonce } = parameters;
    if (!account_) throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/eip7702/prepareAuthorization'
    });
    const account = (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_);
    const executor = (()=>{
        if (!parameters.executor) return undefined;
        if (parameters.executor === 'self') return parameters.executor;
        return (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(parameters.executor);
    })();
    const authorization = {
        address: parameters.contractAddress ?? parameters.address,
        chainId: chainId,
        nonce: nonce
    };
    if (typeof authorization.chainId === 'undefined') authorization.chainId = client.chain?.id ?? await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
    if (typeof authorization.nonce === 'undefined') {
        authorization.nonce = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $38940ece51e7e6e5$export$b18e66333ec1361e), 'getTransactionCount')({
            address: account.address,
            blockTag: 'pending'
        });
        if (executor === 'self' || executor?.address && (0, $4f315ada2038a243$export$34ca016df7f376b8)(executor.address, account.address)) authorization.nonce += 1;
    }
    return authorization;
}




var $kiDAM = parcelRequire("kiDAM");
async function $5a8a34a6ca5a6a42$export$87c5bcc1dede6f06(client) {
    const addresses = await client.request({
        method: 'eth_requestAccounts'
    }, {
        dedupe: true,
        retryCount: 0
    });
    return addresses.map((address)=>(0, $kiDAM.getAddress)(address));
}


/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ async function $7c5a2cb2a2ef21ff$export$8cec5d3683c6896e(client, permissions) {
    return client.request({
        method: 'wallet_requestPermissions',
        params: [
            permissions
        ]
    }, {
        retryCount: 0
    });
}






var $5jfXj = parcelRequire("5jfXj");

var $5jfXj = parcelRequire("5jfXj");
class $c4151ac50429aba3$export$13c803541018408d extends (0, $5jfXj.BaseError) {
    constructor(result){
        super(`Call bundle failed with status: ${result.statusCode}`, {
            name: 'BundleFailedError'
        });
        Object.defineProperty(this, "result", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.result = result;
    }
}



/** @internal */ const $f0ac090e0095891a$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $f0ac090e0095891a$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $f0ac090e0095891a$var$callbackCount = 0;
function $f0ac090e0095891a$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$f0ac090e0095891a$var$callbackCount;
    const getListeners = ()=>$f0ac090e0095891a$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        const nextListeners = listeners.filter((cb)=>cb.id !== callbackId);
        if (nextListeners.length === 0) {
            $f0ac090e0095891a$export$94ab3a05cb07971d.delete(observerId);
            $f0ac090e0095891a$export$b4a4aba7c5f97c17.delete(observerId);
            return;
        }
        $f0ac090e0095891a$export$94ab3a05cb07971d.set(observerId, nextListeners);
    };
    const unwatch = ()=>{
        const listeners = getListeners();
        if (!listeners.some((cb)=>cb.id === callbackId)) return;
        const cleanup = $f0ac090e0095891a$export$b4a4aba7c5f97c17.get(observerId);
        if (listeners.length === 1 && cleanup) {
            const p = cleanup();
            if (p instanceof Promise) p.catch(()=>{});
        }
        unsubscribe();
    };
    const listeners = getListeners();
    $f0ac090e0095891a$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === 'function') $f0ac090e0095891a$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}



var $h08PT = parcelRequire("h08PT");
function $c2f5b84b95a6ebc1$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $h08PT.wait)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $h08PT.wait)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}



var $3izIq = parcelRequire("3izIq");

var $3A9zH = parcelRequire("3A9zH");

var $XRcTc = parcelRequire("XRcTc");

async function $52bc7d97bc3ef02c$export$f5bf85fd054d174f(client, parameters) {
    const { id: id, pollingInterval: pollingInterval = client.pollingInterval, status: status = ({ statusCode: statusCode })=>statusCode === 200 || statusCode >= 300, retryCount: retryCount = 4, retryDelay: retryDelay = ({ count: count })=>~~(1 << count) * 200, timeout: timeout = 60000, throwOnFailure: throwOnFailure = false } = parameters;
    const observerId = (0, $XRcTc.stringify)([
        'waitForCallsStatus',
        client.uid,
        id
    ]);
    const { promise: promise, resolve: resolve, reject: reject } = (0, $3izIq.withResolvers)();
    let timer;
    const unobserve = (0, $f0ac090e0095891a$export$d1203567a167490e)(observerId, {
        resolve: resolve,
        reject: reject
    }, (emit)=>{
        const unpoll = (0, $c2f5b84b95a6ebc1$export$e0c10349b2c5e1d4)(async ()=>{
            const done = (fn)=>{
                clearTimeout(timer);
                unpoll();
                fn();
                unobserve();
            };
            try {
                const result = await (0, $3A9zH.withRetry)(async ()=>{
                    const result = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $6db4cc8fe48ab573$export$e006d787f2407823), 'getCallsStatus')({
                        id: id
                    });
                    if (throwOnFailure && result.status === 'failure') throw new (0, $c4151ac50429aba3$export$13c803541018408d)(result);
                    return result;
                }, {
                    retryCount: retryCount,
                    delay: retryDelay
                });
                if (!status(result)) return;
                done(()=>emit.resolve(result));
            } catch (error) {
                done(()=>emit.reject(error));
            }
        }, {
            interval: pollingInterval,
            emitOnBegin: true
        });
        return unpoll;
    });
    timer = timeout ? setTimeout(()=>{
        unobserve();
        clearTimeout(timer);
        reject(new $52bc7d97bc3ef02c$export$fb6b538e2975389({
            id: id
        }));
    }, timeout) : undefined;
    return await promise;
}
class $52bc7d97bc3ef02c$export$fb6b538e2975389 extends (0, $5jfXj.BaseError) {
    constructor({ id: id }){
        super(`Timed out while waiting for call bundle with id "${id}" to be confirmed.`, {
            name: 'WaitForCallsStatusTimeoutError'
        });
    }
}


async function $ffd422e24a17eefb$export$220732bcfdca3ff8(client, parameters) {
    const { chain: chain = client.chain } = parameters;
    const timeout = parameters.timeout ?? Math.max((chain?.blockTime ?? 0) * 3, 5000);
    const result = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $26c9d7e6b80fcb43$export$855abd4eafd73115), 'sendCalls')(parameters);
    const status = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $52bc7d97bc3ef02c$export$f5bf85fd054d174f), 'waitForCallsStatus')({
        ...parameters,
        id: result.id,
        timeout: timeout
    });
    return status;
}





async function $06be2ddda140d5f6$export$b71ad7c1cdb046c7(client, { serializedTransaction: serializedTransaction, throwOnReceiptRevert: throwOnReceiptRevert, timeout: timeout }) {
    const receipt = await client.request({
        method: 'eth_sendRawTransactionSync',
        params: timeout ? [
            serializedTransaction,
            timeout
        ] : [
            serializedTransaction
        ]
    }, {
        retryCount: 0
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $06be2920925d5dc8$export$30da670e49d6fc31);
    const formatted = format(receipt);
    if (formatted.status === 'reverted' && throwOnReceiptRevert) throw new (0, $8f6a5f9d053a5a2a$export$f0f1b8be51f0d2a2)({
        receipt: formatted
    });
    return formatted;
}






var $5jfXj = parcelRequire("5jfXj");




var $4KuzL = parcelRequire("4KuzL");





var $4nYJj = parcelRequire("4nYJj");







var $3izIq = parcelRequire("3izIq");

var $3A9zH = parcelRequire("3A9zH");

var $XRcTc = parcelRequire("XRcTc");



var $cD3gI = parcelRequire("cD3gI");

async function $9f9315b5ff7f9ff8$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index, sender: sender, nonce: nonce }) {
    const blockTag = blockTag_ || 'latest';
    const blockNumberHex = blockNumber !== undefined ? (0, $cD3gI.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: 'eth_getTransactionByHash',
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    else if (blockHash) transaction = await client.request({
        method: 'eth_getTransactionByBlockHashAndIndex',
        params: [
            blockHash,
            (0, $cD3gI.numberToHex)(index)
        ]
    }, {
        dedupe: true
    });
    else if ((blockNumberHex || blockTag) && typeof index === 'number') transaction = await client.request({
        method: 'eth_getTransactionByBlockNumberAndIndex',
        params: [
            blockNumberHex || blockTag,
            (0, $cD3gI.numberToHex)(index)
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    else if (sender && typeof nonce === 'number') transaction = await client.request({
        method: 'eth_getTransactionBySenderAndNonce',
        params: [
            sender,
            (0, $cD3gI.numberToHex)(nonce)
        ]
    }, {
        dedupe: true
    });
    if (!transaction) throw new (0, $8f6a5f9d053a5a2a$export$23c42bc218867b7c)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $014d88210c5bc9cd$export$b02b16590d26dadc);
    return format(transaction, 'getTransaction');
}




async function $cd8324708314076f$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: 'eth_getTransactionReceipt',
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    if (!receipt) throw new (0, $8f6a5f9d053a5a2a$export$df65591684d92652)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $06be2920925d5dc8$export$30da670e49d6fc31);
    return format(receipt, 'getTransactionReceipt');
}



var $lz1vU = parcelRequire("lz1vU");




var $XRcTc = parcelRequire("XRcTc");
/** @internal */ const $0b1ce0d343498384$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $0b1ce0d343498384$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $0b1ce0d343498384$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $0b1ce0d343498384$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $0b1ce0d343498384$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $0b1ce0d343498384$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Number.POSITIVE_INFINITY }) {
    const cache = $0b1ce0d343498384$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = Date.now() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}


const $f7a2b53be06449fa$var$cacheKey = (id)=>`blockNumber.${id}`;
function $f7a2b53be06449fa$export$bc78c57a2d1b4a2b(id) {
    return (0, $0b1ce0d343498384$export$e2575ed62a2f107b)($f7a2b53be06449fa$var$cacheKey(id));
}
async function $f7a2b53be06449fa$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime } = {}) {
    const blockNumberHex = await (0, $0b1ce0d343498384$export$33b32b3abf8170f0)(()=>client.request({
            method: 'eth_blockNumber'
        }), {
        cacheKey: $f7a2b53be06449fa$var$cacheKey(client.uid),
        cacheTime: cacheTime
    });
    return BigInt(blockNumberHex);
}


function $c0ebbafc2f227a39$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== 'undefined') return poll_;
        if (client.transport.type === 'webSocket' || client.transport.type === 'ipc') return false;
        if (client.transport.type === 'fallback' && (client.transport.transports[0].config.type === 'webSocket' || client.transport.transports[0].config.type === 'ipc')) return false;
        return true;
    })();
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $XRcTc.stringify)([
            'watchBlockNumber',
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $f0ac090e0095891a$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $c2f5b84b95a6ebc1$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const blockNumber = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $f7a2b53be06449fa$export$9328b5c92c53a20e), 'getBlockNumber')({
                        cacheTime: 0
                    });
                    if (prevBlockNumber !== undefined) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (prevBlockNumber === undefined || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        const observerId = (0, $XRcTc.stringify)([
            'watchBlockNumber',
            client.uid,
            emitOnBegin,
            emitMissed
        ]);
        return (0, $f0ac090e0095891a$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>{
            let active = true;
            let unsubscribe = ()=>active = false;
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === 'fallback') {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === 'webSocket' || transport.config.type === 'ipc');
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            'newHeads'
                        ],
                        onData (data) {
                            if (!active) return;
                            const blockNumber = (0, $lz1vU.hexToBigInt)(data.result?.number);
                            emit.onBlockNumber(blockNumber, prevBlockNumber);
                            prevBlockNumber = blockNumber;
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}


async function $048378cb531487ea$export$694ec9bdf0bb55cf(client, parameters) {
    const { checkReplacement: checkReplacement = true, confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, retryCount: retryCount = 6, retryDelay: retryDelay = ({ count: count })=>~~(1 << count) * 200, timeout: timeout = 180000 } = parameters;
    const observerId = (0, $XRcTc.stringify)([
        'waitForTransactionReceipt',
        client.uid,
        hash
    ]);
    const pollingInterval = (()=>{
        if (parameters.pollingInterval) return parameters.pollingInterval;
        if (client.chain?.experimental_preconfirmationTime) return client.chain.experimental_preconfirmationTime;
        return client.pollingInterval;
    })();
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    let _unobserve;
    let _unwatch;
    const { promise: promise, resolve: resolve, reject: reject } = (0, $3izIq.withResolvers)();
    const timer = timeout ? setTimeout(()=>{
        _unwatch?.();
        _unobserve?.();
        reject(new (0, $8f6a5f9d053a5a2a$export$69578a09754f4b33)({
            hash: hash
        }));
    }, timeout) : undefined;
    _unobserve = (0, $f0ac090e0095891a$export$d1203567a167490e)(observerId, {
        onReplaced: onReplaced,
        resolve: resolve,
        reject: reject
    }, async (emit)=>{
        receipt = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $cd8324708314076f$export$6b1ceb3cd5f8b21f), 'getTransactionReceipt')({
            hash: hash
        }).catch(()=>undefined);
        if (receipt && confirmations <= 1) {
            clearTimeout(timer);
            emit.resolve(receipt);
            _unobserve?.();
            return;
        }
        _unwatch = (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $c0ebbafc2f227a39$export$fc5f622dd0d82466), 'watchBlockNumber')({
            emitMissed: true,
            emitOnBegin: true,
            poll: true,
            pollingInterval: pollingInterval,
            async onBlockNumber (blockNumber_) {
                const done = (fn)=>{
                    clearTimeout(timer);
                    _unwatch?.();
                    fn();
                    _unobserve?.();
                };
                let blockNumber = blockNumber_;
                if (retrying) return;
                try {
                    // If we already have a valid receipt, let's check if we have enough
                    // confirmations. If we do, then we can resolve.
                    if (receipt) {
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                        return;
                    }
                    // Get the transaction to check if it's been replaced.
                    // We need to retry as some RPC Providers may be slow to sync
                    // up mined transactions.
                    if (checkReplacement && !transaction) {
                        retrying = true;
                        await (0, $3A9zH.withRetry)(async ()=>{
                            transaction = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $9f9315b5ff7f9ff8$export$ec0c6556a09b65b8), 'getTransaction')({
                                hash: hash
                            });
                            if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                        }, {
                            delay: retryDelay,
                            retryCount: retryCount
                        });
                        retrying = false;
                    }
                    // Get the receipt to check if it's been processed.
                    receipt = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $cd8324708314076f$export$6b1ceb3cd5f8b21f), 'getTransactionReceipt')({
                        hash: hash
                    });
                    // Check if we have enough confirmations. If not, continue polling.
                    if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                    done(()=>emit.resolve(receipt));
                } catch (err) {
                    // If the receipt is not found, the transaction will be pending.
                    // We need to check if it has potentially been replaced.
                    if (err instanceof (0, $8f6a5f9d053a5a2a$export$23c42bc218867b7c) || err instanceof (0, $8f6a5f9d053a5a2a$export$df65591684d92652)) {
                        if (!transaction) {
                            retrying = false;
                            return;
                        }
                        try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await (0, $3A9zH.withRetry)(()=>(0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $e100edce7d3d8fad$export$ea0af84ed2e77902), 'getBlock')({
                                    blockNumber: blockNumber,
                                    includeTransactions: true
                                }), {
                                delay: retryDelay,
                                retryCount: retryCount,
                                shouldRetry: ({ error: error })=>error instanceof (0, $14a6621c64bc60b5$export$f5a00468af285e38)
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction) return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $cd8324708314076f$export$6b1ceb3cd5f8b21f), 'getTransactionReceipt')({
                                hash: replacementTransaction.hash
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            let reason = 'replaced';
                            if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value && replacementTransaction.input === replacedTransaction.input) reason = 'repriced';
                            else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = 'cancelled';
                            done(()=>{
                                emit.onReplaced?.({
                                    reason: reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt
                                });
                                emit.resolve(receipt);
                            });
                        } catch (err_) {
                            done(()=>emit.reject(err_));
                        }
                    } else done(()=>emit.reject(err));
                }
            }
        });
    });
    return promise;
}




const $824a75546155dd49$var$supportsWalletNamespace = new (0, $4nYJj.LruMap)(128);
async function $824a75546155dd49$export$7901f5426fdc01f1(client, parameters) {
    const { account: account_ = client.account, assertChainId: assertChainId = true, chain: chain = client.chain, accessList: accessList, authorizationList: authorizationList, blobs: blobs, data: data, dataSuffix: dataSuffix = typeof client.dataSuffix === 'string' ? client.dataSuffix : client.dataSuffix?.value, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, pollingInterval: pollingInterval, throwOnReceiptRevert: throwOnReceiptRevert, type: type, value: value, ...rest } = parameters;
    const timeout = parameters.timeout ?? Math.max((chain?.blockTime ?? 0) * 3, 5000);
    if (typeof account_ === 'undefined') throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/actions/wallet/sendTransactionSync'
    });
    const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : null;
    let nonceManagerParameters;
    try {
        (0, $6f98ca205ab4eb0c$export$5378021d985ceaf8)(parameters);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (parameters.to) return parameters.to;
            // If `to` is null, we are sending a deployment transaction.
            if (parameters.to === null) return undefined;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $2a378a322473ef36$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $5jfXj.BaseError)('`to` is required. Could not infer from `authorizationList`.');
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account?.type === 'json-rpc' || account === null) {
            let chainId;
            if (chain !== null) {
                chainId = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
                if (assertChainId) (0, $3798f49dfdfe1015$export$390d312ab46d0597)({
                    currentChainId: chainId,
                    chain: chain
                });
            }
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || (0, $1df22e1e5334c1dd$export$d23fcba447c86a8e);
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...(0, $0c055ac55d996b1d$export$f9380c9a627682d3)(rest, {
                    format: chainFormat
                }),
                accessList: accessList,
                account: account,
                authorizationList: authorizationList,
                blobs: blobs,
                chainId: chainId,
                data: dataSuffix ? (0, $4KuzL.concat)([
                    data ?? '0x',
                    dataSuffix
                ]) : data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                type: type,
                value: value
            }, 'sendTransaction');
            const isWalletNamespaceSupported = $824a75546155dd49$var$supportsWalletNamespace.get(client.uid);
            const method = isWalletNamespaceSupported ? 'wallet_sendTransaction' : 'eth_sendTransaction';
            const hash = await (async ()=>{
                try {
                    return await client.request({
                        method: method,
                        params: [
                            request
                        ]
                    }, {
                        retryCount: 0
                    });
                } catch (e) {
                    if (isWalletNamespaceSupported === false) throw e;
                    const error = e;
                    // If the transport does not support the method or input, attempt to use the
                    // `wallet_sendTransaction` method.
                    if (error.name === 'InvalidInputRpcError' || error.name === 'InvalidParamsRpcError' || error.name === 'MethodNotFoundRpcError' || error.name === 'MethodNotSupportedRpcError') return await client.request({
                        method: 'wallet_sendTransaction',
                        params: [
                            request
                        ]
                    }, {
                        retryCount: 0
                    }).then((hash)=>{
                        $824a75546155dd49$var$supportsWalletNamespace.set(client.uid, true);
                        return hash;
                    }).catch((e)=>{
                        const walletNamespaceError = e;
                        if (walletNamespaceError.name === 'MethodNotFoundRpcError' || walletNamespaceError.name === 'MethodNotSupportedRpcError') {
                            $824a75546155dd49$var$supportsWalletNamespace.set(client.uid, false);
                            throw error;
                        }
                        throw walletNamespaceError;
                    });
                    throw error;
                }
            })();
            const receipt = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $048378cb531487ea$export$694ec9bdf0bb55cf), 'waitForTransactionReceipt')({
                checkReplacement: false,
                hash: hash,
                pollingInterval: pollingInterval,
                timeout: timeout
            });
            if (throwOnReceiptRevert && receipt.status === 'reverted') throw new (0, $8f6a5f9d053a5a2a$export$f0f1b8be51f0d2a2)({
                receipt: receipt
            });
            return receipt;
        }
        if (account?.type === 'local') {
            if (account.nonceManager && typeof nonce === 'undefined') {
                const requestChainId = rest.chainId;
                const chainId = await (async ()=>{
                    if (typeof requestChainId === 'number') return requestChainId;
                    if (chain) return chain.id;
                    return (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
                })();
                nonceManagerParameters = {
                    address: account.address,
                    chainId: chainId
                };
            }
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $672e074fa9a15fa8$export$2e8a9232fb815d77), 'prepareTransactionRequest')({
                account: account,
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chain: chain,
                data: dataSuffix ? (0, $4KuzL.concat)([
                    data ?? '0x',
                    dataSuffix
                ]) : data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                nonceManager: account.nonceManager,
                parameters: [
                    ...(0, $672e074fa9a15fa8$export$4f3e0c2bc77eca55),
                    'sidecars'
                ],
                type: type,
                value: value,
                ...rest,
                to: to
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction(request, {
                serializer: serializer
            });
            return await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $06be2ddda140d5f6$export$b71ad7c1cdb046c7), 'sendRawTransactionSync')({
                serializedTransaction: serializedTransaction,
                throwOnReceiptRevert: throwOnReceiptRevert,
                timeout: parameters.timeout
            });
        }
        if (account?.type === 'smart') throw new (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)({
            metaMessages: [
                'Consider using the `sendUserOperation` Action instead.'
            ],
            docsPath: '/docs/actions/bundler/sendUserOperation',
            type: 'smart'
        });
        throw new (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)({
            docsPath: '/docs/actions/wallet/sendTransactionSync',
            type: account?.type
        });
    } catch (err) {
        if (err instanceof (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)) throw err;
        if (nonceManagerParameters && !(err instanceof (0, $8f6a5f9d053a5a2a$export$f0f1b8be51f0d2a2))) account?.nonceManager?.reset(nonceManagerParameters);
        throw (0, $db3d75d11c8bc083$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain || undefined
        });
    }
}


/**
 * Requests for the wallet to show information about a call batch
 * that was sent via `sendCalls`.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/showCallsStatus
 * - JSON-RPC Methods: [`wallet_showCallsStatus`](https://eips.ethereum.org/EIPS/eip-5792)
 *
 * @param client - Client to use
 * @returns Status of the calls. {@link ShowCallsStatusReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { showCallsStatus } from 'viem/actions'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * await showCallsStatus(client, { id: '0xdeadbeef' })
 */ async function $acd6ab369c49c842$export$a503dea929b80d(client, parameters) {
    const { id: id } = parameters;
    await client.request({
        method: 'wallet_showCallsStatus',
        params: [
            id
        ]
    });
    return;
}





async function $1535407178c0e921$export$b34b2771bbc8b9d7(client, parameters) {
    const { account: account_ = client.account } = parameters;
    if (!account_) throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/eip7702/signAuthorization'
    });
    const account = (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_);
    if (!account.signAuthorization) throw new (0, $f8213a878aaa4056$export$22c1d840ef5fbc66)({
        docsPath: '/docs/eip7702/signAuthorization',
        metaMessages: [
            'The `signAuthorization` Action does not support JSON-RPC Accounts.'
        ],
        type: account.type
    });
    const authorization = await (0, $b9def78457a71b09$export$38b9b896ebe80b77)(client, parameters);
    return account.signAuthorization(authorization);
}





var $cD3gI = parcelRequire("cD3gI");
async function $57409f1a06601236$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/actions/wallet/signMessage'
    });
    const account = (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_);
    if (account.signMessage) return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === 'string') return (0, $cD3gI.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $cD3gI.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: 'personal_sign',
        params: [
            message_,
            account.address
        ]
    }, {
        retryCount: 0
    });
}






var $cD3gI = parcelRequire("cD3gI");




async function $b4482e75622132ad$export$6ad02cc4966b42ab(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, ...transaction } = parameters;
    if (!account_) throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/actions/wallet/signTransaction'
    });
    const account = (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_);
    (0, $6f98ca205ab4eb0c$export$5378021d985ceaf8)({
        account: account,
        ...parameters
    });
    const chainId = await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, (0, $2e97a4a9ea5cb029$export$850fa7b3891187c), 'getChainId')({});
    if (chain !== null) (0, $3798f49dfdfe1015$export$390d312ab46d0597)({
        currentChainId: chainId,
        chain: chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || (0, $1df22e1e5334c1dd$export$d23fcba447c86a8e);
    if (account.signTransaction) return account.signTransaction({
        ...transaction,
        account: account,
        chainId: chainId
    }, {
        serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
        method: 'eth_signTransaction',
        params: [
            {
                ...format({
                    ...transaction,
                    account: account
                }, 'signTransaction'),
                chainId: (0, $cD3gI.numberToHex)(chainId),
                from: account.address
            }
        ]
    }, {
        retryCount: 0
    });
}





var $ltkM7 = parcelRequire("ltkM7");
async function $b6a339e863775c2d$export$9f05de2db4d31153(client, parameters) {
    const { account: account_ = client.account, domain: domain, message: message, primaryType: primaryType } = parameters;
    if (!account_) throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
        docsPath: '/docs/actions/wallet/signTypedData'
    });
    const account = (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_);
    const types = {
        EIP712Domain: (0, $ltkM7.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $ltkM7.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    if (account.signTypedData) return account.signTypedData({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const typedData = (0, $ltkM7.serializeTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    return client.request({
        method: 'eth_signTypedData_v4',
        params: [
            account.address,
            typedData
        ]
    }, {
        retryCount: 0
    });
}



var $cD3gI = parcelRequire("cD3gI");
async function $9a248d96442a5848$export$15599da40e72d2f(client, { id: id }) {
    await client.request({
        method: 'wallet_switchEthereumChain',
        params: [
            {
                chainId: (0, $cD3gI.numberToHex)(id)
            }
        ]
    }, {
        retryCount: 0
    });
}



/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ async function $953eb9daf7a5dd17$export$7eea68d1a70548bd(client, params) {
    const added = await client.request({
        method: 'wallet_watchAsset',
        params: params
    }, {
        retryCount: 0
    });
    return added;
}





var $24Ila = parcelRequire("24Ila");

var $dZdNo = parcelRequire("dZdNo");

var $5jfXj = parcelRequire("5jfXj");

// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $3083ddde2574b23e$export$a618024566d3d221 = {
    1: 'An `assert` condition failed.',
    17: 'Arithmetic operation resulted in underflow or overflow.',
    18: 'Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).',
    33: 'Attempted to convert to an invalid type.',
    34: 'Attempted to access a storage byte array that is incorrectly encoded.',
    49: 'Performed `.pop()` on an empty array',
    50: 'Array index is out of bounds.',
    65: 'Allocated too much memory or created an array which is too large.',
    81: 'Attempted to call a zero-initialized variable of internal function type.'
};
const $3083ddde2574b23e$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: 'message',
            type: 'string'
        }
    ],
    name: 'Error',
    type: 'error'
};
const $3083ddde2574b23e$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: 'reason',
            type: 'uint256'
        }
    ],
    name: 'Panic',
    type: 'error'
};




var $dZdNo = parcelRequire("dZdNo");

var $cadfc = parcelRequire("cadfc");

var $eIg5H = parcelRequire("eIg5H");

var $dZdNo = parcelRequire("dZdNo");

var $kiDAM = parcelRequire("kiDAM");


var $2u1VO = parcelRequire("2u1VO");

var $cadfc = parcelRequire("cadfc");

var $2ThTG = parcelRequire("2ThTG");

var $9Ckzf = parcelRequire("9Ckzf");

var $2ThTG = parcelRequire("2ThTG");

var $lz1vU = parcelRequire("lz1vU");

var $cD3gI = parcelRequire("cD3gI");
function $f490b785725addaa$export$de2da3025c30316c(bytes, toOrOpts) {
    const opts = typeof toOrOpts === 'string' ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === 'number') return $f490b785725addaa$export$c0cca17bcf674749(bytes, opts);
    if (to === 'bigint') return $f490b785725addaa$export$2a52511e4f35930a(bytes, opts);
    if (to === 'boolean') return $f490b785725addaa$export$aa06fda122958d5d(bytes, opts);
    if (to === 'string') return $f490b785725addaa$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $cD3gI.bytesToHex)(bytes, opts);
}
function $f490b785725addaa$export$2a52511e4f35930a(bytes, opts = {}) {
    if (typeof opts.size !== 'undefined') (0, $lz1vU.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $cD3gI.bytesToHex)(bytes, opts);
    return (0, $lz1vU.hexToBigInt)(hex, opts);
}
function $f490b785725addaa$export$aa06fda122958d5d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== 'undefined') {
        (0, $lz1vU.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $2ThTG.trim)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $9Ckzf.InvalidBytesBooleanError)(bytes);
    return Boolean(bytes[0]);
}
function $f490b785725addaa$export$c0cca17bcf674749(bytes, opts = {}) {
    if (typeof opts.size !== 'undefined') (0, $lz1vU.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $cD3gI.bytesToHex)(bytes, opts);
    return (0, $lz1vU.hexToNumber)(hex, opts);
}
function $f490b785725addaa$export$7c746b75f47c9c7d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== 'undefined') {
        (0, $lz1vU.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $2ThTG.trim)(bytes, {
            dir: 'right'
        });
    }
    return new TextDecoder().decode(bytes);
}



var $kc9Jh = parcelRequire("kc9Jh");

var $cD3gI = parcelRequire("cD3gI");

var $lBZMD = parcelRequire("lBZMD");
function $e13b2a8578b988c1$export$84d51ac2fffabd56(params, data) {
    const bytes = typeof data === 'string' ? (0, $kc9Jh.hexToBytes)(data) : data;
    const cursor = (0, $3c2e56287ee84b48$export$fb542681b7c0dc55)(bytes);
    if ((0, $2u1VO.size)(bytes) === 0 && params.length > 0) throw new (0, $dZdNo.AbiDecodingZeroDataError)();
    if ((0, $2u1VO.size)(data) && (0, $2u1VO.size)(data) < 32) throw new (0, $dZdNo.AbiDecodingDataSizeTooSmallError)({
        data: typeof data === 'string' ? data : (0, $cD3gI.bytesToHex)(data),
        params: params,
        size: (0, $2u1VO.size)(data)
    });
    let consumed = 0;
    const values = [];
    for(let i = 0; i < params.length; ++i){
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $e13b2a8578b988c1$var$decodeParameter(cursor, param, {
            staticPosition: 0
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function $e13b2a8578b988c1$var$decodeParameter(cursor, param, { staticPosition: staticPosition }) {
    const arrayComponents = (0, $lBZMD.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $e13b2a8578b988c1$var$decodeArray(cursor, {
            ...param,
            type: type
        }, {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === 'tuple') return $e13b2a8578b988c1$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === 'address') return $e13b2a8578b988c1$var$decodeAddress(cursor);
    if (param.type === 'bool') return $e13b2a8578b988c1$var$decodeBool(cursor);
    if (param.type.startsWith('bytes')) return $e13b2a8578b988c1$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith('uint') || param.type.startsWith('int')) return $e13b2a8578b988c1$var$decodeNumber(cursor, param);
    if (param.type === 'string') return $e13b2a8578b988c1$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $dZdNo.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: '/docs/contract/decodeAbiParameters'
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const $e13b2a8578b988c1$var$sizeOfLength = 32;
const $e13b2a8578b988c1$var$sizeOfOffset = 32;
function $e13b2a8578b988c1$var$decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [
        (0, $kiDAM.checksumAddress)((0, $cD3gI.bytesToHex)((0, $cadfc.sliceBytes)(value, -20))),
        32
    ];
}
function $e13b2a8578b988c1$var$decodeArray(cursor, param, { length: length, staticPosition: staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes($e13b2a8578b988c1$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $e13b2a8578b988c1$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes($e13b2a8578b988c1$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $e13b2a8578b988c1$var$hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $e13b2a8578b988c1$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($e13b2a8578b988c1$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes($e13b2a8578b988c1$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $e13b2a8578b988c1$var$decodeParameter(cursor, param, {
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $e13b2a8578b988c1$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $e13b2a8578b988c1$var$decodeBool(cursor) {
    return [
        (0, $f490b785725addaa$export$aa06fda122958d5d)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $e13b2a8578b988c1$var$decodeBytes(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split('bytes');
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                '0x',
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $cD3gI.bytesToHex)(data),
            32
        ];
    }
    const value = (0, $cD3gI.bytesToHex)(cursor.readBytes(Number.parseInt(size, 10), 32));
    return [
        value,
        32
    ];
}
function $e13b2a8578b988c1$var$decodeNumber(cursor, param) {
    const signed = param.type.startsWith('int');
    const size = Number.parseInt(param.type.split('int')[1] || '256', 10);
    const value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $f490b785725addaa$export$2a52511e4f35930a)(value, {
            signed: signed
        }) : (0, $f490b785725addaa$export$c0cca17bcf674749)(value, {
            signed: signed
        }),
        32
    ];
}
function $e13b2a8578b988c1$var$decodeTuple(cursor, param, { staticPosition: staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($e13b2a8578b988c1$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes($e13b2a8578b988c1$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $e13b2a8578b988c1$var$decodeParameter(cursor, component, {
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $e13b2a8578b988c1$var$decodeParameter(cursor, component, {
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $e13b2a8578b988c1$var$decodeString(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = (0, $f490b785725addaa$export$c0cca17bcf674749)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            '',
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = (0, $f490b785725addaa$export$7c746b75f47c9c7d)((0, $2ThTG.trim)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $e13b2a8578b988c1$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === 'string') return true;
    if (type === 'bytes') return true;
    if (type.endsWith('[]')) return true;
    if (type === 'tuple') return param.components?.some($e13b2a8578b988c1$var$hasDynamicChild);
    const arrayComponents = (0, $lBZMD.getArrayComponents)(param.type);
    if (arrayComponents && $e13b2a8578b988c1$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}



var $3IdOg = parcelRequire("3IdOg");
function $3beae61b4af45fab$export$8f7898b7bcae6080(parameters) {
    const { abi: abi, data: data, cause: cause } = parameters;
    const signature = (0, $cadfc.slice)(data, 0, 4);
    if (signature === '0x') throw new (0, $dZdNo.AbiDecodingZeroDataError)({
        cause: cause
    });
    const abi_ = [
        ...abi || [],
        (0, $3083ddde2574b23e$export$730e9cc7aaa8ca20),
        (0, $3083ddde2574b23e$export$e45b3aea1c5b33e6)
    ];
    const abiItem = abi_.find((x)=>x.type === 'error' && signature === (0, $eIg5H.toFunctionSelector)((0, $3IdOg.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $dZdNo.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: '/docs/contract/decodeErrorResult',
        cause: cause
    });
    return {
        abiItem: abiItem,
        args: 'inputs' in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $e13b2a8578b988c1$export$84d51ac2fffabd56)(abiItem.inputs, (0, $cadfc.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}



var $3IdOg = parcelRequire("3IdOg");

var $XRcTc = parcelRequire("XRcTc");
function $28d16210333f0502$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!('name' in abiItem)) return;
    if (!('inputs' in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ''}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ''}${typeof args[i] === 'object' ? (0, $XRcTc.stringify)(args[i]) : args[i]}`).join(', ')})`;
}



var $7zR8F = parcelRequire("7zR8F");


var $3vvQ3 = parcelRequire("3vvQ3");

var $dZdNo = parcelRequire("dZdNo");

var $5jfXj = parcelRequire("5jfXj");



var $ebsn0 = parcelRequire("ebsn0");
class $7dbce9d08740f890$export$e67b04e2cd29b7d extends (0, $5jfXj.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride }){
        const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : undefined;
        let prettyArgs = (0, $8f6a5f9d053a5a2a$export$cde3d1388a9feac3)({
            from: account?.address,
            to: to,
            value: typeof value !== 'undefined' && `${(0, $35711cc57a2002ea$export$11bc63b4c03ea518)(value)} ${chain?.nativeCurrency?.symbol || 'ETH'}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== 'undefined' && `${(0, $3vvQ3.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== 'undefined' && `${(0, $3vvQ3.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' && `${(0, $3vvQ3.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        if (stateOverride) prettyArgs += `\n${(0, $a00e5ec647ff8f90$export$d08c47f9c4a87c67)(stateOverride)}`;
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    ' '
                ] : [],
                'Raw Call Arguments:',
                prettyArgs
            ].filter(Boolean),
            name: 'CallExecutionError'
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $7dbce9d08740f890$export$399e62fddbe24423 extends (0, $5jfXj.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $7zR8F.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $28d16210333f0502$export$5266ec2b0e3e9205)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $3IdOg.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $8f6a5f9d053a5a2a$export$cde3d1388a9feac3)({
            address: contractAddress && (0, $ebsn0.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== '()' && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>' ').join('')}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    ' '
                ] : [],
                prettyArgs && 'Contract Call:',
                prettyArgs
            ].filter(Boolean),
            name: 'ContractFunctionExecutionError'
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $7dbce9d08740f890$export$b3a6b9663001535f extends (0, $5jfXj.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message, cause: error }){
        let cause;
        let decodedData;
        let metaMessages;
        let reason;
        if (data && data !== '0x') try {
            decodedData = (0, $3beae61b4af45fab$export$8f7898b7bcae6080)({
                abi: abi,
                data: data,
                cause: error
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === 'Error') reason = errorArgs[0];
            else if (errorName === 'Panic') {
                const [firstArg] = errorArgs;
                reason = (0, $3083ddde2574b23e$export$a618024566d3d221)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $3IdOg.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $28d16210333f0502$export$5266ec2b0e3e9205)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : '',
                    formattedArgs && formattedArgs !== '()' ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>' ').join('')}${formattedArgs}` : ''
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $dZdNo.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                'Make sure you are using the correct ABI and that the error exists on it.',
                `You can look up the decoded signature here: https://4byte.sourcify.dev/?q=${signature}.`
            ];
        }
        super(reason && reason !== 'execution reverted' || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? 'signature' : 'reason'}:`,
            reason || signature
        ].join('\n') : `The contract function "${functionName}" reverted.`, {
            cause: cause ?? error,
            metaMessages: metaMessages,
            name: 'ContractFunctionRevertedError'
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.raw = data;
        this.reason = reason;
        this.signature = signature;
    }
}
class $7dbce9d08740f890$export$46f5208cdcd5a621 extends (0, $5jfXj.BaseError) {
    constructor({ functionName: functionName, cause: cause }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                'This could be due to any of the following:',
                `  - The contract does not have the function "${functionName}",`,
                '  - The parameters passed to the contract function may be invalid, or',
                '  - The address is not a contract.'
            ],
            name: 'ContractFunctionZeroDataError',
            cause: cause
        });
    }
}
class $7dbce9d08740f890$export$4fec38f081e68d02 extends (0, $5jfXj.BaseError) {
    constructor({ factory: factory }){
        super(`Deployment for counterfactual contract call failed${factory ? ` for factory "${factory}".` : ''}`, {
            metaMessages: [
                'Please ensure:',
                '- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).',
                '- The `factoryData` is a valid encoded function call for contract deployment function on the factory.'
            ],
            name: 'CounterfactualDeploymentFailedError'
        });
    }
}
class $7dbce9d08740f890$export$5b877bc4d7d9d460 extends (0, $5jfXj.BaseError) {
    constructor({ data: data, message: message }){
        super(message || '', {
            name: 'RawContractError'
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}



var $jLSJ6 = parcelRequire("jLSJ6");

var $atQmZ = parcelRequire("atQmZ");
const $8202d2871cb4f527$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $8202d2871cb4f527$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const error = err instanceof (0, $7dbce9d08740f890$export$5b877bc4d7d9d460) ? err : err instanceof (0, $5jfXj.BaseError) ? err.walk((err)=>'data' in err) || err.walk() : {};
    const { code: code, data: data, details: details, message: message, shortMessage: shortMessage } = error;
    const cause = (()=>{
        if (err instanceof (0, $dZdNo.AbiDecodingZeroDataError)) return new (0, $7dbce9d08740f890$export$46f5208cdcd5a621)({
            functionName: functionName,
            cause: err
        });
        if ([
            $8202d2871cb4f527$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $atQmZ.InternalRpcError).code
        ].includes(code) && (data || details || message || shortMessage) || code === (0, $atQmZ.InvalidInputRpcError).code && details === 'execution reverted' && data) return new (0, $7dbce9d08740f890$export$b3a6b9663001535f)({
            abi: abi,
            data: typeof data === 'object' ? data.data : data,
            functionName: functionName,
            message: error instanceof (0, $jLSJ6.RpcRequestError) ? details : shortMessage ?? message,
            cause: err
        });
        return err;
    })();
    return new (0, $7dbce9d08740f890$export$399e62fddbe24423)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}




async function $0bb2729727797821$export$4c0f201bc17cbf23(client, parameters) {
    return $0bb2729727797821$export$4c0f201bc17cbf23.internal(client, (0, $91338b1bb84aec8d$export$8e0e7ffc78696d30), 'sendTransaction', parameters);
}
(function(writeContract) {
    async function internal(client, actionFn, name, parameters) {
        const { abi: abi, account: account_ = client.account, address: address, args: args, functionName: functionName, ...request } = parameters;
        if (typeof account_ === 'undefined') throw new (0, $f8213a878aaa4056$export$62ee6b05f0767f28)({
            docsPath: '/docs/contract/writeContract'
        });
        const account = account_ ? (0, $92cf10dad360a3d9$export$11027cbf6cf15da2)(account_) : null;
        const data = (0, $24Ila.encodeFunctionData)({
            abi: abi,
            args: args,
            functionName: functionName
        });
        try {
            return await (0, $26baef92b6d9efec$export$6ca3170acb89054)(client, actionFn, name)({
                data: data,
                to: address,
                account: account,
                ...request
            });
        } catch (error) {
            throw (0, $8202d2871cb4f527$export$4414444aba6ddd8a)(error, {
                abi: abi,
                address: address,
                args: args,
                docsPath: '/docs/contract/writeContract',
                functionName: functionName,
                sender: account?.address
            });
        }
    }
    writeContract.internal = internal;
})($0bb2729727797821$export$4c0f201bc17cbf23 || ($0bb2729727797821$export$4c0f201bc17cbf23 = {}));




async function $1597d8bf55590752$export$683a2631dc6e30be(client, parameters) {
    return (0, $0bb2729727797821$export$4c0f201bc17cbf23).internal(client, (0, $824a75546155dd49$export$7901f5426fdc01f1), 'sendTransactionSync', parameters);
}


function $8d26291cdb937307$export$d07041b4ed194fbc(client) {
    return {
        addChain: (args)=>(0, $1cecf0d6e55be63d$export$e648161d6b1bb565)(client, args),
        deployContract: (args)=>(0, $8beaa8c5b2a6e9ee$export$46c7a79747abe6a9)(client, args),
        fillTransaction: (args)=>(0, $b4b7601bc7c36213$export$ee39896fd0c30b0)(client, args),
        getAddresses: ()=>(0, $25a1e844e3faa29d$export$17d5f00cfd692b8a)(client),
        getCallsStatus: (args)=>(0, $6db4cc8fe48ab573$export$e006d787f2407823)(client, args),
        getCapabilities: (args)=>(0, $955b2cb8f6ef3967$export$80a6dbd652bdbd9e)(client, args),
        getChainId: ()=>(0, $2e97a4a9ea5cb029$export$850fa7b3891187c)(client),
        getPermissions: ()=>(0, $54608cfb8e4867b5$export$e10fd44ca431fa8e)(client),
        prepareAuthorization: (args)=>(0, $b9def78457a71b09$export$38b9b896ebe80b77)(client, args),
        prepareTransactionRequest: (args)=>(0, $672e074fa9a15fa8$export$2e8a9232fb815d77)(client, args),
        requestAddresses: ()=>(0, $5a8a34a6ca5a6a42$export$87c5bcc1dede6f06)(client),
        requestPermissions: (args)=>(0, $7c5a2cb2a2ef21ff$export$8cec5d3683c6896e)(client, args),
        sendCalls: (args)=>(0, $26c9d7e6b80fcb43$export$855abd4eafd73115)(client, args),
        sendCallsSync: (args)=>(0, $ffd422e24a17eefb$export$220732bcfdca3ff8)(client, args),
        sendRawTransaction: (args)=>(0, $6e49bb3761464a91$export$4e309754b4830e29)(client, args),
        sendRawTransactionSync: (args)=>(0, $06be2ddda140d5f6$export$b71ad7c1cdb046c7)(client, args),
        sendTransaction: (args)=>(0, $91338b1bb84aec8d$export$8e0e7ffc78696d30)(client, args),
        sendTransactionSync: (args)=>(0, $824a75546155dd49$export$7901f5426fdc01f1)(client, args),
        showCallsStatus: (args)=>(0, $acd6ab369c49c842$export$a503dea929b80d)(client, args),
        signAuthorization: (args)=>(0, $1535407178c0e921$export$b34b2771bbc8b9d7)(client, args),
        signMessage: (args)=>(0, $57409f1a06601236$export$1d9a7a8a40780de)(client, args),
        signTransaction: (args)=>(0, $b4482e75622132ad$export$6ad02cc4966b42ab)(client, args),
        signTypedData: (args)=>(0, $b6a339e863775c2d$export$9f05de2db4d31153)(client, args),
        switchChain: (args)=>(0, $9a248d96442a5848$export$15599da40e72d2f)(client, args),
        waitForCallsStatus: (args)=>(0, $52bc7d97bc3ef02c$export$f5bf85fd054d174f)(client, args),
        watchAsset: (args)=>(0, $953eb9daf7a5dd17$export$7eea68d1a70548bd)(client, args),
        writeContract: (args)=>(0, $0bb2729727797821$export$4c0f201bc17cbf23)(client, args),
        writeContractSync: (args)=>(0, $1597d8bf55590752$export$683a2631dc6e30be)(client, args)
    };
}


function $477bc391d519a840$export$362b8ea2edbd9090(parameters) {
    const { key: key = 'wallet', name: name = 'Wallet Client', transport: transport } = parameters;
    const client = (0, $50efdd063d6eb24a$export$5d730b7aed1a3eb0)({
        ...parameters,
        key: key,
        name: name,
        transport: transport,
        type: 'walletClient'
    });
    return client.extend((0, $8d26291cdb937307$export$d07041b4ed194fbc));
}


var $5QBI3 = parcelRequire("5QBI3");
function $bcd0a91e4aef4d13$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = 'custom', methods: methods, name: name = 'Custom Provider', retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $5QBI3.createTransport)({
            key: key,
            methods: methods,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: 'custom'
        });
}



/**
 * Predeploy contracts for OP Stack.
 * @see https://github.com/ethereum-optimism/optimism/blob/develop/specs/predeploys.md
 */ const $242677ecc858b86a$export$ea30b8ddade7b2c1 = {
    gasPriceOracle: {
        address: '0x420000000000000000000000000000000000000F'
    },
    l1Block: {
        address: '0x4200000000000000000000000000000000000015'
    },
    l2CrossDomainMessenger: {
        address: '0x4200000000000000000000000000000000000007'
    },
    l2Erc721Bridge: {
        address: '0x4200000000000000000000000000000000000014'
    },
    l2StandardBridge: {
        address: '0x4200000000000000000000000000000000000010'
    },
    l2ToL1MessagePasser: {
        address: '0x4200000000000000000000000000000000000016'
    }
};



var $lz1vU = parcelRequire("lz1vU");



const $14d97b2a6b564ac6$export$fe98a034cfb96d55 = {
    block: /*#__PURE__*/ (0, $a314c9ea89117125$export$9f35cb3327f1a5c5)({
        format (args) {
            const transactions = args.transactions?.map((transaction)=>{
                if (typeof transaction === 'string') return transaction;
                const formatted = (0, $014d88210c5bc9cd$export$b02b16590d26dadc)(transaction);
                if (formatted.typeHex === '0x7e') {
                    formatted.isSystemTx = transaction.isSystemTx;
                    formatted.mint = transaction.mint ? (0, $lz1vU.hexToBigInt)(transaction.mint) : undefined;
                    formatted.sourceHash = transaction.sourceHash;
                    formatted.type = 'deposit';
                }
                return formatted;
            });
            return {
                transactions: transactions,
                stateRoot: args.stateRoot
            };
        }
    }),
    transaction: /*#__PURE__*/ (0, $014d88210c5bc9cd$export$c19bdc7dbe69198d)({
        format (args) {
            const transaction = {};
            if (args.type === '0x7e') {
                transaction.isSystemTx = args.isSystemTx;
                transaction.mint = args.mint ? (0, $lz1vU.hexToBigInt)(args.mint) : undefined;
                transaction.sourceHash = args.sourceHash;
                transaction.type = 'deposit';
            }
            return transaction;
        }
    }),
    transactionReceipt: /*#__PURE__*/ (0, $06be2920925d5dc8$export$8d3f90420000ba71)({
        format (args) {
            return {
                l1GasPrice: args.l1GasPrice ? (0, $lz1vU.hexToBigInt)(args.l1GasPrice) : null,
                l1GasUsed: args.l1GasUsed ? (0, $lz1vU.hexToBigInt)(args.l1GasUsed) : null,
                l1Fee: args.l1Fee ? (0, $lz1vU.hexToBigInt)(args.l1Fee) : null,
                l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null
            };
        }
    })
};



var $eCsKB = parcelRequire("eCsKB");

var $9GvsK = parcelRequire("9GvsK");

var $4KuzL = parcelRequire("4KuzL");

var $cD3gI = parcelRequire("cD3gI");



var $cD3gI = parcelRequire("cD3gI");

function $2c0e44c701e54ca1$export$a695669f1a41df5b(authorizationList) {
    if (!authorizationList || authorizationList.length === 0) return [];
    const serializedAuthorizationList = [];
    for (const authorization of authorizationList){
        const { chainId: chainId, nonce: nonce, ...signature } = authorization;
        const contractAddress = authorization.address;
        serializedAuthorizationList.push([
            chainId ? (0, $cD3gI.toHex)(chainId) : '0x',
            contractAddress,
            nonce ? (0, $cD3gI.toHex)(nonce) : '0x',
            ...(0, $d8506a0e6a7d61b8$export$13ef8e144f96fd76)({}, signature)
        ]);
    }
    return serializedAuthorizationList;
}







var $4KuzL = parcelRequire("4KuzL");

var $2ThTG = parcelRequire("2ThTG");

var $cD3gI = parcelRequire("cD3gI");




var $eCsKB = parcelRequire("eCsKB");

var $5jfXj = parcelRequire("5jfXj");



var $l8lWo = parcelRequire("l8lWo");

var $9GvsK = parcelRequire("9GvsK");

var $2u1VO = parcelRequire("2u1VO");

var $cadfc = parcelRequire("cadfc");

var $lz1vU = parcelRequire("lz1vU");
function $428d8e291a58076f$export$c066ee77932a0249(transaction) {
    const { authorizationList: authorizationList } = transaction;
    if (authorizationList) for (const authorization of authorizationList){
        const { chainId: chainId } = authorization;
        const address = authorization.address;
        if (!(0, $9GvsK.isAddress)(address)) throw new (0, $eCsKB.InvalidAddressError)({
            address: address
        });
        if (chainId < 0) throw new (0, $16aad06d6e6fffb4$export$4836eb835ffca5b2)({
            chainId: chainId
        });
    }
    $428d8e291a58076f$export$9ce52ad2ebd4d8fd(transaction);
}
function $428d8e291a58076f$export$7a7b1c9cbdcde679(transaction) {
    const { blobVersionedHashes: blobVersionedHashes } = transaction;
    if (blobVersionedHashes) {
        if (blobVersionedHashes.length === 0) throw new (0, $6efd5b462ed1478d$export$d145394ceab4d1c3)();
        for (const hash of blobVersionedHashes){
            const size_ = (0, $2u1VO.size)(hash);
            const version = (0, $lz1vU.hexToNumber)((0, $cadfc.slice)(hash, 0, 1));
            if (size_ !== 32) throw new (0, $6efd5b462ed1478d$export$ebd5b15dd92c680)({
                hash: hash,
                size: size_
            });
            if (version !== (0, $ed6a6d82e55f1902$export$de38d5f871f0b1cd)) throw new (0, $6efd5b462ed1478d$export$509ed1d312c500)({
                hash: hash,
                version: version
            });
        }
    }
    $428d8e291a58076f$export$9ce52ad2ebd4d8fd(transaction);
}
function $428d8e291a58076f$export$9ce52ad2ebd4d8fd(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $16aad06d6e6fffb4$export$4836eb835ffca5b2)({
        chainId: chainId
    });
    if (to && !(0, $9GvsK.isAddress)(to)) throw new (0, $eCsKB.InvalidAddressError)({
        address: to
    });
    if (maxFeePerGas && maxFeePerGas > (0, $16127c6b6c27d616$export$48de485e50a67ffa)) throw new (0, $l8lWo.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $l8lWo.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}
function $428d8e291a58076f$export$18dc5e03b8985881(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $16aad06d6e6fffb4$export$4836eb835ffca5b2)({
        chainId: chainId
    });
    if (to && !(0, $9GvsK.isAddress)(to)) throw new (0, $eCsKB.InvalidAddressError)({
        address: to
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $5jfXj.BaseError)('`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.');
    if (gasPrice && gasPrice > (0, $16127c6b6c27d616$export$48de485e50a67ffa)) throw new (0, $l8lWo.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}
function $428d8e291a58076f$export$f9ff7fa58fadd108(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (to && !(0, $9GvsK.isAddress)(to)) throw new (0, $eCsKB.InvalidAddressError)({
        address: to
    });
    if (typeof chainId !== 'undefined' && chainId <= 0) throw new (0, $16aad06d6e6fffb4$export$4836eb835ffca5b2)({
        chainId: chainId
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $5jfXj.BaseError)('`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.');
    if (gasPrice && gasPrice > (0, $16127c6b6c27d616$export$48de485e50a67ffa)) throw new (0, $l8lWo.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}




var $eCsKB = parcelRequire("eCsKB");


var $9GvsK = parcelRequire("9GvsK");
function $c2da1276c523cef8$export$736ebd57ab43df1(accessList) {
    if (!accessList || accessList.length === 0) return [];
    const serializedAccessList = [];
    for(let i = 0; i < accessList.length; i++){
        const { address: address, storageKeys: storageKeys } = accessList[i];
        for(let j = 0; j < storageKeys.length; j++){
            if (storageKeys[j].length - 2 !== 64) throw new (0, $8f6a5f9d053a5a2a$export$f5e370fd7cd91580)({
                storageKey: storageKeys[j]
            });
        }
        if (!(0, $9GvsK.isAddress)(address, {
            strict: false
        })) throw new (0, $eCsKB.InvalidAddressError)({
            address: address
        });
        serializedAccessList.push([
            address,
            storageKeys
        ]);
    }
    return serializedAccessList;
}


function $d8506a0e6a7d61b8$export$7cb44e9a321cd996(transaction, signature) {
    const type = (0, $172cd6246177605b$export$944c6678cd5a1ea8)(transaction);
    if (type === 'eip1559') return $d8506a0e6a7d61b8$var$serializeTransactionEIP1559(transaction, signature);
    if (type === 'eip2930') return $d8506a0e6a7d61b8$var$serializeTransactionEIP2930(transaction, signature);
    if (type === 'eip4844') return $d8506a0e6a7d61b8$var$serializeTransactionEIP4844(transaction, signature);
    if (type === 'eip7702') return $d8506a0e6a7d61b8$var$serializeTransactionEIP7702(transaction, signature);
    return $d8506a0e6a7d61b8$var$serializeTransactionLegacy(transaction, signature);
}
function $d8506a0e6a7d61b8$var$serializeTransactionEIP7702(transaction, signature) {
    const { authorizationList: authorizationList, chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $428d8e291a58076f$export$c066ee77932a0249)(transaction);
    const serializedAccessList = (0, $c2da1276c523cef8$export$736ebd57ab43df1)(accessList);
    const serializedAuthorizationList = (0, $2c0e44c701e54ca1$export$a695669f1a41df5b)(authorizationList);
    return (0, $4KuzL.concatHex)([
        '0x04',
        (0, $d35bee29afe2a349$export$140c78e750979cda)([
            (0, $cD3gI.numberToHex)(chainId),
            nonce ? (0, $cD3gI.numberToHex)(nonce) : '0x',
            maxPriorityFeePerGas ? (0, $cD3gI.numberToHex)(maxPriorityFeePerGas) : '0x',
            maxFeePerGas ? (0, $cD3gI.numberToHex)(maxFeePerGas) : '0x',
            gas ? (0, $cD3gI.numberToHex)(gas) : '0x',
            to ?? '0x',
            value ? (0, $cD3gI.numberToHex)(value) : '0x',
            data ?? '0x',
            serializedAccessList,
            serializedAuthorizationList,
            ...$d8506a0e6a7d61b8$export$13ef8e144f96fd76(transaction, signature)
        ])
    ]);
}
function $d8506a0e6a7d61b8$var$serializeTransactionEIP4844(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $428d8e291a58076f$export$7a7b1c9cbdcde679)(transaction);
    let blobVersionedHashes = transaction.blobVersionedHashes;
    let sidecars = transaction.sidecars;
    // If `blobs` are passed, we will need to compute the KZG commitments & proofs.
    if (transaction.blobs && (typeof blobVersionedHashes === 'undefined' || typeof sidecars === 'undefined')) {
        const blobs = typeof transaction.blobs[0] === 'string' ? transaction.blobs : transaction.blobs.map((x)=>(0, $cD3gI.bytesToHex)(x));
        const kzg = transaction.kzg;
        const commitments = (0, $de0209608b41db84$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (typeof blobVersionedHashes === 'undefined') blobVersionedHashes = (0, $ffb2e1595d3a548b$export$e31b3e59dda37b17)({
            commitments: commitments
        });
        if (typeof sidecars === 'undefined') {
            const proofs = (0, $0716f0f9a4a3cbdc$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            sidecars = (0, $8c25da7d015526bf$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs
            });
        }
    }
    const serializedAccessList = (0, $c2da1276c523cef8$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $cD3gI.numberToHex)(chainId),
        nonce ? (0, $cD3gI.numberToHex)(nonce) : '0x',
        maxPriorityFeePerGas ? (0, $cD3gI.numberToHex)(maxPriorityFeePerGas) : '0x',
        maxFeePerGas ? (0, $cD3gI.numberToHex)(maxFeePerGas) : '0x',
        gas ? (0, $cD3gI.numberToHex)(gas) : '0x',
        to ?? '0x',
        value ? (0, $cD3gI.numberToHex)(value) : '0x',
        data ?? '0x',
        serializedAccessList,
        maxFeePerBlobGas ? (0, $cD3gI.numberToHex)(maxFeePerBlobGas) : '0x',
        blobVersionedHashes ?? [],
        ...$d8506a0e6a7d61b8$export$13ef8e144f96fd76(transaction, signature)
    ];
    const blobs = [];
    const commitments = [];
    const proofs = [];
    if (sidecars) for(let i = 0; i < sidecars.length; i++){
        const { blob: blob, commitment: commitment, proof: proof } = sidecars[i];
        blobs.push(blob);
        commitments.push(commitment);
        proofs.push(proof);
    }
    return (0, $4KuzL.concatHex)([
        '0x03',
        sidecars ? (0, $d35bee29afe2a349$export$140c78e750979cda)([
            serializedTransaction,
            blobs,
            commitments,
            proofs
        ]) : (0, $d35bee29afe2a349$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $d8506a0e6a7d61b8$var$serializeTransactionEIP1559(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $428d8e291a58076f$export$9ce52ad2ebd4d8fd)(transaction);
    const serializedAccessList = (0, $c2da1276c523cef8$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $cD3gI.numberToHex)(chainId),
        nonce ? (0, $cD3gI.numberToHex)(nonce) : '0x',
        maxPriorityFeePerGas ? (0, $cD3gI.numberToHex)(maxPriorityFeePerGas) : '0x',
        maxFeePerGas ? (0, $cD3gI.numberToHex)(maxFeePerGas) : '0x',
        gas ? (0, $cD3gI.numberToHex)(gas) : '0x',
        to ?? '0x',
        value ? (0, $cD3gI.numberToHex)(value) : '0x',
        data ?? '0x',
        serializedAccessList,
        ...$d8506a0e6a7d61b8$export$13ef8e144f96fd76(transaction, signature)
    ];
    return (0, $4KuzL.concatHex)([
        '0x02',
        (0, $d35bee29afe2a349$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $d8506a0e6a7d61b8$var$serializeTransactionEIP2930(transaction, signature) {
    const { chainId: chainId, gas: gas, data: data, nonce: nonce, to: to, value: value, accessList: accessList, gasPrice: gasPrice } = transaction;
    (0, $428d8e291a58076f$export$18dc5e03b8985881)(transaction);
    const serializedAccessList = (0, $c2da1276c523cef8$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $cD3gI.numberToHex)(chainId),
        nonce ? (0, $cD3gI.numberToHex)(nonce) : '0x',
        gasPrice ? (0, $cD3gI.numberToHex)(gasPrice) : '0x',
        gas ? (0, $cD3gI.numberToHex)(gas) : '0x',
        to ?? '0x',
        value ? (0, $cD3gI.numberToHex)(value) : '0x',
        data ?? '0x',
        serializedAccessList,
        ...$d8506a0e6a7d61b8$export$13ef8e144f96fd76(transaction, signature)
    ];
    return (0, $4KuzL.concatHex)([
        '0x01',
        (0, $d35bee29afe2a349$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $d8506a0e6a7d61b8$var$serializeTransactionLegacy(transaction, signature) {
    const { chainId: chainId = 0, gas: gas, data: data, nonce: nonce, to: to, value: value, gasPrice: gasPrice } = transaction;
    (0, $428d8e291a58076f$export$f9ff7fa58fadd108)(transaction);
    let serializedTransaction = [
        nonce ? (0, $cD3gI.numberToHex)(nonce) : '0x',
        gasPrice ? (0, $cD3gI.numberToHex)(gasPrice) : '0x',
        gas ? (0, $cD3gI.numberToHex)(gas) : '0x',
        to ?? '0x',
        value ? (0, $cD3gI.numberToHex)(value) : '0x',
        data ?? '0x'
    ];
    if (signature) {
        const v = (()=>{
            // EIP-155 (inferred chainId)
            if (signature.v >= 35n) {
                const inferredChainId = (signature.v - 35n) / 2n;
                if (inferredChainId > 0) return signature.v;
                return 27n + (signature.v === 35n ? 0n : 1n);
            }
            // EIP-155 (explicit chainId)
            if (chainId > 0) return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
            // Pre-EIP-155 (no chainId)
            const v = 27n + (signature.v === 27n ? 0n : 1n);
            if (signature.v !== v) throw new (0, $8f6a5f9d053a5a2a$export$8ffce3f13fa2ade4)({
                v: signature.v
            });
            return v;
        })();
        const r = (0, $2ThTG.trim)(signature.r);
        const s = (0, $2ThTG.trim)(signature.s);
        serializedTransaction = [
            ...serializedTransaction,
            (0, $cD3gI.numberToHex)(v),
            r === '0x00' ? '0x' : r,
            s === '0x00' ? '0x' : s
        ];
    } else if (chainId > 0) serializedTransaction = [
        ...serializedTransaction,
        (0, $cD3gI.numberToHex)(chainId),
        '0x',
        '0x'
    ];
    return (0, $d35bee29afe2a349$export$140c78e750979cda)(serializedTransaction);
}
function $d8506a0e6a7d61b8$export$13ef8e144f96fd76(transaction, signature_) {
    const signature = signature_ ?? transaction;
    const { v: v, yParity: yParity } = signature;
    if (typeof signature.r === 'undefined') return [];
    if (typeof signature.s === 'undefined') return [];
    if (typeof v === 'undefined' && typeof yParity === 'undefined') return [];
    const r = (0, $2ThTG.trim)(signature.r);
    const s = (0, $2ThTG.trim)(signature.s);
    const yParity_ = (()=>{
        if (typeof yParity === 'number') return yParity ? (0, $cD3gI.numberToHex)(1) : '0x';
        if (v === 0n) return '0x';
        if (v === 1n) return (0, $cD3gI.numberToHex)(1);
        return v === 27n ? '0x' : (0, $cD3gI.numberToHex)(1);
    })();
    return [
        yParity_,
        r === '0x00' ? '0x' : r,
        s === '0x00' ? '0x' : s
    ];
}


function $7b510c6fd9d4b6c8$export$7cb44e9a321cd996(transaction, signature) {
    if ($7b510c6fd9d4b6c8$var$isDeposit(transaction)) return $7b510c6fd9d4b6c8$var$serializeTransactionDeposit(transaction);
    return (0, $d8506a0e6a7d61b8$export$7cb44e9a321cd996)(transaction, signature);
}
const $7b510c6fd9d4b6c8$export$7824249990c72c71 = {
    transaction: $7b510c6fd9d4b6c8$export$7cb44e9a321cd996
};
function $7b510c6fd9d4b6c8$var$serializeTransactionDeposit(transaction) {
    $7b510c6fd9d4b6c8$export$91db50bb3f58e144(transaction);
    const { sourceHash: sourceHash, data: data, from: from, gas: gas, isSystemTx: isSystemTx, mint: mint, to: to, value: value } = transaction;
    const serializedTransaction = [
        sourceHash,
        from,
        to ?? '0x',
        mint ? (0, $cD3gI.toHex)(mint) : '0x',
        value ? (0, $cD3gI.toHex)(value) : '0x',
        gas ? (0, $cD3gI.toHex)(gas) : '0x',
        isSystemTx ? '0x1' : '0x',
        data ?? '0x'
    ];
    return (0, $4KuzL.concatHex)([
        '0x7e',
        (0, $d35bee29afe2a349$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $7b510c6fd9d4b6c8$var$isDeposit(transaction) {
    if (transaction.type === 'deposit') return true;
    if (typeof transaction.sourceHash !== 'undefined') return true;
    return false;
}
function $7b510c6fd9d4b6c8$export$91db50bb3f58e144(transaction) {
    const { from: from, to: to } = transaction;
    if (from && !(0, $9GvsK.isAddress)(from)) throw new (0, $eCsKB.InvalidAddressError)({
        address: from
    });
    if (to && !(0, $9GvsK.isAddress)(to)) throw new (0, $eCsKB.InvalidAddressError)({
        address: to
    });
}


const $923a066971d2a030$export$ca9ff151299322fa = {
    blockTime: 2000,
    contracts: $242677ecc858b86a$export$ea30b8ddade7b2c1,
    formatters: $14d97b2a6b564ac6$export$fe98a034cfb96d55,
    serializers: $7b510c6fd9d4b6c8$export$7824249990c72c71
};


function $83dd8bbd94990152$export$b6380ff64616a4fb(chain) {
    const chainInstance = {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
    function extend(base) {
        return (fnOrExtended)=>{
            const properties = typeof fnOrExtended === 'function' ? fnOrExtended(base) : fnOrExtended;
            const combined = {
                ...base,
                ...properties
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(chainInstance, {
        extend: extend(chainInstance)
    });
}
function $83dd8bbd94990152$export$35f5fe5f3e862ea3() {
    return {};
}


const $e0c715ed50b15c32$var$sourceId = 1; // mainnet
const $e0c715ed50b15c32$export$e2253033e6e1df16 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    ...(0, $923a066971d2a030$export$ca9ff151299322fa),
    id: 8453,
    name: 'Base',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://mainnet.base.org'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Basescan',
            url: 'https://basescan.org',
            apiUrl: 'https://api.basescan.org/api'
        }
    },
    contracts: {
        ...(0, $923a066971d2a030$export$ca9ff151299322fa).contracts,
        disputeGameFactory: {
            [$e0c715ed50b15c32$var$sourceId]: {
                address: '0x43edB88C4B80fDD2AdFF2412A7BebF9dF42cB40e'
            }
        },
        l2OutputOracle: {
            [$e0c715ed50b15c32$var$sourceId]: {
                address: '0x56315b90c40730925ec5485cf004d835058518A0'
            }
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 5022
        },
        portal: {
            [$e0c715ed50b15c32$var$sourceId]: {
                address: '0x49048044D57e1C92A77f79988d21Fa8fAF74E97e',
                blockCreated: 17482143
            }
        },
        l1StandardBridge: {
            [$e0c715ed50b15c32$var$sourceId]: {
                address: '0x3154Cf16ccdb4C6d922629664174b904d80F2C35',
                blockCreated: 17482143
            }
        }
    },
    sourceId: $e0c715ed50b15c32$var$sourceId
});
const $e0c715ed50b15c32$export$1a19672b76824a89 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    ...$e0c715ed50b15c32$export$e2253033e6e1df16,
    experimental_preconfirmationTime: 200,
    rpcUrls: {
        default: {
            http: [
                'https://mainnet-preconf.base.org'
            ]
        }
    }
});



const $c4d5d115b5ef9924$var$sourceId = 11155111; // sepolia
const $c4d5d115b5ef9924$export$e02aa76c029b1df5 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    ...(0, $923a066971d2a030$export$ca9ff151299322fa),
    id: 84532,
    network: 'base-sepolia',
    name: 'Base Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://sepolia.base.org'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Basescan',
            url: 'https://sepolia.basescan.org',
            apiUrl: 'https://api-sepolia.basescan.org/api'
        }
    },
    contracts: {
        ...(0, $923a066971d2a030$export$ca9ff151299322fa).contracts,
        disputeGameFactory: {
            [$c4d5d115b5ef9924$var$sourceId]: {
                address: '0xd6E6dBf4F7EA0ac412fD8b65ED297e64BB7a06E1'
            }
        },
        l2OutputOracle: {
            [$c4d5d115b5ef9924$var$sourceId]: {
                address: '0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254'
            }
        },
        portal: {
            [$c4d5d115b5ef9924$var$sourceId]: {
                address: '0x49f53e41452c74589e85ca1677426ba426459e85',
                blockCreated: 4446677
            }
        },
        l1StandardBridge: {
            [$c4d5d115b5ef9924$var$sourceId]: {
                address: '0xfd0Bf71F60660E2f608ed56e1659C450eB113120',
                blockCreated: 4446677
            }
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1059647
        }
    },
    testnet: true,
    sourceId: $c4d5d115b5ef9924$var$sourceId
});
const $c4d5d115b5ef9924$export$1398d2696ff676dc = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    ...$c4d5d115b5ef9924$export$e02aa76c029b1df5,
    experimental_preconfirmationTime: 200,
    rpcUrls: {
        default: {
            http: [
                'https://sepolia-preconf.base.org'
            ]
        }
    }
});


const $9f2039e94e33370e$export$e75f932499ee2689 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    id: 295,
    name: 'Hedera Mainnet',
    network: 'hedera-mainnet',
    nativeCurrency: {
        symbol: 'HBAR',
        name: 'HBAR',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://mainnet.hashio.io/api'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Hashscan',
            url: 'https://hashscan.io/mainnet'
        }
    },
    testnet: false
});


const $be0d1a5b786437fc$export$dbcf9e9a85bd4154 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    id: 296,
    name: 'Hedera Testnet',
    network: 'hedera-testnet',
    nativeCurrency: {
        symbol: 'HBAR',
        name: 'HBAR',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://testnet.hashio.io/api'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Hashscan',
            url: 'https://hashscan.io/testnet'
        }
    },
    testnet: true
});



const $5ddc022e4b345134$var$sourceId = 1; // mainnet
const $5ddc022e4b345134$export$4d551dc4315b2348 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    ...(0, $923a066971d2a030$export$ca9ff151299322fa),
    id: 57073,
    name: 'Ink',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc-gel.inkonchain.com',
                'https://rpc-qnd.inkonchain.com'
            ],
            webSocket: [
                'wss://rpc-gel.inkonchain.com',
                'wss://rpc-qnd.inkonchain.com'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.inkonchain.com',
            apiUrl: 'https://explorer.inkonchain.com/api/v2'
        }
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 0
        },
        ...(0, $923a066971d2a030$export$ca9ff151299322fa).contracts,
        disputeGameFactory: {
            [$5ddc022e4b345134$var$sourceId]: {
                address: '0x10d7b35078d3baabb96dd45a9143b94be65b12cd'
            }
        },
        portal: {
            [$5ddc022e4b345134$var$sourceId]: {
                address: '0x5d66c1782664115999c47c9fa5cd031f495d3e4f'
            }
        },
        l1StandardBridge: {
            [$5ddc022e4b345134$var$sourceId]: {
                address: '0x88ff1e5b602916615391f55854588efcbb7663f0'
            }
        }
    },
    testnet: false,
    sourceId: $5ddc022e4b345134$var$sourceId
});



const $f625820deb43c996$var$sourceId = 11155111; // sepolia
const $f625820deb43c996$export$5a250d4e47ac99a6 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    ...(0, $923a066971d2a030$export$ca9ff151299322fa),
    id: 763373,
    name: 'Ink Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc-gel-sepolia.inkonchain.com'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer-sepolia.inkonchain.com/',
            apiUrl: 'https://explorer-sepolia.inkonchain.com/api/v2'
        }
    },
    contracts: {
        ...(0, $923a066971d2a030$export$ca9ff151299322fa).contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 0
        },
        disputeGameFactory: {
            [$f625820deb43c996$var$sourceId]: {
                address: '0x860e626c700af381133d9f4af31412a2d1db3d5d'
            }
        },
        portal: {
            [$f625820deb43c996$var$sourceId]: {
                address: '0x5c1d29c6c9c8b0800692acc95d700bcb4966a1d7'
            }
        },
        l1StandardBridge: {
            [$f625820deb43c996$var$sourceId]: {
                address: '0x33f60714bbd74d62b66d79213c348614de51901c'
            }
        }
    },
    testnet: true,
    sourceId: $f625820deb43c996$var$sourceId
});


const $5f9e5ac2278e4147$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    id: 1,
    name: 'Ethereum',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18
    },
    blockTime: 12000,
    rpcUrls: {
        default: {
            http: [
                'https://eth.merkle.io'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://etherscan.io',
            apiUrl: 'https://api.etherscan.io/api'
        }
    },
    contracts: {
        ensUniversalResolver: {
            address: '0xeeeeeeee14d718c2b47d9923deab1335e144eeee',
            blockCreated: 23085558
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14353601
        }
    }
});


const $6e7d964a29d66ca5$export$b7b19aa0ee06c73 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    id: 137,
    name: 'Polygon',
    blockTime: 2000,
    nativeCurrency: {
        name: 'POL',
        symbol: 'POL',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://polygon.drpc.org'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://polygonscan.com',
            apiUrl: 'https://api.etherscan.io/v2/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 25770160
        }
    }
});


const $0f6d61a96a0005e4$export$5083adb63aed2ae9 = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    id: 80002,
    name: 'Polygon Amoy',
    nativeCurrency: {
        name: 'POL',
        symbol: 'POL',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc-amoy.polygon.technology'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://amoy.polygonscan.com',
            apiUrl: 'https://api.etherscan.io/v2/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 3127388
        }
    },
    testnet: true
});


const $6833b986ea8dfc60$export$31254237fd28c61a = /*#__PURE__*/ (0, $83dd8bbd94990152$export$b6380ff64616a4fb)({
    id: 11155111,
    name: 'Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://11155111.rpc.thirdweb.com'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.etherscan.io',
            apiUrl: 'https://api-sepolia.etherscan.io/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 751532
        },
        ensUniversalResolver: {
            address: '0xeeeeeeee14d718c2b47d9923deab1335e144eeee',
            blockCreated: 8928790
        }
    },
    testnet: true
});




const $1252f7a92d470115$var$ENDPOINT = "/analytics/event";
function $1252f7a92d470115$var$buildFormData(eventName, extras) {
    const formData = new FormData();
    formData.append("event", eventName);
    const sessionId = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION) || "";
    if (sessionId) {
        formData.append("session", sessionId);
        formData.append("checkout_session_id", sessionId);
    }
    formData.append("page", typeof window !== "undefined" ? window.location.pathname : "");
    formData.append("viewport", typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : "");
    if (extras) for (const [k, v] of Object.entries(extras)){
        if (v == null || v === "") continue;
        formData.append(k, Array.isArray(v) ? v.join(",") : String(v));
    }
    return formData;
}
function $1252f7a92d470115$export$905424921aab8cd6(eventName, extras = {}) {
    try {
        const formData = $1252f7a92d470115$var$buildFormData(eventName, extras);
        if (typeof navigator !== "undefined" && navigator.sendBeacon) {
            if (navigator.sendBeacon($1252f7a92d470115$var$ENDPOINT, formData)) return;
        }
        fetch($1252f7a92d470115$var$ENDPOINT, {
            method: "POST",
            body: formData,
            keepalive: true
        }).catch(()=>{});
    } catch (_) {
    /* swallow */ }
}


// Wallet IDs must match the values used in Statsig new_checkout_config.cw_supported_wallets
// and the wallets_available payload on checkout_cw_wallet_selector_viewed. To add a wallet,
// register it here and in the dashboard config.
const $527c3fde4aafeb25$var$WALLET_MODULES = {
    safe: (0, $5fbc42cca8c58e58$export$2e2bcd8739ae039)(),
    metamask: (0, $4073165241fd3590$export$2e2bcd8739ae039)({
        options: {
            extensionOnly: false,
            dappMetadata: {
                name: "Coinsub",
                url: window.location.href
            }
        }
    }),
    coinbase: (0, $0be495f738215320$export$2e2bcd8739ae039)(),
    walletconnect: (0, $24fc5fc17ae2250f$export$2e2bcd8739ae039)({
        projectId: `${"caf258de5d887f868f1121652a17d219"}`,
        dappUrl: window.location.href
    }),
    injected: (0, $7be82505d1105913$export$2e2bcd8739ae039)()
};
function $527c3fde4aafeb25$var$readEnabledWalletIDs() {
    const attr = document.getElementById("checkout_controller")?.dataset?.cwSupportedWallets ?? "";
    const requested = attr.split(",").map((id)=>id.trim().toLowerCase()).filter(Boolean);
    const enabled = requested.filter((id)=>$527c3fde4aafeb25$var$WALLET_MODULES[id]);
    return enabled.length > 0 ? enabled : Object.keys($527c3fde4aafeb25$var$WALLET_MODULES);
}
const $527c3fde4aafeb25$var$customTheme = {
    "--w3o-background-color": "#ffffff",
    "--w3o-foreground-color": "#edf3f8",
    "--w3o-text-color": "#262626",
    "--w3o-border-color": "#c7c7c7",
    "--w3o-action-color": "#0085ff",
    "--w3o-border-radius": "unset",
    "--w3o-font-family": "unset"
};
const $527c3fde4aafeb25$var$chains = [
    {
        id: (0, $0f6d61a96a0005e4$export$5083adb63aed2ae9).id,
        token: (0, $0f6d61a96a0005e4$export$5083adb63aed2ae9).nativeCurrency.name,
        label: (0, $0f6d61a96a0005e4$export$5083adb63aed2ae9).name,
        rpcUrl: (0, $0f6d61a96a0005e4$export$5083adb63aed2ae9).rpcUrls.public ? (0, $0f6d61a96a0005e4$export$5083adb63aed2ae9).rpcUrls.public.http[0] : (0, $0f6d61a96a0005e4$export$5083adb63aed2ae9).rpcUrls.default.http[0]
    },
    {
        id: (0, $6e7d964a29d66ca5$export$b7b19aa0ee06c73).id,
        token: (0, $6e7d964a29d66ca5$export$b7b19aa0ee06c73).nativeCurrency.name,
        label: (0, $6e7d964a29d66ca5$export$b7b19aa0ee06c73).name,
        rpcUrl: (0, $6e7d964a29d66ca5$export$b7b19aa0ee06c73).rpcUrls.public ? (0, $6e7d964a29d66ca5$export$b7b19aa0ee06c73).rpcUrls.public.http[0] : (0, $6e7d964a29d66ca5$export$b7b19aa0ee06c73).rpcUrls.default.http[0]
    },
    {
        id: (0, $6833b986ea8dfc60$export$31254237fd28c61a).id,
        token: (0, $6833b986ea8dfc60$export$31254237fd28c61a).nativeCurrency.name,
        label: (0, $6833b986ea8dfc60$export$31254237fd28c61a).name,
        rpcUrl: (0, $6833b986ea8dfc60$export$31254237fd28c61a).rpcUrls.public ? (0, $6833b986ea8dfc60$export$31254237fd28c61a).rpcUrls.public.http[0] : (0, $6833b986ea8dfc60$export$31254237fd28c61a).rpcUrls.default.http[0]
    },
    {
        id: (0, $5f9e5ac2278e4147$export$536d3e0d2c7baf54).id,
        token: (0, $5f9e5ac2278e4147$export$536d3e0d2c7baf54).nativeCurrency.name,
        label: (0, $5f9e5ac2278e4147$export$536d3e0d2c7baf54).name,
        rpcUrl: (0, $5f9e5ac2278e4147$export$536d3e0d2c7baf54).rpcUrls.public ? (0, $5f9e5ac2278e4147$export$536d3e0d2c7baf54).rpcUrls.public.http[0] : (0, $5f9e5ac2278e4147$export$536d3e0d2c7baf54).rpcUrls.default.http[0]
    },
    {
        id: (0, $c4d5d115b5ef9924$export$e02aa76c029b1df5).id,
        token: (0, $c4d5d115b5ef9924$export$e02aa76c029b1df5).nativeCurrency.name,
        label: (0, $c4d5d115b5ef9924$export$e02aa76c029b1df5).name,
        rpcUrl: (0, $c4d5d115b5ef9924$export$e02aa76c029b1df5).rpcUrls.public ? (0, $c4d5d115b5ef9924$export$e02aa76c029b1df5).rpcUrls.public.http[0] : (0, $c4d5d115b5ef9924$export$e02aa76c029b1df5).rpcUrls.default.http[0]
    },
    {
        id: (0, $e0c715ed50b15c32$export$e2253033e6e1df16).id,
        token: (0, $e0c715ed50b15c32$export$e2253033e6e1df16).nativeCurrency.name,
        label: (0, $e0c715ed50b15c32$export$e2253033e6e1df16).name,
        rpcUrl: (0, $e0c715ed50b15c32$export$e2253033e6e1df16).rpcUrls.public ? (0, $e0c715ed50b15c32$export$e2253033e6e1df16).rpcUrls.public.http[0] : (0, $e0c715ed50b15c32$export$e2253033e6e1df16).rpcUrls.default.http[0]
    },
    {
        id: (0, $f625820deb43c996$export$5a250d4e47ac99a6).id,
        token: (0, $f625820deb43c996$export$5a250d4e47ac99a6).nativeCurrency.name,
        label: (0, $f625820deb43c996$export$5a250d4e47ac99a6).name,
        rpcUrl: (0, $f625820deb43c996$export$5a250d4e47ac99a6).rpcUrls.public ? (0, $f625820deb43c996$export$5a250d4e47ac99a6).rpcUrls.public.http[0] : (0, $f625820deb43c996$export$5a250d4e47ac99a6).rpcUrls.default.http[0]
    },
    {
        id: (0, $5ddc022e4b345134$export$4d551dc4315b2348).id,
        token: (0, $5ddc022e4b345134$export$4d551dc4315b2348).nativeCurrency.name,
        label: (0, $5ddc022e4b345134$export$4d551dc4315b2348).name,
        rpcUrl: (0, $5ddc022e4b345134$export$4d551dc4315b2348).rpcUrls.public ? (0, $5ddc022e4b345134$export$4d551dc4315b2348).rpcUrls.public.http[0] : (0, $5ddc022e4b345134$export$4d551dc4315b2348).rpcUrls.default.http[0]
    },
    {
        id: (0, $be0d1a5b786437fc$export$dbcf9e9a85bd4154).id,
        token: (0, $be0d1a5b786437fc$export$dbcf9e9a85bd4154).nativeCurrency.name,
        label: (0, $be0d1a5b786437fc$export$dbcf9e9a85bd4154).name,
        rpcUrl: (0, $be0d1a5b786437fc$export$dbcf9e9a85bd4154).rpcUrls.public ? (0, $be0d1a5b786437fc$export$dbcf9e9a85bd4154).rpcUrls.public.http[0] : (0, $be0d1a5b786437fc$export$dbcf9e9a85bd4154).rpcUrls.default.http[0]
    },
    {
        id: (0, $9f2039e94e33370e$export$e75f932499ee2689).id,
        token: (0, $9f2039e94e33370e$export$e75f932499ee2689).nativeCurrency.name,
        label: (0, $9f2039e94e33370e$export$e75f932499ee2689).name,
        rpcUrl: (0, $9f2039e94e33370e$export$e75f932499ee2689).rpcUrls.public ? (0, $9f2039e94e33370e$export$e75f932499ee2689).rpcUrls.public.http[0] : (0, $9f2039e94e33370e$export$e75f932499ee2689).rpcUrls.default.http[0]
    }
];
const $527c3fde4aafeb25$var$appMetadata = {
    name: "Coinsub",
    icon: (0, $bd5e7d73d15230a4$export$4e80b7f9eaacb389)() ? `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
    <svg
      width="272.78668"
      height="190.96716"
      viewBox="0 0 272.78668 190.96716"
      fill="none"
      version="1.1"
      id="svg12"
      sodipodi:docname="logo-mobile.svg"
      inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg">
      <sodipodi:namedview
        id="namedview12"
        pagecolor="#ffffff"
        bordercolor="#000000"
        borderopacity="0.25"
        inkscape:showpageshadow="2"
        inkscape:pageopacity="0.0"
        inkscape:pagecheckerboard="0"
        inkscape:deskcolor="#d1d1d1"
        inkscape:zoom="0.81291946"
        inkscape:cx="352.43344"
        inkscape:cy="89.184727"
        inkscape:window-width="1858"
        inkscape:window-height="1057"
        inkscape:window-x="-8"
        inkscape:window-y="-8"
        inkscape:window-maximized="1"
        inkscape:current-layer="svg12" />
      <path
        d="m 11.301914,20.82734 c -9.18999,20.5916 -17.93698,35.7161 -4.0808,56.7847 26.1516,39.7637 101.131496,105.4767 199.978496,113.1537 29.348,2.279 40.818,-15.131 60.672,-34.522 -63.513,58.766 -277.619386,-63.491 -256.569696,-135.4164 z"
        fill="url(#paint0_linear_15_59)"
        id="path9"
        style="fill:url(#paint0_linear_15_59)" />
      <path
        d="m 247.16361,163.12974 c -5.893,-32.692 -85.92,-73.533 -85.92,-73.533 -0.325,0.973 -0.66,1.941 -0.994,2.907 -1.753,5.069 -3.491,10.091 -3.675,15.533 C 65.816514,61.69844 60.760914,19.28034 58.732914,2.2645405 c -0.094,-0.7882 -0.1814,-1.5219 -0.2706,-2.1989 -61.7634323,-2.0471 -46.047,44.3016995 -25.7864,67.0470995 35.7344,50.533 149.905696,117.945 214.487696,96.017 z"
        fill="#0085ff"
        id="path10" />
      <path
        d="M 73.942514,0.8740405 C 75.118614,38.54484 131.85861,67.21654 131.85861,67.21654 c 0.933,-2.919 1.7,-6.0035 2.467,-9.0886 0.776,-3.1234 1.553,-6.2476 2.502,-9.2014 80.03,41.3402 120.701,77.1362 122.619,108.8932 55.679,-30.346 -73.945,-141.0908 -185.504096,-156.9456995 z"
        fill="#0085ff"
        id="path11" />
      <defs
        id="defs12">
        <linearGradient
          id="paint0_linear_15_59"
          x1="212.405"
          y1="197.17799"
          x2="33.5578"
          y2="93.317299"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-3.213386,-16.25626)">
          <stop
            stop-color="#595959"
            id="stop11" />
          <stop
            offset="1"
            stop-color="#242424"
            id="stop12" />
        </linearGradient>
      </defs>
    </svg>` : undefined,
    description: "Improving Subscriptions",
    recommendedInjectedWallets: [
        {
            name: "MetaMask",
            url: "https://metamask.io"
        }
    ]
};
class $527c3fde4aafeb25$var$WalletService extends (0, (/*@__PURE__*/$parcel$interopDefault($kFTZb))) {
    constructor(){
        super();
        if (!$527c3fde4aafeb25$var$WalletService.instance) {
            this.initializeWallets();
            $527c3fde4aafeb25$var$WalletService.instance = this;
        }
        return $527c3fde4aafeb25$var$WalletService.instance;
    }
    initializeWallets() {
        this.cwWalletsAvailable = $527c3fde4aafeb25$var$readEnabledWalletIDs();
        this.onboard = (0, $bBj7l.aB)({
            apiKey: `${"4616690c-af9d-4abe-8b4c-645a82424eac"}`,
            wallets: this.cwWalletsAvailable.map((id)=>$527c3fde4aafeb25$var$WALLET_MODULES[id]),
            chains: $527c3fde4aafeb25$var$chains,
            appMetadata: $527c3fde4aafeb25$var$appMetadata,
            theme: $527c3fde4aafeb25$var$customTheme,
            connect: {
                autoConnectLastWallet: false
            },
            accountCenter: {
                desktop: {
                    enabled: false
                },
                mobile: {
                    enabled: false
                }
            }
        });
        this.observableWallets = this.onboard.state.select("wallets");
        this.walletsSubscription = this.observableWallets.subscribe((wallets)=>{
            this.emit("walletChange", wallets);
        });
    }
    resetOnboardInstance() {
        if (this.walletsSubscription?.unsubscribe) this.walletsSubscription.unsubscribe();
        this.walletsSubscription = null;
        this.initializeWallets();
    }
    async prepareForNewConnection() {
        try {
            await this.disconnectWallet();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("WalletService: disconnect before reconnect failed", error);
        }
        this.resetOnboardInstance();
    }
    // isConnected() {
    //   const state = this.onboard.state.get();
    //   return state.wallets.length > 0;
    // }
    async changeChains(chainId) {
        if (this.getNetworkId() != chainId) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("changing to chain: ", chainId);
            await this.onboard.setChain({
                chainId: chainId
            });
        }
    }
    // onboard.setChain resolves false (no throw) when the user rejects the switch,
    // so verify the wallet actually landed on the target chain before letting an
    // on-chain tx proceed. Never throws; returns false on rejection/failure.
    async ensureOnChain(targetChainId) {
        if (Number.parseInt(this.getNetworkId(), 16) === targetChainId) return true;
        try {
            await this.changeChains(targetChainId);
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("WalletService: chain switch failed or was rejected", error);
            return false;
        }
        return Number.parseInt(this.getNetworkId(), 16) === targetChainId;
    }
    getChain(chainId) {
        return $527c3fde4aafeb25$var$chains.find((chain)=>chain.id === chainId);
    }
    getCurrentChain() {
        const state = this.onboard.state.get();
        if (state.wallets.length > 0) return state.wallets[0].chains[0];
        return null;
    }
    getWalletAddress() {
        const state = this.onboard.state.get();
        if (state.wallets.length > 0) return state.wallets[0].accounts[0].address;
        return null;
    }
    /** Web3-Onboard wallet label, e.g. "MetaMask", "Coinbase Wallet", "WalletConnect" — for UI / server session. */ getConnectedWalletLabel() {
        const state = this.onboard.state.get();
        if (state.wallets.length > 0 && state.wallets[0].label) return state.wallets[0].label;
        return "";
    }
    getNetworkId() {
        const state = this.onboard.state.get();
        if (state.wallets.length > 0) return state.wallets[0].chains[0].id;
        return null;
    }
    onWalletChange(callback) {
        this.on("walletChange", callback);
    }
    removeWalletChangeListener(callback) {
        this.removeListener("walletChange", callback);
    }
    async connectWallet() {
        // checkout_payment_path_selected must fire FIRST so the Statsig dashboard
        // funnel (path_selected → wallet_connected → asset_selected → tx_approved
        // → payment_completed) gets its entry event in chronological order. The
        // server-side helper logCheckoutPathSelectedOnce dedupes via the
        // last_path_selected session marker, so a later server emission is a no-op.
        (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_payment_path_selected", {
            path: "connect_wallet"
        });
        (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_wallet_selector_viewed", {
            wallets_available: this.cwWalletsAvailable
        });
        try {
            try {
                await this.onboard.connectWallet();
                await this.changeChains(this.getNetworkId());
            } catch (error) {
                const errorMessage = String(error?.message || "");
                const hasStaleStylesheetSignature = errorMessage.includes("insertRule") || errorMessage.includes("ownerNode") || errorMessage.includes("stylesheet");
                if (!hasStaleStylesheetSignature) throw error;
                (0, $df5856b8963e2c0f$export$280f90b954565303)("WalletService: stale Onboard stylesheet reference detected, reinitializing", error);
                this.resetOnboardInstance();
                await this.onboard.connectWallet();
                await this.changeChains(this.getNetworkId());
            }
            // web3-onboard resolves without throwing when the user dismisses the
            // modal — detect via empty address so we still emit a drop-off event.
            const address = this.getWalletAddress();
            if (!address) {
                (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_wallet_connection_failed", {
                    wallet_provider: this.getConnectedWalletLabel() || "",
                    error_code: "user_dismissed"
                });
                (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).walletConnectCancelled);
                return;
            }
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_wallet_connected", {
                wallet_provider: this.getConnectedWalletLabel() || "",
                wallet_address: address,
                network_id: this.getNetworkId() || ""
            });
        } catch (error) {
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_wallet_connection_failed", {
                wallet_provider: this.getConnectedWalletLabel() || "",
                error_code: String(error?.code ?? "unknown")
            });
            if ((0, $9286460a480b22e8$export$a5837bf4a7a2713a)(error)) (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).walletConnectCancelled);
            else (0, $9286460a480b22e8$export$b542b247691f8019)("wallet-connect-failed");
            throw error;
        }
    }
    async disconnectWallet() {
        const [primaryWallet] = this.onboard.state.get().wallets;
        if (!primaryWallet?.label) return;
        await this.onboard.disconnectWallet({
            label: primaryWallet.label
        });
    }
    getWalletClient() {
        const state = this.onboard.state.get();
        if (state.wallets.length > 0) return (0, $477bc391d519a840$export$362b8ea2edbd9090)({
            account: state.wallets[0].accounts[0].address,
            chain: state.wallets[0].chains[0].id,
            transport: (0, $bcd0a91e4aef4d13$export$4c00f665f0d4b443)(state.wallets[0].provider)
        });
        else return null;
    }
}
const $527c3fde4aafeb25$var$instance = new $527c3fde4aafeb25$var$WalletService();
var $527c3fde4aafeb25$export$2e2bcd8739ae039 = $527c3fde4aafeb25$var$instance;





// Arms or disarms the order-summary fee breakdown (desktop + mobile) that the server
// renders inert while the fee is pending. Only overviews rendered with an explicit
// enabled value are touched, so already-priced summaries keep their own state.
function $13ee377913fda6ff$export$9f4c63c0d723401e(enabled) {
    document.querySelectorAll('[data-controller~="order-summary"][data-order-summary-enabled-value]').forEach((el)=>{
        el.dataset.orderSummaryEnabledValue = String(enabled);
    });
}
function $13ee377913fda6ff$export$c197863a4beecae7(totalDisplay) {
    const display = (totalDisplay || "").trim();
    if (!display) return;
    document.querySelectorAll(".js-checkout-breakdown-total").forEach((el)=>{
        el.textContent = display;
    });
}


/** Same visual as token row :hover (Tailwind payment-options token item hover tokens) */ const $94dc8f501faf6971$var$PASSIVE_ROW_CLASSES = [
    "bg-thm-selector-asset-selector-passive-bg",
    "border-thm-selector-asset-selector-passive-border-color"
];
const $94dc8f501faf6971$var$SELECTED_ROW_CLASSES = [
    "bg-thm-selector-asset-selector-active-bg",
    "border-thm-selector-asset-selector-active-border-color"
];
const $94dc8f501faf6971$var$SELECTED_CARD_CLASSES = [
    "border-thm-selector-active-border-color",
    "border-2"
];
const $94dc8f501faf6971$var$OPTION_ICON_CIRCLE_DEFAULT_CLASSES = [
    "bg-thm-selector-passive-icon-bg",
    "shadow-none"
];
const $94dc8f501faf6971$var$OPTION_ICON_CIRCLE_SELECTED_CLASSES = [
    "bg-thm-selector-passive-icon-bg",
    "shadow-none"
];
const $94dc8f501faf6971$var$OPTION_ICON_DEFAULT_CLASSES = [
    "text-thm-selector-passive-icon-color"
];
const $94dc8f501faf6971$var$OPTION_ICON_SELECTED_CLASSES = [
    "text-thm-selector-passive-icon-color"
];
function $94dc8f501faf6971$var$clearAssetRowSelection(row) {
    if (!row) return;
    row.classList.remove(...$94dc8f501faf6971$var$SELECTED_ROW_CLASSES);
    row.classList.add(...$94dc8f501faf6971$var$PASSIVE_ROW_CLASSES);
    row.querySelector("button")?.setAttribute("aria-pressed", "false");
}
function $94dc8f501faf6971$var$applyAssetRowSelection(row) {
    if (!row) return;
    row.classList.remove(...$94dc8f501faf6971$var$PASSIVE_ROW_CLASSES);
    row.classList.add(...$94dc8f501faf6971$var$SELECTED_ROW_CLASSES);
    row.querySelector("button")?.setAttribute("aria-pressed", "true");
}
class $94dc8f501faf6971$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "optionCard",
        "directTransferPanel",
        "assetRow",
        "continueButton",
        "tokenSearch",
        "tokenList"
    ];
    static values = {
        code: String,
        session: String
    };
    connect() {
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).THIRD_PARTY_BACK_TARGET, "payment-options");
        // Browser back restores a cached page with stale Onboard state.
        // Force a one-time hard reload to get a clean runtime.
        if (this.shouldForceReload()) {
            sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED, "1");
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_PENDING);
            window.location.reload();
            return;
        }
        sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED);
        this.resetThirdPartyWalletConnection();
        this.selectedOption = null;
        this.selectedRow = null;
        this.hideLoadingScreen();
        if (this.hasOptionCardTarget) this.applySelection(this.initialOptionCard());
        this.restoreSelectionFromStorage();
        this.syncContinueDisabled();
        this.filterTokens();
    }
    /** Statsig `preselected` wins when its card rendered; otherwise Direct Transfer, then the first card. */ initialOptionCard() {
        return this.optionCardTargets.find((card)=>card.dataset.preselected === "true") || this.optionCardTargets.find((card)=>card.dataset.paymentOption === "direct-deposit") || this.optionCardTargets[0];
    }
    shouldForceReload() {
        const isRestore = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_PENDING) === "1";
        const alreadyReloaded = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED) === "1";
        return isRestore && !alreadyReloaded;
    }
    async resetThirdPartyWalletConnection() {
        try {
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).disconnectWallet();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("PaymentOptions: failed to disconnect wallet on load", error);
        }
    }
    /** Client-side filter for token rows (symbol + network name). */ filterTokens() {
        if (!this.hasTokenListTarget) return;
        const q = this.hasTokenSearchTarget ? this.tokenSearchTarget.value.trim().toLowerCase() : "";
        const rows = this.tokenListTarget.querySelectorAll(":scope > li");
        rows.forEach((li)=>{
            const sym = (li.dataset.symbol || "").toLowerCase();
            const net = (li.dataset.networkName || "").toLowerCase();
            const chainId = (li.dataset.chainId || "").toLowerCase();
            const haystack = `${sym} ${net} ${chainId}`.trim();
            const match = !q || haystack.includes(q) || sym.startsWith(q) || net.includes(q);
            li.classList.toggle("hidden", !match);
        });
        if (this.selectedRow?.classList.contains("hidden")) {
            $94dc8f501faf6971$var$clearAssetRowSelection(this.selectedRow);
            this.selectedRow = null;
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_SYMBOL);
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_NETWORK);
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_ICON);
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_CHAIN_ID);
            this.updateCheckoutPaymentMethod("", "");
            this.syncContinueDisabled();
        }
    }
    selectOption(event) {
        const card = event.currentTarget;
        // Token-row clicks bubble up to the direct-deposit card; re-selecting the
        // current option must not wipe the fee the row just set.
        if (card.dataset.paymentOption === this.selectedOption) return;
        this.applySelection(card);
        this.syncContinueDisabled();
    }
    applySelection(card) {
        if (!card || !card.dataset.paymentOption) return;
        this.selectedOption = card.dataset.paymentOption;
        // Switching options drops any token-specific fee: go back to the summary's
        // original "calculated at payment" state until a concrete token is picked.
        this.resetCheckoutOverviewToPlaceholder();
        if (this.selectedOption === "direct-deposit" && this.selectedRow) this.applyAssetRowToOverview(this.selectedRow);
        this.optionCardTargets.forEach((c)=>{
            c.classList.remove(...$94dc8f501faf6971$var$SELECTED_CARD_CLASSES);
            const radio = c.querySelector(".payment-option-selector-radio");
            const check = radio?.querySelector(".payment-option-selector-radio-icon");
            const optionIconCircle = c.querySelector(".payment-option-circle");
            const optionIcon = c.querySelector(".payment-option-circle-icon");
            if (radio) {
                radio.classList.remove("bg-thm-selector-active-checkbox-color", "border-thm-selector-active-checkbox-color");
                radio.classList.add("bg-transparent", "border-thm-selector-passive-checkbox-color");
            }
            if (optionIconCircle) {
                optionIconCircle.classList.remove(...$94dc8f501faf6971$var$OPTION_ICON_CIRCLE_SELECTED_CLASSES);
                optionIconCircle.classList.add(...$94dc8f501faf6971$var$OPTION_ICON_CIRCLE_DEFAULT_CLASSES);
            }
            if (optionIcon) {
                optionIcon.classList.remove(...$94dc8f501faf6971$var$OPTION_ICON_SELECTED_CLASSES);
                optionIcon.classList.add(...$94dc8f501faf6971$var$OPTION_ICON_DEFAULT_CLASSES);
            }
            check?.classList.add("hidden");
        });
        card.classList.add(...$94dc8f501faf6971$var$SELECTED_CARD_CLASSES);
        const selectedRadio = card.querySelector(".payment-option-selector-radio");
        const selectedCheck = selectedRadio?.querySelector(".payment-option-selector-radio-icon");
        const selectedOptionIcon = card.querySelector(".payment-option-circle-icon");
        const selectedOptionIconCircle = card.querySelector(".payment-option-circle");
        if (selectedRadio) {
            selectedRadio.classList.remove("bg-transparent", "border-thm-selector-passive-checkbox-color");
            selectedRadio.classList.add("bg-thm-selector-active-checkbox-color", "border-thm-selector-active-checkbox-color");
        }
        if (selectedOptionIcon) {
            selectedOptionIcon.classList.remove(...$94dc8f501faf6971$var$OPTION_ICON_DEFAULT_CLASSES);
            selectedOptionIcon.classList.add(...$94dc8f501faf6971$var$OPTION_ICON_SELECTED_CLASSES);
        }
        if (selectedOptionIconCircle) {
            selectedOptionIconCircle.classList.remove(...$94dc8f501faf6971$var$OPTION_ICON_CIRCLE_DEFAULT_CLASSES);
            selectedOptionIconCircle.classList.add(...$94dc8f501faf6971$var$OPTION_ICON_CIRCLE_SELECTED_CLASSES);
        }
        selectedCheck?.classList.remove("hidden");
        if (this.hasDirectTransferPanelTarget) this.directTransferPanelTarget.classList.toggle("hidden", this.selectedOption !== "direct-deposit");
    }
    restoreSelectionFromStorage() {
        const sym = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_SYMBOL);
        const net = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_NETWORK);
        if (!sym || !net || !this.hasAssetRowTarget) return;
        const row = this.assetRowTargets.find((r)=>r.dataset.symbol === sym && r.dataset.networkName === net);
        if (!row) return;
        $94dc8f501faf6971$var$applyAssetRowSelection(row);
        this.selectedRow = row;
        this.applyAssetRowToOverview(row);
        const chainId = row.dataset.chainId || "";
        if (chainId) sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_CHAIN_ID, chainId);
        this.updateCheckoutPaymentMethod(sym, net);
    }
    selectAsset(event) {
        const row = event.currentTarget.closest("[data-payment-options-target='assetRow']");
        if (!row) return;
        if (this.selectedRow === row) return;
        if (this.selectedOption !== "direct-deposit") {
            const directDepositCard = this.optionCardTargets.find((card)=>card.dataset.paymentOption === "direct-deposit");
            this.applySelection(directDepositCard);
        }
        this.assetRowTargets.forEach((el)=>{
            $94dc8f501faf6971$var$clearAssetRowSelection(el);
        });
        $94dc8f501faf6971$var$applyAssetRowSelection(row);
        this.selectedRow = row;
        const symbol = row.dataset.symbol || "";
        const networkName = row.dataset.networkName || "";
        const icon = row.dataset.icon || "";
        const chainId = row.dataset.chainId || "";
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_SYMBOL, symbol);
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_NETWORK, networkName);
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_ICON, icon);
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_CHAIN_ID, chainId);
        this.applyAssetRowToOverview(row);
        this.updateCheckoutPaymentMethod(symbol, networkName);
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("DirectTransferOptions: selected", {
            symbol: symbol,
            networkName: networkName,
            icon: icon,
            chainId: chainId
        });
        this.syncContinueDisabled();
    }
    applyAssetRowToOverview(row) {
        this.updateCheckoutOverview(row.dataset.amountDisplay || "");
        this.updateCheckoutFees(row.dataset.checkoutFeeDisplay || "", row.dataset.checkoutFeeUsd || "");
    }
    /**
   * Restore the overview to its "calculated at payment" state. The overview sits
   * outside the step frame, so its current text may be a stale fee from another
   * step (e.g. connect wallet); restore from the server-rendered data-placeholder.
   */ resetCheckoutOverviewToPlaceholder() {
        [
            "checkout_fees",
            "checkout_total_amount",
            "checkout_price_mobile"
        ].forEach((id)=>{
            const el = document.getElementById(id);
            if (el?.dataset.placeholder) el.textContent = el.dataset.placeholder;
        });
        document.querySelectorAll(".js-checkout-fees-incl, .js-checkout-breakdown-total").forEach((el)=>{
            if (el.dataset.placeholder) el.textContent = el.dataset.placeholder;
        });
        (0, $13ee377913fda6ff$export$9f4c63c0d723401e)(false);
    }
    /**
   * Syncs the checkout overview "Estimated Total" display with the selected
   * direct-deposit token amount (e.g. "0.500833 USDC").
   * This updates the persistent overview panel outside the Turbo frame.
   */ updateCheckoutOverview(amountDisplay) {
        if (!amountDisplay || amountDisplay.trim() === "") return;
        const checkoutTotalAmount = document.getElementById("checkout_total_amount");
        if (checkoutTotalAmount) checkoutTotalAmount.textContent = amountDisplay;
        const checkoutPriceMobile = document.getElementById("checkout_price_mobile");
        if (checkoutPriceMobile) checkoutPriceMobile.textContent = `${amountDisplay}`;
        (0, $13ee377913fda6ff$export$c197863a4beecae7)(amountDisplay);
    }
    /**
   * Recomputes the order-summary fee for the selected direct-deposit token. The
   * deposit fee varies by network (origin-chain leg1 gas + the INK legs + reserve),
   * so each option carries its own total; we also keep the breakdown's Network Fee
   * row consistent (total minus the network-independent processing fee).
   */ updateCheckoutFees(feeDisplay, feeUsdRaw) {
        const display = (feeDisplay || "").trim();
        if (!display) return;
        const checkoutFees = document.getElementById("checkout_fees");
        if (checkoutFees) checkoutFees.textContent = display;
        const inclFee = display.replace(/\s*USD$/i, "");
        document.querySelectorAll(".js-checkout-fees-incl").forEach((el)=>{
            el.textContent = `incl. ${inclFee} fees`;
        });
        const total = Number.parseFloat(feeUsdRaw);
        const networkFeeEl = document.querySelector(".js-checkout-network-fee");
        if (networkFeeEl && Number.isFinite(total)) {
            const processing = Number.parseFloat(networkFeeEl.dataset.checkoutProcessingFee || "0");
            const networkFee = Math.max(0, total - (Number.isFinite(processing) ? processing : 0));
            document.querySelectorAll(".js-checkout-network-fee").forEach((el)=>{
                el.textContent = `$${networkFee.toFixed(2)} USD`;
            });
        }
        (0, $13ee377913fda6ff$export$9f4c63c0d723401e)(true);
    }
    updateCheckoutPaymentMethod(symbol, networkName) {
        const checkoutPaymentMethod = document.getElementById("checkout_payment_method");
        if (!checkoutPaymentMethod) return;
        const sym = (symbol || "").trim();
        const net = (networkName || "").trim();
        checkoutPaymentMethod.textContent = sym && net ? `${net} / ${sym}` : "Awaiting Selection";
    }
    syncContinueDisabled() {
        if (!this.hasContinueButtonTarget) return;
        const enabled = this.selectedOption === "third-party" || this.selectedOption === "top-up" || this.selectedOption === "direct-deposit" && Boolean(this.selectedRow);
        this.continueButtonTarget.classList.toggle("is-disabled", !enabled);
    }
    continue() {
        // CS-2698 DIAG — temporary instrumentation. Snapshot the full picker state
        // at click time so we can tell, post-repro, exactly which exit path fires
        // (third-party / no-row / no-chainId-symbol / fired-Turbo). console.warn
        // (not debugLog) so it shows without PARCEL_DEBUG_MODE. Remove once fixed.
        const diag = {
            selectedOption: this.selectedOption,
            hasSelectedRow: Boolean(this.selectedRow),
            rowChainId: this.selectedRow?.dataset?.chainId || null,
            rowSymbol: this.selectedRow?.dataset?.symbol || null,
            rowNetworkName: this.selectedRow?.dataset?.networkName || null,
            storageChainId: sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_CHAIN_ID),
            storageSymbol: sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_SYMBOL),
            storageNetwork: sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_NETWORK),
            buttonDisabled: this.continueButtonTarget?.classList.contains("is-disabled"),
            sessionValue: this.sessionValue,
            codeValue: this.codeValue,
            assetRowCount: this.assetRowTargets?.length ?? 0
        };
        if (this.selectedOption === "third-party") {
            this.connect3rdParyWalletHandler();
            return;
        }
        if (this.selectedOption === "top-up") {
            this.handleTopUpContinue();
            return;
        }
        this.handleDirectDepositContinue();
    }
    handleTopUpContinue() {
        const topUpCard = this.optionCardTargets.find((card)=>card.dataset.paymentOption === "top-up");
        const topUpURL = topUpCard?.dataset.topUpUrl || "";
        if (!topUpURL) {
            console.warn("PaymentOptions: top-up selected but topUpURL is empty");
            return;
        }
        if (!sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_FUNNEL_START_MS)) sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_FUNNEL_START_MS, String(Date.now()));
        this.emitTopUpFunnelEvent((topUpCard?.dataset.wmEntry || "").trim());
        this.showLoadingScreen();
        window.requestAnimationFrame(()=>{
            window.location.assign(topUpURL);
        });
    }
    /** Maps the wallet-modal entry point to its checkout funnel event. */ emitTopUpFunnelEvent(wmEntry) {
        const eventByEntry = {
            top_up: "checkout_wm_top_up_clicked",
            dont_have_crypto: "checkout_wm_dont_have_crypto_clicked"
        };
        const event = eventByEntry[wmEntry];
        if (!event) return;
        if (this.sessionValue) sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION, this.sessionValue);
        (0, $1252f7a92d470115$export$905424921aab8cd6)(event);
    }
    handleDirectDepositContinue() {
        if (!this.selectedRow) return;
        const chainId = this.selectedRow.dataset.chainId || sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_CHAIN_ID) || "";
        const symbol = this.selectedRow.dataset.symbol || "";
        const qs = new URLSearchParams({
            session: this.sessionValue,
            from_dd_options: "1",
            ...chainId ? {
                chain_id: String(chainId)
            } : {},
            ...symbol ? {
                symbol: symbol
            } : {}
        });
        const url = `/${this.codeValue}/direct-deposit?${qs.toString()}`;
        this.showLoadingScreen();
        $16d9fec6fae182d5$export$bf638b60ea8b89b7(url, {
            frame: "step_content",
            action: "advance"
        });
    }
    async connect3rdParyWalletHandler() {
        try {
            window.dispatchEvent(new CustomEvent("payment-options:listenWalletChange", {
                bubbles: true
            }));
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).prepareForNewConnection();
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).connectWallet();
            const connectedWallet = await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletAddress();
            if (connectedWallet) this.showLoadingScreen();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("PaymentOptions: connect wallet failed", error);
            this.dispatch("error", {
                detail: {
                    content: "Unable to open wallet connection. Please refresh and try again."
                }
            });
        }
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}






class $0387ce938a34d8c9$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    async connect() {
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).THIRD_PARTY_BACK_TARGET, "connect-wallet-only");
        // Browser back restores a cached page with stale Onboard state.
        // Force a one-time hard reload to get a clean runtime.
        if (this.shouldForceReload()) {
            sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED, "1");
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_PENDING);
            window.location.reload();
            return;
        }
        sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED);
        await this.resetThirdPartyWalletConnection();
        this.hideLoadingScreen();
    }
    shouldForceReload() {
        const isRestore = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_PENDING) === "1";
        const alreadyReloaded = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED) === "1";
        return isRestore && !alreadyReloaded;
    }
    async continue(event) {
        event?.preventDefault();
        try {
            this.dispatch("listenWalletChange");
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).prepareForNewConnection();
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).connectWallet();
            const connectedWallet = await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletAddress();
            if (connectedWallet) {
                this.showLoadingScreen();
                return;
            }
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ConnectWalletOnly: wallet connection did not return an address");
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ConnectWalletOnly: connect wallet failed", error);
            this.dispatch("error", {
                detail: {
                    content: "Unable to open wallet connection. Please refresh and try again."
                }
            });
        }
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
    async resetThirdPartyWalletConnection() {
        try {
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).disconnectWallet();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ConnectWalletOnly: failed to disconnect wallet on load", error);
        }
    }
}



class $8e2dc7458e49ec68$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    connect() {
        this.hideLoadingScreen();
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}








class $eebfc3c4a0ce5733$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "confirmButton",
        "coins",
        "chains",
        "down"
    ];
    static values = {
        walletaddress: String,
        session: String
    };
    connect() {
        this.codeValue = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
        setTimeout(()=>{
            this.checkForAutoSelection();
            this.listenWalletChange();
            this.hideLoadingScreen();
        }, 100);
        this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this);
        document.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd);
    }
    disconnect() {
        document.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd);
    }
    async handleSubmitEnd(event) {
        const form = event.detail.formSubmission.formElement;
        if (form.id !== "frame-post-form") return;
        const fetchResponse = event.detail.fetchResponse;
        if (!fetchResponse) return;
        const contentType = fetchResponse.response.headers.get("content-type");
        if (contentType?.includes("application/json")) try {
            const res = await fetchResponse.response;
            const jsonData = await res.json();
            if (jsonData.response_type === "redirect") {
                this.hideLoadingScreen();
                $16d9fec6fae182d5$export$bf638b60ea8b89b7(jsonData.redirect_url);
            }
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error parsing JSON response:", error);
        }
    }
    selectPaymentOption() {
        this.showLoadingScreen();
        const radioButtons = document.getElementsByClassName("currency-radio-selector");
        let selectedRadioButton;
        for(let i = 0; i < radioButtons.length; i++)if (radioButtons[i].checked) {
            selectedRadioButton = radioButtons[i];
            const tokenid = selectedRadioButton.getAttribute("data-coinsub-payment-options-tokenid-param");
            const networkid = selectedRadioButton.getAttribute("data-coinsub-payment-options-networkid-param");
            this.renderPaymentMethod(tokenid, networkid);
            const form = document.getElementById("frame-post-form");
            form.action = `/${this.codeValue}/review?session=${this.sessionValue}`;
            document.getElementById("form_session").value = this.sessionValue;
            document.getElementById("form_address").value = this.walletaddressValue;
            document.getElementById("form_networkid").value = networkid;
            document.getElementById("form_tokenid").value = tokenid;
            form.requestSubmit();
            break;
        }
    }
    checkForAutoSelection() {
        const radioButtons = document.getElementsByClassName("currency-radio-selector");
        for(let i = 0; i < radioButtons.length; i++)if (radioButtons[i].checked) {
            this.enableConfirmButton();
            if (this.chainsTargets.length > 0) {
                this.chainsTargets.forEach((chain, index)=>{
                    chain.classList.remove("grid-rows-[1fr]");
                    this.downTargets[index].classList.remove("rotate-180");
                });
                this.chainsTargets[0].classList.add("grid-rows-[1fr]");
                this.downTargets[0].classList.add("rotate-180");
            }
            break;
        }
    }
    enableConfirmButton() {
        this.confirmButtonTarget.classList.remove("is-disabled");
    }
    async showChainsEventHandler(event) {
        const tokenId = event.currentTarget.getAttribute("data-token-id");
        this.chainsTargets.forEach((chain, index)=>{
            if (chain.getAttribute("data-token-id") === tokenId) {
                chain.classList.add("grid-rows-[1fr]");
                this.downTargets[index].classList.add("rotate-180");
            } else {
                chain.classList.remove("grid-rows-[1fr]");
                this.downTargets[index].classList.remove("rotate-180");
            }
        });
    }
    async selectToken(e) {
        const tokenId = e.currentTarget?.dataset?.tokenId;
        const networkId = e.currentTarget?.dataset?.networkId;
        if (!tokenId || !networkId) return;
        const code = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
        const sessionId = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION);
        if (!code || !sessionId) return;
        this.renderPaymentMethod(tokenId, networkId);
    }
    async renderPaymentMethod(tokenId, networkId) {
        const code = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
        const sessionId = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION);
        const httpReq = await fetch(`/${code}/payment-method`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Session": sessionId,
                "X-Code": code
            },
            body: JSON.stringify({
                tokenId: tokenId,
                networkId: networkId
            })
        });
        const jsonData = await httpReq.json();
        if (jsonData.error) return;
        if (jsonData.success && jsonData.type === "html") $16d9fec6fae182d5$export$ebdee272e46e11d9(jsonData.data);
    }
    async connectWallet() {
        try {
            this.dispatch("listenWalletChange", {
                bubbles: true
            });
            this.showLoadingScreen();
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).connectWallet();
            this.hideLoadingScreen();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error connecting wallet:", error);
            this.hideLoadingScreen();
            this.dispatch("error", {
                detail: {
                    content: (0, $871593c39ddb32a9$export$dbb77d813a78f040)(error, "Failed to connect wallet. Please try again.")
                }
            });
        }
    }
    listenWalletChange() {
        this.dispatch("listenWalletChange");
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}










class $7c22653eda9fb1cb$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "confirmButton",
        "coins"
    ];
    static values = {
        walletaddress: String,
        session: String
    };
    connect() {
        this.codeValue = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
        this.selectedTokenId = null;
        this.selectedNetworkId = null;
        setTimeout(()=>{
            this.checkForAutoSelection();
            this.listenWalletChange();
            this.hideLoadingScreen();
        }, 100);
        this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this);
        document.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd);
    }
    disconnect() {
        document.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd);
    }
    async handleSubmitEnd(event) {
        const form = event.detail.formSubmission.formElement;
        if (form.id !== "frame-post-form") return;
        const fetchResponse = event.detail.fetchResponse;
        if (!fetchResponse) return;
        const contentType = fetchResponse.response.headers.get("content-type");
        if (contentType?.includes("application/json")) try {
            const res = await fetchResponse.response;
            const jsonData = await res.json();
            if (jsonData.response_type === "redirect") {
                this.hideLoadingScreen();
                $16d9fec6fae182d5$export$bf638b60ea8b89b7(jsonData.redirect_url);
            }
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error parsing JSON response:", error);
        }
    }
    goBack(event) {
        event.preventDefault();
        const backTarget = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).THIRD_PARTY_BACK_TARGET);
        if (backTarget === "connect-wallet-only") {
            $16d9fec6fae182d5$export$bf638b60ea8b89b7(`/${this.codeValue}/connect-wallet-only?session=${this.sessionValue}`, {
                frame: "step_content",
                action: "replace"
            });
            return;
        }
        if (backTarget === "payment-options") {
            $16d9fec6fae182d5$export$bf638b60ea8b89b7(`/${this.codeValue}/payment-options?session=${this.sessionValue}`, {
                frame: "step_content",
                action: "replace"
            });
            return;
        }
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        $16d9fec6fae182d5$export$bf638b60ea8b89b7(`/${this.codeValue}/payment-options?session=${this.sessionValue}`);
    }
    hideBrokenImage(event) {
        event.currentTarget.style.display = "none";
    }
    selectAsset(event) {
        const el = event.currentTarget;
        const tokenid = el.getAttribute("data-third-party-payment-options-tokenid-param");
        const networkid = el.getAttribute("data-third-party-payment-options-networkid-param");
        if (!tokenid || !networkid) return;
        this.selectedTokenId = tokenid;
        this.selectedNetworkId = networkid;
        (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_asset_selected", {
            asset: el.dataset.symbol || "",
            network: el.dataset.networkName || "",
            token_id: tokenid,
            network_id: networkid,
            balance_available: el.dataset.balanceAvailable || ""
        });
        // Update visual selection using semantic connect-wallet asset classes.
        const selectedClasses = [
            "bg-thm-selector-asset-selector-active-bg",
            "border-thm-selector-asset-selector-active-border-color",
            "text-thm-selector-asset-selector-active-primary-text"
        ];
        const unselectedClasses = [
            "bg-thm-selector-asset-selector-passive-bg",
            "border-thm-selector-asset-selector-passive-border-color",
            "text-thm-selector-asset-selector-passive-primary-text"
        ];
        document.querySelectorAll(".asset-option").forEach((row)=>{
            row.classList.remove(...selectedClasses);
            row.classList.add(...unselectedClasses);
        });
        el.classList.remove(...unselectedClasses);
        el.classList.add(...selectedClasses);
        this.updateCheckoutOverviewFromAsset(el);
        this.enableConfirmButton();
    }
    selectPaymentOption() {
        if (!this.selectedTokenId || !this.selectedNetworkId) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("No asset selected");
            return;
        }
        this.showLoadingScreen();
        const tokenid = this.selectedTokenId;
        const networkid = this.selectedNetworkId;
        this.renderPaymentMethod(tokenid, networkid);
        const form = document.getElementById("frame-post-form");
        form.action = `/${this.codeValue}/review?session=${this.sessionValue}`;
        document.getElementById("form_session").value = this.sessionValue;
        document.getElementById("form_address").value = this.walletaddressValue;
        document.getElementById("form_networkid").value = networkid;
        document.getElementById("form_tokenid").value = tokenid;
        form.requestSubmit();
    }
    checkForAutoSelection() {
        const autoSelected = document.querySelector(".asset-option[data-auto-selected='true']");
        if (autoSelected) {
            this.selectedTokenId = autoSelected.getAttribute("data-third-party-payment-options-tokenid-param");
            this.selectedNetworkId = autoSelected.getAttribute("data-third-party-payment-options-networkid-param");
            this.updateCheckoutOverviewFromAsset(autoSelected);
            this.enableConfirmButton();
            // Statsig funnel between wallet_connected and tx_approved.
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_asset_selected", {
                asset: autoSelected.dataset.symbol || "",
                network: autoSelected.dataset.networkName || "",
                token_id: this.selectedTokenId,
                network_id: this.selectedNetworkId,
                balance_available: autoSelected.dataset.balanceAvailable || ""
            });
        }
    }
    updateCheckoutOverviewFromAsset(assetEl) {
        if (!assetEl) return;
        const amountEl = assetEl.querySelector(".shrink-0.font-medium");
        const amountDisplay = (amountEl?.textContent || "").trim();
        if (!amountDisplay) return;
        const feeDisplay = (assetEl.getAttribute("data-checkout-fee-display") || "").trim();
        if (feeDisplay) {
            const checkoutFees = document.getElementById("checkout_fees");
            if (checkoutFees) checkoutFees.textContent = feeDisplay;
            // Keep the mobile "incl. $X fees" summary in step with the headline.
            const inclFee = feeDisplay.replace(/\s*USD$/i, "");
            document.querySelectorAll(".js-checkout-fees-incl").forEach((el)=>{
                el.textContent = `incl. ${inclFee} fees`;
            });
        }
        // The order-summary breakdown's network-fee row must track the selected asset so it
        // never contradicts the headline fee (headline = network + the constant processing fee).
        const networkFeeDisplay = (assetEl.getAttribute("data-checkout-network-fee-display") || "").trim();
        if (networkFeeDisplay) {
            document.querySelectorAll(".js-checkout-network-fee").forEach((el)=>{
                el.textContent = networkFeeDisplay;
            });
            (0, $13ee377913fda6ff$export$9f4c63c0d723401e)(true);
        }
        const checkoutTotalAmount = document.getElementById("checkout_total_amount");
        if (checkoutTotalAmount) checkoutTotalAmount.textContent = amountDisplay;
        const checkoutPriceMobile = document.getElementById("checkout_price_mobile");
        if (checkoutPriceMobile) checkoutPriceMobile.textContent = `Est. ${amountDisplay}`;
        (0, $13ee377913fda6ff$export$c197863a4beecae7)(amountDisplay);
    }
    enableConfirmButton() {
        if (this.hasConfirmButtonTarget) this.confirmButtonTarget.classList.remove("is-disabled");
    }
    async renderPaymentMethod(tokenId, networkId) {
        const code = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
        const sessionId = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION);
        const httpReq = await fetch(`/${code}/payment-method`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Session": sessionId,
                "X-Code": code
            },
            body: JSON.stringify({
                tokenId: tokenId,
                networkId: networkId
            })
        });
        const jsonData = await httpReq.json();
        if (jsonData.error) return;
        if (jsonData.success && jsonData.type === "html") $16d9fec6fae182d5$export$ebdee272e46e11d9(jsonData.data);
    }
    async connectWallet() {
        try {
            this.dispatch("listenWalletChange", {
                bubbles: true
            });
            this.showLoadingScreen();
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).connectWallet();
            this.hideLoadingScreen();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error connecting wallet:", error);
            this.hideLoadingScreen();
            this.dispatch("error", {
                detail: {
                    content: (0, $871593c39ddb32a9$export$dbb77d813a78f040)(error, "Failed to connect wallet. Please try again.")
                }
            });
        }
    }
    listenWalletChange() {
        this.dispatch("listenWalletChange");
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}






function $dfd4109e85d8ea12$export$8cc545829c7461b0(errorBody) {
    if (!errorBody) return "";
    const envelope = errorBody.error;
    if (envelope && typeof envelope === "object" && envelope.message) return envelope.message;
    if (errorBody.message) return errorBody.message;
    if (typeof envelope === "string") return envelope;
    return "";
}
// codedError builds an Error carrying the envelope's code and request id so
// callers can branch on error.code and quote error.requestId to support.
function $dfd4109e85d8ea12$var$codedError(message, errorBody) {
    const err = new Error(message);
    const envelope = errorBody?.error;
    if (envelope && typeof envelope === "object") {
        err.code = envelope.code;
        err.details = envelope.details;
        err.requestId = envelope.request_id;
    }
    return err;
}
class $dfd4109e85d8ea12$var$HttpService {
    replacer(_, value) {
        if (typeof value === 'bigint') return value.toString();
        return value;
    }
    // async get(url) {
    //   try {
    //     const response = await fetch(url);
    //     return await this.processResponse(response);
    //   } catch (error) {
    //     // Handle or throw the error as needed
    //     debugError('GET request error:', error.message);
    //     throw error;
    //   }
    // }
    async post(url, data) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data, this.replacer)
            });
            return await this.processResponse(response);
        } catch (error) {
            // Handle or throw the error as needed
            (0, $df5856b8963e2c0f$export$280f90b954565303)('POST request error:', error.message);
            throw error;
        }
    }
    // unused
    // async postWithTimeout(url, data, timeout = 1000) {
    //   const controller = new AbortController();
    //   const timeoutId = setTimeout(() => controller.abort(), timeout);
    //   try {
    //     const response = await fetch(url, {
    //       method: 'POST',
    //       signal: controller.signal,
    //       headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    //       body: JSON.stringify(data),
    //     });
    //     clearTimeout(timeoutId);
    //     return await this.processResponse(response);
    //   } catch (error) {
    //     clearTimeout(timeoutId);
    //     // Handle or throw the error as needed
    //     debugError('POST request with timeout error:', error.message);
    //     throw error;
    //   }
    // }
    async processResponse(response) {
        if (!response.ok) {
            let errorBody = {};
            try {
                errorBody = await response.json();
            } catch (parseError) {
                (0, $df5856b8963e2c0f$export$280f90b954565303)('Failed to parse error response body:', parseError.message);
            }
            if (errorBody.type && errorBody.type == "html") return errorBody; //sent html error back
            // Catalog error envelope: the backend ships a server-rendered turbo
            // stream (error card / full page / banner) alongside the error key.
            if (errorBody.error_html) {
                Turbo.renderStreamMessage(errorBody.error_html);
                const renderedError = $dfd4109e85d8ea12$var$codedError($dfd4109e85d8ea12$export$8cc545829c7461b0(errorBody) || errorBody.error_key || 'Checkout error', errorBody);
                renderedError.errorKey = errorBody.error_key;
                renderedError.surfaceRendered = true;
                throw renderedError;
            }
            const errorMessage = $dfd4109e85d8ea12$export$8cc545829c7461b0(errorBody) || 'Unknown error occurred';
            throw $dfd4109e85d8ea12$var$codedError(errorMessage, errorBody);
        }
        return await response.json();
    }
}
const $dfd4109e85d8ea12$var$httpService = new $dfd4109e85d8ea12$var$HttpService();
var $dfd4109e85d8ea12$export$2e2bcd8739ae039 = $dfd4109e85d8ea12$var$httpService;




class $7749c40bd1cc6a71$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        checkoutid: String,
        challenge: String,
        session: String,
        address: String,
        permit: String,
        keycredential: Boolean
    };
    initialize() {
        this.attestation = null;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
    }
    async connect() {
        this.hideLoadingScreen();
        this.challenge = JSON.parse(this.challengeValue);
        this.permit = JSON.parse(this.permitValue);
    }
    async handleSignChallenge() {
        this.showLoadingScreen();
        try {
            if (!this.challenge) throw new Error("No challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            if (this.keycredentialValue) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Using keycredential for signing");
                let signResonse = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/sign/`, {
                    challenge: this.challenge,
                    session: this.sessionValue
                });
                if (signResonse.error) {
                    this.hideLoadingScreen();
                    (0, $df5856b8963e2c0f$export$280f90b954565303)(signResonse.error);
                    throw new Error(signResonse.error);
                }
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("KeyCredential signing successful:", signResonse.data);
                this.attestation = signResonse.data;
            } else {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for stored challenge");
                const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                    relyingParty: {
                        id: this.domain.domain,
                        name: this.domain.company
                    }
                });
                this.attestation = await webauthn.sign(this.challenge);
            }
            this.handleDFNSPermitRequest();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error during WebAuthn signing:", error);
            this.hideLoadingScreen();
            if ((0, $9286460a480b22e8$export$a5837bf4a7a2713a)(error)) (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).passkeyCancelled);
            else (0, $9286460a480b22e8$export$b542b247691f8019)("signing-failed", {
                session: this.sessionValue
            });
        }
    }
    async handleDFNSPermitRequest() {
        const form = document.getElementById("frame-post-form");
        document.getElementById("form_challengeIdentifier").value = this.challenge.challengeIdentifier;
        document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
        document.getElementById("form_session").value = this.sessionValue;
        document.getElementById("form_permitData").value = JSON.stringify({
            ...this.permit,
            address: this.addressValue,
            checkoutid: this.checkoutidValue
        });
        form.action = `/${sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE)}/authorized-review/`;
        form.requestSubmit();
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}








class $7d2cbf8c5a3a22ee$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        chainid: String,
        checkoutid: String,
        session: String,
        spenderaddress: String,
        tokencontractaddress: String,
        approval: String,
        challenge: String,
        credentialType: String
    };
    async connect() {
        this.hideLoadingScreen();
        this.attestation = null;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
        this.session = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION);
        this.challenge = JSON.parse(this.challengeValue);
        this.approval = JSON.parse(this.approvalValue);
    }
    async handleSignChallenge() {
        this.showLoadingScreen();
        try {
            if (!this.challenge) throw new Error("No challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            if (this.credentialTypeValue === "key_credential") {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Using keycredential for signing");
                let signResonse = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/sign/`, {
                    challenge: this.challenge,
                    session: this.session
                });
                if (signResonse.error) {
                    this.hideLoadingScreen();
                    (0, $df5856b8963e2c0f$export$280f90b954565303)(signResonse.error);
                    throw new Error(signResonse.error);
                }
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("KeyCredential signing successful:", signResonse.data);
                this.attestation = signResonse.data;
            } else {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for stored challenge");
                const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                    relyingParty: {
                        id: this.domain.domain,
                        name: this.domain.company
                    }
                });
                this.attestation = await webauthn.sign(this.challenge);
            }
            this.handleApproval();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error during WebAuthn signing:", error);
            this.hideLoadingScreen();
            if ((0, $9286460a480b22e8$export$a5837bf4a7a2713a)(error)) (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).passkeyCancelled);
            else (0, $9286460a480b22e8$export$b542b247691f8019)("signing-failed", {
                session: this.sessionValue
            });
        }
    }
    async handleApproval() {
        const form = document.getElementById("frame-post-form");
        document.getElementById("form_challengeIdentifier").value = this.challenge.challengeIdentifier;
        document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
        document.getElementById("form_approvalData").value = JSON.stringify(this.approval);
        document.getElementById("form_tokenContractAddress").value = this.tokencontractaddressValue;
        document.getElementById("form_session").value = this.sessionValue;
        form.action = `/${sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE)}/authorized-wallet-review/`;
        form.requestSubmit();
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}




var $4XGvQ = parcelRequire("4XGvQ");

var $cD3gI = parcelRequire("cD3gI");
function $2d2d1b67c25ca11b$export$dc1dc22ccf24efef(signatureHex) {
    const { r: r, s: s } = (0, $4XGvQ.secp256k1).Signature.fromCompact(signatureHex.slice(2, 130));
    const yParityOrV = Number(`0x${signatureHex.slice(130)}`);
    const [v, yParity] = (()=>{
        if (yParityOrV === 0 || yParityOrV === 1) return [
            undefined,
            yParityOrV
        ];
        if (yParityOrV === 27) return [
            BigInt(yParityOrV),
            0
        ];
        if (yParityOrV === 28) return [
            BigInt(yParityOrV),
            1
        ];
        throw new Error('Invalid yParityOrV value');
    })();
    if (typeof v !== 'undefined') return {
        r: (0, $cD3gI.numberToHex)(r, {
            size: 32
        }),
        s: (0, $cD3gI.numberToHex)(s, {
            size: 32
        }),
        v: v,
        yParity: yParity
    };
    return {
        r: (0, $cD3gI.numberToHex)(r, {
            size: 32
        }),
        s: (0, $cD3gI.numberToHex)(s, {
            size: 32
        }),
        yParity: yParity
    };
}







class $aa92c694fec4f61a$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        disableDuration: 30,
        permit: String,
        chainid: Number,
        session: String
    };
    async connect() {
        this.permit = JSON.parse(this.permitValue);
        const walletClient = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletClient();
        if (walletClient) {
            const current_chain = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getCurrentChain();
            if (current_chain != null) {
                let chainId = Number.parseInt(current_chain.id, 16);
                if (chainId != this.chainidValue) {
                    (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Connected Chain", chainId, "is not on desired network: ", this.chainidValue);
                    await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).changeChains(this.chainidValue);
                }
            }
        }
        this.hideLoadingScreen();
    }
    async authorise() {
        this.showLoadingScreen();
        this.disableInteractionForDuration();
        const walletClient = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletClient();
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Authorisation3rdPartyWithPermitSupportController PermitData", this.permit);
        if (walletClient) {
            const data = this.permit;
            let permitSignature;
            try {
                permitSignature = await walletClient.signTypedData({
                    domain: data.domain,
                    message: data.message,
                    primaryType: data.primaryType,
                    types: data.types
                });
            } catch (error) {
                (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_rejected", {
                    wallet_provider: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getConnectedWalletLabel() || ""
                });
                (0, $df5856b8963e2c0f$export$280f90b954565303)("Authorisation3rdPartyWithPermit signTypedData rejected", error?.message || error);
                this.hideLoadingScreen();
                if ((0, $9286460a480b22e8$export$a5837bf4a7a2713a)(error)) (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).paymentDeclinedInWallet);
                else (0, $9286460a480b22e8$export$b542b247691f8019)("something-went-wrong", {
                    session: this.sessionValue
                });
                return;
            }
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_approved", {
                network: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
                amount_crypto: String(data.message?.value ?? "")
            });
            data.rawSignature = permitSignature;
            data.signature = (0, $2d2d1b67c25ca11b$export$dc1dc22ccf24efef)(permitSignature);
            // Convert v and yParity to strings
            data.signature.v = data.signature.v.toString();
            data.signature.yParity = data.signature.yParity.toString();
            data.address = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletAddress();
            data.session = this.sessionValue;
            const form = document.getElementById("frame-post-form");
            form.action = `/${sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE)}/authorized-3rdParty-review/`;
            document.getElementById("form_address").value = data.address;
            document.getElementById("form_domain").value = JSON.stringify(data.domain);
            document.getElementById("form_message").value = JSON.stringify(data.message);
            document.getElementById("form_primaryType").value = data.primaryType;
            document.getElementById("form_signature").value = JSON.stringify(data.signature);
            document.getElementById("form_rawSignature").value = data.rawSignature;
            document.getElementById("form_types").value = JSON.stringify(data.types);
            document.getElementById("form_session").value = data.session;
            form.requestSubmit();
        }
    }
    disableInteractionForDuration() {
        const self = this;
        let remaining = this.disableDurationValue;
        self.disableInterval = setInterval(function() {
            remaining = remaining - 1;
            self.updateLoadingScreenMessage(`Please wait for ${remaining} second${remaining < 2 ? '' : 's'} before trying again.`);
            if (remaining === 0) {
                self.hideLoadingScreen();
                clearInterval(self.disableInterval);
            }
        }, 1000);
    }
    updateLoadingScreenMessage(text) {
        this.dispatch("updateLoadingScreenMessage", {
            detail: {
                text: text
            }
        });
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}








class $41f660d65e587d59$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        disableDuration: 30,
        chainid: Number,
        session: String,
        spenderaddress: String,
        ispurchasesession: Boolean,
        tokencontractaddress: String
    };
    async connect() {
        // Proactively prompt the network switch on load. ensureOnChain never throws,
        // so a rejection here can't strand the loading screen — the real enforcement
        // and retry happen in handleLocalApproval.
        if ((0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletClient()) await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).ensureOnChain(this.chainidValue);
        this.hideLoadingScreen();
    }
    async handleLocalApproval() {
        this.showLoadingScreen();
        this.disableInteractionForDuration();
        try {
            // viem's writeContract asserts wallet-chain == target-chain. If the user
            // rejected the switch, unblock the UI and bail so they can retry instead
            // of throwing ChainMismatchError.
            const onTargetChain = await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).ensureOnChain(this.chainidValue);
            if (!onTargetChain) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Wallet not on target chain after switch attempt; aborting approval");
                (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_rejected", {
                    wallet_provider: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getConnectedWalletLabel() || ""
                });
                this.resetInteraction();
                (0, $9286460a480b22e8$export$b542b247691f8019)("network-switch-needed", {
                    session: this.sessionValue
                });
                return;
            }
            // Re-fetch after switching — the client is pinned to the chain it was built on.
            const walletClient = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletClient();
            const contractAddress = this.tokencontractaddressValue;
            const walletAddress = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletAddress();
            const ABI = [
                {
                    constant: false,
                    inputs: [
                        {
                            name: "_spender",
                            type: "address"
                        },
                        {
                            name: "_value",
                            type: "uint256"
                        }
                    ],
                    name: "approve",
                    outputs: [
                        {
                            name: "",
                            type: "bool"
                        }
                    ],
                    payable: false,
                    stateMutability: "nonpayable",
                    type: "function"
                }
            ];
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("chainID:", this.chainidValue);
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("contractAddress:", contractAddress);
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("walletAddress:", walletAddress);
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("this.spenderaddressValue:", this.spenderaddressValue);
            // For Hedera (chain ID 295=mainnet, 296=testnet), use $1 billion approval
            // HTS tokens don't support infinite approvals (max uint256)
            let approvalAmount;
            if (this.chainidValue === 295 || this.chainidValue === 296) {
                approvalAmount = "100000000000000000"; // $100B for USDC (6 decimals)
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Hedera network detected, using $1B approval:", approvalAmount);
            } else {
                approvalAmount = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Non-Hedera network, using max uint256:", approvalAmount);
            }
            const chain = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getChain(this.chainidValue);
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Chain object:", chain);
            const txhash = await walletClient.writeContract({
                account: walletAddress,
                address: contractAddress,
                abi: ABI,
                functionName: "approve",
                args: [
                    this.spenderaddressValue,
                    approvalAmount
                ],
                chain: chain
            });
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("txhash:", txhash);
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_approved", {
                network: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
                tx_hash: txhash || ""
            });
            const data = {
                txhash: txhash,
                tokencontractaddress: this.tokencontractaddressValue,
                ispurchasesession: this.ispurchasesessionValue,
                session: this.sessionValue
            };
            const form = document.getElementById("frame-post-form");
            form.action = `/${sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE)}/authorized-3rdParty-wallet-review/`;
            document.getElementById("form_txhash").value = JSON.stringify(data.txhash);
            document.getElementById("form_tokencontractaddress").value = data.tokencontractaddress;
            document.getElementById("form_ispurchasesession").value = data.ispurchasesession;
            document.getElementById("form_session").value = data.session;
            form.requestSubmit();
        } catch (error) {
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_rejected", {
                wallet_provider: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getConnectedWalletLabel() || ""
            });
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Failed to approve locally:", error);
            this.resetInteraction();
            if ((0, $9286460a480b22e8$export$a5837bf4a7a2713a)(error)) (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).paymentDeclinedInWallet);
            else (0, $9286460a480b22e8$export$b542b247691f8019)("something-went-wrong", {
                session: this.sessionValue
            });
        }
    }
    disconnect() {
        this.clearDisableInterval();
    }
    clearDisableInterval() {
        if (this.disableInterval) {
            clearInterval(this.disableInterval);
            this.disableInterval = null;
        }
    }
    resetInteraction() {
        this.clearDisableInterval();
        this.hideLoadingScreen();
    }
    disableInteractionForDuration() {
        const self = this;
        let remaining = this.disableDurationValue;
        self.disableInterval = setInterval(function() {
            remaining = remaining - 1;
            self.updateLoadingScreenMessage(`Please wait for ${remaining} second${remaining < 2 ? '' : 's'} before trying again.`);
            if (remaining === 0) self.resetInteraction();
        }, 1000);
    }
    updateLoadingScreenMessage(text) {
        this.dispatch("updateLoadingScreenMessage", {
            detail: {
                text: text
            }
        });
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}




var $08c38351731ad8ae$exports = {};
/*!
 * Pusher JavaScript Library v8.5.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $08c38351731ad8ae$exports = factory();
})(self, ()=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ 594 (__unused_webpack_module, exports) {
                "use strict";
                // Copyright (C) 2016 Dmitry Chestnykh
                // MIT License. See LICENSE file for details.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /**
 * Package base64 implements Base64 encoding and decoding.
 */ // Invalid character used in decoding to indicate
                // that the character to decode is out of range of
                // alphabet and cannot be decoded.
                var INVALID_BYTE = 256;
                /**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */ var Coder = /** @class */ function() {
                    // TODO(dchest): methods to encode chunk-by-chunk.
                    function Coder(_paddingCharacter) {
                        if (_paddingCharacter === void 0) _paddingCharacter = "=";
                        this._paddingCharacter = _paddingCharacter;
                    }
                    Coder.prototype.encodedLength = function(length) {
                        if (!this._paddingCharacter) return (length * 8 + 5) / 6 | 0;
                        return (length + 2) / 3 * 4 | 0;
                    };
                    Coder.prototype.encode = function(data) {
                        var out = "";
                        var i = 0;
                        for(; i < data.length - 2; i += 3){
                            var c = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                            out += this._encodeByte(c >>> 18 & 63);
                            out += this._encodeByte(c >>> 12 & 63);
                            out += this._encodeByte(c >>> 6 & 63);
                            out += this._encodeByte(c >>> 0 & 63);
                        }
                        var left = data.length - i;
                        if (left > 0) {
                            var c = data[i] << 16 | (left === 2 ? data[i + 1] << 8 : 0);
                            out += this._encodeByte(c >>> 18 & 63);
                            out += this._encodeByte(c >>> 12 & 63);
                            if (left === 2) out += this._encodeByte(c >>> 6 & 63);
                            else out += this._paddingCharacter || "";
                            out += this._paddingCharacter || "";
                        }
                        return out;
                    };
                    Coder.prototype.maxDecodedLength = function(length) {
                        if (!this._paddingCharacter) return (length * 6 + 7) / 8 | 0;
                        return length / 4 * 3 | 0;
                    };
                    Coder.prototype.decodedLength = function(s) {
                        return this.maxDecodedLength(s.length - this._getPaddingLength(s));
                    };
                    Coder.prototype.decode = function(s) {
                        if (s.length === 0) return new Uint8Array(0);
                        var paddingLength = this._getPaddingLength(s);
                        var length = s.length - paddingLength;
                        var out = new Uint8Array(this.maxDecodedLength(length));
                        var op = 0;
                        var i = 0;
                        var haveBad = 0;
                        var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
                        for(; i < length - 4; i += 4){
                            v0 = this._decodeChar(s.charCodeAt(i + 0));
                            v1 = this._decodeChar(s.charCodeAt(i + 1));
                            v2 = this._decodeChar(s.charCodeAt(i + 2));
                            v3 = this._decodeChar(s.charCodeAt(i + 3));
                            out[op++] = v0 << 2 | v1 >>> 4;
                            out[op++] = v1 << 4 | v2 >>> 2;
                            out[op++] = v2 << 6 | v3;
                            haveBad |= v0 & INVALID_BYTE;
                            haveBad |= v1 & INVALID_BYTE;
                            haveBad |= v2 & INVALID_BYTE;
                            haveBad |= v3 & INVALID_BYTE;
                        }
                        if (i < length - 1) {
                            v0 = this._decodeChar(s.charCodeAt(i));
                            v1 = this._decodeChar(s.charCodeAt(i + 1));
                            out[op++] = v0 << 2 | v1 >>> 4;
                            haveBad |= v0 & INVALID_BYTE;
                            haveBad |= v1 & INVALID_BYTE;
                        }
                        if (i < length - 2) {
                            v2 = this._decodeChar(s.charCodeAt(i + 2));
                            out[op++] = v1 << 4 | v2 >>> 2;
                            haveBad |= v2 & INVALID_BYTE;
                        }
                        if (i < length - 3) {
                            v3 = this._decodeChar(s.charCodeAt(i + 3));
                            out[op++] = v2 << 6 | v3;
                            haveBad |= v3 & INVALID_BYTE;
                        }
                        if (haveBad !== 0) throw new Error("Base64Coder: incorrect characters for decoding");
                        return out;
                    };
                    // Standard encoding have the following encoded/decoded ranges,
                    // which we need to convert between.
                    //
                    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
                    // Index:   0 - 25                    26 - 51              52 - 61   62  63
                    // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
                    //
                    // Encode 6 bits in b into a new character.
                    Coder.prototype._encodeByte = function(b) {
                        // Encoding uses constant time operations as follows:
                        //
                        // 1. Define comparison of A with B using (A - B) >>> 8:
                        //          if A > B, then result is positive integer
                        //          if A <= B, then result is 0
                        //
                        // 2. Define selection of C or 0 using bitwise AND: X & C:
                        //          if X == 0, then result is 0
                        //          if X != 0, then result is C
                        //
                        // 3. Start with the smallest comparison (b >= 0), which is always
                        //    true, so set the result to the starting ASCII value (65).
                        //
                        // 4. Continue comparing b to higher ASCII values, and selecting
                        //    zero if comparison isn't true, otherwise selecting a value
                        //    to add to result, which:
                        //
                        //          a) undoes the previous addition
                        //          b) provides new value to add
                        //
                        var result = b;
                        // b >= 0
                        result += 65;
                        // b > 25
                        result += 25 - b >>> 8 & 6;
                        // b > 51
                        result += 51 - b >>> 8 & -75;
                        // b > 61
                        result += 61 - b >>> 8 & -15;
                        // b > 62
                        result += 62 - b >>> 8 & 3;
                        return String.fromCharCode(result);
                    };
                    // Decode a character code into a byte.
                    // Must return 256 if character is out of alphabet range.
                    Coder.prototype._decodeChar = function(c) {
                        // Decoding works similar to encoding: using the same comparison
                        // function, but now it works on ranges: result is always incremented
                        // by value, but this value becomes zero if the range is not
                        // satisfied.
                        //
                        // Decoding starts with invalid value, 256, which is then
                        // subtracted when the range is satisfied. If none of the ranges
                        // apply, the function returns 256, which is then checked by
                        // the caller to throw error.
                        var result = INVALID_BYTE; // start with invalid character
                        // c == 43 (c > 42 and c < 44)
                        result += (42 - c & c - 44) >>> 8 & -INVALID_BYTE + c - 43 + 62;
                        // c == 47 (c > 46 and c < 48)
                        result += (46 - c & c - 48) >>> 8 & -INVALID_BYTE + c - 47 + 63;
                        // c > 47 and c < 58
                        result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                        // c > 64 and c < 91
                        result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                        // c > 96 and c < 123
                        result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                        return result;
                    };
                    Coder.prototype._getPaddingLength = function(s) {
                        var paddingLength = 0;
                        if (this._paddingCharacter) {
                            for(var i = s.length - 1; i >= 0; i--){
                                if (s[i] !== this._paddingCharacter) break;
                                paddingLength++;
                            }
                            if (s.length < 4 || paddingLength > 2) throw new Error("Base64Coder: incorrect padding");
                        }
                        return paddingLength;
                    };
                    return Coder;
                }();
                exports.Coder = Coder;
                var stdCoder = new Coder();
                function encode(data) {
                    return stdCoder.encode(data);
                }
                exports.encode = encode;
                function decode(s) {
                    return stdCoder.decode(s);
                }
                exports.decode = decode;
                /**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */ var URLSafeCoder = /** @class */ function(_super) {
                    __extends(URLSafeCoder, _super);
                    function URLSafeCoder() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    // URL-safe encoding have the following encoded/decoded ranges:
                    //
                    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
                    // Index:   0 - 25                    26 - 51              52 - 61   62  63
                    // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
                    //
                    URLSafeCoder.prototype._encodeByte = function(b) {
                        var result = b;
                        // b >= 0
                        result += 65;
                        // b > 25
                        result += 25 - b >>> 8 & 6;
                        // b > 51
                        result += 51 - b >>> 8 & -75;
                        // b > 61
                        result += 61 - b >>> 8 & -13;
                        // b > 62
                        result += 62 - b >>> 8 & 49;
                        return String.fromCharCode(result);
                    };
                    URLSafeCoder.prototype._decodeChar = function(c) {
                        var result = INVALID_BYTE;
                        // c == 45 (c > 44 and c < 46)
                        result += (44 - c & c - 46) >>> 8 & -INVALID_BYTE + c - 45 + 62;
                        // c == 95 (c > 94 and c < 96)
                        result += (94 - c & c - 96) >>> 8 & -INVALID_BYTE + c - 95 + 63;
                        // c > 47 and c < 58
                        result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                        // c > 64 and c < 91
                        result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                        // c > 96 and c < 123
                        result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                        return result;
                    };
                    return URLSafeCoder;
                }(Coder);
                exports.URLSafeCoder = URLSafeCoder;
                var urlSafeCoder = new URLSafeCoder();
                function encodeURLSafe(data) {
                    return urlSafeCoder.encode(data);
                }
                exports.encodeURLSafe = encodeURLSafe;
                function decodeURLSafe(s) {
                    return urlSafeCoder.decode(s);
                }
                exports.decodeURLSafe = decodeURLSafe;
                exports.encodedLength = function(length) {
                    return stdCoder.encodedLength(length);
                };
                exports.maxDecodedLength = function(length) {
                    return stdCoder.maxDecodedLength(length);
                };
                exports.decodedLength = function(s) {
                    return stdCoder.decodedLength(s);
                };
            /***/ },
            /***/ 978 (__unused_webpack_module, exports) {
                "use strict";
                var __webpack_unused_export__;
                // Copyright (C) 2016 Dmitry Chestnykh
                // MIT License. See LICENSE file for details.
                __webpack_unused_export__ = {
                    value: true
                };
                /**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ var INVALID_UTF16 = "utf8: invalid string";
                var INVALID_UTF8 = "utf8: invalid source encoding";
                /**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encode(s) {
                    // Calculate result length and allocate output array.
                    // encodedLength() also validates string and throws errors,
                    // so we don't need repeat validation here.
                    var arr = new Uint8Array(encodedLength(s));
                    var pos = 0;
                    for(var i = 0; i < s.length; i++){
                        var c = s.charCodeAt(i);
                        if (c < 0x80) arr[pos++] = c;
                        else if (c < 0x800) {
                            arr[pos++] = 0xc0 | c >> 6;
                            arr[pos++] = 0x80 | c & 0x3f;
                        } else if (c < 0xd800) {
                            arr[pos++] = 0xe0 | c >> 12;
                            arr[pos++] = 0x80 | c >> 6 & 0x3f;
                            arr[pos++] = 0x80 | c & 0x3f;
                        } else {
                            i++; // get one more character
                            c = (c & 0x3ff) << 10;
                            c |= s.charCodeAt(i) & 0x3ff;
                            c += 0x10000;
                            arr[pos++] = 0xf0 | c >> 18;
                            arr[pos++] = 0x80 | c >> 12 & 0x3f;
                            arr[pos++] = 0x80 | c >> 6 & 0x3f;
                            arr[pos++] = 0x80 | c & 0x3f;
                        }
                    }
                    return arr;
                }
                __webpack_unused_export__ = encode;
                /**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encodedLength(s) {
                    var result = 0;
                    for(var i = 0; i < s.length; i++){
                        var c = s.charCodeAt(i);
                        if (c < 0x80) result += 1;
                        else if (c < 0x800) result += 2;
                        else if (c < 0xd800) result += 3;
                        else if (c <= 0xdfff) {
                            if (i >= s.length - 1) throw new Error(INVALID_UTF16);
                            i++; // "eat" next character
                            result += 4;
                        } else throw new Error(INVALID_UTF16);
                    }
                    return result;
                }
                __webpack_unused_export__ = encodedLength;
                /**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */ function decode(arr) {
                    var chars = [];
                    for(var i = 0; i < arr.length; i++){
                        var b = arr[i];
                        if (b & 0x80) {
                            var min = void 0;
                            if (b < 0xe0) {
                                // Need 1 more byte.
                                if (i >= arr.length) throw new Error(INVALID_UTF8);
                                var n1 = arr[++i];
                                if ((n1 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                                b = (b & 0x1f) << 6 | n1 & 0x3f;
                                min = 0x80;
                            } else if (b < 0xf0) {
                                // Need 2 more bytes.
                                if (i >= arr.length - 1) throw new Error(INVALID_UTF8);
                                var n1 = arr[++i];
                                var n2 = arr[++i];
                                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                                b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                                min = 0x800;
                            } else if (b < 0xf8) {
                                // Need 3 more bytes.
                                if (i >= arr.length - 2) throw new Error(INVALID_UTF8);
                                var n1 = arr[++i];
                                var n2 = arr[++i];
                                var n3 = arr[++i];
                                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                                b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                                min = 0x10000;
                            } else throw new Error(INVALID_UTF8);
                            if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error(INVALID_UTF8);
                            if (b >= 0x10000) {
                                // Surrogate pair.
                                if (b > 0x10ffff) throw new Error(INVALID_UTF8);
                                b -= 0x10000;
                                chars.push(String.fromCharCode(0xd800 | b >> 10));
                                b = 0xdc00 | b & 0x3ff;
                            }
                        }
                        chars.push(String.fromCharCode(b));
                    }
                    return chars.join("");
                }
                exports.D4 = decode;
            /***/ },
            /***/ 721 (module1, __unused_webpack_exports, __webpack_require__) {
                // required so we don't have to do require('pusher').default etc.
                module1.exports = __webpack_require__(207)["default"];
            /***/ },
            /***/ 207 (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": ()=>/* binding */ pusher
                });
                class ScriptReceiverFactory {
                    constructor(prefix, name){
                        this.lastId = 0;
                        this.prefix = prefix;
                        this.name = name;
                    }
                    create(callback) {
                        this.lastId++;
                        var number = this.lastId;
                        var id = this.prefix + number;
                        var name = this.name + '[' + number + ']';
                        var called = false;
                        var callbackWrapper = function() {
                            if (!called) {
                                callback.apply(null, arguments);
                                called = true;
                            }
                        };
                        this[number] = callbackWrapper;
                        return {
                            number: number,
                            id: id,
                            name: name,
                            callback: callbackWrapper
                        };
                    }
                    remove(receiver) {
                        delete this[receiver.number];
                    }
                }
                var ScriptReceivers = new ScriptReceiverFactory('_pusher_script_', 'Pusher.ScriptReceivers');
                var Defaults = {
                    VERSION: "8.5.0",
                    PROTOCOL: 7,
                    wsPort: 80,
                    wssPort: 443,
                    wsPath: '',
                    httpHost: 'sockjs.pusher.com',
                    httpPort: 80,
                    httpsPort: 443,
                    httpPath: '/pusher',
                    stats_host: 'stats.pusher.com',
                    authEndpoint: '/pusher/auth',
                    authTransport: 'ajax',
                    activityTimeout: 120000,
                    pongTimeout: 30000,
                    unavailableTimeout: 10000,
                    userAuthentication: {
                        endpoint: '/pusher/user-auth',
                        transport: 'ajax'
                    },
                    channelAuthorization: {
                        endpoint: '/pusher/auth',
                        transport: 'ajax'
                    },
                    cdn_http: "http://js.pusher.com",
                    cdn_https: "https://js.pusher.com",
                    dependency_suffix: ""
                };
                /* harmony default export */ const defaults = Defaults;
                class DependencyLoader {
                    constructor(options){
                        this.options = options;
                        this.receivers = options.receivers || ScriptReceivers;
                        this.loading = {};
                    }
                    load(name, options, callback) {
                        var self1 = this;
                        if (self1.loading[name] && self1.loading[name].length > 0) self1.loading[name].push(callback);
                        else {
                            self1.loading[name] = [
                                callback
                            ];
                            var request = runtime.createScriptRequest(self1.getPath(name, options));
                            var receiver = self1.receivers.create(function(error) {
                                self1.receivers.remove(receiver);
                                if (self1.loading[name]) {
                                    var callbacks = self1.loading[name];
                                    delete self1.loading[name];
                                    var successCallback = function(wasSuccessful) {
                                        if (!wasSuccessful) request.cleanup();
                                    };
                                    for(var i = 0; i < callbacks.length; i++)callbacks[i](error, successCallback);
                                }
                            });
                            request.send(receiver);
                        }
                    }
                    getRoot(options) {
                        var cdn;
                        var protocol = runtime.getDocument().location.protocol;
                        if (options && options.useTLS || protocol === 'https:') cdn = this.options.cdn_https;
                        else cdn = this.options.cdn_http;
                        return cdn.replace(/\/*$/, '') + '/' + this.options.version;
                    }
                    getPath(name, options) {
                        return this.getRoot(options) + '/' + name + this.options.suffix + '.js';
                    }
                }
                var DependenciesReceivers = new ScriptReceiverFactory('_pusher_dependencies', 'Pusher.DependenciesReceivers');
                var Dependencies = new DependencyLoader({
                    cdn_http: defaults.cdn_http,
                    cdn_https: defaults.cdn_https,
                    version: defaults.VERSION,
                    suffix: defaults.dependency_suffix,
                    receivers: DependenciesReceivers
                });
                const urlStore = {
                    baseUrl: 'https://pusher.com',
                    urls: {
                        authenticationEndpoint: {
                            path: '/docs/channels/server_api/authenticating_users'
                        },
                        authorizationEndpoint: {
                            path: '/docs/channels/server_api/authorizing-users/'
                        },
                        javascriptQuickStart: {
                            path: '/docs/javascript_quick_start'
                        },
                        triggeringClientEvents: {
                            path: '/docs/client_api_guide/client_events#trigger-events'
                        },
                        encryptedChannelSupport: {
                            fullUrl: 'https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support'
                        }
                    }
                };
                const buildLogSuffix = function(key) {
                    const urlPrefix = 'See:';
                    const urlObj = urlStore.urls[key];
                    if (!urlObj) return '';
                    let url;
                    if (urlObj.fullUrl) url = urlObj.fullUrl;
                    else if (urlObj.path) url = urlStore.baseUrl + urlObj.path;
                    if (!url) return '';
                    return `${urlPrefix} ${url}`;
                };
                /* harmony default export */ const url_store = {
                    buildLogSuffix: buildLogSuffix
                };
                var AuthRequestType;
                (function(AuthRequestType) {
                    AuthRequestType["UserAuthentication"] = "user-authentication";
                    AuthRequestType["ChannelAuthorization"] = "channel-authorization";
                })(AuthRequestType || (AuthRequestType = {}));
                class BadEventName extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class BadChannelName extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class RequestTimedOut extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class TransportPriorityTooLow extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class TransportClosed extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class UnsupportedFeature extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class UnsupportedTransport extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class UnsupportedStrategy extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class HTTPAuthError extends Error {
                    constructor(status, msg){
                        super(msg);
                        this.status = status;
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                const ajax = function(context, query, authOptions, authRequestType, callback) {
                    const xhr = runtime.createXHR();
                    xhr.open('POST', authOptions.endpoint, true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    for(var headerName in authOptions.headers)xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
                    if (authOptions.headersProvider != null) {
                        let dynamicHeaders = authOptions.headersProvider();
                        for(var headerName in dynamicHeaders)xhr.setRequestHeader(headerName, dynamicHeaders[headerName]);
                    }
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                let data;
                                let parsed = false;
                                try {
                                    data = JSON.parse(xhr.responseText);
                                    parsed = true;
                                } catch (e) {
                                    callback(new HTTPAuthError(200, `JSON returned from ${authRequestType.toString()} endpoint was invalid, yet status code was 200. Data was: ${xhr.responseText}`), null);
                                }
                                if (parsed) callback(null, data);
                            } else {
                                let suffix = '';
                                switch(authRequestType){
                                    case AuthRequestType.UserAuthentication:
                                        suffix = url_store.buildLogSuffix('authenticationEndpoint');
                                        break;
                                    case AuthRequestType.ChannelAuthorization:
                                        suffix = `Clients must be authorized to join private or presence channels. ${url_store.buildLogSuffix('authorizationEndpoint')}`;
                                        break;
                                }
                                callback(new HTTPAuthError(xhr.status, `Unable to retrieve auth string from ${authRequestType.toString()} endpoint - ` + `received status: ${xhr.status} from ${authOptions.endpoint}. ${suffix}`), null);
                            }
                        }
                    };
                    xhr.send(query);
                    return xhr;
                };
                /* harmony default export */ const xhr_auth = ajax;
                function encode(s) {
                    return btoa(utob(s));
                }
                var fromCharCode = String.fromCharCode;
                var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var b64tab = {};
                for(var i = 0, l = b64chars.length; i < l; i++)b64tab[b64chars.charAt(i)] = i;
                var cb_utob = function(c) {
                    var cc = c.charCodeAt(0);
                    return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
                };
                var utob = function(u) {
                    return u.replace(/[^\x00-\x7F]/g, cb_utob);
                };
                var cb_encode = function(ccc) {
                    var padlen = [
                        0,
                        2,
                        1
                    ][ccc.length % 3];
                    var ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
                    var chars = [
                        b64chars.charAt(ord >>> 18),
                        b64chars.charAt(ord >>> 12 & 63),
                        padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
                        padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
                    ];
                    return chars.join('');
                };
                var btoa = window.btoa || function(b) {
                    return b.replace(/[\s\S]{1,3}/g, cb_encode);
                };
                class Timer {
                    constructor(set, clear, delay, callback){
                        this.clear = clear;
                        this.timer = set(()=>{
                            if (this.timer) this.timer = callback(this.timer);
                        }, delay);
                    }
                    isRunning() {
                        return this.timer !== null;
                    }
                    ensureAborted() {
                        if (this.timer) {
                            this.clear(this.timer);
                            this.timer = null;
                        }
                    }
                }
                /* harmony default export */ const abstract_timer = Timer;
                function timers_clearTimeout(timer) {
                    window.clearTimeout(timer);
                }
                function timers_clearInterval(timer) {
                    window.clearInterval(timer);
                }
                class OneOffTimer extends abstract_timer {
                    constructor(delay, callback){
                        super(setTimeout, timers_clearTimeout, delay, function(timer) {
                            callback();
                            return null;
                        });
                    }
                }
                class PeriodicTimer extends abstract_timer {
                    constructor(delay, callback){
                        super(setInterval, timers_clearInterval, delay, function(timer) {
                            callback();
                            return timer;
                        });
                    }
                }
                var Util = {
                    now () {
                        if (Date.now) return Date.now();
                        else return new Date().valueOf();
                    },
                    defer (callback) {
                        return new OneOffTimer(0, callback);
                    },
                    method (name, ...args) {
                        var boundArguments = Array.prototype.slice.call(arguments, 1);
                        return function(object) {
                            return object[name].apply(object, boundArguments.concat(arguments));
                        };
                    }
                };
                /* harmony default export */ const util = Util;
                function extend(target, ...sources) {
                    for(var i = 0; i < sources.length; i++){
                        var extensions = sources[i];
                        for(var property in extensions)if (extensions[property] && extensions[property].constructor && extensions[property].constructor === Object) target[property] = extend(target[property] || {}, extensions[property]);
                        else target[property] = extensions[property];
                    }
                    return target;
                }
                function stringify() {
                    var m = [
                        'Pusher'
                    ];
                    for(var i = 0; i < arguments.length; i++)if (typeof arguments[i] === 'string') m.push(arguments[i]);
                    else m.push(safeJSONStringify(arguments[i]));
                    return m.join(' : ');
                }
                function arrayIndexOf(array, item) {
                    var nativeIndexOf = Array.prototype.indexOf;
                    if (array === null) return -1;
                    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item);
                    for(var i = 0, l = array.length; i < l; i++){
                        if (array[i] === item) return i;
                    }
                    return -1;
                }
                function objectApply(object, f) {
                    for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) f(object[key], key, object);
                }
                function keys(object) {
                    var keys = [];
                    objectApply(object, function(_, key) {
                        keys.push(key);
                    });
                    return keys;
                }
                function values(object) {
                    var values = [];
                    objectApply(object, function(value) {
                        values.push(value);
                    });
                    return values;
                }
                function apply(array, f, context) {
                    for(var i = 0; i < array.length; i++)f.call(context || window, array[i], i, array);
                }
                function map(array, f) {
                    var result = [];
                    for(var i = 0; i < array.length; i++)result.push(f(array[i], i, array, result));
                    return result;
                }
                function mapObject(object, f) {
                    var result = {};
                    objectApply(object, function(value, key) {
                        result[key] = f(value);
                    });
                    return result;
                }
                function filter(array, test) {
                    test = test || function(value) {
                        return !!value;
                    };
                    var result = [];
                    for(var i = 0; i < array.length; i++)if (test(array[i], i, array, result)) result.push(array[i]);
                    return result;
                }
                function filterObject(object, test) {
                    var result = {};
                    objectApply(object, function(value, key) {
                        if (test && test(value, key, object, result) || Boolean(value)) result[key] = value;
                    });
                    return result;
                }
                function flatten(object) {
                    var result = [];
                    objectApply(object, function(value, key) {
                        result.push([
                            key,
                            value
                        ]);
                    });
                    return result;
                }
                function any(array, test) {
                    for(var i = 0; i < array.length; i++){
                        if (test(array[i], i, array)) return true;
                    }
                    return false;
                }
                function collections_all(array, test) {
                    for(var i = 0; i < array.length; i++){
                        if (!test(array[i], i, array)) return false;
                    }
                    return true;
                }
                function encodeParamsObject(data) {
                    return mapObject(data, function(value) {
                        if (typeof value === 'object') value = safeJSONStringify(value);
                        return encodeURIComponent(encode(value.toString()));
                    });
                }
                function buildQueryString(data) {
                    var params = filterObject(data, function(value) {
                        return value !== undefined;
                    });
                    var query = map(flatten(encodeParamsObject(params)), util.method('join', '=')).join('&');
                    return query;
                }
                function decycleObject(object) {
                    var objects = [], paths = [];
                    return function derez(value, path) {
                        var i, name, nu;
                        switch(typeof value){
                            case 'object':
                                if (!value) return null;
                                for(i = 0; i < objects.length; i += 1){
                                    if (objects[i] === value) return {
                                        $ref: paths[i]
                                    };
                                }
                                objects.push(value);
                                paths.push(path);
                                if (Object.prototype.toString.apply(value) === '[object Array]') {
                                    nu = [];
                                    for(i = 0; i < value.length; i += 1)nu[i] = derez(value[i], path + '[' + i + ']');
                                } else {
                                    nu = {};
                                    for(name in value)if (Object.prototype.hasOwnProperty.call(value, name)) nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
                                }
                                return nu;
                            case 'number':
                            case 'string':
                            case 'boolean':
                                return value;
                        }
                    }(object, '$');
                }
                function safeJSONStringify(source) {
                    try {
                        return JSON.stringify(source);
                    } catch (e) {
                        return JSON.stringify(decycleObject(source));
                    }
                }
                class Logger {
                    constructor(){
                        this.globalLog = (message)=>{
                            if (window.console && window.console.log) window.console.log(message);
                        };
                    }
                    debug(...args) {
                        this.log(this.globalLog, args);
                    }
                    warn(...args) {
                        this.log(this.globalLogWarn, args);
                    }
                    error(...args) {
                        this.log(this.globalLogError, args);
                    }
                    globalLogWarn(message) {
                        if (window.console && window.console.warn) window.console.warn(message);
                        else this.globalLog(message);
                    }
                    globalLogError(message) {
                        if (window.console && window.console.error) window.console.error(message);
                        else this.globalLogWarn(message);
                    }
                    log(defaultLoggingFunction, ...args) {
                        var message = stringify.apply(this, arguments);
                        if (pusher.log) pusher.log(message);
                        else if (pusher.logToConsole) {
                            const log = defaultLoggingFunction.bind(this);
                            log(message);
                        }
                    }
                }
                /* harmony default export */ const logger = new Logger();
                var jsonp = function(context, query, authOptions, authRequestType, callback) {
                    if (authOptions.headers !== undefined || authOptions.headersProvider != null) logger.warn(`To send headers with the ${authRequestType.toString()} request, you must use AJAX, rather than JSONP.`);
                    var callbackName = context.nextAuthCallbackID.toString();
                    context.nextAuthCallbackID++;
                    var document1 = context.getDocument();
                    var script = document1.createElement('script');
                    context.auth_callbacks[callbackName] = function(data) {
                        callback(null, data);
                    };
                    var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
                    script.src = authOptions.endpoint + '?callback=' + encodeURIComponent(callback_name) + '&' + query;
                    var head = document1.getElementsByTagName('head')[0] || document1.documentElement;
                    head.insertBefore(script, head.firstChild);
                };
                /* harmony default export */ const jsonp_auth = jsonp;
                class ScriptRequest {
                    constructor(src){
                        this.src = src;
                    }
                    send(receiver) {
                        var self1 = this;
                        var errorString = 'Error loading ' + self1.src;
                        self1.script = document.createElement('script');
                        self1.script.id = receiver.id;
                        self1.script.src = self1.src;
                        self1.script.type = 'text/javascript';
                        self1.script.charset = 'UTF-8';
                        if (self1.script.addEventListener) {
                            self1.script.onerror = function() {
                                receiver.callback(errorString);
                            };
                            self1.script.onload = function() {
                                receiver.callback(null);
                            };
                        } else self1.script.onreadystatechange = function() {
                            if (self1.script.readyState === 'loaded' || self1.script.readyState === 'complete') receiver.callback(null);
                        };
                        if (self1.script.async === undefined && document.attachEvent && /opera/i.test(navigator.userAgent)) {
                            self1.errorScript = document.createElement('script');
                            self1.errorScript.id = receiver.id + '_error';
                            self1.errorScript.text = receiver.name + "('" + errorString + "');";
                            self1.script.async = self1.errorScript.async = false;
                        } else self1.script.async = true;
                        var head = document.getElementsByTagName('head')[0];
                        head.insertBefore(self1.script, head.firstChild);
                        if (self1.errorScript) head.insertBefore(self1.errorScript, self1.script.nextSibling);
                    }
                    cleanup() {
                        if (this.script) {
                            this.script.onload = this.script.onerror = null;
                            this.script.onreadystatechange = null;
                        }
                        if (this.script && this.script.parentNode) this.script.parentNode.removeChild(this.script);
                        if (this.errorScript && this.errorScript.parentNode) this.errorScript.parentNode.removeChild(this.errorScript);
                        this.script = null;
                        this.errorScript = null;
                    }
                }
                class JSONPRequest {
                    constructor(url, data){
                        this.url = url;
                        this.data = data;
                    }
                    send(receiver) {
                        if (this.request) return;
                        var query = buildQueryString(this.data);
                        var url = this.url + '/' + receiver.number + '?' + query;
                        this.request = runtime.createScriptRequest(url);
                        this.request.send(receiver);
                    }
                    cleanup() {
                        if (this.request) this.request.cleanup();
                    }
                }
                var getAgent = function(sender, useTLS) {
                    return function(data, callback) {
                        var scheme = 'http' + (useTLS ? 's' : '') + '://';
                        var url = scheme + (sender.host || sender.options.host) + sender.options.path;
                        var request = runtime.createJSONPRequest(url, data);
                        var receiver = runtime.ScriptReceivers.create(function(error, result) {
                            ScriptReceivers.remove(receiver);
                            request.cleanup();
                            if (result && result.host) sender.host = result.host;
                            if (callback) callback(error, result);
                        });
                        request.send(receiver);
                    };
                };
                var jsonp_timeline_jsonp = {
                    name: 'jsonp',
                    getAgent: getAgent
                };
                /* harmony default export */ const jsonp_timeline = jsonp_timeline_jsonp;
                function getGenericURL(baseScheme, params, path) {
                    var scheme = baseScheme + (params.useTLS ? 's' : '');
                    var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
                    return scheme + '://' + host + path;
                }
                function getGenericPath(key, queryString) {
                    var path = '/app/' + key;
                    var query = '?protocol=' + defaults.PROTOCOL + '&client=js' + '&version=' + defaults.VERSION + (queryString ? '&' + queryString : '');
                    return path + query;
                }
                var ws = {
                    getInitial: function(key, params) {
                        var path = (params.httpPath || '') + getGenericPath(key, 'flash=false');
                        return getGenericURL('ws', params, path);
                    }
                };
                var http = {
                    getInitial: function(key, params) {
                        var path = (params.httpPath || '/pusher') + getGenericPath(key);
                        return getGenericURL('http', params, path);
                    }
                };
                var sockjs = {
                    getInitial: function(key, params) {
                        return getGenericURL('http', params, params.httpPath || '/pusher');
                    },
                    getPath: function(key, params) {
                        return getGenericPath(key);
                    }
                };
                class CallbackRegistry {
                    constructor(){
                        this._callbacks = {};
                    }
                    get(name) {
                        return this._callbacks[prefix(name)];
                    }
                    add(name, callback, context) {
                        var prefixedEventName = prefix(name);
                        this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
                        this._callbacks[prefixedEventName].push({
                            fn: callback,
                            context: context
                        });
                    }
                    remove(name, callback, context) {
                        if (!name && !callback && !context) {
                            this._callbacks = {};
                            return;
                        }
                        var names = name ? [
                            prefix(name)
                        ] : keys(this._callbacks);
                        if (callback || context) this.removeCallback(names, callback, context);
                        else this.removeAllCallbacks(names);
                    }
                    removeCallback(names, callback, context) {
                        apply(names, function(name) {
                            this._callbacks[name] = filter(this._callbacks[name] || [], function(binding) {
                                return callback && callback !== binding.fn || context && context !== binding.context;
                            });
                            if (this._callbacks[name].length === 0) delete this._callbacks[name];
                        }, this);
                    }
                    removeAllCallbacks(names) {
                        apply(names, function(name) {
                            delete this._callbacks[name];
                        }, this);
                    }
                }
                function prefix(name) {
                    return '_' + name;
                }
                class Dispatcher {
                    constructor(failThrough){
                        this.callbacks = new CallbackRegistry();
                        this.global_callbacks = [];
                        this.failThrough = failThrough;
                    }
                    bind(eventName, callback, context) {
                        this.callbacks.add(eventName, callback, context);
                        return this;
                    }
                    bind_global(callback) {
                        this.global_callbacks.push(callback);
                        return this;
                    }
                    unbind(eventName, callback, context) {
                        this.callbacks.remove(eventName, callback, context);
                        return this;
                    }
                    unbind_global(callback) {
                        if (!callback) {
                            this.global_callbacks = [];
                            return this;
                        }
                        this.global_callbacks = filter(this.global_callbacks || [], (c)=>c !== callback);
                        return this;
                    }
                    unbind_all() {
                        this.unbind();
                        this.unbind_global();
                        return this;
                    }
                    emit(eventName, data, metadata) {
                        for(var i = 0; i < this.global_callbacks.length; i++)this.global_callbacks[i](eventName, data);
                        var callbacks = this.callbacks.get(eventName);
                        var args = [];
                        if (metadata) args.push(data, metadata);
                        else if (data) args.push(data);
                        if (callbacks && callbacks.length > 0) for(var i = 0; i < callbacks.length; i++)callbacks[i].fn.apply(callbacks[i].context || window, args);
                        else if (this.failThrough) this.failThrough(eventName, data);
                        return this;
                    }
                }
                class TransportConnection extends Dispatcher {
                    constructor(hooks, name, priority, key, options){
                        super();
                        this.initialize = runtime.transportConnectionInitializer;
                        this.hooks = hooks;
                        this.name = name;
                        this.priority = priority;
                        this.key = key;
                        this.options = options;
                        this.state = 'new';
                        this.timeline = options.timeline;
                        this.activityTimeout = options.activityTimeout;
                        this.id = this.timeline.generateUniqueID();
                    }
                    handlesActivityChecks() {
                        return Boolean(this.hooks.handlesActivityChecks);
                    }
                    supportsPing() {
                        return Boolean(this.hooks.supportsPing);
                    }
                    connect() {
                        if (this.socket || this.state !== 'initialized') return false;
                        var url = this.hooks.urls.getInitial(this.key, this.options);
                        try {
                            this.socket = this.hooks.getSocket(url, this.options);
                        } catch (e) {
                            util.defer(()=>{
                                this.onError(e);
                                this.changeState('closed');
                            });
                            return false;
                        }
                        this.bindListeners();
                        logger.debug('Connecting', {
                            transport: this.name,
                            url: url
                        });
                        this.changeState('connecting');
                        return true;
                    }
                    close() {
                        if (this.socket) {
                            this.socket.close();
                            return true;
                        } else return false;
                    }
                    send(data) {
                        if (this.state === 'open') {
                            util.defer(()=>{
                                if (this.socket) this.socket.send(data);
                            });
                            return true;
                        } else return false;
                    }
                    ping() {
                        if (this.state === 'open' && this.supportsPing()) this.socket.ping();
                    }
                    onOpen() {
                        if (this.hooks.beforeOpen) this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
                        this.changeState('open');
                        this.socket.onopen = undefined;
                    }
                    onError(error) {
                        this.emit('error', {
                            type: 'WebSocketError',
                            error: error
                        });
                        this.timeline.error(this.buildTimelineMessage({
                            error: error.toString()
                        }));
                    }
                    onClose(closeEvent) {
                        if (closeEvent) this.changeState('closed', {
                            code: closeEvent.code,
                            reason: closeEvent.reason,
                            wasClean: closeEvent.wasClean
                        });
                        else this.changeState('closed');
                        this.unbindListeners();
                        this.socket = undefined;
                    }
                    onMessage(message) {
                        this.emit('message', message);
                    }
                    onActivity() {
                        this.emit('activity');
                    }
                    bindListeners() {
                        this.socket.onopen = ()=>{
                            this.onOpen();
                        };
                        this.socket.onerror = (error)=>{
                            this.onError(error);
                        };
                        this.socket.onclose = (closeEvent)=>{
                            this.onClose(closeEvent);
                        };
                        this.socket.onmessage = (message)=>{
                            this.onMessage(message);
                        };
                        if (this.supportsPing()) this.socket.onactivity = ()=>{
                            this.onActivity();
                        };
                    }
                    unbindListeners() {
                        if (this.socket) {
                            this.socket.onopen = undefined;
                            this.socket.onerror = undefined;
                            this.socket.onclose = undefined;
                            this.socket.onmessage = undefined;
                            if (this.supportsPing()) this.socket.onactivity = undefined;
                        }
                    }
                    changeState(state, params) {
                        this.state = state;
                        this.timeline.info(this.buildTimelineMessage({
                            state: state,
                            params: params
                        }));
                        this.emit(state, params);
                    }
                    buildTimelineMessage(message) {
                        return extend({
                            cid: this.id
                        }, message);
                    }
                }
                class Transport {
                    constructor(hooks){
                        this.hooks = hooks;
                    }
                    isSupported(environment) {
                        return this.hooks.isSupported(environment);
                    }
                    createConnection(name, priority, key, options) {
                        return new TransportConnection(this.hooks, name, priority, key, options);
                    }
                }
                var WSTransport = new Transport({
                    urls: ws,
                    handlesActivityChecks: false,
                    supportsPing: false,
                    isInitialized: function() {
                        return Boolean(runtime.getWebSocketAPI());
                    },
                    isSupported: function() {
                        return Boolean(runtime.getWebSocketAPI());
                    },
                    getSocket: function(url) {
                        return runtime.createWebSocket(url);
                    }
                });
                var httpConfiguration = {
                    urls: http,
                    handlesActivityChecks: false,
                    supportsPing: true,
                    isInitialized: function() {
                        return true;
                    }
                };
                var streamingConfiguration = extend({
                    getSocket: function(url) {
                        return runtime.HTTPFactory.createStreamingSocket(url);
                    }
                }, httpConfiguration);
                var pollingConfiguration = extend({
                    getSocket: function(url) {
                        return runtime.HTTPFactory.createPollingSocket(url);
                    }
                }, httpConfiguration);
                var xhrConfiguration = {
                    isSupported: function() {
                        return runtime.isXHRSupported();
                    }
                };
                var XHRStreamingTransport = new Transport(extend({}, streamingConfiguration, xhrConfiguration));
                var XHRPollingTransport = new Transport(extend({}, pollingConfiguration, xhrConfiguration));
                var Transports = {
                    ws: WSTransport,
                    xhr_streaming: XHRStreamingTransport,
                    xhr_polling: XHRPollingTransport
                };
                /* harmony default export */ const transports = Transports;
                var SockJSTransport = new Transport({
                    file: 'sockjs',
                    urls: sockjs,
                    handlesActivityChecks: true,
                    supportsPing: false,
                    isSupported: function() {
                        return true;
                    },
                    isInitialized: function() {
                        return window.SockJS !== undefined;
                    },
                    getSocket: function(url, options) {
                        return new window.SockJS(url, null, {
                            js_path: Dependencies.getPath('sockjs', {
                                useTLS: options.useTLS
                            }),
                            ignore_null_origin: options.ignoreNullOrigin
                        });
                    },
                    beforeOpen: function(socket, path) {
                        socket.send(JSON.stringify({
                            path: path
                        }));
                    }
                });
                var xdrConfiguration = {
                    isSupported: function(environment) {
                        var yes = runtime.isXDRSupported(environment.useTLS);
                        return yes;
                    }
                };
                var XDRStreamingTransport = new Transport(extend({}, streamingConfiguration, xdrConfiguration));
                var XDRPollingTransport = new Transport(extend({}, pollingConfiguration, xdrConfiguration));
                transports.xdr_streaming = XDRStreamingTransport;
                transports.xdr_polling = XDRPollingTransport;
                transports.sockjs = SockJSTransport;
                /* harmony default export */ const transports_transports = transports;
                class NetInfo extends Dispatcher {
                    constructor(){
                        super();
                        var self1 = this;
                        if (window.addEventListener !== undefined) {
                            window.addEventListener('online', function() {
                                self1.emit('online');
                            }, false);
                            window.addEventListener('offline', function() {
                                self1.emit('offline');
                            }, false);
                        }
                    }
                    isOnline() {
                        if (window.navigator.onLine === undefined) return true;
                        else return window.navigator.onLine;
                    }
                }
                var Network = new NetInfo();
                class AssistantToTheTransportManager {
                    constructor(manager, transport, options){
                        this.manager = manager;
                        this.transport = transport;
                        this.minPingDelay = options.minPingDelay;
                        this.maxPingDelay = options.maxPingDelay;
                        this.pingDelay = undefined;
                    }
                    createConnection(name, priority, key, options) {
                        options = extend({}, options, {
                            activityTimeout: this.pingDelay
                        });
                        var connection = this.transport.createConnection(name, priority, key, options);
                        var openTimestamp = null;
                        var onOpen = function() {
                            connection.unbind('open', onOpen);
                            connection.bind('closed', onClosed);
                            openTimestamp = util.now();
                        };
                        var onClosed = (closeEvent)=>{
                            connection.unbind('closed', onClosed);
                            if (closeEvent.code === 1002 || closeEvent.code === 1003) this.manager.reportDeath();
                            else if (!closeEvent.wasClean && openTimestamp) {
                                var lifespan = util.now() - openTimestamp;
                                if (lifespan < 2 * this.maxPingDelay) {
                                    this.manager.reportDeath();
                                    this.pingDelay = Math.max(lifespan / 2, this.minPingDelay);
                                }
                            }
                        };
                        connection.bind('open', onOpen);
                        return connection;
                    }
                    isSupported(environment) {
                        return this.manager.isAlive() && this.transport.isSupported(environment);
                    }
                }
                const Protocol = {
                    decodeMessage: function(messageEvent) {
                        try {
                            var messageData = JSON.parse(messageEvent.data);
                            var pusherEventData = messageData.data;
                            if (typeof pusherEventData === 'string') try {
                                pusherEventData = JSON.parse(messageData.data);
                            } catch (e) {}
                            var pusherEvent = {
                                event: messageData.event,
                                channel: messageData.channel,
                                data: pusherEventData
                            };
                            if (messageData.user_id) pusherEvent.user_id = messageData.user_id;
                            return pusherEvent;
                        } catch (e) {
                            throw {
                                type: 'MessageParseError',
                                error: e,
                                data: messageEvent.data
                            };
                        }
                    },
                    encodeMessage: function(event) {
                        return JSON.stringify(event);
                    },
                    processHandshake: function(messageEvent) {
                        var message = Protocol.decodeMessage(messageEvent);
                        if (message.event === 'pusher:connection_established') {
                            if (!message.data.activity_timeout) throw 'No activity timeout specified in handshake';
                            return {
                                action: 'connected',
                                id: message.data.socket_id,
                                activityTimeout: message.data.activity_timeout * 1000
                            };
                        } else if (message.event === 'pusher:error') return {
                            action: this.getCloseAction(message.data),
                            error: this.getCloseError(message.data)
                        };
                        else throw 'Invalid handshake';
                    },
                    getCloseAction: function(closeEvent) {
                        if (closeEvent.code < 4000) {
                            if (closeEvent.code >= 1002 && closeEvent.code <= 1004) return 'backoff';
                            else return null;
                        } else if (closeEvent.code === 4000) return 'tls_only';
                        else if (closeEvent.code < 4100) return 'refused';
                        else if (closeEvent.code < 4200) return 'backoff';
                        else if (closeEvent.code < 4300) return 'retry';
                        else return 'refused';
                    },
                    getCloseError: function(closeEvent) {
                        if (closeEvent.code !== 1000 && closeEvent.code !== 1001) return {
                            type: 'PusherError',
                            data: {
                                code: closeEvent.code,
                                message: closeEvent.reason || closeEvent.message
                            }
                        };
                        else return null;
                    }
                };
                /* harmony default export */ const protocol = Protocol;
                class Connection extends Dispatcher {
                    constructor(id, transport){
                        super();
                        this.id = id;
                        this.transport = transport;
                        this.activityTimeout = transport.activityTimeout;
                        this.bindListeners();
                    }
                    handlesActivityChecks() {
                        return this.transport.handlesActivityChecks();
                    }
                    send(data) {
                        return this.transport.send(data);
                    }
                    send_event(name, data, channel) {
                        var event = {
                            event: name,
                            data: data
                        };
                        if (channel) event.channel = channel;
                        logger.debug('Event sent', event);
                        return this.send(protocol.encodeMessage(event));
                    }
                    ping() {
                        if (this.transport.supportsPing()) this.transport.ping();
                        else this.send_event('pusher:ping', {});
                    }
                    close() {
                        this.transport.close();
                    }
                    bindListeners() {
                        var listeners = {
                            message: (messageEvent)=>{
                                var pusherEvent;
                                try {
                                    pusherEvent = protocol.decodeMessage(messageEvent);
                                } catch (e) {
                                    this.emit('error', {
                                        type: 'MessageParseError',
                                        error: e,
                                        data: messageEvent.data
                                    });
                                }
                                if (pusherEvent !== undefined) {
                                    logger.debug('Event recd', pusherEvent);
                                    switch(pusherEvent.event){
                                        case 'pusher:error':
                                            this.emit('error', {
                                                type: 'PusherError',
                                                data: pusherEvent.data
                                            });
                                            break;
                                        case 'pusher:ping':
                                            this.emit('ping');
                                            break;
                                        case 'pusher:pong':
                                            this.emit('pong');
                                            break;
                                    }
                                    this.emit('message', pusherEvent);
                                }
                            },
                            activity: ()=>{
                                this.emit('activity');
                            },
                            error: (error)=>{
                                this.emit('error', error);
                            },
                            closed: (closeEvent)=>{
                                unbindListeners();
                                if (closeEvent && closeEvent.code) this.handleCloseEvent(closeEvent);
                                this.transport = null;
                                this.emit('closed');
                            }
                        };
                        var unbindListeners = ()=>{
                            objectApply(listeners, (listener, event)=>{
                                this.transport.unbind(event, listener);
                            });
                        };
                        objectApply(listeners, (listener, event)=>{
                            this.transport.bind(event, listener);
                        });
                    }
                    handleCloseEvent(closeEvent) {
                        var action = protocol.getCloseAction(closeEvent);
                        var error = protocol.getCloseError(closeEvent);
                        if (error) this.emit('error', error);
                        if (action) this.emit(action, {
                            action: action,
                            error: error
                        });
                    }
                }
                class Handshake {
                    constructor(transport, callback){
                        this.transport = transport;
                        this.callback = callback;
                        this.bindListeners();
                    }
                    close() {
                        this.unbindListeners();
                        this.transport.close();
                    }
                    bindListeners() {
                        this.onMessage = (m)=>{
                            this.unbindListeners();
                            var result;
                            try {
                                result = protocol.processHandshake(m);
                            } catch (e) {
                                this.finish('error', {
                                    error: e
                                });
                                this.transport.close();
                                return;
                            }
                            if (result.action === 'connected') this.finish('connected', {
                                connection: new Connection(result.id, this.transport),
                                activityTimeout: result.activityTimeout
                            });
                            else {
                                this.finish(result.action, {
                                    error: result.error
                                });
                                this.transport.close();
                            }
                        };
                        this.onClosed = (closeEvent)=>{
                            this.unbindListeners();
                            var action = protocol.getCloseAction(closeEvent) || 'backoff';
                            var error = protocol.getCloseError(closeEvent);
                            this.finish(action, {
                                error: error
                            });
                        };
                        this.transport.bind('message', this.onMessage);
                        this.transport.bind('closed', this.onClosed);
                    }
                    unbindListeners() {
                        this.transport.unbind('message', this.onMessage);
                        this.transport.unbind('closed', this.onClosed);
                    }
                    finish(action, params) {
                        this.callback(extend({
                            transport: this.transport,
                            action: action
                        }, params));
                    }
                }
                class TimelineSender {
                    constructor(timeline, options){
                        this.timeline = timeline;
                        this.options = options || {};
                    }
                    send(useTLS, callback) {
                        if (this.timeline.isEmpty()) return;
                        this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
                    }
                }
                class Channel extends Dispatcher {
                    constructor(name, pusher){
                        super(function(event, data) {
                            logger.debug('No callbacks on ' + name + ' for ' + event);
                        });
                        this.name = name;
                        this.pusher = pusher;
                        this.subscribed = false;
                        this.subscriptionPending = false;
                        this.subscriptionCancelled = false;
                    }
                    authorize(socketId, callback) {
                        return callback(null, {
                            auth: ''
                        });
                    }
                    trigger(event, data) {
                        if (event.indexOf('client-') !== 0) throw new BadEventName("Event '" + event + "' does not start with 'client-'");
                        if (!this.subscribed) {
                            var suffix = url_store.buildLogSuffix('triggeringClientEvents');
                            logger.warn(`Client event triggered before channel 'subscription_succeeded' event . ${suffix}`);
                        }
                        return this.pusher.send_event(event, data, this.name);
                    }
                    disconnect() {
                        this.subscribed = false;
                        this.subscriptionPending = false;
                    }
                    handleEvent(event) {
                        var eventName = event.event;
                        var data = event.data;
                        if (eventName === 'pusher_internal:subscription_succeeded') this.handleSubscriptionSucceededEvent(event);
                        else if (eventName === 'pusher_internal:subscription_count') this.handleSubscriptionCountEvent(event);
                        else if (eventName.indexOf('pusher_internal:') !== 0) {
                            var metadata = {};
                            this.emit(eventName, data, metadata);
                        }
                    }
                    handleSubscriptionSucceededEvent(event) {
                        this.subscriptionPending = false;
                        this.subscribed = true;
                        if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                        else this.emit('pusher:subscription_succeeded', event.data);
                    }
                    handleSubscriptionCountEvent(event) {
                        if (event.data.subscription_count) this.subscriptionCount = event.data.subscription_count;
                        this.emit('pusher:subscription_count', event.data);
                    }
                    subscribe() {
                        if (this.subscribed) return;
                        this.subscriptionPending = true;
                        this.subscriptionCancelled = false;
                        this.authorize(this.pusher.connection.socket_id, (error, data)=>{
                            if (error) {
                                this.subscriptionPending = false;
                                logger.error(error.toString());
                                this.emit('pusher:subscription_error', Object.assign({}, {
                                    type: 'AuthError',
                                    error: error.message
                                }, error instanceof HTTPAuthError ? {
                                    status: error.status
                                } : {}));
                            } else this.pusher.send_event('pusher:subscribe', {
                                auth: data.auth,
                                channel_data: data.channel_data,
                                channel: this.name
                            });
                        });
                    }
                    unsubscribe() {
                        this.subscribed = false;
                        this.pusher.send_event('pusher:unsubscribe', {
                            channel: this.name
                        });
                    }
                    cancelSubscription() {
                        this.subscriptionCancelled = true;
                    }
                    reinstateSubscription() {
                        this.subscriptionCancelled = false;
                    }
                }
                class PrivateChannel extends Channel {
                    authorize(socketId, callback) {
                        return this.pusher.config.channelAuthorizer({
                            channelName: this.name,
                            socketId: socketId
                        }, callback);
                    }
                }
                class Members {
                    constructor(){
                        this.reset();
                    }
                    get(id) {
                        if (Object.prototype.hasOwnProperty.call(this.members, id)) return {
                            id: id,
                            info: this.members[id]
                        };
                        else return null;
                    }
                    each(callback) {
                        objectApply(this.members, (member, id)=>{
                            callback(this.get(id));
                        });
                    }
                    setMyID(id) {
                        this.myID = id;
                    }
                    onSubscription(subscriptionData) {
                        this.members = subscriptionData.presence.hash;
                        this.count = subscriptionData.presence.count;
                        this.me = this.get(this.myID);
                    }
                    addMember(memberData) {
                        if (this.get(memberData.user_id) === null) this.count++;
                        this.members[memberData.user_id] = memberData.user_info;
                        return this.get(memberData.user_id);
                    }
                    removeMember(memberData) {
                        var member = this.get(memberData.user_id);
                        if (member) {
                            delete this.members[memberData.user_id];
                            this.count--;
                        }
                        return member;
                    }
                    reset() {
                        this.members = {};
                        this.count = 0;
                        this.myID = null;
                        this.me = null;
                    }
                }
                var __awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class PresenceChannel extends PrivateChannel {
                    constructor(name, pusher){
                        super(name, pusher);
                        this.members = new Members();
                    }
                    authorize(socketId, callback) {
                        super.authorize(socketId, (error, authData)=>__awaiter(this, void 0, void 0, function*() {
                                if (!error) {
                                    authData;
                                    if (authData.channel_data != null) {
                                        var channelData = JSON.parse(authData.channel_data);
                                        this.members.setMyID(channelData.user_id);
                                    } else {
                                        yield this.pusher.user.signinDonePromise;
                                        if (this.pusher.user.user_data != null) this.members.setMyID(this.pusher.user.user_data.id);
                                        else {
                                            let suffix = url_store.buildLogSuffix('authorizationEndpoint');
                                            logger.error(`Invalid auth response for channel '${this.name}', ` + `expected 'channel_data' field. ${suffix}, ` + `or the user should be signed in.`);
                                            callback('Invalid auth response');
                                            return;
                                        }
                                    }
                                }
                                callback(error, authData);
                            }));
                    }
                    handleEvent(event) {
                        var eventName = event.event;
                        if (eventName.indexOf('pusher_internal:') === 0) this.handleInternalEvent(event);
                        else {
                            var data = event.data;
                            var metadata = {};
                            if (event.user_id) metadata.user_id = event.user_id;
                            this.emit(eventName, data, metadata);
                        }
                    }
                    handleInternalEvent(event) {
                        var eventName = event.event;
                        var data = event.data;
                        switch(eventName){
                            case 'pusher_internal:subscription_succeeded':
                                this.handleSubscriptionSucceededEvent(event);
                                break;
                            case 'pusher_internal:subscription_count':
                                this.handleSubscriptionCountEvent(event);
                                break;
                            case 'pusher_internal:member_added':
                                var addedMember = this.members.addMember(data);
                                this.emit('pusher:member_added', addedMember);
                                break;
                            case 'pusher_internal:member_removed':
                                var removedMember = this.members.removeMember(data);
                                if (removedMember) this.emit('pusher:member_removed', removedMember);
                                break;
                        }
                    }
                    handleSubscriptionSucceededEvent(event) {
                        this.subscriptionPending = false;
                        this.subscribed = true;
                        if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                        else {
                            this.members.onSubscription(event.data);
                            this.emit('pusher:subscription_succeeded', this.members);
                        }
                    }
                    disconnect() {
                        this.members.reset();
                        super.disconnect();
                    }
                }
                // EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
                var utf8 = __webpack_require__(978);
                // EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
                var base64 = __webpack_require__(594);
                class EncryptedChannel extends PrivateChannel {
                    constructor(name, pusher, nacl){
                        super(name, pusher);
                        this.key = null;
                        this.nacl = nacl;
                    }
                    authorize(socketId, callback) {
                        super.authorize(socketId, (error, authData)=>{
                            if (error) {
                                callback(error, authData);
                                return;
                            }
                            let sharedSecret = authData['shared_secret'];
                            if (!sharedSecret) {
                                callback(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                                return;
                            }
                            this.key = (0, base64.decode)(sharedSecret);
                            delete authData['shared_secret'];
                            callback(null, authData);
                        });
                    }
                    trigger(event, data) {
                        throw new UnsupportedFeature('Client events are not currently supported for encrypted channels');
                    }
                    handleEvent(event) {
                        var eventName = event.event;
                        var data = event.data;
                        if (eventName.indexOf('pusher_internal:') === 0 || eventName.indexOf('pusher:') === 0) {
                            super.handleEvent(event);
                            return;
                        }
                        this.handleEncryptedEvent(eventName, data);
                    }
                    handleEncryptedEvent(event, data) {
                        if (!this.key) {
                            logger.debug('Received encrypted event before key has been retrieved from the authEndpoint');
                            return;
                        }
                        if (!data.ciphertext || !data.nonce) {
                            logger.error('Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: ' + data);
                            return;
                        }
                        let cipherText = (0, base64.decode)(data.ciphertext);
                        if (cipherText.length < this.nacl.secretbox.overheadLength) {
                            logger.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${cipherText.length}`);
                            return;
                        }
                        let nonce = (0, base64.decode)(data.nonce);
                        if (nonce.length < this.nacl.secretbox.nonceLength) {
                            logger.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${nonce.length}`);
                            return;
                        }
                        let bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                        if (bytes === null) {
                            logger.debug('Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...');
                            this.authorize(this.pusher.connection.socket_id, (error, authData)=>{
                                if (error) {
                                    logger.error(`Failed to make a request to the authEndpoint: ${authData}. Unable to fetch new key, so dropping encrypted event`);
                                    return;
                                }
                                bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                                if (bytes === null) {
                                    logger.error(`Failed to decrypt event with new key. Dropping encrypted event`);
                                    return;
                                }
                                this.emit(event, this.getDataToEmit(bytes));
                                return;
                            });
                            return;
                        }
                        this.emit(event, this.getDataToEmit(bytes));
                    }
                    getDataToEmit(bytes) {
                        let raw = (0, utf8 /* decode */ .D4)(bytes);
                        try {
                            return JSON.parse(raw);
                        } catch (_a) {
                            return raw;
                        }
                    }
                }
                class ConnectionManager extends Dispatcher {
                    constructor(key, options){
                        super();
                        this.state = 'initialized';
                        this.connection = null;
                        this.key = key;
                        this.options = options;
                        this.timeline = this.options.timeline;
                        this.usingTLS = this.options.useTLS;
                        this.errorCallbacks = this.buildErrorCallbacks();
                        this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks);
                        this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                        var Network = runtime.getNetwork();
                        Network.bind('online', ()=>{
                            this.timeline.info({
                                netinfo: 'online'
                            });
                            if (this.state === 'connecting' || this.state === 'unavailable') this.retryIn(0);
                        });
                        Network.bind('offline', ()=>{
                            this.timeline.info({
                                netinfo: 'offline'
                            });
                            if (this.connection) this.sendActivityCheck();
                        });
                        this.updateStrategy();
                    }
                    switchCluster(key) {
                        this.key = key;
                        this.updateStrategy();
                        this.retryIn(0);
                    }
                    connect() {
                        if (this.connection || this.runner) return;
                        if (!this.strategy.isSupported()) {
                            this.updateState('failed');
                            return;
                        }
                        this.updateState('connecting');
                        this.startConnecting();
                        this.setUnavailableTimer();
                    }
                    send(data) {
                        if (this.connection) return this.connection.send(data);
                        else return false;
                    }
                    send_event(name, data, channel) {
                        if (this.connection) return this.connection.send_event(name, data, channel);
                        else return false;
                    }
                    disconnect() {
                        this.disconnectInternally();
                        this.updateState('disconnected');
                    }
                    isUsingTLS() {
                        return this.usingTLS;
                    }
                    startConnecting() {
                        var callback = (error, handshake)=>{
                            if (error) this.runner = this.strategy.connect(0, callback);
                            else if (handshake.action === 'error') {
                                this.emit('error', {
                                    type: 'HandshakeError',
                                    error: handshake.error
                                });
                                this.timeline.error({
                                    handshakeError: handshake.error
                                });
                            } else {
                                this.abortConnecting();
                                this.handshakeCallbacks[handshake.action](handshake);
                            }
                        };
                        this.runner = this.strategy.connect(0, callback);
                    }
                    abortConnecting() {
                        if (this.runner) {
                            this.runner.abort();
                            this.runner = null;
                        }
                    }
                    disconnectInternally() {
                        this.abortConnecting();
                        this.clearRetryTimer();
                        this.clearUnavailableTimer();
                        if (this.connection) {
                            var connection = this.abandonConnection();
                            connection.close();
                        }
                    }
                    updateStrategy() {
                        this.strategy = this.options.getStrategy({
                            key: this.key,
                            timeline: this.timeline,
                            useTLS: this.usingTLS
                        });
                    }
                    retryIn(delay) {
                        this.timeline.info({
                            action: 'retry',
                            delay: delay
                        });
                        if (delay > 0) this.emit('connecting_in', Math.round(delay / 1000));
                        this.retryTimer = new OneOffTimer(delay || 0, ()=>{
                            this.disconnectInternally();
                            this.connect();
                        });
                    }
                    clearRetryTimer() {
                        if (this.retryTimer) {
                            this.retryTimer.ensureAborted();
                            this.retryTimer = null;
                        }
                    }
                    setUnavailableTimer() {
                        this.unavailableTimer = new OneOffTimer(this.options.unavailableTimeout, ()=>{
                            this.updateState('unavailable');
                        });
                    }
                    clearUnavailableTimer() {
                        if (this.unavailableTimer) this.unavailableTimer.ensureAborted();
                    }
                    sendActivityCheck() {
                        this.stopActivityCheck();
                        this.connection.ping();
                        this.activityTimer = new OneOffTimer(this.options.pongTimeout, ()=>{
                            this.timeline.error({
                                pong_timed_out: this.options.pongTimeout
                            });
                            this.retryIn(0);
                        });
                    }
                    resetActivityCheck() {
                        this.stopActivityCheck();
                        if (this.connection && !this.connection.handlesActivityChecks()) this.activityTimer = new OneOffTimer(this.activityTimeout, ()=>{
                            this.sendActivityCheck();
                        });
                    }
                    stopActivityCheck() {
                        if (this.activityTimer) this.activityTimer.ensureAborted();
                    }
                    buildConnectionCallbacks(errorCallbacks) {
                        return extend({}, errorCallbacks, {
                            message: (message)=>{
                                this.resetActivityCheck();
                                this.emit('message', message);
                            },
                            ping: ()=>{
                                this.send_event('pusher:pong', {});
                            },
                            activity: ()=>{
                                this.resetActivityCheck();
                            },
                            error: (error)=>{
                                this.emit('error', error);
                            },
                            closed: ()=>{
                                this.abandonConnection();
                                if (this.shouldRetry()) this.retryIn(1000);
                            }
                        });
                    }
                    buildHandshakeCallbacks(errorCallbacks) {
                        return extend({}, errorCallbacks, {
                            connected: (handshake)=>{
                                this.activityTimeout = Math.min(this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                                this.clearUnavailableTimer();
                                this.setConnection(handshake.connection);
                                this.socket_id = this.connection.id;
                                this.updateState('connected', {
                                    socket_id: this.socket_id
                                });
                            }
                        });
                    }
                    buildErrorCallbacks() {
                        let withErrorEmitted = (callback)=>{
                            return (result)=>{
                                if (result.error) this.emit('error', {
                                    type: 'WebSocketError',
                                    error: result.error
                                });
                                callback(result);
                            };
                        };
                        return {
                            tls_only: withErrorEmitted(()=>{
                                this.usingTLS = true;
                                this.updateStrategy();
                                this.retryIn(0);
                            }),
                            refused: withErrorEmitted(()=>{
                                this.disconnect();
                            }),
                            backoff: withErrorEmitted(()=>{
                                this.retryIn(1000);
                            }),
                            retry: withErrorEmitted(()=>{
                                this.retryIn(0);
                            })
                        };
                    }
                    setConnection(connection) {
                        this.connection = connection;
                        for(var event in this.connectionCallbacks)this.connection.bind(event, this.connectionCallbacks[event]);
                        this.resetActivityCheck();
                    }
                    abandonConnection() {
                        if (!this.connection) return;
                        this.stopActivityCheck();
                        for(var event in this.connectionCallbacks)this.connection.unbind(event, this.connectionCallbacks[event]);
                        var connection = this.connection;
                        this.connection = null;
                        return connection;
                    }
                    updateState(newState, data) {
                        var previousState = this.state;
                        this.state = newState;
                        if (previousState !== newState) {
                            var newStateDescription = newState;
                            if (newStateDescription === 'connected') newStateDescription += ' with new socket ID ' + data.socket_id;
                            logger.debug('State changed', previousState + ' -> ' + newStateDescription);
                            this.timeline.info({
                                state: newState,
                                params: data
                            });
                            this.emit('state_change', {
                                previous: previousState,
                                current: newState
                            });
                            this.emit(newState, data);
                        }
                    }
                    shouldRetry() {
                        return this.state === 'connecting' || this.state === 'connected';
                    }
                }
                class Channels {
                    constructor(){
                        this.channels = {};
                    }
                    add(name, pusher) {
                        if (!this.channels[name]) this.channels[name] = createChannel(name, pusher);
                        return this.channels[name];
                    }
                    all() {
                        return values(this.channels);
                    }
                    find(name) {
                        return this.channels[name];
                    }
                    remove(name) {
                        var channel = this.channels[name];
                        delete this.channels[name];
                        return channel;
                    }
                    disconnect() {
                        objectApply(this.channels, function(channel) {
                            channel.disconnect();
                        });
                    }
                }
                function createChannel(name, pusher) {
                    if (name.indexOf('private-encrypted-') === 0) {
                        if (pusher.config.nacl) return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
                        let errMsg = 'Tried to subscribe to a private-encrypted- channel but no nacl implementation available';
                        let suffix = url_store.buildLogSuffix('encryptedChannelSupport');
                        throw new UnsupportedFeature(`${errMsg}. ${suffix}`);
                    } else if (name.indexOf('private-') === 0) return factory.createPrivateChannel(name, pusher);
                    else if (name.indexOf('presence-') === 0) return factory.createPresenceChannel(name, pusher);
                    else if (name.indexOf('#') === 0) throw new BadChannelName('Cannot create a channel with name "' + name + '".');
                    else return factory.createChannel(name, pusher);
                }
                var Factory = {
                    createChannels () {
                        return new Channels();
                    },
                    createConnectionManager (key, options) {
                        return new ConnectionManager(key, options);
                    },
                    createChannel (name, pusher) {
                        return new Channel(name, pusher);
                    },
                    createPrivateChannel (name, pusher) {
                        return new PrivateChannel(name, pusher);
                    },
                    createPresenceChannel (name, pusher) {
                        return new PresenceChannel(name, pusher);
                    },
                    createEncryptedChannel (name, pusher, nacl) {
                        return new EncryptedChannel(name, pusher, nacl);
                    },
                    createTimelineSender (timeline, options) {
                        return new TimelineSender(timeline, options);
                    },
                    createHandshake (transport, callback) {
                        return new Handshake(transport, callback);
                    },
                    createAssistantToTheTransportManager (manager, transport, options) {
                        return new AssistantToTheTransportManager(manager, transport, options);
                    }
                };
                /* harmony default export */ const factory = Factory;
                class TransportManager {
                    constructor(options){
                        this.options = options || {};
                        this.livesLeft = this.options.lives || Infinity;
                    }
                    getAssistant(transport) {
                        return factory.createAssistantToTheTransportManager(this, transport, {
                            minPingDelay: this.options.minPingDelay,
                            maxPingDelay: this.options.maxPingDelay
                        });
                    }
                    isAlive() {
                        return this.livesLeft > 0;
                    }
                    reportDeath() {
                        this.livesLeft -= 1;
                    }
                }
                class SequentialStrategy {
                    constructor(strategies, options){
                        this.strategies = strategies;
                        this.loop = Boolean(options.loop);
                        this.failFast = Boolean(options.failFast);
                        this.timeout = options.timeout;
                        this.timeoutLimit = options.timeoutLimit;
                    }
                    isSupported() {
                        return any(this.strategies, util.method('isSupported'));
                    }
                    connect(minPriority, callback) {
                        var strategies = this.strategies;
                        var current = 0;
                        var timeout = this.timeout;
                        var runner = null;
                        var tryNextStrategy = (error, handshake)=>{
                            if (handshake) callback(null, handshake);
                            else {
                                current = current + 1;
                                if (this.loop) current = current % strategies.length;
                                if (current < strategies.length) {
                                    if (timeout) {
                                        timeout = timeout * 2;
                                        if (this.timeoutLimit) timeout = Math.min(timeout, this.timeoutLimit);
                                    }
                                    runner = this.tryStrategy(strategies[current], minPriority, {
                                        timeout: timeout,
                                        failFast: this.failFast
                                    }, tryNextStrategy);
                                } else callback(true);
                            }
                        };
                        runner = this.tryStrategy(strategies[current], minPriority, {
                            timeout: timeout,
                            failFast: this.failFast
                        }, tryNextStrategy);
                        return {
                            abort: function() {
                                runner.abort();
                            },
                            forceMinPriority: function(p) {
                                minPriority = p;
                                if (runner) runner.forceMinPriority(p);
                            }
                        };
                    }
                    tryStrategy(strategy, minPriority, options, callback) {
                        var timer = null;
                        var runner = null;
                        if (options.timeout > 0) timer = new OneOffTimer(options.timeout, function() {
                            runner.abort();
                            callback(true);
                        });
                        runner = strategy.connect(minPriority, function(error, handshake) {
                            if (error && timer && timer.isRunning() && !options.failFast) return;
                            if (timer) timer.ensureAborted();
                            callback(error, handshake);
                        });
                        return {
                            abort: function() {
                                if (timer) timer.ensureAborted();
                                runner.abort();
                            },
                            forceMinPriority: function(p) {
                                runner.forceMinPriority(p);
                            }
                        };
                    }
                }
                class BestConnectedEverStrategy {
                    constructor(strategies){
                        this.strategies = strategies;
                    }
                    isSupported() {
                        return any(this.strategies, util.method('isSupported'));
                    }
                    connect(minPriority, callback) {
                        return connect(this.strategies, minPriority, function(i, runners) {
                            return function(error, handshake) {
                                runners[i].error = error;
                                if (error) {
                                    if (allRunnersFailed(runners)) callback(true);
                                    return;
                                }
                                apply(runners, function(runner) {
                                    runner.forceMinPriority(handshake.transport.priority);
                                });
                                callback(null, handshake);
                            };
                        });
                    }
                }
                function connect(strategies, minPriority, callbackBuilder) {
                    var runners = map(strategies, function(strategy, i, _, rs) {
                        return strategy.connect(minPriority, callbackBuilder(i, rs));
                    });
                    return {
                        abort: function() {
                            apply(runners, abortRunner);
                        },
                        forceMinPriority: function(p) {
                            apply(runners, function(runner) {
                                runner.forceMinPriority(p);
                            });
                        }
                    };
                }
                function allRunnersFailed(runners) {
                    return collections_all(runners, function(runner) {
                        return Boolean(runner.error);
                    });
                }
                function abortRunner(runner) {
                    if (!runner.error && !runner.aborted) {
                        runner.abort();
                        runner.aborted = true;
                    }
                }
                class WebSocketPrioritizedCachedStrategy {
                    constructor(strategy, transports, options){
                        this.strategy = strategy;
                        this.transports = transports;
                        this.ttl = options.ttl || 1800000;
                        this.usingTLS = options.useTLS;
                        this.timeline = options.timeline;
                    }
                    isSupported() {
                        return this.strategy.isSupported();
                    }
                    connect(minPriority, callback) {
                        var usingTLS = this.usingTLS;
                        var info = fetchTransportCache(usingTLS);
                        var cacheSkipCount = info && info.cacheSkipCount ? info.cacheSkipCount : 0;
                        var strategies = [
                            this.strategy
                        ];
                        if (info && info.timestamp + this.ttl >= util.now()) {
                            var transport = this.transports[info.transport];
                            if (transport) {
                                if ([
                                    'ws',
                                    'wss'
                                ].includes(info.transport) || cacheSkipCount > 3) {
                                    this.timeline.info({
                                        cached: true,
                                        transport: info.transport,
                                        latency: info.latency
                                    });
                                    strategies.push(new SequentialStrategy([
                                        transport
                                    ], {
                                        timeout: info.latency * 2 + 1000,
                                        failFast: true
                                    }));
                                } else cacheSkipCount++;
                            }
                        }
                        var startTimestamp = util.now();
                        var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
                            if (error) {
                                flushTransportCache(usingTLS);
                                if (strategies.length > 0) {
                                    startTimestamp = util.now();
                                    runner = strategies.pop().connect(minPriority, cb);
                                } else callback(error);
                            } else {
                                storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp, cacheSkipCount);
                                callback(null, handshake);
                            }
                        });
                        return {
                            abort: function() {
                                runner.abort();
                            },
                            forceMinPriority: function(p) {
                                minPriority = p;
                                if (runner) runner.forceMinPriority(p);
                            }
                        };
                    }
                }
                function getTransportCacheKey(usingTLS) {
                    return 'pusherTransport' + (usingTLS ? 'TLS' : 'NonTLS');
                }
                function fetchTransportCache(usingTLS) {
                    var storage = runtime.getLocalStorage();
                    if (storage) try {
                        var serializedCache = storage[getTransportCacheKey(usingTLS)];
                        if (serializedCache) return JSON.parse(serializedCache);
                    } catch (e) {
                        flushTransportCache(usingTLS);
                    }
                    return null;
                }
                function storeTransportCache(usingTLS, transport, latency, cacheSkipCount) {
                    var storage = runtime.getLocalStorage();
                    if (storage) try {
                        storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                            timestamp: util.now(),
                            transport: transport,
                            latency: latency,
                            cacheSkipCount: cacheSkipCount
                        });
                    } catch (e) {}
                }
                function flushTransportCache(usingTLS) {
                    var storage = runtime.getLocalStorage();
                    if (storage) try {
                        delete storage[getTransportCacheKey(usingTLS)];
                    } catch (e) {}
                }
                class DelayedStrategy {
                    constructor(strategy, { delay: number }){
                        this.strategy = strategy;
                        this.options = {
                            delay: number
                        };
                    }
                    isSupported() {
                        return this.strategy.isSupported();
                    }
                    connect(minPriority, callback) {
                        var strategy = this.strategy;
                        var runner;
                        var timer = new OneOffTimer(this.options.delay, function() {
                            runner = strategy.connect(minPriority, callback);
                        });
                        return {
                            abort: function() {
                                timer.ensureAborted();
                                if (runner) runner.abort();
                            },
                            forceMinPriority: function(p) {
                                minPriority = p;
                                if (runner) runner.forceMinPriority(p);
                            }
                        };
                    }
                }
                class IfStrategy {
                    constructor(test, trueBranch, falseBranch){
                        this.test = test;
                        this.trueBranch = trueBranch;
                        this.falseBranch = falseBranch;
                    }
                    isSupported() {
                        var branch = this.test() ? this.trueBranch : this.falseBranch;
                        return branch.isSupported();
                    }
                    connect(minPriority, callback) {
                        var branch = this.test() ? this.trueBranch : this.falseBranch;
                        return branch.connect(minPriority, callback);
                    }
                }
                class FirstConnectedStrategy {
                    constructor(strategy){
                        this.strategy = strategy;
                    }
                    isSupported() {
                        return this.strategy.isSupported();
                    }
                    connect(minPriority, callback) {
                        var runner = this.strategy.connect(minPriority, function(error, handshake) {
                            if (handshake) runner.abort();
                            callback(error, handshake);
                        });
                        return runner;
                    }
                }
                function testSupportsStrategy(strategy) {
                    return function() {
                        return strategy.isSupported();
                    };
                }
                var getDefaultStrategy = function(config, baseOptions, defineTransport) {
                    var definedTransports = {};
                    function defineTransportStrategy(name, type, priority, options, manager) {
                        var transport = defineTransport(config, name, type, priority, options, manager);
                        definedTransports[name] = transport;
                        return transport;
                    }
                    var ws_options = Object.assign({}, baseOptions, {
                        hostNonTLS: config.wsHost + ':' + config.wsPort,
                        hostTLS: config.wsHost + ':' + config.wssPort,
                        httpPath: config.wsPath
                    });
                    var wss_options = Object.assign({}, ws_options, {
                        useTLS: true
                    });
                    var sockjs_options = Object.assign({}, baseOptions, {
                        hostNonTLS: config.httpHost + ':' + config.httpPort,
                        hostTLS: config.httpHost + ':' + config.httpsPort,
                        httpPath: config.httpPath
                    });
                    var timeouts = {
                        loop: true,
                        timeout: 15000,
                        timeoutLimit: 60000
                    };
                    var ws_manager = new TransportManager({
                        minPingDelay: 10000,
                        maxPingDelay: config.activityTimeout
                    });
                    var streaming_manager = new TransportManager({
                        lives: 2,
                        minPingDelay: 10000,
                        maxPingDelay: config.activityTimeout
                    });
                    var ws_transport = defineTransportStrategy('ws', 'ws', 3, ws_options, ws_manager);
                    var wss_transport = defineTransportStrategy('wss', 'ws', 3, wss_options, ws_manager);
                    var sockjs_transport = defineTransportStrategy('sockjs', 'sockjs', 1, sockjs_options);
                    var xhr_streaming_transport = defineTransportStrategy('xhr_streaming', 'xhr_streaming', 1, sockjs_options, streaming_manager);
                    var xdr_streaming_transport = defineTransportStrategy('xdr_streaming', 'xdr_streaming', 1, sockjs_options, streaming_manager);
                    var xhr_polling_transport = defineTransportStrategy('xhr_polling', 'xhr_polling', 1, sockjs_options);
                    var xdr_polling_transport = defineTransportStrategy('xdr_polling', 'xdr_polling', 1, sockjs_options);
                    var ws_loop = new SequentialStrategy([
                        ws_transport
                    ], timeouts);
                    var wss_loop = new SequentialStrategy([
                        wss_transport
                    ], timeouts);
                    var sockjs_loop = new SequentialStrategy([
                        sockjs_transport
                    ], timeouts);
                    var streaming_loop = new SequentialStrategy([
                        new IfStrategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
                    ], timeouts);
                    var polling_loop = new SequentialStrategy([
                        new IfStrategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
                    ], timeouts);
                    var http_loop = new SequentialStrategy([
                        new IfStrategy(testSupportsStrategy(streaming_loop), new BestConnectedEverStrategy([
                            streaming_loop,
                            new DelayedStrategy(polling_loop, {
                                delay: 4000
                            })
                        ]), polling_loop)
                    ], timeouts);
                    var http_fallback_loop = new IfStrategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
                    var wsStrategy;
                    if (baseOptions.useTLS) wsStrategy = new BestConnectedEverStrategy([
                        ws_loop,
                        new DelayedStrategy(http_fallback_loop, {
                            delay: 2000
                        })
                    ]);
                    else wsStrategy = new BestConnectedEverStrategy([
                        ws_loop,
                        new DelayedStrategy(wss_loop, {
                            delay: 2000
                        }),
                        new DelayedStrategy(http_fallback_loop, {
                            delay: 5000
                        })
                    ]);
                    return new WebSocketPrioritizedCachedStrategy(new FirstConnectedStrategy(new IfStrategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
                        ttl: 1800000,
                        timeline: baseOptions.timeline,
                        useTLS: baseOptions.useTLS
                    });
                };
                /* harmony default export */ const default_strategy = getDefaultStrategy;
                /* harmony default export */ function transport_connection_initializer() {
                    var self1 = this;
                    self1.timeline.info(self1.buildTimelineMessage({
                        transport: self1.name + (self1.options.useTLS ? 's' : '')
                    }));
                    if (self1.hooks.isInitialized()) self1.changeState('initialized');
                    else if (self1.hooks.file) {
                        self1.changeState('initializing');
                        Dependencies.load(self1.hooks.file, {
                            useTLS: self1.options.useTLS
                        }, function(error, callback) {
                            if (self1.hooks.isInitialized()) {
                                self1.changeState('initialized');
                                callback(true);
                            } else {
                                if (error) self1.onError(error);
                                self1.onClose();
                                callback(false);
                            }
                        });
                    } else self1.onClose();
                }
                var hooks = {
                    getRequest: function(socket) {
                        var xdr = new window.XDomainRequest();
                        xdr.ontimeout = function() {
                            socket.emit('error', new RequestTimedOut());
                            socket.close();
                        };
                        xdr.onerror = function(e) {
                            socket.emit('error', e);
                            socket.close();
                        };
                        xdr.onprogress = function() {
                            if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                        };
                        xdr.onload = function() {
                            if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                            socket.emit('finished', 200);
                            socket.close();
                        };
                        return xdr;
                    },
                    abortRequest: function(xdr) {
                        xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
                        xdr.abort();
                    }
                };
                /* harmony default export */ const http_xdomain_request = hooks;
                const MAX_BUFFER_LENGTH = 262144;
                class HTTPRequest extends Dispatcher {
                    constructor(hooks, method, url){
                        super();
                        this.hooks = hooks;
                        this.method = method;
                        this.url = url;
                    }
                    start(payload) {
                        this.position = 0;
                        this.xhr = this.hooks.getRequest(this);
                        this.unloader = ()=>{
                            this.close();
                        };
                        runtime.addUnloadListener(this.unloader);
                        this.xhr.open(this.method, this.url, true);
                        if (this.xhr.setRequestHeader) this.xhr.setRequestHeader('Content-Type', 'application/json');
                        this.xhr.send(payload);
                    }
                    close() {
                        if (this.unloader) {
                            runtime.removeUnloadListener(this.unloader);
                            this.unloader = null;
                        }
                        if (this.xhr) {
                            this.hooks.abortRequest(this.xhr);
                            this.xhr = null;
                        }
                    }
                    onChunk(status, data) {
                        while(true){
                            var chunk = this.advanceBuffer(data);
                            if (chunk) this.emit('chunk', {
                                status: status,
                                data: chunk
                            });
                            else break;
                        }
                        if (this.isBufferTooLong(data)) this.emit('buffer_too_long');
                    }
                    advanceBuffer(buffer) {
                        var unreadData = buffer.slice(this.position);
                        var endOfLinePosition = unreadData.indexOf('\n');
                        if (endOfLinePosition !== -1) {
                            this.position += endOfLinePosition + 1;
                            return unreadData.slice(0, endOfLinePosition);
                        } else return null;
                    }
                    isBufferTooLong(buffer) {
                        return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
                    }
                }
                var State;
                (function(State) {
                    State[State["CONNECTING"] = 0] = "CONNECTING";
                    State[State["OPEN"] = 1] = "OPEN";
                    State[State["CLOSED"] = 3] = "CLOSED";
                })(State || (State = {}));
                /* harmony default export */ const state = State;
                var autoIncrement = 1;
                class HTTPSocket {
                    constructor(hooks, url){
                        this.hooks = hooks;
                        this.session = randomNumber(1000) + '/' + randomString(8);
                        this.location = getLocation(url);
                        this.readyState = state.CONNECTING;
                        this.openStream();
                    }
                    send(payload) {
                        return this.sendRaw(JSON.stringify([
                            payload
                        ]));
                    }
                    ping() {
                        this.hooks.sendHeartbeat(this);
                    }
                    close(code, reason) {
                        this.onClose(code, reason, true);
                    }
                    sendRaw(payload) {
                        if (this.readyState === state.OPEN) try {
                            runtime.createSocketRequest('POST', getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                            return true;
                        } catch (e) {
                            return false;
                        }
                        else return false;
                    }
                    reconnect() {
                        this.closeStream();
                        this.openStream();
                    }
                    onClose(code, reason, wasClean) {
                        this.closeStream();
                        this.readyState = state.CLOSED;
                        if (this.onclose) this.onclose({
                            code: code,
                            reason: reason,
                            wasClean: wasClean
                        });
                    }
                    onChunk(chunk) {
                        if (chunk.status !== 200) return;
                        if (this.readyState === state.OPEN) this.onActivity();
                        var payload;
                        var type = chunk.data.slice(0, 1);
                        switch(type){
                            case 'o':
                                payload = JSON.parse(chunk.data.slice(1) || '{}');
                                this.onOpen(payload);
                                break;
                            case 'a':
                                payload = JSON.parse(chunk.data.slice(1) || '[]');
                                for(var i = 0; i < payload.length; i++)this.onEvent(payload[i]);
                                break;
                            case 'm':
                                payload = JSON.parse(chunk.data.slice(1) || 'null');
                                this.onEvent(payload);
                                break;
                            case 'h':
                                this.hooks.onHeartbeat(this);
                                break;
                            case 'c':
                                payload = JSON.parse(chunk.data.slice(1) || '[]');
                                this.onClose(payload[0], payload[1], true);
                                break;
                        }
                    }
                    onOpen(options) {
                        if (this.readyState === state.CONNECTING) {
                            if (options && options.hostname) this.location.base = replaceHost(this.location.base, options.hostname);
                            this.readyState = state.OPEN;
                            if (this.onopen) this.onopen();
                        } else this.onClose(1006, 'Server lost session', true);
                    }
                    onEvent(event) {
                        if (this.readyState === state.OPEN && this.onmessage) this.onmessage({
                            data: event
                        });
                    }
                    onActivity() {
                        if (this.onactivity) this.onactivity();
                    }
                    onError(error) {
                        if (this.onerror) this.onerror(error);
                    }
                    openStream() {
                        this.stream = runtime.createSocketRequest('POST', getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
                        this.stream.bind('chunk', (chunk)=>{
                            this.onChunk(chunk);
                        });
                        this.stream.bind('finished', (status)=>{
                            this.hooks.onFinished(this, status);
                        });
                        this.stream.bind('buffer_too_long', ()=>{
                            this.reconnect();
                        });
                        try {
                            this.stream.start();
                        } catch (error) {
                            util.defer(()=>{
                                this.onError(error);
                                this.onClose(1006, 'Could not start streaming', false);
                            });
                        }
                    }
                    closeStream() {
                        if (this.stream) {
                            this.stream.unbind_all();
                            this.stream.close();
                            this.stream = null;
                        }
                    }
                }
                function getLocation(url) {
                    var parts = /([^\?]*)\/*(\??.*)/.exec(url);
                    return {
                        base: parts[1],
                        queryString: parts[2]
                    };
                }
                function getSendURL(url, session) {
                    return url.base + '/' + session + '/xhr_send';
                }
                function getUniqueURL(url) {
                    var separator = url.indexOf('?') === -1 ? '?' : '&';
                    return url + separator + 't=' + +new Date() + '&n=' + autoIncrement++;
                }
                function replaceHost(url, hostname) {
                    var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
                    return urlParts[1] + hostname + urlParts[3];
                }
                function randomNumber(max) {
                    return runtime.randomInt(max);
                }
                function randomString(length) {
                    var result = [];
                    for(var i = 0; i < length; i++)result.push(randomNumber(32).toString(32));
                    return result.join('');
                }
                /* harmony default export */ const http_socket = HTTPSocket;
                var http_streaming_socket_hooks = {
                    getReceiveURL: function(url, session) {
                        return url.base + '/' + session + '/xhr_streaming' + url.queryString;
                    },
                    onHeartbeat: function(socket) {
                        socket.sendRaw('[]');
                    },
                    sendHeartbeat: function(socket) {
                        socket.sendRaw('[]');
                    },
                    onFinished: function(socket, status) {
                        socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
                    }
                };
                /* harmony default export */ const http_streaming_socket = http_streaming_socket_hooks;
                var http_polling_socket_hooks = {
                    getReceiveURL: function(url, session) {
                        return url.base + '/' + session + '/xhr' + url.queryString;
                    },
                    onHeartbeat: function() {},
                    sendHeartbeat: function(socket) {
                        socket.sendRaw('[]');
                    },
                    onFinished: function(socket, status) {
                        if (status === 200) socket.reconnect();
                        else socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
                    }
                };
                /* harmony default export */ const http_polling_socket = http_polling_socket_hooks;
                var http_xhr_request_hooks = {
                    getRequest: function(socket) {
                        var Constructor = runtime.getXHRAPI();
                        var xhr = new Constructor();
                        xhr.onreadystatechange = xhr.onprogress = function() {
                            switch(xhr.readyState){
                                case 3:
                                    if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                    break;
                                case 4:
                                    if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                    socket.emit('finished', xhr.status);
                                    socket.close();
                                    break;
                            }
                        };
                        return xhr;
                    },
                    abortRequest: function(xhr) {
                        xhr.onreadystatechange = null;
                        xhr.abort();
                    }
                };
                /* harmony default export */ const http_xhr_request = http_xhr_request_hooks;
                var HTTP = {
                    createStreamingSocket (url) {
                        return this.createSocket(http_streaming_socket, url);
                    },
                    createPollingSocket (url) {
                        return this.createSocket(http_polling_socket, url);
                    },
                    createSocket (hooks, url) {
                        return new http_socket(hooks, url);
                    },
                    createXHR (method, url) {
                        return this.createRequest(http_xhr_request, method, url);
                    },
                    createRequest (hooks, method, url) {
                        return new HTTPRequest(hooks, method, url);
                    }
                };
                /* harmony default export */ const http_http = HTTP;
                http_http.createXDR = function(method, url) {
                    return this.createRequest(http_xdomain_request, method, url);
                };
                /* harmony default export */ const web_http_http = http_http;
                var Runtime = {
                    nextAuthCallbackID: 1,
                    auth_callbacks: {},
                    ScriptReceivers: ScriptReceivers,
                    DependenciesReceivers: DependenciesReceivers,
                    getDefaultStrategy: default_strategy,
                    Transports: transports_transports,
                    transportConnectionInitializer: transport_connection_initializer,
                    HTTPFactory: web_http_http,
                    TimelineTransport: jsonp_timeline,
                    getXHRAPI () {
                        return window.XMLHttpRequest;
                    },
                    getWebSocketAPI () {
                        return window.WebSocket || window.MozWebSocket;
                    },
                    setup (PusherClass) {
                        window.Pusher = PusherClass;
                        var initializeOnDocumentBody = ()=>{
                            this.onDocumentBody(PusherClass.ready);
                        };
                        if (!window.JSON) Dependencies.load('json2', {}, initializeOnDocumentBody);
                        else initializeOnDocumentBody();
                    },
                    getDocument () {
                        return document;
                    },
                    getProtocol () {
                        return this.getDocument().location.protocol;
                    },
                    getAuthorizers () {
                        return {
                            ajax: xhr_auth,
                            jsonp: jsonp_auth
                        };
                    },
                    onDocumentBody (callback) {
                        if (document.body) callback();
                        else setTimeout(()=>{
                            this.onDocumentBody(callback);
                        }, 0);
                    },
                    createJSONPRequest (url, data) {
                        return new JSONPRequest(url, data);
                    },
                    createScriptRequest (src) {
                        return new ScriptRequest(src);
                    },
                    getLocalStorage () {
                        try {
                            return window.localStorage;
                        } catch (e) {
                            return undefined;
                        }
                    },
                    createXHR () {
                        if (this.getXHRAPI()) return this.createXMLHttpRequest();
                        else return this.createMicrosoftXHR();
                    },
                    createXMLHttpRequest () {
                        var Constructor = this.getXHRAPI();
                        return new Constructor();
                    },
                    createMicrosoftXHR () {
                        return new ActiveXObject('Microsoft.XMLHTTP');
                    },
                    getNetwork () {
                        return Network;
                    },
                    createWebSocket (url) {
                        var Constructor = this.getWebSocketAPI();
                        return new Constructor(url);
                    },
                    createSocketRequest (method, url) {
                        if (this.isXHRSupported()) return this.HTTPFactory.createXHR(method, url);
                        else if (this.isXDRSupported(url.indexOf('https:') === 0)) return this.HTTPFactory.createXDR(method, url);
                        else throw 'Cross-origin HTTP requests are not supported';
                    },
                    isXHRSupported () {
                        var Constructor = this.getXHRAPI();
                        return Boolean(Constructor) && new Constructor().withCredentials !== undefined;
                    },
                    isXDRSupported (useTLS) {
                        var protocol = useTLS ? 'https:' : 'http:';
                        var documentProtocol = this.getProtocol();
                        return Boolean(window['XDomainRequest']) && documentProtocol === protocol;
                    },
                    addUnloadListener (listener) {
                        if (window.addEventListener !== undefined) window.addEventListener('unload', listener, false);
                        else if (window.attachEvent !== undefined) window.attachEvent('onunload', listener);
                    },
                    removeUnloadListener (listener) {
                        if (window.addEventListener !== undefined) window.removeEventListener('unload', listener, false);
                        else if (window.detachEvent !== undefined) window.detachEvent('onunload', listener);
                    },
                    randomInt (max) {
                        const random = function() {
                            const crypto = window.crypto || window['msCrypto'];
                            const random = crypto.getRandomValues(new Uint32Array(1))[0];
                            return random / Math.pow(2, 32);
                        };
                        return Math.floor(random() * max);
                    }
                };
                /* harmony default export */ const runtime = Runtime;
                var TimelineLevel;
                (function(TimelineLevel) {
                    TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
                    TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
                    TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
                })(TimelineLevel || (TimelineLevel = {}));
                /* harmony default export */ const level = TimelineLevel;
                class Timeline {
                    constructor(key, session, options){
                        this.key = key;
                        this.session = session;
                        this.events = [];
                        this.options = options || {};
                        this.sent = 0;
                        this.uniqueID = 0;
                    }
                    log(level, event) {
                        if (level <= this.options.level) {
                            this.events.push(extend({}, event, {
                                timestamp: util.now()
                            }));
                            if (this.options.limit && this.events.length > this.options.limit) this.events.shift();
                        }
                    }
                    error(event) {
                        this.log(level.ERROR, event);
                    }
                    info(event) {
                        this.log(level.INFO, event);
                    }
                    debug(event) {
                        this.log(level.DEBUG, event);
                    }
                    isEmpty() {
                        return this.events.length === 0;
                    }
                    send(sendfn, callback) {
                        var data = extend({
                            session: this.session,
                            bundle: this.sent + 1,
                            key: this.key,
                            lib: 'js',
                            version: this.options.version,
                            cluster: this.options.cluster,
                            features: this.options.features,
                            timeline: this.events
                        }, this.options.params);
                        this.events = [];
                        sendfn(data, (error, result)=>{
                            if (!error) this.sent++;
                            if (callback) callback(error, result);
                        });
                        return true;
                    }
                    generateUniqueID() {
                        this.uniqueID++;
                        return this.uniqueID;
                    }
                }
                class TransportStrategy {
                    constructor(name, priority, transport, options){
                        this.name = name;
                        this.priority = priority;
                        this.transport = transport;
                        this.options = options || {};
                    }
                    isSupported() {
                        return this.transport.isSupported({
                            useTLS: this.options.useTLS
                        });
                    }
                    connect(minPriority, callback) {
                        if (!this.isSupported()) return failAttempt(new UnsupportedStrategy(), callback);
                        else if (this.priority < minPriority) return failAttempt(new TransportPriorityTooLow(), callback);
                        var connected = false;
                        var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
                        var handshake = null;
                        var onInitialized = function() {
                            transport.unbind('initialized', onInitialized);
                            transport.connect();
                        };
                        var onOpen = function() {
                            handshake = factory.createHandshake(transport, function(result) {
                                connected = true;
                                unbindListeners();
                                callback(null, result);
                            });
                        };
                        var onError = function(error) {
                            unbindListeners();
                            callback(error);
                        };
                        var onClosed = function() {
                            unbindListeners();
                            var serializedTransport;
                            serializedTransport = safeJSONStringify(transport);
                            callback(new TransportClosed(serializedTransport));
                        };
                        var unbindListeners = function() {
                            transport.unbind('initialized', onInitialized);
                            transport.unbind('open', onOpen);
                            transport.unbind('error', onError);
                            transport.unbind('closed', onClosed);
                        };
                        transport.bind('initialized', onInitialized);
                        transport.bind('open', onOpen);
                        transport.bind('error', onError);
                        transport.bind('closed', onClosed);
                        transport.initialize();
                        return {
                            abort: ()=>{
                                if (connected) return;
                                unbindListeners();
                                if (handshake) handshake.close();
                                else transport.close();
                            },
                            forceMinPriority: (p)=>{
                                if (connected) return;
                                if (this.priority < p) {
                                    if (handshake) handshake.close();
                                    else transport.close();
                                }
                            }
                        };
                    }
                }
                function failAttempt(error, callback) {
                    util.defer(function() {
                        callback(error);
                    });
                    return {
                        abort: function() {},
                        forceMinPriority: function() {}
                    };
                }
                const { Transports: strategy_builder_Transports } = runtime;
                var defineTransport = function(config, name, type, priority, options, manager) {
                    var transportClass = strategy_builder_Transports[type];
                    if (!transportClass) throw new UnsupportedTransport(type);
                    var enabled = (!config.enabledTransports || arrayIndexOf(config.enabledTransports, name) !== -1) && (!config.disabledTransports || arrayIndexOf(config.disabledTransports, name) === -1);
                    var transport;
                    if (enabled) {
                        options = Object.assign({
                            ignoreNullOrigin: config.ignoreNullOrigin
                        }, options);
                        transport = new TransportStrategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
                    } else transport = strategy_builder_UnsupportedStrategy;
                    return transport;
                };
                var strategy_builder_UnsupportedStrategy = {
                    isSupported: function() {
                        return false;
                    },
                    connect: function(_, callback) {
                        var deferred = util.defer(function() {
                            callback(new UnsupportedStrategy());
                        });
                        return {
                            abort: function() {
                                deferred.ensureAborted();
                            },
                            forceMinPriority: function() {}
                        };
                    }
                };
                function validateOptions(options) {
                    if (options == null) throw 'You must pass an options object';
                    if (options.cluster == null) throw 'Options object must provide a cluster';
                    if ('disableStats' in options) logger.warn('The disableStats option is deprecated in favor of enableStats');
                }
                const composeChannelQuery = (params, authOptions)=>{
                    var query = 'socket_id=' + encodeURIComponent(params.socketId);
                    for(var key in authOptions.params)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(authOptions.params[key]);
                    if (authOptions.paramsProvider != null) {
                        let dynamicParams = authOptions.paramsProvider();
                        for(var key in dynamicParams)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(dynamicParams[key]);
                    }
                    return query;
                };
                const UserAuthenticator = (authOptions)=>{
                    if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') throw `'${authOptions.transport}' is not a recognized auth transport`;
                    return (params, callback)=>{
                        const query = composeChannelQuery(params, authOptions);
                        runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
                    };
                };
                /* harmony default export */ const user_authenticator = UserAuthenticator;
                const channel_authorizer_composeChannelQuery = (params, authOptions)=>{
                    var query = 'socket_id=' + encodeURIComponent(params.socketId);
                    query += '&channel_name=' + encodeURIComponent(params.channelName);
                    for(var key in authOptions.params)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(authOptions.params[key]);
                    if (authOptions.paramsProvider != null) {
                        let dynamicParams = authOptions.paramsProvider();
                        for(var key in dynamicParams)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(dynamicParams[key]);
                    }
                    return query;
                };
                const ChannelAuthorizer = (authOptions)=>{
                    if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') throw `'${authOptions.transport}' is not a recognized auth transport`;
                    return (params, callback)=>{
                        const query = channel_authorizer_composeChannelQuery(params, authOptions);
                        runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
                    };
                };
                /* harmony default export */ const channel_authorizer = ChannelAuthorizer;
                const ChannelAuthorizerProxy = (pusher, authOptions, channelAuthorizerGenerator)=>{
                    const deprecatedAuthorizerOptions = {
                        authTransport: authOptions.transport,
                        authEndpoint: authOptions.endpoint,
                        auth: {
                            params: authOptions.params,
                            headers: authOptions.headers
                        }
                    };
                    return (params, callback)=>{
                        const channel = pusher.channel(params.channelName);
                        const channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
                        channelAuthorizer.authorize(params.socketId, callback);
                    };
                };
                function getConfig(opts, pusher) {
                    let config = {
                        activityTimeout: opts.activityTimeout || defaults.activityTimeout,
                        cluster: opts.cluster,
                        httpPath: opts.httpPath || defaults.httpPath,
                        httpPort: opts.httpPort || defaults.httpPort,
                        httpsPort: opts.httpsPort || defaults.httpsPort,
                        pongTimeout: opts.pongTimeout || defaults.pongTimeout,
                        statsHost: opts.statsHost || defaults.stats_host,
                        unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
                        wsPath: opts.wsPath || defaults.wsPath,
                        wsPort: opts.wsPort || defaults.wsPort,
                        wssPort: opts.wssPort || defaults.wssPort,
                        enableStats: getEnableStatsConfig(opts),
                        httpHost: getHttpHost(opts),
                        useTLS: shouldUseTLS(opts),
                        wsHost: getWebsocketHost(opts),
                        userAuthenticator: buildUserAuthenticator(opts),
                        channelAuthorizer: buildChannelAuthorizer(opts, pusher)
                    };
                    if ('disabledTransports' in opts) config.disabledTransports = opts.disabledTransports;
                    if ('enabledTransports' in opts) config.enabledTransports = opts.enabledTransports;
                    if ('ignoreNullOrigin' in opts) config.ignoreNullOrigin = opts.ignoreNullOrigin;
                    if ('timelineParams' in opts) config.timelineParams = opts.timelineParams;
                    if ('nacl' in opts) config.nacl = opts.nacl;
                    return config;
                }
                function getHttpHost(opts) {
                    if (opts.httpHost) return opts.httpHost;
                    if (opts.cluster) return `sockjs-${opts.cluster}.pusher.com`;
                    return defaults.httpHost;
                }
                function getWebsocketHost(opts) {
                    if (opts.wsHost) return opts.wsHost;
                    return getWebsocketHostFromCluster(opts.cluster);
                }
                function getWebsocketHostFromCluster(cluster) {
                    return `ws-${cluster}.pusher.com`;
                }
                function shouldUseTLS(opts) {
                    if (runtime.getProtocol() === 'https:') return true;
                    else if (opts.forceTLS === false) return false;
                    return true;
                }
                function getEnableStatsConfig(opts) {
                    if ('enableStats' in opts) return opts.enableStats;
                    if ('disableStats' in opts) return !opts.disableStats;
                    return false;
                }
                const hasCustomHandler = (auth)=>{
                    return 'customHandler' in auth && auth['customHandler'] != null;
                };
                function buildUserAuthenticator(opts) {
                    const userAuthentication = Object.assign(Object.assign({}, defaults.userAuthentication), opts.userAuthentication);
                    if (hasCustomHandler(userAuthentication)) return userAuthentication['customHandler'];
                    return user_authenticator(userAuthentication);
                }
                function buildChannelAuth(opts, pusher) {
                    let channelAuthorization;
                    if ('channelAuthorization' in opts) channelAuthorization = Object.assign(Object.assign({}, defaults.channelAuthorization), opts.channelAuthorization);
                    else {
                        channelAuthorization = {
                            transport: opts.authTransport || defaults.authTransport,
                            endpoint: opts.authEndpoint || defaults.authEndpoint
                        };
                        if ('auth' in opts) {
                            if ('params' in opts.auth) channelAuthorization.params = opts.auth.params;
                            if ('headers' in opts.auth) channelAuthorization.headers = opts.auth.headers;
                        }
                        if ('authorizer' in opts) return {
                            customHandler: ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer)
                        };
                    }
                    return channelAuthorization;
                }
                function buildChannelAuthorizer(opts, pusher) {
                    const channelAuthorization = buildChannelAuth(opts, pusher);
                    if (hasCustomHandler(channelAuthorization)) return channelAuthorization['customHandler'];
                    return channel_authorizer(channelAuthorization);
                }
                class WatchlistFacade extends Dispatcher {
                    constructor(pusher){
                        super(function(eventName, data) {
                            logger.debug(`No callbacks on watchlist events for ${eventName}`);
                        });
                        this.pusher = pusher;
                        this.bindWatchlistInternalEvent();
                    }
                    handleEvent(pusherEvent) {
                        pusherEvent.data.events.forEach((watchlistEvent)=>{
                            this.emit(watchlistEvent.name, watchlistEvent);
                        });
                    }
                    bindWatchlistInternalEvent() {
                        this.pusher.connection.bind('message', (pusherEvent)=>{
                            var eventName = pusherEvent.event;
                            if (eventName === 'pusher_internal:watchlist_events') this.handleEvent(pusherEvent);
                        });
                    }
                }
                function flatPromise() {
                    let resolve, reject;
                    const promise = new Promise((res, rej)=>{
                        resolve = res;
                        reject = rej;
                    });
                    return {
                        promise: promise,
                        resolve: resolve,
                        reject: reject
                    };
                }
                /* harmony default export */ const flat_promise = flatPromise;
                class UserFacade extends Dispatcher {
                    constructor(pusher){
                        super(function(eventName, data) {
                            logger.debug('No callbacks on user for ' + eventName);
                        });
                        this.signin_requested = false;
                        this.user_data = null;
                        this.serverToUserChannel = null;
                        this.signinDonePromise = null;
                        this._signinDoneResolve = null;
                        this._onAuthorize = (err, authData)=>{
                            if (err) {
                                logger.warn(`Error during signin: ${err}`);
                                this._cleanup();
                                return;
                            }
                            this.pusher.send_event('pusher:signin', {
                                auth: authData.auth,
                                user_data: authData.user_data
                            });
                        };
                        this.pusher = pusher;
                        this.pusher.connection.bind('state_change', ({ previous: previous, current: current })=>{
                            if (previous !== 'connected' && current === 'connected') this._signin();
                            if (previous === 'connected' && current !== 'connected') {
                                this._cleanup();
                                this._newSigninPromiseIfNeeded();
                            }
                        });
                        this.watchlist = new WatchlistFacade(pusher);
                        this.pusher.connection.bind('message', (event)=>{
                            var eventName = event.event;
                            if (eventName === 'pusher:signin_success') this._onSigninSuccess(event.data);
                            if (this.serverToUserChannel && this.serverToUserChannel.name === event.channel) this.serverToUserChannel.handleEvent(event);
                        });
                    }
                    signin() {
                        if (this.signin_requested) return;
                        this.signin_requested = true;
                        this._signin();
                    }
                    _signin() {
                        if (!this.signin_requested) return;
                        this._newSigninPromiseIfNeeded();
                        if (this.pusher.connection.state !== 'connected') return;
                        this.pusher.config.userAuthenticator({
                            socketId: this.pusher.connection.socket_id
                        }, this._onAuthorize);
                    }
                    _onSigninSuccess(data) {
                        try {
                            this.user_data = JSON.parse(data.user_data);
                        } catch (e) {
                            logger.error(`Failed parsing user data after signin: ${data.user_data}`);
                            this._cleanup();
                            return;
                        }
                        if (typeof this.user_data.id !== 'string' || this.user_data.id === '') {
                            logger.error(`user_data doesn't contain an id. user_data: ${this.user_data}`);
                            this._cleanup();
                            return;
                        }
                        this._signinDoneResolve();
                        this._subscribeChannels();
                    }
                    _subscribeChannels() {
                        const ensure_subscribed = (channel)=>{
                            if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                            else if (!channel.subscriptionPending && this.pusher.connection.state === 'connected') channel.subscribe();
                        };
                        this.serverToUserChannel = new Channel(`#server-to-user-${this.user_data.id}`, this.pusher);
                        this.serverToUserChannel.bind_global((eventName, data)=>{
                            if (eventName.indexOf('pusher_internal:') === 0 || eventName.indexOf('pusher:') === 0) return;
                            this.emit(eventName, data);
                        });
                        ensure_subscribed(this.serverToUserChannel);
                    }
                    _cleanup() {
                        this.user_data = null;
                        if (this.serverToUserChannel) {
                            this.serverToUserChannel.unbind_all();
                            this.serverToUserChannel.disconnect();
                            this.serverToUserChannel = null;
                        }
                        if (this.signin_requested) this._signinDoneResolve();
                    }
                    _newSigninPromiseIfNeeded() {
                        if (!this.signin_requested) return;
                        if (this.signinDonePromise && !this.signinDonePromise.done) return;
                        const { promise: promise, resolve: resolve, reject: _ } = flat_promise();
                        promise.done = false;
                        const setDone = ()=>{
                            promise.done = true;
                        };
                        promise.then(setDone).catch(setDone);
                        this.signinDonePromise = promise;
                        this._signinDoneResolve = resolve;
                    }
                }
                class Pusher {
                    static ready() {
                        Pusher.isReady = true;
                        for(var i = 0, l = Pusher.instances.length; i < l; i++)Pusher.instances[i].connect();
                    }
                    static getClientFeatures() {
                        return keys(filterObject({
                            ws: runtime.Transports.ws
                        }, function(t) {
                            return t.isSupported({});
                        }));
                    }
                    constructor(app_key, options){
                        checkAppKey(app_key);
                        validateOptions(options);
                        this.key = app_key;
                        this.options = options;
                        this.config = getConfig(this.options, this);
                        this.channels = factory.createChannels();
                        this.global_emitter = new Dispatcher();
                        this.sessionID = runtime.randomInt(1000000000);
                        this.timeline = new Timeline(this.key, this.sessionID, {
                            cluster: this.config.cluster,
                            features: Pusher.getClientFeatures(),
                            params: this.config.timelineParams || {},
                            limit: 50,
                            level: level.INFO,
                            version: defaults.VERSION
                        });
                        if (this.config.enableStats) this.timelineSender = factory.createTimelineSender(this.timeline, {
                            host: this.config.statsHost,
                            path: '/timeline/v2/' + runtime.TimelineTransport.name
                        });
                        var getStrategy = (options)=>{
                            return runtime.getDefaultStrategy(this.config, options, defineTransport);
                        };
                        this.connection = factory.createConnectionManager(this.key, {
                            getStrategy: getStrategy,
                            timeline: this.timeline,
                            activityTimeout: this.config.activityTimeout,
                            pongTimeout: this.config.pongTimeout,
                            unavailableTimeout: this.config.unavailableTimeout,
                            useTLS: Boolean(this.config.useTLS)
                        });
                        this.connection.bind('connected', ()=>{
                            this.subscribeAll();
                            if (this.timelineSender) this.timelineSender.send(this.connection.isUsingTLS());
                        });
                        this.connection.bind('message', (event)=>{
                            var eventName = event.event;
                            var internal = eventName.indexOf('pusher_internal:') === 0;
                            if (event.channel) {
                                var channel = this.channel(event.channel);
                                if (channel) channel.handleEvent(event);
                            }
                            if (!internal) this.global_emitter.emit(event.event, event.data);
                        });
                        this.connection.bind('connecting', ()=>{
                            this.channels.disconnect();
                        });
                        this.connection.bind('disconnected', ()=>{
                            this.channels.disconnect();
                        });
                        this.connection.bind('error', (err)=>{
                            logger.warn(err);
                        });
                        Pusher.instances.push(this);
                        this.timeline.info({
                            instances: Pusher.instances.length
                        });
                        this.user = new UserFacade(this);
                        if (Pusher.isReady) this.connect();
                    }
                    switchCluster(options) {
                        const { appKey: appKey, cluster: cluster } = options;
                        this.key = appKey;
                        this.options = Object.assign(Object.assign({}, this.options), {
                            cluster: cluster
                        });
                        this.config = getConfig(this.options, this);
                        this.connection.switchCluster(this.key);
                    }
                    channel(name) {
                        return this.channels.find(name);
                    }
                    allChannels() {
                        return this.channels.all();
                    }
                    connect() {
                        this.connection.connect();
                        if (this.timelineSender) {
                            if (!this.timelineSenderTimer) {
                                var usingTLS = this.connection.isUsingTLS();
                                var timelineSender = this.timelineSender;
                                this.timelineSenderTimer = new PeriodicTimer(60000, function() {
                                    timelineSender.send(usingTLS);
                                });
                            }
                        }
                    }
                    disconnect() {
                        this.connection.disconnect();
                        if (this.timelineSenderTimer) {
                            this.timelineSenderTimer.ensureAborted();
                            this.timelineSenderTimer = null;
                        }
                    }
                    bind(event_name, callback, context) {
                        this.global_emitter.bind(event_name, callback, context);
                        return this;
                    }
                    unbind(event_name, callback, context) {
                        this.global_emitter.unbind(event_name, callback, context);
                        return this;
                    }
                    bind_global(callback) {
                        this.global_emitter.bind_global(callback);
                        return this;
                    }
                    unbind_global(callback) {
                        this.global_emitter.unbind_global(callback);
                        return this;
                    }
                    unbind_all(callback) {
                        this.global_emitter.unbind_all();
                        return this;
                    }
                    subscribeAll() {
                        var channelName;
                        for(channelName in this.channels.channels)if (this.channels.channels.hasOwnProperty(channelName)) this.subscribe(channelName);
                    }
                    subscribe(channel_name) {
                        var channel = this.channels.add(channel_name, this);
                        if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                        else if (!channel.subscriptionPending && this.connection.state === 'connected') channel.subscribe();
                        return channel;
                    }
                    unsubscribe(channel_name) {
                        var channel = this.channels.find(channel_name);
                        if (channel && channel.subscriptionPending) channel.cancelSubscription();
                        else {
                            channel = this.channels.remove(channel_name);
                            if (channel && channel.subscribed) channel.unsubscribe();
                        }
                    }
                    send_event(event_name, data, channel) {
                        return this.connection.send_event(event_name, data, channel);
                    }
                    shouldUseTLS() {
                        return this.config.useTLS;
                    }
                    signin() {
                        this.user.signin();
                    }
                }
                Pusher.instances = [];
                Pusher.isReady = false;
                Pusher.logToConsole = false;
                Pusher.Runtime = runtime;
                Pusher.ScriptReceivers = runtime.ScriptReceivers;
                Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
                Pusher.auth_callbacks = runtime.auth_callbacks;
                /* harmony default export */ const pusher = Pusher;
                function checkAppKey(key) {
                    if (key === null || key === undefined) throw 'You must pass your app key when you instantiate Pusher.';
                }
                runtime.setup(Pusher);
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module used 'module' so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(721);
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});



(0, (/*@__PURE__*/$parcel$interopDefault($08c38351731ad8ae$exports))).logToConsole = true;
class $009129975df2a041$var$ChannelServiceInternal {
    constructor(){
        this.types = {}; // { [type]: { name, channel, status, pendingName, debounceId } }
        this.pusher = new (0, (/*@__PURE__*/$parcel$interopDefault($08c38351731ad8ae$exports)))("792b95cd3a917ca2945a", {
            cluster: "us2"
        });
        this.pusher.connection.bind("state_change", (s)=>(0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("pusher state:", s));
        this.pusher.connection.bind("error", (e)=>console.warn("pusher error:", e));
        this.connect(); // meta tag bootstrap
        window.addEventListener("beforeunload", ()=>this.disconnect());
        // Optional: close modals before *any* Turbo Stream render (covers non-Pusher streams too)
        document.addEventListener("turbo:before-stream-render", ()=>this._closeAllModalsNow());
    }
    connect(channel = null) {
        const ch = typeof channel === "string" && channel.trim() || this._readChannelFromDOM();
        if (!ch) return;
        this.subscribeToChannel("stream", ch);
    }
    disconnect() {
        Object.keys(this.types).forEach((type)=>this._forceUnsubscribe(type));
        this.pusher.disconnect();
    }
    _readChannelFromDOM() {
        const el = document.querySelector('meta[name="pusher-channel"]');
        return el?.content?.trim() || null;
    }
    // --- Modal close helper (global event + hard fallback) ---
    _closeAllModalsNow() {
        // Let modal controllers clean up (move focus, set inert/aria-hidden)
        document.dispatchEvent(new CustomEvent("modal:close-all", {
            bubbles: true
        }));
    // Fallback: slam any visible modal nodes shut if they remain
    /*     document
      .querySelectorAll('[data-controller~="modal"] [data-modal-target="modal"]:not(.hidden)')
      .forEach(el => {
        try {
          el.setAttribute("inert", "");
          el.setAttribute("aria-hidden", "true");
          el.classList.add("hidden");
        } catch (_) {}
      }); */ }
    subscribeToChannel(type, identifier) {
        const channelName = (identifier || "").trim();
        if (!channelName) return;
        // simple debounce in case Stimulus connect fires multiple times rapidly
        clearTimeout(this.types[type]?.debounceId);
        this.types[type] = this.types[type] || {
            status: "idle"
        };
        this.types[type].debounceId = setTimeout(()=>this._subscribeCore(type, channelName), 0);
    }
    _subscribeCore(type, channelName) {
        const state = this.types[type] || {
            status: "idle"
        };
        // If already subscribed/subscribing to exactly this name → no-op
        if ((state.status === "subscribed" || state.status === "subscribing") && state.name === channelName) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ChannelService: already on channel", {
                type: type,
                channelName: channelName,
                status: state.status
            });
            return;
        }
        // If a subscribe is in-flight to a different name, remember the desired one and switch after
        if (state.status === "subscribing") {
            state.pendingName = channelName;
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ChannelService: queue switch after subscribe", {
                type: type,
                from: state.name,
                to: channelName
            });
            return;
        }
        // If subscribed to a different channel, cleanly unsubscribe first
        if (state.status === "subscribed" && state.name && state.name !== channelName) this._safeUnsubscribe(type);
        // Begin subscribe
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ChannelService: subscribing", {
            type: type,
            channelName: channelName
        });
        const channel = this.pusher.subscribe(channelName);
        // Update local state *before* events arrive
        this.types[type] = {
            name: channelName,
            channel: channel,
            status: "subscribing",
            pendingName: null
        };
        // Pusher lifecycle binds
        channel.bind("pusher:subscription_succeeded", ()=>{
            const curr = this.types[type];
            if (!curr || curr.name !== channelName) return; // stale
            curr.status = "subscribed";
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ChannelService: subscription_succeeded", {
                type: type,
                channelName: channelName
            });
            // If a newer request arrived while subscribing, switch now
            if (curr.pendingName && curr.pendingName !== curr.name) {
                const next = curr.pendingName;
                curr.pendingName = null;
                this._safeUnsubscribe(type, ()=>this._subscribeCore(type, next));
            }
        });
        channel.bind("pusher:subscription_error", (err)=>{
            const curr = this.types[type];
            if (curr && curr.name === channelName) curr.status = "idle";
            console.warn("ChannelService: subscription_error", {
                type: type,
                channelName: channelName,
                err: err
            });
        });
        // --- App events ---
        // Direct Turbo Stream HTML payloads
        channel.bind("html", (data)=>{
            this._closeAllModalsNow(); // 👈 close modals first
            Turbo.renderStreamMessage(data);
        });
        // Simple redirect payloads — allow same-origin and any absolute http(s):// URL.
        // Normalise bare domains like "www.google.com" → "https://www.google.com".
        channel.bind("redirect", (data)=>{
            if (data?.url) try {
                const raw = String(data.url).trim();
                if (!raw) return;
                const normalized = !/^https?:\/\//i.test(raw) && !raw.startsWith("/") ? `https://${raw}` : raw;
                const u = new URL(normalized, window.location.origin);
                if (u.protocol !== "http:" && u.protocol !== "https:") return;
                window.location.assign(u.toString());
            } catch  {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Invalid redirect URL payload:", data?.url);
            }
        });
        // Direct deposit events — dispatched as DOM events for DirectDepositController
        channel.bind("deposit_confirmed", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("deposit_confirmed event received:", data);
            window.dispatchEvent(new CustomEvent("dd:deposit-confirmed", {
                detail: data
            }));
        });
        channel.bind("deposit_insufficient", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("deposit_insufficient event received:", data);
            window.dispatchEvent(new CustomEvent("dd:deposit-insufficient", {
                detail: data
            }));
        });
        channel.bind("deposit_manual_check", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("deposit_manual_check event received:", data);
            window.dispatchEvent(new CustomEvent("dd:deposit-manual-check", {
                detail: data
            }));
        });
        // Onramp pending — fired by the WaaS backend on the first Meld
        // pending/transferring webhook, BEFORE funds settle and well before
        // consolidation. AddFundsWalletController uses this to lock the checkout
        // into a spinner the instant an onramp is in flight, so the shopper can't
        // pick another deposit option and race the consolidation swap.
        channel.bind("onramp_pending", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("onramp_pending event received:", data);
            window.dispatchEvent(new CustomEvent("waas:onramp_pending", {
                detail: data
            }));
        });
        // Onramp received — fired by the WaaS backend the instant a Meld/card
        // webhook arrives, BEFORE consolidation + ledger + waas_funded. The buy
        // app's AddFundsWalletController uses this to flip the spinner from
        // "Fund your wallet in the other tab" → "Please wait, finalizing payment"
        // so the shopper isn't staring at a stale UI during the ~10–20 s wait.
        channel.bind("onramp_received", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("onramp_received event received:", data);
            window.dispatchEvent(new CustomEvent("waas:onramp_received", {
                detail: data
            }));
        });
        // WaaS funded — fired by the WaaS backend after a Meld/card deposit settles.
        // AddFundsWalletController listens for this to auto-redirect to Pay Now.
        channel.bind("waas_funded", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("waas_funded event received:", data);
            window.dispatchEvent(new CustomEvent("waas:funded", {
                detail: data
            }));
        });
        // Onramp failed — fired by the WaaS backend on Meld's TRANSACTION_CRYPTO_FAILED
        // webhook (card declined, KYC rejected, provider cancelled). AddFundsWalletController
        // uses it to replace the "confirming your payment" spinner with a retry / choose-
        // another-method view instead of waiting out the timeout (COI-833).
        channel.bind("onramp_failed", (data)=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("onramp_failed event received:", data);
            window.dispatchEvent(new CustomEvent("waas:onramp_failed", {
                detail: data
            }));
        });
        // Fetch-then-render Turbo Stream HTML
        channel.bind("stream", async (payload)=>{
            // Accept either object or JSON string payloads
            let data = payload;
            if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch  {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Stream payload not JSON:", payload);
                return;
            }
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Stream Event:", data);
            const url = data?.url;
            if (!url) return;
            const u = new URL(url, window.location.origin);
            if (u.origin !== window.location.origin) return;
            try {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Trying to access url:", u.toString());
                const res = await fetch(u.toString(), {
                    method: "GET",
                    credentials: "same-origin",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                });
                const json = await res.json();
                if (json?.type === "html" && json.data) {
                    this._closeAllModalsNow(); // 👈 close modals first
                    Turbo.renderStreamMessage(json.data);
                }
            } catch (err) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Failed to fetch Turbo Stream JSON:", err);
            }
        });
    }
    _safeUnsubscribe(type, then) {
        const state = this.types[type];
        if (!state?.channel || state.status === "unsubscribing") {
            if (then) then();
            return;
        }
        state.status = "unsubscribing";
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("ChannelService: unsubscribing", {
            type: type,
            channelName: state.name
        });
        // Pusher has no explicit callback for client-initiated unsubscribe success; do local cleanup immediately.
        state.channel.unbind_all();
        this.pusher.unsubscribe(state.name);
        // Reset state
        this.types[type] = {
            status: "idle"
        };
        if (then) then();
    }
    _forceUnsubscribe(type) {
        const state = this.types[type];
        if (!state?.channel) return;
        try {
            state.channel.unbind_all();
            this.pusher.unsubscribe(state.name);
        } finally{
            this.types[type] = {
                status: "idle"
            };
        }
    }
}
// Hard singleton export
if (!window.__ChannelService) window.__ChannelService = new $009129975df2a041$var$ChannelServiceInternal();
var $009129975df2a041$export$2e2bcd8739ae039 = window.__ChannelService;






class $48746cebd196b34e$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "submitButton"
    ];
    static values = {
        permitid: Number,
        tokensymbol: String,
        challenge: String,
        typeddata: String,
        address: String,
        session: String,
        keycredential: Boolean
    };
    async connect() {
        this.hideLoadingScreen();
        this.attestation = null;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
        this.challenge = JSON.parse(this.challengeValue);
        this.typedData = JSON.parse(this.typeddataValue);
        this.address = this.addressValue;
        this.session = this.sessionValue;
        this.keyCredential = this.keycredentialValue;
    }
    async handleSignChallenge() {
        try {
            if (!this.challenge) throw new Error("No challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            if (this.keyCredential) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Using keycredential for signing");
                let signResonse = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/sign/`, {
                    challenge: this.challenge,
                    session: this.session
                });
                if (signResonse.error) {
                    (0, $df5856b8963e2c0f$export$280f90b954565303)(signResonse.error);
                    throw new Error(signResonse.error);
                }
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("KeyCredential signing successful:", signResonse.data);
                this.attestation = signResonse.data;
            } else {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for stored challenge");
                const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                    relyingParty: {
                        id: this.domain.domain,
                        name: this.domain.company
                    }
                });
                this.attestation = await webauthn.sign(this.challenge);
            }
            // Signature obtained (KMS or WebAuthn) — one step before completion.
            // network/amount_usd are filled backend-side from the session.
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_payment_signed", {
                asset: this.tokensymbolValue || "",
                signing_method: this.keyCredential ? "kms_key_credential" : "dfns_passkey"
            });
            this.showLoadingScreen();
            this.proceedToPurchase();
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error during WebAuthn signing:", error);
        }
    }
    async proceedToPurchase() {
        const data = this.typedData;
        data.session = this.session;
        data.address = this.address;
        data.challengeIdentifier = this.challenge.challengeIdentifier;
        data.firstFactor = this.attestation;
        data.permitId = this.permitidValue;
        data.tokenSymbol = this.tokensymbolValue;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("payment/ endpoint data:", data);
        try {
            const res = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/payment/`, data);
            switch(res.type){
                case "channel":
                    (0, $009129975df2a041$export$2e2bcd8739ae039).connect(res.data);
                    break;
                case "html":
                    Turbo.renderStreamMessage(res.data);
                    if (res.channel) (0, $009129975df2a041$export$2e2bcd8739ae039).connect(res.channel);
                    break;
                case "redirect":
                    Turbo.visit(res.data);
                    break;
            }
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("error", error.message);
        }
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Almost There..."
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}











class $3579c543297cfb19$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        chainid: Number,
        permitid: Number,
        tokensymbol: String,
        session: String,
        typeddata: String,
        permitless: String
    };
    async connect() {
        this.typedData = JSON.parse(this.typeddataValue);
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("this.permitlessValue", this.permitlessValue);
        this.permitless = null;
        if (this.permitlessValue) {
            this.permitless = JSON.parse(this.permitlessValue);
            this.permitless.Txhash = this.permitless.Txhash.slice(1, -1);
        }
        this.stopListeningWalletChange();
        this.hideLoadingScreen();
    }
    async proceedToPurchase() {
        let walletClient = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletClient();
        const data = this.typedData;
        if (walletClient) {
            const current_chain = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getCurrentChain();
            if (current_chain != null) {
                const chainId = Number.parseInt(current_chain.id, 16);
                if (chainId != this.chainidValue) {
                    (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Connected Chain:", chainId, "is not on desired network:", this.chainidValue);
                    await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).changeChains(this.chainidValue);
                    walletClient = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletClient();
                }
            }
            let signature;
            try {
                signature = await walletClient.signTypedData({
                    domain: data.domain,
                    message: data.message,
                    primaryType: data.primaryType,
                    types: data.types
                });
            } catch (error) {
                (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_rejected", {
                    wallet_provider: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getConnectedWalletLabel() || ""
                });
                (0, $df5856b8963e2c0f$export$280f90b954565303)("Review3rdPartyWallet signTypedData rejected", error?.message || error);
                this.hideLoadingScreen();
                if ((0, $9286460a480b22e8$export$a5837bf4a7a2713a)(error)) (0, $9286460a480b22e8$export$739bcfea9ba481d2)((0, $9286460a480b22e8$export$63a19fa2452e67ad).paymentDeclinedInWallet);
                else (0, $9286460a480b22e8$export$b542b247691f8019)("something-went-wrong", {
                    session: this.sessionValue
                });
                return;
            }
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_cw_tx_approved", {
                asset: this.tokensymbolValue || "",
                network: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
                amount_crypto: String(data.message?.value ?? "")
            });
            // Payment signature obtained — one step before completion.
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_payment_signed", {
                asset: this.tokensymbolValue || "",
                network: (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
                amount_crypto: String(data.message?.value ?? ""),
                signing_method: "connected_wallet"
            });
            data.rawSignature = signature;
            data.signature = (0, $2d2d1b67c25ca11b$export$dc1dc22ccf24efef)(signature);
            // Convert v and yParity to strings
            data.signature.v = data.signature.v.toString();
            data.signature.yParity = data.signature.yParity.toString();
            data.address = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletAddress();
        } else {
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).connectWallet();
            await (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).changeChains(this.chainidValue);
        }
        data.permitlessFormData = this.permitless;
        data.permitId = this.permitidValue;
        data.tokenSymbol = this.tokensymbolValue;
        data.session = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION);
        try {
            const response = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/payment/`, data);
            switch(response.type){
                case "channel":
                    (0, $009129975df2a041$export$2e2bcd8739ae039).connect(response.data);
                    break;
                case "html":
                    Turbo.renderStreamMessage(response.data);
                    if (response.channel) (0, $009129975df2a041$export$2e2bcd8739ae039).connect(response.channel);
                    break;
                case "redirect":
                    Turbo.visit(response.data);
                    break;
            }
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Review3rdPartyWallet payment/ request error", error.message);
        }
    }
    stopListeningWalletChange() {
        this.dispatch("stopListeningWalletChange");
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please wait..."
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}









const $9c3c5859321556f6$var$AUTO_FINALIZE_KEY_PREFIX = "fast_track_auto_finalized:";
function $9c3c5859321556f6$export$baf91475999a4200(granted, storage, sessionId) {
    if (!granted || !sessionId) return false;
    const key = $9c3c5859321556f6$var$AUTO_FINALIZE_KEY_PREFIX + sessionId;
    try {
        if (storage.getItem(key)) return false;
        storage.setItem(key, "1");
    } catch  {
        return false;
    }
    return true;
}


class $43f1496dab15d7ce$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "submitButton",
        "processing",
        "retry"
    ];
    static values = {
        code: String,
        permitid: Number,
        tokensymbol: String,
        challenge: String,
        typeddata: String,
        address: String,
        session: String,
        keycredential: Boolean,
        networkName: String,
        amountDisplay: String,
        channelid: String,
        /** Session checkout_path — wallet_management when WM checkout reached Pay Now */ checkoutPath: String,
        /** Human-scale pay total for Statsig (USD total; stablecoin ≈ 1:1 for checkout display) */ wmAmountCrypto: String,
        /** Onramp checkout whose card payment already funded the wallet: start the payment on load (CS-3534) */ autoFinalize: Boolean
    };
    async connect() {
        this.hideLoadingScreen();
        this.attestation = null;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
        this.challenge = JSON.parse(this.challengeValue);
        this.typedData = JSON.parse(this.typeddataValue);
        this.keyCredential = this.keycredentialValue;
        (0, $232ee993f4f32bc5$export$ab11b11b7f1fcc6b)({
            networkName: this.networkNameValue,
            amountDisplay: this.amountDisplayValue
        });
        // Pre-subscribe to the Pusher channel at controller-mount time so the
        // first progress event published after /payment/ returns is not missed.
        // Same channel name the backend will publish to (account.GetChannel());
        // ChannelService deduplicates repeat subscribes by name.
        if (this.channelidValue) (0, $009129975df2a041$export$2e2bcd8739ae039).connect(this.channelidValue);
        if ((0, $9c3c5859321556f6$export$baf91475999a4200)(this.autoFinalizeValue, sessionStorage, this.sessionValue)) {
            this.submitButtonTarget.disabled = true;
            try {
                await this.initiateFastTrackPayment();
            } catch (error) {
                (0, $df5856b8963e2c0f$export$280f90b954565303)("Automatic finalize failed:", error);
                this.hideLoadingScreen();
                this.releaseButton();
            }
        }
    }
    async initiateFastTrackPayment() {
        if ((this.checkoutPathValue || "").trim() === "wallet_management" && this.sessionValue) {
            sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION, this.sessionValue);
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_wm_confirm_pay_clicked", {
                asset: (this.tokensymbolValue || "").trim(),
                amount_crypto: (this.wmAmountCryptoValue || "").trim()
            });
        }
        this.showLoadingScreen("Initiating payment...");
        const initiateFastTrackRequest = await fetch(`initiate-fast-track-payment?session=${this.sessionValue}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Session": this.sessionValue,
                "X-Code": this.codeValue
            }
        });
        if (!initiateFastTrackRequest.ok) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error in initiateFastTrackRequest!");
            this.hideLoadingScreen();
            this.releaseButton();
            return;
        }
        const initiateFastTrackResponse = await initiateFastTrackRequest.json();
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("initiateFastTrackResponse:", initiateFastTrackResponse);
        this.showLoadingScreen("Payment in progress...");
        if (initiateFastTrackResponse.status === "done") this.handleSignChallenge();
    }
    async handleSignChallenge() {
        try {
            if (!this.challenge) throw new Error("No challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            if (this.keyCredential) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Using keycredential for signing");
                const signResonse = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/sign/`, {
                    challenge: this.challenge,
                    session: this.sessionValue
                });
                if (signResonse.error) {
                    (0, $df5856b8963e2c0f$export$280f90b954565303)(signResonse.error);
                    throw new Error(signResonse.error);
                }
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("KeyCredential signing successful:", signResonse.data);
                this.attestation = signResonse.data;
            } else {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for stored challenge");
                const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                    relyingParty: {
                        id: this.domain.domain,
                        name: this.domain.company
                    }
                });
                this.attestation = await webauthn.sign(this.challenge);
            }
            // Signature obtained (KMS or WebAuthn) — one step before completion.
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_payment_signed", {
                asset: (this.tokensymbolValue || "").trim(),
                network: (this.networkNameValue || "").trim(),
                amount_crypto: (this.wmAmountCryptoValue || "").trim(),
                signing_method: this.keyCredential ? "kms_key_credential" : "dfns_passkey"
            });
            this.showLoadingScreen("Payment in progress...");
            this.proceedToPurchase();
        } catch (error) {
            this.hideLoadingScreen();
            this.releaseButton();
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Error during WebAuthn signing:", error);
        }
    }
    async proceedToPurchase() {
        const data = this.typedData;
        data.session = this.sessionValue;
        data.address = this.addressValue;
        data.challengeIdentifier = this.challenge.challengeIdentifier;
        data.firstFactor = this.attestation;
        data.permitId = this.permitidValue;
        data.tokenSymbol = this.tokensymbolValue;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("/payment/ endpoint data:", data);
        try {
            const res = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/payment/`, data);
            switch(res.type){
                case "channel":
                    (0, $009129975df2a041$export$2e2bcd8739ae039).connect(res.data);
                    break;
                case "html":
                    Turbo.renderStreamMessage(res.data);
                    if (res.channel) (0, $009129975df2a041$export$2e2bcd8739ae039).connect(res.channel);
                    break;
                case "redirect":
                    Turbo.visit(res.data);
                    break;
            }
        } catch (error) {
            this.hideLoadingScreen();
            this.releaseButton();
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("error", error.message);
        }
    }
    // An automatic finalize that did not get through leaves the button as the way to retry.
    releaseButton() {
        this.submitButtonTarget.disabled = false;
        // Auto-finalize screens render a processing state with the button hidden so the
        // finalize screen never flashes. When the automatic attempt fails, swap that
        // processing state for the retry prompt and reveal the button.
        if (this.hasProcessingTarget) this.processingTarget.classList.add("hidden");
        if (this.hasRetryTarget) this.retryTarget.classList.remove("hidden");
        this.submitButtonTarget.classList.remove("hidden");
    }
    showLoadingScreen(message) {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: message
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}






class $79cbb1ddb950488d$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        code: String,
        session: String,
        address: String,
        permitid: Number,
        challenge: String,
        permit: String,
        networkName: String,
        amountDisplay: String
    };
    initialize() {
        this.attestation = null;
        this.signing = false;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
    }
    connect() {
        this.hideLoadingScreen();
        this.challenge = JSON.parse(this.challengeValue);
        this.permit = JSON.parse(this.permitValue);
        (0, $232ee993f4f32bc5$export$ab11b11b7f1fcc6b)({
            networkName: this.networkNameValue,
            amountDisplay: this.amountDisplayValue
        });
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("FastTrackOtpPermitController connected with:", {
            "code": this.codeValue,
            "session": this.sessionValue,
            "address": this.addressValue,
            "permitId": this.permitidValue,
            "challenge": this.challenge
        });
    }
    async sign() {
        if (this.signing) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("FastTrackOtpPermit sign() ignored \u2014 already in progress");
            return;
        }
        this.signing = true;
        this.showLoadingScreen("Authorizing allowance...");
        try {
            if (!this.challenge) throw new Error("No permit challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for fast-track permit challenge");
            const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                relyingParty: {
                    id: this.domain.domain,
                    name: this.domain.company
                }
            });
            this.attestation = await webauthn.sign(this.challenge);
            this.submitPermit();
        } catch (error) {
            this.hideLoadingScreen();
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error during fast-track permit WebAuthn signing:", error);
        } finally{
            this.signing = false;
        }
    }
    submitPermit() {
        const form = document.getElementById("frame-post-form");
        const challengeEl = document.getElementById("form_challengeIdentifier");
        if (!form || !challengeEl) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("FastTrackOtpPermit submit aborted \u2014 form already replaced");
            return;
        }
        challengeEl.value = this.challenge.challengeIdentifier;
        document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
        document.getElementById("form_session").value = this.sessionValue;
        document.getElementById("form_permitData").value = JSON.stringify({
            ...this.permit,
            address: this.addressValue,
            session: this.sessionValue
        });
        form.action = `/${this.codeValue}/sign-fast-track-permit`;
        form.requestSubmit();
    }
    showLoadingScreen(message) {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: message || "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}






class $8db7ba932a23c8a8$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        code: String,
        session: String,
        address: String,
        challenge: String,
        approval: String,
        tokenContractAddress: String,
        networkName: String,
        amountDisplay: String
    };
    initialize() {
        this.attestation = null;
        this.signing = false;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
    }
    connect() {
        this.hideLoadingScreen();
        this.challenge = JSON.parse(this.challengeValue);
        this.approval = JSON.parse(this.approvalValue);
        (0, $232ee993f4f32bc5$export$ab11b11b7f1fcc6b)({
            networkName: this.networkNameValue,
            amountDisplay: this.amountDisplayValue
        });
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("FastTrackOtpApproveController connected with:", {
            "code": this.codeValue,
            "session": this.sessionValue,
            "address": this.addressValue,
            "tokenContractAddress": this.tokenContractAddressValue,
            "challenge": this.challenge
        });
    }
    async sign() {
        if (this.signing) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("FastTrackOtpApprove sign() ignored \u2014 already in progress");
            return;
        }
        this.signing = true;
        this.showLoadingScreen("Authorizing spending...");
        try {
            if (!this.challenge) throw new Error("No approve challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for fast-track approve challenge");
            const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                relyingParty: {
                    id: this.domain.domain,
                    name: this.domain.company
                }
            });
            this.attestation = await webauthn.sign(this.challenge);
            this.showLoadingScreen("Confirming authorization on-chain...");
            this.submitApprove();
        } catch (error) {
            this.hideLoadingScreen();
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error during fast-track approve WebAuthn signing:", error);
        } finally{
            this.signing = false;
        }
    }
    submitApprove() {
        const form = document.getElementById("frame-post-form");
        const challengeEl = document.getElementById("form_challengeIdentifier");
        if (!form || !challengeEl) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("FastTrackOtpApprove submit aborted \u2014 form already replaced");
            return;
        }
        challengeEl.value = this.challenge.challengeIdentifier;
        document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
        document.getElementById("form_session").value = this.sessionValue;
        document.getElementById("form_tokenContractAddress").value = this.tokenContractAddressValue;
        document.getElementById("form_approvalData").value = JSON.stringify(this.approval);
        form.action = `/${this.codeValue}/sign-fast-track-approve`;
        form.requestSubmit();
    }
    showLoadingScreen(message) {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: message || "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}








class $19c684597016fd38$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        code: String,
        session: String,
        address: String,
        permitid: Number,
        tokensymbol: String,
        challenge: String,
        typeddata: String,
        networkName: String,
        amountDisplay: String,
        channelid: String
    };
    initialize() {
        this.attestation = null;
        this.domain = JSON.parse(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN));
    }
    connect() {
        this.hideLoadingScreen();
        this.challenge = JSON.parse(this.challengeValue);
        this.typedData = JSON.parse(this.typeddataValue);
        (0, $232ee993f4f32bc5$export$ab11b11b7f1fcc6b)({
            networkName: this.networkNameValue,
            amountDisplay: this.amountDisplayValue
        });
        // Pre-subscribe to the Pusher channel at controller-mount time so the
        // first progress event published after /payment/ returns is not missed.
        if (this.channelidValue) (0, $009129975df2a041$export$2e2bcd8739ae039).connect(this.channelidValue);
    }
    async pay() {
        this.showLoadingScreen("Verifying payment...");
        try {
            if (!this.challenge) throw new Error("No payment challenge available to sign");
            if (!this.domain) throw new Error("Domain data not available");
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Starting WebAuthn signing for fast-track payment challenge");
            const webauthn = new (0, $fb9ea7e7c6187a50$exports.WebAuthnSigner)({
                relyingParty: {
                    id: this.domain.domain,
                    name: this.domain.company
                }
            });
            this.attestation = await webauthn.sign(this.challenge);
            this.showLoadingScreen("Payment in progress...");
            await this.submitPayment();
        } catch (error) {
            this.hideLoadingScreen();
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error during fast-track payment WebAuthn signing:", error);
        }
    }
    async submitPayment() {
        const data = this.typedData;
        data.session = this.sessionValue;
        data.address = this.addressValue;
        data.challengeIdentifier = this.challenge.challengeIdentifier;
        data.firstFactor = this.attestation;
        data.permitId = this.permitidValue;
        data.tokenSymbol = this.tokensymbolValue;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("/payment/ endpoint data:", data);
        try {
            const res = await (0, $dfd4109e85d8ea12$export$2e2bcd8739ae039).post(`/payment/`, data);
            switch(res.type){
                case "channel":
                    (0, $009129975df2a041$export$2e2bcd8739ae039).connect(res.data);
                    break;
                case "html":
                    Turbo.renderStreamMessage(res.data);
                    if (res.channel) (0, $009129975df2a041$export$2e2bcd8739ae039).connect(res.channel);
                    break;
                case "redirect":
                    Turbo.visit(res.data);
                    break;
            }
        } catch (error) {
            this.hideLoadingScreen();
            (0, $df5856b8963e2c0f$export$280f90b954565303)("Error submitting fast-track payment:", error.message);
        }
    }
    showLoadingScreen(message) {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: message || "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}




const $09439d601cee3d34$export$252ea4051516188e = {
    FALSE: "false",
    ALREADY_PAID: "already_paid",
    PAYMENT_FAILED: "payment_failed"
};
const $09439d601cee3d34$var$SUCCESS_OUTCOME_SUFFIXES = [
    "/payment-success",
    "/direct-deposit-success"
];
const $09439d601cee3d34$var$FAILURE_OUTCOME_SUFFIXES = [
    "/payment-failure",
    "/direct-deposit-insufficient-funds"
];
function $09439d601cee3d34$export$f5048665d168cf25() {
    const raw = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION_COMPLETED);
    // Migrate legacy boolean "true" from the earlier client guard.
    if (raw === "true") return $09439d601cee3d34$export$252ea4051516188e.ALREADY_PAID;
    if (raw === $09439d601cee3d34$export$252ea4051516188e.ALREADY_PAID || raw === $09439d601cee3d34$export$252ea4051516188e.PAYMENT_FAILED || raw === $09439d601cee3d34$export$252ea4051516188e.FALSE) return raw;
    return $09439d601cee3d34$export$252ea4051516188e.FALSE;
}
function $09439d601cee3d34$export$5b27f019950ab702(status) {
    sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION_COMPLETED, status);
}
function $09439d601cee3d34$export$8cda6dea30c6a70e() {
    $09439d601cee3d34$export$5b27f019950ab702($09439d601cee3d34$export$252ea4051516188e.FALSE);
}
function $09439d601cee3d34$export$7ca9f8ef177c706() {
    $09439d601cee3d34$export$5b27f019950ab702($09439d601cee3d34$export$252ea4051516188e.ALREADY_PAID);
}
function $09439d601cee3d34$export$4df6a7e99db786c4() {
    $09439d601cee3d34$export$5b27f019950ab702($09439d601cee3d34$export$252ea4051516188e.PAYMENT_FAILED);
}
function $09439d601cee3d34$export$4f384f8a56444e02(pathname = window.location.pathname) {
    return $09439d601cee3d34$var$normalizePathname(pathname).endsWith("/already-paid");
}
function $09439d601cee3d34$export$300337453d1210fb(pathname = window.location.pathname) {
    const path = $09439d601cee3d34$var$normalizePathname(pathname);
    return $09439d601cee3d34$var$SUCCESS_OUTCOME_SUFFIXES.some((suffix)=>path.endsWith(suffix));
}
function $09439d601cee3d34$export$b271613637009436(pathname = window.location.pathname) {
    const path = $09439d601cee3d34$var$normalizePathname(pathname);
    return $09439d601cee3d34$var$FAILURE_OUTCOME_SUFFIXES.some((suffix)=>path.endsWith(suffix));
}
function $09439d601cee3d34$export$1ef9b811f280fee8(pathname = window.location.pathname) {
    return $09439d601cee3d34$export$300337453d1210fb(pathname) || $09439d601cee3d34$export$b271613637009436(pathname);
}
function $09439d601cee3d34$export$faff0e25bbc1aa8(pathname = window.location.pathname) {
    const segments = $09439d601cee3d34$var$normalizePathname(pathname).split("/").filter(Boolean);
    return segments.length === 1;
}
function $09439d601cee3d34$export$7f756e734dc45e16(pathname = window.location.pathname) {
    const status = $09439d601cee3d34$export$f5048665d168cf25();
    if (status === $09439d601cee3d34$export$252ea4051516188e.FALSE) return false;
    const code = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE);
    if (!code) return false;
    if (status === $09439d601cee3d34$export$252ea4051516188e.ALREADY_PAID) {
        if ($09439d601cee3d34$export$4f384f8a56444e02(pathname) || $09439d601cee3d34$export$300337453d1210fb(pathname)) return false;
        const sessionID = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION) || "";
        const query = sessionID ? `?session=${encodeURIComponent(sessionID)}` : "";
        window.location.replace(`/${code}/already-paid${query}`);
        return true;
    }
    if (status === $09439d601cee3d34$export$252ea4051516188e.PAYMENT_FAILED) {
        if ($09439d601cee3d34$export$faff0e25bbc1aa8(pathname) || $09439d601cee3d34$export$b271613637009436(pathname)) return false;
        window.location.replace(`/${code}`);
        return true;
    }
    return false;
}
function $09439d601cee3d34$var$normalizePathname(pathname) {
    if (!pathname || typeof pathname !== "string") return "/";
    const trimmed = pathname.replace(/\/+$/, "");
    return trimmed === "" ? "/" : trimmed;
}




// Progress updates mount a short-lived controller on #blockchain_progess_updater.
// Guard the success fade at module scope so two instances cannot both run it.
let $0d619fe008bce62f$var$blockchainSuccessTransitionStarted = false;
class $0d619fe008bce62f$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        percentage: Number,
        text: String,
        transactionHash: String,
        transactionExplorerUrl: String,
        transactionStatus: String,
        hideTxDetails: Boolean,
        onrampCheckout: Boolean,
        isPosPayment: Boolean,
        errorKey: String
    };
    connect() {
        this.outcomeAdvanceInFlight = false;
        this.lastAdvancedResult = null;
        this.successTransitionStarted = false;
        this.successRowsRevealed = false;
        // New checkout progress (not yet complete) must be allowed to animate again
        // in this Turbo session — the module guard survives Turbo navigations.
        if (this.hasPercentageValue && this.percentageValue < 100) $0d619fe008bce62f$var$blockchainSuccessTransitionStarted = false;
        if (this.isDedicatedOutcomePage()) {
            if (window.location.pathname.includes("/payment-failure")) (0, $09439d601cee3d34$export$4df6a7e99db786c4)();
            else (0, $09439d601cee3d34$export$7ca9f8ef177c706)();
        }
        this.hideLoadingScreen();
        const checkoutTotalAmount = document.getElementById("checkout_total_amount");
        const checkoutPaymentMethod = document.getElementById("checkout_payment_method");
        // Explicit crypto-onramp signal. Prefer this render's own value (passed by
        // the progress/outcome handler, which always knows the flow); fall back to
        // the marker on the persistent order-summary element. When set we force the
        // payment method to "USD", hide all chain-specific UI, and stamp the marker
        // back onto the order-summary element so later Pusher-update controller
        // instances (which lack their own value) inherit it — no network/hash flash.
        const onrampCheckout = this.hasOnrampCheckoutValue && this.onrampCheckoutValue || checkoutPaymentMethod?.dataset?.onrampCheckout === "1";
        if (onrampCheckout && checkoutPaymentMethod) {
            checkoutPaymentMethod.textContent = "USD";
            checkoutPaymentMethod.dataset.onrampCheckout = "1";
        }
        const checkoutPaymentMethodText = checkoutPaymentMethod?.textContent?.trim() || "";
        const checkoutTotalAmountText = checkoutTotalAmount?.textContent?.trim() || "";
        const paymentMethodParts = checkoutPaymentMethodText.split(" / ").map((v)=>v.trim()).filter(Boolean);
        const totalAmountParts = checkoutTotalAmountText.split(/\s+/).map((v)=>v.trim()).filter(Boolean);
        const hasExplicitPaymentMethod = checkoutPaymentMethodText !== "" && checkoutPaymentMethodText !== "Awaiting Selection";
        // "Polygon / USD" has a network part (normal fast-track / MetaMask flows); a
        // custodial coinsub-wallet (crypto-onramp) checkout shows just "USD".
        const hasNetworkPart = hasExplicitPaymentMethod && paymentMethodParts.length >= 2;
        // Hide chain UI for the crypto-onramp flow (explicit flag), or when the
        // payment method is explicitly network-less. An unset / "Awaiting Selection"
        // method is left alone, so normal crypto flows always keep their network +
        // tx-hash display.
        this.hideOnChainDetails = onrampCheckout || hasExplicitPaymentMethod && !hasNetworkPart;
        const checkoutPrice = totalAmountParts[0] || "";
        const checkoutCurrency = (hasNetworkPart ? paymentMethodParts[1] : paymentMethodParts[0]) || totalAmountParts[1] || "USD";
        const checkoutNetwork = hasNetworkPart ? paymentMethodParts[0] : "";
        const checkoutTotalPrice = document.getElementById("checkout_total_price");
        const checkoutCurrencyEl = document.getElementById("checkout_currency");
        const checkoutNetworkEl = document.getElementById("checkout_network");
        const checkoutNetworkRow = document.getElementById("checkout_network_row");
        // Prefer values already rendered by the server on /payment-success. Only
        // overwrite when the overview parse produced a value — never clear a
        // server-rendered network with an empty string.
        if (checkoutTotalPrice && checkoutPrice) checkoutTotalPrice.textContent = checkoutPrice;
        if (checkoutCurrencyEl) {
            const existingCurrency = checkoutCurrencyEl.textContent?.trim() || "";
            if (checkoutCurrency || !existingCurrency) checkoutCurrencyEl.textContent = checkoutCurrency || existingCurrency;
        }
        if (checkoutNetworkEl) {
            const existingNetwork = checkoutNetworkEl.textContent?.trim() || "";
            const networkToShow = checkoutNetwork || existingNetwork;
            if (networkToShow) checkoutNetworkEl.textContent = networkToShow;
        }
        if (checkoutNetworkRow) {
            const networkVisible = !this.hideOnChainDetails && Boolean(checkoutNetwork || checkoutNetworkEl?.textContent?.trim());
            checkoutNetworkRow.classList.toggle("hidden", !networkVisible);
        }
        this.updateProgressLabelsOpacity();
        this.updateTransactionDetails();
        if (this.hasPercentageValue) this.update();
    }
    disconnect() {
        this.clearCompletedFadeOutTimeout();
    // Do not clear success-transition timers here. Progress updates mount a
    // short-lived controller on #blockchain_progess_updater; Turbo can
    // disconnect it while the fade is in flight. Callbacks use document
    // getElementById, so they remain valid after this instance disconnects.
    }
    update() {
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Update State:", this.percentageValue);
        const progressText = document.getElementById("blockchain_progress_text");
        const progressBarProcess = document.getElementById("blockchain_progress_bar");
        if (!progressBarProcess || !progressText) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("BlockchainProgressController: update() - progressBarProcess or progressText not found");
            return;
        }
        // Update the progress state.
        progressText.textContent = this.textValue;
        progressBarProcess.style.width = `${this.percentageValue}%`;
        this.updateProgressLabelsOpacity();
        this.updateTransactionDetails();
        // Show failure UI
        if (this.percentageValue === 0) this.showFailureState();
        // Show success UI
        if (this.percentageValue === 100) this.showSuccessState();
    }
    showSuccessState() {
        if (this.successTransitionStarted) return;
        this.successTransitionStarted = true;
        // In-progress page: navigate to /payment-success without a local success fade.
        // The dedicated outcome page owns the spinner → completed animation so we
        // don't get a double fade (handoff + Turbo frame transition).
        if (!this.isDedicatedOutcomePage()) {
            if ($0d619fe008bce62f$var$blockchainSuccessTransitionStarted) return;
            $0d619fe008bce62f$var$blockchainSuccessTransitionStarted = true;
            this.advanceToOutcomeIfNeeded("success");
            return;
        }
        // /payment-success: fade out progress, then fade in final success content.
        const finishSuccessUI = ()=>{
            this.hideProgressUI();
            this.successRowsRevealed = true;
            this.updateTransactionDetails();
            this.showFinalSuccessContent();
        };
        setTimeout(()=>{
            this.fadeOutProgressUI();
            setTimeout(finishSuccessUI, 300);
        }, 300);
    }
    showFailureState() {
        const blockchainProgressIndicator = document.getElementById("blockchain_progress_indicator");
        const blockchainFailedIconCircle = document.getElementById("blockchain_failed_icon_circle");
        const blockchainProgressSpinnerWrap = document.getElementById("blockchain_progress_spinner_wrap");
        const blockChainFeedbackHeader = document.getElementById("blockchain_feedback_header");
        const blockchainFeedbackMessage = document.getElementById("blockchain_feedback_message");
        const progressIconCircle = document.getElementById("blockchain_progress_icon_circle");
        const transactionStatus = document.getElementById("checkout_tx_status");
        if (!blockchainProgressIndicator || !blockchainFailedIconCircle || !blockChainFeedbackHeader || !blockchainFeedbackMessage) return;
        if (blockchainProgressSpinnerWrap) {
            blockchainProgressSpinnerWrap.classList.add("hidden");
            blockchainProgressSpinnerWrap.classList.remove("flex");
        }
        if (progressIconCircle) {
            progressIconCircle.classList.add("hidden");
            progressIconCircle.classList.remove("flex");
        }
        blockchainFailedIconCircle.classList.remove("hidden");
        blockchainFailedIconCircle.classList.add("flex");
        blockchainProgressIndicator.classList.add("hidden");
        blockChainFeedbackHeader.classList.remove("text-thm-body-primary-text", "text-primaryColor", "text-thm-body-success-text-and-icon");
        blockChainFeedbackHeader.classList.add("text-thm-body-error-text-and-icon-color");
        blockChainFeedbackHeader.textContent = this.hasTextValue && this.textValue ? this.textValue : "Payment Failed!";
        blockchainFeedbackMessage.textContent = "Something went wrong while processing your payment. Please try again in a few moments.";
        this.ensureStartOverButton();
        this.showErrorSurface();
        blockchainFailedIconCircle.classList.remove("border-2", "border-primaryColor");
        blockchainFailedIconCircle.classList.add("bg-thm-red");
        // Failure path reveals status immediately (no success fade).
        this.successRowsRevealed = true;
        this.updateTransactionDetails();
        if (transactionStatus) {
            transactionStatus.classList.remove("text-thm-body-primary-text", "text-thm-body-success-text-and-icon");
            transactionStatus.classList.add("text-thm-body-error-text-and-icon-color");
            transactionStatus.textContent = "Failed";
        }
        this.advanceToOutcomeIfNeeded("failure");
    }
    // Renders the catalog error surface (retry card / needs-help / status) for
    // the pushed error key over the failed progress screen.
    showErrorSurface() {
        if (!this.hasErrorKeyValue || !this.errorKeyValue) return;
        (0, $9286460a480b22e8$export$b542b247691f8019)(this.errorKeyValue);
    }
    fadeOutProgressUI() {
        const progressContainer = document.getElementById("blockchain_progress_container");
        const summaryDetails = document.getElementById("blockchain_summary_details");
        if (progressContainer) {
            progressContainer.style.opacity = "0";
            progressContainer.style.transform = "translateY(-20px)";
        }
        if (summaryDetails) {
            summaryDetails.style.opacity = "0";
            summaryDetails.style.transform = "translateY(-20px)";
        }
    }
    hideProgressUI() {
        const progressContainer = document.getElementById("blockchain_progress_container");
        if (progressContainer) progressContainer.classList.add("hidden");
    }
    showFinalSuccessContent() {
        const finalContent = document.getElementById("blockchain_final_content");
        const summaryDetails = document.getElementById("blockchain_summary_details");
        const onrampNote = document.getElementById("blockchain_onramp_statement_note");
        if (finalContent) {
            finalContent.classList.remove("hidden");
            finalContent.offsetHeight;
            finalContent.style.opacity = "1";
            finalContent.style.transform = "translateY(0px)";
        }
        if (summaryDetails) {
            summaryDetails.offsetHeight;
            summaryDetails.style.opacity = "1";
            summaryDetails.style.transform = "translateY(0px)";
        }
        if (onrampNote) {
            onrampNote.classList.remove("hidden");
            onrampNote.offsetHeight;
            onrampNote.style.opacity = "1";
            onrampNote.style.transform = "translateY(0px)";
        }
    }
    async advanceToOutcomeIfNeeded(result) {
        if (this.isDedicatedOutcomePage()) return;
        if (this.outcomeAdvanceInFlight || this.lastAdvancedResult === result) return;
        const payload = this.buildOutcomeAdvancePayload(result);
        if (!payload.session || !payload.code) return;
        this.outcomeAdvanceInFlight = true;
        try {
            const response = await fetch(`/${payload.code}/payment-outcome/advance`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) return;
            const data = await response.json();
            const resolvedURL = this.getResolvedURL(data?.url);
            if (!resolvedURL) return;
            this.lastAdvancedResult = result;
            if (data?.external) {
                if (result === "failure") (0, $09439d601cee3d34$export$4df6a7e99db786c4)();
                else (0, $09439d601cee3d34$export$7ca9f8ef177c706)();
                window.location.assign(resolvedURL.toString());
                return;
            }
            // Frame visit keeps the checkout overview (payment method / network) mounted,
            // matching direct-deposit success. Full-page visit would re-render overview
            // from session and can leave Network blank if the DOM parse races.
            Turbo.visit(resolvedURL.pathname + resolvedURL.search, {
                frame: "step_content",
                action: "advance"
            });
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("BlockchainProgressController: outcome advance failed", error);
        } finally{
            this.outcomeAdvanceInFlight = false;
        }
    }
    buildOutcomeAdvancePayload(result) {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split("/").filter(Boolean);
        const code = pathSegments[0] || "";
        const session = url.searchParams.get("session") || "";
        return {
            code: code,
            session: session,
            result: result,
            text: this.hasTextValue ? this.textValue : "",
            transactionHash: this.hasTransactionHashValue ? this.transactionHashValue : "",
            transactionExplorerUrl: this.hasTransactionExplorerUrlValue ? this.transactionExplorerUrlValue : "",
            transactionStatus: this.hasTransactionStatusValue ? this.transactionStatusValue : "",
            errorKey: this.hasErrorKeyValue ? this.errorKeyValue : ""
        };
    }
    isDedicatedOutcomePage() {
        return window.location.pathname.includes("/payment-success") || window.location.pathname.includes("/payment-failure");
    }
    getResolvedURL(rawURL) {
        if (!rawURL || typeof rawURL !== "string") return null;
        try {
            const normalized = !/^https?:\/\//i.test(rawURL) && !rawURL.startsWith("/") ? `https://${rawURL}` : rawURL;
            const resolvedURL = new URL(normalized, window.location.origin);
            if (resolvedURL.protocol !== "http:" && resolvedURL.protocol !== "https:") return null;
            return resolvedURL;
        } catch  {
            return null;
        }
    }
    ensureStartOverButton() {
        const blockchainFeedbackMessage = document.getElementById("blockchain_feedback_message");
        if (!blockchainFeedbackMessage) return;
        let startOverButton = document.getElementById("blockchain_start_over_button");
        if (!startOverButton) {
            startOverButton = document.createElement("a");
            startOverButton.id = "blockchain_start_over_button";
            startOverButton.className = "mb-4 inline-flex items-center justify-center rounded-lg bg-primaryColor px-4 py-2 text-sm font-medium text-thm-button-primary-label-color";
            startOverButton.textContent = "Start Over";
            startOverButton.setAttribute("data-turbo", "false");
            startOverButton.setAttribute("data-turbo-frame", "_top");
            blockchainFeedbackMessage.insertAdjacentElement("afterend", startOverButton);
        }
        const startOverUrl = this.getStartOverUrl();
        if (startOverUrl) startOverButton.setAttribute("href", startOverUrl);
    }
    getStartOverUrl() {
        const pathSegments = window.location.pathname.split("/").filter(Boolean);
        if (pathSegments.length === 0) return null;
        const code = pathSegments[0];
        return `${window.location.origin}/${code}/`;
    }
    updateProgressLabelsOpacity() {
        const progressText = document.getElementById("blockchain_progress_text");
        const detectedLabel = progressText?.previousElementSibling;
        const completedLabel = progressText?.nextElementSibling;
        if (!progressText || !detectedLabel || !completedLabel) return;
        const progress = this.getClampedProgress();
        const detectedOpacity = progress <= 65 ? 1 - progress / 65 : 0;
        const confirmingOpacity = this.getConfirmingOpacity(progress);
        const completedOpacity = progress <= 35 ? 0 : (progress - 35) / 65;
        const defaultOpacityTransition = "opacity 450ms cubic-bezier(0.22, 1, 0.36, 1)";
        detectedLabel.style.transition = defaultOpacityTransition;
        progressText.style.transition = defaultOpacityTransition;
        completedLabel.style.transition = defaultOpacityTransition;
        detectedLabel.style.opacity = `${detectedOpacity}`;
        progressText.style.opacity = `${confirmingOpacity}`;
        if (progress === 100) {
            this.triggerCompletedLabelFadeOut(completedLabel);
            return;
        }
        this.completedFadeOutTriggered = false;
        this.clearCompletedFadeOutTimeout();
        completedLabel.style.opacity = `${completedOpacity}`;
    }
    getClampedProgress() {
        if (!this.hasPercentageValue || Number.isNaN(this.percentageValue)) return 0;
        return Math.min(100, Math.max(0, this.percentageValue));
    }
    getConfirmingOpacity(progress) {
        if (progress <= 45) return progress / 45;
        if (progress <= 55) return 1;
        return (100 - progress) / 45;
    }
    triggerCompletedLabelFadeOut(completedLabel) {
        if (this.completedFadeOutTriggered) return;
        this.completedFadeOutTriggered = true;
        this.clearCompletedFadeOutTimeout();
        completedLabel.style.opacity = "1";
        completedLabel.style.transition = "opacity 3000ms cubic-bezier(0.16, 1, 0.3, 1)";
        this.completedFadeOutTimeout = window.setTimeout(()=>{
            completedLabel.style.opacity = "0";
            this.completedFadeOutTimeout = null;
        }, 120);
    }
    clearCompletedFadeOutTimeout() {
        if (this.completedFadeOutTimeout) {
            window.clearTimeout(this.completedFadeOutTimeout);
            this.completedFadeOutTimeout = null;
        }
    }
    updateTransactionDetails() {
        // POS confirmation renders a POS-tailored receipt (Amount, Order ID,
        // Merchant, TX Hash, Date) — the TX Hash row is provided by the template so
        // it sits above the Date row, and there is NO Status row. Read the marker off
        // the summary element too, not just this instance's value: the Pusher
        // progress-update stream spawns its own controller instance without the value
        // (same reason the onramp marker is mirrored onto the DOM above), and it must
        // treat the receipt as POS just like the outcome-page instance.
        const summaryContainer = document.getElementById("blockchain_summary_details");
        const isPosReceipt = this.hasIsPosPaymentValue && this.isPosPaymentValue || summaryContainer?.dataset?.posReceipt === "1";
        const txNodes = this.ensureTransactionDetailsNodes(isPosReceipt);
        if (!txNodes) return;
        const { txHashRow: txHashRow, transactionHashText: transactionHashText, transactionHashLink: transactionHashLink, transactionStatus: transactionStatus } = txNodes;
        const hash = this.hasTransactionHashValue ? this.transactionHashValue.trim() : "";
        const explorerUrl = this.hasTransactionExplorerUrlValue ? this.transactionExplorerUrlValue.trim() : "";
        const status = this.hasTransactionStatusValue ? this.transactionStatusValue.trim() : "";
        const statusLower = status.toLowerCase();
        const isSuccessful = this.percentageValue === 100 || statusLower === "completed" || statusLower === "success";
        // Crypto-onramp checkout pays from the custodial coinsub wallet, so the
        // on-chain tx hash is noise — keep the row hidden for that flow. Driven by
        // the same "no network part" signal as the Network row (hideOnChainDetails),
        // so every progress/outcome render — including the Pusher 100% update that
        // carries the hash — keeps it hidden (no brief flash before the final reload).
        const hideTxDetails = this.hideOnChainDetails || this.hasHideTxDetailsValue && this.hideTxDetailsValue;
        const isFailed = this.percentageValue === 0 || statusLower === "failed";
        // Success rows wait for the fade handoff (successRowsRevealed). Failure shows immediately.
        const shouldShowTxRow = !hideTxDetails && (isSuccessful && this.successRowsRevealed || isFailed && Boolean(hash));
        const shouldShowStatusRow = isSuccessful && this.successRowsRevealed || isFailed;
        if (txHashRow) txHashRow.classList.toggle("hidden", !shouldShowTxRow);
        if (transactionStatus?.parentElement) transactionStatus.parentElement.classList.toggle("hidden", !shouldShowStatusRow);
        if (hash) {
            const shortHash = hash.length > 12 ? `${hash.slice(0, 4)}...${hash.slice(-4)}` : hash;
            transactionHashText.textContent = shortHash;
            transactionHashLink.title = hash;
            if (explorerUrl) {
                transactionHashLink.href = explorerUrl;
                transactionHashLink.setAttribute("target", "_blank");
            } else {
                transactionHashLink.removeAttribute("href");
                transactionHashLink.removeAttribute("target");
            }
        } else {
            transactionHashText.textContent = "-";
            transactionHashLink.removeAttribute("title");
            transactionHashLink.removeAttribute("href");
            transactionHashLink.removeAttribute("target");
        }
        if (status && transactionStatus) {
            transactionStatus.textContent = status;
            transactionStatus.classList.remove("text-thm-body-error-text-and-icon-color", "text-thm-body-success-text-and-icon");
            if (statusLower === "completed" || statusLower === "success") {
                transactionStatus.classList.remove("text-thm-body-primary-text");
                transactionStatus.classList.add("text-thm-body-success-text-and-icon");
            }
            if (statusLower === "failed") {
                transactionStatus.classList.remove("text-thm-body-primary-text");
                transactionStatus.classList.add("text-thm-body-error-text-and-icon-color");
            }
        }
    }
    ensureTransactionDetailsNodes(isPosReceipt = false) {
        const summaryContainer = document.getElementById("blockchain_summary_details");
        if (!summaryContainer) return null;
        let transactionHashText = document.getElementById("checkout_tx_hash_text");
        let transactionHashLink = document.getElementById("checkout_tx_hash_link");
        let transactionStatus = document.getElementById("checkout_tx_status");
        let txHashRow = document.getElementById("checkout_tx_hash_row");
        // POS receipt: the TX Hash row lives in the template (above Date) and there
        // is no Status row. Reuse the template nodes as-is; never inject.
        if (isPosReceipt) {
            if (transactionHashText && transactionHashLink && txHashRow) return {
                txHashRow: txHashRow,
                transactionHashText: transactionHashText,
                transactionHashLink: transactionHashLink,
                transactionStatus: null
            };
            return null;
        }
        if (transactionHashText && transactionHashLink && transactionStatus && txHashRow) return {
            txHashRow: txHashRow,
            transactionHashText: transactionHashText,
            transactionHashLink: transactionHashLink,
            transactionStatus: transactionStatus
        };
        const baseLabelClasses = "text-sm text-thm-body-primary-text";
        const baseValueClasses = "text-sm font-medium text-thm-body-primary-text";
        const dividerClasses = "hidden flex justify-between items-center py-3 border-t border-thm-desktop-sidebar-border-color";
        txHashRow = document.createElement("div");
        txHashRow.id = "checkout_tx_hash_row";
        txHashRow.className = dividerClasses;
        const txHashLabel = document.createElement("span");
        txHashLabel.className = baseLabelClasses;
        txHashLabel.textContent = "TX Hash";
        transactionHashLink = document.createElement("a");
        transactionHashLink.id = "checkout_tx_hash_link";
        transactionHashLink.className = "text-sm font-medium text-primaryColor";
        transactionHashLink.rel = "noopener noreferrer";
        transactionHashText = document.createElement("span");
        transactionHashText.id = "checkout_tx_hash_text";
        transactionHashText.textContent = "";
        transactionHashLink.appendChild(transactionHashText);
        txHashRow.append(txHashLabel, transactionHashLink);
        const statusRow = document.createElement("div");
        statusRow.className = "hidden flex justify-between items-center py-3 border-t border-thm-desktop-sidebar-border-color";
        const statusLabel = document.createElement("span");
        statusLabel.className = baseLabelClasses;
        statusLabel.textContent = "Status";
        transactionStatus = document.createElement("span");
        transactionStatus.id = "checkout_tx_status";
        transactionStatus.className = baseValueClasses;
        transactionStatus.textContent = "Pending";
        statusRow.append(statusLabel, transactionStatus);
        summaryContainer.append(txHashRow, statusRow);
        return {
            txHashRow: txHashRow,
            transactionHashText: transactionHashText,
            transactionHashLink: transactionHashLink,
            transactionStatus: transactionStatus
        };
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
}









function $04945de706d76f6e$var$formatMmSs(totalSec) {
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
const $04945de706d76f6e$var$TIMER_STYLES = {
    normal: {
        row: [
            "bg-thm-body-warning-bg",
            "border-thm-body-warning-border-color"
        ],
        icon: [
            "text-thm-body-warning-text-and-icon-color"
        ],
        text: [
            "text-thm-body-warning-text-and-icon-color"
        ]
    },
    orange: {
        row: [
            "bg-thm-body-warning-bg",
            "border-thm-body-warning-border-color"
        ],
        icon: [
            "text-thm-body-warning-text-and-icon-color"
        ],
        text: [
            "text-thm-body-warning-text-and-icon-color"
        ]
    },
    red: {
        row: [
            "bg-thm-body-error-bg",
            "border-thm-body-error-border-color"
        ],
        icon: [
            "text-thm-body-error-text-and-icon-color"
        ],
        text: [
            "text-thm-body-error-text-and-icon-color"
        ]
    }
};
const $04945de706d76f6e$var$TIMER_STYLE_CLASSES = {
    row: Object.values($04945de706d76f6e$var$TIMER_STYLES).flatMap((style)=>style.row),
    icon: Object.values($04945de706d76f6e$var$TIMER_STYLES).flatMap((style)=>style.icon),
    text: Object.values($04945de706d76f6e$var$TIMER_STYLES).flatMap((style)=>style.text)
};
class $04945de706d76f6e$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "activeBlock",
        "qrSection",
        "qrToggle",
        "qrToggleText",
        "qrCode",
        "qrToggleIcon",
        "expiresIn",
        "timerRow",
        "waitingBlock",
        "expiredBlock",
        "spinner",
        "assetIcon",
        "assetHeading",
        "amountWithSymbol",
        "bannerSymbol",
        "bannerNetwork"
    ];
    static values = {
        code: String,
        session: String,
        amount: String,
        channelid: String,
        successRedirectUrl: String,
        failureRedirectUrl: String,
        /** Server-rendered: { wallets, error, chainId } from CreateEphemeralWalletsForDeposit */ walletsPayload: Object,
        /** Unix seconds when the ephemeral deposit address expires (CreatedOn + TTL from server). 0 = no countdown. */ expiresAtUnix: Number,
        networkExplorerLink: String
    };
    connect() {
        this.hideLoadingScreen();
        this._walletExpired = false;
        this.applyDirectTransferSelectionFromStorage();
        this.updateCheckoutOverviewFromCurrentAmount();
        if (this.hasExpiresAtUnixValue && this.expiresAtUnixValue > 0) this.startExpiryCountdown();
        else if (this.hasTimerRowTarget) this.timerRowTarget.classList.add("hidden");
        // Subscribe to Pusher for real-time deposit events.
        if (this.channelidValue) {
            (0, $009129975df2a041$export$2e2bcd8739ae039).connect(this.channelidValue);
            this._onDepositConfirmed = (e)=>this.handleDepositConfirmed(e);
            this._onDepositInsufficient = (e)=>this.handleDepositInsufficient(e);
            this._onDepositManualCheck = (e)=>this.handleDepositManualCheck(e);
            window.addEventListener("dd:deposit-confirmed", this._onDepositConfirmed);
            window.addEventListener("dd:deposit-insufficient", this._onDepositInsufficient);
            window.addEventListener("dd:deposit-manual-check", this._onDepositManualCheck);
        }
        this.initQrState();
    }
    disconnect() {
        if (this._expiryTimer) {
            clearInterval(this._expiryTimer);
            this._expiryTimer = null;
        }
        if (this._onDepositConfirmed) window.removeEventListener("dd:deposit-confirmed", this._onDepositConfirmed);
        if (this._onDepositInsufficient) window.removeEventListener("dd:deposit-insufficient", this._onDepositInsufficient);
        if (this._onDepositManualCheck) window.removeEventListener("dd:deposit-manual-check", this._onDepositManualCheck);
        if (this._qrDesktopMediaQuery && this._onDesktopMediaChange) {
            if (this._qrDesktopMediaQuery.removeEventListener) this._qrDesktopMediaQuery.removeEventListener("change", this._onDesktopMediaChange);
            else if (this._qrDesktopMediaQuery.removeListener) this._qrDesktopMediaQuery.removeListener(this._onDesktopMediaChange);
        }
    }
    initQrState() {
        if (!this.hasQrCodeTarget) return;
        this._qrDesktopMediaQuery = window.matchMedia("(min-width: 640px)");
        this.setQrExpanded(this._qrDesktopMediaQuery.matches);
        this._onDesktopMediaChange = (event)=>{
            this.setQrExpanded(event.matches);
        };
        if (this._qrDesktopMediaQuery.addEventListener) this._qrDesktopMediaQuery.addEventListener("change", this._onDesktopMediaChange);
        else if (this._qrDesktopMediaQuery.addListener) this._qrDesktopMediaQuery.addListener(this._onDesktopMediaChange);
    }
    setQrExpanded(isExpanded) {
        this.qrCodeTarget.classList.toggle("hidden", !isExpanded);
        this.qrCodeTarget.classList.toggle("flex", isExpanded);
        if (this.hasQrToggleTextTarget) this.qrToggleTextTarget.textContent = isExpanded ? "Hide QR" : "Show QR";
        if (this.hasQrToggleIconTarget) // Chevron down when collapsed (tap to expand), chevron up when expanded (tap to collapse)
        this.qrToggleIconTarget.innerHTML = isExpanded ? '<path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />' : '<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />';
    }
    startExpiryCountdown() {
        const tick = ()=>{
            const nowSec = Math.floor(Date.now() / 1000);
            const rem = Math.max(0, this.expiresAtUnixValue - nowSec);
            if (this.hasExpiresInTarget) this.expiresInTarget.textContent = $04945de706d76f6e$var$formatMmSs(rem);
            this.updateTimerColorState(rem);
            if (rem <= 0) {
                if (this._expiryTimer) {
                    clearInterval(this._expiryTimer);
                    this._expiryTimer = null;
                }
                this.showWalletExpired();
            }
        };
        tick();
        this._expiryTimer = setInterval(tick, 1000);
    }
    updateTimerColorState(remainingSeconds) {
        if (!this.hasTimerRowTarget) return;
        const state = remainingSeconds <= 60 ? "red" : remainingSeconds <= 300 ? "orange" : "normal";
        const timerStyle = $04945de706d76f6e$var$TIMER_STYLES[state];
        if (!timerStyle) return;
        this.timerRowTarget.classList.remove(...$04945de706d76f6e$var$TIMER_STYLE_CLASSES.row);
        this.timerRowTarget.classList.add(...timerStyle.row);
        const iconElement = this.timerRowTarget.querySelector("svg");
        if (iconElement) {
            iconElement.classList.remove(...$04945de706d76f6e$var$TIMER_STYLE_CLASSES.icon);
            iconElement.classList.add(...timerStyle.icon);
        }
        const textElement = this.timerRowTarget.querySelector("span.text-sm");
        if (textElement) {
            textElement.classList.remove(...$04945de706d76f6e$var$TIMER_STYLE_CLASSES.text);
            textElement.classList.add(...timerStyle.text);
        }
    }
    showWalletExpired() {
        if (this._walletExpired) return;
        this._walletExpired = true;
        if (this.hasActiveBlockTarget) this.activeBlockTarget.classList.add("hidden");
        if (this.hasTimerRowTarget) this.timerRowTarget.classList.add("hidden");
        if (this.hasWaitingBlockTarget) this.waitingBlockTarget.classList.add("hidden");
        if (this.hasExpiredBlockTarget) this.expiredBlockTarget.classList.remove("hidden");
    }
    handleDepositConfirmed(event) {
        const txHash = String(event.detail?.tx_hash || "");
        const amountReceived = String(event.detail?.amount_received || "");
        if (txHash && amountReceived) (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_dd_deposit_detected", {
            tx_hash: txHash,
            amount_received: amountReceived
        });
        if (this._walletExpired) return;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("DirectDeposit: deposit confirmed!", event.detail);
        (0, $09439d601cee3d34$export$7ca9f8ef177c706)();
        const successRedirectURL = this.getValidatedRedirectURL(this.successRedirectUrlValue);
        if (successRedirectURL) {
            window.location.assign(successRedirectURL);
            return;
        }
        const txExplorerURL = String(event.detail.tx_explorer_url || "");
        if (txExplorerURL !== "") sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_EXPLORER_URL, txExplorerURL);
        else sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_EXPLORER_URL);
        const url = `/${this.codeValue}/direct-deposit-success?session=${encodeURIComponent(this.sessionValue)}`;
        $16d9fec6fae182d5$export$bf638b60ea8b89b7(url, {
            frame: "step_content",
            action: "advance"
        });
    }
    handleDepositInsufficient(event) {
        if (this._walletExpired) return;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("DirectDeposit: deposit insufficient!", event.detail);
        this.persistInsufficientResult(event.detail);
        (0, $09439d601cee3d34$export$4df6a7e99db786c4)();
        const failureRedirectURL = this.getValidatedRedirectURL(this.failureRedirectUrlValue);
        if (failureRedirectURL) {
            window.location.assign(failureRedirectURL);
            return;
        }
        const url = `/${this.codeValue}/direct-deposit-insufficient-funds?session=${encodeURIComponent(this.sessionValue)}`;
        $16d9fec6fae182d5$export$bf638b60ea8b89b7(url, {
            frame: "step_content",
            action: "advance"
        });
    }
    persistInsufficientResult(payload) {
        if (!payload || typeof payload !== "object") return;
        const requiredAmount = String(payload.required_amount || "").trim();
        const receivedAmount = String(payload.received_amount || "").trim();
        const requiredToken = String(payload.required_token || payload.received_token || "").trim();
        const receivedToken = String(payload.received_token || payload.required_token || "").trim();
        if (!requiredAmount || !receivedAmount) return;
        const result = {
            requiredAmount: requiredAmount,
            receivedAmount: receivedAmount,
            requiredToken: requiredToken,
            receivedToken: receivedToken
        };
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_INSUFFICIENT_RESULT, JSON.stringify(result));
    }
    handleDepositManualCheck(event) {
        if (this._walletExpired) return;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("DirectDeposit: deposit needs manual check!", event.detail);
        const url = `/${this.codeValue}/direct-deposit-manual-check?session=${encodeURIComponent(this.sessionValue)}`;
        $16d9fec6fae182d5$export$bf638b60ea8b89b7(url, {
            frame: "step_content",
            action: "advance"
        });
    }
    /** Applies token/network/icon chosen on direct-transfer-options (sessionStorage). */ applyDirectTransferSelectionFromStorage() {
        const symbol = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_SYMBOL);
        const network = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_NETWORK);
        const icon = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_TRANSFER_ICON);
        if (!symbol || !network) return;
        if (this.hasAssetIconTarget) {
            if (icon) this.assetIconTarget.src = icon;
            this.assetIconTarget.alt = symbol;
        }
        if (this.hasAssetHeadingTarget) this.assetHeadingTarget.textContent = `${symbol} (${network})`;
        // Use the server-rendered Stimulus value ({{ amount }}) as the single source of truth.
        // sessionStorage carried a stale price from the token-selection page which overwrote
        // the fresh server value, causing Alchemy Gate 1 to reject every volatile-token deposit.
        const amt = this.amountValue && this.amountValue !== "" ? this.amountValue : "0";
        const line = `${amt} ${symbol}`;
        this.amountWithSymbolTargets.forEach((el)=>{
            el.textContent = line;
        });
        if (this.hasBannerSymbolTarget) this.bannerSymbolTarget.textContent = symbol;
        if (this.hasBannerNetworkTarget) this.bannerNetworkTarget.textContent = network;
        this.updateCheckoutPaymentMethod(symbol, network);
        this.updateCheckoutOverviewFromCurrentAmount();
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("DirectDeposit: applied asset from storage", {
            symbol: symbol,
            network: network,
            icon: icon
        });
    }
    /**
   * Sync checkout overview total from what this page currently displays.
   * This keeps overview values consistent on direct-deposit Turbo visits and reloads,
   * without affecting non-direct-deposit pages.
   */ updateCheckoutOverviewFromCurrentAmount() {
        if (!this.hasAmountWithSymbolTarget) return;
        const amountDisplay = (this.amountWithSymbolTarget.textContent || "").trim();
        if (!amountDisplay) return;
        const checkoutTotalAmount = document.getElementById("checkout_total_amount");
        if (checkoutTotalAmount) checkoutTotalAmount.textContent = amountDisplay;
        const checkoutPriceMobile = document.getElementById("checkout_price_mobile");
        if (checkoutPriceMobile) checkoutPriceMobile.textContent = `${amountDisplay}`;
    }
    updateCheckoutPaymentMethod(symbol, networkName) {
        const checkoutPaymentMethod = document.getElementById("checkout_payment_method");
        if (!checkoutPaymentMethod) return;
        const sym = (symbol || "").trim();
        const net = (networkName || "").trim();
        checkoutPaymentMethod.textContent = sym && net ? `${net} / ${sym}` : "Awaiting Selection";
    }
    toggleQr() {
        if (!this.hasQrCodeTarget) return;
        const isCurrentlyExpanded = this.qrCodeTarget.classList.contains("flex");
        this.setQrExpanded(!isCurrentlyExpanded);
    }
    changeAsset() {
        const url = `/${this.codeValue}/payment-options?session=${encodeURIComponent(this.sessionValue)}`;
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("DirectDepositController: changeAsset ->", url);
        $16d9fec6fae182d5$export$bf638b60ea8b89b7(url, {
            frame: "step_content",
            action: "advance"
        });
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
    getValidatedRedirectURL(urlValue) {
        if (!urlValue) return "";
        try {
            const u = new URL(urlValue, window.location.origin);
            if (u.protocol !== "http:" && u.protocol !== "https:") return "";
            return u.toString();
        } catch  {
            return "";
        }
    }
}



class $9065f32f05909292$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "container",
        "backdrop",
        "sheet"
    ];
    static values = {
        closeDeltaY: {
            type: Number,
            default: 100
        }
    };
    connect() {
        this._onKeydown = (e)=>{
            if (e.key === "Escape") this.close();
        };
        this._onTouchStart = this.handleTouchStart.bind(this);
        this._onTouchMove = this.handleTouchMove.bind(this);
        this._onTouchEnd = this.handleTouchEnd.bind(this);
    }
    disconnect() {
        document.removeEventListener("keydown", this._onKeydown);
        this.teardownDrag();
    }
    open(event) {
        if (event) event.preventDefault();
        if (!this.hasContainerTarget) return;
        const container = this.containerTarget;
        container.classList.remove("hidden");
        container.removeAttribute("inert");
        container.removeAttribute("aria-hidden");
        // The theme surface tokens are translucent (glass over the page background),
        // so a modal sheet would let page content show through. Force the panel fully
        // opaque by resolving its themed background color and dropping the alpha —
        // keeps the exact theme hue in light and dark, just solid.
        this.forceOpaqueSurface();
        // Animate in from a lowered, transparent state.
        if (this.hasBackdropTarget) this.backdropTarget.style.opacity = "0";
        if (this.hasSheetTarget) {
            this.sheetTarget.style.transform = "translateY(16px)";
            this.sheetTarget.style.opacity = "0";
        }
        requestAnimationFrame(()=>{
            if (this.hasBackdropTarget) this.backdropTarget.style.opacity = "1";
            if (this.hasSheetTarget) {
                this.sheetTarget.style.transform = "translateY(0)";
                this.sheetTarget.style.opacity = "1";
            }
        });
        document.addEventListener("keydown", this._onKeydown);
        if (this.isTouchDevice()) this.setupDrag();
        if (this.hasSheetTarget && this.sheetTarget.focus) this.sheetTarget.focus();
    }
    close() {
        if (!this.hasContainerTarget || this.containerTarget.classList.contains("hidden")) return;
        const container = this.containerTarget;
        container.classList.add("hidden");
        container.setAttribute("inert", "");
        container.setAttribute("aria-hidden", "true");
        document.removeEventListener("keydown", this._onKeydown);
        this.teardownDrag();
        // Reset inline styles so the next open animates (and re-resolves) cleanly.
        if (this.hasSheetTarget) {
            this.sheetTarget.style.transform = "";
            this.sheetTarget.style.opacity = "";
            this.sheetTarget.style.backgroundColor = "";
        }
        if (this.hasBackdropTarget) this.backdropTarget.style.opacity = "";
    }
    // Resolve the panel's themed background color and re-apply it with the alpha
    // stripped, so a translucent theme surface token becomes a solid, opaque panel
    // (same hue) that never lets page content show through.
    forceOpaqueSurface() {
        if (!this.hasSheetTarget) return;
        const resolved = getComputedStyle(this.sheetTarget).backgroundColor;
        const parts = resolved?.match(/[\d.]+/g);
        if (parts && parts.length >= 3) this.sheetTarget.style.backgroundColor = `rgb(${parts[0]}, ${parts[1]}, ${parts[2]})`;
    }
    isTouchDevice() {
        return window.matchMedia("(pointer: coarse)").matches || "ontouchstart" in window;
    }
    setupDrag() {
        if (!this.hasSheetTarget) return;
        this._dragStartY = 0;
        this._dragging = false;
        this.sheetTarget.addEventListener("touchstart", this._onTouchStart, {
            passive: true
        });
        this.sheetTarget.addEventListener("touchmove", this._onTouchMove, {
            passive: true
        });
        this.sheetTarget.addEventListener("touchend", this._onTouchEnd, {
            passive: true
        });
    }
    teardownDrag() {
        if (!this.hasSheetTarget) return;
        this.sheetTarget.removeEventListener("touchstart", this._onTouchStart);
        this.sheetTarget.removeEventListener("touchmove", this._onTouchMove);
        this.sheetTarget.removeEventListener("touchend", this._onTouchEnd);
    }
    handleTouchStart(event) {
        this._dragStartY = event.touches[0].clientY;
        this._dragging = false;
    }
    handleTouchMove(event) {
        if (!this._dragStartY) return;
        const deltaY = event.touches[0].clientY - this._dragStartY;
        if (deltaY > 40) this._dragging = true;
        if (deltaY > 0) this.sheetTarget.style.transform = `translateY(${Math.min(deltaY, 400)}px)`;
    }
    handleTouchEnd(event) {
        if (!this._dragStartY) return;
        const deltaY = event.changedTouches[0].clientY - this._dragStartY;
        if (this._dragging && deltaY > this.closeDeltaYValue) this.close();
        else if (this.hasSheetTarget) this.sheetTarget.style.transform = "translateY(0)";
        this._dragStartY = 0;
        this._dragging = false;
    }
}






class $515f18e6c9f06652$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "totalPrice",
        "currency",
        "network",
        "txhash",
        "requiredAmount",
        "requiredToken",
        "receivedAmount",
        "receivedToken",
        "progressContainer",
        "progressBar",
        "progressStatusLabel",
        "progressDetectedLabel",
        "progressCompletedLabel",
        "finalContent",
        "orderSummary"
    ];
    connect() {
        // Shared controller also mounts on manual-check; only terminal outcomes set status.
        if ((0, $09439d601cee3d34$export$300337453d1210fb)()) (0, $09439d601cee3d34$export$7ca9f8ef177c706)();
        else if ((0, $09439d601cee3d34$export$b271613637009436)()) (0, $09439d601cee3d34$export$4df6a7e99db786c4)();
        this.progressTimeouts = [];
        this.hideLoadingScreen();
        this.fillOrderSummary();
        this.fillInsufficientAmounts();
        if (this.hasProgressBarTarget && this.hasFinalContentTarget && this.hasProgressContainerTarget) this.startProgress();
    }
    disconnect() {
        this.clearProgressTimers();
    }
    fillOrderSummary() {
        const checkoutPaymentMethod = document.getElementById("checkout_payment_method");
        const checkoutTotalAmount = document.getElementById("checkout_total_amount");
        if (!checkoutPaymentMethod || !checkoutTotalAmount) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("DirectDepositResultController: checkout overview nodes missing");
            return;
        }
        const methodText = checkoutPaymentMethod.textContent || "";
        const amountText = checkoutTotalAmount.textContent || "";
        const network = methodText.split(" / ")[0]?.trim() || "";
        const currency = methodText.split(" / ")[1]?.trim() || "";
        const price = amountText.split(" ")[0]?.trim() || "";
        if (this.hasTotalPriceTarget) this.totalPriceTarget.textContent = price ? `${price} ` : "";
        if (this.hasCurrencyTarget) this.currencyTarget.textContent = currency;
        if (this.hasNetworkTarget) this.networkTarget.textContent = network;
    }
    fillInsufficientAmounts() {
        const raw = sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_INSUFFICIENT_RESULT);
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw);
            if (this.hasRequiredAmountTarget) this.requiredAmountTarget.textContent = parsed.requiredAmount || "";
            if (this.hasRequiredTokenTarget) this.requiredTokenTarget.textContent = parsed.requiredToken || "";
            if (this.hasReceivedAmountTarget) this.receivedAmountTarget.textContent = parsed.receivedAmount || "";
            if (this.hasReceivedTokenTarget) this.receivedTokenTarget.textContent = parsed.receivedToken || "";
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("DirectDepositResultController: invalid insufficient payload", error);
        } finally{
            sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_INSUFFICIENT_RESULT);
        }
    }
    showLoadingScreen() {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: "Please Wait"
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
    startProgress() {
        this.updateProgressLabelsOpacity(0);
        this.setProgressStep(8, "Detected");
        this.progressTimeouts.push(setTimeout(()=>this.setProgressStep(16, "Detected"), 400), setTimeout(()=>this.setProgressStep(29, "Confirming"), 1200), // Intentional plateau to mimic network confirmation stalls.
        setTimeout(()=>this.setProgressStep(33, "Confirming"), 2100), setTimeout(()=>this.setProgressStep(48, "Confirming"), 3000), setTimeout(()=>this.setProgressStep(66, "Confirming"), 3900), setTimeout(()=>this.setProgressStep(78, "Confirming"), 4700), setTimeout(()=>this.setProgressStep(91, "Finalizing"), 5300), setTimeout(()=>this.completeProgress(), 5750));
    }
    completeProgress() {
        const txHash = String(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_EXPLORER_URL));
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("txHash value in Results controller", txHash);
        this.populateTxHashLink(txHash);
        // Reveal TX Hash / Status rows only after the fade-out, so they don't snap in.
        this.pendingSuccessRows = txHash !== "";
        sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DIRECT_DEPOSIT_EXPLORER_URL);
        this.setProgressStep(100, "Completed");
        // Match buy-app step transitions: fade out, then fade in (300ms each).
        this.progressTimeouts.push(setTimeout(()=>{
            this.fadeOutProgress();
            this.progressTimeouts.push(setTimeout(()=>{
                this.hideProgress();
                this.revealSuccessRows();
                this.showSuccessContent();
            }, 300));
        }, 300));
    }
    populateTxHashLink(rawExplorerURL) {
        if (!this.hasTxhashTarget) return;
        const linkElement = this.txhashTarget.querySelector("a");
        if (!linkElement) return;
        if (!rawExplorerURL) {
            linkElement.textContent = "";
            linkElement.removeAttribute("href");
            linkElement.removeAttribute("title");
            return;
        }
        try {
            const parsedURL = new URL(rawExplorerURL, window.location.origin);
            if (parsedURL.protocol !== "http:" && parsedURL.protocol !== "https:") throw new Error("Unsupported explorer URL protocol");
            // For hash-based explorers (e.g. tronscan.org/#/transaction/<hash>),
            // the identifier is in the fragment, not the pathname.
            const searchIn = parsedURL.hash ? parsedURL.hash.replace(/^#/, "") : parsedURL.pathname;
            const rawSegment = searchIn.split("/").filter(Boolean).pop() || parsedURL.toString();
            const decoded = decodeURIComponent(rawSegment);
            linkElement.href = parsedURL.toString();
            const shortDisplay = decoded.length > 8 ? `${decoded.slice(0, 4)}....${decoded.slice(-4)}` : decoded;
            linkElement.textContent = shortDisplay;
            linkElement.title = decoded;
        } catch (error) {
            (0, $df5856b8963e2c0f$export$280f90b954565303)("DirectDepositResultController: invalid explorer URL", error);
            linkElement.textContent = "";
            linkElement.removeAttribute("href");
            linkElement.removeAttribute("title");
        }
    }
    setProgressStep(percentage, text) {
        if (this.hasProgressBarTarget) this.progressBarTarget.style.width = `${percentage}%`;
        if (this.hasProgressStatusLabelTarget) {
            this.progressStatusLabelTarget.textContent = text;
            this.progressStatusLabelTarget.style.transition = "opacity .35s ease";
            this.progressStatusLabelTarget.style.opacity = percentage >= 100 ? "0.65" : "1";
        }
        this.updateProgressLabelsOpacity(percentage);
    }
    fadeOutProgress() {
        if (this.hasProgressContainerTarget) {
            this.progressContainerTarget.style.opacity = "0";
            this.progressContainerTarget.style.transform = "translateY(-20px)";
        }
        if (this.hasOrderSummaryTarget) {
            this.orderSummaryTarget.style.opacity = "0";
            this.orderSummaryTarget.style.transform = "translateY(-20px)";
        }
    }
    hideProgress() {
        if (!this.hasProgressContainerTarget) return;
        this.progressContainerTarget.classList.add("hidden");
    }
    revealSuccessRows() {
        if (!this.pendingSuccessRows) return;
        const successRow1 = document.getElementById("success_row_1");
        const successRow2 = document.getElementById("success_row_2");
        if (successRow1) {
            successRow1.classList.add("flex");
            successRow1.classList.remove("hidden");
        }
        if (successRow2) {
            successRow2.classList.add("flex");
            successRow2.classList.remove("hidden");
        }
    }
    showSuccessContent() {
        if (this.hasFinalContentTarget) {
            this.finalContentTarget.classList.remove("hidden");
            // Commit the opacity-0 / translateY(-20px) baseline before animating in
            // (same values as fadeInAnimationOnRender in app.js).
            this.finalContentTarget.offsetHeight;
            this.finalContentTarget.style.opacity = "1";
            this.finalContentTarget.style.transform = "translateY(0px)";
        }
        if (this.hasOrderSummaryTarget) {
            this.orderSummaryTarget.offsetHeight;
            this.orderSummaryTarget.style.opacity = "1";
            this.orderSummaryTarget.style.transform = "translateY(0px)";
        }
    }
    updateProgressLabelsOpacity(percentage) {
        if (this.hasProgressDetectedLabelTarget) {
            this.progressDetectedLabelTarget.style.transition = "opacity .35s ease";
            this.progressDetectedLabelTarget.style.opacity = percentage < 50 ? "1" : "0.35";
        }
        if (this.hasProgressCompletedLabelTarget) {
            this.progressCompletedLabelTarget.style.transition = "opacity .35s ease";
            this.progressCompletedLabelTarget.style.opacity = percentage >= 100 ? "1" : "0.35";
        }
    }
    clearProgressTimers() {
        if (!Array.isArray(this.progressTimeouts)) return;
        this.progressTimeouts.forEach((timeoutId)=>clearTimeout(timeoutId));
        this.progressTimeouts = [];
    }
}








const $dd5b7877d54ff66b$var$SECOND_MS = 1000;
const $dd5b7877d54ff66b$var$MINUTE_MS = 60 * $dd5b7877d54ff66b$var$SECOND_MS;
/**
 * The webhook stays the primary signal: the server leaves a pending deposit to it for the first
 * minute and only then starts asking Meld. Polls in that minute are DB-only and still catch a
 * webhook whose Pusher event was missed.
 */ const $dd5b7877d54ff66b$var$WEBHOOK_GRACE_MS = $dd5b7877d54ff66b$var$MINUTE_MS;
const $dd5b7877d54ff66b$var$FAST_POLL_WINDOW_MS = $dd5b7877d54ff66b$var$WEBHOOK_GRACE_MS + 3 * $dd5b7877d54ff66b$var$MINUTE_MS;
/** Matches ONRAMP_FINALIZING_TIMEOUT_MS: past it the timeout view and the 30-min job take over. */ const $dd5b7877d54ff66b$var$POLL_STOP_MS = 15 * $dd5b7877d54ff66b$var$MINUTE_MS;
const $dd5b7877d54ff66b$export$c3ad108b97095076 = 5 * $dd5b7877d54ff66b$var$SECOND_MS;
const $dd5b7877d54ff66b$export$a33e147b15618a97 = 30 * $dd5b7877d54ff66b$var$SECOND_MS;
function $dd5b7877d54ff66b$export$6646c3e0069dde8b(waitingMs) {
    if (waitingMs < $dd5b7877d54ff66b$var$FAST_POLL_WINDOW_MS) return $dd5b7877d54ff66b$export$c3ad108b97095076;
    if (waitingMs < $dd5b7877d54ff66b$var$POLL_STOP_MS) return $dd5b7877d54ff66b$export$a33e147b15618a97;
    return null;
}
function $dd5b7877d54ff66b$export$e9c1f1c90c041ebc(status, { sawPending: sawPending, waiting: waiting }) {
    switch(status){
        case "completed":
            return "advance";
        case "failed":
            return waiting ? "failed" : "wait";
        case "pending":
            return "pending";
        case "none":
            return sawPending ? "advance" : "wait";
        default:
            return "wait";
    }
}


/** postMessage type emitted by WaaS when the shopper picks card/bank (Meld/Stripe). */ const $1eb115dc4bea19fb$export$6acf1bf64841a8c2 = "checkout_onramp_method_selected";
const $1eb115dc4bea19fb$export$29683e7ac68ad070 = "checkout_onramp_payment_in_progress";
function $1eb115dc4bea19fb$export$15f04b537cd21d64(event, allowedOrigin) {
    const type = event?.data?.type;
    if (type !== $1eb115dc4bea19fb$export$6acf1bf64841a8c2 && type !== $1eb115dc4bea19fb$export$29683e7ac68ad070) return null;
    if (allowedOrigin && event.origin !== allowedOrigin) return null;
    return type === $1eb115dc4bea19fb$export$29683e7ac68ad070 ? "payment_in_progress" : "method_selected";
}


/** Ms without refocusing checkout after opening WM partner tab → checkout_wm_tab_abandoned (aligns with partner link expiry). */ const $7790db228f53cf26$var$WM_TAB_RETURN_TIMEOUT_MS = 900000;
/** Ms to wait for the embedded WaaS iframe before opening a backup tab (iframe stays visible). */ const $7790db228f53cf26$var$IFRAME_LOAD_TIMEOUT_MS = 45000;
/**
 * Two-tier onramp wait timeout (COI-365). The trigger for "waiting" is the return from the provider,
 * but the FIRST webhook is the only proof the deposit is real (vs a failed/abandoned attempt):
 *  - Confirming: returned from provider, no webhook yet → short wait, then offer a retry.
 *  - Finalizing: a webhook proved it → longer wait (it's settling), then "taking longer" + support.
 */ const $7790db228f53cf26$var$ONRAMP_CONFIRMING_TIMEOUT_MS = 180000;
const $7790db228f53cf26$var$ONRAMP_FINALIZING_TIMEOUT_MS = 900000;
class $7790db228f53cf26$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        channelid: String,
        addFundsBalanceUrl: String,
        paymentStatusUrl: String,
        partnerOnrampUrl: String,
        session: String,
        asset: String,
        onrampPending: Boolean,
        fromOnramp: Boolean,
        onrampFailed: Boolean
    };
    static targets = [
        "backButton",
        "pageTitle",
        "pageSubtitle",
        "purchaseShortfall",
        "topUpNotice",
        "balanceCheckActions",
        "embedView",
        "iframeLoading",
        "onrampFrame",
        "waitingView",
        "consolidatingView",
        "timeoutView",
        "timeoutTitle",
        "timeoutMessage",
        "retryButton",
        "chooseAnotherButton",
        "fallbackLink"
    ];
    connect() {
        if (!sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_FUNNEL_START_MS)) sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_FUNNEL_START_MS, String(Date.now()));
        this._allowedWaasOrigin = this.resolveAllowedWaasOrigin();
        this._onPostMessage = (e)=>this.handlePostMessage(e);
        globalThis.addEventListener("message", this._onPostMessage);
        // Back from the provider via the browser's back/forward cache, the page would resume a stale
        // pay screen. Reload so the server decides: payment in progress, failed, or pay.
        this._onPageShow = (e)=>{
            if (e.persisted) globalThis.location.reload();
        };
        globalThis.addEventListener("pageshow", this._onPageShow);
        if (this.onrampFailedValue) // The provider attempt already failed (webhook processed before this render) — nothing to
        // wait for, go straight to retry / choose another method.
        this.showFailedView();
        else if (this.onrampPendingValue) {
            // First webhook already proved a real pending deposit — show the finalizing spinner with the
            // long timeout (it's settling, just slow). No iframe: the shopper waits it out.
            this.showConsolidatingView();
            this._startOnrampTimeout(false);
        } else if (this.fromOnrampValue) {
            // Returned from the provider but no webhook yet — optimistically show the "confirming" spinner
            // with the SHORT timeout. If no webhook proves it, we assume the attempt failed/was abandoned
            // and offer a retry. Don't start a second onramp iframe here.
            this.showConfirmingView();
            this._startOnrampTimeout(true);
        } else this.startEmbeddedOnramp();
        this._sawPending = this.onrampPendingValue;
        if (!this.onrampFailedValue) this._startPaymentStatusPoll();
        if (this.channelidValue) {
            (0, $009129975df2a041$export$2e2bcd8739ae039).connect(this.channelidValue);
            this._onWaasFunded = (e)=>this.handleWaasFunded(e);
            globalThis.addEventListener("waas:funded", this._onWaasFunded);
            // A webhook is the proof the deposit is real: switch to the finalizing spinner and reset to the
            // long timeout. This also recovers if the optimistic timeout view is already showing.
            this._onOnrampReceived = ()=>{
                this.showConsolidatingView();
                this._startOnrampTimeout(false);
            };
            globalThis.addEventListener("waas:onramp_received", this._onOnrampReceived);
            this._onOnrampPending = ()=>{
                this.showOnrampPendingView();
                this._startOnrampTimeout(false);
            };
            globalThis.addEventListener("waas:onramp_pending", this._onOnrampPending);
            // Meld's failed webhook (declined card, KYC rejection, provider cancel): stop waiting and
            // offer the way out immediately. Only while we're actually waiting — a late failure event
            // from an earlier attempt must not yank the deposit chooser away mid-flow.
            this._onOnrampFailed = ()=>{
                if (!this._waiting) return;
                this.showFailedView();
            };
            globalThis.addEventListener("waas:onramp_failed", this._onOnrampFailed);
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: subscribed to channel", this.channelidValue);
        }
    }
    disconnect() {
        this.clearIframeLoadTimeout();
        this.clearWMTabAbandonWatch();
        this._clearOnrampTimeout();
        this._stopPaymentStatusPoll();
        if (this._onPostMessage) globalThis.removeEventListener("message", this._onPostMessage);
        if (this._onPageShow) globalThis.removeEventListener("pageshow", this._onPageShow);
        if (this._onWaasFunded) globalThis.removeEventListener("waas:funded", this._onWaasFunded);
        if (this._onOnrampReceived) globalThis.removeEventListener("waas:onramp_received", this._onOnrampReceived);
        if (this._onOnrampPending) globalThis.removeEventListener("waas:onramp_pending", this._onOnrampPending);
        if (this._onOnrampFailed) globalThis.removeEventListener("waas:onramp_failed", this._onOnrampFailed);
    }
    startEmbeddedOnramp() {
        if (!this.hasPartnerOnrampUrlValue || !this.partnerOnrampUrlValue) {
            this.fallbackToNewTab("missing_partner_url");
            return;
        }
        if (!this.hasOnrampFrameTarget) {
            this.fallbackToNewTab("missing_iframe");
            return;
        }
        this._waiting = false;
        this.clearIframeLoadTimeout();
        this._iframeLoadTimeout = globalThis.setTimeout(()=>{
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: iframe load timed out");
            this.fallbackToNewTab("load_timeout");
        }, $7790db228f53cf26$var$IFRAME_LOAD_TIMEOUT_MS);
        this.onrampFrameTarget.src = this.partnerOnrampUrlValue;
    }
    handleIframeLoad() {
        this.clearIframeLoadTimeout();
        if (this.hasIframeLoadingTarget) this.iframeLoadingTarget.classList.add("hidden");
        if (this.hasOnrampFrameTarget) this.onrampFrameTarget.classList.remove("hidden");
    }
    handlePostMessage(event) {
        switch((0, $1eb115dc4bea19fb$export$15f04b537cd21d64)(event, this._allowedWaasOrigin)){
            case "method_selected":
                this.recordPartnerRedirect(event.data.href || this.partnerOnrampUrlValue);
                break;
            case "payment_in_progress":
                // The embed refused a second payment: one is already pending for this checkout.
                this._sawPending = true;
                this.showOnrampPendingView();
                this._startOnrampTimeout(false);
                this._startPaymentStatusPoll();
                break;
        }
    }
    // showOnrampPendingView locks the page while an onramp is in flight: the
    // onramp iframe is hidden so the shopper can't start another deposit, and the
    // page advances on its own once the deposit settles (waas_funded or the status poll).
    showOnrampPendingView() {
        this._beginWaiting();
        this.clearIframeLoadTimeout();
        this.hidePurchaseShortfall();
        this._hideTimeoutView();
        // Lock the shopper in: an onramp is in flight, so they can't go back and
        // pick a different payment option.
        if (this.hasBackButtonTarget) this.backButtonTarget.classList.add("hidden");
        if (this.hasEmbedViewTarget) this.embedViewTarget.classList.add("hidden");
        if (this.hasWaitingViewTarget) this.waitingViewTarget.classList.add("hidden");
        if (this.hasPageTitleTarget) this.pageTitleTarget.textContent = "Payment in progress";
        this._setSubtitle("Funds detected. Confirming your deposit. This usually takes 2\u20133 minutes.");
        if (this.hasConsolidatingViewTarget) this.consolidatingViewTarget.classList.remove("hidden");
    }
    showConsolidatingView() {
        this._beginWaiting();
        this.hidePurchaseShortfall();
        this._hideTimeoutView();
        if (this.hasWaitingViewTarget) this.waitingViewTarget.classList.add("hidden");
        if (this.hasBackButtonTarget) this.backButtonTarget.classList.add("hidden");
        if (this.hasEmbedViewTarget) this.embedViewTarget.classList.add("hidden");
        if (this.hasPageTitleTarget) this.pageTitleTarget.textContent = "Payment in progress";
        this._setSubtitle("Funds detected. Confirming your deposit. This usually takes 2\u20133 minutes.");
        if (this.hasConsolidatingViewTarget) this.consolidatingViewTarget.classList.remove("hidden");
    }
    // showConfirmingView is the optimistic post-provider state: the shopper is back from the provider
    // but no webhook has proven the deposit yet. Same spinner as finalizing, softer copy.
    showConfirmingView() {
        this._beginWaiting();
        this.clearIframeLoadTimeout();
        this.hidePurchaseShortfall();
        this._hideTimeoutView();
        if (this.hasBackButtonTarget) this.backButtonTarget.classList.add("hidden");
        if (this.hasEmbedViewTarget) this.embedViewTarget.classList.add("hidden");
        if (this.hasWaitingViewTarget) this.waitingViewTarget.classList.add("hidden");
        if (this.hasPageTitleTarget) this.pageTitleTarget.textContent = "Confirming your payment";
        this._setSubtitle("This usually takes a minute \u2014 we'll continue automatically once it arrives.");
        if (this.hasConsolidatingViewTarget) this.consolidatingViewTarget.classList.remove("hidden");
    }
    // showTimeoutView surfaces after the wait times out. optimistic=true → no webhook ever proved the
    // deposit (likely a failed/abandoned attempt) → offer a retry with the same email. optimistic=false
    // → a webhook proved it but it's slow → keep it soft, no retry (funds are coming; a retry would
    // start a second onramp).
    showTimeoutView(optimistic) {
        this.clearIframeLoadTimeout();
        this.hidePurchaseShortfall();
        if (this.hasEmbedViewTarget) this.embedViewTarget.classList.add("hidden");
        if (this.hasWaitingViewTarget) this.waitingViewTarget.classList.add("hidden");
        if (this.hasConsolidatingViewTarget) this.consolidatingViewTarget.classList.add("hidden");
        if (this.hasBackButtonTarget) this.backButtonTarget.classList.add("hidden");
        if (this.hasPageTitleTarget) this.pageTitleTarget.textContent = optimistic ? "Confirming your payment" : "Almost there";
        this._setSubtitle("");
        if (this.hasTimeoutTitleTarget) this.timeoutTitleTarget.textContent = optimistic ? "We haven't received your payment yet" : "This is taking longer than expected";
        if (this.hasTimeoutMessageTarget) this.timeoutMessageTarget.textContent = optimistic ? "If you completed the payment it can take a moment to arrive. Check again, or try once more with the same email." : "Your payment is confirmed and still settling. Check again in a moment, or contact support if it doesn't clear.";
        if (this.hasRetryButtonTarget) this.retryButtonTarget.classList.toggle("hidden", !optimistic);
        if (this.hasChooseAnotherButtonTarget) this.chooseAnotherButtonTarget.classList.toggle("hidden", !optimistic);
        if (this.hasTimeoutViewTarget) this.timeoutViewTarget.classList.remove("hidden");
    }
    // showFailedView: the provider reported the attempt failed (declined card, KYC, cancel), so
    // there is nothing to confirm. Same panel as the timeout view, definite copy, both ways out:
    // retry on the same wallet, or go back and pick another payment method (COI-833).
    showFailedView() {
        this._waiting = false;
        this._clearOnrampTimeout();
        this._stopPaymentStatusPoll();
        this.clearWMTabAbandonWatch();
        this.clearIframeLoadTimeout();
        this.hidePurchaseShortfall();
        if (this.hasEmbedViewTarget) this.embedViewTarget.classList.add("hidden");
        if (this.hasWaitingViewTarget) this.waitingViewTarget.classList.add("hidden");
        if (this.hasConsolidatingViewTarget) this.consolidatingViewTarget.classList.add("hidden");
        if (this.hasBackButtonTarget) this.backButtonTarget.classList.add("hidden");
        if (this.hasPageTitleTarget) this.pageTitleTarget.textContent = "Payment not completed";
        this._setSubtitle("");
        if (this.hasTimeoutTitleTarget) this.timeoutTitleTarget.textContent = "Your payment didn't go through";
        if (this.hasTimeoutMessageTarget) this.timeoutMessageTarget.textContent = "The card provider didn't complete this payment, so nothing was charged to your wallet. You can try again or choose another way to pay.";
        if (this.hasRetryButtonTarget) this.retryButtonTarget.classList.remove("hidden");
        if (this.hasChooseAnotherButtonTarget) this.chooseAnotherButtonTarget.classList.remove("hidden");
        if (this.hasTimeoutViewTarget) this.timeoutViewTarget.classList.remove("hidden");
        (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_wm_onramp_failed", {});
    }
    // retryOnramp restarts the onramp on the same session/wallet: reload the add-funds page WITHOUT
    // from_onramp so the deposit chooser loads again. The wallet is deterministic per account, so any
    // late funds from the earlier attempt still land here — retrying can't strand money or send it to
    // a different wallet.
    retryOnramp(event) {
        event?.preventDefault();
        const u = new URL(globalThis.location.href);
        u.searchParams.delete("from_onramp");
        u.searchParams.set("_bc", String(Date.now()));
        globalThis.location.assign(u.toString());
    }
    _startOnrampTimeout(optimistic) {
        this._clearOnrampTimeout();
        const ms = optimistic ? $7790db228f53cf26$var$ONRAMP_CONFIRMING_TIMEOUT_MS : $7790db228f53cf26$var$ONRAMP_FINALIZING_TIMEOUT_MS;
        this._onrampTimeout = globalThis.setTimeout(()=>{
            this._onrampTimeout = null;
            this.showTimeoutView(optimistic);
        }, ms);
    }
    // _beginWaiting marks the page as waiting on a payment and starts the poll clock on the first
    // call, so polling switches from the idle cadence to the fast one straight away.
    _beginWaiting() {
        this._waiting = true;
        if (this._waitingSinceMs) return;
        this._waitingSinceMs = Date.now();
        if (this._paymentStatusPollActive) this._scheduleNextPoll(0);
    }
    _startPaymentStatusPoll() {
        if (!this.hasPaymentStatusUrlValue || !this.paymentStatusUrlValue) return;
        this._paymentStatusPollActive = true;
        this._scheduleNextPoll(this._waiting ? 0 : (0, $dd5b7877d54ff66b$export$a33e147b15618a97));
    }
    _nextPollDelayMs() {
        if (!this._waiting) return 0, $dd5b7877d54ff66b$export$a33e147b15618a97;
        return (0, $dd5b7877d54ff66b$export$6646c3e0069dde8b)(Date.now() - this._waitingSinceMs);
    }
    _scheduleNextPoll(delayMs) {
        this._clearPaymentStatusTimer();
        if (delayMs === null) {
            this._paymentStatusPollActive = false;
            return;
        }
        this._paymentStatusPoll = globalThis.setTimeout(async ()=>{
            this._paymentStatusPoll = null;
            try {
                await this._pollPaymentStatus();
            } catch (err) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: status poll failed", err);
            }
            if (this._paymentStatusPollActive && !this._paymentStatusPoll) this._scheduleNextPoll(this._nextPollDelayMs());
        }, delayMs);
    }
    _stopPaymentStatusPoll() {
        this._paymentStatusPollActive = false;
        this._clearPaymentStatusTimer();
    }
    _clearPaymentStatusTimer() {
        if (this._paymentStatusPoll) {
            globalThis.clearTimeout(this._paymentStatusPoll);
            this._paymentStatusPoll = null;
        }
    }
    async _pollPaymentStatus() {
        if (this._statusPollInFlight) return;
        this._statusPollInFlight = true;
        try {
            const url = new URL(this.paymentStatusUrlValue, globalThis.location.href);
            url.searchParams.set("_bc", String(Date.now()));
            const res = await fetch(url.toString(), {
                headers: {
                    Accept: "application/json"
                },
                cache: "no-store",
                credentials: "same-origin"
            });
            if (!res.ok) return;
            const { status: status } = await res.json();
            this._applyPaymentStatus(status);
        } finally{
            this._statusPollInFlight = false;
        }
    }
    _applyPaymentStatus(status) {
        switch((0, $dd5b7877d54ff66b$export$e9c1f1c90c041ebc)(status, {
            sawPending: this._sawPending,
            waiting: this._waiting
        })){
            case "advance":
                this._clearOnrampTimeout();
                this.navigateToBalanceCheck("status_poll");
                break;
            case "failed":
                this.showFailedView();
                break;
            case "pending":
                this._sawPending = true;
                if (!this._waiting) {
                    this.showConsolidatingView();
                    this._startOnrampTimeout(false);
                }
                break;
        }
    }
    _clearOnrampTimeout() {
        if (this._onrampTimeout) {
            globalThis.clearTimeout(this._onrampTimeout);
            this._onrampTimeout = null;
        }
    }
    _hideTimeoutView() {
        if (this.hasTimeoutViewTarget) this.timeoutViewTarget.classList.add("hidden");
    }
    // _setSubtitle sets the first subtitle line and hides any extra subtitle lines (the template has
    // two) so spinner/timeout states don't leave a stray sentence behind.
    _setSubtitle(text) {
        if (!this.hasPageSubtitleTarget) return;
        this.pageSubtitleTargets.forEach((el, i)=>{
            if (i === 0) {
                el.textContent = text;
                el.classList.toggle("hidden", !text);
            } else el.classList.add("hidden");
        });
    }
    fallbackToNewTab(reason) {
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: opening backup onramp tab (iframe stays visible)", {
            reason: reason
        });
        this.clearIframeLoadTimeout();
        const url = this.hasPartnerOnrampUrlValue ? this.partnerOnrampUrlValue : "";
        if (!url) {
            // No provider URL at all — the buy-crypto window can never load (ONR-03).
            (0, $9286460a480b22e8$export$b542b247691f8019)("buy-unavailable");
            return;
        }
        if (this.hasFallbackLinkTarget) this.fallbackLinkTarget.click();
        else globalThis.open(url, "_blank", "noopener,noreferrer");
        this.recordPartnerRedirect(url);
    }
    recordPartnerRedirect(href) {
        this.hidePurchaseShortfall();
        let domain = "";
        try {
            domain = new URL(href, globalThis.location.href).hostname || "";
        } catch (_) {
        /* swallow */ }
        if (!domain) return;
        if (this.hasSessionValue && this.sessionValue) sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION, this.sessionValue);
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_FUNNEL_START_MS, String(Date.now()));
        (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_wm_redirect", {
            redirect_url_domain: domain
        });
        this.scheduleWMTabAbandonWatch();
    }
    hidePurchaseShortfall() {
        if (this.hasPurchaseShortfallTarget) this.purchaseShortfallTarget.classList.add("hidden");
        // The top-up notice (COI-833) is the shortfall explanation for the embedded second onramp;
        // once the shopper is redirected to the provider or a spinner state takes over, it's stale.
        if (this.hasTopUpNoticeTarget) this.topUpNoticeTarget.classList.add("hidden");
    }
    navigateToBalanceCheck(source) {
        if (!this.hasAddFundsBalanceUrlValue || !this.addFundsBalanceUrlValue) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: balance check skipped \u2014 missing URL", {
                source: source
            });
            return false;
        }
        if (this._navigating) return true;
        this._navigating = true;
        this._stopPaymentStatusPoll();
        this.hidePurchaseShortfall();
        const checkURL = new URL(this.addFundsBalanceUrlValue, globalThis.location.href);
        checkURL.searchParams.set("_bc", String(Date.now()));
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: navigating to balance check", {
            source: source,
            url: checkURL.toString()
        });
        globalThis.location.assign(checkURL.toString());
        return true;
    }
    checkBalanceNow(event) {
        event?.preventDefault();
        this.navigateToBalanceCheck("manual_reload");
    }
    resolveAllowedWaasOrigin() {
        if (!this.hasPartnerOnrampUrlValue || !this.partnerOnrampUrlValue) return "";
        try {
            return new URL(this.partnerOnrampUrlValue).origin;
        } catch (_) {
            return "";
        }
    }
    clearIframeLoadTimeout() {
        if (this._iframeLoadTimeout) {
            globalThis.clearTimeout(this._iframeLoadTimeout);
            this._iframeLoadTimeout = null;
        }
    }
    scheduleWMTabAbandonWatch() {
        this.clearWMTabAbandonWatch();
        this._wmRedirectAtMs = Date.now();
        this._wmAbandonTimeout = globalThis.setTimeout(()=>{
            const elapsed = Date.now() - (this._wmRedirectAtMs || Date.now());
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_wm_tab_abandoned", {
                time_since_redirect_ms: String(elapsed)
            });
            this._wmAbandonTimeout = null;
        }, $7790db228f53cf26$var$WM_TAB_RETURN_TIMEOUT_MS);
        this._onWMVisibilityReturn = ()=>{
            if (typeof document !== "undefined" && document.visibilityState === "visible") this.clearWMTabAbandonWatch();
        };
        if (typeof document !== "undefined") document.addEventListener("visibilitychange", this._onWMVisibilityReturn);
    }
    clearWMTabAbandonWatch() {
        if (this._wmAbandonTimeout) {
            globalThis.clearTimeout(this._wmAbandonTimeout);
            this._wmAbandonTimeout = null;
        }
        if (this._onWMVisibilityReturn && typeof document !== "undefined") {
            document.removeEventListener("visibilitychange", this._onWMVisibilityReturn);
            this._onWMVisibilityReturn = null;
        }
    }
    handleWaasFunded(event) {
        this.clearWMTabAbandonWatch();
        this._clearOnrampTimeout();
        const detail = event.detail || {};
        const balanceUSD = Number.parseFloat(detail.balanceUSD) || 0;
        const prevBal = Number.parseFloat(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_LAST_BALANCE_USD) || "") || 0;
        const purchased = balanceUSD > prevBal ? balanceUSD - prevBal : balanceUSD > 0 ? balanceUSD : 0;
        const startMs = Number.parseInt(sessionStorage.getItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_FUNNEL_START_MS) || "", 10);
        const elapsed = Number.isFinite(startMs) && startMs > 0 ? Date.now() - startMs : 0;
        const asset = (this.hasAssetValue && this.assetValue ? this.assetValue : "USDC").trim();
        if (this.hasSessionValue && this.sessionValue) sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION, this.sessionValue);
        if (balanceUSD > 0 || purchased > 0) {
            sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).WM_LAST_BALANCE_USD, String(balanceUSD));
            (0, $1252f7a92d470115$export$905424921aab8cd6)("checkout_wm_balance_updated", {
                amount_purchased_crypto: purchased > 0 ? purchased.toFixed(8) : "",
                asset: asset,
                time_in_wm_ms: elapsed > 0 ? String(elapsed) : ""
            });
        }
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("AddFundsWallet: waas_funded received", {
            balanceUSD: balanceUSD
        });
        this.navigateToBalanceCheck("waas_funded");
    }
}



class $eaa6e74b724780b4$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "panel",
        "chevron",
        "trigger"
    ];
    static values = {
        enabled: {
            type: Boolean,
            default: true
        }
    };
    enabledValueChanged(enabled) {
        if (this.hasChevronTarget) this.chevronTarget.classList.toggle("hidden", !enabled);
        if (this.hasTriggerTarget) this.triggerTarget.classList.toggle("cursor-pointer", enabled && this.hasPanelTarget);
        if (!enabled) this.collapse();
    }
    toggle() {
        if (!this.enabledValue || !this.hasPanelTarget) return;
        const expanded = !this.panelTarget.classList.toggle("hidden");
        if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180", expanded);
    }
    collapse() {
        if (this.hasPanelTarget) this.panelTarget.classList.add("hidden");
        if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180");
    }
}





class $72d51806423603b9$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "text",
        "icon"
    ];
    static values = {
        text: String,
        successMessage: {
            type: String,
            default: "Copied!"
        },
        errorMessage: {
            type: String,
            default: "Failed to copy"
        },
        // Opt-in analytics: when set, emit this event via emitCheckoutEvent when copy is successful. Since this controller
        // is reused across the checkout — keeping the emit gated by this value
        // avoids accidental funnel events on unrelated copy buttons.
        analyticsEvent: String
    };
    connect() {
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Copy Controller Connected");
    }
    async copy() {
        try {
            // Get the text to copy (either from value or target)
            let textToCopy = this.hasTextValue ? this.textValue : this.textTarget.textContent;
            // Use the modern Clipboard API
            await navigator.clipboard.writeText(textToCopy);
            // Show success feedback
            this.showSuccess();
            this.emitAnalytics();
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Text copied successfully:", textToCopy);
        } catch (error) {
            // Fallback for older browsers or if clipboard API fails
            this.fallbackCopy();
        }
    }
    emitAnalytics() {
        if (!this.analyticsEventValue) return;
        (0, $1252f7a92d470115$export$905424921aab8cd6)(this.analyticsEventValue, {
            copy_method: "clipboard"
        });
    }
    showSuccess() {
        // Change icon to checkmark temporarily
        if (this.hasIconTarget) {
            const originalHTML = this.iconTarget.innerHTML;
            // Change to checkmark icon
            this.iconTarget.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path d="M7.5 10L9.5 12L13.5 8" stroke="rgb(var(--primary-color))" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
            // Add success class for styling
            this.element.classList.add('copy-success');
            // Revert back after 2 seconds
            setTimeout(()=>{
                this.iconTarget.innerHTML = originalHTML;
                this.element.classList.remove('copy-success');
            }, 2000);
        }
    }
    fallbackCopy() {
        // Fallback method for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = this.hasTextValue ? this.textValue : this.textTarget.textContent;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            this.showSuccess();
            this.emitAnalytics();
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Text copied using fallback method");
        } catch (error) {
            (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Copy failed:", error);
            this.showError();
        } finally{
            document.body.removeChild(textArea);
        }
    }
    showError() {
        // Show error feedback
        if (this.hasIconTarget) {
            const originalHTML = this.iconTarget.innerHTML;
            // Change to error icon
            this.iconTarget.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path d="M10 7V10M10 13H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
            // Add error class for styling
            this.element.classList.add('copy-error');
            // Revert back after 2 seconds
            setTimeout(()=>{
                this.iconTarget.innerHTML = originalHTML;
                this.element.classList.remove('copy-error');
            }, 2000);
        }
    }
    disconnect() {
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Copy Controller Disconnected");
    }
}



class $9dd7332bd010ca2c$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "container",
        "text"
    ];
    show({ detail: { text: text } }) {
        const self = this;
        self.textTarget.textContent = text;
        self.containerTarget.classList.remove("hidden");
        setTimeout(function() {
            self.containerTarget.style.opacity = 1;
        }, 10);
    }
    hide() {
        const self = this;
        self.containerTarget.style.opacity = 0;
        setTimeout(function() {
            self.containerTarget.classList.add("hidden");
        }, 150);
    }
    updateText({ detail: { text: text } }) {
        this.textTarget.textContent = text;
    }
}



class $1c82a6608b3cd2bf$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    endpoint = "/analytics/event";
    connect() {
        this.viewport = this.resolveViewport();
        this.boundUnload = this.handleBeforeUnload.bind(this);
        window.addEventListener("beforeunload", this.boundUnload);
        this.connectedAt = Date.now();
    }
    disconnect() {
        if (this.boundUnload) window.removeEventListener("beforeunload", this.boundUnload);
    }
    resolveViewport() {
        const fromAttr = this.element?.dataset?.analyticsViewport;
        if (fromAttr) return fromAttr;
        if (typeof window === "undefined") return "";
        const w = window.innerWidth || 0;
        if (w >= 1280) return "desktop";
        if (w >= 768) return "tablet";
        return "mobile";
    }
    handleBeforeUnload() {
        const lastStep = this.element?.dataset?.analyticsLastStep || "";
        const session = this.element?.dataset?.analyticsSession || "";
        const checkoutSessionId = this.element?.dataset?.analyticsCustomidCheckoutSessionId || "";
        const partnerId = this.element?.dataset?.analyticsCustomidPartnerId || "";
        const timeSpent = String(Date.now() - (this.connectedAt || Date.now()));
        const formData = new FormData();
        formData.append("event", "checkout_abandoned");
        formData.append("page", window.location.pathname);
        formData.append("ts", String(Date.now()));
        formData.append("viewport", this.viewport);
        if (session) formData.append("session", session);
        if (lastStep) formData.append("last_step", lastStep);
        formData.append("time_spent_ms", timeSpent);
        // Sent as a fallback for the rare case where the server-side session
        // load fails (cookie cleared, DB blip). When it succeeds, the backend
        // recovers these from sess.Data and ignores these fields.
        if (checkoutSessionId) formData.append("checkout_session_id", checkoutSessionId);
        if (partnerId) formData.append("partner_id", partnerId);
        if (navigator.sendBeacon) {
            const ok = navigator.sendBeacon(this.endpoint, formData);
            if (ok) return;
        }
        fetch(this.endpoint, {
            method: "POST",
            body: formData,
            keepalive: true
        }).catch(()=>{});
    }
}







class $d44c530371c6dc81$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        domain: Object,
        companyName: String,
        companyLightLogo: String,
        companyDarkLogo: String,
        code: String,
        session: String,
        thirdPartyWalletChangeHandler: false
    };
    initialize() {
        this.cachedAddress = null;
        // Only reset on bare /{code} entry. Outcome / already-paid loads also mount
        // this controller and must keep the completed status for the Back guard.
        if ((0, $09439d601cee3d34$export$faff0e25bbc1aa8)()) (0, $09439d601cee3d34$export$8cda6dea30c6a70e)();
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).CODE, this.codeValue);
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).DOMAIN, JSON.stringify(this.domainValue));
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).SESSION, this.sessionValue);
        sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).COMPANY_NAME, this.companyNameValue);
        this.watchAccounts = async (wallets)=>{
            // When we are are checking wallet changes.
            if (this.thirdPartyWalletChangeHandlerValue) {
                (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("watchAccounts wallets", wallets);
                if (wallets.length !== 0) try {
                    this.showLoadingScreen("Connecting New Wallet");
                    const currentAddress = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getWalletAddress();
                    // Prevent double invoking twice. 
                    if (!currentAddress || this.cachedAddress === currentAddress) return;
                    this.cachedAddress = currentAddress;
                    const form = document.getElementById("thirdPartyWalletForm");
                    form.action = "/select-third-party-wallet";
                    document.getElementById("third_party_wallet_form_wallet_type").value = "WALLET_CONNECT";
                    document.getElementById("third_party_wallet_form_address").value = currentAddress;
                    const connectorInput = document.getElementById("third_party_wallet_form_connector_label");
                    if (connectorInput) connectorInput.value = (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).getConnectedWalletLabel() || "";
                    form.requestSubmit();
                    this.hideLoadingScreen();
                } catch (error) {
                    console.error(error);
                }
                else this.cachedAddress = null;
            }
        };
        this.boundWatchAccounts = this.watchAccounts.bind(this);
        document.addEventListener("turbo:before-fetch-request", (event)=>{
            const { fetchOptions: fetchOptions } = event.detail;
            // fetchOptions is the same object Turbo will pass to fetch()
            // so you can mutate it in place.
            fetchOptions.headers["X-Requested-With"] = "Turbo";
            fetchOptions.headers["X-Session"] = this.sessionValue;
            fetchOptions.headers["X-Code"] = this.codeValue;
        });
    }
    keypressEnterEvent(e) {
        if (e.key !== "Enter") return;
        const checkoutButton = document.getElementsByClassName("step-button")[0];
        if (!checkoutButton) return;
        const pointerEvents = window.getComputedStyle(checkoutButton).pointerEvents;
        if (pointerEvents === "none") return;
        e.preventDefault();
        checkoutButton.click();
    }
    connect() {
        this.boundKeypressEnterEvent = this.keypressEnterEvent.bind(this);
        document.addEventListener("keydown", this.boundKeypressEnterEvent);
        (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).onWalletChange(this.boundWatchAccounts);
    }
    showLoadingScreen(message = "Please Wait") {
        this.dispatch("showLoadingScreen", {
            detail: {
                text: message
            }
        });
    }
    hideLoadingScreen() {
        this.dispatch("hideLoadingScreen");
    }
    listenWalletChange() {
        // Allow reconnecting the same wallet address after a back-navigation/disconnect cycle.
        this.cachedAddress = null;
        this.thirdPartyWalletChangeHandlerValue = true;
    }
    stopListeningWalletChange() {
        this.cachedAddress = null;
        this.thirdPartyWalletChangeHandlerValue = false;
    }
    disconnect() {
        document.removeEventListener("keydown", this.boundKeypressEnterEvent);
        (0, $527c3fde4aafeb25$export$2e2bcd8739ae039).removeWalletChangeListener(this.boundWatchAccounts);
    }
}



class $0cfa27d034322e67$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static targets = [
        "container"
    ];
    connect() {
        this.boundOpenDialog = this.openDialog.bind(this);
        document.addEventListener("open-dialog", this.boundOpenDialog);
    }
    disconnect() {
        document.removeEventListener("open-dialog", this.boundOpenDialog);
    }
    async openDialog(event) {
        const { dialogId: dialogId, posturl: posturl } = event.detail || {};
        if (!dialogId) return;
        // Close all OTHER modals, but ignore (do not close) the one we're opening
        document.dispatchEvent(new CustomEvent("modal:close-all", {
            detail: {
                exceptId: dialogId
            },
            bubbles: true
        }));
        // Let focus/aria settle before showing another
        await new Promise(requestAnimationFrame);
    // ⛔️ Do NOT remove existing modals here anymore.
    // If you want to fetch a fresh modal for this dialogId, do it explicitly:
    // if (posturl) {
    //   const res = await httpService.get(posturl);
    //   if (res.type === "html") {
    //     Turbo.renderStreamMessage(res.data);
    //   }
    // } else {
    //   // If no fetch, just ensure an existing modal with this ID is visible
    //   const modalRoot = this.containerTarget.querySelector(
    //     `[data-modal-dialog-id-value="${dialogId}"] [data-modal-target="modal"]`
    //   );
    //   if (modalRoot) {
    //     modalRoot.classList.remove("hidden");
    //     modalRoot.removeAttribute("inert");
    //     modalRoot.removeAttribute("aria-hidden");
    //   }
    // }
    }
}





class $bee0555672baad9b$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        channelid: String
    };
    /* when the channel is shifted on the backend, 
    the socket controller is loaded on the front-end
  to reconnect. */ connect() {
        (0, $df5856b8963e2c0f$export$140d7860bc6d1e6e)("Socket Controller Loaded");
        (0, $009129975df2a041$export$2e2bcd8739ae039).connect(this.channelidValue);
    }
}



class $decfc700a29aee0c$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    static values = {
        key: String
    };
    handleAction(event) {
        const kind = event.params.kind;
        switch(kind){
            case "refresh":
                this.reloadWithoutErrorParams();
                break;
            case "try_again":
                {
                    const retryEvent = new CustomEvent("error-surface:retry", {
                        detail: {
                            key: this.keyValue
                        },
                        bubbles: true,
                        cancelable: true
                    });
                    const handled = !this.element.dispatchEvent(retryEvent);
                    // Read before dismiss() empties the overlay, or it is always false.
                    const overlayCard = this.isOverlayCard();
                    this.dismiss();
                    if (!handled && !overlayCard) // Full-page surface with no step behind it: reload to a clean state.
                    this.reloadWithoutErrorParams();
                    break;
                }
            case "send_new_code":
                this.element.dispatchEvent(new CustomEvent("error-surface:resend", {
                    detail: {
                        key: this.keyValue
                    },
                    bubbles: true
                }));
                this.dismiss();
                break;
            default:
                this.dismiss();
        }
    }
    // Error markers in the query string would re-trigger the same surface on a
    // plain reload, looping the customer forever.
    reloadWithoutErrorParams() {
        const url = new URL(window.location.href);
        url.searchParams.delete("error");
        url.searchParams.delete("error_key");
        window.location.assign(url.toString());
    }
    dismiss() {
        const overlay = document.getElementById("error_overlay");
        if (overlay?.contains(this.element)) overlay.innerHTML = "";
    }
    isOverlayCard() {
        const overlay = document.getElementById("error_overlay");
        return Boolean(overlay?.contains(this.element));
    }
}



const $0e13eba4cf529f3e$var$TOAST_VISIBLE_MS = 4000;
class $0e13eba4cf529f3e$export$2e2bcd8739ae039 extends (0, $a7248a23ab27f746$export$bd0bf19f25da8474) {
    connect() {
        this.boundShow = this.show.bind(this);
        document.addEventListener("toast:show", this.boundShow);
    }
    disconnect() {
        document.removeEventListener("toast:show", this.boundShow);
        if (this.hideTimer) clearTimeout(this.hideTimer);
    }
    show(event) {
        const message = event.detail?.message;
        if (!message) return;
        if (this.hideTimer) clearTimeout(this.hideTimer);
        this.element.textContent = message;
        this.element.classList.remove("hidden", "opacity-0");
        this.hideTimer = setTimeout(()=>this.hide(), $0e13eba4cf529f3e$var$TOAST_VISIBLE_MS);
    }
    hide() {
        this.element.classList.add("opacity-0");
        setTimeout(()=>this.element.classList.add("hidden"), 300);
    }
}




// Track Turbo restore visits (browser back/forward) so wallet-connecting
// controllers can detect stale cached pages and force a clean reload.
document.addEventListener("turbo:visit", (event)=>{
    if (event.detail?.action === "restore") sessionStorage.setItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_PENDING, "1");
    else {
        sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_PENDING);
        sessionStorage.removeItem((0, $6278b20997bc647a$export$ddcffe0146c8f882).TURBO_RESTORE_RELOADED);
    }
    // Use the visit destination — window.location may still be the previous step
    // when we mark completed and then Turbo.visit an outcome URL.
    let pathname = window.location.pathname;
    const visitURL = event.detail?.url;
    if (visitURL) try {
        pathname = new URL(visitURL, window.location.origin).pathname;
    } catch (_) {
    // Keep current pathname if the visit URL is malformed.
    }
    // BE middleware may land here without the FE having marked yet.
    if ((0, $09439d601cee3d34$export$4f384f8a56444e02)(pathname)) (0, $09439d601cee3d34$export$7ca9f8ef177c706)();
    (0, $09439d601cee3d34$export$7f756e734dc45e16)(pathname);
});
window.Stimulus = (0, $a7248a23ab27f746$export$16975c34e60e1e61).start();
Stimulus.debug = "true";
// Steps
Stimulus.register("authorisation-dfns-with-permit", (0, $7749c40bd1cc6a71$export$2e2bcd8739ae039));
Stimulus.register("authorisation-dfns-without-permit", (0, $7d2cbf8c5a3a22ee$export$2e2bcd8739ae039));
Stimulus.register("authorisation-3rd-party-with-permit", (0, $aa92c694fec4f61a$export$2e2bcd8739ae039));
Stimulus.register("authorisation-3rd-party-without-permit", (0, $41f660d65e587d59$export$2e2bcd8739ae039));
Stimulus.register("blockchain-progress", (0, $0d619fe008bce62f$export$2e2bcd8739ae039));
Stimulus.register("checkout-form", (0, $9089923ccb187870$export$2e2bcd8739ae039));
Stimulus.register("add-funds-wallet", (0, $7790db228f53cf26$export$2e2bcd8739ae039));
Stimulus.register("coinsub-payment-options", (0, $eebfc3c4a0ce5733$export$2e2bcd8739ae039));
Stimulus.register("direct-deposit", (0, $04945de706d76f6e$export$2e2bcd8739ae039));
Stimulus.register("direct-deposit-result", (0, $515f18e6c9f06652$export$2e2bcd8739ae039));
Stimulus.register("otp", (0, $bb3e1c8304151088$export$2e2bcd8739ae039));
Stimulus.register("passkey", (0, $ebfc04dcf68de6b9$export$2e2bcd8739ae039));
Stimulus.register("payment-options", (0, $94dc8f501faf6971$export$2e2bcd8739ae039));
Stimulus.register("connect-wallet-only", (0, $0387ce938a34d8c9$export$2e2bcd8739ae039));
Stimulus.register("not-enough-balance", (0, $8e2dc7458e49ec68$export$2e2bcd8739ae039));
Stimulus.register("third-party-payment-options", (0, $7c22653eda9fb1cb$export$2e2bcd8739ae039));
Stimulus.register("order-summary", (0, $eaa6e74b724780b4$export$2e2bcd8739ae039));
Stimulus.register("review-dfns", (0, $48746cebd196b34e$export$2e2bcd8739ae039));
Stimulus.register("review-3rd-party-wallet", (0, $3579c543297cfb19$export$2e2bcd8739ae039));
Stimulus.register("fast-track-payment", (0, $43f1496dab15d7ce$export$2e2bcd8739ae039));
Stimulus.register("fast-track-otp-permit", (0, $79cbb1ddb950488d$export$2e2bcd8739ae039));
Stimulus.register("fast-track-otp-approve", (0, $8db7ba932a23c8a8$export$2e2bcd8739ae039));
Stimulus.register("fast-track-otp-pay", (0, $19c684597016fd38$export$2e2bcd8739ae039));
Stimulus.register("checkout", (0, $d44c530371c6dc81$export$2e2bcd8739ae039));
Stimulus.register("loadingscreen", (0, $9dd7332bd010ca2c$export$2e2bcd8739ae039));
Stimulus.register("copy", (0, $72d51806423603b9$export$2e2bcd8739ae039));
Stimulus.register("modal-container", (0, $0cfa27d034322e67$export$2e2bcd8739ae039));
Stimulus.register("bottom-sheet", (0, $9065f32f05909292$export$2e2bcd8739ae039));
Stimulus.register("error-surface", (0, $decfc700a29aee0c$export$2e2bcd8739ae039));
Stimulus.register("toast", (0, $0e13eba4cf529f3e$export$2e2bcd8739ae039));
Stimulus.register("socket", (0, $bee0555672baad9b$export$2e2bcd8739ae039));
Stimulus.register("analytics", (0, $1c82a6608b3cd2bf$export$2e2bcd8739ae039));
Stimulus.handleError = (error, message, detail)=>{
    (0, $df5856b8963e2c0f$export$280f90b954565303)(message, detail, error);
};
document.addEventListener("turbo:before-frame-render", (event)=>{
    if (event.target.id !== "step_content") return;
    if (event.detail?.action === "restore") return;
    event.preventDefault();
    const { resume: resume } = event.detail;
    $4ab85fa2a90a2892$var$fadeOutAnimationOnRender().then(()=>resume());
});
document.addEventListener("turbo:frame-render", (event)=>{
    if (event.target.id !== "step_content") return;
    if ((0, $09439d601cee3d34$export$7f756e734dc45e16)()) return;
    $4ab85fa2a90a2892$var$fadeInAnimationOnRender();
});
// Fast-track passkey steps (Authorize Allowance / Approve / Pay) arrive via
// Turbo.renderStreamMessage, which does not fire turbo:frame-render. Without
// this hook, .step-content / .step-button stay at the CSS opacity-0 baseline.
document.addEventListener("turbo:before-stream-render", (event)=>{
    if (event.target.getAttribute("target") !== "step_content") return;
    if ((0, $09439d601cee3d34$export$7f756e734dc45e16)()) {
        event.preventDefault();
        return;
    }
    const originalRender = event.detail.render;
    event.detail.render = async (streamElement)=>{
        await $4ab85fa2a90a2892$var$fadeOutAnimationOnRender();
        await originalRender(streamElement);
        $4ab85fa2a90a2892$var$fadeInAnimationOnRender();
    };
});
function $4ab85fa2a90a2892$var$ensureStepVisibleOnLoad() {
    if ((0, $09439d601cee3d34$export$4f384f8a56444e02)()) (0, $09439d601cee3d34$export$7ca9f8ef177c706)();
    if ((0, $09439d601cee3d34$export$7f756e734dc45e16)()) return;
    const stepFrame = document.getElementById("step_content");
    if (!stepFrame) return;
    $4ab85fa2a90a2892$var$hideStaleLoadingScreen();
    $4ab85fa2a90a2892$var$fadeInAnimationOnRender();
}
// A history-restored snapshot can carry the loading overlay captured mid-transition,
// and the controllers' hide events fire before the loadingscreen controller listens.
function $4ab85fa2a90a2892$var$hideStaleLoadingScreen() {
    const overlay = document.querySelector('[data-controller~="loadingscreen"]');
    if (!overlay) return;
    overlay.style.opacity = 0;
    overlay.classList.add("hidden");
}
document.addEventListener("turbo:load", $4ab85fa2a90a2892$var$ensureStepVisibleOnLoad);
document.addEventListener("DOMContentLoaded", $4ab85fa2a90a2892$var$ensureStepVisibleOnLoad);
function $4ab85fa2a90a2892$var$fadeOutAnimationOnRender() {
    return new Promise((resolve)=>{
        const stepContent = document.getElementsByClassName("step-content")[0];
        const stepButton = document.getElementsByClassName("step-button")[0];
        if (stepContent) {
            stepContent.style.opacity = 0;
            stepContent.style.transform = "translateY(-20px)";
        }
        if (stepButton) {
            stepButton.style.opacity = 0;
            stepButton.style.transform = "translateY(20px)";
        }
        setTimeout(()=>{
            resolve();
        }, 300);
    });
}
function $4ab85fa2a90a2892$var$fadeInAnimationOnRender() {
    const stepContent = document.getElementsByClassName("step-content")[0];
    const stepButton = document.getElementsByClassName("step-button")[0];
    if (stepContent) {
        stepContent.style.opacity = 1;
        stepContent.style.transform = "translateY(0px)";
    }
    if (stepButton) {
        stepButton.style.opacity = 1;
        stepButton.style.transform = "translateY(0px)";
    }
}

})();
//# sourceMappingURL=app.js.map
